/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(257);
	module.exports = __webpack_require__(218);


/***/ },
/* 1 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(267);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(246)();
	}


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(53);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.7.1
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "chainPropTypes", {
	  enumerable: true,
	  get: function get() {
	    return _chainPropTypes.default;
	  }
	});
	Object.defineProperty(exports, "deepmerge", {
	  enumerable: true,
	  get: function get() {
	    return _deepmerge.default;
	  }
	});
	Object.defineProperty(exports, "elementAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "elementTypeAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementTypeAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "exactProp", {
	  enumerable: true,
	  get: function get() {
	    return _exactProp.default;
	  }
	});
	Object.defineProperty(exports, "getDisplayName", {
	  enumerable: true,
	  get: function get() {
	    return _getDisplayName.default;
	  }
	});
	Object.defineProperty(exports, "ponyfillGlobal", {
	  enumerable: true,
	  get: function get() {
	    return _ponyfillGlobal.default;
	  }
	});
	Object.defineProperty(exports, "refType", {
	  enumerable: true,
	  get: function get() {
	    return _refType.default;
	  }
	});
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(44));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(195));
	
	var _elementAcceptingRef = _interopRequireDefault(__webpack_require__(196));
	
	var _elementTypeAcceptingRef = _interopRequireDefault(__webpack_require__(197));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(198));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(199));
	
	var _ponyfillGlobal = _interopRequireDefault(__webpack_require__(200));
	
	var _refType = _interopRequireDefault(__webpack_require__(201));

/***/ },
/* 7 */
/***/ function(module, exports) {

	function toVal(mix) {
		var k, y, str='';
		if (mix) {
			if (typeof mix === 'object') {
				if (Array.isArray(mix)) {
					for (k=0; k < mix.length; k++) {
						if (mix[k] && (y = toVal(mix[k]))) {
							str && (str += ' ');
							str += y;
						}
					}
				} else {
					for (k in mix) {
						if (mix[k] && (y = toVal(k))) {
							str && (str += ' ');
							str += y;
						}
					}
				}
			} else if (typeof mix !== 'boolean' && !mix.call) {
				str && (str += ' ');
				str += mix;
			}
		}
		return str;
	}
	
	module.exports = function () {
		var i=0, x, str='';
		while (i < arguments.length) {
			if (x = toVal(arguments[i++])) {
				str && (str += ' ');
				str += x
			}
		}
		return str;
	}


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _styles = __webpack_require__(15);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(21));
	
	function withStyles(stylesOrCreator, options) {
	  return (0, _styles.withStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18n = __webpack_require__(208);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _globals = __webpack_require__(207);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var userLang = navigator.language || navigator.userLanguage;
	
	// All components inherit from BaseComponent to get this.globs.  this.globs is a legacy project super global which I can maybe update later all the callers, but I dont feel like it now.
	var $ = window;
	
	var BaseComponent = function (_Component) {
	  _inherits(BaseComponent, _Component);
	
	  function BaseComponent(props, context) {
	    _classCallCheck(this, BaseComponent);
	
	    var _this = _possibleConstructorReturn(this, (BaseComponent.__proto__ || Object.getPrototypeOf(BaseComponent)).call(this, props, context));
	
	    _this.setupSiteSpecificFunctions = function () {
	      _this.globs.ComponentError = function (classname, message) {
	        var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	        var stack = null;
	        try {
	          stack = e !== null && e !== undefined ? e.stack : null;
	        } catch (ee) {}
	        _this.globs.log("ComponentError: " + classname + " errored with", message, stack);
	        return _react2.default.createElement(
	          "div",
	          { className: "example", style: { margin: 15, backgroundColor: "orange" } },
	          _react2.default.createElement(
	            "div",
	            { className: "step error", style: { backgroundColor: "orange" } },
	            _react2.default.createElement(
	              "span",
	              { className: "step-number" },
	              "!"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "step-desc" },
	              _react2.default.createElement(
	                "span",
	                { className: "step-title" },
	                "Error"
	              ),
	              _react2.default.createElement(
	                "pre",
	                { className: "stacktrace" },
	                stack
	              )
	            )
	          )
	        );
	      };
	
	      _this.globs.log = function () {
	        console.debug("");
	        var colors = "background: #222; color: #bada55";
	        console.debug("%c!!!!!!!!!!!!! DEBUG !!!!!!!!!!!!!", colors);
	        console.debug(new Error().stack);
	        for (var i = 0; i < arguments.length; ++i) {
	          console.debug("%cParm" + i + ":", colors, arguments[i]);
	        }
	        console.debug("%c!!!!!!!!!!!!! ENDDEBUG !!!!!!!!!!!!!", colors);
	        console.debug("");
	      };
	    };
	
	    var transKey = "en";
	    if (userLang.indexOf("en") === -1) {
	      transKey = "jp";
	    }
	    _this.user = $.user;
	    _this.lang = transKey;
	    _this.translate = _i18n2.default[transKey];
	    _this.globs = _globals2.default;
	    _this.setupSiteSpecificFunctions();
	    return _this;
	  }
	
	  return BaseComponent;
	}(_react.Component);
	
	exports.default = BaseComponent;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(11);
	var util = __webpack_require__(14);
	var component = __webpack_require__(12);
	var logger$1 = __webpack_require__(20);
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERRORS = (_a = {},
	    _a["no-app" /* NO_APP */] = "No Firebase App '{$appName}' has been created - " +
	        'call Firebase App.initializeApp()',
	    _a["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$appName}",
	    _a["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$appName}' already exists",
	    _a["app-deleted" /* APP_DELETED */] = "Firebase App named '{$appName}' already deleted",
	    _a["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$appName}() takes either no argument or a ' +
	        'Firebase App instance.',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory('app', 'Firebase', ERRORS);
	
	var name = "@firebase/app";
	var version = "0.5.4";
	
	var name$1 = "@firebase/analytics";
	
	var name$2 = "@firebase/auth";
	
	var name$3 = "@firebase/database";
	
	var name$4 = "@firebase/functions";
	
	var name$5 = "@firebase/installations";
	
	var name$6 = "@firebase/messaging";
	
	var name$7 = "@firebase/performance";
	
	var name$8 = "@firebase/remote-config";
	
	var name$9 = "@firebase/storage";
	
	var name$a = "@firebase/firestore";
	
	var name$b = "firebase-wrapper";
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a$1;
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	var PLATFORM_LOG_STRING = (_a$1 = {},
	    _a$1[name] = 'fire-core',
	    _a$1[name$1] = 'fire-analytics',
	    _a$1[name$2] = 'fire-auth',
	    _a$1[name$3] = 'fire-rtdb',
	    _a$1[name$4] = 'fire-fn',
	    _a$1[name$5] = 'fire-iid',
	    _a$1[name$6] = 'fire-fcm',
	    _a$1[name$7] = 'fire-perf',
	    _a$1[name$8] = 'fire-rc',
	    _a$1[name$9] = 'fire-gcs',
	    _a$1[name$a] = 'fire-fst',
	    _a$1['fire-js'] = 'fire-js',
	    _a$1[name$b] = 'fire-js-all',
	    _a$1);
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var logger = new logger$1.Logger('@firebase/app');
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Global context object for a collection of services using
	 * a shared authentication state.
	 */
	var FirebaseAppImpl = /** @class */ (function () {
	    function FirebaseAppImpl(options, config, firebase_) {
	        var e_1, _a;
	        var _this = this;
	        this.firebase_ = firebase_;
	        this.isDeleted_ = false;
	        this.name_ = config.name;
	        this.automaticDataCollectionEnabled_ =
	            config.automaticDataCollectionEnabled || false;
	        this.options_ = util.deepCopy(options);
	        this.container = new component.ComponentContainer(config.name);
	        // add itself to container
	        this._addComponent(new component.Component('app', function () { return _this; }, "PUBLIC" /* PUBLIC */));
	        try {
	            // populate ComponentContainer with existing components
	            for (var _b = tslib.__values(this.firebase_.INTERNAL.components.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var component$1 = _c.value;
	                this._addComponent(component$1);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    }
	    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.automaticDataCollectionEnabled_;
	        },
	        set: function (val) {
	            this.checkDestroyed_();
	            this.automaticDataCollectionEnabled_ = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.options_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FirebaseAppImpl.prototype.delete = function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this.checkDestroyed_();
	            resolve();
	        })
	            .then(function () {
	            _this.firebase_.INTERNAL.removeApp(_this.name_);
	            return Promise.all(_this.container.getProviders().map(function (provider) { return provider.delete(); }));
	        })
	            .then(function () {
	            _this.isDeleted_ = true;
	        });
	    };
	    /**
	     * Return a service instance associated with this app (creating it
	     * on demand), identified by the passed instanceIdentifier.
	     *
	     * NOTE: Currently storage and functions are the only ones that are leveraging this
	     * functionality. They invoke it by calling:
	     *
	     * ```javascript
	     * firebase.app().storage('STORAGE BUCKET ID')
	     * ```
	     *
	     * The service name is passed to this already
	     * @internal
	     */
	    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
	        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
	        this.checkDestroyed_();
	        // getImmediate will always succeed because _getService is only called for registered components.
	        return this.container.getProvider(name).getImmediate({
	            identifier: instanceIdentifier
	        });
	    };
	    /**
	     * Remove a service instance from the cache, so we will create a new instance for this service
	     * when people try to get this service again.
	     *
	     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
	     *
	     * @param name The service name
	     * @param instanceIdentifier instance identifier in case multiple instances are allowed
	     * @internal
	     */
	    FirebaseAppImpl.prototype._removeServiceInstance = function (name, instanceIdentifier) {
	        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this.container.getProvider(name).clearInstance(instanceIdentifier);
	    };
	    /**
	     * @param component the component being added to this app's container
	     */
	    FirebaseAppImpl.prototype._addComponent = function (component) {
	        try {
	            this.container.addComponent(component);
	        }
	        catch (e) {
	            logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
	        }
	    };
	    FirebaseAppImpl.prototype._addOrOverwriteComponent = function (component) {
	        this.container.addOrOverwriteComponent(component);
	    };
	    /**
	     * This function will throw an Error if the App has already been deleted -
	     * use before performing API actions on the App.
	     */
	    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
	        if (this.isDeleted_) {
	            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this.name_ });
	        }
	    };
	    return FirebaseAppImpl;
	}());
	// Prevent dead-code elimination of these methods w/o invalid property
	// copying.
	(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
	    FirebaseAppImpl.prototype.delete ||
	    console.log('dc');
	
	var version$1 = "7.8.1";
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Because auth can't share code with other components, we attach the utility functions
	 * in an internal namespace to share code.
	 * This function return a firebase namespace object without
	 * any utility functions, so it can be shared between the regular firebaseNamespace and
	 * the lite version.
	 */
	function createFirebaseNamespaceCore(firebaseAppImpl) {
	    var apps = {};
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var components = new Map();
	    // A namespace is a plain JavaScript Object.
	    var namespace = {
	        // Hack to prevent Babel from modifying the object returned
	        // as the firebase namespace.
	        // @ts-ignore
	        __esModule: true,
	        initializeApp: initializeApp,
	        // @ts-ignore
	        app: app,
	        registerVersion: registerVersion,
	        // @ts-ignore
	        apps: null,
	        SDK_VERSION: version$1,
	        INTERNAL: {
	            registerComponent: registerComponent,
	            removeApp: removeApp,
	            components: components,
	            useAsService: useAsService
	        }
	    };
	    // Inject a circular default export to allow Babel users who were previously
	    // using:
	    //
	    //   import firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase').default;
	    //
	    // instead of
	    //
	    //   import * as firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase');
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    namespace['default'] = namespace;
	    // firebase.apps is a read-only getter.
	    Object.defineProperty(namespace, 'apps', {
	        get: getApps
	    });
	    /**
	     * Called by App.delete() - but before any services associated with the App
	     * are deleted.
	     */
	    function removeApp(name) {
	        delete apps[name];
	    }
	    /**
	     * Get the App object for a given name (or DEFAULT).
	     */
	    function app(name) {
	        name = name || DEFAULT_ENTRY_NAME;
	        if (!util.contains(apps, name)) {
	            throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
	        }
	        return apps[name];
	    }
	    // @ts-ignore
	    app['App'] = firebaseAppImpl;
	    function initializeApp(options, rawConfig) {
	        if (rawConfig === void 0) { rawConfig = {}; }
	        if (typeof rawConfig !== 'object' || rawConfig === null) {
	            var name_1 = rawConfig;
	            rawConfig = { name: name_1 };
	        }
	        var config = rawConfig;
	        if (config.name === undefined) {
	            config.name = DEFAULT_ENTRY_NAME;
	        }
	        var name = config.name;
	        if (typeof name !== 'string' || !name) {
	            throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
	                appName: String(name)
	            });
	        }
	        if (util.contains(apps, name)) {
	            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
	        }
	        var app = new firebaseAppImpl(options, config, namespace);
	        apps[name] = app;
	        return app;
	    }
	    /*
	     * Return an array of all the non-deleted FirebaseApps.
	     */
	    function getApps() {
	        // Make a copy so caller cannot mutate the apps list.
	        return Object.keys(apps).map(function (name) { return apps[name]; });
	    }
	    function registerComponent(component) {
	        var e_1, _a;
	        var componentName = component.name;
	        if (components.has(componentName)) {
	            logger.debug("There were multiple attempts to register component " + componentName + ".");
	            return component.type === "PUBLIC" /* PUBLIC */
	                ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    namespace[componentName]
	                : null;
	        }
	        components.set(componentName, component);
	        // create service namespace for public components
	        if (component.type === "PUBLIC" /* PUBLIC */) {
	            // The Service namespace is an accessor function ...
	            var serviceNamespace = function (appArg) {
	                if (appArg === void 0) { appArg = app(); }
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                if (typeof appArg[componentName] !== 'function') {
	                    // Invalid argument.
	                    // This happens in the following case: firebase.storage('gs:/')
	                    throw ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */, {
	                        appName: componentName
	                    });
	                }
	                // Forward service instance lookup to the FirebaseApp.
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                return appArg[componentName]();
	            };
	            // ... and a container for service-level properties.
	            if (component.serviceProps !== undefined) {
	                util.deepExtend(serviceNamespace, component.serviceProps);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            namespace[componentName] = serviceNamespace;
	            // Patch the FirebaseAppImpl prototype
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            firebaseAppImpl.prototype[componentName] =
	                // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
	                // option added to the no-explicit-any rule when ESlint releases it.
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var serviceFxn = this._getService.bind(this, componentName);
	                    return serviceFxn.apply(this, component.multipleInstances ? args : []);
	                };
	        }
	        try {
	            // add the component to existing app instances
	            for (var _b = tslib.__values(Object.keys(apps)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var appName = _c.value;
	                apps[appName]._addComponent(component);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return component.type === "PUBLIC" /* PUBLIC */
	            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                namespace[componentName]
	            : null;
	    }
	    function registerVersion(libraryKeyOrName, version, variant) {
	        var _a;
	        // TODO: We can use this check to whitelist strings when/if we set up
	        // a good whitelist system.
	        var library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName], (_a !== null && _a !== void 0 ? _a : libraryKeyOrName));
	        if (variant) {
	            library += "-" + variant;
	        }
	        var libraryMismatch = library.match(/\s|\//);
	        var versionMismatch = version.match(/\s|\//);
	        if (libraryMismatch || versionMismatch) {
	            var warning = [
	                "Unable to register library \"" + library + "\" with version \"" + version + "\":"
	            ];
	            if (libraryMismatch) {
	                warning.push("library name \"" + library + "\" contains illegal characters (whitespace or \"/\")");
	            }
	            if (libraryMismatch && versionMismatch) {
	                warning.push('and');
	            }
	            if (versionMismatch) {
	                warning.push("version name \"" + version + "\" contains illegal characters (whitespace or \"/\")");
	            }
	            logger.warn(warning.join(' '));
	            return;
	        }
	        registerComponent(new component.Component(library + "-version", function () { return ({ library: library, version: version }); }, "VERSION" /* VERSION */));
	    }
	    // Map the requested service to a registered service name
	    // (used to map auth to serverAuth service when needed).
	    function useAsService(app, name) {
	        if (name === 'serverAuth') {
	            return null;
	        }
	        var useService = name;
	        return useService;
	    }
	    return namespace;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Return a firebase namespace object.
	 *
	 * In production, this will be called exactly once and the result
	 * assigned to the 'firebase' global.  It may be called multiple times
	 * in unit tests.
	 */
	function createFirebaseNamespace() {
	    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
	    namespace.INTERNAL = tslib.__assign(tslib.__assign({}, namespace.INTERNAL), { createFirebaseNamespace: createFirebaseNamespace,
	        extendNamespace: extendNamespace,
	        createSubscribe: util.createSubscribe,
	        ErrorFactory: util.ErrorFactory,
	        deepExtend: util.deepExtend });
	    /**
	     * Patch the top-level firebase namespace with additional properties.
	     *
	     * firebase.INTERNAL.extendNamespace()
	     */
	    function extendNamespace(props) {
	        util.deepExtend(namespace, props);
	    }
	    return namespace;
	}
	var firebase = createFirebaseNamespace();
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PlatformLoggerService = /** @class */ (function () {
	    function PlatformLoggerService(container) {
	        this.container = container;
	    }
	    // In initial implementation, this will be called by installations on
	    // auth token refresh, and installations will send this string.
	    PlatformLoggerService.prototype.getPlatformInfoString = function () {
	        var providers = this.container.getProviders();
	        // Loop through providers and get library/version pairs from any that are
	        // version components.
	        return providers
	            .map(function (provider) {
	            if (isVersionServiceProvider(provider)) {
	                var service = provider.getImmediate();
	                return service.library + "/" + service.version;
	            }
	            else {
	                return null;
	            }
	        })
	            .filter(function (logString) { return logString; })
	            .join(' ');
	    };
	    return PlatformLoggerService;
	}());
	/**
	 *
	 * @param provider check if this provider provides a VersionService
	 *
	 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
	 * provides VersionService. The provider is not necessarily a 'app-version'
	 * provider.
	 */
	function isVersionServiceProvider(provider) {
	    var _a;
	    var component = provider.getComponent();
	    return ((_a = component) === null || _a === void 0 ? void 0 : _a.type) === "VERSION" /* VERSION */;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerCoreComponents(firebase, variant) {
	    firebase.INTERNAL.registerComponent(new component.Component('platform-logger', function (container) { return new PlatformLoggerService(container); }, "PRIVATE" /* PRIVATE */));
	    // Register `app` package.
	    firebase.registerVersion(name, version, variant);
	    // Register platform SDK identifier (no version).
	    firebase.registerVersion('fire-js', '');
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Firebase Lite detection
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	if (util.isBrowser() && self.firebase !== undefined) {
	    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
	    // eslint-disable-next-line
	    var sdkVersion = self.firebase.SDK_VERSION;
	    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
	        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
	    }
	}
	var initializeApp = firebase.initializeApp;
	// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
	// the no-explicit-any rule when ESlint releases it.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	firebase.initializeApp = function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    // Environment check before initializing app
	    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
	    // in @firebase/logger
	    if (util.isNode()) {
	        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
	    }
	    return initializeApp.apply(undefined, args);
	};
	var firebase$1 = firebase;
	registerCoreComponents(firebase$1);
	
	exports.default = firebase$1;
	exports.firebase = firebase$1;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	        if (m) return m.call(o);
	        return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(11);
	var util = __webpack_require__(14);
	
	/**
	 * Component for service name T, e.g. `auth`, `auth-internal`
	 */
	var Component = /** @class */ (function () {
	    /**
	     *
	     * @param name The public service name, e.g. app, auth, firestore, database
	     * @param instanceFactory Service factory responsible for creating the public interface
	     * @param type whether the service provided by the component is public or private
	     */
	    function Component(name, instanceFactory, type) {
	        this.name = name;
	        this.instanceFactory = instanceFactory;
	        this.type = type;
	        this.multipleInstances = false;
	        /**
	         * Properties to be added to the service namespace
	         */
	        this.serviceProps = {};
	        this.instantiationMode = "LAZY" /* LAZY */;
	    }
	    Component.prototype.setInstantiationMode = function (mode) {
	        this.instantiationMode = mode;
	        return this;
	    };
	    Component.prototype.setMultipleInstances = function (multipleInstances) {
	        this.multipleInstances = multipleInstances;
	        return this;
	    };
	    Component.prototype.setServiceProps = function (props) {
	        this.serviceProps = props;
	        return this;
	    };
	    return Component;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
	 * NameServiceMapping[T] is an alias for the type of the instance
	 */
	var Provider = /** @class */ (function () {
	    function Provider(name, container) {
	        this.name = name;
	        this.container = container;
	        this.component = null;
	        this.instances = new Map();
	        this.instancesDeferred = new Map();
	    }
	    /**
	     * @param identifier A provider can provide mulitple instances of a service
	     * if this.component.multipleInstances is true.
	     */
	    Provider.prototype.get = function (identifier) {
	        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
	        // if multipleInstances is not supported, use the default name
	        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
	        if (!this.instancesDeferred.has(normalizedIdentifier)) {
	            var deferred = new util.Deferred();
	            this.instancesDeferred.set(normalizedIdentifier, deferred);
	            // If the service instance is available, resolve the promise with it immediately
	            try {
	                var instance = this.getOrInitializeService(normalizedIdentifier);
	                if (instance) {
	                    deferred.resolve(instance);
	                }
	            }
	            catch (e) {
	                // when the instance factory throws an exception during get(), it should not cause
	                // a fatal error. We just return the unresolved promise in this case.
	            }
	        }
	        return this.instancesDeferred.get(normalizedIdentifier).promise;
	    };
	    Provider.prototype.getImmediate = function (options) {
	        var _a = tslib.__assign({ identifier: DEFAULT_ENTRY_NAME, optional: false }, options), identifier = _a.identifier, optional = _a.optional;
	        // if multipleInstances is not supported, use the default name
	        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
	        try {
	            var instance = this.getOrInitializeService(normalizedIdentifier);
	            if (!instance) {
	                if (optional) {
	                    return null;
	                }
	                throw Error("Service " + this.name + " is not available");
	            }
	            return instance;
	        }
	        catch (e) {
	            if (optional) {
	                return null;
	            }
	            else {
	                throw e;
	            }
	        }
	    };
	    Provider.prototype.getComponent = function () {
	        return this.component;
	    };
	    Provider.prototype.setComponent = function (component) {
	        var e_1, _a;
	        if (component.name !== this.name) {
	            throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
	        }
	        if (this.component) {
	            throw Error("Component for " + this.name + " has already been provided");
	        }
	        this.component = component;
	        // if the service is eager, initialize the default instance
	        if (isComponentEager(component)) {
	            try {
	                this.getOrInitializeService(DEFAULT_ENTRY_NAME);
	            }
	            catch (e) {
	                // when the instance factory for an eager Component throws an exception during the eager
	                // initialization, it should not cause a fatal error.
	                // TODO: Investigate if we need to make it configurable, because some component may want to cause
	                // a fatal error in this case?
	            }
	        }
	        try {
	            // Create service instances for the pending promises and resolve them
	            // NOTE: if this.multipleInstances is false, only the default instance will be created
	            // and all promises with resolve with it regardless of the identifier.
	            for (var _b = tslib.__values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var _d = tslib.__read(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
	                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
	                try {
	                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
	                    var instance = this.getOrInitializeService(normalizedIdentifier);
	                    instanceDeferred.resolve(instance);
	                }
	                catch (e) {
	                    // when the instance factory throws an exception, it should not cause
	                    // a fatal error. We just leave the promise unresolved.
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    Provider.prototype.clearInstance = function (identifier) {
	        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
	        this.instancesDeferred.delete(identifier);
	        this.instances.delete(identifier);
	    };
	    // app.delete() will call this method on every provider to delete the services
	    // TODO: should we mark the provider as deleted?
	    Provider.prototype.delete = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var services;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        services = Array.from(this.instances.values());
	                        return [4 /*yield*/, Promise.all(services
	                                .filter(function (service) { return 'INTERNAL' in service; })
	                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                                .map(function (service) { return service.INTERNAL.delete(); }))];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    Provider.prototype.isComponentSet = function () {
	        return this.component != null;
	    };
	    Provider.prototype.getOrInitializeService = function (identifier) {
	        var instance = this.instances.get(identifier);
	        if (!instance && this.component) {
	            instance = this.component.instanceFactory(this.container, normalizeIdentifierForFactory(identifier));
	            this.instances.set(identifier, instance);
	        }
	        return instance || null;
	    };
	    Provider.prototype.normalizeInstanceIdentifier = function (identifier) {
	        if (this.component) {
	            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
	        }
	        else {
	            return identifier; // assume multiple instances are supported before the component is provided.
	        }
	    };
	    return Provider;
	}());
	// undefined should be passed to the service factory for the default instance
	function normalizeIdentifierForFactory(identifier) {
	    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
	}
	function isComponentEager(component) {
	    return component.instantiationMode === "EAGER" /* EAGER */;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
	 */
	var ComponentContainer = /** @class */ (function () {
	    function ComponentContainer(name) {
	        this.name = name;
	        this.providers = new Map();
	    }
	    /**
	     *
	     * @param component Component being added
	     * @param overwrite When a component with the same name has already been registered,
	     * if overwrite is true: overwrite the existing component with the new component and create a new
	     * provider with the new component. It can be useful in tests where you want to use different mocks
	     * for different tests.
	     * if overwrite is false: throw an exception
	     */
	    ComponentContainer.prototype.addComponent = function (component) {
	        var provider = this.getProvider(component.name);
	        if (provider.isComponentSet()) {
	            throw new Error("Component " + component.name + " has already been registered with " + this.name);
	        }
	        provider.setComponent(component);
	    };
	    ComponentContainer.prototype.addOrOverwriteComponent = function (component) {
	        var provider = this.getProvider(component.name);
	        if (provider.isComponentSet()) {
	            // delete the existing provider from the container, so we can register the new component
	            this.providers.delete(component.name);
	        }
	        this.addComponent(component);
	    };
	    /**
	     * getProvider provides a type safe interface where it can only be called with a field name
	     * present in NameServiceMapping interface.
	     *
	     * Firebase SDKs providing services should extend NameServiceMapping interface to register
	     * themselves.
	     */
	    ComponentContainer.prototype.getProvider = function (name) {
	        if (this.providers.has(name)) {
	            return this.providers.get(name);
	        }
	        // create a Provider for a service that hasn't registered with Firebase
	        var provider = new Provider(name, this);
	        this.providers.set(name, provider);
	        return provider;
	    };
	    ComponentContainer.prototype.getProviders = function () {
	        return Array.from(this.providers.values());
	    };
	    return ComponentContainer;
	}());
	
	exports.Component = Component;
	exports.ComponentContainer = ComponentContainer;
	exports.Provider = Provider;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(248);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(11);
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
	 */
	var CONSTANTS = {
	    /**
	     * @define {boolean} Whether this is the client Node.js SDK.
	     */
	    NODE_CLIENT: false,
	    /**
	     * @define {boolean} Whether this is the Admin Node.js SDK.
	     */
	    NODE_ADMIN: false,
	    /**
	     * Firebase SDK Version
	     */
	    SDK_VERSION: '${JSCORE_VERSION}'
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Throws an error if the provided assertion is falsy
	 */
	var assert = function (assertion, message) {
	    if (!assertion) {
	        throw assertionError(message);
	    }
	};
	/**
	 * Returns an Error object suitable for throwing.
	 */
	var assertionError = function (message) {
	    return new Error('Firebase Database (' +
	        CONSTANTS.SDK_VERSION +
	        ') INTERNAL ASSERT FAILED: ' +
	        message);
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var stringToByteArray = function (str) {
	    // TODO(user): Use native implementations if/when available
	    var out = [];
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if ((c & 0xfc00) === 0xd800 &&
	            i + 1 < str.length &&
	            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
	            // Surrogate Pair
	            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Turns an array of numbers into the string given by the concatenation of the
	 * characters to which the numbers correspond.
	 * @param bytes Array of numbers representing characters.
	 * @return Stringification of the array.
	 */
	var byteArrayToString = function (bytes) {
	    // TODO(user): Use native implementations if/when available
	    var out = [];
	    var pos = 0, c = 0;
	    while (pos < bytes.length) {
	        var c1 = bytes[pos++];
	        if (c1 < 128) {
	            out[c++] = String.fromCharCode(c1);
	        }
	        else if (c1 > 191 && c1 < 224) {
	            var c2 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
	        }
	        else if (c1 > 239 && c1 < 365) {
	            // Surrogate Pair
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            var c4 = bytes[pos++];
	            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
	                0x10000;
	            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
	            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
	        }
	        else {
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
	        }
	    }
	    return out.join('');
	};
	// We define it as an object literal instead of a class because a class compiled down to es5 can't
	// be treeshaked. https://github.com/rollup/rollup/issues/1691
	// Static lookup maps, lazily populated by init_()
	var base64 = {
	    /**
	     * Maps bytes to characters.
	     */
	    byteToCharMap_: null,
	    /**
	     * Maps characters to bytes.
	     */
	    charToByteMap_: null,
	    /**
	     * Maps bytes to websafe characters.
	     * @private
	     */
	    byteToCharMapWebSafe_: null,
	    /**
	     * Maps websafe characters to bytes.
	     * @private
	     */
	    charToByteMapWebSafe_: null,
	    /**
	     * Our default alphabet, shared between
	     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
	     */
	    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
	    /**
	     * Our default alphabet. Value 64 (=) is special; it means "nothing."
	     */
	    get ENCODED_VALS() {
	        return this.ENCODED_VALS_BASE + '+/=';
	    },
	    /**
	     * Our websafe alphabet.
	     */
	    get ENCODED_VALS_WEBSAFE() {
	        return this.ENCODED_VALS_BASE + '-_.';
	    },
	    /**
	     * Whether this browser supports the atob and btoa functions. This extension
	     * started at Mozilla but is now implemented by many browsers. We use the
	     * ASSUME_* variables to avoid pulling in the full useragent detection library
	     * but still allowing the standard per-browser compilations.
	     *
	     */
	    HAS_NATIVE_SUPPORT: typeof atob === 'function',
	    /**
	     * Base64-encode an array of bytes.
	     *
	     * @param input An array of bytes (numbers with
	     *     value in [0, 255]) to encode.
	     * @param webSafe Boolean indicating we should use the
	     *     alternative alphabet.
	     * @return The base64 encoded string.
	     */
	    encodeByteArray: function (input, webSafe) {
	        if (!Array.isArray(input)) {
	            throw Error('encodeByteArray takes an array as a parameter');
	        }
	        this.init_();
	        var byteToCharMap = webSafe
	            ? this.byteToCharMapWebSafe_
	            : this.byteToCharMap_;
	        var output = [];
	        for (var i = 0; i < input.length; i += 3) {
	            var byte1 = input[i];
	            var haveByte2 = i + 1 < input.length;
	            var byte2 = haveByte2 ? input[i + 1] : 0;
	            var haveByte3 = i + 2 < input.length;
	            var byte3 = haveByte3 ? input[i + 2] : 0;
	            var outByte1 = byte1 >> 2;
	            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
	            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
	            var outByte4 = byte3 & 0x3f;
	            if (!haveByte3) {
	                outByte4 = 64;
	                if (!haveByte2) {
	                    outByte3 = 64;
	                }
	            }
	            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
	        }
	        return output.join('');
	    },
	    /**
	     * Base64-encode a string.
	     *
	     * @param input A string to encode.
	     * @param webSafe If true, we should use the
	     *     alternative alphabet.
	     * @return The base64 encoded string.
	     */
	    encodeString: function (input, webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
	            return btoa(input);
	        }
	        return this.encodeByteArray(stringToByteArray(input), webSafe);
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * @param input to decode.
	     * @param webSafe True if we should use the
	     *     alternative alphabet.
	     * @return string representing the decoded value.
	     */
	    decodeString: function (input, webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
	            return atob(input);
	        }
	        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * In base-64 decoding, groups of four characters are converted into three
	     * bytes.  If the encoder did not apply padding, the input length may not
	     * be a multiple of 4.
	     *
	     * In this case, the last group will have fewer than 4 characters, and
	     * padding will be inferred.  If the group has one or two characters, it decodes
	     * to one byte.  If the group has three characters, it decodes to two bytes.
	     *
	     * @param input Input to decode.
	     * @param webSafe True if we should use the web-safe alphabet.
	     * @return bytes representing the decoded value.
	     */
	    decodeStringToByteArray: function (input, webSafe) {
	        this.init_();
	        var charToByteMap = webSafe
	            ? this.charToByteMapWebSafe_
	            : this.charToByteMap_;
	        var output = [];
	        for (var i = 0; i < input.length;) {
	            var byte1 = charToByteMap[input.charAt(i++)];
	            var haveByte2 = i < input.length;
	            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
	            ++i;
	            var haveByte3 = i < input.length;
	            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            var haveByte4 = i < input.length;
	            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
	                throw Error();
	            }
	            var outByte1 = (byte1 << 2) | (byte2 >> 4);
	            output.push(outByte1);
	            if (byte3 !== 64) {
	                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
	                output.push(outByte2);
	                if (byte4 !== 64) {
	                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
	                    output.push(outByte3);
	                }
	            }
	        }
	        return output;
	    },
	    /**
	     * Lazy static initialization function. Called before
	     * accessing any of the static map variables.
	     * @private
	     */
	    init_: function () {
	        if (!this.byteToCharMap_) {
	            this.byteToCharMap_ = {};
	            this.charToByteMap_ = {};
	            this.byteToCharMapWebSafe_ = {};
	            this.charToByteMapWebSafe_ = {};
	            // We want quick mappings back and forth, so we precompute two maps.
	            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
	                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
	                this.charToByteMap_[this.byteToCharMap_[i]] = i;
	                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
	                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
	                // Be forgiving when decoding and correctly decode both encodings.
	                if (i >= this.ENCODED_VALS_BASE.length) {
	                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
	                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
	                }
	            }
	        }
	    }
	};
	/**
	 * URL-safe base64 encoding
	 */
	var base64Encode = function (str) {
	    var utf8Bytes = stringToByteArray(str);
	    return base64.encodeByteArray(utf8Bytes, true);
	};
	/**
	 * URL-safe base64 decoding
	 *
	 * NOTE: DO NOT use the global atob() function - it does NOT support the
	 * base64Url variant encoding.
	 *
	 * @param str To be decoded
	 * @return Decoded result, if possible
	 */
	var base64Decode = function (str) {
	    try {
	        return base64.decodeString(str, true);
	    }
	    catch (e) {
	        console.error('base64Decode failed: ', e);
	    }
	    return null;
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Do a deep-copy of basic JavaScript Objects or Arrays.
	 */
	function deepCopy(value) {
	    return deepExtend(undefined, value);
	}
	/**
	 * Copy properties from source to target (recursively allows extension
	 * of Objects and Arrays).  Scalar values in the target are over-written.
	 * If target is undefined, an object of the appropriate type will be created
	 * (and returned).
	 *
	 * We recursively copy all child properties of plain Objects in the source- so
	 * that namespace- like dictionaries are merged.
	 *
	 * Note that the target can be a function, in which case the properties in
	 * the source Object are copied onto it as static properties of the Function.
	 */
	function deepExtend(target, source) {
	    if (!(source instanceof Object)) {
	        return source;
	    }
	    switch (source.constructor) {
	        case Date:
	            // Treat Dates like scalars; if the target date object had any child
	            // properties - they will be lost!
	            var dateValue = source;
	            return new Date(dateValue.getTime());
	        case Object:
	            if (target === undefined) {
	                target = {};
	            }
	            break;
	        case Array:
	            // Always copy the array source and overwrite the target.
	            target = [];
	            break;
	        default:
	            // Not a plain Object - treat it as a scalar.
	            return source;
	    }
	    for (var prop in source) {
	        if (!source.hasOwnProperty(prop)) {
	            continue;
	        }
	        target[prop] = deepExtend(target[prop], source[prop]);
	    }
	    return target;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Deferred = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.reject = function () { };
	        this.resolve = function () { };
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    /**
	     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
	     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
	     * and returns a node-style callback which will resolve or reject the Deferred's promise.
	     */
	    Deferred.prototype.wrapCallback = function (callback) {
	        var _this = this;
	        return function (error, value) {
	            if (error) {
	                _this.reject(error);
	            }
	            else {
	                _this.resolve(value);
	            }
	            if (typeof callback === 'function') {
	                // Attaching noop handler just in case developer wasn't expecting
	                // promises
	                _this.promise.catch(function () { });
	                // Some of our callbacks don't expect a value and our own tests
	                // assert that the parameter length is 1
	                if (callback.length === 1) {
	                    callback(error);
	                }
	                else {
	                    callback(error, value);
	                }
	            }
	        };
	    };
	    return Deferred;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns navigator.userAgent string or '' if it's not defined.
	 * @return user agent string
	 */
	function getUA() {
	    if (typeof navigator !== 'undefined' &&
	        typeof navigator['userAgent'] === 'string') {
	        return navigator['userAgent'];
	    }
	    else {
	        return '';
	    }
	}
	/**
	 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
	 *
	 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
	 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
	 * wait for a callback.
	 */
	function isMobileCordova() {
	    return (typeof window !== 'undefined' &&
	        // @ts-ignore Setting up an broadly applicable index signature for Window
	        // just to deal with this case would probably be a bad idea.
	        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
	        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
	}
	/**
	 * Detect Node.js.
	 *
	 * @return true if Node.js environment is detected.
	 */
	// Node detection logic from: https://github.com/iliakan/detect-node/
	function isNode() {
	    try {
	        return (Object.prototype.toString.call(global.process) === '[object process]');
	    }
	    catch (e) {
	        return false;
	    }
	}
	/**
	 * Detect Browser Environment
	 */
	function isBrowser() {
	    return typeof self === 'object' && self.self === self;
	}
	function isBrowserExtension() {
	    var runtime = typeof chrome === 'object'
	        ? chrome.runtime
	        : typeof browser === 'object'
	            ? browser.runtime
	            : undefined;
	    return typeof runtime === 'object' && runtime.id !== undefined;
	}
	/**
	 * Detect React Native.
	 *
	 * @return true if ReactNative environment is detected.
	 */
	function isReactNative() {
	    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
	}
	/** Detects Electron apps. */
	function isElectron() {
	    return getUA().indexOf('Electron/') >= 0;
	}
	/** Detects Internet Explorer. */
	function isIE() {
	    var ua = getUA();
	    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
	}
	/** Detects Universal Windows Platform apps. */
	function isUWP() {
	    return getUA().indexOf('MSAppHost/') >= 0;
	}
	/**
	 * Detect whether the current SDK build is the Node version.
	 *
	 * @return true if it's the Node SDK build.
	 */
	function isNodeSdk() {
	    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ERROR_NAME = 'FirebaseError';
	// Based on code from:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
	var FirebaseError = /** @class */ (function (_super) {
	    tslib.__extends(FirebaseError, _super);
	    function FirebaseError(code, message) {
	        var _this = _super.call(this, message) || this;
	        _this.code = code;
	        _this.name = ERROR_NAME;
	        // Fix For ES5
	        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
	        Object.setPrototypeOf(_this, FirebaseError.prototype);
	        // Maintains proper stack trace for where our error was thrown.
	        // Only available on V8.
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
	        }
	        return _this;
	    }
	    return FirebaseError;
	}(Error));
	var ErrorFactory = /** @class */ (function () {
	    function ErrorFactory(service, serviceName, errors) {
	        this.service = service;
	        this.serviceName = serviceName;
	        this.errors = errors;
	    }
	    ErrorFactory.prototype.create = function (code) {
	        var data = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            data[_i - 1] = arguments[_i];
	        }
	        var customData = data[0] || {};
	        var fullCode = this.service + "/" + code;
	        var template = this.errors[code];
	        var message = template ? replaceTemplate(template, customData) : 'Error';
	        // Service Name: Error message (service/code).
	        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
	        var error = new FirebaseError(fullCode, fullMessage);
	        // Keys with an underscore at the end of their name are not included in
	        // error.data for some reason.
	        // TODO: Replace with Object.entries when lib is updated to es2017.
	        for (var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++) {
	            var key = _b[_a];
	            if (key.slice(-1) !== '_') {
	                if (key in error) {
	                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
	                }
	                error[key] = customData[key];
	            }
	        }
	        return error;
	    };
	    return ErrorFactory;
	}());
	function replaceTemplate(template, data) {
	    return template.replace(PATTERN, function (_, key) {
	        var value = data[key];
	        return value != null ? value.toString() : "<" + key + "?>";
	    });
	}
	var PATTERN = /\{\$([^}]+)}/g;
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Evaluates a JSON string into a javascript object.
	 *
	 * @param {string} str A string containing JSON.
	 * @return {*} The javascript object representing the specified JSON.
	 */
	function jsonEval(str) {
	    return JSON.parse(str);
	}
	/**
	 * Returns JSON representing a javascript object.
	 * @param {*} data Javascript object to be stringified.
	 * @return {string} The JSON contents of the object.
	 */
	function stringify(data) {
	    return JSON.stringify(data);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Decodes a Firebase auth. token into constituent parts.
	 *
	 * Notes:
	 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var decode = function (token) {
	    var header = {}, claims = {}, data = {}, signature = '';
	    try {
	        var parts = token.split('.');
	        header = jsonEval(base64Decode(parts[0]) || '');
	        claims = jsonEval(base64Decode(parts[1]) || '');
	        signature = parts[2];
	        data = claims['d'] || {};
	        delete claims['d'];
	    }
	    catch (e) { }
	    return {
	        header: header,
	        claims: claims,
	        data: data,
	        signature: signature
	    };
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
	 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var isValidTimestamp = function (token) {
	    var claims = decode(token).claims;
	    var now = Math.floor(new Date().getTime() / 1000);
	    var validSince = 0, validUntil = 0;
	    if (typeof claims === 'object') {
	        if (claims.hasOwnProperty('nbf')) {
	            validSince = claims['nbf'];
	        }
	        else if (claims.hasOwnProperty('iat')) {
	            validSince = claims['iat'];
	        }
	        if (claims.hasOwnProperty('exp')) {
	            validUntil = claims['exp'];
	        }
	        else {
	            // token will expire after 24h by default
	            validUntil = validSince + 86400;
	        }
	    }
	    return (!!now &&
	        !!validSince &&
	        !!validUntil &&
	        now >= validSince &&
	        now <= validUntil);
	};
	/**
	 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
	 *
	 * Notes:
	 * - May return null if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var issuedAtTime = function (token) {
	    var claims = decode(token).claims;
	    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
	        return claims['iat'];
	    }
	    return null;
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var isValidFormat = function (token) {
	    var decoded = decode(token), claims = decoded.claims;
	    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
	};
	/**
	 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var isAdmin = function (token) {
	    var claims = decode(token).claims;
	    return typeof claims === 'object' && claims['admin'] === true;
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function contains(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	function safeGet(obj, key) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        return obj[key];
	    }
	    else {
	        return undefined;
	    }
	}
	function isEmpty(obj) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            return false;
	        }
	    }
	    return true;
	}
	function map(obj, fn, contextObj) {
	    var res = {};
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            res[key] = fn.call(contextObj, obj[key], key, obj);
	        }
	    }
	    return res;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
	 * params object (e.g. {arg: 'val', arg2: 'val2'})
	 * Note: You must prepend it with ? when adding it to a URL.
	 */
	function querystring(querystringParams) {
	    var params = [];
	    var _loop_1 = function (key, value) {
	        if (Array.isArray(value)) {
	            value.forEach(function (arrayVal) {
	                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
	            });
	        }
	        else {
	            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	        }
	    };
	    for (var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++) {
	        var _b = _a[_i], key = _b[0], value = _b[1];
	        _loop_1(key, value);
	    }
	    return params.length ? '&' + params.join('&') : '';
	}
	/**
	 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
	 * (e.g. {arg: 'val', arg2: 'val2'})
	 */
	function querystringDecode(querystring) {
	    var obj = {};
	    var tokens = querystring.replace(/^\?/, '').split('&');
	    tokens.forEach(function (token) {
	        if (token) {
	            var key = token.split('=');
	            obj[key[0]] = key[1];
	        }
	    });
	    return obj;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview SHA-1 cryptographic hash.
	 * Variable names follow the notation in FIPS PUB 180-3:
	 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
	 *
	 * Usage:
	 *   var sha1 = new sha1();
	 *   sha1.update(bytes);
	 *   var hash = sha1.digest();
	 *
	 * Performance:
	 *   Chrome 23:   ~400 Mbit/s
	 *   Firefox 16:  ~250 Mbit/s
	 *
	 */
	/**
	 * SHA-1 cryptographic hash constructor.
	 *
	 * The properties declared here are discussed in the above algorithm document.
	 * @constructor
	 * @final
	 * @struct
	 */
	var Sha1 = /** @class */ (function () {
	    function Sha1() {
	        /**
	         * Holds the previous values of accumulated variables a-e in the compress_
	         * function.
	         * @private
	         */
	        this.chain_ = [];
	        /**
	         * A buffer holding the partially computed hash result.
	         * @private
	         */
	        this.buf_ = [];
	        /**
	         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
	         * as the message schedule in the docs.
	         * @private
	         */
	        this.W_ = [];
	        /**
	         * Contains data needed to pad messages less than 64 bytes.
	         * @private
	         */
	        this.pad_ = [];
	        /**
	         * @private {number}
	         */
	        this.inbuf_ = 0;
	        /**
	         * @private {number}
	         */
	        this.total_ = 0;
	        this.blockSize = 512 / 8;
	        this.pad_[0] = 128;
	        for (var i = 1; i < this.blockSize; ++i) {
	            this.pad_[i] = 0;
	        }
	        this.reset();
	    }
	    Sha1.prototype.reset = function () {
	        this.chain_[0] = 0x67452301;
	        this.chain_[1] = 0xefcdab89;
	        this.chain_[2] = 0x98badcfe;
	        this.chain_[3] = 0x10325476;
	        this.chain_[4] = 0xc3d2e1f0;
	        this.inbuf_ = 0;
	        this.total_ = 0;
	    };
	    /**
	     * Internal compress helper function.
	     * @param buf Block to compress.
	     * @param offset Offset of the block in the buffer.
	     * @private
	     */
	    Sha1.prototype.compress_ = function (buf, offset) {
	        if (!offset) {
	            offset = 0;
	        }
	        var W = this.W_;
	        // get 16 big endian words
	        if (typeof buf === 'string') {
	            for (var i = 0; i < 16; i++) {
	                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
	                // have a bug that turns the post-increment ++ operator into pre-increment
	                // during JIT compilation.  We have code that depends heavily on SHA-1 for
	                // correctness and which is affected by this bug, so I've removed all uses
	                // of post-increment ++ in which the result value is used.  We can revert
	                // this change once the Safari bug
	                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
	                // most clients have been updated.
	                W[i] =
	                    (buf.charCodeAt(offset) << 24) |
	                        (buf.charCodeAt(offset + 1) << 16) |
	                        (buf.charCodeAt(offset + 2) << 8) |
	                        buf.charCodeAt(offset + 3);
	                offset += 4;
	            }
	        }
	        else {
	            for (var i = 0; i < 16; i++) {
	                W[i] =
	                    (buf[offset] << 24) |
	                        (buf[offset + 1] << 16) |
	                        (buf[offset + 2] << 8) |
	                        buf[offset + 3];
	                offset += 4;
	            }
	        }
	        // expand to 80 words
	        for (var i = 16; i < 80; i++) {
	            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
	        }
	        var a = this.chain_[0];
	        var b = this.chain_[1];
	        var c = this.chain_[2];
	        var d = this.chain_[3];
	        var e = this.chain_[4];
	        var f, k;
	        // TODO(user): Try to unroll this loop to speed up the computation.
	        for (var i = 0; i < 80; i++) {
	            if (i < 40) {
	                if (i < 20) {
	                    f = d ^ (b & (c ^ d));
	                    k = 0x5a827999;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0x6ed9eba1;
	                }
	            }
	            else {
	                if (i < 60) {
	                    f = (b & c) | (d & (b | c));
	                    k = 0x8f1bbcdc;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0xca62c1d6;
	                }
	            }
	            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
	            e = d;
	            d = c;
	            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
	            b = a;
	            a = t;
	        }
	        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
	        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
	        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
	        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
	        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
	    };
	    Sha1.prototype.update = function (bytes, length) {
	        // TODO(johnlenz): tighten the function signature and remove this check
	        if (bytes == null) {
	            return;
	        }
	        if (length === undefined) {
	            length = bytes.length;
	        }
	        var lengthMinusBlock = length - this.blockSize;
	        var n = 0;
	        // Using local instead of member variables gives ~5% speedup on Firefox 16.
	        var buf = this.buf_;
	        var inbuf = this.inbuf_;
	        // The outer while loop should execute at most twice.
	        while (n < length) {
	            // When we have no data in the block to top up, we can directly process the
	            // input buffer (assuming it contains sufficient data). This gives ~25%
	            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
	            // the data is provided in large chunks (or in multiples of 64 bytes).
	            if (inbuf === 0) {
	                while (n <= lengthMinusBlock) {
	                    this.compress_(bytes, n);
	                    n += this.blockSize;
	                }
	            }
	            if (typeof bytes === 'string') {
	                while (n < length) {
	                    buf[inbuf] = bytes.charCodeAt(n);
	                    ++inbuf;
	                    ++n;
	                    if (inbuf === this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	            else {
	                while (n < length) {
	                    buf[inbuf] = bytes[n];
	                    ++inbuf;
	                    ++n;
	                    if (inbuf === this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	        }
	        this.inbuf_ = inbuf;
	        this.total_ += length;
	    };
	    /** @override */
	    Sha1.prototype.digest = function () {
	        var digest = [];
	        var totalBits = this.total_ * 8;
	        // Add pad 0x80 0x00*.
	        if (this.inbuf_ < 56) {
	            this.update(this.pad_, 56 - this.inbuf_);
	        }
	        else {
	            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
	        }
	        // Add # bits.
	        for (var i = this.blockSize - 1; i >= 56; i--) {
	            this.buf_[i] = totalBits & 255;
	            totalBits /= 256; // Don't use bit-shifting here!
	        }
	        this.compress_(this.buf_);
	        var n = 0;
	        for (var i = 0; i < 5; i++) {
	            for (var j = 24; j >= 0; j -= 8) {
	                digest[n] = (this.chain_[i] >> j) & 255;
	                ++n;
	            }
	        }
	        return digest;
	    };
	    return Sha1;
	}());
	
	/**
	 * Helper to make a Subscribe function (just like Promise helps make a
	 * Thenable).
	 *
	 * @param executor Function which can make calls to a single Observer
	 *     as a proxy.
	 * @param onNoObservers Callback when count of Observers goes to zero.
	 */
	function createSubscribe(executor, onNoObservers) {
	    var proxy = new ObserverProxy(executor, onNoObservers);
	    return proxy.subscribe.bind(proxy);
	}
	/**
	 * Implement fan-out for any number of Observers attached via a subscribe
	 * function.
	 */
	var ObserverProxy = /** @class */ (function () {
	    /**
	     * @param executor Function which can make calls to a single Observer
	     *     as a proxy.
	     * @param onNoObservers Callback when count of Observers goes to zero.
	     */
	    function ObserverProxy(executor, onNoObservers) {
	        var _this = this;
	        this.observers = [];
	        this.unsubscribes = [];
	        this.observerCount = 0;
	        // Micro-task scheduling by calling task.then().
	        this.task = Promise.resolve();
	        this.finalized = false;
	        this.onNoObservers = onNoObservers;
	        // Call the executor asynchronously so subscribers that are called
	        // synchronously after the creation of the subscribe function
	        // can still receive the very first value generated in the executor.
	        this.task
	            .then(function () {
	            executor(_this);
	        })
	            .catch(function (e) {
	            _this.error(e);
	        });
	    }
	    ObserverProxy.prototype.next = function (value) {
	        this.forEachObserver(function (observer) {
	            observer.next(value);
	        });
	    };
	    ObserverProxy.prototype.error = function (error) {
	        this.forEachObserver(function (observer) {
	            observer.error(error);
	        });
	        this.close(error);
	    };
	    ObserverProxy.prototype.complete = function () {
	        this.forEachObserver(function (observer) {
	            observer.complete();
	        });
	        this.close();
	    };
	    /**
	     * Subscribe function that can be used to add an Observer to the fan-out list.
	     *
	     * - We require that no event is sent to a subscriber sychronously to their
	     *   call to subscribe().
	     */
	    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
	        var _this = this;
	        var observer;
	        if (nextOrObserver === undefined &&
	            error === undefined &&
	            complete === undefined) {
	            throw new Error('Missing Observer.');
	        }
	        // Assemble an Observer object when passed as callback functions.
	        if (implementsAnyMethods(nextOrObserver, [
	            'next',
	            'error',
	            'complete'
	        ])) {
	            observer = nextOrObserver;
	        }
	        else {
	            observer = {
	                next: nextOrObserver,
	                error: error,
	                complete: complete
	            };
	        }
	        if (observer.next === undefined) {
	            observer.next = noop;
	        }
	        if (observer.error === undefined) {
	            observer.error = noop;
	        }
	        if (observer.complete === undefined) {
	            observer.complete = noop;
	        }
	        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
	        // Attempt to subscribe to a terminated Observable - we
	        // just respond to the Observer with the final error or complete
	        // event.
	        if (this.finalized) {
	            // eslint-disable-next-line @typescript-eslint/no-floating-promises
	            this.task.then(function () {
	                try {
	                    if (_this.finalError) {
	                        observer.error(_this.finalError);
	                    }
	                    else {
	                        observer.complete();
	                    }
	                }
	                catch (e) {
	                    // nothing
	                }
	                return;
	            });
	        }
	        this.observers.push(observer);
	        return unsub;
	    };
	    // Unsubscribe is synchronous - we guarantee that no events are sent to
	    // any unsubscribed Observer.
	    ObserverProxy.prototype.unsubscribeOne = function (i) {
	        if (this.observers === undefined || this.observers[i] === undefined) {
	            return;
	        }
	        delete this.observers[i];
	        this.observerCount -= 1;
	        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
	            this.onNoObservers(this);
	        }
	    };
	    ObserverProxy.prototype.forEachObserver = function (fn) {
	        if (this.finalized) {
	            // Already closed by previous event....just eat the additional values.
	            return;
	        }
	        // Since sendOne calls asynchronously - there is no chance that
	        // this.observers will become undefined.
	        for (var i = 0; i < this.observers.length; i++) {
	            this.sendOne(i, fn);
	        }
	    };
	    // Call the Observer via one of it's callback function. We are careful to
	    // confirm that the observe has not been unsubscribed since this asynchronous
	    // function had been queued.
	    ObserverProxy.prototype.sendOne = function (i, fn) {
	        var _this = this;
	        // Execute the callback asynchronously
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.task.then(function () {
	            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
	                try {
	                    fn(_this.observers[i]);
	                }
	                catch (e) {
	                    // Ignore exceptions raised in Observers or missing methods of an
	                    // Observer.
	                    // Log error to console. b/31404806
	                    if (typeof console !== 'undefined' && console.error) {
	                        console.error(e);
	                    }
	                }
	            }
	        });
	    };
	    ObserverProxy.prototype.close = function (err) {
	        var _this = this;
	        if (this.finalized) {
	            return;
	        }
	        this.finalized = true;
	        if (err !== undefined) {
	            this.finalError = err;
	        }
	        // Proxy is no longer needed - garbage collect references
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.task.then(function () {
	            _this.observers = undefined;
	            _this.onNoObservers = undefined;
	        });
	    };
	    return ObserverProxy;
	}());
	/** Turn synchronous function into one called asynchronously. */
	function async(fn, onError) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        Promise.resolve(true)
	            .then(function () {
	            fn.apply(void 0, args);
	        })
	            .catch(function (error) {
	            if (onError) {
	                onError(error);
	            }
	        });
	    };
	}
	/**
	 * Return true if the object passed in implements any of the named methods.
	 */
	function implementsAnyMethods(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in obj && typeof obj[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	function noop() {
	    // do nothing
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Check to make sure the appropriate number of arguments are provided for a public function.
	 * Throws an error if it fails.
	 *
	 * @param fnName The function name
	 * @param minCount The minimum number of arguments to allow for the function call
	 * @param maxCount The maximum number of argument to allow for the function call
	 * @param argCount The actual number of arguments provided.
	 */
	var validateArgCount = function (fnName, minCount, maxCount, argCount) {
	    var argError;
	    if (argCount < minCount) {
	        argError = 'at least ' + minCount;
	    }
	    else if (argCount > maxCount) {
	        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
	    }
	    if (argError) {
	        var error = fnName +
	            ' failed: Was called with ' +
	            argCount +
	            (argCount === 1 ? ' argument.' : ' arguments.') +
	            ' Expects ' +
	            argError +
	            '.';
	        throw new Error(error);
	    }
	};
	/**
	 * Generates a string to prefix an error message about failed argument validation
	 *
	 * @param fnName The function name
	 * @param argumentNumber The index of the argument
	 * @param optional Whether or not the argument is optional
	 * @return The prefix to add to the error thrown for validation.
	 */
	function errorPrefix(fnName, argumentNumber, optional) {
	    var argName = '';
	    switch (argumentNumber) {
	        case 1:
	            argName = optional ? 'first' : 'First';
	            break;
	        case 2:
	            argName = optional ? 'second' : 'Second';
	            break;
	        case 3:
	            argName = optional ? 'third' : 'Third';
	            break;
	        case 4:
	            argName = optional ? 'fourth' : 'Fourth';
	            break;
	        default:
	            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
	    }
	    var error = fnName + ' failed: ';
	    error += argName + ' argument ';
	    return error;
	}
	/**
	 * @param fnName
	 * @param argumentNumber
	 * @param namespace
	 * @param optional
	 */
	function validateNamespace(fnName, argumentNumber, namespace, optional) {
	    if (optional && !namespace) {
	        return;
	    }
	    if (typeof namespace !== 'string') {
	        //TODO: I should do more validation here. We only allow certain chars in namespaces.
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid firebase namespace.');
	    }
	}
	function validateCallback(fnName, argumentNumber, callback, optional) {
	    if (optional && !callback) {
	        return;
	    }
	    if (typeof callback !== 'function') {
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid function.');
	    }
	}
	function validateContextObject(fnName, argumentNumber, context, optional) {
	    if (optional && !context) {
	        return;
	    }
	    if (typeof context !== 'object' || context === null) {
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid context object.');
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
	// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
	// so it's been modified.
	// Note that not all Unicode characters appear as single characters in JavaScript strings.
	// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
	// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
	// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
	// pair).
	// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
	/**
	 * @param {string} str
	 * @return {Array}
	 */
	var stringToByteArray$1 = function (str) {
	    var out = [];
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        // Is this the lead surrogate in a surrogate pair?
	        if (c >= 0xd800 && c <= 0xdbff) {
	            var high = c - 0xd800; // the high 10 bits.
	            i++;
	            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
	            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
	            c = 0x10000 + (high << 10) + low;
	        }
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if (c < 65536) {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Calculate length without actually converting; useful for doing cheaper validation.
	 * @param {string} str
	 * @return {number}
	 */
	var stringLength = function (str) {
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            p++;
	        }
	        else if (c < 2048) {
	            p += 2;
	        }
	        else if (c >= 0xd800 && c <= 0xdbff) {
	            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
	            p += 4;
	            i++; // skip trail surrogate.
	        }
	        else {
	            p += 3;
	        }
	    }
	    return p;
	};
	
	exports.CONSTANTS = CONSTANTS;
	exports.Deferred = Deferred;
	exports.ErrorFactory = ErrorFactory;
	exports.FirebaseError = FirebaseError;
	exports.Sha1 = Sha1;
	exports.assert = assert;
	exports.assertionError = assertionError;
	exports.async = async;
	exports.base64 = base64;
	exports.base64Decode = base64Decode;
	exports.base64Encode = base64Encode;
	exports.contains = contains;
	exports.createSubscribe = createSubscribe;
	exports.decode = decode;
	exports.deepCopy = deepCopy;
	exports.deepExtend = deepExtend;
	exports.errorPrefix = errorPrefix;
	exports.getUA = getUA;
	exports.isAdmin = isAdmin;
	exports.isBrowser = isBrowser;
	exports.isBrowserExtension = isBrowserExtension;
	exports.isElectron = isElectron;
	exports.isEmpty = isEmpty;
	exports.isIE = isIE;
	exports.isMobileCordova = isMobileCordova;
	exports.isNode = isNode;
	exports.isNodeSdk = isNodeSdk;
	exports.isReactNative = isReactNative;
	exports.isUWP = isUWP;
	exports.isValidFormat = isValidFormat;
	exports.isValidTimestamp = isValidTimestamp;
	exports.issuedAtTime = issuedAtTime;
	exports.jsonEval = jsonEval;
	exports.map = map;
	exports.querystring = querystring;
	exports.querystringDecode = querystringDecode;
	exports.safeGet = safeGet;
	exports.stringLength = stringLength;
	exports.stringToByteArray = stringToByteArray$1;
	exports.stringify = stringify;
	exports.validateArgCount = validateArgCount;
	exports.validateCallback = validateCallback;
	exports.validateContextObject = validateContextObject;
	exports.validateNamespace = validateNamespace;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.9.0
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(19);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createGenerateClassName: true,
	  createStyles: true,
	  getThemeProps: true,
	  jssPreset: true,
	  makeStyles: true,
	  mergeClasses: true,
	  ServerStyleSheets: true,
	  styled: true,
	  StylesProvider: true,
	  ThemeProvider: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true
	};
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "getThemeProps", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "mergeClasses", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _utils = __webpack_require__(6);
	
	var _createGenerateClassName = _interopRequireWildcard(__webpack_require__(42));
	
	Object.keys(_createGenerateClassName).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createGenerateClassName[key];
	    }
	  });
	});
	
	var _createStyles = _interopRequireWildcard(__webpack_require__(179));
	
	Object.keys(_createStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createStyles[key];
	    }
	  });
	});
	
	var _getThemeProps = _interopRequireWildcard(__webpack_require__(68));
	
	Object.keys(_getThemeProps).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getThemeProps[key];
	    }
	  });
	});
	
	var _jssPreset = _interopRequireWildcard(__webpack_require__(69));
	
	Object.keys(_jssPreset).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _jssPreset[key];
	    }
	  });
	});
	
	var _makeStyles = _interopRequireWildcard(__webpack_require__(43));
	
	Object.keys(_makeStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _makeStyles[key];
	    }
	  });
	});
	
	var _mergeClasses = _interopRequireWildcard(__webpack_require__(70));
	
	Object.keys(_mergeClasses).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mergeClasses[key];
	    }
	  });
	});
	
	var _ServerStyleSheets = _interopRequireWildcard(__webpack_require__(173));
	
	Object.keys(_ServerStyleSheets).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ServerStyleSheets[key];
	    }
	  });
	});
	
	var _styled = _interopRequireWildcard(__webpack_require__(188));
	
	Object.keys(_styled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styled[key];
	    }
	  });
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(41));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});
	
	var _ThemeProvider = _interopRequireWildcard(__webpack_require__(176));
	
	Object.keys(_ThemeProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ThemeProvider[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireWildcard(__webpack_require__(23));
	
	Object.keys(_useTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useTheme[key];
	    }
	  });
	});
	
	var _withStyles = _interopRequireWildcard(__webpack_require__(191));
	
	Object.keys(_withStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withStyles[key];
	    }
	  });
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(193));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});
	
	/* eslint-disable import/export */
	
	/* Warning if there are several instances of @material-ui/styles */
	if (false) {
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] = _utils.ponyfillGlobal['__@material-ui/styles-init__'] || 0;
	
	  if (_utils.ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
	    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
	  }
	
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] += 1;
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useForkRef;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _setRef = _interopRequireDefault(__webpack_require__(65));
	
	function useForkRef(refA, refB) {
	  /**
	   * This will create a new function if the ref props change and are defined.
	   * This means react will call the old forkRef with `null` and the new forkRef
	   * with the ref. Cleanup naturally emerges from this behavior
	   */
	  return _react.default.useMemo(function () {
	    if (refA == null && refB == null) {
	      return null;
	    }
	
	    return function (refValue) {
	      (0, _setRef.default)(refA, refValue);
	      (0, _setRef.default)(refB, refValue);
	    };
	  }, [refA, refB]);
	}

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(3));
	var isInBrowser = _interopDefault(__webpack_require__(77));
	var warning = _interopDefault(__webpack_require__(18));
	var _createClass = _interopDefault(__webpack_require__(37));
	var _inheritsLoose = _interopDefault(__webpack_require__(38));
	var _assertThisInitialized = _interopDefault(__webpack_require__(86));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(53));
	
	var plainObjectConstrurctor = {}.constructor;
	function cloneStyle(style) {
	  if (style == null || typeof style !== 'object') return style;
	  if (Array.isArray(style)) return style.map(cloneStyle);
	  if (style.constructor !== plainObjectConstrurctor) return style;
	  var newStyle = {};
	
	  for (var name in style) {
	    newStyle[name] = cloneStyle(style[name]);
	  }
	
	  return newStyle;
	}
	
	/**
	 * Create a rule instance.
	 */
	
	function createRule(name, decl, options) {
	  if (name === void 0) {
	    name = 'unnamed';
	  }
	
	  var jss = options.jss;
	  var declCopy = cloneStyle(decl);
	  var rule = jss.plugins.onCreateRule(name, declCopy, options);
	  if (rule) return rule; // It is an at-rule and it has no instance.
	
	  if (name[0] === '@') {
	     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
	  }
	
	  return null;
	}
	
	var join = function join(value, by) {
	  var result = '';
	
	  for (var i = 0; i < value.length; i++) {
	    // Remove !important from the value, it will be readded later.
	    if (value[i] === '!important') break;
	    if (result) result += by;
	    result += value[i];
	  }
	
	  return result;
	};
	/**
	 * Converts array values to string.
	 *
	 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	 * `border: ['1px', '2px']` > `border: 1px, 2px;`
	 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
	 * `color: ['red', !important]` > `color: red !important;`
	 */
	
	
	function toCssValue(value, ignoreImportant) {
	  if (ignoreImportant === void 0) {
	    ignoreImportant = false;
	  }
	
	  if (!Array.isArray(value)) return value;
	  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
	
	  if (Array.isArray(value[0])) {
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] === '!important') break;
	      if (cssValue) cssValue += ', ';
	      cssValue += join(value[i], ' ');
	    }
	  } else cssValue = join(value, ', '); // Add !important, because it was ignored.
	
	
	  if (!ignoreImportant && value[value.length - 1] === '!important') {
	    cssValue += ' !important';
	  }
	
	  return cssValue;
	}
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	function indentStr(str, indent) {
	  var result = '';
	
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }
	
	  return result + str;
	}
	/**
	 * Converts a Rule to CSS string.
	 */
	
	
	function toCss(selector, style, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var result = '';
	  if (!style) return result;
	  var _options = options,
	      _options$indent = _options.indent,
	      indent = _options$indent === void 0 ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	  if (selector) indent++; // Apply fallbacks first.
	
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	
	        for (var prop in fallback) {
	          var value = fallback[prop];
	
	          if (value != null) {
	            if (result) result += '\n';
	            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
	          }
	        }
	      }
	    } else {
	      // Object syntax {fallbacks: {prop: value}}
	      for (var _prop in fallbacks) {
	        var _value = fallbacks[_prop];
	
	        if (_value != null) {
	          if (result) result += '\n';
	          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
	        }
	      }
	    }
	  }
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      if (result) result += '\n';
	      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
	    }
	  } // Allow empty style in this case, because properties will be added dynamically.
	
	
	  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
	
	  if (!selector) return result;
	  indent--;
	  if (result) result = "\n" + result + "\n";
	  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
	}
	
	var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
	var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
	var escape = (function (str) {
	  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
	});
	
	var BaseStyleRule =
	/*#__PURE__*/
	function () {
	  function BaseStyleRule(key, style, options) {
	    this.type = 'style';
	    this.key = void 0;
	    this.isProcessed = false;
	    this.style = void 0;
	    this.renderer = void 0;
	    this.renderable = void 0;
	    this.options = void 0;
	    var sheet = options.sheet,
	        Renderer = options.Renderer;
	    this.key = key;
	    this.options = options;
	    this.style = style;
	    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
	  }
	  /**
	   * Get or set a style property.
	   */
	
	
	  var _proto = BaseStyleRule.prototype;
	
	  _proto.prop = function prop(name, value, options) {
	    // It's a getter.
	    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
	
	    var force = options ? options.force : false;
	    if (!force && this.style[name] === value) return this;
	    var newValue = value;
	
	    if (!options || options.process !== false) {
	      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
	    }
	
	    var isEmpty = newValue == null || newValue === false;
	    var isDefined = name in this.style; // Value is empty and wasn't defined before.
	
	    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
	
	    var remove = isEmpty && isDefined;
	    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
	
	    if (this.renderable && this.renderer) {
	      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
	      return this;
	    }
	
	    var sheet = this.options.sheet;
	
	    if (sheet && sheet.attached) {
	       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
	    }
	
	    return this;
	  };
	
	  return BaseStyleRule;
	}();
	var StyleRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose(StyleRule, _BaseStyleRule);
	
	  function StyleRule(key, style, options) {
	    var _this;
	
	    _this = _BaseStyleRule.call(this, key, style, options) || this;
	    _this.selectorText = void 0;
	    _this.id = void 0;
	    _this.renderable = void 0;
	    var selector = options.selector,
	        scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	
	    if (selector) {
	      _this.selectorText = selector;
	    } else if (scoped !== false) {
	      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
	      _this.selectorText = "." + escape(_this.id);
	    }
	
	    return _this;
	  }
	  /**
	   * Set selector string.
	   * Attention: use this with caution. Most browsers didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  var _proto2 = StyleRule.prototype;
	
	  /**
	   * Apply rule to an element inline.
	   */
	  _proto2.applyTo = function applyTo(renderable) {
	    var renderer = this.renderer;
	
	    if (renderer) {
	      var json = this.toJSON();
	
	      for (var prop in json) {
	        renderer.setProperty(renderable, prop, json[prop]);
	      }
	    }
	
	    return this;
	  }
	  /**
	   * Returns JSON representation of the rule.
	   * Fallbacks are not supported.
	   * Useful for inline styles.
	   */
	  ;
	
	  _proto2.toJSON = function toJSON() {
	    var json = {};
	
	    for (var prop in this.style) {
	      var value = this.style[prop];
	      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
	    }
	
	    return json;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto2.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.selectorText, this.style, opts);
	  };
	
	  _createClass(StyleRule, [{
	    key: "selector",
	    set: function set(selector) {
	      if (selector === this.selectorText) return;
	      this.selectorText = selector;
	      var renderer = this.renderer,
	          renderable = this.renderable;
	      if (!renderable || !renderer) return;
	      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
	
	      if (!hasChanged) {
	        renderer.replaceRule(renderable, this);
	      }
	    }
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      return this.selectorText;
	    }
	  }]);
	
	  return StyleRule;
	}(BaseStyleRule);
	var pluginStyleRule = {
	  onCreateRule: function onCreateRule(name, style, options) {
	    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
	      return null;
	    }
	
	    return new StyleRule(name, style, options);
	  }
	};
	
	var defaultToStringOptions = {
	  indent: 1,
	  children: true
	};
	var atRegExp = /@([\w-]+)/;
	/**
	 * Conditional rule for @media, @supports
	 */
	
	var ConditionalRule =
	/*#__PURE__*/
	function () {
	  function ConditionalRule(key, styles, options) {
	    this.type = 'conditional';
	    this.at = void 0;
	    this.key = void 0;
	    this.query = void 0;
	    this.rules = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
	
	    this.query = options.name;
	    var atMatch = key.match(atRegExp);
	    this.at = atMatch ? atMatch[1] : 'unknown';
	    this.options = options;
	    this.rules = new RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = ConditionalRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions;
	    }
	
	    if (options.indent == null) options.indent = defaultToStringOptions.indent;
	    if (options.children == null) options.children = defaultToStringOptions.children;
	
	    if (options.children === false) {
	      return this.query + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    return children ? this.query + " {\n" + children + "\n}" : '';
	  };
	
	  return ConditionalRule;
	}();
	var keyRegExp = /@media|@supports\s+/;
	var pluginConditionalRule = {
	  onCreateRule: function onCreateRule(key, styles, options) {
	    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
	  }
	};
	
	var defaultToStringOptions$1 = {
	  indent: 1,
	  children: true
	};
	var nameRegExp = /@keyframes\s+([\w-]+)/;
	/**
	 * Rule for @keyframes
	 */
	
	var KeyframesRule =
	/*#__PURE__*/
	function () {
	  function KeyframesRule(key, frames, options) {
	    this.type = 'keyframes';
	    this.at = '@keyframes';
	    this.key = void 0;
	    this.name = void 0;
	    this.id = void 0;
	    this.rules = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    var nameMatch = key.match(nameRegExp);
	
	    if (nameMatch && nameMatch[1]) {
	      this.name = nameMatch[1];
	    } else {
	      this.name = 'noname';
	       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
	    }
	
	    this.key = this.type + "-" + this.name;
	    this.options = options;
	    var scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
	    this.rules = new RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends({}, options, {
	        parent: this
	      }));
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = KeyframesRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions$1;
	    }
	
	    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
	    if (options.children == null) options.children = defaultToStringOptions$1.children;
	
	    if (options.children === false) {
	      return this.at + " " + this.id + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    if (children) children = "\n" + children + "\n";
	    return this.at + " " + this.id + " {" + children + "}";
	  };
	
	  return KeyframesRule;
	}();
	var keyRegExp$1 = /@keyframes\s+/;
	var refRegExp = /\$([\w-]+)/g;
	
	var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
	  if (typeof val === 'string') {
	    return val.replace(refRegExp, function (match, name) {
	      if (name in keyframes) {
	        return keyframes[name];
	      }
	
	       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
	      return match;
	    });
	  }
	
	  return val;
	};
	/**
	 * Replace the reference for a animation name.
	 */
	
	
	var replaceRef = function replaceRef(style, prop, keyframes) {
	  var value = style[prop];
	  var refKeyframe = findReferencedKeyframe(value, keyframes);
	
	  if (refKeyframe !== value) {
	    style[prop] = refKeyframe;
	  }
	};
	
	var plugin = {
	  onCreateRule: function onCreateRule(key, frames, options) {
	    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
	  },
	  // Animation name ref replacer.
	  onProcessStyle: function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return style;
	    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
	    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
	    return style;
	  },
	  onChangeValue: function onChangeValue(val, prop, rule) {
	    var sheet = rule.options.sheet;
	
	    if (!sheet) {
	      return val;
	    }
	
	    switch (prop) {
	      case 'animation':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      case 'animation-name':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      default:
	        return val;
	    }
	  }
	};
	
	var KeyframeRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose(KeyframeRule, _BaseStyleRule);
	
	  function KeyframeRule() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
	    _this.renderable = void 0;
	    return _this;
	  }
	
	  var _proto = KeyframeRule.prototype;
	
	  /**
	   * Generates a CSS string.
	   */
	  _proto.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.key, this.style, opts);
	  };
	
	  return KeyframeRule;
	}(BaseStyleRule);
	var pluginKeyframeRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    if (options.parent && options.parent.type === 'keyframes') {
	      return new KeyframeRule(key, style, options);
	    }
	
	    return null;
	  }
	};
	
	var FontFaceRule =
	/*#__PURE__*/
	function () {
	  function FontFaceRule(key, style, options) {
	    this.type = 'font-face';
	    this.at = '@font-face';
	    this.key = void 0;
	    this.style = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = FontFaceRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.style)) {
	      var str = '';
	
	      for (var index = 0; index < this.style.length; index++) {
	        str += toCss(this.key, this.style[index]);
	        if (this.style[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return toCss(this.key, this.style, options);
	  };
	
	  return FontFaceRule;
	}();
	var pluginFontFaceRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return key === '@font-face' ? new FontFaceRule(key, style, options) : null;
	  }
	};
	
	var ViewportRule =
	/*#__PURE__*/
	function () {
	  function ViewportRule(key, style, options) {
	    this.type = 'viewport';
	    this.at = '@viewport';
	    this.key = void 0;
	    this.style = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = ViewportRule.prototype;
	
	  _proto.toString = function toString(options) {
	    return toCss(this.key, this.style, options);
	  };
	
	  return ViewportRule;
	}();
	var pluginViewportRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
	  }
	};
	
	var SimpleRule =
	/*#__PURE__*/
	function () {
	  function SimpleRule(key, value, options) {
	    this.type = 'simple';
	    this.key = void 0;
	    this.value = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.value = value;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  // eslint-disable-next-line no-unused-vars
	
	
	  var _proto = SimpleRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.value)) {
	      var str = '';
	
	      for (var index = 0; index < this.value.length; index++) {
	        str += this.key + " " + this.value[index] + ";";
	        if (this.value[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return this.key + " " + this.value + ";";
	  };
	
	  return SimpleRule;
	}();
	var keysMap = {
	  '@charset': true,
	  '@import': true,
	  '@namespace': true
	};
	var pluginSimpleRule = {
	  onCreateRule: function onCreateRule(key, value, options) {
	    return key in keysMap ? new SimpleRule(key, value, options) : null;
	  }
	};
	
	var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
	
	var defaultUpdateOptions = {
	  process: true
	};
	var forceUpdateOptions = {
	  force: true,
	  process: true
	  /**
	   * Contains rules objects and allows adding/removing etc.
	   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	   */
	
	};
	
	var RuleList =
	/*#__PURE__*/
	function () {
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	  // Original styles object.
	  // Used to ensure correct rules order.
	  function RuleList(options) {
	    this.map = {};
	    this.raw = {};
	    this.index = [];
	    this.counter = 0;
	    this.options = void 0;
	    this.classes = void 0;
	    this.keyframes = void 0;
	    this.options = options;
	    this.classes = options.classes;
	    this.keyframes = options.keyframes;
	  }
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	
	  var _proto = RuleList.prototype;
	
	  _proto.add = function add(name, decl, ruleOptions) {
	    var _this$options = this.options,
	        parent = _this$options.parent,
	        sheet = _this$options.sheet,
	        jss = _this$options.jss,
	        Renderer = _this$options.Renderer,
	        generateId = _this$options.generateId,
	        scoped = _this$options.scoped;
	
	    var options = _extends({
	      classes: this.classes,
	      parent: parent,
	      sheet: sheet,
	      jss: jss,
	      Renderer: Renderer,
	      generateId: generateId,
	      scoped: scoped,
	      name: name
	    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
	    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
	    // we need to make the key unique within this RuleList instance scope.
	
	
	    var key = name;
	
	    if (name in this.raw) {
	      key = name + "-d" + this.counter++;
	    } // We need to save the original decl before creating the rule
	    // because cache plugin needs to use it as a key to return a cached rule.
	
	
	    this.raw[key] = decl;
	
	    if (key in this.classes) {
	      // E.g. rules inside of @media container
	      options.selector = "." + escape(this.classes[key]);
	    }
	
	    var rule = createRule(key, decl, options);
	    if (!rule) return null;
	    this.register(rule);
	    var index = options.index === undefined ? this.index.length : options.index;
	    this.index.splice(index, 0, rule);
	    return rule;
	  }
	  /**
	   * Get a rule.
	   */
	  ;
	
	  _proto.get = function get(name) {
	    return this.map[name];
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.remove = function remove(rule) {
	    this.unregister(rule);
	    delete this.raw[rule.key];
	    this.index.splice(this.index.indexOf(rule), 1);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.index.indexOf(rule);
	  }
	  /**
	   * Run `onProcessRule()` plugins on every rule.
	   */
	  ;
	
	  _proto.process = function process() {
	    var plugins$$1 = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
	    // we end up with very hard-to-track-down side effects.
	
	    this.index.slice(0).forEach(plugins$$1.onProcessRule, plugins$$1);
	  }
	  /**
	   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
	   */
	  ;
	
	  _proto.register = function register(rule) {
	    this.map[rule.key] = rule;
	
	    if (rule instanceof StyleRule) {
	      this.map[rule.selector] = rule;
	      if (rule.id) this.classes[rule.key] = rule.id;
	    } else if (rule instanceof KeyframesRule && this.keyframes) {
	      this.keyframes[rule.name] = rule.id;
	    }
	  }
	  /**
	   * Unregister a rule.
	   */
	  ;
	
	  _proto.unregister = function unregister(rule) {
	    delete this.map[rule.key];
	
	    if (rule instanceof StyleRule) {
	      delete this.map[rule.selector];
	      delete this.classes[rule.key];
	    } else if (rule instanceof KeyframesRule) {
	      delete this.keyframes[rule.name];
	    }
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var name;
	    var data;
	    var options;
	
	    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
	      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe
	
	      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe
	
	      options = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe
	
	      options = arguments.length <= 1 ? undefined : arguments[1];
	      name = null;
	    }
	
	    if (name) {
	      this.updateOne(this.map[name], data, options);
	    } else {
	      for (var index = 0; index < this.index.length; index++) {
	        this.updateOne(this.index[index], data, options);
	      }
	    }
	  }
	  /**
	   * Execute plugins, update rule props.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    if (options === void 0) {
	      options = defaultUpdateOptions;
	    }
	
	    var _this$options2 = this.options,
	        plugins$$1 = _this$options2.jss.plugins,
	        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
	
	    if (rule.rules instanceof RuleList) {
	      rule.rules.update(data, options);
	      return;
	    }
	
	    var styleRule = rule;
	    var style = styleRule.style;
	    plugins$$1.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
	
	    if (options.process && style && style !== styleRule.style) {
	      // We need to run the plugins in case new `style` relies on syntax plugins.
	      plugins$$1.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.
	
	      for (var prop in styleRule.style) {
	        var nextValue = styleRule.style[prop];
	        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (nextValue !== prevValue) {
	          styleRule.prop(prop, nextValue, forceUpdateOptions);
	        }
	      } // Remove props.
	
	
	      for (var _prop in style) {
	        var _nextValue = styleRule.style[_prop];
	        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (_nextValue == null && _nextValue !== _prevValue) {
	          styleRule.prop(_prop, null, forceUpdateOptions);
	        }
	      }
	    }
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    var str = '';
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	
	    for (var index = 0; index < this.index.length; index++) {
	      var rule = this.index[index];
	      var css = rule.toString(options); // No need to render an empty rule.
	
	      if (!css && !link) continue;
	      if (str) str += '\n';
	      str += css;
	    }
	
	    return str;
	  };
	
	  return RuleList;
	}();
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(styles, options) {
	    this.options = void 0;
	    this.deployed = void 0;
	    this.attached = void 0;
	    this.rules = void 0;
	    this.renderer = void 0;
	    this.classes = void 0;
	    this.keyframes = void 0;
	    this.queue = void 0;
	    this.attached = false;
	    this.deployed = false;
	    this.classes = {};
	    this.keyframes = {};
	    this.options = _extends({}, options, {
	      sheet: this,
	      parent: this,
	      classes: this.classes,
	      keyframes: this.keyframes
	    });
	
	    if (options.Renderer) {
	      this.renderer = new options.Renderer(this);
	    }
	
	    this.rules = new RuleList(this.options);
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.attach = function attach() {
	    if (this.attached) return this;
	    if (this.renderer) this.renderer.attach();
	    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
	
	    if (!this.deployed) this.deploy();
	    return this;
	  }
	  /**
	   * Remove renderable from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.attached) return this;
	    if (this.renderer) this.renderer.detach();
	    this.attached = false;
	    return this;
	  }
	  /**
	   * Add a rule to the current stylesheet.
	   * Will insert a rule also after the stylesheet has been rendered first time.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, decl, options) {
	    var queue = this.queue; // Plugins can create rules.
	    // In order to preserve the right order, we need to queue all `.addRule` calls,
	    // which happen after the first `rules.add()` call.
	
	    if (this.attached && !queue) this.queue = [];
	    var rule = this.rules.add(name, decl, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	
	    if (this.attached) {
	      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
	      // It will be inserted all together when .attach is called.
	
	      if (queue) queue.push(rule);else {
	        this.insertRule(rule);
	
	        if (this.queue) {
	          this.queue.forEach(this.insertRule, this);
	          this.queue = undefined;
	        }
	      }
	      return rule;
	    } // We can't add rules to a detached style node.
	    // We will redeploy the sheet once user will attach it.
	
	
	    this.deployed = false;
	    return rule;
	  }
	  /**
	   * Insert rule into the StyleSheet
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule) {
	    if (this.renderer) {
	      this.renderer.insertRule(rule);
	    }
	  }
	  /**
	   * Create and add rules.
	   * Will render also after Style Sheet was rendered the first time.
	   */
	  ;
	
	  _proto.addRules = function addRules(styles, options) {
	    var added = [];
	
	    for (var name in styles) {
	      var rule = this.addRule(name, styles[name], options);
	      if (rule) added.push(rule);
	    }
	
	    return added;
	  }
	  /**
	   * Get a rule by name.
	   */
	  ;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Delete a rule by name.
	   * Returns `true`: if rule has been deleted from the DOM.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(name) {
	    var rule = typeof name === 'object' ? name : this.rules.get(name);
	    if (!rule) return false;
	    this.rules.remove(rule);
	
	    if (this.attached && rule.renderable && this.renderer) {
	      return this.renderer.deleteRule(rule.renderable);
	    }
	
	    return true;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Deploy pure CSS string to a renderable.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    if (this.renderer) this.renderer.deploy();
	    this.deployed = true;
	    return this;
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var _this$rules;
	
	    (_this$rules = this.rules).update.apply(_this$rules, arguments);
	
	    return this;
	  }
	  /**
	   * Updates a single rule.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    this.rules.updateOne(rule, data, options);
	    return this;
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    return this.rules.toString(options);
	  };
	
	  return StyleSheet;
	}();
	
	var PluginsRegistry =
	/*#__PURE__*/
	function () {
	  function PluginsRegistry() {
	    this.plugins = {
	      internal: [],
	      external: []
	    };
	    this.registry = void 0;
	  }
	
	  var _proto = PluginsRegistry.prototype;
	
	  /**
	   * Call `onCreateRule` hooks and return an object if returned by a hook.
	   */
	  _proto.onCreateRule = function onCreateRule(name, decl, options) {
	    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
	      var rule = this.registry.onCreateRule[i](name, decl, options);
	      if (rule) return rule;
	    }
	
	    return null;
	  }
	  /**
	   * Call `onProcessRule` hooks.
	   */
	  ;
	
	  _proto.onProcessRule = function onProcessRule(rule) {
	    if (rule.isProcessed) return;
	    var sheet = rule.options.sheet;
	
	    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
	      this.registry.onProcessRule[i](rule, sheet);
	    }
	
	    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	    rule.isProcessed = true;
	  }
	  /**
	   * Call `onProcessStyle` hooks.
	   */
	  ;
	
	  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
	    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
	      // $FlowFixMe
	      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
	    }
	  }
	  /**
	   * Call `onProcessSheet` hooks.
	   */
	  ;
	
	  _proto.onProcessSheet = function onProcessSheet(sheet) {
	    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
	      this.registry.onProcessSheet[i](sheet);
	    }
	  }
	  /**
	   * Call `onUpdate` hooks.
	   */
	  ;
	
	  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
	    for (var i = 0; i < this.registry.onUpdate.length; i++) {
	      this.registry.onUpdate[i](data, rule, sheet, options);
	    }
	  }
	  /**
	   * Call `onChangeValue` hooks.
	   */
	  ;
	
	  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
	    var processedValue = value;
	
	    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
	      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
	    }
	
	    return processedValue;
	  }
	  /**
	   * Register a plugin.
	   */
	  ;
	
	  _proto.use = function use(newPlugin, options) {
	    if (options === void 0) {
	      options = {
	        queue: 'external'
	      };
	    }
	
	    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
	
	    if (plugins.indexOf(newPlugin) !== -1) {
	      return;
	    }
	
	    plugins.push(newPlugin);
	    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
	      for (var name in plugin) {
	        if (name in registry) {
	          registry[name].push(plugin[name]);
	        } else {
	           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
	        }
	      }
	
	      return registry;
	    }, {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: [],
	      onUpdate: []
	    });
	  };
	
	  return PluginsRegistry;
	}();
	
	/**
	 * Sheets registry to access them all at one place.
	 */
	var SheetsRegistry =
	/*#__PURE__*/
	function () {
	  function SheetsRegistry() {
	    this.registry = [];
	  }
	
	  var _proto = SheetsRegistry.prototype;
	
	  /**
	   * Register a Style Sheet.
	   */
	  _proto.add = function add(sheet) {
	    var registry = this.registry;
	    var index = sheet.options.index;
	    if (registry.indexOf(sheet) !== -1) return;
	
	    if (registry.length === 0 || index >= this.index) {
	      registry.push(sheet);
	      return;
	    } // Find a position.
	
	
	    for (var i = 0; i < registry.length; i++) {
	      if (registry[i].options.index > index) {
	        registry.splice(i, 0, sheet);
	        return;
	      }
	    }
	  }
	  /**
	   * Reset the registry.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    this.registry = [];
	  }
	  /**
	   * Remove a Style Sheet.
	   */
	  ;
	
	  _proto.remove = function remove(sheet) {
	    var index = this.registry.indexOf(sheet);
	    this.registry.splice(index, 1);
	  }
	  /**
	   * Convert all attached sheets to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        attached = _ref.attached,
	        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);
	
	    var css = '';
	
	    for (var i = 0; i < this.registry.length; i++) {
	      var sheet = this.registry[i];
	
	      if (attached != null && sheet.attached !== attached) {
	        continue;
	      }
	
	      if (css) css += '\n';
	      css += sheet.toString(options);
	    }
	
	    return css;
	  };
	
	  _createClass(SheetsRegistry, [{
	    key: "index",
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	
	var sheets = new SheetsRegistry();
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var globalThis = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
	if (globalThis[ns] == null) globalThis[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
	// the current version with just one short number and use it for classes generation
	// we use a counter. Also it is more accurate, because user can manually reevaluate
	// the module.
	
	var moduleId = globalThis[ns]++;
	
	var maxRules = 1e10;
	
	/**
	 * Returns a function which generates unique class names based on counters.
	 * When new generator function is created, rule counter is reseted.
	 * We need to reset the rule counter for SSR for each request.
	 */
	var createGenerateId = function createGenerateId(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var ruleCounter = 0;
	  return function (rule, sheet) {
	    ruleCounter += 1;
	
	    if (ruleCounter > maxRules) {
	       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
	    }
	
	    var jssId = '';
	    var prefix = '';
	
	    if (sheet) {
	      if (sheet.options.classNamePrefix) {
	        prefix = sheet.options.classNamePrefix;
	      }
	
	      if (sheet.options.jss.id != null) {
	        jssId = String(sheet.options.jss.id);
	      }
	    }
	
	    if (options.minify) {
	      // Using "c" because a number can't be the first char in a class name.
	      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
	    }
	
	    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
	  };
	};
	
	/**
	 * Cache the value from the first time a function is called.
	 */
	var memoize = function memoize(fn) {
	  var value;
	  return function () {
	    if (!value) value = fn();
	    return value;
	  };
	};
	/**
	 * Get a style property value.
	 */
	
	
	function getPropertyValue(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      return cssRule.attributeStyleMap.get(prop);
	    }
	
	    return cssRule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	}
	/**
	 * Set a style property.
	 */
	
	
	function setProperty(cssRule, prop, value) {
	  try {
	    var cssValue = value;
	
	    if (Array.isArray(value)) {
	      cssValue = toCssValue(value, true);
	
	      if (value[value.length - 1] === '!important') {
	        cssRule.style.setProperty(prop, cssValue, 'important');
	        return true;
	      }
	    } // Support CSSTOM.
	
	
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.set(prop, cssValue);
	    } else {
	      cssRule.style.setProperty(prop, cssValue);
	    }
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Remove a style property.
	 */
	
	
	function removeProperty(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.delete(prop);
	    } else {
	      cssRule.style.removeProperty(prop);
	    }
	  } catch (err) {
	     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
	  }
	}
	/**
	 * Set the selector.
	 */
	
	
	function setSelector(cssRule, selectorText) {
	  cssRule.selectorText = selectorText; // Return false if setter was not successful.
	  // Currently works in chrome only.
	
	  return cssRule.selectorText === selectorText;
	}
	/**
	 * Gets the `head` element upon the first call and caches it.
	 * We assume it can't be null.
	 */
	
	
	var getHead = memoize(function () {
	  return document.querySelector('head');
	});
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	
	function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find attached sheet with the highest index.
	 */
	
	
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find a comment with "jss" inside.
	 */
	
	
	function findCommentNode(text) {
	  var head = getHead();
	
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	
	  return null;
	}
	
	/**
	 * Find a node before which we can insert the sheet.
	 */
	function findPrevNode(options) {
	  var registry = sheets.registry;
	
	  if (registry.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element
	      };
	    } // Otherwise insert after the last attached.
	
	
	    sheet = findHighestSheet(registry, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element.nextSibling
	      };
	    }
	  } // Try to find a comment placeholder if registry is empty.
	
	
	  var insertionPoint = options.insertionPoint;
	
	  if (insertionPoint && typeof insertionPoint === 'string') {
	    var comment = findCommentNode(insertionPoint);
	
	    if (comment) {
	      return {
	        parent: comment.parentNode,
	        node: comment.nextSibling
	      };
	    } // If user specifies an insertion point and it can't be found in the document -
	    // bad specificity issues may appear.
	
	
	     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
	  }
	
	  return false;
	}
	/**
	 * Insert style element into the DOM.
	 */
	
	
	function insertStyle(style, options) {
	  var insertionPoint = options.insertionPoint;
	  var nextNode = findPrevNode(options);
	
	  if (nextNode !== false && nextNode.parent) {
	    nextNode.parent.insertBefore(style, nextNode.node);
	    return;
	  } // Works with iframes and any node types.
	
	
	  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
	    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	    var insertionPointElement = insertionPoint;
	    var parentNode = insertionPointElement.parentNode;
	    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
	    return;
	  }
	
	  getHead().appendChild(style);
	}
	/**
	 * Read jss nonce setting from the page if the user has set it.
	 */
	
	
	var getNonce = memoize(function () {
	  var node = document.querySelector('meta[property="csp-nonce"]');
	  return node ? node.getAttribute('content') : null;
	});
	
	var _insertRule = function insertRule(container, rule, index) {
	  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
	
	  if (index === undefined || index > maxIndex) {
	    // eslint-disable-next-line no-param-reassign
	    index = maxIndex;
	  }
	
	  try {
	    if ('insertRule' in container) {
	      var c = container;
	      c.insertRule(rule, index);
	    } // Keyframes rule.
	    else if ('appendRule' in container) {
	        var _c = container;
	
	        _c.appendRule(rule);
	      }
	  } catch (err) {
	     false ? warning(false, "[JSS] " + err.message) : void 0;
	    return false;
	  }
	
	  return container.cssRules[index];
	};
	
	var createStyle = function createStyle() {
	  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
	  // insert rules after we insert the style tag.
	  // It seems to kick-off the source order specificity algorithm.
	
	  el.textContent = '\n';
	  return el;
	};
	
	var DomRenderer =
	/*#__PURE__*/
	function () {
	  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
	  function DomRenderer(sheet) {
	    this.getPropertyValue = getPropertyValue;
	    this.setProperty = setProperty;
	    this.removeProperty = removeProperty;
	    this.setSelector = setSelector;
	    this.element = void 0;
	    this.sheet = void 0;
	    this.hasInsertedRules = false;
	    // There is no sheet when the renderer is used from a standalone StyleRule.
	    if (sheet) sheets.add(sheet);
	    this.sheet = sheet;
	
	    var _ref = this.sheet ? this.sheet.options : {},
	        media = _ref.media,
	        meta = _ref.meta,
	        element = _ref.element;
	
	    this.element = element || createStyle();
	    this.element.setAttribute('data-jss', '');
	    if (media) this.element.setAttribute('media', media);
	    if (meta) this.element.setAttribute('data-meta', meta);
	    var nonce = getNonce();
	    if (nonce) this.element.setAttribute('nonce', nonce);
	  }
	  /**
	   * Insert style element into render tree.
	   */
	
	
	  var _proto = DomRenderer.prototype;
	
	  _proto.attach = function attach() {
	    // In the case the element node is external and it is already in the DOM.
	    if (this.element.parentNode || !this.sheet) return;
	    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	    // most browsers create a new CSSStyleSheet, except of all IEs.
	
	    var deployed = Boolean(this.sheet && this.sheet.deployed);
	
	    if (this.hasInsertedRules && deployed) {
	      this.hasInsertedRules = false;
	      this.deploy();
	    }
	  }
	  /**
	   * Remove style element from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    var parentNode = this.element.parentNode;
	    if (parentNode) parentNode.removeChild(this.element);
	  }
	  /**
	   * Inject CSS string into element.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    var sheet = this.sheet;
	    if (!sheet) return;
	
	    if (sheet.options.link) {
	      this.insertRules(sheet.rules);
	      return;
	    }
	
	    this.element.textContent = "\n" + sheet.toString() + "\n";
	  }
	  /**
	   * Insert RuleList into an element.
	   */
	  ;
	
	  _proto.insertRules = function insertRules(rules, nativeParent) {
	    for (var i = 0; i < rules.index.length; i++) {
	      this.insertRule(rules.index[i], i, nativeParent);
	    }
	  }
	  /**
	   * Insert a rule into element.
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule, index, nativeParent) {
	    if (nativeParent === void 0) {
	      nativeParent = this.element.sheet;
	    }
	
	    if (rule.rules) {
	      var parent = rule;
	      var latestNativeParent = nativeParent;
	
	      if (rule.type === 'conditional' || rule.type === 'keyframes') {
	        // We need to render the container without children first.
	        latestNativeParent = _insertRule(nativeParent, parent.toString({
	          children: false
	        }), index);
	
	        if (latestNativeParent === false) {
	          return false;
	        }
	      }
	
	      this.insertRules(parent.rules, latestNativeParent);
	      return latestNativeParent;
	    } // IE keeps the CSSStyleSheet after style node has been reattached,
	    // so we need to check if the `renderable` reference the right style sheet and not
	    // rerender those rules.
	
	
	    if (rule.renderable && rule.renderable.parentStyleSheet === this.element.sheet) {
	      return rule.renderable;
	    }
	
	    var ruleStr = rule.toString();
	    if (!ruleStr) return false;
	
	    var nativeRule = _insertRule(nativeParent, ruleStr, index);
	
	    if (nativeRule === false) {
	      return false;
	    }
	
	    this.hasInsertedRules = true;
	    rule.renderable = nativeRule;
	    return nativeRule;
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(cssRule) {
	    var sheet = this.element.sheet;
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    sheet.deleteRule(index);
	    return true;
	  }
	  /**
	   * Get index of a CSS Rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(cssRule) {
	    var cssRules = this.element.sheet.cssRules;
	
	    for (var index = 0; index < cssRules.length; index++) {
	      if (cssRule === cssRules[index]) return index;
	    }
	
	    return -1;
	  }
	  /**
	   * Generate a new CSS rule and replace the existing one.
	   *
	   * Only used for some old browsers because they can't set a selector.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(cssRule, rule) {
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    this.element.sheet.deleteRule(index);
	    return this.insertRule(rule, index);
	  }
	  /**
	   * Get all rules elements.
	   */
	  ;
	
	  _proto.getRules = function getRules() {
	    return this.element.sheet.cssRules;
	  };
	
	  return DomRenderer;
	}();
	
	var instanceCounter = 0;
	
	var Jss =
	/*#__PURE__*/
	function () {
	  function Jss(options) {
	    this.id = instanceCounter++;
	    this.version = "10.0.4";
	    this.plugins = new PluginsRegistry();
	    this.options = {
	      id: {
	        minify: false
	      },
	      createGenerateId: createGenerateId,
	      Renderer: isInBrowser ? DomRenderer : null,
	      plugins: []
	    };
	    this.generateId = createGenerateId({
	      minify: false
	    });
	
	    for (var i = 0; i < plugins.length; i++) {
	      this.plugins.use(plugins[i], {
	        queue: 'internal'
	      });
	    }
	
	    this.setup(options);
	  }
	  /**
	   * Prepares various options, applies plugins.
	   * Should not be used twice on the same instance, because there is no plugins
	   * deduplication logic.
	   */
	
	
	  var _proto = Jss.prototype;
	
	  _proto.setup = function setup(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (options.createGenerateId) {
	      this.options.createGenerateId = options.createGenerateId;
	    }
	
	    if (options.id) {
	      this.options.id = _extends({}, this.options.id, options.id);
	    }
	
	    if (options.createGenerateId || options.id) {
	      this.generateId = this.options.createGenerateId(this.options.id);
	    }
	
	    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
	
	    if ('Renderer' in options) {
	      this.options.Renderer = options.Renderer;
	    } // eslint-disable-next-line prefer-spread
	
	
	    if (options.plugins) this.use.apply(this, options.plugins);
	    return this;
	  }
	  /**
	   * Create a Style Sheet.
	   */
	  ;
	
	  _proto.createStyleSheet = function createStyleSheet(styles, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        index = _options.index;
	
	    if (typeof index !== 'number') {
	      index = sheets.index === 0 ? 0 : sheets.index + 1;
	    }
	
	    var sheet = new StyleSheet(styles, _extends({}, options, {
	      jss: this,
	      generateId: options.generateId || this.generateId,
	      insertionPoint: this.options.insertionPoint,
	      Renderer: this.options.Renderer,
	      index: index
	    }));
	    this.plugins.onProcessSheet(sheet);
	    return sheet;
	  }
	  /**
	   * Detach the Style Sheet and remove it from the registry.
	   */
	  ;
	
	  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
	    sheet.detach();
	    sheets.remove(sheet);
	    return this;
	  }
	  /**
	   * Create a rule without a Style Sheet.
	   * [Deprecated] will be removed in the next major version.
	   */
	  ;
	
	  _proto.createRule = function createRule$$1(name, style, options) {
	    if (style === void 0) {
	      style = {};
	    }
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    // Enable rule without name for inline styles.
	    if (typeof name === 'object') {
	      return this.createRule(undefined, name, style);
	    }
	
	    var ruleOptions = _extends({}, options, {
	      name: name,
	      jss: this,
	      Renderer: this.options.Renderer
	    });
	
	    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
	    if (!ruleOptions.classes) ruleOptions.classes = {};
	    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
	
	    var rule = createRule(name, style, ruleOptions);
	
	    if (rule) this.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Register plugin. Passed function will be invoked with a rule instance.
	   */
	  ;
	
	  _proto.use = function use() {
	    var _this = this;
	
	    for (var _len = arguments.length, plugins$$1 = new Array(_len), _key = 0; _key < _len; _key++) {
	      plugins$$1[_key] = arguments[_key];
	    }
	
	    plugins$$1.forEach(function (plugin) {
	      _this.plugins.use(plugin);
	    });
	    return this;
	  };
	
	  return Jss;
	}();
	
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	function getDynamicStyles(styles) {
	  var to = null;
	
	  for (var key in styles) {
	    var value = styles[key];
	    var type = typeof value;
	
	    if (type === 'function') {
	      if (!to) to = {};
	      to[key] = value;
	    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	      var extracted = getDynamicStyles(value);
	
	      if (extracted) {
	        if (!to) to = {};
	        to[key] = extracted;
	      }
	    }
	  }
	
	  return to;
	}
	
	/**
	 * SheetsManager is like a WeakMap which is designed to count StyleSheet
	 * instances and attach/detach automatically.
	 */
	var SheetsManager =
	/*#__PURE__*/
	function () {
	  function SheetsManager() {
	    this.length = 0;
	    this.sheets = new WeakMap();
	  }
	
	  var _proto = SheetsManager.prototype;
	
	  _proto.get = function get(key) {
	    var entry = this.sheets.get(key);
	    return entry && entry.sheet;
	  };
	
	  _proto.add = function add(key, sheet) {
	    if (this.sheets.has(key)) return;
	    this.length++;
	    this.sheets.set(key, {
	      sheet: sheet,
	      refs: 0
	    });
	  };
	
	  _proto.manage = function manage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs === 0) {
	        entry.sheet.attach();
	      }
	
	      entry.refs++;
	      return entry.sheet;
	    }
	
	    warning(false, "[JSS] SheetsManager: can't find sheet to manage");
	    return undefined;
	  };
	
	  _proto.unmanage = function unmanage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs > 0) {
	        entry.refs--;
	        if (entry.refs === 0) entry.sheet.detach();
	      }
	    } else {
	      warning(false, "SheetsManager: can't find sheet to unmanage");
	    }
	  };
	
	  _createClass(SheetsManager, [{
	    key: "size",
	    get: function get() {
	      return this.length;
	    }
	  }]);
	
	  return SheetsManager;
	}();
	
	/**
	 * A better abstraction over CSS.
	 *
	 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
	 * @website https://github.com/cssinjs/jss
	 * @license MIT
	 */
	
	/**
	 * Export a constant indicating if this browser has CSSTOM support.
	 * https://developers.google.com/web/updates/2018/03/cssom
	 */
	var hasCSSTOMSupport = typeof CSS !== 'undefined' && CSS && 'number' in CSS;
	/**
	 * Creates a new instance of Jss.
	 */
	
	var create = function create(options) {
	  return new Jss(options);
	};
	/**
	 * A global Jss instance.
	 */
	
	var index = create();
	
	exports.hasCSSTOMSupport = hasCSSTOMSupport;
	exports.create = create;
	exports.default = index;
	exports.getDynamicStyles = getDynamicStyles;
	exports.toCssValue = toCssValue;
	exports.createRule = createRule;
	exports.SheetsRegistry = SheetsRegistry;
	exports.SheetsManager = SheetsManager;
	exports.RuleList = RuleList;
	exports.sheets = sheets;
	exports.createGenerateId = createGenerateId;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(27);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	function __spreadArrays() {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A container for all of the Logger instances
	 */
	var instances = [];
	(function (LogLevel) {
	    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
	    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
	    LogLevel[LogLevel["INFO"] = 2] = "INFO";
	    LogLevel[LogLevel["WARN"] = 3] = "WARN";
	    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
	    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
	})(exports.LogLevel || (exports.LogLevel = {}));
	/**
	 * The default log level
	 */
	var defaultLogLevel = exports.LogLevel.INFO;
	/**
	 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
	 * messages on to their corresponding console counterparts (if the log method
	 * is supported by the current log level)
	 */
	var defaultLogHandler = function (instance, logType) {
	    var args = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        args[_i - 2] = arguments[_i];
	    }
	    if (logType < instance.logLevel) {
	        return;
	    }
	    var now = new Date().toISOString();
	    switch (logType) {
	        /**
	         * By default, `console.debug` is not displayed in the developer console (in
	         * chrome). To avoid forcing users to have to opt-in to these logs twice
	         * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
	         * logs to the `console.log` function.
	         */
	        case exports.LogLevel.DEBUG:
	            console.log.apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
	            break;
	        case exports.LogLevel.VERBOSE:
	            console.log.apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
	            break;
	        case exports.LogLevel.INFO:
	            console.info.apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
	            break;
	        case exports.LogLevel.WARN:
	            console.warn.apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
	            break;
	        case exports.LogLevel.ERROR:
	            console.error.apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
	            break;
	        default:
	            throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
	    }
	};
	var Logger = /** @class */ (function () {
	    /**
	     * Gives you an instance of a Logger to capture messages according to
	     * Firebase's logging scheme.
	     *
	     * @param name The name that the logs will be associated with
	     */
	    function Logger(name) {
	        this.name = name;
	        /**
	         * The log level of the given Logger instance.
	         */
	        this._logLevel = defaultLogLevel;
	        /**
	         * The log handler for the Logger instance.
	         */
	        this._logHandler = defaultLogHandler;
	        /**
	         * Capture the current instance for later use
	         */
	        instances.push(this);
	    }
	    Object.defineProperty(Logger.prototype, "logLevel", {
	        get: function () {
	            return this._logLevel;
	        },
	        set: function (val) {
	            if (!(val in exports.LogLevel)) {
	                throw new TypeError('Invalid value assigned to `logLevel`');
	            }
	            this._logLevel = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Logger.prototype, "logHandler", {
	        get: function () {
	            return this._logHandler;
	        },
	        set: function (val) {
	            if (typeof val !== 'function') {
	                throw new TypeError('Value assigned to `logHandler` must be a function');
	            }
	            this._logHandler = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * The functions below are all based on the `console` interface
	     */
	    Logger.prototype.debug = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.DEBUG], args));
	    };
	    Logger.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.VERBOSE], args));
	    };
	    Logger.prototype.info = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.INFO], args));
	    };
	    Logger.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.WARN], args));
	    };
	    Logger.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.ERROR], args));
	    };
	    return Logger;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function setLogLevel(level) {
	    instances.forEach(function (inst) {
	        inst.logLevel = level;
	    });
	}
	
	exports.Logger = Logger;
	exports.setLogLevel = setLogLevel;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(62));
	
	var defaultTheme = (0, _createMuiTheme.default)();
	var _default = defaultTheme;
	exports.default = _default;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.duration = exports.easing = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
	// to learn the context in which each easing should be used.
	var easing = {
	  // This is the most common easing curve.
	  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
	  // Objects enter the screen at full velocity from off-screen and
	  // slowly decelerate to a resting point.
	  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
	  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
	  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
	  // The sharp curve is used by objects that may return to the screen at any time.
	  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
	}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
	// to learn when use what timing
	
	exports.easing = easing;
	var duration = {
	  shortest: 150,
	  shorter: 200,
	  short: 250,
	  // most basic recommended timing
	  standard: 300,
	  // this is to be used in complex animations
	  complex: 375,
	  // recommended when something is entering screen
	  enteringScreen: 225,
	  // recommended when something is leaving screen
	  leavingScreen: 195
	};
	exports.duration = duration;
	
	function formatMs(milliseconds) {
	  return "".concat(Math.round(milliseconds), "ms");
	}
	/**
	 * @param {string|Array} props
	 * @param {object} param
	 * @param {string} param.prop
	 * @param {number} param.duration
	 * @param {string} param.easing
	 * @param {number} param.delay
	 */
	
	
	var _default = {
	  easing: easing,
	  duration: duration,
	  create: function create() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$duration = options.duration,
	        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
	        _options$easing = options.easing,
	        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
	        _options$delay = options.delay,
	        delay = _options$delay === void 0 ? 0 : _options$delay,
	        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
	
	    if (false) {
	      var isString = function isString(value) {
	        return typeof value === 'string';
	      };
	
	      var isNumber = function isNumber(value) {
	        return !isNaN(parseFloat(value));
	      };
	
	      if (!isString(props) && !Array.isArray(props)) {
	        console.error('Material-UI: argument "props" must be a string or Array.');
	      }
	
	      if (!isNumber(durationOption) && !isString(durationOption)) {
	        console.error("Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
	      }
	
	      if (!isString(easingOption)) {
	        console.error('Material-UI: argument "easing" must be a string.');
	      }
	
	      if (!isNumber(delay) && !isString(delay)) {
	        console.error('Material-UI: argument "delay" must be a number or a string.');
	      }
	
	      if (Object.keys(other).length !== 0) {
	        console.error("Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]"));
	      }
	    }
	
	    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
	      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
	    }).join(',');
	  },
	  getAutoHeightDuration: function getAutoHeightDuration(height) {
	    if (!height) {
	      return 0;
	    }
	
	    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
	
	    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
	  }
	};
	exports.default = _default;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(190));

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(36);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
	 * License: MIT - http://mrgnrdrck.mit-license.org
	 *
	 * https://github.com/mroderick/PubSubJS
	 */
	
	(function (root, factory){
	    'use strict';
	
	    var PubSub = {};
	    root.PubSub = PubSub;
	
	    var define = root.define;
	
	    factory(PubSub);
	
	    // AMD support
	    if (typeof define === 'function' && define.amd){
	        define(function() { return PubSub; });
	
	        // CommonJS and Node.js module support
	    } else if (true){
	        if (module !== undefined && module.exports) {
	            exports = module.exports = PubSub; // Node.js specific `module.exports`
	        }
	        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
	        module.exports = exports = PubSub; // CommonJS
	    }
	
	}(( typeof window === 'object' && window ) || this, function (PubSub){
	    'use strict';
	
	    var messages = {},
	        lastUid = -1;
	
	    function hasKeys(obj){
	        var key;
	
	        for (key in obj){
	            if ( obj.hasOwnProperty(key) ){
	                return true;
	            }
	        }
	        return false;
	    }
	
	    /**
	     * Returns a function that throws the passed exception, for use as argument for setTimeout
	     * @alias throwException
	     * @function
	     * @param { Object } ex An Error object
	     */
	    function throwException( ex ){
	        return function reThrowException(){
	            throw ex;
	        };
	    }
	
	    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
	        try {
	            subscriber( message, data );
	        } catch( ex ){
	            setTimeout( throwException( ex ), 0);
	        }
	    }
	
	    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
	        subscriber( message, data );
	    }
	
	    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
	        var subscribers = messages[matchedMessage],
	            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
	            s;
	
	        if ( !messages.hasOwnProperty( matchedMessage ) ) {
	            return;
	        }
	
	        for (s in subscribers){
	            if ( subscribers.hasOwnProperty(s)){
	                callSubscriber( subscribers[s], originalMessage, data );
	            }
	        }
	    }
	
	    function createDeliveryFunction( message, data, immediateExceptions ){
	        return function deliverNamespaced(){
	            var topic = String( message ),
	                position = topic.lastIndexOf( '.' );
	
	            // deliver the message as it is now
	            deliverMessage(message, message, data, immediateExceptions);
	
	            // trim the hierarchy and deliver message to each level
	            while( position !== -1 ){
	                topic = topic.substr( 0, position );
	                position = topic.lastIndexOf('.');
	                deliverMessage( message, topic, data, immediateExceptions );
	            }
	        };
	    }
	
	    function messageHasSubscribers( message ){
	        var topic = String( message ),
	            found = Boolean(messages.hasOwnProperty( topic ) && hasKeys(messages[topic])),
	            position = topic.lastIndexOf( '.' );
	
	        while ( !found && position !== -1 ){
	            topic = topic.substr( 0, position );
	            position = topic.lastIndexOf( '.' );
	            found = Boolean(messages.hasOwnProperty( topic ) && hasKeys(messages[topic]));
	        }
	
	        return found;
	    }
	
	    function publish( message, data, sync, immediateExceptions ){
	        message = (typeof message === 'symbol') ? message.toString() : message;
	
	        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
	            hasSubscribers = messageHasSubscribers( message );
	
	        if ( !hasSubscribers ){
	            return false;
	        }
	
	        if ( sync === true ){
	            deliver();
	        } else {
	            setTimeout( deliver, 0 );
	        }
	        return true;
	    }
	
	    /**
	     * Publishes the message, passing the data to it's subscribers
	     * @function
	     * @alias publish
	     * @param { String } message The message to publish
	     * @param {} data The data to pass to subscribers
	     * @return { Boolean }
	     */
	    PubSub.publish = function( message, data ){
	        return publish( message, data, false, PubSub.immediateExceptions );
	    };
	
	    /**
	     * Publishes the message synchronously, passing the data to it's subscribers
	     * @function
	     * @alias publishSync
	     * @param { String } message The message to publish
	     * @param {} data The data to pass to subscribers
	     * @return { Boolean }
	     */
	    PubSub.publishSync = function( message, data ){
	        return publish( message, data, true, PubSub.immediateExceptions );
	    };
	
	    /**
	     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
	     * @function
	     * @alias subscribe
	     * @param { String } message The message to subscribe to
	     * @param { Function } func The function to call when a new message is published
	     * @return { String }
	     */
	    PubSub.subscribe = function( message, func ){
	        if ( typeof func !== 'function'){
	            return false;
	        }
	
	        message = (typeof message === 'symbol') ? message.toString() : message;
	
	        // message is not registered yet
	        if ( !messages.hasOwnProperty( message ) ){
	            messages[message] = {};
	        }
	
	        // forcing token as String, to allow for future expansions without breaking usage
	        // and allow for easy use as key names for the 'messages' object
	        var token = 'uid_' + String(++lastUid);
	        messages[message][token] = func;
	        
	        // return token for unsubscribing
	        return token;
	    };
	
	    /**
	     * Subscribes the passed function to the passed message once
	     * @function
	     * @alias subscribeOnce
	     * @param { String } message The message to subscribe to
	     * @param { Function } func The function to call when a new message is published
	     * @return { PubSub }
	     */
	    PubSub.subscribeOnce = function( message, func ){
	        var token = PubSub.subscribe( message, function(){
	            // before func apply, unsubscribe message
	            PubSub.unsubscribe( token );
	            func.apply( this, arguments );
	        });
	        return PubSub;
	    };
	
	    /**
	     * Clears all subscriptions
	     * @function
	     * @public
	     * @alias clearAllSubscriptions
	     */
	    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
	        messages = {};
	    };
	
	    /**
	     * Clear subscriptions by the topic
	     * @function
	     * @public
	     * @alias clearAllSubscriptions
	     * @return { int }
	     */
	    PubSub.clearSubscriptions = function clearSubscriptions(topic){
	        var m;
	        for (m in messages){
	            if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0){
	                delete messages[m];
	            }
	        }
	    };
	
	    /** 
	       Count subscriptions by the topic
	     * @function
	     * @public
	     * @alias countSubscriptions
	     * @return { Array }
	    */
	    PubSub.countSubscriptions = function countSubscriptions(topic){
	        var m;
	        var count = 0;
	        for (m in messages){
	            if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0){
	                count++;
	            }
	        }
	        return count;
	    };
	
	    
	    /** 
	       Gets subscriptions by the topic
	     * @function
	     * @public
	     * @alias getSubscriptions
	    */
	    PubSub.getSubscriptions = function getSubscriptions(topic){
	        var m;
	        var list = [];
	        for (m in messages){
	            if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0){
	                list.push(m);
	            }
	        }
	        return list;
	    };
	
	    /**
	     * Removes subscriptions
	     *
	     * - When passed a token, removes a specific subscription.
	     *
		 * - When passed a function, removes all subscriptions for that function
	     *
		 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
	     * @function
	     * @public
	     * @alias subscribeOnce
	     * @param { String | Function } value A token, function or topic to unsubscribe from
	     * @example // Unsubscribing with a token
	     * var token = PubSub.subscribe('mytopic', myFunc);
	     * PubSub.unsubscribe(token);
	     * @example // Unsubscribing with a function
	     * PubSub.unsubscribe(myFunc);
	     * @example // Unsubscribing from a topic
	     * PubSub.unsubscribe('mytopic');
	     */
	    PubSub.unsubscribe = function(value){
	        var descendantTopicExists = function(topic) {
	                var m;
	                for ( m in messages ){
	                    if ( messages.hasOwnProperty(m) && m.indexOf(topic) === 0 ){
	                        // a descendant of the topic exists:
	                        return true;
	                    }
	                }
	
	                return false;
	            },
	            isTopic    = typeof value === 'string' && ( messages.hasOwnProperty(value) || descendantTopicExists(value) ),
	            isToken    = !isTopic && typeof value === 'string',
	            isFunction = typeof value === 'function',
	            result = false,
	            m, message, t;
	
	        if (isTopic){
	            PubSub.clearSubscriptions(value);
	            return;
	        }
	
	        for ( m in messages ){
	            if ( messages.hasOwnProperty( m ) ){
	                message = messages[m];
	
	                if ( isToken && message[value] ){
	                    delete message[value];
	                    result = value;
	                    // tokens are unique, so we can just stop here
	                    break;
	                }
	
	                if (isFunction) {
	                    for ( t in message ){
	                        if (message.hasOwnProperty(t) && message[t] === value){
	                            delete message[t];
	                            result = true;
	                        }
	                    }
	                }
	            }
	        }
	
	        return result;
	    };
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)(module)))

/***/ },
/* 26 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ },
/* 27 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	var component = __webpack_require__(12);
	var tslib = __webpack_require__(11);
	var util = __webpack_require__(14);
	var idb = __webpack_require__(76);
	
	var name = "@firebase/installations";
	var version = "0.4.2";
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PENDING_TIMEOUT_MS = 10000;
	var PACKAGE_VERSION = "w:" + version;
	var INTERNAL_AUTH_VERSION = 'FIS_v2';
	var INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
	var TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
	var SERVICE = 'installations';
	var SERVICE_NAME = 'Installations';
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERROR_DESCRIPTION_MAP = (_a = {},
	    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration value: "{$valueName}"',
	    _a["not-registered" /* NOT_REGISTERED */] = 'Firebase Installation is not registered.',
	    _a["installation-not-found" /* INSTALLATION_NOT_FOUND */] = 'Firebase Installation not found.',
	    _a["request-failed" /* REQUEST_FAILED */] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
	    _a["app-offline" /* APP_OFFLINE */] = 'Could not process request. Application offline.',
	    _a["delete-pending-registration" /* DELETE_PENDING_REGISTRATION */] = "Can't delete installation while there is a pending registration request.",
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
	/** Returns true if error is a FirebaseError that is based on an error from the server. */
	function isServerError(error) {
	    return (error instanceof util.FirebaseError &&
	        error.code.includes("request-failed" /* REQUEST_FAILED */));
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getInstallationsEndpoint(_a) {
	    var projectId = _a.projectId;
	    return INSTALLATIONS_API_URL + "/projects/" + projectId + "/installations";
	}
	function extractAuthTokenInfoFromResponse(response) {
	    return {
	        token: response.token,
	        requestStatus: 2 /* COMPLETED */,
	        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
	        creationTime: Date.now()
	    };
	}
	function getErrorFromResponse(requestName, response) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var responseJson, errorData;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, response.json()];
	                case 1:
	                    responseJson = _a.sent();
	                    errorData = responseJson.error;
	                    return [2 /*return*/, ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */, {
	                            requestName: requestName,
	                            serverCode: errorData.code,
	                            serverMessage: errorData.message,
	                            serverStatus: errorData.status
	                        })];
	            }
	        });
	    });
	}
	function getHeaders(_a) {
	    var apiKey = _a.apiKey;
	    return new Headers({
	        'Content-Type': 'application/json',
	        Accept: 'application/json',
	        'x-goog-api-key': apiKey
	    });
	}
	function getHeadersWithAuth(appConfig, _a) {
	    var refreshToken = _a.refreshToken;
	    var headers = getHeaders(appConfig);
	    headers.append('Authorization', getAuthorizationHeader(refreshToken));
	    return headers;
	}
	/**
	 * Calls the passed in fetch wrapper and returns the response.
	 * If the returned response has a status of 5xx, re-runs the function once and
	 * returns the response.
	 */
	function retryIfServerError(fn) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var result;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, fn()];
	                case 1:
	                    result = _a.sent();
	                    if (result.status >= 500 && result.status < 600) {
	                        // Internal Server Error. Retry request.
	                        return [2 /*return*/, fn()];
	                    }
	                    return [2 /*return*/, result];
	            }
	        });
	    });
	}
	function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
	    // This works because the server will never respond with fractions of a second.
	    return Number(responseExpiresIn.replace('s', '000'));
	}
	function getAuthorizationHeader(refreshToken) {
	    return INTERNAL_AUTH_VERSION + " " + refreshToken;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function createInstallationRequest(appConfig, _a) {
	    var fid = _a.fid;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    endpoint = getInstallationsEndpoint(appConfig);
	                    headers = getHeaders(appConfig);
	                    body = {
	                        fid: fid,
	                        authVersion: INTERNAL_AUTH_VERSION,
	                        appId: appConfig.appId,
	                        sdkVersion: PACKAGE_VERSION
	                    };
	                    request = {
	                        method: 'POST',
	                        headers: headers,
	                        body: JSON.stringify(body)
	                    };
	                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
	                case 1:
	                    response = _b.sent();
	                    if (!response.ok) return [3 /*break*/, 3];
	                    return [4 /*yield*/, response.json()];
	                case 2:
	                    responseValue = _b.sent();
	                    registeredInstallationEntry = {
	                        fid: responseValue.fid || fid,
	                        registrationStatus: 2 /* COMPLETED */,
	                        refreshToken: responseValue.refreshToken,
	                        authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
	                    };
	                    return [2 /*return*/, registeredInstallationEntry];
	                case 3: return [4 /*yield*/, getErrorFromResponse('Create Installation', response)];
	                case 4: throw _b.sent();
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Returns a promise that resolves after given time passes. */
	function sleep(ms) {
	    return new Promise(function (resolve) {
	        setTimeout(resolve, ms);
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function bufferToBase64UrlSafe(array) {
	    var b64 = btoa(String.fromCharCode.apply(String, tslib.__spread(array)));
	    return b64.replace(/\+/g, '-').replace(/\//g, '_');
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
	var INVALID_FID = '';
	/**
	 * Generates a new FID using random values from Web Crypto API.
	 * Returns an empty string if FID generation fails for any reason.
	 */
	function generateFid() {
	    try {
	        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
	        // bytes. our implementation generates a 17 byte array instead.
	        var fidByteArray = new Uint8Array(17);
	        var crypto_1 = self.crypto || self.msCrypto;
	        crypto_1.getRandomValues(fidByteArray);
	        // Replace the first 4 random bits with the constant FID header of 0b0111.
	        fidByteArray[0] = 112 + (fidByteArray[0] % 16);
	        var fid = encode(fidByteArray);
	        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
	    }
	    catch (_a) {
	        // FID generation errored
	        return INVALID_FID;
	    }
	}
	/** Converts a FID Uint8Array to a base64 string representation. */
	function encode(fidByteArray) {
	    var b64String = bufferToBase64UrlSafe(fidByteArray);
	    // Remove the 23rd character that was added because of the extra 4 bits at the
	    // end of our 17 byte array, and the '=' padding.
	    return b64String.substr(0, 22);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Returns a string key that can be used to identify the app. */
	function getKey(appConfig) {
	    return appConfig.appName + "!" + appConfig.appId;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var fidChangeCallbacks = new Map();
	/**
	 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
	 * change to other tabs.
	 */
	function fidChanged(appConfig, fid) {
	    var key = getKey(appConfig);
	    callFidChangeCallbacks(key, fid);
	    broadcastFidChange(key, fid);
	}
	function addCallback(appConfig, callback) {
	    // Open the broadcast channel if it's not already open,
	    // to be able to listen to change events from other tabs.
	    getBroadcastChannel();
	    var key = getKey(appConfig);
	    var callbackSet = fidChangeCallbacks.get(key);
	    if (!callbackSet) {
	        callbackSet = new Set();
	        fidChangeCallbacks.set(key, callbackSet);
	    }
	    callbackSet.add(callback);
	}
	function removeCallback(appConfig, callback) {
	    var key = getKey(appConfig);
	    var callbackSet = fidChangeCallbacks.get(key);
	    if (!callbackSet) {
	        return;
	    }
	    callbackSet.delete(callback);
	    if (callbackSet.size === 0) {
	        fidChangeCallbacks.delete(key);
	    }
	    // Close broadcast channel if there are no more callbacks.
	    closeBroadcastChannel();
	}
	function callFidChangeCallbacks(key, fid) {
	    var e_1, _a;
	    var callbacks = fidChangeCallbacks.get(key);
	    if (!callbacks) {
	        return;
	    }
	    try {
	        for (var callbacks_1 = tslib.__values(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()) {
	            var callback = callbacks_1_1.value;
	            callback(fid);
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	function broadcastFidChange(key, fid) {
	    var channel = getBroadcastChannel();
	    if (channel) {
	        channel.postMessage({ key: key, fid: fid });
	    }
	    closeBroadcastChannel();
	}
	var broadcastChannel = null;
	/** Opens and returns a BroadcastChannel if it is supported by the browser. */
	function getBroadcastChannel() {
	    if (!broadcastChannel && 'BroadcastChannel' in self) {
	        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
	        broadcastChannel.onmessage = function (e) {
	            callFidChangeCallbacks(e.data.key, e.data.fid);
	        };
	    }
	    return broadcastChannel;
	}
	function closeBroadcastChannel() {
	    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
	        broadcastChannel.close();
	        broadcastChannel = null;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DATABASE_NAME = 'firebase-installations-database';
	var DATABASE_VERSION = 1;
	var OBJECT_STORE_NAME = 'firebase-installations-store';
	var dbPromise = null;
	function getDbPromise() {
	    if (!dbPromise) {
	        dbPromise = idb.openDb(DATABASE_NAME, DATABASE_VERSION, function (upgradeDB) {
	            // We don't use 'break' in this switch statement, the fall-through
	            // behavior is what we want, because if there are multiple versions between
	            // the old version and the current version, we want ALL the migrations
	            // that correspond to those versions to run, not only the last one.
	            // eslint-disable-next-line default-case
	            switch (upgradeDB.oldVersion) {
	                case 0:
	                    upgradeDB.createObjectStore(OBJECT_STORE_NAME);
	            }
	        });
	    }
	    return dbPromise;
	}
	/** Assigns or overwrites the record for the given key with the given value. */
	function set(appConfig, value) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx, objectStore, oldValue;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(appConfig);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    objectStore = tx.objectStore(OBJECT_STORE_NAME);
	                    return [4 /*yield*/, objectStore.get(key)];
	                case 2:
	                    oldValue = _a.sent();
	                    return [4 /*yield*/, objectStore.put(value, key)];
	                case 3:
	                    _a.sent();
	                    return [4 /*yield*/, tx.complete];
	                case 4:
	                    _a.sent();
	                    if (!oldValue || oldValue.fid !== value.fid) {
	                        fidChanged(appConfig, value.fid);
	                    }
	                    return [2 /*return*/, value];
	            }
	        });
	    });
	}
	/** Removes record(s) from the objectStore that match the given key. */
	function remove(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(appConfig);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
	                case 2:
	                    _a.sent();
	                    return [4 /*yield*/, tx.complete];
	                case 3:
	                    _a.sent();
	                    return [2 /*return*/];
	            }
	        });
	    });
	}
	/**
	 * Atomically updates a record with the result of updateFn, which gets
	 * called with the current value. If newValue is undefined, the record is
	 * deleted instead.
	 * @return Updated value
	 */
	function update(appConfig, updateFn) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx, store, oldValue, newValue;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(appConfig);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    store = tx.objectStore(OBJECT_STORE_NAME);
	                    return [4 /*yield*/, store.get(key)];
	                case 2:
	                    oldValue = _a.sent();
	                    newValue = updateFn(oldValue);
	                    if (!(newValue === undefined)) return [3 /*break*/, 4];
	                    return [4 /*yield*/, store.delete(key)];
	                case 3:
	                    _a.sent();
	                    return [3 /*break*/, 6];
	                case 4: return [4 /*yield*/, store.put(newValue, key)];
	                case 5:
	                    _a.sent();
	                    _a.label = 6;
	                case 6: return [4 /*yield*/, tx.complete];
	                case 7:
	                    _a.sent();
	                    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
	                        fidChanged(appConfig, newValue.fid);
	                    }
	                    return [2 /*return*/, newValue];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Updates and returns the InstallationEntry from the database.
	 * Also triggers a registration request if it is necessary and possible.
	 */
	function getInstallationEntry(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var registrationPromise, installationEntry, _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, update(appConfig, function (oldEntry) {
	                        var installationEntry = updateOrCreateInstallationEntry(oldEntry);
	                        var entryWithPromise = triggerRegistrationIfNecessary(appConfig, installationEntry);
	                        registrationPromise = entryWithPromise.registrationPromise;
	                        return entryWithPromise.installationEntry;
	                    })];
	                case 1:
	                    installationEntry = _b.sent();
	                    if (!(installationEntry.fid === INVALID_FID)) return [3 /*break*/, 3];
	                    _a = {};
	                    return [4 /*yield*/, registrationPromise];
	                case 2: 
	                // FID generation failed. Waiting for the FID from the server.
	                return [2 /*return*/, (_a.installationEntry = _b.sent(), _a)];
	                case 3: return [2 /*return*/, {
	                        installationEntry: installationEntry,
	                        registrationPromise: registrationPromise
	                    }];
	            }
	        });
	    });
	}
	/**
	 * Creates a new Installation Entry if one does not exist.
	 * Also clears timed out pending requests.
	 */
	function updateOrCreateInstallationEntry(oldEntry) {
	    var entry = oldEntry || {
	        fid: generateFid(),
	        registrationStatus: 0 /* NOT_STARTED */
	    };
	    return clearTimedOutRequest(entry);
	}
	/**
	 * If the Firebase Installation is not registered yet, this will trigger the
	 * registration and return an InProgressInstallationEntry.
	 *
	 * If registrationPromise does not exist, the installationEntry is guaranteed
	 * to be registered.
	 */
	function triggerRegistrationIfNecessary(appConfig, installationEntry) {
	    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */) {
	        if (!navigator.onLine) {
	            // Registration required but app is offline.
	            var registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */));
	            return {
	                installationEntry: installationEntry,
	                registrationPromise: registrationPromiseWithError
	            };
	        }
	        // Try registering. Change status to IN_PROGRESS.
	        var inProgressEntry = {
	            fid: installationEntry.fid,
	            registrationStatus: 1 /* IN_PROGRESS */,
	            registrationTime: Date.now()
	        };
	        var registrationPromise = registerInstallation(appConfig, inProgressEntry);
	        return { installationEntry: inProgressEntry, registrationPromise: registrationPromise };
	    }
	    else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */) {
	        return {
	            installationEntry: installationEntry,
	            registrationPromise: waitUntilFidRegistration(appConfig)
	        };
	    }
	    else {
	        return { installationEntry: installationEntry };
	    }
	}
	/** This will be executed only once for each new Firebase Installation. */
	function registerInstallation(appConfig, installationEntry) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var registeredInstallationEntry, e_1;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    _a.trys.push([0, 2, , 7]);
	                    return [4 /*yield*/, createInstallationRequest(appConfig, installationEntry)];
	                case 1:
	                    registeredInstallationEntry = _a.sent();
	                    return [2 /*return*/, set(appConfig, registeredInstallationEntry)];
	                case 2:
	                    e_1 = _a.sent();
	                    if (!(isServerError(e_1) && e_1.serverCode === 409)) return [3 /*break*/, 4];
	                    // Server returned a "FID can not be used" error.
	                    // Generate a new ID next time.
	                    return [4 /*yield*/, remove(appConfig)];
	                case 3:
	                    // Server returned a "FID can not be used" error.
	                    // Generate a new ID next time.
	                    _a.sent();
	                    return [3 /*break*/, 6];
	                case 4: 
	                // Registration failed. Set FID as not registered.
	                return [4 /*yield*/, set(appConfig, {
	                        fid: installationEntry.fid,
	                        registrationStatus: 0 /* NOT_STARTED */
	                    })];
	                case 5:
	                    // Registration failed. Set FID as not registered.
	                    _a.sent();
	                    _a.label = 6;
	                case 6: throw e_1;
	                case 7: return [2 /*return*/];
	            }
	        });
	    });
	}
	/** Call if FID registration is pending in another request. */
	function waitUntilFidRegistration(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var entry, _a, installationEntry, registrationPromise;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, updateInstallationRequest(appConfig)];
	                case 1:
	                    entry = _b.sent();
	                    _b.label = 2;
	                case 2:
	                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
	                    // createInstallation request still in progress.
	                    return [4 /*yield*/, sleep(100)];
	                case 3:
	                    // createInstallation request still in progress.
	                    _b.sent();
	                    return [4 /*yield*/, updateInstallationRequest(appConfig)];
	                case 4:
	                    entry = _b.sent();
	                    return [3 /*break*/, 2];
	                case 5:
	                    if (!(entry.registrationStatus === 0 /* NOT_STARTED */)) return [3 /*break*/, 7];
	                    return [4 /*yield*/, getInstallationEntry(appConfig)];
	                case 6:
	                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
	                    if (registrationPromise) {
	                        return [2 /*return*/, registrationPromise];
	                    }
	                    else {
	                        // if there is no registrationPromise, entry is registered.
	                        return [2 /*return*/, installationEntry];
	                    }
	                case 7: return [2 /*return*/, entry];
	            }
	        });
	    });
	}
	/**
	 * Called only if there is a CreateInstallation request in progress.
	 *
	 * Updates the InstallationEntry in the DB based on the status of the
	 * CreateInstallation request.
	 *
	 * Returns the updated InstallationEntry.
	 */
	function updateInstallationRequest(appConfig) {
	    return update(appConfig, function (oldEntry) {
	        if (!oldEntry) {
	            throw ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */);
	        }
	        return clearTimedOutRequest(oldEntry);
	    });
	}
	function clearTimedOutRequest(entry) {
	    if (hasInstallationRequestTimedOut(entry)) {
	        return {
	            fid: entry.fid,
	            registrationStatus: 0 /* NOT_STARTED */
	        };
	    }
	    return entry;
	}
	function hasInstallationRequestTimedOut(installationEntry) {
	    return (installationEntry.registrationStatus === 1 /* IN_PROGRESS */ &&
	        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function generateAuthTokenRequest(_a, installationEntry) {
	    var appConfig = _a.appConfig, platformLoggerProvider = _a.platformLoggerProvider;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var endpoint, headers, platformLogger, body, request, response, responseValue, completedAuthToken;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
	                    headers = getHeadersWithAuth(appConfig, installationEntry);
	                    platformLogger = platformLoggerProvider.getImmediate({
	                        optional: true
	                    });
	                    if (platformLogger) {
	                        headers.append('x-firebase-client', platformLogger.getPlatformInfoString());
	                    }
	                    body = {
	                        installation: {
	                            sdkVersion: PACKAGE_VERSION
	                        }
	                    };
	                    request = {
	                        method: 'POST',
	                        headers: headers,
	                        body: JSON.stringify(body)
	                    };
	                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
	                case 1:
	                    response = _b.sent();
	                    if (!response.ok) return [3 /*break*/, 3];
	                    return [4 /*yield*/, response.json()];
	                case 2:
	                    responseValue = _b.sent();
	                    completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
	                    return [2 /*return*/, completedAuthToken];
	                case 3: return [4 /*yield*/, getErrorFromResponse('Generate Auth Token', response)];
	                case 4: throw _b.sent();
	            }
	        });
	    });
	}
	function getGenerateAuthTokenEndpoint(appConfig, _a) {
	    var fid = _a.fid;
	    return getInstallationsEndpoint(appConfig) + "/" + fid + "/authTokens:generate";
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a valid authentication token for the installation. Generates a new
	 * token if one doesn't exist, is expired or about to expire.
	 *
	 * Should only be called if the Firebase Installation is registered.
	 */
	function refreshAuthToken(dependencies, forceRefresh) {
	    if (forceRefresh === void 0) { forceRefresh = false; }
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var tokenPromise, entry, authToken, _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, update(dependencies.appConfig, function (oldEntry) {
	                        if (!isEntryRegistered(oldEntry)) {
	                            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
	                        }
	                        var oldAuthToken = oldEntry.authToken;
	                        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
	                            // There is a valid token in the DB.
	                            return oldEntry;
	                        }
	                        else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */) {
	                            // There already is a token request in progress.
	                            tokenPromise = waitUntilAuthTokenRequest(dependencies, forceRefresh);
	                            return oldEntry;
	                        }
	                        else {
	                            // No token or token expired.
	                            if (!navigator.onLine) {
	                                throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
	                            }
	                            var inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
	                            tokenPromise = fetchAuthTokenFromServer(dependencies, inProgressEntry);
	                            return inProgressEntry;
	                        }
	                    })];
	                case 1:
	                    entry = _b.sent();
	                    if (!tokenPromise) return [3 /*break*/, 3];
	                    return [4 /*yield*/, tokenPromise];
	                case 2:
	                    _a = _b.sent();
	                    return [3 /*break*/, 4];
	                case 3:
	                    _a = entry.authToken;
	                    _b.label = 4;
	                case 4:
	                    authToken = _a;
	                    return [2 /*return*/, authToken];
	            }
	        });
	    });
	}
	/**
	 * Call only if FID is registered and Auth Token request is in progress.
	 *
	 * Waits until the current pending request finishes. If the request times out,
	 * tries once in this thread as well.
	 */
	function waitUntilAuthTokenRequest(dependencies, forceRefresh) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var entry, authToken;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, updateAuthTokenRequest(dependencies.appConfig)];
	                case 1:
	                    entry = _a.sent();
	                    _a.label = 2;
	                case 2:
	                    if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
	                    // generateAuthToken still in progress.
	                    return [4 /*yield*/, sleep(100)];
	                case 3:
	                    // generateAuthToken still in progress.
	                    _a.sent();
	                    return [4 /*yield*/, updateAuthTokenRequest(dependencies.appConfig)];
	                case 4:
	                    entry = _a.sent();
	                    return [3 /*break*/, 2];
	                case 5:
	                    authToken = entry.authToken;
	                    if (authToken.requestStatus === 0 /* NOT_STARTED */) {
	                        // The request timed out or failed in a different call. Try again.
	                        return [2 /*return*/, refreshAuthToken(dependencies, forceRefresh)];
	                    }
	                    else {
	                        return [2 /*return*/, authToken];
	                    }
	            }
	        });
	    });
	}
	/**
	 * Called only if there is a GenerateAuthToken request in progress.
	 *
	 * Updates the InstallationEntry in the DB based on the status of the
	 * GenerateAuthToken request.
	 *
	 * Returns the updated InstallationEntry.
	 */
	function updateAuthTokenRequest(appConfig) {
	    return update(appConfig, function (oldEntry) {
	        if (!isEntryRegistered(oldEntry)) {
	            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
	        }
	        var oldAuthToken = oldEntry.authToken;
	        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
	            return tslib.__assign(tslib.__assign({}, oldEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
	        }
	        return oldEntry;
	    });
	}
	function fetchAuthTokenFromServer(dependencies, installationEntry) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var authToken, updatedInstallationEntry, e_1, updatedInstallationEntry;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    _a.trys.push([0, 3, , 8]);
	                    return [4 /*yield*/, generateAuthTokenRequest(dependencies, installationEntry)];
	                case 1:
	                    authToken = _a.sent();
	                    updatedInstallationEntry = tslib.__assign(tslib.__assign({}, installationEntry), { authToken: authToken });
	                    return [4 /*yield*/, set(dependencies.appConfig, updatedInstallationEntry)];
	                case 2:
	                    _a.sent();
	                    return [2 /*return*/, authToken];
	                case 3:
	                    e_1 = _a.sent();
	                    if (!(isServerError(e_1) && (e_1.serverCode === 401 || e_1.serverCode === 404))) return [3 /*break*/, 5];
	                    // Server returned a "FID not found" or a "Invalid authentication" error.
	                    // Generate a new ID next time.
	                    return [4 /*yield*/, remove(dependencies.appConfig)];
	                case 4:
	                    // Server returned a "FID not found" or a "Invalid authentication" error.
	                    // Generate a new ID next time.
	                    _a.sent();
	                    return [3 /*break*/, 7];
	                case 5:
	                    updatedInstallationEntry = tslib.__assign(tslib.__assign({}, installationEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
	                    return [4 /*yield*/, set(dependencies.appConfig, updatedInstallationEntry)];
	                case 6:
	                    _a.sent();
	                    _a.label = 7;
	                case 7: throw e_1;
	                case 8: return [2 /*return*/];
	            }
	        });
	    });
	}
	function isEntryRegistered(installationEntry) {
	    return (installationEntry !== undefined &&
	        installationEntry.registrationStatus === 2 /* COMPLETED */);
	}
	function isAuthTokenValid(authToken) {
	    return (authToken.requestStatus === 2 /* COMPLETED */ &&
	        !isAuthTokenExpired(authToken));
	}
	function isAuthTokenExpired(authToken) {
	    var now = Date.now();
	    return (now < authToken.creationTime ||
	        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
	}
	/** Returns an updated InstallationEntry with an InProgressAuthToken. */
	function makeAuthTokenRequestInProgressEntry(oldEntry) {
	    var inProgressAuthToken = {
	        requestStatus: 1 /* IN_PROGRESS */,
	        requestTime: Date.now()
	    };
	    return tslib.__assign(tslib.__assign({}, oldEntry), { authToken: inProgressAuthToken });
	}
	function hasAuthTokenRequestTimedOut(authToken) {
	    return (authToken.requestStatus === 1 /* IN_PROGRESS */ &&
	        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getId(dependencies) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var _a, installationEntry, registrationPromise;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, getInstallationEntry(dependencies.appConfig)];
	                case 1:
	                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
	                    if (registrationPromise) {
	                        registrationPromise.catch(console.error);
	                    }
	                    else {
	                        // If the installation is already registered, update the authentication
	                        // token if needed.
	                        refreshAuthToken(dependencies).catch(console.error);
	                    }
	                    return [2 /*return*/, installationEntry.fid];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getToken(dependencies, forceRefresh) {
	    if (forceRefresh === void 0) { forceRefresh = false; }
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var authToken;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, completeInstallationRegistration(dependencies.appConfig)];
	                case 1:
	                    _a.sent();
	                    return [4 /*yield*/, refreshAuthToken(dependencies, forceRefresh)];
	                case 2:
	                    authToken = _a.sent();
	                    return [2 /*return*/, authToken.token];
	            }
	        });
	    });
	}
	function completeInstallationRegistration(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var registrationPromise;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, getInstallationEntry(appConfig)];
	                case 1:
	                    registrationPromise = (_a.sent()).registrationPromise;
	                    if (!registrationPromise) return [3 /*break*/, 3];
	                    // A createInstallation request is in progress. Wait until it finishes.
	                    return [4 /*yield*/, registrationPromise];
	                case 2:
	                    // A createInstallation request is in progress. Wait until it finishes.
	                    _a.sent();
	                    _a.label = 3;
	                case 3: return [2 /*return*/];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function deleteInstallationRequest(appConfig, installationEntry) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var endpoint, headers, request, response;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    endpoint = getDeleteEndpoint(appConfig, installationEntry);
	                    headers = getHeadersWithAuth(appConfig, installationEntry);
	                    request = {
	                        method: 'DELETE',
	                        headers: headers
	                    };
	                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
	                case 1:
	                    response = _a.sent();
	                    if (!!response.ok) return [3 /*break*/, 3];
	                    return [4 /*yield*/, getErrorFromResponse('Delete Installation', response)];
	                case 2: throw _a.sent();
	                case 3: return [2 /*return*/];
	            }
	        });
	    });
	}
	function getDeleteEndpoint(appConfig, _a) {
	    var fid = _a.fid;
	    return getInstallationsEndpoint(appConfig) + "/" + fid;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function deleteInstallation(dependencies) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var appConfig, entry;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    appConfig = dependencies.appConfig;
	                    return [4 /*yield*/, update(appConfig, function (oldEntry) {
	                            if (oldEntry && oldEntry.registrationStatus === 0 /* NOT_STARTED */) {
	                                // Delete the unregistered entry without sending a deleteInstallation request.
	                                return undefined;
	                            }
	                            return oldEntry;
	                        })];
	                case 1:
	                    entry = _a.sent();
	                    if (!entry) return [3 /*break*/, 6];
	                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 2];
	                    // Can't delete while trying to register.
	                    throw ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */);
	                case 2:
	                    if (!(entry.registrationStatus === 2 /* COMPLETED */)) return [3 /*break*/, 6];
	                    if (!!navigator.onLine) return [3 /*break*/, 3];
	                    throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
	                case 3: return [4 /*yield*/, deleteInstallationRequest(appConfig, entry)];
	                case 4:
	                    _a.sent();
	                    return [4 /*yield*/, remove(appConfig)];
	                case 5:
	                    _a.sent();
	                    _a.label = 6;
	                case 6: return [2 /*return*/];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Sets a new callback that will get called when Installation ID changes.
	 * Returns an unsubscribe function that will remove the callback when called.
	 */
	function onIdChange(_a, callback) {
	    var appConfig = _a.appConfig;
	    addCallback(appConfig, callback);
	    return function () {
	        removeCallback(appConfig, callback);
	    };
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function extractAppConfig(app) {
	    var e_1, _a;
	    if (!app || !app.options) {
	        throw getMissingValueError('App Configuration');
	    }
	    if (!app.name) {
	        throw getMissingValueError('App Name');
	    }
	    // Required app config keys
	    var configKeys = [
	        'projectId',
	        'apiKey',
	        'appId'
	    ];
	    try {
	        for (var configKeys_1 = tslib.__values(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
	            var keyName = configKeys_1_1.value;
	            if (!app.options[keyName]) {
	                throw getMissingValueError(keyName);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	    return {
	        appName: app.name,
	        projectId: app.options.projectId,
	        apiKey: app.options.apiKey,
	        appId: app.options.appId
	    };
	}
	function getMissingValueError(valueName) {
	    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
	        valueName: valueName
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerInstallations(instance) {
	    var installationsName = 'installations';
	    instance.INTERNAL.registerComponent(new component.Component(installationsName, function (container) {
	        var app = container.getProvider('app').getImmediate();
	        // Throws if app isn't configured properly.
	        var appConfig = extractAppConfig(app);
	        var platformLoggerProvider = container.getProvider('platform-logger');
	        var dependencies = {
	            appConfig: appConfig,
	            platformLoggerProvider: platformLoggerProvider
	        };
	        var installations = {
	            app: app,
	            getId: function () { return getId(dependencies); },
	            getToken: function (forceRefresh) {
	                return getToken(dependencies, forceRefresh);
	            },
	            delete: function () { return deleteInstallation(dependencies); },
	            onIdChange: function (callback) {
	                return onIdChange(dependencies, callback);
	            }
	        };
	        return installations;
	    }, "PUBLIC" /* PUBLIC */));
	    instance.registerVersion(name, version);
	}
	registerInstallations(firebase);
	
	exports.registerInstallations = registerInstallations;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var ListContext = _react.default.createContext({});
	
	if (false) {
	  ListContext.displayName = 'ListContext';
	}
	
	var _default = ListContext;
	exports.default = _default;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hexToRgb = hexToRgb;
	exports.rgbToHex = rgbToHex;
	exports.hslToRgb = hslToRgb;
	exports.decomposeColor = decomposeColor;
	exports.recomposeColor = recomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	/* eslint-disable no-use-before-define */
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value) {
	  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  if (false) {
	    if (value < min || value > max) {
	      console.error("Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
	    }
	  }
	
	  return Math.min(Math.max(min, value), max);
	}
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 * @returns {string} A CSS rgb color string
	 */
	
	
	function hexToRgb(color) {
	  color = color.substr(1);
	  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
	  var colors = color.match(re);
	
	  if (colors && colors[0].length === 1) {
	    colors = colors.map(function (n) {
	      return n + n;
	    });
	  }
	
	  return colors ? "rgb(".concat(colors.map(function (n) {
	    return parseInt(n, 16);
	  }).join(', '), ")") : '';
	}
	
	function intToHex(int) {
	  var hex = int.toString(16);
	  return hex.length === 1 ? "0".concat(hex) : hex;
	}
	/**
	 * Converts a color from CSS rgb format to CSS hex format.
	 *
	 * @param {string} color - RGB color, i.e. rgb(n, n, n)
	 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
	 */
	
	
	function rgbToHex(color) {
	  // Idempotent
	  if (color.indexOf('#') === 0) {
	    return color;
	  }
	
	  var _decomposeColor = decomposeColor(color),
	      values = _decomposeColor.values;
	
	  return "#".concat(values.map(function (n) {
	    return intToHex(n);
	  }).join(''));
	}
	/**
	 * Converts a color from hsl format to rgb format.
	 *
	 * @param {string} color - HSL color values
	 * @returns {string} rgb color values
	 */
	
	
	function hslToRgb(color) {
	  color = decomposeColor(color);
	  var _color = color,
	      values = _color.values;
	  var h = values[0];
	  var s = values[1] / 100;
	  var l = values[2] / 100;
	  var a = s * Math.min(l, 1 - l);
	
	  var f = function f(n) {
	    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
	    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
	  };
	
	  var type = 'rgb';
	  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
	
	  if (color.type === 'hsla') {
	    type += 'a';
	    rgb.push(values[3]);
	  }
	
	  return recomposeColor({
	    type: type,
	    values: rgb
	  });
	}
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {object} - A MUI color object: {type: string, values: number[]}
	 */
	
	
	function decomposeColor(color) {
	  // Idempotent
	  if (color.type) {
	    return color;
	  }
	
	  if (color.charAt(0) === '#') {
	    return decomposeColor(hexToRgb(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	
	  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
	    throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
	  }
	
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	  return {
	    type: type,
	    values: values
	  };
	}
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	
	
	function recomposeColor(color) {
	  var type = color.type;
	  var values = color.values;
	
	  if (type.indexOf('rgb') !== -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    values = values.map(function (n, i) {
	      return i < 3 ? parseInt(n, 10) : n;
	    });
	  } else if (type.indexOf('hsl') !== -1) {
	    values[1] = "".concat(values[1], "%");
	    values[2] = "".concat(values[2], "%");
	  }
	
	  return "".concat(type, "(").concat(values.join(', '), ")");
	}
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21.
	 */
	
	
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	}
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	
	
	function getLuminance(color) {
	  color = decomposeColor(color);
	  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
	  rgb = rgb.map(function (val) {
	    val /= 255; // normalized
	
	    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	  }); // Truncate at 3 digits
	
	  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
	}
	/**
	 * Darken or lighten a color, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	
	  color.values[3] = value;
	  return recomposeColor(color);
	}
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _styles = __webpack_require__(15);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(21));
	
	function useTheme() {
	  return (0, _styles.useTheme)() || _defaultTheme.default;
	}

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalize;
	
	// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
	//
	// A strict capitalization should uppercase the first letter of each word a the sentence.
	// We only handle the first word.
	function capitalize(string) {
	  if (false) {
	    if (typeof string !== 'string') {
	      throw new Error('Material-UI: capitalize(string) expects a string argument.');
	    }
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}

/***/ },
/* 33 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FireBaseConsumer = exports.FireBaseProvider = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FireBaseContext = _react2.default.createContext({});
	
	var FireBaseProvider = exports.FireBaseProvider = FireBaseContext.Provider;
	var FireBaseConsumer = exports.FireBaseConsumer = FireBaseContext.Consumer;
	exports.default = FireBaseContext;

/***/ },
/* 35 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(250);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 37 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ },
/* 38 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(85);
	
	var iterableToArray = __webpack_require__(87);
	
	var nonIterableSpread = __webpack_require__(88);
	
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useEventCallback;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var useEnhancedEffect = typeof window !== 'undefined' ? _react.default.useLayoutEffect : _react.default.useEffect;
	/**
	 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
	 *
	 * @param {function} fn
	 */
	
	function useEventCallback(fn) {
	  var ref = _react.default.useRef(fn);
	
	  useEnhancedEffect(function () {
	    ref.current = fn;
	  });
	  return _react.default.useCallback(function () {
	    return (0, ref.current).apply(void 0, arguments);
	  }, []);
	}

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(19);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(174));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(177));

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(185));

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = chainPropTypes;
	
	function chainPropTypes(propType1, propType2) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function validate() {
	    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
	  };
	}

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Consumer = exports.Provider = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Context = _react2.default.createContext({});
	
	var Provider = exports.Provider = Context.Provider;
	var Consumer = exports.Consumer = Context.Consumer;
	exports.default = Context;

/***/ },
/* 46 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(13));
	
	var _config = _interopRequireDefault(__webpack_require__(80));
	
	var _PropTypes = __webpack_require__(81);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(48));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      // allows for nested Transitions
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, children(status, childProps));
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return (// allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, _react.default.cloneElement(child, childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the
	   * `<Transition>` component mounts. If you want to transition on the first
	   * mount set `appear` to `true`, and the component will transition in as soon
	   * as the `<Transition>` mounts.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	var _default = Transition;
	exports.default = _default;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.config = exports.Transition = exports.TransitionGroup = exports.SwitchTransition = exports.ReplaceTransition = exports.CSSTransition = void 0;
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(263));
	
	exports.CSSTransition = _CSSTransition.default;
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(264));
	
	exports.ReplaceTransition = _ReplaceTransition.default;
	
	var _SwitchTransition = _interopRequireDefault(__webpack_require__(265));
	
	exports.SwitchTransition = _SwitchTransition.default;
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(79));
	
	exports.TransitionGroup = _TransitionGroup.default;
	
	var _Transition = _interopRequireDefault(__webpack_require__(47));
	
	exports.Transition = _Transition.default;
	
	var _config = _interopRequireDefault(__webpack_require__(80));
	
	exports.config = _config.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 52 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ },
/* 53 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 54 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(93));
	var unitless = _interopDefault(__webpack_require__(58));
	var memoize = _interopDefault(__webpack_require__(54));
	
	var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
	var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var isProcessableValue = function isProcessableValue(value) {
	  return value != null && typeof value !== 'boolean';
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          return value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
	        return _char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles + ";";
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        break;
	      }
	
	    case 'string':
	      if (false) {
	        var matched = [];
	        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
	          var fakeVarName = "animation" + matched.length;
	          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
	          return "${" + fakeVarName + "}";
	        });
	
	        if (matched.length) {
	          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
	        }
	      }
	
	      break;
	  } // finalize string values (regular strings and functions interpolated into css calls)
	
	
	  if (registered == null) {
	    return interpolation;
	  }
	
	  var cached = registered[interpolation];
	
	  if (false) {
	    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	    shouldWarnAboutInterpolatingClassNameFromCss = false;
	  }
	
	  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else if (isProcessableValue(value)) {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            if (isProcessableValue(value[_i])) {
	              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	            }
	          }
	        } else {
	          var interpolated = handleInterpolation(mergedProps, registered, value, false);
	
	          switch (_key) {
	            case 'animation':
	            case 'animationName':
	              {
	                string += processStyleName(_key) + ":" + interpolated + ";";
	                break;
	              }
	
	            default:
	              {
	                if (false) {
	                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
	                }
	
	                string += _key + "{" + interpolated + "}";
	              }
	          }
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    if (false) {
	      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	    }
	
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      if (false) {
	        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	      }
	
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor,
	      toString: function toString() {
	        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
	      }
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ },
/* 57 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ },
/* 58 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {var firebase = __webpack_require__(10).default;var k,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)};function ba(a){a=["object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global,a];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}return globalThis}var ca=ba(this);
	function da(a,b){if(b){var c=ca;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];e in c||(c[e]={});c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&aa(c,a,{configurable:!0,writable:!0,value:b})}}function ea(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}function fa(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:ea(a)}}
	da("Promise",function(a){function b(g){this.b=0;this.c=void 0;this.a=[];var h=this.f();try{g(h.resolve,h.reject)}catch(m){h.reject(m)}}function c(){this.a=null}function d(g){return g instanceof b?g:new b(function(h){h(g)})}if(a)return a;c.prototype.b=function(g){if(null==this.a){this.a=[];var h=this;this.c(function(){h.g()})}this.a.push(g)};var e=ca.setTimeout;c.prototype.c=function(g){e(g,0)};c.prototype.g=function(){for(;this.a&&this.a.length;){var g=this.a;this.a=[];for(var h=0;h<g.length;++h){var m=
	g[h];g[h]=null;try{m()}catch(p){this.f(p)}}}this.a=null};c.prototype.f=function(g){this.c(function(){throw g;})};b.prototype.f=function(){function g(p){return function(u){m||(m=!0,p.call(h,u))}}var h=this,m=!1;return{resolve:g(this.m),reject:g(this.g)}};b.prototype.m=function(g){if(g===this)this.g(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.o(g);else{a:switch(typeof g){case "object":var h=null!=g;break a;case "function":h=!0;break a;default:h=!1}h?this.u(g):this.h(g)}};
	b.prototype.u=function(g){var h=void 0;try{h=g.then}catch(m){this.g(m);return}"function"==typeof h?this.v(h,g):this.h(g)};b.prototype.g=function(g){this.i(2,g)};b.prototype.h=function(g){this.i(1,g)};b.prototype.i=function(g,h){if(0!=this.b)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.b);this.b=g;this.c=h;this.l()};b.prototype.l=function(){if(null!=this.a){for(var g=0;g<this.a.length;++g)f.b(this.a[g]);this.a=null}};var f=new c;b.prototype.o=function(g){var h=this.f();
	g.La(h.resolve,h.reject)};b.prototype.v=function(g,h){var m=this.f();try{g.call(h,m.resolve,m.reject)}catch(p){m.reject(p)}};b.prototype.then=function(g,h){function m(C,N){return"function"==typeof C?function(wa){try{p(C(wa))}catch(ld){u(ld)}}:N}var p,u,A=new b(function(C,N){p=C;u=N});this.La(m(g,p),m(h,u));return A};b.prototype.catch=function(g){return this.then(void 0,g)};b.prototype.La=function(g,h){function m(){switch(p.b){case 1:g(p.c);break;case 2:h(p.c);break;default:throw Error("Unexpected state: "+
	p.b);}}var p=this;null==this.a?f.b(m):this.a.push(m)};b.resolve=d;b.reject=function(g){return new b(function(h,m){m(g)})};b.race=function(g){return new b(function(h,m){for(var p=fa(g),u=p.next();!u.done;u=p.next())d(u.value).La(h,m)})};b.all=function(g){var h=fa(g),m=h.next();return m.done?d([]):new b(function(p,u){function A(wa){return function(ld){C[wa]=ld;N--;0==N&&p(C)}}var C=[],N=0;do C.push(void 0),N++,d(m.value).La(A(C.length-1),u),m=h.next();while(!m.done)})};return b});
	var ha=ha||{},l=this||self;function n(a){return"string"==typeof a}function ia(a){return"boolean"==typeof a}var ja=/^[\w+/_-]+[=]{0,2}$/,ka=null;function la(){}
	function ma(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function na(a){return null===a}function oa(a){return"array"==ma(a)}function pa(a){var b=ma(a);return"array"==b||"object"==b&&"number"==typeof a.length}function q(a){return"function"==ma(a)}function r(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var qa="closure_uid_"+(1E9*Math.random()>>>0),ra=0;function sa(a,b,c){return a.call.apply(a.bind,arguments)}
	function ta(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function t(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?t=sa:t=ta;return t.apply(null,arguments)}
	function ua(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}var va=Date.now||function(){return+new Date};function v(a,b){function c(){}c.prototype=b.prototype;a.qb=b.prototype;a.prototype=new c;a.prototype.constructor=a};function xa(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function w(a){if(Error.captureStackTrace)Error.captureStackTrace(this,w);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}v(w,Error);w.prototype.name="CustomError";function ya(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");w.call(this,c+a[d])}v(ya,w);ya.prototype.name="AssertionError";function za(a,b){throw new ya("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function Aa(a,b){this.c=a;this.f=b;this.b=0;this.a=null}Aa.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function Ba(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function Ca(){this.b=this.a=null}var Ea=new Aa(function(){return new Da},function(a){a.reset()});Ca.prototype.add=function(a,b){var c=Ea.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function Fa(){var a=Ga,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function Da(){this.next=this.b=this.a=null}Da.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};Da.prototype.reset=function(){this.next=this.b=this.a=null};function Ha(a,b){a:{try{var c=a&&a.ownerDocument,d=c&&(c.defaultView||c.parentWindow);d=d||l;if(d.Element&&d.Location){var e=d;break a}}catch(g){}e=null}if(e&&"undefined"!=typeof e[b]&&(!a||!(a instanceof e[b])&&(a instanceof e.Location||a instanceof e.Element))){if(r(a))try{var f=a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a)}catch(g){f="<object could not be stringified>"}else f=void 0===a?"undefined":null===a?"null":typeof a;za("Argument is not a %s (or a non-Element, non-Location mock); got: %s",
	b,f)}};var Ia=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(n(a))return n(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},x=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=n(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};function Ja(a,b){for(var c=n(a)?a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)}
	var Ka=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=n(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},La=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=n(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};
	function Ma(a){a:{var b=Na;for(var c=a.length,d=n(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:n(a)?a.charAt(b):a[b]}function Oa(a,b){return 0<=Ia(a,b)}function Pa(a,b){b=Ia(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function Qa(a,b){var c=0;Ja(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ra(a){return Array.prototype.concat.apply([],arguments)}
	function Sa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};function Ta(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Ua(a){for(var b in a)return!1;return!0}function Va(a){var b={},c;for(c in a)b[c]=a[c];return b}var Wa="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function Xa(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Wa.length;f++)c=Wa[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function Ya(a,b){this.a=a===Za&&b||"";this.b=$a}Ya.prototype.qa=!0;Ya.prototype.pa=function(){return this.a};Ya.prototype.toString=function(){return"Const{"+this.a+"}"};function ab(a){if(a instanceof Ya&&a.constructor===Ya&&a.b===$a)return a.a;za("expected object of type Const, got '"+a+"'");return"type_error:Const"}var $a={},Za={},bb=new Ya(Za,"");function cb(){this.a="";this.b=db}cb.prototype.qa=!0;cb.prototype.pa=function(){return this.a.toString()};cb.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function eb(a){if(a instanceof cb&&a.constructor===cb&&a.b===db)return a.a;za("expected object of type TrustedResourceUrl, got '"+a+"' of type "+ma(a));return"type_error:TrustedResourceUrl"}
	function fb(a,b){var c=ab(a);if(!gb.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(hb,function(d,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));d=b[e];return d instanceof Ya?ab(d):encodeURIComponent(String(d))});return ib(a)}var hb=/%{(\w+)}/g,gb=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i,db={};
	function ib(a){var b=new cb;b.a=a;return b};var jb=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]},kb=/&/g,lb=/</g,mb=/>/g,nb=/"/g,ob=/'/g,pb=/\x00/g,qb=/[\x00&<>"']/;function y(a,b){return-1!=a.indexOf(b)}function rb(a,b){return a<b?-1:a>b?1:0};function sb(){this.a="";this.b=tb}sb.prototype.qa=!0;sb.prototype.pa=function(){return this.a.toString()};sb.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function ub(a){if(a instanceof sb&&a.constructor===sb&&a.b===tb)return a.a;za("expected object of type SafeUrl, got '"+a+"' of type "+ma(a));return"type_error:SafeUrl"}var vb=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
	function wb(a){if(a instanceof sb)return a;a="object"==typeof a&&a.qa?a.pa():String(a);vb.test(a)||(a="about:invalid#zClosurez");return xb(a)}var tb={};function xb(a){var b=new sb;b.a=a;return b}xb("about:blank");var yb;a:{var zb=l.navigator;if(zb){var Ab=zb.userAgent;if(Ab){yb=Ab;break a}}yb=""}function z(a){return y(yb,a)};function Bb(){this.a="";this.b=Cb}Bb.prototype.qa=!0;Bb.prototype.pa=function(){return this.a.toString()};Bb.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Db(a){if(a instanceof Bb&&a.constructor===Bb&&a.b===Cb)return a.a;za("expected object of type SafeHtml, got '"+a+"' of type "+ma(a));return"type_error:SafeHtml"}var Cb={};function Eb(a){var b=new Bb;b.a=a;return b}Eb("<!DOCTYPE html>");var Fb=Eb("");Eb("<br>");function Gb(a){var b=ib(ab(bb));Ha(a,"HTMLIFrameElement");a.src=eb(b).toString()}function Hb(a,b){Ha(a,"HTMLScriptElement");a.src=eb(b);if(null===ka)b:{b=l.document;if((b=b.querySelector&&b.querySelector("script[nonce]"))&&(b=b.nonce||b.getAttribute("nonce"))&&ja.test(b)){ka=b;break b}ka=""}b=ka;b&&a.setAttribute("nonce",b)};function Ib(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}function Jb(a){qb.test(a)&&(-1!=a.indexOf("&")&&(a=a.replace(kb,"&amp;")),-1!=a.indexOf("<")&&(a=a.replace(lb,"&lt;")),-1!=a.indexOf(">")&&(a=a.replace(mb,"&gt;")),-1!=a.indexOf('"')&&(a=a.replace(nb,"&quot;")),-1!=a.indexOf("'")&&(a=a.replace(ob,"&#39;")),-1!=a.indexOf("\x00")&&(a=a.replace(pb,"&#0;")));return a};function Kb(a){l.setTimeout(function(){throw a;},0)}var Lb;
	function Mb(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!z("Presto")&&(a=function(){var e=document.createElement("IFRAME");e.style.display="none";Gb(e);document.documentElement.appendChild(e);var f=e.contentWindow;e=f.document;e.open();e.write(Db(Fb));e.close();var g="callImmediate"+Math.random(),h="file:"==f.location.protocol?"*":f.location.protocol+"//"+f.location.host;e=t(function(m){if(("*"==h||m.origin==h)&&m.data==
	g)this.port1.onmessage()},this);f.addEventListener("message",e,!1);this.port1={};this.port2={postMessage:function(){f.postMessage(g,h)}}});if("undefined"!==typeof a&&!z("Trident")&&!z("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var e=c.yb;c.yb=null;e()}};return function(e){d.next={yb:e};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(e){var f=document.createElement("SCRIPT");
	f.onreadystatechange=function(){f.onreadystatechange=null;f.parentNode.removeChild(f);f=null;e();e=null};document.documentElement.appendChild(f)}:function(e){l.setTimeout(e,0)}};function Nb(a,b){Ob||Pb();Qb||(Ob(),Qb=!0);Ga.add(a,b)}var Ob;function Pb(){if(l.Promise&&l.Promise.resolve){var a=l.Promise.resolve(void 0);Ob=function(){a.then(Rb)}}else Ob=function(){var b=Rb;!q(l.setImmediate)||l.Window&&l.Window.prototype&&!z("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(Lb||(Lb=Mb()),Lb(b)):l.setImmediate(b)}}var Qb=!1,Ga=new Ca;function Rb(){for(var a;a=Fa();){try{a.a.call(a.b)}catch(b){Kb(b)}Ba(Ea,a)}Qb=!1};function B(a,b){this.a=Sb;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=la)try{var c=this;a.call(b,function(d){Tb(c,Ub,d)},function(d){if(!(d instanceof Vb))try{if(d instanceof Error)throw d;throw Error("Promise rejected.");}catch(e){}Tb(c,Wb,d)})}catch(d){Tb(this,Wb,d)}}var Sb=0,Ub=2,Wb=3;function Xb(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}Xb.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var Yb=new Aa(function(){return new Xb},function(a){a.reset()});
	function Zb(a,b,c){var d=Yb.get();d.g=a;d.b=b;d.f=c;return d}function D(a){if(a instanceof B)return a;var b=new B(la);Tb(b,Ub,a);return b}function E(a){return new B(function(b,c){c(a)})}function $b(a,b,c){ac(a,b,c,null)||Nb(ua(b,a))}function bc(a){return new B(function(b,c){var d=a.length,e=[];if(d)for(var f=function(p,u){d--;e[p]=u;0==d&&b(e)},g=function(p){c(p)},h=0,m;h<a.length;h++)m=a[h],$b(m,ua(f,h),g);else b(e)})}
	function cc(a){return new B(function(b){var c=a.length,d=[];if(c)for(var e=function(h,m,p){c--;d[h]=m?{Gb:!0,value:p}:{Gb:!1,reason:p};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],$b(g,ua(e,f,!0),ua(e,f,!1));else b(d)})}B.prototype.then=function(a,b,c){return dc(this,q(a)?a:null,q(b)?b:null,c)};B.prototype.$goog_Thenable=!0;k=B.prototype;k.ka=function(a,b){a=Zb(a,a,b);a.c=!0;ec(this,a);return this};k.s=function(a,b){return dc(this,null,a,b)};
	k.cancel=function(a){this.a==Sb&&Nb(function(){var b=new Vb(a);fc(this,b)},this)};function fc(a,b){if(a.a==Sb)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,g=c.b;g&&(g.c||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==Sb&&1==d?fc(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):gc(c),hc(c,e,Wb,b)))}a.c=null}else Tb(a,Wb,b)}function ec(a,b){a.b||a.a!=Ub&&a.a!=Wb||ic(a);a.f?a.f.next=b:a.b=b;a.f=b}
	function dc(a,b,c,d){var e=Zb(null,null,null);e.a=new B(function(f,g){e.g=b?function(h){try{var m=b.call(d,h);f(m)}catch(p){g(p)}}:f;e.b=c?function(h){try{var m=c.call(d,h);void 0===m&&h instanceof Vb?g(h):f(m)}catch(p){g(p)}}:g});e.a.c=a;ec(a,e);return e.a}k.Oc=function(a){this.a=Sb;Tb(this,Ub,a)};k.Pc=function(a){this.a=Sb;Tb(this,Wb,a)};
	function Tb(a,b,c){a.a==Sb&&(a===c&&(b=Wb,c=new TypeError("Promise cannot resolve to itself")),a.a=1,ac(c,a.Oc,a.Pc,a)||(a.i=c,a.a=b,a.c=null,ic(a),b!=Wb||c instanceof Vb||jc(a,c)))}function ac(a,b,c,d){if(a instanceof B)return ec(a,Zb(b||la,c||null,d)),!0;if(xa(a))return a.then(b,c,d),!0;if(r(a))try{var e=a.then;if(q(e))return kc(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
	function kc(a,b,c,d,e){function f(m){h||(h=!0,d.call(e,m))}function g(m){h||(h=!0,c.call(e,m))}var h=!1;try{b.call(a,g,f)}catch(m){f(m)}}function ic(a){a.h||(a.h=!0,Nb(a.Zb,a))}function gc(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}k.Zb=function(){for(var a;a=gc(this);)hc(this,a,this.a,this.i);this.h=!1};
	function hc(a,b,c,d){if(c==Wb&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,lc(b,c,d);else try{b.c?b.g.call(b.f):lc(b,c,d)}catch(e){mc.call(null,e)}Ba(Yb,b)}function lc(a,b,c){b==Ub?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function jc(a,b){a.g=!0;Nb(function(){a.g&&mc.call(null,b)})}var mc=Kb;function Vb(a){w.call(this,a)}v(Vb,w);Vb.prototype.name="cancel";function nc(){0!=oc&&(pc[this[qa]||(this[qa]=++ra)]=this);this.va=this.va;this.la=this.la}var oc=0,pc={};nc.prototype.va=!1;function qc(a){if(!a.va&&(a.va=!0,a.za(),0!=oc)){var b=a[qa]||(a[qa]=++ra);if(0!=oc&&a.la&&0<a.la.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete pc[b]}}nc.prototype.za=function(){if(this.la)for(;this.la.length;)this.la.shift()()};function rc(a){rc[" "](a);return a}rc[" "]=la;function sc(a,b){var c=tc;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var uc=z("Opera"),vc=z("Trident")||z("MSIE"),wc=z("Edge"),xc=wc||vc,yc=z("Gecko")&&!(y(yb.toLowerCase(),"webkit")&&!z("Edge"))&&!(z("Trident")||z("MSIE"))&&!z("Edge"),zc=y(yb.toLowerCase(),"webkit")&&!z("Edge");function Ac(){var a=l.document;return a?a.documentMode:void 0}var Bc;
	a:{var Cc="",Dc=function(){var a=yb;if(yc)return/rv:([^\);]+)(\)|;)/.exec(a);if(wc)return/Edge\/([\d\.]+)/.exec(a);if(vc)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(zc)return/WebKit\/(\S+)/.exec(a);if(uc)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Dc&&(Cc=Dc?Dc[1]:"");if(vc){var Ec=Ac();if(null!=Ec&&Ec>parseFloat(Cc)){Bc=String(Ec);break a}}Bc=Cc}var tc={};
	function Fc(a){return sc(a,function(){for(var b=0,c=jb(String(Bc)).split("."),d=jb(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",h=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];if(0==g[0].length&&0==h[0].length)break;b=rb(0==g[1].length?0:parseInt(g[1],10),0==h[1].length?0:parseInt(h[1],10))||rb(0==g[2].length,0==h[2].length)||rb(g[2],h[2]);g=g[3];h=h[3]}while(0==b)}return 0<=b})}var Gc;
	Gc=l.document&&vc?Ac():void 0;var Hc=Object.freeze||function(a){return a};var Ic=!vc||9<=Number(Gc),Jc=vc&&!Fc("9"),Kc=function(){if(!l.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});try{l.addEventListener("test",la,b),l.removeEventListener("test",la,b)}catch(c){}return a}();function F(a,b){this.type=a;this.b=this.target=b;this.Mb=!0}F.prototype.preventDefault=function(){this.Mb=!1};function Lc(a,b){F.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(yc){a:{try{rc(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==
	c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
	a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=n(a.pointerType)?a.pointerType:Mc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}v(Lc,F);var Mc=Hc({2:"touch",3:"pen",4:"mouse"});Lc.prototype.preventDefault=function(){Lc.qb.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Jc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Lc.prototype.f=function(){return this.a};var Nc="closure_listenable_"+(1E6*Math.random()|0),Oc=0;function Pc(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.Pa=e;this.key=++Oc;this.ta=this.Ka=!1}function Qc(a){a.ta=!0;a.listener=null;a.proxy=null;a.src=null;a.Pa=null};function Rc(a){this.src=a;this.a={};this.b=0}Rc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var g=Sc(a,b,d,e);-1<g?(b=a[g],c||(b.Ka=!1)):(b=new Pc(b,this.src,f,!!d,e),b.Ka=c,a.push(b));return b};function Tc(a,b){var c=b.type;c in a.a&&Pa(a.a[c],b)&&(Qc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function Sc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.ta&&f.listener==b&&f.capture==!!c&&f.Pa==d)return e}return-1};var Uc="closure_lm_"+(1E6*Math.random()|0),Vc={},Wc=0;function Xc(a,b,c,d,e){if(d&&d.once)Yc(a,b,c,d,e);else if(oa(b))for(var f=0;f<b.length;f++)Xc(a,b[f],c,d,e);else c=Zc(c),a&&a[Nc]?$c(a,b,c,r(d)?!!d.capture:!!d,e):ad(a,b,c,!1,d,e)}
	function ad(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=r(e)?!!e.capture:!!e,h=bd(a);h||(a[Uc]=h=new Rc(a));c=h.add(b,c,d,g,f);if(!c.proxy){d=cd();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)Kc||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(dd(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");Wc++}}
	function cd(){var a=ed,b=Ic?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function Yc(a,b,c,d,e){if(oa(b))for(var f=0;f<b.length;f++)Yc(a,b[f],c,d,e);else c=Zc(c),a&&a[Nc]?fd(a,b,c,r(d)?!!d.capture:!!d,e):ad(a,b,c,!0,d,e)}
	function gd(a,b,c,d,e){if(oa(b))for(var f=0;f<b.length;f++)gd(a,b[f],c,d,e);else(d=r(d)?!!d.capture:!!d,c=Zc(c),a&&a[Nc])?(a=a.u,b=String(b).toString(),b in a.a&&(f=a.a[b],c=Sc(f,c,d,e),-1<c&&(Qc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=bd(a))&&(b=a.a[b.toString()],a=-1,b&&(a=Sc(b,c,d,e)),(c=-1<a?b[a]:null)&&hd(c))}
	function hd(a){if("number"!=typeof a&&a&&!a.ta){var b=a.src;if(b&&b[Nc])Tc(b.u,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(dd(c),d):b.addListener&&b.removeListener&&b.removeListener(d);Wc--;(c=bd(b))?(Tc(c,a),0==c.b&&(c.src=null,b[Uc]=null)):Qc(a)}}}function dd(a){return a in Vc?Vc[a]:Vc[a]="on"+a}
	function id(a,b,c,d){var e=!0;if(a=bd(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.ta&&(f=jd(f,d),e=e&&!1!==f)}return e}function jd(a,b){var c=a.listener,d=a.Pa||a.src;a.Ka&&hd(a);return c.call(d,b)}
	function ed(a,b){if(a.ta)return!0;if(!Ic){if(!b)a:{b=["window","event"];for(var c=l,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new Lc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=id(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=id(d[e],a,!1,b),c=c&&f}return c}return jd(a,
	new Lc(b,this))}function bd(a){a=a[Uc];return a instanceof Rc?a:null}var kd="__closure_events_fn_"+(1E9*Math.random()>>>0);function Zc(a){if(q(a))return a;a[kd]||(a[kd]=function(b){return a.handleEvent(b)});return a[kd]};function G(){nc.call(this);this.u=new Rc(this);this.Sb=this;this.Xa=null}v(G,nc);G.prototype[Nc]=!0;G.prototype.addEventListener=function(a,b,c,d){Xc(this,a,b,c,d)};G.prototype.removeEventListener=function(a,b,c,d){gd(this,a,b,c,d)};
	G.prototype.dispatchEvent=function(a){var b,c=this.Xa;if(c)for(b=[];c;c=c.Xa)b.push(c);c=this.Sb;var d=a.type||a;if(n(a))a=new F(a,c);else if(a instanceof F)a.target=a.target||c;else{var e=a;a=new F(d,c);Xa(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var g=a.b=b[f];e=md(g,d,!0,a)&&e}g=a.b=c;e=md(g,d,!0,a)&&e;e=md(g,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)g=a.b=b[f],e=md(g,d,!1,a)&&e;return e};
	G.prototype.za=function(){G.qb.za.call(this);if(this.u){var a=this.u,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,Qc(d[e]);delete a.a[c];a.b--}}this.Xa=null};function $c(a,b,c,d,e){a.u.add(String(b),c,!1,d,e)}function fd(a,b,c,d,e){a.u.add(String(b),c,!0,d,e)}
	function md(a,b,c,d){b=a.u.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.ta&&g.capture==c){var h=g.listener,m=g.Pa||g.src;g.Ka&&Tc(a.u,g);e=!1!==h.call(m,d)&&e}}return e&&0!=d.Mb};function nd(a,b,c){if(q(a))c&&(a=t(a,c));else if(a&&"function"==typeof a.handleEvent)a=t(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)}function od(a){var b=null;return(new B(function(c,d){b=nd(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(c){l.clearTimeout(b);throw c;})};function pd(a){if(a.U&&"function"==typeof a.U)return a.U();if(n(a))return a.split("");if(pa(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function qd(a){if(a.X&&"function"==typeof a.X)return a.X();if(!a.U||"function"!=typeof a.U){if(pa(a)||n(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
	function rd(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(pa(a)||n(a))x(a,b,void 0);else for(var c=qd(a),d=pd(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function sd(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof sd)for(c=a.X(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}k=sd.prototype;k.U=function(){td(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};k.X=function(){td(this);return this.a.concat()};
	k.clear=function(){this.b={};this.c=this.a.length=0};function td(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];ud(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],ud(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}k.get=function(a,b){return ud(this.b,a)?this.b[a]:b};k.set=function(a,b){ud(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
	k.forEach=function(a,b){for(var c=this.X(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function ud(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var vd=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function wd(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function xd(a,b){this.b=this.i=this.f="";this.l=null;this.g=this.c="";this.h=!1;var c;a instanceof xd?(this.h=void 0!==b?b:a.h,yd(this,a.f),this.i=a.i,this.b=a.b,zd(this,a.l),this.c=a.c,Ad(this,Bd(a.a)),this.g=a.g):a&&(c=String(a).match(vd))?(this.h=!!b,yd(this,c[1]||"",!0),this.i=Cd(c[2]||""),this.b=Cd(c[3]||"",!0),zd(this,c[4]),this.c=Cd(c[5]||"",!0),Ad(this,c[6]||"",!0),this.g=Cd(c[7]||"")):(this.h=!!b,this.a=new Dd(null,this.h))}
	xd.prototype.toString=function(){var a=[],b=this.f;b&&a.push(Ed(b,Fd,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.i)&&a.push(Ed(b,Fd,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.l,null!=c&&a.push(":",String(c));if(c=this.c)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Ed(c,"/"==c.charAt(0)?Gd:Hd,!0));(c=this.a.toString())&&a.push("?",c);(c=this.g)&&a.push("#",Ed(c,Id));return a.join("")};
	xd.prototype.resolve=function(a){var b=new xd(this),c=!!a.f;c?yd(b,a.f):c=!!a.i;c?b.i=a.i:c=!!a.b;c?b.b=a.b:c=null!=a.l;var d=a.c;if(c)zd(b,a.l);else if(c=!!a.c){if("/"!=d.charAt(0))if(this.b&&!this.c)d="/"+d;else{var e=b.c.lastIndexOf("/");-1!=e&&(d=b.c.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(y(e,"./")||y(e,"/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],g=0;g<e.length;){var h=e[g++];"."==h?d&&g==e.length&&f.push(""):".."==h?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),
	d&&g==e.length&&f.push("")):(f.push(h),d=!0)}d=f.join("/")}else d=e}c?b.c=d:c=""!==a.a.toString();c?Ad(b,Bd(a.a)):c=!!a.g;c&&(b.g=a.g);return b};function yd(a,b,c){a.f=c?Cd(b,!0):b;a.f&&(a.f=a.f.replace(/:$/,""))}function zd(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.l=b}else a.l=null}function Ad(a,b,c){b instanceof Dd?(a.a=b,Jd(a.a,a.h)):(c||(b=Ed(b,Kd)),a.a=new Dd(b,a.h))}function H(a,b,c){a.a.set(b,c)}function Ld(a,b){return a.a.get(b)}
	function Md(a){return a instanceof xd?new xd(a):new xd(a,void 0)}function Nd(a,b){var c=new xd(null,void 0);yd(c,"https");a&&(c.b=a);b&&(c.c=b);return c}function Cd(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Ed(a,b,c){return n(a)?(a=encodeURI(a).replace(b,Od),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Od(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}
	var Fd=/[#\/\?@]/g,Hd=/[#\?:]/g,Gd=/[#\?]/g,Kd=/[#\?@]/g,Id=/#/g;function Dd(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}function Pd(a){a.a||(a.a=new sd,a.b=0,a.c&&wd(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function Qd(a){var b=qd(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Dd(null,void 0);a=pd(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];oa(f)?Rd(c,e,f):c.add(e,f)}return c}k=Dd.prototype;
	k.add=function(a,b){Pd(this);this.c=null;a=Sd(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function Td(a,b){Pd(a);b=Sd(a,b);ud(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,ud(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&td(a)))}k.clear=function(){this.a=this.c=null;this.b=0};function Ud(a,b){Pd(a);b=Sd(a,b);return ud(a.a.b,b)}k.forEach=function(a,b){Pd(this);this.a.forEach(function(c,d){x(c,function(e){a.call(b,e,d,this)},this)},this)};
	k.X=function(){Pd(this);for(var a=this.a.U(),b=this.a.X(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};k.U=function(a){Pd(this);var b=[];if(n(a))Ud(this,a)&&(b=Ra(b,this.a.get(Sd(this,a))));else{a=this.a.U();for(var c=0;c<a.length;c++)b=Ra(b,a[c])}return b};k.set=function(a,b){Pd(this);this.c=null;a=Sd(this,a);Ud(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};
	k.get=function(a,b){if(!a)return b;a=this.U(a);return 0<a.length?String(a[0]):b};function Rd(a,b,c){Td(a,b);0<c.length&&(a.c=null,a.a.set(Sd(a,b),Sa(c)),a.b+=c.length)}k.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.X(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.U(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.c=a.join("&")};
	function Bd(a){var b=new Dd;b.c=a.c;a.a&&(b.a=new sd(a.a),b.b=a.b);return b}function Sd(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function Jd(a,b){b&&!a.f&&(Pd(a),a.c=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(Td(this,d),Rd(this,e,c))},a));a.f=b};var Vd=!vc||9<=Number(Gc);function Wd(a){var b=document;return n(a)?b.getElementById(a):a}function Xd(a,b){Ta(b,function(c,d){c&&"object"==typeof c&&c.qa&&(c=c.pa());"style"==d?a.style.cssText=c:"class"==d?a.className=c:"for"==d?a.htmlFor=c:Yd.hasOwnProperty(d)?a.setAttribute(Yd[d],c):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,c):a[d]=c})}
	var Yd={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
	function Zd(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!Vd&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',Jb(g.name),'"');if(g.type){f.push(' type="',Jb(g.type),'"');var h={};Xa(h,g);delete h.type;g=h}f.push(">");f=f.join("")}f=e.createElement(f);g&&(n(g)?f.className=g:oa(g)?f.className=g.join(" "):Xd(f,g));2<d.length&&$d(e,f,d);return f}
	function $d(a,b,c){function d(g){g&&b.appendChild(n(g)?a.createTextNode(g):g)}for(var e=2;e<c.length;e++){var f=c[e];!pa(f)||r(f)&&0<f.nodeType?d(f):x(ae(f)?Sa(f):f,d)}}function ae(a){if(a&&"number"==typeof a.length){if(r(a))return"function"==typeof a.item||"string"==typeof a.item;if(q(a))return"function"==typeof a.item}return!1};function be(a){var b=[];ce(new de,a,b);return b.join("")}function de(){}
	function ce(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(oa(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),ce(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),ee(d,c),c.push(":"),ce(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":ee(b,c);break;case "number":c.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var fe={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},ge=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
	function ee(a,b){b.push('"',a.replace(ge,function(c){var d=fe[c];d||(d="\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),fe[c]=d);return d}),'"')};/*
	
	 Copyright 2017 Google Inc.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function he(){var a=I();return vc&&!!Gc&&11==Gc||/Edge\/\d+/.test(a)}function ie(){return l.window&&l.window.location.href||self&&self.location&&self.location.href||""}function je(a,b){b=b||l.window;var c="about:blank";a&&(c=ub(wb(a)).toString());b.location.href=c}function ke(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<ke(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
	function le(){var a=I();a=me(a)!=ne?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!vc||!Gc||9<Gc}function oe(a){a=(a||I()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function pe(a){a=a||l.window;try{a.close()}catch(b){}}
	function qe(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=I().toLowerCase();d&&(b.target=d,y(c,"crios/")&&(b.target="_blank"));me(I())==re&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof sb?c:wb("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
	for(g in a)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+a[g]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(g+"="+(a[g]?1:0))}var g=e.join(",");(z("iPhone")&&!z("iPod")&&!z("iPad")||z("iPad")||z("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c?(g=d.document.createElement("A"),Ha(g,"HTMLAnchorElement"),b instanceof sb||b instanceof sb||(b="object"==typeof b&&b.qa?b.pa():String(b),vb.test(b)||(b="about:invalid#zClosurez"),b=xb(b)),
	g.href=ub(b),g.setAttribute("target",c),a.noreferrer&&g.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),g.dispatchEvent(a),g={}):a.noreferrer?(g=d.open("",c,g),a=ub(b).toString(),g&&(xc&&y(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),g.opener=null,a=Eb('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+Jb(a)+'">'),g.document.write(Db(a)),g.document.close())):(g=d.open(ub(b).toString(),c,g))&&a.noopener&&
	(g.opener=null);if(g)try{g.focus()}catch(h){}return g}function se(a){return new B(function(b){function c(){od(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var te=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,ue=/^[^@]+@[^@]+$/;function ve(){var a=null;return(new B(function(b){"complete"==l.document.readyState?b():(a=function(){b()},Yc(window,"load",a))})).s(function(b){gd(window,"load",a);throw b;})}
	function we(){return xe(void 0)?ve().then(function(){return new B(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):E(Error("Cordova must run in an Android or iOS file scheme."))}function xe(a){a=a||I();return!("file:"!==ye()&&"ionic:"!==ye()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function ze(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}}
	function Ae(){return"undefined"!==typeof l.WorkerGlobalScope&&"function"===typeof l.importScripts}function Be(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":Ae()?"Worker":"Browser"}function Ce(){var a=Be();return"ReactNative"===a||"Node"===a}function De(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}
	var re="Firefox",ne="Chrome";
	function me(a){var b=a.toLowerCase();if(y(b,"opera/")||y(b,"opr/")||y(b,"opios/"))return"Opera";if(y(b,"iemobile"))return"IEMobile";if(y(b,"msie")||y(b,"trident/"))return"IE";if(y(b,"edge/"))return"Edge";if(y(b,"firefox/"))return re;if(y(b,"silk/"))return"Silk";if(y(b,"blackberry"))return"Blackberry";if(y(b,"webos"))return"Webos";if(!y(b,"safari/")||y(b,"chrome/")||y(b,"crios/")||y(b,"android"))if(!y(b,"chrome/")&&!y(b,"crios/")||y(b,"edge/")){if(y(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
	2==a.length)return a[1]}else return ne;else return"Safari";return"Other"}var Ee={Wc:"FirebaseCore-web",Yc:"FirebaseUI-web"};function Fe(a,b){b=b||[];var c=[],d={},e;for(e in Ee)d[Ee[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=Be();"Browser"===c?(d=I(),c=me(d)):"Worker"===c&&(d=I(),c=me(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function I(){return l.navigator&&l.navigator.userAgent||""}
	function J(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function Ge(){try{var a=l.localStorage,b=He();if(a)return a.setItem(b,"1"),a.removeItem(b),he()?!!l.indexedDB:!0}catch(c){return Ae()&&!!l.indexedDB}return!1}function Ie(){return(Je()||"chrome-extension:"===ye()||xe())&&!Ce()&&Ge()&&!Ae()}function Je(){return"http:"===ye()||"https:"===ye()}function ye(){return l.location&&l.location.protocol||null}
	function Ke(a){a=a||I();return oe(a)||me(a)==re?!1:!0}function Le(a){return"undefined"===typeof a?null:be(a)}function Me(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function Ne(a){if(null!==a)return JSON.parse(a)}function He(a){return a?a:Math.floor(1E9*Math.random()).toString()}function Oe(a){a=a||I();return"Safari"==me(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
	function Pe(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Qe(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=I();b=Be();this.b=oe(a)||"ReactNative"===b}
	Qe.prototype.get=function(){var a=l.navigator;return(a&&"boolean"===typeof a.onLine&&(Je()||"chrome-extension:"===ye()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function Re(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
	function Se(){var a=l.document,b=null;return Re()||!a?D():(new B(function(c){b=function(){Re()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Te(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function Ue(){return!(!J("fireauth.oauthhelper",l)&&!J("fireauth.iframe",l))}
	function Ve(){var a=l.navigator;return a&&a.serviceWorker&&a.serviceWorker.controller||null}function We(){var a=l.navigator;return a&&a.serviceWorker?D().then(function(){return a.serviceWorker.ready}).then(function(b){return b.active||null}).s(function(){return null}):D(null)};var Xe={};function Ye(a){Xe[a]||(Xe[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Ze;try{var $e={};Object.defineProperty($e,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty($e,"abcd",{configurable:!0,enumerable:!0,value:2});Ze=2==$e.abcd}catch(a){Ze=!1}function K(a,b,c){Ze?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function L(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&K(a,c,b[c])}function af(a){var b={};L(b,a);return b}function bf(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
	function cf(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function df(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)K(b,c,df(a[c]))}return b};function ef(a){var b={},c=a[ff],d=a[gf];a=a[hf];if(!a||a!=jf&&!c)throw Error("Invalid provider user info!");b[kf]=d||null;b[lf]=c||null;K(this,mf,a);K(this,nf,df(b))}var jf="EMAIL_SIGNIN",ff="email",gf="newEmail",hf="requestType",lf="email",kf="fromEmail",nf="data",mf="operation";function M(a,b){this.code=of+a;this.message=b||pf[a]||""}v(M,Error);M.prototype.A=function(){return{code:this.code,message:this.message}};M.prototype.toJSON=function(){return this.A()};function qf(a){var b=a&&a.code;return b?new M(b.substring(of.length),a.message):null}
	var of="auth/",pf={"admin-restricted-operation":"This operation is restricted to administrators only.","argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
	"captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.","code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.",
	"requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.",
	"internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.",
	"invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
	"invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-dynamic-link-domain":"The provided dynamic link domain is not configured or authorized for the current project.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.",
	"invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
	"invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
	"invalid-provider-id":"The specified provider ID is invalid.","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","invalid-tenant-id":"The Auth instance's tenant ID is invalid.",
	"missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.",
	"missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.","missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-or-invalid-nonce":"The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.",
	"missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.","network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.",
	"no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
	"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
	"rejected-credential":"The request contains malformed or mismatching credentials.","tenant-id-mismatch":"The provided tenant ID does not match the Auth instance's tenant ID",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
	"unsupported-persistence-type":"The current environment does not support the specified persistence type.","unsupported-tenant-operation":"This operation is not supported in a multi-tenant context.","user-cancelled":"The user did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.",
	"user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function rf(a){a=Md(a);var b=Ld(a,sf)||null,c=Ld(a,tf)||null,d=Ld(a,uf)||null;d=d?vf[d]||null:null;if(!b||!c||!d)throw new M("argument-error",sf+", "+tf+"and "+uf+" are required in a valid action code URL.");L(this,{apiKey:b,operation:d,code:c,continueUrl:Ld(a,wf)||null,languageCode:Ld(a,xf)||null,tenantId:Ld(a,yf)||null})}var sf="apiKey",tf="oobCode",wf="continueUrl",xf="languageCode",uf="mode",yf="tenantId",vf={recoverEmail:"RECOVER_EMAIL",resetPassword:"PASSWORD_RESET",signIn:jf,verifyEmail:"VERIFY_EMAIL"};
	function zf(a){try{return new rf(a)}catch(b){return null}};function Af(a){var b=a[Bf];if("undefined"===typeof b)throw new M("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new M("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[Cf];if(c&&"object"===typeof c){b=c[Df];var d=c[Ef];c=c[Ff];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new M("argument-error",Ef+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
	typeof c||"string"===typeof c&&!c.length))throw new M("argument-error",Ff+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new M("argument-error",Df+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new M("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new M("argument-error",Cf+" property must be a non null object when specified.");this.f=null;if((b=a[Gf])&&"object"===
	typeof b)if(b=b[Hf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new M("argument-error",Hf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new M("argument-error",Gf+" property must be a non null object when specified.");b=a[If];if("undefined"!==typeof b&&"boolean"!==typeof b)throw new M("argument-error",If+" property must be a boolean when specified.");this.c=!!b;a=a[Jf];if("undefined"!==typeof a&&("string"!==typeof a||"string"===
	typeof a&&!a.length))throw new M("argument-error",Jf+" property must be a non empty string when specified.");this.i=a||null}var Cf="android",Jf="dynamicLinkDomain",If="handleCodeInApp",Gf="iOS",Bf="url",Ef="installApp",Ff="minimumVersion",Df="packageName",Hf="bundleId";
	function Kf(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;b.dynamicLinkDomain=a.i;for(var c in b)null===b[c]&&delete b[c];return b};function Lf(a){return Ka(a,function(b){b=b.toString(16);return 1<b.length?b:"0"+b}).join("")};var Mf=null,Nf=null;function Of(a){var b="";Pf(a,function(c){b+=String.fromCharCode(c)});return b}function Pf(a,b){function c(m){for(;d<a.length;){var p=a.charAt(d++),u=Nf[p];if(null!=u)return u;if(!/^[\s\xa0]*$/.test(p))throw Error("Unknown base64 encoding at char: "+p);}return m}Qf();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),h=c(64);if(64===h&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=h&&b(g<<6&192|h))}}
	function Qf(){if(!Mf){Mf={};Nf={};for(var a=0;65>a;a++)Mf[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Nf[Mf[a]]=a,62<=a&&(Nf["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};function Rf(a){this.f=a.sub;va();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null;this.c=a.firebase&&a.firebase.tenant||null;this.b=!!a.is_anonymous||"anonymous"==this.a}Rf.prototype.R=function(){return this.c};Rf.prototype.g=function(){return this.b};function Sf(a){return(a=Tf(a))&&a.sub&&a.iss&&a.aud&&a.exp?new Rf(a):null}
	function Tf(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(Of(a))}catch(d){}return null};var Uf={bd:{cb:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",ib:"https://securetoken.googleapis.com/v1/token",id:"p"},dd:{cb:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",ib:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},ed:{cb:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",ib:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
	function Vf(a){for(var b in Uf)if(Uf[b].id===a)return a=Uf[b],{firebaseEndpoint:a.cb,secureTokenEndpoint:a.ib};return null}var Wf;Wf=Vf("__EID__")?"__EID__":void 0;var Xf="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Yf=["client_id","response_type","scope","redirect_uri","state"],Zf={Xc:{Ea:"locale",sa:700,ra:600,Fa:"facebook.com",Qa:Yf},Zc:{Ea:null,sa:500,ra:750,Fa:"github.com",Qa:Yf},$c:{Ea:"hl",sa:515,ra:680,Fa:"google.com",Qa:Yf},fd:{Ea:"lang",sa:485,ra:705,Fa:"twitter.com",Qa:Xf},Vc:{Ea:"locale",sa:600,ra:600,Fa:"apple.com",Qa:[]}};
	function $f(a){for(var b in Zf)if(Zf[b].Fa==a)return Zf[b];return null};function ag(a){var b={};b["facebook.com"]=bg;b["google.com"]=cg;b["github.com"]=dg;b["twitter.com"]=eg;var c=a&&a[fg];try{if(c)return b[c]?new b[c](a):new gg(a);if("undefined"!==typeof a[hg])return new ig(a)}catch(d){}return null}var hg="idToken",fg="providerId";
	function ig(a){var b=a[fg];if(!b&&a[hg]){var c=Sf(a[hg]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);K(this,"providerId",b);K(this,"isNewUser",c)}function gg(a){ig.call(this,a);a=Ne(a.rawUserInfo||"{}");K(this,"profile",df(a||{}))}v(gg,ig);
	function bg(a){gg.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}v(bg,gg);function dg(a){gg.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",this.profile&&this.profile.login||null)}v(dg,gg);function cg(a){gg.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}v(cg,gg);
	function eg(a){gg.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",a.screenName||null)}v(eg,gg);function jg(a){var b=Md(a),c=Ld(b,"link"),d=Ld(Md(c),"link");b=Ld(b,"deep_link_id");return Ld(Md(b),"link")||b||d||c||a};function kg(){}function lg(a,b){return a.then(function(c){if(c[mg]){var d=Sf(c[mg]);if(!d||b!=d.f)throw new M("user-mismatch");return c}throw new M("user-mismatch");}).s(function(c){throw c&&c.code&&c.code==of+"user-not-found"?new M("user-mismatch"):c;})}function ng(a,b){if(b)this.a=b;else throw new M("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",a)}ng.prototype.na=function(a){return og(a,pg(this))};
	ng.prototype.b=function(a,b){var c=pg(this);c.idToken=b;return qg(a,c)};ng.prototype.f=function(a,b){return lg(rg(a,pg(this)),b)};function pg(a){return{pendingToken:a.a,requestUri:"http://localhost"}}ng.prototype.A=function(){return{providerId:this.providerId,signInMethod:this.signInMethod,pendingToken:this.a}};function sg(a){if(a&&a.providerId&&a.signInMethod&&0==a.providerId.indexOf("saml.")&&a.pendingToken)try{return new ng(a.providerId,a.pendingToken)}catch(b){}return null}
	function tg(a,b,c){this.a=null;if(b.idToken||b.accessToken)b.idToken&&K(this,"idToken",b.idToken),b.accessToken&&K(this,"accessToken",b.accessToken),b.nonce&&!b.pendingToken&&K(this,"nonce",b.nonce),b.pendingToken&&(this.a=b.pendingToken);else if(b.oauthToken&&b.oauthTokenSecret)K(this,"accessToken",b.oauthToken),K(this,"secret",b.oauthTokenSecret);else throw new M("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",c)}
	tg.prototype.na=function(a){return og(a,ug(this))};tg.prototype.b=function(a,b){var c=ug(this);c.idToken=b;return qg(a,c)};tg.prototype.f=function(a,b){var c=ug(this);return lg(rg(a,c),b)};
	function ug(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;a.nonce&&!a.a&&(b.nonce=a.nonce);b={postBody:Qd(b).toString(),requestUri:"http://localhost"};a.a&&(delete b.postBody,b.pendingToken=a.a);return b}
	tg.prototype.A=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);this.nonce&&(a.nonce=this.nonce);this.a&&(a.pendingToken=this.a);return a};
	function vg(a){if(a&&a.providerId&&a.signInMethod){var b={idToken:a.oauthIdToken,accessToken:a.oauthTokenSecret?null:a.oauthAccessToken,oauthTokenSecret:a.oauthTokenSecret,oauthToken:a.oauthTokenSecret&&a.oauthAccessToken,nonce:a.nonce,pendingToken:a.pendingToken};try{return new tg(a.providerId,b,a.signInMethod)}catch(c){}}return null}function wg(a,b){this.Fc=b||[];L(this,{providerId:a,isOAuthProvider:!0});this.zb={};this.eb=($f(a)||{}).Ea||null;this.bb=null}
	wg.prototype.Ga=function(a){this.zb=Va(a);return this};function xg(a){if("string"!==typeof a||0!=a.indexOf("saml."))throw new M("argument-error",'SAML provider IDs must be prefixed with "saml."');wg.call(this,a,[])}v(xg,wg);function O(a){wg.call(this,a,Yf);this.a=[]}v(O,wg);O.prototype.ya=function(a){Oa(this.a,a)||this.a.push(a);return this};O.prototype.Hb=function(){return Sa(this.a)};
	O.prototype.credential=function(a,b){var c;r(a)?c={idToken:a.idToken||null,accessToken:a.accessToken||null,nonce:a.rawNonce||null}:c={idToken:a||null,accessToken:b||null};if(!c.idToken&&!c.accessToken)throw new M("argument-error","credential failed: must provide the ID token and/or the access token.");return new tg(this.providerId,c,this.providerId)};function yg(){O.call(this,"facebook.com")}v(yg,O);K(yg,"PROVIDER_ID","facebook.com");K(yg,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
	function zg(a){if(!a)throw new M("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;r(a)&&(b=a.accessToken);return(new yg).credential({accessToken:b})}function Ag(){O.call(this,"github.com")}v(Ag,O);K(Ag,"PROVIDER_ID","github.com");K(Ag,"GITHUB_SIGN_IN_METHOD","github.com");
	function Bg(a){if(!a)throw new M("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;r(a)&&(b=a.accessToken);return(new Ag).credential({accessToken:b})}function Cg(){O.call(this,"google.com");this.ya("profile")}v(Cg,O);K(Cg,"PROVIDER_ID","google.com");K(Cg,"GOOGLE_SIGN_IN_METHOD","google.com");function Dg(a,b){var c=a;r(a)&&(c=a.idToken,b=a.accessToken);return(new Cg).credential({idToken:c,accessToken:b})}function Eg(){wg.call(this,"twitter.com",Xf)}v(Eg,wg);
	K(Eg,"PROVIDER_ID","twitter.com");K(Eg,"TWITTER_SIGN_IN_METHOD","twitter.com");function Fg(a,b){var c=a;r(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new M("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new tg("twitter.com",c,"twitter.com")}
	function Gg(a,b,c){this.a=a;this.c=b;K(this,"providerId","password");K(this,"signInMethod",c===Hg.EMAIL_LINK_SIGN_IN_METHOD?Hg.EMAIL_LINK_SIGN_IN_METHOD:Hg.EMAIL_PASSWORD_SIGN_IN_METHOD)}Gg.prototype.na=function(a){return this.signInMethod==Hg.EMAIL_LINK_SIGN_IN_METHOD?P(a,Ig,{email:this.a,oobCode:this.c}):P(a,Jg,{email:this.a,password:this.c})};
	Gg.prototype.b=function(a,b){return this.signInMethod==Hg.EMAIL_LINK_SIGN_IN_METHOD?P(a,Kg,{idToken:b,email:this.a,oobCode:this.c}):P(a,Lg,{idToken:b,email:this.a,password:this.c})};Gg.prototype.f=function(a,b){return lg(this.na(a),b)};Gg.prototype.A=function(){return{email:this.a,password:this.c,signInMethod:this.signInMethod}};function Mg(a){return a&&a.email&&a.password?new Gg(a.email,a.password,a.signInMethod):null}function Hg(){L(this,{providerId:"password",isOAuthProvider:!1})}
	function Ng(a,b){b=Og(b);if(!b)throw new M("argument-error","Invalid email link!");return new Gg(a,b.code,Hg.EMAIL_LINK_SIGN_IN_METHOD)}function Og(a){a=jg(a);return(a=zf(a))&&a.operation===jf?a:null}L(Hg,{PROVIDER_ID:"password"});L(Hg,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});L(Hg,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});function Pg(a){if(!(a.Va&&a.Ua||a.Ha&&a.ba))throw new M("internal-error");this.a=a;K(this,"providerId","phone");K(this,"signInMethod","phone")}Pg.prototype.na=function(a){return a.Wa(Qg(this))};
	Pg.prototype.b=function(a,b){var c=Qg(this);c.idToken=b;return P(a,Rg,c)};Pg.prototype.f=function(a,b){var c=Qg(this);c.operation="REAUTH";a=P(a,Sg,c);return lg(a,b)};Pg.prototype.A=function(){var a={providerId:"phone"};this.a.Va&&(a.verificationId=this.a.Va);this.a.Ua&&(a.verificationCode=this.a.Ua);this.a.Ha&&(a.temporaryProof=this.a.Ha);this.a.ba&&(a.phoneNumber=this.a.ba);return a};
	function Tg(a){if(a&&"phone"===a.providerId&&(a.verificationId&&a.verificationCode||a.temporaryProof&&a.phoneNumber)){var b={};x(["verificationId","verificationCode","temporaryProof","phoneNumber"],function(c){a[c]&&(b[c]=a[c])});return new Pg(b)}return null}function Qg(a){return a.a.Ha&&a.a.ba?{temporaryProof:a.a.Ha,phoneNumber:a.a.ba}:{sessionInfo:a.a.Va,code:a.a.Ua}}
	function Ug(a){try{this.a=a||firebase.auth()}catch(b){throw new M("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}L(this,{providerId:"phone",isOAuthProvider:!1})}
	Ug.prototype.Wa=function(a,b){var c=this.a.b;return D(b.verify()).then(function(d){if(!n(d))throw new M("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return Vg(c,{phoneNumber:a,recaptchaToken:d}).then(function(e){"function"===typeof b.reset&&b.reset();return e},function(e){"function"===typeof b.reset&&b.reset();throw e;});default:throw new M("argument-error",
	'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function Wg(a,b){if(!a)throw new M("missing-verification-id");if(!b)throw new M("missing-verification-code");return new Pg({Va:a,Ua:b})}L(Ug,{PROVIDER_ID:"phone"});L(Ug,{PHONE_SIGN_IN_METHOD:"phone"});
	function Xg(a){if(a.temporaryProof&&a.phoneNumber)return new Pg({Ha:a.temporaryProof,ba:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret,e=a&&a.nonce,f=a&&a.oauthIdToken,g=a&&a.pendingToken;try{switch(b){case "google.com":return Dg(f,c);case "facebook.com":return zg(c);case "github.com":return Bg(c);case "twitter.com":return Fg(c,d);default:return c||d||f||g?g?0==b.indexOf("saml.")?new ng(b,g):new tg(b,{pendingToken:g,idToken:a.oauthIdToken,
	accessToken:a.oauthAccessToken},b):(new O(b)).credential({idToken:f,accessToken:c,rawNonce:e}):null}}catch(h){return null}}function Yg(a){if(!a.isOAuthProvider)throw new M("invalid-oauth-provider");};function Zg(a,b,c,d,e,f,g){this.c=a;this.b=b||null;this.g=c||null;this.f=d||null;this.i=f||null;this.h=g||null;this.a=e||null;if(this.g||this.a){if(this.g&&this.a)throw new M("invalid-auth-event");if(this.g&&!this.f)throw new M("invalid-auth-event");}else throw new M("invalid-auth-event");}Zg.prototype.getUid=function(){var a=[];a.push(this.c);this.b&&a.push(this.b);this.f&&a.push(this.f);this.h&&a.push(this.h);return a.join("-")};Zg.prototype.R=function(){return this.h};
	Zg.prototype.A=function(){return{type:this.c,eventId:this.b,urlResponse:this.g,sessionId:this.f,postBody:this.i,tenantId:this.h,error:this.a&&this.a.A()}};function $g(a){a=a||{};return a.type?new Zg(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&qf(a.error),a.postBody,a.tenantId):null};/*
	
	 Copyright 2018 Google Inc.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function ah(){this.b=null;this.a=[]}var bh=null;function ch(a){var b=bh;b.a.push(a);b.b||(b.b=function(c){for(var d=0;d<b.a.length;d++)b.a[d](c)},a=J("universalLinks.subscribe",l),"function"===typeof a&&a(null,b.b))};function dh(a){var b="unauthorized-domain",c=void 0,d=Md(a);a=d.b;d=d.f;"chrome-extension"==d?c=Ib("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=Ib("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
	M.call(this,b,c)}v(dh,M);function eh(a,b,c){M.call(this,a,c);a=b||{};a.Ab&&K(this,"email",a.Ab);a.ba&&K(this,"phoneNumber",a.ba);a.credential&&K(this,"credential",a.credential);a.Qb&&K(this,"tenantId",a.Qb)}v(eh,M);eh.prototype.A=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);this.tenantId&&(a.tenantId=this.tenantId);var b=this.credential&&this.credential.A();b&&Xa(a,b);return a};eh.prototype.toJSON=function(){return this.A()};
	function fh(a){if(a.code){var b=a.code||"";0==b.indexOf(of)&&(b=b.substring(of.length));var c={credential:Xg(a),Qb:a.tenantId};if(a.email)c.Ab=a.email;else if(a.phoneNumber)c.ba=a.phoneNumber;else if(!c.credential)return new M(b,a.message||void 0);return new eh(b,c,a.message)}return null};function gh(){}gh.prototype.c=null;function hh(a){return a.c||(a.c=a.b())};var ih;function jh(){}v(jh,gh);jh.prototype.a=function(){var a=kh(this);return a?new ActiveXObject(a):new XMLHttpRequest};jh.prototype.b=function(){var a={};kh(this)&&(a[0]=!0,a[1]=!0);return a};
	function kh(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}ih=new jh;function lh(){}v(lh,gh);lh.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new mh;throw Error("Unsupported browser");};lh.prototype.b=function(){return{}};
	function mh(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseType=this.responseText=this.response="";this.status=-1;this.statusText="";this.a.onload=t(this.fc,this);this.a.onerror=t(this.Ib,this);this.a.onprogress=t(this.gc,this);this.a.ontimeout=t(this.kc,this)}k=mh.prototype;k.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
	k.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};k.abort=function(){this.a.abort()};k.setRequestHeader=function(){};k.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};k.fc=function(){this.status=200;this.response=this.responseText=this.a.responseText;nh(this,4)};k.Ib=function(){this.status=500;this.response=this.responseText="";nh(this,4)};k.kc=function(){this.Ib()};
	k.gc=function(){this.status=200;nh(this,1)};function nh(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}k.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function oh(a,b,c){this.reset(a,b,c,void 0,void 0)}oh.prototype.a=null;var ph=0;oh.prototype.reset=function(a,b,c,d,e){"number"==typeof e||ph++;d||va();delete this.a};function qh(a){this.f=a;this.b=this.c=this.a=null}function rh(a,b){this.name=a;this.value=b}rh.prototype.toString=function(){return this.name};var sh=new rh("SEVERE",1E3),th=new rh("WARNING",900),uh=new rh("CONFIG",700),vh=new rh("FINE",500);function wh(a){if(a.c)return a.c;if(a.a)return wh(a.a);za("Root logger has no level set.");return null}qh.prototype.log=function(a,b,c){if(a.value>=wh(this).value)for(q(b)&&(b=b()),a=new oh(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var xh={},yh=null;
	function zh(a){yh||(yh=new qh(""),xh[""]=yh,yh.c=uh);var b;if(!(b=xh[a])){b=new qh(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=zh(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;xh[a]=b}return b};function Ah(a,b){a&&a.log(vh,b,void 0)};function Bh(a){this.f=a}v(Bh,gh);Bh.prototype.a=function(){return new Ch(this.f)};Bh.prototype.b=function(a){return function(){return a}}({});function Ch(a){G.call(this);this.o=a;this.readyState=Dh;this.status=0;this.responseType=this.responseText=this.response=this.statusText="";this.onreadystatechange=null;this.i=new Headers;this.b=null;this.m="GET";this.g="";this.a=!1;this.h=zh("goog.net.FetchXmlHttp");this.l=this.c=this.f=null}v(Ch,G);var Dh=0;k=Ch.prototype;
	k.open=function(a,b){if(this.readyState!=Dh)throw this.abort(),Error("Error reopening a connection");this.m=a;this.g=b;this.readyState=1;Eh(this)};k.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.i,method:this.m,credentials:void 0,cache:void 0};a&&(b.body=a);this.o.fetch(new Request(this.g,b)).then(this.jc.bind(this),this.Oa.bind(this))};
	k.abort=function(){this.response=this.responseText="";this.i=new Headers;this.status=0;this.c&&this.c.cancel("Request was aborted.");1<=this.readyState&&this.a&&4!=this.readyState&&(this.a=!1,Fh(this,!1));this.readyState=Dh};
	k.jc=function(a){this.a&&(this.f=a,this.b||(this.b=a.headers,this.readyState=2,Eh(this)),this.a&&(this.readyState=3,Eh(this),this.a&&("arraybuffer"===this.responseType?a.arrayBuffer().then(this.hc.bind(this),this.Oa.bind(this)):"undefined"!==typeof l.ReadableStream&&"body"in a?(this.response=this.responseText="",this.c=a.body.getReader(),this.l=new TextDecoder,Gh(this)):a.text().then(this.ic.bind(this),this.Oa.bind(this)))))};function Gh(a){a.c.read().then(a.ec.bind(a)).catch(a.Oa.bind(a))}
	k.ec=function(a){if(this.a){var b=this.l.decode(a.value?a.value:new Uint8Array(0),{stream:!a.done});b&&(this.response=this.responseText+=b);a.done?Fh(this,!0):Eh(this);3==this.readyState&&Gh(this)}};k.ic=function(a){this.a&&(this.response=this.responseText=a,Fh(this,!0))};k.hc=function(a){this.a&&(this.response=a,Fh(this,!0))};k.Oa=function(a){var b=this.h;b&&b.log(th,"Failed to fetch url "+this.g,a instanceof Error?a:Error(a));this.a&&Fh(this,!0)};
	function Fh(a,b){b&&a.f&&(a.status=a.f.status,a.statusText=a.f.statusText);a.readyState=4;a.f=null;a.c=null;a.l=null;Eh(a)}k.setRequestHeader=function(a,b){this.i.append(a,b)};k.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.h)&&a.log(th,"Attempting to get response header but no headers have been received for url: "+this.g,void 0),"")};
	k.getAllResponseHeaders=function(){if(!this.b){var a=this.h;a&&a.log(th,"Attempting to get all response headers but no headers have been received for url: "+this.g,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function Eh(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function Hh(a){G.call(this);this.headers=new sd;this.B=a||null;this.c=!1;this.w=this.a=null;this.h=this.O=this.l="";this.f=this.J=this.i=this.I=!1;this.g=0;this.o=null;this.m=Ih;this.v=this.P=!1}v(Hh,G);var Ih="";Hh.prototype.b=zh("goog.net.XhrIo");var Jh=/^https?$/i,Kh=["POST","PUT"];
	function Lh(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.l+"; newUri="+b);c=c?c.toUpperCase():"GET";a.l=b;a.h="";a.O=c;a.I=!1;a.c=!0;a.a=a.B?a.B.a():ih.a();a.w=a.B?hh(a.B):hh(ih);a.a.onreadystatechange=t(a.Lb,a);try{Ah(a.b,Mh(a,"Opening Xhr")),a.J=!0,a.a.open(c,String(b),!0),a.J=!1}catch(g){Ah(a.b,Mh(a,"Error opening Xhr: "+g.message));Nh(a,g);return}b=d||"";var f=new sd(a.headers);e&&rd(e,function(g,h){f.set(h,g)});e=Ma(f.X());d=l.FormData&&b instanceof
	l.FormData;!Oa(Kh,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(g,h){this.a.setRequestHeader(h,g)},a);a.m&&(a.a.responseType=a.m);"withCredentials"in a.a&&a.a.withCredentials!==a.P&&(a.a.withCredentials=a.P);try{Oh(a),0<a.g&&(a.v=Ph(a.a),Ah(a.b,Mh(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.v)),a.v?(a.a.timeout=a.g,a.a.ontimeout=t(a.Ia,a)):a.o=nd(a.Ia,a.g,a)),Ah(a.b,Mh(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(g){Ah(a.b,
	Mh(a,"Send error: "+g.message)),Nh(a,g)}}function Ph(a){return vc&&Fc(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Na(a){return"content-type"==a.toLowerCase()}k=Hh.prototype;k.Ia=function(){"undefined"!=typeof ha&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",Ah(this.b,Mh(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function Nh(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;Qh(a);Rh(a)}
	function Qh(a){a.I||(a.I=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}k.abort=function(){this.a&&this.c&&(Ah(this.b,Mh(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),Rh(this))};k.za=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),Rh(this,!0));Hh.qb.za.call(this)};k.Lb=function(){this.va||(this.J||this.i||this.f?Sh(this):this.yc())};k.yc=function(){Sh(this)};
	function Sh(a){if(a.c&&"undefined"!=typeof ha)if(a.w[1]&&4==Th(a)&&2==Uh(a))Ah(a.b,Mh(a,"Local request error detected and ignored"));else if(a.i&&4==Th(a))nd(a.Lb,0,a);else if(a.dispatchEvent("readystatechange"),4==Th(a)){Ah(a.b,Mh(a,"Request complete"));a.c=!1;try{var b=Uh(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.l).match(vd)[1]||null;if(!f&&l.self&&l.self.location){var g=l.self.location.protocol;
	f=g.substr(0,g.length-1)}e=!Jh.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var h=2<Th(a)?a.a.statusText:""}catch(m){Ah(a.b,"Can not get status: "+m.message),h=""}a.h=h+" ["+Uh(a)+"]";Qh(a)}}finally{Rh(a)}}}function Rh(a,b){if(a.a){Oh(a);var c=a.a,d=a.w[0]?la:null;a.a=null;a.w=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(sh,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
	function Oh(a){a.a&&a.v&&(a.a.ontimeout=null);a.o&&(l.clearTimeout(a.o),a.o=null)}function Th(a){return a.a?a.a.readyState:0}function Uh(a){try{return 2<Th(a)?a.a.status:-1}catch(b){return-1}}function Vh(a){try{return a.a?a.a.responseText:""}catch(b){return Ah(a.b,"Can not get responseText: "+b.message),""}}
	k.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.m){case Ih:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(sh,"Response type "+this.m+" is not supported on this browser",void 0);return null}catch(b){return Ah(this.b,"Can not get response: "+b.message),null}};function Mh(a,b){return b+" ["+a.O+" "+a.l+" "+Uh(a)+"]"};/*
	 Portions of this code are from MochiKit, received by
	 The Closure Authors under the MIT license. All other code is Copyright
	 2005-2009 The Closure Authors. All Rights Reserved.
	*/
	function Wh(a){var b=Xh;this.g=[];this.v=b;this.o=a||null;this.f=this.a=!1;this.c=void 0;this.u=this.w=this.i=!1;this.h=0;this.b=null;this.l=0}Wh.prototype.cancel=function(a){if(this.a)this.c instanceof Wh&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.v?this.v.call(this.o,this):this.u=!0;this.a||(a=new Yh(this),Zh(this),$h(this,!1,a))}};Wh.prototype.m=function(a,b){this.i=!1;$h(this,a,b)};function $h(a,b,c){a.a=!0;a.c=c;a.f=!b;ai(a)}
	function Zh(a){if(a.a){if(!a.u)throw new bi(a);a.u=!1}}function ci(a,b){di(a,null,b,void 0)}function di(a,b,c,d){a.g.push([b,c,d]);a.a&&ai(a)}Wh.prototype.then=function(a,b,c){var d,e,f=new B(function(g,h){d=g;e=h});di(this,d,function(g){g instanceof Yh?f.cancel():e(g)});return f.then(a,b,c)};Wh.prototype.$goog_Thenable=!0;function ei(a){return La(a.g,function(b){return q(b[1])})}
	function ai(a){if(a.h&&a.a&&ei(a)){var b=a.h,c=fi[b];c&&(l.clearTimeout(c.a),delete fi[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],g=e[1];e=e[2];if(f=a.f?g:f)try{var h=f.call(e||a.o,b);void 0!==h&&(a.f=a.f&&(h==b||h instanceof Error),a.c=b=h);if(xa(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.i=!0}catch(m){b=m,a.f=!0,ei(a)||(c=!0)}}a.c=b;d&&(h=t(a.m,a,!0),d=t(a.m,a,!1),b instanceof Wh?(di(b,h,d),b.w=!0):b.then(h,d));c&&(b=
	new gi(b),fi[b.a]=b,a.h=b.a)}function bi(){w.call(this)}v(bi,w);bi.prototype.message="Deferred has already fired";bi.prototype.name="AlreadyCalledError";function Yh(){w.call(this)}v(Yh,w);Yh.prototype.message="Deferred was canceled";Yh.prototype.name="CanceledError";function gi(a){this.a=l.setTimeout(t(this.c,this),0);this.b=a}gi.prototype.c=function(){delete fi[this.a];throw this.b;};var fi={};function hi(a){var b={},c=b.document||document,d=eb(a).toString(),e=document.createElement("SCRIPT"),f={Nb:e,Ia:void 0},g=new Wh(f),h=null,m=null!=b.timeout?b.timeout:5E3;0<m&&(h=window.setTimeout(function(){ii(e,!0);var p=new ji(ki,"Timeout reached for loading script "+d);Zh(g);$h(g,!1,p)},m),f.Ia=h);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(ii(e,b.gd||!1,h),Zh(g),$h(g,!0,null))};e.onerror=function(){ii(e,!0,h);var p=new ji(li,"Error while loading script "+
	d);Zh(g);$h(g,!1,p)};f=b.attributes||{};Xa(f,{type:"text/javascript",charset:"UTF-8"});Xd(e,f);Hb(e,a);mi(c).appendChild(e);return g}function mi(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function Xh(){if(this&&this.Nb){var a=this.Nb;a&&"SCRIPT"==a.tagName&&ii(a,!0,this.Ia)}}
	function ii(a,b,c){null!=c&&l.clearTimeout(c);a.onload=la;a.onerror=la;a.onreadystatechange=la;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var li=0,ki=1;function ji(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);w.call(this,c);this.code=a}v(ji,w);function ni(a){this.f=a}v(ni,gh);ni.prototype.a=function(){return new this.f};ni.prototype.b=function(){return{}};
	function oi(a,b,c){this.c=a;a=b||{};this.l=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.u=a.secureTokenTimeout||pi;this.g=Va(a.secureTokenHeaders||qi);this.h=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.i=a.firebaseTimeout||ri;this.a=Va(a.firebaseHeaders||si);c&&(this.a["X-Client-Version"]=c,this.g["X-Client-Version"]=c);c="Node"==Be();c=l.XMLHttpRequest||c&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!c&&
	!Ae())throw new M("internal-error","The XMLHttpRequest compatibility library was not found.");this.f=void 0;Ae()?this.f=new Bh(self):Ce()?this.f=new ni(c):this.f=new lh;this.b=null}var ti,mg="idToken",pi=new Qe(3E4,6E4),qi={"Content-Type":"application/x-www-form-urlencoded"},ri=new Qe(3E4,6E4),si={"Content-Type":"application/json"};function ui(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
	function vi(a,b){b?(a.a["X-Client-Version"]=b,a.g["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.g["X-Client-Version"])}oi.prototype.R=function(){return this.b};function wi(a,b,c,d,e,f,g){le()||Ae()?a=t(a.o,a):(ti||(ti=new B(function(h,m){xi(h,m)})),a=t(a.m,a));a(b,c,d,e,f,g)}
	oi.prototype.o=function(a,b,c,d,e,f){if(Ae()&&("undefined"===typeof l.fetch||"undefined"===typeof l.Headers||"undefined"===typeof l.Request))throw new M("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var g=new Hh(this.f);if(f){g.g=Math.max(0,f);var h=setTimeout(function(){g.dispatchEvent("timeout")},f)}$c(g,"complete",function(){h&&clearTimeout(h);var m=null;try{m=
	JSON.parse(Vh(this))||null}catch(p){m=null}b&&b(m)});fd(g,"ready",function(){h&&clearTimeout(h);qc(this)});fd(g,"timeout",function(){h&&clearTimeout(h);qc(this);b&&b(null)});Lh(g,a,c,d,e)};var yi=new Ya(Za,"https://apis.google.com/js/client.js?onload=%{onload}"),zi="__fcb"+Math.floor(1E6*Math.random()).toString();
	function xi(a,b){if(((window.gapi||{}).client||{}).request)a();else{l[zi]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=fb(yi,{onload:zi});ci(hi(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
	oi.prototype.m=function(a,b,c,d,e){var f=this;ti.then(function(){window.gapi.client.setApiKey(f.c);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(h){window.gapi.auth.setToken(g);b&&b(h)}})}).s(function(g){b&&b({error:{message:g&&g.message||"CORS_UNSUPPORTED"}})})};
	function Ai(a,b){return new B(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?wi(a,a.l+"?key="+encodeURIComponent(a.c),function(e){e?e.error?d(Bi(e)):e.access_token&&e.refresh_token?c(e):d(new M("internal-error")):d(new M("network-request-failed"))},"POST",Qd(b).toString(),a.g,a.u.get()):d(new M("internal-error"))})}
	function Ci(a,b,c,d,e,f){var g=Md(a.h+b);H(g,"key",a.c);f&&H(g,"cb",va().toString());var h="GET"==c;if(h)for(var m in d)d.hasOwnProperty(m)&&H(g,m,d[m]);return new B(function(p,u){wi(a,g.toString(),function(A){A?A.error?u(Bi(A,e||{})):p(A):u(new M("network-request-failed"))},c,h?void 0:be(Me(d)),a.a,a.i.get())})}function Di(a){a=a.email;if(!n(a)||!ue.test(a))throw new M("invalid-email");}function Ei(a){"email"in a&&Di(a)}
	function Fi(a,b){return P(a,Gi,{identifier:b,continueUri:Je()?ie():"http://localhost"}).then(function(c){return c.signinMethods||[]})}function Hi(a){return P(a,Ii,{}).then(function(b){return b.authorizedDomains||[]})}function Ji(a){if(!a[mg])throw new M("internal-error");}
	function Ki(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new M("internal-error");}else{if(!a.sessionInfo)throw new M("missing-verification-id");if(!a.code)throw new M("missing-verification-code");}}oi.prototype.ob=function(){return P(this,Li,{})};oi.prototype.rb=function(a,b){return P(this,Mi,{idToken:a,email:b})};oi.prototype.sb=function(a,b){return P(this,Lg,{idToken:a,password:b})};var Ni={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};k=oi.prototype;
	k.tb=function(a,b){var c={idToken:a},d=[];Ta(Ni,function(e,f){var g=b[f];null===g?d.push(e):f in b&&(c[f]=g)});d.length&&(c.deleteAttribute=d);return P(this,Mi,c)};k.kb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};Xa(a,b);return P(this,Oi,a)};k.lb=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};Xa(a,b);return P(this,Pi,a)};k.jb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};Xa(a,b);return P(this,Qi,a)};function Vg(a,b){return P(a,Ri,b)}k.Wa=function(a){return P(this,Si,a)};
	function Ti(a,b,c){return P(a,Ui,{idToken:b,deleteProvider:c})}function Vi(a){if(!a.requestUri||!a.sessionId&&!a.postBody&&!a.pendingToken)throw new M("internal-error");}function Wi(a,b){b.oauthIdToken&&b.providerId&&0==b.providerId.indexOf("oidc.")&&!b.pendingToken&&(a.sessionId?b.nonce=a.sessionId:a.postBody&&(a=new Dd(a.postBody),Ud(a,"nonce")&&(b.nonce=a.get("nonce"))));return b}
	function Xi(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=fh(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=fh(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=fh(a)):a.errorMessage&&(b=Yi(a.errorMessage));if(b)throw b;if(!a[mg])throw new M("internal-error");}function og(a,b){b.returnIdpCredential=!0;return P(a,Zi,b)}function qg(a,b){b.returnIdpCredential=!0;return P(a,$i,b)}
	function rg(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return P(a,aj,b)}function bj(a){if(!a.oobCode)throw new M("invalid-action-code");}k.ab=function(a,b){return P(this,cj,{oobCode:a,newPassword:b})};k.Ma=function(a){return P(this,dj,{oobCode:a})};k.Ya=function(a){return P(this,ej,{oobCode:a})};
	var ej={endpoint:"setAccountInfo",D:bj,fa:"email",F:!0},dj={endpoint:"resetPassword",D:bj,K:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b)throw new M("internal-error");},F:!0},fj={endpoint:"signupNewUser",D:function(a){Di(a);if(!a.password)throw new M("weak-password");},K:Ji,T:!0,F:!0},Gi={endpoint:"createAuthUri",F:!0},gj={endpoint:"deleteAccount",V:["idToken"]},Ui={endpoint:"setAccountInfo",V:["idToken","deleteProvider"],D:function(a){if(!oa(a.deleteProvider))throw new M("internal-error");
	}},Ig={endpoint:"emailLinkSignin",V:["email","oobCode"],D:Di,K:Ji,T:!0,F:!0},Kg={endpoint:"emailLinkSignin",V:["idToken","email","oobCode"],D:Di,K:Ji,T:!0},hj={endpoint:"getAccountInfo"},Pi={endpoint:"getOobConfirmationCode",V:["requestType"],D:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new M("internal-error");Di(a)},fa:"email",F:!0},Qi={endpoint:"getOobConfirmationCode",V:["idToken","requestType"],D:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new M("internal-error");},fa:"email",F:!0},
	Oi={endpoint:"getOobConfirmationCode",V:["requestType"],D:function(a){if("PASSWORD_RESET"!=a.requestType)throw new M("internal-error");Di(a)},fa:"email",F:!0},Ii={wb:!0,endpoint:"getProjectConfig",Kb:"GET"},ij={wb:!0,endpoint:"getRecaptchaParam",Kb:"GET",K:function(a){if(!a.recaptchaSiteKey)throw new M("internal-error");}},cj={endpoint:"resetPassword",D:bj,fa:"email",F:!0},Ri={endpoint:"sendVerificationCode",V:["phoneNumber","recaptchaToken"],fa:"sessionInfo",F:!0},Mi={endpoint:"setAccountInfo",V:["idToken"],
	D:Ei,T:!0},Lg={endpoint:"setAccountInfo",V:["idToken"],D:function(a){Ei(a);if(!a.password)throw new M("weak-password");},K:Ji,T:!0},Li={endpoint:"signupNewUser",K:Ji,T:!0,F:!0},Zi={endpoint:"verifyAssertion",D:Vi,Ra:Wi,K:Xi,T:!0,F:!0},aj={endpoint:"verifyAssertion",D:Vi,Ra:Wi,K:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new M("user-not-found");if(a.errorMessage)throw Yi(a.errorMessage);if(!a[mg])throw new M("internal-error");},T:!0,F:!0},$i={endpoint:"verifyAssertion",D:function(a){Vi(a);
	if(!a.idToken)throw new M("internal-error");},Ra:Wi,K:Xi,T:!0},jj={endpoint:"verifyCustomToken",D:function(a){if(!a.token)throw new M("invalid-custom-token");},K:Ji,T:!0,F:!0},Jg={endpoint:"verifyPassword",D:function(a){Di(a);if(!a.password)throw new M("wrong-password");},K:Ji,T:!0,F:!0},Si={endpoint:"verifyPhoneNumber",D:Ki,K:Ji,F:!0},Rg={endpoint:"verifyPhoneNumber",D:function(a){if(!a.idToken)throw new M("internal-error");Ki(a)},K:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",
	fh(a);Ji(a)}},Sg={Yb:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",D:Ki,K:Ji,F:!0};
	function P(a,b,c){if(!cf(c,b.V))return E(new M("internal-error"));var d=b.Kb||"POST",e;return D(c).then(b.D).then(function(){b.T&&(c.returnSecureToken=!0);b.F&&a.b&&"undefined"===typeof c.tenantId&&(c.tenantId=a.b);return Ci(a,b.endpoint,d,c,b.Yb,b.wb||!1)}).then(function(f){e=f;return b.Ra?b.Ra(c,e):e}).then(b.K).then(function(){if(!b.fa)return e;if(!(b.fa in e))throw new M("internal-error");return e[b.fa]})}function Yi(a){return Bi({error:{errors:[{message:a}],code:400,message:a}})}
	function Bi(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new M(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
	MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",INVALID_PENDING_TOKEN:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",MISSING_OR_INVALID_NONCE:"missing-or-invalid-nonce",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",RESET_PASSWORD_EXCEED_LIMIT:"too-many-requests",
	EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",INVALID_PROVIDER_ID:"invalid-provider-id",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",
	OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",
	QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",REJECTED_CREDENTIAL:"rejected-credential",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_DYNAMIC_LINK_DOMAIN:"invalid-dynamic-link-domain",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash",UNSUPPORTED_TENANT_OPERATION:"unsupported-tenant-operation",
	INVALID_TENANT_ID:"invalid-tenant-id",TENANT_ID_MISMATCH:"tenant-id-mismatch",ADMIN_ONLY_OPERATION:"admin-restricted-operation"};Xa(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*([\s\S]*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new M(d[e],b);!b&&a&&(b=Le(a));return new M("internal-error",b)};function kj(a){this.b=a;this.a=null;this.gb=lj(this)}
	function lj(a){return mj().then(function(){return new B(function(b,c){J("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},nj.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
	function oj(a,b){return a.gb.then(function(){return new B(function(c){a.a.send(b.type,b,c,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function pj(a,b){a.gb.then(function(){a.a.register("authEvent",b,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var qj=new Ya(Za,"https://apis.google.com/js/api.js?onload=%{onload}"),rj=new Qe(3E4,6E4),nj=new Qe(5E3,15E3),sj=null;
	function mj(){return sj?sj:sj=(new B(function(a,b){function c(){Pe();J("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Pe();b(Error("Network Error"))},timeout:rj.get()})}if(J("gapi.iframes.Iframe"))a();else if(J("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){J("gapi.load")?c():b(Error("Network Error"))};d=fb(qj,{onload:d});D(hi(d)).s(function(){b(Error("Network Error"))})}})).s(function(a){sj=null;throw a;})};function tj(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=Nd(this.i,"/__/auth/iframe");H(this.a,"apiKey",this.g);H(this.a,"appName",this.h);this.b=null;this.c=[]}tj.prototype.toString=function(){this.f?H(this.a,"v",this.f):Td(this.a.a,"v");this.b?H(this.a,"eid",this.b):Td(this.a.a,"eid");this.c.length?H(this.a,"fw",this.c.join(",")):Td(this.a.a,"fw");return this.a.toString()};function uj(a,b,c,d,e){this.o=a;this.m=b;this.c=c;this.u=d;this.i=this.g=this.l=null;this.a=e;this.h=this.f=null}
	uj.prototype.nb=function(a){this.h=a;return this};
	uj.prototype.toString=function(){var a=Nd(this.o,"/__/auth/handler");H(a,"apiKey",this.m);H(a,"appName",this.c);H(a,"authType",this.u);if(this.a.isOAuthProvider){var b=this.a;try{var c=firebase.app(this.c).auth().ha()}catch(h){c=null}b.bb=c;H(a,"providerId",this.a.providerId);b=this.a;c=Me(b.zb);for(var d in c)c[d]=c[d].toString();d=b.Fc;c=Va(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.eb&&b.bb&&!c[b.eb]&&(c[b.eb]=b.bb);Ua(c)||H(a,"customParameters",Le(c))}"function"===typeof this.a.Hb&&
	(b=this.a.Hb(),b.length&&H(a,"scopes",b.join(",")));this.l?H(a,"redirectUrl",this.l):Td(a.a,"redirectUrl");this.g?H(a,"eventId",this.g):Td(a.a,"eventId");this.i?H(a,"v",this.i):Td(a.a,"v");if(this.b)for(var g in this.b)this.b.hasOwnProperty(g)&&!Ld(a,g)&&H(a,g,this.b[g]);this.h?H(a,"tid",this.h):Td(a.a,"tid");this.f?H(a,"eid",this.f):Td(a.a,"eid");g=vj(this.c);g.length&&H(a,"fw",g.join(","));return a.toString()};function vj(a){try{return firebase.app(a).auth().Ca()}catch(b){return[]}}
	function wj(a,b,c,d,e){this.u=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.m=this.o=this.v=null;this.g=[];this.l=this.a=null}
	function xj(a){var b=ie();return Hi(a).then(function(c){a:{var d=Md(b),e=d.f;d=d.b;for(var f=0;f<c.length;f++){var g=c[f];var h=d;var m=e;0==g.indexOf("chrome-extension://")?h=Md(g).b==h&&"chrome-extension"==m:"http"!=m&&"https"!=m?h=!1:te.test(g)?h=h==g:(g=g.split(".").join("\\."),h=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(h));if(h){c=!0;break a}}c=!1}if(!c)throw new dh(ie());})}
	function yj(a){if(a.l)return a.l;a.l=ve().then(function(){if(!a.o){var b=a.c,c=a.h,d=vj(a.b),e=new tj(a.u,a.f,a.b);e.f=b;e.b=c;e.c=Sa(d||[]);a.o=e.toString()}a.i=new kj(a.o);zj(a)});return a.l}k=wj.prototype;k.Fb=function(a,b,c){var d=new M("popup-closed-by-user"),e=new M("web-storage-unsupported"),f=this,g=!1;return this.ia().then(function(){Aj(f).then(function(h){h||(a&&pe(a),b(e),g=!0)})}).s(function(){}).then(function(){if(!g)return se(a)}).then(function(){if(!g)return od(c).then(function(){b(d)})})};
	k.Ob=function(){var a=I();return!Ke(a)&&!Oe(a)};k.Jb=function(){return!1};
	k.Db=function(a,b,c,d,e,f,g,h){if(!a)return E(new M("popup-blocked"));if(g&&!Ke())return this.ia().s(function(p){pe(a);e(p)}),d(),D();this.a||(this.a=xj(Bj(this)));var m=this;return this.a.then(function(){var p=m.ia().s(function(u){pe(a);e(u);throw u;});d();return p}).then(function(){Yg(c);if(!g){var p=Cj(m.u,m.f,m.b,b,c,null,f,m.c,void 0,m.h,h);je(p,a)}}).s(function(p){"auth/network-request-failed"==p.code&&(m.a=null);throw p;})};
	function Bj(a){a.m||(a.v=a.c?Fe(a.c,vj(a.b)):null,a.m=new oi(a.f,Vf(a.h),a.v));return a.m}k.Eb=function(a,b,c,d){this.a||(this.a=xj(Bj(this)));var e=this;return this.a.then(function(){Yg(b);var f=Cj(e.u,e.f,e.b,a,b,ie(),c,e.c,void 0,e.h,d);je(f)}).s(function(f){"auth/network-request-failed"==f.code&&(e.a=null);throw f;})};k.ia=function(){var a=this;return yj(this).then(function(){return a.i.gb}).s(function(){a.a=null;throw new M("network-request-failed");})};k.Rb=function(){return!0};
	function Cj(a,b,c,d,e,f,g,h,m,p,u){a=new uj(a,b,c,d,e);a.l=f;a.g=g;a.i=h;a.b=Va(m||null);a.f=p;return a.nb(u).toString()}function zj(a){if(!a.i)throw Error("IfcHandler must be initialized!");pj(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=$g(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return D(c)}c.status="ERROR";return D(c)})}
	function Aj(a){var b={type:"webStorageSupport"};return yj(a).then(function(){return oj(a.i,b)}).then(function(c){if(c&&c.length&&"undefined"!==typeof c[0].webStorageSupport)return c[0].webStorageSupport;throw Error();})}k.Aa=function(a){this.g.push(a)};k.Na=function(a){Qa(this.g,function(b){return b==a})};function Dj(a){this.a=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new M("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}k=Dj.prototype;k.get=function(a){return D(this.a.getItem(a)).then(function(b){return b&&Ne(b)})};k.set=function(a,b){return D(this.a.setItem(a,Le(b)))};k.S=function(a){return D(this.a.removeItem(a))};k.$=function(){};k.ea=function(){};function Ej(a){this.b=a;this.a={};this.f=t(this.c,this)}var Fj=[];function Gj(){var a=Ae()?self:null;x(Fj,function(c){c.b==a&&(b=c)});if(!b){var b=new Ej(a);Fj.push(b)}return b}
	Ej.prototype.c=function(a){var b=a.data.eventType,c=a.data.eventId,d=this.a[b];if(d&&0<d.length){a.ports[0].postMessage({status:"ack",eventId:c,eventType:b,response:null});var e=[];x(d,function(f){e.push(D().then(function(){return f(a.origin,a.data.data)}))});cc(e).then(function(f){var g=[];x(f,function(h){g.push({fulfilled:h.Gb,value:h.value,reason:h.reason?h.reason.message:void 0})});x(g,function(h){for(var m in h)"undefined"===typeof h[m]&&delete h[m]});a.ports[0].postMessage({status:"done",eventId:c,
	eventType:b,response:g})})}};function Hj(a,b,c){Ua(a.a)&&a.b.addEventListener("message",a.f);"undefined"===typeof a.a[b]&&(a.a[b]=[]);a.a[b].push(c)};function Ij(a){this.a=a}Ij.prototype.postMessage=function(a,b){this.a.postMessage(a,b)};function Jj(a){this.c=a;this.b=!1;this.a=[]}
	function Kj(a,b,c,d){var e,f=c||{},g,h,m,p=null;if(a.b)return E(Error("connection_unavailable"));var u=d?800:50,A="undefined"!==typeof MessageChannel?new MessageChannel:null;return(new B(function(C,N){A?(e=Math.floor(Math.random()*Math.pow(10,20)).toString(),A.port1.start(),h=setTimeout(function(){N(Error("unsupported_event"))},u),g=function(wa){wa.data.eventId===e&&("ack"===wa.data.status?(clearTimeout(h),m=setTimeout(function(){N(Error("timeout"))},3E3)):"done"===wa.data.status?(clearTimeout(m),
	"undefined"!==typeof wa.data.response?C(wa.data.response):N(Error("unknown_error"))):(clearTimeout(h),clearTimeout(m),N(Error("invalid_response"))))},p={messageChannel:A,onMessage:g},a.a.push(p),A.port1.addEventListener("message",g),a.c.postMessage({eventType:b,eventId:e,data:f},[A.port2])):N(Error("connection_unavailable"))})).then(function(C){Lj(a,p);return C}).s(function(C){Lj(a,p);throw C;})}
	function Lj(a,b){if(b){var c=b.messageChannel,d=b.onMessage;c&&(c.port1.removeEventListener("message",d),c.port1.close());Qa(a.a,function(e){return e==b})}}Jj.prototype.close=function(){for(;0<this.a.length;)Lj(this,this.a[0]);this.b=!0};function Mj(){if(!Nj())throw new M("web-storage-unsupported");this.c={};this.a=[];this.b=0;this.u=l.indexedDB;this.type="indexedDB";this.g=this.l=this.f=this.i=null;this.o=!1;this.h=null;var a=this;Ae()&&self?(this.l=Gj(),Hj(this.l,"keyChanged",function(b,c){return Oj(a).then(function(d){0<d.length&&x(a.a,function(e){e(d)});return{keyProcessed:Oa(d,c.key)}})}),Hj(this.l,"ping",function(){return D(["keyChanged"])})):We().then(function(b){if(a.h=b)a.g=new Jj(new Ij(b)),Kj(a.g,"ping",null,!0).then(function(c){c[0].fulfilled&&
	Oa(c[0].value,"keyChanged")&&(a.o=!0)}).s(function(){})})}var Pj;function Qj(a){return new B(function(b,c){var d=a.u.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(e){c(Error(e.target.error))}})}
	function Rj(a){return new B(function(b,c){var d=a.u.open("firebaseLocalStorageDb",1);d.onerror=function(e){try{e.preventDefault()}catch(f){}c(Error(e.target.error))};d.onupgradeneeded=function(e){e=e.target.result;try{e.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(e){e=e.target.result;e.objectStoreNames.contains("firebaseLocalStorage")?b(e):Qj(a).then(function(){return Rj(a)}).then(function(f){b(f)}).s(function(f){c(f)})}})}
	function Sj(a){a.m||(a.m=Rj(a));return a.m}function Nj(){try{return!!l.indexedDB}catch(a){return!1}}function Tj(a){return a.objectStore("firebaseLocalStorage")}function Uj(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function Vj(a){return new B(function(b,c){a.onsuccess=function(d){d&&d.target?b(d.target.result):b()};a.onerror=function(d){c(d.target.error)}})}k=Mj.prototype;
	k.set=function(a,b){var c=!1,d,e=this;return Sj(this).then(function(f){d=f;f=Tj(Uj(d,!0));return Vj(f.get(a))}).then(function(f){var g=Tj(Uj(d,!0));if(f)return f.value=b,Vj(g.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return Vj(g.add(f))}).then(function(){e.c[a]=b;return Wj(e,a)}).ka(function(){c&&e.b--})};function Wj(a,b){return a.g&&a.h&&Ve()===a.h?Kj(a.g,"keyChanged",{key:b},a.o).then(function(){}).s(function(){}):D()}
	k.get=function(a){return Sj(this).then(function(b){return Vj(Tj(Uj(b,!1)).get(a))}).then(function(b){return b&&b.value})};k.S=function(a){var b=!1,c=this;return Sj(this).then(function(d){b=!0;c.b++;return Vj(Tj(Uj(d,!0))["delete"](a))}).then(function(){delete c.c[a];return Wj(c,a)}).ka(function(){b&&c.b--})};
	function Oj(a){return Sj(a).then(function(b){var c=Tj(Uj(b,!1));return c.getAll?Vj(c.getAll()):new B(function(d,e){var f=[],g=c.openCursor();g.onsuccess=function(h){(h=h.target.result)?(f.push(h.value),h["continue"]()):d(f)};g.onerror=function(h){e(h.target.error)}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=ke(a.c,c);a.c=c}return d})}k.$=function(a){0==this.a.length&&Xj(this);this.a.push(a)};
	k.ea=function(a){Qa(this.a,function(b){return b==a});0==this.a.length&&Yj(this)};function Xj(a){function b(){a.f=setTimeout(function(){a.i=Oj(a).then(function(c){0<c.length&&x(a.a,function(d){d(c)})}).then(function(){b()}).s(function(c){"STOP_EVENT"!=c.message&&b()})},800)}Yj(a);b()}function Yj(a){a.i&&a.i.cancel("STOP_EVENT");a.f&&(clearTimeout(a.f),a.f=null)};function Zj(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=D().then(function(){if(Nj()){var d=He(),e="__sak"+d;Pj||(Pj=new Mj);c=Pj;return c.set(e,d).then(function(){return c.get(e)}).then(function(f){if(f!==d)throw Error("indexedDB not supported!");return c.S(e)}).then(function(){return c}).s(function(){return b.c})}return b.c}).then(function(d){b.type=d.type;d.$(function(e){x(b.a,function(f){f(e)})});return d})}k=Zj.prototype;k.get=function(a){return this.b.then(function(b){return b.get(a)})};
	k.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};k.S=function(a){return this.b.then(function(b){return b.S(a)})};k.$=function(a){this.a.push(a)};k.ea=function(a){Qa(this.a,function(b){return b==a})};function ak(){this.a={};this.type="inMemory"}k=ak.prototype;k.get=function(a){return D(this.a[a])};k.set=function(a,b){this.a[a]=b;return D()};k.S=function(a){delete this.a[a];return D()};k.$=function(){};k.ea=function(){};function bk(){if(!ck()){if("Node"==Be())throw new M("internal-error","The LocalStorage compatibility library was not found.");throw new M("web-storage-unsupported");}this.a=dk()||firebase.INTERNAL.node.localStorage;this.type="localStorage"}function dk(){try{var a=l.localStorage,b=He();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function ck(){var a="Node"==Be();a=dk()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=bk.prototype;k.get=function(a){var b=this;return D().then(function(){var c=b.a.getItem(a);return Ne(c)})};k.set=function(a,b){var c=this;return D().then(function(){var d=Le(b);null===d?c.S(a):c.a.setItem(a,d)})};k.S=function(a){var b=this;return D().then(function(){b.a.removeItem(a)})};
	k.$=function(a){l.window&&Xc(l.window,"storage",a)};k.ea=function(a){l.window&&gd(l.window,"storage",a)};function ek(){this.type="nullStorage"}k=ek.prototype;k.get=function(){return D(null)};k.set=function(){return D()};k.S=function(){return D()};k.$=function(){};k.ea=function(){};function fk(){if(!gk()){if("Node"==Be())throw new M("internal-error","The SessionStorage compatibility library was not found.");throw new M("web-storage-unsupported");}this.a=hk()||firebase.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function hk(){try{var a=l.sessionStorage,b=He();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function gk(){var a="Node"==Be();a=hk()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=fk.prototype;k.get=function(a){var b=this;return D().then(function(){var c=b.a.getItem(a);return Ne(c)})};k.set=function(a,b){var c=this;return D().then(function(){var d=Le(b);null===d?c.S(a):c.a.setItem(a,d)})};k.S=function(a){var b=this;return D().then(function(){b.a.removeItem(a)})};k.$=function(){};
	k.ea=function(){};function ik(){var a={};a.Browser=jk;a.Node=kk;a.ReactNative=lk;a.Worker=mk;this.a=a[Be()]}var nk,jk={C:bk,Ta:fk},kk={C:bk,Ta:fk},lk={C:Dj,Ta:ek},mk={C:bk,Ta:ek};var ok={ad:"local",NONE:"none",cd:"session"};function pk(a){var b=new M("invalid-persistence-type"),c=new M("unsupported-persistence-type");a:{for(d in ok)if(ok[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(Be()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!Ge()&&"none"!==a)throw c;}}
	function qk(){var a=!Oe(I())&&ze()?!0:!1,b=Ke(),c=Ge();this.m=a;this.h=b;this.l=c;this.a={};nk||(nk=new ik);a=nk;try{this.g=!he()&&Ue()||!l.indexedDB?new a.a.C:new Zj(Ae()?new ak:new a.a.C)}catch(d){this.g=new ak,this.h=!0}try{this.i=new a.a.Ta}catch(d){this.i=new ak}this.u=new ak;this.f=t(this.Pb,this);this.b={}}var rk;function sk(){rk||(rk=new qk);return rk}function tk(a,b){switch(b){case "session":return a.i;case "none":return a.u;default:return a.g}}
	function uk(a,b){return"firebase:"+a.name+(b?":"+b:"")}function vk(a,b,c){var d=uk(b,c),e=tk(a,b.C);return a.get(b,c).then(function(f){var g=null;try{g=Ne(l.localStorage.getItem(d))}catch(h){}if(g&&!f)return l.localStorage.removeItem(d),a.set(b,g,c);g&&f&&"localStorage"!=e.type&&l.localStorage.removeItem(d)})}k=qk.prototype;k.get=function(a,b){return tk(this,a.C).get(uk(a,b))};function wk(a,b,c){c=uk(b,c);"local"==b.C&&(a.b[c]=null);return tk(a,b.C).S(c)}
	k.set=function(a,b,c){var d=uk(a,c),e=this,f=tk(this,a.C);return f.set(d,b).then(function(){return f.get(d)}).then(function(g){"local"==a.C&&(e.b[d]=g)})};k.addListener=function(a,b,c){a=uk(a,b);this.l&&(this.b[a]=l.localStorage.getItem(a));Ua(this.a)&&(tk(this,"local").$(this.f),this.h||(he()||!Ue())&&l.indexedDB||!this.l||xk(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
	k.removeListener=function(a,b,c){a=uk(a,b);this.a[a]&&(Qa(this.a[a],function(d){return d==c}),0==this.a[a].length&&delete this.a[a]);Ua(this.a)&&(tk(this,"local").ea(this.f),yk(this))};function xk(a){yk(a);a.c=setInterval(function(){for(var b in a.a){var c=l.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new Lc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Pb(c))}},1E3)}function yk(a){a.c&&(clearInterval(a.c),a.c=null)}
	k.Pb=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=l.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.$a(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?tk(this,"local").ea(this.f):yk(this);if(this.m)if(c=l.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?l.localStorage.setItem(b,d):l.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
	typeof a.a.a||f.b[b]!==l.localStorage.getItem(b))f.b[b]=l.localStorage.getItem(b),f.$a(b)};vc&&Gc&&10==Gc&&l.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else x(a,t(this.$a,this))};k.$a=function(a){this.a[a]&&x(this.a[a],function(b){b()})};function zk(a){this.a=a;this.b=sk()}var Ak={name:"authEvent",C:"local"};function Bk(a){return a.b.get(Ak,a.a).then(function(b){return $g(b)})};function Ck(){this.a=sk()};function Dk(){this.b=-1};function Ek(a,b){this.b=Fk;this.f=l.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.l=l.Int32Array?new Int32Array(64):Array(64);void 0!==Gk||(l.Int32Array?Gk=new Int32Array(Hk):Gk=Hk);this.reset()}var Gk;v(Ek,Dk);for(var Fk=64,Ik=Fk-1,Jk=[],Kk=0;Kk<Ik;Kk++)Jk[Kk]=0;var Lk=Ra(128,Jk);Ek.prototype.reset=function(){this.g=this.c=0;this.a=l.Int32Array?new Int32Array(this.h):Sa(this.h)};
	function Mk(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.a[0]|0;e=a.a[1]|0;var h=a.a[2]|0,m=a.a[3]|0,p=a.a[4]|0,u=a.a[5]|0,A=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var C=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&h^e&h)|0;g=p&u^~p&A;f=f+((p>>>6|p<<26)^(p>>>11|p<<21)^(p>>>25|p<<
	7))|0;g=g+(Gk[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=A;A=u;u=p;p=m+g|0;m=h;h=e;e=d;d=g+C|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+h|0;a.a[3]=a.a[3]+m|0;a.a[4]=a.a[4]+p|0;a.a[5]=a.a[5]+u|0;a.a[6]=a.a[6]+A|0;a.a[7]=a.a[7]+f|0}
	function Nk(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(n(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(Mk(a),e=0);else if(pa(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(Mk(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
	var Hk=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
	4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function Ok(){Ek.call(this,8,Pk)}v(Ok,Ek);var Pk=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function Qk(a,b,c,d,e){this.u=a;this.i=b;this.l=c;this.m=d||null;this.o=e||null;this.h=b+":"+c;this.v=new Ck;this.g=new zk(this.h);this.f=null;this.b=[];this.a=this.c=null}function Rk(a){return new M("invalid-cordova-configuration",a)}k=Qk.prototype;
	k.ia=function(){return this.Da?this.Da:this.Da=we().then(function(){if("function"!==typeof J("universalLinks.subscribe",l))throw Rk("cordova-universal-links-plugin-fix is not installed");if("undefined"===typeof J("BuildInfo.packageName",l))throw Rk("cordova-plugin-buildinfo is not installed");if("function"!==typeof J("cordova.plugins.browsertab.openUrl",l))throw Rk("cordova-plugin-browsertab is not installed");if("function"!==typeof J("cordova.InAppBrowser.open",l))throw Rk("cordova-plugin-inappbrowser is not installed");
	},function(){throw new M("cordova-not-ready");})};function Sk(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function Tk(a){var b=new Ok;Nk(b,a);a=[];var c=8*b.g;56>b.c?Nk(b,Lk,56-b.c):Nk(b,Lk,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;Mk(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return Lf(a)}
	k.Fb=function(a,b){b(new M("operation-not-supported-in-this-environment"));return D()};k.Db=function(){return E(new M("operation-not-supported-in-this-environment"))};k.Rb=function(){return!1};k.Ob=function(){return!0};k.Jb=function(){return!0};
	k.Eb=function(a,b,c,d){if(this.c)return E(new M("redirect-operation-pending"));var e=this,f=l.document,g=null,h=null,m=null,p=null;return this.c=D().then(function(){Yg(b);return Uk(e)}).then(function(){return Vk(e,a,b,c,d)}).then(function(){return(new B(function(u,A){h=function(){var C=J("cordova.plugins.browsertab.close",l);u();"function"===typeof C&&C();e.a&&"function"===typeof e.a.close&&(e.a.close(),e.a=null);return!1};e.Aa(h);m=function(){g||(g=od(2E3).then(function(){A(new M("redirect-cancelled-by-user"))}))};
	p=function(){Re()&&m()};f.addEventListener("resume",m,!1);I().toLowerCase().match(/android/)||f.addEventListener("visibilitychange",p,!1)})).s(function(u){return Wk(e).then(function(){throw u;})})}).ka(function(){m&&f.removeEventListener("resume",m,!1);p&&f.removeEventListener("visibilitychange",p,!1);g&&g.cancel();h&&e.Na(h);e.c=null})};
	function Vk(a,b,c,d,e){var f=Sk(),g=new Zg(b,d,null,f,new M("no-auth-event"),null,e),h=J("BuildInfo.packageName",l);if("string"!==typeof h)throw new M("invalid-cordova-configuration");var m=J("BuildInfo.displayName",l),p={};if(I().toLowerCase().match(/iphone|ipad|ipod/))p.ibi=h;else if(I().toLowerCase().match(/android/))p.apn=h;else return E(new M("operation-not-supported-in-this-environment"));m&&(p.appDisplayName=m);f=Tk(f);p.sessionId=f;var u=Cj(a.u,a.i,a.l,b,c,null,d,a.m,p,a.o,e);return a.ia().then(function(){var A=
	a.h;return a.v.a.set(Ak,g.A(),A)}).then(function(){var A=J("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof A)throw new M("invalid-cordova-configuration");var C=null;A(function(N){if(N){C=J("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof C)throw new M("invalid-cordova-configuration");C(u)}else{C=J("cordova.InAppBrowser.open",l);if("function"!==typeof C)throw new M("invalid-cordova-configuration");N=I();a.a=C(u,N.match(/(iPad|iPhone|iPod).*OS 7_\d/i)||N.match(/(iPad|iPhone|iPod).*OS 8_\d/i)?
	"_blank":"_system","location=yes")}})})}function Xk(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function Uk(a){a.f||(a.f=a.ia().then(function(){return new B(function(b){function c(d){b(d);a.Na(c);return!1}a.Aa(c);Yk(a)})}));return a.f}function Wk(a){var b=null;return Bk(a.g).then(function(c){b=c;c=a.g;return wk(c.b,Ak,c.a)}).then(function(){return b})}
	function Yk(a){function b(g){d=!0;e&&e.cancel();Wk(a).then(function(h){var m=c;if(h&&g&&g.url){var p=null;m=jg(g.url);-1!=m.indexOf("/__/auth/callback")&&(p=Md(m),p=Ne(Ld(p,"firebaseError")||null),p=(p="object"===typeof p?qf(p):null)?new Zg(h.c,h.b,null,null,p,null,h.R()):new Zg(h.c,h.b,m,h.f,null,null,h.R()));m=p||c}Xk(a,m)})}var c=new Zg("unknown",null,null,null,new M("no-auth-event")),d=!1,e=od(500).then(function(){return Wk(a).then(function(){d||Xk(a,c)})}),f=l.handleOpenURL;l.handleOpenURL=function(g){0==
	g.toLowerCase().indexOf(J("BuildInfo.packageName",l).toLowerCase()+"://")&&b({url:g});if("function"===typeof f)try{f(g)}catch(h){console.error(h)}};bh||(bh=new ah);ch(b)}k.Aa=function(a){this.b.push(a);Uk(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new Zg("unknown",null,null,null,new M("no-auth-event")),a(b))})};k.Na=function(a){Qa(this.b,function(b){return b==a})};function Zk(a){this.a=a;this.b=sk()}var $k={name:"pendingRedirect",C:"session"};function al(a){return a.b.set($k,"pending",a.a)}function bl(a){return wk(a.b,$k,a.a)}function cl(a){return a.b.get($k,a.a).then(function(b){return"pending"==b})};function dl(a,b,c){this.i={};this.v=0;this.B=a;this.u=b;this.m=c;this.h=[];this.f=!1;this.l=t(this.o,this);this.b=new el;this.w=new fl;this.g=new Zk(this.u+":"+this.m);this.c={};this.c.unknown=this.b;this.c.signInViaRedirect=this.b;this.c.linkViaRedirect=this.b;this.c.reauthViaRedirect=this.b;this.c.signInViaPopup=this.w;this.c.linkViaPopup=this.w;this.c.reauthViaPopup=this.w;this.a=gl(this.B,this.u,this.m,Wf)}
	function gl(a,b,c,d){var e=firebase.SDK_VERSION||null;return xe()?new Qk(a,b,c,e,d):new wj(a,b,c,e,d)}dl.prototype.reset=function(){this.f=!1;this.a.Na(this.l);this.a=gl(this.B,this.u,this.m);this.i={}};function hl(a){a.f||(a.f=!0,a.a.Aa(a.l));var b=a.a;return a.a.ia().s(function(c){a.a==b&&a.reset();throw c;})}function il(a){a.a.Ob()&&hl(a).s(function(b){var c=new Zg("unknown",null,null,null,new M("operation-not-supported-in-this-environment"));jl(b)&&a.o(c)});a.a.Jb()||kl(a.b)}
	function ll(a,b){Oa(a.h,b)||a.h.push(b);a.f||cl(a.g).then(function(c){c?bl(a.g).then(function(){hl(a).s(function(d){var e=new Zg("unknown",null,null,null,new M("operation-not-supported-in-this-environment"));jl(d)&&a.o(e)})}):il(a)}).s(function(){il(a)})}function ml(a,b){Qa(a.h,function(c){return c==b})}
	dl.prototype.o=function(a){if(!a)throw new M("invalid-auth-event");6E5<=va()-this.v&&(this.i={},this.v=0);if(a&&a.getUid()&&this.i.hasOwnProperty(a.getUid()))return!1;for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.xb(a.c,a.b)){if(b=this.c[a.c])b.h(a,d),a&&(a.f||a.b)&&(this.i[a.getUid()]=!0,this.v=va());b=!0;break}}kl(this.b);return b};var nl=new Qe(2E3,1E4),ol=new Qe(3E4,6E4);dl.prototype.oa=function(){return this.b.oa()};
	function pl(a,b,c,d,e,f,g){return a.a.Db(b,c,d,function(){a.f||(a.f=!0,a.a.Aa(a.l))},function(){a.reset()},e,f,g)}function jl(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
	function ql(a,b,c,d,e){var f;return al(a.g).then(function(){return a.a.Eb(b,c,d,e).s(function(g){if(jl(g))throw new M("operation-not-supported-in-this-environment");f=g;return bl(a.g).then(function(){throw f;})}).then(function(){return a.a.Rb()?new B(function(){}):bl(a.g).then(function(){return a.oa()}).then(function(){}).s(function(){})})})}function rl(a,b,c,d,e){return a.a.Fb(d,function(f){b.ja(c,null,f,e)},nl.get())}var sl={};
	function tl(a,b,c){var d=b+":"+c;sl[d]||(sl[d]=new dl(a,b,c));return sl[d]}function el(){this.b=null;this.f=[];this.c=[];this.a=null;this.i=this.g=!1}el.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
	el.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.c,d=a.b,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;this.i=!(!e&&!f);"unknown"!=c||e||f?a.a?(ul(this,!0,null,a.a),D()):b.Ba(c,d)?vl(this,a,b):E(new M("invalid-auth-event")):(ul(this,!1,null,null),D())}else E(new M("invalid-auth-event"))};function kl(a){a.g||(a.g=!0,ul(a,!1,null,null))}function wl(a){a.g&&!a.i&&ul(a,!1,null,null)}
	function vl(a,b,c){c=c.Ba(b.c,b.b);var d=b.g,e=b.f,f=b.i,g=b.R(),h=!!b.c.match(/Redirect$/);c(d,e,g,f).then(function(m){ul(a,h,m,null)}).s(function(m){ul(a,h,null,m)})}function xl(a,b){a.b=function(){return E(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function yl(a,b){a.b=function(){return D(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function ul(a,b,c,d){b?d?xl(a,d):yl(a,c):yl(a,{user:null});a.f=[];a.c=[]}
	el.prototype.oa=function(){var a=this;return new B(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),zl(a))})};function zl(a){var b=new M("timeout");a.a&&a.a.cancel();a.a=od(ol.get()).then(function(){a.b||(a.g=!0,ul(a,!0,null,b))})}function fl(){}fl.prototype.h=function(a,b){if(a){var c=a.c,d=a.b;a.a?(b.ja(a.c,null,a.a,a.b),D()):b.Ba(c,d)?Al(a,b):E(new M("invalid-auth-event"))}else E(new M("invalid-auth-event"))};
	function Al(a,b){var c=a.b,d=a.c;b.Ba(d,c)(a.g,a.f,a.R(),a.i).then(function(e){b.ja(d,e,null,c)}).s(function(e){b.ja(d,null,e,c)})};function Bl(){this.vb=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.vb},set:function(a){this.vb=a},enumerable:!1})};function Cl(a,b){this.a=b;K(this,"verificationId",a)}Cl.prototype.confirm=function(a){a=Wg(this.verificationId,a);return this.a(a)};function Dl(a,b,c,d){return(new Ug(a)).Wa(b,c).then(function(e){return new Cl(e,d)})};function El(a){var b=Tf(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new M("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");L(this,{token:a,expirationTime:Te(1E3*b.exp),authTime:Te(1E3*b.auth_time),issuedAtTime:Te(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,claims:b})};function Fl(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}Fl.prototype.start=function(){this.a=this.c;Gl(this,!0)};function Hl(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function Gl(a,b){a.stop();a.b=od(Hl(a,b)).then(function(){return Se()}).then(function(){return a.h()}).then(function(){Gl(a,!0)}).s(function(c){a.i(c)&&Gl(a,!1)})}
	Fl.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function Il(a){this.f=a;this.b=this.a=null;this.c=0}Il.prototype.A=function(){return{apiKey:this.f.c,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function Jl(a,b){var c=b[mg],d=b.refreshToken;b=Kl(b.expiresIn);a.b=c;a.c=b;a.a=d}function Ll(a,b){a.b=b.b;a.a=b.a;a.c=b.c}function Kl(a){return va()+1E3*parseInt(a,10)}
	function Ml(a,b){return Ai(a.f,b).then(function(c){a.b=c.access_token;a.c=Kl(c.expires_in);a.a=c.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(c){"auth/user-token-expired"==c.code&&(a.a=null);throw c;})}Il.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?E(new M("user-token-expired")):a||!this.b||va()>this.c-3E4?this.a?Ml(this,{grant_type:"refresh_token",refresh_token:this.a}):D(null):D({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function Nl(a,b){this.a=a||null;this.b=b||null;L(this,{lastSignInTime:Te(b||null),creationTime:Te(a||null)})}function Ol(a){return new Nl(a.a,a.b)}Nl.prototype.A=function(){return{lastLoginAt:this.b,createdAt:this.a}};function Pl(a,b,c,d,e,f){L(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function Ql(a,b){F.call(this,a);for(var c in b)this[c]=b[c]}v(Ql,F);
	function Q(a,b,c){this.I=[];this.l=a.apiKey;this.m=a.appName;this.o=a.authDomain||null;a=firebase.SDK_VERSION?Fe(firebase.SDK_VERSION):null;this.a=new oi(this.l,Vf(Wf),a);this.b=new Il(this.a);Rl(this,b[mg]);Jl(this.b,b);K(this,"refreshToken",this.b.a);Sl(this,c||{});G.call(this);this.J=!1;this.o&&Ie()&&(this.i=tl(this.o,this.l,this.m));this.O=[];this.h=null;this.w=Tl(this);this.W=t(this.Ja,this);var d=this;this.ga=null;this.xa=function(e){d.ua(e.g)};this.Z=null;this.P=[];this.wa=function(e){Ul(d,
	e.c)};this.Y=null}v(Q,G);Q.prototype.ua=function(a){this.ga=a;ui(this.a,a)};Q.prototype.ha=function(){return this.ga};function Vl(a,b){a.Z&&gd(a.Z,"languageCodeChanged",a.xa);(a.Z=b)&&Xc(b,"languageCodeChanged",a.xa)}function Ul(a,b){a.P=b;vi(a.a,firebase.SDK_VERSION?Fe(firebase.SDK_VERSION,a.P):null)}Q.prototype.Ca=function(){return Sa(this.P)};function Wl(a,b){a.Y&&gd(a.Y,"frameworkChanged",a.wa);(a.Y=b)&&Xc(b,"frameworkChanged",a.wa)}Q.prototype.Ja=function(){this.w.b&&(this.w.stop(),this.w.start())};
	function Xl(a){try{return firebase.app(a.m).auth()}catch(b){throw new M("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.m+"'!");}}function Tl(a){return new Fl(function(){return a.G(!0)},function(b){return b&&"auth/network-request-failed"==b.code?!0:!1},function(){var b=a.b.c-va()-3E5;return 0<b?b:0})}function Yl(a){a.B||a.w.b||(a.w.start(),gd(a,"tokenChanged",a.W),Xc(a,"tokenChanged",a.W))}function Zl(a){gd(a,"tokenChanged",a.W);a.w.stop()}
	function Rl(a,b){a.ma=b;K(a,"_lat",b)}function $l(a,b){Qa(a.O,function(c){return c==b})}function am(a){for(var b=[],c=0;c<a.O.length;c++)b.push(a.O[c](a));return cc(b).then(function(){return a})}function bm(a){a.i&&!a.J&&(a.J=!0,ll(a.i,a))}
	function Sl(a,b){L(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,tenantId:b.tenantId||null,metadata:new Nl(b.createdAt,b.lastLoginAt),providerData:[]});a.a.b=a.tenantId}K(Q.prototype,"providerId","firebase");function cm(){}function dm(a){return D().then(function(){if(a.B)throw new M("app-deleted");})}
	function em(a){return Ka(a.providerData,function(b){return b.providerId})}function fm(a,b){b&&(gm(a,b.providerId),a.providerData.push(b))}function gm(a,b){Qa(a.providerData,function(c){return c.providerId==b})}function hm(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&K(a,b,c)}
	function im(a,b){a!=b&&(L(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,tenantId:b.tenantId,providerData:[]}),b.metadata?K(a,"metadata",Ol(b.metadata)):K(a,"metadata",new Nl),x(b.providerData,function(c){fm(a,c)}),Ll(a.b,b.b),K(a,"refreshToken",a.b.a))}k=Q.prototype;k.reload=function(){var a=this;return R(this,dm(this).then(function(){return jm(a).then(function(){return am(a)}).then(cm)}))};
	function jm(a){return a.G().then(function(b){var c=a.isAnonymous;return km(a,b).then(function(){c||hm(a,"isAnonymous",!1);return b})})}k.dc=function(a){return this.G(a).then(function(b){return new El(b)})};k.G=function(a){var b=this;return R(this,dm(this).then(function(){return b.b.getToken(a)}).then(function(c){if(!c)throw new M("internal-error");c.accessToken!=b.ma&&(Rl(b,c.accessToken),b.dispatchEvent(new Ql("tokenChanged")));hm(b,"refreshToken",c.refreshToken);return c.accessToken}))};
	function lm(a,b){b[mg]&&a.ma!=b[mg]&&(Jl(a.b,b),a.dispatchEvent(new Ql("tokenChanged")),Rl(a,b[mg]),hm(a,"refreshToken",a.b.a))}function km(a,b){return P(a.a,hj,{idToken:b}).then(t(a.zc,a))}
	k.zc=function(a){a=a.users;if(!a||!a.length)throw new M("internal-error");a=a[0];Sl(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt,tenantId:a.tenantId});for(var b=mm(a),c=0;c<b.length;c++)fm(this,b[c]);hm(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
	function mm(a){return(a=a.providerUserInfo)&&a.length?Ka(a,function(b){return new Pl(b.rawId,b.providerId,b.email,b.displayName,b.photoUrl,b.phoneNumber)}):[]}k.Ac=function(a){Ye("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.hb(a)};
	k.hb=function(a){var b=this,c=null;return R(this,a.f(this.a,this.uid).then(function(d){lm(b,d);c=nm(b,d,"reauthenticate");b.h=null;return b.reload()}).then(function(){return c}),!0)};function om(a,b){return jm(a).then(function(){if(Oa(em(a),b))return am(a).then(function(){throw new M("provider-already-linked");})})}k.rc=function(a){Ye("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.fb(a)};
	k.fb=function(a){var b=this,c=null;return R(this,om(this,a.providerId).then(function(){return b.G()}).then(function(d){return a.b(b.a,d)}).then(function(d){c=nm(b,d,"link");return pm(b,d)}).then(function(){return c}))};k.sc=function(a,b){var c=this;return R(this,om(this,"phone").then(function(){return Dl(Xl(c),a,b,t(c.fb,c))}))};k.Bc=function(a,b){var c=this;return R(this,D().then(function(){return Dl(Xl(c),a,b,t(c.hb,c))}),!0)};
	function nm(a,b,c){var d=Xg(b);b=ag(b);return af({user:a,credential:d,additionalUserInfo:b,operationType:c})}function pm(a,b){lm(a,b);return a.reload().then(function(){return a})}k.rb=function(a){var b=this;return R(this,this.G().then(function(c){return b.a.rb(c,a)}).then(function(c){lm(b,c);return b.reload()}))};k.Sc=function(a){var b=this;return R(this,this.G().then(function(c){return a.b(b.a,c)}).then(function(c){lm(b,c);return b.reload()}))};
	k.sb=function(a){var b=this;return R(this,this.G().then(function(c){return b.a.sb(c,a)}).then(function(c){lm(b,c);return b.reload()}))};
	k.tb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return dm(this);var b=this;return R(this,this.G().then(function(c){return b.a.tb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(c){lm(b,c);hm(b,"displayName",c.displayName||null);hm(b,"photoURL",c.photoUrl||null);x(b.providerData,function(d){"password"===d.providerId&&(K(d,"displayName",b.displayName),K(d,"photoURL",b.photoURL))});return am(b)}).then(cm))};
	k.Qc=function(a){var b=this;return R(this,jm(this).then(function(c){return Oa(em(b),a)?Ti(b.a,c,[a]).then(function(d){var e={};x(d.providerUserInfo||[],function(f){e[f.providerId]=!0});x(em(b),function(f){e[f]||gm(b,f)});e[Ug.PROVIDER_ID]||K(b,"phoneNumber",null);return am(b)}):am(b).then(function(){throw new M("no-such-provider");})}))};
	k.delete=function(){var a=this;return R(this,this.G().then(function(b){return P(a.a,gj,{idToken:b})}).then(function(){a.dispatchEvent(new Ql("userDeleted"))})).then(function(){for(var b=0;b<a.I.length;b++)a.I[b].cancel("app-deleted");Vl(a,null);Wl(a,null);a.I=[];a.B=!0;Zl(a);K(a,"refreshToken",null);a.i&&ml(a.i,a)})};
	k.xb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.ca||null)==b||"reauthViaRedirect"==a&&(this.ca||null)==b?!0:!1};k.ja=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};
	k.Ba=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?t(this.Bb,this):"reauthViaPopup"==a&&b==(this.g||null)?t(this.Cb,this):"linkViaRedirect"==a&&(this.ca||null)==b?t(this.Bb,this):"reauthViaRedirect"==a&&(this.ca||null)==b?t(this.Cb,this):null};k.tc=function(a){var b=this;return qm(this,"linkViaPopup",a,function(){return om(b,a.providerId).then(function(){return am(b)})},!1)};k.Cc=function(a){return qm(this,"reauthViaPopup",a,function(){return D()},!0)};
	function qm(a,b,c,d,e){if(!Ie())return E(new M("operation-not-supported-in-this-environment"));if(a.h&&!e)return E(a.h);var f=$f(c.providerId),g=He(a.uid+":::"),h=null;(!Ke()||ze())&&a.o&&c.isOAuthProvider&&(h=Cj(a.o,a.l,a.m,b,c,null,g,firebase.SDK_VERSION||null,null,null,a.tenantId));var m=qe(h,f&&f.sa,f&&f.ra);d=d().then(function(){rm(a);if(!e)return a.G().then(function(){})}).then(function(){return pl(a.i,m,b,c,g,!!h,a.tenantId)}).then(function(){return new B(function(p,u){a.ja(b,null,new M("cancelled-popup-request"),
	a.g||null);a.f=p;a.v=u;a.g=g;a.c=rl(a.i,a,b,m,g)})}).then(function(p){m&&pe(m);return p?af(p):null}).s(function(p){m&&pe(m);throw p;});return R(a,d,e)}k.uc=function(a){var b=this;return sm(this,"linkViaRedirect",a,function(){return om(b,a.providerId)},!1)};k.Dc=function(a){return sm(this,"reauthViaRedirect",a,function(){return D()},!0)};
	function sm(a,b,c,d,e){if(!Ie())return E(new M("operation-not-supported-in-this-environment"));if(a.h&&!e)return E(a.h);var f=null,g=He(a.uid+":::");d=d().then(function(){rm(a);if(!e)return a.G().then(function(){})}).then(function(){a.ca=g;return am(a)}).then(function(h){a.da&&(h=a.da,h=h.b.set(tm,a.A(),h.a));return h}).then(function(){return ql(a.i,b,c,g,a.tenantId)}).s(function(h){f=h;if(a.da)return um(a.da);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
	function rm(a){if(!a.i||!a.J){if(a.i&&!a.J)throw new M("internal-error");throw new M("auth-domain-config-required");}}k.Bb=function(a,b,c,d){var e=this;this.c&&(this.c.cancel(),this.c=null);var f=null;c=this.G().then(function(g){return qg(e.a,{requestUri:a,postBody:d,sessionId:b,idToken:g})}).then(function(g){f=nm(e,g,"link");return pm(e,g)}).then(function(){return f});return R(this,c)};
	k.Cb=function(a,b,c,d){var e=this;this.c&&(this.c.cancel(),this.c=null);var f=null,g=D().then(function(){return lg(rg(e.a,{requestUri:a,sessionId:b,postBody:d,tenantId:c}),e.uid)}).then(function(h){f=nm(e,h,"reauthenticate");lm(e,h);e.h=null;return e.reload()}).then(function(){return f});return R(this,g,!0)};
	k.jb=function(a){var b=this,c=null;return R(this,this.G().then(function(d){c=d;return"undefined"===typeof a||Ua(a)?{}:Kf(new Af(a))}).then(function(d){return b.a.jb(c,d)}).then(function(d){if(b.email!=d)return b.reload()}).then(function(){}))};function R(a,b,c){var d=vm(a,b,c);a.I.push(d);d.ka(function(){Pa(a.I,d)});return d}
	function vm(a,b,c){return a.h&&!c?(b.cancel(),E(a.h)):b.s(function(d){!d||"auth/user-disabled"!=d.code&&"auth/user-token-expired"!=d.code||(a.h||a.dispatchEvent(new Ql("userInvalidated")),a.h=d);throw d;})}k.toJSON=function(){return this.A()};
	k.A=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,tenantId:this.tenantId,providerData:[],apiKey:this.l,appName:this.m,authDomain:this.o,stsTokenManager:this.b.A(),redirectEventId:this.ca||null};this.metadata&&Xa(a,this.metadata.A());x(this.providerData,function(b){a.providerData.push(bf(b))});return a};
	function wm(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[mg]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-va())/1E3;else return null;var d=new Q(b,c,a);a.providerData&&x(a.providerData,function(e){e&&fm(d,af(e))});a.redirectEventId&&(d.ca=a.redirectEventId);return d}
	function xm(a,b,c,d){var e=new Q(a,b);c&&(e.da=c);d&&Ul(e,d);return e.reload().then(function(){return e})}function ym(a,b,c,d){b=b||{apiKey:a.l,authDomain:a.o,appName:a.m};var e=a.b,f={};f[mg]=e.b;f.refreshToken=e.a;f.expiresIn=(e.c-va())/1E3;b=new Q(b,f);c&&(b.da=c);d&&Ul(b,d);im(b,a);return b};function zm(a){this.a=a;this.b=sk()}var tm={name:"redirectUser",C:"session"};function um(a){return wk(a.b,tm,a.a)}function Am(a,b){return a.b.get(tm,a.a).then(function(c){c&&b&&(c.authDomain=b);return wm(c||{})})};function Bm(a){this.a=a;this.b=sk();this.c=null;this.f=Cm(this);this.b.addListener(Dm("local"),this.a,t(this.g,this))}Bm.prototype.g=function(){var a=this,b=Dm("local");Em(this,function(){return D().then(function(){return a.c&&"local"!=a.c.C?a.b.get(b,a.a):null}).then(function(c){if(c)return Fm(a,"local").then(function(){a.c=b})})})};function Fm(a,b){var c=[],d;for(d in ok)ok[d]!==b&&c.push(wk(a.b,Dm(ok[d]),a.a));c.push(wk(a.b,Gm,a.a));return bc(c)}
	function Cm(a){var b=Dm("local"),c=Dm("session"),d=Dm("none");return vk(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(f){return f?d:a.b.get(b,a.a).then(function(g){return g?b:a.b.get(Gm,a.a).then(function(h){return h?Dm(h):b})})})}).then(function(e){a.c=e;return Fm(a,e.C)}).s(function(){a.c||(a.c=b)})}var Gm={name:"persistence",C:"session"};function Dm(a){return{name:"authUser",C:a}}
	Bm.prototype.mb=function(a){var b=null,c=this;pk(a);return Em(this,function(){return a!=c.c.C?c.b.get(c.c,c.a).then(function(d){b=d;return Fm(c,a)}).then(function(){c.c=Dm(a);if(b)return c.b.set(c.c,b,c.a)}):D()})};function Hm(a){return Em(a,function(){return a.b.set(Gm,a.c.C,a.a)})}function Im(a,b){return Em(a,function(){return a.b.set(a.c,b.A(),a.a)})}function Jm(a){return Em(a,function(){return wk(a.b,a.c,a.a)})}
	function Km(a,b){return Em(a,function(){return a.b.get(a.c,a.a).then(function(c){c&&b&&(c.authDomain=b);return wm(c||{})})})}function Em(a,b){a.f=a.f.then(b,b);return a.f};function Lm(a){this.l=!1;K(this,"settings",new Bl);K(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=firebase.SDK_VERSION?Fe(firebase.SDK_VERSION):null,this.b=new oi(S(this).options&&S(this).options.apiKey,Vf(Wf),a);else throw new M("invalid-api-key");this.O=[];this.m=[];this.J=[];this.Ub=firebase.INTERNAL.createSubscribe(t(this.oc,this));this.W=void 0;this.Vb=firebase.INTERNAL.createSubscribe(t(this.pc,this));Mm(this,null);this.h=new Bm(S(this).options.apiKey+":"+S(this).name);this.w=
	new zm(S(this).options.apiKey+":"+S(this).name);this.Y=T(this,Nm(this));this.i=T(this,Om(this));this.ga=!1;this.ma=t(this.Nc,this);this.ub=t(this.aa,this);this.wa=t(this.bc,this);this.xa=t(this.mc,this);this.Ja=t(this.nc,this);this.a=null;Pm(this);this.INTERNAL={};this.INTERNAL["delete"]=t(this.delete,this);this.INTERNAL.logFramework=t(this.vc,this);this.o=0;G.call(this);Qm(this);this.I=[]}v(Lm,G);function Rm(a){F.call(this,"languageCodeChanged");this.g=a}v(Rm,F);
	function Sm(a){F.call(this,"frameworkChanged");this.c=a}v(Sm,F);k=Lm.prototype;k.mb=function(a){a=this.h.mb(a);return T(this,a)};k.ua=function(a){this.Z===a||this.l||(this.Z=a,ui(this.b,this.Z),this.dispatchEvent(new Rm(this.ha())))};k.ha=function(){return this.Z};k.Tc=function(){var a=l.navigator;this.ua(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};k.vc=function(a){this.I.push(a);vi(this.b,firebase.SDK_VERSION?Fe(firebase.SDK_VERSION,this.I):null);this.dispatchEvent(new Sm(this.I))};
	k.Ca=function(){return Sa(this.I)};k.nb=function(a){this.P===a||this.l||(this.P=a,this.b.b=this.P)};k.R=function(){return this.P};function Qm(a){Object.defineProperty(a,"lc",{get:function(){return this.ha()},set:function(b){this.ua(b)},enumerable:!1});a.Z=null;Object.defineProperty(a,"ti",{get:function(){return this.R()},set:function(b){this.nb(b)},enumerable:!1});a.P=null}
	k.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).A()}};function Tm(a){return a.Tb||E(new M("auth-domain-config-required"))}function Pm(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&Ie()&&(a.Tb=a.Y.then(function(){if(!a.l){a.a=tl(b,c,S(a).name);ll(a.a,a);U(a)&&bm(U(a));if(a.B){bm(a.B);var d=a.B;d.ua(a.ha());Vl(d,a);d=a.B;Ul(d,a.I);Wl(d,a);a.B=null}return a.a}}))}
	k.xb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};k.ja=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};k.Ba=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?t(this.ac,this):null};
	k.ac=function(a,b,c,d){var e=this;a={requestUri:a,postBody:d,sessionId:b,tenantId:c};this.c&&(this.c.cancel(),this.c=null);var f=null,g=null,h=og(e.b,a).then(function(m){f=Xg(m);g=ag(m);return m});a=e.Y.then(function(){return h}).then(function(m){return Um(e,m)}).then(function(){return af({user:U(e),credential:f,additionalUserInfo:g,operationType:"signIn"})});return T(this,a)};
	k.Lc=function(a){if(!Ie())return E(new M("operation-not-supported-in-this-environment"));var b=this,c=$f(a.providerId),d=He(),e=null;(!Ke()||ze())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Cj(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null,null,null,this.R()));var f=qe(e,c&&c.sa,c&&c.ra);c=Tm(this).then(function(g){return pl(g,f,"signInViaPopup",a,d,!!e,b.R())}).then(function(){return new B(function(g,h){b.ja("signInViaPopup",
	null,new M("cancelled-popup-request"),b.g);b.f=g;b.v=h;b.g=d;b.c=rl(b.a,b,"signInViaPopup",f,d)})}).then(function(g){f&&pe(f);return g?af(g):null}).s(function(g){f&&pe(f);throw g;});return T(this,c)};k.Mc=function(a){if(!Ie())return E(new M("operation-not-supported-in-this-environment"));var b=this,c=Tm(this).then(function(){return Hm(b.h)}).then(function(){return ql(b.a,"signInViaRedirect",a,void 0,b.R())});return T(this,c)};
	function Vm(a){if(!Ie())return E(new M("operation-not-supported-in-this-environment"));var b=Tm(a).then(function(){return a.a.oa()}).then(function(c){return c?af(c):null});return T(a,b)}k.oa=function(){var a=this;return Vm(this).then(function(b){a.a&&wl(a.a.b);return b}).s(function(b){a.a&&wl(a.a.b);throw b;})};
	k.Rc=function(a){if(!a)return E(new M("null-user"));if(this.P!=a.tenantId)return E(new M("tenant-id-mismatch"));var b=this,c={};c.apiKey=S(this).options.apiKey;c.authDomain=S(this).options.authDomain;c.appName=S(this).name;var d=ym(a,c,b.w,b.Ca());return T(this,this.i.then(function(){if(S(b).options.apiKey!=a.l)return d.reload()}).then(function(){if(U(b)&&a.uid==U(b).uid)return im(U(b),a),b.aa(a);Mm(b,d);bm(d);return b.aa(d)}).then(function(){Wm(b)}))};
	function Um(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.Y.then(function(){return xm(c,b,a.w,a.Ca())}).then(function(d){if(U(a)&&d.uid==U(a).uid)return im(U(a),d),a.aa(d);Mm(a,d);bm(d);return a.aa(d)}).then(function(){Wm(a)})}
	function Mm(a,b){U(a)&&($l(U(a),a.ub),gd(U(a),"tokenChanged",a.wa),gd(U(a),"userDeleted",a.xa),gd(U(a),"userInvalidated",a.Ja),Zl(U(a)));b&&(b.O.push(a.ub),Xc(b,"tokenChanged",a.wa),Xc(b,"userDeleted",a.xa),Xc(b,"userInvalidated",a.Ja),0<a.o&&Yl(b));K(a,"currentUser",b);b&&(b.ua(a.ha()),Vl(b,a),Ul(b,a.I),Wl(b,a))}k.pb=function(){var a=this,b=this.i.then(function(){a.a&&wl(a.a.b);if(!U(a))return D();Mm(a,null);return Jm(a.h).then(function(){Wm(a)})});return T(this,b)};
	function Xm(a){var b=Am(a.w,S(a).options.authDomain).then(function(c){if(a.B=c)c.da=a.w;return um(a.w)});return T(a,b)}function Nm(a){var b=S(a).options.authDomain,c=Xm(a).then(function(){return Km(a.h,b)}).then(function(d){return d?(d.da=a.w,a.B&&(a.B.ca||null)==(d.ca||null)?d:d.reload().then(function(){return Im(a.h,d).then(function(){return d})}).s(function(e){return"auth/network-request-failed"==e.code?d:Jm(a.h)})):null}).then(function(d){Mm(a,d||null)});return T(a,c)}
	function Om(a){return a.Y.then(function(){return Vm(a)}).s(function(){}).then(function(){if(!a.l)return a.ma()}).s(function(){}).then(function(){if(!a.l){a.ga=!0;var b=a.h;b.b.addListener(Dm("local"),b.a,a.ma)}})}
	k.Nc=function(){var a=this;return Km(this.h,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return im(U(a),b),U(a).G();if(U(a)||b)Mm(a,b),b&&(bm(b),b.da=a.w),a.a&&ll(a.a,a),Wm(a)}})};k.aa=function(a){return Im(this.h,a)};k.bc=function(){Wm(this);this.aa(U(this))};k.mc=function(){this.pb()};k.nc=function(){this.pb()};
	function Ym(a,b){var c=null,d=null;return T(a,b.then(function(e){c=Xg(e);d=ag(e);return Um(a,e)}).then(function(){return af({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}k.oc=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};k.pc=function(a){var b=this;Zm(this,function(){a.next(U(b))})};k.xc=function(a,b,c){var d=this;this.ga&&Promise.resolve().then(function(){q(a)?a(U(d)):q(a.next)&&a.next(U(d))});return this.Ub(a,b,c)};
	k.wc=function(a,b,c){var d=this;this.ga&&Promise.resolve().then(function(){d.W=d.getUid();q(a)?a(U(d)):q(a.next)&&a.next(U(d))});return this.Vb(a,b,c)};k.cc=function(a){var b=this,c=this.i.then(function(){return U(b)?U(b).G(a).then(function(d){return{accessToken:d}}):null});return T(this,c)};k.Hc=function(a){var b=this;return this.i.then(function(){return Ym(b,P(b.b,jj,{token:a}))}).then(function(c){var d=c.user;hm(d,"isAnonymous",!1);b.aa(d);return c})};
	k.Ic=function(a,b){var c=this;return this.i.then(function(){return Ym(c,P(c.b,Jg,{email:a,password:b}))})};k.Xb=function(a,b){var c=this;return this.i.then(function(){return Ym(c,P(c.b,fj,{email:a,password:b}))})};k.Sa=function(a){var b=this;return this.i.then(function(){return Ym(b,a.na(b.b))})};k.Gc=function(a){Ye("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");return this.Sa(a)};
	k.ob=function(){var a=this;return this.i.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=af({providerId:null,isNewUser:!1});return af({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Ym(a,a.b.ob()).then(function(d){var e=d.user;hm(e,"isAnonymous",!0);a.aa(e);return d})})};function S(a){return a.app}function U(a){return a.currentUser}k.getUid=function(){return U(this)&&U(this).uid||null};function $m(a){return U(a)&&U(a)._lat||null}
	function Wm(a){if(a.ga){for(var b=0;b<a.m.length;b++)if(a.m[b])a.m[b]($m(a));if(a.W!==a.getUid()&&a.J.length)for(a.W=a.getUid(),b=0;b<a.J.length;b++)if(a.J[b])a.J[b]($m(a))}}k.Wb=function(a){this.addAuthTokenListener(a);this.o++;0<this.o&&U(this)&&Yl(U(this))};k.Ec=function(a){var b=this;x(this.m,function(c){c==a&&b.o--});0>this.o&&(this.o=0);0==this.o&&U(this)&&Zl(U(this));this.removeAuthTokenListener(a)};
	k.addAuthTokenListener=function(a){var b=this;this.m.push(a);T(this,this.i.then(function(){b.l||Oa(b.m,a)&&a($m(b))}))};k.removeAuthTokenListener=function(a){Qa(this.m,function(b){return b==a})};function Zm(a,b){a.J.push(b);T(a,a.i.then(function(){!a.l&&Oa(a.J,b)&&a.W!==a.getUid()&&(a.W=a.getUid(),b($m(a)))}))}
	k.delete=function(){this.l=!0;for(var a=0;a<this.O.length;a++)this.O[a].cancel("app-deleted");this.O=[];this.h&&(a=this.h,a.b.removeListener(Dm("local"),a.a,this.ma));this.a&&(ml(this.a,this),wl(this.a.b));return Promise.resolve()};function T(a,b){a.O.push(b);b.ka(function(){Pa(a.O,b)});return b}k.$b=function(a){return T(this,Fi(this.b,a))};k.qc=function(a){return!!Og(a)};
	k.lb=function(a,b){var c=this;return T(this,D().then(function(){var d=new Af(b);if(!d.c)throw new M("argument-error",If+" must be true when sending sign in link to email");return Kf(d)}).then(function(d){return c.b.lb(a,d)}).then(function(){}))};k.Uc=function(a){return this.Ma(a).then(function(b){return b.data.email})};k.ab=function(a,b){return T(this,this.b.ab(a,b).then(function(){}))};k.Ma=function(a){return T(this,this.b.Ma(a).then(function(b){return new ef(b)}))};
	k.Ya=function(a){return T(this,this.b.Ya(a).then(function(){}))};k.kb=function(a,b){var c=this;return T(this,D().then(function(){return"undefined"===typeof b||Ua(b)?{}:Kf(new Af(b))}).then(function(d){return c.b.kb(a,d)}).then(function(){}))};k.Kc=function(a,b){return T(this,Dl(this,a,b,t(this.Sa,this)))};
	k.Jc=function(a,b){var c=this;return T(this,D().then(function(){var d=b||ie(),e=Ng(a,d);d=Og(d);if(!d)throw new M("argument-error","Invalid email link!");if(d.tenantId!==c.R())throw new M("tenant-id-mismatch");return c.Sa(e)}))};function an(){}an.prototype.render=function(){};an.prototype.reset=function(){};an.prototype.getResponse=function(){};an.prototype.execute=function(){};function bn(){this.a={};this.b=1E12}var cn=null;bn.prototype.render=function(a,b){this.a[this.b.toString()]=new dn(a,b);return this.b++};bn.prototype.reset=function(a){var b=en(this,a);a=fn(a);b&&a&&(b.delete(),delete this.a[a])};bn.prototype.getResponse=function(a){return(a=en(this,a))?a.getResponse():null};bn.prototype.execute=function(a){(a=en(this,a))&&a.execute()};function en(a,b){return(b=fn(b))?a.a[b]||null:null}function fn(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
	function dn(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=Wd(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():Xc(this.f,"click",this.i)}dn.prototype.getResponse=function(){gn(this);return this.b};
	dn.prototype.execute=function(){gn(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=De();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};dn.prototype.delete=function(){gn(this);this.g=!0;clearTimeout(this.a);this.a=null;gd(this.f,"click",this.i)};function gn(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function hn(){}hn.prototype.g=function(){cn||(cn=new bn);return D(cn)};hn.prototype.c=function(){};var jn=null;function kn(){this.b=l.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var ln=new Ya(Za,"https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),mn=new Qe(3E4,6E4);
	kn.prototype.g=function(a){var b=this;return new B(function(c,d){var e=setTimeout(function(){d(new M("network-request-failed"))},mn.get());if(!l.grecaptcha||a!==b.f&&!b.b){l[b.a]=function(){if(l.grecaptcha){b.f=a;var g=l.grecaptcha.render;l.grecaptcha.render=function(h,m){h=g(h,m);b.b++;return h};clearTimeout(e);c(l.grecaptcha)}else clearTimeout(e),d(new M("internal-error"));delete l[b.a]};var f=fb(ln,{onload:b.a,hl:a||""});D(hi(f)).s(function(){clearTimeout(e);d(new M("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
	c(l.grecaptcha)})};kn.prototype.c=function(){this.b--};var nn=null;function on(a,b,c,d,e,f,g){K(this,"type","recaptcha");this.c=this.f=null;this.B=!1;this.u=b;this.g=null;g?(jn||(jn=new hn),g=jn):(nn||(nn=new kn),g=nn);this.m=g;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[pn])throw new M("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[qn];if(!l.document)throw new M("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
	if(!Wd(b)||!this.i&&Wd(b).hasChildNodes())throw new M("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.o=new oi(a,f||null,e||null);this.v=d||function(){return null};var h=this;this.l=[];var m=this.a[rn];this.a[rn]=function(u){sn(h,u);if("function"===typeof m)m(u);else if("string"===typeof m){var A=J(m,l);"function"===typeof A&&A(u)}};var p=this.a[tn];this.a[tn]=function(){sn(h,null);if("function"===typeof p)p();else if("string"===typeof p){var u=
	J(p,l);"function"===typeof u&&u()}}}var rn="callback",tn="expired-callback",pn="sitekey",qn="size";function sn(a,b){for(var c=0;c<a.l.length;c++)try{a.l[c](b)}catch(d){}}function un(a,b){Qa(a.l,function(c){return c==b})}function vn(a,b){a.h.push(b);b.ka(function(){Pa(a.h,b)});return b}k=on.prototype;
	k.Da=function(){var a=this;return this.f?this.f:this.f=vn(this,D().then(function(){if(Je()&&!Ae())return ve();throw new M("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.m.g(a.v())}).then(function(b){a.g=b;return P(a.o,ij,{})}).then(function(b){a.a[pn]=b.recaptchaSiteKey}).s(function(b){a.f=null;throw b;}))};
	k.render=function(){wn(this);var a=this;return vn(this,this.Da().then(function(){if(null===a.c){var b=a.u;if(!a.i){var c=Wd(b);b=Zd("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};k.verify=function(){wn(this);var a=this;return vn(this,this.render().then(function(b){return new B(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(f){f&&(un(a,e),c(f))};a.l.push(e);a.i&&a.g.execute(a.c)}})}))};k.reset=function(){wn(this);null!==this.c&&this.g.reset(this.c)};
	function wn(a){if(a.B)throw new M("internal-error","RecaptchaVerifier instance has been destroyed.");}k.clear=function(){wn(this);this.B=!0;this.m.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=Wd(this.u);for(var b;b=a.firstChild;)a.removeChild(b)}};
	function xn(a,b,c){var d=!1;try{this.b=c||firebase.app()}catch(g){throw new M("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new M("invalid-api-key");var e=this,f=null;try{f=this.b.auth().Ca()}catch(g){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(g){}f=firebase.SDK_VERSION?Fe(firebase.SDK_VERSION,f):null;on.call(this,c,a,b,function(){try{var g=e.b.auth().ha()}catch(h){g=
	null}return g},f,Vf(Wf),d)}v(xn,on);function yn(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new M("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].N(c[e])&&!f){b=b[e];if(0>e||e>=zn.length)throw new M("internal-error",
	"Argument validator received an unsupported number of arguments.");c=zn[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.M+".";break a}d=null}}if(d)throw new M("argument-error",a+" failed: "+d);}var zn="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",M:"a valid string",optional:!!b,N:n}}function An(a,b){return{name:a||"",M:"a boolean",optional:!!b,N:ia}}
	function W(a,b){return{name:a||"",M:"a valid object",optional:!!b,N:r}}function Bn(a,b){return{name:a||"",M:"a function",optional:!!b,N:q}}function Cn(a,b){return{name:a||"",M:"null",optional:!!b,N:na}}function Dn(){return{name:"",M:"an HTML element",optional:!1,N:function(a){return!!(a&&a instanceof Element)}}}function En(){return{name:"auth",M:"an instance of Firebase Auth",optional:!0,N:function(a){return!!(a&&a instanceof Lm)}}}
	function Fn(){return{name:"app",M:"an instance of Firebase App",optional:!0,N:function(a){return!!(a&&a instanceof firebase.app.App)}}}function Gn(a){return{name:a?a+"Credential":"credential",M:a?"a valid "+a+" credential":"a valid credential",optional:!1,N:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.na||!c)}}}
	function Hn(){return{name:"authProvider",M:"a valid Auth provider",optional:!1,N:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function In(){return{name:"applicationVerifier",M:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,N:function(a){return!!(a&&n(a.type)&&q(a.verify))}}}function X(a,b,c,d){return{name:c||"",M:a.M+" or "+b.M,optional:!!d,N:function(e){return a.N(e)||b.N(e)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=Jn(d,a[c],b[c].j)}}function Kn(a,b){for(var c in b){var d=b[c].name;d!==c&&Object.defineProperty(a,d,{get:ua(function(e){return this[e]},c),set:ua(function(e,f,g,h){yn(e,[g],[h],!0);this[f]=h},d,c,b[c].Za),enumerable:!0})}}function Z(a,b,c,d){a[b]=Jn(b,c,d)}
	function Jn(a,b,c){function d(){var g=Array.prototype.slice.call(arguments);yn(e,c,g);return b.apply(this,g)}if(!c)return b;var e=Ln(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function Ln(a){a=a.split(".");return a[a.length-1]};Y(Lm.prototype,{Ya:{name:"applyActionCode",j:[V("code")]},Ma:{name:"checkActionCode",j:[V("code")]},ab:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},Xb:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},$b:{name:"fetchSignInMethodsForEmail",j:[V("email")]},oa:{name:"getRedirectResult",j:[]},qc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},wc:{name:"onAuthStateChanged",j:[X(W(),Bn(),"nextOrObserver"),Bn("opt_error",!0),Bn("opt_completed",!0)]},xc:{name:"onIdTokenChanged",
	j:[X(W(),Bn(),"nextOrObserver"),Bn("opt_error",!0),Bn("opt_completed",!0)]},kb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),Cn(null,!0),"opt_actionCodeSettings",!0)]},lb:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},mb:{name:"setPersistence",j:[V("persistence")]},Gc:{name:"signInAndRetrieveDataWithCredential",j:[Gn()]},ob:{name:"signInAnonymously",j:[]},Sa:{name:"signInWithCredential",j:[Gn()]},Hc:{name:"signInWithCustomToken",j:[V("token")]},
	Ic:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Jc:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Kc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),In()]},Lc:{name:"signInWithPopup",j:[Hn()]},Mc:{name:"signInWithRedirect",j:[Hn()]},Rc:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",M:"an instance of Firebase User",optional:!!a,N:function(b){return!!(b&&b instanceof Q)}}}(),Cn(),"user")]},pb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},
	Tc:{name:"useDeviceLanguage",j:[]},Uc:{name:"verifyPasswordResetCode",j:[V("code")]}});Kn(Lm.prototype,{lc:{name:"languageCode",Za:X(V(),Cn(),"languageCode")},ti:{name:"tenantId",Za:X(V(),Cn(),"tenantId")}});Lm.Persistence=ok;Lm.Persistence.LOCAL="local";Lm.Persistence.SESSION="session";Lm.Persistence.NONE="none";
	Y(Q.prototype,{"delete":{name:"delete",j:[]},dc:{name:"getIdTokenResult",j:[An("opt_forceRefresh",!0)]},G:{name:"getIdToken",j:[An("opt_forceRefresh",!0)]},rc:{name:"linkAndRetrieveDataWithCredential",j:[Gn()]},fb:{name:"linkWithCredential",j:[Gn()]},sc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),In()]},tc:{name:"linkWithPopup",j:[Hn()]},uc:{name:"linkWithRedirect",j:[Hn()]},Ac:{name:"reauthenticateAndRetrieveDataWithCredential",j:[Gn()]},hb:{name:"reauthenticateWithCredential",j:[Gn()]},Bc:{name:"reauthenticateWithPhoneNumber",
	j:[V("phoneNumber"),In()]},Cc:{name:"reauthenticateWithPopup",j:[Hn()]},Dc:{name:"reauthenticateWithRedirect",j:[Hn()]},reload:{name:"reload",j:[]},jb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),Cn(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},Qc:{name:"unlink",j:[V("provider")]},rb:{name:"updateEmail",j:[V("email")]},sb:{name:"updatePassword",j:[V("password")]},Sc:{name:"updatePhoneNumber",j:[Gn("phone")]},tb:{name:"updateProfile",j:[W("profile")]}});
	Y(bn.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(an.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(B.prototype,{ka:{name:"finally"},s:{name:"catch"},then:{name:"then"}});Kn(Bl.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",Za:An("appVerificationDisabledForTesting")}});Y(Cl.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});
	Z(kg,"fromJSON",function(a){a=n(a)?JSON.parse(a):a;for(var b,c=[vg,Mg,Tg,sg],d=0;d<c.length;d++)if(b=c[d](a))return b;return null},[X(V(),W(),"json")]);Z(Hg,"credential",function(a,b){return new Gg(a,b)},[V("email"),V("password")]);Y(Gg.prototype,{A:{name:"toJSON",j:[V(null,!0)]}});Y(yg.prototype,{ya:{name:"addScope",j:[V("scope")]},Ga:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(yg,"credential",zg,[X(V(),W(),"token")]);Z(Hg,"credentialWithLink",Ng,[V("email"),V("emailLink")]);
	Y(Ag.prototype,{ya:{name:"addScope",j:[V("scope")]},Ga:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Ag,"credential",Bg,[X(V(),W(),"token")]);Y(Cg.prototype,{ya:{name:"addScope",j:[V("scope")]},Ga:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Cg,"credential",Dg,[X(V(),X(W(),Cn()),"idToken"),X(V(),Cn(),"accessToken",!0)]);Y(Eg.prototype,{Ga:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Eg,"credential",Fg,[X(V(),W(),"token"),V("secret",!0)]);
	Y(O.prototype,{ya:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),X(W(),Cn()),"optionsOrIdToken"),X(V(),Cn(),"accessToken",!0)]},Ga:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Y(tg.prototype,{A:{name:"toJSON",j:[V(null,!0)]}});Y(ng.prototype,{A:{name:"toJSON",j:[V(null,!0)]}});Z(Ug,"credential",Wg,[V("verificationId"),V("verificationCode")]);Y(Ug.prototype,{Wa:{name:"verifyPhoneNumber",j:[V("phoneNumber"),In()]}});
	Y(Pg.prototype,{A:{name:"toJSON",j:[V(null,!0)]}});Y(M.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(eh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(dh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(xn.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});Z(rf,"parseLink",zf,[V("link")]);
	(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerComponent){var a={ActionCodeInfo:{Operation:{EMAIL_SIGNIN:jf,PASSWORD_RESET:"PASSWORD_RESET",RECOVER_EMAIL:"RECOVER_EMAIL",VERIFY_EMAIL:"VERIFY_EMAIL"}},Auth:Lm,AuthCredential:kg,Error:M};Z(a,"EmailAuthProvider",Hg,[]);Z(a,"FacebookAuthProvider",yg,[]);Z(a,"GithubAuthProvider",Ag,[]);Z(a,"GoogleAuthProvider",Cg,[]);Z(a,"TwitterAuthProvider",Eg,[]);Z(a,"OAuthProvider",O,[V("providerId")]);Z(a,"SAMLAuthProvider",
	xg,[V("providerId")]);Z(a,"PhoneAuthProvider",Ug,[En()]);Z(a,"RecaptchaVerifier",xn,[X(V(),Dn(),"recaptchaContainer"),W("recaptchaParameters",!0),Fn()]);Z(a,"ActionCodeURL",rf,[]);firebase.INTERNAL.registerComponent({name:"auth",instanceFactory:function(b){b=b.getProvider("app").getImmediate();return new Lm(b)},multipleInstances:!1,serviceProps:a,instantiationMode:"LAZY",type:"PUBLIC"});firebase.INTERNAL.registerComponent({name:"auth-internal",instanceFactory:function(b){b=b.getProvider("auth").getImmediate();
	return{getUid:t(b.getUid,b),getToken:t(b.cc,b),addAuthTokenListener:t(b.Wb,b),removeAuthTokenListener:t(b.Ec,b)}},multipleInstances:!1,instantiationMode:"LAZY",type:"PRIVATE"});firebase.registerVersion("@firebase/auth","0.13.5");firebase.INTERNAL.extendNamespace({User:Q})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).apply(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
	
	//# sourceMappingURL=auth.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(107));

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(52));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(37));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(39));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(167));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(169));
	
	// Is a vertical scrollbar displayed?
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument.default)(container);
	
	  if (doc.body === container) {
	    return (0, _ownerWindow.default)(doc).innerWidth > doc.documentElement.clientWidth;
	  }
	
	  return container.scrollHeight > container.clientHeight;
	}
	
	function ariaHidden(node, show) {
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function getPaddingRight(node) {
	  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
	}
	
	function ariaHiddenSiblings(container, mountNode, currentNode) {
	  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var show = arguments.length > 4 ? arguments[4] : undefined;
	  var blacklist = [mountNode, currentNode].concat((0, _toConsumableArray2.default)(nodesToExclude));
	  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
	  [].forEach.call(container.children, function (node) {
	    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
	      ariaHidden(node, show);
	    }
	  });
	}
	
	function findIndexOf(containerInfo, callback) {
	  var idx = -1;
	  containerInfo.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	function handleContainer(containerInfo, props) {
	  var restoreStyle = [];
	  var restorePaddings = [];
	  var container = containerInfo.container;
	  var fixedNodes;
	
	  if (!props.disableScrollLock) {
	    if (isOverflowing(container)) {
	      // Compute the size before applying overflow hidden to avoid any scroll jumps.
	      var scrollbarSize = (0, _getScrollbarSize.default)();
	      restoreStyle.push({
	        value: container.style.paddingRight,
	        key: 'padding-right',
	        el: container
	      }); // Use computed style, here to get the real padding to add our scrollbar width.
	
	      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
	
	      fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	      [].forEach.call(fixedNodes, function (node) {
	        restorePaddings.push(node.style.paddingRight);
	        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
	      });
	    } // Improve Gatsby support
	    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
	
	
	    var parent = container.parentElement;
	    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
	    // screensize shrink.
	
	    restoreStyle.push({
	      value: scrollContainer.style.overflow,
	      key: 'overflow',
	      el: scrollContainer
	    });
	    scrollContainer.style.overflow = 'hidden';
	  }
	
	  var restore = function restore() {
	    if (fixedNodes) {
	      [].forEach.call(fixedNodes, function (node, i) {
	        if (restorePaddings[i]) {
	          node.style.paddingRight = restorePaddings[i];
	        } else {
	          node.style.removeProperty('padding-right');
	        }
	      });
	    }
	
	    restoreStyle.forEach(function (_ref) {
	      var value = _ref.value,
	          el = _ref.el,
	          key = _ref.key;
	
	      if (value) {
	        el.style.setProperty(key, value);
	      } else {
	        el.style.removeProperty(key);
	      }
	    });
	  };
	
	  return restore;
	}
	
	function getHiddenSiblings(container) {
	  var hiddenSiblings = [];
	  [].forEach.call(container.children, function (node) {
	    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	      hiddenSiblings.push(node);
	    }
	  });
	  return hiddenSiblings;
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state management for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class.
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	
	var ModalManager =
	/*#__PURE__*/
	function () {
	  function ModalManager() {
	    (0, _classCallCheck2.default)(this, ModalManager);
	    // this.modals[modalIndex] = modal
	    this.modals = []; // this.containers[containerIndex] = {
	    //   modals: [],
	    //   container,
	    //   restore: null,
	    // }
	
	    this.containers = [];
	  }
	
	  (0, _createClass2.default)(ModalManager, [{
	    key: "add",
	    value: function add(modal, container) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex !== -1) {
	        return modalIndex;
	      }
	
	      modalIndex = this.modals.length;
	      this.modals.push(modal); // If the modal we are adding is already in the DOM.
	
	      if (modal.modalRef) {
	        ariaHidden(modal.modalRef, false);
	      }
	
	      var hiddenSiblingNodes = getHiddenSiblings(container);
	      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.container === container;
	      });
	
	      if (containerIndex !== -1) {
	        this.containers[containerIndex].modals.push(modal);
	        return modalIndex;
	      }
	
	      this.containers.push({
	        modals: [modal],
	        container: container,
	        restore: null,
	        hiddenSiblingNodes: hiddenSiblingNodes
	      });
	      return modalIndex;
	    }
	  }, {
	    key: "mount",
	    value: function mount(modal, props) {
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	
	      if (!containerInfo.restore) {
	        containerInfo.restore = handleContainer(containerInfo, props);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(modal) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex === -1) {
	        return modalIndex;
	      }
	
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
	      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
	
	      if (containerInfo.modals.length === 0) {
	        // The modal might be closed before it had the chance to be mounted in the DOM.
	        if (containerInfo.restore) {
	          containerInfo.restore();
	        }
	
	        if (modal.modalRef) {
	          // In case the modal wasn't in the DOM yet.
	          ariaHidden(modal.modalRef, true);
	        }
	
	        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
	        this.containers.splice(containerIndex, 1);
	      } else {
	        // Otherwise make sure the next top modal is visible to a screen reader.
	        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
	        // aria-hidden because the dom element doesn't exist either
	        // when modal was unmounted before modalRef gets null
	
	        if (nextTop.modalRef) {
	          ariaHidden(nextTop.modalRef, false);
	        }
	      }
	
	      return modalIndex;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal(modal) {
	      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	  return ModalManager;
	}();
	
	exports.default = ModalManager;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(26));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(6);
	
	var _createBreakpoints = _interopRequireDefault(__webpack_require__(150));
	
	var _createMixins = _interopRequireDefault(__webpack_require__(151));
	
	var _createPalette = _interopRequireDefault(__webpack_require__(152));
	
	var _createTypography = _interopRequireDefault(__webpack_require__(155));
	
	var _shadows = _interopRequireDefault(__webpack_require__(160));
	
	var _shape = _interopRequireDefault(__webpack_require__(161));
	
	var _createSpacing = _interopRequireDefault(__webpack_require__(153));
	
	var _transitions = _interopRequireDefault(__webpack_require__(22));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(63));
	
	function createMuiTheme() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
	      _options$mixins = options.mixins,
	      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
	      _options$palette = options.palette,
	      paletteInput = _options$palette === void 0 ? {} : _options$palette,
	      spacingInput = options.spacing,
	      _options$typography = options.typography,
	      typographyInput = _options$typography === void 0 ? {} : _options$typography,
	      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
	  var palette = (0, _createPalette.default)(paletteInput);
	  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
	  var spacing = (0, _createSpacing.default)(spacingInput);
	  var muiTheme = (0, _utils.deepmerge)({
	    breakpoints: breakpoints,
	    direction: 'ltr',
	    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
	    overrides: {},
	    // Inject custom styles
	    palette: palette,
	    props: {},
	    // Provide default props
	    shadows: _shadows.default,
	    typography: (0, _createTypography.default)(palette, typographyInput),
	    spacing: spacing,
	    shape: _shape.default,
	    transitions: _transitions.default,
	    zIndex: _zIndex.default
	  }, other);
	
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = args.reduce(function (acc, argument) {
	    return (0, _utils.deepmerge)(acc, argument);
	  }, muiTheme);
	
	  if (false) {
	    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];
	
	    var traverse = function traverse(node, parentKey) {
	      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax
	
	      for (key in node) {
	        var child = node[key];
	
	        if (depth === 1) {
	          if (key.indexOf('Mui') === 0 && child) {
	            traverse(child, key, depth + 1);
	          }
	        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
	          if (process.env.NODE_ENV !== 'production') {
	            console.error(["Material-UI: the `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
	              root: (0, _defineProperty2.default)({}, "&$".concat(key), child)
	            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
	          } // Remove the style to prevent global conflicts.
	
	
	          node[key] = {};
	        }
	      }
	    };
	
	    traverse(muiTheme.overrides);
	  }
	
	  return muiTheme;
	}
	
	var _default = createMuiTheme;
	exports.default = _default;

/***/ },
/* 63 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We need to centralize the zIndex definitions as they work
	// like global values in the browser.
	var zIndex = {
	  mobileStepper: 1000,
	  speedDial: 1050,
	  appBar: 1100,
	  drawer: 1200,
	  modal: 1300,
	  snackbar: 1400,
	  tooltip: 1500
	};
	var _default = zIndex;
	exports.default = _default;

/***/ },
/* 64 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
	    delay: style.transitionDelay
	  };
	}

/***/ },
/* 65 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRef;
	
	// TODO v5: make it private
	function setRef(ref, value) {
	  if (typeof ref === 'function') {
	    ref(value);
	  } else if (ref) {
	    ref.current = value;
	  }
	}

/***/ },
/* 66 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	
	var _default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';
	
	exports.default = _default;

/***/ },
/* 67 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We use the same empty object to ref count the styles that don't need a theme object.
	var noopTheme = {};
	var _default = noopTheme;
	exports.default = _default;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(182));

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(183));

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(187));

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var ThemeContext = _react.default.createContext(null);
	
	if (false) {
	  ThemeContext.displayName = 'ThemeContext';
	}
	
	var _default = ThemeContext;
	exports.default = _default;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _app = __webpack_require__(73);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(74);
	
	var _StyledFirebaseAuth = __webpack_require__(249);
	
	var _StyledFirebaseAuth2 = _interopRequireDefault(_StyledFirebaseAuth);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _app3 = __webpack_require__(228);
	
	var _app4 = _interopRequireDefault(_app3);
	
	var _fireBaseContext = __webpack_require__(34);
	
	var _fireBaseContext2 = _interopRequireDefault(_fireBaseContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // React core.
	
	
	// Firebase.
	
	
	// Styles
	// This uses CSS modules.
	
	// Context
	
	
	var $ = window;
	var postMessageProxy = function postMessageProxy(message) {
	  if ($.ReactNativeWebView !== undefined) {
	    setTimeout(function () {
	      $.ReactNativeWebView.postMessage(message);
	    }, 0);
	  }
	};
	
	var Auth = function (_BaseComponent) {
	  _inherits(Auth, _BaseComponent);
	
	  function Auth() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Auth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Auth.__proto__ || Object.getPrototypeOf(Auth)).call.apply(_ref, [this].concat(args))), _this), _this.uiConfig = {
	      signInFlow: 'popup',
	      'signInOptions': [
	      // The Provider you need for your app. We need the Phone Auth
	      _app2.default.auth.EmailAuthProvider.PROVIDER_ID, {
	        provider: _app2.default.auth.FacebookAuthProvider.PROVIDER_ID
	
	      }, {
	        provider: _app2.default.auth.PhoneAuthProvider.PROVIDER_ID,
	        requireDisplayName: true,
	        recaptchaParameters: {
	          type: 'image', // another option is 'audio'
	          size: 'invisible', // other options are 'normal' or 'compact'
	          badge: 'bottomleft' // 'bottomright' or 'inline' applies to invisible.
	        }
	      }],
	      callbacks: {
	        signInSuccessWithAuthResult: function signInSuccessWithAuthResult() {
	          return false;
	        }
	      }
	    }, _this.state = {
	      isSignedIn: undefined
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Auth, [{
	    key: 'componentDidMount',
	
	
	    /**
	     * @inheritDoc
	     */
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.unregisterAuthObserver = this.context.firebase.auth().onAuthStateChanged(function (user) {
	        if (user !== undefined && user !== null) {
	          _this2.context.firebase.firestore().collection("users").doc(user.uid).set({ UserId: user.uid });
	        }
	        _this2.setState({ isSignedIn: !!user });
	      });
	    }
	
	    /**
	     * @inheritDoc
	     */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unregisterAuthObserver();
	    }
	
	    /**
	     * @inheritDoc
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: _app4.default.container },
	        this.state.isSignedIn !== undefined && !this.state.isSignedIn && _react2.default.createElement(
	          'div',
	          { style: this.globs.GetVar("mode") === "select" ? { marginTop: 150 } : {} },
	          this.globs.GetVar("mode") !== "select" && _react2.default.createElement(
	            'div',
	            { className: 'center' },
	            _react2.default.createElement('img', Object.assign({ id: 'mainFish', style: { marginTop: 5, width: "100%" }, src: '/images/content/login/Fish-Home.png', alt: 'Main Fish' }, this.globs.touchAndClick(function (e) {
	              postMessageProxy("qr");
	            })))
	          ),
	          _react2.default.createElement(_StyledFirebaseAuth2.default, { className: _app4.default.firebaseUi, uiConfig: this.uiConfig,
	            firebaseAuth: this.context.firebase.auth() })
	        )
	      );
	    }
	  }]);
	
	  return Auth;
	}(_base2.default);
	
	Auth.contextType = _fireBaseContext2.default;
	exports.default = Auth;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	
	var name = "firebase";
	var version = "7.8.2";
	
	/**
	 * @license
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	firebase.registerVersion(name, version, 'app');
	
	module.exports = firebase;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(59);
	
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(232);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = global || self, factory(global.idb = {}));
	}(this, function (exports) { 'use strict';
	
	  function toArray(arr) {
	    return Array.prototype.slice.call(arr);
	  }
	
	  function promisifyRequest(request) {
	    return new Promise(function(resolve, reject) {
	      request.onsuccess = function() {
	        resolve(request.result);
	      };
	
	      request.onerror = function() {
	        reject(request.error);
	      };
	    });
	  }
	
	  function promisifyRequestCall(obj, method, args) {
	    var request;
	    var p = new Promise(function(resolve, reject) {
	      request = obj[method].apply(obj, args);
	      promisifyRequest(request).then(resolve, reject);
	    });
	
	    p.request = request;
	    return p;
	  }
	
	  function promisifyCursorRequestCall(obj, method, args) {
	    var p = promisifyRequestCall(obj, method, args);
	    return p.then(function(value) {
	      if (!value) return;
	      return new Cursor(value, p.request);
	    });
	  }
	
	  function proxyProperties(ProxyClass, targetProp, properties) {
	    properties.forEach(function(prop) {
	      Object.defineProperty(ProxyClass.prototype, prop, {
	        get: function() {
	          return this[targetProp][prop];
	        },
	        set: function(val) {
	          this[targetProp][prop] = val;
	        }
	      });
	    });
	  }
	
	  function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
	    properties.forEach(function(prop) {
	      if (!(prop in Constructor.prototype)) return;
	      ProxyClass.prototype[prop] = function() {
	        return promisifyRequestCall(this[targetProp], prop, arguments);
	      };
	    });
	  }
	
	  function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
	    properties.forEach(function(prop) {
	      if (!(prop in Constructor.prototype)) return;
	      ProxyClass.prototype[prop] = function() {
	        return this[targetProp][prop].apply(this[targetProp], arguments);
	      };
	    });
	  }
	
	  function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
	    properties.forEach(function(prop) {
	      if (!(prop in Constructor.prototype)) return;
	      ProxyClass.prototype[prop] = function() {
	        return promisifyCursorRequestCall(this[targetProp], prop, arguments);
	      };
	    });
	  }
	
	  function Index(index) {
	    this._index = index;
	  }
	
	  proxyProperties(Index, '_index', [
	    'name',
	    'keyPath',
	    'multiEntry',
	    'unique'
	  ]);
	
	  proxyRequestMethods(Index, '_index', IDBIndex, [
	    'get',
	    'getKey',
	    'getAll',
	    'getAllKeys',
	    'count'
	  ]);
	
	  proxyCursorRequestMethods(Index, '_index', IDBIndex, [
	    'openCursor',
	    'openKeyCursor'
	  ]);
	
	  function Cursor(cursor, request) {
	    this._cursor = cursor;
	    this._request = request;
	  }
	
	  proxyProperties(Cursor, '_cursor', [
	    'direction',
	    'key',
	    'primaryKey',
	    'value'
	  ]);
	
	  proxyRequestMethods(Cursor, '_cursor', IDBCursor, [
	    'update',
	    'delete'
	  ]);
	
	  // proxy 'next' methods
	  ['advance', 'continue', 'continuePrimaryKey'].forEach(function(methodName) {
	    if (!(methodName in IDBCursor.prototype)) return;
	    Cursor.prototype[methodName] = function() {
	      var cursor = this;
	      var args = arguments;
	      return Promise.resolve().then(function() {
	        cursor._cursor[methodName].apply(cursor._cursor, args);
	        return promisifyRequest(cursor._request).then(function(value) {
	          if (!value) return;
	          return new Cursor(value, cursor._request);
	        });
	      });
	    };
	  });
	
	  function ObjectStore(store) {
	    this._store = store;
	  }
	
	  ObjectStore.prototype.createIndex = function() {
	    return new Index(this._store.createIndex.apply(this._store, arguments));
	  };
	
	  ObjectStore.prototype.index = function() {
	    return new Index(this._store.index.apply(this._store, arguments));
	  };
	
	  proxyProperties(ObjectStore, '_store', [
	    'name',
	    'keyPath',
	    'indexNames',
	    'autoIncrement'
	  ]);
	
	  proxyRequestMethods(ObjectStore, '_store', IDBObjectStore, [
	    'put',
	    'add',
	    'delete',
	    'clear',
	    'get',
	    'getAll',
	    'getKey',
	    'getAllKeys',
	    'count'
	  ]);
	
	  proxyCursorRequestMethods(ObjectStore, '_store', IDBObjectStore, [
	    'openCursor',
	    'openKeyCursor'
	  ]);
	
	  proxyMethods(ObjectStore, '_store', IDBObjectStore, [
	    'deleteIndex'
	  ]);
	
	  function Transaction(idbTransaction) {
	    this._tx = idbTransaction;
	    this.complete = new Promise(function(resolve, reject) {
	      idbTransaction.oncomplete = function() {
	        resolve();
	      };
	      idbTransaction.onerror = function() {
	        reject(idbTransaction.error);
	      };
	      idbTransaction.onabort = function() {
	        reject(idbTransaction.error);
	      };
	    });
	  }
	
	  Transaction.prototype.objectStore = function() {
	    return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
	  };
	
	  proxyProperties(Transaction, '_tx', [
	    'objectStoreNames',
	    'mode'
	  ]);
	
	  proxyMethods(Transaction, '_tx', IDBTransaction, [
	    'abort'
	  ]);
	
	  function UpgradeDB(db, oldVersion, transaction) {
	    this._db = db;
	    this.oldVersion = oldVersion;
	    this.transaction = new Transaction(transaction);
	  }
	
	  UpgradeDB.prototype.createObjectStore = function() {
	    return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
	  };
	
	  proxyProperties(UpgradeDB, '_db', [
	    'name',
	    'version',
	    'objectStoreNames'
	  ]);
	
	  proxyMethods(UpgradeDB, '_db', IDBDatabase, [
	    'deleteObjectStore',
	    'close'
	  ]);
	
	  function DB(db) {
	    this._db = db;
	  }
	
	  DB.prototype.transaction = function() {
	    return new Transaction(this._db.transaction.apply(this._db, arguments));
	  };
	
	  proxyProperties(DB, '_db', [
	    'name',
	    'version',
	    'objectStoreNames'
	  ]);
	
	  proxyMethods(DB, '_db', IDBDatabase, [
	    'close'
	  ]);
	
	  // Add cursor iterators
	  // TODO: remove this once browsers do the right thing with promises
	  ['openCursor', 'openKeyCursor'].forEach(function(funcName) {
	    [ObjectStore, Index].forEach(function(Constructor) {
	      // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
	      if (!(funcName in Constructor.prototype)) return;
	
	      Constructor.prototype[funcName.replace('open', 'iterate')] = function() {
	        var args = toArray(arguments);
	        var callback = args[args.length - 1];
	        var nativeObject = this._store || this._index;
	        var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
	        request.onsuccess = function() {
	          callback(request.result);
	        };
	      };
	    });
	  });
	
	  // polyfill getAll
	  [Index, ObjectStore].forEach(function(Constructor) {
	    if (Constructor.prototype.getAll) return;
	    Constructor.prototype.getAll = function(query, count) {
	      var instance = this;
	      var items = [];
	
	      return new Promise(function(resolve) {
	        instance.iterateCursor(query, function(cursor) {
	          if (!cursor) {
	            resolve(items);
	            return;
	          }
	          items.push(cursor.value);
	
	          if (count !== undefined && items.length == count) {
	            resolve(items);
	            return;
	          }
	          cursor.continue();
	        });
	      });
	    };
	  });
	
	  function openDb(name, version, upgradeCallback) {
	    var p = promisifyRequestCall(indexedDB, 'open', [name, version]);
	    var request = p.request;
	
	    if (request) {
	      request.onupgradeneeded = function(event) {
	        if (upgradeCallback) {
	          upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
	        }
	      };
	    }
	
	    return p.then(function(db) {
	      return new DB(db);
	    });
	  }
	
	  function deleteDb(name) {
	    return promisifyRequestCall(indexedDB, 'deleteDatabase', [name]);
	  }
	
	  exports.openDb = openDb;
	  exports.deleteDb = deleteDb;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 77 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(202);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(48));
	
	var _ChildMapping = __webpack_require__(266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, _react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 80 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _styledComponents = _interopRequireWildcard(__webpack_require__(275));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _templateObject2() {
	  var data = _taggedTemplateLiteral(["\n    animation-name: ", ";\n    animation-duration: ", "ms;\n    animation-iteration-count: ", ";\n    display: 'inline-block';\n    transform-origin: ", ";\n\n    &", " {\n      animation-name: ", ";\n      animation-play-state: ", ";\n      animation: ", ";\n    }\n\n    animation-play-state: ", ";\n  "]);
	
	  _templateObject2 = function _templateObject2() {
	    return data;
	  };
	
	  return data;
	}
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["", ""]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Shake = function Shake(_ref) {
	  var _ref$h = _ref.h,
	      h = _ref$h === void 0 ? 5 : _ref$h,
	      _ref$v = _ref.v,
	      v = _ref$v === void 0 ? 5 : _ref$v,
	      _ref$r = _ref.r,
	      r = _ref$r === void 0 ? 3 : _ref$r,
	      _ref$dur = _ref.dur,
	      dur = _ref$dur === void 0 ? 300 : _ref$dur,
	      _ref$q = _ref.q,
	      q = _ref$q === void 0 ? 'infinite' : _ref$q,
	      _ref$tf = _ref.tf,
	      tf = _ref$tf === void 0 ? 'ease-in-out' : _ref$tf,
	      _ref$int = _ref["int"],
	      _int = _ref$int === void 0 ? 10 : _ref$int,
	      _ref$max = _ref.max,
	      max = _ref$max === void 0 ? 100 : _ref$max,
	      _ref$orig = _ref.orig,
	      orig = _ref$orig === void 0 ? 'center center' : _ref$orig,
	      _ref$fixed = _ref.fixed,
	      fixed = _ref$fixed === void 0 ? false : _ref$fixed,
	      _ref$freez = _ref.freez,
	      freez = _ref$freez === void 0 ? false : _ref$freez,
	      _ref$active = _ref.active,
	      active = _ref$active === void 0 ? true : _ref$active,
	      _ref$trigger = _ref.trigger,
	      trigger = _ref$trigger === void 0 ? ':hover' : _ref$trigger,
	      _ref$fixedStop = _ref.fixedStop,
	      fixedStop = _ref$fixedStop === void 0 ? false : _ref$fixedStop,
	      _ref$elem = _ref.elem,
	      elem = _ref$elem === void 0 ? 'div' : _ref$elem,
	      props = _objectWithoutProperties(_ref, ["h", "v", "r", "dur", "q", "tf", "int", "max", "orig", "fixed", "freez", "active", "trigger", "fixedStop", "elem"]);
	
	  var random = function random(max) {
	    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return Math.random() * (max - min) - max / 2;
	  };
	
	  var doKeyframes = function doKeyframes() {
	    // el objecto que iremos llenando
	    var kf = {};
	    var init = 'translate(0,0) rotate(0)'; // loop con intervalos basados en `int`
	
	    for (var st = _int; st <= max; st += _int) {
	      // Numeros aleatorios en cada keyframe
	      var x = random(h);
	      var y = random(v);
	      var rot = random(r);
	      kf["".concat(st, "%")] = {
	        transform: "translate(".concat(x, "px, ").concat(y, "px) rotate(").concat(rot, "deg)")
	      };
	    } // Init de las transformaciones en 0% y 100%
	
	
	    kf["0%"] = kf["".concat(Math.min(max, 100), "%")] = {
	      transform: init
	    };
	    return kf;
	  }; // Creamos los `@keyframes`
	
	
	  var kf = doKeyframes();
	
	  var toString = function toString(obj) {
	    return Object.keys(obj).reduce(function (acc, next) {
	      return "".concat(acc, "\n\t\t\t").concat(next, " {\n\t\t\t\ttransform: ").concat(obj[next].transform, "\n\t\t\t}");
	    }, '');
	  };
	
	  var shakeKeyframes = (0, _styledComponents.keyframes)(_templateObject(), toString(kf));
	  var shouldShakeDefault = fixed || !fixed && freez;
	  var shouldShakeWhenTriggered = !fixed && !freez;
	
	  var ShakeComp = _styledComponents["default"][elem](_templateObject2(), shouldShakeDefault && shakeKeyframes, dur, q, orig, trigger, shouldShakeWhenTriggered && shakeKeyframes, freez && (!fixed ? 'running' : 'paused'), fixed && fixedStop && 'initial', active ? freez && !fixed ? 'paused' : 'running' : 'paused');
	
	  return _react["default"].createElement(ShakeComp, props, props.children);
	};
	
	var _default = Shake;
	exports["default"] = _default;

/***/ },
/* 83 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var shakes = {
	  little: {
	    h: 2,
	    v: 2,
	    r: 2
	  },
	  slow: {
	    h: 20,
	    v: 20,
	    r: 7,
	    dur: 5000
	  },
	  hard: {
	    h: 20,
	    v: 20,
	    r: 7
	  },
	  horizontal: {
	    h: 20,
	    v: 0,
	    r: 0
	  },
	  vertical: {
	    h: 0,
	    v: 20,
	    r: 0
	  },
	  rotate: {
	    h: 0,
	    v: 0,
	    r: 15
	  },
	  crazy: {
	    h: 40,
	    v: 40,
	    r: 20,
	    dur: 100,
	    "int": .1
	  }
	};
	var _default = shakes;
	exports["default"] = _default;

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 85 */
/***/ function(module, exports) {

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  }
	}
	
	module.exports = _arrayWithoutHoles;

/***/ },
/* 86 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 87 */
/***/ function(module, exports) {

	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	module.exports = _iterableToArray;

/***/ },
/* 88 */
/***/ function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	module.exports = _nonIterableSpread;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(56);
	var Stylis = _interopDefault(__webpack_require__(57));
	__webpack_require__(95);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case -1:
	          {
	            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
	            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
	
	            if (unsafePseudoClasses && cache.compat !== true) {
	              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
	                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
	                var ignore = ignoreRegExp.test(content);
	
	                if (unsafePseudoClass && !ignore) {
	                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
	                }
	              });
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _inheritsLoose = _interopDefault(__webpack_require__(38));
	var React = __webpack_require__(2);
	var createCache = _interopDefault(__webpack_require__(89));
	var utils = __webpack_require__(94);
	var serialize = __webpack_require__(55);
	var sheet = __webpack_require__(56);
	var css = _interopDefault(__webpack_require__(91));
	
	var EmotionCacheContext = React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
	// because this module is primarily intended for the browser and node
	// but it's also required in react native and similar environments sometimes
	// and we could have a special build just for that
	// but this is much easier and the native packages
	// might use a different theme context in the future anyway
	typeof HTMLElement !== 'undefined' ? createCache() : null);
	var ThemeContext = React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	exports.withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return React.forwardRef(render);
	};
	
	// thus we only need to replace what is a valid character for JS, but not for CSS
	
	var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
	  return identifier.replace(/\$/g, '-');
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var render = function render(cache, props, theme, ref) {
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  var type = props[typePropName];
	  var registeredStyles = [cssProp];
	  var className = '';
	
	  if (typeof props.className === 'string') {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  } else if (props.className != null) {
	    className = props.className + " ";
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = React.createElement(type, newProps);
	
	  return ele;
	};
	
	var Emotion =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache, ref) {
	  // use Context.read for the theme when it's stable
	  if (typeof props.css === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	} // $FlowFixMe
	
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || !hasOwnProperty.call(props, 'css')) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = Emotion;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type;
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = sanitizeIdentifier(match[1]);
	      }
	    }
	  }
	
	  createElementArgArray[1] = newProps;
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css.apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var ClassNames = exports.withEmotionCache(function (props, context) {
	  return React.createElement(ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.css = css;
	exports.CacheProvider = CacheProvider;
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.ThemeContext = ThemeContext;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var serialize = __webpack_require__(55);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(54));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
	
	var index = memoize(function (prop) {
	  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
	  /* o */
	  && prop.charCodeAt(1) === 110
	  /* n */
	  && prop.charCodeAt(2) < 91;
	}
	/* Z+1 */
	);
	
	exports.default = index;


/***/ },
/* 93 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// Inspired by https://github.com/garycourt/murmurhash-js
	// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
	function murmur2(str) {
	  // 'm' and 'r' are mixing constants generated offline.
	  // They're not really 'magic', they just happen to work well.
	  // const m = 0x5bd1e995;
	  // const r = 24;
	  // Initialize the hash
	  var h = 0; // Mix 4 bytes at a time into the hash
	
	  var k,
	      i = 0,
	      len = str.length;
	
	  for (; len >= 4; ++i, len -= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k =
	    /* Math.imul(k, m): */
	    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
	    k ^=
	    /* k >>> r: */
	    k >>> 24;
	    h =
	    /* Math.imul(k, m): */
	    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
	    /* Math.imul(h, m): */
	    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  } // Handle the last few bytes of the input array
	
	
	  switch (len) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h =
	      /* Math.imul(h, m): */
	      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  } // Do a few final mixes of the hash to ensure the last few
	  // bytes are well-incorporated.
	
	
	  h ^= h >>> 13;
	  h =
	  /* Math.imul(h, m): */
	  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  return ((h ^ h >>> 15) >>> 0).toString(36);
	}
	
	exports.default = murmur2;


/***/ },
/* 94 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ },
/* 95 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	__webpack_require__(28);
	var tslib = __webpack_require__(11);
	var util = __webpack_require__(14);
	var component = __webpack_require__(12);
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ANALYTICS_ID_FIELD = 'measurementId';
	// Key to attach FID to in gtag params.
	var GA_FID_KEY = 'firebase_id';
	var ORIGIN_KEY = 'origin';
	var GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
	var GtagCommand;
	(function (GtagCommand) {
	    GtagCommand["EVENT"] = "event";
	    GtagCommand["SET"] = "set";
	    GtagCommand["CONFIG"] = "config";
	})(GtagCommand || (GtagCommand = {}));
	/*
	 * Officially recommended event names for gtag.js
	 * Any other string is also allowed.
	 */
	var EventName;
	(function (EventName) {
	    EventName["ADD_PAYMENT_INFO"] = "add_payment_info";
	    EventName["ADD_TO_CART"] = "add_to_cart";
	    EventName["ADD_TO_WISHLIST"] = "add_to_wishlist";
	    EventName["BEGIN_CHECKOUT"] = "begin_checkout";
	    EventName["CHECKOUT_PROGRESS"] = "checkout_progress";
	    EventName["EXCEPTION"] = "exception";
	    EventName["GENERATE_LEAD"] = "generate_lead";
	    EventName["LOGIN"] = "login";
	    EventName["PAGE_VIEW"] = "page_view";
	    EventName["PURCHASE"] = "purchase";
	    EventName["REFUND"] = "refund";
	    EventName["REMOVE_FROM_CART"] = "remove_from_cart";
	    EventName["SCREEN_VIEW"] = "screen_view";
	    EventName["SEARCH"] = "search";
	    EventName["SELECT_CONTENT"] = "select_content";
	    EventName["SET_CHECKOUT_OPTION"] = "set_checkout_option";
	    EventName["SHARE"] = "share";
	    EventName["SIGN_UP"] = "sign_up";
	    EventName["TIMING_COMPLETE"] = "timing_complete";
	    EventName["VIEW_ITEM"] = "view_item";
	    EventName["VIEW_ITEM_LIST"] = "view_item_list";
	    EventName["VIEW_PROMOTION"] = "view_promotion";
	    EventName["VIEW_SEARCH_RESULTS"] = "view_search_results";
	})(EventName || (EventName = {}));
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Logs an analytics event through the Firebase SDK.
	 *
	 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
	 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
	 * @param eventParams Analytics event parameters.
	 */
	function logEvent(gtagFunction, analyticsId, eventName, eventParams, options) {
	    var params = eventParams || {};
	    if (!options || !options.global) {
	        params = tslib.__assign(tslib.__assign({}, eventParams), { 'send_to': analyticsId });
	    }
	    // Workaround for http://b/141370449 - third argument cannot be undefined.
	    gtagFunction(GtagCommand.EVENT, eventName, params || {});
	}
	// TODO: Brad is going to add `screen_name` to GA Gold config parameter schema
	/**
	 * Set screen_name parameter for this Google Analytics ID.
	 *
	 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
	 * @param screenName Screen name string to set.
	 */
	function setCurrentScreen(gtagFunction, analyticsId, screenName, options) {
	    if (options && options.global) {
	        gtagFunction(GtagCommand.SET, { 'screen_name': screenName });
	    }
	    else {
	        gtagFunction(GtagCommand.CONFIG, analyticsId, {
	            update: true,
	            'screen_name': screenName
	        });
	    }
	}
	/**
	 * Set user_id parameter for this Google Analytics ID.
	 *
	 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
	 * @param id User ID string to set
	 */
	function setUserId(gtagFunction, analyticsId, id, options) {
	    if (options && options.global) {
	        gtagFunction(GtagCommand.SET, { 'user_id': id });
	    }
	    else {
	        gtagFunction(GtagCommand.CONFIG, analyticsId, {
	            update: true,
	            'user_id': id
	        });
	    }
	}
	/**
	 * Set all other user properties other than user_id and screen_name.
	 *
	 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
	 * @param properties Map of user properties to set
	 */
	function setUserProperties(gtagFunction, analyticsId, properties, options) {
	    if (options && options.global) {
	        var flatProperties = {};
	        for (var _i = 0, _a = Object.keys(properties); _i < _a.length; _i++) {
	            var key = _a[_i];
	            // use dot notation for merge behavior in gtag.js
	            flatProperties["user_properties." + key] = properties[key];
	        }
	        gtagFunction(GtagCommand.SET, flatProperties);
	    }
	    else {
	        gtagFunction(GtagCommand.CONFIG, analyticsId, {
	            update: true,
	            'user_properties': properties
	        });
	    }
	}
	/**
	 * Set whether collection is enabled for this ID.
	 *
	 * @param enabled If true, collection is enabled for this ID.
	 */
	function setAnalyticsCollectionEnabled(analyticsId, enabled) {
	    window["ga-disable-" + analyticsId] = !enabled;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Initialize the analytics instance in gtag.js by calling config command with fid.
	 *
	 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
	 * part of the `page_view` event that's sent during the initialization
	 * @param app Firebase app
	 * @param gtagCore The gtag function that's not wrapped.
	 */
	function initializeGAId(app, installations, gtagCore) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var fid;
	        var _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, installations.getId()];
	                case 1:
	                    fid = _b.sent();
	                    // This command initializes gtag.js and only needs to be called once for the entire web app,
	                    // but since it is idempotent, we can call it multiple times.
	                    // We keep it together with other initialization logic for better code structure.
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    gtagCore('js', new Date());
	                    // It should be the first config command called on this GA-ID
	                    // Initialize this GA-ID and set FID on it using the gtag config API.
	                    gtagCore(GtagCommand.CONFIG, app.options[ANALYTICS_ID_FIELD], (_a = {},
	                        _a[GA_FID_KEY] = fid,
	                        // guard against developers accidentally setting properties with prefix `firebase_`
	                        _a[ORIGIN_KEY] = 'firebase',
	                        _a.update = true,
	                        _a));
	                    return [2 /*return*/];
	            }
	        });
	    });
	}
	function insertScriptTag(dataLayerName) {
	    var script = document.createElement('script');
	    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
	    // without fid. We will initialize ga-id using gtag (config) command together with fid.
	    script.src = GTAG_URL + "?l=" + dataLayerName;
	    script.async = true;
	    document.head.appendChild(script);
	}
	/** Get reference to, or create, global datalayer.
	 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer")
	 */
	function getOrCreateDataLayer(dataLayerName) {
	    // Check for existing dataLayer and create if needed.
	    var dataLayer = [];
	    if (Array.isArray(window[dataLayerName])) {
	        dataLayer = window[dataLayerName];
	    }
	    else {
	        window[dataLayerName] = dataLayer;
	    }
	    return dataLayer;
	}
	/**
	 * Wraps a standard gtag function with extra code to wait for completion of
	 * relevant initialization promises before sending requests.
	 *
	 * @param gtagCore Basic gtag function that just appends to dataLayer
	 * @param initializedIdPromisesMap Map of gaIds to their initialization promises
	 */
	function wrapGtag(gtagCore, initializedIdPromisesMap) {
	    return function (command, idOrNameOrParams, gtagParams) {
	        // If event, check that relevant initialization promises have completed.
	        if (command === GtagCommand.EVENT) {
	            var initializationPromisesToWaitFor = [];
	            // If there's a 'send_to' param, check if any ID specified matches
	            // a FID we have begun a fetch on.
	            if (gtagParams && gtagParams['send_to']) {
	                var gaSendToList = gtagParams['send_to'];
	                // Make it an array if is isn't, so it can be dealt with the same way.
	                if (!Array.isArray(gaSendToList)) {
	                    gaSendToList = [gaSendToList];
	                }
	                for (var _i = 0, gaSendToList_1 = gaSendToList; _i < gaSendToList_1.length; _i++) {
	                    var sendToId = gaSendToList_1[_i];
	                    var initializationPromise = initializedIdPromisesMap[sendToId];
	                    // Groups will not be in the map.
	                    if (initializationPromise) {
	                        initializationPromisesToWaitFor.push(initializationPromise);
	                    }
	                    else {
	                        // There is an item in 'send_to' that is not associated
	                        // directly with an FID, possibly a group.  Empty this array
	                        // and let it get populated below.
	                        initializationPromisesToWaitFor = [];
	                        break;
	                    }
	                }
	            }
	            // This will be unpopulated if there was no 'send_to' field , or
	            // if not all entries in the 'send_to' field could be mapped to
	            // a FID. In these cases, wait on all pending initialization promises.
	            if (initializationPromisesToWaitFor.length === 0) {
	                for (var _a = 0, _b = Object.values(initializedIdPromisesMap); _a < _b.length; _a++) {
	                    var idPromise = _b[_a];
	                    initializationPromisesToWaitFor.push(idPromise);
	                }
	            }
	            // Run core gtag function with args after all relevant initialization
	            // promises have been resolved.
	            Promise.all(initializationPromisesToWaitFor)
	                // Workaround for http://b/141370449 - third argument cannot be undefined.
	                .then(function () {
	                return gtagCore(GtagCommand.EVENT, idOrNameOrParams, gtagParams || {});
	            })
	                .catch(function (e) { return console.error(e); });
	        }
	        else if (command === GtagCommand.CONFIG) {
	            var initializationPromiseToWait = initializedIdPromisesMap[idOrNameOrParams] ||
	                Promise.resolve();
	            initializationPromiseToWait
	                .then(function () {
	                gtagCore(GtagCommand.CONFIG, idOrNameOrParams, gtagParams);
	            })
	                .catch(function (e) { return console.error(e); });
	        }
	        else {
	            // SET command.
	            // Splitting calls for CONFIG and SET to make it clear which signature
	            // Typescript is checking.
	            gtagCore(GtagCommand.SET, idOrNameOrParams);
	        }
	    };
	}
	/**
	 * Creates global gtag function or wraps existing one if found.
	 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
	 * 'event' calls that belong to the GAID associated with this Firebase instance.
	 *
	 * @param initializedIdPromisesMap Map of gaId to initialization promises.
	 * @param dataLayerName Name of global GA datalayer array.
	 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified)
	 */
	function wrapOrCreateGtag(initializedIdPromisesMap, dataLayerName, gtagFunctionName) {
	    // Create a basic core gtag function
	    var gtagCore = function () {
	        var _args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            _args[_i] = arguments[_i];
	        }
	        // Must push IArguments object, not an array.
	        window[dataLayerName].push(arguments);
	    };
	    // Replace it with existing one if found
	    if (window[gtagFunctionName] &&
	        typeof window[gtagFunctionName] === 'function') {
	        // @ts-ignore
	        gtagCore = window[gtagFunctionName];
	    }
	    window[gtagFunctionName] = wrapGtag(gtagCore, initializedIdPromisesMap);
	    return {
	        gtagCore: gtagCore,
	        wrappedGtag: window[gtagFunctionName]
	    };
	}
	/**
	 * Returns first script tag in DOM matching our gtag url pattern.
	 */
	function findGtagScriptOnPage() {
	    var scriptTags = window.document.getElementsByTagName('script');
	    for (var _i = 0, _a = Object.values(scriptTags); _i < _a.length; _i++) {
	        var tag = _a[_i];
	        if (tag.src && tag.src.includes(GTAG_URL)) {
	            return tag;
	        }
	    }
	    return null;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERRORS = (_a = {},
	    _a["no-ga-id" /* NO_GA_ID */] = "\"" + ANALYTICS_ID_FIELD + "\" field is empty in " +
	        'Firebase config. Firebase Analytics ' +
	        'requires this field to contain a valid measurement ID.',
	    _a["already-exists" /* ALREADY_EXISTS */] = 'A Firebase Analytics instance with the measurement ID ${id} ' +
	        ' already exists. ' +
	        'Only one Firebase Analytics instance can be created for each measurement ID.',
	    _a["already-initialized" /* ALREADY_INITIALIZED */] = 'Firebase Analytics has already been initialized.' +
	        'settings() must be called before initializing any Analytics instance' +
	        'or it will have no effect.',
	    _a["interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */] = 'Firebase Analytics Interop Component failed to instantiate',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory('analytics', 'Analytics', ERRORS);
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Maps gaId to FID fetch promises.
	 */
	var initializedIdPromisesMap = {};
	/**
	 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
	 */
	var dataLayerName = 'dataLayer';
	/**
	 * Name for window global gtag function used by GA: defaults to 'gtag'.
	 */
	var gtagName = 'gtag';
	/**
	 * Reproduction of standard gtag function or reference to existing
	 * gtag function on window object.
	 */
	var gtagCoreFunction;
	/**
	 * Wrapper around gtag function that ensures FID is sent with all
	 * relevant event and config calls.
	 */
	var wrappedGtagFunction;
	/**
	 * Flag to ensure page initialization steps (creation or wrapping of
	 * dataLayer and gtag script) are only run once per page load.
	 */
	var globalInitDone = false;
	/**
	 * For testing
	 */
	function resetGlobalVars(newGlobalInitDone, newGaInitializedPromise) {
	    if (newGlobalInitDone === void 0) { newGlobalInitDone = false; }
	    if (newGaInitializedPromise === void 0) { newGaInitializedPromise = {}; }
	    globalInitDone = newGlobalInitDone;
	    initializedIdPromisesMap = newGaInitializedPromise;
	    dataLayerName = 'dataLayer';
	    gtagName = 'gtag';
	}
	/**
	 * This must be run before calling firebase.analytics() or it won't
	 * have any effect.
	 * @param options Custom gtag and dataLayer names.
	 */
	function settings(options) {
	    if (globalInitDone) {
	        throw ERROR_FACTORY.create("already-initialized" /* ALREADY_INITIALIZED */);
	    }
	    if (options.dataLayerName) {
	        dataLayerName = options.dataLayerName;
	    }
	    if (options.gtagName) {
	        gtagName = options.gtagName;
	    }
	}
	function factory(app, installations) {
	    var analyticsId = app.options[ANALYTICS_ID_FIELD];
	    if (!analyticsId) {
	        throw ERROR_FACTORY.create("no-ga-id" /* NO_GA_ID */);
	    }
	    if (initializedIdPromisesMap[analyticsId] != null) {
	        throw ERROR_FACTORY.create("already-exists" /* ALREADY_EXISTS */, {
	            id: analyticsId
	        });
	    }
	    if (!globalInitDone) {
	        // Steps here should only be done once per page: creation or wrapping
	        // of dataLayer and global gtag function.
	        // Detect if user has already put the gtag <script> tag on this page.
	        if (!findGtagScriptOnPage()) {
	            insertScriptTag(dataLayerName);
	        }
	        getOrCreateDataLayer(dataLayerName);
	        var _a = wrapOrCreateGtag(initializedIdPromisesMap, dataLayerName, gtagName), wrappedGtag = _a.wrappedGtag, gtagCore = _a.gtagCore;
	        wrappedGtagFunction = wrappedGtag;
	        gtagCoreFunction = gtagCore;
	        globalInitDone = true;
	    }
	    // Async but non-blocking.
	    initializedIdPromisesMap[analyticsId] = initializeGAId(app, installations, gtagCoreFunction);
	    var analyticsInstance = {
	        app: app,
	        logEvent: function (eventName, eventParams, options) {
	            return logEvent(wrappedGtagFunction, analyticsId, eventName, eventParams, options);
	        },
	        setCurrentScreen: function (screenName, options) {
	            return setCurrentScreen(wrappedGtagFunction, analyticsId, screenName, options);
	        },
	        setUserId: function (id, options) {
	            return setUserId(wrappedGtagFunction, analyticsId, id, options);
	        },
	        setUserProperties: function (properties, options) {
	            return setUserProperties(wrappedGtagFunction, analyticsId, properties, options);
	        },
	        setAnalyticsCollectionEnabled: function (enabled) {
	            return setAnalyticsCollectionEnabled(analyticsId, enabled);
	        }
	    };
	    return analyticsInstance;
	}
	
	var name = "@firebase/analytics";
	var version = "0.2.13";
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Type constant for Firebase Analytics.
	 */
	var ANALYTICS_TYPE = 'analytics';
	function registerAnalytics(instance) {
	    instance.INTERNAL.registerComponent(new component.Component(ANALYTICS_TYPE, function (container) {
	        // getImmediate for FirebaseApp will always succeed
	        var app = container.getProvider('app').getImmediate();
	        var installations = container
	            .getProvider('installations')
	            .getImmediate();
	        return factory(app, installations);
	    }, "PUBLIC" /* PUBLIC */).setServiceProps({
	        settings: settings,
	        EventName: EventName
	    }));
	    instance.INTERNAL.registerComponent(new component.Component('analytics-internal', internalFactory, "PRIVATE" /* PRIVATE */));
	    instance.registerVersion(name, version);
	    function internalFactory(container) {
	        try {
	            var analytics = container.getProvider(ANALYTICS_TYPE).getImmediate();
	            return {
	                logEvent: analytics.logEvent
	            };
	        }
	        catch (e) {
	            throw ERROR_FACTORY.create("interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */, {
	                reason: e
	            });
	        }
	    }
	}
	registerAnalytics(firebase);
	
	exports.factory = factory;
	exports.registerAnalytics = registerAnalytics;
	exports.resetGlobalVars = resetGlobalVars;
	exports.settings = settings;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	var tslib = __webpack_require__(11);
	var util = __webpack_require__(14);
	var logger$1 = __webpack_require__(20);
	var component = __webpack_require__(12);
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Wraps a DOM Storage object and:
	 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
	 * - prefixes names with "firebase:" to avoid collisions with app data.
	 *
	 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
	 * and one for localStorage.
	 *
	 * @constructor
	 */
	var DOMStorageWrapper = /** @class */ (function () {
	    /**
	     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
	     */
	    function DOMStorageWrapper(domStorage_) {
	        this.domStorage_ = domStorage_;
	        // Use a prefix to avoid collisions with other stuff saved by the app.
	        this.prefix_ = 'firebase:';
	    }
	    /**
	     * @param {string} key The key to save the value under
	     * @param {?Object} value The value being stored, or null to remove the key.
	     */
	    DOMStorageWrapper.prototype.set = function (key, value) {
	        if (value == null) {
	            this.domStorage_.removeItem(this.prefixedName_(key));
	        }
	        else {
	            this.domStorage_.setItem(this.prefixedName_(key), util.stringify(value));
	        }
	    };
	    /**
	     * @param {string} key
	     * @return {*} The value that was stored under this key, or null
	     */
	    DOMStorageWrapper.prototype.get = function (key) {
	        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
	        if (storedVal == null) {
	            return null;
	        }
	        else {
	            return util.jsonEval(storedVal);
	        }
	    };
	    /**
	     * @param {string} key
	     */
	    DOMStorageWrapper.prototype.remove = function (key) {
	        this.domStorage_.removeItem(this.prefixedName_(key));
	    };
	    /**
	     * @param {string} name
	     * @return {string}
	     */
	    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
	        return this.prefix_ + name;
	    };
	    DOMStorageWrapper.prototype.toString = function () {
	        return this.domStorage_.toString();
	    };
	    return DOMStorageWrapper;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An in-memory storage implementation that matches the API of DOMStorageWrapper
	 * (TODO: create interface for both to implement).
	 *
	 * @constructor
	 */
	var MemoryStorage = /** @class */ (function () {
	    function MemoryStorage() {
	        this.cache_ = {};
	        this.isInMemoryStorage = true;
	    }
	    MemoryStorage.prototype.set = function (key, value) {
	        if (value == null) {
	            delete this.cache_[key];
	        }
	        else {
	            this.cache_[key] = value;
	        }
	    };
	    MemoryStorage.prototype.get = function (key) {
	        if (util.contains(this.cache_, key)) {
	            return this.cache_[key];
	        }
	        return null;
	    };
	    MemoryStorage.prototype.remove = function (key) {
	        delete this.cache_[key];
	    };
	    return MemoryStorage;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
	 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
	 * to reflect this type
	 *
	 * @param {string} domStorageName Name of the underlying storage object
	 *   (e.g. 'localStorage' or 'sessionStorage').
	 * @return {?} Turning off type information until a common interface is defined.
	 */
	var createStoragefor = function (domStorageName) {
	    try {
	        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
	        // so it must be inside the try/catch.
	        if (typeof window !== 'undefined' &&
	            typeof window[domStorageName] !== 'undefined') {
	            // Need to test cache. Just because it's here doesn't mean it works
	            var domStorage = window[domStorageName];
	            domStorage.setItem('firebase:sentinel', 'cache');
	            domStorage.removeItem('firebase:sentinel');
	            return new DOMStorageWrapper(domStorage);
	        }
	    }
	    catch (e) { }
	    // Failed to create wrapper.  Just return in-memory storage.
	    // TODO: log?
	    return new MemoryStorage();
	};
	/** A storage object that lasts across sessions */
	var PersistentStorage = createStoragefor('localStorage');
	/** A storage object that only lasts one session */
	var SessionStorage = createStoragefor('sessionStorage');
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var logClient = new logger$1.Logger('@firebase/database');
	/**
	 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
	 * @type {function(): number} Generated ID.
	 */
	var LUIDGenerator = (function () {
	    var id = 1;
	    return function () {
	        return id++;
	    };
	})();
	/**
	 * Sha1 hash of the input string
	 * @param {!string} str The string to hash
	 * @return {!string} The resulting hash
	 */
	var sha1 = function (str) {
	    var utf8Bytes = util.stringToByteArray(str);
	    var sha1 = new util.Sha1();
	    sha1.update(utf8Bytes);
	    var sha1Bytes = sha1.digest();
	    return util.base64.encodeByteArray(sha1Bytes);
	};
	/**
	 * @param {...*} varArgs
	 * @return {string}
	 * @private
	 */
	var buildLogMessage_ = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = '';
	    for (var i = 0; i < varArgs.length; i++) {
	        var arg = varArgs[i];
	        if (Array.isArray(arg) ||
	            (arg &&
	                typeof arg === 'object' &&
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                typeof arg.length === 'number')) {
	            message += buildLogMessage_.apply(null, arg);
	        }
	        else if (typeof arg === 'object') {
	            message += util.stringify(arg);
	        }
	        else {
	            message += arg;
	        }
	        message += ' ';
	    }
	    return message;
	};
	/**
	 * Use this for all debug messages in Firebase.
	 * @type {?function(string)}
	 */
	var logger = null;
	/**
	 * Flag to check for log availability on first log message
	 * @type {boolean}
	 * @private
	 */
	var firstLog_ = true;
	/**
	 * The implementation of Firebase.enableLogging (defined here to break dependencies)
	 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
	 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
	 */
	var enableLogging = function (logger_, persistent) {
	    util.assert(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
	    if (logger_ === true) {
	        logClient.logLevel = logger$1.LogLevel.VERBOSE;
	        logger = logClient.log.bind(logClient);
	        if (persistent) {
	            SessionStorage.set('logging_enabled', true);
	        }
	    }
	    else if (typeof logger_ === 'function') {
	        logger = logger_;
	    }
	    else {
	        logger = null;
	        SessionStorage.remove('logging_enabled');
	    }
	};
	/**
	 *
	 * @param {...(string|Arguments)} varArgs
	 */
	var log = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    if (firstLog_ === true) {
	        firstLog_ = false;
	        if (logger === null && SessionStorage.get('logging_enabled') === true) {
	            enableLogging(true);
	        }
	    }
	    if (logger) {
	        var message = buildLogMessage_.apply(null, varArgs);
	        logger(message);
	    }
	};
	/**
	 * @param {!string} prefix
	 * @return {function(...[*])}
	 */
	var logWrapper = function (prefix) {
	    return function () {
	        var varArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            varArgs[_i] = arguments[_i];
	        }
	        log.apply(void 0, tslib.__spread([prefix], varArgs));
	    };
	};
	/**
	 * @param {...string} varArgs
	 */
	var error = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, tslib.__spread(varArgs));
	    logClient.error(message);
	};
	/**
	 * @param {...string} varArgs
	 */
	var fatal = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, tslib.__spread(varArgs));
	    logClient.error(message);
	    throw new Error(message);
	};
	/**
	 * @param {...*} varArgs
	 */
	var warn = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, tslib.__spread(varArgs));
	    logClient.warn(message);
	};
	/**
	 * Logs a warning if the containing page uses https. Called when a call to new Firebase
	 * does not use https.
	 */
	var warnIfPageIsSecure = function () {
	    // Be very careful accessing browser globals. Who knows what may or may not exist.
	    if (typeof window !== 'undefined' &&
	        window.location &&
	        window.location.protocol &&
	        window.location.protocol.indexOf('https:') !== -1) {
	        warn('Insecure Firebase access from a secure page. ' +
	            'Please use https in calls to new Firebase().');
	    }
	};
	/**
	 * Returns true if data is NaN, or +/- Infinity.
	 * @param {*} data
	 * @return {boolean}
	 */
	var isInvalidJSONNumber = function (data) {
	    return (typeof data === 'number' &&
	        (data !== data || // NaN
	            data === Number.POSITIVE_INFINITY ||
	            data === Number.NEGATIVE_INFINITY));
	};
	/**
	 * @param {function()} fn
	 */
	var executeWhenDOMReady = function (fn) {
	    if (util.isNodeSdk() || document.readyState === 'complete') {
	        fn();
	    }
	    else {
	        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
	        // fire before onload), but fall back to onload.
	        var called_1 = false;
	        var wrappedFn_1 = function () {
	            if (!document.body) {
	                setTimeout(wrappedFn_1, Math.floor(10));
	                return;
	            }
	            if (!called_1) {
	                called_1 = true;
	                fn();
	            }
	        };
	        if (document.addEventListener) {
	            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
	            // fallback to onload.
	            window.addEventListener('load', wrappedFn_1, false);
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }
	        else if (document.attachEvent) {
	            // IE.
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            document.attachEvent('onreadystatechange', function () {
	                if (document.readyState === 'complete') {
	                    wrappedFn_1();
	                }
	            });
	            // fallback to onload.
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            window.attachEvent('onload', wrappedFn_1);
	            // jQuery has an extra hack for IE that we could employ (based on
	            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
	            // I'm hoping we don't need it.
	        }
	    }
	};
	/**
	 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
	 * @type {!string}
	 */
	var MIN_NAME = '[MIN_NAME]';
	/**
	 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
	 * @type {!string}
	 */
	var MAX_NAME = '[MAX_NAME]';
	/**
	 * Compares valid Firebase key names, plus min and max name
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number}
	 */
	var nameCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a === MIN_NAME || b === MAX_NAME) {
	        return -1;
	    }
	    else if (b === MIN_NAME || a === MAX_NAME) {
	        return 1;
	    }
	    else {
	        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
	        if (aAsInt !== null) {
	            if (bAsInt !== null) {
	                return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (bAsInt !== null) {
	            return 1;
	        }
	        else {
	            return a < b ? -1 : 1;
	        }
	    }
	};
	/**
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number} comparison result.
	 */
	var stringCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a < b) {
	        return -1;
	    }
	    else {
	        return 1;
	    }
	};
	/**
	 * @param {string} key
	 * @param {Object} obj
	 * @return {*}
	 */
	var requireKey = function (key, obj) {
	    if (obj && key in obj) {
	        return obj[key];
	    }
	    else {
	        throw new Error('Missing required key (' + key + ') in object: ' + util.stringify(obj));
	    }
	};
	/**
	 * @param {*} obj
	 * @return {string}
	 */
	var ObjectToUniqueKey = function (obj) {
	    if (typeof obj !== 'object' || obj === null) {
	        return util.stringify(obj);
	    }
	    var keys = [];
	    // eslint-disable-next-line guard-for-in
	    for (var k in obj) {
	        keys.push(k);
	    }
	    // Export as json, but with the keys sorted.
	    keys.sort();
	    var key = '{';
	    for (var i = 0; i < keys.length; i++) {
	        if (i !== 0) {
	            key += ',';
	        }
	        key += util.stringify(keys[i]);
	        key += ':';
	        key += ObjectToUniqueKey(obj[keys[i]]);
	    }
	    key += '}';
	    return key;
	};
	/**
	 * Splits a string into a number of smaller segments of maximum size
	 * @param {!string} str The string
	 * @param {!number} segsize The maximum number of chars in the string.
	 * @return {Array.<string>} The string, split into appropriately-sized chunks
	 */
	var splitStringBySize = function (str, segsize) {
	    var len = str.length;
	    if (len <= segsize) {
	        return [str];
	    }
	    var dataSegs = [];
	    for (var c = 0; c < len; c += segsize) {
	        if (c + segsize > len) {
	            dataSegs.push(str.substring(c, len));
	        }
	        else {
	            dataSegs.push(str.substring(c, c + segsize));
	        }
	    }
	    return dataSegs;
	};
	/**
	 * Apply a function to each (key, value) pair in an object or
	 * apply a function to each (index, value) pair in an array
	 * @param obj The object or array to iterate over
	 * @param fn The function to apply
	 */
	function each(obj, fn) {
	    for (var key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            fn(key, obj[key]);
	        }
	    }
	}
	/**
	 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
	 * I made one modification at the end and removed the NaN / Infinity
	 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
	 * @param {!number} v A double
	 * @return {string}
	 */
	var doubleToIEEE754String = function (v) {
	    util.assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
	    var ebits = 11, fbits = 52;
	    var bias = (1 << (ebits - 1)) - 1;
	    var s, e, f, ln, i;
	    // Compute sign, exponent, fraction
	    // Skip NaN / Infinity handling --MJL.
	    if (v === 0) {
	        e = 0;
	        f = 0;
	        s = 1 / v === -Infinity ? 1 : 0;
	    }
	    else {
	        s = v < 0;
	        v = Math.abs(v);
	        if (v >= Math.pow(2, 1 - bias)) {
	            // Normalized
	            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
	            e = ln + bias;
	            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
	        }
	        else {
	            // Denormalized
	            e = 0;
	            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
	        }
	    }
	    // Pack sign, exponent, fraction
	    var bits = [];
	    for (i = fbits; i; i -= 1) {
	        bits.push(f % 2 ? 1 : 0);
	        f = Math.floor(f / 2);
	    }
	    for (i = ebits; i; i -= 1) {
	        bits.push(e % 2 ? 1 : 0);
	        e = Math.floor(e / 2);
	    }
	    bits.push(s ? 1 : 0);
	    bits.reverse();
	    var str = bits.join('');
	    // Return the data as a hex string. --MJL
	    var hexByteString = '';
	    for (i = 0; i < 64; i += 8) {
	        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
	        if (hexByte.length === 1) {
	            hexByte = '0' + hexByte;
	        }
	        hexByteString = hexByteString + hexByte;
	    }
	    return hexByteString.toLowerCase();
	};
	/**
	 * Used to detect if we're in a Chrome content script (which executes in an
	 * isolated environment where long-polling doesn't work).
	 * @return {boolean}
	 */
	var isChromeExtensionContentScript = function () {
	    return !!(typeof window === 'object' &&
	        window['chrome'] &&
	        window['chrome']['extension'] &&
	        !/^chrome/.test(window.location.href));
	};
	/**
	 * Used to detect if we're in a Windows 8 Store app.
	 * @return {boolean}
	 */
	var isWindowsStoreApp = function () {
	    // Check for the presence of a couple WinRT globals
	    return typeof Windows === 'object' && typeof Windows.UI === 'object';
	};
	/**
	 * Converts a server error code to a Javascript Error
	 * @param {!string} code
	 * @param {!Query} query
	 * @return {Error}
	 */
	var errorForServerCode = function (code, query) {
	    var reason = 'Unknown Error';
	    if (code === 'too_big') {
	        reason =
	            'The data requested exceeds the maximum size ' +
	                'that can be accessed with a single request.';
	    }
	    else if (code === 'permission_denied') {
	        reason = "Client doesn't have permission to access the desired data.";
	    }
	    else if (code === 'unavailable') {
	        reason = 'The service is unavailable';
	    }
	    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    error.code = code.toUpperCase();
	    return error;
	};
	/**
	 * Used to test for integer-looking strings
	 * @type {RegExp}
	 * @private
	 */
	var INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
	/**
	 * If the string contains a 32-bit integer, return it.  Else return null.
	 * @param {!string} str
	 * @return {?number}
	 */
	var tryParseInt = function (str) {
	    if (INTEGER_REGEXP_.test(str)) {
	        var intVal = Number(str);
	        if (intVal >= -2147483648 && intVal <= 2147483647) {
	            return intVal;
	        }
	    }
	    return null;
	};
	/**
	 * Helper to run some code but catch any exceptions and re-throw them later.
	 * Useful for preventing user callbacks from breaking internal code.
	 *
	 * Re-throwing the exception from a setTimeout is a little evil, but it's very
	 * convenient (we don't have to try to figure out when is a safe point to
	 * re-throw it), and the behavior seems reasonable:
	 *
	 * * If you aren't pausing on exceptions, you get an error in the console with
	 *   the correct stack trace.
	 * * If you're pausing on all exceptions, the debugger will pause on your
	 *   exception and then again when we rethrow it.
	 * * If you're only pausing on uncaught exceptions, the debugger will only pause
	 *   on us re-throwing it.
	 *
	 * @param {!function()} fn The code to guard.
	 */
	var exceptionGuard = function (fn) {
	    try {
	        fn();
	    }
	    catch (e) {
	        // Re-throw exception when it's safe.
	        setTimeout(function () {
	            // It used to be that "throw e" would result in a good console error with
	            // relevant context, but as of Chrome 39, you just get the firebase.js
	            // file/line number where we re-throw it, which is useless. So we log
	            // e.stack explicitly.
	            var stack = e.stack || '';
	            warn('Exception was thrown by user callback.', stack);
	            throw e;
	        }, Math.floor(0));
	    }
	};
	/**
	 * @return {boolean} true if we think we're currently being crawled.
	 */
	var beingCrawled = function () {
	    var userAgent = (typeof window === 'object' &&
	        window['navigator'] &&
	        window['navigator']['userAgent']) ||
	        '';
	    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
	    // believe to support JavaScript/AJAX rendering.
	    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
	    // would have seen the page" is flaky if we don't treat it as a crawler.
	    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
	};
	/**
	 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
	 *
	 * It is removed with clearTimeout() as normal.
	 *
	 * @param {Function} fn Function to run.
	 * @param {number} time Milliseconds to wait before running.
	 * @return {number|Object} The setTimeout() return value.
	 */
	var setTimeoutNonBlocking = function (fn, time) {
	    var timeout = setTimeout(fn, time);
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    if (typeof timeout === 'object' && timeout['unref']) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        timeout['unref']();
	    }
	    return timeout;
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An immutable object representing a parsed path.  It's immutable so that you
	 * can pass them around to other functions without worrying about them changing
	 * it.
	 */
	var Path = /** @class */ (function () {
	    /**
	     * @param {string|Array.<string>} pathOrString Path string to parse,
	     *      or another path, or the raw tokens array
	     * @param {number=} pieceNum
	     */
	    function Path(pathOrString, pieceNum) {
	        if (pieceNum === void 0) {
	            this.pieces_ = pathOrString.split('/');
	            // Remove empty pieces.
	            var copyTo = 0;
	            for (var i = 0; i < this.pieces_.length; i++) {
	                if (this.pieces_[i].length > 0) {
	                    this.pieces_[copyTo] = this.pieces_[i];
	                    copyTo++;
	                }
	            }
	            this.pieces_.length = copyTo;
	            this.pieceNum_ = 0;
	        }
	        else {
	            this.pieces_ = pathOrString;
	            this.pieceNum_ = pieceNum;
	        }
	    }
	    Object.defineProperty(Path, "Empty", {
	        /**
	         * Singleton to represent an empty path
	         *
	         * @const
	         */
	        get: function () {
	            return new Path('');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Path.prototype.getFront = function () {
	        if (this.pieceNum_ >= this.pieces_.length) {
	            return null;
	        }
	        return this.pieces_[this.pieceNum_];
	    };
	    /**
	     * @return {number} The number of segments in this path
	     */
	    Path.prototype.getLength = function () {
	        return this.pieces_.length - this.pieceNum_;
	    };
	    /**
	     * @return {!Path}
	     */
	    Path.prototype.popFront = function () {
	        var pieceNum = this.pieceNum_;
	        if (pieceNum < this.pieces_.length) {
	            pieceNum++;
	        }
	        return new Path(this.pieces_, pieceNum);
	    };
	    /**
	     * @return {?string}
	     */
	    Path.prototype.getBack = function () {
	        if (this.pieceNum_ < this.pieces_.length) {
	            return this.pieces_[this.pieces_.length - 1];
	        }
	        return null;
	    };
	    Path.prototype.toString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '') {
	                pathString += '/' + this.pieces_[i];
	            }
	        }
	        return pathString || '/';
	    };
	    Path.prototype.toUrlEncodedString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '') {
	                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
	            }
	        }
	        return pathString || '/';
	    };
	    /**
	     * Shallow copy of the parts of the path.
	     *
	     * @param {number=} begin
	     * @return {!Array<string>}
	     */
	    Path.prototype.slice = function (begin) {
	        if (begin === void 0) { begin = 0; }
	        return this.pieces_.slice(this.pieceNum_ + begin);
	    };
	    /**
	     * @return {?Path}
	     */
	    Path.prototype.parent = function () {
	        if (this.pieceNum_ >= this.pieces_.length) {
	            return null;
	        }
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++) {
	            pieces.push(this.pieces_[i]);
	        }
	        return new Path(pieces, 0);
	    };
	    /**
	     * @param {string|!Path} childPathObj
	     * @return {!Path}
	     */
	    Path.prototype.child = function (childPathObj) {
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            pieces.push(this.pieces_[i]);
	        }
	        if (childPathObj instanceof Path) {
	            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
	                pieces.push(childPathObj.pieces_[i]);
	            }
	        }
	        else {
	            var childPieces = childPathObj.split('/');
	            for (var i = 0; i < childPieces.length; i++) {
	                if (childPieces[i].length > 0) {
	                    pieces.push(childPieces[i]);
	                }
	            }
	        }
	        return new Path(pieces, 0);
	    };
	    /**
	     * @return {boolean} True if there are no segments in this path
	     */
	    Path.prototype.isEmpty = function () {
	        return this.pieceNum_ >= this.pieces_.length;
	    };
	    /**
	     * @param {!Path} outerPath
	     * @param {!Path} innerPath
	     * @return {!Path} The path from outerPath to innerPath
	     */
	    Path.relativePath = function (outerPath, innerPath) {
	        var outer = outerPath.getFront(), inner = innerPath.getFront();
	        if (outer === null) {
	            return innerPath;
	        }
	        else if (outer === inner) {
	            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
	        }
	        else {
	            throw new Error('INTERNAL ERROR: innerPath (' +
	                innerPath +
	                ') is not within ' +
	                'outerPath (' +
	                outerPath +
	                ')');
	        }
	    };
	    /**
	     * @param {!Path} left
	     * @param {!Path} right
	     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
	     */
	    Path.comparePaths = function (left, right) {
	        var leftKeys = left.slice();
	        var rightKeys = right.slice();
	        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
	            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
	            if (cmp !== 0) {
	                return cmp;
	            }
	        }
	        if (leftKeys.length === rightKeys.length) {
	            return 0;
	        }
	        return leftKeys.length < rightKeys.length ? -1 : 1;
	    };
	    /**
	     *
	     * @param {Path} other
	     * @return {boolean} true if paths are the same.
	     */
	    Path.prototype.equals = function (other) {
	        if (this.getLength() !== other.getLength()) {
	            return false;
	        }
	        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     *
	     * @param {!Path} other
	     * @return {boolean} True if this path is a parent (or the same as) other
	     */
	    Path.prototype.contains = function (other) {
	        var i = this.pieceNum_;
	        var j = other.pieceNum_;
	        if (this.getLength() > other.getLength()) {
	            return false;
	        }
	        while (i < this.pieces_.length) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	            ++i;
	            ++j;
	        }
	        return true;
	    };
	    return Path;
	}()); // end Path
	/**
	 * Dynamic (mutable) path used to count path lengths.
	 *
	 * This class is used to efficiently check paths for valid
	 * length (in UTF8 bytes) and depth (used in path validation).
	 *
	 * Throws Error exception if path is ever invalid.
	 *
	 * The definition of a path always begins with '/'.
	 */
	var ValidationPath = /** @class */ (function () {
	    /**
	     * @param {!Path} path Initial Path.
	     * @param {string} errorPrefix_ Prefix for any error messages.
	     */
	    function ValidationPath(path, errorPrefix_) {
	        this.errorPrefix_ = errorPrefix_;
	        /** @type {!Array<string>} */
	        this.parts_ = path.slice();
	        /** @type {number} Initialize to number of '/' chars needed in path. */
	        this.byteLength_ = Math.max(1, this.parts_.length);
	        for (var i = 0; i < this.parts_.length; i++) {
	            this.byteLength_ += util.stringLength(this.parts_[i]);
	        }
	        this.checkValid_();
	    }
	    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
	        /** @const {number} Maximum key depth. */
	        get: function () {
	            return 32;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
	        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
	        get: function () {
	            return 768;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @param {string} child */
	    ValidationPath.prototype.push = function (child) {
	        // Count the needed '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ += 1;
	        }
	        this.parts_.push(child);
	        this.byteLength_ += util.stringLength(child);
	        this.checkValid_();
	    };
	    ValidationPath.prototype.pop = function () {
	        var last = this.parts_.pop();
	        this.byteLength_ -= util.stringLength(last);
	        // Un-count the previous '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ -= 1;
	        }
	    };
	    ValidationPath.prototype.checkValid_ = function () {
	        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
	            throw new Error(this.errorPrefix_ +
	                'has a key path longer than ' +
	                ValidationPath.MAX_PATH_LENGTH_BYTES +
	                ' bytes (' +
	                this.byteLength_ +
	                ').');
	        }
	        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
	            throw new Error(this.errorPrefix_ +
	                'path specified exceeds the maximum depth that can be written (' +
	                ValidationPath.MAX_PATH_DEPTH +
	                ') or object contains a cycle ' +
	                this.toErrorString());
	        }
	    };
	    /**
	     * String for use in error messages - uses '.' notation for path.
	     *
	     * @return {string}
	     */
	    ValidationPath.prototype.toErrorString = function () {
	        if (this.parts_.length === 0) {
	            return '';
	        }
	        return "in property '" + this.parts_.join('.') + "'";
	    };
	    return ValidationPath;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PROTOCOL_VERSION = '5';
	var VERSION_PARAM = 'v';
	var TRANSPORT_SESSION_PARAM = 's';
	var REFERER_PARAM = 'r';
	var FORGE_REF = 'f';
	var FORGE_DOMAIN = 'firebaseio.com';
	var LAST_SESSION_PARAM = 'ls';
	var WEBSOCKET = 'websocket';
	var LONG_POLLING = 'long_polling';
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A class that holds metadata about a Repo object
	 *
	 * @constructor
	 */
	var RepoInfo = /** @class */ (function () {
	    /**
	     * @param {string} host Hostname portion of the url for the repo
	     * @param {boolean} secure Whether or not this repo is accessed over ssl
	     * @param {string} namespace The namespace represented by the repo
	     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
	     * @param {string=} persistenceKey Override the default session persistence storage key
	     */
	    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey, includeNamespaceInQueryParams) {
	        if (persistenceKey === void 0) { persistenceKey = ''; }
	        if (includeNamespaceInQueryParams === void 0) { includeNamespaceInQueryParams = false; }
	        this.secure = secure;
	        this.namespace = namespace;
	        this.webSocketOnly = webSocketOnly;
	        this.persistenceKey = persistenceKey;
	        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
	        this.host = host.toLowerCase();
	        this.domain = this.host.substr(this.host.indexOf('.') + 1);
	        this.internalHost =
	            PersistentStorage.get('host:' + host) || this.host;
	    }
	    RepoInfo.prototype.needsQueryParam = function () {
	        return (this.host !== this.internalHost ||
	            this.isCustomHost() ||
	            this.includeNamespaceInQueryParams);
	    };
	    RepoInfo.prototype.isCacheableHost = function () {
	        return this.internalHost.substr(0, 2) === 's-';
	    };
	    RepoInfo.prototype.isDemoHost = function () {
	        return this.domain === 'firebaseio-demo.com';
	    };
	    RepoInfo.prototype.isCustomHost = function () {
	        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
	    };
	    RepoInfo.prototype.updateHost = function (newHost) {
	        if (newHost !== this.internalHost) {
	            this.internalHost = newHost;
	            if (this.isCacheableHost()) {
	                PersistentStorage.set('host:' + this.host, this.internalHost);
	            }
	        }
	    };
	    /**
	     * Returns the websocket URL for this repo
	     * @param {string} type of connection
	     * @param {Object} params list
	     * @return {string} The URL for this repo
	     */
	    RepoInfo.prototype.connectionURL = function (type, params) {
	        util.assert(typeof type === 'string', 'typeof type must == string');
	        util.assert(typeof params === 'object', 'typeof params must == object');
	        var connURL;
	        if (type === WEBSOCKET) {
	            connURL =
	                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
	        }
	        else if (type === LONG_POLLING) {
	            connURL =
	                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
	        }
	        else {
	            throw new Error('Unknown connection type: ' + type);
	        }
	        if (this.needsQueryParam()) {
	            params['ns'] = this.namespace;
	        }
	        var pairs = [];
	        each(params, function (key, value) {
	            pairs.push(key + '=' + value);
	        });
	        return connURL + pairs.join('&');
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toString = function () {
	        var str = this.toURLString();
	        if (this.persistenceKey) {
	            str += '<' + this.persistenceKey + '>';
	        }
	        return str;
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toURLString = function () {
	        return (this.secure ? 'https://' : 'http://') + this.host;
	    };
	    return RepoInfo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!string} pathString
	 * @return {string}
	 */
	function decodePath(pathString) {
	    var pathStringDecoded = '';
	    var pieces = pathString.split('/');
	    for (var i = 0; i < pieces.length; i++) {
	        if (pieces[i].length > 0) {
	            var piece = pieces[i];
	            try {
	                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
	            }
	            catch (e) { }
	            pathStringDecoded += '/' + piece;
	        }
	    }
	    return pathStringDecoded;
	}
	/**
	 * @param {!string} queryString
	 * @return {!{[key:string]:string}} key value hash
	 */
	function decodeQuery(queryString) {
	    var e_1, _a;
	    var results = {};
	    if (queryString.charAt(0) === '?') {
	        queryString = queryString.substring(1);
	    }
	    try {
	        for (var _b = tslib.__values(queryString.split('&')), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var segment = _c.value;
	            if (segment.length === 0) {
	                continue;
	            }
	            var kv = segment.split('=');
	            if (kv.length === 2) {
	                results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
	            }
	            else {
	                warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	    return results;
	}
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{repoInfo: !RepoInfo, path: !Path}}
	 */
	var parseRepoInfo = function (dataURL) {
	    var parsedUrl = parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
	    if (parsedUrl.domain === 'firebase') {
	        fatal(parsedUrl.host +
	            ' is no longer supported. ' +
	            'Please use <YOUR FIREBASE>.firebaseio.com instead');
	    }
	    // Catch common error of uninitialized namespace value.
	    if ((!namespace || namespace === 'undefined') &&
	        parsedUrl.domain !== 'localhost') {
	        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
	    }
	    if (!parsedUrl.secure) {
	        warnIfPageIsSecure();
	    }
	    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
	    return {
	        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, 
	        /*persistenceKey=*/ '', 
	        /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
	        path: new Path(parsedUrl.pathString)
	    };
	};
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string, namespace: string}}
	 */
	var parseDatabaseURL = function (dataURL) {
	    // Default to empty strings in the event of a malformed string.
	    var host = '', domain = '', subdomain = '', pathString = '', namespace = '';
	    // Always default to SSL, unless otherwise specified.
	    var secure = true, scheme = 'https', port = 443;
	    // Don't do any validation here. The caller is responsible for validating the result of parsing.
	    if (typeof dataURL === 'string') {
	        // Parse scheme.
	        var colonInd = dataURL.indexOf('//');
	        if (colonInd >= 0) {
	            scheme = dataURL.substring(0, colonInd - 1);
	            dataURL = dataURL.substring(colonInd + 2);
	        }
	        // Parse host, path, and query string.
	        var slashInd = dataURL.indexOf('/');
	        if (slashInd === -1) {
	            slashInd = dataURL.length;
	        }
	        var questionMarkInd = dataURL.indexOf('?');
	        if (questionMarkInd === -1) {
	            questionMarkInd = dataURL.length;
	        }
	        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
	        if (slashInd < questionMarkInd) {
	            // For pathString, questionMarkInd will always come after slashInd
	            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
	        }
	        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
	        // If we have a port, use scheme for determining if it's secure.
	        colonInd = host.indexOf(':');
	        if (colonInd >= 0) {
	            secure = scheme === 'https' || scheme === 'wss';
	            port = parseInt(host.substring(colonInd + 1), 10);
	        }
	        else {
	            colonInd = dataURL.length;
	        }
	        var parts = host.split('.');
	        if (parts.length === 3) {
	            // Normalize namespaces to lowercase to share storage / connection.
	            domain = parts[1];
	            subdomain = parts[0].toLowerCase();
	            // We interpret the subdomain of a 3 component URL as the namespace name.
	            namespace = subdomain;
	        }
	        else if (parts.length === 2) {
	            domain = parts[0];
	        }
	        else if (parts[0].slice(0, colonInd).toLowerCase() === 'localhost') {
	            domain = 'localhost';
	        }
	        // Always treat the value of the `ns` as the namespace name if it is present.
	        if ('ns' in queryParams) {
	            namespace = queryParams['ns'];
	        }
	    }
	    return {
	        host: host,
	        port: port,
	        domain: domain,
	        subdomain: subdomain,
	        secure: secure,
	        scheme: scheme,
	        pathString: pathString,
	        namespace: namespace
	    };
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * True for invalid Firebase keys
	 * @type {RegExp}
	 * @private
	 */
	var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
	/**
	 * True for invalid Firebase paths.
	 * Allows '/' in paths.
	 * @type {RegExp}
	 * @private
	 */
	var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
	/**
	 * Maximum number of characters to allow in leaf value
	 * @type {number}
	 * @private
	 */
	var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
	/**
	 * @param {*} key
	 * @return {boolean}
	 */
	var isValidKey = function (key) {
	    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	var isValidPathString = function (pathString) {
	    return (typeof pathString === 'string' &&
	        pathString.length !== 0 &&
	        !INVALID_PATH_REGEX_.test(pathString));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	var isValidRootPathString = function (pathString) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    return isValidPathString(pathString);
	};
	/**
	 * @param {*} priority
	 * @return {boolean}
	 */
	var isValidPriority = function (priority) {
	    return (priority === null ||
	        typeof priority === 'string' ||
	        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
	        (priority &&
	            typeof priority === 'object' &&
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            util.contains(priority, '.sv')));
	};
	/**
	 * Pre-validate a datum passed as an argument to Firebase function.
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined) {
	        return;
	    }
	    validateFirebaseData(util.errorPrefix(fnName, argumentNumber, optional), data, path);
	};
	/**
	 * Validate a data object client-side before sending to server.
	 *
	 * @param {string} errorPrefix
	 * @param {*} data
	 * @param {!Path|!ValidationPath} path_
	 */
	var validateFirebaseData = function (errorPrefix, data, path_) {
	    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
	    if (data === undefined) {
	        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
	    }
	    if (typeof data === 'function') {
	        throw new Error(errorPrefix +
	            'contains a function ' +
	            path.toErrorString() +
	            ' with contents = ' +
	            data.toString());
	    }
	    if (isInvalidJSONNumber(data)) {
	        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
	    }
	    // Check max leaf size, but try to avoid the utf8 conversion if we can.
	    if (typeof data === 'string' &&
	        data.length > MAX_LEAF_SIZE_ / 3 &&
	        util.stringLength(data) > MAX_LEAF_SIZE_) {
	        throw new Error(errorPrefix +
	            'contains a string greater than ' +
	            MAX_LEAF_SIZE_ +
	            ' utf8 bytes ' +
	            path.toErrorString() +
	            " ('" +
	            data.substring(0, 50) +
	            "...')");
	    }
	    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
	    // to save extra walking of large objects.
	    if (data && typeof data === 'object') {
	        var hasDotValue_1 = false;
	        var hasActualChild_1 = false;
	        each(data, function (key, value) {
	            if (key === '.value') {
	                hasDotValue_1 = true;
	            }
	            else if (key !== '.priority' && key !== '.sv') {
	                hasActualChild_1 = true;
	                if (!isValidKey(key)) {
	                    throw new Error(errorPrefix +
	                        ' contains an invalid key (' +
	                        key +
	                        ') ' +
	                        path.toErrorString() +
	                        '.  Keys must be non-empty strings ' +
	                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	                }
	            }
	            path.push(key);
	            validateFirebaseData(errorPrefix, value, path);
	            path.pop();
	        });
	        if (hasDotValue_1 && hasActualChild_1) {
	            throw new Error(errorPrefix +
	                ' contains ".value" child ' +
	                path.toErrorString() +
	                ' in addition to actual children.');
	        }
	    }
	};
	/**
	 * Pre-validate paths passed in the firebase function.
	 *
	 * @param {string} errorPrefix
	 * @param {Array<!Path>} mergePaths
	 */
	var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
	    var i, curPath;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        var keys = curPath.slice();
	        for (var j = 0; j < keys.length; j++) {
	            if (keys[j] === '.priority' && j === keys.length - 1) ;
	            else if (!isValidKey(keys[j])) {
	                throw new Error(errorPrefix +
	                    'contains an invalid key (' +
	                    keys[j] +
	                    ') in path ' +
	                    curPath.toString() +
	                    '. Keys must be non-empty strings ' +
	                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	            }
	        }
	    }
	    // Check that update keys are not descendants of each other.
	    // We rely on the property that sorting guarantees that ancestors come
	    // right before descendants.
	    mergePaths.sort(Path.comparePaths);
	    var prevPath = null;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        if (prevPath !== null && prevPath.contains(curPath)) {
	            throw new Error(errorPrefix +
	                'contains a path ' +
	                prevPath.toString() +
	                ' that is ancestor of another path ' +
	                curPath.toString());
	        }
	        prevPath = curPath;
	    }
	};
	/**
	 * pre-validate an object passed as an argument to firebase function (
	 * must be an object - e.g. for firebase.update()).
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined) {
	        return;
	    }
	    var errorPrefix = util.errorPrefix(fnName, argumentNumber, optional);
	    if (!(data && typeof data === 'object') || Array.isArray(data)) {
	        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
	    }
	    var mergePaths = [];
	    each(data, function (key, value) {
	        var curPath = new Path(key);
	        validateFirebaseData(errorPrefix, value, path.child(curPath));
	        if (curPath.getBack() === '.priority') {
	            if (!isValidPriority(value)) {
	                throw new Error(errorPrefix +
	                    "contains an invalid value for '" +
	                    curPath.toString() +
	                    "', which must be a valid " +
	                    'Firebase priority (a string, finite number, server value, or null).');
	            }
	        }
	        mergePaths.push(curPath);
	    });
	    validateFirebaseMergePaths(errorPrefix, mergePaths);
	};
	var validatePriority = function (fnName, argumentNumber, priority, optional) {
	    if (optional && priority === undefined) {
	        return;
	    }
	    if (isInvalidJSONNumber(priority)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'is ' +
	            priority.toString() +
	            ', but must be a valid Firebase priority (a string, finite number, ' +
	            'server value, or null).');
	    }
	    // Special case to allow importing data with a .sv.
	    if (!isValidPriority(priority)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid Firebase priority ' +
	            '(a string, finite number, server value, or null).');
	    }
	};
	var validateEventType = function (fnName, argumentNumber, eventType, optional) {
	    if (optional && eventType === undefined) {
	        return;
	    }
	    switch (eventType) {
	        case 'value':
	        case 'child_added':
	        case 'child_removed':
	        case 'child_changed':
	        case 'child_moved':
	            break;
	        default:
	            throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	                'must be a valid event type = "value", "child_added", "child_removed", ' +
	                '"child_changed", or "child_moved".');
	    }
	};
	var validateKey = function (fnName, argumentNumber, key, optional) {
	    if (optional && key === undefined) {
	        return;
	    }
	    if (!isValidKey(key)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid key = "' +
	            key +
	            '".  Firebase keys must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "/", "[", or "]").');
	    }
	};
	var validatePathString = function (fnName, argumentNumber, pathString, optional) {
	    if (optional && pathString === undefined) {
	        return;
	    }
	    if (!isValidPathString(pathString)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid path = "' +
	            pathString +
	            '". Paths must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "[", or "]"');
	    }
	};
	var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    validatePathString(fnName, argumentNumber, pathString, optional);
	};
	var validateWritablePath = function (fnName, path) {
	    if (path.getFront() === '.info') {
	        throw new Error(fnName + " failed = Can't modify data under /.info/");
	    }
	};
	var validateUrl = function (fnName, argumentNumber, parsedUrl) {
	    // TODO = Validate server better.
	    var pathString = parsedUrl.path.toString();
	    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
	        parsedUrl.repoInfo.host.length === 0 ||
	        (!isValidKey(parsedUrl.repoInfo.namespace) &&
	            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
	        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, false) +
	            'must be a valid firebase URL and ' +
	            'the path can\'t contain ".", "#", "$", "[", or "]".');
	    }
	};
	var validateBoolean = function (fnName, argumentNumber, bool, optional) {
	    if (optional && bool === undefined) {
	        return;
	    }
	    if (typeof bool !== 'boolean') {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
	    }
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 */
	var OnDisconnect = /** @class */ (function () {
	    /**
	     * @param {!Repo} repo_
	     * @param {!Path} path_
	     */
	    function OnDisconnect(repo_, path_) {
	        this.repo_ = repo_;
	        this.path_ = path_;
	    }
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.cancel = function (onComplete) {
	        util.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
	        util.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.remove = function (onComplete) {
	        util.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
	        validateWritablePath('OnDisconnect.remove', this.path_);
	        util.validateCallback('OnDisconnect.remove', 1, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.set = function (value, onComplete) {
	        util.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
	        validateWritablePath('OnDisconnect.set', this.path_);
	        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
	        util.validateCallback('OnDisconnect.set', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {number|string|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
	        util.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
	        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
	        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
	        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
	        util.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
	        util.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
	        validateWritablePath('OnDisconnect.update', this.path_);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
	                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
	        }
	        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
	        util.validateCallback('OnDisconnect.update', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    return OnDisconnect;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TransactionResult = /** @class */ (function () {
	    /**
	     * A type for the resolve value of Firebase.transaction.
	     * @constructor
	     * @dict
	     * @param {boolean} committed
	     * @param {DataSnapshot} snapshot
	     */
	    function TransactionResult(committed, snapshot) {
	        this.committed = committed;
	        this.snapshot = snapshot;
	    }
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    TransactionResult.prototype.toJSON = function () {
	        util.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
	        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
	    };
	    return TransactionResult;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Fancy ID generator that creates 20-character string identifiers with the
	 * following properties:
	 *
	 * 1. They're based on timestamp so that they sort *after* any existing ids.
	 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
	 *    collide with other clients' IDs.
	 * 3. They sort *lexicographically* (so the timestamp is converted to characters
	 *    that will sort properly).
	 * 4. They're monotonically increasing. Even if you generate more than one in
	 *    the same timestamp, the latter ones will sort after the former ones. We do
	 *    this by using the previous random bits but "incrementing" them by 1 (only
	 *    in the case of a timestamp collision).
	 */
	var nextPushId = (function () {
	    // Modeled after base64 web-safe chars, but ordered by ASCII.
	    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
	    // Timestamp of last push, used to prevent local collisions if you push twice
	    // in one ms.
	    var lastPushTime = 0;
	    // We generate 72-bits of randomness which get turned into 12 characters and
	    // appended to the timestamp to prevent collisions with other clients. We
	    // store the last characters we generated because in the event of a collision,
	    // we'll use those same characters except "incremented" by one.
	    var lastRandChars = [];
	    return function (now) {
	        var duplicateTime = now === lastPushTime;
	        lastPushTime = now;
	        var i;
	        var timeStampChars = new Array(8);
	        for (i = 7; i >= 0; i--) {
	            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
	            // NOTE: Can't use << here because javascript will convert to int and lose
	            // the upper bits.
	            now = Math.floor(now / 64);
	        }
	        util.assert(now === 0, 'Cannot push at time == 0');
	        var id = timeStampChars.join('');
	        if (!duplicateTime) {
	            for (i = 0; i < 12; i++) {
	                lastRandChars[i] = Math.floor(Math.random() * 64);
	            }
	        }
	        else {
	            // If the timestamp hasn't changed since last push, use the same random
	            // number, except incremented by 1.
	            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
	                lastRandChars[i] = 0;
	            }
	            lastRandChars[i]++;
	        }
	        for (i = 0; i < 12; i++) {
	            id += PUSH_CHARS.charAt(lastRandChars[i]);
	        }
	        util.assert(id.length === 20, 'nextPushId: Length should be 20.');
	        return id;
	    };
	})();
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @param {!string} name
	 * @param {!Node} node
	 * @constructor
	 * @struct
	 */
	var NamedNode = /** @class */ (function () {
	    function NamedNode(name, node) {
	        this.name = name;
	        this.node = node;
	    }
	    /**
	     *
	     * @param {!string} name
	     * @param {!Node} node
	     * @return {NamedNode}
	     */
	    NamedNode.Wrap = function (name, node) {
	        return new NamedNode(name, node);
	    };
	    return NamedNode;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @constructor
	 */
	var Index = /** @class */ (function () {
	    function Index() {
	    }
	    /**
	     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
	     * this index
	     */
	    Index.prototype.getCompare = function () {
	        return this.compare.bind(this);
	    };
	    /**
	     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
	     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
	     *
	     * @param {!Node} oldNode
	     * @param {!Node} newNode
	     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
	     */
	    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
	        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
	        var newWrapped = new NamedNode(MIN_NAME, newNode);
	        return this.compare(oldWrapped, newWrapped) !== 0;
	    };
	    /**
	     * @return {!NamedNode} a node wrapper that will sort equal to or less than
	     * any other node wrapper, using this index
	     */
	    Index.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    return Index;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __EMPTY_NODE;
	var KeyIndex = /** @class */ (function (_super) {
	    tslib.__extends(KeyIndex, _super);
	    function KeyIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
	        get: function () {
	            return __EMPTY_NODE;
	        },
	        set: function (val) {
	            __EMPTY_NODE = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.compare = function (a, b) {
	        return nameCompare(a.name, b.name);
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.isDefinedOn = function (node) {
	        // We could probably return true here (since every node has a key), but it's never called
	        // so just leaving unimplemented for now.
	        throw util.assertionError('KeyIndex.isDefinedOn not expected to be called.');
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return false; // The key for a node never changes.
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.maxPost = function () {
	        // TODO: This should really be created once and cached in a static property, but
	        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
	        return new NamedNode(MAX_NAME, __EMPTY_NODE);
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    KeyIndex.prototype.makePost = function (indexValue, name) {
	        util.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
	        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
	        return new NamedNode(indexValue, __EMPTY_NODE);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    KeyIndex.prototype.toString = function () {
	        return '.key';
	    };
	    return KeyIndex;
	}(Index));
	var KEY_INDEX = new KeyIndex();
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MAX_NODE;
	function setMaxNode(val) {
	    MAX_NODE = val;
	}
	/**
	 * @param {(!string|!number)} priority
	 * @return {!string}
	 */
	var priorityHashText = function (priority) {
	    if (typeof priority === 'number') {
	        return 'number:' + doubleToIEEE754String(priority);
	    }
	    else {
	        return 'string:' + priority;
	    }
	};
	/**
	 * Validates that a priority snapshot Node is valid.
	 *
	 * @param {!Node} priorityNode
	 */
	var validatePriorityNode = function (priorityNode) {
	    if (priorityNode.isLeafNode()) {
	        var val = priorityNode.val();
	        util.assert(typeof val === 'string' ||
	            typeof val === 'number' ||
	            (typeof val === 'object' && util.contains(val, '.sv')), 'Priority must be a string or number.');
	    }
	    else {
	        util.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
	    }
	    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
	    util.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __childrenNodeConstructor;
	/**
	 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
	 * implements Node and stores the value of the node (a string,
	 * number, or boolean) accessible via getValue().
	 */
	var LeafNode = /** @class */ (function () {
	    /**
	     * @implements {Node}
	     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
	     *                                         The object type is possible in the event of a deferred value
	     * @param {!Node=} priorityNode_ The priority of this node.
	     */
	    function LeafNode(value_, priorityNode_) {
	        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
	        this.value_ = value_;
	        this.priorityNode_ = priorityNode_;
	        this.lazyHash_ = null;
	        util.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
	        validatePriorityNode(this.priorityNode_);
	    }
	    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
	        get: function () {
	            return __childrenNodeConstructor;
	        },
	        set: function (val) {
	            __childrenNodeConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @inheritDoc */
	    LeafNode.prototype.isLeafNode = function () {
	        return true;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPriority = function () {
	        return this.priorityNode_;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updatePriority = function (newPriorityNode) {
	        return new LeafNode(this.value_, newPriorityNode);
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getChild = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else if (path.getFront() === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.hasChild = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
	        return null;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else if (newChildNode.isEmpty() && childName !== '.priority') {
	            return this;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else if (newChildNode.isEmpty() && front !== '.priority') {
	            return this;
	        }
	        else {
	            util.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.numChildren = function () {
	        return 0;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.forEachChild = function (index, action) {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.val = function (exportFormat) {
	        if (exportFormat && !this.getPriority().isEmpty()) {
	            return {
	                '.value': this.getValue(),
	                '.priority': this.getPriority().val()
	            };
	        }
	        else {
	            return this.getValue();
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash = '';
	            if (!this.priorityNode_.isEmpty()) {
	                toHash +=
	                    'priority:' +
	                        priorityHashText(this.priorityNode_.val()) +
	                        ':';
	            }
	            var type = typeof this.value_;
	            toHash += type + ':';
	            if (type === 'number') {
	                toHash += doubleToIEEE754String(this.value_);
	            }
	            else {
	                toHash += this.value_;
	            }
	            this.lazyHash_ = sha1(toHash);
	        }
	        return this.lazyHash_;
	    };
	    /**
	     * Returns the value of the leaf node.
	     * @return {Object|string|number|boolean} The value of the node.
	     */
	    LeafNode.prototype.getValue = function () {
	        return this.value_;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.compareTo = function (other) {
	        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
	            return 1;
	        }
	        else if (other instanceof LeafNode.__childrenNodeConstructor) {
	            return -1;
	        }
	        else {
	            util.assert(other.isLeafNode(), 'Unknown node type');
	            return this.compareToLeafNode_(other);
	        }
	    };
	    /**
	     * Comparison specifically for two leaf nodes
	     * @param {!LeafNode} otherLeaf
	     * @return {!number}
	     * @private
	     */
	    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
	        var otherLeafType = typeof otherLeaf.value_;
	        var thisLeafType = typeof this.value_;
	        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
	        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
	        util.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
	        util.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
	        if (otherIndex === thisIndex) {
	            // Same type, compare values
	            if (thisLeafType === 'object') {
	                // Deferred value nodes are all equal, but we should also never get to this point...
	                return 0;
	            }
	            else {
	                // Note that this works because true > false, all others are number or string comparisons
	                if (this.value_ < otherLeaf.value_) {
	                    return -1;
	                }
	                else if (this.value_ === otherLeaf.value_) {
	                    return 0;
	                }
	                else {
	                    return 1;
	                }
	            }
	        }
	        else {
	            return thisIndex - otherIndex;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.withIndex = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.isIndexed = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.equals = function (other) {
	        /**
	         * @inheritDoc
	         */
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            var otherLeaf = other;
	            return (this.value_ === otherLeaf.value_ &&
	                this.priorityNode_.equals(otherLeaf.priorityNode_));
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
	     * the same type, the comparison falls back to their value
	     * @type {Array.<!string>}
	     * @const
	     */
	    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
	    return LeafNode;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var nodeFromJSON;
	var MAX_NODE$1;
	function setNodeFromJSON(val) {
	    nodeFromJSON = val;
	}
	function setMaxNode$1(val) {
	    MAX_NODE$1 = val;
	}
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var PriorityIndex = /** @class */ (function (_super) {
	    tslib.__extends(PriorityIndex, _super);
	    function PriorityIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.compare = function (a, b) {
	        var aPriority = a.node.getPriority();
	        var bPriority = b.node.getPriority();
	        var indexCmp = aPriority.compareTo(bPriority);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.isDefinedOn = function (node) {
	        return !node.getPriority().isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.getPriority().equals(newNode.getPriority());
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.maxPost = function () {
	        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    PriorityIndex.prototype.makePost = function (indexValue, name) {
	        var priorityNode = nodeFromJSON(indexValue);
	        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    PriorityIndex.prototype.toString = function () {
	        return '.priority';
	    };
	    return PriorityIndex;
	}(Index));
	var PRIORITY_INDEX = new PriorityIndex();
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An iterator over an LLRBNode.
	 */
	var SortedMapIterator = /** @class */ (function () {
	    /**
	     * @template K, V, T
	     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
	     * @param {?K} startKey
	     * @param {function(K, K): number} comparator
	     * @param {boolean} isReverse_ Whether or not to iterate in reverse
	     * @param {(function(K, V):T)=} resultGenerator_
	     */
	    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
	        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
	        this.isReverse_ = isReverse_;
	        this.resultGenerator_ = resultGenerator_;
	        /** @private
	         * @type {Array.<!LLRBNode>}
	         */
	        this.nodeStack_ = [];
	        var cmp = 1;
	        while (!node.isEmpty()) {
	            node = node;
	            cmp = startKey ? comparator(node.key, startKey) : 1;
	            // flip the comparison if we're going in reverse
	            if (isReverse_) {
	                cmp *= -1;
	            }
	            if (cmp < 0) {
	                // This node is less than our start key. ignore it
	                if (this.isReverse_) {
	                    node = node.left;
	                }
	                else {
	                    node = node.right;
	                }
	            }
	            else if (cmp === 0) {
	                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
	                this.nodeStack_.push(node);
	                break;
	            }
	            else {
	                // This node is greater than our start key, add it to the stack and move to the next one
	                this.nodeStack_.push(node);
	                if (this.isReverse_) {
	                    node = node.right;
	                }
	                else {
	                    node = node.left;
	                }
	            }
	        }
	    }
	    SortedMapIterator.prototype.getNext = function () {
	        if (this.nodeStack_.length === 0) {
	            return null;
	        }
	        var node = this.nodeStack_.pop();
	        var result;
	        if (this.resultGenerator_) {
	            result = this.resultGenerator_(node.key, node.value);
	        }
	        else {
	            result = { key: node.key, value: node.value };
	        }
	        if (this.isReverse_) {
	            node = node.left;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.right;
	            }
	        }
	        else {
	            node = node.right;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.left;
	            }
	        }
	        return result;
	    };
	    SortedMapIterator.prototype.hasNext = function () {
	        return this.nodeStack_.length > 0;
	    };
	    SortedMapIterator.prototype.peek = function () {
	        if (this.nodeStack_.length === 0) {
	            return null;
	        }
	        var node = this.nodeStack_[this.nodeStack_.length - 1];
	        if (this.resultGenerator_) {
	            return this.resultGenerator_(node.key, node.value);
	        }
	        else {
	            return { key: node.key, value: node.value };
	        }
	    };
	    return SortedMapIterator;
	}());
	/**
	 * Represents a node in a Left-leaning Red-Black tree.
	 */
	var LLRBNode = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {!K} key Key associated with this node.
	     * @param {!V} value Value associated with this node.
	     * @param {?boolean} color Whether this node is red.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
	     */
	    function LLRBNode(key, value, color, left, right) {
	        this.key = key;
	        this.value = value;
	        this.color = color != null ? color : LLRBNode.RED;
	        this.left =
	            left != null ? left : SortedMap.EMPTY_NODE;
	        this.right =
	            right != null ? right : SortedMap.EMPTY_NODE;
	    }
	    /**
	     * Returns a copy of the current node, optionally replacing pieces of it.
	     *
	     * @param {?K} key New key for the node, or null.
	     * @param {?V} value New value for the node, or null.
	     * @param {?boolean} color New color for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
	     * @return {!LLRBNode} The node copy.
	     */
	    LLRBNode.prototype.copy = function (key, value, color, left, right) {
	        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBNode.prototype.count = function () {
	        return this.left.count() + 1 + this.right.count();
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     *   node.  If it returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    LLRBNode.prototype.inorderTraversal = function (action) {
	        return (this.left.inorderTraversal(action) ||
	            !!action(this.key, this.value) ||
	            this.right.inorderTraversal(action));
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {*} True if traversal was aborted.
	     */
	    LLRBNode.prototype.reverseTraversal = function (action) {
	        return (this.right.reverseTraversal(action) ||
	            action(this.key, this.value) ||
	            this.left.reverseTraversal(action));
	    };
	    /**
	     * @return {!Object} The minimum node in the tree.
	     * @private
	     */
	    LLRBNode.prototype.min_ = function () {
	        if (this.left.isEmpty()) {
	            return this;
	        }
	        else {
	            return this.left.min_();
	        }
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.minKey = function () {
	        return this.min_().key;
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.maxKey = function () {
	        if (this.right.isEmpty()) {
	            return this.key;
	        }
	        else {
	            return this.right.maxKey();
	        }
	    };
	    /**
	     *
	     * @param {!Object} key Key to insert.
	     * @param {!Object} value Value to insert.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with the key/value added.
	     */
	    LLRBNode.prototype.insert = function (key, value, comparator) {
	        var n = this;
	        var cmp = comparator(key, n.key);
	        if (cmp < 0) {
	            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
	        }
	        else if (cmp === 0) {
	            n = n.copy(null, value, null, null, null);
	        }
	        else {
	            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
	     */
	    LLRBNode.prototype.removeMin_ = function () {
	        if (this.left.isEmpty()) {
	            return SortedMap.EMPTY_NODE;
	        }
	        var n = this;
	        if (!n.left.isRed_() && !n.left.left.isRed_()) {
	            n = n.moveRedLeft_();
	        }
	        n = n.copy(null, null, null, n.left.removeMin_(), null);
	        return n.fixUp_();
	    };
	    /**
	     * @param {!Object} key The key of the item to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
	     */
	    LLRBNode.prototype.remove = function (key, comparator) {
	        var n, smallest;
	        n = this;
	        if (comparator(key, n.key) < 0) {
	            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
	                n = n.moveRedLeft_();
	            }
	            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
	        }
	        else {
	            if (n.left.isRed_()) {
	                n = n.rotateRight_();
	            }
	            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
	                n = n.moveRedRight_();
	            }
	            if (comparator(key, n.key) === 0) {
	                if (n.right.isEmpty()) {
	                    return SortedMap.EMPTY_NODE;
	                }
	                else {
	                    smallest = n.right.min_();
	                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
	                }
	            }
	            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this is a RED node.
	     */
	    LLRBNode.prototype.isRed_ = function () {
	        return this.color;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree after performing any needed rotations.
	     */
	    LLRBNode.prototype.fixUp_ = function () {
	        var n = this;
	        if (n.right.isRed_() && !n.left.isRed_()) {
	            n = n.rotateLeft_();
	        }
	        if (n.left.isRed_() && n.left.left.isRed_()) {
	            n = n.rotateRight_();
	        }
	        if (n.left.isRed_() && n.right.isRed_()) {
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedLeft.
	     */
	    LLRBNode.prototype.moveRedLeft_ = function () {
	        var n = this.colorFlip_();
	        if (n.right.left.isRed_()) {
	            n = n.copy(null, null, null, null, n.right.rotateRight_());
	            n = n.rotateLeft_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedRight.
	     */
	    LLRBNode.prototype.moveRedRight_ = function () {
	        var n = this.colorFlip_();
	        if (n.left.left.isRed_()) {
	            n = n.rotateRight_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateLeft.
	     */
	    LLRBNode.prototype.rotateLeft_ = function () {
	        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, nl, null);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateRight.
	     */
	    LLRBNode.prototype.rotateRight_ = function () {
	        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, nr);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after colorFlip.
	     */
	    LLRBNode.prototype.colorFlip_ = function () {
	        var left = this.left.copy(null, null, !this.left.color, null, null);
	        var right = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, left, right);
	    };
	    /**
	     * For testing.
	     *
	     * @private
	     * @return {boolean} True if all is well.
	     */
	    LLRBNode.prototype.checkMaxDepth_ = function () {
	        var blackDepth = this.check_();
	        return Math.pow(2.0, blackDepth) <= this.count() + 1;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBNode.prototype.check_ = function () {
	        if (this.isRed_() && this.left.isRed_()) {
	            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
	        }
	        if (this.right.isRed_()) {
	            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
	        }
	        var blackDepth = this.left.check_();
	        if (blackDepth !== this.right.check_()) {
	            throw new Error('Black depths differ');
	        }
	        else {
	            return blackDepth + (this.isRed_() ? 0 : 1);
	        }
	    };
	    LLRBNode.RED = true;
	    LLRBNode.BLACK = false;
	    return LLRBNode;
	}());
	/**
	 * Represents an empty node (a leaf node in the Red-Black Tree).
	 */
	var LLRBEmptyNode = /** @class */ (function () {
	    function LLRBEmptyNode() {
	    }
	    /**
	     * Returns a copy of the current node.
	     *
	     * @return {!LLRBEmptyNode} The node copy.
	     */
	    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
	        return this;
	    };
	    /**
	     * Returns a copy of the tree, with the specified key/value added.
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with item added.
	     */
	    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
	        return new LLRBNode(key, value, null);
	    };
	    /**
	     * Returns a copy of the tree, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBEmptyNode} New tree, with item removed.
	     */
	    LLRBEmptyNode.prototype.remove = function (key, comparator) {
	        return this;
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBEmptyNode.prototype.count = function () {
	        return 0;
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBEmptyNode.prototype.isEmpty = function () {
	        return true;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
	        return false;
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
	        return false;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.minKey = function () {
	        return null;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.maxKey = function () {
	        return null;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBEmptyNode.prototype.check_ = function () {
	        return 0;
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this node is red.
	     */
	    LLRBEmptyNode.prototype.isRed_ = function () {
	        return false;
	    };
	    return LLRBEmptyNode;
	}());
	/**
	 * An immutable sorted map implementation, based on a Left-leaning Red-Black
	 * tree.
	 */
	var SortedMap = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {function(K, K):number} comparator_ Key comparator.
	     * @param {LLRBNode=} root_ (Optional) Root node for the map.
	     */
	    function SortedMap(comparator_, root_) {
	        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
	        this.comparator_ = comparator_;
	        this.root_ = root_;
	    }
	    /**
	     * Returns a copy of the map, with the specified key/value added or replaced.
	     * (TODO: We should perhaps rename this method to 'put')
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @return {!SortedMap.<K, V>} New map, with item added.
	     */
	    SortedMap.prototype.insert = function (key, value) {
	        return new SortedMap(this.comparator_, this.root_
	            .insert(key, value, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns a copy of the map, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @return {!SortedMap.<K, V>} New map, with item removed.
	     */
	    SortedMap.prototype.remove = function (key) {
	        return new SortedMap(this.comparator_, this.root_
	            .remove(key, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns the value of the node with the given key, or null.
	     *
	     * @param {!K} key The key to look up.
	     * @return {?V} The value of the node with the given key, or null if the
	     * key doesn't exist.
	     */
	    SortedMap.prototype.get = function (key) {
	        var cmp;
	        var node = this.root_;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                return node.value;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                node = node.right;
	            }
	        }
	        return null;
	    };
	    /**
	     * Returns the key of the item *before* the specified key, or null if key is the first item.
	     * @param {K} key The key to find the predecessor of
	     * @return {?K} The predecessor key.
	     */
	    SortedMap.prototype.getPredecessorKey = function (key) {
	        var cmp, node = this.root_, rightParent = null;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                if (!node.left.isEmpty()) {
	                    node = node.left;
	                    while (!node.right.isEmpty()) {
	                        node = node.right;
	                    }
	                    return node.key;
	                }
	                else if (rightParent) {
	                    return rightParent.key;
	                }
	                else {
	                    return null; // first item.
	                }
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                rightParent = node;
	                node = node.right;
	            }
	        }
	        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
	    };
	    /**
	     * @return {boolean} True if the map is empty.
	     */
	    SortedMap.prototype.isEmpty = function () {
	        return this.root_.isEmpty();
	    };
	    /**
	     * @return {number} The total number of nodes in the map.
	     */
	    SortedMap.prototype.count = function () {
	        return this.root_.count();
	    };
	    /**
	     * @return {?K} The minimum key in the map.
	     */
	    SortedMap.prototype.minKey = function () {
	        return this.root_.minKey();
	    };
	    /**
	     * @return {?K} The maximum key in the map.
	     */
	    SortedMap.prototype.maxKey = function () {
	        return this.root_.maxKey();
	    };
	    /**
	     * Traverses the map in key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    SortedMap.prototype.inorderTraversal = function (action) {
	        return this.root_.inorderTraversal(action);
	    };
	    /**
	     * Traverses the map in reverse key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} True if the traversal was aborted.
	     */
	    SortedMap.prototype.reverseTraversal = function (action) {
	        return this.root_.reverseTraversal(action);
	    };
	    /**
	     * Returns an iterator over the SortedMap.
	     * @template T
	     * @param {(function(K, V):T)=} resultGenerator
	     * @return {SortedMapIterator.<K, V, T>} The iterator.
	     */
	    SortedMap.prototype.getIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
	    };
	    /**
	     * Always use the same empty node, to reduce memory.
	     * @const
	     */
	    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
	    return SortedMap;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_2 = Math.log(2);
	/**
	 * @constructor
	 */
	var Base12Num = /** @class */ (function () {
	    /**
	     * @param {number} length
	     */
	    function Base12Num(length) {
	        var logBase2 = function (num) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            return parseInt((Math.log(num) / LOG_2), 10);
	        };
	        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
	        this.count = logBase2(length + 1);
	        this.current_ = this.count - 1;
	        var mask = bitMask(this.count);
	        this.bits_ = (length + 1) & mask;
	    }
	    /**
	     * @return {boolean}
	     */
	    Base12Num.prototype.nextBitIsOne = function () {
	        //noinspection JSBitwiseOperatorUsage
	        var result = !(this.bits_ & (0x1 << this.current_));
	        this.current_--;
	        return result;
	    };
	    return Base12Num;
	}());
	/**
	 * Takes a list of child nodes and constructs a SortedSet using the given comparison
	 * function
	 *
	 * Uses the algorithm described in the paper linked here:
	 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
	 *
	 * @template K, V
	 * @param {Array.<!NamedNode>} childList Unsorted list of children
	 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
	 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
	 *                                                        type is not NamedNode
	 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
	 * @return {SortedMap.<K, V>}
	 */
	var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
	    childList.sort(cmp);
	    var buildBalancedTree = function (low, high) {
	        var length = high - low;
	        var namedNode;
	        var key;
	        if (length === 0) {
	            return null;
	        }
	        else if (length === 1) {
	            namedNode = childList[low];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
	        }
	        else {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var middle = parseInt((length / 2), 10) + low;
	            var left = buildBalancedTree(low, middle);
	            var right = buildBalancedTree(middle + 1, high);
	            namedNode = childList[middle];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
	        }
	    };
	    var buildFrom12Array = function (base12) {
	        var node = null;
	        var root = null;
	        var index = childList.length;
	        var buildPennant = function (chunkSize, color) {
	            var low = index - chunkSize;
	            var high = index;
	            index -= chunkSize;
	            var childTree = buildBalancedTree(low + 1, high);
	            var namedNode = childList[low];
	            var key = keyFn ? keyFn(namedNode) : namedNode;
	            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
	        };
	        var attachPennant = function (pennant) {
	            if (node) {
	                node.left = pennant;
	                node = pennant;
	            }
	            else {
	                root = pennant;
	                node = pennant;
	            }
	        };
	        for (var i = 0; i < base12.count; ++i) {
	            var isOne = base12.nextBitIsOne();
	            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
	            var chunkSize = Math.pow(2, base12.count - (i + 1));
	            if (isOne) {
	                buildPennant(chunkSize, LLRBNode.BLACK);
	            }
	            else {
	                // current == 2
	                buildPennant(chunkSize, LLRBNode.BLACK);
	                buildPennant(chunkSize, LLRBNode.RED);
	            }
	        }
	        return root;
	    };
	    var base12 = new Base12Num(childList.length);
	    var root = buildFrom12Array(base12);
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return new SortedMap(mapSortFn || cmp, root);
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _defaultIndexMap;
	var fallbackObject = {};
	var IndexMap = /** @class */ (function () {
	    function IndexMap(indexes_, indexSet_) {
	        this.indexes_ = indexes_;
	        this.indexSet_ = indexSet_;
	    }
	    Object.defineProperty(IndexMap, "Default", {
	        /**
	         * The default IndexMap for nodes without a priority
	         */
	        get: function () {
	            util.assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
	            _defaultIndexMap =
	                _defaultIndexMap ||
	                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
	            return _defaultIndexMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    IndexMap.prototype.get = function (indexKey) {
	        var sortedMap = util.safeGet(this.indexes_, indexKey);
	        if (!sortedMap) {
	            throw new Error('No index defined for ' + indexKey);
	        }
	        if (sortedMap instanceof SortedMap) {
	            return sortedMap;
	        }
	        else {
	            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
	            // regular child map
	            return null;
	        }
	    };
	    IndexMap.prototype.hasIndex = function (indexDefinition) {
	        return util.contains(this.indexSet_, indexDefinition.toString());
	    };
	    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
	        util.assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
	        var childList = [];
	        var sawIndexedValue = false;
	        var iter = existingChildren.getIterator(NamedNode.Wrap);
	        var next = iter.getNext();
	        while (next) {
	            sawIndexedValue =
	                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
	            childList.push(next);
	            next = iter.getNext();
	        }
	        var newIndex;
	        if (sawIndexedValue) {
	            newIndex = buildChildSet(childList, indexDefinition.getCompare());
	        }
	        else {
	            newIndex = fallbackObject;
	        }
	        var indexName = indexDefinition.toString();
	        var newIndexSet = tslib.__assign({}, this.indexSet_);
	        newIndexSet[indexName] = indexDefinition;
	        var newIndexes = tslib.__assign({}, this.indexes_);
	        newIndexes[indexName] = newIndex;
	        return new IndexMap(newIndexes, newIndexSet);
	    };
	    /**
	     * Ensure that this node is properly tracked in any indexes that we're maintaining
	     */
	    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
	        var _this = this;
	        var newIndexes = util.map(this.indexes_, function (indexedChildren, indexName) {
	            var index = util.safeGet(_this.indexSet_, indexName);
	            util.assert(index, 'Missing index implementation for ' + indexName);
	            if (indexedChildren === fallbackObject) {
	                // Check to see if we need to index everything
	                if (index.isDefinedOn(namedNode.node)) {
	                    // We need to build this index
	                    var childList = [];
	                    var iter = existingChildren.getIterator(NamedNode.Wrap);
	                    var next = iter.getNext();
	                    while (next) {
	                        if (next.name !== namedNode.name) {
	                            childList.push(next);
	                        }
	                        next = iter.getNext();
	                    }
	                    childList.push(namedNode);
	                    return buildChildSet(childList, index.getCompare());
	                }
	                else {
	                    // No change, this remains a fallback
	                    return fallbackObject;
	                }
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                var newChildren = indexedChildren;
	                if (existingSnap) {
	                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
	                }
	                return newChildren.insert(namedNode, namedNode.node);
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    /**
	     * Create a new IndexMap instance with the given value removed
	     */
	    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
	        var newIndexes = util.map(this.indexes_, function (indexedChildren) {
	            if (indexedChildren === fallbackObject) {
	                // This is the fallback. Just return it, nothing to do in this case
	                return indexedChildren;
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                if (existingSnap) {
	                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
	                }
	                else {
	                    // No record of this child
	                    return indexedChildren;
	                }
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    return IndexMap;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function NAME_ONLY_COMPARATOR(left, right) {
	    return nameCompare(left.name, right.name);
	}
	function NAME_COMPARATOR(left, right) {
	    return nameCompare(left, right);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// TODO: For memory savings, don't store priorityNode_ if it's empty.
	var EMPTY_NODE;
	/**
	 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
	 * (i.e. nodes with children).  It implements Node and stores the
	 * list of children in the children property, sorted by child name.
	 *
	 * @constructor
	 * @implements {Node}
	 */
	var ChildrenNode = /** @class */ (function () {
	    /**
	     *
	     * @param {!SortedMap.<string, !Node>} children_ List of children
	     * of this node..
	     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
	     * @param {!IndexMap} indexMap_
	     */
	    function ChildrenNode(children_, priorityNode_, indexMap_) {
	        this.children_ = children_;
	        this.priorityNode_ = priorityNode_;
	        this.indexMap_ = indexMap_;
	        this.lazyHash_ = null;
	        /**
	         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
	         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
	         * class instead of an empty ChildrenNode.
	         */
	        if (this.priorityNode_) {
	            validatePriorityNode(this.priorityNode_);
	        }
	        if (this.children_.isEmpty()) {
	            util.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
	        }
	    }
	    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
	        get: function () {
	            return (EMPTY_NODE ||
	                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @inheritDoc */
	    ChildrenNode.prototype.isLeafNode = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPriority = function () {
	        return this.priorityNode_ || EMPTY_NODE;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
	        if (this.children_.isEmpty()) {
	            // Don't allow priorities on empty nodes
	            return this;
	        }
	        else {
	            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.getPriority();
	        }
	        else {
	            var child = this.children_.get(childName);
	            return child === null ? EMPTY_NODE : child;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getChild = function (path) {
	        var front = path.getFront();
	        if (front === null) {
	            return this;
	        }
	        return this.getImmediateChild(front).getChild(path.popFront());
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hasChild = function (childName) {
	        return this.children_.get(childName) !== null;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        util.assert(newChildNode, 'We should always be passing snapshot nodes');
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else {
	            var namedNode = new NamedNode(childName, newChildNode);
	            var newChildren = void 0, newIndexMap = void 0;
	            if (newChildNode.isEmpty()) {
	                newChildren = this.children_.remove(childName);
	                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
	            }
	            else {
	                newChildren = this.children_.insert(childName, newChildNode);
	                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
	            }
	            var newPriority = newChildren.isEmpty()
	                ? EMPTY_NODE
	                : this.priorityNode_;
	            return new ChildrenNode(newChildren, newPriority, newIndexMap);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else {
	            util.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
	            return this.updateImmediateChild(front, newImmediateChild);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.isEmpty = function () {
	        return this.children_.isEmpty();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.numChildren = function () {
	        return this.children_.count();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.val = function (exportFormat) {
	        if (this.isEmpty()) {
	            return null;
	        }
	        var obj = {};
	        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
	        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	            obj[key] = childNode.val(exportFormat);
	            numKeys++;
	            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
	                maxKey = Math.max(maxKey, Number(key));
	            }
	            else {
	                allIntegerKeys = false;
	            }
	        });
	        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
	            // convert to array.
	            var array = [];
	            // eslint-disable-next-line guard-for-in
	            for (var key in obj) {
	                array[key] = obj[key];
	            }
	            return array;
	        }
	        else {
	            if (exportFormat && !this.getPriority().isEmpty()) {
	                obj['.priority'] = this.getPriority().val();
	            }
	            return obj;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash_1 = '';
	            if (!this.getPriority().isEmpty()) {
	                toHash_1 +=
	                    'priority:' +
	                        priorityHashText(this.getPriority().val()) +
	                        ':';
	            }
	            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                var childHash = childNode.hash();
	                if (childHash !== '') {
	                    toHash_1 += ':' + key + ':' + childHash;
	                }
	            });
	            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
	        }
	        return this.lazyHash_;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
	            return predecessor ? predecessor.name : null;
	        }
	        else {
	            return this.children_.getPredecessorKey(childName);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var minKey = idx.minKey();
	            return minKey && minKey.name;
	        }
	        else {
	            return this.children_.minKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
	        var minKey = this.getFirstChildName(indexDefinition);
	        if (minKey) {
	            return new NamedNode(minKey, this.children_.get(minKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Given an index, return the key name of the largest value we have, according to that index
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var maxKey = idx.maxKey();
	            return maxKey && maxKey.name;
	        }
	        else {
	            return this.children_.maxKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
	        var maxKey = this.getLastChildName(indexDefinition);
	        if (maxKey) {
	            return new NamedNode(maxKey, this.children_.get(maxKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.forEachChild = function (index, action) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            return idx.inorderTraversal(function (wrappedNode) {
	                return action(wrappedNode.name, wrappedNode.node);
	            });
	        }
	        else {
	            return this.children_.inorderTraversal(action);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIterator = function (indexDefinition) {
	        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
	    };
	    /**
	     *
	     * @param {!NamedNode} startPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getIteratorFrom(startPost, function (key) { return key; });
	        }
	        else {
	            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, startPost) < 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
	        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
	    };
	    /**
	     * @param {!NamedNode} endPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getReverseIteratorFrom(endPost, function (key) {
	                return key;
	            });
	        }
	        else {
	            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, endPost) > 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.compareTo = function (other) {
	        if (this.isEmpty()) {
	            if (other.isEmpty()) {
	                return 0;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (other.isLeafNode() || other.isEmpty()) {
	            return 1;
	        }
	        else if (other === MAX_NODE$2) {
	            return -1;
	        }
	        else {
	            // Must be another node with children.
	            return 0;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.withIndex = function (indexDefinition) {
	        if (indexDefinition === KEY_INDEX ||
	            this.indexMap_.hasIndex(indexDefinition)) {
	            return this;
	        }
	        else {
	            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
	            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.isIndexed = function (index) {
	        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            return false;
	        }
	        else {
	            var otherChildrenNode = other;
	            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
	                return false;
	            }
	            else if (this.children_.count() === otherChildrenNode.children_.count()) {
	                var thisIter = this.getIterator(PRIORITY_INDEX);
	                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
	                var thisCurrent = thisIter.getNext();
	                var otherCurrent = otherIter.getNext();
	                while (thisCurrent && otherCurrent) {
	                    if (thisCurrent.name !== otherCurrent.name ||
	                        !thisCurrent.node.equals(otherCurrent.node)) {
	                        return false;
	                    }
	                    thisCurrent = thisIter.getNext();
	                    otherCurrent = otherIter.getNext();
	                }
	                return thisCurrent === null && otherCurrent === null;
	            }
	            else {
	                return false;
	            }
	        }
	    };
	    /**
	     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
	     * instead.
	     *
	     * @private
	     * @param {!Index} indexDefinition
	     * @return {?SortedMap.<NamedNode, Node>}
	     */
	    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
	        if (indexDefinition === KEY_INDEX) {
	            return null;
	        }
	        else {
	            return this.indexMap_.get(indexDefinition.toString());
	        }
	    };
	    /**
	     * @private
	     * @type {RegExp}
	     */
	    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
	    return ChildrenNode;
	}());
	/**
	 * @constructor
	 * @extends {ChildrenNode}
	 * @private
	 */
	var MaxNode = /** @class */ (function (_super) {
	    tslib.__extends(MaxNode, _super);
	    function MaxNode() {
	        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
	    }
	    MaxNode.prototype.compareTo = function (other) {
	        if (other === this) {
	            return 0;
	        }
	        else {
	            return 1;
	        }
	    };
	    MaxNode.prototype.equals = function (other) {
	        // Not that we every compare it, but MAX_NODE is only ever equal to itself
	        return other === this;
	    };
	    MaxNode.prototype.getPriority = function () {
	        return this;
	    };
	    MaxNode.prototype.getImmediateChild = function (childName) {
	        return ChildrenNode.EMPTY_NODE;
	    };
	    MaxNode.prototype.isEmpty = function () {
	        return false;
	    };
	    return MaxNode;
	}(ChildrenNode));
	/**
	 * Marker that will sort higher than any other snapshot.
	 * @type {!MAX_NODE}
	 * @const
	 */
	var MAX_NODE$2 = new MaxNode();
	Object.defineProperties(NamedNode, {
	    MIN: {
	        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
	    },
	    MAX: {
	        value: new NamedNode(MAX_NAME, MAX_NODE$2)
	    }
	});
	/**
	 * Reference Extensions
	 */
	KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
	LeafNode.__childrenNodeConstructor = ChildrenNode;
	setMaxNode(MAX_NODE$2);
	setMaxNode$1(MAX_NODE$2);
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var USE_HINZE = true;
	/**
	 * Constructs a snapshot node representing the passed JSON and returns it.
	 * @param {*} json JSON to create a node for.
	 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
	 * passed JSON contains a .priority property.
	 * @return {!Node}
	 */
	function nodeFromJSON$1(json, priority) {
	    if (priority === void 0) { priority = null; }
	    if (json === null) {
	        return ChildrenNode.EMPTY_NODE;
	    }
	    if (typeof json === 'object' && '.priority' in json) {
	        priority = json['.priority'];
	    }
	    util.assert(priority === null ||
	        typeof priority === 'string' ||
	        typeof priority === 'number' ||
	        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
	    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
	        json = json['.value'];
	    }
	    // Valid leaf nodes include non-objects or server-value wrapper objects
	    if (typeof json !== 'object' || '.sv' in json) {
	        var jsonLeaf = json;
	        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
	    }
	    if (!(json instanceof Array) && USE_HINZE) {
	        var children_1 = [];
	        var childrenHavePriority_1 = false;
	        var hinzeJsonObj = json;
	        each(hinzeJsonObj, function (key, child) {
	            if (key.substring(0, 1) !== '.') {
	                // Ignore metadata nodes
	                var childNode = nodeFromJSON$1(child);
	                if (!childNode.isEmpty()) {
	                    childrenHavePriority_1 =
	                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
	                    children_1.push(new NamedNode(key, childNode));
	                }
	            }
	        });
	        if (children_1.length === 0) {
	            return ChildrenNode.EMPTY_NODE;
	        }
	        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
	        if (childrenHavePriority_1) {
	            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
	            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
	        }
	        else {
	            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
	        }
	    }
	    else {
	        var node_1 = ChildrenNode.EMPTY_NODE;
	        each(json, function (key, childData) {
	            if (util.contains(json, key)) {
	                if (key.substring(0, 1) !== '.') {
	                    // ignore metadata nodes.
	                    var childNode = nodeFromJSON$1(childData);
	                    if (childNode.isLeafNode() || !childNode.isEmpty()) {
	                        node_1 = node_1.updateImmediateChild(key, childNode);
	                    }
	                }
	            }
	        });
	        return node_1.updatePriority(nodeFromJSON$1(priority));
	    }
	}
	setNodeFromJSON(nodeFromJSON$1);
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var ValueIndex = /** @class */ (function (_super) {
	    tslib.__extends(ValueIndex, _super);
	    function ValueIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.compare = function (a, b) {
	        var indexCmp = a.node.compareTo(b.node);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.isDefinedOn = function (node) {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.equals(newNode);
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.maxPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MAX;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    ValueIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON$1(indexValue);
	        return new NamedNode(name, valueNode);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    ValueIndex.prototype.toString = function () {
	        return '.value';
	    };
	    return ValueIndex;
	}(Index));
	var VALUE_INDEX = new ValueIndex();
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!Path} indexPath
	 * @constructor
	 * @extends {Index}
	 */
	var PathIndex = /** @class */ (function (_super) {
	    tslib.__extends(PathIndex, _super);
	    function PathIndex(indexPath_) {
	        var _this = _super.call(this) || this;
	        _this.indexPath_ = indexPath_;
	        util.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
	        return _this;
	    }
	    /**
	     * @param {!Node} snap
	     * @return {!Node}
	     * @protected
	     */
	    PathIndex.prototype.extractChild = function (snap) {
	        return snap.getChild(this.indexPath_);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.isDefinedOn = function (node) {
	        return !node.getChild(this.indexPath_).isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.compare = function (a, b) {
	        var aChild = this.extractChild(a.node);
	        var bChild = this.extractChild(b.node);
	        var indexCmp = aChild.compareTo(bChild);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON$1(indexValue);
	        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
	        return new NamedNode(name, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.maxPost = function () {
	        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
	        return new NamedNode(MAX_NAME, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.toString = function () {
	        return this.indexPath_.slice().join('/');
	    };
	    return PathIndex;
	}(Index));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
	 * surfaces the public methods (val, forEach, etc.) we want to expose.
	 */
	var DataSnapshot = /** @class */ (function () {
	    /**
	     * @param {!Node} node_ A SnapshotNode to wrap.
	     * @param {!Reference} ref_ The ref of the location this snapshot came from.
	     * @param {!Index} index_ The iteration order for this snapshot
	     */
	    function DataSnapshot(node_, ref_, index_) {
	        this.node_ = node_;
	        this.ref_ = ref_;
	        this.index_ = index_;
	    }
	    /**
	     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
	     * empty.
	     *
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.val = function () {
	        util.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
	        return this.node_.val();
	    };
	    /**
	     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
	     * the entire node contents.
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.exportVal = function () {
	        util.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
	        return this.node_.val(true);
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    DataSnapshot.prototype.toJSON = function () {
	        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
	        util.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
	        return this.exportVal();
	    };
	    /**
	     * Returns whether the snapshot contains a non-null value.
	     *
	     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
	     */
	    DataSnapshot.prototype.exists = function () {
	        util.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
	        return !this.node_.isEmpty();
	    };
	    /**
	     * Returns a DataSnapshot of the specified child node's contents.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {!DataSnapshot} DataSnapshot for child node.
	     */
	    DataSnapshot.prototype.child = function (childPathString) {
	        util.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
	        // Ensure the childPath is a string (can be a number)
	        childPathString = String(childPathString);
	        validatePathString('DataSnapshot.child', 1, childPathString, false);
	        var childPath = new Path(childPathString);
	        var childRef = this.ref_.child(childPath);
	        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
	    };
	    /**
	     * Returns whether the snapshot contains a child at the specified path.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {boolean} Whether the child exists.
	     */
	    DataSnapshot.prototype.hasChild = function (childPathString) {
	        util.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
	        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
	        var childPath = new Path(childPathString);
	        return !this.node_.getChild(childPath).isEmpty();
	    };
	    /**
	     * Returns the priority of the object, or null if no priority was set.
	     *
	     * @return {string|number|null} The priority.
	     */
	    DataSnapshot.prototype.getPriority = function () {
	        util.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
	        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
	        return this.node_.getPriority().val();
	    };
	    /**
	     * Iterates through child nodes and calls the specified action for each one.
	     *
	     * @param {function(!DataSnapshot)} action Callback function to be called
	     * for each child.
	     * @return {boolean} True if forEach was canceled by action returning true for
	     * one of the child nodes.
	     */
	    DataSnapshot.prototype.forEach = function (action) {
	        var _this = this;
	        util.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
	        util.validateCallback('DataSnapshot.forEach', 1, action, false);
	        if (this.node_.isLeafNode()) {
	            return false;
	        }
	        var childrenNode = this.node_;
	        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
	        return !!childrenNode.forEachChild(this.index_, function (key, node) {
	            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
	        });
	    };
	    /**
	     * Returns whether this DataSnapshot has children.
	     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
	     */
	    DataSnapshot.prototype.hasChildren = function () {
	        util.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
	        if (this.node_.isLeafNode()) {
	            return false;
	        }
	        else {
	            return !this.node_.isEmpty();
	        }
	    };
	    Object.defineProperty(DataSnapshot.prototype, "key", {
	        get: function () {
	            return this.ref_.getKey();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the number of children for this DataSnapshot.
	     * @return {number} The number of children that this DataSnapshot contains.
	     */
	    DataSnapshot.prototype.numChildren = function () {
	        util.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
	        return this.node_.numChildren();
	    };
	    /**
	     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
	     */
	    DataSnapshot.prototype.getRef = function () {
	        util.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
	        return this.ref_;
	    };
	    Object.defineProperty(DataSnapshot.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return DataSnapshot;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Encapsulates the data needed to raise an event
	 * @implements {Event}
	 */
	var DataEvent = /** @class */ (function () {
	    /**
	     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
	     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
	     * @param {!DataSnapshot} snapshot The data backing the event
	     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
	     */
	    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
	        this.eventType = eventType;
	        this.eventRegistration = eventRegistration;
	        this.snapshot = snapshot;
	        this.prevName = prevName;
	    }
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getPath = function () {
	        var ref = this.snapshot.getRef();
	        if (this.eventType === 'value') {
	            return ref.path;
	        }
	        else {
	            return ref.getParent().path;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventType = function () {
	        return this.eventType;
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.toString = function () {
	        return (this.getPath().toString() +
	            ':' +
	            this.eventType +
	            ':' +
	            util.stringify(this.snapshot.exportVal()));
	    };
	    return DataEvent;
	}());
	var CancelEvent = /** @class */ (function () {
	    /**
	     * @param {EventRegistration} eventRegistration
	     * @param {Error} error
	     * @param {!Path} path
	     */
	    function CancelEvent(eventRegistration, error, path) {
	        this.eventRegistration = eventRegistration;
	        this.error = error;
	        this.path = path;
	    }
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getPath = function () {
	        return this.path;
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventType = function () {
	        return 'cancel';
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.toString = function () {
	        return this.path.toString() + ':cancel';
	    };
	    return CancelEvent;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents registration for 'value' events.
	 */
	var ValueEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?function(!DataSnapshot)} callback_
	     * @param {?function(Error)} cancelCallback_
	     * @param {?Object} context_
	     */
	    function ValueEventRegistration(callback_, cancelCallback_, context_) {
	        this.callback_ = callback_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.respondsTo = function (eventType) {
	        return eventType === 'value';
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createEvent = function (change, query) {
	        var index = query.getQueryParams().getIndex();
	        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_1 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_1.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_1 = this.callback_;
	            return function () {
	                cb_1.call(ctx, eventData.snapshot);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.matches = function (other) {
	        if (!(other instanceof ValueEventRegistration)) {
	            return false;
	        }
	        else if (!other.callback_ || !this.callback_) {
	            // If no callback specified, we consider it to match any callback.
	            return true;
	        }
	        else {
	            return (other.callback_ === this.callback_ && other.context_ === this.context_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callback_ !== null;
	    };
	    return ValueEventRegistration;
	}());
	/**
	 * Represents the registration of 1 or more child_xxx events.
	 *
	 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
	 * register a group of callbacks together in the future.
	 *
	 * @constructor
	 * @implements {EventRegistration}
	 */
	var ChildEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
	     * @param {?function(Error)} cancelCallback_
	     * @param {Object=} context_
	     */
	    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
	        this.callbacks_ = callbacks_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.respondsTo = function (eventType) {
	        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
	        eventToCheck =
	            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
	        return util.contains(this.callbacks_, eventToCheck);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createEvent = function (change, query) {
	        util.assert(change.childName != null, 'Child events should have a childName.');
	        var ref = query.getRef().child(/** @type {!string} */ change.childName);
	        var index = query.getQueryParams().getIndex();
	        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_2 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_2.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_2 = this.callbacks_[eventData.eventType];
	            return function () {
	                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.matches = function (other) {
	        var _this = this;
	        if (other instanceof ChildEventRegistration) {
	            if (!this.callbacks_ || !other.callbacks_) {
	                return true;
	            }
	            else if (this.context_ === other.context_) {
	                var otherKeys = Object.keys(other.callbacks_);
	                var thisKeys = Object.keys(this.callbacks_);
	                var otherCount = otherKeys.length;
	                var thisCount = thisKeys.length;
	                if (otherCount === thisCount) {
	                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
	                    // If event types don't match, not a match
	                    // If count is not 1, exact match across all
	                    if (otherCount === 1) {
	                        var otherKey = otherKeys[0];
	                        var thisKey = thisKeys[0];
	                        return (thisKey === otherKey &&
	                            (!other.callbacks_[otherKey] ||
	                                !this.callbacks_[thisKey] ||
	                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
	                    }
	                    else {
	                        // Exact match on each key.
	                        return thisKeys.every(function (eventType) {
	                            return other.callbacks_[eventType] === _this.callbacks_[eventType];
	                        });
	                    }
	                }
	            }
	        }
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callbacks_ !== null;
	    };
	    return ChildEventRegistration;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __referenceConstructor;
	/**
	 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
	 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
	 *
	 * Since every Firebase reference is a query, Firebase inherits from this object.
	 */
	var Query = /** @class */ (function () {
	    function Query(repo, path, queryParams_, orderByCalled_) {
	        this.repo = repo;
	        this.path = path;
	        this.queryParams_ = queryParams_;
	        this.orderByCalled_ = orderByCalled_;
	    }
	    Object.defineProperty(Query, "__referenceConstructor", {
	        get: function () {
	            util.assert(__referenceConstructor, 'Reference.ts has not been loaded');
	            return __referenceConstructor;
	        },
	        set: function (val) {
	            __referenceConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Validates start/end values for queries.
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateQueryEndpoints_ = function (params) {
	        var startNode = null;
	        var endNode = null;
	        if (params.hasStart()) {
	            startNode = params.getIndexStartValue();
	        }
	        if (params.hasEnd()) {
	            endNode = params.getIndexEndValue();
	        }
	        if (params.getIndex() === KEY_INDEX) {
	            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
	                'startAt(), endAt(), or equalTo().';
	            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
	                'or equalTo() must be a string.';
	            if (params.hasStart()) {
	                var startName = params.getIndexStartName();
	                if (startName !== MIN_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof startNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	            if (params.hasEnd()) {
	                var endName = params.getIndexEndName();
	                if (endName !== MAX_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof endNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	        }
	        else if (params.getIndex() === PRIORITY_INDEX) {
	            if ((startNode != null && !isValidPriority(startNode)) ||
	                (endNode != null && !isValidPriority(endNode))) {
	                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
	                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
	            }
	        }
	        else {
	            util.assert(params.getIndex() instanceof PathIndex ||
	                params.getIndex() === VALUE_INDEX, 'unknown index type.');
	            if ((startNode != null && typeof startNode === 'object') ||
	                (endNode != null && typeof endNode === 'object')) {
	                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
	                    'an object.');
	            }
	        }
	    };
	    /**
	     * Validates that limit* has been called with the correct combination of parameters
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateLimit_ = function (params) {
	        if (params.hasStart() &&
	            params.hasEnd() &&
	            params.hasLimit() &&
	            !params.hasAnchoredLimit()) {
	            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
	        }
	    };
	    /**
	     * Validates that no other order by call has been made
	     * @param {!string} fnName
	     * @private
	     */
	    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
	        if (this.orderByCalled_ === true) {
	            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
	        }
	    };
	    /**
	     * @return {!QueryParams}
	     */
	    Query.prototype.getQueryParams = function () {
	        return this.queryParams_;
	    };
	    /**
	     * @return {!Reference}
	     */
	    Query.prototype.getRef = function () {
	        util.validateArgCount('Query.ref', 0, 0, arguments.length);
	        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
	        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
	        // method gets called.
	        return new Query.__referenceConstructor(this.repo, this.path);
	    };
	    /**
	     * @param {!string} eventType
	     * @param {!function(DataSnapshot, string=)} callback
	     * @param {(function(Error)|Object)=} cancelCallbackOrContext
	     * @param {Object=} context
	     * @return {!function(DataSnapshot, string=)}
	     */
	    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
	        util.validateArgCount('Query.on', 2, 4, arguments.length);
	        validateEventType('Query.on', 1, eventType, false);
	        util.validateCallback('Query.on', 2, callback, false);
	        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
	        if (eventType === 'value') {
	            this.onValueEvent(callback, ret.cancel, ret.context);
	        }
	        else {
	            var callbacks = {};
	            callbacks[eventType] = callback;
	            this.onChildEvent(callbacks, ret.cancel, ret.context);
	        }
	        return callback;
	    };
	    /**
	     * @param {!function(!DataSnapshot)} callback
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
	        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
	        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {string=} eventType
	     * @param {(function(!DataSnapshot, ?string=))=} callback
	     * @param {Object=} context
	     */
	    Query.prototype.off = function (eventType, callback, context) {
	        util.validateArgCount('Query.off', 0, 3, arguments.length);
	        validateEventType('Query.off', 1, eventType, true);
	        util.validateCallback('Query.off', 2, callback, true);
	        util.validateContextObject('Query.off', 3, context, true);
	        var container = null;
	        var callbacks = null;
	        if (eventType === 'value') {
	            var valueCallback = callback || null;
	            container = new ValueEventRegistration(valueCallback, null, context || null);
	        }
	        else if (eventType) {
	            if (callback) {
	                callbacks = {};
	                callbacks[eventType] = callback;
	            }
	            container = new ChildEventRegistration(callbacks, null, context || null);
	        }
	        this.repo.removeEventCallbackForQuery(this, container);
	    };
	    /**
	     * Attaches a listener, waits for the first event, and then removes the listener
	     * @param {!string} eventType
	     * @param {!function(!DataSnapshot, string=)} userCallback
	     * @param failureCallbackOrContext
	     * @param context
	     * @return {!firebase.Promise}
	     */
	    Query.prototype.once = function (eventType, userCallback, failureCallbackOrContext, context) {
	        var _this = this;
	        util.validateArgCount('Query.once', 1, 4, arguments.length);
	        validateEventType('Query.once', 1, eventType, false);
	        util.validateCallback('Query.once', 2, userCallback, true);
	        var ret = Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
	        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
	        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
	        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
	        // against the Promise specification.
	        var firstCall = true;
	        var deferred = new util.Deferred();
	        // A dummy error handler in case a user wasn't expecting promises
	        deferred.promise.catch(function () { });
	        var onceCallback = function (snapshot) {
	            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
	            // triggers multiple events (e.g. child_added or child_changed).
	            if (firstCall) {
	                firstCall = false;
	                _this.off(eventType, onceCallback);
	                if (userCallback) {
	                    userCallback.bind(ret.context)(snapshot);
	                }
	                deferred.resolve(snapshot);
	            }
	        };
	        this.on(eventType, onceCallback, 
	        /*cancel=*/ function (err) {
	            _this.off(eventType, onceCallback);
	            if (ret.cancel) {
	                ret.cancel.bind(ret.context)(err);
	            }
	            deferred.reject(err);
	        });
	        return deferred.promise;
	    };
	    /**
	     * Set a limit and anchor it to the start of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToFirst = function (limit) {
	        util.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
	    };
	    /**
	     * Set a limit and anchor it to the end of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToLast = function (limit) {
	        util.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToLast: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
	    };
	    /**
	     * Given a child path, return a new query ordered by the specified grandchild path.
	     * @param {!string} path
	     * @return {!Query}
	     */
	    Query.prototype.orderByChild = function (path) {
	        util.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
	        if (path === '$key') {
	            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
	        }
	        else if (path === '$priority') {
	            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
	        }
	        else if (path === '$value') {
	            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
	        }
	        validatePathString('Query.orderByChild', 1, path, false);
	        this.validateNoPreviousOrderByCall_('Query.orderByChild');
	        var parsedPath = new Path(path);
	        if (parsedPath.isEmpty()) {
	            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
	        }
	        var index = new PathIndex(parsedPath);
	        var newParams = this.queryParams_.orderBy(index);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the KeyIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByKey = function () {
	        util.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByKey');
	        var newParams = this.queryParams_.orderBy(KEY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the PriorityIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByPriority = function () {
	        util.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
	        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the ValueIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByValue = function () {
	        util.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByValue');
	        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.startAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util.validateArgCount('Query.startAt', 0, 2, arguments.length);
	        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
	        validateKey('Query.startAt', 2, name, true);
	        var newParams = this.queryParams_.startAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
	                'or equalTo).');
	        }
	        // Calling with no params tells us to start at the beginning.
	        if (value === undefined) {
	            value = null;
	            name = null;
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.endAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util.validateArgCount('Query.endAt', 0, 2, arguments.length);
	        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
	        validateKey('Query.endAt', 2, name, true);
	        var newParams = this.queryParams_.endAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * Load the selection of children with exactly the specified value, and, optionally,
	     * the specified name.
	     * @param {number|string|boolean|null} value
	     * @param {string=} name
	     * @return {!Query}
	     */
	    Query.prototype.equalTo = function (value, name) {
	        util.validateArgCount('Query.equalTo', 1, 2, arguments.length);
	        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
	        validateKey('Query.equalTo', 2, name, true);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
	                'equalTo).');
	        }
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return this.startAt(value, name).endAt(value, name);
	    };
	    /**
	     * @return {!string} URL for this location.
	     */
	    Query.prototype.toString = function () {
	        util.validateArgCount('Query.toString', 0, 0, arguments.length);
	        return this.repo.toString() + this.path.toUrlEncodedString();
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users.
	    Query.prototype.toJSON = function () {
	        // An optional spacer argument is unnecessary for a string.
	        util.validateArgCount('Query.toJSON', 0, 1, arguments.length);
	        return this.toString();
	    };
	    /**
	     * An object representation of the query parameters used by this Query.
	     * @return {!Object}
	     */
	    Query.prototype.queryObject = function () {
	        return this.queryParams_.getQueryObject();
	    };
	    /**
	     * @return {!string}
	     */
	    Query.prototype.queryIdentifier = function () {
	        var obj = this.queryObject();
	        var id = ObjectToUniqueKey(obj);
	        return id === '{}' ? 'default' : id;
	    };
	    /**
	     * Return true if this query and the provided query are equivalent; otherwise, return false.
	     * @param {Query} other
	     * @return {boolean}
	     */
	    Query.prototype.isEqual = function (other) {
	        util.validateArgCount('Query.isEqual', 1, 1, arguments.length);
	        if (!(other instanceof Query)) {
	            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
	            throw new Error(error);
	        }
	        var sameRepo = this.repo === other.repo;
	        var samePath = this.path.equals(other.path);
	        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
	        return sameRepo && samePath && sameQueryIdentifier;
	    };
	    /**
	     * Helper used by .on and .once to extract the context and or cancel arguments.
	     * @param {!string} fnName The function name (on or once)
	     * @param {(function(Error)|Object)=} cancelOrContext
	     * @param {Object=} context
	     * @return {{cancel: ?function(Error), context: ?Object}}
	     * @private
	     */
	    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
	        var ret = { cancel: null, context: null };
	        if (cancelOrContext && context) {
	            ret.cancel = cancelOrContext;
	            util.validateCallback(fnName, 3, ret.cancel, true);
	            ret.context = context;
	            util.validateContextObject(fnName, 4, ret.context, true);
	        }
	        else if (cancelOrContext) {
	            // we have either a cancel callback or a context.
	            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
	                // it's a context!
	                ret.context = cancelOrContext;
	            }
	            else if (typeof cancelOrContext === 'function') {
	                ret.cancel = cancelOrContext;
	            }
	            else {
	                throw new Error(util.errorPrefix(fnName, 3, true) +
	                    ' must either be a cancel callback or a context object.');
	            }
	        }
	        return ret;
	    };
	    Object.defineProperty(Query.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Query;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper class to store a sparse set of snapshots.
	 */
	var SparseSnapshotTree = /** @class */ (function () {
	    function SparseSnapshotTree() {
	        this.value = null;
	        this.children = new Map();
	    }
	    /**
	     * Gets the node stored at the given path if one exists.
	     *
	     * @param path Path to look up snapshot for.
	     * @return The retrieved node, or null.
	     */
	    SparseSnapshotTree.prototype.find = function (path) {
	        if (this.value != null) {
	            return this.value.getChild(path);
	        }
	        else if (!path.isEmpty() && this.children.size > 0) {
	            var childKey = path.getFront();
	            path = path.popFront();
	            if (this.children.has(childKey)) {
	                var childTree = this.children.get(childKey);
	                return childTree.find(path);
	            }
	            else {
	                return null;
	            }
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Stores the given node at the specified path. If there is already a node
	     * at a shallower path, it merges the new data into that snapshot node.
	     *
	     * @param path Path to look up snapshot for.
	     * @param data The new data, or null.
	     */
	    SparseSnapshotTree.prototype.remember = function (path, data) {
	        if (path.isEmpty()) {
	            this.value = data;
	            this.children.clear();
	        }
	        else if (this.value !== null) {
	            this.value = this.value.updateChild(path, data);
	        }
	        else {
	            var childKey = path.getFront();
	            if (!this.children.has(childKey)) {
	                this.children.set(childKey, new SparseSnapshotTree());
	            }
	            var child = this.children.get(childKey);
	            path = path.popFront();
	            child.remember(path, data);
	        }
	    };
	    /**
	     * Purge the data at path from the cache.
	     *
	     * @param path Path to look up snapshot for.
	     * @return True if this node should now be removed.
	     */
	    SparseSnapshotTree.prototype.forget = function (path) {
	        if (path.isEmpty()) {
	            this.value = null;
	            this.children.clear();
	            return true;
	        }
	        else {
	            if (this.value !== null) {
	                if (this.value.isLeafNode()) {
	                    // We're trying to forget a node that doesn't exist
	                    return false;
	                }
	                else {
	                    var value = this.value;
	                    this.value = null;
	                    var self_1 = this;
	                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
	                        self_1.remember(new Path(key), tree);
	                    });
	                    return this.forget(path);
	                }
	            }
	            else if (this.children.size > 0) {
	                var childKey = path.getFront();
	                path = path.popFront();
	                if (this.children.has(childKey)) {
	                    var safeToRemove = this.children.get(childKey).forget(path);
	                    if (safeToRemove) {
	                        this.children.delete(childKey);
	                    }
	                }
	                return this.children.size === 0;
	            }
	            else {
	                return true;
	            }
	        }
	    };
	    /**
	     * Recursively iterates through all of the stored tree and calls the
	     * callback on each one.
	     *
	     * @param prefixPath Path to look up node for.
	     * @param func The function to invoke for each tree.
	     */
	    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
	        if (this.value !== null) {
	            func(prefixPath, this.value);
	        }
	        else {
	            this.forEachChild(function (key, tree) {
	                var path = new Path(prefixPath.toString() + '/' + key);
	                tree.forEachTree(path, func);
	            });
	        }
	    };
	    /**
	     * Iterates through each immediate child and triggers the callback.
	     *
	     * @param func The function to invoke for each child.
	     */
	    SparseSnapshotTree.prototype.forEachChild = function (func) {
	        this.children.forEach(function (tree, key) {
	            func(key, tree);
	        });
	    };
	    return SparseSnapshotTree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Generate placeholders for deferred values.
	 * @param {?Object} values
	 * @return {!Object}
	 */
	var generateWithValues = function (values) {
	    values = values || {};
	    values['timestamp'] = values['timestamp'] || new Date().getTime();
	    return values;
	};
	/**
	 * Value to use when firing local events. When writing server values, fire
	 * local events with an approximate value, otherwise return value as-is.
	 * @param {(Object|string|number|boolean)} value
	 * @param {!Object} serverValues
	 * @return {!(string|number|boolean)}
	 */
	var resolveDeferredValue = function (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	value, 
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	serverValues) {
	    if (!value || typeof value !== 'object') {
	        return value;
	    }
	    else {
	        util.assert('.sv' in value, 'Unexpected leaf node or priority contents');
	        return serverValues[value['.sv']];
	    }
	};
	/**
	 * Recursively replace all deferred values and priorities in the tree with the
	 * specified generated replacement values.
	 * @param {!SparseSnapshotTree} tree
	 * @param {!Object} serverValues
	 * @return {!SparseSnapshotTree}
	 */
	var resolveDeferredValueTree = function (tree, serverValues) {
	    var resolvedTree = new SparseSnapshotTree();
	    tree.forEachTree(new Path(''), function (path, node) {
	        resolvedTree.remember(path, resolveDeferredValueSnapshot(node, serverValues));
	    });
	    return resolvedTree;
	};
	/**
	 * Recursively replace all deferred values and priorities in the node with the
	 * specified generated replacement values.  If there are no server values in the node,
	 * it'll be returned as-is.
	 * @param {!Node} node
	 * @param {!Object} serverValues
	 * @return {!Node}
	 */
	var resolveDeferredValueSnapshot = function (node, serverValues) {
	    var rawPri = node.getPriority().val();
	    var priority = resolveDeferredValue(rawPri, serverValues);
	    var newNode;
	    if (node.isLeafNode()) {
	        var leafNode = node;
	        var value = resolveDeferredValue(leafNode.getValue(), serverValues);
	        if (value !== leafNode.getValue() ||
	            priority !== leafNode.getPriority().val()) {
	            return new LeafNode(value, nodeFromJSON$1(priority));
	        }
	        else {
	            return node;
	        }
	    }
	    else {
	        var childrenNode = node;
	        newNode = childrenNode;
	        if (priority !== childrenNode.getPriority().val()) {
	            newNode = newNode.updatePriority(new LeafNode(priority));
	        }
	        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	            var newChildNode = resolveDeferredValueSnapshot(childNode, serverValues);
	            if (newChildNode !== childNode) {
	                newNode = newNode.updateImmediateChild(childName, newChildNode);
	            }
	        });
	        return newNode;
	    }
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @enum
	 */
	var OperationType;
	(function (OperationType) {
	    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
	    OperationType[OperationType["MERGE"] = 1] = "MERGE";
	    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
	    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
	})(OperationType || (OperationType = {}));
	/**
	 * @param {boolean} fromUser
	 * @param {boolean} fromServer
	 * @param {?string} queryId
	 * @param {boolean} tagged
	 * @constructor
	 */
	var OperationSource = /** @class */ (function () {
	    function OperationSource(fromUser, fromServer, queryId, tagged) {
	        this.fromUser = fromUser;
	        this.fromServer = fromServer;
	        this.queryId = queryId;
	        this.tagged = tagged;
	        util.assert(!tagged || fromServer, 'Tagged queries must be from server.');
	    }
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.User = new OperationSource(
	    /*fromUser=*/ true, false, null, 
	    /*tagged=*/ false);
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.Server = new OperationSource(false, 
	    /*fromServer=*/ true, null, 
	    /*tagged=*/ false);
	    /**
	     * @param {string} queryId
	     * @return {!OperationSource}
	     */
	    OperationSource.forServerTaggedQuery = function (queryId) {
	        return new OperationSource(false, 
	        /*fromServer=*/ true, queryId, 
	        /*tagged=*/ true);
	    };
	    return OperationSource;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var AckUserWrite = /** @class */ (function () {
	    /**
	     *
	     * @param {!Path} path
	     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
	     * @param {!boolean} revert
	     */
	    function AckUserWrite(
	    /** @inheritDoc */ path, 
	    /** @inheritDoc */ affectedTree, 
	    /** @inheritDoc */ revert) {
	        this.path = path;
	        this.affectedTree = affectedTree;
	        this.revert = revert;
	        /** @inheritDoc */
	        this.type = OperationType.ACK_USER_WRITE;
	        /** @inheritDoc */
	        this.source = OperationSource.User;
	    }
	    /**
	     * @inheritDoc
	     */
	    AckUserWrite.prototype.operationForChild = function (childName) {
	        if (!this.path.isEmpty()) {
	            util.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
	            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
	        }
	        else if (this.affectedTree.value != null) {
	            util.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
	            // All child locations are affected as well; just return same operation.
	            return this;
	        }
	        else {
	            var childTree = this.affectedTree.subtree(new Path(childName));
	            return new AckUserWrite(Path.Empty, childTree, this.revert);
	        }
	    };
	    return AckUserWrite;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var emptyChildrenSingleton;
	/**
	 * Singleton empty children collection.
	 *
	 * @const
	 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
	 */
	var EmptyChildren = function () {
	    if (!emptyChildrenSingleton) {
	        emptyChildrenSingleton = new SortedMap(stringCompare);
	    }
	    return emptyChildrenSingleton;
	};
	/**
	 * A tree with immutable elements.
	 */
	var ImmutableTree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {?T} value
	     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
	     */
	    function ImmutableTree(value, children) {
	        if (children === void 0) { children = EmptyChildren(); }
	        this.value = value;
	        this.children = children;
	    }
	    /**
	     * @template T
	     * @param {!Object.<string, !T>} obj
	     * @return {!ImmutableTree.<!T>}
	     */
	    ImmutableTree.fromObject = function (obj) {
	        var tree = ImmutableTree.Empty;
	        each(obj, function (childPath, childSnap) {
	            tree = tree.set(new Path(childPath), childSnap);
	        });
	        return tree;
	    };
	    /**
	     * True if the value is empty and there are no children
	     * @return {boolean}
	     */
	    ImmutableTree.prototype.isEmpty = function () {
	        return this.value === null && this.children.isEmpty();
	    };
	    /**
	     * Given a path and predicate, return the first node and the path to that node
	     * where the predicate returns true.
	     *
	     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
	     * on the way back out, it may be better to pass down a pathSoFar obj.
	     *
	     * @param {!Path} relativePath The remainder of the path
	     * @param {function(T):boolean} predicate The predicate to satisfy to return a
	     *   node
	     * @return {?{path:!Path, value:!T}}
	     */
	    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
	        if (this.value != null && predicate(this.value)) {
	            return { path: Path.Empty, value: this.value };
	        }
	        else {
	            if (relativePath.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = relativePath.getFront();
	                var child = this.children.get(front);
	                if (child !== null) {
	                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
	                    if (childExistingPathAndValue != null) {
	                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
	                        return { path: fullPath, value: childExistingPathAndValue.value };
	                    }
	                    else {
	                        return null;
	                    }
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     * Find, if it exists, the shortest subpath of the given path that points a defined
	     * value in the tree
	     * @param {!Path} relativePath
	     * @return {?{path: !Path, value: !T}}
	     */
	    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
	        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
	    };
	    /**
	     * @param {!Path} relativePath
	     * @return {!ImmutableTree.<T>} The subtree at the given path
	     */
	    ImmutableTree.prototype.subtree = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this;
	        }
	        else {
	            var front = relativePath.getFront();
	            var childTree = this.children.get(front);
	            if (childTree !== null) {
	                return childTree.subtree(relativePath.popFront());
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Sets a value at the specified path.
	     *
	     * @param {!Path} relativePath Path to set value at.
	     * @param {?T} toSet Value to set.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.set = function (relativePath, toSet) {
	        if (relativePath.isEmpty()) {
	            return new ImmutableTree(toSet, this.children);
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.set(relativePath.popFront(), toSet);
	            var newChildren = this.children.insert(front, newChild);
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Removes the value at the specified path.
	     *
	     * @param {!Path} relativePath Path to value to remove.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.remove = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            if (this.children.isEmpty()) {
	                return ImmutableTree.Empty;
	            }
	            else {
	                return new ImmutableTree(null, this.children);
	            }
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                var newChild = child.remove(relativePath.popFront());
	                var newChildren = void 0;
	                if (newChild.isEmpty()) {
	                    newChildren = this.children.remove(front);
	                }
	                else {
	                    newChildren = this.children.insert(front, newChild);
	                }
	                if (this.value === null && newChildren.isEmpty()) {
	                    return ImmutableTree.Empty;
	                }
	                else {
	                    return new ImmutableTree(this.value, newChildren);
	                }
	            }
	            else {
	                return this;
	            }
	        }
	    };
	    /**
	     * Gets a value from the tree.
	     *
	     * @param {!Path} relativePath Path to get value for.
	     * @return {?T} Value at path, or null.
	     */
	    ImmutableTree.prototype.get = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this.value;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                return child.get(relativePath.popFront());
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Replace the subtree at the specified path with the given new tree.
	     *
	     * @param {!Path} relativePath Path to replace subtree for.
	     * @param {!ImmutableTree} newTree New tree.
	     * @return {!ImmutableTree} Resulting tree.
	     */
	    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
	        if (relativePath.isEmpty()) {
	            return newTree;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.setTree(relativePath.popFront(), newTree);
	            var newChildren = void 0;
	            if (newChild.isEmpty()) {
	                newChildren = this.children.remove(front);
	            }
	            else {
	                newChildren = this.children.insert(front, newChild);
	            }
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Performs a depth first fold on this tree. Transforms a tree into a single
	     * value, given a function that operates on the path to a node, an optional
	     * current value, and a map of child names to folded subtrees
	     * @template V
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     */
	    ImmutableTree.prototype.fold = function (fn) {
	        return this.fold_(Path.Empty, fn);
	    };
	    /**
	     * Recursive helper for public-facing fold() method
	     * @template V
	     * @param {!Path} pathSoFar
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     * @private
	     */
	    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
	        var accum = {};
	        this.children.inorderTraversal(function (childKey, childTree) {
	            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
	        });
	        return fn(pathSoFar, this.value, accum);
	    };
	    /**
	     * Find the first matching value on the given path. Return the result of applying f to it.
	     * @template V
	     * @param {!Path} path
	     * @param {!function(!Path, !T):?V} f
	     * @return {?V}
	     */
	    ImmutableTree.prototype.findOnPath = function (path, f) {
	        return this.findOnPath_(path, Path.Empty, f);
	    };
	    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
	        var result = this.value ? f(pathSoFar, this.value) : false;
	        if (result) {
	            return result;
	        }
	        else {
	            if (pathToFollow.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = pathToFollow.getFront();
	                var nextChild = this.children.get(front);
	                if (nextChild) {
	                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     *
	     * @param {!Path} path
	     * @param {!function(!Path, !T)} f
	     * @returns {!ImmutableTree.<T>}
	     */
	    ImmutableTree.prototype.foreachOnPath = function (path, f) {
	        return this.foreachOnPath_(path, Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
	        if (pathToFollow.isEmpty()) {
	            return this;
	        }
	        else {
	            if (this.value) {
	                f(currentRelativePath, this.value);
	            }
	            var front = pathToFollow.getFront();
	            var nextChild = this.children.get(front);
	            if (nextChild) {
	                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Calls the given function for each node in the tree that has a value.
	     *
	     * @param {function(!Path, !T)} f A function to be called with
	     *   the path from the root of the tree to a node, and the value at that node.
	     *   Called in depth-first order.
	     */
	    ImmutableTree.prototype.foreach = function (f) {
	        this.foreach_(Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            childTree.foreach_(currentRelativePath.child(childName), f);
	        });
	        if (this.value) {
	            f(currentRelativePath, this.value);
	        }
	    };
	    /**
	     *
	     * @param {function(string, !T)} f
	     */
	    ImmutableTree.prototype.foreachChild = function (f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            if (childTree.value) {
	                f(childName, childTree.value);
	            }
	        });
	    };
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    ImmutableTree.Empty = new ImmutableTree(null);
	    return ImmutableTree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @constructor
	 * @implements {Operation}
	 */
	var ListenComplete = /** @class */ (function () {
	    function ListenComplete(source, path) {
	        this.source = source;
	        this.path = path;
	        /** @inheritDoc */
	        this.type = OperationType.LISTEN_COMPLETE;
	    }
	    ListenComplete.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new ListenComplete(this.source, Path.Empty);
	        }
	        else {
	            return new ListenComplete(this.source, this.path.popFront());
	        }
	    };
	    return ListenComplete;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!Node} snap
	 * @constructor
	 * @implements {Operation}
	 */
	var Overwrite = /** @class */ (function () {
	    function Overwrite(source, path, snap) {
	        this.source = source;
	        this.path = path;
	        this.snap = snap;
	        /** @inheritDoc */
	        this.type = OperationType.OVERWRITE;
	    }
	    Overwrite.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
	        }
	        else {
	            return new Overwrite(this.source, this.path.popFront(), this.snap);
	        }
	    };
	    return Overwrite;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!ImmutableTree.<!Node>} children
	 * @constructor
	 * @implements {Operation}
	 */
	var Merge = /** @class */ (function () {
	    function Merge(
	    /** @inheritDoc */ source, 
	    /** @inheritDoc */ path, 
	    /** @inheritDoc */ children) {
	        this.source = source;
	        this.path = path;
	        this.children = children;
	        /** @inheritDoc */
	        this.type = OperationType.MERGE;
	    }
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            var childTree = this.children.subtree(new Path(childName));
	            if (childTree.isEmpty()) {
	                // This child is unaffected
	                return null;
	            }
	            else if (childTree.value) {
	                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
	                return new Overwrite(this.source, Path.Empty, childTree.value);
	            }
	            else {
	                // This is a merge at a deeper level
	                return new Merge(this.source, Path.Empty, childTree);
	            }
	        }
	        else {
	            util.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
	            return new Merge(this.source, this.path.popFront(), this.children);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.toString = function () {
	        return ('Operation(' +
	            this.path +
	            ': ' +
	            this.source.toString() +
	            ' merge: ' +
	            this.children.toString() +
	            ')');
	    };
	    return Merge;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
	 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
	 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
	 * whether a node potentially had children removed due to a filter.
	 */
	var CacheNode = /** @class */ (function () {
	    /**
	     * @param {!Node} node_
	     * @param {boolean} fullyInitialized_
	     * @param {boolean} filtered_
	     */
	    function CacheNode(node_, fullyInitialized_, filtered_) {
	        this.node_ = node_;
	        this.fullyInitialized_ = fullyInitialized_;
	        this.filtered_ = filtered_;
	    }
	    /**
	     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFullyInitialized = function () {
	        return this.fullyInitialized_;
	    };
	    /**
	     * Returns whether this node is potentially missing children due to a filter applied to the node
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFiltered = function () {
	        return this.filtered_;
	    };
	    /**
	     * @param {!Path} path
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForPath = function (path) {
	        if (path.isEmpty()) {
	            return this.isFullyInitialized() && !this.filtered_;
	        }
	        var childKey = path.getFront();
	        return this.isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!string} key
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForChild = function (key) {
	        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
	    };
	    /**
	     * @return {!Node}
	     */
	    CacheNode.prototype.getNode = function () {
	        return this.node_;
	    };
	    return CacheNode;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Stores the data we have cached for a view.
	 *
	 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
	 *
	 * @constructor
	 */
	var ViewCache = /** @class */ (function () {
	    /**
	     *
	     * @param {!CacheNode} eventCache_
	     * @param {!CacheNode} serverCache_
	     */
	    function ViewCache(eventCache_, serverCache_) {
	        this.eventCache_ = eventCache_;
	        this.serverCache_ = serverCache_;
	    }
	    /**
	     * @param {!Node} eventSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
	        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
	    };
	    /**
	     * @param {!Node} serverSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
	        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getEventCache = function () {
	        return this.eventCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteEventSnap = function () {
	        return this.eventCache_.isFullyInitialized()
	            ? this.eventCache_.getNode()
	            : null;
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getServerCache = function () {
	        return this.serverCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteServerSnap = function () {
	        return this.serverCache_.isFullyInitialized()
	            ? this.serverCache_.getNode()
	            : null;
	    };
	    /**
	     * @const
	     * @type {ViewCache}
	     */
	    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false));
	    return ViewCache;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @struct
	 * @param {!string} type The event type
	 * @param {!Node} snapshotNode The data
	 * @param {string=} childName The name for this child, if it's a child event
	 * @param {Node=} oldSnap Used for intermediate processing of child changed events
	 * @param {string=} prevName The name for the previous child, if applicable
	 */
	var Change = /** @class */ (function () {
	    function Change(type, snapshotNode, childName, oldSnap, prevName) {
	        this.type = type;
	        this.snapshotNode = snapshotNode;
	        this.childName = childName;
	        this.oldSnap = oldSnap;
	        this.prevName = prevName;
	    }
	    /**
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.valueChange = function (snapshot) {
	        return new Change(Change.VALUE, snapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childAddedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_ADDED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childRemovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} newSnapshot
	     * @param {!Node} oldSnapshot
	     * @return {!Change}
	     */
	    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
	        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childMovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_MOVED, snapshot, childKey);
	    };
	    //event types
	    /** Event type for a child added */
	    Change.CHILD_ADDED = 'child_added';
	    /** Event type for a child removed */
	    Change.CHILD_REMOVED = 'child_removed';
	    /** Event type for a child changed */
	    Change.CHILD_CHANGED = 'child_changed';
	    /** Event type for a child moved */
	    Change.CHILD_MOVED = 'child_moved';
	    /** Event type for a value change */
	    Change.VALUE = 'value';
	    return Change;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 * @param {!Index} index
	 */
	var IndexedFilter = /** @class */ (function () {
	    function IndexedFilter(index_) {
	        this.index_ = index_;
	    }
	    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        util.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
	        var oldChild = snap.getImmediateChild(key);
	        // Check if anything actually changed.
	        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
	            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
	            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
	            // to avoid treating these cases as "nothing changed."
	            if (oldChild.isEmpty() === newChild.isEmpty()) {
	                // Nothing changed.
	                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
	                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
	                return snap;
	            }
	        }
	        if (optChangeAccumulator != null) {
	            if (newChild.isEmpty()) {
	                if (snap.hasChild(key)) {
	                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
	                }
	                else {
	                    util.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
	                }
	            }
	            else if (oldChild.isEmpty()) {
	                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
	            }
	            else {
	                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
	            }
	        }
	        if (snap.isLeafNode() && newChild.isEmpty()) {
	            return snap;
	        }
	        else {
	            // Make sure the node is indexed
	            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (optChangeAccumulator != null) {
	            if (!oldSnap.isLeafNode()) {
	                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                    if (!newSnap.hasChild(key)) {
	                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
	                    }
	                });
	            }
	            if (!newSnap.isLeafNode()) {
	                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                    if (oldSnap.hasChild(key)) {
	                        var oldChild = oldSnap.getImmediateChild(key);
	                        if (!oldChild.equals(childNode)) {
	                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
	                        }
	                    }
	                    else {
	                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
	                    }
	                });
	            }
	        }
	        return newSnap.withIndex(this.index_);
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        if (oldSnap.isEmpty()) {
	            return ChildrenNode.EMPTY_NODE;
	        }
	        else {
	            return oldSnap.updatePriority(newPriority);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.filtersNodes = function () {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndexedFilter = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    return IndexedFilter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ChildChangeAccumulator = /** @class */ (function () {
	    function ChildChangeAccumulator() {
	        this.changeMap = new Map();
	    }
	    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
	        var type = change.type;
	        var childKey = change.childName;
	        util.assert(type === Change.CHILD_ADDED ||
	            type === Change.CHILD_CHANGED ||
	            type === Change.CHILD_REMOVED, 'Only child changes supported for tracking');
	        util.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
	        var oldChange = this.changeMap.get(childKey);
	        if (oldChange) {
	            var oldType = oldChange.type;
	            if (type === Change.CHILD_ADDED && oldType === Change.CHILD_REMOVED) {
	                this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode));
	            }
	            else if (type === Change.CHILD_REMOVED &&
	                oldType === Change.CHILD_ADDED) {
	                this.changeMap.delete(childKey);
	            }
	            else if (type === Change.CHILD_REMOVED &&
	                oldType === Change.CHILD_CHANGED) {
	                this.changeMap.set(childKey, Change.childRemovedChange(childKey, oldChange.oldSnap));
	            }
	            else if (type === Change.CHILD_CHANGED &&
	                oldType === Change.CHILD_ADDED) {
	                this.changeMap.set(childKey, Change.childAddedChange(childKey, change.snapshotNode));
	            }
	            else if (type === Change.CHILD_CHANGED &&
	                oldType === Change.CHILD_CHANGED) {
	                this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap));
	            }
	            else {
	                throw util.assertionError('Illegal combination of changes: ' +
	                    change +
	                    ' occurred after ' +
	                    oldChange);
	            }
	        }
	        else {
	            this.changeMap.set(childKey, change);
	        }
	    };
	    ChildChangeAccumulator.prototype.getChanges = function () {
	        return Array.from(this.changeMap.values());
	    };
	    return ChildChangeAccumulator;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An implementation of CompleteChildSource that never returns any additional children
	 *
	 * @private
	 * @constructor
	 * @implements CompleteChildSource
	 */
	// eslint-disable-next-line @typescript-eslint/class-name-casing
	var NoCompleteChildSource_ = /** @class */ (function () {
	    function NoCompleteChildSource_() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
	        return null;
	    };
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
	        return null;
	    };
	    return NoCompleteChildSource_;
	}());
	/**
	 * Singleton instance.
	 * @const
	 * @type {!CompleteChildSource}
	 */
	var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
	/**
	 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
	 * old event caches available to calculate complete children.
	 *
	 *
	 * @implements CompleteChildSource
	 */
	var WriteTreeCompleteChildSource = /** @class */ (function () {
	    /**
	     * @param {!WriteTreeRef} writes_
	     * @param {!ViewCache} viewCache_
	     * @param {?Node} optCompleteServerCache_
	     */
	    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
	        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
	        this.writes_ = writes_;
	        this.viewCache_ = viewCache_;
	        this.optCompleteServerCache_ = optCompleteServerCache_;
	    }
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
	        var node = this.viewCache_.getEventCache();
	        if (node.isCompleteForChild(childKey)) {
	            return node.getNode().getImmediateChild(childKey);
	        }
	        else {
	            var serverNode = this.optCompleteServerCache_ != null
	                ? new CacheNode(this.optCompleteServerCache_, true, false)
	                : this.viewCache_.getServerCache();
	            return this.writes_.calcCompleteChild(childKey, serverNode);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
	        var completeServerData = this.optCompleteServerCache_ != null
	            ? this.optCompleteServerCache_
	            : this.viewCache_.getCompleteServerSnap();
	        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
	        if (nodes.length === 0) {
	            return null;
	        }
	        else {
	            return nodes[0];
	        }
	    };
	    return WriteTreeCompleteChildSource;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @struct
	 */
	var ProcessorResult = /** @class */ (function () {
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Array.<!Change>} changes
	     */
	    function ProcessorResult(viewCache, changes) {
	        this.viewCache = viewCache;
	        this.changes = changes;
	    }
	    return ProcessorResult;
	}());
	/**
	 * @constructor
	 */
	var ViewProcessor = /** @class */ (function () {
	    /**
	     * @param {!NodeFilter} filter_
	     */
	    function ViewProcessor(filter_) {
	        this.filter_ = filter_;
	    }
	    /**
	     * @param {!ViewCache} viewCache
	     */
	    ViewProcessor.prototype.assertIndexed = function (viewCache) {
	        util.assert(viewCache
	            .getEventCache()
	            .getNode()
	            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
	        util.assert(viewCache
	            .getServerCache()
	            .getNode()
	            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @return {!ProcessorResult}
	     */
	    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
	        var accumulator = new ChildChangeAccumulator();
	        var newViewCache, filterServerNode;
	        if (operation.type === OperationType.OVERWRITE) {
	            var overwrite = operation;
	            if (overwrite.source.fromUser) {
	                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
	            }
	            else {
	                util.assert(overwrite.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered  and the
	                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
	                // again
	                filterServerNode =
	                    overwrite.source.tagged ||
	                        (oldViewCache.getServerCache().isFiltered() &&
	                            !overwrite.path.isEmpty());
	                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.MERGE) {
	            var merge = operation;
	            if (merge.source.fromUser) {
	                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
	            }
	            else {
	                util.assert(merge.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered
	                filterServerNode =
	                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
	                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.ACK_USER_WRITE) {
	            var ackUserWrite = operation;
	            if (!ackUserWrite.revert) {
	                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
	            }
	            else {
	                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.LISTEN_COMPLETE) {
	            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
	        }
	        else {
	            throw util.assertionError('Unknown operation type: ' + operation.type);
	        }
	        var changes = accumulator.getChanges();
	        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
	        return new ProcessorResult(newViewCache, changes);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!ViewCache} newViewCache
	     * @param {!Array.<!Change>} accumulator
	     * @private
	     */
	    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
	        var eventSnap = newViewCache.getEventCache();
	        if (eventSnap.isFullyInitialized()) {
	            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
	            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
	            if (accumulator.length > 0 ||
	                !oldViewCache.getEventCache().isFullyInitialized() ||
	                (isLeafOrEmpty &&
	                    !eventSnap.getNode().equals(/** @type {!Node} */ oldCompleteSnap)) ||
	                !eventSnap
	                    .getNode()
	                    .getPriority()
	                    .equals(oldCompleteSnap.getPriority())) {
	                accumulator.push(Change.valueChange(
	                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
	            }
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} changePath
	     * @param {!WriteTreeRef} writesCache
	     * @param {!CompleteChildSource} source
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
	        var oldEventSnap = viewCache.getEventCache();
	        if (writesCache.shadowingWrite(changePath) != null) {
	            // we have a shadowing write, ignore changes
	            return viewCache;
	        }
	        else {
	            var newEventCache = void 0, serverNode = void 0;
	            if (changePath.isEmpty()) {
	                // TODO: figure out how this plays with "sliding ack windows"
	                util.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
	                if (viewCache.getServerCache().isFiltered()) {
	                    // We need to special case this, because we need to only apply writes to complete children, or
	                    // we might end up raising events for incomplete children. If the server data is filtered deep
	                    // writes cannot be guaranteed to be complete
	                    var serverCache = viewCache.getCompleteServerSnap();
	                    var completeChildren = serverCache instanceof ChildrenNode
	                        ? serverCache
	                        : ChildrenNode.EMPTY_NODE;
	                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
	                }
	                else {
	                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
	                }
	            }
	            else {
	                var childKey = changePath.getFront();
	                if (childKey === '.priority') {
	                    util.assert(changePath.getLength() === 1, "Can't have a priority with additional path components");
	                    var oldEventNode = oldEventSnap.getNode();
	                    serverNode = viewCache.getServerCache().getNode();
	                    // we might have overwrites for this priority
	                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
	                    if (updatedPriority != null) {
	                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
	                    }
	                    else {
	                        // priority didn't change, keep old node
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	                else {
	                    var childChangePath = changePath.popFront();
	                    // update child
	                    var newEventChild = void 0;
	                    if (oldEventSnap.isCompleteForChild(childKey)) {
	                        serverNode = viewCache.getServerCache().getNode();
	                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
	                        if (eventChildUpdate != null) {
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey)
	                                .updateChild(childChangePath, eventChildUpdate);
	                        }
	                        else {
	                            // Nothing changed, just keep the old child
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey);
	                        }
	                    }
	                    else {
	                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                    }
	                    if (newEventChild != null) {
	                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
	                    }
	                    else {
	                        // no complete child available or no change
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	            }
	            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
	        }
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
	        var oldServerSnap = oldViewCache.getServerCache();
	        var newServerCache;
	        var serverFilter = filterServerNode
	            ? this.filter_
	            : this.filter_.getIndexedFilter();
	        if (changePath.isEmpty()) {
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
	        }
	        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
	            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
	            var newServerNode = oldServerSnap
	                .getNode()
	                .updateChild(changePath, changedSnap);
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (!oldServerSnap.isCompleteForPath(changePath) &&
	                changePath.getLength() > 1) {
	                // We don't update incomplete nodes with updates intended for other listeners
	                return oldViewCache;
	            }
	            var childChangePath = changePath.popFront();
	            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
	            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
	            if (childKey === '.priority') {
	                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
	            }
	            else {
	                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
	            }
	        }
	        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
	        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
	        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
	        var oldEventSnap = oldViewCache.getEventCache();
	        var newViewCache, newEventCache;
	        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
	        if (changePath.isEmpty()) {
	            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
	            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (childKey === '.priority') {
	                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
	                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
	            }
	            else {
	                var childChangePath = changePath.popFront();
	                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
	                var newChild = void 0;
	                if (childChangePath.isEmpty()) {
	                    // Child overwrite, we can replace the child
	                    newChild = changedSnap;
	                }
	                else {
	                    var childNode = source.getCompleteChild(childKey);
	                    if (childNode != null) {
	                        if (childChangePath.getBack() === '.priority' &&
	                            childNode.getChild(childChangePath.parent()).isEmpty()) {
	                            // This is a priority update on an empty node. If this node exists on the server, the
	                            // server will send down the priority in the update, so ignore for now
	                            newChild = childNode;
	                        }
	                        else {
	                            newChild = childNode.updateChild(childChangePath, changedSnap);
	                        }
	                    }
	                    else {
	                        // There is no complete child node available
	                        newChild = ChildrenNode.EMPTY_NODE;
	                    }
	                }
	                if (!oldChild.equals(newChild)) {
	                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
	                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
	                }
	                else {
	                    newViewCache = oldViewCache;
	                }
	            }
	        }
	        return newViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {string} childKey
	     * @return {boolean}
	     * @private
	     */
	    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
	        return viewCache.getEventCache().isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
	        var _this = this;
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!Node} node
	     * @param {ImmutableTree.<!Node>} merge
	     * @return {!Node}
	     * @private
	     */
	    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
	        merge.foreach(function (relativePath, childNode) {
	            node = node.updateChild(relativePath, childNode);
	        });
	        return node;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
	        var _this = this;
	        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
	        // wait for the complete data update coming soon.
	        if (viewCache
	            .getServerCache()
	            .getNode()
	            .isEmpty() &&
	            !viewCache.getServerCache().isFullyInitialized()) {
	            return viewCache;
	        }
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        var viewMergeTree;
	        if (path.isEmpty()) {
	            viewMergeTree = changedChildren;
	        }
	        else {
	            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
	        }
	        var serverNode = viewCache.getServerCache().getNode();
	        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
	            if (serverNode.hasChild(childKey)) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
	            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
	                childMergeTree.value == null;
	            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childMergeTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} ackPath
	     * @param {!ImmutableTree<!boolean>} affectedTree
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
	        if (writesCache.shadowingWrite(ackPath) != null) {
	            return viewCache;
	        }
	        // Only filter server node if it is currently filtered
	        var filterServerNode = viewCache.getServerCache().isFiltered();
	        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
	        // now that it won't be shadowed.
	        var serverCache = viewCache.getServerCache();
	        if (affectedTree.value != null) {
	            // This is an overwrite.
	            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
	                serverCache.isCompleteForPath(ackPath)) {
	                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else if (ackPath.isEmpty()) {
	                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
	                // should just re-apply whatever we have in our cache as a merge.
	                var changedChildren_1 = ImmutableTree.Empty;
	                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
	                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
	                });
	                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else {
	                return viewCache;
	            }
	        }
	        else {
	            // This is a merge.
	            var changedChildren_2 = ImmutableTree.Empty;
	            affectedTree.foreach(function (mergePath, value) {
	                var serverCachePath = ackPath.child(mergePath);
	                if (serverCache.isCompleteForPath(serverCachePath)) {
	                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
	                }
	            });
	            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
	        var oldServerNode = viewCache.getServerCache();
	        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
	        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
	        var complete;
	        if (writesCache.shadowingWrite(path) != null) {
	            return viewCache;
	        }
	        else {
	            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
	            var oldEventCache = viewCache.getEventCache().getNode();
	            var newEventCache = void 0;
	            if (path.isEmpty() || path.getFront() === '.priority') {
	                var newNode = void 0;
	                if (viewCache.getServerCache().isFullyInitialized()) {
	                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                }
	                else {
	                    var serverChildren = viewCache.getServerCache().getNode();
	                    util.assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
	                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
	                }
	                newNode = newNode;
	                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
	            }
	            else {
	                var childKey = path.getFront();
	                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                if (newChild == null &&
	                    viewCache.getServerCache().isCompleteForChild(childKey)) {
	                    newChild = oldEventCache.getImmediateChild(childKey);
	                }
	                if (newChild != null) {
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
	                }
	                else if (viewCache
	                    .getEventCache()
	                    .getNode()
	                    .hasChild(childKey)) {
	                    // No complete child available, delete the existing one, if any
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
	                }
	                else {
	                    newEventCache = oldEventCache;
	                }
	                if (newEventCache.isEmpty() &&
	                    viewCache.getServerCache().isFullyInitialized()) {
	                    // We might have reverted all child writes. Maybe the old event was a leaf node
	                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    if (complete.isLeafNode()) {
	                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
	                    }
	                }
	            }
	            complete =
	                viewCache.getServerCache().isFullyInitialized() ||
	                    writesCache.shadowingWrite(Path.Empty) != null;
	            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
	        }
	    };
	    return ViewProcessor;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
	 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
	 * for details.
	 *
	 * @constructor
	 */
	var EventGenerator = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     */
	    function EventGenerator(query_) {
	        this.query_ = query_;
	        /**
	         * @private
	         * @type {!Index}
	         */
	        this.index_ = this.query_.getQueryParams().getIndex();
	    }
	    /**
	     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
	     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
	     *
	     * Notes:
	     *  - child_moved events will be synthesized at this time for any child_changed events that affect
	     *    our index.
	     *  - prevName will be calculated based on the index ordering.
	     *
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {!Array.<!EventRegistration>} eventRegistrations
	     * @return {!Array.<!Event>}
	     */
	    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
	        var _this = this;
	        var events = [];
	        var moves = [];
	        changes.forEach(function (change) {
	            if (change.type === Change.CHILD_CHANGED &&
	                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
	                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
	            }
	        });
	        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
	        return events;
	    };
	    /**
	     * Given changes of a single change type, generate the corresponding events.
	     *
	     * @param {!Array.<!Event>} events
	     * @param {!string} eventType
	     * @param {!Array.<!Change>} changes
	     * @param {!Array.<!EventRegistration>} registrations
	     * @param {!Node} eventCache
	     * @private
	     */
	    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
	        var _this = this;
	        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
	        filteredChanges.sort(this.compareChanges_.bind(this));
	        filteredChanges.forEach(function (change) {
	            var materializedChange = _this.materializeSingleChange_(change, eventCache);
	            registrations.forEach(function (registration) {
	                if (registration.respondsTo(change.type)) {
	                    events.push(registration.createEvent(materializedChange, _this.query_));
	                }
	            });
	        });
	    };
	    /**
	     * @param {!Change} change
	     * @param {!Node} eventCache
	     * @return {!Change}
	     * @private
	     */
	    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
	        if (change.type === 'value' || change.type === 'child_removed') {
	            return change;
	        }
	        else {
	            change.prevName = eventCache.getPredecessorChildName(
	            /** @type {!string} */
	            change.childName, change.snapshotNode, this.index_);
	            return change;
	        }
	    };
	    /**
	     * @param {!Change} a
	     * @param {!Change} b
	     * @return {number}
	     * @private
	     */
	    EventGenerator.prototype.compareChanges_ = function (a, b) {
	        if (a.childName == null || b.childName == null) {
	            throw util.assertionError('Should only compare child_ events.');
	        }
	        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
	        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
	        return this.index_.compare(aWrapped, bWrapped);
	    };
	    return EventGenerator;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A view represents a specific location and query that has 1 or more event registrations.
	 *
	 * It does several things:
	 *  - Maintains the list of event registrations for this location/query.
	 *  - Maintains a cache of the data visible for this location/query.
	 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
	 *    registrations returns the set of events to be raised.
	 * @constructor
	 */
	var View = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     * @param {!ViewCache} initialViewCache
	     */
	    function View(query_, initialViewCache) {
	        this.query_ = query_;
	        this.eventRegistrations_ = [];
	        var params = this.query_.getQueryParams();
	        var indexFilter = new IndexedFilter(params.getIndex());
	        var filter = params.getNodeFilter();
	        /**
	         * @type {ViewProcessor}
	         * @private
	         */
	        this.processor_ = new ViewProcessor(filter);
	        var initialServerCache = initialViewCache.getServerCache();
	        var initialEventCache = initialViewCache.getEventCache();
	        // Don't filter server node with other filter than index, wait for tagged listen
	        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
	        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
	        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
	        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
	        /**
	         * @type {!ViewCache}
	         * @private
	         */
	        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
	        /**
	         * @type {!EventGenerator}
	         * @private
	         */
	        this.eventGenerator_ = new EventGenerator(this.query_);
	    }
	    /**
	     * @return {!Query}
	     */
	    View.prototype.getQuery = function () {
	        return this.query_;
	    };
	    /**
	     * @return {?Node}
	     */
	    View.prototype.getServerCache = function () {
	        return this.viewCache_.getServerCache().getNode();
	    };
	    /**
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    View.prototype.getCompleteServerCache = function (path) {
	        var cache = this.viewCache_.getCompleteServerSnap();
	        if (cache) {
	            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
	            // we need to see if it contains the child we're interested in.
	            if (this.query_.getQueryParams().loadsAllData() ||
	                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
	                return cache.getChild(path);
	            }
	        }
	        return null;
	    };
	    /**
	     * @return {boolean}
	     */
	    View.prototype.isEmpty = function () {
	        return this.eventRegistrations_.length === 0;
	    };
	    /**
	     * @param {!EventRegistration} eventRegistration
	     */
	    View.prototype.addEventRegistration = function (eventRegistration) {
	        this.eventRegistrations_.push(eventRegistration);
	    };
	    /**
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
	     */
	    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
	        var cancelEvents = [];
	        if (cancelError) {
	            util.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
	            var path_1 = this.query_.path;
	            this.eventRegistrations_.forEach(function (registration) {
	                cancelError /** @type {!Error} */ = cancelError;
	                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
	                if (maybeEvent) {
	                    cancelEvents.push(maybeEvent);
	                }
	            });
	        }
	        if (eventRegistration) {
	            var remaining = [];
	            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
	                var existing = this.eventRegistrations_[i];
	                if (!existing.matches(eventRegistration)) {
	                    remaining.push(existing);
	                }
	                else if (eventRegistration.hasAnyCallback()) {
	                    // We're removing just this one
	                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
	                    break;
	                }
	            }
	            this.eventRegistrations_ = remaining;
	        }
	        else {
	            this.eventRegistrations_ = [];
	        }
	        return cancelEvents;
	    };
	    /**
	     * Applies the given Operation, updates our cache, and returns the appropriate events.
	     *
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
	        if (operation.type === OperationType.MERGE &&
	            operation.source.queryId !== null) {
	            util.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
	            util.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
	        }
	        var oldViewCache = this.viewCache_;
	        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
	        this.processor_.assertIndexed(result.viewCache);
	        util.assert(result.viewCache.getServerCache().isFullyInitialized() ||
	            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
	        this.viewCache_ = result.viewCache;
	        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
	    };
	    /**
	     * @param {!EventRegistration} registration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.getInitialEvents = function (registration) {
	        var eventSnap = this.viewCache_.getEventCache();
	        var initialChanges = [];
	        if (!eventSnap.getNode().isLeafNode()) {
	            var eventNode = eventSnap.getNode();
	            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                initialChanges.push(Change.childAddedChange(key, childNode));
	            });
	        }
	        if (eventSnap.isFullyInitialized()) {
	            initialChanges.push(Change.valueChange(eventSnap.getNode()));
	        }
	        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
	    };
	    /**
	     * @private
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {EventRegistration=} eventRegistration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
	        var registrations = eventRegistration
	            ? [eventRegistration]
	            : this.eventRegistrations_;
	        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
	    };
	    return View;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __referenceConstructor$1;
	/**
	 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
	 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
	 * and user writes (set, transaction, update).
	 *
	 * It's responsible for:
	 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
	 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
	 *    applyUserOverwrite, etc.)
	 */
	var SyncPoint = /** @class */ (function () {
	    function SyncPoint() {
	        /**
	         * The Views being tracked at this location in the tree, stored as a map where the key is a
	         * queryId and the value is the View for that query.
	         *
	         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
	         */
	        this.views = new Map();
	    }
	    Object.defineProperty(SyncPoint, "__referenceConstructor", {
	        get: function () {
	            util.assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
	            return __referenceConstructor$1;
	        },
	        set: function (val) {
	            util.assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
	            __referenceConstructor$1 = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SyncPoint.prototype.isEmpty = function () {
	        return this.views.size === 0;
	    };
	    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
	        var e_1, _a;
	        var queryId = operation.source.queryId;
	        if (queryId !== null) {
	            var view = this.views.get(queryId);
	            util.assert(view != null, 'SyncTree gave us an op for an invalid query.');
	            return view.applyOperation(operation, writesCache, optCompleteServerCache);
	        }
	        else {
	            var events = [];
	            try {
	                for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var view = _c.value;
	                    events = events.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            return events;
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache Complete server cache, if we have it.
	     * @param {boolean} serverCacheComplete
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
	        var queryId = query.queryIdentifier();
	        var view = this.views.get(queryId);
	        if (!view) {
	            // TODO: make writesCache take flag for complete server node
	            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
	            var eventCacheComplete = false;
	            if (eventCache) {
	                eventCacheComplete = true;
	            }
	            else if (serverCache instanceof ChildrenNode) {
	                eventCache = writesCache.calcCompleteEventChildren(serverCache);
	                eventCacheComplete = false;
	            }
	            else {
	                eventCache = ChildrenNode.EMPTY_NODE;
	                eventCacheComplete = false;
	            }
	            var viewCache = new ViewCache(new CacheNode(
	            /** @type {!Node} */ eventCache, eventCacheComplete, false), new CacheNode(
	            /** @type {!Node} */ serverCache, serverCacheComplete, false));
	            view = new View(query, viewCache);
	            this.views.set(queryId, view);
	        }
	        // This is guaranteed to exist now, we just created anything that was missing
	        view.addEventRegistration(eventRegistration);
	        return view.getInitialEvents(eventRegistration);
	    };
	    /**
	     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
	     *
	     * If query is the default query, we'll check all views for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
	     *
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
	     */
	    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var e_2, _a;
	        var queryId = query.queryIdentifier();
	        var removed = [];
	        var cancelEvents = [];
	        var hadCompleteView = this.hasCompleteView();
	        if (queryId === 'default') {
	            try {
	                // When you do ref.off(...), we search all views for the registration to remove.
	                for (var _b = tslib.__values(this.views.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var _d = tslib.__read(_c.value, 2), viewQueryId = _d[0], view = _d[1];
	                    cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                    if (view.isEmpty()) {
	                        this.views.delete(viewQueryId);
	                        // We'll deal with complete views later.
	                        if (!view
	                            .getQuery()
	                            .getQueryParams()
	                            .loadsAllData()) {
	                            removed.push(view.getQuery());
	                        }
	                    }
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	        }
	        else {
	            // remove the callback from the specific view.
	            var view = this.views.get(queryId);
	            if (view) {
	                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                if (view.isEmpty()) {
	                    this.views.delete(queryId);
	                    // We'll deal with complete views later.
	                    if (!view
	                        .getQuery()
	                        .getQueryParams()
	                        .loadsAllData()) {
	                        removed.push(view.getQuery());
	                    }
	                }
	            }
	        }
	        if (hadCompleteView && !this.hasCompleteView()) {
	            // We removed our last complete view.
	            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
	        }
	        return { removed: removed, events: cancelEvents };
	    };
	    SyncPoint.prototype.getQueryViews = function () {
	        var e_3, _a;
	        var result = [];
	        try {
	            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var view = _c.value;
	                if (!view
	                    .getQuery()
	                    .getQueryParams()
	                    .loadsAllData()) {
	                    result.push(view);
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        return result;
	    };
	    /**
	     * @param path The path to the desired complete snapshot
	     * @return A complete cache, if it exists
	     */
	    SyncPoint.prototype.getCompleteServerCache = function (path) {
	        var e_4, _a;
	        var serverCache = null;
	        try {
	            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var view = _c.value;
	                serverCache = serverCache || view.getCompleteServerCache(path);
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        return serverCache;
	    };
	    SyncPoint.prototype.viewForQuery = function (query) {
	        var params = query.getQueryParams();
	        if (params.loadsAllData()) {
	            return this.getCompleteView();
	        }
	        else {
	            var queryId = query.queryIdentifier();
	            return this.views.get(queryId);
	        }
	    };
	    SyncPoint.prototype.viewExistsForQuery = function (query) {
	        return this.viewForQuery(query) != null;
	    };
	    SyncPoint.prototype.hasCompleteView = function () {
	        return this.getCompleteView() != null;
	    };
	    SyncPoint.prototype.getCompleteView = function () {
	        var e_5, _a;
	        try {
	            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var view = _c.value;
	                if (view
	                    .getQuery()
	                    .getQueryParams()
	                    .loadsAllData()) {
	                    return view;
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        return null;
	    };
	    return SyncPoint;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
	 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
	 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
	 * to reflect the write added.
	 */
	var CompoundWrite = /** @class */ (function () {
	    function CompoundWrite(writeTree_) {
	        this.writeTree_ = writeTree_;
	    }
	    CompoundWrite.prototype.addWrite = function (path, node) {
	        if (path.isEmpty()) {
	            return new CompoundWrite(new ImmutableTree(node));
	        }
	        else {
	            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	            if (rootmost != null) {
	                var rootMostPath = rootmost.path;
	                var value = rootmost.value;
	                var relativePath = Path.relativePath(rootMostPath, path);
	                value = value.updateChild(relativePath, node);
	                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
	            }
	            else {
	                var subtree = new ImmutableTree(node);
	                var newWriteTree = this.writeTree_.setTree(path, subtree);
	                return new CompoundWrite(newWriteTree);
	            }
	        }
	    };
	    CompoundWrite.prototype.addWrites = function (path, updates) {
	        var newWrite = this;
	        each(updates, function (childKey, node) {
	            newWrite = newWrite.addWrite(path.child(childKey), node);
	        });
	        return newWrite;
	    };
	    /**
	     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
	     * location, which must be removed by calling this method with that path.
	     *
	     * @param path The path at which a write and all deeper writes should be removed
	     * @return {!CompoundWrite} The new CompoundWrite with the removed path
	     */
	    CompoundWrite.prototype.removeWrite = function (path) {
	        if (path.isEmpty()) {
	            return CompoundWrite.Empty;
	        }
	        else {
	            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
	            return new CompoundWrite(newWriteTree);
	        }
	    };
	    /**
	     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
	     * considered "complete".
	     *
	     * @param path The path to check for
	     * @return Whether there is a complete write at that path
	     */
	    CompoundWrite.prototype.hasCompleteWrite = function (path) {
	        return this.getCompleteNode(path) != null;
	    };
	    /**
	     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
	     * writes from deeper paths, but will return child nodes from a more shallow path.
	     *
	     * @param path The path to get a complete write
	     * @return The node if complete at that path, or null otherwise.
	     */
	    CompoundWrite.prototype.getCompleteNode = function (path) {
	        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	        if (rootmost != null) {
	            return this.writeTree_
	                .get(rootmost.path)
	                .getChild(Path.relativePath(rootmost.path, path));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Returns all children that are guaranteed to be a complete overwrite.
	     *
	     * @return A list of all complete children.
	     */
	    CompoundWrite.prototype.getCompleteChildren = function () {
	        var children = [];
	        var node = this.writeTree_.value;
	        if (node != null) {
	            // If it's a leaf node, it has no children; so nothing to do.
	            if (!node.isLeafNode()) {
	                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	                    children.push(new NamedNode(childName, childNode));
	                });
	            }
	        }
	        else {
	            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
	                if (childTree.value != null) {
	                    children.push(new NamedNode(childName, childTree.value));
	                }
	            });
	        }
	        return children;
	    };
	    CompoundWrite.prototype.childCompoundWrite = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else {
	            var shadowingNode = this.getCompleteNode(path);
	            if (shadowingNode != null) {
	                return new CompoundWrite(new ImmutableTree(shadowingNode));
	            }
	            else {
	                return new CompoundWrite(this.writeTree_.subtree(path));
	            }
	        }
	    };
	    /**
	     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
	     * @return Whether this CompoundWrite is empty
	     */
	    CompoundWrite.prototype.isEmpty = function () {
	        return this.writeTree_.isEmpty();
	    };
	    /**
	     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
	     * node
	     * @param node The node to apply this CompoundWrite to
	     * @return The node with all writes applied
	     */
	    CompoundWrite.prototype.apply = function (node) {
	        return applySubtreeWrite(Path.Empty, this.writeTree_, node);
	    };
	    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
	    return CompoundWrite;
	}());
	function applySubtreeWrite(relativePath, writeTree, node) {
	    if (writeTree.value != null) {
	        // Since there a write is always a leaf, we're done here
	        return node.updateChild(relativePath, writeTree.value);
	    }
	    else {
	        var priorityWrite_1 = null;
	        writeTree.children.inorderTraversal(function (childKey, childTree) {
	            if (childKey === '.priority') {
	                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
	                // to apply priorities to empty nodes that are later filled
	                util.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
	                priorityWrite_1 = childTree.value;
	            }
	            else {
	                node = applySubtreeWrite(relativePath.child(childKey), childTree, node);
	            }
	        });
	        // If there was a priority write, we only apply it if the node is not empty
	        if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
	            node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
	        }
	        return node;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
	 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
	 * and addMerge(), and removed with removeWrite().
	 *
	 * @constructor
	 */
	var WriteTree = /** @class */ (function () {
	    function WriteTree() {
	        /**
	         * A tree tracking the result of applying all visible writes.  This does not include transactions with
	         * applyLocally=false or writes that are completely shadowed by other writes.
	         *
	         * @type {!CompoundWrite}
	         * @private
	         */
	        this.visibleWrites_ = CompoundWrite.Empty;
	        /**
	         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
	         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
	         * used by transactions).
	         *
	         * @type {!Array.<!WriteRecord>}
	         * @private
	         */
	        this.allWrites_ = [];
	        this.lastWriteId_ = -1;
	    }
	    /**
	     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
	     *
	     * @param {!Path} path
	     * @return {!WriteTreeRef}
	     */
	    WriteTree.prototype.childWrites = function (path) {
	        return new WriteTreeRef(path, this);
	    };
	    /**
	     * Record a new overwrite from user code.
	     *
	     * @param {!Path} path
	     * @param {!Node} snap
	     * @param {!number} writeId
	     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
	     */
	    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
	        util.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
	        if (visible === undefined) {
	            visible = true;
	        }
	        this.allWrites_.push({
	            path: path,
	            snap: snap,
	            writeId: writeId,
	            visible: visible
	        });
	        if (visible) {
	            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
	        }
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * Record a new merge from user code.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} writeId
	     */
	    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
	        util.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
	        this.allWrites_.push({
	            path: path,
	            children: changedChildren,
	            writeId: writeId,
	            visible: true
	        });
	        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * @param {!number} writeId
	     * @return {?WriteRecord}
	     */
	    WriteTree.prototype.getWrite = function (writeId) {
	        for (var i = 0; i < this.allWrites_.length; i++) {
	            var record = this.allWrites_[i];
	            if (record.writeId === writeId) {
	                return record;
	            }
	        }
	        return null;
	    };
	    /**
	     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
	     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
	     *
	     * @param {!number} writeId
	     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
	     * events as a result).
	     */
	    WriteTree.prototype.removeWrite = function (writeId) {
	        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
	        // out of order.
	        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
	        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
	        var _this = this;
	        var idx = this.allWrites_.findIndex(function (s) {
	            return s.writeId === writeId;
	        });
	        util.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
	        var writeToRemove = this.allWrites_[idx];
	        this.allWrites_.splice(idx, 1);
	        var removedWriteWasVisible = writeToRemove.visible;
	        var removedWriteOverlapsWithOtherWrites = false;
	        var i = this.allWrites_.length - 1;
	        while (removedWriteWasVisible && i >= 0) {
	            var currentWrite = this.allWrites_[i];
	            if (currentWrite.visible) {
	                if (i >= idx &&
	                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
	                    // The removed write was completely shadowed by a subsequent write.
	                    removedWriteWasVisible = false;
	                }
	                else if (writeToRemove.path.contains(currentWrite.path)) {
	                    // Either we're covering some writes or they're covering part of us (depending on which came first).
	                    removedWriteOverlapsWithOtherWrites = true;
	                }
	            }
	            i--;
	        }
	        if (!removedWriteWasVisible) {
	            return false;
	        }
	        else if (removedWriteOverlapsWithOtherWrites) {
	            // There's some shadowing going on. Just rebuild the visible writes from scratch.
	            this.resetTree_();
	            return true;
	        }
	        else {
	            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
	            if (writeToRemove.snap) {
	                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
	            }
	            else {
	                var children = writeToRemove.children;
	                each(children, function (childName) {
	                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
	                });
	            }
	            return true;
	        }
	    };
	    /**
	     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
	     * No server data is considered.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTree.prototype.getCompleteWriteData = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
	     * writes), attempt to calculate a complete snapshot for the given path
	     *
	     * @param {!Path} treePath
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        if (!writeIdsToExclude && !includeHiddenWrites) {
	            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
	            if (shadowingNode != null) {
	                return shadowingNode;
	            }
	            else {
	                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
	                if (subMerge.isEmpty()) {
	                    return completeServerCache;
	                }
	                else if (completeServerCache == null &&
	                    !subMerge.hasCompleteWrite(Path.Empty)) {
	                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
	                    return null;
	                }
	                else {
	                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
	                    return subMerge.apply(layeredCache);
	                }
	            }
	        }
	        else {
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            if (!includeHiddenWrites && merge.isEmpty()) {
	                return completeServerCache;
	            }
	            else {
	                // If the server cache is null, and we don't have a complete cache, we need to return null
	                if (!includeHiddenWrites &&
	                    completeServerCache == null &&
	                    !merge.hasCompleteWrite(Path.Empty)) {
	                    return null;
	                }
	                else {
	                    var filter = function (write) {
	                        return ((write.visible || includeHiddenWrites) &&
	                            (!writeIdsToExclude ||
	                                !~writeIdsToExclude.indexOf(write.writeId)) &&
	                            (write.path.contains(treePath) || treePath.contains(write.path)));
	                    };
	                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
	                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
	                    return mergeAtPath.apply(layeredCache);
	                }
	            }
	        }
	    };
	    /**
	     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
	     * Used when creating new views, to pre-fill their complete event children snapshot.
	     *
	     * @param {!Path} treePath
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
	        var completeChildren = ChildrenNode.EMPTY_NODE;
	        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
	        if (topLevelSet) {
	            if (!topLevelSet.isLeafNode()) {
	                // we're shadowing everything. Return the children.
	                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
	                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
	                });
	            }
	            return completeChildren;
	        }
	        else if (completeServerChildren) {
	            // Layer any children we have on top of this
	            // We know we don't have a top-level set, so just enumerate existing children
	            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
	            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	                var node = merge_1
	                    .childCompoundWrite(new Path(childName))
	                    .apply(childNode);
	                completeChildren = completeChildren.updateImmediateChild(childName, node);
	            });
	            // Add any complete children we have from the set
	            merge_1.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	        else {
	            // We don't have anything to layer on top of. Layer on any children we have
	            // Note that we can return an empty snap if we have a defined delete
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            merge.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	    };
	    /**
	     * Given that the underlying server data has updated, determine what, if anything, needs to be
	     * applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events
	     *
	     * Either existingEventSnap or existingServerSnap must exist
	     *
	     * @param {!Path} treePath
	     * @param {!Path} childPath
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
	        util.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
	        var path = treePath.child(childPath);
	        if (this.visibleWrites_.hasCompleteWrite(path)) {
	            // At this point we can probably guarantee that we're in case 2, meaning no events
	            // May need to check visibility while doing the findRootMostValueAndPath call
	            return null;
	        }
	        else {
	            // No complete shadowing. We're either partially shadowing or not shadowing at all.
	            var childMerge = this.visibleWrites_.childCompoundWrite(path);
	            if (childMerge.isEmpty()) {
	                // We're not shadowing at all. Case 1
	                return existingServerSnap.getChild(childPath);
	            }
	            else {
	                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
	                // However this is tricky to find out, since user updates don't necessary change the server
	                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
	                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
	                // only check if the updates change the serverNode.
	                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
	                return childMerge.apply(existingServerSnap.getChild(childPath));
	            }
	        }
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!Path} treePath
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
	        var path = treePath.child(childKey);
	        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
	        if (shadowingNode != null) {
	            return shadowingNode;
	        }
	        else {
	            if (existingServerSnap.isCompleteForChild(childKey)) {
	                var childMerge = this.visibleWrites_.childCompoundWrite(path);
	                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     */
	    WriteTree.prototype.shadowingWrite = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window.
	     */
	    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
	        var toIterate;
	        var merge = this.visibleWrites_.childCompoundWrite(treePath);
	        var shadowingNode = merge.getCompleteNode(Path.Empty);
	        if (shadowingNode != null) {
	            toIterate = shadowingNode;
	        }
	        else if (completeServerData != null) {
	            toIterate = merge.apply(completeServerData);
	        }
	        else {
	            // no children to iterate on
	            return [];
	        }
	        toIterate = toIterate.withIndex(index);
	        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
	            var nodes = [];
	            var cmp = index.getCompare();
	            var iter = reverse
	                ? toIterate.getReverseIteratorFrom(startPost, index)
	                : toIterate.getIteratorFrom(startPost, index);
	            var next = iter.getNext();
	            while (next && nodes.length < count) {
	                if (cmp(next, startPost) !== 0) {
	                    nodes.push(next);
	                }
	                next = iter.getNext();
	            }
	            return nodes;
	        }
	        else {
	            return [];
	        }
	    };
	    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
	        if (writeRecord.snap) {
	            return writeRecord.path.contains(path);
	        }
	        else {
	            for (var childName in writeRecord.children) {
	                if (writeRecord.children.hasOwnProperty(childName) &&
	                    writeRecord.path.child(childName).contains(path)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    };
	    /**
	     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
	     */
	    WriteTree.prototype.resetTree_ = function () {
	        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
	        if (this.allWrites_.length > 0) {
	            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
	        }
	        else {
	            this.lastWriteId_ = -1;
	        }
	    };
	    /**
	     * The default filter used when constructing the tree. Keep everything that's visible.
	     */
	    WriteTree.DefaultFilter_ = function (write) {
	        return write.visible;
	    };
	    /**
	     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
	     * event data at that path.
	     */
	    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
	        var compoundWrite = CompoundWrite.Empty;
	        for (var i = 0; i < writes.length; ++i) {
	            var write = writes[i];
	            // Theory, a later set will either:
	            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
	            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
	            if (filter(write)) {
	                var writePath = write.path;
	                var relativePath = void 0;
	                if (write.snap) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path.relativePath(writePath, treeRoot);
	                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
	                    }
	                }
	                else if (write.children) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path.relativePath(writePath, treeRoot);
	                        if (relativePath.isEmpty()) {
	                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
	                        }
	                        else {
	                            var child = util.safeGet(write.children, relativePath.getFront());
	                            if (child) {
	                                // There exists a child in this node that matches the root path
	                                var deepNode = child.getChild(relativePath.popFront());
	                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
	                            }
	                        }
	                    }
	                }
	                else {
	                    throw util.assertionError('WriteRecord should have .snap or .children');
	                }
	            }
	        }
	        return compoundWrite;
	    };
	    return WriteTree;
	}());
	/**
	 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
	 * just proxy to the underlying WriteTree.
	 *
	 * @constructor
	 */
	var WriteTreeRef = /** @class */ (function () {
	    /**
	     * @param {!Path} path
	     * @param {!WriteTree} writeTree
	     */
	    function WriteTreeRef(path, writeTree) {
	        this.treePath_ = path;
	        this.writeTree_ = writeTree;
	    }
	    /**
	     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
	     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
	     * can lead to a more expensive calculation.
	     *
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
	    };
	    /**
	     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
	     * mix of the given server data and write data.
	     *
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
	        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
	    };
	    /**
	     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
	     * if anything, needs to be applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events should be raised
	     *
	     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
	     *
	     * @param {!Path} path
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
	        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.shadowingWrite = function (path) {
	        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window
	     *
	     * @param {?Node} completeServerData
	     * @param {!NamedNode} startPost
	     * @param {!number} count
	     * @param {boolean} reverse
	     * @param {!Index} index
	     * @return {!Array.<!NamedNode>}
	     */
	    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
	        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerCache
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
	        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
	    };
	    /**
	     * Return a WriteTreeRef for a child.
	     *
	     * @param {string} childName
	     * @return {!WriteTreeRef}
	     */
	    WriteTreeRef.prototype.child = function (childName) {
	        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
	    };
	    return WriteTreeRef;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * SyncTree is the central class for managing event callback registration, data caching, views
	 * (query processing), and event generation.  There are typically two SyncTree instances for
	 * each Repo, one for the normal Firebase data, and one for the .info data.
	 *
	 * It has a number of responsibilities, including:
	 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
	 *  - Applying and caching data changes for user set(), transaction(), and update() calls
	 *    (applyUserOverwrite(), applyUserMerge()).
	 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
	 *    applyServerMerge()).
	 *  - Generating user-facing events for server and user changes (all of the apply* methods
	 *    return the set of events that need to be raised as a result).
	 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
	 *    to the correct set of paths and queries to satisfy the current set of user event
	 *    callbacks (listens are started/stopped using the provided listenProvider).
	 *
	 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
	 * events are returned to the caller rather than raised synchronously.
	 *
	 * @constructor
	 */
	var SyncTree = /** @class */ (function () {
	    /**
	     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
	     *   to server data.
	     */
	    function SyncTree(listenProvider_) {
	        this.listenProvider_ = listenProvider_;
	        /**
	         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
	         */
	        this.syncPointTree_ = ImmutableTree.Empty;
	        /**
	         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
	         */
	        this.pendingWriteTree_ = new WriteTree();
	        this.tagToQueryMap = new Map();
	        this.queryToTagMap = new Map();
	    }
	    /**
	     * Apply the data changes for a user-generated set() or transaction() call.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
	        // Record pending write.
	        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
	        if (!visible) {
	            return [];
	        }
	        else {
	            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
	        }
	    };
	    /**
	     * Apply the data from a user-generated update() call
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
	        // Record pending merge.
	        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
	        var changeTree = ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
	    };
	    /**
	     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
	     *
	     * @param revert True if the given write failed and needs to be reverted
	     * @return Events to raise.
	     */
	    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
	        if (revert === void 0) { revert = false; }
	        var write = this.pendingWriteTree_.getWrite(writeId);
	        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
	        if (!needToReevaluate) {
	            return [];
	        }
	        else {
	            var affectedTree_1 = ImmutableTree.Empty;
	            if (write.snap != null) {
	                // overwrite
	                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
	            }
	            else {
	                each(write.children, function (pathString, node) {
	                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
	                });
	            }
	            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
	        }
	    };
	    /**
	     * Apply new server data for the specified path..
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
	        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
	    };
	    /**
	     * Apply new server data to be merged in at the specified path.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
	        var changeTree = ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
	    };
	    /**
	     * Apply a listen complete for a query
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyListenComplete = function (path) {
	        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
	    };
	    /**
	     * Apply new server data for the specified tagged query.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey != null) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // Query must have been removed already
	            return [];
	        }
	    };
	    /**
	     * Apply server data to be merged in for the specified tagged query.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var changeTree = ImmutableTree.fromObject(changedChildren);
	            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Apply a listen complete for a tagged query
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
	        var path = query.path;
	        var serverCache = null;
	        var foundAncestorDefaultView = false;
	        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
	        // Consider optimizing this once there's a better understanding of what actual behavior will be.
	        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
	            var relativePath = Path.relativePath(pathToSyncPoint, path);
	            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || sp.hasCompleteView();
	        });
	        var syncPoint = this.syncPointTree_.get(path);
	        if (!syncPoint) {
	            syncPoint = new SyncPoint();
	            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
	        }
	        else {
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || syncPoint.hasCompleteView();
	            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
	        }
	        var serverCacheComplete;
	        if (serverCache != null) {
	            serverCacheComplete = true;
	        }
	        else {
	            serverCacheComplete = false;
	            serverCache = ChildrenNode.EMPTY_NODE;
	            var subtree = this.syncPointTree_.subtree(path);
	            subtree.foreachChild(function (childName, childSyncPoint) {
	                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
	                if (completeCache) {
	                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
	                }
	            });
	        }
	        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
	        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
	            // We need to track a tag for this query
	            var queryKey = SyncTree.makeQueryKey_(query);
	            util.assert(!this.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
	            var tag = SyncTree.getNextQueryTag_();
	            this.queryToTagMap.set(queryKey, tag);
	            this.tagToQueryMap.set(tag, queryKey);
	        }
	        var writesCache = this.pendingWriteTree_.childWrites(path);
	        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
	        if (!viewAlreadyExists && !foundAncestorDefaultView) {
	            var view /** @type !View */ = syncPoint.viewForQuery(query);
	            events = events.concat(this.setupListener_(query, view));
	        }
	        return events;
	    };
	    /**
	     * Remove event callback(s).
	     *
	     * If query is the default query, we'll check all queries for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
	     *
	     * @param eventRegistration If null, all callbacks are removed.
	     * @param cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return Cancel events, if cancelError was provided.
	     */
	    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var _this = this;
	        // Find the syncPoint first. Then deal with whether or not it has matching listeners
	        var path = query.path;
	        var maybeSyncPoint = this.syncPointTree_.get(path);
	        var cancelEvents = [];
	        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
	        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
	        // not loadsAllData().
	        if (maybeSyncPoint &&
	            (query.queryIdentifier() === 'default' ||
	                maybeSyncPoint.viewExistsForQuery(query))) {
	            /**
	             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
	             */
	            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
	            if (maybeSyncPoint.isEmpty()) {
	                this.syncPointTree_ = this.syncPointTree_.remove(path);
	            }
	            var removed = removedAndEvents.removed;
	            cancelEvents = removedAndEvents.events;
	            // We may have just removed one of many listeners and can short-circuit this whole process
	            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
	            // properly set up.
	            //
	            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
	            // queryId === 'default'
	            var removingDefault = -1 !==
	                removed.findIndex(function (query) {
	                    return query.getQueryParams().loadsAllData();
	                });
	            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
	                return parentSyncPoint.hasCompleteView();
	            });
	            if (removingDefault && !covered) {
	                var subtree = this.syncPointTree_.subtree(path);
	                // There are potentially child listeners. Determine what if any listens we need to send before executing the
	                // removal
	                if (!subtree.isEmpty()) {
	                    // We need to fold over our subtree and collect the listeners to send
	                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
	                    // Ok, we've collected all the listens we need. Set them up.
	                    for (var i = 0; i < newViews.length; ++i) {
	                        var view = newViews[i], newQuery = view.getQuery();
	                        var listener = this.createListenerForView_(view);
	                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
	                    }
	                }
	            }
	            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
	            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
	            // Also, note that if we have a cancelError, it's already been removed at the provider level.
	            if (!covered && removed.length > 0 && !cancelError) {
	                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
	                // default. Otherwise, we need to iterate through and cancel each individual query
	                if (removingDefault) {
	                    // We don't tag default listeners
	                    var defaultTag = null;
	                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
	                }
	                else {
	                    removed.forEach(function (queryToRemove) {
	                        var tagToRemove = _this.queryToTagMap.get(SyncTree.makeQueryKey_(queryToRemove));
	                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
	                    });
	                }
	            }
	            // Now, clear all of the tags we're tracking for the removed listens
	            this.removeTags_(removed);
	        }
	        return cancelEvents;
	    };
	    /**
	     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
	     * it, but as this is only used by transaction code, that should always be the case anyways.
	     *
	     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
	     *
	     * @param path The path to the data we want
	     * @param writeIdsToExclude A specific set to be excluded
	     */
	    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
	        var includeHiddenSets = true;
	        var writeTree = this.pendingWriteTree_;
	        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
	            var relativePath = Path.relativePath(pathSoFar, path);
	            var serverCache = syncPoint.getCompleteServerCache(relativePath);
	            if (serverCache) {
	                return serverCache;
	            }
	        });
	        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
	    };
	    /**
	     * This collapses multiple unfiltered views into a single view, since we only need a single
	     * listener for them.
	     */
	    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
	        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
	                var completeView = maybeChildSyncPoint.getCompleteView();
	                return [completeView];
	            }
	            else {
	                // No complete view here, flatten any deeper listens into an array
	                var views_1 = [];
	                if (maybeChildSyncPoint) {
	                    views_1 = maybeChildSyncPoint.getQueryViews();
	                }
	                each(childMap, function (_key, childViews) {
	                    views_1 = views_1.concat(childViews);
	                });
	                return views_1;
	            }
	        });
	    };
	    SyncTree.prototype.removeTags_ = function (queries) {
	        for (var j = 0; j < queries.length; ++j) {
	            var removedQuery = queries[j];
	            if (!removedQuery.getQueryParams().loadsAllData()) {
	                // We should have a tag for this
	                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
	                var removedQueryTag = this.queryToTagMap.get(removedQueryKey);
	                this.queryToTagMap.delete(removedQueryKey);
	                this.tagToQueryMap.delete(removedQueryTag);
	            }
	        }
	    };
	    /**
	     * Normalizes a query to a query we send the server for listening
	     *
	     * @return The normalized query
	     */
	    SyncTree.queryForListening_ = function (query) {
	        if (query.getQueryParams().loadsAllData() &&
	            !query.getQueryParams().isDefault()) {
	            // We treat queries that load all data as default queries
	            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
	            // from Query
	            return query.getRef();
	        }
	        else {
	            return query;
	        }
	    };
	    /**
	     * For a given new listen, manage the de-duplication of outstanding subscriptions.
	     *
	     * @return This method can return events to support synchronous data sources
	     */
	    SyncTree.prototype.setupListener_ = function (query, view) {
	        var path = query.path;
	        var tag = this.tagForQuery_(query);
	        var listener = this.createListenerForView_(view);
	        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
	        var subtree = this.syncPointTree_.subtree(path);
	        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
	        // may need to shadow other listens as well.
	        if (tag) {
	            util.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
	        }
	        else {
	            // Shadow everything at or below this location, this is a default listener.
	            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	                if (!relativePath.isEmpty() &&
	                    maybeChildSyncPoint &&
	                    maybeChildSyncPoint.hasCompleteView()) {
	                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
	                }
	                else {
	                    // No default listener here, flatten any deeper queries into an array
	                    var queries_1 = [];
	                    if (maybeChildSyncPoint) {
	                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
	                    }
	                    each(childMap, function (_key, childQueries) {
	                        queries_1 = queries_1.concat(childQueries);
	                    });
	                    return queries_1;
	                }
	            });
	            for (var i = 0; i < queriesToStop.length; ++i) {
	                var queryToStop = queriesToStop[i];
	                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
	            }
	        }
	        return events;
	    };
	    SyncTree.prototype.createListenerForView_ = function (view) {
	        var _this = this;
	        var query = view.getQuery();
	        var tag = this.tagForQuery_(query);
	        return {
	            hashFn: function () {
	                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
	                return cache.hash();
	            },
	            onComplete: function (status) {
	                if (status === 'ok') {
	                    if (tag) {
	                        return _this.applyTaggedListenComplete(query.path, tag);
	                    }
	                    else {
	                        return _this.applyListenComplete(query.path);
	                    }
	                }
	                else {
	                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
	                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
	                    var error = errorForServerCode(status, query);
	                    return _this.removeEventRegistration(query, 
	                    /*eventRegistration*/ null, error);
	                }
	            }
	        };
	    };
	    /**
	     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
	     */
	    SyncTree.makeQueryKey_ = function (query) {
	        return query.path.toString() + '$' + query.queryIdentifier();
	    };
	    /**
	     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
	     */
	    SyncTree.parseQueryKey_ = function (queryKey) {
	        var splitIndex = queryKey.indexOf('$');
	        util.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
	        return {
	            queryId: queryKey.substr(splitIndex + 1),
	            path: new Path(queryKey.substr(0, splitIndex))
	        };
	    };
	    /**
	     * Return the query associated with the given tag, if we have one
	     */
	    SyncTree.prototype.queryKeyForTag_ = function (tag) {
	        return this.tagToQueryMap.get(tag);
	    };
	    /**
	     * Return the tag associated with the given query.
	     */
	    SyncTree.prototype.tagForQuery_ = function (query) {
	        var queryKey = SyncTree.makeQueryKey_(query);
	        return this.queryToTagMap.get(queryKey);
	    };
	    /**
	     * Static accessor for query tags.
	     */
	    SyncTree.getNextQueryTag_ = function () {
	        return SyncTree.nextQueryTag_++;
	    };
	    /**
	     * A helper method to apply tagged operations
	     */
	    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
	        var syncPoint = this.syncPointTree_.get(queryPath);
	        util.assert(syncPoint, "Missing sync point for query tag that we're tracking");
	        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
	        return syncPoint.applyOperation(operation, writesCache, 
	        /*serverCache=*/ null);
	    };
	    /**
	     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
	     *
	     * NOTES:
	     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
	     *
	     * - We call applyOperation() on each SyncPoint passing three things:
	     *   1. A version of the Operation that has been made relative to the SyncPoint location.
	     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
	     *   3. A snapshot Node with cached server data, if we have it.
	     *
	     * - We concatenate all of the events returned by each SyncPoint and return the result.
	     */
	    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
	        return this.applyOperationHelper_(operation, this.syncPointTree_, 
	        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     */
	    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        if (operation.path.isEmpty()) {
	            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
	        }
	        else {
	            var syncPoint = syncPointTree.get(Path.Empty);
	            // If we don't have cached server data, see if we can get it from this SyncPoint.
	            if (serverCache == null && syncPoint != null) {
	                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
	            }
	            var events = [];
	            var childName = operation.path.getFront();
	            var childOperation = operation.operationForChild(childName);
	            var childTree = syncPointTree.children.get(childName);
	            if (childTree && childOperation) {
	                var childServerCache = serverCache
	                    ? serverCache.getImmediateChild(childName)
	                    : null;
	                var childWritesCache = writesCache.child(childName);
	                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	            if (syncPoint) {
	                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	            }
	            return events;
	        }
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     */
	    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        var _this = this;
	        var syncPoint = syncPointTree.get(Path.Empty);
	        // If we don't have cached server data, see if we can get it from this SyncPoint.
	        if (serverCache == null && syncPoint != null) {
	            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
	        }
	        var events = [];
	        syncPointTree.children.inorderTraversal(function (childName, childTree) {
	            var childServerCache = serverCache
	                ? serverCache.getImmediateChild(childName)
	                : null;
	            var childWritesCache = writesCache.child(childName);
	            var childOperation = operation.operationForChild(childName);
	            if (childOperation) {
	                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	        });
	        if (syncPoint) {
	            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	        }
	        return events;
	    };
	    /**
	     * Static tracker for next query tag.
	     */
	    SyncTree.nextQueryTag_ = 1;
	    return SyncTree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
	 *
	 * @constructor
	 */
	var SnapshotHolder = /** @class */ (function () {
	    function SnapshotHolder() {
	        this.rootNode_ = ChildrenNode.EMPTY_NODE;
	    }
	    SnapshotHolder.prototype.getNode = function (path) {
	        return this.rootNode_.getChild(path);
	    };
	    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
	        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
	    };
	    return SnapshotHolder;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Abstraction around FirebaseApp's token fetching capabilities.
	 */
	var AuthTokenProvider = /** @class */ (function () {
	    function AuthTokenProvider(app_, authProvider_) {
	        var _this = this;
	        this.app_ = app_;
	        this.authProvider_ = authProvider_;
	        this.auth_ = null;
	        this.auth_ = authProvider_.getImmediate({ optional: true });
	        if (!this.auth_) {
	            authProvider_.get().then(function (auth) { return (_this.auth_ = auth); });
	        }
	    }
	    /**
	     * @param {boolean} forceRefresh
	     * @return {!Promise<FirebaseAuthTokenData>}
	     */
	    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
	        if (!this.auth_) {
	            return Promise.resolve(null);
	        }
	        return this.auth_.getToken(forceRefresh).catch(function (error) {
	            // TODO: Need to figure out all the cases this is raised and whether
	            // this makes sense.
	            if (error && error.code === 'auth/token-not-initialized') {
	                log('Got auth/token-not-initialized error.  Treating as null token.');
	                return null;
	            }
	            else {
	                return Promise.reject(error);
	            }
	        });
	    };
	    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
	        // TODO: We might want to wrap the listener and call it with no args to
	        // avoid a leaky abstraction, but that makes removing the listener harder.
	        if (this.auth_) {
	            this.auth_.addAuthTokenListener(listener);
	        }
	        else {
	            setTimeout(function () { return listener(null); }, 0);
	            this.authProvider_
	                .get()
	                .then(function (auth) { return auth.addAuthTokenListener(listener); });
	        }
	    };
	    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
	        this.authProvider_
	            .get()
	            .then(function (auth) { return auth.removeAuthTokenListener(listener); });
	    };
	    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
	        var errorMessage = 'Provided authentication credentials for the app named "' +
	            this.app_.name +
	            '" are invalid. This usually indicates your app was not ' +
	            'initialized correctly. ';
	        if ('credential' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "credential" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else if ('serviceAccount' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "serviceAccount" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else {
	            errorMessage +=
	                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
	                    'initializeApp() match the values provided for your app at ' +
	                    'https://console.firebase.google.com/.';
	        }
	        warn(errorMessage);
	    };
	    return AuthTokenProvider;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Tracks a collection of stats.
	 *
	 * @constructor
	 */
	var StatsCollection = /** @class */ (function () {
	    function StatsCollection() {
	        this.counters_ = {};
	    }
	    StatsCollection.prototype.incrementCounter = function (name, amount) {
	        if (amount === void 0) { amount = 1; }
	        if (!util.contains(this.counters_, name)) {
	            this.counters_[name] = 0;
	        }
	        this.counters_[name] += amount;
	    };
	    StatsCollection.prototype.get = function () {
	        return util.deepCopy(this.counters_);
	    };
	    return StatsCollection;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var StatsManager = /** @class */ (function () {
	    function StatsManager() {
	    }
	    StatsManager.getCollection = function (repoInfo) {
	        var hashString = repoInfo.toString();
	        if (!this.collections_[hashString]) {
	            this.collections_[hashString] = new StatsCollection();
	        }
	        return this.collections_[hashString];
	    };
	    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
	        var hashString = repoInfo.toString();
	        if (!this.reporters_[hashString]) {
	            this.reporters_[hashString] = creatorFunction();
	        }
	        return this.reporters_[hashString];
	    };
	    StatsManager.collections_ = {};
	    StatsManager.reporters_ = {};
	    return StatsManager;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns the delta from the previous call to get stats.
	 *
	 * @param collection_ The collection to "listen" to.
	 * @constructor
	 */
	var StatsListener = /** @class */ (function () {
	    function StatsListener(collection_) {
	        this.collection_ = collection_;
	        this.last_ = null;
	    }
	    StatsListener.prototype.get = function () {
	        var newStats = this.collection_.get();
	        var delta = tslib.__assign({}, newStats);
	        if (this.last_) {
	            each(this.last_, function (stat, value) {
	                delta[stat] = delta[stat] - value;
	            });
	        }
	        this.last_ = newStats;
	        return delta;
	    };
	    return StatsListener;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
	// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
	// seconds to try to ensure the Firebase connection is established / settled.
	var FIRST_STATS_MIN_TIME = 10 * 1000;
	var FIRST_STATS_MAX_TIME = 30 * 1000;
	// We'll continue to report stats on average every 5 minutes.
	var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
	/**
	 * @constructor
	 */
	var StatsReporter = /** @class */ (function () {
	    /**
	     * @param collection
	     * @param server_
	     */
	    function StatsReporter(collection, server_) {
	        this.server_ = server_;
	        this.statsToReport_ = {};
	        this.statsListener_ = new StatsListener(collection);
	        var timeout = FIRST_STATS_MIN_TIME +
	            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
	        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
	    }
	    StatsReporter.prototype.includeStat = function (stat) {
	        this.statsToReport_[stat] = true;
	    };
	    StatsReporter.prototype.reportStats_ = function () {
	        var _this = this;
	        var stats = this.statsListener_.get();
	        var reportedStats = {};
	        var haveStatsToReport = false;
	        each(stats, function (stat, value) {
	            if (value > 0 && util.contains(_this.statsToReport_, stat)) {
	                reportedStats[stat] = value;
	                haveStatsToReport = true;
	            }
	        });
	        if (haveStatsToReport) {
	            this.server_.reportStats(reportedStats);
	        }
	        // queue our next run.
	        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
	    };
	    return StatsReporter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * The event queue serves a few purposes:
	 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
	 *    events being queued.
	 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
	 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
	 *    left off, ensuring that the events are still raised synchronously and in order.
	 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
	 *    events are raised synchronously.
	 *
	 * NOTE: This can all go away if/when we move to async events.
	 *
	 * @constructor
	 */
	var EventQueue = /** @class */ (function () {
	    function EventQueue() {
	        /**
	         * @private
	         * @type {!Array.<EventList>}
	         */
	        this.eventLists_ = [];
	        /**
	         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
	         * @private
	         * @type {!number}
	         */
	        this.recursionDepth_ = 0;
	    }
	    /**
	     * @param {!Array.<Event>} eventDataList The new events to queue.
	     */
	    EventQueue.prototype.queueEvents = function (eventDataList) {
	        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
	        var currList = null;
	        for (var i = 0; i < eventDataList.length; i++) {
	            var eventData = eventDataList[i];
	            var eventPath = eventData.getPath();
	            if (currList !== null && !eventPath.equals(currList.getPath())) {
	                this.eventLists_.push(currList);
	                currList = null;
	            }
	            if (currList === null) {
	                currList = new EventList(eventPath);
	            }
	            currList.add(eventData);
	        }
	        if (currList) {
	            this.eventLists_.push(currList);
	        }
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones)
	     * for the specified path.
	     *
	     * It is assumed that the new events are all for the specified path.
	     *
	     * @param {!Path} path The path to raise events for.
	     * @param {!Array.<Event>} eventDataList The new events to raise.
	     */
	    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.equals(path);
	        });
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones) for
	     * locations related to the specified change path (i.e. all ancestors and descendants).
	     *
	     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
	     *
	     * @param {!Path} changedPath The path to raise events for.
	     * @param {!Array.<!Event>} eventDataList The events to raise
	     */
	    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
	        });
	    };
	    /**
	     * @param {!function(!Path):boolean} predicate
	     * @private
	     */
	    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
	        this.recursionDepth_++;
	        var sentAll = true;
	        for (var i = 0; i < this.eventLists_.length; i++) {
	            var eventList = this.eventLists_[i];
	            if (eventList) {
	                var eventPath = eventList.getPath();
	                if (predicate(eventPath)) {
	                    this.eventLists_[i].raise();
	                    this.eventLists_[i] = null;
	                }
	                else {
	                    sentAll = false;
	                }
	            }
	        }
	        if (sentAll) {
	            this.eventLists_ = [];
	        }
	        this.recursionDepth_--;
	    };
	    return EventQueue;
	}());
	/**
	 * @param {!Path} path
	 * @constructor
	 */
	var EventList = /** @class */ (function () {
	    function EventList(path_) {
	        this.path_ = path_;
	        /**
	         * @type {!Array.<Event>}
	         * @private
	         */
	        this.events_ = [];
	    }
	    /**
	     * @param {!Event} eventData
	     */
	    EventList.prototype.add = function (eventData) {
	        this.events_.push(eventData);
	    };
	    /**
	     * Iterates through the list and raises each event
	     */
	    EventList.prototype.raise = function () {
	        for (var i = 0; i < this.events_.length; i++) {
	            var eventData = this.events_[i];
	            if (eventData !== null) {
	                this.events_[i] = null;
	                var eventFn = eventData.getEventRunner();
	                if (logger) {
	                    log('event: ' + eventData.toString());
	                }
	                exceptionGuard(eventFn);
	            }
	        }
	    };
	    /**
	     * @return {!Path}
	     */
	    EventList.prototype.getPath = function () {
	        return this.path_;
	    };
	    return EventList;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Base class to be used if you want to emit events. Call the constructor with
	 * the set of allowed event names.
	 */
	var EventEmitter = /** @class */ (function () {
	    /**
	     * @param {!Array.<string>} allowedEvents_
	     */
	    function EventEmitter(allowedEvents_) {
	        this.allowedEvents_ = allowedEvents_;
	        this.listeners_ = {};
	        util.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
	    }
	    /**
	     * To be called by derived classes to trigger events.
	     * @param {!string} eventType
	     * @param {...*} varArgs
	     */
	    EventEmitter.prototype.trigger = function (eventType) {
	        var varArgs = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            varArgs[_i - 1] = arguments[_i];
	        }
	        if (Array.isArray(this.listeners_[eventType])) {
	            // Clone the list, since callbacks could add/remove listeners.
	            var listeners = tslib.__spread(this.listeners_[eventType]);
	            for (var i = 0; i < listeners.length; i++) {
	                listeners[i].callback.apply(listeners[i].context, varArgs);
	            }
	        }
	    };
	    EventEmitter.prototype.on = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        this.listeners_[eventType] = this.listeners_[eventType] || [];
	        this.listeners_[eventType].push({ callback: callback, context: context });
	        var eventData = this.getInitialEvent(eventType);
	        if (eventData) {
	            callback.apply(context, eventData);
	        }
	    };
	    EventEmitter.prototype.off = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        var listeners = this.listeners_[eventType] || [];
	        for (var i = 0; i < listeners.length; i++) {
	            if (listeners[i].callback === callback &&
	                (!context || context === listeners[i].context)) {
	                listeners.splice(i, 1);
	                return;
	            }
	        }
	    };
	    EventEmitter.prototype.validateEventType_ = function (eventType) {
	        util.assert(this.allowedEvents_.find(function (et) {
	            return et === eventType;
	        }), 'Unknown event: ' + eventType);
	    };
	    return EventEmitter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @extends {EventEmitter}
	 */
	var VisibilityMonitor = /** @class */ (function (_super) {
	    tslib.__extends(VisibilityMonitor, _super);
	    function VisibilityMonitor() {
	        var _this = _super.call(this, ['visible']) || this;
	        var hidden;
	        var visibilityChange;
	        if (typeof document !== 'undefined' &&
	            typeof document.addEventListener !== 'undefined') {
	            if (typeof document['hidden'] !== 'undefined') {
	                // Opera 12.10 and Firefox 18 and later support
	                visibilityChange = 'visibilitychange';
	                hidden = 'hidden';
	            }
	            else if (typeof document['mozHidden'] !== 'undefined') {
	                visibilityChange = 'mozvisibilitychange';
	                hidden = 'mozHidden';
	            }
	            else if (typeof document['msHidden'] !== 'undefined') {
	                visibilityChange = 'msvisibilitychange';
	                hidden = 'msHidden';
	            }
	            else if (typeof document['webkitHidden'] !== 'undefined') {
	                visibilityChange = 'webkitvisibilitychange';
	                hidden = 'webkitHidden';
	            }
	        }
	        // Initially, we always assume we are visible. This ensures that in browsers
	        // without page visibility support or in cases where we are never visible
	        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
	        // reconnects
	        _this.visible_ = true;
	        if (visibilityChange) {
	            document.addEventListener(visibilityChange, function () {
	                var visible = !document[hidden];
	                if (visible !== _this.visible_) {
	                    _this.visible_ = visible;
	                    _this.trigger('visible', visible);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    VisibilityMonitor.getInstance = function () {
	        return new VisibilityMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
	        util.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
	        return [this.visible_];
	    };
	    return VisibilityMonitor;
	}(EventEmitter));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Monitors online state (as reported by window.online/offline events).
	 *
	 * The expectation is that this could have many false positives (thinks we are online
	 * when we're not), but no false negatives.  So we can safely use it to determine when
	 * we definitely cannot reach the internet.
	 *
	 * @extends {EventEmitter}
	 */
	var OnlineMonitor = /** @class */ (function (_super) {
	    tslib.__extends(OnlineMonitor, _super);
	    function OnlineMonitor() {
	        var _this = _super.call(this, ['online']) || this;
	        _this.online_ = true;
	        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
	        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
	        // It would seem that the 'online' event does not always fire consistently. So we disable it
	        // for Cordova.
	        if (typeof window !== 'undefined' &&
	            typeof window.addEventListener !== 'undefined' &&
	            !util.isMobileCordova()) {
	            window.addEventListener('online', function () {
	                if (!_this.online_) {
	                    _this.online_ = true;
	                    _this.trigger('online', true);
	                }
	            }, false);
	            window.addEventListener('offline', function () {
	                if (_this.online_) {
	                    _this.online_ = false;
	                    _this.trigger('online', false);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    OnlineMonitor.getInstance = function () {
	        return new OnlineMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
	        util.assert(eventType === 'online', 'Unknown event type: ' + eventType);
	        return [this.online_];
	    };
	    /**
	     * @return {boolean}
	     */
	    OnlineMonitor.prototype.currentlyOnline = function () {
	        return this.online_;
	    };
	    return OnlineMonitor;
	}(EventEmitter));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class ensures the packets from the server arrive in order
	 * This class takes data from the server and ensures it gets passed into the callbacks in order.
	 * @constructor
	 */
	var PacketReceiver = /** @class */ (function () {
	    /**
	     * @param onMessage_
	     */
	    function PacketReceiver(onMessage_) {
	        this.onMessage_ = onMessage_;
	        this.pendingResponses = [];
	        this.currentResponseNum = 0;
	        this.closeAfterResponse = -1;
	        this.onClose = null;
	    }
	    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
	        this.closeAfterResponse = responseNum;
	        this.onClose = callback;
	        if (this.closeAfterResponse < this.currentResponseNum) {
	            this.onClose();
	            this.onClose = null;
	        }
	    };
	    /**
	     * Each message from the server comes with a response number, and an array of data. The responseNumber
	     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
	     * browsers will respond in the same order as the requests we sent
	     * @param {number} requestNum
	     * @param {Array} data
	     */
	    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
	        var _this = this;
	        this.pendingResponses[requestNum] = data;
	        var _loop_1 = function () {
	            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
	            delete this_1.pendingResponses[this_1.currentResponseNum];
	            var _loop_2 = function (i) {
	                if (toProcess[i]) {
	                    exceptionGuard(function () {
	                        _this.onMessage_(toProcess[i]);
	                    });
	                }
	            };
	            for (var i = 0; i < toProcess.length; ++i) {
	                _loop_2(i);
	            }
	            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
	                if (this_1.onClose) {
	                    this_1.onClose();
	                    this_1.onClose = null;
	                }
	                return "break";
	            }
	            this_1.currentResponseNum++;
	        };
	        var this_1 = this;
	        while (this.pendingResponses[this.currentResponseNum]) {
	            var state_1 = _loop_1();
	            if (state_1 === "break")
	                break;
	        }
	    };
	    return PacketReceiver;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// URL query parameters associated with longpolling
	var FIREBASE_LONGPOLL_START_PARAM = 'start';
	var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
	var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
	var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
	var FIREBASE_LONGPOLL_ID_PARAM = 'id';
	var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
	var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
	var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
	var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
	var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
	var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
	var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
	//Data size constants.
	//TODO: Perf: the maximum length actually differs from browser to browser.
	// We should check what browser we're on and set accordingly.
	var MAX_URL_DATA_SIZE = 1870;
	var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
	var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
	/**
	 * Keepalive period
	 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
	 * length of 30 seconds that we can't exceed.
	 * @const
	 * @type {number}
	 */
	var KEEPALIVE_REQUEST_INTERVAL = 25000;
	/**
	 * How long to wait before aborting a long-polling connection attempt.
	 * @const
	 * @type {number}
	 */
	var LP_CONNECT_TIMEOUT = 30000;
	/**
	 * This class manages a single long-polling connection.
	 *
	 * @constructor
	 * @implements {Transport}
	 */
	var BrowserPollConnection = /** @class */ (function () {
	    /**
	     * @param {string} connId An identifier for this connection, used for logging
	     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
	     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
	     *                                         transport session
	     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
	     *                                     connection previously
	     */
	    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.repoInfo = repoInfo;
	        this.transportSessionId = transportSessionId;
	        this.lastSessionId = lastSessionId;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.everConnected_ = false;
	        this.log_ = logWrapper(connId);
	        this.stats_ = StatsManager.getCollection(repoInfo);
	        this.urlFn = function (params) {
	            return repoInfo.connectionURL(LONG_POLLING, params);
	        };
	    }
	    /**
	     *
	     * @param {function(Object)} onMessage Callback when messages arrive
	     * @param {function()} onDisconnect Callback with connection lost.
	     */
	    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.curSegmentNum = 0;
	        this.onDisconnect_ = onDisconnect;
	        this.myPacketOrderer = new PacketReceiver(onMessage);
	        this.isClosed_ = false;
	        this.connectTimeoutTimer_ = setTimeout(function () {
	            _this.log_('Timed out trying to connect.');
	            // Make sure we clear the host cache
	            _this.onClosed_();
	            _this.connectTimeoutTimer_ = null;
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }, Math.floor(LP_CONNECT_TIMEOUT));
	        // Ensure we delay the creation of the iframe until the DOM is loaded.
	        executeWhenDOMReady(function () {
	            if (_this.isClosed_) {
	                return;
	            }
	            //Set up a callback that gets triggered once a connection is set up.
	            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a = tslib.__read(args, 5), command = _a[0], arg1 = _a[1], arg2 = _a[2], arg3 = _a[3], arg4 = _a[4];
	                _this.incrementIncomingBytes_(args);
	                if (!_this.scriptTagHolder) {
	                    return; // we closed the connection.
	                }
	                if (_this.connectTimeoutTimer_) {
	                    clearTimeout(_this.connectTimeoutTimer_);
	                    _this.connectTimeoutTimer_ = null;
	                }
	                _this.everConnected_ = true;
	                if (command === FIREBASE_LONGPOLL_START_PARAM) {
	                    _this.id = arg1;
	                    _this.password = arg2;
	                }
	                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
	                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
	                    if (arg1) {
	                        // We aren't expecting any more data (other than what the server's already in the process of sending us
	                        // through our already open polls), so don't send any more.
	                        _this.scriptTagHolder.sendNewPolls = false;
	                        // arg1 in this case is the last response number sent by the server. We should try to receive
	                        // all of the responses up to this one before closing
	                        _this.myPacketOrderer.closeAfter(arg1, function () {
	                            _this.onClosed_();
	                        });
	                    }
	                    else {
	                        _this.onClosed_();
	                    }
	                }
	                else {
	                    throw new Error('Unrecognized command received: ' + command);
	                }
	            }, function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a = tslib.__read(args, 2), pN = _a[0], data = _a[1];
	                _this.incrementIncomingBytes_(args);
	                _this.myPacketOrderer.handleResponse(pN, data);
	            }, function () {
	                _this.onClosed_();
	            }, _this.urlFn);
	            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
	            //from cache.
	            var urlParams = {};
	            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
	            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
	            if (_this.scriptTagHolder.uniqueCallbackIdentifier) {
	                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
	            }
	            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
	            if (_this.transportSessionId) {
	                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
	            }
	            if (_this.lastSessionId) {
	                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
	            }
	            if (typeof location !== 'undefined' &&
	                location.href &&
	                location.href.indexOf(FORGE_DOMAIN) !== -1) {
	                urlParams[REFERER_PARAM] = FORGE_REF;
	            }
	            var connectURL = _this.urlFn(urlParams);
	            _this.log_('Connecting via long-poll to ' + connectURL);
	            _this.scriptTagHolder.addTag(connectURL, function () {
	                /* do nothing */
	            });
	        });
	    };
	    /**
	     * Call this when a handshake has completed successfully and we want to consider the connection established
	     */
	    BrowserPollConnection.prototype.start = function () {
	        this.scriptTagHolder.startLongPoll(this.id, this.password);
	        this.addDisconnectPingFrame(this.id, this.password);
	    };
	    /**
	     * Forces long polling to be considered as a potential transport
	     */
	    BrowserPollConnection.forceAllow = function () {
	        BrowserPollConnection.forceAllow_ = true;
	    };
	    /**
	     * Forces longpolling to not be considered as a potential transport
	     */
	    BrowserPollConnection.forceDisallow = function () {
	        BrowserPollConnection.forceDisallow_ = true;
	    };
	    // Static method, use string literal so it can be accessed in a generic way
	    BrowserPollConnection.isAvailable = function () {
	        if (util.isNodeSdk()) {
	            return false;
	        }
	        else if (BrowserPollConnection.forceAllow_) {
	            return true;
	        }
	        else {
	            // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
	            // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
	            return (!BrowserPollConnection.forceDisallow_ &&
	                typeof document !== 'undefined' &&
	                document.createElement != null &&
	                !isChromeExtensionContentScript() &&
	                !isWindowsStoreApp());
	        }
	    };
	    /**
	     * No-op for polling
	     */
	    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
	    /**
	     * Stops polling and cleans up the iframe
	     * @private
	     */
	    BrowserPollConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.scriptTagHolder) {
	            this.scriptTagHolder.close();
	            this.scriptTagHolder = null;
	        }
	        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
	        if (this.myDisconnFrame) {
	            document.body.removeChild(this.myDisconnFrame);
	            this.myDisconnFrame = null;
	        }
	        if (this.connectTimeoutTimer_) {
	            clearTimeout(this.connectTimeoutTimer_);
	            this.connectTimeoutTimer_ = null;
	        }
	    };
	    /**
	     * Triggered when this transport is closed
	     * @private
	     */
	    BrowserPollConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is closing itself');
	            this.shutdown_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_(this.everConnected_);
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
	     * that we've left.
	     */
	    BrowserPollConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is being closed.');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
	     * broken into chunks (since URLs have a small maximum length).
	     * @param {!Object} data The JSON data to transmit.
	     */
	    BrowserPollConnection.prototype.send = function (data) {
	        var dataStr = util.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //first, lets get the base64-encoded data
	        var base64data = util.base64Encode(dataStr);
	        //We can only fit a certain amount in each URL, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
	        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
	        //of segments so that we can reassemble the packet on the server.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
	            this.curSegmentNum++;
	        }
	    };
	    /**
	     * This is how we notify the server that we're leaving.
	     * We aren't able to send requests with DHTML on a window close event, but we can
	     * trigger XHR requests in some browsers (everything but Opera basically).
	     * @param {!string} id
	     * @param {!string} pw
	     */
	    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
	        if (util.isNodeSdk()) {
	            return;
	        }
	        this.myDisconnFrame = document.createElement('iframe');
	        var urlParams = {};
	        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
	        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
	        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
	        this.myDisconnFrame.src = this.urlFn(urlParams);
	        this.myDisconnFrame.style.display = 'none';
	        document.body.appendChild(this.myDisconnFrame);
	    };
	    /**
	     * Used to track the bytes received by this client
	     * @param {*} args
	     * @private
	     */
	    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
	        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
	        var bytesReceived = util.stringify(args).length;
	        this.bytesReceived += bytesReceived;
	        this.stats_.incrementCounter('bytes_received', bytesReceived);
	    };
	    return BrowserPollConnection;
	}());
	/*********************************************************************************************
	 * A wrapper around an iframe that is used as a long-polling script holder.
	 * @constructor
	 *********************************************************************************************/
	var FirebaseIFrameScriptHolder = /** @class */ (function () {
	    /**
	     * @param commandCB - The callback to be called when control commands are recevied from the server.
	     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
	     * @param onDisconnect - The callback to be triggered when this tag holder is closed
	     * @param urlFn - A function that provides the URL of the endpoint to send data to.
	     */
	    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
	        this.onDisconnect = onDisconnect;
	        this.urlFn = urlFn;
	        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
	        //problems in some browsers.
	        this.outstandingRequests = new Set();
	        //A queue of the pending segments waiting for transmission to the server.
	        this.pendingSegs = [];
	        //A serial number. We use this for two things:
	        // 1) A way to ensure the browser doesn't cache responses to polls
	        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
	        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
	        //    JSONP code in the order it was added to the iframe.
	        this.currentSerial = Math.floor(Math.random() * 100000000);
	        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
	        // incoming data from the server that we're waiting for).
	        this.sendNewPolls = true;
	        if (!util.isNodeSdk()) {
	            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
	            //iframes where we put the long-polling script tags. We have two callbacks:
	            //   1) Command Callback - Triggered for control issues, like starting a connection.
	            //   2) Message Callback - Triggered when new data arrives.
	            this.uniqueCallbackIdentifier = LUIDGenerator();
	            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
	            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
	            //Create an iframe for us to add script tags to.
	            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
	            // Set the iframe's contents.
	            var script = '';
	            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
	            // for ie9, but ie8 needs to do it again in the document itself.
	            if (this.myIFrame.src &&
	                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
	                var currentDomain = document.domain;
	                script = '<script>document.domain="' + currentDomain + '";</script>';
	            }
	            var iframeContents = '<html><body>' + script + '</body></html>';
	            try {
	                this.myIFrame.doc.open();
	                this.myIFrame.doc.write(iframeContents);
	                this.myIFrame.doc.close();
	            }
	            catch (e) {
	                log('frame writing exception');
	                if (e.stack) {
	                    log(e.stack);
	                }
	                log(e);
	            }
	        }
	        else {
	            this.commandCB = commandCB;
	            this.onMessageCB = onMessageCB;
	        }
	    }
	    /**
	     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
	     * actually use.
	     * @private
	     * @return {Element}
	     */
	    FirebaseIFrameScriptHolder.createIFrame_ = function () {
	        var iframe = document.createElement('iframe');
	        iframe.style.display = 'none';
	        // This is necessary in order to initialize the document inside the iframe
	        if (document.body) {
	            document.body.appendChild(iframe);
	            try {
	                // If document.domain has been modified in IE, this will throw an error, and we need to set the
	                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
	                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
	                var a = iframe.contentWindow.document;
	                if (!a) {
	                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
	                    log('No IE domain setting required');
	                }
	            }
	            catch (e) {
	                var domain = document.domain;
	                iframe.src =
	                    "javascript:void((function(){document.open();document.domain='" +
	                        domain +
	                        "';document.close();})())";
	            }
	        }
	        else {
	            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
	            // never gets hit.
	            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
	        }
	        // Get the document of the iframe in a browser-specific way.
	        if (iframe.contentDocument) {
	            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
	        }
	        else if (iframe.contentWindow) {
	            iframe.doc = iframe.contentWindow.document; // Internet Explorer
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }
	        else if (iframe.document) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            iframe.doc = iframe.document; //others?
	        }
	        return iframe;
	    };
	    /**
	     * Cancel all outstanding queries and remove the frame.
	     */
	    FirebaseIFrameScriptHolder.prototype.close = function () {
	        var _this = this;
	        //Mark this iframe as dead, so no new requests are sent.
	        this.alive = false;
	        if (this.myIFrame) {
	            //We have to actually remove all of the html inside this iframe before removing it from the
	            //window, or IE will continue loading and executing the script tags we've already added, which
	            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
	            this.myIFrame.doc.body.innerHTML = '';
	            setTimeout(function () {
	                if (_this.myIFrame !== null) {
	                    document.body.removeChild(_this.myIFrame);
	                    _this.myIFrame = null;
	                }
	            }, Math.floor(0));
	        }
	        // Protect from being called recursively.
	        var onDisconnect = this.onDisconnect;
	        if (onDisconnect) {
	            this.onDisconnect = null;
	            onDisconnect();
	        }
	    };
	    /**
	     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
	     * @param {!string} id - The ID of this connection
	     * @param {!string} pw - The password for this connection
	     */
	    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
	        this.myID = id;
	        this.myPW = pw;
	        this.alive = true;
	        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
	        while (this.newRequest_()) { }
	    };
	    /**
	     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
	     * too many outstanding requests and we are still alive.
	     *
	     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
	     * needed.
	     */
	    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
	        // We keep one outstanding request open all the time to receive data, but if we need to send data
	        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
	        // close the old request.
	        if (this.alive &&
	            this.sendNewPolls &&
	            this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
	            //construct our url
	            this.currentSerial++;
	            var urlParams = {};
	            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
	            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
	            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
	            var theURL = this.urlFn(urlParams);
	            //Now add as much data as we can.
	            var curDataString = '';
	            var i = 0;
	            while (this.pendingSegs.length > 0) {
	                //first, lets see if the next segment will fit.
	                var nextSeg = this.pendingSegs[0];
	                if (nextSeg.d.length +
	                    SEG_HEADER_SIZE +
	                    curDataString.length <=
	                    MAX_URL_DATA_SIZE) {
	                    //great, the segment will fit. Lets append it.
	                    var theSeg = this.pendingSegs.shift();
	                    curDataString =
	                        curDataString +
	                            '&' +
	                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
	                            i +
	                            '=' +
	                            theSeg.seg +
	                            '&' +
	                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
	                            i +
	                            '=' +
	                            theSeg.ts +
	                            '&' +
	                            FIREBASE_LONGPOLL_DATA_PARAM +
	                            i +
	                            '=' +
	                            theSeg.d;
	                    i++;
	                }
	                else {
	                    break;
	                }
	            }
	            theURL = theURL + curDataString;
	            this.addLongPollTag_(theURL, this.currentSerial);
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * Queue a packet for transmission to the server.
	     * @param segnum - A sequential id for this packet segment used for reassembly
	     * @param totalsegs - The total number of segments in this packet
	     * @param data - The data for this segment.
	     */
	    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
	        //add this to the queue of segments to send.
	        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
	        //send the data immediately if there isn't already data being transmitted, unless
	        //startLongPoll hasn't been called yet.
	        if (this.alive) {
	            this.newRequest_();
	        }
	    };
	    /**
	     * Add a script tag for a regular long-poll request.
	     * @param {!string} url - The URL of the script tag.
	     * @param {!number} serial - The serial number of the request.
	     * @private
	     */
	    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
	        var _this = this;
	        //remember that we sent this request.
	        this.outstandingRequests.add(serial);
	        var doNewRequest = function () {
	            _this.outstandingRequests.delete(serial);
	            _this.newRequest_();
	        };
	        // If this request doesn't return on its own accord (by the server sending us some data), we'll
	        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
	        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
	        var readyStateCB = function () {
	            // Request completed.  Cancel the keepalive.
	            clearTimeout(keepaliveTimeout);
	            // Trigger a new request so we can continue receiving data.
	            doNewRequest();
	        };
	        this.addTag(url, readyStateCB);
	    };
	    /**
	     * Add an arbitrary script tag to the iframe.
	     * @param {!string} url - The URL for the script tag source.
	     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
	     */
	    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
	        var _this = this;
	        if (util.isNodeSdk()) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            this.doNodeLongPoll(url, loadCB);
	        }
	        else {
	            setTimeout(function () {
	                try {
	                    // if we're already closed, don't add this poll
	                    if (!_this.sendNewPolls) {
	                        return;
	                    }
	                    var newScript_1 = _this.myIFrame.doc.createElement('script');
	                    newScript_1.type = 'text/javascript';
	                    newScript_1.async = true;
	                    newScript_1.src = url;
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    newScript_1.onload = newScript_1.onreadystatechange = function () {
	                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                        var rstate = newScript_1.readyState;
	                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
	                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                            newScript_1.onload = newScript_1.onreadystatechange = null;
	                            if (newScript_1.parentNode) {
	                                newScript_1.parentNode.removeChild(newScript_1);
	                            }
	                            loadCB();
	                        }
	                    };
	                    newScript_1.onerror = function () {
	                        log('Long-poll script failed to load: ' + url);
	                        _this.sendNewPolls = false;
	                        _this.close();
	                    };
	                    _this.myIFrame.doc.body.appendChild(newScript_1);
	                }
	                catch (e) {
	                    // TODO: we should make this error visible somehow
	                }
	            }, Math.floor(1));
	        }
	    };
	    return FirebaseIFrameScriptHolder;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** The semver (www.semver.org) version of the SDK. */
	var SDK_VERSION = '';
	// SDK_VERSION should be set before any database instance is created
	function setSDKVersion(version) {
	    SDK_VERSION = version;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var WEBSOCKET_MAX_FRAME_SIZE = 16384;
	var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
	var WebSocketImpl = null;
	if (typeof MozWebSocket !== 'undefined') {
	    WebSocketImpl = MozWebSocket;
	}
	else if (typeof WebSocket !== 'undefined') {
	    WebSocketImpl = WebSocket;
	}
	/**
	 * Create a new websocket connection with the given callbacks.
	 * @constructor
	 * @implements {Transport}
	 */
	var WebSocketConnection = /** @class */ (function () {
	    /**
	     * @param {string} connId identifier for this transport
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     */
	    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.keepaliveTimer = null;
	        this.frames = null;
	        this.totalFrames = 0;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.log_ = logWrapper(this.connId);
	        this.stats_ = StatsManager.getCollection(repoInfo);
	        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
	    }
	    /**
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     * @return {string} connection url
	     * @private
	     */
	    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
	        var urlParams = {};
	        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
	        if (!util.isNodeSdk() &&
	            typeof location !== 'undefined' &&
	            location.href &&
	            location.href.indexOf(FORGE_DOMAIN) !== -1) {
	            urlParams[REFERER_PARAM] = FORGE_REF;
	        }
	        if (transportSessionId) {
	            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
	        }
	        if (lastSessionId) {
	            urlParams[LAST_SESSION_PARAM] = lastSessionId;
	        }
	        return repoInfo.connectionURL(WEBSOCKET, urlParams);
	    };
	    /**
	     *
	     * @param onMessage Callback when messages arrive
	     * @param onDisconnect Callback with connection lost.
	     */
	    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.onDisconnect = onDisconnect;
	        this.onMessage = onMessage;
	        this.log_('Websocket connecting to ' + this.connURL);
	        this.everConnected_ = false;
	        // Assume failure until proven otherwise.
	        PersistentStorage.set('previous_websocket_failure', true);
	        try {
	            if (util.isNodeSdk()) {
	                var device = util.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
	                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
	                var options = {
	                    headers: {
	                        'User-Agent': "Firebase/" + PROTOCOL_VERSION + "/" + SDK_VERSION + "/" + process.platform + "/" + device
	                    }
	                };
	                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
	                var env = process['env'];
	                var proxy = this.connURL.indexOf('wss://') === 0
	                    ? env['HTTPS_PROXY'] || env['https_proxy']
	                    : env['HTTP_PROXY'] || env['http_proxy'];
	                if (proxy) {
	                    options['proxy'] = { origin: proxy };
	                }
	                this.mySock = new WebSocketImpl(this.connURL, [], options);
	            }
	            else {
	                this.mySock = new WebSocketImpl(this.connURL);
	            }
	        }
	        catch (e) {
	            this.log_('Error instantiating WebSocket.');
	            var error = e.message || e.data;
	            if (error) {
	                this.log_(error);
	            }
	            this.onClosed_();
	            return;
	        }
	        this.mySock.onopen = function () {
	            _this.log_('Websocket connected.');
	            _this.everConnected_ = true;
	        };
	        this.mySock.onclose = function () {
	            _this.log_('Websocket connection was disconnected.');
	            _this.mySock = null;
	            _this.onClosed_();
	        };
	        this.mySock.onmessage = function (m) {
	            _this.handleIncomingFrame(m);
	        };
	        this.mySock.onerror = function (e) {
	            _this.log_('WebSocket error.  Closing connection.');
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var error = e.message || e.data;
	            if (error) {
	                _this.log_(error);
	            }
	            _this.onClosed_();
	        };
	    };
	    /**
	     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
	     */
	    WebSocketConnection.prototype.start = function () { };
	    WebSocketConnection.forceDisallow = function () {
	        WebSocketConnection.forceDisallow_ = true;
	    };
	    WebSocketConnection.isAvailable = function () {
	        var isOldAndroid = false;
	        if (typeof navigator !== 'undefined' && navigator.userAgent) {
	            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
	            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
	            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
	                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
	                    isOldAndroid = true;
	                }
	            }
	        }
	        return (!isOldAndroid &&
	            WebSocketImpl !== null &&
	            !WebSocketConnection.forceDisallow_);
	    };
	    /**
	     * Returns true if we previously failed to connect with this transport.
	     * @return {boolean}
	     */
	    WebSocketConnection.previouslyFailed = function () {
	        // If our persistent storage is actually only in-memory storage,
	        // we default to assuming that it previously failed to be safe.
	        return (PersistentStorage.isInMemoryStorage ||
	            PersistentStorage.get('previous_websocket_failure') === true);
	    };
	    WebSocketConnection.prototype.markConnectionHealthy = function () {
	        PersistentStorage.remove('previous_websocket_failure');
	    };
	    WebSocketConnection.prototype.appendFrame_ = function (data) {
	        this.frames.push(data);
	        if (this.frames.length === this.totalFrames) {
	            var fullMess = this.frames.join('');
	            this.frames = null;
	            var jsonMess = util.jsonEval(fullMess);
	            //handle the message
	            this.onMessage(jsonMess);
	        }
	    };
	    /**
	     * @param {number} frameCount The number of frames we are expecting from the server
	     * @private
	     */
	    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
	        this.totalFrames = frameCount;
	        this.frames = [];
	    };
	    /**
	     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
	     * @param {!String} data
	     * @return {?String} Any remaining data to be process, or null if there is none
	     * @private
	     */
	    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
	        util.assert(this.frames === null, 'We already have a frame buffer');
	        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
	        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
	        if (data.length <= 6) {
	            var frameCount = Number(data);
	            if (!isNaN(frameCount)) {
	                this.handleNewFrameCount_(frameCount);
	                return null;
	            }
	        }
	        this.handleNewFrameCount_(1);
	        return data;
	    };
	    /**
	     * Process a websocket frame that has arrived from the server.
	     * @param mess The frame data
	     */
	    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
	        if (this.mySock === null) {
	            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
	        }
	        var data = mess['data'];
	        this.bytesReceived += data.length;
	        this.stats_.incrementCounter('bytes_received', data.length);
	        this.resetKeepAlive();
	        if (this.frames !== null) {
	            // we're buffering
	            this.appendFrame_(data);
	        }
	        else {
	            // try to parse out a frame count, otherwise, assume 1 and process it
	            var remainingData = this.extractFrameCount_(data);
	            if (remainingData !== null) {
	                this.appendFrame_(remainingData);
	            }
	        }
	    };
	    /**
	     * Send a message to the server
	     * @param {Object} data The JSON object to transmit
	     */
	    WebSocketConnection.prototype.send = function (data) {
	        this.resetKeepAlive();
	        var dataStr = util.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //We can only fit a certain amount in each websocket frame, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
	        //Send the length header
	        if (dataSegs.length > 1) {
	            this.sendString_(String(dataSegs.length));
	        }
	        //Send the actual data in segments.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.sendString_(dataSegs[i]);
	        }
	    };
	    WebSocketConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.keepaliveTimer) {
	            clearInterval(this.keepaliveTimer);
	            this.keepaliveTimer = null;
	        }
	        if (this.mySock) {
	            this.mySock.close();
	            this.mySock = null;
	        }
	    };
	    WebSocketConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is closing itself');
	            this.shutdown_();
	            // since this is an internal close, trigger the close listener
	            if (this.onDisconnect) {
	                this.onDisconnect(this.everConnected_);
	                this.onDisconnect = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler.
	     * Close the websocket and kill the connection.
	     */
	    WebSocketConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is being closed');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
	     * the last activity.
	     */
	    WebSocketConnection.prototype.resetKeepAlive = function () {
	        var _this = this;
	        clearInterval(this.keepaliveTimer);
	        this.keepaliveTimer = setInterval(function () {
	            //If there has been no websocket activity for a while, send a no-op
	            if (_this.mySock) {
	                _this.sendString_('0');
	            }
	            _this.resetKeepAlive();
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
	    };
	    /**
	     * Send a string over the websocket.
	     *
	     * @param {string} str String to send.
	     * @private
	     */
	    WebSocketConnection.prototype.sendString_ = function (str) {
	        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
	        // calls for some unknown reason.  We treat these as an error and disconnect.
	        // See https://app.asana.com/0/58926111402292/68021340250410
	        try {
	            this.mySock.send(str);
	        }
	        catch (e) {
	            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
	            setTimeout(this.onClosed_.bind(this), 0);
	        }
	    };
	    /**
	     * Number of response before we consider the connection "healthy."
	     * @type {number}
	     */
	    WebSocketConnection.responsesRequiredToBeHealthy = 2;
	    /**
	     * Time to wait for the connection te become healthy before giving up.
	     * @type {number}
	     */
	    WebSocketConnection.healthyTimeout = 30000;
	    return WebSocketConnection;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
	 * lifecycle.
	 *
	 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
	 * they are available.
	 * @constructor
	 */
	var TransportManager = /** @class */ (function () {
	    /**
	     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
	     */
	    function TransportManager(repoInfo) {
	        this.initTransports_(repoInfo);
	    }
	    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
	        /**
	         * @const
	         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
	         */
	        get: function () {
	            return [BrowserPollConnection, WebSocketConnection];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {!RepoInfo} repoInfo
	     * @private
	     */
	    TransportManager.prototype.initTransports_ = function (repoInfo) {
	        var e_1, _a;
	        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
	        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
	        if (repoInfo.webSocketOnly) {
	            if (!isWebSocketsAvailable) {
	                warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
	            }
	            isSkipPollConnection = true;
	        }
	        if (isSkipPollConnection) {
	            this.transports_ = [WebSocketConnection];
	        }
	        else {
	            var transports = (this.transports_ = []);
	            try {
	                for (var _b = tslib.__values(TransportManager.ALL_TRANSPORTS), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var transport = _c.value;
	                    if (transport && transport['isAvailable']()) {
	                        transports.push(transport);
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	    };
	    /**
	     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
	     * initial transport to use
	     */
	    TransportManager.prototype.initialTransport = function () {
	        if (this.transports_.length > 0) {
	            return this.transports_[0];
	        }
	        else {
	            throw new Error('No transports available');
	        }
	    };
	    /**
	     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
	     * transport, or null
	     */
	    TransportManager.prototype.upgradeTransport = function () {
	        if (this.transports_.length > 1) {
	            return this.transports_[1];
	        }
	        else {
	            return null;
	        }
	    };
	    return TransportManager;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Abort upgrade attempt if it takes longer than 60s.
	var UPGRADE_TIMEOUT = 60000;
	// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
	// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
	var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
	// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
	// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
	// but we've sent/received enough bytes, we don't cancel the connection.
	var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
	var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
	var MESSAGE_TYPE = 't';
	var MESSAGE_DATA = 'd';
	var CONTROL_SHUTDOWN = 's';
	var CONTROL_RESET = 'r';
	var CONTROL_ERROR = 'e';
	var CONTROL_PONG = 'o';
	var SWITCH_ACK = 'a';
	var END_TRANSMISSION = 'n';
	var PING = 'p';
	var SERVER_HELLO = 'h';
	/**
	 * Creates a new real-time connection to the server using whichever method works
	 * best in the current browser.
	 *
	 * @constructor
	 */
	var Connection = /** @class */ (function () {
	    /**
	     * @param {!string} id - an id for this connection
	     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
	     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
	     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
	     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
	     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
	     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
	     */
	    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
	        this.id = id;
	        this.repoInfo_ = repoInfo_;
	        this.onMessage_ = onMessage_;
	        this.onReady_ = onReady_;
	        this.onDisconnect_ = onDisconnect_;
	        this.onKill_ = onKill_;
	        this.lastSessionId = lastSessionId;
	        this.connectionCount = 0;
	        this.pendingDataMessages = [];
	        this.state_ = 0 /* CONNECTING */;
	        this.log_ = logWrapper('c:' + this.id + ':');
	        this.transportManager_ = new TransportManager(repoInfo_);
	        this.log_('Connection created');
	        this.start_();
	    }
	    /**
	     * Starts a connection attempt
	     * @private
	     */
	    Connection.prototype.start_ = function () {
	        var _this = this;
	        var conn = this.transportManager_.initialTransport();
	        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessageReceived = this.connReceiver_(this.conn_);
	        var onConnectionLost = this.disconnReceiver_(this.conn_);
	        this.tx_ = this.conn_;
	        this.rx_ = this.conn_;
	        this.secondaryConn_ = null;
	        this.isHealthy_ = false;
	        /*
	         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
	         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
	         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
	         * still have the context of your originating frame.
	         */
	        setTimeout(function () {
	            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
	            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
	        }, Math.floor(0));
	        var healthyTimeoutMS = conn['healthyTimeout'] || 0;
	        if (healthyTimeoutMS > 0) {
	            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
	                _this.healthyTimeout_ = null;
	                if (!_this.isHealthy_) {
	                    if (_this.conn_ &&
	                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has received ' +
	                            _this.conn_.bytesReceived +
	                            ' bytes.  Marking connection healthy.');
	                        _this.isHealthy_ = true;
	                        _this.conn_.markConnectionHealthy();
	                    }
	                    else if (_this.conn_ &&
	                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has sent ' +
	                            _this.conn_.bytesSent +
	                            ' bytes.  Leaving connection alive.');
	                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
	                        // the server.
	                    }
	                    else {
	                        _this.log_('Closing unhealthy connection after timeout.');
	                        _this.close();
	                    }
	                }
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            }, Math.floor(healthyTimeoutMS));
	        }
	    };
	    /**
	     * @return {!string}
	     * @private
	     */
	    Connection.prototype.nextTransportId_ = function () {
	        return 'c:' + this.id + ':' + this.connectionCount++;
	    };
	    Connection.prototype.disconnReceiver_ = function (conn) {
	        var _this = this;
	        return function (everConnected) {
	            if (conn === _this.conn_) {
	                _this.onConnectionLost_(everConnected);
	            }
	            else if (conn === _this.secondaryConn_) {
	                _this.log_('Secondary connection lost.');
	                _this.onSecondaryConnectionLost_();
	            }
	            else {
	                _this.log_('closing an old connection');
	            }
	        };
	    };
	    Connection.prototype.connReceiver_ = function (conn) {
	        var _this = this;
	        return function (message) {
	            if (_this.state_ !== 2 /* DISCONNECTED */) {
	                if (conn === _this.rx_) {
	                    _this.onPrimaryMessageReceived_(message);
	                }
	                else if (conn === _this.secondaryConn_) {
	                    _this.onSecondaryMessageReceived_(message);
	                }
	                else {
	                    _this.log_('message on old connection');
	                }
	            }
	        };
	    };
	    /**
	     *
	     * @param {Object} dataMsg An arbitrary data message to be sent to the server
	     */
	    Connection.prototype.sendRequest = function (dataMsg) {
	        // wrap in a data message envelope and send it on
	        var msg = { t: 'd', d: dataMsg };
	        this.sendData_(msg);
	    };
	    Connection.prototype.tryCleanupConnection = function () {
	        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
	            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
	            this.conn_ = this.secondaryConn_;
	            this.secondaryConn_ = null;
	            // the server will shutdown the old connection
	        }
	    };
	    Connection.prototype.onSecondaryControl_ = function (controlData) {
	        if (MESSAGE_TYPE in controlData) {
	            var cmd = controlData[MESSAGE_TYPE];
	            if (cmd === SWITCH_ACK) {
	                this.upgradeIfSecondaryHealthy_();
	            }
	            else if (cmd === CONTROL_RESET) {
	                // Most likely the session wasn't valid. Abandon the switch attempt
	                this.log_('Got a reset on secondary, closing it');
	                this.secondaryConn_.close();
	                // If we were already using this connection for something, than we need to fully close
	                if (this.tx_ === this.secondaryConn_ ||
	                    this.rx_ === this.secondaryConn_) {
	                    this.close();
	                }
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on secondary.');
	                this.secondaryResponsesRequired_--;
	                this.upgradeIfSecondaryHealthy_();
	            }
	        }
	    };
	    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
	        var layer = requireKey('t', parsedData);
	        var data = requireKey('d', parsedData);
	        if (layer === 'c') {
	            this.onSecondaryControl_(data);
	        }
	        else if (layer === 'd') {
	            // got a data message, but we're still second connection. Need to buffer it up
	            this.pendingDataMessages.push(data);
	        }
	        else {
	            throw new Error('Unknown protocol layer: ' + layer);
	        }
	    };
	    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
	        if (this.secondaryResponsesRequired_ <= 0) {
	            this.log_('Secondary connection is healthy.');
	            this.isHealthy_ = true;
	            this.secondaryConn_.markConnectionHealthy();
	            this.proceedWithUpgrade_();
	        }
	        else {
	            // Send a ping to make sure the connection is healthy.
	            this.log_('sending ping on secondary.');
	            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.proceedWithUpgrade_ = function () {
	        // tell this connection to consider itself open
	        this.secondaryConn_.start();
	        // send ack
	        this.log_('sending client ack on secondary');
	        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
	        // send end packet on primary transport, switch to sending on this one
	        // can receive on this one, buffer responses until end received on primary transport
	        this.log_('Ending transmission on primary');
	        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
	        this.tx_ = this.secondaryConn_;
	        this.tryCleanupConnection();
	    };
	    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
	        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
	        var layer = requireKey('t', parsedData);
	        var data = requireKey('d', parsedData);
	        if (layer === 'c') {
	            this.onControl_(data);
	        }
	        else if (layer === 'd') {
	            this.onDataMessage_(data);
	        }
	    };
	    Connection.prototype.onDataMessage_ = function (message) {
	        this.onPrimaryResponse_();
	        // We don't do anything with data messages, just kick them up a level
	        this.onMessage_(message);
	    };
	    Connection.prototype.onPrimaryResponse_ = function () {
	        if (!this.isHealthy_) {
	            this.primaryResponsesRequired_--;
	            if (this.primaryResponsesRequired_ <= 0) {
	                this.log_('Primary connection is healthy.');
	                this.isHealthy_ = true;
	                this.conn_.markConnectionHealthy();
	            }
	        }
	    };
	    Connection.prototype.onControl_ = function (controlData) {
	        var cmd = requireKey(MESSAGE_TYPE, controlData);
	        if (MESSAGE_DATA in controlData) {
	            var payload = controlData[MESSAGE_DATA];
	            if (cmd === SERVER_HELLO) {
	                this.onHandshake_(payload);
	            }
	            else if (cmd === END_TRANSMISSION) {
	                this.log_('recvd end transmission on primary');
	                this.rx_ = this.secondaryConn_;
	                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
	                    this.onDataMessage_(this.pendingDataMessages[i]);
	                }
	                this.pendingDataMessages = [];
	                this.tryCleanupConnection();
	            }
	            else if (cmd === CONTROL_SHUTDOWN) {
	                // This was previously the 'onKill' callback passed to the lower-level connection
	                // payload in this case is the reason for the shutdown. Generally a human-readable error
	                this.onConnectionShutdown_(payload);
	            }
	            else if (cmd === CONTROL_RESET) {
	                // payload in this case is the host we should contact
	                this.onReset_(payload);
	            }
	            else if (cmd === CONTROL_ERROR) {
	                error('Server Error: ' + payload);
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on primary.');
	                this.onPrimaryResponse_();
	                this.sendPingOnPrimaryIfNecessary_();
	            }
	            else {
	                error('Unknown control packet command: ' + cmd);
	            }
	        }
	    };
	    /**
	     *
	     * @param {Object} handshake The handshake data returned from the server
	     * @private
	     */
	    Connection.prototype.onHandshake_ = function (handshake) {
	        var timestamp = handshake.ts;
	        var version = handshake.v;
	        var host = handshake.h;
	        this.sessionId = handshake.s;
	        this.repoInfo_.updateHost(host);
	        // if we've already closed the connection, then don't bother trying to progress further
	        if (this.state_ === 0 /* CONNECTING */) {
	            this.conn_.start();
	            this.onConnectionEstablished_(this.conn_, timestamp);
	            if (PROTOCOL_VERSION !== version) {
	                warn('Protocol version mismatch detected');
	            }
	            // TODO: do we want to upgrade? when? maybe a delay?
	            this.tryStartUpgrade_();
	        }
	    };
	    Connection.prototype.tryStartUpgrade_ = function () {
	        var conn = this.transportManager_.upgradeTransport();
	        if (conn) {
	            this.startUpgrade_(conn);
	        }
	    };
	    Connection.prototype.startUpgrade_ = function (conn) {
	        var _this = this;
	        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.secondaryResponsesRequired_ =
	            conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessage = this.connReceiver_(this.secondaryConn_);
	        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
	        this.secondaryConn_.open(onMessage, onDisconnect);
	        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
	        setTimeoutNonBlocking(function () {
	            if (_this.secondaryConn_) {
	                _this.log_('Timed out trying to upgrade.');
	                _this.secondaryConn_.close();
	            }
	        }, Math.floor(UPGRADE_TIMEOUT));
	    };
	    Connection.prototype.onReset_ = function (host) {
	        this.log_('Reset packet received.  New host: ' + host);
	        this.repoInfo_.updateHost(host);
	        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
	        // We don't currently support resets after the connection has already been established
	        if (this.state_ === 1 /* CONNECTED */) {
	            this.close();
	        }
	        else {
	            // Close whatever connections we have open and start again.
	            this.closeConnections_();
	            this.start_();
	        }
	    };
	    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
	        var _this = this;
	        this.log_('Realtime connection established.');
	        this.conn_ = conn;
	        this.state_ = 1 /* CONNECTED */;
	        if (this.onReady_) {
	            this.onReady_(timestamp, this.sessionId);
	            this.onReady_ = null;
	        }
	        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
	        // send some pings.
	        if (this.primaryResponsesRequired_ === 0) {
	            this.log_('Primary connection is healthy.');
	            this.isHealthy_ = true;
	        }
	        else {
	            setTimeoutNonBlocking(function () {
	                _this.sendPingOnPrimaryIfNecessary_();
	            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
	        }
	    };
	    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
	        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
	        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
	            this.log_('sending ping on primary.');
	            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.onSecondaryConnectionLost_ = function () {
	        var conn = this.secondaryConn_;
	        this.secondaryConn_ = null;
	        if (this.tx_ === conn || this.rx_ === conn) {
	            // we are relying on this connection already in some capacity. Therefore, a failure is real
	            this.close();
	        }
	    };
	    /**
	     *
	     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
	     * we should flush the host cache
	     * @private
	     */
	    Connection.prototype.onConnectionLost_ = function (everConnected) {
	        this.conn_ = null;
	        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
	        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
	        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
	            this.log_('Realtime connection failed.');
	            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
	            if (this.repoInfo_.isCacheableHost()) {
	                PersistentStorage.remove('host:' + this.repoInfo_.host);
	                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
	                this.repoInfo_.internalHost = this.repoInfo_.host;
	            }
	        }
	        else if (this.state_ === 1 /* CONNECTED */) {
	            this.log_('Realtime connection lost.');
	        }
	        this.close();
	    };
	    /**
	     *
	     * @param {string} reason
	     * @private
	     */
	    Connection.prototype.onConnectionShutdown_ = function (reason) {
	        this.log_('Connection shutdown command received. Shutting down...');
	        if (this.onKill_) {
	            this.onKill_(reason);
	            this.onKill_ = null;
	        }
	        // We intentionally don't want to fire onDisconnect (kill is a different case),
	        // so clear the callback.
	        this.onDisconnect_ = null;
	        this.close();
	    };
	    Connection.prototype.sendData_ = function (data) {
	        if (this.state_ !== 1 /* CONNECTED */) {
	            throw 'Connection is not connected';
	        }
	        else {
	            this.tx_.send(data);
	        }
	    };
	    /**
	     * Cleans up this connection, calling the appropriate callbacks
	     */
	    Connection.prototype.close = function () {
	        if (this.state_ !== 2 /* DISCONNECTED */) {
	            this.log_('Closing realtime connection.');
	            this.state_ = 2 /* DISCONNECTED */;
	            this.closeConnections_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_();
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     *
	     * @private
	     */
	    Connection.prototype.closeConnections_ = function () {
	        this.log_('Shutting down all connections');
	        if (this.conn_) {
	            this.conn_.close();
	            this.conn_ = null;
	        }
	        if (this.secondaryConn_) {
	            this.secondaryConn_.close();
	            this.secondaryConn_ = null;
	        }
	        if (this.healthyTimeout_) {
	            clearTimeout(this.healthyTimeout_);
	            this.healthyTimeout_ = null;
	        }
	    };
	    return Connection;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Interface defining the set of actions that can be performed against the Firebase server
	 * (basically corresponds to our wire protocol).
	 *
	 * @interface
	 */
	var ServerActions = /** @class */ (function () {
	    function ServerActions() {
	    }
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, ?string)} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
	    /**
	     * Refreshes the auth token for the current connection.
	     * @param {string} token The authentication token
	     */
	    ServerActions.prototype.refreshAuthToken = function (token) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
	    /**
	     * @param {Object.<string, *>} stats
	     */
	    ServerActions.prototype.reportStats = function (stats) { };
	    return ServerActions;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var RECONNECT_MIN_DELAY = 1000;
	var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
	var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
	var RECONNECT_DELAY_MULTIPLIER = 1.3;
	var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
	var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
	// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
	var INVALID_AUTH_TOKEN_THRESHOLD = 3;
	/**
	 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
	 *
	 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
	 * in quotes to make sure the closure compiler does not minify them.
	 */
	var PersistentConnection = /** @class */ (function (_super) {
	    tslib.__extends(PersistentConnection, _super);
	    /**
	     * @implements {ServerActions}
	     * @param repoInfo_ Data about the namespace we are connecting to
	     * @param onDataUpdate_ A callback for new data from the server
	     */
	    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.onConnectStatus_ = onConnectStatus_;
	        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        _this.authOverride_ = authOverride_;
	        // Used for diagnostic logging.
	        _this.id = PersistentConnection.nextPersistentConnectionId_++;
	        _this.log_ = logWrapper('p:' + _this.id + ':');
	        _this.interruptReasons_ = {};
	        /** Map<path, Map<queryId, ListenSpec>> */
	        _this.listens = new Map();
	        _this.outstandingPuts_ = [];
	        _this.outstandingPutCount_ = 0;
	        _this.onDisconnectRequestQueue_ = [];
	        _this.connected_ = false;
	        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
	        _this.securityDebugCallback_ = null;
	        _this.lastSessionId = null;
	        _this.establishConnectionTimer_ = null;
	        _this.visible_ = false;
	        // Before we get connected, we keep a queue of pending messages to send.
	        _this.requestCBHash_ = {};
	        _this.requestNumber_ = 0;
	        _this.realtime_ = null;
	        _this.authToken_ = null;
	        _this.forceTokenRefresh_ = false;
	        _this.invalidAuthTokenCount_ = 0;
	        _this.firstConnection_ = true;
	        _this.lastConnectionAttemptTime_ = null;
	        _this.lastConnectionEstablishedTime_ = null;
	        if (authOverride_ && !util.isNodeSdk()) {
	            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
	        }
	        _this.scheduleConnect_(0);
	        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
	        if (repoInfo_.host.indexOf('fblocal') === -1) {
	            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
	        }
	        return _this;
	    }
	    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
	        var curReqNum = ++this.requestNumber_;
	        var msg = { r: curReqNum, a: action, b: body };
	        this.log_(util.stringify(msg));
	        util.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
	        this.realtime_.sendRequest(msg);
	        if (onResponse) {
	            this.requestCBHash_[curReqNum] = onResponse;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var queryId = query.queryIdentifier();
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + queryId);
	        if (!this.listens.has(pathString)) {
	            this.listens.set(pathString, new Map());
	        }
	        util.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
	        util.assert(!this.listens.get(pathString).has(queryId), 'listen() called twice for same path/queryId.');
	        var listenSpec = {
	            onComplete: onComplete,
	            hashFn: currentHashFn,
	            query: query,
	            tag: tag
	        };
	        this.listens.get(pathString).set(queryId, listenSpec);
	        if (this.connected_) {
	            this.sendListen_(listenSpec);
	        }
	    };
	    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
	        var _this = this;
	        var query = listenSpec.query;
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Listen on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'q';
	        // Only bother to send query if it's non-default.
	        if (listenSpec.tag) {
	            req['q'] = query.queryObject();
	            req['t'] = listenSpec.tag;
	        }
	        req[ /*hash*/'h'] = listenSpec.hashFn();
	        this.sendRequest(action, req, function (message) {
	            var payload = message[ /*data*/'d'];
	            var status = message[ /*status*/'s'];
	            // print warnings in any case...
	            PersistentConnection.warnOnListenWarnings_(payload, query);
	            var currentListenSpec = _this.listens.get(pathString) &&
	                _this.listens.get(pathString).get(queryId);
	            // only trigger actions if the listen hasn't been removed and readded
	            if (currentListenSpec === listenSpec) {
	                _this.log_('listen response', message);
	                if (status !== 'ok') {
	                    _this.removeListen_(pathString, queryId);
	                }
	                if (listenSpec.onComplete) {
	                    listenSpec.onComplete(status, payload);
	                }
	            }
	        });
	    };
	    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
	        if (payload && typeof payload === 'object' && util.contains(payload, 'w')) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var warnings = util.safeGet(payload, 'w');
	            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
	                var indexSpec = '".indexOn": "' +
	                    query
	                        .getQueryParams()
	                        .getIndex()
	                        .toString() +
	                    '"';
	                var indexPath = query.path.toString();
	                warn("Using an unspecified index. Your data will be downloaded and " +
	                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
	                    (indexPath + " to your security rules for better performance."));
	            }
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.refreshAuthToken = function (token) {
	        this.authToken_ = token;
	        this.log_('Auth token refreshed');
	        if (this.authToken_) {
	            this.tryAuth();
	        }
	        else {
	            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
	            //the credential so we dont become authenticated next time we connect.
	            if (this.connected_) {
	                this.sendRequest('unauth', {}, function () { });
	            }
	        }
	        this.reduceReconnectDelayIfAdminCredential_(token);
	    };
	    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
	        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
	        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
	        var isFirebaseSecret = credential && credential.length === 40;
	        if (isFirebaseSecret || util.isAdmin(credential)) {
	            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
	            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	        }
	    };
	    /**
	     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
	     * a auth revoked (the connection is closed).
	     */
	    PersistentConnection.prototype.tryAuth = function () {
	        var _this = this;
	        if (this.connected_ && this.authToken_) {
	            var token_1 = this.authToken_;
	            var authMethod = util.isValidFormat(token_1) ? 'auth' : 'gauth';
	            var requestData = { cred: token_1 };
	            if (this.authOverride_ === null) {
	                requestData['noauth'] = true;
	            }
	            else if (typeof this.authOverride_ === 'object') {
	                requestData['authvar'] = this.authOverride_;
	            }
	            this.sendRequest(authMethod, requestData, function (res) {
	                var status = res[ /*status*/'s'];
	                var data = res[ /*data*/'d'] || 'error';
	                if (_this.authToken_ === token_1) {
	                    if (status === 'ok') {
	                        _this.invalidAuthTokenCount_ = 0;
	                    }
	                    else {
	                        // Triggers reconnect and force refresh for auth token
	                        _this.onAuthRevoked_(status, data);
	                    }
	                }
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.unlisten = function (query, tag) {
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
	        util.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && this.connected_) {
	            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
	        }
	    };
	    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
	        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'n';
	        // Only bother sending queryId if it's non-default.
	        if (tag) {
	            req['q'] = queryObj;
	            req['t'] = tag;
	        }
	        this.sendRequest(action, req);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('o', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'o',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('om', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'om',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('oc', pathString, null, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'oc',
	                data: null,
	                onComplete: onComplete
	            });
	        }
	    };
	    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
	        var request = { /*path*/ p: pathString, /*data*/ d: data };
	        this.log_('onDisconnect ' + action, request);
	        this.sendRequest(action, request, function (response) {
	            if (onComplete) {
	                setTimeout(function () {
	                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
	                }, Math.floor(0));
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
	        this.putInternal('p', pathString, data, onComplete, hash);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
	        this.putInternal('m', pathString, data, onComplete, hash);
	    };
	    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
	        var request = {
	            /*path*/ p: pathString,
	            /*data*/ d: data
	        };
	        if (hash !== undefined) {
	            request[ /*hash*/'h'] = hash;
	        }
	        // TODO: Only keep track of the most recent put for a given path?
	        this.outstandingPuts_.push({
	            action: action,
	            request: request,
	            onComplete: onComplete
	        });
	        this.outstandingPutCount_++;
	        var index = this.outstandingPuts_.length - 1;
	        if (this.connected_) {
	            this.sendPut_(index);
	        }
	        else {
	            this.log_('Buffering put: ' + pathString);
	        }
	    };
	    PersistentConnection.prototype.sendPut_ = function (index) {
	        var _this = this;
	        var action = this.outstandingPuts_[index].action;
	        var request = this.outstandingPuts_[index].request;
	        var onComplete = this.outstandingPuts_[index].onComplete;
	        this.outstandingPuts_[index].queued = this.connected_;
	        this.sendRequest(action, request, function (message) {
	            _this.log_(action + ' response', message);
	            delete _this.outstandingPuts_[index];
	            _this.outstandingPutCount_--;
	            // Clean up array occasionally.
	            if (_this.outstandingPutCount_ === 0) {
	                _this.outstandingPuts_ = [];
	            }
	            if (onComplete) {
	                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.reportStats = function (stats) {
	        var _this = this;
	        // If we're not connected, we just drop the stats.
	        if (this.connected_) {
	            var request = { /*counters*/ c: stats };
	            this.log_('reportStats', request);
	            this.sendRequest(/*stats*/ 's', request, function (result) {
	                var status = result[ /*status*/'s'];
	                if (status !== 'ok') {
	                    var errorReason = result[ /* data */'d'];
	                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
	                }
	            });
	        }
	    };
	    PersistentConnection.prototype.onDataMessage_ = function (message) {
	        if ('r' in message) {
	            // this is a response
	            this.log_('from server: ' + util.stringify(message));
	            var reqNum = message['r'];
	            var onResponse = this.requestCBHash_[reqNum];
	            if (onResponse) {
	                delete this.requestCBHash_[reqNum];
	                onResponse(message[ /*body*/'b']);
	            }
	        }
	        else if ('error' in message) {
	            throw 'A server-side error has occurred: ' + message['error'];
	        }
	        else if ('a' in message) {
	            // a and b are action and body, respectively
	            this.onDataPush_(message['a'], message['b']);
	        }
	    };
	    PersistentConnection.prototype.onDataPush_ = function (action, body) {
	        this.log_('handleServerMessage', action, body);
	        if (action === 'd') {
	            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
	            /*isMerge*/ false, body['t']);
	        }
	        else if (action === 'm') {
	            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
	            /*isMerge=*/ true, body['t']);
	        }
	        else if (action === 'c') {
	            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
	        }
	        else if (action === 'ac') {
	            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
	        }
	        else if (action === 'sd') {
	            this.onSecurityDebugPacket_(body);
	        }
	        else {
	            error('Unrecognized action received from server: ' +
	                util.stringify(action) +
	                '\nAre you using the latest client?');
	        }
	    };
	    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
	        this.log_('connection ready');
	        this.connected_ = true;
	        this.lastConnectionEstablishedTime_ = new Date().getTime();
	        this.handleTimestamp_(timestamp);
	        this.lastSessionId = sessionId;
	        if (this.firstConnection_) {
	            this.sendConnectStats_();
	        }
	        this.restoreState_();
	        this.firstConnection_ = false;
	        this.onConnectStatus_(true);
	    };
	    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
	        var _this = this;
	        util.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
	        if (this.establishConnectionTimer_) {
	            clearTimeout(this.establishConnectionTimer_);
	        }
	        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
	        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
	        this.establishConnectionTimer_ = setTimeout(function () {
	            _this.establishConnectionTimer_ = null;
	            _this.establishConnection_();
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }, Math.floor(timeout));
	    };
	    PersistentConnection.prototype.onVisible_ = function (visible) {
	        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
	        if (visible &&
	            !this.visible_ &&
	            this.reconnectDelay_ === this.maxReconnectDelay_) {
	            this.log_('Window became visible.  Reducing delay.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        this.visible_ = visible;
	    };
	    PersistentConnection.prototype.onOnline_ = function (online) {
	        if (online) {
	            this.log_('Browser went online.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        else {
	            this.log_('Browser went offline.  Killing connection.');
	            if (this.realtime_) {
	                this.realtime_.close();
	            }
	        }
	    };
	    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
	        this.log_('data client disconnected');
	        this.connected_ = false;
	        this.realtime_ = null;
	        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
	        this.cancelSentTransactions_();
	        // Clear out the pending requests.
	        this.requestCBHash_ = {};
	        if (this.shouldReconnect_()) {
	            if (!this.visible_) {
	                this.log_("Window isn't visible.  Delaying reconnect.");
	                this.reconnectDelay_ = this.maxReconnectDelay_;
	                this.lastConnectionAttemptTime_ = new Date().getTime();
	            }
	            else if (this.lastConnectionEstablishedTime_) {
	                // If we've been connected long enough, reset reconnect delay to minimum.
	                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
	                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT) {
	                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	                }
	                this.lastConnectionEstablishedTime_ = null;
	            }
	            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
	            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
	            reconnectDelay = Math.random() * reconnectDelay;
	            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
	            this.scheduleConnect_(reconnectDelay);
	            // Adjust reconnect delay for next time.
	            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
	        }
	        this.onConnectStatus_(false);
	    };
	    PersistentConnection.prototype.establishConnection_ = function () {
	        if (this.shouldReconnect_()) {
	            this.log_('Making a connection attempt');
	            this.lastConnectionAttemptTime_ = new Date().getTime();
	            this.lastConnectionEstablishedTime_ = null;
	            var onDataMessage_1 = this.onDataMessage_.bind(this);
	            var onReady_1 = this.onReady_.bind(this);
	            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
	            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
	            var self_1 = this;
	            var lastSessionId_1 = this.lastSessionId;
	            var canceled_1 = false;
	            var connection_1 = null;
	            var closeFn_1 = function () {
	                if (connection_1) {
	                    connection_1.close();
	                }
	                else {
	                    canceled_1 = true;
	                    onDisconnect_1();
	                }
	            };
	            var sendRequestFn = function (msg) {
	                util.assert(connection_1, "sendRequest call when we're not connected not allowed.");
	                connection_1.sendRequest(msg);
	            };
	            this.realtime_ = {
	                close: closeFn_1,
	                sendRequest: sendRequestFn
	            };
	            var forceRefresh = this.forceTokenRefresh_;
	            this.forceTokenRefresh_ = false;
	            // First fetch auth token, and establish connection after fetching the token was successful
	            this.authTokenProvider_
	                .getToken(forceRefresh)
	                .then(function (result) {
	                if (!canceled_1) {
	                    log('getToken() completed. Creating connection.');
	                    self_1.authToken_ = result && result.accessToken;
	                    connection_1 = new Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
	                    /* onKill= */ function (reason) {
	                        warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
	                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
	                    }, lastSessionId_1);
	                }
	                else {
	                    log('getToken() completed but was canceled');
	                }
	            })
	                .then(null, function (error) {
	                self_1.log_('Failed to get token: ' + error);
	                if (!canceled_1) {
	                    if (util.CONSTANTS.NODE_ADMIN) {
	                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
	                        // But getToken() may also just have temporarily failed, so we still want to
	                        // continue retrying.
	                        warn(error);
	                    }
	                    closeFn_1();
	                }
	            });
	        }
	    };
	    PersistentConnection.prototype.interrupt = function (reason) {
	        log('Interrupting connection for reason: ' + reason);
	        this.interruptReasons_[reason] = true;
	        if (this.realtime_) {
	            this.realtime_.close();
	        }
	        else {
	            if (this.establishConnectionTimer_) {
	                clearTimeout(this.establishConnectionTimer_);
	                this.establishConnectionTimer_ = null;
	            }
	            if (this.connected_) {
	                this.onRealtimeDisconnect_();
	            }
	        }
	    };
	    PersistentConnection.prototype.resume = function (reason) {
	        log('Resuming connection for reason: ' + reason);
	        delete this.interruptReasons_[reason];
	        if (util.isEmpty(this.interruptReasons_)) {
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	    };
	    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
	        var delta = timestamp - new Date().getTime();
	        this.onServerInfoUpdate_({ serverTimeOffset: delta });
	    };
	    PersistentConnection.prototype.cancelSentTransactions_ = function () {
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            var put = this.outstandingPuts_[i];
	            if (put && /*hash*/ 'h' in put.request && put.queued) {
	                if (put.onComplete) {
	                    put.onComplete('disconnect');
	                }
	                delete this.outstandingPuts_[i];
	                this.outstandingPutCount_--;
	            }
	        }
	        // Clean up array occasionally.
	        if (this.outstandingPutCount_ === 0) {
	            this.outstandingPuts_ = [];
	        }
	    };
	    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
	        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
	        var queryId;
	        if (!query) {
	            queryId = 'default';
	        }
	        else {
	            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
	        }
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && listen.onComplete) {
	            listen.onComplete('permission_denied');
	        }
	    };
	    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
	        var normalizedPathString = new Path(pathString).toString(); // normalize path.
	        var listen;
	        if (this.listens.has(normalizedPathString)) {
	            var map = this.listens.get(normalizedPathString);
	            listen = map.get(queryId);
	            map.delete(queryId);
	            if (map.size === 0) {
	                this.listens.delete(normalizedPathString);
	            }
	        }
	        else {
	            // all listens for this path has already been removed
	            listen = undefined;
	        }
	        return listen;
	    };
	    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
	        log('Auth token revoked: ' + statusCode + '/' + explanation);
	        this.authToken_ = null;
	        this.forceTokenRefresh_ = true;
	        this.realtime_.close();
	        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
	            // We'll wait a couple times before logging the warning / increasing the
	            // retry period since oauth tokens will report as "invalid" if they're
	            // just expired. Plus there may be transient issues that resolve themselves.
	            this.invalidAuthTokenCount_++;
	            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
	                // Set a long reconnect delay because recovery is unlikely
	                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	                // Notify the auth token provider that the token is invalid, which will log
	                // a warning
	                this.authTokenProvider_.notifyForInvalidToken();
	            }
	        }
	    };
	    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
	        if (this.securityDebugCallback_) {
	            this.securityDebugCallback_(body);
	        }
	        else {
	            if ('msg' in body) {
	                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
	            }
	        }
	    };
	    PersistentConnection.prototype.restoreState_ = function () {
	        var e_1, _a, e_2, _b;
	        //Re-authenticate ourselves if we have a credential stored.
	        this.tryAuth();
	        try {
	            // Puts depend on having received the corresponding data update from the server before they complete, so we must
	            // make sure to send listens before puts.
	            for (var _c = tslib.__values(this.listens.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var queries = _d.value;
	                try {
	                    for (var _e = (e_2 = void 0, tslib.__values(queries.values())), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var listenSpec = _f.value;
	                        this.sendListen_(listenSpec);
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            if (this.outstandingPuts_[i]) {
	                this.sendPut_(i);
	            }
	        }
	        while (this.onDisconnectRequestQueue_.length) {
	            var request = this.onDisconnectRequestQueue_.shift();
	            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
	        }
	    };
	    /**
	     * Sends client stats for first connection
	     */
	    PersistentConnection.prototype.sendConnectStats_ = function () {
	        var stats = {};
	        var clientName = 'js';
	        if (util.CONSTANTS.NODE_ADMIN) {
	            clientName = 'admin_node';
	        }
	        else if (util.CONSTANTS.NODE_CLIENT) {
	            clientName = 'node';
	        }
	        stats['sdk.' + clientName + '.' + SDK_VERSION.replace(/\./g, '-')] = 1;
	        if (util.isMobileCordova()) {
	            stats['framework.cordova'] = 1;
	        }
	        else if (util.isReactNative()) {
	            stats['framework.reactnative'] = 1;
	        }
	        this.reportStats(stats);
	    };
	    PersistentConnection.prototype.shouldReconnect_ = function () {
	        var online = OnlineMonitor.getInstance().currentlyOnline();
	        return util.isEmpty(this.interruptReasons_) && online;
	    };
	    PersistentConnection.nextPersistentConnectionId_ = 0;
	    /**
	     * Counter for number of connections created. Mainly used for tagging in the logs
	     */
	    PersistentConnection.nextConnectionId_ = 0;
	    return PersistentConnection;
	}(ServerActions));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An implementation of ServerActions that communicates with the server via REST requests.
	 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
	 * persistent connection (using WebSockets or long-polling)
	 */
	var ReadonlyRestClient = /** @class */ (function (_super) {
	    tslib.__extends(ReadonlyRestClient, _super);
	    /**
	     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
	     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
	     * @param {AuthTokenProvider} authTokenProvider_
	     * @implements {ServerActions}
	     */
	    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        /** @private {function(...[*])} */
	        _this.log_ = logWrapper('p:rest:');
	        /**
	         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
	         * that's been removed. :-/
	         *
	         * @private {!Object.<string, !Object>}
	         */
	        _this.listens_ = {};
	        return _this;
	    }
	    ReadonlyRestClient.prototype.reportStats = function (stats) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @param {!Query} query
	     * @param {?number=} tag
	     * @return {string}
	     * @private
	     */
	    ReadonlyRestClient.getListenId_ = function (query, tag) {
	        if (tag !== undefined) {
	            return 'tag$' + tag;
	        }
	        else {
	            util.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
	            return query.path.toString();
	        }
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var _this = this;
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
	        // Mark this listener so we can tell if it's removed.
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        var thisListen = {};
	        this.listens_[listenId] = thisListen;
	        var queryStringParameters = query
	            .getQueryParams()
	            .toRestQueryStringParameters();
	        this.restRequest_(pathString + '.json', queryStringParameters, function (error, result) {
	            var data = result;
	            if (error === 404) {
	                data = null;
	                error = null;
	            }
	            if (error === null) {
	                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
	            }
	            if (util.safeGet(_this.listens_, listenId) === thisListen) {
	                var status_1;
	                if (!error) {
	                    status_1 = 'ok';
	                }
	                else if (error === 401) {
	                    status_1 = 'permission_denied';
	                }
	                else {
	                    status_1 = 'rest_error:' + error;
	                }
	                onComplete(status_1, null);
	            }
	        });
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        delete this.listens_[listenId];
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
	        // no-op since we just always call getToken.
	    };
	    /**
	     * Performs a REST request to the given path, with the provided query string parameters,
	     * and any auth credentials we have.
	     *
	     * @param {!string} pathString
	     * @param {!Object.<string, *>} queryStringParameters
	     * @param {?function(?number, *=)} callback
	     * @private
	     */
	    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
	        var _this = this;
	        if (queryStringParameters === void 0) { queryStringParameters = {}; }
	        queryStringParameters['format'] = 'export';
	        this.authTokenProvider_
	            .getToken(/*forceRefresh=*/ false)
	            .then(function (authTokenData) {
	            var authToken = authTokenData && authTokenData.accessToken;
	            if (authToken) {
	                queryStringParameters['auth'] = authToken;
	            }
	            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
	                _this.repoInfo_.host +
	                pathString +
	                '?' +
	                'ns=' +
	                _this.repoInfo_.namespace +
	                util.querystring(queryStringParameters);
	            _this.log_('Sending REST request for ' + url);
	            var xhr = new XMLHttpRequest();
	            xhr.onreadystatechange = function () {
	                if (callback && xhr.readyState === 4) {
	                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
	                    var res = null;
	                    if (xhr.status >= 200 && xhr.status < 300) {
	                        try {
	                            res = util.jsonEval(xhr.responseText);
	                        }
	                        catch (e) {
	                            warn('Failed to parse JSON response for ' +
	                                url +
	                                ': ' +
	                                xhr.responseText);
	                        }
	                        callback(null, res);
	                    }
	                    else {
	                        // 401 and 404 are expected.
	                        if (xhr.status !== 401 && xhr.status !== 404) {
	                            warn('Got unsuccessful REST response for ' +
	                                url +
	                                ' Status: ' +
	                                xhr.status);
	                        }
	                        callback(xhr.status);
	                    }
	                    callback = null;
	                }
	            };
	            xhr.open('GET', url, /*asynchronous=*/ true);
	            xhr.send();
	        });
	    };
	    return ReadonlyRestClient;
	}(ServerActions));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var INTERRUPT_REASON = 'repo_interrupt';
	/**
	 * A connection to a single data repository.
	 */
	var Repo = /** @class */ (function () {
	    function Repo(repoInfo_, forceRestClient, app, authProvider) {
	        var _this = this;
	        this.repoInfo_ = repoInfo_;
	        this.app = app;
	        this.dataUpdateCount = 0;
	        this.statsListener_ = null;
	        this.eventQueue_ = new EventQueue();
	        this.nextWriteId_ = 1;
	        this.interceptServerDataCallback_ = null;
	        /** A list of data pieces and paths to be set when this client disconnects. */
	        this.onDisconnect_ = new SparseSnapshotTree();
	        // TODO: This should be @private but it's used by test_access.js and internal.js
	        this.persistentConnection_ = null;
	        var authTokenProvider = new AuthTokenProvider(app, authProvider);
	        this.stats_ = StatsManager.getCollection(repoInfo_);
	        if (forceRestClient || beingCrawled()) {
	            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
	            // Minor hack: Fire onConnect immediately, since there's no actual connection.
	            setTimeout(this.onConnectStatus_.bind(this, true), 0);
	        }
	        else {
	            var authOverride = app.options['databaseAuthVariableOverride'];
	            // Validate authOverride
	            if (typeof authOverride !== 'undefined' && authOverride !== null) {
	                if (typeof authOverride !== 'object') {
	                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
	                }
	                try {
	                    util.stringify(authOverride);
	                }
	                catch (e) {
	                    throw new Error('Invalid authOverride provided: ' + e);
	                }
	            }
	            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
	            this.server_ = this.persistentConnection_;
	        }
	        authTokenProvider.addTokenChangeListener(function (token) {
	            _this.server_.refreshAuthToken(token);
	        });
	        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
	        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
	        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
	        this.transactionsInit_();
	        // Used for .info.
	        this.infoData_ = new SnapshotHolder();
	        this.infoSyncTree_ = new SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                var infoEvents = [];
	                var node = _this.infoData_.getNode(query.path);
	                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
	                // on initial data...
	                if (!node.isEmpty()) {
	                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
	                    setTimeout(function () {
	                        onComplete('ok');
	                    }, 0);
	                }
	                return infoEvents;
	            },
	            stopListening: function () { }
	        });
	        this.updateInfo_('connected', false);
	        this.serverSyncTree_ = new SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
	                    var events = onComplete(status, data);
	                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
	                });
	                // No synchronous events for network-backed sync trees
	                return [];
	            },
	            stopListening: function (query, tag) {
	                _this.server_.unlisten(query, tag);
	            }
	        });
	    }
	    /**
	     * @return The URL corresponding to the root of this Firebase.
	     */
	    Repo.prototype.toString = function () {
	        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
	    };
	    /**
	     * @return The namespace represented by the repo.
	     */
	    Repo.prototype.name = function () {
	        return this.repoInfo_.namespace;
	    };
	    /**
	     * @return The time in milliseconds, taking the server offset into account if we have one.
	     */
	    Repo.prototype.serverTime = function () {
	        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
	        var offset = offsetNode.val() || 0;
	        return new Date().getTime() + offset;
	    };
	    /**
	     * Generate ServerValues using some variables from the repo object.
	     */
	    Repo.prototype.generateServerValues = function () {
	        return generateWithValues({
	            timestamp: this.serverTime()
	        });
	    };
	    /**
	     * Called by realtime when we get new messages from the server.
	     */
	    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
	        // For testing.
	        this.dataUpdateCount++;
	        var path = new Path(pathString);
	        data = this.interceptServerDataCallback_
	            ? this.interceptServerDataCallback_(pathString, data)
	            : data;
	        var events = [];
	        if (tag) {
	            if (isMerge) {
	                var taggedChildren = util.map(data, function (raw) { return nodeFromJSON$1(raw); });
	                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
	            }
	            else {
	                var taggedSnap = nodeFromJSON$1(data);
	                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
	            }
	        }
	        else if (isMerge) {
	            var changedChildren = util.map(data, function (raw) { return nodeFromJSON$1(raw); });
	            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
	        }
	        else {
	            var snap = nodeFromJSON$1(data);
	            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
	        }
	        var affectedPath = path;
	        if (events.length > 0) {
	            // Since we have a listener outstanding for each transaction, receiving any events
	            // is a proxy for some change having occurred.
	            affectedPath = this.rerunTransactions_(path);
	        }
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
	    };
	    // TODO: This should be @private but it's used by test_access.js and internal.js
	    Repo.prototype.interceptServerData_ = function (callback) {
	        this.interceptServerDataCallback_ = callback;
	    };
	    Repo.prototype.onConnectStatus_ = function (connectStatus) {
	        this.updateInfo_('connected', connectStatus);
	        if (connectStatus === false) {
	            this.runOnDisconnectEvents_();
	        }
	    };
	    Repo.prototype.onServerInfoUpdate_ = function (updates) {
	        var _this = this;
	        each(updates, function (key, value) {
	            _this.updateInfo_(key, value);
	        });
	    };
	    Repo.prototype.updateInfo_ = function (pathString, value) {
	        var path = new Path('/.info/' + pathString);
	        var newNode = nodeFromJSON$1(value);
	        this.infoData_.updateSnapshot(path, newNode);
	        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	    };
	    Repo.prototype.getNextWriteId_ = function () {
	        return this.nextWriteId_++;
	    };
	    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
	        var _this = this;
	        this.log_('set', {
	            path: path.toString(),
	            value: newVal,
	            priority: newPriority
	        });
	        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
	        // (b) store unresolved paths on JSON parse
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
	        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        var writeId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
	        this.eventQueue_.queueEvents(events);
	        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
	            var success = status === 'ok';
	            if (!success) {
	                warn('set at ' + path + ' failed: ' + status);
	            }
	            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
	            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	        var affectedPath = this.abortTransactions_(path);
	        this.rerunTransactions_(affectedPath);
	        // We queued the events above, so just flush the queue here
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
	    };
	    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        this.log_('update', { path: path.toString(), value: childrenToMerge });
	        // Start with our existing data and merge each child into it.
	        var empty = true;
	        var serverValues = this.generateServerValues();
	        var changedChildren = {};
	        each(childrenToMerge, function (changedKey, changedValue) {
	            empty = false;
	            var newNodeUnresolved = nodeFromJSON$1(changedValue);
	            changedChildren[changedKey] = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        });
	        if (!empty) {
	            var writeId_1 = this.getNextWriteId_();
	            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
	            this.eventQueue_.queueEvents(events);
	            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
	                var success = status === 'ok';
	                if (!success) {
	                    warn('update at ' + path + ' failed: ' + status);
	                }
	                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
	                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
	                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
	                _this.callOnCompleteCallback(onComplete, status, errorReason);
	            });
	            each(childrenToMerge, function (changedPath) {
	                var affectedPath = _this.abortTransactions_(path.child(changedPath));
	                _this.rerunTransactions_(affectedPath);
	            });
	            // We queued the events above, so just flush the queue here
	            this.eventQueue_.raiseEventsForChangedPath(path, []);
	        }
	        else {
	            log("update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	        }
	    };
	    /**
	     * Applies all of the changes stored up in the onDisconnect_ tree.
	     */
	    Repo.prototype.runOnDisconnectEvents_ = function () {
	        var _this = this;
	        this.log_('onDisconnectEvents');
	        var serverValues = this.generateServerValues();
	        var resolvedOnDisconnectTree = resolveDeferredValueTree(this.onDisconnect_, serverValues);
	        var events = [];
	        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
	            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
	            var affectedPath = _this.abortTransactions_(path);
	            _this.rerunTransactions_(affectedPath);
	        });
	        this.onDisconnect_ = new SparseSnapshotTree();
	        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
	    };
	    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
	        var _this = this;
	        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.forget(path);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON$1(value);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON$1(value, priority);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        if (util.isEmpty(childrenToMerge)) {
	            log("onDisconnect().update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	            return;
	        }
	        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
	            if (status === 'ok') {
	                each(childrenToMerge, function (childName, childNode) {
	                    var newChildNode = nodeFromJSON$1(childNode);
	                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
	                });
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
	        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
	        // a little bit by handling the return values anyways.
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    Repo.prototype.interrupt = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.interrupt(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.resume = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.resume(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.stats = function (showDelta) {
	        if (showDelta === void 0) { showDelta = false; }
	        if (typeof console === 'undefined') {
	            return;
	        }
	        var stats;
	        if (showDelta) {
	            if (!this.statsListener_) {
	                this.statsListener_ = new StatsListener(this.stats_);
	            }
	            stats = this.statsListener_.get();
	        }
	        else {
	            stats = this.stats_.get();
	        }
	        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
	            return Math.max(currentValue.length, previousValue);
	        }, 0);
	        each(stats, function (stat, value) {
	            var paddedStat = stat;
	            // pad stat names to be the same length (plus 2 extra spaces).
	            for (var i = stat.length; i < longestName + 2; i++) {
	                paddedStat += ' ';
	            }
	            console.log(paddedStat + value);
	        });
	    };
	    Repo.prototype.statsIncrementCounter = function (metric) {
	        this.stats_.incrementCounter(metric);
	        this.statsReporter_.includeStat(metric);
	    };
	    Repo.prototype.log_ = function () {
	        var varArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            varArgs[_i] = arguments[_i];
	        }
	        var prefix = '';
	        if (this.persistentConnection_) {
	            prefix = this.persistentConnection_.id + ':';
	        }
	        log.apply(void 0, tslib.__spread([prefix], varArgs));
	    };
	    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
	        if (callback) {
	            exceptionGuard(function () {
	                if (status === 'ok') {
	                    callback(null);
	                }
	                else {
	                    var code = (status || 'error').toUpperCase();
	                    var message = code;
	                    if (errorReason) {
	                        message += ': ' + errorReason;
	                    }
	                    var error = new Error(message);
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    error.code = code;
	                    callback(error);
	                }
	            });
	        }
	    };
	    Object.defineProperty(Repo.prototype, "database", {
	        get: function () {
	            return this.__database || (this.__database = new Database(this));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Repo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var RangedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function RangedFilter(params) {
	        this.indexedFilter_ = new IndexedFilter(params.getIndex());
	        this.index_ = params.getIndex();
	        this.startPost_ = RangedFilter.getStartPost_(params);
	        this.endPost_ = RangedFilter.getEndPost_(params);
	    }
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getStartPost = function () {
	        return this.startPost_;
	    };
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getEndPost = function () {
	        return this.endPost_;
	    };
	    /**
	     * @param {!NamedNode} node
	     * @return {boolean}
	     */
	    RangedFilter.prototype.matches = function (node) {
	        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
	            this.index_.compare(node, this.getEndPost()) <= 0);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.matches(new NamedNode(key, newChild))) {
	            newChild = ChildrenNode.EMPTY_NODE;
	        }
	        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (newSnap.isLeafNode()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            newSnap = ChildrenNode.EMPTY_NODE;
	        }
	        var filtered = newSnap.withIndex(this.index_);
	        // Don't support priorities on queries
	        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
	        var self = this;
	        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	            if (!self.matches(new NamedNode(key, childNode))) {
	                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
	            }
	        });
	        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndexedFilter = function () {
	        return this.indexedFilter_;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getStartPost_ = function (params) {
	        if (params.hasStart()) {
	            var startName = params.getIndexStartName();
	            return params.getIndex().makePost(params.getIndexStartValue(), startName);
	        }
	        else {
	            return params.getIndex().minPost();
	        }
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getEndPost_ = function (params) {
	        if (params.hasEnd()) {
	            var endName = params.getIndexEndName();
	            return params.getIndex().makePost(params.getIndexEndValue(), endName);
	        }
	        else {
	            return params.getIndex().maxPost();
	        }
	    };
	    return RangedFilter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var LimitedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function LimitedFilter(params) {
	        this.rangedFilter_ = new RangedFilter(params);
	        this.index_ = params.getIndex();
	        this.limit_ = params.getLimit();
	        this.reverse_ = !params.isViewFromLeft();
	    }
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
	            newChild = ChildrenNode.EMPTY_NODE;
	        }
	        if (snap.getImmediateChild(key).equals(newChild)) {
	            // No change
	            return snap;
	        }
	        else if (snap.numChildren() < this.limit_) {
	            return this.rangedFilter_
	                .getIndexedFilter()
	                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	        }
	        else {
	            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        var filtered;
	        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	        }
	        else {
	            if (this.limit_ * 2 < newSnap.numChildren() &&
	                newSnap.isIndexed(this.index_)) {
	                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
	                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	                // anchor to the startPost, endPost, or last element as appropriate
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
	                }
	                else {
	                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
	                }
	                var count = 0;
	                while (iterator.hasNext() && count < this.limit_) {
	                    var next = iterator.getNext();
	                    var inRange = void 0;
	                    if (this.reverse_) {
	                        inRange =
	                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
	                    }
	                    else {
	                        inRange =
	                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
	                    }
	                    if (inRange) {
	                        filtered = filtered.updateImmediateChild(next.name, next.node);
	                        count++;
	                    }
	                    else {
	                        // if we have reached the end post, we cannot keep adding elemments
	                        break;
	                    }
	                }
	            }
	            else {
	                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
	                filtered = newSnap.withIndex(this.index_);
	                // Don't support priorities on queries
	                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
	                var startPost = void 0;
	                var endPost = void 0;
	                var cmp = void 0;
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = filtered.getReverseIterator(this.index_);
	                    startPost = this.rangedFilter_.getEndPost();
	                    endPost = this.rangedFilter_.getStartPost();
	                    var indexCompare_1 = this.index_.getCompare();
	                    cmp = function (a, b) { return indexCompare_1(b, a); };
	                }
	                else {
	                    iterator = filtered.getIterator(this.index_);
	                    startPost = this.rangedFilter_.getStartPost();
	                    endPost = this.rangedFilter_.getEndPost();
	                    cmp = this.index_.getCompare();
	                }
	                var count = 0;
	                var foundStartPost = false;
	                while (iterator.hasNext()) {
	                    var next = iterator.getNext();
	                    if (!foundStartPost && cmp(startPost, next) <= 0) {
	                        // start adding
	                        foundStartPost = true;
	                    }
	                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
	                    if (inRange) {
	                        count++;
	                    }
	                    else {
	                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
	                    }
	                }
	            }
	        }
	        return this.rangedFilter_
	            .getIndexedFilter()
	            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndexedFilter = function () {
	        return this.rangedFilter_.getIndexedFilter();
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!Node} snap
	     * @param {string} childKey
	     * @param {!Node} childSnap
	     * @param {!CompleteChildSource} source
	     * @param {?ChildChangeAccumulator} changeAccumulator
	     * @return {!Node}
	     * @private
	     */
	    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
	        // TODO: rename all cache stuff etc to general snap terminology
	        var cmp;
	        if (this.reverse_) {
	            var indexCmp_1 = this.index_.getCompare();
	            cmp = function (a, b) { return indexCmp_1(b, a); };
	        }
	        else {
	            cmp = this.index_.getCompare();
	        }
	        var oldEventCache = snap;
	        util.assert(oldEventCache.numChildren() === this.limit_, '');
	        var newChildNamedNode = new NamedNode(childKey, childSnap);
	        var windowBoundary = this.reverse_
	            ? oldEventCache.getFirstChild(this.index_)
	            : oldEventCache.getLastChild(this.index_);
	        var inRange = this.rangedFilter_.matches(newChildNamedNode);
	        if (oldEventCache.hasChild(childKey)) {
	            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
	            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
	            while (nextChild != null &&
	                (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name))) {
	                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
	                // been applied to the limited filter yet. Ignore this next child which will be updated later in
	                // the limited filter...
	                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
	            }
	            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
	            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
	            if (remainsInWindow) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
	                }
	                return oldEventCache.updateImmediateChild(childKey, childSnap);
	            }
	            else {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
	                }
	                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
	                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
	                if (nextChildInRange) {
	                    if (changeAccumulator != null) {
	                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
	                    }
	                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
	                }
	                else {
	                    return newEventCache;
	                }
	            }
	        }
	        else if (childSnap.isEmpty()) {
	            // we're deleting a node, but it was not in the window, so ignore it
	            return snap;
	        }
	        else if (inRange) {
	            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
	                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
	                }
	                return oldEventCache
	                    .updateImmediateChild(childKey, childSnap)
	                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
	            }
	            else {
	                return snap;
	            }
	        }
	        else {
	            return snap;
	        }
	    };
	    return LimitedFilter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
	 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
	 * user-facing API level, so it is not done here.
	 * @constructor
	 */
	var QueryParams = /** @class */ (function () {
	    function QueryParams() {
	        this.limitSet_ = false;
	        this.startSet_ = false;
	        this.startNameSet_ = false;
	        this.endSet_ = false;
	        this.endNameSet_ = false;
	        this.limit_ = 0;
	        this.viewFrom_ = '';
	        this.indexStartValue_ = null;
	        this.indexStartName_ = '';
	        this.indexEndValue_ = null;
	        this.indexEndName_ = '';
	        this.index_ = PRIORITY_INDEX;
	    }
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasStart = function () {
	        return this.startSet_;
	    };
	    /**
	     * @return {boolean} True if it would return from left.
	     */
	    QueryParams.prototype.isViewFromLeft = function () {
	        if (this.viewFrom_ === '') {
	            // limit(), rather than limitToFirst or limitToLast was called.
	            // This means that only one of startSet_ and endSet_ is true. Use them
	            // to calculate which side of the view to anchor to. If neither is set,
	            // anchor to the end.
	            return this.startSet_;
	        }
	        else {
	            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
	        }
	    };
	    /**
	     * Only valid to call if hasStart() returns true
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexStartValue = function () {
	        util.assert(this.startSet_, 'Only valid if start has been set');
	        return this.indexStartValue_;
	    };
	    /**
	     * Only valid to call if hasStart() returns true.
	     * Returns the starting key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexStartName = function () {
	        util.assert(this.startSet_, 'Only valid if start has been set');
	        if (this.startNameSet_) {
	            return this.indexStartName_;
	        }
	        else {
	            return MIN_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasEnd = function () {
	        return this.endSet_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexEndValue = function () {
	        util.assert(this.endSet_, 'Only valid if end has been set');
	        return this.indexEndValue_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * Returns the end key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexEndName = function () {
	        util.assert(this.endSet_, 'Only valid if end has been set');
	        if (this.endNameSet_) {
	            return this.indexEndName_;
	        }
	        else {
	            return MAX_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasLimit = function () {
	        return this.limitSet_;
	    };
	    /**
	     * @return {boolean} True if a limit has been set and it has been explicitly anchored
	     */
	    QueryParams.prototype.hasAnchoredLimit = function () {
	        return this.limitSet_ && this.viewFrom_ !== '';
	    };
	    /**
	     * Only valid to call if hasLimit() returns true
	     * @return {!number}
	     */
	    QueryParams.prototype.getLimit = function () {
	        util.assert(this.limitSet_, 'Only valid if limit has been set');
	        return this.limit_;
	    };
	    /**
	     * @return {!Index}
	     */
	    QueryParams.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @return {!QueryParams}
	     * @private
	     */
	    QueryParams.prototype.copy_ = function () {
	        var copy = new QueryParams();
	        copy.limitSet_ = this.limitSet_;
	        copy.limit_ = this.limit_;
	        copy.startSet_ = this.startSet_;
	        copy.indexStartValue_ = this.indexStartValue_;
	        copy.startNameSet_ = this.startNameSet_;
	        copy.indexStartName_ = this.indexStartName_;
	        copy.endSet_ = this.endSet_;
	        copy.indexEndValue_ = this.indexEndValue_;
	        copy.endNameSet_ = this.endNameSet_;
	        copy.indexEndName_ = this.indexEndName_;
	        copy.index_ = this.index_;
	        copy.viewFrom_ = this.viewFrom_;
	        return copy;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limit = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = '';
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToFirst = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToLast = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.startAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.startSet_ = true;
	        if (indexValue === undefined) {
	            indexValue = null;
	        }
	        newParams.indexStartValue_ = indexValue;
	        if (key != null) {
	            newParams.startNameSet_ = true;
	            newParams.indexStartName_ = key;
	        }
	        else {
	            newParams.startNameSet_ = false;
	            newParams.indexStartName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.endAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.endSet_ = true;
	        if (indexValue === undefined) {
	            indexValue = null;
	        }
	        newParams.indexEndValue_ = indexValue;
	        if (key !== undefined) {
	            newParams.endNameSet_ = true;
	            newParams.indexEndName_ = key;
	        }
	        else {
	            newParams.endNameSet_ = false;
	            newParams.indexEndName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {!Index} index
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.orderBy = function (index) {
	        var newParams = this.copy_();
	        newParams.index_ = index;
	        return newParams;
	    };
	    /**
	     * @return {!Object}
	     */
	    QueryParams.prototype.getQueryObject = function () {
	        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
	        var obj = {};
	        if (this.startSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
	            if (this.startNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
	            }
	        }
	        if (this.endSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
	            if (this.endNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
	            }
	        }
	        if (this.limitSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
	            var viewFrom = this.viewFrom_;
	            if (viewFrom === '') {
	                if (this.isViewFromLeft()) {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
	                }
	                else {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
	                }
	            }
	            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
	        }
	        // For now, priority index is the default, so we only specify if it's some other index
	        if (this.index_ !== PRIORITY_INDEX) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
	        }
	        return obj;
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.loadsAllData = function () {
	        return !(this.startSet_ || this.endSet_ || this.limitSet_);
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.isDefault = function () {
	        return this.loadsAllData() && this.index_ === PRIORITY_INDEX;
	    };
	    /**
	     * @return {!NodeFilter}
	     */
	    QueryParams.prototype.getNodeFilter = function () {
	        if (this.loadsAllData()) {
	            return new IndexedFilter(this.getIndex());
	        }
	        else if (this.hasLimit()) {
	            return new LimitedFilter(this);
	        }
	        else {
	            return new RangedFilter(this);
	        }
	    };
	    /**
	     * Returns a set of REST query string parameters representing this query.
	     *
	     * @return {!Object.<string,*>} query string parameters
	     */
	    QueryParams.prototype.toRestQueryStringParameters = function () {
	        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
	        var qs = {};
	        if (this.isDefault()) {
	            return qs;
	        }
	        var orderBy;
	        if (this.index_ === PRIORITY_INDEX) {
	            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
	        }
	        else if (this.index_ === VALUE_INDEX) {
	            orderBy = REST_CONSTANTS.VALUE_INDEX;
	        }
	        else if (this.index_ === KEY_INDEX) {
	            orderBy = REST_CONSTANTS.KEY_INDEX;
	        }
	        else {
	            util.assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
	            orderBy = this.index_.toString();
	        }
	        qs[REST_CONSTANTS.ORDER_BY] = util.stringify(orderBy);
	        if (this.startSet_) {
	            qs[REST_CONSTANTS.START_AT] = util.stringify(this.indexStartValue_);
	            if (this.startNameSet_) {
	                qs[REST_CONSTANTS.START_AT] += ',' + util.stringify(this.indexStartName_);
	            }
	        }
	        if (this.endSet_) {
	            qs[REST_CONSTANTS.END_AT] = util.stringify(this.indexEndValue_);
	            if (this.endNameSet_) {
	                qs[REST_CONSTANTS.END_AT] += ',' + util.stringify(this.indexEndName_);
	            }
	        }
	        if (this.limitSet_) {
	            if (this.isViewFromLeft()) {
	                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
	            }
	            else {
	                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
	            }
	        }
	        return qs;
	    };
	    /**
	     * Wire Protocol Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
	        INDEX_START_VALUE: 'sp',
	        INDEX_START_NAME: 'sn',
	        INDEX_END_VALUE: 'ep',
	        INDEX_END_NAME: 'en',
	        LIMIT: 'l',
	        VIEW_FROM: 'vf',
	        VIEW_FROM_LEFT: 'l',
	        VIEW_FROM_RIGHT: 'r',
	        INDEX: 'i'
	    };
	    /**
	     * REST Query Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.REST_QUERY_CONSTANTS_ = {
	        ORDER_BY: 'orderBy',
	        PRIORITY_INDEX: '$priority',
	        VALUE_INDEX: '$value',
	        KEY_INDEX: '$key',
	        START_AT: 'startAt',
	        END_AT: 'endAt',
	        LIMIT_TO_FIRST: 'limitToFirst',
	        LIMIT_TO_LAST: 'limitToLast'
	    };
	    /**
	     * Default, empty query parameters
	     * @type {!QueryParams}
	     * @const
	     */
	    QueryParams.DEFAULT = new QueryParams();
	    return QueryParams;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Reference = /** @class */ (function (_super) {
	    tslib.__extends(Reference, _super);
	    /**
	     * Call options:
	     *   new Reference(Repo, Path) or
	     *   new Reference(url: string, string|RepoManager)
	     *
	     * Externally - this is the firebase.database.Reference type.
	     *
	     * @param {!Repo} repo
	     * @param {(!Path)} path
	     * @extends {Query}
	     */
	    function Reference(repo, path) {
	        var _this = this;
	        if (!(repo instanceof Repo)) {
	            throw new Error('new Reference() no longer supported - use app.database().');
	        }
	        // call Query's constructor, passing in the repo and path.
	        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
	        return _this;
	    }
	    /** @return {?string} */
	    Reference.prototype.getKey = function () {
	        util.validateArgCount('Reference.key', 0, 0, arguments.length);
	        if (this.path.isEmpty()) {
	            return null;
	        }
	        else {
	            return this.path.getBack();
	        }
	    };
	    /**
	     * @param {!(string|Path)} pathString
	     * @return {!Reference}
	     */
	    Reference.prototype.child = function (pathString) {
	        util.validateArgCount('Reference.child', 1, 1, arguments.length);
	        if (typeof pathString === 'number') {
	            pathString = String(pathString);
	        }
	        else if (!(pathString instanceof Path)) {
	            if (this.path.getFront() === null) {
	                validateRootPathString('Reference.child', 1, pathString, false);
	            }
	            else {
	                validatePathString('Reference.child', 1, pathString, false);
	            }
	        }
	        return new Reference(this.repo, this.path.child(pathString));
	    };
	    /** @return {?Reference} */
	    Reference.prototype.getParent = function () {
	        util.validateArgCount('Reference.parent', 0, 0, arguments.length);
	        var parentPath = this.path.parent();
	        return parentPath === null ? null : new Reference(this.repo, parentPath);
	    };
	    /** @return {!Reference} */
	    Reference.prototype.getRoot = function () {
	        util.validateArgCount('Reference.root', 0, 0, arguments.length);
	        var ref = this;
	        while (ref.getParent() !== null) {
	            ref = ref.getParent();
	        }
	        return ref;
	    };
	    /** @return {!Database} */
	    Reference.prototype.databaseProp = function () {
	        return this.repo.database;
	    };
	    /**
	     * @param {*} newVal
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.set = function (newVal, onComplete) {
	        util.validateArgCount('Reference.set', 1, 2, arguments.length);
	        validateWritablePath('Reference.set', this.path);
	        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
	        util.validateCallback('Reference.set', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path, newVal, 
	        /*priority=*/ null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.update = function (objectToMerge, onComplete) {
	        util.validateArgCount('Reference.update', 1, 2, arguments.length);
	        validateWritablePath('Reference.update', this.path);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            warn('Passing an Array to Firebase.update() is deprecated. ' +
	                'Use set() if you want to overwrite the existing data, or ' +
	                'an Object with integer keys if you really do want to ' +
	                'only update some of the children.');
	        }
	        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
	        util.validateCallback('Reference.update', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} newVal
	     * @param {string|number|null} newPriority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
	        util.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
	        validateWritablePath('Reference.setWithPriority', this.path);
	        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
	        validatePriority('Reference.setWithPriority', 2, newPriority, false);
	        util.validateCallback('Reference.setWithPriority', 3, onComplete, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys') {
	            throw 'Reference.setWithPriority failed: ' +
	                this.getKey() +
	                ' is a read-only object.';
	        }
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.remove = function (onComplete) {
	        util.validateArgCount('Reference.remove', 0, 1, arguments.length);
	        validateWritablePath('Reference.remove', this.path);
	        util.validateCallback('Reference.remove', 1, onComplete, true);
	        return this.set(null, onComplete);
	    };
	    /**
	     * @param {function(*):*} transactionUpdate
	     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
	     * @param {boolean=} applyLocally
	     * @return {!Promise}
	     */
	    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
	        util.validateArgCount('Reference.transaction', 1, 3, arguments.length);
	        validateWritablePath('Reference.transaction', this.path);
	        util.validateCallback('Reference.transaction', 1, transactionUpdate, false);
	        util.validateCallback('Reference.transaction', 2, onComplete, true);
	        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
	        // to expose it.
	        validateBoolean('Reference.transaction', 3, applyLocally, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys') {
	            throw 'Reference.transaction failed: ' +
	                this.getKey() +
	                ' is a read-only object.';
	        }
	        if (applyLocally === undefined) {
	            applyLocally = true;
	        }
	        var deferred = new util.Deferred();
	        if (typeof onComplete === 'function') {
	            deferred.promise.catch(function () { });
	        }
	        var promiseComplete = function (error, committed, snapshot) {
	            if (error) {
	                deferred.reject(error);
	            }
	            else {
	                deferred.resolve(new TransactionResult(committed, snapshot));
	            }
	            if (typeof onComplete === 'function') {
	                onComplete(error, committed, snapshot);
	            }
	        };
	        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
	        return deferred.promise;
	    };
	    /**
	     * @param {string|number|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setPriority = function (priority, onComplete) {
	        util.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
	        validateWritablePath('Reference.setPriority', this.path);
	        validatePriority('Reference.setPriority', 1, priority, false);
	        util.validateCallback('Reference.setPriority', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*=} value
	     * @param {function(?Error)=} onComplete
	     * @return {!Reference}
	     */
	    Reference.prototype.push = function (value, onComplete) {
	        util.validateArgCount('Reference.push', 0, 2, arguments.length);
	        validateWritablePath('Reference.push', this.path);
	        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
	        util.validateCallback('Reference.push', 2, onComplete, true);
	        var now = this.repo.serverTime();
	        var name = nextPushId(now);
	        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
	        // We use child() to create handles to two different references. The first is turned into a
	        // ThennableReference below by adding then() and catch() methods and is used as the
	        // return value of push(). The second remains a regular Reference and is used as the fulfilled
	        // value of the first ThennableReference.
	        var thennablePushRef = this.child(name);
	        var pushRef = this.child(name);
	        var promise;
	        if (value != null) {
	            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
	        }
	        else {
	            promise = Promise.resolve(pushRef);
	        }
	        thennablePushRef.then = promise.then.bind(promise);
	        thennablePushRef.catch = promise.then.bind(promise, undefined);
	        if (typeof onComplete === 'function') {
	            promise.catch(function () { });
	        }
	        return thennablePushRef;
	    };
	    /**
	     * @return {!OnDisconnect}
	     */
	    Reference.prototype.onDisconnect = function () {
	        validateWritablePath('Reference.onDisconnect', this.path);
	        return new OnDisconnect(this.repo, this.path);
	    };
	    Object.defineProperty(Reference.prototype, "database", {
	        get: function () {
	            return this.databaseProp();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "key", {
	        get: function () {
	            return this.getKey();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "parent", {
	        get: function () {
	            return this.getParent();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        get: function () {
	            return this.getRoot();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Reference;
	}(Query));
	/**
	 * Define reference constructor in various modules
	 *
	 * We are doing this here to avoid several circular
	 * dependency issues
	 */
	Query.__referenceConstructor = Reference;
	SyncPoint.__referenceConstructor = Reference;
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Node in a Tree.
	 */
	var TreeNode = /** @class */ (function () {
	    function TreeNode() {
	        // TODO: Consider making accessors that create children and value lazily or
	        // separate Internal / Leaf 'types'.
	        this.children = {};
	        this.childCount = 0;
	        this.value = null;
	    }
	    return TreeNode;
	}());
	/**
	 * A light-weight tree, traversable by path.  Nodes can have both values and children.
	 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
	 * children.
	 */
	var Tree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {string=} name_ Optional name of the node.
	     * @param {Tree=} parent_ Optional parent node.
	     * @param {TreeNode=} node_ Optional node to wrap.
	     */
	    function Tree(name_, parent_, node_) {
	        if (name_ === void 0) { name_ = ''; }
	        if (parent_ === void 0) { parent_ = null; }
	        if (node_ === void 0) { node_ = new TreeNode(); }
	        this.name_ = name_;
	        this.parent_ = parent_;
	        this.node_ = node_;
	    }
	    /**
	     * Returns a sub-Tree for the given path.
	     *
	     * @param {!(string|Path)} pathObj Path to look up.
	     * @return {!Tree.<T>} Tree for path.
	     */
	    Tree.prototype.subTree = function (pathObj) {
	        // TODO: Require pathObj to be Path?
	        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
	        var child = this, next = path.getFront();
	        while (next !== null) {
	            var childNode = util.safeGet(child.node_.children, next) || new TreeNode();
	            child = new Tree(next, child, childNode);
	            path = path.popFront();
	            next = path.getFront();
	        }
	        return child;
	    };
	    /**
	     * Returns the data associated with this tree node.
	     *
	     * @return {?T} The data or null if no data exists.
	     */
	    Tree.prototype.getValue = function () {
	        return this.node_.value;
	    };
	    /**
	     * Sets data to this tree node.
	     *
	     * @param {!T} value Value to set.
	     */
	    Tree.prototype.setValue = function (value) {
	        util.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
	        this.node_.value = value;
	        this.updateParents_();
	    };
	    /**
	     * Clears the contents of the tree node (its value and all children).
	     */
	    Tree.prototype.clear = function () {
	        this.node_.value = null;
	        this.node_.children = {};
	        this.node_.childCount = 0;
	        this.updateParents_();
	    };
	    /**
	     * @return {boolean} Whether the tree has any children.
	     */
	    Tree.prototype.hasChildren = function () {
	        return this.node_.childCount > 0;
	    };
	    /**
	     * @return {boolean} Whether the tree is empty (no value or children).
	     */
	    Tree.prototype.isEmpty = function () {
	        return this.getValue() === null && !this.hasChildren();
	    };
	    /**
	     * Calls action for each child of this tree node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachChild = function (action) {
	        var _this = this;
	        each(this.node_.children, function (child, childTree) {
	            action(new Tree(child, _this, childTree));
	        });
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants, calling action for each one.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
	     *   false.
	     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
	     *   parent.
	     */
	    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
	        if (includeSelf && !childrenFirst) {
	            action(this);
	        }
	        this.forEachChild(function (child) {
	            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
	        });
	        if (includeSelf && childrenFirst) {
	            action(this);
	        }
	    };
	    /**
	     * Calls action on each ancestor node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
	     *   true to abort.
	     * @param {boolean=} includeSelf Whether to call action on this node as well.
	     * @return {boolean} true if the action callback returned true.
	     */
	    Tree.prototype.forEachAncestor = function (action, includeSelf) {
	        var node = includeSelf ? this : this.parent();
	        while (node !== null) {
	            if (action(node)) {
	                return true;
	            }
	            node = node.parent();
	        }
	        return false;
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
	     * is found, action is called on it and traversal does not continue inside the node.
	     * Action is *not* called on this node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
	        this.forEachChild(function (child) {
	            if (child.getValue() !== null) {
	                action(child);
	            }
	            else {
	                child.forEachImmediateDescendantWithValue(action);
	            }
	        });
	    };
	    /**
	     * @return {!Path} The path of this tree node, as a Path.
	     */
	    Tree.prototype.path = function () {
	        return new Path(this.parent_ === null
	            ? this.name_
	            : this.parent_.path() + '/' + this.name_);
	    };
	    /**
	     * @return {string} The name of the tree node.
	     */
	    Tree.prototype.name = function () {
	        return this.name_;
	    };
	    /**
	     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
	     */
	    Tree.prototype.parent = function () {
	        return this.parent_;
	    };
	    /**
	     * Adds or removes this child from its parent based on whether it's empty or not.
	     *
	     * @private
	     */
	    Tree.prototype.updateParents_ = function () {
	        if (this.parent_ !== null) {
	            this.parent_.updateChild_(this.name_, this);
	        }
	    };
	    /**
	     * Adds or removes the passed child to this tree node, depending on whether it's empty.
	     *
	     * @param {string} childName The name of the child to update.
	     * @param {!Tree.<T>} child The child to update.
	     * @private
	     */
	    Tree.prototype.updateChild_ = function (childName, child) {
	        var childEmpty = child.isEmpty();
	        var childExists = util.contains(this.node_.children, childName);
	        if (childEmpty && childExists) {
	            delete this.node_.children[childName];
	            this.node_.childCount--;
	            this.updateParents_();
	        }
	        else if (!childEmpty && !childExists) {
	            this.node_.children[childName] = child.node_;
	            this.node_.childCount++;
	            this.updateParents_();
	        }
	    };
	    return Tree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
	// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
	// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
	// For now it's part of Repo, but in its own file.
	/**
	 * @enum {number}
	 */
	var TransactionStatus;
	(function (TransactionStatus) {
	    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
	    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
	    // mismatched hash.
	    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
	    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
	    // or rejected yet).
	    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
	    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
	    // removed when we get a chance to prune completed ones.
	    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
	    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
	    // If it comes back as unsuccessful, we'll abort it.
	    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
	    // Temporary state used to mark transactions that need to be aborted.
	    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
	})(TransactionStatus || (TransactionStatus = {}));
	/**
	 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
	 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
	 * @type {number}
	 * @const
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.MAX_TRANSACTION_RETRIES_ = 25;
	/**
	 * Setup the transaction data structures
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.transactionsInit_ = function () {
	    /**
	     * Stores queues of outstanding transactions for Firebase locations.
	     *
	     * @type {!Tree.<Array.<!Transaction>>}
	     * @private
	     */
	    this.transactionQueueTree_ = new Tree();
	};
	/**
	 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
	 *
	 * @param {!Path} path Path at which to do transaction.
	 * @param {function(*):*} transactionUpdate Update callback.
	 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
	 * @param {boolean} applyLocally Whether or not to make intermediate results visible
	 */
	Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
	    this.log_('transaction on ' + path);
	    // Add a watch to make sure we get server updates.
	    var valueCallback = function () { };
	    var watchRef = new Reference(this, path);
	    watchRef.on('value', valueCallback);
	    var unwatcher = function () {
	        watchRef.off('value', valueCallback);
	    };
	    // Initialize transaction.
	    var transaction = {
	        path: path,
	        update: transactionUpdate,
	        onComplete: onComplete,
	        // One of TransactionStatus enums.
	        status: null,
	        // Used when combining transactions at different locations to figure out which one goes first.
	        order: LUIDGenerator(),
	        // Whether to raise local events for this transaction.
	        applyLocally: applyLocally,
	        // Count of how many times we've retried the transaction.
	        retryCount: 0,
	        // Function to call to clean up our .on() listener.
	        unwatcher: unwatcher,
	        // Stores why a transaction was aborted.
	        abortReason: null,
	        currentWriteId: null,
	        currentInputSnapshot: null,
	        currentOutputSnapshotRaw: null,
	        currentOutputSnapshotResolved: null
	    };
	    // Run transaction initially.
	    var currentState = this.getLatestState_(path);
	    transaction.currentInputSnapshot = currentState;
	    var newVal = transaction.update(currentState.val());
	    if (newVal === undefined) {
	        // Abort transaction.
	        transaction.unwatcher();
	        transaction.currentOutputSnapshotRaw = null;
	        transaction.currentOutputSnapshotResolved = null;
	        if (transaction.onComplete) {
	            // We just set the input snapshot, so this cast should be safe
	            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference(this, transaction.path), PRIORITY_INDEX);
	            transaction.onComplete(null, false, snapshot);
	        }
	    }
	    else {
	        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
	        // Mark as run and add to our queue.
	        transaction.status = TransactionStatus.RUN;
	        var queueNode = this.transactionQueueTree_.subTree(path);
	        var nodeQueue = queueNode.getValue() || [];
	        nodeQueue.push(transaction);
	        queueNode.setValue(nodeQueue);
	        // Update visibleData and raise events
	        // Note: We intentionally raise events after updating all of our transaction state, since the user could
	        // start new transactions from the event callbacks.
	        var priorityForNode = void 0;
	        if (typeof newVal === 'object' &&
	            newVal !== null &&
	            util.contains(newVal, '.priority')) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            priorityForNode = util.safeGet(newVal, '.priority');
	            util.assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
	                'Priority must be a valid string, finite number, server value, or null.');
	        }
	        else {
	            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
	                ChildrenNode.EMPTY_NODE;
	            priorityForNode = currentNode.getPriority().val();
	        }
	        priorityForNode /** @type {null|number|string} */ = priorityForNode;
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
	        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
	        transaction.currentOutputSnapshotResolved = newNode;
	        transaction.currentWriteId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        this.sendReadyTransactions_();
	    }
	};
	/**
	 * @param {!Path} path
	 * @param {Array.<number>=} excludeSets A specific set to exclude
	 * @return {Node}
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.getLatestState_ = function (path, excludeSets) {
	    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
	        ChildrenNode.EMPTY_NODE);
	};
	/**
	 * Sends any already-run transactions that aren't waiting for outstanding transactions to
	 * complete.
	 *
	 * Externally it's called with no arguments, but it calls itself recursively with a particular
	 * transactionQueueTree node to recurse through the tree.
	 *
	 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.sendReadyTransactions_ = function (node) {
	    var _this = this;
	    if (node === void 0) { node = this.transactionQueueTree_; }
	    // Before recursing, make sure any completed transactions are removed.
	    if (!node) {
	        this.pruneCompletedTransactionsBelowNode_(node);
	    }
	    if (node.getValue() !== null) {
	        var queue = this.buildTransactionQueue_(node);
	        util.assert(queue.length > 0, 'Sending zero length transaction queue');
	        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
	        // If they're all run (and not sent), we can send them.  Else, we must wait.
	        if (allRun) {
	            this.sendTransactionQueue_(node.path(), queue);
	        }
	    }
	    else if (node.hasChildren()) {
	        node.forEachChild(function (childNode) {
	            _this.sendReadyTransactions_(childNode);
	        });
	    }
	};
	/**
	 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
	 *
	 * @param {!Path} path The location of the queue.
	 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.sendTransactionQueue_ = function (path, queue) {
	    var _this = this;
	    // Mark transactions as sent and increment retry count!
	    var setsToIgnore = queue.map(function (txn) {
	        return txn.currentWriteId;
	    });
	    var latestState = this.getLatestState_(path, setsToIgnore);
	    var snapToSend = latestState;
	    var latestHash = latestState.hash();
	    for (var i = 0; i < queue.length; i++) {
	        var txn = queue[i];
	        util.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
	        txn.status = TransactionStatus.SENT;
	        txn.retryCount++;
	        var relativePath = Path.relativePath(path, txn.path);
	        // If we've gotten to this point, the output snapshot must be defined.
	        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */, txn.currentOutputSnapshotRaw);
	    }
	    var dataToSend = snapToSend.val(true);
	    var pathToSend = path;
	    // Send the put.
	    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
	        _this.log_('transaction put response', {
	            path: pathToSend.toString(),
	            status: status
	        });
	        var events = [];
	        if (status === 'ok') {
	            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	            // the callback could trigger more transactions or sets.
	            var callbacks = [];
	            for (var i = 0; i < queue.length; i++) {
	                queue[i].status = TransactionStatus.COMPLETED;
	                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
	                if (queue[i].onComplete) {
	                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
	                    var node = queue[i].currentOutputSnapshotResolved;
	                    var ref = new Reference(_this, queue[i].path);
	                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
	                }
	                queue[i].unwatcher();
	            }
	            // Now remove the completed transactions.
	            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
	            // There may be pending transactions that we can now send.
	            _this.sendReadyTransactions_();
	            _this.eventQueue_.raiseEventsForChangedPath(path, events);
	            // Finally, trigger onComplete callbacks.
	            for (var i = 0; i < callbacks.length; i++) {
	                exceptionGuard(callbacks[i]);
	            }
	        }
	        else {
	            // transactions are no longer sent.  Update their status appropriately.
	            if (status === 'datastale') {
	                for (var i = 0; i < queue.length; i++) {
	                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
	                        queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    }
	                    else {
	                        queue[i].status = TransactionStatus.RUN;
	                    }
	                }
	            }
	            else {
	                warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
	                for (var i = 0; i < queue.length; i++) {
	                    queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    queue[i].abortReason = status;
	                }
	            }
	            _this.rerunTransactions_(path);
	        }
	    }, latestHash);
	};
	/**
	 * Finds all transactions dependent on the data at changedPath and reruns them.
	 *
	 * Should be called any time cached data changes.
	 *
	 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
	 * be raised for.
	 *
	 * @param {!Path} changedPath The path in mergedData that changed.
	 * @return {!Path} The rootmost path that was affected by rerunning transactions.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.rerunTransactions_ = function (changedPath) {
	    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
	    var path = rootMostTransactionNode.path();
	    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
	    this.rerunTransactionQueue_(queue, path);
	    return path;
	};
	/**
	 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
	 *
	 * @param {Array.<Transaction>} queue The queue of transactions to run.
	 * @param {!Path} path The path the queue is for.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
	    if (queue.length === 0) {
	        return; // Nothing to do!
	    }
	    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	    // the callback could trigger more transactions or sets.
	    var callbacks = [];
	    var events = [];
	    // Ignore all of the sets we're going to re-run.
	    var txnsToRerun = queue.filter(function (q) {
	        return q.status === TransactionStatus.RUN;
	    });
	    var setsToIgnore = txnsToRerun.map(function (q) {
	        return q.currentWriteId;
	    });
	    for (var i = 0; i < queue.length; i++) {
	        var transaction = queue[i];
	        var relativePath = Path.relativePath(path, transaction.path);
	        var abortTransaction = false, abortReason = void 0;
	        util.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
	        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
	            abortTransaction = true;
	            abortReason = transaction.abortReason;
	            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	        }
	        else if (transaction.status === TransactionStatus.RUN) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
	                abortTransaction = true;
	                abortReason = 'maxretry';
	                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	            }
	            else {
	                // This code reruns a transaction
	                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
	                transaction.currentInputSnapshot = currentNode;
	                var newData = queue[i].update(currentNode.val());
	                if (newData !== undefined) {
	                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
	                    var newDataNode = nodeFromJSON$1(newData);
	                    var hasExplicitPriority = typeof newData === 'object' &&
	                        newData != null &&
	                        util.contains(newData, '.priority');
	                    if (!hasExplicitPriority) {
	                        // Keep the old priority if there wasn't a priority explicitly specified.
	                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
	                    }
	                    var oldWriteId = transaction.currentWriteId;
	                    var serverValues = this.generateServerValues();
	                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, serverValues);
	                    transaction.currentOutputSnapshotRaw = newDataNode;
	                    transaction.currentOutputSnapshotResolved = newNodeResolved;
	                    transaction.currentWriteId = this.getNextWriteId_();
	                    // Mutates setsToIgnore in place
	                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
	                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
	                }
	                else {
	                    abortTransaction = true;
	                    abortReason = 'nodata';
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	                }
	            }
	        }
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        events = [];
	        if (abortTransaction) {
	            // Abort.
	            queue[i].status = TransactionStatus.COMPLETED;
	            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
	            // So defer the unwatcher until we're done.
	            (function (unwatcher) {
	                setTimeout(unwatcher, Math.floor(0));
	            })(queue[i].unwatcher);
	            if (queue[i].onComplete) {
	                if (abortReason === 'nodata') {
	                    var ref = new Reference(this, queue[i].path);
	                    // We set this field immediately, so it's safe to cast to an actual snapshot
	                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
	                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
	                }
	                else {
	                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
	                }
	            }
	        }
	    }
	    // Clean up completed transactions.
	    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
	    // Now fire callbacks, now that we're in a good, known state.
	    for (var i = 0; i < callbacks.length; i++) {
	        exceptionGuard(callbacks[i]);
	    }
	    // Try to send the transaction result to the server.
	    this.sendReadyTransactions_();
	};
	/**
	 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
	 * the node for the given path if there are no pending transactions on any ancestor.
	 *
	 * @param {!Path} path The location to start at.
	 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.getAncestorTransactionNode_ = function (path) {
	    var front;
	    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
	    var transactionNode = this.transactionQueueTree_;
	    front = path.getFront();
	    while (front !== null && transactionNode.getValue() === null) {
	        transactionNode = transactionNode.subTree(front);
	        path = path.popFront();
	        front = path.getFront();
	    }
	    return transactionNode;
	};
	/**
	 * Builds the queue of all transactions at or below the specified transactionNode.
	 *
	 * @param {!Tree.<Array.<Transaction>>} transactionNode
	 * @return {Array.<Transaction>} The generated queue.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
	    // Walk any child transaction queues and aggregate them into a single queue.
	    var transactionQueue = [];
	    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
	    // Sort them by the order the transactions were created.
	    transactionQueue.sort(function (a, b) {
	        return a.order - b.order;
	    });
	    return transactionQueue;
	};
	/**
	 * @param {!Tree.<Array.<Transaction>>} node
	 * @param {Array.<Transaction>} queue
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
	    var _this = this;
	    var nodeQueue = node.getValue();
	    if (nodeQueue !== null) {
	        for (var i = 0; i < nodeQueue.length; i++) {
	            queue.push(nodeQueue[i]);
	        }
	    }
	    node.forEachChild(function (child) {
	        _this.aggregateTransactionQueuesForNode_(child, queue);
	    });
	};
	/**
	 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
	 *
	 * @param {!Tree.<Array.<!Transaction>>} node
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
	    var _this = this;
	    var queue = node.getValue();
	    if (queue) {
	        var to = 0;
	        for (var from = 0; from < queue.length; from++) {
	            if (queue[from].status !== TransactionStatus.COMPLETED) {
	                queue[to] = queue[from];
	                to++;
	            }
	        }
	        queue.length = to;
	        node.setValue(queue.length > 0 ? queue : null);
	    }
	    node.forEachChild(function (childNode) {
	        _this.pruneCompletedTransactionsBelowNode_(childNode);
	    });
	};
	/**
	 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
	 * since we consider them incompatible with transactions.
	 *
	 * @param {!Path} path Path for which we want to abort related transactions.
	 * @return {!Path}
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.abortTransactions_ = function (path) {
	    var _this = this;
	    var affectedPath = this.getAncestorTransactionNode_(path).path();
	    var transactionNode = this.transactionQueueTree_.subTree(path);
	    transactionNode.forEachAncestor(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    this.abortTransactionsOnNode_(transactionNode);
	    transactionNode.forEachDescendant(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    return affectedPath;
	};
	/**
	 * Abort transactions stored in this transaction queue node.
	 *
	 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.abortTransactionsOnNode_ = function (node) {
	    var queue = node.getValue();
	    if (queue !== null) {
	        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	        // the callback could trigger more transactions or sets.
	        var callbacks = [];
	        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
	        // can be immediately aborted and removed.
	        var events = [];
	        var lastSent = -1;
	        for (var i = 0; i < queue.length; i++) {
	            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) ;
	            else if (queue[i].status === TransactionStatus.SENT) {
	                util.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
	                lastSent = i;
	                // Mark transaction for abort when it comes back.
	                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
	                queue[i].abortReason = 'set';
	            }
	            else {
	                util.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
	                // We can abort it immediately.
	                queue[i].unwatcher();
	                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
	                if (queue[i].onComplete) {
	                    var snapshot = null;
	                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
	                }
	            }
	        }
	        if (lastSent === -1) {
	            // We're not waiting for any sent transactions.  We can clear the queue.
	            node.setValue(null);
	        }
	        else {
	            // Remove the transactions we aborted.
	            queue.length = lastSent + 1;
	        }
	        // Now fire the callbacks.
	        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
	        for (var i = 0; i < callbacks.length; i++) {
	            exceptionGuard(callbacks[i]);
	        }
	    }
	};
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** @const {string} */
	var DATABASE_URL_OPTION = 'databaseURL';
	/**
	 * This variable is also defined in the firebase node.js admin SDK. Before
	 * modifying this definition, consult the definition in:
	 *
	 * https://github.com/firebase/firebase-admin-node
	 *
	 * and make sure the two are consistent.
	 */
	var FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
	var _staticInstance;
	/**
	 * Creates and caches Repo instances.
	 */
	var RepoManager = /** @class */ (function () {
	    function RepoManager() {
	        /**
	         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
	         */
	        this.repos_ = {};
	        /**
	         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
	         * @private {boolean}
	         */
	        this.useRestClient_ = false;
	    }
	    RepoManager.getInstance = function () {
	        if (!_staticInstance) {
	            _staticInstance = new RepoManager();
	        }
	        return _staticInstance;
	    };
	    // TODO(koss): Remove these functions unless used in tests?
	    RepoManager.prototype.interrupt = function () {
	        var e_1, _a, e_2, _b;
	        try {
	            for (var _c = tslib.__values(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var appName = _d.value;
	                try {
	                    for (var _e = (e_2 = void 0, tslib.__values(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var dbUrl = _f.value;
	                        this.repos_[appName][dbUrl].interrupt();
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    RepoManager.prototype.resume = function () {
	        var e_3, _a, e_4, _b;
	        try {
	            for (var _c = tslib.__values(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var appName = _d.value;
	                try {
	                    for (var _e = (e_4 = void 0, tslib.__values(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var dbUrl = _f.value;
	                        this.repos_[appName][dbUrl].resume();
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	    };
	    /**
	     * This function should only ever be called to CREATE a new database instance.
	     *
	     * @param {!FirebaseApp} app
	     * @return {!Database}
	     */
	    RepoManager.prototype.databaseFromApp = function (app, authProvider, url) {
	        var dbUrl = url || app.options[DATABASE_URL_OPTION];
	        if (dbUrl === undefined) {
	            fatal("Can't determine Firebase Database URL.  Be sure to include " +
	                DATABASE_URL_OPTION +
	                ' option when calling firebase.initializeApp().');
	        }
	        var parsedUrl = parseRepoInfo(dbUrl);
	        var repoInfo = parsedUrl.repoInfo;
	        var dbEmulatorHost = undefined;
	        if (typeof process !== 'undefined') {
	            dbEmulatorHost = ({"NODE_ENV":"production","PUBLIC_URL":""})[FIREBASE_DATABASE_EMULATOR_HOST_VAR];
	        }
	        if (dbEmulatorHost) {
	            dbUrl = "http://" + dbEmulatorHost + "?ns=" + repoInfo.namespace;
	            parsedUrl = parseRepoInfo(dbUrl);
	            repoInfo = parsedUrl.repoInfo;
	        }
	        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
	        if (!parsedUrl.path.isEmpty()) {
	            fatal('Database URL must point to the root of a Firebase Database ' +
	                '(not including a child path).');
	        }
	        var repo = this.createRepo(repoInfo, app, authProvider);
	        return repo.database;
	    };
	    /**
	     * Remove the repo and make sure it is disconnected.
	     *
	     * @param {!Repo} repo
	     */
	    RepoManager.prototype.deleteRepo = function (repo) {
	        var appRepos = util.safeGet(this.repos_, repo.app.name);
	        // This should never happen...
	        if (!appRepos || util.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
	            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
	        }
	        repo.interrupt();
	        delete appRepos[repo.repoInfo_.toURLString()];
	    };
	    /**
	     * Ensures a repo doesn't already exist and then creates one using the
	     * provided app.
	     *
	     * @param {!RepoInfo} repoInfo The metadata about the Repo
	     * @param {!FirebaseApp} app
	     * @return {!Repo} The Repo object for the specified server / repoName.
	     */
	    RepoManager.prototype.createRepo = function (repoInfo, app, authProvider) {
	        var appRepos = util.safeGet(this.repos_, app.name);
	        if (!appRepos) {
	            appRepos = {};
	            this.repos_[app.name] = appRepos;
	        }
	        var repo = util.safeGet(appRepos, repoInfo.toURLString());
	        if (repo) {
	            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
	        }
	        repo = new Repo(repoInfo, this.useRestClient_, app, authProvider);
	        appRepos[repoInfo.toURLString()] = repo;
	        return repo;
	    };
	    /**
	     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
	     * @param {boolean} forceRestClient
	     */
	    RepoManager.prototype.forceRestClient = function (forceRestClient) {
	        this.useRestClient_ = forceRestClient;
	    };
	    return RepoManager;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Class representing a firebase database.
	 * @implements {FirebaseService}
	 */
	var Database = /** @class */ (function () {
	    /**
	     * The constructor should not be called by users of our public API.
	     * @param {!Repo} repo_
	     */
	    function Database(repo_) {
	        this.repo_ = repo_;
	        if (!(repo_ instanceof Repo)) {
	            fatal("Don't call new Database() directly - please use firebase.database().");
	        }
	        /** @type {Reference} */
	        this.root_ = new Reference(repo_, Path.Empty);
	        this.INTERNAL = new DatabaseInternals(this);
	    }
	    Object.defineProperty(Database.prototype, "app", {
	        get: function () {
	            return this.repo_.app;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Database.prototype.ref = function (path) {
	        this.checkDeleted_('ref');
	        util.validateArgCount('database.ref', 0, 1, arguments.length);
	        if (path instanceof Reference) {
	            return this.refFromURL(path.toString());
	        }
	        return path !== undefined ? this.root_.child(path) : this.root_;
	    };
	    /**
	     * Returns a reference to the root or the path specified in url.
	     * We throw a exception if the url is not in the same domain as the
	     * current repo.
	     * @param {string} url
	     * @return {!Reference} Firebase reference.
	     */
	    Database.prototype.refFromURL = function (url) {
	        /** @const {string} */
	        var apiName = 'database.refFromURL';
	        this.checkDeleted_(apiName);
	        util.validateArgCount(apiName, 1, 1, arguments.length);
	        var parsedURL = parseRepoInfo(url);
	        validateUrl(apiName, 1, parsedURL);
	        var repoInfo = parsedURL.repoInfo;
	        if (repoInfo.host !== this.repo_.repoInfo_.host) {
	            fatal(apiName +
	                ': Host name does not match the current database: ' +
	                '(found ' +
	                repoInfo.host +
	                ' but expected ' +
	                this.repo_.repoInfo_.host +
	                ')');
	        }
	        return this.ref(parsedURL.path.toString());
	    };
	    /**
	     * @param {string} apiName
	     */
	    Database.prototype.checkDeleted_ = function (apiName) {
	        if (this.repo_ === null) {
	            fatal('Cannot call ' + apiName + ' on a deleted database.');
	        }
	    };
	    // Make individual repo go offline.
	    Database.prototype.goOffline = function () {
	        util.validateArgCount('database.goOffline', 0, 0, arguments.length);
	        this.checkDeleted_('goOffline');
	        this.repo_.interrupt();
	    };
	    Database.prototype.goOnline = function () {
	        util.validateArgCount('database.goOnline', 0, 0, arguments.length);
	        this.checkDeleted_('goOnline');
	        this.repo_.resume();
	    };
	    Database.ServerValue = {
	        TIMESTAMP: {
	            '.sv': 'timestamp'
	        }
	    };
	    return Database;
	}());
	var DatabaseInternals = /** @class */ (function () {
	    /** @param {!Database} database */
	    function DatabaseInternals(database) {
	        this.database = database;
	    }
	    /** @return {Promise<void>} */
	    DatabaseInternals.prototype.delete = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                this.database.checkDeleted_('delete');
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                RepoManager.getInstance().deleteRepo(this.database.repo_);
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                this.database.repo_ = null;
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                this.database.root_ = null;
	                this.database.INTERNAL = null;
	                this.database = null;
	                return [2 /*return*/];
	            });
	        });
	    };
	    return DatabaseInternals;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * INTERNAL methods for internal-use only (tests, etc.).
	 *
	 * Customers shouldn't use these or else should be aware that they could break at any time.
	 *
	 * @const
	 */
	var forceLongPolling = function () {
	    WebSocketConnection.forceDisallow();
	    BrowserPollConnection.forceAllow();
	};
	var forceWebSockets = function () {
	    BrowserPollConnection.forceDisallow();
	};
	/* Used by App Manager */
	var isWebSocketsAvailable = function () {
	    return WebSocketConnection['isAvailable']();
	};
	var setSecurityDebugCallback = function (ref, callback) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
	};
	var stats = function (ref, showDelta) {
	    ref.repo.stats(showDelta);
	};
	var statsIncrementCounter = function (ref, metric) {
	    ref.repo.statsIncrementCounter(metric);
	};
	var dataUpdateCount = function (ref) {
	    return ref.repo.dataUpdateCount;
	};
	var interceptServerData = function (ref, callback) {
	    return ref.repo.interceptServerData_(callback);
	};
	
	var INTERNAL = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  forceLongPolling: forceLongPolling,
	  forceWebSockets: forceWebSockets,
	  isWebSocketsAvailable: isWebSocketsAvailable,
	  setSecurityDebugCallback: setSecurityDebugCallback,
	  stats: stats,
	  statsIncrementCounter: statsIncrementCounter,
	  dataUpdateCount: dataUpdateCount,
	  interceptServerData: interceptServerData
	});
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DataConnection = PersistentConnection;
	/**
	 * @param {!string} pathString
	 * @param {function(*)} onComplete
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
	    this.sendRequest('q', { p: pathString }, onComplete);
	};
	/**
	 * @param {*} data
	 * @param {function(*)} onEcho
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	PersistentConnection.prototype.echo = function (data, onEcho) {
	    this.sendRequest('echo', { d: data }, onEcho);
	};
	// RealTimeConnection properties that we use in tests.
	var RealTimeConnection = Connection;
	/**
	 * @param {function(): string} newHash
	 * @return {function()}
	 */
	var hijackHash = function (newHash) {
	    var oldPut = PersistentConnection.prototype.put;
	    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
	        if (hash !== undefined) {
	            hash = newHash();
	        }
	        oldPut.call(this, pathString, data, onComplete, hash);
	    };
	    return function () {
	        PersistentConnection.prototype.put = oldPut;
	    };
	};
	/**
	 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
	 */
	var ConnectionTarget = RepoInfo;
	/**
	 * @param {!Query} query
	 * @return {!string}
	 */
	var queryIdentifier = function (query) {
	    return query.queryIdentifier();
	};
	/**
	 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
	 *
	 * @param {boolean} forceRestClient
	 */
	var forceRestClient = function (forceRestClient) {
	    RepoManager.getInstance().forceRestClient(forceRestClient);
	};
	
	var TEST_ACCESS = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  DataConnection: DataConnection,
	  RealTimeConnection: RealTimeConnection,
	  hijackHash: hijackHash,
	  ConnectionTarget: ConnectionTarget,
	  queryIdentifier: queryIdentifier,
	  forceRestClient: forceRestClient
	});
	
	var name = "@firebase/database";
	var version = "0.5.21";
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ServerValue = Database.ServerValue;
	function registerDatabase(instance) {
	    // set SDK_VERSION
	    setSDKVersion(instance.SDK_VERSION);
	    // Register the Database Service with the 'firebase' namespace.
	    var namespace = instance.INTERNAL.registerComponent(new component.Component('database', function (container, url) {
	        /* Dependencies */
	        // getImmediate for FirebaseApp will always succeed
	        var app = container.getProvider('app').getImmediate();
	        var authProvider = container.getProvider('auth-internal');
	        return RepoManager.getInstance().databaseFromApp(app, authProvider, url);
	    }, "PUBLIC" /* PUBLIC */)
	        .setServiceProps(
	    // firebase.database namespace properties
	    {
	        Reference: Reference,
	        Query: Query,
	        Database: Database,
	        DataSnapshot: DataSnapshot,
	        enableLogging: enableLogging,
	        INTERNAL: INTERNAL,
	        ServerValue: ServerValue,
	        TEST_ACCESS: TEST_ACCESS
	    })
	        .setMultipleInstances(true));
	    instance.registerVersion(name, version);
	    if (util.isNodeSdk()) {
	        module.exports = namespace;
	    }
	}
	registerDatabase(firebase);
	
	exports.DataSnapshot = DataSnapshot;
	exports.Database = Database;
	exports.OnDisconnect = OnDisconnect;
	exports.Query = Query;
	exports.Reference = Reference;
	exports.ServerValue = ServerValue;
	exports.enableLogging = enableLogging;
	exports.registerDatabase = registerDatabase;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	var tslib = __webpack_require__(11);
	var logger = __webpack_require__(20);
	var util = __webpack_require__(14);
	var component = __webpack_require__(12);
	var webchannelWrapper = __webpack_require__(104);
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** The semver (www.semver.org) version of the SDK. */
	var SDK_VERSION = firebase.SDK_VERSION;
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var logClient = new logger.Logger('@firebase/firestore');
	var LogLevel;
	(function (LogLevel) {
	    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
	    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
	    LogLevel[LogLevel["SILENT"] = 2] = "SILENT";
	})(LogLevel || (LogLevel = {}));
	// Helper methods are needed because variables can't be exported as read/write
	function getLogLevel() {
	    if (logClient.logLevel === logger.LogLevel.DEBUG) {
	        return LogLevel.DEBUG;
	    }
	    else if (logClient.logLevel === logger.LogLevel.SILENT) {
	        return LogLevel.SILENT;
	    }
	    else {
	        return LogLevel.ERROR;
	    }
	}
	function setLogLevel(newLevel) {
	    /**
	     * Map the new log level to the associated Firebase Log Level
	     */
	    switch (newLevel) {
	        case LogLevel.DEBUG:
	            logClient.logLevel = logger.LogLevel.DEBUG;
	            break;
	        case LogLevel.ERROR:
	            logClient.logLevel = logger.LogLevel.ERROR;
	            break;
	        case LogLevel.SILENT:
	            logClient.logLevel = logger.LogLevel.SILENT;
	            break;
	        default:
	            logClient.error("Firestore (" + SDK_VERSION + "): Invalid value passed to `setLogLevel`");
	    }
	}
	function debug(tag, msg) {
	    var obj = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        obj[_i - 2] = arguments[_i];
	    }
	    if (logClient.logLevel <= logger.LogLevel.DEBUG) {
	        var args = obj.map(argToString);
	        logClient.debug.apply(logClient, tslib.__spreadArrays(["Firestore (" + SDK_VERSION + ") [" + tag + "]: " + msg], args));
	    }
	}
	function error(msg) {
	    var obj = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        obj[_i - 1] = arguments[_i];
	    }
	    if (logClient.logLevel <= logger.LogLevel.ERROR) {
	        var args = obj.map(argToString);
	        logClient.error.apply(logClient, tslib.__spreadArrays(["Firestore (" + SDK_VERSION + "): " + msg], args));
	    }
	}
	/**
	 * Converts an additional log parameter to a string representation.
	 */
	function argToString(obj) {
	    if (typeof obj === 'string') {
	        return obj;
	    }
	    else {
	        var platform = PlatformSupport.getPlatform();
	        try {
	            return platform.formatJSON(obj);
	        }
	        catch (e) {
	            // Converting to JSON failed, just log the object directly
	            return obj;
	        }
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Unconditionally fails, throwing an Error with the given message.
	 *
	 * Returns any so it can be used in expressions:
	 * @example
	 * let futureVar = fail('not implemented yet');
	 */
	function fail(failure) {
	    // Log the failure in addition to throw an exception, just in case the
	    // exception is swallowed.
	    var message = "FIRESTORE (" + SDK_VERSION + ") INTERNAL ASSERTION FAILED: " + failure;
	    error(message);
	    // NOTE: We don't use FirestoreError here because these are internal failures
	    // that cannot be handled by the user. (Also it would create a circular
	    // dependency between the error and assert modules which doesn't work.)
	    throw new Error(message);
	}
	/**
	 * Fails if the given assertion condition is false, throwing an Error with the
	 * given message if it did.
	 */
	function assert(assertion, message) {
	    if (!assertion) {
	        fail(message);
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides singleton helpers where setup code can inject a platform at runtime.
	 * setPlatform needs to be set before Firestore is used and must be set exactly
	 * once.
	 */
	var PlatformSupport = /** @class */ (function () {
	    function PlatformSupport() {
	    }
	    PlatformSupport.setPlatform = function (platform) {
	        if (PlatformSupport.platform) {
	            fail('Platform already defined');
	        }
	        PlatformSupport.platform = platform;
	    };
	    PlatformSupport.getPlatform = function () {
	        if (!PlatformSupport.platform) {
	            fail('Platform not set');
	        }
	        return PlatformSupport.platform;
	    };
	    return PlatformSupport;
	}());
	/**
	 * Returns the representation of an empty "proto" byte string for the
	 * platform.
	 */
	function emptyByteString() {
	    return PlatformSupport.getPlatform().emptyByteString;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Code = {
	    // Causes are copied from:
	    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
	    /** Not an error; returned on success. */
	    OK: 'ok',
	    /** The operation was cancelled (typically by the caller). */
	    CANCELLED: 'cancelled',
	    /** Unknown error or an error from a different error domain. */
	    UNKNOWN: 'unknown',
	    /**
	     * Client specified an invalid argument. Note that this differs from
	     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
	     * problematic regardless of the state of the system (e.g., a malformed file
	     * name).
	     */
	    INVALID_ARGUMENT: 'invalid-argument',
	    /**
	     * Deadline expired before operation could complete. For operations that
	     * change the state of the system, this error may be returned even if the
	     * operation has completed successfully. For example, a successful response
	     * from a server could have been delayed long enough for the deadline to
	     * expire.
	     */
	    DEADLINE_EXCEEDED: 'deadline-exceeded',
	    /** Some requested entity (e.g., file or directory) was not found. */
	    NOT_FOUND: 'not-found',
	    /**
	     * Some entity that we attempted to create (e.g., file or directory) already
	     * exists.
	     */
	    ALREADY_EXISTS: 'already-exists',
	    /**
	     * The caller does not have permission to execute the specified operation.
	     * PERMISSION_DENIED must not be used for rejections caused by exhausting
	     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
	     * PERMISSION_DENIED must not be used if the caller can not be identified
	     * (use UNAUTHENTICATED instead for those errors).
	     */
	    PERMISSION_DENIED: 'permission-denied',
	    /**
	     * The request does not have valid authentication credentials for the
	     * operation.
	     */
	    UNAUTHENTICATED: 'unauthenticated',
	    /**
	     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
	     * entire file system is out of space.
	     */
	    RESOURCE_EXHAUSTED: 'resource-exhausted',
	    /**
	     * Operation was rejected because the system is not in a state required for
	     * the operation's execution. For example, directory to be deleted may be
	     * non-empty, an rmdir operation is applied to a non-directory, etc.
	     *
	     * A litmus test that may help a service implementor in deciding
	     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
	     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
	     *  (b) Use ABORTED if the client should retry at a higher-level
	     *      (e.g., restarting a read-modify-write sequence).
	     *  (c) Use FAILED_PRECONDITION if the client should not retry until
	     *      the system state has been explicitly fixed. E.g., if an "rmdir"
	     *      fails because the directory is non-empty, FAILED_PRECONDITION
	     *      should be returned since the client should not retry unless
	     *      they have first fixed up the directory by deleting files from it.
	     *  (d) Use FAILED_PRECONDITION if the client performs conditional
	     *      REST Get/Update/Delete on a resource and the resource on the
	     *      server does not match the condition. E.g., conflicting
	     *      read-modify-write on the same resource.
	     */
	    FAILED_PRECONDITION: 'failed-precondition',
	    /**
	     * The operation was aborted, typically due to a concurrency issue like
	     * sequencer check failures, transaction aborts, etc.
	     *
	     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
	     * and UNAVAILABLE.
	     */
	    ABORTED: 'aborted',
	    /**
	     * Operation was attempted past the valid range. E.g., seeking or reading
	     * past end of file.
	     *
	     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
	     * if the system state changes. For example, a 32-bit file system will
	     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
	     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
	     * an offset past the current file size.
	     *
	     * There is a fair bit of overlap between FAILED_PRECONDITION and
	     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
	     * when it applies so that callers who are iterating through a space can
	     * easily look for an OUT_OF_RANGE error to detect when they are done.
	     */
	    OUT_OF_RANGE: 'out-of-range',
	    /** Operation is not implemented or not supported/enabled in this service. */
	    UNIMPLEMENTED: 'unimplemented',
	    /**
	     * Internal errors. Means some invariants expected by underlying System has
	     * been broken. If you see one of these errors, Something is very broken.
	     */
	    INTERNAL: 'internal',
	    /**
	     * The service is currently unavailable. This is a most likely a transient
	     * condition and may be corrected by retrying with a backoff.
	     *
	     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
	     * and UNAVAILABLE.
	     */
	    UNAVAILABLE: 'unavailable',
	    /** Unrecoverable data loss or corruption. */
	    DATA_LOSS: 'data-loss'
	};
	/**
	 * An error class used for Firestore-generated errors. Ideally we should be
	 * using FirebaseError, but integrating with it is overly arduous at the moment,
	 * so we define our own compatible error class (with a `name` of 'FirebaseError'
	 * and compatible `code` and `message` fields.)
	 */
	var FirestoreError = /** @class */ (function (_super) {
	    tslib.__extends(FirestoreError, _super);
	    function FirestoreError(code, message) {
	        var _this = _super.call(this, message) || this;
	        _this.code = code;
	        _this.message = message;
	        _this.name = 'FirebaseError';
	        // HACK: We write a toString property directly because Error is not a real
	        // class and so inheritance does not work correctly. We could alternatively
	        // do the same "back-door inheritance" trick that FirebaseError does.
	        _this.toString = function () { return _this.name + ": [code=" + _this.code + "]: " + _this.message; };
	        return _this;
	    }
	    return FirestoreError;
	}(Error));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper function to prevent instantiation through the constructor.
	 *
	 * This method creates a new constructor that throws when it's invoked.
	 * The prototype of that constructor is then set to the prototype of the hidden
	 * "class" to expose all the prototype methods and allow for instanceof
	 * checks.
	 *
	 * To also make all the static methods available, all properties of the
	 * original constructor are copied to the new constructor.
	 */
	function makeConstructorPrivate(cls, optionalMessage) {
	    function PublicConstructor() {
	        var error = 'This constructor is private.';
	        if (optionalMessage) {
	            error += ' ';
	            error += optionalMessage;
	        }
	        throw new FirestoreError(Code.INVALID_ARGUMENT, error);
	    }
	    // Make sure instanceof checks work and all methods are exposed on the public
	    // constructor
	    PublicConstructor.prototype = cls.prototype;
	    // Copy any static methods/members
	    for (var staticProperty in cls) {
	        if (cls.hasOwnProperty(staticProperty)) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            PublicConstructor[staticProperty] = cls[staticProperty];
	        }
	    }
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return PublicConstructor;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function contains(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	/** Returns the given value if it's defined or the defaultValue otherwise. */
	function defaulted(value, defaultValue) {
	    return value !== undefined ? value : defaultValue;
	}
	function forEachNumber(obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            var num = Number(key);
	            if (!isNaN(num)) {
	                fn(num, obj[key]);
	            }
	        }
	    }
	}
	function values(obj) {
	    var vs = [];
	    forEach(obj, function (_, v) { return vs.push(v); });
	    return vs;
	}
	function forEach(obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            fn(key, obj[key]);
	        }
	    }
	}
	function isEmpty(obj) {
	    assert(obj != null && typeof obj === 'object', 'isEmpty() expects object parameter.');
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            return false;
	        }
	    }
	    return true;
	}
	function shallowCopy(obj) {
	    assert(obj && typeof obj === 'object', 'shallowCopy() expects object parameter.');
	    var result = {};
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            result[key] = obj[key];
	        }
	    }
	    return result;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Validates that no arguments were passed in the invocation of functionName.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateNoArgs('myFunction', arguments);
	 */
	function validateNoArgs(functionName, args) {
	    if (args.length !== 0) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() does not support arguments, " +
	            'but was called with ' +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	/**
	 * Validates the invocation of functionName has the exact number of arguments.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateExactNumberOfArgs('myFunction', arguments, 2);
	 */
	function validateExactNumberOfArgs(functionName, args, numberOfArgs) {
	    if (args.length !== numberOfArgs) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires " +
	            formatPlural(numberOfArgs, 'argument') +
	            ', but was called with ' +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	/**
	 * Validates the invocation of functionName has at least the provided number of
	 * arguments (but can have many more).
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
	 */
	function validateAtLeastNumberOfArgs(functionName, args, minNumberOfArgs) {
	    if (args.length < minNumberOfArgs) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires at least " +
	            formatPlural(minNumberOfArgs, 'argument') +
	            ', but was called with ' +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	/**
	 * Validates the invocation of functionName has number of arguments between
	 * the values provided.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
	 */
	function validateBetweenNumberOfArgs(functionName, args, minNumberOfArgs, maxNumberOfArgs) {
	    if (args.length < minNumberOfArgs || args.length > maxNumberOfArgs) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires between " + minNumberOfArgs + " and " +
	            (maxNumberOfArgs + " arguments, but was called with ") +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	/**
	 * Validates the provided argument is an array and has as least the expected
	 * number of elements.
	 */
	function validateNamedArrayAtLeastNumberOfElements(functionName, value, name, minNumberOfElements) {
	    if (!(value instanceof Array) || value.length < minNumberOfElements) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + name + " argument to be an " +
	            'array with at least ' +
	            (formatPlural(minNumberOfElements, 'element') + "."));
	    }
	}
	/**
	 * Validates the provided positional argument has the native JavaScript type
	 * using typeof checks.
	 */
	function validateArgType(functionName, type, position, argument) {
	    validateType(functionName, type, ordinal(position) + " argument", argument);
	}
	/**
	 * Validates the provided argument has the native JavaScript type using
	 * typeof checks or is undefined.
	 */
	function validateOptionalArgType(functionName, type, position, argument) {
	    if (argument !== undefined) {
	        validateArgType(functionName, type, position, argument);
	    }
	}
	/**
	 * Validates the provided named option has the native JavaScript type using
	 * typeof checks.
	 */
	function validateNamedType(functionName, type, optionName, argument) {
	    validateType(functionName, type, optionName + " option", argument);
	}
	/**
	 * Validates the provided named option has the native JavaScript type using
	 * typeof checks or is undefined.
	 */
	function validateNamedOptionalType(functionName, type, optionName, argument) {
	    if (argument !== undefined) {
	        validateNamedType(functionName, type, optionName, argument);
	    }
	}
	function validateArrayElements(functionName, optionName, typeDescription, argument, validator) {
	    if (!(argument instanceof Array)) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + optionName + " " +
	            ("option to be an array, but it was: " + valueDescription(argument)));
	    }
	    for (var i = 0; i < argument.length; ++i) {
	        if (!validator(argument[i])) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires all " + optionName + " " +
	                ("elements to be " + typeDescription + ", but the value at index " + i + " ") +
	                ("was: " + valueDescription(argument[i])));
	        }
	    }
	}
	function validateOptionalArrayElements(functionName, optionName, typeDescription, argument, validator) {
	    if (argument !== undefined) {
	        validateArrayElements(functionName, optionName, typeDescription, argument, validator);
	    }
	}
	/**
	 * Validates that the provided named option equals one of the expected values.
	 */
	function validateNamedPropertyEquals(functionName, inputName, optionName, input, expected) {
	    var expectedDescription = [];
	    for (var _i = 0, expected_1 = expected; _i < expected_1.length; _i++) {
	        var val = expected_1[_i];
	        if (val === input) {
	            return;
	        }
	        expectedDescription.push(valueDescription(val));
	    }
	    var actualDescription = valueDescription(input);
	    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid value " + actualDescription + " provided to function " + functionName + "() for option " +
	        ("\"" + optionName + "\". Acceptable values: " + expectedDescription.join(', ')));
	}
	/**
	 * Validates that the provided named option equals one of the expected values or
	 * is undefined.
	 */
	function validateNamedOptionalPropertyEquals(functionName, inputName, optionName, input, expected) {
	    if (input !== undefined) {
	        validateNamedPropertyEquals(functionName, inputName, optionName, input, expected);
	    }
	}
	/**
	 * Validates that the provided argument is a valid enum.
	 *
	 * @param functionName Function making the validation call.
	 * @param enums Array containing all possible values for the enum.
	 * @param position Position of the argument in `functionName`.
	 * @param argument Arugment to validate.
	 */
	function validateStringEnum(functionName, enums, position, argument) {
	    if (!enums.some(function (element) { return element === argument; })) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid value " + valueDescription(argument) + " provided to function " +
	            (functionName + "() for its " + ordinal(position) + " argument. Acceptable ") +
	            ("values: " + enums.join(', ')));
	    }
	}
	/** Helper to validate the type of a provided input. */
	function validateType(functionName, type, inputName, input) {
	    var valid = false;
	    if (type === 'object') {
	        valid = isPlainObject(input);
	    }
	    else if (type === 'non-empty string') {
	        valid = typeof input === 'string' && input !== '';
	    }
	    else {
	        valid = typeof input === type;
	    }
	    if (!valid) {
	        var description = valueDescription(input);
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + inputName + " " +
	            ("to be of type " + type + ", but it was: " + description));
	    }
	}
	/**
	 * Returns true if it's a non-null object without a custom prototype
	 * (i.e. excludes Array, Date, etc.).
	 */
	function isPlainObject(input) {
	    return (typeof input === 'object' &&
	        input !== null &&
	        (Object.getPrototypeOf(input) === Object.prototype ||
	            Object.getPrototypeOf(input) === null));
	}
	/** Returns a string describing the type / value of the provided input. */
	function valueDescription(input) {
	    if (input === undefined) {
	        return 'undefined';
	    }
	    else if (input === null) {
	        return 'null';
	    }
	    else if (typeof input === 'string') {
	        if (input.length > 20) {
	            input = input.substring(0, 20) + "...";
	        }
	        return JSON.stringify(input);
	    }
	    else if (typeof input === 'number' || typeof input === 'boolean') {
	        return '' + input;
	    }
	    else if (typeof input === 'object') {
	        if (input instanceof Array) {
	            return 'an array';
	        }
	        else {
	            var customObjectName = tryGetCustomObjectType(input);
	            if (customObjectName) {
	                return "a custom " + customObjectName + " object";
	            }
	            else {
	                return 'an object';
	            }
	        }
	    }
	    else if (typeof input === 'function') {
	        return 'a function';
	    }
	    else {
	        return fail('Unknown wrong type: ' + typeof input);
	    }
	}
	/** Hacky method to try to get the constructor name for an object. */
	function tryGetCustomObjectType(input) {
	    if (input.constructor) {
	        var funcNameRegex = /function\s+([^\s(]+)\s*\(/;
	        var results = funcNameRegex.exec(input.constructor.toString());
	        if (results && results.length > 1) {
	            return results[1];
	        }
	    }
	    return null;
	}
	/** Validates the provided argument is defined. */
	function validateDefined(functionName, position, argument) {
	    if (argument === undefined) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires a valid " + ordinal(position) + " " +
	            "argument, but it was undefined.");
	    }
	}
	/**
	 * Validates the provided positional argument is an object, and its keys and
	 * values match the expected keys and types provided in optionTypes.
	 */
	function validateOptionNames(functionName, options, optionNames) {
	    forEach(options, function (key, _) {
	        if (optionNames.indexOf(key) < 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Unknown option '" + key + "' passed to function " + functionName + "(). " +
	                'Available options: ' +
	                optionNames.join(', '));
	        }
	    });
	}
	/**
	 * Helper method to throw an error that the provided argument did not pass
	 * an instanceof check.
	 */
	function invalidClassError(functionName, type, position, argument) {
	    var description = valueDescription(argument);
	    return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + ordinal(position) + " " +
	        ("argument to be a " + type + ", but it was: " + description));
	}
	function validatePositiveNumber(functionName, position, n) {
	    if (n <= 0) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function \"" + functionName + "()\" requires its " + ordinal(position) + " argument to be a positive number, but it was: " + n + ".");
	    }
	}
	/** Converts a number to its english word representation */
	function ordinal(num) {
	    switch (num) {
	        case 1:
	            return 'first';
	        case 2:
	            return 'second';
	        case 3:
	            return 'third';
	        default:
	            return num + 'th';
	    }
	}
	/**
	 * Formats the given word as plural conditionally given the preceding number.
	 */
	function formatPlural(num, str) {
	    return num + " " + str + (num === 1 ? '' : 's');
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var AutoId = /** @class */ (function () {
	    function AutoId() {
	    }
	    AutoId.newId = function () {
	        // Alphanumeric characters
	        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	        var autoId = '';
	        for (var i = 0; i < 20; i++) {
	            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
	        }
	        assert(autoId.length === 20, 'Invalid auto ID: ' + autoId);
	        return autoId;
	    };
	    return AutoId;
	}());
	function primitiveComparator(left, right) {
	    if (left < right) {
	        return -1;
	    }
	    if (left > right) {
	        return 1;
	    }
	    return 0;
	}
	/** Helper to compare nullable (or undefined-able) objects using isEqual(). */
	function equals(left, right) {
	    if (left !== null && left !== undefined) {
	        return !!(right && left.isEqual(right));
	    }
	    else {
	        // HACK: Explicitly cast since TypeScript's type narrowing apparently isn't
	        // smart enough.
	        return left === right;
	    }
	}
	/** Helper to compare arrays using isEqual(). */
	function arrayEquals(left, right) {
	    if (left.length !== right.length) {
	        return false;
	    }
	    for (var i = 0; i < left.length; i++) {
	        if (!left[i].isEqual(right[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	/**
	 * Returns the immediate lexicographically-following string. This is useful to
	 * construct an inclusive range for indexeddb iterators.
	 */
	function immediateSuccessor(s) {
	    // Return the input string, with an additional NUL byte appended.
	    return s + '\0';
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Helper function to assert Uint8Array is available at runtime. */
	function assertUint8ArrayAvailable() {
	    if (typeof Uint8Array === 'undefined') {
	        throw new FirestoreError(Code.UNIMPLEMENTED, 'Uint8Arrays are not available in this environment.');
	    }
	}
	/** Helper function to assert Base64 functions are available at runtime. */
	function assertBase64Available() {
	    if (!PlatformSupport.getPlatform().base64Available) {
	        throw new FirestoreError(Code.UNIMPLEMENTED, 'Blobs are unavailable in Firestore in this environment.');
	    }
	}
	/**
	 * Immutable class holding a blob (binary data).
	 * This class is directly exposed in the public API.
	 *
	 * Note that while you can't hide the constructor in JavaScript code, we are
	 * using the hack above to make sure no-one outside this module can call it.
	 */
	var Blob = /** @class */ (function () {
	    function Blob(binaryString) {
	        assertBase64Available();
	        this._binaryString = binaryString;
	    }
	    Blob.fromBase64String = function (base64) {
	        validateExactNumberOfArgs('Blob.fromBase64String', arguments, 1);
	        validateArgType('Blob.fromBase64String', 'string', 1, base64);
	        assertBase64Available();
	        try {
	            var binaryString = PlatformSupport.getPlatform().atob(base64);
	            return new Blob(binaryString);
	        }
	        catch (e) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Failed to construct Blob from Base64 string: ' + e);
	        }
	    };
	    Blob.fromUint8Array = function (array) {
	        validateExactNumberOfArgs('Blob.fromUint8Array', arguments, 1);
	        assertUint8ArrayAvailable();
	        if (!(array instanceof Uint8Array)) {
	            throw invalidClassError('Blob.fromUint8Array', 'Uint8Array', 1, array);
	        }
	        // We can't call array.map directly because it expects the return type to
	        // be a Uint8Array, whereas we can convert it to a regular array by invoking
	        // map on the Array prototype.
	        var binaryString = Array.prototype.map
	            .call(array, function (char) {
	            return String.fromCharCode(char);
	        })
	            .join('');
	        return new Blob(binaryString);
	    };
	    Blob.prototype.toBase64 = function () {
	        validateExactNumberOfArgs('Blob.toBase64', arguments, 0);
	        assertBase64Available();
	        return PlatformSupport.getPlatform().btoa(this._binaryString);
	    };
	    Blob.prototype.toUint8Array = function () {
	        validateExactNumberOfArgs('Blob.toUint8Array', arguments, 0);
	        assertUint8ArrayAvailable();
	        var buffer = new Uint8Array(this._binaryString.length);
	        for (var i = 0; i < this._binaryString.length; i++) {
	            buffer[i] = this._binaryString.charCodeAt(i);
	        }
	        return buffer;
	    };
	    Blob.prototype.toString = function () {
	        return 'Blob(base64: ' + this.toBase64() + ')';
	    };
	    Blob.prototype.isEqual = function (other) {
	        return this._binaryString === other._binaryString;
	    };
	    Blob.prototype._approximateByteSize = function () {
	        // Assume UTF-16 encoding in memory (see StringValue.approximateByteSize())
	        return this._binaryString.length * 2;
	    };
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    Blob.prototype._compareTo = function (other) {
	        return primitiveComparator(this._binaryString, other._binaryString);
	    };
	    return Blob;
	}());
	// Public instance that disallows construction at runtime. This constructor is
	// used when exporting Blob on firebase.firestore.Blob and will be called Blob
	// publicly. Internally we still use Blob which has a type checked private
	// constructor. Note that Blob and PublicBlob can be used interchangeably in
	// instanceof checks.
	// For our internal TypeScript code PublicBlob doesn't exist as a type, and so
	// we need to use Blob as type and export it too.
	var PublicBlob = makeConstructorPrivate(Blob, 'Use Blob.fromUint8Array() or Blob.fromBase64String() instead.');
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DatabaseInfo = /** @class */ (function () {
	    /**
	     * Constructs a DatabaseInfo using the provided host, databaseId and
	     * persistenceKey.
	     *
	     * @param databaseId The database to use.
	     * @param persistenceKey A unique identifier for this Firestore's local
	     * storage (used in conjunction with the databaseId).
	     * @param host The Firestore backend host to connect to.
	     * @param ssl Whether to use SSL when connecting.
	     * @param forceLongPolling Whether to use the forceLongPolling option
	     * when using WebChannel as the network transport.
	     */
	    function DatabaseInfo(databaseId, persistenceKey, host, ssl, forceLongPolling) {
	        this.databaseId = databaseId;
	        this.persistenceKey = persistenceKey;
	        this.host = host;
	        this.ssl = ssl;
	        this.forceLongPolling = forceLongPolling;
	    }
	    return DatabaseInfo;
	}());
	/** The default database name for a project. */
	var DEFAULT_DATABASE_NAME = '(default)';
	/** Represents the database ID a Firestore client is associated with. */
	var DatabaseId = /** @class */ (function () {
	    function DatabaseId(projectId, database) {
	        this.projectId = projectId;
	        this.database = database ? database : DEFAULT_DATABASE_NAME;
	    }
	    Object.defineProperty(DatabaseId.prototype, "isDefaultDatabase", {
	        get: function () {
	            return this.database === DEFAULT_DATABASE_NAME;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DatabaseId.prototype.isEqual = function (other) {
	        return (other instanceof DatabaseId &&
	            other.projectId === this.projectId &&
	            other.database === this.database);
	    };
	    DatabaseId.prototype.compareTo = function (other) {
	        return (primitiveComparator(this.projectId, other.projectId) ||
	            primitiveComparator(this.database, other.database));
	    };
	    return DatabaseId;
	}());
	
	/**
	 * @license
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
	 * exceed. All subsequent calls to next will return increasing values. If provided with a
	 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
	 * well as write out sequence numbers that it produces via `next()`.
	 */
	var ListenSequence = /** @class */ (function () {
	    function ListenSequence(previousValue, sequenceNumberSyncer) {
	        var _this = this;
	        this.previousValue = previousValue;
	        if (sequenceNumberSyncer) {
	            sequenceNumberSyncer.sequenceNumberHandler = function (sequenceNumber) {
	                return _this.setPreviousValue(sequenceNumber);
	            };
	            this.writeNewSequenceNumber = function (sequenceNumber) {
	                return sequenceNumberSyncer.writeSequenceNumber(sequenceNumber);
	            };
	        }
	    }
	    ListenSequence.prototype.setPreviousValue = function (externalPreviousValue) {
	        this.previousValue = Math.max(externalPreviousValue, this.previousValue);
	        return this.previousValue;
	    };
	    ListenSequence.prototype.next = function () {
	        var nextValue = ++this.previousValue;
	        if (this.writeNewSequenceNumber) {
	            this.writeNewSequenceNumber(nextValue);
	        }
	        return nextValue;
	    };
	    ListenSequence.INVALID = -1;
	    return ListenSequence;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DOCUMENT_KEY_NAME = '__name__';
	/**
	 * Path represents an ordered sequence of string segments.
	 */
	var BasePath = /** @class */ (function () {
	    function BasePath(segments, offset, length) {
	        if (offset === undefined) {
	            offset = 0;
	        }
	        else if (offset > segments.length) {
	            fail('offset ' + offset + ' out of range ' + segments.length);
	        }
	        if (length === undefined) {
	            length = segments.length - offset;
	        }
	        else if (length > segments.length - offset) {
	            fail('length ' + length + ' out of range ' + (segments.length - offset));
	        }
	        this.segments = segments;
	        this.offset = offset;
	        this.len = length;
	    }
	    Object.defineProperty(BasePath.prototype, "length", {
	        get: function () {
	            return this.len;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BasePath.prototype.isEqual = function (other) {
	        return BasePath.comparator(this, other) === 0;
	    };
	    BasePath.prototype.child = function (nameOrPath) {
	        var segments = this.segments.slice(this.offset, this.limit());
	        if (nameOrPath instanceof BasePath) {
	            nameOrPath.forEach(function (segment) {
	                segments.push(segment);
	            });
	        }
	        else {
	            segments.push(nameOrPath);
	        }
	        return this.construct(segments);
	    };
	    /** The index of one past the last segment of the path. */
	    BasePath.prototype.limit = function () {
	        return this.offset + this.length;
	    };
	    BasePath.prototype.popFirst = function (size) {
	        size = size === undefined ? 1 : size;
	        assert(this.length >= size, "Can't call popFirst() with less segments");
	        return this.construct(this.segments, this.offset + size, this.length - size);
	    };
	    BasePath.prototype.popLast = function () {
	        assert(!this.isEmpty(), "Can't call popLast() on empty path");
	        return this.construct(this.segments, this.offset, this.length - 1);
	    };
	    BasePath.prototype.firstSegment = function () {
	        assert(!this.isEmpty(), "Can't call firstSegment() on empty path");
	        return this.segments[this.offset];
	    };
	    BasePath.prototype.lastSegment = function () {
	        return this.get(this.length - 1);
	    };
	    BasePath.prototype.get = function (index) {
	        assert(index < this.length, 'Index out of range');
	        return this.segments[this.offset + index];
	    };
	    BasePath.prototype.isEmpty = function () {
	        return this.length === 0;
	    };
	    BasePath.prototype.isPrefixOf = function (other) {
	        if (other.length < this.length) {
	            return false;
	        }
	        for (var i = 0; i < this.length; i++) {
	            if (this.get(i) !== other.get(i)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    BasePath.prototype.isImmediateParentOf = function (potentialChild) {
	        if (this.length + 1 !== potentialChild.length) {
	            return false;
	        }
	        for (var i = 0; i < this.length; i++) {
	            if (this.get(i) !== potentialChild.get(i)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    BasePath.prototype.forEach = function (fn) {
	        for (var i = this.offset, end = this.limit(); i < end; i++) {
	            fn(this.segments[i]);
	        }
	    };
	    BasePath.prototype.toArray = function () {
	        return this.segments.slice(this.offset, this.limit());
	    };
	    BasePath.comparator = function (p1, p2) {
	        var len = Math.min(p1.length, p2.length);
	        for (var i = 0; i < len; i++) {
	            var left = p1.get(i);
	            var right = p2.get(i);
	            if (left < right) {
	                return -1;
	            }
	            if (left > right) {
	                return 1;
	            }
	        }
	        if (p1.length < p2.length) {
	            return -1;
	        }
	        if (p1.length > p2.length) {
	            return 1;
	        }
	        return 0;
	    };
	    return BasePath;
	}());
	/**
	 * A slash-separated path for navigating resources (documents and collections)
	 * within Firestore.
	 */
	var ResourcePath = /** @class */ (function (_super) {
	    tslib.__extends(ResourcePath, _super);
	    function ResourcePath() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResourcePath.prototype.construct = function (segments, offset, length) {
	        return new ResourcePath(segments, offset, length);
	    };
	    ResourcePath.prototype.canonicalString = function () {
	        // NOTE: The client is ignorant of any path segments containing escape
	        // sequences (e.g. __id123__) and just passes them through raw (they exist
	        // for legacy reasons and should not be used frequently).
	        return this.toArray().join('/');
	    };
	    ResourcePath.prototype.toString = function () {
	        return this.canonicalString();
	    };
	    /**
	     * Creates a resource path from the given slash-delimited string.
	     */
	    ResourcePath.fromString = function (path) {
	        // NOTE: The client is ignorant of any path segments containing escape
	        // sequences (e.g. __id123__) and just passes them through raw (they exist
	        // for legacy reasons and should not be used frequently).
	        if (path.indexOf('//') >= 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid path (" + path + "). Paths must not contain // in them.");
	        }
	        // We may still have an empty segment at the beginning or end if they had a
	        // leading or trailing slash (which we allow).
	        var segments = path.split('/').filter(function (segment) { return segment.length > 0; });
	        return new ResourcePath(segments);
	    };
	    ResourcePath.EMPTY_PATH = new ResourcePath([]);
	    return ResourcePath;
	}(BasePath));
	var identifierRegExp = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
	/** A dot-separated path for navigating sub-objects within a document. */
	var FieldPath = /** @class */ (function (_super) {
	    tslib.__extends(FieldPath, _super);
	    function FieldPath() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FieldPath.prototype.construct = function (segments, offset, length) {
	        return new FieldPath(segments, offset, length);
	    };
	    /**
	     * Returns true if the string could be used as a segment in a field path
	     * without escaping.
	     */
	    FieldPath.isValidIdentifier = function (segment) {
	        return identifierRegExp.test(segment);
	    };
	    FieldPath.prototype.canonicalString = function () {
	        return this.toArray()
	            .map(function (str) {
	            str = str.replace('\\', '\\\\').replace('`', '\\`');
	            if (!FieldPath.isValidIdentifier(str)) {
	                str = '`' + str + '`';
	            }
	            return str;
	        })
	            .join('.');
	    };
	    FieldPath.prototype.toString = function () {
	        return this.canonicalString();
	    };
	    /**
	     * Returns true if this field references the key of a document.
	     */
	    FieldPath.prototype.isKeyField = function () {
	        return this.length === 1 && this.get(0) === DOCUMENT_KEY_NAME;
	    };
	    /**
	     * The field designating the key of a document.
	     */
	    FieldPath.keyField = function () {
	        return new FieldPath([DOCUMENT_KEY_NAME]);
	    };
	    /**
	     * Parses a field string from the given server-formatted string.
	     *
	     * - Splitting the empty string is not allowed (for now at least).
	     * - Empty segments within the string (e.g. if there are two consecutive
	     *   separators) are not allowed.
	     *
	     * TODO(b/37244157): we should make this more strict. Right now, it allows
	     * non-identifier path components, even if they aren't escaped.
	     */
	    FieldPath.fromServerFormat = function (path) {
	        var segments = [];
	        var current = '';
	        var i = 0;
	        var addCurrentSegment = function () {
	            if (current.length === 0) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, begin " +
	                    "with '.', end with '.', or contain '..'");
	            }
	            segments.push(current);
	            current = '';
	        };
	        var inBackticks = false;
	        while (i < path.length) {
	            var c = path[i];
	            if (c === '\\') {
	                if (i + 1 === path.length) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has trailing escape character: ' + path);
	                }
	                var next = path[i + 1];
	                if (!(next === '\\' || next === '.' || next === '`')) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has invalid escape sequence: ' + path);
	                }
	                current += next;
	                i += 2;
	            }
	            else if (c === '`') {
	                inBackticks = !inBackticks;
	                i++;
	            }
	            else if (c === '.' && !inBackticks) {
	                addCurrentSegment();
	                i++;
	            }
	            else {
	                current += c;
	                i++;
	            }
	        }
	        addCurrentSegment();
	        if (inBackticks) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Unterminated ` in path: ' + path);
	        }
	        return new FieldPath(segments);
	    };
	    FieldPath.EMPTY_PATH = new FieldPath([]);
	    return FieldPath;
	}(BasePath));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DocumentKey = /** @class */ (function () {
	    function DocumentKey(path) {
	        this.path = path;
	        assert(DocumentKey.isDocumentKey(path), 'Invalid DocumentKey with an odd number of segments: ' +
	            path.toArray().join('/'));
	    }
	    /** Returns true if the document is in the specified collectionId. */
	    DocumentKey.prototype.hasCollectionId = function (collectionId) {
	        return (this.path.length >= 2 &&
	            this.path.get(this.path.length - 2) === collectionId);
	    };
	    DocumentKey.prototype.isEqual = function (other) {
	        return (other !== null && ResourcePath.comparator(this.path, other.path) === 0);
	    };
	    DocumentKey.prototype.toString = function () {
	        return this.path.toString();
	    };
	    DocumentKey.comparator = function (k1, k2) {
	        return ResourcePath.comparator(k1.path, k2.path);
	    };
	    DocumentKey.isDocumentKey = function (path) {
	        return path.length % 2 === 0;
	    };
	    /**
	     * Creates and returns a new document key with the given segments.
	     *
	     * @param path The segments of the path to the document
	     * @return A new instance of DocumentKey
	     */
	    DocumentKey.fromSegments = function (segments) {
	        return new DocumentKey(new ResourcePath(segments.slice()));
	    };
	    /**
	     * Creates and returns a new document key using '/' to split the string into
	     * segments.
	     *
	     * @param path The slash-separated path string to the document
	     * @return A new instance of DocumentKey
	     */
	    DocumentKey.fromPathString = function (path) {
	        return new DocumentKey(ResourcePath.fromString(path));
	    };
	    DocumentKey.EMPTY = new DocumentKey(new ResourcePath([]));
	    return DocumentKey;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Deferred = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    return Deferred;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Wellknown "timer" IDs used when scheduling delayed operations on the
	 * AsyncQueue. These IDs can then be used from tests to check for the presence
	 * of operations or to run them early.
	 *
	 * The string values are used when encoding these timer IDs in JSON spec tests.
	 */
	var TimerId;
	(function (TimerId) {
	    /** All can be used with runDelayedOperationsEarly() to run all timers. */
	    TimerId["All"] = "all";
	    /**
	     * The following 4 timers are used in persistent_stream.ts for the listen and
	     * write streams. The "Idle" timer is used to close the stream due to
	     * inactivity. The "ConnectionBackoff" timer is used to restart a stream once
	     * the appropriate backoff delay has elapsed.
	     */
	    TimerId["ListenStreamIdle"] = "listen_stream_idle";
	    TimerId["ListenStreamConnectionBackoff"] = "listen_stream_connection_backoff";
	    TimerId["WriteStreamIdle"] = "write_stream_idle";
	    TimerId["WriteStreamConnectionBackoff"] = "write_stream_connection_backoff";
	    /**
	     * A timer used in online_state_tracker.ts to transition from
	     * OnlineState.Unknown to Offline after a set timeout, rather than waiting
	     * indefinitely for success or failure.
	     */
	    TimerId["OnlineStateTimeout"] = "online_state_timeout";
	    /**
	     * A timer used to update the client metadata in IndexedDb, which is used
	     * to determine the primary leaseholder.
	     */
	    TimerId["ClientMetadataRefresh"] = "client_metadata_refresh";
	    /** A timer used to periodically attempt LRU Garbage collection */
	    TimerId["LruGarbageCollection"] = "lru_garbage_collection";
	    /**
	     * A timer used to retry transactions. Since there can be multiple concurrent
	     * transactions, multiple of these may be in the queue at a given time.
	     */
	    TimerId["RetryTransaction"] = "retry_transaction";
	})(TimerId || (TimerId = {}));
	/**
	 * Represents an operation scheduled to be run in the future on an AsyncQueue.
	 *
	 * It is created via DelayedOperation.createAndSchedule().
	 *
	 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
	 */
	var DelayedOperation = /** @class */ (function () {
	    function DelayedOperation(asyncQueue, timerId, targetTimeMs, op, removalCallback) {
	        this.asyncQueue = asyncQueue;
	        this.timerId = timerId;
	        this.targetTimeMs = targetTimeMs;
	        this.op = op;
	        this.removalCallback = removalCallback;
	        this.deferred = new Deferred();
	        this.then = this.deferred.promise.then.bind(this.deferred.promise);
	        this.catch = this.deferred.promise.catch.bind(this.deferred.promise);
	        // It's normal for the deferred promise to be canceled (due to cancellation)
	        // and so we attach a dummy catch callback to avoid
	        // 'UnhandledPromiseRejectionWarning' log spam.
	        this.deferred.promise.catch(function (err) { });
	    }
	    /**
	     * Creates and returns a DelayedOperation that has been scheduled to be
	     * executed on the provided asyncQueue after the provided delayMs.
	     *
	     * @param asyncQueue The queue to schedule the operation on.
	     * @param id A Timer ID identifying the type of operation this is.
	     * @param delayMs The delay (ms) before the operation should be scheduled.
	     * @param op The operation to run.
	     * @param removalCallback A callback to be called synchronously once the
	     *   operation is executed or canceled, notifying the AsyncQueue to remove it
	     *   from its delayedOperations list.
	     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
	     *   the DelayedOperation class public.
	     */
	    DelayedOperation.createAndSchedule = function (asyncQueue, timerId, delayMs, op, removalCallback) {
	        var targetTime = Date.now() + delayMs;
	        var delayedOp = new DelayedOperation(asyncQueue, timerId, targetTime, op, removalCallback);
	        delayedOp.start(delayMs);
	        return delayedOp;
	    };
	    /**
	     * Starts the timer. This is called immediately after construction by
	     * createAndSchedule().
	     */
	    DelayedOperation.prototype.start = function (delayMs) {
	        var _this = this;
	        this.timerHandle = setTimeout(function () { return _this.handleDelayElapsed(); }, delayMs);
	    };
	    /**
	     * Queues the operation to run immediately (if it hasn't already been run or
	     * canceled).
	     */
	    DelayedOperation.prototype.skipDelay = function () {
	        return this.handleDelayElapsed();
	    };
	    /**
	     * Cancels the operation if it hasn't already been executed or canceled. The
	     * promise will be rejected.
	     *
	     * As long as the operation has not yet been run, calling cancel() provides a
	     * guarantee that the operation will not be run.
	     */
	    DelayedOperation.prototype.cancel = function (reason) {
	        if (this.timerHandle !== null) {
	            this.clearTimeout();
	            this.deferred.reject(new FirestoreError(Code.CANCELLED, 'Operation cancelled' + (reason ? ': ' + reason : '')));
	        }
	    };
	    DelayedOperation.prototype.handleDelayElapsed = function () {
	        var _this = this;
	        this.asyncQueue.enqueueAndForget(function () {
	            if (_this.timerHandle !== null) {
	                _this.clearTimeout();
	                return _this.op().then(function (result) {
	                    return _this.deferred.resolve(result);
	                });
	            }
	            else {
	                return Promise.resolve();
	            }
	        });
	    };
	    DelayedOperation.prototype.clearTimeout = function () {
	        if (this.timerHandle !== null) {
	            this.removalCallback(this);
	            clearTimeout(this.timerHandle);
	            this.timerHandle = null;
	        }
	    };
	    return DelayedOperation;
	}());
	var AsyncQueue = /** @class */ (function () {
	    function AsyncQueue() {
	        // The last promise in the queue.
	        this.tail = Promise.resolve();
	        // Is this AsyncQueue being shut down? Once it is set to true, it will not
	        // be changed again.
	        this._isShuttingDown = false;
	        // Operations scheduled to be queued in the future. Operations are
	        // automatically removed after they are run or canceled.
	        this.delayedOperations = [];
	        // visible for testing
	        this.failure = null;
	        // Flag set while there's an outstanding AsyncQueue operation, used for
	        // assertion sanity-checks.
	        this.operationInProgress = false;
	        // List of TimerIds to fast-forward delays for.
	        this.timerIdsToSkip = [];
	    }
	    Object.defineProperty(AsyncQueue.prototype, "isShuttingDown", {
	        // Is this AsyncQueue being shut down? If true, this instance will not enqueue
	        // any new operations, Promises from enqueue requests will not resolve.
	        get: function () {
	            return this._isShuttingDown;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Adds a new operation to the queue without waiting for it to complete (i.e.
	     * we ignore the Promise result).
	     */
	    AsyncQueue.prototype.enqueueAndForget = function (op) {
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.enqueue(op);
	    };
	    /**
	     * Regardless if the queue has initialized shutdown, adds a new operation to the
	     * queue without waiting for it to complete (i.e. we ignore the Promise result).
	     */
	    AsyncQueue.prototype.enqueueAndForgetEvenAfterShutdown = function (op) {
	        this.verifyNotFailed();
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.enqueueInternal(op);
	    };
	    /**
	     * Regardless if the queue has initialized shutdown, adds a new operation to the
	     * queue.
	     */
	    AsyncQueue.prototype.enqueueEvenAfterShutdown = function (op) {
	        this.verifyNotFailed();
	        return this.enqueueInternal(op);
	    };
	    /**
	     * Adds a new operation to the queue and initialize the shut down of this queue.
	     * Returns a promise that will be resolved when the promise returned by the new
	     * operation is (with its value).
	     * Once this method is called, the only possible way to request running an operation
	     * is through `enqueueAndForgetEvenAfterShutdown`.
	     */
	    AsyncQueue.prototype.enqueueAndInitiateShutdown = function (op) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.verifyNotFailed();
	                        if (!!this._isShuttingDown) return [3 /*break*/, 2];
	                        this._isShuttingDown = true;
	                        return [4 /*yield*/, this.enqueueEvenAfterShutdown(op)];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Adds a new operation to the queue. Returns a promise that will be resolved
	     * when the promise returned by the new operation is (with its value).
	     */
	    AsyncQueue.prototype.enqueue = function (op) {
	        this.verifyNotFailed();
	        if (this._isShuttingDown) {
	            // Return a Promise which never resolves.
	            return new Promise(function (resolve) { });
	        }
	        return this.enqueueInternal(op);
	    };
	    AsyncQueue.prototype.enqueueInternal = function (op) {
	        var _this = this;
	        var newTail = this.tail.then(function () {
	            _this.operationInProgress = true;
	            return op()
	                .catch(function (error$1) {
	                _this.failure = error$1;
	                _this.operationInProgress = false;
	                var message = error$1.stack || error$1.message || '';
	                error('INTERNAL UNHANDLED ERROR: ', message);
	                // Escape the promise chain and throw the error globally so that
	                // e.g. any global crash reporting library detects and reports it.
	                // (but not for simulated errors in our tests since this breaks mocha)
	                if (message.indexOf('Firestore Test Simulated Error') < 0) {
	                    setTimeout(function () {
	                        throw error$1;
	                    }, 0);
	                }
	                // Re-throw the error so that this.tail becomes a rejected Promise and
	                // all further attempts to chain (via .then) will just short-circuit
	                // and return the rejected Promise.
	                throw error$1;
	            })
	                .then(function (result) {
	                _this.operationInProgress = false;
	                return result;
	            });
	        });
	        this.tail = newTail;
	        return newTail;
	    };
	    /**
	     * Schedules an operation to be queued on the AsyncQueue once the specified
	     * `delayMs` has elapsed. The returned CancelablePromise can be used to cancel
	     * the operation prior to its running.
	     */
	    AsyncQueue.prototype.enqueueAfterDelay = function (timerId, delayMs, op) {
	        var _this = this;
	        this.verifyNotFailed();
	        assert(delayMs >= 0, "Attempted to schedule an operation with a negative delay of " + delayMs);
	        // Fast-forward delays for timerIds that have been overriden.
	        if (this.timerIdsToSkip.indexOf(timerId) > -1) {
	            delayMs = 0;
	        }
	        var delayedOp = DelayedOperation.createAndSchedule(this, timerId, delayMs, op, function (removedOp) {
	            return _this.removeDelayedOperation(removedOp);
	        });
	        this.delayedOperations.push(delayedOp);
	        return delayedOp;
	    };
	    AsyncQueue.prototype.verifyNotFailed = function () {
	        if (this.failure) {
	            fail('AsyncQueue is already failed: ' +
	                (this.failure.stack || this.failure.message));
	        }
	    };
	    /**
	     * Verifies there's an operation currently in-progress on the AsyncQueue.
	     * Unfortunately we can't verify that the running code is in the promise chain
	     * of that operation, so this isn't a foolproof check, but it should be enough
	     * to catch some bugs.
	     */
	    AsyncQueue.prototype.verifyOperationInProgress = function () {
	        assert(this.operationInProgress, 'verifyOpInProgress() called when no op in progress on this queue.');
	    };
	    /**
	     * Waits until all currently queued tasks are finished executing. Delayed
	     * operations are not run.
	     */
	    AsyncQueue.prototype.drain = function () {
	        // It should still be possible to drain the queue after it is shutting down.
	        return this.enqueueEvenAfterShutdown(function () { return Promise.resolve(); });
	    };
	    /**
	     * For Tests: Determine if a delayed operation with a particular TimerId
	     * exists.
	     */
	    AsyncQueue.prototype.containsDelayedOperation = function (timerId) {
	        for (var _i = 0, _a = this.delayedOperations; _i < _a.length; _i++) {
	            var op = _a[_i];
	            if (op.timerId === timerId) {
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * For Tests: Runs some or all delayed operations early.
	     *
	     * @param lastTimerId Delayed operations up to and including this TimerId will
	     *  be drained. Throws if no such operation exists. Pass TimerId.All to run
	     *  all delayed operations.
	     * @returns a Promise that resolves once all operations have been run.
	     */
	    AsyncQueue.prototype.runDelayedOperationsEarly = function (lastTimerId) {
	        var _this = this;
	        // Note that draining may generate more delayed ops, so we do that first.
	        return this.drain().then(function () {
	            assert(lastTimerId === TimerId.All ||
	                _this.containsDelayedOperation(lastTimerId), "Attempted to drain to missing operation " + lastTimerId);
	            // Run ops in the same order they'd run if they ran naturally.
	            _this.delayedOperations.sort(function (a, b) { return a.targetTimeMs - b.targetTimeMs; });
	            for (var _i = 0, _a = _this.delayedOperations; _i < _a.length; _i++) {
	                var op = _a[_i];
	                op.skipDelay();
	                if (lastTimerId !== TimerId.All && op.timerId === lastTimerId) {
	                    break;
	                }
	            }
	            return _this.drain();
	        });
	    };
	    /**
	     * For Tests: Skip all subsequent delays for a timer id.
	     */
	    AsyncQueue.prototype.skipDelaysForTimerId = function (timerId) {
	        this.timerIdsToSkip.push(timerId);
	    };
	    /** Called once a DelayedOperation is run or canceled. */
	    AsyncQueue.prototype.removeDelayedOperation = function (op) {
	        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
	        var index = this.delayedOperations.indexOf(op);
	        assert(index >= 0, 'Delayed operation not found.');
	        this.delayedOperations.splice(index, 1);
	    };
	    return AsyncQueue;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var escapeChar = '\u0001';
	var encodedSeparatorChar = '\u0001';
	var encodedNul = '\u0010';
	var encodedEscape = '\u0011';
	/**
	 * Encodes a resource path into a IndexedDb-compatible string form.
	 */
	function encode(path) {
	    var result = '';
	    for (var i = 0; i < path.length; i++) {
	        if (result.length > 0) {
	            result = encodeSeparator(result);
	        }
	        result = encodeSegment(path.get(i), result);
	    }
	    return encodeSeparator(result);
	}
	/** Encodes a single segment of a resource path into the given result */
	function encodeSegment(segment, resultBuf) {
	    var result = resultBuf;
	    var length = segment.length;
	    for (var i = 0; i < length; i++) {
	        var c = segment.charAt(i);
	        switch (c) {
	            case '\0':
	                result += escapeChar + encodedNul;
	                break;
	            case escapeChar:
	                result += escapeChar + encodedEscape;
	                break;
	            default:
	                result += c;
	        }
	    }
	    return result;
	}
	/** Encodes a path separator into the given result */
	function encodeSeparator(result) {
	    return result + escapeChar + encodedSeparatorChar;
	}
	/**
	 * Decodes the given IndexedDb-compatible string form of a resource path into
	 * a ResourcePath instance. Note that this method is not suitable for use with
	 * decoding resource names from the server; those are One Platform format
	 * strings.
	 */
	function decode(path) {
	    // Event the empty path must encode as a path of at least length 2. A path
	    // with exactly 2 must be the empty path.
	    var length = path.length;
	    assert(length >= 2, 'Invalid path ' + path);
	    if (length === 2) {
	        assert(path.charAt(0) === escapeChar && path.charAt(1) === encodedSeparatorChar, 'Non-empty path ' + path + ' had length 2');
	        return ResourcePath.EMPTY_PATH;
	    }
	    // Escape characters cannot exist past the second-to-last position in the
	    // source value.
	    var lastReasonableEscapeIndex = length - 2;
	    var segments = [];
	    var segmentBuilder = '';
	    for (var start = 0; start < length;) {
	        // The last two characters of a valid encoded path must be a separator, so
	        // there must be an end to this segment.
	        var end = path.indexOf(escapeChar, start);
	        if (end < 0 || end > lastReasonableEscapeIndex) {
	            fail('Invalid encoded resource path: "' + path + '"');
	        }
	        var next = path.charAt(end + 1);
	        switch (next) {
	            case encodedSeparatorChar:
	                var currentPiece = path.substring(start, end);
	                var segment = void 0;
	                if (segmentBuilder.length === 0) {
	                    // Avoid copying for the common case of a segment that excludes \0
	                    // and \001
	                    segment = currentPiece;
	                }
	                else {
	                    segmentBuilder += currentPiece;
	                    segment = segmentBuilder;
	                    segmentBuilder = '';
	                }
	                segments.push(segment);
	                break;
	            case encodedNul:
	                segmentBuilder += path.substring(start, end);
	                segmentBuilder += '\0';
	                break;
	            case encodedEscape:
	                // The escape character can be used in the output to encode itself.
	                segmentBuilder += path.substring(start, end + 1);
	                break;
	            default:
	                fail('Invalid encoded resource path: "' + path + '"');
	        }
	        start = end + 2;
	    }
	    return new ResourcePath(segments);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Timestamp = /** @class */ (function () {
	    function Timestamp(seconds, nanoseconds) {
	        this.seconds = seconds;
	        this.nanoseconds = nanoseconds;
	        if (nanoseconds < 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
	        }
	        if (nanoseconds >= 1e9) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
	        }
	        // Midnight at the beginning of 1/1/1 is the earliest Firestore supports.
	        if (seconds < -62135596800) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
	        }
	        // This will break in the year 10,000.
	        if (seconds >= 253402300800) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
	        }
	    }
	    Timestamp.now = function () {
	        return Timestamp.fromMillis(Date.now());
	    };
	    Timestamp.fromDate = function (date) {
	        return Timestamp.fromMillis(date.getTime());
	    };
	    Timestamp.fromMillis = function (milliseconds) {
	        var seconds = Math.floor(milliseconds / 1000);
	        var nanos = (milliseconds - seconds * 1000) * 1e6;
	        return new Timestamp(seconds, nanos);
	    };
	    Timestamp.prototype.toDate = function () {
	        return new Date(this.toMillis());
	    };
	    Timestamp.prototype.toMillis = function () {
	        return this.seconds * 1000 + this.nanoseconds / 1e6;
	    };
	    Timestamp.prototype._compareTo = function (other) {
	        if (this.seconds === other.seconds) {
	            return primitiveComparator(this.nanoseconds, other.nanoseconds);
	        }
	        return primitiveComparator(this.seconds, other.seconds);
	    };
	    Timestamp.prototype.isEqual = function (other) {
	        return (other.seconds === this.seconds && other.nanoseconds === this.nanoseconds);
	    };
	    Timestamp.prototype.toString = function () {
	        return ('Timestamp(seconds=' +
	            this.seconds +
	            ', nanoseconds=' +
	            this.nanoseconds +
	            ')');
	    };
	    return Timestamp;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A version of a document in Firestore. This corresponds to the version
	 * timestamp, such as update_time or read_time.
	 */
	var SnapshotVersion = /** @class */ (function () {
	    function SnapshotVersion(timestamp) {
	        this.timestamp = timestamp;
	    }
	    // TODO(b/34176344): Once we no longer need to use the old alpha protos,
	    // delete this constructor and use a timestamp-backed version everywhere.
	    SnapshotVersion.fromMicroseconds = function (value) {
	        var seconds = Math.floor(value / 1e6);
	        var nanos = (value % 1e6) * 1e3;
	        return new SnapshotVersion(new Timestamp(seconds, nanos));
	    };
	    SnapshotVersion.fromTimestamp = function (value) {
	        return new SnapshotVersion(value);
	    };
	    SnapshotVersion.forDeletedDoc = function () {
	        return SnapshotVersion.MIN;
	    };
	    SnapshotVersion.prototype.compareTo = function (other) {
	        return this.timestamp._compareTo(other.timestamp);
	    };
	    SnapshotVersion.prototype.isEqual = function (other) {
	        return this.timestamp.isEqual(other.timestamp);
	    };
	    /** Returns a number representation of the version for use in spec tests. */
	    SnapshotVersion.prototype.toMicroseconds = function () {
	        // Convert to microseconds.
	        return this.timestamp.seconds * 1e6 + this.timestamp.nanoseconds / 1000;
	    };
	    SnapshotVersion.prototype.toString = function () {
	        return 'SnapshotVersion(' + this.timestamp.toString() + ')';
	    };
	    SnapshotVersion.prototype.toTimestamp = function () {
	        return this.timestamp;
	    };
	    SnapshotVersion.MIN = new SnapshotVersion(new Timestamp(0, 0));
	    return SnapshotVersion;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// An immutable sorted map implementation, based on a Left-leaning Red-Black
	// tree.
	var SortedMap = /** @class */ (function () {
	    function SortedMap(comparator, root) {
	        this.comparator = comparator;
	        this.root = root ? root : LLRBNode.EMPTY;
	    }
	    // Returns a copy of the map, with the specified key/value added or replaced.
	    SortedMap.prototype.insert = function (key, value) {
	        return new SortedMap(this.comparator, this.root
	            .insert(key, value, this.comparator)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    // Returns a copy of the map, with the specified key removed.
	    SortedMap.prototype.remove = function (key) {
	        return new SortedMap(this.comparator, this.root
	            .remove(key, this.comparator)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    // Returns the value of the node with the given key, or null.
	    SortedMap.prototype.get = function (key) {
	        var node = this.root;
	        while (!node.isEmpty()) {
	            var cmp = this.comparator(key, node.key);
	            if (cmp === 0) {
	                return node.value;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                node = node.right;
	            }
	        }
	        return null;
	    };
	    // Returns the index of the element in this sorted map, or -1 if it doesn't
	    // exist.
	    SortedMap.prototype.indexOf = function (key) {
	        // Number of nodes that were pruned when descending right
	        var prunedNodes = 0;
	        var node = this.root;
	        while (!node.isEmpty()) {
	            var cmp = this.comparator(key, node.key);
	            if (cmp === 0) {
	                return prunedNodes + node.left.size;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else {
	                // Count all nodes left of the node plus the node itself
	                prunedNodes += node.left.size + 1;
	                node = node.right;
	            }
	        }
	        // Node not found
	        return -1;
	    };
	    SortedMap.prototype.isEmpty = function () {
	        return this.root.isEmpty();
	    };
	    Object.defineProperty(SortedMap.prototype, "size", {
	        // Returns the total number of nodes in the map.
	        get: function () {
	            return this.root.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Returns the minimum key in the map.
	    SortedMap.prototype.minKey = function () {
	        return this.root.minKey();
	    };
	    // Returns the maximum key in the map.
	    SortedMap.prototype.maxKey = function () {
	        return this.root.maxKey();
	    };
	    // Traverses the map in key order and calls the specified action function
	    // for each key/value pair. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    SortedMap.prototype.inorderTraversal = function (action) {
	        return this.root.inorderTraversal(action);
	    };
	    SortedMap.prototype.forEach = function (fn) {
	        this.inorderTraversal(function (k, v) {
	            fn(k, v);
	            return false;
	        });
	    };
	    SortedMap.prototype.toString = function () {
	        var descriptions = [];
	        this.inorderTraversal(function (k, v) {
	            descriptions.push(k + ":" + v);
	            return false;
	        });
	        return "{" + descriptions.join(', ') + "}";
	    };
	    // Traverses the map in reverse key order and calls the specified action
	    // function for each key/value pair. If action returns true, traversal is
	    // aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    SortedMap.prototype.reverseTraversal = function (action) {
	        return this.root.reverseTraversal(action);
	    };
	    // Returns an iterator over the SortedMap.
	    SortedMap.prototype.getIterator = function () {
	        return new SortedMapIterator(this.root, null, this.comparator, false);
	    };
	    SortedMap.prototype.getIteratorFrom = function (key) {
	        return new SortedMapIterator(this.root, key, this.comparator, false);
	    };
	    SortedMap.prototype.getReverseIterator = function () {
	        return new SortedMapIterator(this.root, null, this.comparator, true);
	    };
	    SortedMap.prototype.getReverseIteratorFrom = function (key) {
	        return new SortedMapIterator(this.root, key, this.comparator, true);
	    };
	    return SortedMap;
	}()); // end SortedMap
	// An iterator over an LLRBNode.
	var SortedMapIterator = /** @class */ (function () {
	    function SortedMapIterator(node, startKey, comparator, isReverse) {
	        this.isReverse = isReverse;
	        this.nodeStack = [];
	        var cmp = 1;
	        while (!node.isEmpty()) {
	            cmp = startKey ? comparator(node.key, startKey) : 1;
	            // flip the comparison if we're going in reverse
	            if (isReverse) {
	                cmp *= -1;
	            }
	            if (cmp < 0) {
	                // This node is less than our start key. ignore it
	                if (this.isReverse) {
	                    node = node.left;
	                }
	                else {
	                    node = node.right;
	                }
	            }
	            else if (cmp === 0) {
	                // This node is exactly equal to our start key. Push it on the stack,
	                // but stop iterating;
	                this.nodeStack.push(node);
	                break;
	            }
	            else {
	                // This node is greater than our start key, add it to the stack and move
	                // to the next one
	                this.nodeStack.push(node);
	                if (this.isReverse) {
	                    node = node.right;
	                }
	                else {
	                    node = node.left;
	                }
	            }
	        }
	    }
	    SortedMapIterator.prototype.getNext = function () {
	        assert(this.nodeStack.length > 0, 'getNext() called on iterator when hasNext() is false.');
	        var node = this.nodeStack.pop();
	        var result = { key: node.key, value: node.value };
	        if (this.isReverse) {
	            node = node.left;
	            while (!node.isEmpty()) {
	                this.nodeStack.push(node);
	                node = node.right;
	            }
	        }
	        else {
	            node = node.right;
	            while (!node.isEmpty()) {
	                this.nodeStack.push(node);
	                node = node.left;
	            }
	        }
	        return result;
	    };
	    SortedMapIterator.prototype.hasNext = function () {
	        return this.nodeStack.length > 0;
	    };
	    SortedMapIterator.prototype.peek = function () {
	        if (this.nodeStack.length === 0) {
	            return null;
	        }
	        var node = this.nodeStack[this.nodeStack.length - 1];
	        return { key: node.key, value: node.value };
	    };
	    return SortedMapIterator;
	}()); // end SortedMapIterator
	// Represents a node in a Left-leaning Red-Black tree.
	var LLRBNode = /** @class */ (function () {
	    function LLRBNode(key, value, color, left, right) {
	        this.key = key;
	        this.value = value;
	        this.color = color != null ? color : LLRBNode.RED;
	        this.left = left != null ? left : LLRBNode.EMPTY;
	        this.right = right != null ? right : LLRBNode.EMPTY;
	        this.size = this.left.size + 1 + this.right.size;
	    }
	    // Returns a copy of the current node, optionally replacing pieces of it.
	    LLRBNode.prototype.copy = function (key, value, color, left, right) {
	        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
	    };
	    LLRBNode.prototype.isEmpty = function () {
	        return false;
	    };
	    // Traverses the tree in key order and calls the specified action function
	    // for each node. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    LLRBNode.prototype.inorderTraversal = function (action) {
	        return (this.left.inorderTraversal(action) ||
	            action(this.key, this.value) ||
	            this.right.inorderTraversal(action));
	    };
	    // Traverses the tree in reverse key order and calls the specified action
	    // function for each node. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    LLRBNode.prototype.reverseTraversal = function (action) {
	        return (this.right.reverseTraversal(action) ||
	            action(this.key, this.value) ||
	            this.left.reverseTraversal(action));
	    };
	    // Returns the minimum node in the tree.
	    LLRBNode.prototype.min = function () {
	        if (this.left.isEmpty()) {
	            return this;
	        }
	        else {
	            return this.left.min();
	        }
	    };
	    // Returns the maximum key in the tree.
	    LLRBNode.prototype.minKey = function () {
	        return this.min().key;
	    };
	    // Returns the maximum key in the tree.
	    LLRBNode.prototype.maxKey = function () {
	        if (this.right.isEmpty()) {
	            return this.key;
	        }
	        else {
	            return this.right.maxKey();
	        }
	    };
	    // Returns new tree, with the key/value added.
	    LLRBNode.prototype.insert = function (key, value, comparator) {
	        var n = this;
	        var cmp = comparator(key, n.key);
	        if (cmp < 0) {
	            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
	        }
	        else if (cmp === 0) {
	            n = n.copy(null, value, null, null, null);
	        }
	        else {
	            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
	        }
	        return n.fixUp();
	    };
	    LLRBNode.prototype.removeMin = function () {
	        if (this.left.isEmpty()) {
	            return LLRBNode.EMPTY;
	        }
	        var n = this;
	        if (!n.left.isRed() && !n.left.left.isRed()) {
	            n = n.moveRedLeft();
	        }
	        n = n.copy(null, null, null, n.left.removeMin(), null);
	        return n.fixUp();
	    };
	    // Returns new tree, with the specified item removed.
	    LLRBNode.prototype.remove = function (key, comparator) {
	        var smallest;
	        var n = this;
	        if (comparator(key, n.key) < 0) {
	            if (!n.left.isEmpty() && !n.left.isRed() && !n.left.left.isRed()) {
	                n = n.moveRedLeft();
	            }
	            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
	        }
	        else {
	            if (n.left.isRed()) {
	                n = n.rotateRight();
	            }
	            if (!n.right.isEmpty() && !n.right.isRed() && !n.right.left.isRed()) {
	                n = n.moveRedRight();
	            }
	            if (comparator(key, n.key) === 0) {
	                if (n.right.isEmpty()) {
	                    return LLRBNode.EMPTY;
	                }
	                else {
	                    smallest = n.right.min();
	                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin());
	                }
	            }
	            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
	        }
	        return n.fixUp();
	    };
	    LLRBNode.prototype.isRed = function () {
	        return this.color;
	    };
	    // Returns new tree after performing any needed rotations.
	    LLRBNode.prototype.fixUp = function () {
	        var n = this;
	        if (n.right.isRed() && !n.left.isRed()) {
	            n = n.rotateLeft();
	        }
	        if (n.left.isRed() && n.left.left.isRed()) {
	            n = n.rotateRight();
	        }
	        if (n.left.isRed() && n.right.isRed()) {
	            n = n.colorFlip();
	        }
	        return n;
	    };
	    LLRBNode.prototype.moveRedLeft = function () {
	        var n = this.colorFlip();
	        if (n.right.left.isRed()) {
	            n = n.copy(null, null, null, null, n.right.rotateRight());
	            n = n.rotateLeft();
	            n = n.colorFlip();
	        }
	        return n;
	    };
	    LLRBNode.prototype.moveRedRight = function () {
	        var n = this.colorFlip();
	        if (n.left.left.isRed()) {
	            n = n.rotateRight();
	            n = n.colorFlip();
	        }
	        return n;
	    };
	    LLRBNode.prototype.rotateLeft = function () {
	        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, nl, null);
	    };
	    LLRBNode.prototype.rotateRight = function () {
	        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, nr);
	    };
	    LLRBNode.prototype.colorFlip = function () {
	        var left = this.left.copy(null, null, !this.left.color, null, null);
	        var right = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, left, right);
	    };
	    // For testing.
	    LLRBNode.prototype.checkMaxDepth = function () {
	        var blackDepth = this.check();
	        if (Math.pow(2.0, blackDepth) <= this.size + 1) {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    // In a balanced RB tree, the black-depth (number of black nodes) from root to
	    // leaves is equal on both sides.  This function verifies that or asserts.
	    LLRBNode.prototype.check = function () {
	        if (this.isRed() && this.left.isRed()) {
	            throw fail('Red node has red child(' + this.key + ',' + this.value + ')');
	        }
	        if (this.right.isRed()) {
	            throw fail('Right child of (' + this.key + ',' + this.value + ') is red');
	        }
	        var blackDepth = this.left.check();
	        if (blackDepth !== this.right.check()) {
	            throw fail('Black depths differ');
	        }
	        else {
	            return blackDepth + (this.isRed() ? 0 : 1);
	        }
	    };
	    // Empty node is shared between all LLRB trees.
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    LLRBNode.EMPTY = null;
	    LLRBNode.RED = true;
	    LLRBNode.BLACK = false;
	    return LLRBNode;
	}()); // end LLRBNode
	// Represents an empty node (a leaf node in the Red-Black Tree).
	var LLRBEmptyNode = /** @class */ (function () {
	    function LLRBEmptyNode() {
	        this.size = 0;
	    }
	    Object.defineProperty(LLRBEmptyNode.prototype, "key", {
	        get: function () {
	            throw fail('LLRBEmptyNode has no key.');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(LLRBEmptyNode.prototype, "value", {
	        get: function () {
	            throw fail('LLRBEmptyNode has no value.');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(LLRBEmptyNode.prototype, "color", {
	        get: function () {
	            throw fail('LLRBEmptyNode has no color.');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(LLRBEmptyNode.prototype, "left", {
	        get: function () {
	            throw fail('LLRBEmptyNode has no left child.');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(LLRBEmptyNode.prototype, "right", {
	        get: function () {
	            throw fail('LLRBEmptyNode has no right child.');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Returns a copy of the current node.
	    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
	        return this;
	    };
	    // Returns a copy of the tree, with the specified key/value added.
	    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
	        return new LLRBNode(key, value);
	    };
	    // Returns a copy of the tree, with the specified key removed.
	    LLRBEmptyNode.prototype.remove = function (key, comparator) {
	        return this;
	    };
	    LLRBEmptyNode.prototype.isEmpty = function () {
	        return true;
	    };
	    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
	        return false;
	    };
	    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
	        return false;
	    };
	    LLRBEmptyNode.prototype.minKey = function () {
	        return null;
	    };
	    LLRBEmptyNode.prototype.maxKey = function () {
	        return null;
	    };
	    LLRBEmptyNode.prototype.isRed = function () {
	        return false;
	    };
	    // For testing.
	    LLRBEmptyNode.prototype.checkMaxDepth = function () {
	        return true;
	    };
	    LLRBEmptyNode.prototype.check = function () {
	        return 0;
	    };
	    return LLRBEmptyNode;
	}()); // end LLRBEmptyNode
	LLRBNode.EMPTY = new LLRBEmptyNode();
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * SortedSet is an immutable (copy-on-write) collection that holds elements
	 * in order specified by the provided comparator.
	 *
	 * NOTE: if provided comparator returns 0 for two elements, we consider them to
	 * be equal!
	 */
	var SortedSet = /** @class */ (function () {
	    function SortedSet(comparator) {
	        this.comparator = comparator;
	        this.data = new SortedMap(this.comparator);
	    }
	    /**
	     * Creates a SortedSet from the keys of the map.
	     * This is currently implemented as an O(n) copy.
	     */
	    SortedSet.fromMapKeys = function (map) {
	        var keys = new SortedSet(map.comparator);
	        map.forEach(function (key) {
	            keys = keys.add(key);
	        });
	        return keys;
	    };
	    SortedSet.prototype.has = function (elem) {
	        return this.data.get(elem) !== null;
	    };
	    SortedSet.prototype.first = function () {
	        return this.data.minKey();
	    };
	    SortedSet.prototype.last = function () {
	        return this.data.maxKey();
	    };
	    Object.defineProperty(SortedSet.prototype, "size", {
	        get: function () {
	            return this.data.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SortedSet.prototype.indexOf = function (elem) {
	        return this.data.indexOf(elem);
	    };
	    /** Iterates elements in order defined by "comparator" */
	    SortedSet.prototype.forEach = function (cb) {
	        this.data.inorderTraversal(function (k, v) {
	            cb(k);
	            return false;
	        });
	    };
	    /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */
	    SortedSet.prototype.forEachInRange = function (range, cb) {
	        var iter = this.data.getIteratorFrom(range[0]);
	        while (iter.hasNext()) {
	            var elem = iter.getNext();
	            if (this.comparator(elem.key, range[1]) >= 0) {
	                return;
	            }
	            cb(elem.key);
	        }
	    };
	    /**
	     * Iterates over `elem`s such that: start <= elem until false is returned.
	     */
	    SortedSet.prototype.forEachWhile = function (cb, start) {
	        var iter;
	        if (start !== undefined) {
	            iter = this.data.getIteratorFrom(start);
	        }
	        else {
	            iter = this.data.getIterator();
	        }
	        while (iter.hasNext()) {
	            var elem = iter.getNext();
	            var result = cb(elem.key);
	            if (!result) {
	                return;
	            }
	        }
	    };
	    /** Finds the least element greater than or equal to `elem`. */
	    SortedSet.prototype.firstAfterOrEqual = function (elem) {
	        var iter = this.data.getIteratorFrom(elem);
	        return iter.hasNext() ? iter.getNext().key : null;
	    };
	    SortedSet.prototype.getIterator = function () {
	        return new SortedSetIterator(this.data.getIterator());
	    };
	    SortedSet.prototype.getIteratorFrom = function (key) {
	        return new SortedSetIterator(this.data.getIteratorFrom(key));
	    };
	    /** Inserts or updates an element */
	    SortedSet.prototype.add = function (elem) {
	        return this.copy(this.data.remove(elem).insert(elem, true));
	    };
	    /** Deletes an element */
	    SortedSet.prototype.delete = function (elem) {
	        if (!this.has(elem)) {
	            return this;
	        }
	        return this.copy(this.data.remove(elem));
	    };
	    SortedSet.prototype.isEmpty = function () {
	        return this.data.isEmpty();
	    };
	    SortedSet.prototype.unionWith = function (other) {
	        var result = this;
	        other.forEach(function (elem) {
	            result = result.add(elem);
	        });
	        return result;
	    };
	    SortedSet.prototype.isEqual = function (other) {
	        if (!(other instanceof SortedSet)) {
	            return false;
	        }
	        if (this.size !== other.size) {
	            return false;
	        }
	        var thisIt = this.data.getIterator();
	        var otherIt = other.data.getIterator();
	        while (thisIt.hasNext()) {
	            var thisElem = thisIt.getNext().key;
	            var otherElem = otherIt.getNext().key;
	            if (this.comparator(thisElem, otherElem) !== 0) {
	                return false;
	            }
	        }
	        return true;
	    };
	    SortedSet.prototype.toArray = function () {
	        var res = [];
	        this.forEach(function (targetId) {
	            res.push(targetId);
	        });
	        return res;
	    };
	    SortedSet.prototype.toString = function () {
	        var result = [];
	        this.forEach(function (elem) { return result.push(elem); });
	        return 'SortedSet(' + result.toString() + ')';
	    };
	    SortedSet.prototype.copy = function (data) {
	        var result = new SortedSet(this.comparator);
	        result.data = data;
	        return result;
	    };
	    return SortedSet;
	}());
	var SortedSetIterator = /** @class */ (function () {
	    function SortedSetIterator(iter) {
	        this.iter = iter;
	    }
	    SortedSetIterator.prototype.getNext = function () {
	        return this.iter.getNext().key;
	    };
	    SortedSetIterator.prototype.hasNext = function () {
	        return this.iter.hasNext();
	    };
	    return SortedSetIterator;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var EMPTY_MAYBE_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
	function maybeDocumentMap() {
	    return EMPTY_MAYBE_DOCUMENT_MAP;
	}
	function nullableMaybeDocumentMap() {
	    return maybeDocumentMap();
	}
	var EMPTY_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
	function documentMap() {
	    return EMPTY_DOCUMENT_MAP;
	}
	var EMPTY_DOCUMENT_VERSION_MAP = new SortedMap(DocumentKey.comparator);
	function documentVersionMap() {
	    return EMPTY_DOCUMENT_VERSION_MAP;
	}
	var EMPTY_DOCUMENT_KEY_SET = new SortedSet(DocumentKey.comparator);
	function documentKeySet() {
	    var keys = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        keys[_i] = arguments[_i];
	    }
	    var set = EMPTY_DOCUMENT_KEY_SET;
	    for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
	        var key = keys_1[_a];
	        set = set.add(key);
	    }
	    return set;
	}
	var EMPTY_TARGET_ID_SET = new SortedSet(primitiveComparator);
	function targetIdSet() {
	    return EMPTY_TARGET_ID_SET;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var BATCHID_UNKNOWN = -1;
	/**
	 * A batch of mutations that will be sent as one unit to the backend.
	 */
	var MutationBatch = /** @class */ (function () {
	    /**
	     * @param batchId The unique ID of this mutation batch.
	     * @param localWriteTime The original write time of this mutation.
	     * @param baseMutations Mutations that are used to populate the base
	     * values when this mutation is applied locally. This can be used to locally
	     * overwrite values that are persisted in the remote document cache. Base
	     * mutations are never sent to the backend.
	     * @param mutations The user-provided mutations in this mutation batch.
	     * User-provided mutations are applied both locally and remotely on the
	     * backend.
	     */
	    function MutationBatch(batchId, localWriteTime, baseMutations, mutations) {
	        this.batchId = batchId;
	        this.localWriteTime = localWriteTime;
	        this.baseMutations = baseMutations;
	        this.mutations = mutations;
	        assert(mutations.length > 0, 'Cannot create an empty mutation batch');
	    }
	    /**
	     * Applies all the mutations in this MutationBatch to the specified document
	     * to create a new remote document
	     *
	     * @param docKey The key of the document to apply mutations to.
	     * @param maybeDoc The document to apply mutations to.
	     * @param batchResult The result of applying the MutationBatch to the
	     * backend.
	     */
	    MutationBatch.prototype.applyToRemoteDocument = function (docKey, maybeDoc, batchResult) {
	        if (maybeDoc) {
	            assert(maybeDoc.key.isEqual(docKey), "applyToRemoteDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
	        }
	        var mutationResults = batchResult.mutationResults;
	        assert(mutationResults.length === this.mutations.length, "Mismatch between mutations length\n      (" + this.mutations.length + ") and mutation results length\n      (" + mutationResults.length + ").");
	        for (var i = 0; i < this.mutations.length; i++) {
	            var mutation = this.mutations[i];
	            if (mutation.key.isEqual(docKey)) {
	                var mutationResult = mutationResults[i];
	                maybeDoc = mutation.applyToRemoteDocument(maybeDoc, mutationResult);
	            }
	        }
	        return maybeDoc;
	    };
	    /**
	     * Computes the local view of a document given all the mutations in this
	     * batch.
	     *
	     * @param docKey The key of the document to apply mutations to.
	     * @param maybeDoc The document to apply mutations to.
	     */
	    MutationBatch.prototype.applyToLocalView = function (docKey, maybeDoc) {
	        if (maybeDoc) {
	            assert(maybeDoc.key.isEqual(docKey), "applyToLocalDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
	        }
	        // First, apply the base state. This allows us to apply non-idempotent
	        // transform against a consistent set of values.
	        for (var _i = 0, _a = this.baseMutations; _i < _a.length; _i++) {
	            var mutation = _a[_i];
	            if (mutation.key.isEqual(docKey)) {
	                maybeDoc = mutation.applyToLocalView(maybeDoc, maybeDoc, this.localWriteTime);
	            }
	        }
	        var baseDoc = maybeDoc;
	        // Second, apply all user-provided mutations.
	        for (var _b = 0, _c = this.mutations; _b < _c.length; _b++) {
	            var mutation = _c[_b];
	            if (mutation.key.isEqual(docKey)) {
	                maybeDoc = mutation.applyToLocalView(maybeDoc, baseDoc, this.localWriteTime);
	            }
	        }
	        return maybeDoc;
	    };
	    /**
	     * Computes the local view for all provided documents given the mutations in
	     * this batch.
	     */
	    MutationBatch.prototype.applyToLocalDocumentSet = function (maybeDocs) {
	        var _this = this;
	        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
	        // directly (as done in `applyToLocalView()`), we can reduce the complexity
	        // to O(n).
	        var mutatedDocuments = maybeDocs;
	        this.mutations.forEach(function (m) {
	            var mutatedDocument = _this.applyToLocalView(m.key, maybeDocs.get(m.key));
	            if (mutatedDocument) {
	                mutatedDocuments = mutatedDocuments.insert(m.key, mutatedDocument);
	            }
	        });
	        return mutatedDocuments;
	    };
	    MutationBatch.prototype.keys = function () {
	        return this.mutations.reduce(function (keys, m) { return keys.add(m.key); }, documentKeySet());
	    };
	    MutationBatch.prototype.isEqual = function (other) {
	        return (this.batchId === other.batchId &&
	            arrayEquals(this.mutations, other.mutations) &&
	            arrayEquals(this.baseMutations, other.baseMutations));
	    };
	    return MutationBatch;
	}());
	/** The result of applying a mutation batch to the backend. */
	var MutationBatchResult = /** @class */ (function () {
	    function MutationBatchResult(batch, commitVersion, mutationResults, streamToken, 
	    /**
	     * A pre-computed mapping from each mutated document to the resulting
	     * version.
	     */
	    docVersions) {
	        this.batch = batch;
	        this.commitVersion = commitVersion;
	        this.mutationResults = mutationResults;
	        this.streamToken = streamToken;
	        this.docVersions = docVersions;
	    }
	    /**
	     * Creates a new MutationBatchResult for the given batch and results. There
	     * must be one result for each mutation in the batch. This static factory
	     * caches a document=>version mapping (docVersions).
	     */
	    MutationBatchResult.from = function (batch, commitVersion, results, streamToken) {
	        assert(batch.mutations.length === results.length, 'Mutations sent ' +
	            batch.mutations.length +
	            ' must equal results received ' +
	            results.length);
	        var versionMap = documentVersionMap();
	        var mutations = batch.mutations;
	        for (var i = 0; i < mutations.length; i++) {
	            versionMap = versionMap.insert(mutations[i].key, results[i].version);
	        }
	        return new MutationBatchResult(batch, commitVersion, results, streamToken, versionMap);
	    };
	    return MutationBatchResult;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * PersistencePromise<> is essentially a re-implementation of Promise<> except
	 * it has a .next() method instead of .then() and .next() and .catch() callbacks
	 * are executed synchronously when a PersistencePromise resolves rather than
	 * asynchronously (Promise<> implementations use setImmediate() or similar).
	 *
	 * This is necessary to interoperate with IndexedDB which will automatically
	 * commit transactions if control is returned to the event loop without
	 * synchronously initiating another operation on the transaction.
	 *
	 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
	 * Promises.
	 */
	var PersistencePromise = /** @class */ (function () {
	    function PersistencePromise(callback) {
	        var _this = this;
	        // NOTE: next/catchCallback will always point to our own wrapper functions,
	        // not the user's raw next() or catch() callbacks.
	        this.nextCallback = null;
	        this.catchCallback = null;
	        // When the operation resolves, we'll set result or error and mark isDone.
	        this.result = undefined;
	        this.error = undefined;
	        this.isDone = false;
	        // Set to true when .then() or .catch() are called and prevents additional
	        // chaining.
	        this.callbackAttached = false;
	        callback(function (value) {
	            _this.isDone = true;
	            _this.result = value;
	            if (_this.nextCallback) {
	                // value should be defined unless T is Void, but we can't express
	                // that in the type system.
	                _this.nextCallback(value);
	            }
	        }, function (error) {
	            _this.isDone = true;
	            _this.error = error;
	            if (_this.catchCallback) {
	                _this.catchCallback(error);
	            }
	        });
	    }
	    PersistencePromise.prototype.catch = function (fn) {
	        return this.next(undefined, fn);
	    };
	    PersistencePromise.prototype.next = function (nextFn, catchFn) {
	        var _this = this;
	        if (this.callbackAttached) {
	            fail('Called next() or catch() twice for PersistencePromise');
	        }
	        this.callbackAttached = true;
	        if (this.isDone) {
	            if (!this.error) {
	                return this.wrapSuccess(nextFn, this.result);
	            }
	            else {
	                return this.wrapFailure(catchFn, this.error);
	            }
	        }
	        else {
	            return new PersistencePromise(function (resolve, reject) {
	                _this.nextCallback = function (value) {
	                    _this.wrapSuccess(nextFn, value).next(resolve, reject);
	                };
	                _this.catchCallback = function (error) {
	                    _this.wrapFailure(catchFn, error).next(resolve, reject);
	                };
	            });
	        }
	    };
	    PersistencePromise.prototype.toPromise = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.next(resolve, reject);
	        });
	    };
	    PersistencePromise.prototype.wrapUserFunction = function (fn) {
	        try {
	            var result = fn();
	            if (result instanceof PersistencePromise) {
	                return result;
	            }
	            else {
	                return PersistencePromise.resolve(result);
	            }
	        }
	        catch (e) {
	            return PersistencePromise.reject(e);
	        }
	    };
	    PersistencePromise.prototype.wrapSuccess = function (nextFn, value) {
	        if (nextFn) {
	            return this.wrapUserFunction(function () { return nextFn(value); });
	        }
	        else {
	            // If there's no nextFn, then R must be the same as T
	            return PersistencePromise.resolve(value);
	        }
	    };
	    PersistencePromise.prototype.wrapFailure = function (catchFn, error) {
	        if (catchFn) {
	            return this.wrapUserFunction(function () { return catchFn(error); });
	        }
	        else {
	            return PersistencePromise.reject(error);
	        }
	    };
	    PersistencePromise.resolve = function (result) {
	        return new PersistencePromise(function (resolve, reject) {
	            resolve(result);
	        });
	    };
	    PersistencePromise.reject = function (error) {
	        return new PersistencePromise(function (resolve, reject) {
	            reject(error);
	        });
	    };
	    PersistencePromise.waitFor = function (
	    // Accept all Promise types in waitFor().
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    all) {
	        return new PersistencePromise(function (resolve, reject) {
	            var expectedCount = 0;
	            var resolvedCount = 0;
	            var done = false;
	            all.forEach(function (element) {
	                ++expectedCount;
	                element.next(function () {
	                    ++resolvedCount;
	                    if (done && resolvedCount === expectedCount) {
	                        resolve();
	                    }
	                }, function (err) { return reject(err); });
	            });
	            done = true;
	            if (resolvedCount === expectedCount) {
	                resolve();
	            }
	        });
	    };
	    /**
	     * Given an array of predicate functions that asynchronously evaluate to a
	     * boolean, implements a short-circuiting `or` between the results. Predicates
	     * will be evaluated until one of them returns `true`, then stop. The final
	     * result will be whether any of them returned `true`.
	     */
	    PersistencePromise.or = function (predicates) {
	        var p = PersistencePromise.resolve(false);
	        var _loop_1 = function (predicate) {
	            p = p.next(function (isTrue) {
	                if (isTrue) {
	                    return PersistencePromise.resolve(isTrue);
	                }
	                else {
	                    return predicate();
	                }
	            });
	        };
	        for (var _i = 0, predicates_1 = predicates; _i < predicates_1.length; _i++) {
	            var predicate = predicates_1[_i];
	            _loop_1(predicate);
	        }
	        return p;
	    };
	    PersistencePromise.forEach = function (collection, f) {
	        var _this = this;
	        var promises = [];
	        collection.forEach(function (r, s) {
	            promises.push(f.call(_this, r, s));
	        });
	        return this.waitFor(promises);
	    };
	    return PersistencePromise;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG = 'SimpleDb';
	/**
	 * The maximum number of retry attempts for an IndexedDb transaction that fails
	 * with a DOMException.
	 */
	var TRANSACTION_RETRY_COUNT = 3;
	/**
	 * Provides a wrapper around IndexedDb with a simplified interface that uses
	 * Promise-like return values to chain operations. Real promises cannot be used
	 * since .then() continuations are executed asynchronously (e.g. via
	 * .setImmediate), which would cause IndexedDB to end the transaction.
	 * See PersistencePromise for more details.
	 */
	var SimpleDb = /** @class */ (function () {
	    function SimpleDb(db) {
	        this.db = db;
	        var iOSVersion = SimpleDb.getIOSVersion(util.getUA());
	        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
	        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
	        // whatever reason it's much harder to hit after 12.2 so we only proactively
	        // log on 12.2.
	        if (iOSVersion === 12.2) {
	            error('Firestore persistence suffers from a bug in iOS 12.2 ' +
	                'Safari that may cause your app to stop working. See ' +
	                'https://stackoverflow.com/q/56496296/110915 for details ' +
	                'and a potential workaround.');
	        }
	    }
	    /**
	     * Opens the specified database, creating or upgrading it if necessary.
	     *
	     * Note that `version` must not be a downgrade. IndexedDB does not support downgrading the schema
	     * version. We currently do not support any way to do versioning outside of IndexedDB's versioning
	     * mechanism, as only version-upgrade transactions are allowed to do things like create
	     * objectstores.
	     */
	    SimpleDb.openOrCreate = function (name, version, schemaConverter) {
	        assert(SimpleDb.isAvailable(), 'IndexedDB not supported in current environment.');
	        debug(LOG_TAG, 'Opening database:', name);
	        return new PersistencePromise(function (resolve, reject) {
	            // TODO(mikelehen): Investigate browser compatibility.
	            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
	            // suggests IE9 and older WebKit browsers handle upgrade
	            // differently. They expect setVersion, as described here:
	            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
	            var request = window.indexedDB.open(name, version);
	            request.onsuccess = function (event) {
	                var db = event.target.result;
	                resolve(new SimpleDb(db));
	            };
	            request.onblocked = function () {
	                reject(new FirestoreError(Code.FAILED_PRECONDITION, 'Cannot upgrade IndexedDB schema while another tab is open. ' +
	                    'Close all tabs that access Firestore and reload this page to proceed.'));
	            };
	            request.onerror = function (event) {
	                var error = event.target.error;
	                if (error.name === 'VersionError') {
	                    reject(new FirestoreError(Code.FAILED_PRECONDITION, 'A newer version of the Firestore SDK was previously used and so the persisted ' +
	                        'data is not compatible with the version of the SDK you are now using. The SDK ' +
	                        'will operate with persistence disabled. If you need persistence, please ' +
	                        're-upgrade to a newer version of the SDK or else clear the persisted IndexedDB ' +
	                        'data for your app to start fresh.'));
	                }
	                else {
	                    reject(error);
	                }
	            };
	            request.onupgradeneeded = function (event) {
	                debug(LOG_TAG, 'Database "' + name + '" requires upgrade from version:', event.oldVersion);
	                var db = event.target.result;
	                schemaConverter
	                    .createOrUpgrade(db, request.transaction, event.oldVersion, SCHEMA_VERSION)
	                    .next(function () {
	                    debug(LOG_TAG, 'Database upgrade to version ' + SCHEMA_VERSION + ' complete');
	                });
	            };
	        }).toPromise();
	    };
	    /** Deletes the specified database. */
	    SimpleDb.delete = function (name) {
	        debug(LOG_TAG, 'Removing database:', name);
	        return wrapRequest(window.indexedDB.deleteDatabase(name)).toPromise();
	    };
	    /** Returns true if IndexedDB is available in the current environment. */
	    SimpleDb.isAvailable = function () {
	        if (typeof window === 'undefined' || window.indexedDB == null) {
	            return false;
	        }
	        if (SimpleDb.isMockPersistence()) {
	            return true;
	        }
	        // In some Node environments, `window` is defined, but `window.navigator` is
	        // not. We don't support IndexedDB persistence in Node if the
	        // isMockPersistence() check above returns false.
	        if (window.navigator === undefined) {
	            return false;
	        }
	        // We extensively use indexed array values and compound keys,
	        // which IE and Edge do not support. However, they still have indexedDB
	        // defined on the window, so we need to check for them here and make sure
	        // to return that persistence is not enabled for those browsers.
	        // For tracking support of this feature, see here:
	        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
	        // Check the UA string to find out the browser.
	        var ua = util.getUA();
	        // IE 10
	        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
	        // IE 11
	        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
	        // Edge
	        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
	        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
	        // iOS Safari: Disable for users running iOS version < 10.
	        var iOSVersion = SimpleDb.getIOSVersion(ua);
	        var isUnsupportedIOS = 0 < iOSVersion && iOSVersion < 10;
	        // Android browser: Disable for userse running version < 4.5.
	        var androidVersion = SimpleDb.getAndroidVersion(ua);
	        var isUnsupportedAndroid = 0 < androidVersion && androidVersion < 4.5;
	        if (ua.indexOf('MSIE ') > 0 ||
	            ua.indexOf('Trident/') > 0 ||
	            ua.indexOf('Edge/') > 0 ||
	            isUnsupportedIOS ||
	            isUnsupportedAndroid) {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    /**
	     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
	     * (see https://github.com/axemclion/IndexedDBShim).
	     */
	    SimpleDb.isMockPersistence = function () {
	        var _a;
	        return (typeof process !== 'undefined' &&
	            ((_a = ({"NODE_ENV":"production","PUBLIC_URL":""})) === null || _a === void 0 ? void 0 : _a.USE_MOCK_PERSISTENCE) === 'YES');
	    };
	    /** Helper to get a typed SimpleDbStore from a transaction. */
	    SimpleDb.getStore = function (txn, store) {
	        return txn.store(store);
	    };
	    // visible for testing
	    /** Parse User Agent to determine iOS version. Returns -1 if not found. */
	    SimpleDb.getIOSVersion = function (ua) {
	        var iOSVersionRegex = ua.match(/i(?:phone|pad|pod) os ([\d_]+)/i);
	        var version = iOSVersionRegex
	            ? iOSVersionRegex[1]
	                .split('_')
	                .slice(0, 2)
	                .join('.')
	            : '-1';
	        return Number(version);
	    };
	    // visible for testing
	    /** Parse User Agent to determine Android version. Returns -1 if not found. */
	    SimpleDb.getAndroidVersion = function (ua) {
	        var androidVersionRegex = ua.match(/Android ([\d.]+)/i);
	        var version = androidVersionRegex
	            ? androidVersionRegex[1]
	                .split('.')
	                .slice(0, 2)
	                .join('.')
	            : '-1';
	        return Number(version);
	    };
	    SimpleDb.prototype.setVersionChangeListener = function (versionChangeListener) {
	        this.db.onversionchange = function (event) {
	            return versionChangeListener(event);
	        };
	    };
	    SimpleDb.prototype.runTransaction = function (mode, objectStores, transactionFn) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var readonly, idempotent, attemptNumber, _loop_1, this_1, state_1;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        readonly = mode.startsWith('readonly');
	                        idempotent = mode.endsWith('idempotent');
	                        attemptNumber = 0;
	                        _loop_1 = function () {
	                            var transaction, transactionFnResult, error_1, retryable;
	                            return tslib.__generator(this, function (_a) {
	                                switch (_a.label) {
	                                    case 0:
	                                        ++attemptNumber;
	                                        transaction = SimpleDbTransaction.open(this_1.db, readonly ? 'readonly' : 'readwrite', objectStores);
	                                        _a.label = 1;
	                                    case 1:
	                                        _a.trys.push([1, 3, , 4]);
	                                        transactionFnResult = transactionFn(transaction)
	                                            .catch(function (error) {
	                                            // Abort the transaction if there was an error.
	                                            transaction.abort(error);
	                                            // We cannot actually recover, and calling `abort()` will cause the transaction's
	                                            // completion promise to be rejected. This in turn means that we won't use
	                                            // `transactionFnResult` below. We return a rejection here so that we don't add the
	                                            // possibility of returning `void` to the type of `transactionFnResult`.
	                                            return PersistencePromise.reject(error);
	                                        })
	                                            .toPromise();
	                                        // As noted above, errors are propagated by aborting the transaction. So
	                                        // we swallow any error here to avoid the browser logging it as unhandled.
	                                        transactionFnResult.catch(function () { });
	                                        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
	                                        // fire), but still return the original transactionFnResult back to the
	                                        // caller.
	                                        return [4 /*yield*/, transaction.completionPromise];
	                                    case 2:
	                                        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
	                                        // fire), but still return the original transactionFnResult back to the
	                                        // caller.
	                                        _a.sent();
	                                        return [2 /*return*/, { value: transactionFnResult }];
	                                    case 3:
	                                        error_1 = _a.sent();
	                                        retryable = idempotent &&
	                                            error_1.name !== 'FirebaseError' &&
	                                            attemptNumber < TRANSACTION_RETRY_COUNT;
	                                        debug(LOG_TAG, 'Transaction failed with error: %s. Retrying: %s.', error_1.message, retryable);
	                                        if (!retryable) {
	                                            return [2 /*return*/, { value: Promise.reject(error_1) }];
	                                        }
	                                        return [3 /*break*/, 4];
	                                    case 4: return [2 /*return*/];
	                                }
	                            });
	                        };
	                        this_1 = this;
	                        _a.label = 1;
	                    case 1:
	                        return [5 /*yield**/, _loop_1()];
	                    case 2:
	                        state_1 = _a.sent();
	                        if (typeof state_1 === "object")
	                            return [2 /*return*/, state_1.value];
	                        return [3 /*break*/, 1];
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SimpleDb.prototype.close = function () {
	        this.db.close();
	    };
	    return SimpleDb;
	}());
	/**
	 * A controller for iterating over a key range or index. It allows an iterate
	 * callback to delete the currently-referenced object, or jump to a new key
	 * within the key range or index.
	 */
	var IterationController = /** @class */ (function () {
	    function IterationController(dbCursor) {
	        this.dbCursor = dbCursor;
	        this.shouldStop = false;
	        this.nextKey = null;
	    }
	    Object.defineProperty(IterationController.prototype, "isDone", {
	        get: function () {
	            return this.shouldStop;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(IterationController.prototype, "skipToKey", {
	        get: function () {
	            return this.nextKey;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(IterationController.prototype, "cursor", {
	        set: function (value) {
	            this.dbCursor = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * This function can be called to stop iteration at any point.
	     */
	    IterationController.prototype.done = function () {
	        this.shouldStop = true;
	    };
	    /**
	     * This function can be called to skip to that next key, which could be
	     * an index or a primary key.
	     */
	    IterationController.prototype.skip = function (key) {
	        this.nextKey = key;
	    };
	    /**
	     * Delete the current cursor value from the object store.
	     *
	     * NOTE: You CANNOT do this with a keysOnly query.
	     */
	    IterationController.prototype.delete = function () {
	        return wrapRequest(this.dbCursor.delete());
	    };
	    return IterationController;
	}());
	/**
	 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
	 * specific object store.
	 */
	var SimpleDbTransaction = /** @class */ (function () {
	    function SimpleDbTransaction(transaction) {
	        var _this = this;
	        this.transaction = transaction;
	        this.aborted = false;
	        /**
	         * A promise that resolves with the result of the IndexedDb transaction.
	         */
	        this.completionDeferred = new Deferred();
	        this.transaction.oncomplete = function () {
	            _this.completionDeferred.resolve();
	        };
	        this.transaction.onabort = function () {
	            if (transaction.error) {
	                _this.completionDeferred.reject(transaction.error);
	            }
	            else {
	                _this.completionDeferred.resolve();
	            }
	        };
	        this.transaction.onerror = function (event) {
	            var error = checkForAndReportiOSError(event.target.error);
	            _this.completionDeferred.reject(error);
	        };
	    }
	    SimpleDbTransaction.open = function (db, mode, objectStoreNames) {
	        return new SimpleDbTransaction(db.transaction(objectStoreNames, mode));
	    };
	    Object.defineProperty(SimpleDbTransaction.prototype, "completionPromise", {
	        get: function () {
	            return this.completionDeferred.promise;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SimpleDbTransaction.prototype.abort = function (error) {
	        if (error) {
	            this.completionDeferred.reject(error);
	        }
	        if (!this.aborted) {
	            debug(LOG_TAG, 'Aborting transaction:', error ? error.message : 'Client-initiated abort');
	            this.aborted = true;
	            this.transaction.abort();
	        }
	    };
	    /**
	     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
	     * operations performed on the SimpleDbStore happen within the context of this
	     * transaction and it cannot be used anymore once the transaction is
	     * completed.
	     *
	     * Note that we can't actually enforce that the KeyType and ValueType are
	     * correct, but they allow type safety through the rest of the consuming code.
	     */
	    SimpleDbTransaction.prototype.store = function (storeName) {
	        var store = this.transaction.objectStore(storeName);
	        assert(!!store, 'Object store not part of transaction: ' + storeName);
	        return new SimpleDbStore(store);
	    };
	    return SimpleDbTransaction;
	}());
	/**
	 * A wrapper around an IDBObjectStore providing an API that:
	 *
	 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
	 * methods for acting against the object store.
	 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
	 * method return a PersistencePromise instead.
	 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
	 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
	 */
	var SimpleDbStore = /** @class */ (function () {
	    function SimpleDbStore(store) {
	        this.store = store;
	    }
	    SimpleDbStore.prototype.put = function (keyOrValue, value) {
	        var request;
	        if (value !== undefined) {
	            debug(LOG_TAG, 'PUT', this.store.name, keyOrValue, value);
	            request = this.store.put(value, keyOrValue);
	        }
	        else {
	            debug(LOG_TAG, 'PUT', this.store.name, '<auto-key>', keyOrValue);
	            request = this.store.put(keyOrValue);
	        }
	        return wrapRequest(request);
	    };
	    /**
	     * Adds a new value into an Object Store and returns the new key. Similar to
	     * IndexedDb's `add()`, this method will fail on primary key collisions.
	     *
	     * @param value The object to write.
	     * @return The key of the value to add.
	     */
	    SimpleDbStore.prototype.add = function (value) {
	        debug(LOG_TAG, 'ADD', this.store.name, value, value);
	        var request = this.store.add(value);
	        return wrapRequest(request);
	    };
	    /**
	     * Gets the object with the specified key from the specified store, or null
	     * if no object exists with the specified key.
	     *
	     * @key The key of the object to get.
	     * @return The object with the specified key or null if no object exists.
	     */
	    SimpleDbStore.prototype.get = function (key) {
	        var _this = this;
	        var request = this.store.get(key);
	        // We're doing an unsafe cast to ValueType.
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return wrapRequest(request).next(function (result) {
	            // Normalize nonexistence to null.
	            if (result === undefined) {
	                result = null;
	            }
	            debug(LOG_TAG, 'GET', _this.store.name, key, result);
	            return result;
	        });
	    };
	    SimpleDbStore.prototype.delete = function (key) {
	        debug(LOG_TAG, 'DELETE', this.store.name, key);
	        var request = this.store.delete(key);
	        return wrapRequest(request);
	    };
	    /**
	     * If we ever need more of the count variants, we can add overloads. For now,
	     * all we need is to count everything in a store.
	     *
	     * Returns the number of rows in the store.
	     */
	    SimpleDbStore.prototype.count = function () {
	        debug(LOG_TAG, 'COUNT', this.store.name);
	        var request = this.store.count();
	        return wrapRequest(request);
	    };
	    SimpleDbStore.prototype.loadAll = function (indexOrRange, range) {
	        var cursor = this.cursor(this.options(indexOrRange, range));
	        var results = [];
	        return this.iterateCursor(cursor, function (key, value) {
	            results.push(value);
	        }).next(function () {
	            return results;
	        });
	    };
	    SimpleDbStore.prototype.deleteAll = function (indexOrRange, range) {
	        debug(LOG_TAG, 'DELETE ALL', this.store.name);
	        var options = this.options(indexOrRange, range);
	        options.keysOnly = false;
	        var cursor = this.cursor(options);
	        return this.iterateCursor(cursor, function (key, value, control) {
	            // NOTE: Calling delete() on a cursor is documented as more efficient than
	            // calling delete() on an object store with a single key
	            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/delete),
	            // however, this requires us *not* to use a keysOnly cursor
	            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBCursor/delete). We
	            // may want to compare the performance of each method.
	            return control.delete();
	        });
	    };
	    SimpleDbStore.prototype.iterate = function (optionsOrCallback, callback) {
	        var options;
	        if (!callback) {
	            options = {};
	            callback = optionsOrCallback;
	        }
	        else {
	            options = optionsOrCallback;
	        }
	        var cursor = this.cursor(options);
	        return this.iterateCursor(cursor, callback);
	    };
	    /**
	     * Iterates over a store, but waits for the given callback to complete for
	     * each entry before iterating the next entry. This allows the callback to do
	     * asynchronous work to determine if this iteration should continue.
	     *
	     * The provided callback should return `true` to continue iteration, and
	     * `false` otherwise.
	     */
	    SimpleDbStore.prototype.iterateSerial = function (callback) {
	        var cursorRequest = this.cursor({});
	        return new PersistencePromise(function (resolve, reject) {
	            cursorRequest.onerror = function (event) {
	                var error = checkForAndReportiOSError(event.target.error);
	                reject(error);
	            };
	            cursorRequest.onsuccess = function (event) {
	                var cursor = event.target.result;
	                if (!cursor) {
	                    resolve();
	                    return;
	                }
	                callback(cursor.primaryKey, cursor.value).next(function (shouldContinue) {
	                    if (shouldContinue) {
	                        cursor.continue();
	                    }
	                    else {
	                        resolve();
	                    }
	                });
	            };
	        });
	    };
	    SimpleDbStore.prototype.iterateCursor = function (cursorRequest, fn) {
	        var results = [];
	        return new PersistencePromise(function (resolve, reject) {
	            cursorRequest.onerror = function (event) {
	                reject(event.target.error);
	            };
	            cursorRequest.onsuccess = function (event) {
	                var cursor = event.target.result;
	                if (!cursor) {
	                    resolve();
	                    return;
	                }
	                var controller = new IterationController(cursor);
	                var userResult = fn(cursor.primaryKey, cursor.value, controller);
	                if (userResult instanceof PersistencePromise) {
	                    var userPromise = userResult.catch(function (err) {
	                        controller.done();
	                        return PersistencePromise.reject(err);
	                    });
	                    results.push(userPromise);
	                }
	                if (controller.isDone) {
	                    resolve();
	                }
	                else if (controller.skipToKey === null) {
	                    cursor.continue();
	                }
	                else {
	                    cursor.continue(controller.skipToKey);
	                }
	            };
	        }).next(function () {
	            return PersistencePromise.waitFor(results);
	        });
	    };
	    SimpleDbStore.prototype.options = function (indexOrRange, range) {
	        var indexName = undefined;
	        if (indexOrRange !== undefined) {
	            if (typeof indexOrRange === 'string') {
	                indexName = indexOrRange;
	            }
	            else {
	                assert(range === undefined, '3rd argument must not be defined if 2nd is a range.');
	                range = indexOrRange;
	            }
	        }
	        return { index: indexName, range: range };
	    };
	    SimpleDbStore.prototype.cursor = function (options) {
	        var direction = 'next';
	        if (options.reverse) {
	            direction = 'prev';
	        }
	        if (options.index) {
	            var index = this.store.index(options.index);
	            if (options.keysOnly) {
	                return index.openKeyCursor(options.range, direction);
	            }
	            else {
	                return index.openCursor(options.range, direction);
	            }
	        }
	        else {
	            return this.store.openCursor(options.range, direction);
	        }
	    };
	    return SimpleDbStore;
	}());
	/**
	 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
	 * handlers to resolve / reject the PersistencePromise as appropriate.
	 */
	function wrapRequest(request) {
	    return new PersistencePromise(function (resolve, reject) {
	        request.onsuccess = function (event) {
	            var result = event.target.result;
	            resolve(result);
	        };
	        request.onerror = function (event) {
	            var error = checkForAndReportiOSError(event.target.error);
	            reject(error);
	        };
	    });
	}
	// Guard so we only report the error once.
	var reportedIOSError = false;
	function checkForAndReportiOSError(error) {
	    var iOSVersion = SimpleDb.getIOSVersion(util.getUA());
	    if (iOSVersion >= 12.2 && iOSVersion < 13) {
	        var IOS_ERROR = 'An internal error was encountered in the Indexed Database server';
	        if (error.message.indexOf(IOS_ERROR) >= 0) {
	            // Wrap error in a more descriptive one.
	            var newError_1 = new FirestoreError('internal', "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '" + IOS_ERROR + "'. This is likely " +
	                "due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 " +
	                "for details and a potential workaround.");
	            if (!reportedIOSError) {
	                reportedIOSError = true;
	                // Throw a global exception outside of this promise chain, for the user to
	                // potentially catch.
	                setTimeout(function () {
	                    throw newError_1;
	                }, 0);
	            }
	            return newError_1;
	        }
	    }
	    return error;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** A mutation queue for a specific user, backed by IndexedDB. */
	var IndexedDbMutationQueue = /** @class */ (function () {
	    function IndexedDbMutationQueue(
	    /**
	     * The normalized userId (e.g. null UID => "" userId) used to store /
	     * retrieve mutations.
	     */
	    userId, serializer, indexManager, referenceDelegate) {
	        this.userId = userId;
	        this.serializer = serializer;
	        this.indexManager = indexManager;
	        this.referenceDelegate = referenceDelegate;
	        /**
	         * Caches the document keys for pending mutation batches. If the mutation
	         * has been removed from IndexedDb, the cached value may continue to
	         * be used to retrieve the batch's document keys. To remove a cached value
	         * locally, `removeCachedMutationKeys()` should be invoked either directly
	         * or through `removeMutationBatches()`.
	         *
	         * With multi-tab, when the primary client acknowledges or rejects a mutation,
	         * this cache is used by secondary clients to invalidate the local
	         * view of the documents that were previously affected by the mutation.
	         */
	        // PORTING NOTE: Multi-tab only.
	        this.documentKeysByBatchId = {};
	    }
	    /**
	     * Creates a new mutation queue for the given user.
	     * @param user The user for which to create a mutation queue.
	     * @param serializer The serializer to use when persisting to IndexedDb.
	     */
	    IndexedDbMutationQueue.forUser = function (user, serializer, indexManager, referenceDelegate) {
	        // TODO(mcg): Figure out what constraints there are on userIDs
	        // In particular, are there any reserved characters? are empty ids allowed?
	        // For the moment store these together in the same mutations table assuming
	        // that empty userIDs aren't allowed.
	        assert(user.uid !== '', 'UserID must not be an empty string.');
	        var userId = user.isAuthenticated() ? user.uid : '';
	        return new IndexedDbMutationQueue(userId, serializer, indexManager, referenceDelegate);
	    };
	    IndexedDbMutationQueue.prototype.checkEmpty = function (transaction) {
	        var empty = true;
	        var range = IDBKeyRange.bound([this.userId, Number.NEGATIVE_INFINITY], [this.userId, Number.POSITIVE_INFINITY]);
	        return mutationsStore(transaction)
	            .iterate({ index: DbMutationBatch.userMutationsIndex, range: range }, function (key, value, control) {
	            empty = false;
	            control.done();
	        })
	            .next(function () { return empty; });
	    };
	    IndexedDbMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
	        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
	            metadata.lastStreamToken = convertStreamToken(streamToken);
	            return mutationQueuesStore(transaction).put(metadata);
	        });
	    };
	    IndexedDbMutationQueue.prototype.getLastStreamToken = function (transaction) {
	        return this.getMutationQueueMetadata(transaction).next(function (metadata) { return metadata.lastStreamToken; });
	    };
	    IndexedDbMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
	        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
	            metadata.lastStreamToken = convertStreamToken(streamToken);
	            return mutationQueuesStore(transaction).put(metadata);
	        });
	    };
	    IndexedDbMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, baseMutations, mutations) {
	        var _this = this;
	        var documentStore = documentMutationsStore(transaction);
	        var mutationStore = mutationsStore(transaction);
	        // The IndexedDb implementation in Chrome (and Firefox) does not handle
	        // compound indices that include auto-generated keys correctly. To ensure
	        // that the index entry is added correctly in all browsers, we perform two
	        // writes: The first write is used to retrieve the next auto-generated Batch
	        // ID, and the second write populates the index and stores the actual
	        // mutation batch.
	        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
	        // We write an empty object to obtain key
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return mutationStore.add({}).next(function (batchId) {
	            assert(typeof batchId === 'number', 'Auto-generated key is not a number');
	            var batch = new MutationBatch(batchId, localWriteTime, baseMutations, mutations);
	            var dbBatch = _this.serializer.toDbMutationBatch(_this.userId, batch);
	            var promises = [];
	            var collectionParents = new SortedSet(function (l, r) {
	                return primitiveComparator(l.canonicalString(), r.canonicalString());
	            });
	            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
	                var mutation = mutations_1[_i];
	                var indexKey = DbDocumentMutation.key(_this.userId, mutation.key.path, batchId);
	                collectionParents = collectionParents.add(mutation.key.path.popLast());
	                promises.push(mutationStore.put(dbBatch));
	                promises.push(documentStore.put(indexKey, DbDocumentMutation.PLACEHOLDER));
	            }
	            collectionParents.forEach(function (parent) {
	                promises.push(_this.indexManager.addToCollectionParentIndex(transaction, parent));
	            });
	            transaction.addOnCommittedListener(function () {
	                _this.documentKeysByBatchId[batchId] = batch.keys();
	            });
	            return PersistencePromise.waitFor(promises).next(function () { return batch; });
	        });
	    };
	    IndexedDbMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
	        var _this = this;
	        return mutationsStore(transaction)
	            .get(batchId)
	            .next(function (dbBatch) {
	            if (dbBatch) {
	                assert(dbBatch.userId === _this.userId, "Unexpected user '" + dbBatch.userId + "' for mutation batch " + batchId);
	                return _this.serializer.fromDbMutationBatch(dbBatch);
	            }
	            return null;
	        });
	    };
	    IndexedDbMutationQueue.prototype.lookupMutationKeys = function (transaction, batchId) {
	        var _this = this;
	        if (this.documentKeysByBatchId[batchId]) {
	            return PersistencePromise.resolve(this.documentKeysByBatchId[batchId]);
	        }
	        else {
	            return this.lookupMutationBatch(transaction, batchId).next(function (batch) {
	                if (batch) {
	                    var keys = batch.keys();
	                    _this.documentKeysByBatchId[batchId] = keys;
	                    return keys;
	                }
	                else {
	                    return null;
	                }
	            });
	        }
	    };
	    IndexedDbMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
	        var _this = this;
	        var nextBatchId = batchId + 1;
	        var range = IDBKeyRange.lowerBound([this.userId, nextBatchId]);
	        var foundBatch = null;
	        return mutationsStore(transaction)
	            .iterate({ index: DbMutationBatch.userMutationsIndex, range: range }, function (key, dbBatch, control) {
	            if (dbBatch.userId === _this.userId) {
	                assert(dbBatch.batchId >= nextBatchId, 'Should have found mutation after ' + nextBatchId);
	                foundBatch = _this.serializer.fromDbMutationBatch(dbBatch);
	            }
	            control.done();
	        })
	            .next(function () { return foundBatch; });
	    };
	    IndexedDbMutationQueue.prototype.getHighestUnacknowledgedBatchId = function (transaction) {
	        var range = IDBKeyRange.upperBound([
	            this.userId,
	            Number.POSITIVE_INFINITY
	        ]);
	        var batchId = BATCHID_UNKNOWN;
	        return mutationsStore(transaction)
	            .iterate({ index: DbMutationBatch.userMutationsIndex, range: range, reverse: true }, function (key, dbBatch, control) {
	            batchId = dbBatch.batchId;
	            control.done();
	        })
	            .next(function () { return batchId; });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatches = function (transaction) {
	        var _this = this;
	        var range = IDBKeyRange.bound([this.userId, BATCHID_UNKNOWN], [this.userId, Number.POSITIVE_INFINITY]);
	        return mutationsStore(transaction)
	            .loadAll(DbMutationBatch.userMutationsIndex, range)
	            .next(function (dbBatches) {
	            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
	        });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
	        var _this = this;
	        // Scan the document-mutation index starting with a prefix starting with
	        // the given documentKey.
	        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, documentKey.path);
	        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
	        var results = [];
	        return documentMutationsStore(transaction)
	            .iterate({ range: indexStart }, function (indexKey, _, control) {
	            var userID = indexKey[0], encodedPath = indexKey[1], batchId = indexKey[2];
	            // Only consider rows matching exactly the specific key of
	            // interest. Note that because we order by path first, and we
	            // order terminators before path separators, we'll encounter all
	            // the index rows for documentKey contiguously. In particular, all
	            // the rows for documentKey will occur before any rows for
	            // documents nested in a subcollection beneath documentKey so we
	            // can stop as soon as we hit any such row.
	            var path = decode(encodedPath);
	            if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
	                control.done();
	                return;
	            }
	            // Look up the mutation batch in the store.
	            return mutationsStore(transaction)
	                .get(batchId)
	                .next(function (mutation) {
	                if (!mutation) {
	                    throw fail('Dangling document-mutation reference found: ' +
	                        indexKey +
	                        ' which points to ' +
	                        batchId);
	                }
	                assert(mutation.userId === _this.userId, "Unexpected user '" + mutation.userId + "' for mutation batch " + batchId);
	                results.push(_this.serializer.fromDbMutationBatch(mutation));
	            });
	        })
	            .next(function () { return results; });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys = function (transaction, documentKeys) {
	        var _this = this;
	        var uniqueBatchIDs = new SortedSet(primitiveComparator);
	        var promises = [];
	        documentKeys.forEach(function (documentKey) {
	            var indexStart = DbDocumentMutation.prefixForPath(_this.userId, documentKey.path);
	            var range = IDBKeyRange.lowerBound(indexStart);
	            var promise = documentMutationsStore(transaction).iterate({ range: range }, function (indexKey, _, control) {
	                var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
	                // Only consider rows matching exactly the specific key of
	                // interest. Note that because we order by path first, and we
	                // order terminators before path separators, we'll encounter all
	                // the index rows for documentKey contiguously. In particular, all
	                // the rows for documentKey will occur before any rows for
	                // documents nested in a subcollection beneath documentKey so we
	                // can stop as soon as we hit any such row.
	                var path = decode(encodedPath);
	                if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
	                    control.done();
	                    return;
	                }
	                uniqueBatchIDs = uniqueBatchIDs.add(batchID);
	            });
	            promises.push(promise);
	        });
	        return PersistencePromise.waitFor(promises).next(function () {
	            return _this.lookupMutationBatches(transaction, uniqueBatchIDs);
	        });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
	        var _this = this;
	        assert(!query.isDocumentQuery(), "Document queries shouldn't go down this path");
	        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
	        var queryPath = query.path;
	        var immediateChildrenLength = queryPath.length + 1;
	        // TODO(mcg): Actually implement a single-collection query
	        //
	        // This is actually executing an ancestor query, traversing the whole
	        // subtree below the collection which can be horrifically inefficient for
	        // some structures. The right way to solve this is to implement the full
	        // value index, but that's not in the cards in the near future so this is
	        // the best we can do for the moment.
	        //
	        // Since we don't yet index the actual properties in the mutations, our
	        // current approach is to just return all mutation batches that affect
	        // documents in the collection being queried.
	        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, queryPath);
	        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
	        // Collect up unique batchIDs encountered during a scan of the index. Use a
	        // SortedSet to accumulate batch IDs so they can be traversed in order in a
	        // scan of the main table.
	        var uniqueBatchIDs = new SortedSet(primitiveComparator);
	        return documentMutationsStore(transaction)
	            .iterate({ range: indexStart }, function (indexKey, _, control) {
	            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
	            var path = decode(encodedPath);
	            if (userID !== _this.userId || !queryPath.isPrefixOf(path)) {
	                control.done();
	                return;
	            }
	            // Rows with document keys more than one segment longer than the
	            // query path can't be matches. For example, a query on 'rooms'
	            // can't match the document /rooms/abc/messages/xyx.
	            // TODO(mcg): we'll need a different scanner when we implement
	            // ancestor queries.
	            if (path.length !== immediateChildrenLength) {
	                return;
	            }
	            uniqueBatchIDs = uniqueBatchIDs.add(batchID);
	        })
	            .next(function () { return _this.lookupMutationBatches(transaction, uniqueBatchIDs); });
	    };
	    IndexedDbMutationQueue.prototype.lookupMutationBatches = function (transaction, batchIDs) {
	        var _this = this;
	        var results = [];
	        var promises = [];
	        // TODO(rockwood): Implement this using iterate.
	        batchIDs.forEach(function (batchId) {
	            promises.push(mutationsStore(transaction)
	                .get(batchId)
	                .next(function (mutation) {
	                if (mutation === null) {
	                    throw fail('Dangling document-mutation reference found, ' +
	                        'which points to ' +
	                        batchId);
	                }
	                assert(mutation.userId === _this.userId, "Unexpected user '" + mutation.userId + "' for mutation batch " + batchId);
	                results.push(_this.serializer.fromDbMutationBatch(mutation));
	            }));
	        });
	        return PersistencePromise.waitFor(promises).next(function () { return results; });
	    };
	    IndexedDbMutationQueue.prototype.removeMutationBatch = function (transaction, batch) {
	        var _this = this;
	        return removeMutationBatch(transaction.simpleDbTransaction, this.userId, batch).next(function (removedDocuments) {
	            transaction.addOnCommittedListener(function () {
	                _this.removeCachedMutationKeys(batch.batchId);
	            });
	            return PersistencePromise.forEach(removedDocuments, function (key) {
	                return _this.referenceDelegate.removeMutationReference(transaction, key);
	            });
	        });
	    };
	    IndexedDbMutationQueue.prototype.removeCachedMutationKeys = function (batchId) {
	        delete this.documentKeysByBatchId[batchId];
	    };
	    IndexedDbMutationQueue.prototype.performConsistencyCheck = function (txn) {
	        var _this = this;
	        return this.checkEmpty(txn).next(function (empty) {
	            if (!empty) {
	                return PersistencePromise.resolve();
	            }
	            // Verify that there are no entries in the documentMutations index if
	            // the queue is empty.
	            var startRange = IDBKeyRange.lowerBound(DbDocumentMutation.prefixForUser(_this.userId));
	            var danglingMutationReferences = [];
	            return documentMutationsStore(txn)
	                .iterate({ range: startRange }, function (key, _, control) {
	                var userID = key[0];
	                if (userID !== _this.userId) {
	                    control.done();
	                    return;
	                }
	                else {
	                    var path = decode(key[1]);
	                    danglingMutationReferences.push(path);
	                }
	            })
	                .next(function () {
	                assert(danglingMutationReferences.length === 0, 'Document leak -- detected dangling mutation references when queue is empty. ' +
	                    'Dangling keys: ' +
	                    danglingMutationReferences.map(function (p) { return p.canonicalString(); }));
	            });
	        });
	    };
	    IndexedDbMutationQueue.prototype.containsKey = function (txn, key) {
	        return mutationQueueContainsKey(txn, this.userId, key);
	    };
	    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
	    /** Returns the mutation queue's metadata from IndexedDb. */
	    IndexedDbMutationQueue.prototype.getMutationQueueMetadata = function (transaction) {
	        var _this = this;
	        return mutationQueuesStore(transaction)
	            .get(this.userId)
	            .next(function (metadata) {
	            return (metadata ||
	                new DbMutationQueue(_this.userId, BATCHID_UNKNOWN, 
	                /*lastStreamToken=*/ ''));
	        });
	    };
	    return IndexedDbMutationQueue;
	}());
	/**
	 * @return true if the mutation queue for the given user contains a pending
	 *         mutation for the given key.
	 */
	function mutationQueueContainsKey(txn, userId, key) {
	    var indexKey = DbDocumentMutation.prefixForPath(userId, key.path);
	    var encodedPath = indexKey[1];
	    var startRange = IDBKeyRange.lowerBound(indexKey);
	    var containsKey = false;
	    return documentMutationsStore(txn)
	        .iterate({ range: startRange, keysOnly: true }, function (key, value, control) {
	        var userID = key[0], keyPath = key[1], /*batchID*/ _ = key[2];
	        if (userID === userId && keyPath === encodedPath) {
	            containsKey = true;
	        }
	        control.done();
	    })
	        .next(function () { return containsKey; });
	}
	/** Returns true if any mutation queue contains the given document. */
	function mutationQueuesContainKey(txn, docKey) {
	    var found = false;
	    return mutationQueuesStore(txn)
	        .iterateSerial(function (userId) {
	        return mutationQueueContainsKey(txn, userId, docKey).next(function (containsKey) {
	            if (containsKey) {
	                found = true;
	            }
	            return PersistencePromise.resolve(!containsKey);
	        });
	    })
	        .next(function () { return found; });
	}
	/**
	 * Delete a mutation batch and the associated document mutations.
	 * @return A PersistencePromise of the document mutations that were removed.
	 */
	function removeMutationBatch(txn, userId, batch) {
	    var mutationStore = txn.store(DbMutationBatch.store);
	    var indexTxn = txn.store(DbDocumentMutation.store);
	    var promises = [];
	    var range = IDBKeyRange.only(batch.batchId);
	    var numDeleted = 0;
	    var removePromise = mutationStore.iterate({ range: range }, function (key, value, control) {
	        numDeleted++;
	        return control.delete();
	    });
	    promises.push(removePromise.next(function () {
	        assert(numDeleted === 1, 'Dangling document-mutation reference found: Missing batch ' +
	            batch.batchId);
	    }));
	    var removedDocuments = [];
	    for (var _i = 0, _a = batch.mutations; _i < _a.length; _i++) {
	        var mutation = _a[_i];
	        var indexKey = DbDocumentMutation.key(userId, mutation.key.path, batch.batchId);
	        promises.push(indexTxn.delete(indexKey));
	        removedDocuments.push(mutation.key);
	    }
	    return PersistencePromise.waitFor(promises).next(function () { return removedDocuments; });
	}
	function convertStreamToken(token) {
	    if (token instanceof Uint8Array) {
	        // TODO(b/78771403): Convert tokens to strings during deserialization
	        assert(SimpleDb.isMockPersistence(), 'Persisting non-string stream tokens is only supported with mock persistence.');
	        return token.toString();
	    }
	    else {
	        return token;
	    }
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutations object store.
	 */
	function mutationsStore(txn) {
	    return IndexedDbPersistence.getStore(txn, DbMutationBatch.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
	 */
	function documentMutationsStore(txn) {
	    return IndexedDbPersistence.getStore(txn, DbDocumentMutation.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
	 */
	function mutationQueuesStore(txn) {
	    return IndexedDbPersistence.getStore(txn, DbMutationQueue.store);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var RESERVED_BITS = 1;
	var GeneratorIds;
	(function (GeneratorIds) {
	    GeneratorIds[GeneratorIds["QueryCache"] = 0] = "QueryCache";
	    GeneratorIds[GeneratorIds["SyncEngine"] = 1] = "SyncEngine"; // The target IDs for limbo detection are odd (end in 1).
	})(GeneratorIds || (GeneratorIds = {}));
	/**
	 * Generates monotonically increasing target IDs for sending targets to the
	 * watch stream.
	 *
	 * The client constructs two generators, one for the query cache (via
	 * forQueryCache()), and one for limbo documents (via forSyncEngine()). These
	 * two generators produce non-overlapping IDs (by using even and odd IDs
	 * respectively).
	 *
	 * By separating the target ID space, the query cache can generate target IDs
	 * that persist across client restarts, while sync engine can independently
	 * generate in-memory target IDs that are transient and can be reused after a
	 * restart.
	 */
	// TODO(mrschmidt): Explore removing this class in favor of generating these IDs
	// directly in SyncEngine and LocalStore.
	var TargetIdGenerator = /** @class */ (function () {
	    /**
	     * Instantiates a new TargetIdGenerator. If a seed is provided, the generator
	     * will use the seed value as the next target ID.
	     */
	    function TargetIdGenerator(generatorId, seed) {
	        this.generatorId = generatorId;
	        assert((generatorId & RESERVED_BITS) === generatorId, "Generator ID " + generatorId + " contains more than " + RESERVED_BITS + " reserved bits");
	        this.seek(seed !== undefined ? seed : this.generatorId);
	    }
	    TargetIdGenerator.prototype.next = function () {
	        var nextId = this.nextId;
	        this.nextId += 1 << RESERVED_BITS;
	        return nextId;
	    };
	    /**
	     * Returns the ID that follows the given ID. Subsequent calls to `next()`
	     * use the newly returned target ID as their base.
	     */
	    // PORTING NOTE: Multi-tab only.
	    TargetIdGenerator.prototype.after = function (targetId) {
	        this.seek(targetId + (1 << RESERVED_BITS));
	        return this.next();
	    };
	    TargetIdGenerator.prototype.seek = function (targetId) {
	        assert((targetId & RESERVED_BITS) === this.generatorId, 'Cannot supply target ID from different generator ID');
	        this.nextId = targetId;
	    };
	    TargetIdGenerator.forTargetCache = function () {
	        // We seed the query cache generator to return '2' as its first ID, as there
	        // is no differentiation in the protocol layer between an unset number and
	        // the number '0'. If we were to sent a target with target ID '0', the
	        // backend would consider it unset and replace it with its own ID.
	        var targetIdGenerator = new TargetIdGenerator(GeneratorIds.QueryCache, 2);
	        return targetIdGenerator;
	    };
	    TargetIdGenerator.forSyncEngine = function () {
	        // Sync engine assigns target IDs for limbo document detection.
	        return new TargetIdGenerator(GeneratorIds.SyncEngine);
	    };
	    return TargetIdGenerator;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var IndexedDbTargetCache = /** @class */ (function () {
	    function IndexedDbTargetCache(referenceDelegate, serializer) {
	        this.referenceDelegate = referenceDelegate;
	        this.serializer = serializer;
	        // PORTING NOTE: We don't cache global metadata for the target cache, since
	        // some of it (in particular `highestTargetId`) can be modified by secondary
	        // tabs. We could perhaps be more granular (and e.g. still cache
	        // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
	        // to IndexedDb whenever we need to read metadata. We can revisit if it turns
	        // out to have a meaningful performance impact.
	        this.targetIdGenerator = TargetIdGenerator.forTargetCache();
	    }
	    IndexedDbTargetCache.prototype.allocateTargetId = function (transaction) {
	        var _this = this;
	        return this.retrieveMetadata(transaction).next(function (metadata) {
	            metadata.highestTargetId = _this.targetIdGenerator.after(metadata.highestTargetId);
	            return _this.saveMetadata(transaction, metadata).next(function () { return metadata.highestTargetId; });
	        });
	    };
	    IndexedDbTargetCache.prototype.getLastRemoteSnapshotVersion = function (transaction) {
	        return this.retrieveMetadata(transaction).next(function (metadata) {
	            return SnapshotVersion.fromTimestamp(new Timestamp(metadata.lastRemoteSnapshotVersion.seconds, metadata.lastRemoteSnapshotVersion.nanoseconds));
	        });
	    };
	    IndexedDbTargetCache.prototype.getHighestSequenceNumber = function (transaction) {
	        return getHighestListenSequenceNumber(transaction.simpleDbTransaction);
	    };
	    IndexedDbTargetCache.prototype.setTargetsMetadata = function (transaction, highestListenSequenceNumber, lastRemoteSnapshotVersion) {
	        var _this = this;
	        return this.retrieveMetadata(transaction).next(function (metadata) {
	            metadata.highestListenSequenceNumber = highestListenSequenceNumber;
	            if (lastRemoteSnapshotVersion) {
	                metadata.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion.toTimestamp();
	            }
	            if (highestListenSequenceNumber > metadata.highestListenSequenceNumber) {
	                metadata.highestListenSequenceNumber = highestListenSequenceNumber;
	            }
	            return _this.saveMetadata(transaction, metadata);
	        });
	    };
	    IndexedDbTargetCache.prototype.addTargetData = function (transaction, targetData) {
	        var _this = this;
	        return this.saveTargetData(transaction, targetData).next(function () {
	            return _this.retrieveMetadata(transaction).next(function (metadata) {
	                metadata.targetCount += 1;
	                _this.updateMetadataFromTargetData(targetData, metadata);
	                return _this.saveMetadata(transaction, metadata);
	            });
	        });
	    };
	    IndexedDbTargetCache.prototype.updateTargetData = function (transaction, targetData) {
	        return this.saveTargetData(transaction, targetData);
	    };
	    IndexedDbTargetCache.prototype.removeTargetData = function (transaction, targetData) {
	        var _this = this;
	        return this.removeMatchingKeysForTargetId(transaction, targetData.targetId)
	            .next(function () { return targetsStore(transaction).delete(targetData.targetId); })
	            .next(function () { return _this.retrieveMetadata(transaction); })
	            .next(function (metadata) {
	            assert(metadata.targetCount > 0, 'Removing from an empty target cache');
	            metadata.targetCount -= 1;
	            return _this.saveMetadata(transaction, metadata);
	        });
	    };
	    /**
	     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
	     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
	     * Returns the number of targets removed.
	     */
	    IndexedDbTargetCache.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
	        var _this = this;
	        var count = 0;
	        var promises = [];
	        return targetsStore(txn)
	            .iterate(function (key, value) {
	            var targetData = _this.serializer.fromDbTarget(value);
	            if (targetData.sequenceNumber <= upperBound &&
	                activeTargetIds.get(targetData.targetId) === null) {
	                count++;
	                promises.push(_this.removeTargetData(txn, targetData));
	            }
	        })
	            .next(function () { return PersistencePromise.waitFor(promises); })
	            .next(function () { return count; });
	    };
	    /**
	     * Call provided function with each `TargetData` that we have cached.
	     */
	    IndexedDbTargetCache.prototype.forEachTarget = function (txn, f) {
	        var _this = this;
	        return targetsStore(txn).iterate(function (key, value) {
	            var targetData = _this.serializer.fromDbTarget(value);
	            f(targetData);
	        });
	    };
	    IndexedDbTargetCache.prototype.retrieveMetadata = function (transaction) {
	        return retrieveMetadata(transaction.simpleDbTransaction);
	    };
	    IndexedDbTargetCache.prototype.saveMetadata = function (transaction, metadata) {
	        return globalTargetStore(transaction).put(DbTargetGlobal.key, metadata);
	    };
	    IndexedDbTargetCache.prototype.saveTargetData = function (transaction, targetData) {
	        return targetsStore(transaction).put(this.serializer.toDbTarget(targetData));
	    };
	    /**
	     * In-place updates the provided metadata to account for values in the given
	     * TargetData. Saving is done separately. Returns true if there were any
	     * changes to the metadata.
	     */
	    IndexedDbTargetCache.prototype.updateMetadataFromTargetData = function (targetData, metadata) {
	        var updated = false;
	        if (targetData.targetId > metadata.highestTargetId) {
	            metadata.highestTargetId = targetData.targetId;
	            updated = true;
	        }
	        if (targetData.sequenceNumber > metadata.highestListenSequenceNumber) {
	            metadata.highestListenSequenceNumber = targetData.sequenceNumber;
	            updated = true;
	        }
	        return updated;
	    };
	    IndexedDbTargetCache.prototype.getTargetCount = function (transaction) {
	        return this.retrieveMetadata(transaction).next(function (metadata) { return metadata.targetCount; });
	    };
	    IndexedDbTargetCache.prototype.getTargetData = function (transaction, target) {
	        var _this = this;
	        // Iterating by the canonicalId may yield more than one result because
	        // canonicalId values are not required to be unique per target. This query
	        // depends on the queryTargets index to be efficient.
	        var canonicalId = target.canonicalId();
	        var range = IDBKeyRange.bound([canonicalId, Number.NEGATIVE_INFINITY], [canonicalId, Number.POSITIVE_INFINITY]);
	        var result = null;
	        return targetsStore(transaction)
	            .iterate({ range: range, index: DbTarget.queryTargetsIndexName }, function (key, value, control) {
	            var found = _this.serializer.fromDbTarget(value);
	            // After finding a potential match, check that the target is
	            // actually equal to the requested target.
	            if (target.isEqual(found.target)) {
	                result = found;
	                control.done();
	            }
	        })
	            .next(function () { return result; });
	    };
	    IndexedDbTargetCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
	        var _this = this;
	        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
	        // IndexedDb.
	        var promises = [];
	        var store = documentTargetStore(txn);
	        keys.forEach(function (key) {
	            var path = encode(key.path);
	            promises.push(store.put(new DbTargetDocument(targetId, path)));
	            promises.push(_this.referenceDelegate.addReference(txn, key));
	        });
	        return PersistencePromise.waitFor(promises);
	    };
	    IndexedDbTargetCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
	        var _this = this;
	        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
	        // IndexedDb.
	        var store = documentTargetStore(txn);
	        return PersistencePromise.forEach(keys, function (key) {
	            var path = encode(key.path);
	            return PersistencePromise.waitFor([
	                store.delete([targetId, path]),
	                _this.referenceDelegate.removeReference(txn, key)
	            ]);
	        });
	    };
	    IndexedDbTargetCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
	        var store = documentTargetStore(txn);
	        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        return store.delete(range);
	    };
	    IndexedDbTargetCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
	        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        var store = documentTargetStore(txn);
	        var result = documentKeySet();
	        return store
	            .iterate({ range: range, keysOnly: true }, function (key, _, control) {
	            var path = decode(key[1]);
	            var docKey = new DocumentKey(path);
	            result = result.add(docKey);
	        })
	            .next(function () { return result; });
	    };
	    IndexedDbTargetCache.prototype.containsKey = function (txn, key) {
	        var path = encode(key.path);
	        var range = IDBKeyRange.bound([path], [immediateSuccessor(path)], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        var count = 0;
	        return documentTargetStore(txn)
	            .iterate({
	            index: DbTargetDocument.documentTargetsIndex,
	            keysOnly: true,
	            range: range
	        }, function (_a, _, control) {
	            var targetId = _a[0], path = _a[1];
	            // Having a sentinel row for a document does not count as containing that document;
	            // For the target cache, containing the document means the document is part of some
	            // target.
	            if (targetId !== 0) {
	                count++;
	                control.done();
	            }
	        })
	            .next(function () { return count > 0; });
	    };
	    IndexedDbTargetCache.prototype.getTargetDataForTarget = function (transaction, targetId) {
	        var _this = this;
	        return targetsStore(transaction)
	            .get(targetId)
	            .next(function (found) {
	            if (found) {
	                return _this.serializer.fromDbTarget(found);
	            }
	            else {
	                return null;
	            }
	        });
	    };
	    return IndexedDbTargetCache;
	}());
	/**
	 * Helper to get a typed SimpleDbStore for the queries object store.
	 */
	function targetsStore(txn) {
	    return IndexedDbPersistence.getStore(txn, DbTarget.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the target globals object store.
	 */
	function globalTargetStore(txn) {
	    return IndexedDbPersistence.getStore(txn, DbTargetGlobal.store);
	}
	function retrieveMetadata(txn) {
	    var globalStore = SimpleDb.getStore(txn, DbTargetGlobal.store);
	    return globalStore.get(DbTargetGlobal.key).next(function (metadata) {
	        assert(metadata !== null, 'Missing metadata row.');
	        return metadata;
	    });
	}
	function getHighestListenSequenceNumber(txn) {
	    return retrieveMetadata(txn).next(function (targetGlobal) { return targetGlobal.highestListenSequenceNumber; });
	}
	/**
	 * Helper to get a typed SimpleDbStore for the document target object store.
	 */
	function documentTargetStore(txn) {
	    return IndexedDbPersistence.getStore(txn, DbTargetDocument.store);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides a set of fields that can be used to partially patch a document.
	 * FieldMask is used in conjunction with ObjectValue.
	 * Examples:
	 *   foo - Overwrites foo entirely with the provided value. If foo is not
	 *         present in the companion ObjectValue, the field is deleted.
	 *   foo.bar - Overwrites only the field bar of the object foo.
	 *             If foo is not an object, foo is replaced with an object
	 *             containing foo
	 */
	var FieldMask = /** @class */ (function () {
	    function FieldMask(fields) {
	        this.fields = fields;
	        // TODO(dimond): validation of FieldMask
	    }
	    FieldMask.fromSet = function (fields) {
	        return new FieldMask(fields);
	    };
	    FieldMask.fromArray = function (fields) {
	        var fieldsAsSet = new SortedSet(FieldPath.comparator);
	        fields.forEach(function (fieldPath) { return (fieldsAsSet = fieldsAsSet.add(fieldPath)); });
	        return new FieldMask(fieldsAsSet);
	    };
	    /**
	     * Verifies that `fieldPath` is included by at least one field in this field
	     * mask.
	     *
	     * This is an O(n) operation, where `n` is the size of the field mask.
	     */
	    FieldMask.prototype.covers = function (fieldPath) {
	        var found = false;
	        this.fields.forEach(function (fieldMaskPath) {
	            if (fieldMaskPath.isPrefixOf(fieldPath)) {
	                found = true;
	            }
	        });
	        return found;
	    };
	    FieldMask.prototype.isEqual = function (other) {
	        return this.fields.isEqual(other.fields);
	    };
	    return FieldMask;
	}());
	/** A field path and the TransformOperation to perform upon it. */
	var FieldTransform = /** @class */ (function () {
	    function FieldTransform(field, transform) {
	        this.field = field;
	        this.transform = transform;
	    }
	    FieldTransform.prototype.isEqual = function (other) {
	        return (this.field.isEqual(other.field) && this.transform.isEqual(other.transform));
	    };
	    return FieldTransform;
	}());
	/** The result of successfully applying a mutation to the backend. */
	var MutationResult = /** @class */ (function () {
	    function MutationResult(
	    /**
	     * The version at which the mutation was committed:
	     *
	     * - For most operations, this is the updateTime in the WriteResult.
	     * - For deletes, the commitTime of the WriteResponse (because deletes are
	     *   not stored and have no updateTime).
	     *
	     * Note that these versions can be different: No-op writes will not change
	     * the updateTime even though the commitTime advances.
	     */
	    version, 
	    /**
	     * The resulting fields returned from the backend after a
	     * TransformMutation has been committed. Contains one FieldValue for each
	     * FieldTransform that was in the mutation.
	     *
	     * Will be null if the mutation was not a TransformMutation.
	     */
	    transformResults) {
	        this.version = version;
	        this.transformResults = transformResults;
	    }
	    return MutationResult;
	}());
	var MutationType;
	(function (MutationType) {
	    MutationType[MutationType["Set"] = 0] = "Set";
	    MutationType[MutationType["Patch"] = 1] = "Patch";
	    MutationType[MutationType["Transform"] = 2] = "Transform";
	    MutationType[MutationType["Delete"] = 3] = "Delete";
	    MutationType[MutationType["Verify"] = 4] = "Verify";
	})(MutationType || (MutationType = {}));
	/**
	 * Encodes a precondition for a mutation. This follows the model that the
	 * backend accepts with the special case of an explicit "empty" precondition
	 * (meaning no precondition).
	 */
	var Precondition = /** @class */ (function () {
	    function Precondition(updateTime, exists) {
	        this.updateTime = updateTime;
	        this.exists = exists;
	        assert(updateTime === undefined || exists === undefined, 'Precondition can specify "exists" or "updateTime" but not both');
	    }
	    /** Creates a new Precondition with an exists flag. */
	    Precondition.exists = function (exists) {
	        return new Precondition(undefined, exists);
	    };
	    /** Creates a new Precondition based on a version a document exists at. */
	    Precondition.updateTime = function (version) {
	        return new Precondition(version);
	    };
	    Object.defineProperty(Precondition.prototype, "isNone", {
	        /** Returns whether this Precondition is empty. */
	        get: function () {
	            return this.updateTime === undefined && this.exists === undefined;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns true if the preconditions is valid for the given document
	     * (or null if no document is available).
	     */
	    Precondition.prototype.isValidFor = function (maybeDoc) {
	        if (this.updateTime !== undefined) {
	            return (maybeDoc instanceof Document &&
	                maybeDoc.version.isEqual(this.updateTime));
	        }
	        else if (this.exists !== undefined) {
	            return this.exists === maybeDoc instanceof Document;
	        }
	        else {
	            assert(this.isNone, 'Precondition should be empty');
	            return true;
	        }
	    };
	    Precondition.prototype.isEqual = function (other) {
	        return (equals(this.updateTime, other.updateTime) &&
	            this.exists === other.exists);
	    };
	    Precondition.NONE = new Precondition();
	    return Precondition;
	}());
	/**
	 * A mutation describes a self-contained change to a document. Mutations can
	 * create, replace, delete, and update subsets of documents.
	 *
	 * Mutations not only act on the value of the document but also its version.
	 *
	 * For local mutations (mutations that haven't been committed yet), we preserve
	 * the existing version for Set, Patch, and Transform mutations. For Delete
	 * mutations, we reset the version to 0.
	 *
	 * Here's the expected transition table.
	 *
	 * MUTATION           APPLIED TO            RESULTS IN
	 *
	 * SetMutation        Document(v3)          Document(v3)
	 * SetMutation        NoDocument(v3)        Document(v0)
	 * SetMutation        null                  Document(v0)
	 * PatchMutation      Document(v3)          Document(v3)
	 * PatchMutation      NoDocument(v3)        NoDocument(v3)
	 * PatchMutation      null                  null
	 * TransformMutation  Document(v3)          Document(v3)
	 * TransformMutation  NoDocument(v3)        NoDocument(v3)
	 * TransformMutation  null                  null
	 * DeleteMutation     Document(v3)          NoDocument(v0)
	 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
	 * DeleteMutation     null                  NoDocument(v0)
	 *
	 * For acknowledged mutations, we use the updateTime of the WriteResponse as
	 * the resulting version for Set, Patch, and Transform mutations. As deletes
	 * have no explicit update time, we use the commitTime of the WriteResponse for
	 * Delete mutations.
	 *
	 * If a mutation is acknowledged by the backend but fails the precondition check
	 * locally, we return an `UnknownDocument` and rely on Watch to send us the
	 * updated version.
	 *
	 * Note that TransformMutations don't create Documents (in the case of being
	 * applied to a NoDocument), even though they would on the backend. This is
	 * because the client always combines the TransformMutation with a SetMutation
	 * or PatchMutation and we only want to apply the transform if the prior
	 * mutation resulted in a Document (always true for a SetMutation, but not
	 * necessarily for a PatchMutation).
	 *
	 * ## Subclassing Notes
	 *
	 * Subclasses of Mutation need to implement applyToRemoteDocument() and
	 * applyToLocalView() to implement the actual behavior of applying the mutation
	 * to some source document.
	 */
	var Mutation = /** @class */ (function () {
	    function Mutation() {
	    }
	    Mutation.prototype.verifyKeyMatches = function (maybeDoc) {
	        if (maybeDoc != null) {
	            assert(maybeDoc.key.isEqual(this.key), 'Can only apply a mutation to a document with the same key');
	        }
	    };
	    /**
	     * Returns the version from the given document for use as the result of a
	     * mutation. Mutations are defined to return the version of the base document
	     * only if it is an existing document. Deleted and unknown documents have a
	     * post-mutation version of SnapshotVersion.MIN.
	     */
	    Mutation.getPostMutationVersion = function (maybeDoc) {
	        if (maybeDoc instanceof Document) {
	            return maybeDoc.version;
	        }
	        else {
	            return SnapshotVersion.MIN;
	        }
	    };
	    return Mutation;
	}());
	/**
	 * A mutation that creates or replaces the document at the given key with the
	 * object value contents.
	 */
	var SetMutation = /** @class */ (function (_super) {
	    tslib.__extends(SetMutation, _super);
	    function SetMutation(key, value, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.value = value;
	        _this.precondition = precondition;
	        _this.type = MutationType.Set;
	        return _this;
	    }
	    SetMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert(mutationResult.transformResults == null, 'Transform results received by SetMutation.');
	        // Unlike applyToLocalView, if we're applying a mutation to a remote
	        // document the server has accepted the mutation so the precondition must
	        // have held.
	        var version = mutationResult.version;
	        return new Document(this.key, version, {
	            hasCommittedMutations: true
	        }, this.value);
	    };
	    SetMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        return new Document(this.key, version, {
	            hasLocalMutations: true
	        }, this.value);
	    };
	    SetMutation.prototype.extractBaseValue = function (maybeDoc) {
	        return null;
	    };
	    SetMutation.prototype.isEqual = function (other) {
	        return (other instanceof SetMutation &&
	            this.key.isEqual(other.key) &&
	            this.value.isEqual(other.value) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    return SetMutation;
	}(Mutation));
	/**
	 * A mutation that modifies fields of the document at the given key with the
	 * given values. The values are applied through a field mask:
	 *
	 *  * When a field is in both the mask and the values, the corresponding field
	 *    is updated.
	 *  * When a field is in neither the mask nor the values, the corresponding
	 *    field is unmodified.
	 *  * When a field is in the mask but not in the values, the corresponding field
	 *    is deleted.
	 *  * When a field is not in the mask but is in the values, the values map is
	 *    ignored.
	 */
	var PatchMutation = /** @class */ (function (_super) {
	    tslib.__extends(PatchMutation, _super);
	    function PatchMutation(key, data, fieldMask, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.data = data;
	        _this.fieldMask = fieldMask;
	        _this.precondition = precondition;
	        _this.type = MutationType.Patch;
	        return _this;
	    }
	    PatchMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert(mutationResult.transformResults == null, 'Transform results received by PatchMutation.');
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            // Since the mutation was not rejected, we know that the  precondition
	            // matched on the backend. We therefore must not have the expected version
	            // of the document in our cache and return an UnknownDocument with the
	            // known updateTime.
	            return new UnknownDocument(this.key, mutationResult.version);
	        }
	        var newData = this.patchDocument(maybeDoc);
	        return new Document(this.key, mutationResult.version, {
	            hasCommittedMutations: true
	        }, newData);
	    };
	    PatchMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        var newData = this.patchDocument(maybeDoc);
	        return new Document(this.key, version, {
	            hasLocalMutations: true
	        }, newData);
	    };
	    PatchMutation.prototype.extractBaseValue = function (maybeDoc) {
	        return null;
	    };
	    PatchMutation.prototype.isEqual = function (other) {
	        return (other instanceof PatchMutation &&
	            this.key.isEqual(other.key) &&
	            this.fieldMask.isEqual(other.fieldMask) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    /**
	     * Patches the data of document if available or creates a new document. Note
	     * that this does not check whether or not the precondition of this patch
	     * holds.
	     */
	    PatchMutation.prototype.patchDocument = function (maybeDoc) {
	        var data;
	        if (maybeDoc instanceof Document) {
	            data = maybeDoc.data();
	        }
	        else {
	            data = ObjectValue.EMPTY;
	        }
	        return this.patchObject(data);
	    };
	    PatchMutation.prototype.patchObject = function (data) {
	        var _this = this;
	        this.fieldMask.fields.forEach(function (fieldPath) {
	            if (!fieldPath.isEmpty()) {
	                var newValue = _this.data.field(fieldPath);
	                if (newValue !== null) {
	                    data = data.set(fieldPath, newValue);
	                }
	                else {
	                    data = data.delete(fieldPath);
	                }
	            }
	        });
	        return data;
	    };
	    return PatchMutation;
	}(Mutation));
	/**
	 * A mutation that modifies specific fields of the document with transform
	 * operations. Currently the only supported transform is a server timestamp, but
	 * IP Address, increment(n), etc. could be supported in the future.
	 *
	 * It is somewhat similar to a PatchMutation in that it patches specific fields
	 * and has no effect when applied to a null or NoDocument (see comment on
	 * Mutation for rationale).
	 */
	var TransformMutation = /** @class */ (function (_super) {
	    tslib.__extends(TransformMutation, _super);
	    function TransformMutation(key, fieldTransforms) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.fieldTransforms = fieldTransforms;
	        _this.type = MutationType.Transform;
	        // NOTE: We set a precondition of exists: true as a safety-check, since we
	        // always combine TransformMutations with a SetMutation or PatchMutation which
	        // (if successful) should end up with an existing document.
	        _this.precondition = Precondition.exists(true);
	        return _this;
	    }
	    TransformMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert(mutationResult.transformResults != null, 'Transform results missing for TransformMutation.');
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            // Since the mutation was not rejected, we know that the  precondition
	            // matched on the backend. We therefore must not have the expected version
	            // of the document in our cache and return an UnknownDocument with the
	            // known updateTime.
	            return new UnknownDocument(this.key, mutationResult.version);
	        }
	        var doc = this.requireDocument(maybeDoc);
	        var transformResults = this.serverTransformResults(maybeDoc, mutationResult.transformResults);
	        var version = mutationResult.version;
	        var newData = this.transformObject(doc.data(), transformResults);
	        return new Document(this.key, version, {
	            hasCommittedMutations: true
	        }, newData);
	    };
	    TransformMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var doc = this.requireDocument(maybeDoc);
	        var transformResults = this.localTransformResults(localWriteTime, maybeDoc, baseDoc);
	        var newData = this.transformObject(doc.data(), transformResults);
	        return new Document(this.key, doc.version, {
	            hasLocalMutations: true
	        }, newData);
	    };
	    TransformMutation.prototype.extractBaseValue = function (maybeDoc) {
	        var baseObject = null;
	        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
	            var fieldTransform = _a[_i];
	            var existingValue = maybeDoc instanceof Document
	                ? maybeDoc.field(fieldTransform.field)
	                : undefined;
	            var coercedValue = fieldTransform.transform.computeBaseValue(existingValue || null);
	            if (coercedValue != null) {
	                if (baseObject == null) {
	                    baseObject = ObjectValue.EMPTY.set(fieldTransform.field, coercedValue);
	                }
	                else {
	                    baseObject = baseObject.set(fieldTransform.field, coercedValue);
	                }
	            }
	        }
	        return baseObject;
	    };
	    TransformMutation.prototype.isEqual = function (other) {
	        return (other instanceof TransformMutation &&
	            this.key.isEqual(other.key) &&
	            arrayEquals(this.fieldTransforms, other.fieldTransforms) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    /**
	     * Asserts that the given MaybeDocument is actually a Document and verifies
	     * that it matches the key for this mutation. Since we only support
	     * transformations with precondition exists this method is guaranteed to be
	     * safe.
	     */
	    TransformMutation.prototype.requireDocument = function (maybeDoc) {
	        assert(maybeDoc instanceof Document, 'Unknown MaybeDocument type ' + maybeDoc);
	        assert(maybeDoc.key.isEqual(this.key), 'Can only transform a document with the same key');
	        return maybeDoc;
	    };
	    /**
	     * Creates a list of "transform results" (a transform result is a field value
	     * representing the result of applying a transform) for use after a
	     * TransformMutation has been acknowledged by the server.
	     *
	     * @param baseDoc The document prior to applying this mutation batch.
	     * @param serverTransformResults The transform results received by the server.
	     * @return The transform results list.
	     */
	    TransformMutation.prototype.serverTransformResults = function (baseDoc, serverTransformResults) {
	        var transformResults = [];
	        assert(this.fieldTransforms.length === serverTransformResults.length, "server transform result count (" + serverTransformResults.length + ") " +
	            ("should match field transform count (" + this.fieldTransforms.length + ")"));
	        for (var i = 0; i < serverTransformResults.length; i++) {
	            var fieldTransform = this.fieldTransforms[i];
	            var transform = fieldTransform.transform;
	            var previousValue = null;
	            if (baseDoc instanceof Document) {
	                previousValue = baseDoc.field(fieldTransform.field);
	            }
	            transformResults.push(transform.applyToRemoteDocument(previousValue, serverTransformResults[i]));
	        }
	        return transformResults;
	    };
	    /**
	     * Creates a list of "transform results" (a transform result is a field value
	     * representing the result of applying a transform) for use when applying a
	     * TransformMutation locally.
	     *
	     * @param localWriteTime The local time of the transform mutation (used to
	     *     generate ServerTimestampValues).
	     * @param maybeDoc The current state of the document after applying all
	     *     previous mutations.
	     * @param baseDoc The document prior to applying this mutation batch.
	     * @return The transform results list.
	     */
	    TransformMutation.prototype.localTransformResults = function (localWriteTime, maybeDoc, baseDoc) {
	        var transformResults = [];
	        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
	            var fieldTransform = _a[_i];
	            var transform = fieldTransform.transform;
	            var previousValue = null;
	            if (maybeDoc instanceof Document) {
	                previousValue = maybeDoc.field(fieldTransform.field);
	            }
	            if (previousValue === null && baseDoc instanceof Document) {
	                // If the current document does not contain a value for the mutated
	                // field, use the value that existed before applying this mutation
	                // batch. This solves an edge case where a PatchMutation clears the
	                // values in a nested map before the TransformMutation is applied.
	                previousValue = baseDoc.field(fieldTransform.field);
	            }
	            transformResults.push(transform.applyToLocalView(previousValue, localWriteTime));
	        }
	        return transformResults;
	    };
	    TransformMutation.prototype.transformObject = function (data, transformResults) {
	        assert(transformResults.length === this.fieldTransforms.length, 'TransformResults length mismatch.');
	        for (var i = 0; i < this.fieldTransforms.length; i++) {
	            var fieldTransform = this.fieldTransforms[i];
	            var fieldPath = fieldTransform.field;
	            data = data.set(fieldPath, transformResults[i]);
	        }
	        return data;
	    };
	    return TransformMutation;
	}(Mutation));
	/** A mutation that deletes the document at the given key. */
	var DeleteMutation = /** @class */ (function (_super) {
	    tslib.__extends(DeleteMutation, _super);
	    function DeleteMutation(key, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.precondition = precondition;
	        _this.type = MutationType.Delete;
	        return _this;
	    }
	    DeleteMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert(mutationResult.transformResults == null, 'Transform results received by DeleteMutation.');
	        // Unlike applyToLocalView, if we're applying a mutation to a remote
	        // document the server has accepted the mutation so the precondition must
	        // have held.
	        return new NoDocument(this.key, mutationResult.version, {
	            hasCommittedMutations: true
	        });
	    };
	    DeleteMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        if (maybeDoc) {
	            assert(maybeDoc.key.isEqual(this.key), 'Can only apply mutation to document with same key');
	        }
	        return new NoDocument(this.key, SnapshotVersion.forDeletedDoc());
	    };
	    DeleteMutation.prototype.extractBaseValue = function (maybeDoc) {
	        return null;
	    };
	    DeleteMutation.prototype.isEqual = function (other) {
	        return (other instanceof DeleteMutation &&
	            this.key.isEqual(other.key) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    return DeleteMutation;
	}(Mutation));
	/**
	 * A mutation that verifies the existence of the document at the given key with
	 * the provided precondition.
	 *
	 * The `verify` operation is only used in Transactions, and this class serves
	 * primarily to facilitate serialization into protos.
	 */
	var VerifyMutation = /** @class */ (function (_super) {
	    tslib.__extends(VerifyMutation, _super);
	    function VerifyMutation(key, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.precondition = precondition;
	        _this.type = MutationType.Verify;
	        return _this;
	    }
	    VerifyMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        fail('VerifyMutation should only be used in Transactions.');
	    };
	    VerifyMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
	        fail('VerifyMutation should only be used in Transactions.');
	    };
	    VerifyMutation.prototype.extractBaseValue = function (maybeDoc) {
	        fail('VerifyMutation should only be used in Transactions.');
	    };
	    VerifyMutation.prototype.isEqual = function (other) {
	        return (other instanceof VerifyMutation &&
	            this.key.isEqual(other.key) &&
	            this.precondition.isEqual(other.precondition));
	    };
	    return VerifyMutation;
	}(Mutation));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TypeOrder;
	(function (TypeOrder) {
	    // This order is defined by the backend.
	    TypeOrder[TypeOrder["NullValue"] = 0] = "NullValue";
	    TypeOrder[TypeOrder["BooleanValue"] = 1] = "BooleanValue";
	    TypeOrder[TypeOrder["NumberValue"] = 2] = "NumberValue";
	    TypeOrder[TypeOrder["TimestampValue"] = 3] = "TimestampValue";
	    TypeOrder[TypeOrder["StringValue"] = 4] = "StringValue";
	    TypeOrder[TypeOrder["BlobValue"] = 5] = "BlobValue";
	    TypeOrder[TypeOrder["RefValue"] = 6] = "RefValue";
	    TypeOrder[TypeOrder["GeoPointValue"] = 7] = "GeoPointValue";
	    TypeOrder[TypeOrder["ArrayValue"] = 8] = "ArrayValue";
	    TypeOrder[TypeOrder["ObjectValue"] = 9] = "ObjectValue";
	})(TypeOrder || (TypeOrder = {}));
	/** Defines the return value for pending server timestamps. */
	var ServerTimestampBehavior;
	(function (ServerTimestampBehavior) {
	    ServerTimestampBehavior[ServerTimestampBehavior["Default"] = 0] = "Default";
	    ServerTimestampBehavior[ServerTimestampBehavior["Estimate"] = 1] = "Estimate";
	    ServerTimestampBehavior[ServerTimestampBehavior["Previous"] = 2] = "Previous";
	})(ServerTimestampBehavior || (ServerTimestampBehavior = {}));
	/** Holds properties that define field value deserialization options. */
	var FieldValueOptions = /** @class */ (function () {
	    function FieldValueOptions(serverTimestampBehavior, timestampsInSnapshots) {
	        this.serverTimestampBehavior = serverTimestampBehavior;
	        this.timestampsInSnapshots = timestampsInSnapshots;
	    }
	    FieldValueOptions.fromSnapshotOptions = function (options, timestampsInSnapshots) {
	        switch (options.serverTimestamps) {
	            case 'estimate':
	                return new FieldValueOptions(ServerTimestampBehavior.Estimate, timestampsInSnapshots);
	            case 'previous':
	                return new FieldValueOptions(ServerTimestampBehavior.Previous, timestampsInSnapshots);
	            case 'none': // Fall-through intended.
	            case undefined:
	                return new FieldValueOptions(ServerTimestampBehavior.Default, timestampsInSnapshots);
	            default:
	                return fail('fromSnapshotOptions() called with invalid options.');
	        }
	    };
	    return FieldValueOptions;
	}());
	/**
	 * A field value represents a datatype as stored by Firestore.
	 */
	var FieldValue = /** @class */ (function () {
	    function FieldValue() {
	    }
	    FieldValue.prototype.toString = function () {
	        var val = this.value();
	        return val === null ? 'null' : val.toString();
	    };
	    FieldValue.prototype.defaultCompareTo = function (other) {
	        assert(this.typeOrder !== other.typeOrder, 'Default compareTo should not be used for values of same type.');
	        var cmp = primitiveComparator(this.typeOrder, other.typeOrder);
	        return cmp;
	    };
	    return FieldValue;
	}());
	var NullValue = /** @class */ (function (_super) {
	    tslib.__extends(NullValue, _super);
	    function NullValue() {
	        var _this = _super.call(this) || this;
	        _this.typeOrder = TypeOrder.NullValue;
	        // internalValue is unused but we add it to work around
	        // https://github.com/Microsoft/TypeScript/issues/15585
	        _this.internalValue = null;
	        return _this;
	    }
	    NullValue.prototype.value = function (options) {
	        return null;
	    };
	    NullValue.prototype.isEqual = function (other) {
	        return other instanceof NullValue;
	    };
	    NullValue.prototype.compareTo = function (other) {
	        if (other instanceof NullValue) {
	            return 0;
	        }
	        return this.defaultCompareTo(other);
	    };
	    NullValue.prototype.approximateByteSize = function () {
	        return 4;
	    };
	    NullValue.INSTANCE = new NullValue();
	    return NullValue;
	}(FieldValue));
	var BooleanValue = /** @class */ (function (_super) {
	    tslib.__extends(BooleanValue, _super);
	    function BooleanValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.BooleanValue;
	        return _this;
	    }
	    BooleanValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    BooleanValue.prototype.isEqual = function (other) {
	        return (other instanceof BooleanValue &&
	            this.internalValue === other.internalValue);
	    };
	    BooleanValue.prototype.compareTo = function (other) {
	        if (other instanceof BooleanValue) {
	            return primitiveComparator(this, other);
	        }
	        return this.defaultCompareTo(other);
	    };
	    BooleanValue.prototype.approximateByteSize = function () {
	        return 4;
	    };
	    BooleanValue.of = function (value) {
	        return value ? BooleanValue.TRUE : BooleanValue.FALSE;
	    };
	    BooleanValue.TRUE = new BooleanValue(true);
	    BooleanValue.FALSE = new BooleanValue(false);
	    return BooleanValue;
	}(FieldValue));
	/** Base class for IntegerValue and DoubleValue. */
	var NumberValue = /** @class */ (function (_super) {
	    tslib.__extends(NumberValue, _super);
	    function NumberValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.NumberValue;
	        return _this;
	    }
	    NumberValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    NumberValue.prototype.compareTo = function (other) {
	        if (other instanceof NumberValue) {
	            return numericComparator(this.internalValue, other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    NumberValue.prototype.approximateByteSize = function () {
	        return 8;
	    };
	    return NumberValue;
	}(FieldValue));
	/** Utility function to compare doubles (using Firestore semantics for NaN). */
	function numericComparator(left, right) {
	    if (left < right) {
	        return -1;
	    }
	    else if (left > right) {
	        return 1;
	    }
	    else if (left === right) {
	        return 0;
	    }
	    else {
	        // one or both are NaN.
	        if (isNaN(left)) {
	            return isNaN(right) ? 0 : -1;
	        }
	        else {
	            return 1;
	        }
	    }
	}
	/**
	 * Utility function to check numbers for equality using Firestore semantics
	 * (NaN === NaN, -0.0 !== 0.0).
	 */
	function numericEquals(left, right) {
	    // Implemented based on Object.is() polyfill from
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	    if (left === right) {
	        // +0 != -0
	        return left !== 0 || 1 / left === 1 / right;
	    }
	    else {
	        // NaN == NaN
	        return left !== left && right !== right;
	    }
	}
	var IntegerValue = /** @class */ (function (_super) {
	    tslib.__extends(IntegerValue, _super);
	    function IntegerValue() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    IntegerValue.prototype.isEqual = function (other) {
	        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
	        // but that doesn't make them equal via isEqual().
	        if (other instanceof IntegerValue) {
	            return numericEquals(this.internalValue, other.internalValue);
	        }
	        else {
	            return false;
	        }
	    };
	    return IntegerValue;
	}(NumberValue));
	var DoubleValue = /** @class */ (function (_super) {
	    tslib.__extends(DoubleValue, _super);
	    function DoubleValue() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DoubleValue.prototype.isEqual = function (other) {
	        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
	        // but that doesn't make them equal via isEqual().
	        if (other instanceof DoubleValue) {
	            return numericEquals(this.internalValue, other.internalValue);
	        }
	        else {
	            return false;
	        }
	    };
	    DoubleValue.NAN = new DoubleValue(NaN);
	    DoubleValue.POSITIVE_INFINITY = new DoubleValue(Infinity);
	    DoubleValue.NEGATIVE_INFINITY = new DoubleValue(-Infinity);
	    return DoubleValue;
	}(NumberValue));
	// TODO(b/37267885): Add truncation support
	var StringValue = /** @class */ (function (_super) {
	    tslib.__extends(StringValue, _super);
	    function StringValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.StringValue;
	        return _this;
	    }
	    StringValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    StringValue.prototype.isEqual = function (other) {
	        return (other instanceof StringValue && this.internalValue === other.internalValue);
	    };
	    StringValue.prototype.compareTo = function (other) {
	        if (other instanceof StringValue) {
	            return primitiveComparator(this.internalValue, other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    StringValue.prototype.approximateByteSize = function () {
	        // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
	        // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
	        // integer values"
	        return this.internalValue.length * 2;
	    };
	    return StringValue;
	}(FieldValue));
	var TimestampValue = /** @class */ (function (_super) {
	    tslib.__extends(TimestampValue, _super);
	    function TimestampValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.TimestampValue;
	        return _this;
	    }
	    TimestampValue.prototype.value = function (options) {
	        if (!options || options.timestampsInSnapshots) {
	            return this.internalValue;
	        }
	        else {
	            return this.internalValue.toDate();
	        }
	    };
	    TimestampValue.prototype.isEqual = function (other) {
	        return (other instanceof TimestampValue &&
	            this.internalValue.isEqual(other.internalValue));
	    };
	    TimestampValue.prototype.compareTo = function (other) {
	        if (other instanceof TimestampValue) {
	            return this.internalValue._compareTo(other.internalValue);
	        }
	        else if (other instanceof ServerTimestampValue) {
	            // Concrete timestamps come before server timestamps.
	            return -1;
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    TimestampValue.prototype.approximateByteSize = function () {
	        // Timestamps are made up of two distinct numbers (seconds + nanoseconds)
	        return 16;
	    };
	    return TimestampValue;
	}(FieldValue));
	/**
	 * Represents a locally-applied ServerTimestamp.
	 *
	 * Notes:
	 * - ServerTimestampValue instances are created as the result of applying a
	 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
	 *   the local view of a document. Therefore they do not need to be parsed or
	 *   serialized.
	 * - When evaluated locally (e.g. for snapshot.data()), they by default
	 *   evaluate to `null`. This behavior can be configured by passing custom
	 *   FieldValueOptions to value().
	 * - With respect to other ServerTimestampValues, they sort by their
	 *   localWriteTime.
	 */
	var ServerTimestampValue = /** @class */ (function (_super) {
	    tslib.__extends(ServerTimestampValue, _super);
	    function ServerTimestampValue(localWriteTime, previousValue) {
	        var _this = _super.call(this) || this;
	        _this.localWriteTime = localWriteTime;
	        _this.previousValue = previousValue;
	        _this.typeOrder = TypeOrder.TimestampValue;
	        return _this;
	    }
	    ServerTimestampValue.prototype.value = function (options) {
	        if (options &&
	            options.serverTimestampBehavior === ServerTimestampBehavior.Estimate) {
	            return new TimestampValue(this.localWriteTime).value(options);
	        }
	        else if (options &&
	            options.serverTimestampBehavior === ServerTimestampBehavior.Previous) {
	            return this.previousValue ? this.previousValue.value(options) : null;
	        }
	        else {
	            return null;
	        }
	    };
	    ServerTimestampValue.prototype.isEqual = function (other) {
	        return (other instanceof ServerTimestampValue &&
	            this.localWriteTime.isEqual(other.localWriteTime));
	    };
	    ServerTimestampValue.prototype.compareTo = function (other) {
	        if (other instanceof ServerTimestampValue) {
	            return this.localWriteTime._compareTo(other.localWriteTime);
	        }
	        else if (other instanceof TimestampValue) {
	            // Server timestamps come after all concrete timestamps.
	            return 1;
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ServerTimestampValue.prototype.toString = function () {
	        return '<ServerTimestamp localTime=' + this.localWriteTime.toString() + '>';
	    };
	    ServerTimestampValue.prototype.approximateByteSize = function () {
	        return (
	        /* localWriteTime */ 16 +
	            (this.previousValue ? this.previousValue.approximateByteSize() : 0));
	    };
	    return ServerTimestampValue;
	}(FieldValue));
	var BlobValue = /** @class */ (function (_super) {
	    tslib.__extends(BlobValue, _super);
	    function BlobValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.BlobValue;
	        return _this;
	    }
	    BlobValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    BlobValue.prototype.isEqual = function (other) {
	        return (other instanceof BlobValue &&
	            this.internalValue.isEqual(other.internalValue));
	    };
	    BlobValue.prototype.compareTo = function (other) {
	        if (other instanceof BlobValue) {
	            return this.internalValue._compareTo(other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    BlobValue.prototype.approximateByteSize = function () {
	        return this.internalValue._approximateByteSize();
	    };
	    return BlobValue;
	}(FieldValue));
	var RefValue = /** @class */ (function (_super) {
	    tslib.__extends(RefValue, _super);
	    function RefValue(databaseId, key) {
	        var _this = _super.call(this) || this;
	        _this.databaseId = databaseId;
	        _this.key = key;
	        _this.typeOrder = TypeOrder.RefValue;
	        return _this;
	    }
	    RefValue.prototype.value = function (options) {
	        return this.key;
	    };
	    RefValue.prototype.isEqual = function (other) {
	        if (other instanceof RefValue) {
	            return (this.key.isEqual(other.key) && this.databaseId.isEqual(other.databaseId));
	        }
	        else {
	            return false;
	        }
	    };
	    RefValue.prototype.compareTo = function (other) {
	        if (other instanceof RefValue) {
	            var cmp = this.databaseId.compareTo(other.databaseId);
	            return cmp !== 0 ? cmp : DocumentKey.comparator(this.key, other.key);
	        }
	        return this.defaultCompareTo(other);
	    };
	    RefValue.prototype.approximateByteSize = function () {
	        return (this.databaseId.projectId.length +
	            this.databaseId.database.length +
	            this.key.toString().length);
	    };
	    return RefValue;
	}(FieldValue));
	var GeoPointValue = /** @class */ (function (_super) {
	    tslib.__extends(GeoPointValue, _super);
	    function GeoPointValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.GeoPointValue;
	        return _this;
	    }
	    GeoPointValue.prototype.value = function (options) {
	        return this.internalValue;
	    };
	    GeoPointValue.prototype.isEqual = function (other) {
	        return (other instanceof GeoPointValue &&
	            this.internalValue.isEqual(other.internalValue));
	    };
	    GeoPointValue.prototype.compareTo = function (other) {
	        if (other instanceof GeoPointValue) {
	            return this.internalValue._compareTo(other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    GeoPointValue.prototype.approximateByteSize = function () {
	        // GeoPoints are made up of two distinct numbers (latitude + longitude)
	        return 16;
	    };
	    return GeoPointValue;
	}(FieldValue));
	var ObjectValue = /** @class */ (function (_super) {
	    tslib.__extends(ObjectValue, _super);
	    function ObjectValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.ObjectValue;
	        return _this;
	    }
	    ObjectValue.prototype.value = function (options) {
	        var result = {};
	        this.internalValue.inorderTraversal(function (key, val) {
	            result[key] = val.value(options);
	        });
	        return result;
	    };
	    ObjectValue.prototype.forEach = function (action) {
	        this.internalValue.inorderTraversal(action);
	    };
	    ObjectValue.prototype.isEqual = function (other) {
	        if (other instanceof ObjectValue) {
	            var it1 = this.internalValue.getIterator();
	            var it2 = other.internalValue.getIterator();
	            while (it1.hasNext() && it2.hasNext()) {
	                var next1 = it1.getNext();
	                var next2 = it2.getNext();
	                if (next1.key !== next2.key || !next1.value.isEqual(next2.value)) {
	                    return false;
	                }
	            }
	            return !it1.hasNext() && !it2.hasNext();
	        }
	        return false;
	    };
	    ObjectValue.prototype.compareTo = function (other) {
	        if (other instanceof ObjectValue) {
	            var it1 = this.internalValue.getIterator();
	            var it2 = other.internalValue.getIterator();
	            while (it1.hasNext() && it2.hasNext()) {
	                var next1 = it1.getNext();
	                var next2 = it2.getNext();
	                var cmp = primitiveComparator(next1.key, next2.key) ||
	                    next1.value.compareTo(next2.value);
	                if (cmp) {
	                    return cmp;
	                }
	            }
	            // Only equal if both iterators are exhausted
	            return primitiveComparator(it1.hasNext(), it2.hasNext());
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ObjectValue.prototype.set = function (path, to) {
	        assert(!path.isEmpty(), 'Cannot set field for empty path on ObjectValue');
	        if (path.length === 1) {
	            return this.setChild(path.firstSegment(), to);
	        }
	        else {
	            var child = this.child(path.firstSegment());
	            if (!(child instanceof ObjectValue)) {
	                child = ObjectValue.EMPTY;
	            }
	            var newChild = child.set(path.popFirst(), to);
	            return this.setChild(path.firstSegment(), newChild);
	        }
	    };
	    ObjectValue.prototype.delete = function (path) {
	        assert(!path.isEmpty(), 'Cannot delete field for empty path on ObjectValue');
	        if (path.length === 1) {
	            return new ObjectValue(this.internalValue.remove(path.firstSegment()));
	        }
	        else {
	            // nested field
	            var child = this.child(path.firstSegment());
	            if (child instanceof ObjectValue) {
	                var newChild = child.delete(path.popFirst());
	                return new ObjectValue(this.internalValue.insert(path.firstSegment(), newChild));
	            }
	            else {
	                // Don't actually change a primitive value to an object for a delete
	                return this;
	            }
	        }
	    };
	    ObjectValue.prototype.contains = function (path) {
	        return this.field(path) !== null;
	    };
	    ObjectValue.prototype.field = function (path) {
	        assert(!path.isEmpty(), "Can't get field of empty path");
	        var field = this;
	        path.forEach(function (pathSegment) {
	            if (field instanceof ObjectValue) {
	                field = field.internalValue.get(pathSegment);
	            }
	            else {
	                field = null;
	            }
	        });
	        return field;
	    };
	    /**
	     * Returns a FieldMask built from all FieldPaths starting from this ObjectValue,
	     * including paths from nested objects.
	     */
	    ObjectValue.prototype.fieldMask = function () {
	        var fields = new SortedSet(FieldPath.comparator);
	        this.internalValue.forEach(function (key, value) {
	            var currentPath = new FieldPath([key]);
	            if (value instanceof ObjectValue) {
	                var nestedMask = value.fieldMask();
	                var nestedFields = nestedMask.fields;
	                if (nestedFields.isEmpty()) {
	                    // Preserve the empty map by adding it to the FieldMask.
	                    fields = fields.add(currentPath);
	                }
	                else {
	                    // For nested and non-empty ObjectValues, add the FieldPath of the
	                    // leaf nodes.
	                    nestedFields.forEach(function (nestedPath) {
	                        fields = fields.add(currentPath.child(nestedPath));
	                    });
	                }
	            }
	            else {
	                fields = fields.add(currentPath);
	            }
	        });
	        return FieldMask.fromSet(fields);
	    };
	    ObjectValue.prototype.approximateByteSize = function () {
	        var size = 0;
	        this.internalValue.inorderTraversal(function (key, val) {
	            size += key.length + val.approximateByteSize();
	        });
	        return size;
	    };
	    ObjectValue.prototype.toString = function () {
	        return this.internalValue.toString();
	    };
	    ObjectValue.prototype.child = function (childName) {
	        return this.internalValue.get(childName) || undefined;
	    };
	    ObjectValue.prototype.setChild = function (childName, value) {
	        return new ObjectValue(this.internalValue.insert(childName, value));
	    };
	    ObjectValue.EMPTY = new ObjectValue(new SortedMap(primitiveComparator));
	    return ObjectValue;
	}(FieldValue));
	var ArrayValue = /** @class */ (function (_super) {
	    tslib.__extends(ArrayValue, _super);
	    function ArrayValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.ArrayValue;
	        return _this;
	    }
	    ArrayValue.prototype.value = function (options) {
	        return this.internalValue.map(function (v) { return v.value(options); });
	    };
	    /**
	     * Returns true if the given value is contained in this array.
	     */
	    ArrayValue.prototype.contains = function (value) {
	        for (var _i = 0, _a = this.internalValue; _i < _a.length; _i++) {
	            var element = _a[_i];
	            if (element.isEqual(value)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    ArrayValue.prototype.forEach = function (action) {
	        this.internalValue.forEach(action);
	    };
	    ArrayValue.prototype.isEqual = function (other) {
	        if (other instanceof ArrayValue) {
	            if (this.internalValue.length !== other.internalValue.length) {
	                return false;
	            }
	            for (var i = 0; i < this.internalValue.length; i++) {
	                if (!this.internalValue[i].isEqual(other.internalValue[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        return false;
	    };
	    ArrayValue.prototype.compareTo = function (other) {
	        if (other instanceof ArrayValue) {
	            var minLength = Math.min(this.internalValue.length, other.internalValue.length);
	            for (var i = 0; i < minLength; i++) {
	                var cmp = this.internalValue[i].compareTo(other.internalValue[i]);
	                if (cmp) {
	                    return cmp;
	                }
	            }
	            return primitiveComparator(this.internalValue.length, other.internalValue.length);
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ArrayValue.prototype.approximateByteSize = function () {
	        return this.internalValue.reduce(function (totalSize, value) { return totalSize + value.approximateByteSize(); }, 0);
	    };
	    ArrayValue.prototype.toString = function () {
	        var descriptions = this.internalValue.map(function (v) { return v.toString(); });
	        return "[" + descriptions.join(',') + "]";
	    };
	    return ArrayValue;
	}(FieldValue));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * The result of a lookup for a given path may be an existing document or a
	 * marker that this document does not exist at a given version.
	 */
	var MaybeDocument = /** @class */ (function () {
	    function MaybeDocument(key, version) {
	        this.key = key;
	        this.version = version;
	    }
	    MaybeDocument.compareByKey = function (d1, d2) {
	        return DocumentKey.comparator(d1.key, d2.key);
	    };
	    return MaybeDocument;
	}());
	/**
	 * Represents a document in Firestore with a key, version, data and whether the
	 * data has local mutations applied to it.
	 */
	var Document = /** @class */ (function (_super) {
	    tslib.__extends(Document, _super);
	    function Document(key, version, options, objectValue, proto, converter) {
	        var _this = _super.call(this, key, version) || this;
	        _this.objectValue = objectValue;
	        _this.proto = proto;
	        _this.converter = converter;
	        assert(_this.objectValue !== undefined ||
	            (_this.proto !== undefined && _this.converter !== undefined), 'If objectValue is not defined, proto and converter need to be set.');
	        _this.hasLocalMutations = !!options.hasLocalMutations;
	        _this.hasCommittedMutations = !!options.hasCommittedMutations;
	        return _this;
	    }
	    Document.prototype.field = function (path) {
	        if (this.objectValue) {
	            return this.objectValue.field(path);
	        }
	        else {
	            if (!this.fieldValueCache) {
	                // TODO(b/136090445): Remove the cache when `getField` is no longer
	                // called during Query ordering.
	                this.fieldValueCache = new Map();
	            }
	            var canonicalPath = path.canonicalString();
	            var fieldValue = this.fieldValueCache.get(canonicalPath);
	            if (fieldValue === undefined) {
	                // Instead of deserializing the full Document proto, we only
	                // deserialize the value at the requested field path. This speeds up
	                // Query execution as query filters can discard documents based on a
	                // single field.
	                var protoValue = this.getProtoField(path);
	                if (protoValue === undefined) {
	                    fieldValue = null;
	                }
	                else {
	                    fieldValue = this.converter(protoValue);
	                }
	                this.fieldValueCache.set(canonicalPath, fieldValue);
	            }
	            return fieldValue;
	        }
	    };
	    Document.prototype.data = function () {
	        var _this = this;
	        if (!this.objectValue) {
	            var result_1 = ObjectValue.EMPTY;
	            forEach(this.proto.fields || {}, function (key, value) {
	                result_1 = result_1.set(new FieldPath([key]), _this.converter(value));
	            });
	            this.objectValue = result_1;
	            // Once objectValue is computed, values inside the fieldValueCache are no
	            // longer accessed.
	            this.fieldValueCache = undefined;
	        }
	        return this.objectValue;
	    };
	    Document.prototype.value = function () {
	        return this.data().value();
	    };
	    Document.prototype.isEqual = function (other) {
	        return (other instanceof Document &&
	            this.key.isEqual(other.key) &&
	            this.version.isEqual(other.version) &&
	            this.hasLocalMutations === other.hasLocalMutations &&
	            this.hasCommittedMutations === other.hasCommittedMutations &&
	            this.data().isEqual(other.data()));
	    };
	    Document.prototype.toString = function () {
	        return ("Document(" + this.key + ", " + this.version + ", " + this.data().toString() + ", " +
	            ("{hasLocalMutations: " + this.hasLocalMutations + "}), ") +
	            ("{hasCommittedMutations: " + this.hasCommittedMutations + "})"));
	    };
	    Object.defineProperty(Document.prototype, "hasPendingWrites", {
	        get: function () {
	            return this.hasLocalMutations || this.hasCommittedMutations;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the nested Protobuf value for 'path`. Can only be called if
	     * `proto` was provided at construction time.
	     */
	    Document.prototype.getProtoField = function (path) {
	        assert(this.proto !== undefined, 'Can only call getProtoField() when proto is defined');
	        var protoValue = this.proto.fields
	            ? this.proto.fields[path.firstSegment()]
	            : undefined;
	        for (var i = 1; i < path.length; ++i) {
	            if (!protoValue || !protoValue.mapValue || !protoValue.mapValue.fields) {
	                return undefined;
	            }
	            protoValue = protoValue.mapValue.fields[path.get(i)];
	        }
	        return protoValue;
	    };
	    Document.compareByField = function (field, d1, d2) {
	        var v1 = d1.field(field);
	        var v2 = d2.field(field);
	        if (v1 !== null && v2 !== null) {
	            return v1.compareTo(v2);
	        }
	        else {
	            return fail("Trying to compare documents on fields that don't exist");
	        }
	    };
	    return Document;
	}(MaybeDocument));
	/**
	 * A class representing a deleted document.
	 * Version is set to 0 if we don't point to any specific time, otherwise it
	 * denotes time we know it didn't exist at.
	 */
	var NoDocument = /** @class */ (function (_super) {
	    tslib.__extends(NoDocument, _super);
	    function NoDocument(key, version, options) {
	        var _this = _super.call(this, key, version) || this;
	        _this.hasCommittedMutations = !!(options && options.hasCommittedMutations);
	        return _this;
	    }
	    NoDocument.prototype.toString = function () {
	        return "NoDocument(" + this.key + ", " + this.version + ")";
	    };
	    Object.defineProperty(NoDocument.prototype, "hasPendingWrites", {
	        get: function () {
	            return this.hasCommittedMutations;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    NoDocument.prototype.isEqual = function (other) {
	        return (other instanceof NoDocument &&
	            other.hasCommittedMutations === this.hasCommittedMutations &&
	            other.version.isEqual(this.version) &&
	            other.key.isEqual(this.key));
	    };
	    return NoDocument;
	}(MaybeDocument));
	/**
	 * A class representing an existing document whose data is unknown (e.g. a
	 * document that was updated without a known base document).
	 */
	var UnknownDocument = /** @class */ (function (_super) {
	    tslib.__extends(UnknownDocument, _super);
	    function UnknownDocument() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    UnknownDocument.prototype.toString = function () {
	        return "UnknownDocument(" + this.key + ", " + this.version + ")";
	    };
	    Object.defineProperty(UnknownDocument.prototype, "hasPendingWrites", {
	        get: function () {
	            return true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    UnknownDocument.prototype.isEqual = function (other) {
	        return (other instanceof UnknownDocument &&
	            other.version.isEqual(this.version) &&
	            other.key.isEqual(this.key));
	    };
	    return UnknownDocument;
	}(MaybeDocument));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A map implementation that uses objects as keys. Objects must implement the
	 * Equatable interface and must be immutable. Entries in the map are stored
	 * together with the key being produced from the mapKeyFn. This map
	 * automatically handles collisions of keys.
	 */
	var ObjectMap = /** @class */ (function () {
	    function ObjectMap(mapKeyFn) {
	        this.mapKeyFn = mapKeyFn;
	        /**
	         * The inner map for a key -> value pair. Due to the possibility of
	         * collisions we keep a list of entries that we do a linear search through
	         * to find an actual match. Note that collisions should be rare, so we still
	         * expect near constant time lookups in practice.
	         */
	        this.inner = {};
	    }
	    /** Get a value for this key, or undefined if it does not exist. */
	    ObjectMap.prototype.get = function (key) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            return undefined;
	        }
	        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
	            var _a = matches_1[_i], otherKey = _a[0], value = _a[1];
	            if (otherKey.isEqual(key)) {
	                return value;
	            }
	        }
	        return undefined;
	    };
	    ObjectMap.prototype.has = function (key) {
	        return this.get(key) !== undefined;
	    };
	    /** Put this key and value in the map. */
	    ObjectMap.prototype.set = function (key, value) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            this.inner[id] = [[key, value]];
	            return;
	        }
	        for (var i = 0; i < matches.length; i++) {
	            if (matches[i][0].isEqual(key)) {
	                matches[i] = [key, value];
	                return;
	            }
	        }
	        matches.push([key, value]);
	    };
	    /**
	     * Remove this key from the map. Returns a boolean if anything was deleted.
	     */
	    ObjectMap.prototype.delete = function (key) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            return false;
	        }
	        for (var i = 0; i < matches.length; i++) {
	            if (matches[i][0].isEqual(key)) {
	                if (matches.length === 1) {
	                    delete this.inner[id];
	                }
	                else {
	                    matches.splice(i, 1);
	                }
	                return true;
	            }
	        }
	        return false;
	    };
	    ObjectMap.prototype.forEach = function (fn) {
	        forEach(this.inner, function (_, entries) {
	            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                var _a = entries_1[_i], k = _a[0], v = _a[1];
	                fn(k, v);
	            }
	        });
	    };
	    ObjectMap.prototype.isEmpty = function () {
	        return isEmpty(this.inner);
	    };
	    return ObjectMap;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
	 * It can be used to batch up a set of changes to be written to the cache, but
	 * additionally supports reading entries back with the `getEntry()` method,
	 * falling back to the underlying RemoteDocumentCache if no entry is
	 * buffered.
	 *
	 * Entries added to the cache *must* be read first. This is to facilitate
	 * calculating the size delta of the pending changes.
	 *
	 * PORTING NOTE: This class was implemented then removed from other platforms.
	 * If byte-counting ends up being needed on the other platforms, consider
	 * porting this class as part of that implementation work.
	 */
	var RemoteDocumentChangeBuffer = /** @class */ (function () {
	    function RemoteDocumentChangeBuffer() {
	        // A mapping of document key to the new cache entry that should be written (or null if any
	        // existing cache entry should be removed).
	        this.changes = new ObjectMap(function (key) { return key.toString(); });
	        this.changesApplied = false;
	    }
	    Object.defineProperty(RemoteDocumentChangeBuffer.prototype, "readTime", {
	        get: function () {
	            assert(this._readTime !== undefined, 'Read time is not set. All removeEntry() calls must include a readTime if `trackRemovals` is used.');
	            return this._readTime;
	        },
	        set: function (value) {
	            // Right now (for simplicity) we just track a single readTime for all the
	            // added entries since we expect them to all be the same, but we could
	            // rework to store per-entry readTimes if necessary.
	            assert(this._readTime === undefined || this._readTime.isEqual(value), 'All changes in a RemoteDocumentChangeBuffer must have the same read time');
	            this._readTime = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Buffers a `RemoteDocumentCache.addEntry()` call.
	     *
	     * You can only modify documents that have already been retrieved via
	     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
	     */
	    RemoteDocumentChangeBuffer.prototype.addEntry = function (maybeDocument, readTime) {
	        this.assertNotApplied();
	        this.readTime = readTime;
	        this.changes.set(maybeDocument.key, maybeDocument);
	    };
	    /**
	     * Buffers a `RemoteDocumentCache.removeEntry()` call.
	     *
	     * You can only remove documents that have already been retrieved via
	     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
	     */
	    RemoteDocumentChangeBuffer.prototype.removeEntry = function (key, readTime) {
	        this.assertNotApplied();
	        if (readTime) {
	            this.readTime = readTime;
	        }
	        this.changes.set(key, null);
	    };
	    /**
	     * Looks up an entry in the cache. The buffered changes will first be checked,
	     * and if no buffered change applies, this will forward to
	     * `RemoteDocumentCache.getEntry()`.
	     *
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documentKey The key of the entry to look up.
	     * @return The cached Document or NoDocument entry, or null if we have nothing
	     * cached.
	     */
	    RemoteDocumentChangeBuffer.prototype.getEntry = function (transaction, documentKey) {
	        this.assertNotApplied();
	        var bufferedEntry = this.changes.get(documentKey);
	        if (bufferedEntry !== undefined) {
	            return PersistencePromise.resolve(bufferedEntry);
	        }
	        else {
	            return this.getFromCache(transaction, documentKey);
	        }
	    };
	    /**
	     * Looks up several entries in the cache, forwarding to
	     * `RemoteDocumentCache.getEntry()`.
	     *
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documentKeys The keys of the entries to look up.
	     * @return A map of cached `Document`s or `NoDocument`s, indexed by key. If an
	     *     entry cannot be found, the corresponding key will be mapped to a null
	     *     value.
	     */
	    RemoteDocumentChangeBuffer.prototype.getEntries = function (transaction, documentKeys) {
	        return this.getAllFromCache(transaction, documentKeys);
	    };
	    /**
	     * Applies buffered changes to the underlying RemoteDocumentCache, using
	     * the provided transaction.
	     */
	    RemoteDocumentChangeBuffer.prototype.apply = function (transaction) {
	        this.assertNotApplied();
	        this.changesApplied = true;
	        return this.applyChanges(transaction);
	    };
	    /** Helper to assert this.changes is not null  */
	    RemoteDocumentChangeBuffer.prototype.assertNotApplied = function () {
	        assert(!this.changesApplied, 'Changes have already been applied.');
	    };
	    return RemoteDocumentChangeBuffer;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var IndexedDbRemoteDocumentCache = /** @class */ (function () {
	    /**
	     * @param {LocalSerializer} serializer The document serializer.
	     * @param {IndexManager} indexManager The query indexes that need to be maintained.
	     */
	    function IndexedDbRemoteDocumentCache(serializer, indexManager) {
	        this.serializer = serializer;
	        this.indexManager = indexManager;
	    }
	    /**
	     * Adds the supplied entries to the cache.
	     *
	     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
	     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
	     */
	    IndexedDbRemoteDocumentCache.prototype.addEntry = function (transaction, key, doc) {
	        var documentStore = remoteDocumentsStore(transaction);
	        return documentStore.put(dbKey(key), doc);
	    };
	    /**
	     * Removes a document from the cache.
	     *
	     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
	     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
	     */
	    IndexedDbRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
	        var store = remoteDocumentsStore(transaction);
	        var key = dbKey(documentKey);
	        return store.delete(key);
	    };
	    /**
	     * Updates the current cache size.
	     *
	     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
	     * cache's metadata.
	     */
	    IndexedDbRemoteDocumentCache.prototype.updateMetadata = function (transaction, sizeDelta) {
	        var _this = this;
	        return this.getMetadata(transaction).next(function (metadata) {
	            metadata.byteSize += sizeDelta;
	            return _this.setMetadata(transaction, metadata);
	        });
	    };
	    IndexedDbRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
	        var _this = this;
	        return remoteDocumentsStore(transaction)
	            .get(dbKey(documentKey))
	            .next(function (dbRemoteDoc) {
	            return _this.maybeDecodeDocument(dbRemoteDoc);
	        });
	    };
	    /**
	     * Looks up an entry in the cache.
	     *
	     * @param documentKey The key of the entry to look up.
	     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
	     */
	    IndexedDbRemoteDocumentCache.prototype.getSizedEntry = function (transaction, documentKey) {
	        var _this = this;
	        return remoteDocumentsStore(transaction)
	            .get(dbKey(documentKey))
	            .next(function (dbRemoteDoc) {
	            var doc = _this.maybeDecodeDocument(dbRemoteDoc);
	            return doc
	                ? {
	                    maybeDocument: doc,
	                    size: dbDocumentSize(dbRemoteDoc)
	                }
	                : null;
	        });
	    };
	    IndexedDbRemoteDocumentCache.prototype.getEntries = function (transaction, documentKeys) {
	        var _this = this;
	        var results = nullableMaybeDocumentMap();
	        return this.forEachDbEntry(transaction, documentKeys, function (key, dbRemoteDoc) {
	            var doc = _this.maybeDecodeDocument(dbRemoteDoc);
	            results = results.insert(key, doc);
	        }).next(function () { return results; });
	    };
	    /**
	     * Looks up several entries in the cache.
	     *
	     * @param documentKeys The set of keys entries to look up.
	     * @return A map of MaybeDocuments indexed by key (if a document cannot be
	     *     found, the key will be mapped to null) and a map of sizes indexed by
	     *     key (zero if the key cannot be found).
	     */
	    IndexedDbRemoteDocumentCache.prototype.getSizedEntries = function (transaction, documentKeys) {
	        var _this = this;
	        var results = nullableMaybeDocumentMap();
	        var sizeMap = new SortedMap(DocumentKey.comparator);
	        return this.forEachDbEntry(transaction, documentKeys, function (key, dbRemoteDoc) {
	            var doc = _this.maybeDecodeDocument(dbRemoteDoc);
	            if (doc) {
	                results = results.insert(key, doc);
	                sizeMap = sizeMap.insert(key, dbDocumentSize(dbRemoteDoc));
	            }
	            else {
	                results = results.insert(key, null);
	                sizeMap = sizeMap.insert(key, 0);
	            }
	        }).next(function () {
	            return { maybeDocuments: results, sizeMap: sizeMap };
	        });
	    };
	    IndexedDbRemoteDocumentCache.prototype.forEachDbEntry = function (transaction, documentKeys, callback) {
	        if (documentKeys.isEmpty()) {
	            return PersistencePromise.resolve();
	        }
	        var range = IDBKeyRange.bound(documentKeys.first().path.toArray(), documentKeys.last().path.toArray());
	        var keyIter = documentKeys.getIterator();
	        var nextKey = keyIter.getNext();
	        return remoteDocumentsStore(transaction)
	            .iterate({ range: range }, function (potentialKeyRaw, dbRemoteDoc, control) {
	            var potentialKey = DocumentKey.fromSegments(potentialKeyRaw);
	            // Go through keys not found in cache.
	            while (nextKey && DocumentKey.comparator(nextKey, potentialKey) < 0) {
	                callback(nextKey, null);
	                nextKey = keyIter.getNext();
	            }
	            if (nextKey && nextKey.isEqual(potentialKey)) {
	                // Key found in cache.
	                callback(nextKey, dbRemoteDoc);
	                nextKey = keyIter.hasNext() ? keyIter.getNext() : null;
	            }
	            // Skip to the next key (if there is one).
	            if (nextKey) {
	                control.skip(nextKey.path.toArray());
	            }
	            else {
	                control.done();
	            }
	        })
	            .next(function () {
	            // The rest of the keys are not in the cache. One case where `iterate`
	            // above won't go through them is when the cache is empty.
	            while (nextKey) {
	                callback(nextKey, null);
	                nextKey = keyIter.hasNext() ? keyIter.getNext() : null;
	            }
	        });
	    };
	    IndexedDbRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query, sinceReadTime) {
	        var _this = this;
	        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
	        var results = documentMap();
	        var immediateChildrenPathLength = query.path.length + 1;
	        var iterationOptions = {};
	        if (sinceReadTime.isEqual(SnapshotVersion.MIN)) {
	            // Documents are ordered by key, so we can use a prefix scan to narrow
	            // down the documents we need to match the query against.
	            var startKey = query.path.toArray();
	            iterationOptions.range = IDBKeyRange.lowerBound(startKey);
	        }
	        else {
	            // Execute an index-free query and filter by read time. This is safe
	            // since all document changes to queries that have a
	            // lastLimboFreeSnapshotVersion (`sinceReadTime`) have a read time set.
	            var collectionKey = query.path.toArray();
	            var readTimeKey = this.serializer.toDbTimestampKey(sinceReadTime);
	            iterationOptions.range = IDBKeyRange.lowerBound([collectionKey, readTimeKey], 
	            /* open= */ true);
	            iterationOptions.index = DbRemoteDocument.collectionReadTimeIndex;
	        }
	        return remoteDocumentsStore(transaction)
	            .iterate(iterationOptions, function (key, dbRemoteDoc, control) {
	            // The query is actually returning any path that starts with the query
	            // path prefix which may include documents in subcollections. For
	            // example, a query on 'rooms' will return rooms/abc/messages/xyx but we
	            // shouldn't match it. Fix this by discarding rows with document keys
	            // more than one segment longer than the query path.
	            if (key.length !== immediateChildrenPathLength) {
	                return;
	            }
	            var maybeDoc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
	            if (!query.path.isPrefixOf(maybeDoc.key.path)) {
	                control.done();
	            }
	            else if (maybeDoc instanceof Document && query.matches(maybeDoc)) {
	                results = results.insert(maybeDoc.key, maybeDoc);
	            }
	        })
	            .next(function () { return results; });
	    };
	    IndexedDbRemoteDocumentCache.prototype.getNewDocumentChanges = function (transaction, sinceReadTime) {
	        var _this = this;
	        var changedDocs = maybeDocumentMap();
	        var lastReadTime = this.serializer.toDbTimestampKey(sinceReadTime);
	        var documentsStore = remoteDocumentsStore(transaction);
	        var range = IDBKeyRange.lowerBound(lastReadTime, true);
	        return documentsStore
	            .iterate({ index: DbRemoteDocument.readTimeIndex, range: range }, function (_, dbRemoteDoc) {
	            // Unlike `getEntry()` and others, `getNewDocumentChanges()` parses
	            // the documents directly since we want to keep sentinel deletes.
	            var doc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
	            changedDocs = changedDocs.insert(doc.key, doc);
	            lastReadTime = dbRemoteDoc.readTime;
	        })
	            .next(function () {
	            return {
	                changedDocs: changedDocs,
	                readTime: _this.serializer.fromDbTimestampKey(lastReadTime)
	            };
	        });
	    };
	    IndexedDbRemoteDocumentCache.prototype.getLastReadTime = function (transaction) {
	        var _this = this;
	        var documentsStore = remoteDocumentsStore(transaction);
	        // If there are no existing entries, we return SnapshotVersion.MIN.
	        var readTime = SnapshotVersion.MIN;
	        return documentsStore
	            .iterate({ index: DbRemoteDocument.readTimeIndex, reverse: true }, function (key, dbRemoteDoc, control) {
	            if (dbRemoteDoc.readTime) {
	                readTime = _this.serializer.fromDbTimestampKey(dbRemoteDoc.readTime);
	            }
	            control.done();
	        })
	            .next(function () { return readTime; });
	    };
	    IndexedDbRemoteDocumentCache.prototype.newChangeBuffer = function (options) {
	        return new IndexedDbRemoteDocumentCache.RemoteDocumentChangeBuffer(this, !!options && options.trackRemovals);
	    };
	    IndexedDbRemoteDocumentCache.prototype.getSize = function (txn) {
	        return this.getMetadata(txn).next(function (metadata) { return metadata.byteSize; });
	    };
	    IndexedDbRemoteDocumentCache.prototype.getMetadata = function (txn) {
	        return documentGlobalStore(txn)
	            .get(DbRemoteDocumentGlobal.key)
	            .next(function (metadata) {
	            assert(!!metadata, 'Missing document cache metadata');
	            return metadata;
	        });
	    };
	    IndexedDbRemoteDocumentCache.prototype.setMetadata = function (txn, metadata) {
	        return documentGlobalStore(txn).put(DbRemoteDocumentGlobal.key, metadata);
	    };
	    /**
	     * Decodes `remoteDoc` and returns the document (or null, if the document
	     * corresponds to the format used for sentinel deletes).
	     */
	    IndexedDbRemoteDocumentCache.prototype.maybeDecodeDocument = function (dbRemoteDoc) {
	        if (dbRemoteDoc) {
	            var doc = this.serializer.fromDbRemoteDocument(dbRemoteDoc);
	            if (doc instanceof NoDocument &&
	                doc.version.isEqual(SnapshotVersion.forDeletedDoc())) {
	                // The document is a sentinel removal and should only be used in the
	                // `getNewDocumentChanges()`.
	                return null;
	            }
	            return doc;
	        }
	        return null;
	    };
	    /**
	     * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
	     *
	     * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
	     * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
	     * when we apply the changes.
	     */
	    IndexedDbRemoteDocumentCache.RemoteDocumentChangeBuffer = /** @class */ (function (_super) {
	        tslib.__extends(class_1, _super);
	        /**
	         * @param documentCache The IndexedDbRemoteDocumentCache to apply the changes to.
	         * @param trackRemovals Whether to create sentinel deletes that can be tracked by
	         * `getNewDocumentChanges()`.
	         */
	        function class_1(documentCache, trackRemovals) {
	            var _this = _super.call(this) || this;
	            _this.documentCache = documentCache;
	            _this.trackRemovals = trackRemovals;
	            // A map of document sizes prior to applying the changes in this buffer.
	            _this.documentSizes = new ObjectMap(function (key) { return key.toString(); });
	            return _this;
	        }
	        class_1.prototype.applyChanges = function (transaction) {
	            var _this = this;
	            var promises = [];
	            var sizeDelta = 0;
	            var collectionParents = new SortedSet(function (l, r) {
	                return primitiveComparator(l.canonicalString(), r.canonicalString());
	            });
	            this.changes.forEach(function (key, maybeDocument) {
	                var previousSize = _this.documentSizes.get(key);
	                assert(previousSize !== undefined, "Cannot modify a document that wasn't read (for " + key + ")");
	                if (maybeDocument) {
	                    assert(!_this.readTime.isEqual(SnapshotVersion.MIN), 'Cannot add a document with a read time of zero');
	                    var doc = _this.documentCache.serializer.toDbRemoteDocument(maybeDocument, _this.readTime);
	                    collectionParents = collectionParents.add(key.path.popLast());
	                    var size = dbDocumentSize(doc);
	                    sizeDelta += size - previousSize;
	                    promises.push(_this.documentCache.addEntry(transaction, key, doc));
	                }
	                else {
	                    sizeDelta -= previousSize;
	                    if (_this.trackRemovals) {
	                        // In order to track removals, we store a "sentinel delete" in the
	                        // RemoteDocumentCache. This entry is represented by a NoDocument
	                        // with a version of 0 and ignored by `maybeDecodeDocument()` but
	                        // preserved in `getNewDocumentChanges()`.
	                        var deletedDoc = _this.documentCache.serializer.toDbRemoteDocument(new NoDocument(key, SnapshotVersion.forDeletedDoc()), _this.readTime);
	                        promises.push(_this.documentCache.addEntry(transaction, key, deletedDoc));
	                    }
	                    else {
	                        promises.push(_this.documentCache.removeEntry(transaction, key));
	                    }
	                }
	            });
	            collectionParents.forEach(function (parent) {
	                promises.push(_this.documentCache.indexManager.addToCollectionParentIndex(transaction, parent));
	            });
	            promises.push(this.documentCache.updateMetadata(transaction, sizeDelta));
	            return PersistencePromise.waitFor(promises);
	        };
	        class_1.prototype.getFromCache = function (transaction, documentKey) {
	            var _this = this;
	            // Record the size of everything we load from the cache so we can compute a delta later.
	            return this.documentCache
	                .getSizedEntry(transaction, documentKey)
	                .next(function (getResult) {
	                if (getResult === null) {
	                    _this.documentSizes.set(documentKey, 0);
	                    return null;
	                }
	                else {
	                    _this.documentSizes.set(documentKey, getResult.size);
	                    return getResult.maybeDocument;
	                }
	            });
	        };
	        class_1.prototype.getAllFromCache = function (transaction, documentKeys) {
	            var _this = this;
	            // Record the size of everything we load from the cache so we can compute
	            // a delta later.
	            return this.documentCache
	                .getSizedEntries(transaction, documentKeys)
	                .next(function (_a) {
	                var maybeDocuments = _a.maybeDocuments, sizeMap = _a.sizeMap;
	                // Note: `getAllFromCache` returns two maps instead of a single map from
	                // keys to `DocumentSizeEntry`s. This is to allow returning the
	                // `NullableMaybeDocumentMap` directly, without a conversion.
	                sizeMap.forEach(function (documentKey, size) {
	                    _this.documentSizes.set(documentKey, size);
	                });
	                return maybeDocuments;
	            });
	        };
	        return class_1;
	    }(RemoteDocumentChangeBuffer));
	    return IndexedDbRemoteDocumentCache;
	}());
	function documentGlobalStore(txn) {
	    return IndexedDbPersistence.getStore(txn, DbRemoteDocumentGlobal.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
	 */
	function remoteDocumentsStore(txn) {
	    return IndexedDbPersistence.getStore(txn, DbRemoteDocument.store);
	}
	function dbKey(docKey) {
	    return docKey.path.toArray();
	}
	/**
	 * Retrusn an approximate size for the given document.
	 */
	function dbDocumentSize(doc) {
	    var value;
	    if (doc.document) {
	        value = doc.document;
	    }
	    else if (doc.unknownDocument) {
	        value = doc.unknownDocument;
	    }
	    else if (doc.noDocument) {
	        value = doc.noDocument;
	    }
	    else {
	        throw fail('Unknown remote document type');
	    }
	    return JSON.stringify(value).length;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An in-memory implementation of IndexManager.
	 */
	var MemoryIndexManager = /** @class */ (function () {
	    function MemoryIndexManager() {
	        this.collectionParentIndex = new MemoryCollectionParentIndex();
	    }
	    MemoryIndexManager.prototype.addToCollectionParentIndex = function (transaction, collectionPath) {
	        this.collectionParentIndex.add(collectionPath);
	        return PersistencePromise.resolve();
	    };
	    MemoryIndexManager.prototype.getCollectionParents = function (transaction, collectionId) {
	        return PersistencePromise.resolve(this.collectionParentIndex.getEntries(collectionId));
	    };
	    return MemoryIndexManager;
	}());
	/**
	 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
	 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
	 * in indexeddb_schema.ts
	 */
	var MemoryCollectionParentIndex = /** @class */ (function () {
	    function MemoryCollectionParentIndex() {
	        this.index = {};
	    }
	    // Returns false if the entry already existed.
	    MemoryCollectionParentIndex.prototype.add = function (collectionPath) {
	        assert(collectionPath.length % 2 === 1, 'Expected a collection path.');
	        var collectionId = collectionPath.lastSegment();
	        var parentPath = collectionPath.popLast();
	        var existingParents = this.index[collectionId] ||
	            new SortedSet(ResourcePath.comparator);
	        var added = !existingParents.has(parentPath);
	        this.index[collectionId] = existingParents.add(parentPath);
	        return added;
	    };
	    MemoryCollectionParentIndex.prototype.has = function (collectionPath) {
	        var collectionId = collectionPath.lastSegment();
	        var parentPath = collectionPath.popLast();
	        var existingParents = this.index[collectionId];
	        return existingParents && existingParents.has(parentPath);
	    };
	    MemoryCollectionParentIndex.prototype.getEntries = function (collectionId) {
	        var parentPaths = this.index[collectionId] ||
	            new SortedSet(ResourcePath.comparator);
	        return parentPaths.toArray();
	    };
	    return MemoryCollectionParentIndex;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Schema Version for the Web client:
	 * 1. Initial version including Mutation Queue, Query Cache, and Remote Document
	 *    Cache
	 * 2. Used to ensure a targetGlobal object exists and add targetCount to it. No
	 *    longer required because migration 3 unconditionally clears it.
	 * 3. Dropped and re-created Query Cache to deal with cache corruption related
	 *    to limbo resolution. Addresses
	 *    https://github.com/firebase/firebase-ios-sdk/issues/1548
	 * 4. Multi-Tab Support.
	 * 5. Removal of held write acks.
	 * 6. Create document global for tracking document cache size.
	 * 7. Ensure every cached document has a sentinel row with a sequence number.
	 * 8. Add collection-parent index for Collection Group queries.
	 * 9. Change RemoteDocumentChanges store to be keyed by readTime rather than
	 *    an auto-incrementing ID. This is required for Index-Free queries.
	 */
	var SCHEMA_VERSION = 9;
	/** Performs database creation and schema upgrades. */
	var SchemaConverter = /** @class */ (function () {
	    function SchemaConverter(serializer) {
	        this.serializer = serializer;
	    }
	    /**
	     * Performs database creation and schema upgrades.
	     *
	     * Note that in production, this method is only ever used to upgrade the schema
	     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
	     * and local feature development.
	     */
	    SchemaConverter.prototype.createOrUpgrade = function (db, txn, fromVersion, toVersion) {
	        var _this = this;
	        assert(fromVersion < toVersion &&
	            fromVersion >= 0 &&
	            toVersion <= SCHEMA_VERSION, "Unexpected schema upgrade from v" + fromVersion + " to v{toVersion}.");
	        var simpleDbTransaction = new SimpleDbTransaction(txn);
	        if (fromVersion < 1 && toVersion >= 1) {
	            createPrimaryClientStore(db);
	            createMutationQueue(db);
	            createQueryCache(db);
	            createRemoteDocumentCache(db);
	        }
	        // Migration 2 to populate the targetGlobal object no longer needed since
	        // migration 3 unconditionally clears it.
	        var p = PersistencePromise.resolve();
	        if (fromVersion < 3 && toVersion >= 3) {
	            // Brand new clients don't need to drop and recreate--only clients that
	            // potentially have corrupt data.
	            if (fromVersion !== 0) {
	                dropQueryCache(db);
	                createQueryCache(db);
	            }
	            p = p.next(function () { return writeEmptyTargetGlobalEntry(simpleDbTransaction); });
	        }
	        if (fromVersion < 4 && toVersion >= 4) {
	            if (fromVersion !== 0) {
	                // Schema version 3 uses auto-generated keys to generate globally unique
	                // mutation batch IDs (this was previously ensured internally by the
	                // client). To migrate to the new schema, we have to read all mutations
	                // and write them back out. We preserve the existing batch IDs to guarantee
	                // consistency with other object stores. Any further mutation batch IDs will
	                // be auto-generated.
	                p = p.next(function () {
	                    return upgradeMutationBatchSchemaAndMigrateData(db, simpleDbTransaction);
	                });
	            }
	            p = p.next(function () {
	                createClientMetadataStore(db);
	            });
	        }
	        if (fromVersion < 5 && toVersion >= 5) {
	            p = p.next(function () { return _this.removeAcknowledgedMutations(simpleDbTransaction); });
	        }
	        if (fromVersion < 6 && toVersion >= 6) {
	            p = p.next(function () {
	                createDocumentGlobalStore(db);
	                return _this.addDocumentGlobal(simpleDbTransaction);
	            });
	        }
	        if (fromVersion < 7 && toVersion >= 7) {
	            p = p.next(function () { return _this.ensureSequenceNumbers(simpleDbTransaction); });
	        }
	        if (fromVersion < 8 && toVersion >= 8) {
	            p = p.next(function () {
	                return _this.createCollectionParentIndex(db, simpleDbTransaction);
	            });
	        }
	        if (fromVersion < 9 && toVersion >= 9) {
	            p = p.next(function () {
	                // Multi-Tab used to manage its own changelog, but this has been moved
	                // to the DbRemoteDocument object store itself. Since the previous change
	                // log only contained transient data, we can drop its object store.
	                dropRemoteDocumentChangesStore(db);
	                createRemoteDocumentReadTimeIndex(txn);
	            });
	        }
	        return p;
	    };
	    SchemaConverter.prototype.addDocumentGlobal = function (txn) {
	        var byteCount = 0;
	        return txn
	            .store(DbRemoteDocument.store)
	            .iterate(function (_, doc) {
	            byteCount += dbDocumentSize(doc);
	        })
	            .next(function () {
	            var metadata = new DbRemoteDocumentGlobal(byteCount);
	            return txn
	                .store(DbRemoteDocumentGlobal.store)
	                .put(DbRemoteDocumentGlobal.key, metadata);
	        });
	    };
	    SchemaConverter.prototype.removeAcknowledgedMutations = function (txn) {
	        var _this = this;
	        var queuesStore = txn.store(DbMutationQueue.store);
	        var mutationsStore = txn.store(DbMutationBatch.store);
	        return queuesStore.loadAll().next(function (queues) {
	            return PersistencePromise.forEach(queues, function (queue) {
	                var range = IDBKeyRange.bound([queue.userId, BATCHID_UNKNOWN], [queue.userId, queue.lastAcknowledgedBatchId]);
	                return mutationsStore
	                    .loadAll(DbMutationBatch.userMutationsIndex, range)
	                    .next(function (dbBatches) {
	                    return PersistencePromise.forEach(dbBatches, function (dbBatch) {
	                        assert(dbBatch.userId === queue.userId, "Cannot process batch " + dbBatch.batchId + " from unexpected user");
	                        var batch = _this.serializer.fromDbMutationBatch(dbBatch);
	                        return removeMutationBatch(txn, queue.userId, batch).next(function () { });
	                    });
	                });
	            });
	        });
	    };
	    /**
	     * Ensures that every document in the remote document cache has a corresponding sentinel row
	     * with a sequence number. Missing rows are given the most recently used sequence number.
	     */
	    SchemaConverter.prototype.ensureSequenceNumbers = function (txn) {
	        var documentTargetStore = txn.store(DbTargetDocument.store);
	        var documentsStore = txn.store(DbRemoteDocument.store);
	        return getHighestListenSequenceNumber(txn).next(function (currentSequenceNumber) {
	            var writeSentinelKey = function (path) {
	                return documentTargetStore.put(new DbTargetDocument(0, encode(path), currentSequenceNumber));
	            };
	            var promises = [];
	            return documentsStore
	                .iterate(function (key, doc) {
	                var path = new ResourcePath(key);
	                var docSentinelKey = sentinelKey(path);
	                promises.push(documentTargetStore.get(docSentinelKey).next(function (maybeSentinel) {
	                    if (!maybeSentinel) {
	                        return writeSentinelKey(path);
	                    }
	                    else {
	                        return PersistencePromise.resolve();
	                    }
	                }));
	            })
	                .next(function () { return PersistencePromise.waitFor(promises); });
	        });
	    };
	    SchemaConverter.prototype.createCollectionParentIndex = function (db, txn) {
	        // Create the index.
	        db.createObjectStore(DbCollectionParent.store, {
	            keyPath: DbCollectionParent.keyPath
	        });
	        var collectionParentsStore = txn.store(DbCollectionParent.store);
	        // Helper to add an index entry iff we haven't already written it.
	        var cache = new MemoryCollectionParentIndex();
	        var addEntry = function (collectionPath) {
	            if (cache.add(collectionPath)) {
	                var collectionId = collectionPath.lastSegment();
	                var parentPath = collectionPath.popLast();
	                return collectionParentsStore.put({
	                    collectionId: collectionId,
	                    parent: encode(parentPath)
	                });
	            }
	        };
	        // Index existing remote documents.
	        return txn
	            .store(DbRemoteDocument.store)
	            .iterate({ keysOnly: true }, function (pathSegments, _) {
	            var path = new ResourcePath(pathSegments);
	            return addEntry(path.popLast());
	        })
	            .next(function () {
	            // Index existing mutations.
	            return txn
	                .store(DbDocumentMutation.store)
	                .iterate({ keysOnly: true }, function (_a, _) {
	                var userID = _a[0], encodedPath = _a[1], batchId = _a[2];
	                var path = decode(encodedPath);
	                return addEntry(path.popLast());
	            });
	        });
	    };
	    return SchemaConverter;
	}());
	function sentinelKey(path) {
	    return [0, encode(path)];
	}
	/**
	 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
	 */
	var DbTimestamp = /** @class */ (function () {
	    function DbTimestamp(seconds, nanoseconds) {
	        this.seconds = seconds;
	        this.nanoseconds = nanoseconds;
	    }
	    return DbTimestamp;
	}());
	/**
	 * A singleton object to be stored in the 'owner' store in IndexedDb.
	 *
	 * A given database can have a single primary tab assigned at a given time. That
	 * tab must validate that it is still holding the primary lease before every
	 * operation that requires locked access. The primary tab should regularly
	 * write an updated timestamp to this lease to prevent other tabs from
	 * "stealing" the primary lease
	 */
	var DbPrimaryClient = /** @class */ (function () {
	    function DbPrimaryClient(ownerId, 
	    /** Whether to allow shared access from multiple tabs. */
	    allowTabSynchronization, leaseTimestampMs) {
	        this.ownerId = ownerId;
	        this.allowTabSynchronization = allowTabSynchronization;
	        this.leaseTimestampMs = leaseTimestampMs;
	    }
	    /**
	     * Name of the IndexedDb object store.
	     *
	     * Note that the name 'owner' is chosen to ensure backwards compatibility with
	     * older clients that only supported single locked access to the persistence
	     * layer.
	     */
	    DbPrimaryClient.store = 'owner';
	    /**
	     * The key string used for the single object that exists in the
	     * DbPrimaryClient store.
	     */
	    DbPrimaryClient.key = 'owner';
	    return DbPrimaryClient;
	}());
	function createPrimaryClientStore(db) {
	    db.createObjectStore(DbPrimaryClient.store);
	}
	/**
	 * An object to be stored in the 'mutationQueues' store in IndexedDb.
	 *
	 * Each user gets a single queue of MutationBatches to apply to the server.
	 * DbMutationQueue tracks the metadata about the queue.
	 */
	var DbMutationQueue = /** @class */ (function () {
	    function DbMutationQueue(
	    /**
	     * The normalized user ID to which this queue belongs.
	     */
	    userId, 
	    /**
	     * An identifier for the highest numbered batch that has been acknowledged
	     * by the server. All MutationBatches in this queue with batchIds less
	     * than or equal to this value are considered to have been acknowledged by
	     * the server.
	     *
	     * NOTE: this is deprecated and no longer used by the code.
	     */
	    lastAcknowledgedBatchId, 
	    /**
	     * A stream token that was previously sent by the server.
	     *
	     * See StreamingWriteRequest in datastore.proto for more details about
	     * usage.
	     *
	     * After sending this token, earlier tokens may not be used anymore so
	     * only a single stream token is retained.
	     */
	    lastStreamToken) {
	        this.userId = userId;
	        this.lastAcknowledgedBatchId = lastAcknowledgedBatchId;
	        this.lastStreamToken = lastStreamToken;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbMutationQueue.store = 'mutationQueues';
	    /** Keys are automatically assigned via the userId property. */
	    DbMutationQueue.keyPath = 'userId';
	    return DbMutationQueue;
	}());
	/**
	 * An object to be stored in the 'mutations' store in IndexedDb.
	 *
	 * Represents a batch of user-level mutations intended to be sent to the server
	 * in a single write. Each user-level batch gets a separate DbMutationBatch
	 * with a new batchId.
	 */
	var DbMutationBatch = /** @class */ (function () {
	    function DbMutationBatch(
	    /**
	     * The normalized user ID to which this batch belongs.
	     */
	    userId, 
	    /**
	     * An identifier for this batch, allocated using an auto-generated key.
	     */
	    batchId, 
	    /**
	     * The local write time of the batch, stored as milliseconds since the
	     * epoch.
	     */
	    localWriteTimeMs, 
	    /**
	     * A list of "mutations" that represent a partial base state from when this
	     * write batch was initially created. During local application of the write
	     * batch, these baseMutations are applied prior to the real writes in order
	     * to override certain document fields from the remote document cache. This
	     * is necessary in the case of non-idempotent writes (e.g. `increment()`
	     * transforms) to make sure that the local view of the modified documents
	     * doesn't flicker if the remote document cache receives the result of the
	     * non-idempotent write before the write is removed from the queue.
	     *
	     * These mutations are never sent to the backend.
	     */
	    baseMutations, 
	    /**
	     * A list of mutations to apply. All mutations will be applied atomically.
	     *
	     * Mutations are serialized via JsonProtoSerializer.toMutation().
	     */
	    mutations) {
	        this.userId = userId;
	        this.batchId = batchId;
	        this.localWriteTimeMs = localWriteTimeMs;
	        this.baseMutations = baseMutations;
	        this.mutations = mutations;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbMutationBatch.store = 'mutations';
	    /** Keys are automatically assigned via the userId, batchId properties. */
	    DbMutationBatch.keyPath = 'batchId';
	    /** The index name for lookup of mutations by user. */
	    DbMutationBatch.userMutationsIndex = 'userMutationsIndex';
	    /** The user mutations index is keyed by [userId, batchId] pairs. */
	    DbMutationBatch.userMutationsKeyPath = ['userId', 'batchId'];
	    return DbMutationBatch;
	}());
	function createMutationQueue(db) {
	    db.createObjectStore(DbMutationQueue.store, {
	        keyPath: DbMutationQueue.keyPath
	    });
	    var mutationBatchesStore = db.createObjectStore(DbMutationBatch.store, {
	        keyPath: DbMutationBatch.keyPath,
	        autoIncrement: true
	    });
	    mutationBatchesStore.createIndex(DbMutationBatch.userMutationsIndex, DbMutationBatch.userMutationsKeyPath, { unique: true });
	    db.createObjectStore(DbDocumentMutation.store);
	}
	/**
	 * Upgrade function to migrate the 'mutations' store from V1 to V3. Loads
	 * and rewrites all data.
	 */
	function upgradeMutationBatchSchemaAndMigrateData(db, txn) {
	    var v1MutationsStore = txn.store(DbMutationBatch.store);
	    return v1MutationsStore.loadAll().next(function (existingMutations) {
	        db.deleteObjectStore(DbMutationBatch.store);
	        var mutationsStore = db.createObjectStore(DbMutationBatch.store, {
	            keyPath: DbMutationBatch.keyPath,
	            autoIncrement: true
	        });
	        mutationsStore.createIndex(DbMutationBatch.userMutationsIndex, DbMutationBatch.userMutationsKeyPath, { unique: true });
	        var v3MutationsStore = txn.store(DbMutationBatch.store);
	        var writeAll = existingMutations.map(function (mutation) {
	            return v3MutationsStore.put(mutation);
	        });
	        return PersistencePromise.waitFor(writeAll);
	    });
	}
	/**
	 * An object to be stored in the 'documentMutations' store in IndexedDb.
	 *
	 * A manually maintained index of all the mutation batches that affect a given
	 * document key. The rows in this table are references based on the contents of
	 * DbMutationBatch.mutations.
	 */
	var DbDocumentMutation = /** @class */ (function () {
	    function DbDocumentMutation() {
	    }
	    /**
	     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
	     * over all of a user's document mutations.
	     */
	    DbDocumentMutation.prefixForUser = function (userId) {
	        return [userId];
	    };
	    /**
	     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
	     * index to iterate over all at document mutations for a given path or lower.
	     */
	    DbDocumentMutation.prefixForPath = function (userId, path) {
	        return [userId, encode(path)];
	    };
	    /**
	     * Creates a full index key of [userId, encodedPath, batchId] for inserting
	     * and deleting into the DbDocumentMutations index.
	     */
	    DbDocumentMutation.key = function (userId, path, batchId) {
	        return [userId, encode(path), batchId];
	    };
	    DbDocumentMutation.store = 'documentMutations';
	    /**
	     * Because we store all the useful information for this store in the key,
	     * there is no useful information to store as the value. The raw (unencoded)
	     * path cannot be stored because IndexedDb doesn't store prototype
	     * information.
	     */
	    DbDocumentMutation.PLACEHOLDER = new DbDocumentMutation();
	    return DbDocumentMutation;
	}());
	function createRemoteDocumentCache(db) {
	    db.createObjectStore(DbRemoteDocument.store);
	}
	/**
	 * Represents the known absence of a document at a particular version.
	 * Stored in IndexedDb as part of a DbRemoteDocument object.
	 */
	var DbNoDocument = /** @class */ (function () {
	    function DbNoDocument(path, readTime) {
	        this.path = path;
	        this.readTime = readTime;
	    }
	    return DbNoDocument;
	}());
	/**
	 * Represents a document that is known to exist but whose data is unknown.
	 * Stored in IndexedDb as part of a DbRemoteDocument object.
	 */
	var DbUnknownDocument = /** @class */ (function () {
	    function DbUnknownDocument(path, version) {
	        this.path = path;
	        this.version = version;
	    }
	    return DbUnknownDocument;
	}());
	/**
	 * An object to be stored in the 'remoteDocuments' store in IndexedDb.
	 * It represents either:
	 *
	 * - A complete document.
	 * - A "no document" representing a document that is known not to exist (at
	 * some version).
	 * - An "unknown document" representing a document that is known to exist (at
	 * some version) but whose contents are unknown.
	 *
	 * Note: This is the persisted equivalent of a MaybeDocument and could perhaps
	 * be made more general if necessary.
	 */
	var DbRemoteDocument = /** @class */ (function () {
	    // TODO: We are currently storing full document keys almost three times
	    // (once as part of the primary key, once - partly - as `parentPath` and once
	    // inside the encoded documents). During our next migration, we should
	    // rewrite the primary key as parentPath + document ID which would allow us
	    // to drop one value.
	    function DbRemoteDocument(
	    /**
	     * Set to an instance of DbUnknownDocument if the data for a document is
	     * not known, but it is known that a document exists at the specified
	     * version (e.g. it had a successful update applied to it)
	     */
	    unknownDocument, 
	    /**
	     * Set to an instance of a DbNoDocument if it is known that no document
	     * exists.
	     */
	    noDocument, 
	    /**
	     * Set to an instance of a Document if there's a cached version of the
	     * document.
	     */
	    document, 
	    /**
	     * Documents that were written to the remote document store based on
	     * a write acknowledgment are marked with `hasCommittedMutations`. These
	     * documents are potentially inconsistent with the backend's copy and use
	     * the write's commit version as their document version.
	     */
	    hasCommittedMutations, 
	    /**
	     * When the document was read from the backend. Undefined for data written
	     * prior to schema version 9.
	     */
	    readTime, 
	    /**
	     * The path of the collection this document is part of. Undefined for data
	     * written prior to schema version 9.
	     */
	    parentPath) {
	        this.unknownDocument = unknownDocument;
	        this.noDocument = noDocument;
	        this.document = document;
	        this.hasCommittedMutations = hasCommittedMutations;
	        this.readTime = readTime;
	        this.parentPath = parentPath;
	    }
	    DbRemoteDocument.store = 'remoteDocuments';
	    /**
	     * An index that provides access to all entries sorted by read time (which
	     * corresponds to the last modification time of each row).
	     *
	     * This index is used to provide a changelog for Multi-Tab.
	     */
	    DbRemoteDocument.readTimeIndex = 'readTimeIndex';
	    DbRemoteDocument.readTimeIndexPath = 'readTime';
	    /**
	     * An index that provides access to documents in a collection sorted by read
	     * time.
	     *
	     * This index is used to allow the RemoteDocumentCache to fetch newly changed
	     * documents in a collection.
	     */
	    DbRemoteDocument.collectionReadTimeIndex = 'collectionReadTimeIndex';
	    DbRemoteDocument.collectionReadTimeIndexPath = ['parentPath', 'readTime'];
	    return DbRemoteDocument;
	}());
	/**
	 * Contains a single entry that has metadata about the remote document cache.
	 */
	var DbRemoteDocumentGlobal = /** @class */ (function () {
	    /**
	     * @param byteSize Approximately the total size in bytes of all the documents in the document
	     * cache.
	     */
	    function DbRemoteDocumentGlobal(byteSize) {
	        this.byteSize = byteSize;
	    }
	    DbRemoteDocumentGlobal.store = 'remoteDocumentGlobal';
	    DbRemoteDocumentGlobal.key = 'remoteDocumentGlobalKey';
	    return DbRemoteDocumentGlobal;
	}());
	function createDocumentGlobalStore(db) {
	    db.createObjectStore(DbRemoteDocumentGlobal.store);
	}
	/**
	 * An object to be stored in the 'targets' store in IndexedDb.
	 *
	 * This is based on and should be kept in sync with the proto used in the iOS
	 * client.
	 *
	 * Each query the client listens to against the server is tracked on disk so
	 * that the query can be efficiently resumed on restart.
	 */
	var DbTarget = /** @class */ (function () {
	    function DbTarget(
	    /**
	     * An auto-generated sequential numeric identifier for the query.
	     *
	     * Queries are stored using their canonicalId as the key, but these
	     * canonicalIds can be quite long so we additionally assign a unique
	     * queryId which can be used by referenced data structures (e.g.
	     * indexes) to minimize the on-disk cost.
	     */
	    targetId, 
	    /**
	     * The canonical string representing this query. This is not unique.
	     */
	    canonicalId, 
	    /**
	     * The last readTime received from the Watch Service for this query.
	     *
	     * This is the same value as TargetChange.read_time in the protos.
	     */
	    readTime, 
	    /**
	     * An opaque, server-assigned token that allows watching a query to be
	     * resumed after disconnecting without retransmitting all the data
	     * that matches the query. The resume token essentially identifies a
	     * point in time from which the server should resume sending results.
	     *
	     * This is related to the snapshotVersion in that the resumeToken
	     * effectively also encodes that value, but the resumeToken is opaque
	     * and sometimes encodes additional information.
	     *
	     * A consequence of this is that the resumeToken should be used when
	     * asking the server to reason about where this client is in the watch
	     * stream, but the client should use the snapshotVersion for its own
	     * purposes.
	     *
	     * This is the same value as TargetChange.resume_token in the protos.
	     */
	    resumeToken, 
	    /**
	     * A sequence number representing the last time this query was
	     * listened to, used for garbage collection purposes.
	     *
	     * Conventionally this would be a timestamp value, but device-local
	     * clocks are unreliable and they must be able to create new listens
	     * even while disconnected. Instead this should be a monotonically
	     * increasing number that's incremented on each listen call.
	     *
	     * This is different from the queryId since the queryId is an
	     * immutable identifier assigned to the Query on first use while
	     * lastListenSequenceNumber is updated every time the query is
	     * listened to.
	     */
	    lastListenSequenceNumber, 
	    /**
	     * Denotes the maximum snapshot version at which the associated query view
	     * contained no limbo documents.  Undefined for data written prior to
	     * schema version 9.
	     */
	    lastLimboFreeSnapshotVersion, 
	    /**
	     * The query for this target.
	     *
	     * Because canonical ids are not unique we must store the actual query. We
	     * use the proto to have an object we can persist without having to
	     * duplicate translation logic to and from a `Query` object.
	     */
	    query) {
	        this.targetId = targetId;
	        this.canonicalId = canonicalId;
	        this.readTime = readTime;
	        this.resumeToken = resumeToken;
	        this.lastListenSequenceNumber = lastListenSequenceNumber;
	        this.lastLimboFreeSnapshotVersion = lastLimboFreeSnapshotVersion;
	        this.query = query;
	    }
	    DbTarget.store = 'targets';
	    /** Keys are automatically assigned via the targetId property. */
	    DbTarget.keyPath = 'targetId';
	    /** The name of the queryTargets index. */
	    DbTarget.queryTargetsIndexName = 'queryTargetsIndex';
	    /**
	     * The index of all canonicalIds to the targets that they match. This is not
	     * a unique mapping because canonicalId does not promise a unique name for all
	     * possible queries, so we append the targetId to make the mapping unique.
	     */
	    DbTarget.queryTargetsKeyPath = ['canonicalId', 'targetId'];
	    return DbTarget;
	}());
	/**
	 * An object representing an association between a target and a document, or a
	 * sentinel row marking the last sequence number at which a document was used.
	 * Each document cached must have a corresponding sentinel row before lru
	 * garbage collection is enabled.
	 *
	 * The target associations and sentinel rows are co-located so that orphaned
	 * documents and their sequence numbers can be identified efficiently via a scan
	 * of this store.
	 */
	var DbTargetDocument = /** @class */ (function () {
	    function DbTargetDocument(
	    /**
	     * The targetId identifying a target or 0 for a sentinel row.
	     */
	    targetId, 
	    /**
	     * The path to the document, as encoded in the key.
	     */
	    path, 
	    /**
	     * If this is a sentinel row, this should be the sequence number of the last
	     * time the document specified by `path` was used. Otherwise, it should be
	     * `undefined`.
	     */
	    sequenceNumber) {
	        this.targetId = targetId;
	        this.path = path;
	        this.sequenceNumber = sequenceNumber;
	        assert((targetId === 0) === (sequenceNumber !== undefined), 'A target-document row must either have targetId == 0 and a defined sequence number, or a non-zero targetId and no sequence number');
	    }
	    /** Name of the IndexedDb object store.  */
	    DbTargetDocument.store = 'targetDocuments';
	    /** Keys are automatically assigned via the targetId, path properties. */
	    DbTargetDocument.keyPath = ['targetId', 'path'];
	    /** The index name for the reverse index. */
	    DbTargetDocument.documentTargetsIndex = 'documentTargetsIndex';
	    /** We also need to create the reverse index for these properties. */
	    DbTargetDocument.documentTargetsKeyPath = ['path', 'targetId'];
	    return DbTargetDocument;
	}());
	/**
	 * A record of global state tracked across all Targets, tracked separately
	 * to avoid the need for extra indexes.
	 *
	 * This should be kept in-sync with the proto used in the iOS client.
	 */
	var DbTargetGlobal = /** @class */ (function () {
	    function DbTargetGlobal(
	    /**
	     * The highest numbered target id across all targets.
	     *
	     * See DbTarget.targetId.
	     */
	    highestTargetId, 
	    /**
	     * The highest numbered lastListenSequenceNumber across all targets.
	     *
	     * See DbTarget.lastListenSequenceNumber.
	     */
	    highestListenSequenceNumber, 
	    /**
	     * A global snapshot version representing the last consistent snapshot we
	     * received from the backend. This is monotonically increasing and any
	     * snapshots received from the backend prior to this version (e.g. for
	     * targets resumed with a resumeToken) should be suppressed (buffered)
	     * until the backend has caught up to this snapshot version again. This
	     * prevents our cache from ever going backwards in time.
	     */
	    lastRemoteSnapshotVersion, 
	    /**
	     * The number of targets persisted.
	     */
	    targetCount) {
	        this.highestTargetId = highestTargetId;
	        this.highestListenSequenceNumber = highestListenSequenceNumber;
	        this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
	        this.targetCount = targetCount;
	    }
	    /**
	     * The key string used for the single object that exists in the
	     * DbTargetGlobal store.
	     */
	    DbTargetGlobal.key = 'targetGlobalKey';
	    DbTargetGlobal.store = 'targetGlobal';
	    return DbTargetGlobal;
	}());
	/**
	 * An object representing an association between a Collection id (e.g. 'messages')
	 * to a parent path (e.g. '/chats/123') that contains it as a (sub)collection.
	 * This is used to efficiently find all collections to query when performing
	 * a Collection Group query.
	 */
	var DbCollectionParent = /** @class */ (function () {
	    function DbCollectionParent(
	    /**
	     * The collectionId (e.g. 'messages')
	     */
	    collectionId, 
	    /**
	     * The path to the parent (either a document location or an empty path for
	     * a root-level collection).
	     */
	    parent) {
	        this.collectionId = collectionId;
	        this.parent = parent;
	    }
	    /** Name of the IndexedDb object store. */
	    DbCollectionParent.store = 'collectionParents';
	    /** Keys are automatically assigned via the collectionId, parent properties. */
	    DbCollectionParent.keyPath = ['collectionId', 'parent'];
	    return DbCollectionParent;
	}());
	function createQueryCache(db) {
	    var targetDocumentsStore = db.createObjectStore(DbTargetDocument.store, {
	        keyPath: DbTargetDocument.keyPath
	    });
	    targetDocumentsStore.createIndex(DbTargetDocument.documentTargetsIndex, DbTargetDocument.documentTargetsKeyPath, { unique: true });
	    var targetStore = db.createObjectStore(DbTarget.store, {
	        keyPath: DbTarget.keyPath
	    });
	    // NOTE: This is unique only because the TargetId is the suffix.
	    targetStore.createIndex(DbTarget.queryTargetsIndexName, DbTarget.queryTargetsKeyPath, { unique: true });
	    db.createObjectStore(DbTargetGlobal.store);
	}
	function dropQueryCache(db) {
	    db.deleteObjectStore(DbTargetDocument.store);
	    db.deleteObjectStore(DbTarget.store);
	    db.deleteObjectStore(DbTargetGlobal.store);
	}
	function dropRemoteDocumentChangesStore(db) {
	    if (db.objectStoreNames.contains('remoteDocumentChanges')) {
	        db.deleteObjectStore('remoteDocumentChanges');
	    }
	}
	/**
	 * Creates the target global singleton row.
	 *
	 * @param {IDBTransaction} txn The version upgrade transaction for indexeddb
	 */
	function writeEmptyTargetGlobalEntry(txn) {
	    var globalStore = txn.store(DbTargetGlobal.store);
	    var metadata = new DbTargetGlobal(
	    /*highestTargetId=*/ 0, 
	    /*lastListenSequenceNumber=*/ 0, SnapshotVersion.MIN.toTimestamp(), 
	    /*targetCount=*/ 0);
	    return globalStore.put(DbTargetGlobal.key, metadata);
	}
	/**
	 * Creates indices on the RemoteDocuments store used for both multi-tab
	 * and Index-Free queries.
	 */
	function createRemoteDocumentReadTimeIndex(txn) {
	    var remoteDocumentStore = txn.objectStore(DbRemoteDocument.store);
	    remoteDocumentStore.createIndex(DbRemoteDocument.readTimeIndex, DbRemoteDocument.readTimeIndexPath, { unique: false });
	    remoteDocumentStore.createIndex(DbRemoteDocument.collectionReadTimeIndex, DbRemoteDocument.collectionReadTimeIndexPath, { unique: false });
	}
	/**
	 * A record of the metadata state of each client.
	 *
	 * PORTING NOTE: This is used to synchronize multi-tab state and does not need
	 * to be ported to iOS or Android.
	 */
	var DbClientMetadata = /** @class */ (function () {
	    function DbClientMetadata(
	    // Note: Previous schema versions included a field
	    // "lastProcessedDocumentChangeId". Don't use anymore.
	    /** The auto-generated client id assigned at client startup. */
	    clientId, 
	    /** The last time this state was updated. */
	    updateTimeMs, 
	    /** Whether the client's network connection is enabled. */
	    networkEnabled, 
	    /** Whether this client is running in a foreground tab. */
	    inForeground) {
	        this.clientId = clientId;
	        this.updateTimeMs = updateTimeMs;
	        this.networkEnabled = networkEnabled;
	        this.inForeground = inForeground;
	    }
	    /** Name of the IndexedDb object store. */
	    DbClientMetadata.store = 'clientMetadata';
	    /** Keys are automatically assigned via the clientId properties. */
	    DbClientMetadata.keyPath = 'clientId';
	    return DbClientMetadata;
	}());
	function createClientMetadataStore(db) {
	    db.createObjectStore(DbClientMetadata.store, {
	        keyPath: DbClientMetadata.keyPath
	    });
	}
	// Visible for testing
	var V1_STORES = [
	    DbMutationQueue.store,
	    DbMutationBatch.store,
	    DbDocumentMutation.store,
	    DbRemoteDocument.store,
	    DbTarget.store,
	    DbPrimaryClient.store,
	    DbTargetGlobal.store,
	    DbTargetDocument.store
	];
	// V2 is no longer usable (see comment at top of file)
	// Visible for testing
	var V3_STORES = V1_STORES;
	// Visible for testing
	// Note: DbRemoteDocumentChanges is no longer used and dropped with v9.
	var V4_STORES = tslib.__spreadArrays(V3_STORES, [DbClientMetadata.store]);
	// V5 does not change the set of stores.
	var V6_STORES = tslib.__spreadArrays(V4_STORES, [DbRemoteDocumentGlobal.store]);
	// V7 does not change the set of stores.
	var V8_STORES = tslib.__spreadArrays(V6_STORES, [DbCollectionParent.store]);
	// V9 does not change the set of stores.
	/**
	 * The list of all default IndexedDB stores used throughout the SDK. This is
	 * used when creating transactions so that access across all stores is done
	 * atomically.
	 */
	var ALL_STORES = V8_STORES;
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A persisted implementation of IndexManager.
	 */
	var IndexedDbIndexManager = /** @class */ (function () {
	    function IndexedDbIndexManager() {
	        /**
	         * An in-memory copy of the index entries we've already written since the SDK
	         * launched. Used to avoid re-writing the same entry repeatedly.
	         *
	         * This is *NOT* a complete cache of what's in persistence and so can never be used to
	         * satisfy reads.
	         */
	        this.collectionParentsCache = new MemoryCollectionParentIndex();
	    }
	    /**
	     * Adds a new entry to the collection parent index.
	     *
	     * Repeated calls for the same collectionPath should be avoided within a
	     * transaction as IndexedDbIndexManager only caches writes once a transaction
	     * has been committed.
	     */
	    IndexedDbIndexManager.prototype.addToCollectionParentIndex = function (transaction, collectionPath) {
	        var _this = this;
	        assert(collectionPath.length % 2 === 1, 'Expected a collection path.');
	        if (!this.collectionParentsCache.has(collectionPath)) {
	            var collectionId = collectionPath.lastSegment();
	            var parentPath = collectionPath.popLast();
	            transaction.addOnCommittedListener(function () {
	                // Add the collection to the in memory cache only if the transaction was
	                // successfully committed.
	                _this.collectionParentsCache.add(collectionPath);
	            });
	            var collectionParent = {
	                collectionId: collectionId,
	                parent: encode(parentPath)
	            };
	            return collectionParentsStore(transaction).put(collectionParent);
	        }
	        return PersistencePromise.resolve();
	    };
	    IndexedDbIndexManager.prototype.getCollectionParents = function (transaction, collectionId) {
	        var parentPaths = [];
	        var range = IDBKeyRange.bound([collectionId, ''], [immediateSuccessor(collectionId), ''], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        return collectionParentsStore(transaction)
	            .loadAll(range)
	            .next(function (entries) {
	            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                var entry = entries_1[_i];
	                // This collectionId guard shouldn't be necessary (and isn't as long
	                // as we're running in a real browser), but there's a bug in
	                // indexeddbshim that breaks our range in our tests running in node:
	                // https://github.com/axemclion/IndexedDBShim/issues/334
	                if (entry.collectionId !== collectionId) {
	                    break;
	                }
	                parentPaths.push(decode(entry.parent));
	            }
	            return parentPaths;
	        });
	    };
	    return IndexedDbIndexManager;
	}());
	/**
	 * Helper to get a typed SimpleDbStore for the collectionParents
	 * document store.
	 */
	function collectionParentsStore(txn) {
	    return IndexedDbPersistence.getStore(txn, DbCollectionParent.store);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** An enumeration of the different purposes we have for targets. */
	var TargetPurpose;
	(function (TargetPurpose) {
	    /** A regular, normal query target. */
	    TargetPurpose[TargetPurpose["Listen"] = 0] = "Listen";
	    /**
	     * The query target was used to refill a query after an existence filter mismatch.
	     */
	    TargetPurpose[TargetPurpose["ExistenceFilterMismatch"] = 1] = "ExistenceFilterMismatch";
	    /** The query target was used to resolve a limbo document. */
	    TargetPurpose[TargetPurpose["LimboResolution"] = 2] = "LimboResolution";
	})(TargetPurpose || (TargetPurpose = {}));
	/**
	 * An immutable set of metadata that the local store tracks for each target.
	 */
	var TargetData = /** @class */ (function () {
	    function TargetData(
	    /** The target being listened to. */
	    target, 
	    /**
	     * The target ID to which the target corresponds; Assigned by the
	     * LocalStore for user listens and by the SyncEngine for limbo watches.
	     */
	    targetId, 
	    /** The purpose of the target. */
	    purpose, 
	    /**
	     * The sequence number of the last transaction during which this target data
	     * was modified.
	     */
	    sequenceNumber, 
	    /** The latest snapshot version seen for this target. */
	    snapshotVersion, 
	    /**
	     * The maximum snapshot version at which the associated view
	     * contained no limbo documents.
	     */
	    lastLimboFreeSnapshotVersion, 
	    /**
	     * An opaque, server-assigned token that allows watching a target to be
	     * resumed after disconnecting without retransmitting all the data that
	     * matches the target. The resume token essentially identifies a point in
	     * time from which the server should resume sending results.
	     */
	    resumeToken) {
	        if (snapshotVersion === void 0) { snapshotVersion = SnapshotVersion.MIN; }
	        if (lastLimboFreeSnapshotVersion === void 0) { lastLimboFreeSnapshotVersion = SnapshotVersion.MIN; }
	        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
	        this.target = target;
	        this.targetId = targetId;
	        this.purpose = purpose;
	        this.sequenceNumber = sequenceNumber;
	        this.snapshotVersion = snapshotVersion;
	        this.lastLimboFreeSnapshotVersion = lastLimboFreeSnapshotVersion;
	        this.resumeToken = resumeToken;
	    }
	    /** Creates a new target data instance with an updated sequence number. */
	    TargetData.prototype.withSequenceNumber = function (sequenceNumber) {
	        return new TargetData(this.target, this.targetId, this.purpose, sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken);
	    };
	    /**
	     * Creates a new target data instance with an updated resume token and
	     * snapshot version.
	     */
	    TargetData.prototype.withResumeToken = function (resumeToken, snapshotVersion) {
	        return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, snapshotVersion, this.lastLimboFreeSnapshotVersion, resumeToken);
	    };
	    /**
	     * Creates a new target data instance with an updated last limbo free
	     * snapshot version number.
	     */
	    TargetData.prototype.withLastLimboFreeSnapshotVersion = function (lastLimboFreeSnapshotVersion) {
	        return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, lastLimboFreeSnapshotVersion, this.resumeToken);
	    };
	    TargetData.prototype.isEqual = function (other) {
	        return (this.targetId === other.targetId &&
	            this.purpose === other.purpose &&
	            this.sequenceNumber === other.sequenceNumber &&
	            this.snapshotVersion.isEqual(other.snapshotVersion) &&
	            this.lastLimboFreeSnapshotVersion.isEqual(other.lastLimboFreeSnapshotVersion) &&
	            this.resumeToken === other.resumeToken &&
	            this.target.isEqual(other.target));
	    };
	    return TargetData;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Serializer for values stored in the LocalStore. */
	var LocalSerializer = /** @class */ (function () {
	    function LocalSerializer(remoteSerializer) {
	        this.remoteSerializer = remoteSerializer;
	    }
	    /** Decodes a remote document from storage locally to a Document. */
	    LocalSerializer.prototype.fromDbRemoteDocument = function (remoteDoc) {
	        if (remoteDoc.document) {
	            return this.remoteSerializer.fromDocument(remoteDoc.document, !!remoteDoc.hasCommittedMutations);
	        }
	        else if (remoteDoc.noDocument) {
	            var key = DocumentKey.fromSegments(remoteDoc.noDocument.path);
	            var version = this.fromDbTimestamp(remoteDoc.noDocument.readTime);
	            return new NoDocument(key, version, {
	                hasCommittedMutations: !!remoteDoc.hasCommittedMutations
	            });
	        }
	        else if (remoteDoc.unknownDocument) {
	            var key = DocumentKey.fromSegments(remoteDoc.unknownDocument.path);
	            var version = this.fromDbTimestamp(remoteDoc.unknownDocument.version);
	            return new UnknownDocument(key, version);
	        }
	        else {
	            return fail('Unexpected DbRemoteDocument');
	        }
	    };
	    /** Encodes a document for storage locally. */
	    LocalSerializer.prototype.toDbRemoteDocument = function (maybeDoc, readTime) {
	        var dbReadTime = this.toDbTimestampKey(readTime);
	        var parentPath = maybeDoc.key.path.popLast().toArray();
	        if (maybeDoc instanceof Document) {
	            var doc = maybeDoc.proto
	                ? maybeDoc.proto
	                : this.remoteSerializer.toDocument(maybeDoc);
	            var hasCommittedMutations = maybeDoc.hasCommittedMutations;
	            return new DbRemoteDocument(
	            /* unknownDocument= */ null, 
	            /* noDocument= */ null, doc, hasCommittedMutations, dbReadTime, parentPath);
	        }
	        else if (maybeDoc instanceof NoDocument) {
	            var path = maybeDoc.key.path.toArray();
	            var readTime_1 = this.toDbTimestamp(maybeDoc.version);
	            var hasCommittedMutations = maybeDoc.hasCommittedMutations;
	            return new DbRemoteDocument(
	            /* unknownDocument= */ null, new DbNoDocument(path, readTime_1), 
	            /* document= */ null, hasCommittedMutations, dbReadTime, parentPath);
	        }
	        else if (maybeDoc instanceof UnknownDocument) {
	            var path = maybeDoc.key.path.toArray();
	            var readTime_2 = this.toDbTimestamp(maybeDoc.version);
	            return new DbRemoteDocument(new DbUnknownDocument(path, readTime_2), 
	            /* noDocument= */ null, 
	            /* document= */ null, 
	            /* hasCommittedMutations= */ true, dbReadTime, parentPath);
	        }
	        else {
	            return fail('Unexpected MaybeDocument');
	        }
	    };
	    LocalSerializer.prototype.toDbTimestampKey = function (snapshotVersion) {
	        var timestamp = snapshotVersion.toTimestamp();
	        return [timestamp.seconds, timestamp.nanoseconds];
	    };
	    LocalSerializer.prototype.fromDbTimestampKey = function (dbTimestampKey) {
	        var timestamp = new Timestamp(dbTimestampKey[0], dbTimestampKey[1]);
	        return SnapshotVersion.fromTimestamp(timestamp);
	    };
	    LocalSerializer.prototype.toDbTimestamp = function (snapshotVersion) {
	        var timestamp = snapshotVersion.toTimestamp();
	        return new DbTimestamp(timestamp.seconds, timestamp.nanoseconds);
	    };
	    LocalSerializer.prototype.fromDbTimestamp = function (dbTimestamp) {
	        var timestamp = new Timestamp(dbTimestamp.seconds, dbTimestamp.nanoseconds);
	        return SnapshotVersion.fromTimestamp(timestamp);
	    };
	    /** Encodes a batch of mutations into a DbMutationBatch for local storage. */
	    LocalSerializer.prototype.toDbMutationBatch = function (userId, batch) {
	        var _this = this;
	        var serializedBaseMutations = batch.baseMutations.map(function (m) {
	            return _this.remoteSerializer.toMutation(m);
	        });
	        var serializedMutations = batch.mutations.map(function (m) {
	            return _this.remoteSerializer.toMutation(m);
	        });
	        return new DbMutationBatch(userId, batch.batchId, batch.localWriteTime.toMillis(), serializedBaseMutations, serializedMutations);
	    };
	    /** Decodes a DbMutationBatch into a MutationBatch */
	    LocalSerializer.prototype.fromDbMutationBatch = function (dbBatch) {
	        var _this = this;
	        var baseMutations = (dbBatch.baseMutations || []).map(function (m) {
	            return _this.remoteSerializer.fromMutation(m);
	        });
	        var mutations = dbBatch.mutations.map(function (m) {
	            return _this.remoteSerializer.fromMutation(m);
	        });
	        var timestamp = Timestamp.fromMillis(dbBatch.localWriteTimeMs);
	        return new MutationBatch(dbBatch.batchId, timestamp, baseMutations, mutations);
	    };
	    /*
	     * Encodes a set of document keys into an array of EncodedResourcePaths.
	     */
	    LocalSerializer.prototype.toDbResourcePaths = function (keys) {
	        var encodedKeys = [];
	        keys.forEach(function (key) {
	            encodedKeys.push(encode(key.path));
	        });
	        return encodedKeys;
	    };
	    /** Decodes an array of EncodedResourcePaths into a set of document keys. */
	    LocalSerializer.prototype.fromDbResourcePaths = function (encodedPaths) {
	        var keys = documentKeySet();
	        for (var _i = 0, encodedPaths_1 = encodedPaths; _i < encodedPaths_1.length; _i++) {
	            var documentKey = encodedPaths_1[_i];
	            keys = keys.add(new DocumentKey(decode(documentKey)));
	        }
	        return keys;
	    };
	    /** Decodes a DbTarget into TargetData */
	    LocalSerializer.prototype.fromDbTarget = function (dbTarget) {
	        var version = this.fromDbTimestamp(dbTarget.readTime);
	        var lastLimboFreeSnapshotVersion = dbTarget.lastLimboFreeSnapshotVersion !== undefined
	            ? this.fromDbTimestamp(dbTarget.lastLimboFreeSnapshotVersion)
	            : SnapshotVersion.MIN;
	        // TODO(b/140573486): Convert to platform representation
	        var resumeToken = dbTarget.resumeToken;
	        var target;
	        if (isDocumentQuery(dbTarget.query)) {
	            target = this.remoteSerializer.fromDocumentsTarget(dbTarget.query);
	        }
	        else {
	            target = this.remoteSerializer.fromQueryTarget(dbTarget.query);
	        }
	        return new TargetData(target, dbTarget.targetId, TargetPurpose.Listen, dbTarget.lastListenSequenceNumber, version, lastLimboFreeSnapshotVersion, resumeToken);
	    };
	    /** Encodes TargetData into a DbTarget for storage locally. */
	    LocalSerializer.prototype.toDbTarget = function (targetData) {
	        assert(TargetPurpose.Listen === targetData.purpose, 'Only queries with purpose ' +
	            TargetPurpose.Listen +
	            ' may be stored, got ' +
	            targetData.purpose);
	        var dbTimestamp = this.toDbTimestamp(targetData.snapshotVersion);
	        var dbLastLimboFreeTimestamp = this.toDbTimestamp(targetData.lastLimboFreeSnapshotVersion);
	        var queryProto;
	        if (targetData.target.isDocumentQuery()) {
	            queryProto = this.remoteSerializer.toDocumentsTarget(targetData.target);
	        }
	        else {
	            queryProto = this.remoteSerializer.toQueryTarget(targetData.target);
	        }
	        var resumeToken;
	        if (targetData.resumeToken instanceof Uint8Array) {
	            // TODO(b/78771403): Convert tokens to strings during deserialization
	            assert(SimpleDb.isMockPersistence(), 'Persisting non-string stream tokens is only supported with mock persistence .');
	            resumeToken = targetData.resumeToken.toString();
	        }
	        else {
	            resumeToken = targetData.resumeToken;
	        }
	        // lastListenSequenceNumber is always 0 until we do real GC.
	        return new DbTarget(targetData.targetId, targetData.target.canonicalId(), dbTimestamp, resumeToken, targetData.sequenceNumber, dbLastLimboFreeTimestamp, queryProto);
	    };
	    return LocalSerializer;
	}());
	/**
	 * A helper function for figuring out what kind of query has been stored.
	 */
	function isDocumentQuery(dbQuery) {
	    return dbQuery.documents !== undefined;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A readonly view of the local state of all documents we're tracking (i.e. we
	 * have a cached version in remoteDocumentCache or local mutations for the
	 * document). The view is computed by applying the mutations in the
	 * MutationQueue to the RemoteDocumentCache.
	 */
	var LocalDocumentsView = /** @class */ (function () {
	    function LocalDocumentsView(remoteDocumentCache, mutationQueue, indexManager) {
	        this.remoteDocumentCache = remoteDocumentCache;
	        this.mutationQueue = mutationQueue;
	        this.indexManager = indexManager;
	    }
	    /**
	     * Get the local view of the document identified by `key`.
	     *
	     * @return Local view of the document or null if we don't have any cached
	     * state for it.
	     */
	    LocalDocumentsView.prototype.getDocument = function (transaction, key) {
	        var _this = this;
	        return this.mutationQueue
	            .getAllMutationBatchesAffectingDocumentKey(transaction, key)
	            .next(function (batches) { return _this.getDocumentInternal(transaction, key, batches); });
	    };
	    /** Internal version of `getDocument` that allows reusing batches. */
	    LocalDocumentsView.prototype.getDocumentInternal = function (transaction, key, inBatches) {
	        return this.remoteDocumentCache.getEntry(transaction, key).next(function (doc) {
	            for (var _i = 0, inBatches_1 = inBatches; _i < inBatches_1.length; _i++) {
	                var batch = inBatches_1[_i];
	                doc = batch.applyToLocalView(key, doc);
	            }
	            return doc;
	        });
	    };
	    // Returns the view of the given `docs` as they would appear after applying
	    // all mutations in the given `batches`.
	    LocalDocumentsView.prototype.applyLocalMutationsToDocuments = function (transaction, docs, batches) {
	        var results = nullableMaybeDocumentMap();
	        docs.forEach(function (key, localView) {
	            for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
	                var batch = batches_1[_i];
	                localView = batch.applyToLocalView(key, localView);
	            }
	            results = results.insert(key, localView);
	        });
	        return results;
	    };
	    /**
	     * Gets the local view of the documents identified by `keys`.
	     *
	     * If we don't have cached state for a document in `keys`, a NoDocument will
	     * be stored for that key in the resulting set.
	     */
	    LocalDocumentsView.prototype.getDocuments = function (transaction, keys) {
	        var _this = this;
	        return this.remoteDocumentCache
	            .getEntries(transaction, keys)
	            .next(function (docs) { return _this.getLocalViewOfDocuments(transaction, docs); });
	    };
	    /**
	     * Similar to `getDocuments`, but creates the local view from the given
	     * `baseDocs` without retrieving documents from the local store.
	     */
	    LocalDocumentsView.prototype.getLocalViewOfDocuments = function (transaction, baseDocs) {
	        var _this = this;
	        return this.mutationQueue
	            .getAllMutationBatchesAffectingDocumentKeys(transaction, baseDocs)
	            .next(function (batches) {
	            var docs = _this.applyLocalMutationsToDocuments(transaction, baseDocs, batches);
	            var results = maybeDocumentMap();
	            docs.forEach(function (key, maybeDoc) {
	                // TODO(http://b/32275378): Don't conflate missing / deleted.
	                if (!maybeDoc) {
	                    maybeDoc = new NoDocument(key, SnapshotVersion.forDeletedDoc());
	                }
	                results = results.insert(key, maybeDoc);
	            });
	            return results;
	        });
	    };
	    /**
	     * Performs a query against the local view of all documents.
	     *
	     * @param transaction The persistence transaction.
	     * @param query The query to match documents against.
	     * @param sinceReadTime If not set to SnapshotVersion.MIN, return only
	     *     documents that have been read since this snapshot version (exclusive).
	     */
	    LocalDocumentsView.prototype.getDocumentsMatchingQuery = function (transaction, query, sinceReadTime) {
	        if (query.isDocumentQuery()) {
	            return this.getDocumentsMatchingDocumentQuery(transaction, query.path);
	        }
	        else if (query.isCollectionGroupQuery()) {
	            return this.getDocumentsMatchingCollectionGroupQuery(transaction, query, sinceReadTime);
	        }
	        else {
	            return this.getDocumentsMatchingCollectionQuery(transaction, query, sinceReadTime);
	        }
	    };
	    LocalDocumentsView.prototype.getDocumentsMatchingDocumentQuery = function (transaction, docPath) {
	        // Just do a simple document lookup.
	        return this.getDocument(transaction, new DocumentKey(docPath)).next(function (maybeDoc) {
	            var result = documentMap();
	            if (maybeDoc instanceof Document) {
	                result = result.insert(maybeDoc.key, maybeDoc);
	            }
	            return result;
	        });
	    };
	    LocalDocumentsView.prototype.getDocumentsMatchingCollectionGroupQuery = function (transaction, query, sinceReadTime) {
	        var _this = this;
	        assert(query.path.isEmpty(), 'Currently we only support collection group queries at the root.');
	        var collectionId = query.collectionGroup;
	        var results = documentMap();
	        return this.indexManager
	            .getCollectionParents(transaction, collectionId)
	            .next(function (parents) {
	            // Perform a collection query against each parent that contains the
	            // collectionId and aggregate the results.
	            return PersistencePromise.forEach(parents, function (parent) {
	                var collectionQuery = query.asCollectionQueryAtPath(parent.child(collectionId));
	                return _this.getDocumentsMatchingCollectionQuery(transaction, collectionQuery, sinceReadTime).next(function (r) {
	                    r.forEach(function (key, doc) {
	                        results = results.insert(key, doc);
	                    });
	                });
	            }).next(function () { return results; });
	        });
	    };
	    LocalDocumentsView.prototype.getDocumentsMatchingCollectionQuery = function (transaction, query, sinceReadTime) {
	        var _this = this;
	        // Query the remote documents and overlay mutations.
	        var results;
	        var mutationBatches;
	        return this.remoteDocumentCache
	            .getDocumentsMatchingQuery(transaction, query, sinceReadTime)
	            .next(function (queryResults) {
	            results = queryResults;
	            return _this.mutationQueue.getAllMutationBatchesAffectingQuery(transaction, query);
	        })
	            .next(function (matchingMutationBatches) {
	            mutationBatches = matchingMutationBatches;
	            // It is possible that a PatchMutation can make a document match a query, even if
	            // the version in the RemoteDocumentCache is not a match yet (waiting for server
	            // to ack). To handle this, we find all document keys affected by the PatchMutations
	            // that are not in `result` yet, and back fill them via `remoteDocumentCache.getEntries`,
	            // otherwise those `PatchMutations` will be ignored because no base document can be found,
	            // and lead to missing result for the query.
	            return _this.addMissingBaseDocuments(transaction, mutationBatches, results).next(function (mergedDocuments) {
	                results = mergedDocuments;
	                for (var _i = 0, mutationBatches_1 = mutationBatches; _i < mutationBatches_1.length; _i++) {
	                    var batch = mutationBatches_1[_i];
	                    for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                        var mutation = _b[_a];
	                        var key = mutation.key;
	                        var baseDoc = results.get(key);
	                        var mutatedDoc = mutation.applyToLocalView(baseDoc, baseDoc, batch.localWriteTime);
	                        if (mutatedDoc instanceof Document) {
	                            results = results.insert(key, mutatedDoc);
	                        }
	                        else {
	                            results = results.remove(key);
	                        }
	                    }
	                }
	            });
	        })
	            .next(function () {
	            // Finally, filter out any documents that don't actually match
	            // the query.
	            results.forEach(function (key, doc) {
	                if (!query.matches(doc)) {
	                    results = results.remove(key);
	                }
	            });
	            return results;
	        });
	    };
	    LocalDocumentsView.prototype.addMissingBaseDocuments = function (transaction, matchingMutationBatches, existingDocuments) {
	        var missingBaseDocEntriesForPatching = documentKeySet();
	        for (var _i = 0, matchingMutationBatches_1 = matchingMutationBatches; _i < matchingMutationBatches_1.length; _i++) {
	            var batch = matchingMutationBatches_1[_i];
	            for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                var mutation = _b[_a];
	                if (mutation instanceof PatchMutation &&
	                    existingDocuments.get(mutation.key) === null) {
	                    missingBaseDocEntriesForPatching = missingBaseDocEntriesForPatching.add(mutation.key);
	                }
	            }
	        }
	        var mergedDocuments = existingDocuments;
	        return this.remoteDocumentCache
	            .getEntries(transaction, missingBaseDocEntriesForPatching)
	            .next(function (missingBaseDocs) {
	            missingBaseDocs.forEach(function (key, doc) {
	                if (doc !== null && doc instanceof Document) {
	                    mergedDocuments = mergedDocuments.insert(key, doc);
	                }
	            });
	            return mergedDocuments;
	        });
	    };
	    return LocalDocumentsView;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PRIMARY_LEASE_LOST_ERROR_MSG = 'The current tab is not in the required state to perform this operation. ' +
	    'It might be necessary to refresh the browser tab.';
	/**
	 * A base class representing a persistence transaction, encapsulating both the
	 * transaction's sequence numbers as well as a list of onCommitted listeners.
	 *
	 * When you call Persistence.runTransaction(), it will create a transaction and
	 * pass it to your callback. You then pass it to any method that operates
	 * on persistence.
	 */
	var PersistenceTransaction = /** @class */ (function () {
	    function PersistenceTransaction() {
	        this.onCommittedListeners = [];
	    }
	    PersistenceTransaction.prototype.addOnCommittedListener = function (listener) {
	        this.onCommittedListeners.push(listener);
	    };
	    PersistenceTransaction.prototype.raiseOnCommittedEvent = function () {
	        this.onCommittedListeners.forEach(function (listener) { return listener(); });
	    };
	    return PersistenceTransaction;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A collection of references to a document from some kind of numbered entity
	 * (either a target ID or batch ID). As references are added to or removed from
	 * the set corresponding events are emitted to a registered garbage collector.
	 *
	 * Each reference is represented by a DocumentReference object. Each of them
	 * contains enough information to uniquely identify the reference. They are all
	 * stored primarily in a set sorted by key. A document is considered garbage if
	 * there's no references in that set (this can be efficiently checked thanks to
	 * sorting by key).
	 *
	 * ReferenceSet also keeps a secondary set that contains references sorted by
	 * IDs. This one is used to efficiently implement removal of all references by
	 * some target ID.
	 */
	var ReferenceSet = /** @class */ (function () {
	    function ReferenceSet() {
	        // A set of outstanding references to a document sorted by key.
	        this.refsByKey = new SortedSet(DocReference.compareByKey);
	        // A set of outstanding references to a document sorted by target id.
	        this.refsByTarget = new SortedSet(DocReference.compareByTargetId);
	    }
	    /** Returns true if the reference set contains no references. */
	    ReferenceSet.prototype.isEmpty = function () {
	        return this.refsByKey.isEmpty();
	    };
	    /** Adds a reference to the given document key for the given ID. */
	    ReferenceSet.prototype.addReference = function (key, id) {
	        var ref = new DocReference(key, id);
	        this.refsByKey = this.refsByKey.add(ref);
	        this.refsByTarget = this.refsByTarget.add(ref);
	    };
	    /** Add references to the given document keys for the given ID. */
	    ReferenceSet.prototype.addReferences = function (keys, id) {
	        var _this = this;
	        keys.forEach(function (key) { return _this.addReference(key, id); });
	    };
	    /**
	     * Removes a reference to the given document key for the given
	     * ID.
	     */
	    ReferenceSet.prototype.removeReference = function (key, id) {
	        this.removeRef(new DocReference(key, id));
	    };
	    ReferenceSet.prototype.removeReferences = function (keys, id) {
	        var _this = this;
	        keys.forEach(function (key) { return _this.removeReference(key, id); });
	    };
	    /**
	     * Clears all references with a given ID. Calls removeRef() for each key
	     * removed.
	     */
	    ReferenceSet.prototype.removeReferencesForId = function (id) {
	        var _this = this;
	        var emptyKey = DocumentKey.EMPTY;
	        var startRef = new DocReference(emptyKey, id);
	        var endRef = new DocReference(emptyKey, id + 1);
	        var keys = [];
	        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
	            _this.removeRef(ref);
	            keys.push(ref.key);
	        });
	        return keys;
	    };
	    ReferenceSet.prototype.removeAllReferences = function () {
	        var _this = this;
	        this.refsByKey.forEach(function (ref) { return _this.removeRef(ref); });
	    };
	    ReferenceSet.prototype.removeRef = function (ref) {
	        this.refsByKey = this.refsByKey.delete(ref);
	        this.refsByTarget = this.refsByTarget.delete(ref);
	    };
	    ReferenceSet.prototype.referencesForId = function (id) {
	        var emptyKey = DocumentKey.EMPTY;
	        var startRef = new DocReference(emptyKey, id);
	        var endRef = new DocReference(emptyKey, id + 1);
	        var keys = documentKeySet();
	        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
	            keys = keys.add(ref.key);
	        });
	        return keys;
	    };
	    ReferenceSet.prototype.containsKey = function (key) {
	        var ref = new DocReference(key, 0);
	        var firstRef = this.refsByKey.firstAfterOrEqual(ref);
	        return firstRef !== null && key.isEqual(firstRef.key);
	    };
	    return ReferenceSet;
	}());
	var DocReference = /** @class */ (function () {
	    function DocReference(key, targetOrBatchId) {
	        this.key = key;
	        this.targetOrBatchId = targetOrBatchId;
	    }
	    /** Compare by key then by ID */
	    DocReference.compareByKey = function (left, right) {
	        return (DocumentKey.comparator(left.key, right.key) ||
	            primitiveComparator(left.targetOrBatchId, right.targetOrBatchId));
	    };
	    /** Compare by ID then by key */
	    DocReference.compareByTargetId = function (left, right) {
	        return (primitiveComparator(left.targetOrBatchId, right.targetOrBatchId) ||
	            DocumentKey.comparator(left.key, right.key));
	    };
	    return DocReference;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$1 = 'LocalStore';
	/**
	 * Local storage in the Firestore client. Coordinates persistence components
	 * like the mutation queue and remote document cache to present a
	 * latency-compensated view of stored data.
	 *
	 * The LocalStore is responsible for accepting mutations from the Sync Engine.
	 * Writes from the client are put into a queue as provisional Mutations until
	 * they are processed by the RemoteStore and confirmed as having been written
	 * to the server.
	 *
	 * The local store provides the local version of documents that have been
	 * modified locally. It maintains the constraint:
	 *
	 *   LocalDocument = RemoteDocument + Active(LocalMutations)
	 *
	 * (Active mutations are those that are enqueued and have not been previously
	 * acknowledged or rejected).
	 *
	 * The RemoteDocument ("ground truth") state is provided via the
	 * applyChangeBatch method. It will be some version of a server-provided
	 * document OR will be a server-provided document PLUS acknowledged mutations:
	 *
	 *   RemoteDocument' = RemoteDocument + Acknowledged(LocalMutations)
	 *
	 * Note that this "dirty" version of a RemoteDocument will not be identical to a
	 * server base version, since it has LocalMutations added to it pending getting
	 * an authoritative copy from the server.
	 *
	 * Since LocalMutations can be rejected by the server, we have to be able to
	 * revert a LocalMutation that has already been applied to the LocalDocument
	 * (typically done by replaying all remaining LocalMutations to the
	 * RemoteDocument to re-apply).
	 *
	 * The LocalStore is responsible for the garbage collection of the documents it
	 * contains. For now, it every doc referenced by a view, the mutation queue, or
	 * the RemoteStore.
	 *
	 * It also maintains the persistence of mapping queries to resume tokens and
	 * target ids. It needs to know this data about queries to properly know what
	 * docs it would be allowed to garbage collect.
	 *
	 * The LocalStore must be able to efficiently execute queries against its local
	 * cache of the documents, to provide the initial set of results before any
	 * remote changes have been received.
	 *
	 * Note: In TypeScript, most methods return Promises since the implementation
	 * may rely on fetching data from IndexedDB which is async.
	 * These Promises will only be rejected on an I/O error or other internal
	 * (unexpected) failure (e.g. failed assert) and always represent an
	 * unrecoverable error (should be caught / reported by the async_queue).
	 */
	var LocalStore = /** @class */ (function () {
	    function LocalStore(
	    /** Manages our in-memory or durable persistence. */
	    persistence, queryEngine, initialUser) {
	        this.persistence = persistence;
	        this.queryEngine = queryEngine;
	        /**
	         * The set of document references maintained by any local views.
	         */
	        this.localViewReferences = new ReferenceSet();
	        /**
	         * Maps a targetID to data about its target.
	         *
	         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
	         * of `applyRemoteEvent()` idempotent.
	         */
	        this.targetDataByTarget = new SortedMap(primitiveComparator);
	        /** Maps a target to its targetID. */
	        // TODO(wuandy): Evaluate if TargetId can be part of Target.
	        this.targetIdByTarget = new ObjectMap(function (t) {
	            return t.canonicalId();
	        });
	        /**
	         * The read time of the last entry processed by `getNewDocumentChanges()`.
	         *
	         * PORTING NOTE: This is only used for multi-tab synchronization.
	         */
	        this.lastDocumentChangeReadTime = SnapshotVersion.MIN;
	        assert(persistence.started, 'LocalStore was passed an unstarted persistence implementation');
	        this.persistence.referenceDelegate.setInMemoryPins(this.localViewReferences);
	        this.mutationQueue = persistence.getMutationQueue(initialUser);
	        this.remoteDocuments = persistence.getRemoteDocumentCache();
	        this.targetCache = persistence.getTargetCache();
	        this.localDocuments = new LocalDocumentsView(this.remoteDocuments, this.mutationQueue, this.persistence.getIndexManager());
	        this.queryEngine.setLocalDocumentsView(this.localDocuments);
	    }
	    /** Starts the LocalStore. */
	    LocalStore.prototype.start = function () {
	        return this.synchronizeLastDocumentChangeReadTime();
	    };
	    /**
	     * Tells the LocalStore that the currently authenticated user has changed.
	     *
	     * In response the local store switches the mutation queue to the new user and
	     * returns any resulting document changes.
	     */
	    // PORTING NOTE: Android and iOS only return the documents affected by the
	    // change.
	    LocalStore.prototype.handleUserChange = function (user) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var newMutationQueue, newLocalDocuments, result;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        newMutationQueue = this.mutationQueue;
	                        newLocalDocuments = this.localDocuments;
	                        return [4 /*yield*/, this.persistence.runTransaction('Handle user change', 'readonly-idempotent', function (txn) {
	                                // Swap out the mutation queue, grabbing the pending mutation batches
	                                // before and after.
	                                var oldBatches;
	                                return _this.mutationQueue
	                                    .getAllMutationBatches(txn)
	                                    .next(function (promisedOldBatches) {
	                                    oldBatches = promisedOldBatches;
	                                    newMutationQueue = _this.persistence.getMutationQueue(user);
	                                    // Recreate our LocalDocumentsView using the new
	                                    // MutationQueue.
	                                    newLocalDocuments = new LocalDocumentsView(_this.remoteDocuments, newMutationQueue, _this.persistence.getIndexManager());
	                                    return newMutationQueue.getAllMutationBatches(txn);
	                                })
	                                    .next(function (newBatches) {
	                                    var removedBatchIds = [];
	                                    var addedBatchIds = [];
	                                    // Union the old/new changed keys.
	                                    var changedKeys = documentKeySet();
	                                    for (var _i = 0, oldBatches_1 = oldBatches; _i < oldBatches_1.length; _i++) {
	                                        var batch = oldBatches_1[_i];
	                                        removedBatchIds.push(batch.batchId);
	                                        for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                                            var mutation = _b[_a];
	                                            changedKeys = changedKeys.add(mutation.key);
	                                        }
	                                    }
	                                    for (var _c = 0, newBatches_1 = newBatches; _c < newBatches_1.length; _c++) {
	                                        var batch = newBatches_1[_c];
	                                        addedBatchIds.push(batch.batchId);
	                                        for (var _d = 0, _e = batch.mutations; _d < _e.length; _d++) {
	                                            var mutation = _e[_d];
	                                            changedKeys = changedKeys.add(mutation.key);
	                                        }
	                                    }
	                                    // Return the set of all (potentially) changed documents and the list
	                                    // of mutation batch IDs that were affected by change.
	                                    return newLocalDocuments
	                                        .getDocuments(txn, changedKeys)
	                                        .next(function (affectedDocuments) {
	                                        return {
	                                            affectedDocuments: affectedDocuments,
	                                            removedBatchIds: removedBatchIds,
	                                            addedBatchIds: addedBatchIds
	                                        };
	                                    });
	                                });
	                            })];
	                    case 1:
	                        result = _a.sent();
	                        this.mutationQueue = newMutationQueue;
	                        this.localDocuments = newLocalDocuments;
	                        this.queryEngine.setLocalDocumentsView(this.localDocuments);
	                        return [2 /*return*/, result];
	                }
	            });
	        });
	    };
	    /* Accept locally generated Mutations and commit them to storage. */
	    LocalStore.prototype.localWrite = function (mutations) {
	        var _this = this;
	        var localWriteTime = Timestamp.now();
	        var keys = mutations.reduce(function (keys, m) { return keys.add(m.key); }, documentKeySet());
	        var existingDocs;
	        return this.persistence
	            .runTransaction('Locally write mutations', 'readwrite-idempotent', function (txn) {
	            // Load and apply all existing mutations. This lets us compute the
	            // current base state for all non-idempotent transforms before applying
	            // any additional user-provided writes.
	            return _this.localDocuments.getDocuments(txn, keys).next(function (docs) {
	                existingDocs = docs;
	                // For non-idempotent mutations (such as `FieldValue.increment()`),
	                // we record the base state in a separate patch mutation. This is
	                // later used to guarantee consistent values and prevents flicker
	                // even if the backend sends us an update that already includes our
	                // transform.
	                var baseMutations = [];
	                for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
	                    var mutation = mutations_1[_i];
	                    var baseValue = mutation.extractBaseValue(existingDocs.get(mutation.key));
	                    if (baseValue != null) {
	                        // NOTE: The base state should only be applied if there's some
	                        // existing document to override, so use a Precondition of
	                        // exists=true
	                        baseMutations.push(new PatchMutation(mutation.key, baseValue, baseValue.fieldMask(), Precondition.exists(true)));
	                    }
	                }
	                return _this.mutationQueue.addMutationBatch(txn, localWriteTime, baseMutations, mutations);
	            });
	        })
	            .then(function (batch) {
	            var changes = batch.applyToLocalDocumentSet(existingDocs);
	            return { batchId: batch.batchId, changes: changes };
	        });
	    };
	    /** Returns the local view of the documents affected by a mutation batch. */
	    // PORTING NOTE: Multi-tab only.
	    LocalStore.prototype.lookupMutationDocuments = function (batchId) {
	        var _this = this;
	        return this.persistence.runTransaction('Lookup mutation documents', 'readonly-idempotent', function (txn) {
	            return _this.mutationQueue
	                .lookupMutationKeys(txn, batchId)
	                .next(function (keys) {
	                if (keys) {
	                    return _this.localDocuments.getDocuments(txn, keys);
	                }
	                else {
	                    return PersistencePromise.resolve(null);
	                }
	            });
	        });
	    };
	    /**
	     * Acknowledge the given batch.
	     *
	     * On the happy path when a batch is acknowledged, the local store will
	     *
	     *  + remove the batch from the mutation queue;
	     *  + apply the changes to the remote document cache;
	     *  + recalculate the latency compensated view implied by those changes (there
	     *    may be mutations in the queue that affect the documents but haven't been
	     *    acknowledged yet); and
	     *  + give the changed documents back the sync engine
	     *
	     * @returns The resulting (modified) documents.
	     */
	    LocalStore.prototype.acknowledgeBatch = function (batchResult) {
	        var _this = this;
	        return this.persistence.runTransaction('Acknowledge batch', 'readwrite-primary-idempotent', function (txn) {
	            var affected = batchResult.batch.keys();
	            var documentBuffer = _this.remoteDocuments.newChangeBuffer({
	                trackRemovals: true // Make sure document removals show up in `getNewDocumentChanges()`
	            });
	            return _this.mutationQueue
	                .acknowledgeBatch(txn, batchResult.batch, batchResult.streamToken)
	                .next(function () {
	                return _this.applyWriteToRemoteDocuments(txn, batchResult, documentBuffer);
	            })
	                .next(function () { return documentBuffer.apply(txn); })
	                .next(function () { return _this.mutationQueue.performConsistencyCheck(txn); })
	                .next(function () { return _this.localDocuments.getDocuments(txn, affected); });
	        });
	    };
	    /**
	     * Remove mutations from the MutationQueue for the specified batch;
	     * LocalDocuments will be recalculated.
	     *
	     * @returns The resulting modified documents.
	     */
	    LocalStore.prototype.rejectBatch = function (batchId) {
	        var _this = this;
	        return this.persistence.runTransaction('Reject batch', 'readwrite-primary-idempotent', function (txn) {
	            var affectedKeys;
	            return _this.mutationQueue
	                .lookupMutationBatch(txn, batchId)
	                .next(function (batch) {
	                assert(batch !== null, 'Attempt to reject nonexistent batch!');
	                affectedKeys = batch.keys();
	                return _this.mutationQueue.removeMutationBatch(txn, batch);
	            })
	                .next(function () {
	                return _this.mutationQueue.performConsistencyCheck(txn);
	            })
	                .next(function () {
	                return _this.localDocuments.getDocuments(txn, affectedKeys);
	            });
	        });
	    };
	    /**
	     * Returns the largest (latest) batch id in mutation queue that is pending server response.
	     * Returns `BATCHID_UNKNOWN` if the queue is empty.
	     */
	    LocalStore.prototype.getHighestUnacknowledgedBatchId = function () {
	        var _this = this;
	        return this.persistence.runTransaction('Get highest unacknowledged batch id', 'readonly-idempotent', function (txn) {
	            return _this.mutationQueue.getHighestUnacknowledgedBatchId(txn);
	        });
	    };
	    /** Returns the last recorded stream token for the current user. */
	    LocalStore.prototype.getLastStreamToken = function () {
	        var _this = this;
	        return this.persistence.runTransaction('Get last stream token', 'readonly-idempotent', function (txn) {
	            return _this.mutationQueue.getLastStreamToken(txn);
	        });
	    };
	    /**
	     * Sets the stream token for the current user without acknowledging any
	     * mutation batch. This is usually only useful after a stream handshake or in
	     * response to an error that requires clearing the stream token.
	     */
	    LocalStore.prototype.setLastStreamToken = function (streamToken) {
	        var _this = this;
	        return this.persistence.runTransaction('Set last stream token', 'readwrite-primary-idempotent', function (txn) {
	            return _this.mutationQueue.setLastStreamToken(txn, streamToken);
	        });
	    };
	    /**
	     * Returns the last consistent snapshot processed (used by the RemoteStore to
	     * determine whether to buffer incoming snapshots from the backend).
	     */
	    LocalStore.prototype.getLastRemoteSnapshotVersion = function () {
	        var _this = this;
	        return this.persistence.runTransaction('Get last remote snapshot version', 'readonly-idempotent', function (txn) { return _this.targetCache.getLastRemoteSnapshotVersion(txn); });
	    };
	    /**
	     * Update the "ground-state" (remote) documents. We assume that the remote
	     * event reflects any write batches that have been acknowledged or rejected
	     * (i.e. we do not re-apply local mutations to updates from this event).
	     *
	     * LocalDocuments are re-calculated if there are remaining mutations in the
	     * queue.
	     */
	    LocalStore.prototype.applyRemoteEvent = function (remoteEvent) {
	        var _this = this;
	        var remoteVersion = remoteEvent.snapshotVersion;
	        var newTargetDataByTargetMap = this.targetDataByTarget;
	        return this.persistence
	            .runTransaction('Apply remote event', 'readwrite-primary-idempotent', function (txn) {
	            var documentBuffer = _this.remoteDocuments.newChangeBuffer({
	                trackRemovals: true // Make sure document removals show up in `getNewDocumentChanges()`
	            });
	            // Reset newTargetDataByTargetMap in case this transaction gets re-run.
	            newTargetDataByTargetMap = _this.targetDataByTarget;
	            var promises = [];
	            forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
	                var oldTargetData = newTargetDataByTargetMap.get(targetId);
	                if (!oldTargetData) {
	                    return;
	                }
	                // Only update the remote keys if the target is still active. This
	                // ensures that we can persist the updated target data along with
	                // the updated assignment.
	                promises.push(_this.targetCache
	                    .removeMatchingKeys(txn, change.removedDocuments, targetId)
	                    .next(function () {
	                    return _this.targetCache.addMatchingKeys(txn, change.addedDocuments, targetId);
	                }));
	                var resumeToken = change.resumeToken;
	                // Update the resume token if the change includes one.
	                if (resumeToken.length > 0) {
	                    var newTargetData = oldTargetData
	                        .withResumeToken(resumeToken, remoteVersion)
	                        .withSequenceNumber(txn.currentSequenceNumber);
	                    newTargetDataByTargetMap = newTargetDataByTargetMap.insert(targetId, newTargetData);
	                    // Update the target data if there are target changes (or if
	                    // sufficient time has passed since the last update).
	                    if (LocalStore.shouldPersistTargetData(oldTargetData, newTargetData, change)) {
	                        promises.push(_this.targetCache.updateTargetData(txn, newTargetData));
	                    }
	                }
	            });
	            var changedDocs = maybeDocumentMap();
	            var updatedKeys = documentKeySet();
	            remoteEvent.documentUpdates.forEach(function (key, doc) {
	                updatedKeys = updatedKeys.add(key);
	            });
	            // Each loop iteration only affects its "own" doc, so it's safe to get all the remote
	            // documents in advance in a single call.
	            promises.push(documentBuffer.getEntries(txn, updatedKeys).next(function (existingDocs) {
	                remoteEvent.documentUpdates.forEach(function (key, doc) {
	                    var existingDoc = existingDocs.get(key);
	                    // Note: The order of the steps below is important, since we want
	                    // to ensure that rejected limbo resolutions (which fabricate
	                    // NoDocuments with SnapshotVersion.MIN) never add documents to
	                    // cache.
	                    if (doc instanceof NoDocument &&
	                        doc.version.isEqual(SnapshotVersion.MIN)) {
	                        // NoDocuments with SnapshotVersion.MIN are used in manufactured
	                        // events. We remove these documents from cache since we lost
	                        // access.
	                        documentBuffer.removeEntry(key, remoteVersion);
	                        changedDocs = changedDocs.insert(key, doc);
	                    }
	                    else if (existingDoc == null ||
	                        doc.version.compareTo(existingDoc.version) > 0 ||
	                        (doc.version.compareTo(existingDoc.version) === 0 &&
	                            existingDoc.hasPendingWrites)) {
	                        assert(!SnapshotVersion.MIN.isEqual(remoteVersion), 'Cannot add a document when the remote version is zero');
	                        documentBuffer.addEntry(doc, remoteVersion);
	                        changedDocs = changedDocs.insert(key, doc);
	                    }
	                    else {
	                        debug(LOG_TAG$1, 'Ignoring outdated watch update for ', key, '. Current version:', existingDoc.version, ' Watch version:', doc.version);
	                    }
	                    if (remoteEvent.resolvedLimboDocuments.has(key)) {
	                        promises.push(_this.persistence.referenceDelegate.updateLimboDocument(txn, key));
	                    }
	                });
	            }));
	            // HACK: The only reason we allow a null snapshot version is so that we
	            // can synthesize remote events when we get permission denied errors while
	            // trying to resolve the state of a locally cached document that is in
	            // limbo.
	            if (!remoteVersion.isEqual(SnapshotVersion.MIN)) {
	                var updateRemoteVersion = _this.targetCache
	                    .getLastRemoteSnapshotVersion(txn)
	                    .next(function (lastRemoteSnapshotVersion) {
	                    assert(remoteVersion.compareTo(lastRemoteSnapshotVersion) >= 0, 'Watch stream reverted to previous snapshot?? ' +
	                        remoteVersion +
	                        ' < ' +
	                        lastRemoteSnapshotVersion);
	                    return _this.targetCache.setTargetsMetadata(txn, txn.currentSequenceNumber, remoteVersion);
	                });
	                promises.push(updateRemoteVersion);
	            }
	            return PersistencePromise.waitFor(promises)
	                .next(function () { return documentBuffer.apply(txn); })
	                .next(function () {
	                return _this.localDocuments.getLocalViewOfDocuments(txn, changedDocs);
	            });
	        })
	            .then(function (changedDocs) {
	            _this.targetDataByTarget = newTargetDataByTargetMap;
	            return changedDocs;
	        });
	    };
	    /**
	     * Returns true if the newTargetData should be persisted during an update of
	     * an active target. TargetData should always be persisted when a target is
	     * being released and should not call this function.
	     *
	     * While the target is active, TargetData updates can be omitted when nothing
	     * about the target has changed except metadata like the resume token or
	     * snapshot version. Occasionally it's worth the extra write to prevent these
	     * values from getting too stale after a crash, but this doesn't have to be
	     * too frequent.
	     */
	    LocalStore.shouldPersistTargetData = function (oldTargetData, newTargetData, change) {
	        assert(newTargetData.resumeToken.length > 0, 'Attempted to persist target data with no resume token');
	        // Always persist target data if we don't already have a resume token.
	        if (oldTargetData.resumeToken.length === 0) {
	            return true;
	        }
	        // Don't allow resume token changes to be buffered indefinitely. This
	        // allows us to be reasonably up-to-date after a crash and avoids needing
	        // to loop over all active queries on shutdown. Especially in the browser
	        // we may not get time to do anything interesting while the current tab is
	        // closing.
	        var timeDelta = newTargetData.snapshotVersion.toMicroseconds() -
	            oldTargetData.snapshotVersion.toMicroseconds();
	        if (timeDelta >= this.RESUME_TOKEN_MAX_AGE_MICROS) {
	            return true;
	        }
	        // Otherwise if the only thing that has changed about a target is its resume
	        // token it's not worth persisting. Note that the RemoteStore keeps an
	        // in-memory view of the currently active targets which includes the current
	        // resume token, so stream failure or user changes will still use an
	        // up-to-date resume token regardless of what we do here.
	        var changes = change.addedDocuments.size +
	            change.modifiedDocuments.size +
	            change.removedDocuments.size;
	        return changes > 0;
	    };
	    /**
	     * Notify local store of the changed views to locally pin documents.
	     */
	    LocalStore.prototype.notifyLocalViewChanges = function (viewChanges) {
	        var _this = this;
	        for (var _i = 0, viewChanges_1 = viewChanges; _i < viewChanges_1.length; _i++) {
	            var viewChange = viewChanges_1[_i];
	            var targetId = viewChange.targetId;
	            this.localViewReferences.addReferences(viewChange.addedKeys, targetId);
	            this.localViewReferences.removeReferences(viewChange.removedKeys, targetId);
	            if (!viewChange.fromCache) {
	                var targetData = this.targetDataByTarget.get(targetId);
	                assert(targetData !== null, "Can't set limbo-free snapshot version for unknown target: " + targetId);
	                // Advance the last limbo free snapshot version
	                var lastLimboFreeSnapshotVersion = targetData.snapshotVersion;
	                var updatedTargetData = targetData.withLastLimboFreeSnapshotVersion(lastLimboFreeSnapshotVersion);
	                this.targetDataByTarget = this.targetDataByTarget.insert(targetId, updatedTargetData);
	            }
	        }
	        return this.persistence.runTransaction('notifyLocalViewChanges', 'readwrite-idempotent', function (txn) {
	            return PersistencePromise.forEach(viewChanges, function (viewChange) {
	                return PersistencePromise.forEach(viewChange.removedKeys, function (key) {
	                    return _this.persistence.referenceDelegate.removeReference(txn, key);
	                });
	            });
	        });
	    };
	    /**
	     * Gets the mutation batch after the passed in batchId in the mutation queue
	     * or null if empty.
	     * @param afterBatchId If provided, the batch to search after.
	     * @returns The next mutation or null if there wasn't one.
	     */
	    LocalStore.prototype.nextMutationBatch = function (afterBatchId) {
	        var _this = this;
	        return this.persistence.runTransaction('Get next mutation batch', 'readonly-idempotent', function (txn) {
	            if (afterBatchId === undefined) {
	                afterBatchId = BATCHID_UNKNOWN;
	            }
	            return _this.mutationQueue.getNextMutationBatchAfterBatchId(txn, afterBatchId);
	        });
	    };
	    /**
	     * Read the current value of a Document with a given key or null if not
	     * found - used for testing.
	     */
	    LocalStore.prototype.readDocument = function (key) {
	        var _this = this;
	        return this.persistence.runTransaction('read document', 'readonly-idempotent', function (txn) {
	            return _this.localDocuments.getDocument(txn, key);
	        });
	    };
	    /**
	     * Assigns the given target an internal ID so that its results can be pinned so
	     * they don't get GC'd. A target must be allocated in the local store before
	     * the store can be used to manage its view.
	     *
	     * Allocating an already allocated `Target` will return the existing `TargetData`
	     * for that `Target`.
	     */
	    LocalStore.prototype.allocateTarget = function (target) {
	        var _this = this;
	        return this.persistence
	            .runTransaction('Allocate target', 'readwrite-idempotent', function (txn) {
	            var targetData;
	            return _this.targetCache
	                .getTargetData(txn, target)
	                .next(function (cached) {
	                if (cached) {
	                    // This target has been listened to previously, so reuse the
	                    // previous targetID.
	                    // TODO(mcg): freshen last accessed date?
	                    targetData = cached;
	                    return PersistencePromise.resolve(targetData);
	                }
	                else {
	                    return _this.targetCache.allocateTargetId(txn).next(function (targetId) {
	                        targetData = new TargetData(target, targetId, TargetPurpose.Listen, txn.currentSequenceNumber);
	                        return _this.targetCache
	                            .addTargetData(txn, targetData)
	                            .next(function () { return targetData; });
	                    });
	                }
	            });
	        })
	            .then(function (targetData) {
	            if (_this.targetDataByTarget.get(targetData.targetId) === null) {
	                _this.targetDataByTarget = _this.targetDataByTarget.insert(targetData.targetId, targetData);
	                _this.targetIdByTarget.set(target, targetData.targetId);
	            }
	            return targetData;
	        });
	    };
	    /**
	     * Returns the TargetData as seen by the LocalStore, including updates that may
	     * have not yet been persisted to the TargetCache.
	     */
	    // Visible for testing.
	    LocalStore.prototype.getTargetData = function (transaction, target) {
	        var targetId = this.targetIdByTarget.get(target);
	        if (targetId !== undefined) {
	            return PersistencePromise.resolve(this.targetDataByTarget.get(targetId));
	        }
	        else {
	            return this.targetCache.getTargetData(transaction, target);
	        }
	    };
	    /**
	     * Unpin all the documents associated with the given target. If
	     * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
	     * directly removes the associated target data from the target cache.
	     *
	     * Releasing a non-existing `Target` is a no-op.
	     */
	    // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
	    LocalStore.prototype.releaseTarget = function (targetId, keepPersistedTargetData) {
	        var _this = this;
	        var targetData = this.targetDataByTarget.get(targetId);
	        assert(targetData !== null, "Tried to release nonexistent target: " + targetId);
	        var mode = keepPersistedTargetData
	            ? 'readwrite-idempotent'
	            : 'readwrite-primary-idempotent';
	        return this.persistence
	            .runTransaction('Release target', mode, function (txn) {
	            // References for documents sent via Watch are automatically removed
	            // when we delete a target's data from the reference delegate.
	            // Since this does not remove references for locally mutated documents,
	            // we have to remove the target associations for these documents
	            // manually.
	            // This operation needs to be run inside the transaction since EagerGC
	            // uses the local view references during the transaction's commit.
	            // Fortunately, the operation is safe to be re-run in case the
	            // transaction fails since there are no side effects if the target has
	            // already been removed.
	            var removed = _this.localViewReferences.removeReferencesForId(targetId);
	            if (!keepPersistedTargetData) {
	                return PersistencePromise.forEach(removed, function (key) {
	                    return _this.persistence.referenceDelegate.removeReference(txn, key);
	                }).next(function () {
	                    _this.persistence.referenceDelegate.removeTarget(txn, targetData);
	                });
	            }
	            else {
	                return PersistencePromise.resolve();
	            }
	        })
	            .then(function () {
	            _this.targetDataByTarget = _this.targetDataByTarget.remove(targetId);
	            _this.targetIdByTarget.delete(targetData.target);
	        });
	    };
	    /**
	     * Runs the specified query against the local store and returns the results,
	     * potentially taking advantage of query data from previous executions (such
	     * as the set of remote keys).
	     *
	     * @param usePreviousResults Whether results from previous executions can
	     * be used to optimize this query execution.
	     */
	    LocalStore.prototype.executeQuery = function (query, usePreviousResults) {
	        var _this = this;
	        var lastLimboFreeSnapshotVersion = SnapshotVersion.MIN;
	        var remoteKeys = documentKeySet();
	        return this.persistence.runTransaction('Execute query', 'readonly-idempotent', function (txn) {
	            return _this.getTargetData(txn, query.toTarget())
	                .next(function (targetData) {
	                if (targetData) {
	                    lastLimboFreeSnapshotVersion =
	                        targetData.lastLimboFreeSnapshotVersion;
	                    return _this.targetCache
	                        .getMatchingKeysForTargetId(txn, targetData.targetId)
	                        .next(function (result) {
	                        remoteKeys = result;
	                    });
	                }
	            })
	                .next(function () {
	                return _this.queryEngine.getDocumentsMatchingQuery(txn, query, usePreviousResults
	                    ? lastLimboFreeSnapshotVersion
	                    : SnapshotVersion.MIN, usePreviousResults ? remoteKeys : documentKeySet());
	            })
	                .next(function (documents) {
	                return { documents: documents, remoteKeys: remoteKeys };
	            });
	        });
	    };
	    /**
	     * Returns the keys of the documents that are associated with the given
	     * target id in the remote table.
	     */
	    LocalStore.prototype.remoteDocumentKeys = function (targetId) {
	        var _this = this;
	        return this.persistence.runTransaction('Remote document keys', 'readonly-idempotent', function (txn) {
	            return _this.targetCache.getMatchingKeysForTargetId(txn, targetId);
	        });
	    };
	    // PORTING NOTE: Multi-tab only.
	    LocalStore.prototype.getActiveClients = function () {
	        return this.persistence.getActiveClients();
	    };
	    // PORTING NOTE: Multi-tab only.
	    LocalStore.prototype.removeCachedMutationBatchMetadata = function (batchId) {
	        this.mutationQueue.removeCachedMutationKeys(batchId);
	    };
	    // PORTING NOTE: Multi-tab only.
	    LocalStore.prototype.setNetworkEnabled = function (networkEnabled) {
	        this.persistence.setNetworkEnabled(networkEnabled);
	    };
	    LocalStore.prototype.applyWriteToRemoteDocuments = function (txn, batchResult, documentBuffer) {
	        var _this = this;
	        var batch = batchResult.batch;
	        var docKeys = batch.keys();
	        var promiseChain = PersistencePromise.resolve();
	        docKeys.forEach(function (docKey) {
	            promiseChain = promiseChain
	                .next(function () {
	                return documentBuffer.getEntry(txn, docKey);
	            })
	                .next(function (remoteDoc) {
	                var doc = remoteDoc;
	                var ackVersion = batchResult.docVersions.get(docKey);
	                assert(ackVersion !== null, 'ackVersions should contain every doc in the write.');
	                if (!doc || doc.version.compareTo(ackVersion) < 0) {
	                    doc = batch.applyToRemoteDocument(docKey, doc, batchResult);
	                    if (!doc) {
	                        assert(!remoteDoc, 'Mutation batch ' +
	                            batch +
	                            ' applied to document ' +
	                            remoteDoc +
	                            ' resulted in null');
	                    }
	                    else {
	                        // We use the commitVersion as the readTime rather than the
	                        // document's updateTime since the updateTime is not advanced
	                        // for updates that do not modify the underlying document.
	                        documentBuffer.addEntry(doc, batchResult.commitVersion);
	                    }
	                }
	            });
	        });
	        return promiseChain.next(function () {
	            return _this.mutationQueue.removeMutationBatch(txn, batch);
	        });
	    };
	    LocalStore.prototype.collectGarbage = function (garbageCollector) {
	        var _this = this;
	        return this.persistence.runTransaction('Collect garbage', 'readwrite-primary-idempotent', function (txn) { return garbageCollector.collect(txn, _this.targetDataByTarget); });
	    };
	    // PORTING NOTE: Multi-tab only.
	    LocalStore.prototype.getTarget = function (targetId) {
	        var _this = this;
	        var cachedTargetData = this.targetDataByTarget.get(targetId);
	        if (cachedTargetData) {
	            return Promise.resolve(cachedTargetData.target);
	        }
	        else {
	            return this.persistence.runTransaction('Get target data', 'readonly-idempotent', function (txn) {
	                return _this.targetCache
	                    .getTargetDataForTarget(txn, targetId)
	                    .next(function (targetData) { return (targetData ? targetData.target : null); });
	            });
	        }
	    };
	    /**
	     * Returns the set of documents that have been updated since the last call.
	     * If this is the first call, returns the set of changes since client
	     * initialization. Further invocations will return document changes since
	     * the point of rejection.
	     */
	    // PORTING NOTE: Multi-tab only.
	    LocalStore.prototype.getNewDocumentChanges = function () {
	        var _this = this;
	        return this.persistence
	            .runTransaction('Get new document changes', 'readonly-idempotent', function (txn) {
	            return _this.remoteDocuments.getNewDocumentChanges(txn, _this.lastDocumentChangeReadTime);
	        })
	            .then(function (_a) {
	            var changedDocs = _a.changedDocs, readTime = _a.readTime;
	            _this.lastDocumentChangeReadTime = readTime;
	            return changedDocs;
	        });
	    };
	    /**
	     * Reads the newest document change from persistence and forwards the internal
	     * synchronization marker so that calls to `getNewDocumentChanges()`
	     * only return changes that happened after client initialization.
	     */
	    // PORTING NOTE: Multi-tab only.
	    LocalStore.prototype.synchronizeLastDocumentChangeReadTime = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            var _this = this;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _a = this;
	                        return [4 /*yield*/, this.persistence.runTransaction('Synchronize last document change read time', 'readonly-idempotent', function (txn) { return _this.remoteDocuments.getLastReadTime(txn); })];
	                    case 1:
	                        _a.lastDocumentChangeReadTime = _b.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * The maximum time to leave a resume token buffered without writing it out.
	     * This value is arbitrary: it's long enough to avoid several writes
	     * (possibly indefinitely if updates come more frequently than this) but
	     * short enough that restarting after crashing will still have a pretty
	     * recent resume token.
	     */
	    LocalStore.RESUME_TOKEN_MAX_AGE_MICROS = 5 * 60 * 1e6;
	    return LocalStore;
	}());
	/**
	 * Verifies the error thrown by a LocalStore operation. If a LocalStore
	 * operation fails because the primary lease has been taken by another client,
	 * we ignore the error (the persistence layer will immediately call
	 * `applyPrimaryLease` to propagate the primary state change). All other errors
	 * are re-thrown.
	 *
	 * @param err An error returned by a LocalStore operation.
	 * @return A Promise that resolves after we recovered, or the original error.
	 */
	function ignoreIfPrimaryLeaseLoss(err) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        return tslib.__generator(this, function (_a) {
	            if (err.code === Code.FAILED_PRECONDITION &&
	                err.message === PRIMARY_LEASE_LOST_ERROR_MSG) {
	                debug(LOG_TAG$1, 'Unexpectedly lost primary lease');
	            }
	            else {
	                throw err;
	            }
	            return [2 /*return*/];
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function bufferEntryComparator(_a, _b) {
	    var aSequence = _a[0], aIndex = _a[1];
	    var bSequence = _b[0], bIndex = _b[1];
	    var seqCmp = primitiveComparator(aSequence, bSequence);
	    if (seqCmp === 0) {
	        // This order doesn't matter, but we can bias against churn by sorting
	        // entries created earlier as less than newer entries.
	        return primitiveComparator(aIndex, bIndex);
	    }
	    else {
	        return seqCmp;
	    }
	}
	/**
	 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
	 * lowest n values passed to `addElement`, and finally reports the largest of
	 * them in `maxValue`.
	 */
	var RollingSequenceNumberBuffer = /** @class */ (function () {
	    function RollingSequenceNumberBuffer(maxElements) {
	        this.maxElements = maxElements;
	        this.buffer = new SortedSet(bufferEntryComparator);
	        this.previousIndex = 0;
	    }
	    RollingSequenceNumberBuffer.prototype.nextIndex = function () {
	        return ++this.previousIndex;
	    };
	    RollingSequenceNumberBuffer.prototype.addElement = function (sequenceNumber) {
	        var entry = [sequenceNumber, this.nextIndex()];
	        if (this.buffer.size < this.maxElements) {
	            this.buffer = this.buffer.add(entry);
	        }
	        else {
	            var highestValue = this.buffer.last();
	            if (bufferEntryComparator(entry, highestValue) < 0) {
	                this.buffer = this.buffer.delete(highestValue).add(entry);
	            }
	        }
	    };
	    Object.defineProperty(RollingSequenceNumberBuffer.prototype, "maxValue", {
	        get: function () {
	            // Guaranteed to be non-empty. If we decide we are not collecting any
	            // sequence numbers, nthSequenceNumber below short-circuits. If we have
	            // decided that we are collecting n sequence numbers, it's because n is some
	            // percentage of the existing sequence numbers. That means we should never
	            // be in a situation where we are collecting sequence numbers but don't
	            // actually have any.
	            return this.buffer.last()[0];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return RollingSequenceNumberBuffer;
	}());
	var GC_DID_NOT_RUN = {
	    didRun: false,
	    sequenceNumbersCollected: 0,
	    targetsRemoved: 0,
	    documentsRemoved: 0
	};
	var LruParams = /** @class */ (function () {
	    function LruParams(
	    // When we attempt to collect, we will only do so if the cache size is greater than this
	    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
	    cacheSizeCollectionThreshold, 
	    // The percentage of sequence numbers that we will attempt to collect
	    percentileToCollect, 
	    // A cap on the total number of sequence numbers that will be collected. This prevents
	    // us from collecting a huge number of sequence numbers if the cache has grown very large.
	    maximumSequenceNumbersToCollect) {
	        this.cacheSizeCollectionThreshold = cacheSizeCollectionThreshold;
	        this.percentileToCollect = percentileToCollect;
	        this.maximumSequenceNumbersToCollect = maximumSequenceNumbersToCollect;
	    }
	    LruParams.withCacheSize = function (cacheSize) {
	        return new LruParams(cacheSize, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
	    };
	    LruParams.COLLECTION_DISABLED = -1;
	    LruParams.MINIMUM_CACHE_SIZE_BYTES = 1 * 1024 * 1024;
	    LruParams.DEFAULT_CACHE_SIZE_BYTES = 40 * 1024 * 1024;
	    LruParams.DEFAULT_COLLECTION_PERCENTILE = 10;
	    LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1000;
	    LruParams.DEFAULT = new LruParams(LruParams.DEFAULT_CACHE_SIZE_BYTES, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
	    LruParams.DISABLED = new LruParams(LruParams.COLLECTION_DISABLED, 0, 0);
	    return LruParams;
	}());
	/** How long we wait to try running LRU GC after SDK initialization. */
	var INITIAL_GC_DELAY_MS = 1 * 60 * 1000;
	/** Minimum amount of time between GC checks, after the first one. */
	var REGULAR_GC_DELAY_MS = 5 * 60 * 1000;
	/**
	 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
	 * whether or not GC is enabled, as well as which delay to use before the next run.
	 */
	var LruScheduler = /** @class */ (function () {
	    function LruScheduler(garbageCollector, asyncQueue, localStore) {
	        this.garbageCollector = garbageCollector;
	        this.asyncQueue = asyncQueue;
	        this.localStore = localStore;
	        this.hasRun = false;
	        this.gcTask = null;
	    }
	    LruScheduler.prototype.start = function () {
	        assert(this.gcTask === null, 'Cannot start an already started LruScheduler');
	        if (this.garbageCollector.params.cacheSizeCollectionThreshold !==
	            LruParams.COLLECTION_DISABLED) {
	            this.scheduleGC();
	        }
	    };
	    LruScheduler.prototype.stop = function () {
	        if (this.gcTask) {
	            this.gcTask.cancel();
	            this.gcTask = null;
	        }
	    };
	    Object.defineProperty(LruScheduler.prototype, "started", {
	        get: function () {
	            return this.gcTask !== null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    LruScheduler.prototype.scheduleGC = function () {
	        var _this = this;
	        assert(this.gcTask === null, 'Cannot schedule GC while a task is pending');
	        var delay = this.hasRun ? REGULAR_GC_DELAY_MS : INITIAL_GC_DELAY_MS;
	        debug('LruGarbageCollector', "Garbage collection scheduled in " + delay + "ms");
	        this.gcTask = this.asyncQueue.enqueueAfterDelay(TimerId.LruGarbageCollection, delay, function () {
	            _this.gcTask = null;
	            _this.hasRun = true;
	            return _this.localStore
	                .collectGarbage(_this.garbageCollector)
	                .then(function () { return _this.scheduleGC(); })
	                .catch(ignoreIfPrimaryLeaseLoss);
	        });
	    };
	    return LruScheduler;
	}());
	/** Implements the steps for LRU garbage collection. */
	var LruGarbageCollector = /** @class */ (function () {
	    function LruGarbageCollector(delegate, params) {
	        this.delegate = delegate;
	        this.params = params;
	    }
	    /** Given a percentile of target to collect, returns the number of targets to collect. */
	    LruGarbageCollector.prototype.calculateTargetCount = function (txn, percentile) {
	        return this.delegate.getSequenceNumberCount(txn).next(function (targetCount) {
	            return Math.floor((percentile / 100.0) * targetCount);
	        });
	    };
	    /** Returns the nth sequence number, counting in order from the smallest. */
	    LruGarbageCollector.prototype.nthSequenceNumber = function (txn, n) {
	        var _this = this;
	        if (n === 0) {
	            return PersistencePromise.resolve(ListenSequence.INVALID);
	        }
	        var buffer = new RollingSequenceNumberBuffer(n);
	        return this.delegate
	            .forEachTarget(txn, function (target) { return buffer.addElement(target.sequenceNumber); })
	            .next(function () {
	            return _this.delegate.forEachOrphanedDocumentSequenceNumber(txn, function (sequenceNumber) { return buffer.addElement(sequenceNumber); });
	        })
	            .next(function () { return buffer.maxValue; });
	    };
	    /**
	     * Removes targets with a sequence number equal to or less than the given upper bound, and removes
	     * document associations with those targets.
	     */
	    LruGarbageCollector.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
	        return this.delegate.removeTargets(txn, upperBound, activeTargetIds);
	    };
	    /**
	     * Removes documents that have a sequence number equal to or less than the upper bound and are not
	     * otherwise pinned.
	     */
	    LruGarbageCollector.prototype.removeOrphanedDocuments = function (txn, upperBound) {
	        return this.delegate.removeOrphanedDocuments(txn, upperBound);
	    };
	    LruGarbageCollector.prototype.collect = function (txn, activeTargetIds) {
	        var _this = this;
	        if (this.params.cacheSizeCollectionThreshold === LruParams.COLLECTION_DISABLED) {
	            debug('LruGarbageCollector', 'Garbage collection skipped; disabled');
	            return PersistencePromise.resolve(GC_DID_NOT_RUN);
	        }
	        return this.getCacheSize(txn).next(function (cacheSize) {
	            if (cacheSize < _this.params.cacheSizeCollectionThreshold) {
	                debug('LruGarbageCollector', "Garbage collection skipped; Cache size " + cacheSize + " " +
	                    ("is lower than threshold " + _this.params.cacheSizeCollectionThreshold));
	                return GC_DID_NOT_RUN;
	            }
	            else {
	                return _this.runGarbageCollection(txn, activeTargetIds);
	            }
	        });
	    };
	    LruGarbageCollector.prototype.getCacheSize = function (txn) {
	        return this.delegate.getCacheSize(txn);
	    };
	    LruGarbageCollector.prototype.runGarbageCollection = function (txn, activeTargetIds) {
	        var _this = this;
	        var upperBoundSequenceNumber;
	        var sequenceNumbersToCollect, targetsRemoved;
	        // Timestamps for various pieces of the process
	        var countedTargetsTs, foundUpperBoundTs, removedTargetsTs, removedDocumentsTs;
	        var startTs = Date.now();
	        return this.calculateTargetCount(txn, this.params.percentileToCollect)
	            .next(function (sequenceNumbers) {
	            // Cap at the configured max
	            if (sequenceNumbers > _this.params.maximumSequenceNumbersToCollect) {
	                debug('LruGarbageCollector', 'Capping sequence numbers to collect down ' +
	                    ("to the maximum of " + _this.params.maximumSequenceNumbersToCollect + " ") +
	                    ("from " + sequenceNumbers));
	                sequenceNumbersToCollect = _this.params
	                    .maximumSequenceNumbersToCollect;
	            }
	            else {
	                sequenceNumbersToCollect = sequenceNumbers;
	            }
	            countedTargetsTs = Date.now();
	            return _this.nthSequenceNumber(txn, sequenceNumbersToCollect);
	        })
	            .next(function (upperBound) {
	            upperBoundSequenceNumber = upperBound;
	            foundUpperBoundTs = Date.now();
	            return _this.removeTargets(txn, upperBoundSequenceNumber, activeTargetIds);
	        })
	            .next(function (numTargetsRemoved) {
	            targetsRemoved = numTargetsRemoved;
	            removedTargetsTs = Date.now();
	            return _this.removeOrphanedDocuments(txn, upperBoundSequenceNumber);
	        })
	            .next(function (documentsRemoved) {
	            removedDocumentsTs = Date.now();
	            if (getLogLevel() <= LogLevel.DEBUG) {
	                var desc = 'LRU Garbage Collection\n' +
	                    ("\tCounted targets in " + (countedTargetsTs - startTs) + "ms\n") +
	                    ("\tDetermined least recently used " + sequenceNumbersToCollect + " in ") +
	                    (foundUpperBoundTs - countedTargetsTs + "ms\n") +
	                    ("\tRemoved " + targetsRemoved + " targets in ") +
	                    (removedTargetsTs - foundUpperBoundTs + "ms\n") +
	                    ("\tRemoved " + documentsRemoved + " documents in ") +
	                    (removedDocumentsTs - removedTargetsTs + "ms\n") +
	                    ("Total Duration: " + (removedDocumentsTs - startTs) + "ms");
	                debug('LruGarbageCollector', desc);
	            }
	            return PersistencePromise.resolve({
	                didRun: true,
	                sequenceNumbersCollected: sequenceNumbersToCollect,
	                targetsRemoved: targetsRemoved,
	                documentsRemoved: documentsRemoved
	            });
	        });
	    };
	    return LruGarbageCollector;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$2 = 'IndexedDbPersistence';
	/**
	 * Oldest acceptable age in milliseconds for client metadata before the client
	 * is considered inactive and its associated data is garbage collected.
	 */
	var MAX_CLIENT_AGE_MS = 30 * 60 * 1000; // 30 minutes
	/**
	 * Oldest acceptable metadata age for clients that may participate in the
	 * primary lease election. Clients that have not updated their client metadata
	 * within 5 seconds are not eligible to receive a primary lease.
	 */
	var MAX_PRIMARY_ELIGIBLE_AGE_MS = 5000;
	/**
	 * The interval at which clients will update their metadata, including
	 * refreshing their primary lease if held or potentially trying to acquire it if
	 * not held.
	 *
	 * Primary clients may opportunistically refresh their metadata earlier
	 * if they're already performing an IndexedDB operation.
	 */
	var CLIENT_METADATA_REFRESH_INTERVAL_MS = 4000;
	/** User-facing error when the primary lease is required but not available. */
	var PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG = 'Another tab has exclusive access to the persistence layer. ' +
	    'To allow shared access, make sure to invoke ' +
	    '`enablePersistence()` with `synchronizeTabs:true` in all tabs.';
	var UNSUPPORTED_PLATFORM_ERROR_MSG = 'This platform is either missing' +
	    ' IndexedDB or is known to have an incomplete implementation. Offline' +
	    ' persistence has been disabled.';
	// The format of the LocalStorage key that stores zombied client is:
	//     firestore_zombie_<persistence_prefix>_<instance_key>
	var ZOMBIED_CLIENTS_KEY_PREFIX = 'firestore_zombie';
	var IndexedDbTransaction = /** @class */ (function (_super) {
	    tslib.__extends(IndexedDbTransaction, _super);
	    function IndexedDbTransaction(simpleDbTransaction, currentSequenceNumber) {
	        var _this = _super.call(this) || this;
	        _this.simpleDbTransaction = simpleDbTransaction;
	        _this.currentSequenceNumber = currentSequenceNumber;
	        return _this;
	    }
	    return IndexedDbTransaction;
	}(PersistenceTransaction));
	/**
	 * An IndexedDB-backed instance of Persistence. Data is stored persistently
	 * across sessions.
	 *
	 * On Web only, the Firestore SDKs support shared access to its persistence
	 * layer. This allows multiple browser tabs to read and write to IndexedDb and
	 * to synchronize state even without network connectivity. Shared access is
	 * currently optional and not enabled unless all clients invoke
	 * `enablePersistence()` with `{synchronizeTabs:true}`.
	 *
	 * In multi-tab mode, if multiple clients are active at the same time, the SDK
	 * will designate one client as the “primary client”. An effort is made to pick
	 * a visible, network-connected and active client, and this client is
	 * responsible for letting other clients know about its presence. The primary
	 * client writes a unique client-generated identifier (the client ID) to
	 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
	 * update this entry, another client can acquire the lease and take over as
	 * primary.
	 *
	 * Some persistence operations in the SDK are designated as primary-client only
	 * operations. This includes the acknowledgment of mutations and all updates of
	 * remote documents. The effects of these operations are written to persistence
	 * and then broadcast to other tabs via LocalStorage (see
	 * `WebStorageSharedClientState`), which then refresh their state from
	 * persistence.
	 *
	 * Similarly, the primary client listens to notifications sent by secondary
	 * clients to discover persistence changes written by secondary clients, such as
	 * the addition of new mutations and query targets.
	 *
	 * If multi-tab is not enabled and another tab already obtained the primary
	 * lease, IndexedDbPersistence enters a failed state and all subsequent
	 * operations will automatically fail.
	 *
	 * Additionally, there is an optimization so that when a tab is closed, the
	 * primary lease is released immediately (this is especially important to make
	 * sure that a refreshed tab is able to immediately re-acquire the primary
	 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
	 * since it is an asynchronous API. So in addition to attempting to give up the
	 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
	 * LocalStorage which acts as an indicator that another tab should go ahead and
	 * take the primary lease immediately regardless of the current lease timestamp.
	 *
	 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
	 * longer optional.
	 */
	var IndexedDbPersistence = /** @class */ (function () {
	    function IndexedDbPersistence(allowTabSynchronization, persistenceKey, clientId, platform, lruParams, queue, serializer, sequenceNumberSyncer) {
	        this.allowTabSynchronization = allowTabSynchronization;
	        this.persistenceKey = persistenceKey;
	        this.clientId = clientId;
	        this.queue = queue;
	        this.sequenceNumberSyncer = sequenceNumberSyncer;
	        this._started = false;
	        this.isPrimary = false;
	        this.networkEnabled = true;
	        /** Our window.unload handler, if registered. */
	        this.windowUnloadHandler = null;
	        this.inForeground = false;
	        /** Our 'visibilitychange' listener if registered. */
	        this.documentVisibilityHandler = null;
	        /** The client metadata refresh task. */
	        this.clientMetadataRefresher = null;
	        /** The last time we garbage collected the client metadata object store. */
	        this.lastGarbageCollectionTime = Number.NEGATIVE_INFINITY;
	        /** A listener to notify on primary state changes. */
	        this.primaryStateListener = function (_) { return Promise.resolve(); };
	        this.referenceDelegate = new IndexedDbLruDelegate(this, lruParams);
	        this.dbName = persistenceKey + IndexedDbPersistence.MAIN_DATABASE;
	        this.serializer = new LocalSerializer(serializer);
	        this.document = platform.document;
	        this.targetCache = new IndexedDbTargetCache(this.referenceDelegate, this.serializer);
	        this.indexManager = new IndexedDbIndexManager();
	        this.remoteDocumentCache = new IndexedDbRemoteDocumentCache(this.serializer, this.indexManager);
	        if (platform.window && platform.window.localStorage) {
	            this.window = platform.window;
	            this.webStorage = this.window.localStorage;
	        }
	        else {
	            throw new FirestoreError(Code.UNIMPLEMENTED, 'IndexedDB persistence is only available on platforms that support LocalStorage.');
	        }
	    }
	    IndexedDbPersistence.getStore = function (txn, store) {
	        if (txn instanceof IndexedDbTransaction) {
	            return SimpleDb.getStore(txn.simpleDbTransaction, store);
	        }
	        else {
	            throw fail('IndexedDbPersistence must use instances of IndexedDbTransaction');
	        }
	    };
	    IndexedDbPersistence.createIndexedDbPersistence = function (options) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var persistence;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!IndexedDbPersistence.isAvailable()) {
	                            throw new FirestoreError(Code.UNIMPLEMENTED, UNSUPPORTED_PLATFORM_ERROR_MSG);
	                        }
	                        persistence = new IndexedDbPersistence(options.allowTabSynchronization, options.persistenceKey, options.clientId, options.platform, options.lruParams, options.queue, options.serializer, options.sequenceNumberSyncer);
	                        return [4 /*yield*/, persistence.start()];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/, persistence];
	                }
	            });
	        });
	    };
	    /**
	     * Attempt to start IndexedDb persistence.
	     *
	     * @return {Promise<void>} Whether persistence was enabled.
	     */
	    IndexedDbPersistence.prototype.start = function () {
	        var _this = this;
	        assert(!this.started, 'IndexedDbPersistence double-started!');
	        assert(this.window !== null, "Expected 'window' to be defined");
	        return SimpleDb.openOrCreate(this.dbName, SCHEMA_VERSION, new SchemaConverter(this.serializer))
	            .then(function (db) {
	            _this.simpleDb = db;
	            // NOTE: This is expected to fail sometimes (in the case of another tab already
	            // having the persistence lock), so it's the first thing we should do.
	            return _this.updateClientMetadataAndTryBecomePrimary();
	        })
	            .then(function () {
	            _this.attachVisibilityHandler();
	            _this.attachWindowUnloadHook();
	            _this.scheduleClientMetadataAndPrimaryLeaseRefreshes();
	            return _this.simpleDb.runTransaction('readonly-idempotent', [DbTargetGlobal.store], function (txn) { return getHighestListenSequenceNumber(txn); });
	        })
	            .then(function (highestListenSequenceNumber) {
	            _this.listenSequence = new ListenSequence(highestListenSequenceNumber, _this.sequenceNumberSyncer);
	        })
	            .then(function () {
	            _this._started = true;
	        })
	            .catch(function (reason) {
	            _this.simpleDb && _this.simpleDb.close();
	            return Promise.reject(reason);
	        });
	    };
	    IndexedDbPersistence.prototype.setPrimaryStateListener = function (primaryStateListener) {
	        var _this = this;
	        this.primaryStateListener = function (primaryState) { return tslib.__awaiter(_this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                if (this.started) {
	                    return [2 /*return*/, primaryStateListener(primaryState)];
	                }
	                return [2 /*return*/];
	            });
	        }); };
	        return primaryStateListener(this.isPrimary);
	    };
	    IndexedDbPersistence.prototype.setDatabaseDeletedListener = function (databaseDeletedListener) {
	        var _this = this;
	        this.simpleDb.setVersionChangeListener(function (event) { return tslib.__awaiter(_this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!(event.newVersion === null)) return [3 /*break*/, 2];
	                        return [4 /*yield*/, databaseDeletedListener()];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        }); });
	    };
	    IndexedDbPersistence.prototype.setNetworkEnabled = function (networkEnabled) {
	        var _this = this;
	        if (this.networkEnabled !== networkEnabled) {
	            this.networkEnabled = networkEnabled;
	            // Schedule a primary lease refresh for immediate execution. The eventual
	            // lease update will be propagated via `primaryStateListener`.
	            this.queue.enqueueAndForget(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	                return tslib.__generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            if (!this.started) return [3 /*break*/, 2];
	                            return [4 /*yield*/, this.updateClientMetadataAndTryBecomePrimary()];
	                        case 1:
	                            _a.sent();
	                            _a.label = 2;
	                        case 2: return [2 /*return*/];
	                    }
	                });
	            }); });
	        }
	    };
	    /**
	     * Updates the client metadata in IndexedDb and attempts to either obtain or
	     * extend the primary lease for the local client. Asynchronously notifies the
	     * primary state listener if the client either newly obtained or released its
	     * primary lease.
	     */
	    IndexedDbPersistence.prototype.updateClientMetadataAndTryBecomePrimary = function () {
	        var _this = this;
	        return this.simpleDb
	            .runTransaction('readwrite-idempotent', ALL_STORES, function (txn) {
	            var metadataStore = clientMetadataStore(txn);
	            return metadataStore
	                .put(new DbClientMetadata(_this.clientId, Date.now(), _this.networkEnabled, _this.inForeground))
	                .next(function () {
	                if (_this.isPrimary) {
	                    return _this.verifyPrimaryLease(txn).next(function (success) {
	                        if (!success) {
	                            _this.isPrimary = false;
	                            _this.queue.enqueueAndForget(function () {
	                                return _this.primaryStateListener(false);
	                            });
	                        }
	                    });
	                }
	            })
	                .next(function () { return _this.canActAsPrimary(txn); })
	                .next(function (canActAsPrimary) {
	                if (_this.isPrimary && !canActAsPrimary) {
	                    return _this.releasePrimaryLeaseIfHeld(txn).next(function () { return false; });
	                }
	                else if (canActAsPrimary) {
	                    return _this.acquireOrExtendPrimaryLease(txn).next(function () { return true; });
	                }
	                else {
	                    return /* canActAsPrimary= */ false;
	                }
	            });
	        })
	            .catch(function (e) {
	            if (!_this.allowTabSynchronization) {
	                throw e;
	            }
	            debug(LOG_TAG$2, 'Releasing owner lease after error during lease refresh', e);
	            return /* isPrimary= */ false;
	        })
	            .then(function (isPrimary) {
	            if (_this.isPrimary !== isPrimary) {
	                _this.queue.enqueueAndForget(function () {
	                    return _this.primaryStateListener(isPrimary);
	                });
	            }
	            _this.isPrimary = isPrimary;
	        });
	    };
	    IndexedDbPersistence.prototype.verifyPrimaryLease = function (txn) {
	        var _this = this;
	        var store = primaryClientStore(txn);
	        return store.get(DbPrimaryClient.key).next(function (primaryClient) {
	            return PersistencePromise.resolve(_this.isLocalClient(primaryClient));
	        });
	    };
	    IndexedDbPersistence.prototype.removeClientMetadata = function (txn) {
	        var metadataStore = clientMetadataStore(txn);
	        return metadataStore.delete(this.clientId);
	    };
	    /**
	     * If the garbage collection threshold has passed, prunes the
	     * RemoteDocumentChanges and the ClientMetadata store based on the last update
	     * time of all clients.
	     */
	    IndexedDbPersistence.prototype.maybeGarbageCollectMultiClientState = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var inactiveClients;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!(this.isPrimary &&
	                            !this.isWithinAge(this.lastGarbageCollectionTime, MAX_CLIENT_AGE_MS))) return [3 /*break*/, 2];
	                        this.lastGarbageCollectionTime = Date.now();
	                        return [4 /*yield*/, this.runTransaction('maybeGarbageCollectMultiClientState', 'readwrite-primary-idempotent', function (txn) {
	                                var metadataStore = IndexedDbPersistence.getStore(txn, DbClientMetadata.store);
	                                return metadataStore.loadAll().next(function (existingClients) {
	                                    var active = _this.filterActiveClients(existingClients, MAX_CLIENT_AGE_MS);
	                                    var inactive = existingClients.filter(function (client) { return active.indexOf(client) === -1; });
	                                    // Delete metadata for clients that are no longer considered active.
	                                    return PersistencePromise.forEach(inactive, function (inactiveClient) {
	                                        return metadataStore.delete(inactiveClient.clientId);
	                                    }).next(function () { return inactive; });
	                                });
	                            }).catch(function () {
	                                // Ignore primary lease violations or any other type of error. The next
	                                // primary will run `maybeGarbageCollectMultiClientState()` again.
	                                // We don't use `ignoreIfPrimaryLeaseLoss()` since we don't want to depend
	                                // on LocalStore.
	                                return [];
	                            })];
	                    case 1:
	                        inactiveClients = _a.sent();
	                        // Delete potential leftover entries that may continue to mark the
	                        // inactive clients as zombied in LocalStorage.
	                        // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
	                        // the client atomically, but we can't. So we opt to delete the IndexedDb
	                        // entries first to avoid potentially reviving a zombied client.
	                        inactiveClients.forEach(function (inactiveClient) {
	                            _this.window.localStorage.removeItem(_this.zombiedClientLocalStorageKey(inactiveClient.clientId));
	                        });
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Schedules a recurring timer to update the client metadata and to either
	     * extend or acquire the primary lease if the client is eligible.
	     */
	    IndexedDbPersistence.prototype.scheduleClientMetadataAndPrimaryLeaseRefreshes = function () {
	        var _this = this;
	        this.clientMetadataRefresher = this.queue.enqueueAfterDelay(TimerId.ClientMetadataRefresh, CLIENT_METADATA_REFRESH_INTERVAL_MS, function () {
	            return _this.updateClientMetadataAndTryBecomePrimary()
	                .then(function () { return _this.maybeGarbageCollectMultiClientState(); })
	                .then(function () { return _this.scheduleClientMetadataAndPrimaryLeaseRefreshes(); });
	        });
	    };
	    /** Checks whether `client` is the local client. */
	    IndexedDbPersistence.prototype.isLocalClient = function (client) {
	        return client ? client.ownerId === this.clientId : false;
	    };
	    /**
	     * Evaluate the state of all active clients and determine whether the local
	     * client is or can act as the holder of the primary lease. Returns whether
	     * the client is eligible for the lease, but does not actually acquire it.
	     * May return 'false' even if there is no active leaseholder and another
	     * (foreground) client should become leaseholder instead.
	     */
	    IndexedDbPersistence.prototype.canActAsPrimary = function (txn) {
	        var _this = this;
	        var store = primaryClientStore(txn);
	        return store
	            .get(DbPrimaryClient.key)
	            .next(function (currentPrimary) {
	            var currentLeaseIsValid = currentPrimary !== null &&
	                _this.isWithinAge(currentPrimary.leaseTimestampMs, MAX_PRIMARY_ELIGIBLE_AGE_MS) &&
	                !_this.isClientZombied(currentPrimary.ownerId);
	            // A client is eligible for the primary lease if:
	            // - its network is enabled and the client's tab is in the foreground.
	            // - its network is enabled and no other client's tab is in the
	            //   foreground.
	            // - every clients network is disabled and the client's tab is in the
	            //   foreground.
	            // - every clients network is disabled and no other client's tab is in
	            //   the foreground.
	            if (currentLeaseIsValid) {
	                if (_this.isLocalClient(currentPrimary) && _this.networkEnabled) {
	                    return true;
	                }
	                if (!_this.isLocalClient(currentPrimary)) {
	                    if (!currentPrimary.allowTabSynchronization) {
	                        // Fail the `canActAsPrimary` check if the current leaseholder has
	                        // not opted into multi-tab synchronization. If this happens at
	                        // client startup, we reject the Promise returned by
	                        // `enablePersistence()` and the user can continue to use Firestore
	                        // with in-memory persistence.
	                        // If this fails during a lease refresh, we will instead block the
	                        // AsyncQueue from executing further operations. Note that this is
	                        // acceptable since mixing & matching different `synchronizeTabs`
	                        // settings is not supported.
	                        //
	                        // TODO(b/114226234): Remove this check when `synchronizeTabs` can
	                        // no longer be turned off.
	                        throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);
	                    }
	                    return false;
	                }
	            }
	            if (_this.networkEnabled && _this.inForeground) {
	                return true;
	            }
	            return clientMetadataStore(txn)
	                .loadAll()
	                .next(function (existingClients) {
	                // Process all existing clients and determine whether at least one of
	                // them is better suited to obtain the primary lease.
	                var preferredCandidate = _this.filterActiveClients(existingClients, MAX_PRIMARY_ELIGIBLE_AGE_MS).find(function (otherClient) {
	                    if (_this.clientId !== otherClient.clientId) {
	                        var otherClientHasBetterNetworkState = !_this.networkEnabled && otherClient.networkEnabled;
	                        var otherClientHasBetterVisibility = !_this.inForeground && otherClient.inForeground;
	                        var otherClientHasSameNetworkState = _this.networkEnabled === otherClient.networkEnabled;
	                        if (otherClientHasBetterNetworkState ||
	                            (otherClientHasBetterVisibility &&
	                                otherClientHasSameNetworkState)) {
	                            return true;
	                        }
	                    }
	                    return false;
	                });
	                return preferredCandidate === undefined;
	            });
	        })
	            .next(function (canActAsPrimary) {
	            if (_this.isPrimary !== canActAsPrimary) {
	                debug(LOG_TAG$2, "Client " + (canActAsPrimary ? 'is' : 'is not') + " eligible for a primary lease.");
	            }
	            return canActAsPrimary;
	        });
	    };
	    IndexedDbPersistence.prototype.shutdown = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        // The shutdown() operations are idempotent and can be called even when
	                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
	                        this._started = false;
	                        this.markClientZombied();
	                        if (this.clientMetadataRefresher) {
	                            this.clientMetadataRefresher.cancel();
	                            this.clientMetadataRefresher = null;
	                        }
	                        this.detachVisibilityHandler();
	                        this.detachWindowUnloadHook();
	                        return [4 /*yield*/, this.simpleDb.runTransaction('readwrite-idempotent', [DbPrimaryClient.store, DbClientMetadata.store], function (txn) {
	                                return _this.releasePrimaryLeaseIfHeld(txn).next(function () {
	                                    return _this.removeClientMetadata(txn);
	                                });
	                            })];
	                    case 1:
	                        _a.sent();
	                        this.simpleDb.close();
	                        // Remove the entry marking the client as zombied from LocalStorage since
	                        // we successfully deleted its metadata from IndexedDb.
	                        this.removeClientZombiedEntry();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Returns clients that are not zombied and have an updateTime within the
	     * provided threshold.
	     */
	    IndexedDbPersistence.prototype.filterActiveClients = function (clients, activityThresholdMs) {
	        var _this = this;
	        return clients.filter(function (client) {
	            return _this.isWithinAge(client.updateTimeMs, activityThresholdMs) &&
	                !_this.isClientZombied(client.clientId);
	        });
	    };
	    IndexedDbPersistence.prototype.getActiveClients = function () {
	        var _this = this;
	        return this.simpleDb.runTransaction('readonly-idempotent', [DbClientMetadata.store], function (txn) {
	            return clientMetadataStore(txn)
	                .loadAll()
	                .next(function (clients) {
	                return _this.filterActiveClients(clients, MAX_CLIENT_AGE_MS).map(function (clientMetadata) { return clientMetadata.clientId; });
	            });
	        });
	    };
	    IndexedDbPersistence.clearPersistence = function (persistenceKey) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var dbName;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!IndexedDbPersistence.isAvailable()) {
	                            return [2 /*return*/, Promise.resolve()];
	                        }
	                        dbName = persistenceKey + IndexedDbPersistence.MAIN_DATABASE;
	                        return [4 /*yield*/, SimpleDb.delete(dbName)];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    Object.defineProperty(IndexedDbPersistence.prototype, "started", {
	        get: function () {
	            return this._started;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    IndexedDbPersistence.prototype.getMutationQueue = function (user) {
	        assert(this.started, 'Cannot initialize MutationQueue before persistence is started.');
	        return IndexedDbMutationQueue.forUser(user, this.serializer, this.indexManager, this.referenceDelegate);
	    };
	    IndexedDbPersistence.prototype.getTargetCache = function () {
	        assert(this.started, 'Cannot initialize TargetCache before persistence is started.');
	        return this.targetCache;
	    };
	    IndexedDbPersistence.prototype.getRemoteDocumentCache = function () {
	        assert(this.started, 'Cannot initialize RemoteDocumentCache before persistence is started.');
	        return this.remoteDocumentCache;
	    };
	    IndexedDbPersistence.prototype.getIndexManager = function () {
	        assert(this.started, 'Cannot initialize IndexManager before persistence is started.');
	        return this.indexManager;
	    };
	    IndexedDbPersistence.prototype.runTransaction = function (action, mode, transactionOperation) {
	        var _this = this;
	        debug(LOG_TAG$2, 'Starting transaction:', action);
	        // TODO(schmidt-sebastian): Simplify once all transactions are idempotent.
	        var idempotent = mode.endsWith('idempotent');
	        var readonly = mode.startsWith('readonly');
	        var simpleDbMode = readonly
	            ? idempotent
	                ? 'readonly-idempotent'
	                : 'readonly'
	            : idempotent
	                ? 'readwrite-idempotent'
	                : 'readwrite';
	        var persistenceTransaction;
	        // Do all transactions as readwrite against all object stores, since we
	        // are the only reader/writer.
	        return this.simpleDb
	            .runTransaction(simpleDbMode, ALL_STORES, function (simpleDbTxn) {
	            persistenceTransaction = new IndexedDbTransaction(simpleDbTxn, _this.listenSequence.next());
	            if (mode === 'readwrite-primary' ||
	                mode === 'readwrite-primary-idempotent') {
	                // While we merely verify that we have (or can acquire) the lease
	                // immediately, we wait to extend the primary lease until after
	                // executing transactionOperation(). This ensures that even if the
	                // transactionOperation takes a long time, we'll use a recent
	                // leaseTimestampMs in the extended (or newly acquired) lease.
	                return _this.verifyPrimaryLease(simpleDbTxn)
	                    .next(function (holdsPrimaryLease) {
	                    if (holdsPrimaryLease) {
	                        return /* holdsPrimaryLease= */ true;
	                    }
	                    return _this.canActAsPrimary(simpleDbTxn);
	                })
	                    .next(function (holdsPrimaryLease) {
	                    if (!holdsPrimaryLease) {
	                        error("Failed to obtain primary lease for action '" + action + "'.");
	                        _this.isPrimary = false;
	                        _this.queue.enqueueAndForget(function () {
	                            return _this.primaryStateListener(false);
	                        });
	                        throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_LOST_ERROR_MSG);
	                    }
	                    return transactionOperation(persistenceTransaction);
	                })
	                    .next(function (result) {
	                    return _this.acquireOrExtendPrimaryLease(simpleDbTxn).next(function () { return result; });
	                });
	            }
	            else {
	                return _this.verifyAllowTabSynchronization(simpleDbTxn).next(function () {
	                    return transactionOperation(persistenceTransaction);
	                });
	            }
	        })
	            .then(function (result) {
	            persistenceTransaction.raiseOnCommittedEvent();
	            return result;
	        });
	    };
	    /**
	     * Verifies that the current tab is the primary leaseholder or alternatively
	     * that the leaseholder has opted into multi-tab synchronization.
	     */
	    // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
	    // be turned off.
	    IndexedDbPersistence.prototype.verifyAllowTabSynchronization = function (txn) {
	        var _this = this;
	        var store = primaryClientStore(txn);
	        return store.get(DbPrimaryClient.key).next(function (currentPrimary) {
	            var currentLeaseIsValid = currentPrimary !== null &&
	                _this.isWithinAge(currentPrimary.leaseTimestampMs, MAX_PRIMARY_ELIGIBLE_AGE_MS) &&
	                !_this.isClientZombied(currentPrimary.ownerId);
	            if (currentLeaseIsValid && !_this.isLocalClient(currentPrimary)) {
	                if (!currentPrimary.allowTabSynchronization) {
	                    throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);
	                }
	            }
	        });
	    };
	    /**
	     * Obtains or extends the new primary lease for the local client. This
	     * method does not verify that the client is eligible for this lease.
	     */
	    IndexedDbPersistence.prototype.acquireOrExtendPrimaryLease = function (txn) {
	        var newPrimary = new DbPrimaryClient(this.clientId, this.allowTabSynchronization, Date.now());
	        return primaryClientStore(txn).put(DbPrimaryClient.key, newPrimary);
	    };
	    IndexedDbPersistence.isAvailable = function () {
	        return SimpleDb.isAvailable();
	    };
	    /**
	     * Generates a string used as a prefix when storing data in IndexedDB and
	     * LocalStorage.
	     */
	    IndexedDbPersistence.buildStoragePrefix = function (databaseInfo) {
	        // Use two different prefix formats:
	        //
	        //   * firestore / persistenceKey / projectID . databaseID / ...
	        //   * firestore / persistenceKey / projectID / ...
	        //
	        // projectIDs are DNS-compatible names and cannot contain dots
	        // so there's no danger of collisions.
	        var database = databaseInfo.databaseId.projectId;
	        if (!databaseInfo.databaseId.isDefaultDatabase) {
	            database += '.' + databaseInfo.databaseId.database;
	        }
	        return 'firestore/' + databaseInfo.persistenceKey + '/' + database + '/';
	    };
	    /** Checks the primary lease and removes it if we are the current primary. */
	    IndexedDbPersistence.prototype.releasePrimaryLeaseIfHeld = function (txn) {
	        var _this = this;
	        var store = primaryClientStore(txn);
	        return store.get(DbPrimaryClient.key).next(function (primaryClient) {
	            if (_this.isLocalClient(primaryClient)) {
	                debug(LOG_TAG$2, 'Releasing primary lease.');
	                return store.delete(DbPrimaryClient.key);
	            }
	            else {
	                return PersistencePromise.resolve();
	            }
	        });
	    };
	    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */
	    IndexedDbPersistence.prototype.isWithinAge = function (updateTimeMs, maxAgeMs) {
	        var now = Date.now();
	        var minAcceptable = now - maxAgeMs;
	        var maxAcceptable = now;
	        if (updateTimeMs < minAcceptable) {
	            return false;
	        }
	        else if (updateTimeMs > maxAcceptable) {
	            error("Detected an update time that is in the future: " + updateTimeMs + " > " + maxAcceptable);
	            return false;
	        }
	        return true;
	    };
	    IndexedDbPersistence.prototype.attachVisibilityHandler = function () {
	        var _this = this;
	        if (this.document !== null &&
	            typeof this.document.addEventListener === 'function') {
	            this.documentVisibilityHandler = function () {
	                _this.queue.enqueueAndForget(function () {
	                    _this.inForeground = _this.document.visibilityState === 'visible';
	                    return _this.updateClientMetadataAndTryBecomePrimary();
	                });
	            };
	            this.document.addEventListener('visibilitychange', this.documentVisibilityHandler);
	            this.inForeground = this.document.visibilityState === 'visible';
	        }
	    };
	    IndexedDbPersistence.prototype.detachVisibilityHandler = function () {
	        if (this.documentVisibilityHandler) {
	            assert(this.document !== null &&
	                typeof this.document.addEventListener === 'function', "Expected 'document.addEventListener' to be a function");
	            this.document.removeEventListener('visibilitychange', this.documentVisibilityHandler);
	            this.documentVisibilityHandler = null;
	        }
	    };
	    /**
	     * Attaches a window.unload handler that will synchronously write our
	     * clientId to a "zombie client id" location in LocalStorage. This can be used
	     * by tabs trying to acquire the primary lease to determine that the lease
	     * is no longer valid even if the timestamp is recent. This is particularly
	     * important for the refresh case (so the tab correctly re-acquires the
	     * primary lease). LocalStorage is used for this rather than IndexedDb because
	     * it is a synchronous API and so can be used reliably from  an unload
	     * handler.
	     */
	    IndexedDbPersistence.prototype.attachWindowUnloadHook = function () {
	        var _this = this;
	        if (typeof this.window.addEventListener === 'function') {
	            this.windowUnloadHandler = function () {
	                // Note: In theory, this should be scheduled on the AsyncQueue since it
	                // accesses internal state. We execute this code directly during shutdown
	                // to make sure it gets a chance to run.
	                _this.markClientZombied();
	                _this.queue.enqueueAndForget(function () {
	                    // Attempt graceful shutdown (including releasing our primary lease),
	                    // but there's no guarantee it will complete.
	                    return _this.shutdown();
	                });
	            };
	            this.window.addEventListener('unload', this.windowUnloadHandler);
	        }
	    };
	    IndexedDbPersistence.prototype.detachWindowUnloadHook = function () {
	        if (this.windowUnloadHandler) {
	            assert(typeof this.window.removeEventListener === 'function', "Expected 'window.removeEventListener' to be a function");
	            this.window.removeEventListener('unload', this.windowUnloadHandler);
	            this.windowUnloadHandler = null;
	        }
	    };
	    /**
	     * Returns whether a client is "zombied" based on its LocalStorage entry.
	     * Clients become zombied when their tab closes without running all of the
	     * cleanup logic in `shutdown()`.
	     */
	    IndexedDbPersistence.prototype.isClientZombied = function (clientId) {
	        try {
	            var isZombied = this.webStorage.getItem(this.zombiedClientLocalStorageKey(clientId)) !==
	                null;
	            debug(LOG_TAG$2, "Client '" + clientId + "' " + (isZombied ? 'is' : 'is not') + " zombied in LocalStorage");
	            return isZombied;
	        }
	        catch (e) {
	            // Gracefully handle if LocalStorage isn't working.
	            error(LOG_TAG$2, 'Failed to get zombied client id.', e);
	            return false;
	        }
	    };
	    /**
	     * Record client as zombied (a client that had its tab closed). Zombied
	     * clients are ignored during primary tab selection.
	     */
	    IndexedDbPersistence.prototype.markClientZombied = function () {
	        try {
	            this.webStorage.setItem(this.zombiedClientLocalStorageKey(this.clientId), String(Date.now()));
	        }
	        catch (e) {
	            // Gracefully handle if LocalStorage isn't available / working.
	            error('Failed to set zombie client id.', e);
	        }
	    };
	    /** Removes the zombied client entry if it exists. */
	    IndexedDbPersistence.prototype.removeClientZombiedEntry = function () {
	        try {
	            this.webStorage.removeItem(this.zombiedClientLocalStorageKey(this.clientId));
	        }
	        catch (e) {
	            // Ignore
	        }
	    };
	    IndexedDbPersistence.prototype.zombiedClientLocalStorageKey = function (clientId) {
	        return ZOMBIED_CLIENTS_KEY_PREFIX + "_" + this.persistenceKey + "_" + clientId;
	    };
	    /**
	     * The name of the main (and currently only) IndexedDB database. this name is
	     * appended to the prefix provided to the IndexedDbPersistence constructor.
	     */
	    IndexedDbPersistence.MAIN_DATABASE = 'main';
	    return IndexedDbPersistence;
	}());
	/**
	 * Helper to get a typed SimpleDbStore for the primary client object store.
	 */
	function primaryClientStore(txn) {
	    return txn.store(DbPrimaryClient.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the client metadata object store.
	 */
	function clientMetadataStore(txn) {
	    return txn.store(DbClientMetadata.store);
	}
	/** Provides LRU functionality for IndexedDB persistence. */
	var IndexedDbLruDelegate = /** @class */ (function () {
	    function IndexedDbLruDelegate(db, params) {
	        this.db = db;
	        this.inMemoryPins = null;
	        this.garbageCollector = new LruGarbageCollector(this, params);
	    }
	    IndexedDbLruDelegate.prototype.getSequenceNumberCount = function (txn) {
	        var docCountPromise = this.orphanedDocmentCount(txn);
	        var targetCountPromise = this.db.getTargetCache().getTargetCount(txn);
	        return targetCountPromise.next(function (targetCount) {
	            return docCountPromise.next(function (docCount) { return targetCount + docCount; });
	        });
	    };
	    IndexedDbLruDelegate.prototype.orphanedDocmentCount = function (txn) {
	        var orphanedCount = 0;
	        return this.forEachOrphanedDocumentSequenceNumber(txn, function (_) {
	            orphanedCount++;
	        }).next(function () { return orphanedCount; });
	    };
	    IndexedDbLruDelegate.prototype.forEachTarget = function (txn, f) {
	        return this.db.getTargetCache().forEachTarget(txn, f);
	    };
	    IndexedDbLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber = function (txn, f) {
	        return this.forEachOrphanedDocument(txn, function (docKey, sequenceNumber) {
	            return f(sequenceNumber);
	        });
	    };
	    IndexedDbLruDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
	        this.inMemoryPins = inMemoryPins;
	    };
	    IndexedDbLruDelegate.prototype.addReference = function (txn, key) {
	        return writeSentinelKey(txn, key);
	    };
	    IndexedDbLruDelegate.prototype.removeReference = function (txn, key) {
	        return writeSentinelKey(txn, key);
	    };
	    IndexedDbLruDelegate.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
	        return this.db
	            .getTargetCache()
	            .removeTargets(txn, upperBound, activeTargetIds);
	    };
	    IndexedDbLruDelegate.prototype.removeMutationReference = function (txn, key) {
	        return writeSentinelKey(txn, key);
	    };
	    /**
	     * Returns true if anything would prevent this document from being garbage
	     * collected, given that the document in question is not present in any
	     * targets and has a sequence number less than or equal to the upper bound for
	     * the collection run.
	     */
	    IndexedDbLruDelegate.prototype.isPinned = function (txn, docKey) {
	        if (this.inMemoryPins.containsKey(docKey)) {
	            return PersistencePromise.resolve(true);
	        }
	        else {
	            return mutationQueuesContainKey(txn, docKey);
	        }
	    };
	    IndexedDbLruDelegate.prototype.removeOrphanedDocuments = function (txn, upperBound) {
	        var _this = this;
	        var documentCache = this.db.getRemoteDocumentCache();
	        var changeBuffer = documentCache.newChangeBuffer();
	        var promises = [];
	        var documentCount = 0;
	        var iteration = this.forEachOrphanedDocument(txn, function (docKey, sequenceNumber) {
	            if (sequenceNumber <= upperBound) {
	                var p = _this.isPinned(txn, docKey).next(function (isPinned) {
	                    if (!isPinned) {
	                        documentCount++;
	                        // Our size accounting requires us to read all documents before
	                        // removing them.
	                        return changeBuffer.getEntry(txn, docKey).next(function () {
	                            changeBuffer.removeEntry(docKey);
	                            return documentTargetStore(txn).delete(sentinelKey$1(docKey));
	                        });
	                    }
	                });
	                promises.push(p);
	            }
	        });
	        return iteration
	            .next(function () { return PersistencePromise.waitFor(promises); })
	            .next(function () { return changeBuffer.apply(txn); })
	            .next(function () { return documentCount; });
	    };
	    IndexedDbLruDelegate.prototype.removeTarget = function (txn, targetData) {
	        var updated = targetData.withSequenceNumber(txn.currentSequenceNumber);
	        return this.db.getTargetCache().updateTargetData(txn, updated);
	    };
	    IndexedDbLruDelegate.prototype.updateLimboDocument = function (txn, key) {
	        return writeSentinelKey(txn, key);
	    };
	    /**
	     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
	     * means not a part of any target, so the only entry in the target-document index for
	     * that document will be the sentinel row (targetId 0), which will also have the sequence
	     * number for the last time the document was accessed.
	     */
	    IndexedDbLruDelegate.prototype.forEachOrphanedDocument = function (txn, f) {
	        var store = documentTargetStore(txn);
	        var nextToReport = ListenSequence.INVALID;
	        var nextPath;
	        return store
	            .iterate({
	            index: DbTargetDocument.documentTargetsIndex
	        }, function (_a, _b) {
	            var targetId = _a[0], docKey = _a[1];
	            var path = _b.path, sequenceNumber = _b.sequenceNumber;
	            if (targetId === 0) {
	                // if nextToReport is valid, report it, this is a new key so the
	                // last one must not be a member of any targets.
	                if (nextToReport !== ListenSequence.INVALID) {
	                    f(new DocumentKey(decode(nextPath)), nextToReport);
	                }
	                // set nextToReport to be this sequence number. It's the next one we
	                // might report, if we don't find any targets for this document.
	                // Note that the sequence number must be defined when the targetId
	                // is 0.
	                nextToReport = sequenceNumber;
	                nextPath = path;
	            }
	            else {
	                // set nextToReport to be invalid, we know we don't need to report
	                // this one since we found a target for it.
	                nextToReport = ListenSequence.INVALID;
	            }
	        })
	            .next(function () {
	            // Since we report sequence numbers after getting to the next key, we
	            // need to check if the last key we iterated over was an orphaned
	            // document and report it.
	            if (nextToReport !== ListenSequence.INVALID) {
	                f(new DocumentKey(decode(nextPath)), nextToReport);
	            }
	        });
	    };
	    IndexedDbLruDelegate.prototype.getCacheSize = function (txn) {
	        return this.db.getRemoteDocumentCache().getSize(txn);
	    };
	    return IndexedDbLruDelegate;
	}());
	function sentinelKey$1(key) {
	    return [0, encode(key.path)];
	}
	/**
	 * @return A value suitable for writing a sentinel row in the target-document
	 * store.
	 */
	function sentinelRow(key, sequenceNumber) {
	    return new DbTargetDocument(0, encode(key.path), sequenceNumber);
	}
	function writeSentinelKey(txn, key) {
	    return documentTargetStore(txn).put(sentinelRow(key, txn.currentSequenceNumber));
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Untyped Number alias we can use to check for ES6 methods / properties.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	var NumberAsAny = Number;
	/**
	 * Minimum safe integer in Javascript because of floating point precision.
	 * Added to not rely on ES6 features.
	 */
	var MIN_SAFE_INTEGER = NumberAsAny.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1);
	/**
	 * Maximum safe integer in Javascript because of floating point precision.
	 * Added to not rely on ES6 features.
	 */
	var MAX_SAFE_INTEGER = NumberAsAny.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	/**
	 * Returns whether an number is an integer, uses native implementation if
	 * available.
	 * Added to not rely on ES6 features.
	 * @param value The value to test for being an integer
	 */
	var isInteger = NumberAsAny.isInteger ||
	    (function (value) {
	        return typeof value === 'number' &&
	            isFinite(value) &&
	            Math.floor(value) === value;
	    });
	/**
	 * Returns whether a variable is either undefined or null.
	 */
	function isNullOrUndefined(value) {
	    return value === null || value === undefined;
	}
	/**
	 * Returns whether a value is an integer and in the safe integer range
	 * @param value The value to test for being an integer and in the safe range
	 */
	function isSafeInteger(value) {
	    return (isInteger(value) &&
	        value <= MAX_SAFE_INTEGER &&
	        value >= MIN_SAFE_INTEGER);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A Target represents the WatchTarget representation of a Query, which is used
	 * by the LocalStore and the RemoteStore to keep track of and to execute
	 * backend queries. While a Query can represent multiple Targets, each Targets
	 * maps to a single WatchTarget in RemoteStore and a single TargetData entry
	 * in persistence.
	 */
	var Target = /** @class */ (function () {
	    /**
	     * Initializes a Target with a path and optional additional query constraints.
	     * Path must currently be empty if this is a collection group query.
	     *
	     * NOTE: you should always construct `Target` from `Query.toTarget` instead of
	     * using this constructor, because `Query` provides an implicit `orderBy`
	     * property.
	     */
	    function Target(path, collectionGroup, orderBy, filters, limit, startAt, endAt) {
	        if (collectionGroup === void 0) { collectionGroup = null; }
	        if (orderBy === void 0) { orderBy = []; }
	        if (filters === void 0) { filters = []; }
	        if (limit === void 0) { limit = null; }
	        if (startAt === void 0) { startAt = null; }
	        if (endAt === void 0) { endAt = null; }
	        this.path = path;
	        this.collectionGroup = collectionGroup;
	        this.orderBy = orderBy;
	        this.filters = filters;
	        this.limit = limit;
	        this.startAt = startAt;
	        this.endAt = endAt;
	        this.memoizedCanonicalId = null;
	    }
	    Target.prototype.canonicalId = function () {
	        if (this.memoizedCanonicalId === null) {
	            var canonicalId = this.path.canonicalString();
	            if (this.collectionGroup !== null) {
	                canonicalId += '|cg:' + this.collectionGroup;
	            }
	            canonicalId += '|f:';
	            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	                var filter = _a[_i];
	                canonicalId += filter.canonicalId();
	                canonicalId += ',';
	            }
	            canonicalId += '|ob:';
	            // TODO(dimond): make this collision resistant
	            for (var _b = 0, _c = this.orderBy; _b < _c.length; _b++) {
	                var orderBy = _c[_b];
	                canonicalId += orderBy.canonicalId();
	                canonicalId += ',';
	            }
	            if (!isNullOrUndefined(this.limit)) {
	                canonicalId += '|l:';
	                canonicalId += this.limit;
	            }
	            if (this.startAt) {
	                canonicalId += '|lb:';
	                canonicalId += this.startAt.canonicalId();
	            }
	            if (this.endAt) {
	                canonicalId += '|ub:';
	                canonicalId += this.endAt.canonicalId();
	            }
	            this.memoizedCanonicalId = canonicalId;
	        }
	        return this.memoizedCanonicalId;
	    };
	    Target.prototype.toString = function () {
	        var str = this.path.canonicalString();
	        if (this.collectionGroup !== null) {
	            str += ' collectionGroup=' + this.collectionGroup;
	        }
	        if (this.filters.length > 0) {
	            str += ", filters: [" + this.filters.join(', ') + "]";
	        }
	        if (!isNullOrUndefined(this.limit)) {
	            str += ', limit: ' + this.limit;
	        }
	        if (this.orderBy.length > 0) {
	            str += ", orderBy: [" + this.orderBy.join(', ') + "]";
	        }
	        if (this.startAt) {
	            str += ', startAt: ' + this.startAt.canonicalId();
	        }
	        if (this.endAt) {
	            str += ', endAt: ' + this.endAt.canonicalId();
	        }
	        return "Target(" + str + ")";
	    };
	    Target.prototype.isEqual = function (other) {
	        if (this.limit !== other.limit) {
	            return false;
	        }
	        if (this.orderBy.length !== other.orderBy.length) {
	            return false;
	        }
	        for (var i = 0; i < this.orderBy.length; i++) {
	            if (!this.orderBy[i].isEqual(other.orderBy[i])) {
	                return false;
	            }
	        }
	        if (this.filters.length !== other.filters.length) {
	            return false;
	        }
	        for (var i = 0; i < this.filters.length; i++) {
	            if (!this.filters[i].isEqual(other.filters[i])) {
	                return false;
	            }
	        }
	        if (this.collectionGroup !== other.collectionGroup) {
	            return false;
	        }
	        if (!this.path.isEqual(other.path)) {
	            return false;
	        }
	        if (this.startAt !== null
	            ? !this.startAt.isEqual(other.startAt)
	            : other.startAt !== null) {
	            return false;
	        }
	        return this.endAt !== null
	            ? this.endAt.isEqual(other.endAt)
	            : other.endAt === null;
	    };
	    Target.prototype.isDocumentQuery = function () {
	        return (DocumentKey.isDocumentKey(this.path) &&
	            this.collectionGroup === null &&
	            this.filters.length === 0);
	    };
	    return Target;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LimitType;
	(function (LimitType) {
	    LimitType["First"] = "F";
	    LimitType["Last"] = "L";
	})(LimitType || (LimitType = {}));
	/**
	 * Query encapsulates all the query attributes we support in the SDK. It can
	 * be run against the LocalStore, as well as be converted to a `Target` to
	 * query the RemoteStore results.
	 */
	var Query = /** @class */ (function () {
	    /**
	     * Initializes a Query with a path and optional additional query constraints.
	     * Path must currently be empty if this is a collection group query.
	     */
	    function Query(path, collectionGroup, explicitOrderBy, filters, limit, limitType, startAt, endAt) {
	        if (collectionGroup === void 0) { collectionGroup = null; }
	        if (explicitOrderBy === void 0) { explicitOrderBy = []; }
	        if (filters === void 0) { filters = []; }
	        if (limit === void 0) { limit = null; }
	        if (limitType === void 0) { limitType = LimitType.First; }
	        if (startAt === void 0) { startAt = null; }
	        if (endAt === void 0) { endAt = null; }
	        this.path = path;
	        this.collectionGroup = collectionGroup;
	        this.explicitOrderBy = explicitOrderBy;
	        this.filters = filters;
	        this.limit = limit;
	        this.limitType = limitType;
	        this.startAt = startAt;
	        this.endAt = endAt;
	        this.memoizedOrderBy = null;
	        // The corresponding `Target` of this `Query` instance.
	        this.memoizedTarget = null;
	        if (this.startAt) {
	            this.assertValidBound(this.startAt);
	        }
	        if (this.endAt) {
	            this.assertValidBound(this.endAt);
	        }
	    }
	    Query.atPath = function (path) {
	        return new Query(path);
	    };
	    Object.defineProperty(Query.prototype, "orderBy", {
	        get: function () {
	            if (this.memoizedOrderBy === null) {
	                var inequalityField = this.getInequalityFilterField();
	                var firstOrderByField = this.getFirstOrderByField();
	                if (inequalityField !== null && firstOrderByField === null) {
	                    // In order to implicitly add key ordering, we must also add the
	                    // inequality filter field for it to be a valid query.
	                    // Note that the default inequality field and key ordering is ascending.
	                    if (inequalityField.isKeyField()) {
	                        this.memoizedOrderBy = [KEY_ORDERING_ASC];
	                    }
	                    else {
	                        this.memoizedOrderBy = [
	                            new OrderBy(inequalityField),
	                            KEY_ORDERING_ASC
	                        ];
	                    }
	                }
	                else {
	                    assert(inequalityField === null ||
	                        (firstOrderByField !== null &&
	                            inequalityField.isEqual(firstOrderByField)), 'First orderBy should match inequality field.');
	                    this.memoizedOrderBy = [];
	                    var foundKeyOrdering = false;
	                    for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
	                        var orderBy = _a[_i];
	                        this.memoizedOrderBy.push(orderBy);
	                        if (orderBy.field.isKeyField()) {
	                            foundKeyOrdering = true;
	                        }
	                    }
	                    if (!foundKeyOrdering) {
	                        // The order of the implicit key ordering always matches the last
	                        // explicit order by
	                        var lastDirection = this.explicitOrderBy.length > 0
	                            ? this.explicitOrderBy[this.explicitOrderBy.length - 1].dir
	                            : Direction.ASCENDING;
	                        this.memoizedOrderBy.push(lastDirection === Direction.ASCENDING
	                            ? KEY_ORDERING_ASC
	                            : KEY_ORDERING_DESC);
	                    }
	                }
	            }
	            return this.memoizedOrderBy;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Query.prototype.addFilter = function (filter) {
	        assert(this.getInequalityFilterField() == null ||
	            !(filter instanceof FieldFilter) ||
	            !filter.isInequality() ||
	            filter.field.isEqual(this.getInequalityFilterField()), 'Query must only have one inequality field.');
	        assert(!this.isDocumentQuery(), 'No filtering allowed for document query');
	        var newFilters = this.filters.concat([filter]);
	        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), newFilters, this.limit, this.limitType, this.startAt, this.endAt);
	    };
	    Query.prototype.addOrderBy = function (orderBy) {
	        assert(!this.startAt && !this.endAt, 'Bounds must be set after orderBy');
	        // TODO(dimond): validate that orderBy does not list the same key twice.
	        var newOrderBy = this.explicitOrderBy.concat([orderBy]);
	        return new Query(this.path, this.collectionGroup, newOrderBy, this.filters.slice(), this.limit, this.limitType, this.startAt, this.endAt);
	    };
	    Query.prototype.withLimitToFirst = function (limit) {
	        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), limit, LimitType.First, this.startAt, this.endAt);
	    };
	    Query.prototype.withLimitToLast = function (limit) {
	        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), limit, LimitType.Last, this.startAt, this.endAt);
	    };
	    Query.prototype.withStartAt = function (bound) {
	        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.limitType, bound, this.endAt);
	    };
	    Query.prototype.withEndAt = function (bound) {
	        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.limitType, this.startAt, bound);
	    };
	    /**
	     * Helper to convert a collection group query into a collection query at a
	     * specific path. This is used when executing collection group queries, since
	     * we have to split the query into a set of collection queries at multiple
	     * paths.
	     */
	    Query.prototype.asCollectionQueryAtPath = function (path) {
	        return new Query(path, 
	        /*collectionGroup=*/ null, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.limitType, this.startAt, this.endAt);
	    };
	    /**
	     * Returns true if this query does not specify any query constraints that
	     * could remove results.
	     */
	    Query.prototype.matchesAllDocuments = function () {
	        return (this.filters.length === 0 &&
	            this.limit === null &&
	            this.startAt == null &&
	            this.endAt == null &&
	            (this.explicitOrderBy.length === 0 ||
	                (this.explicitOrderBy.length === 1 &&
	                    this.explicitOrderBy[0].field.isKeyField())));
	    };
	    // TODO(b/29183165): This is used to get a unique string from a query to, for
	    // example, use as a dictionary key, but the implementation is subject to
	    // collisions. Make it collision-free.
	    Query.prototype.canonicalId = function () {
	        return this.toTarget().canonicalId() + "|lt:" + this.limitType;
	    };
	    Query.prototype.toString = function () {
	        return "Query(target=" + this.toTarget().toString() + "; limitType=" + this.limitType + ")";
	    };
	    Query.prototype.isEqual = function (other) {
	        return (this.toTarget().isEqual(other.toTarget()) &&
	            this.limitType === other.limitType);
	    };
	    Query.prototype.docComparator = function (d1, d2) {
	        var comparedOnKeyField = false;
	        for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            var comp = orderBy.compare(d1, d2);
	            if (comp !== 0) {
	                return comp;
	            }
	            comparedOnKeyField = comparedOnKeyField || orderBy.field.isKeyField();
	        }
	        // Assert that we actually compared by key
	        assert(comparedOnKeyField, "orderBy used that doesn't compare on key field");
	        return 0;
	    };
	    Query.prototype.matches = function (doc) {
	        return (this.matchesPathAndCollectionGroup(doc) &&
	            this.matchesOrderBy(doc) &&
	            this.matchesFilters(doc) &&
	            this.matchesBounds(doc));
	    };
	    Query.prototype.hasLimitToFirst = function () {
	        return !isNullOrUndefined(this.limit) && this.limitType === LimitType.First;
	    };
	    Query.prototype.hasLimitToLast = function () {
	        return !isNullOrUndefined(this.limit) && this.limitType === LimitType.Last;
	    };
	    Query.prototype.getFirstOrderByField = function () {
	        return this.explicitOrderBy.length > 0
	            ? this.explicitOrderBy[0].field
	            : null;
	    };
	    Query.prototype.getInequalityFilterField = function () {
	        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	            var filter = _a[_i];
	            if (filter instanceof FieldFilter && filter.isInequality()) {
	                return filter.field;
	            }
	        }
	        return null;
	    };
	    // Checks if any of the provided Operators are included in the query and
	    // returns the first one that is, or null if none are.
	    Query.prototype.findFilterOperator = function (operators) {
	        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	            var filter = _a[_i];
	            if (filter instanceof FieldFilter) {
	                if (operators.indexOf(filter.op) >= 0) {
	                    return filter.op;
	                }
	            }
	        }
	        return null;
	    };
	    Query.prototype.isDocumentQuery = function () {
	        return this.toTarget().isDocumentQuery();
	    };
	    Query.prototype.isCollectionGroupQuery = function () {
	        return this.collectionGroup !== null;
	    };
	    /**
	     * Converts this `Query` instance to it's corresponding `Target`
	     * representation.
	     */
	    Query.prototype.toTarget = function () {
	        if (!this.memoizedTarget) {
	            if (this.limitType === LimitType.First) {
	                this.memoizedTarget = new Target(this.path, this.collectionGroup, this.orderBy, this.filters, this.limit, this.startAt, this.endAt);
	            }
	            else {
	                // Flip the orderBy directions since we want the last results
	                var orderBys = [];
	                for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
	                    var orderBy = _a[_i];
	                    var dir = orderBy.dir === Direction.DESCENDING
	                        ? Direction.ASCENDING
	                        : Direction.DESCENDING;
	                    orderBys.push(new OrderBy(orderBy.field, dir));
	                }
	                // We need to swap the cursors to match the now-flipped query ordering.
	                var startAt = this.endAt
	                    ? new Bound(this.endAt.position, !this.endAt.before)
	                    : null;
	                var endAt = this.startAt
	                    ? new Bound(this.startAt.position, !this.startAt.before)
	                    : null;
	                // Now return as a LimitType.First query.
	                this.memoizedTarget = new Target(this.path, this.collectionGroup, orderBys, this.filters, this.limit, startAt, endAt);
	            }
	        }
	        return this.memoizedTarget;
	    };
	    Query.prototype.matchesPathAndCollectionGroup = function (doc) {
	        var docPath = doc.key.path;
	        if (this.collectionGroup !== null) {
	            // NOTE: this.path is currently always empty since we don't expose Collection
	            // Group queries rooted at a document path yet.
	            return (doc.key.hasCollectionId(this.collectionGroup) &&
	                this.path.isPrefixOf(docPath));
	        }
	        else if (DocumentKey.isDocumentKey(this.path)) {
	            // exact match for document queries
	            return this.path.isEqual(docPath);
	        }
	        else {
	            // shallow ancestor queries by default
	            return this.path.isImmediateParentOf(docPath);
	        }
	    };
	    /**
	     * A document must have a value for every ordering clause in order to show up
	     * in the results.
	     */
	    Query.prototype.matchesOrderBy = function (doc) {
	        for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            // order by key always matches
	            if (!orderBy.field.isKeyField() && doc.field(orderBy.field) === null) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Query.prototype.matchesFilters = function (doc) {
	        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	            var filter = _a[_i];
	            if (!filter.matches(doc)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     * Makes sure a document is within the bounds, if provided.
	     */
	    Query.prototype.matchesBounds = function (doc) {
	        if (this.startAt && !this.startAt.sortsBeforeDocument(this.orderBy, doc)) {
	            return false;
	        }
	        if (this.endAt && this.endAt.sortsBeforeDocument(this.orderBy, doc)) {
	            return false;
	        }
	        return true;
	    };
	    Query.prototype.assertValidBound = function (bound) {
	        assert(bound.position.length <= this.orderBy.length, 'Bound is longer than orderBy');
	    };
	    return Query;
	}());
	var Filter = /** @class */ (function () {
	    function Filter() {
	    }
	    return Filter;
	}());
	var Operator = /** @class */ (function () {
	    function Operator(name) {
	        this.name = name;
	    }
	    Operator.fromString = function (op) {
	        switch (op) {
	            case '<':
	                return Operator.LESS_THAN;
	            case '<=':
	                return Operator.LESS_THAN_OR_EQUAL;
	            case '==':
	                return Operator.EQUAL;
	            case '>=':
	                return Operator.GREATER_THAN_OR_EQUAL;
	            case '>':
	                return Operator.GREATER_THAN;
	            case 'array-contains':
	                return Operator.ARRAY_CONTAINS;
	            case 'in':
	                return Operator.IN;
	            case 'array-contains-any':
	                return Operator.ARRAY_CONTAINS_ANY;
	            default:
	                return fail('Unknown FieldFilter operator: ' + op);
	        }
	    };
	    Operator.prototype.toString = function () {
	        return this.name;
	    };
	    Operator.prototype.isEqual = function (other) {
	        return this.name === other.name;
	    };
	    Operator.LESS_THAN = new Operator('<');
	    Operator.LESS_THAN_OR_EQUAL = new Operator('<=');
	    Operator.EQUAL = new Operator('==');
	    Operator.GREATER_THAN = new Operator('>');
	    Operator.GREATER_THAN_OR_EQUAL = new Operator('>=');
	    Operator.ARRAY_CONTAINS = new Operator('array-contains');
	    Operator.IN = new Operator('in');
	    Operator.ARRAY_CONTAINS_ANY = new Operator('array-contains-any');
	    return Operator;
	}());
	var FieldFilter = /** @class */ (function (_super) {
	    tslib.__extends(FieldFilter, _super);
	    function FieldFilter(field, op, value) {
	        var _this = _super.call(this) || this;
	        _this.field = field;
	        _this.op = op;
	        _this.value = value;
	        return _this;
	    }
	    /**
	     * Creates a filter based on the provided arguments.
	     */
	    FieldFilter.create = function (field, op, value) {
	        if (field.isKeyField()) {
	            if (op === Operator.IN) {
	                assert(value instanceof ArrayValue, 'Comparing on key with IN, but filter value not an ArrayValue');
	                assert(value.internalValue.every(function (elem) {
	                    return elem instanceof RefValue;
	                }), 'Comparing on key with IN, but an array value was not a RefValue');
	                return new KeyFieldInFilter(field, value);
	            }
	            else {
	                assert(value instanceof RefValue, 'Comparing on key, but filter value not a RefValue');
	                assert(op !== Operator.ARRAY_CONTAINS && op !== Operator.ARRAY_CONTAINS_ANY, "'" + op.toString() + "' queries don't make sense on document keys.");
	                return new KeyFieldFilter(field, op, value);
	            }
	        }
	        else if (value.isEqual(NullValue.INSTANCE)) {
	            if (op !== Operator.EQUAL) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. Null supports only equality comparisons.');
	            }
	            return new FieldFilter(field, op, value);
	        }
	        else if (value.isEqual(DoubleValue.NAN)) {
	            if (op !== Operator.EQUAL) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. NaN supports only equality comparisons.');
	            }
	            return new FieldFilter(field, op, value);
	        }
	        else if (op === Operator.ARRAY_CONTAINS) {
	            return new ArrayContainsFilter(field, value);
	        }
	        else if (op === Operator.IN) {
	            assert(value instanceof ArrayValue, 'IN filter has invalid value: ' + value.toString());
	            return new InFilter(field, value);
	        }
	        else if (op === Operator.ARRAY_CONTAINS_ANY) {
	            assert(value instanceof ArrayValue, 'ARRAY_CONTAINS_ANY filter has invalid value: ' + value.toString());
	            return new ArrayContainsAnyFilter(field, value);
	        }
	        else {
	            return new FieldFilter(field, op, value);
	        }
	    };
	    FieldFilter.prototype.matches = function (doc) {
	        var other = doc.field(this.field);
	        // Only compare types with matching backend order (such as double and int).
	        return (other !== null &&
	            this.value.typeOrder === other.typeOrder &&
	            this.matchesComparison(other.compareTo(this.value)));
	    };
	    FieldFilter.prototype.matchesComparison = function (comparison) {
	        switch (this.op) {
	            case Operator.LESS_THAN:
	                return comparison < 0;
	            case Operator.LESS_THAN_OR_EQUAL:
	                return comparison <= 0;
	            case Operator.EQUAL:
	                return comparison === 0;
	            case Operator.GREATER_THAN:
	                return comparison > 0;
	            case Operator.GREATER_THAN_OR_EQUAL:
	                return comparison >= 0;
	            default:
	                return fail('Unknown FieldFilter operator: ' + this.op);
	        }
	    };
	    FieldFilter.prototype.isInequality = function () {
	        return ([
	            Operator.LESS_THAN,
	            Operator.LESS_THAN_OR_EQUAL,
	            Operator.GREATER_THAN,
	            Operator.GREATER_THAN_OR_EQUAL
	        ].indexOf(this.op) >= 0);
	    };
	    FieldFilter.prototype.canonicalId = function () {
	        // TODO(b/29183165): Technically, this won't be unique if two values have
	        // the same description, such as the int 3 and the string "3". So we should
	        // add the types in here somehow, too.
	        return (this.field.canonicalString() + this.op.toString() + this.value.toString());
	    };
	    FieldFilter.prototype.isEqual = function (other) {
	        if (other instanceof FieldFilter) {
	            return (this.op.isEqual(other.op) &&
	                this.field.isEqual(other.field) &&
	                this.value.isEqual(other.value));
	        }
	        else {
	            return false;
	        }
	    };
	    FieldFilter.prototype.toString = function () {
	        return this.field.canonicalString() + " " + this.op + " " + this.value.value();
	    };
	    return FieldFilter;
	}(Filter));
	/** Filter that matches on key fields (i.e. '__name__'). */
	var KeyFieldFilter = /** @class */ (function (_super) {
	    tslib.__extends(KeyFieldFilter, _super);
	    function KeyFieldFilter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    KeyFieldFilter.prototype.matches = function (doc) {
	        var refValue = this.value;
	        var comparison = DocumentKey.comparator(doc.key, refValue.key);
	        return this.matchesComparison(comparison);
	    };
	    return KeyFieldFilter;
	}(FieldFilter));
	/** Filter that matches on key fields within an array. */
	var KeyFieldInFilter = /** @class */ (function (_super) {
	    tslib.__extends(KeyFieldInFilter, _super);
	    function KeyFieldInFilter(field, value) {
	        var _this = _super.call(this, field, Operator.IN, value) || this;
	        _this.value = value;
	        return _this;
	    }
	    KeyFieldInFilter.prototype.matches = function (doc) {
	        var arrayValue = this.value;
	        return arrayValue.internalValue.some(function (refValue) {
	            return doc.key.isEqual(refValue.key);
	        });
	    };
	    return KeyFieldInFilter;
	}(FieldFilter));
	/** A Filter that implements the array-contains operator. */
	var ArrayContainsFilter = /** @class */ (function (_super) {
	    tslib.__extends(ArrayContainsFilter, _super);
	    function ArrayContainsFilter(field, value) {
	        return _super.call(this, field, Operator.ARRAY_CONTAINS, value) || this;
	    }
	    ArrayContainsFilter.prototype.matches = function (doc) {
	        var other = doc.field(this.field);
	        return other instanceof ArrayValue && other.contains(this.value);
	    };
	    return ArrayContainsFilter;
	}(FieldFilter));
	/** A Filter that implements the IN operator. */
	var InFilter = /** @class */ (function (_super) {
	    tslib.__extends(InFilter, _super);
	    function InFilter(field, value) {
	        var _this = _super.call(this, field, Operator.IN, value) || this;
	        _this.value = value;
	        return _this;
	    }
	    InFilter.prototype.matches = function (doc) {
	        var arrayValue = this.value;
	        var other = doc.field(this.field);
	        return other !== null && arrayValue.contains(other);
	    };
	    return InFilter;
	}(FieldFilter));
	/** A Filter that implements the array-contains-any operator. */
	var ArrayContainsAnyFilter = /** @class */ (function (_super) {
	    tslib.__extends(ArrayContainsAnyFilter, _super);
	    function ArrayContainsAnyFilter(field, value) {
	        var _this = _super.call(this, field, Operator.ARRAY_CONTAINS_ANY, value) || this;
	        _this.value = value;
	        return _this;
	    }
	    ArrayContainsAnyFilter.prototype.matches = function (doc) {
	        var _this = this;
	        var other = doc.field(this.field);
	        return (other instanceof ArrayValue &&
	            other.internalValue.some(function (lhsElem) {
	                return _this.value.contains(lhsElem);
	            }));
	    };
	    return ArrayContainsAnyFilter;
	}(FieldFilter));
	/**
	 * The direction of sorting in an order by.
	 */
	var Direction = /** @class */ (function () {
	    function Direction(name) {
	        this.name = name;
	    }
	    Direction.prototype.toString = function () {
	        return this.name;
	    };
	    Direction.ASCENDING = new Direction('asc');
	    Direction.DESCENDING = new Direction('desc');
	    return Direction;
	}());
	/**
	 * Represents a bound of a query.
	 *
	 * The bound is specified with the given components representing a position and
	 * whether it's just before or just after the position (relative to whatever the
	 * query order is).
	 *
	 * The position represents a logical index position for a query. It's a prefix
	 * of values for the (potentially implicit) order by clauses of a query.
	 *
	 * Bound provides a function to determine whether a document comes before or
	 * after a bound. This is influenced by whether the position is just before or
	 * just after the provided values.
	 */
	var Bound = /** @class */ (function () {
	    function Bound(position, before) {
	        this.position = position;
	        this.before = before;
	    }
	    Bound.prototype.canonicalId = function () {
	        // TODO(b/29183165): Make this collision robust.
	        var canonicalId = this.before ? 'b:' : 'a:';
	        for (var _i = 0, _a = this.position; _i < _a.length; _i++) {
	            var component = _a[_i];
	            canonicalId += component.toString();
	        }
	        return canonicalId;
	    };
	    /**
	     * Returns true if a document sorts before a bound using the provided sort
	     * order.
	     */
	    Bound.prototype.sortsBeforeDocument = function (orderBy, doc) {
	        assert(this.position.length <= orderBy.length, "Bound has more components than query's orderBy");
	        var comparison = 0;
	        for (var i = 0; i < this.position.length; i++) {
	            var orderByComponent = orderBy[i];
	            var component = this.position[i];
	            if (orderByComponent.field.isKeyField()) {
	                assert(component instanceof RefValue, 'Bound has a non-key value where the key path is being used.');
	                comparison = DocumentKey.comparator(component.key, doc.key);
	            }
	            else {
	                var docValue = doc.field(orderByComponent.field);
	                assert(docValue !== null, 'Field should exist since document matched the orderBy already.');
	                comparison = component.compareTo(docValue);
	            }
	            if (orderByComponent.dir === Direction.DESCENDING) {
	                comparison = comparison * -1;
	            }
	            if (comparison !== 0) {
	                break;
	            }
	        }
	        return this.before ? comparison <= 0 : comparison < 0;
	    };
	    Bound.prototype.isEqual = function (other) {
	        if (other === null) {
	            return false;
	        }
	        if (this.before !== other.before ||
	            this.position.length !== other.position.length) {
	            return false;
	        }
	        for (var i = 0; i < this.position.length; i++) {
	            var thisPosition = this.position[i];
	            var otherPosition = other.position[i];
	            if (!thisPosition.isEqual(otherPosition)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    return Bound;
	}());
	/**
	 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
	 */
	var OrderBy = /** @class */ (function () {
	    function OrderBy(field, dir) {
	        this.field = field;
	        if (dir === undefined) {
	            dir = Direction.ASCENDING;
	        }
	        this.dir = dir;
	        this.isKeyOrderBy = field.isKeyField();
	    }
	    OrderBy.prototype.compare = function (d1, d2) {
	        var comparison = this.isKeyOrderBy
	            ? Document.compareByKey(d1, d2)
	            : Document.compareByField(this.field, d1, d2);
	        switch (this.dir) {
	            case Direction.ASCENDING:
	                return comparison;
	            case Direction.DESCENDING:
	                return -1 * comparison;
	            default:
	                return fail('Unknown direction: ' + this.dir);
	        }
	    };
	    OrderBy.prototype.canonicalId = function () {
	        // TODO(b/29183165): Make this collision robust.
	        return this.field.canonicalString() + this.dir.toString();
	    };
	    OrderBy.prototype.toString = function () {
	        return this.field.canonicalString() + " (" + this.dir + ")";
	    };
	    OrderBy.prototype.isEqual = function (other) {
	        return this.dir === other.dir && this.field.isEqual(other.field);
	    };
	    return OrderBy;
	}());
	var KEY_ORDERING_ASC = new OrderBy(FieldPath.keyField(), Direction.ASCENDING);
	var KEY_ORDERING_DESC = new OrderBy(FieldPath.keyField(), Direction.DESCENDING);
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// TOOD(b/140938512): Drop SimpleQueryEngine and rename IndexFreeQueryEngine.
	/**
	 * A query engine that takes advantage of the target document mapping in the
	 * QueryCache. The IndexFreeQueryEngine optimizes query execution by only
	 * reading the documents that previously matched a query plus any documents that were
	 * edited after the query was last listened to.
	 *
	 * There are some cases where Index-Free queries are not guaranteed to produce
	 * the same results as full collection scans. In these cases, the
	 * IndexFreeQueryEngine falls back to full query processing. These cases are:
	 *
	 * - Limit queries where a document that matched the query previously no longer
	 *   matches the query.
	 *
	 * - Limit queries where a document edit may cause the document to sort below
	 *   another document that is in the local cache.
	 *
	 * - Queries that have never been CURRENT or free of Limbo documents.
	 */
	var IndexFreeQueryEngine = /** @class */ (function () {
	    function IndexFreeQueryEngine() {
	    }
	    IndexFreeQueryEngine.prototype.setLocalDocumentsView = function (localDocuments) {
	        this.localDocumentsView = localDocuments;
	    };
	    IndexFreeQueryEngine.prototype.getDocumentsMatchingQuery = function (transaction, query, lastLimboFreeSnapshotVersion, remoteKeys) {
	        var _this = this;
	        assert(this.localDocumentsView !== undefined, 'setLocalDocumentsView() not called');
	        // Queries that match all documents don't benefit from using
	        // IndexFreeQueries. It is more efficient to scan all documents in a
	        // collection, rather than to perform individual lookups.
	        if (query.matchesAllDocuments()) {
	            return this.executeFullCollectionScan(transaction, query);
	        }
	        // Queries that have never seen a snapshot without limbo free documents
	        // should also be run as a full collection scan.
	        if (lastLimboFreeSnapshotVersion.isEqual(SnapshotVersion.MIN)) {
	            return this.executeFullCollectionScan(transaction, query);
	        }
	        return this.localDocumentsView.getDocuments(transaction, remoteKeys).next(function (documents) {
	            var previousResults = _this.applyQuery(query, documents);
	            if ((query.hasLimitToFirst() || query.hasLimitToLast()) &&
	                _this.needsRefill(query.limitType, previousResults, remoteKeys, lastLimboFreeSnapshotVersion)) {
	                return _this.executeFullCollectionScan(transaction, query);
	            }
	            if (getLogLevel() <= LogLevel.DEBUG) {
	                debug('IndexFreeQueryEngine', 'Re-using previous result from %s to execute query: %s', lastLimboFreeSnapshotVersion.toString(), query.toString());
	            }
	            // Retrieve all results for documents that were updated since the last
	            // limbo-document free remote snapshot.
	            return _this.localDocumentsView.getDocumentsMatchingQuery(transaction, query, lastLimboFreeSnapshotVersion).next(function (updatedResults) {
	                // We merge `previousResults` into `updateResults`, since
	                // `updateResults` is already a DocumentMap. If a document is
	                // contained in both lists, then its contents are the same.
	                previousResults.forEach(function (doc) {
	                    updatedResults = updatedResults.insert(doc.key, doc);
	                });
	                return updatedResults;
	            });
	        });
	    };
	    /** Applies the query filter and sorting to the provided documents.  */
	    IndexFreeQueryEngine.prototype.applyQuery = function (query, documents) {
	        // Sort the documents and re-apply the query filter since previously
	        // matching documents do not necessarily still match the query.
	        var queryResults = new SortedSet(function (d1, d2) {
	            return query.docComparator(d1, d2);
	        });
	        documents.forEach(function (_, maybeDoc) {
	            if (maybeDoc instanceof Document && query.matches(maybeDoc)) {
	                queryResults = queryResults.add(maybeDoc);
	            }
	        });
	        return queryResults;
	    };
	    /**
	     * Determines if a limit query needs to be refilled from cache, making it
	     * ineligible for index-free execution.
	     *
	     * @param sortedPreviousResults The documents that matched the query when it
	     * was last synchronized, sorted by the query's comparator.
	     * @param remoteKeys The document keys that matched the query at the last
	     * snapshot.
	     * @param limboFreeSnapshotVersion The version of the snapshot when the query
	     * was last synchronized.
	     */
	    IndexFreeQueryEngine.prototype.needsRefill = function (limitType, sortedPreviousResults, remoteKeys, limboFreeSnapshotVersion) {
	        // The query needs to be refilled if a previously matching document no
	        // longer matches.
	        if (remoteKeys.size !== sortedPreviousResults.size) {
	            return true;
	        }
	        // Limit queries are not eligible for index-free query execution if there is
	        // a potential that an older document from cache now sorts before a document
	        // that was previously part of the limit. This, however, can only happen if
	        // the document at the edge of the limit goes out of limit.
	        // If a document that is not the limit boundary sorts differently,
	        // the boundary of the limit itself did not change and documents from cache
	        // will continue to be "rejected" by this boundary. Therefore, we can ignore
	        // any modifications that don't affect the last document.
	        var docAtLimitEdge = limitType === LimitType.First
	            ? sortedPreviousResults.last()
	            : sortedPreviousResults.first();
	        if (!docAtLimitEdge) {
	            // We don't need to refill the query if there were already no documents.
	            return false;
	        }
	        return (docAtLimitEdge.hasPendingWrites ||
	            docAtLimitEdge.version.compareTo(limboFreeSnapshotVersion) > 0);
	    };
	    IndexFreeQueryEngine.prototype.executeFullCollectionScan = function (transaction, query) {
	        if (getLogLevel() <= LogLevel.DEBUG) {
	            debug('IndexFreeQueryEngine', 'Using full collection scan to execute query: %s', query.toString());
	        }
	        return this.localDocumentsView.getDocumentsMatchingQuery(transaction, query, SnapshotVersion.MIN);
	    };
	    return IndexFreeQueryEngine;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MemoryMutationQueue = /** @class */ (function () {
	    function MemoryMutationQueue(indexManager, referenceDelegate) {
	        this.indexManager = indexManager;
	        this.referenceDelegate = referenceDelegate;
	        /**
	         * The set of all mutations that have been sent but not yet been applied to
	         * the backend.
	         */
	        this.mutationQueue = [];
	        /** Next value to use when assigning sequential IDs to each mutation batch. */
	        this.nextBatchId = 1;
	        /** The last received stream token from the server, used to acknowledge which
	         * responses the client has processed. Stream tokens are opaque checkpoint
	         * markers whose only real value is their inclusion in the next request.
	         */
	        this.lastStreamToken = emptyByteString();
	        /** An ordered mapping between documents and the mutations batch IDs. */
	        this.batchesByDocumentKey = new SortedSet(DocReference.compareByKey);
	    }
	    MemoryMutationQueue.prototype.checkEmpty = function (transaction) {
	        return PersistencePromise.resolve(this.mutationQueue.length === 0);
	    };
	    MemoryMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
	        var batchId = batch.batchId;
	        var batchIndex = this.indexOfExistingBatchId(batchId, 'acknowledged');
	        assert(batchIndex === 0, 'Can only acknowledge the first batch in the mutation queue');
	        // Verify that the batch in the queue is the one to be acknowledged.
	        var check = this.mutationQueue[batchIndex];
	        assert(batchId === check.batchId, 'Queue ordering failure: expected batch ' +
	            batchId +
	            ', got batch ' +
	            check.batchId);
	        this.lastStreamToken = streamToken;
	        return PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.getLastStreamToken = function (transaction) {
	        return PersistencePromise.resolve(this.lastStreamToken);
	    };
	    MemoryMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
	        this.lastStreamToken = streamToken;
	        return PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, baseMutations, mutations) {
	        assert(mutations.length !== 0, 'Mutation batches should not be empty');
	        var batchId = this.nextBatchId;
	        this.nextBatchId++;
	        if (this.mutationQueue.length > 0) {
	            var prior = this.mutationQueue[this.mutationQueue.length - 1];
	            assert(prior.batchId < batchId, 'Mutation batchIDs must be monotonically increasing order');
	        }
	        var batch = new MutationBatch(batchId, localWriteTime, baseMutations, mutations);
	        this.mutationQueue.push(batch);
	        // Track references by document key and index collection parents.
	        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
	            var mutation = mutations_1[_i];
	            this.batchesByDocumentKey = this.batchesByDocumentKey.add(new DocReference(mutation.key, batchId));
	            this.indexManager.addToCollectionParentIndex(transaction, mutation.key.path.popLast());
	        }
	        return PersistencePromise.resolve(batch);
	    };
	    MemoryMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
	        return PersistencePromise.resolve(this.findMutationBatch(batchId));
	    };
	    MemoryMutationQueue.prototype.lookupMutationKeys = function (transaction, batchId) {
	        var mutationBatch = this.findMutationBatch(batchId);
	        assert(mutationBatch != null, 'Failed to find local mutation batch.');
	        return PersistencePromise.resolve(mutationBatch.keys());
	    };
	    MemoryMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
	        var nextBatchId = batchId + 1;
	        // The requested batchId may still be out of range so normalize it to the
	        // start of the queue.
	        var rawIndex = this.indexOfBatchId(nextBatchId);
	        var index = rawIndex < 0 ? 0 : rawIndex;
	        return PersistencePromise.resolve(this.mutationQueue.length > index ? this.mutationQueue[index] : null);
	    };
	    MemoryMutationQueue.prototype.getHighestUnacknowledgedBatchId = function () {
	        return PersistencePromise.resolve(this.mutationQueue.length === 0 ? BATCHID_UNKNOWN : this.nextBatchId - 1);
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatches = function (transaction) {
	        return PersistencePromise.resolve(this.mutationQueue.slice());
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
	        var _this = this;
	        var start = new DocReference(documentKey, 0);
	        var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
	        var result = [];
	        this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
	            assert(documentKey.isEqual(ref.key), "Should only iterate over a single key's batches");
	            var batch = _this.findMutationBatch(ref.targetOrBatchId);
	            assert(batch !== null, 'Batches in the index must exist in the main table');
	            result.push(batch);
	        });
	        return PersistencePromise.resolve(result);
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys = function (transaction, documentKeys) {
	        var _this = this;
	        var uniqueBatchIDs = new SortedSet(primitiveComparator);
	        documentKeys.forEach(function (documentKey) {
	            var start = new DocReference(documentKey, 0);
	            var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
	            _this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
	                assert(documentKey.isEqual(ref.key), "For each key, should only iterate over a single key's batches");
	                uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
	            });
	        });
	        return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
	        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
	        // Use the query path as a prefix for testing if a document matches the
	        // query.
	        var prefix = query.path;
	        var immediateChildrenPathLength = prefix.length + 1;
	        // Construct a document reference for actually scanning the index. Unlike
	        // the prefix the document key in this reference must have an even number of
	        // segments. The empty segment can be used a suffix of the query path
	        // because it precedes all other segments in an ordered traversal.
	        var startPath = prefix;
	        if (!DocumentKey.isDocumentKey(startPath)) {
	            startPath = startPath.child('');
	        }
	        var start = new DocReference(new DocumentKey(startPath), 0);
	        // Find unique batchIDs referenced by all documents potentially matching the
	        // query.
	        var uniqueBatchIDs = new SortedSet(primitiveComparator);
	        this.batchesByDocumentKey.forEachWhile(function (ref) {
	            var rowKeyPath = ref.key.path;
	            if (!prefix.isPrefixOf(rowKeyPath)) {
	                return false;
	            }
	            else {
	                // Rows with document keys more than one segment longer than the query
	                // path can't be matches. For example, a query on 'rooms' can't match
	                // the document /rooms/abc/messages/xyx.
	                // TODO(mcg): we'll need a different scanner when we implement
	                // ancestor queries.
	                if (rowKeyPath.length === immediateChildrenPathLength) {
	                    uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
	                }
	                return true;
	            }
	        }, start);
	        return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));
	    };
	    MemoryMutationQueue.prototype.findMutationBatches = function (batchIDs) {
	        var _this = this;
	        // Construct an array of matching batches, sorted by batchID to ensure that
	        // multiple mutations affecting the same document key are applied in order.
	        var result = [];
	        batchIDs.forEach(function (batchId) {
	            var batch = _this.findMutationBatch(batchId);
	            if (batch !== null) {
	                result.push(batch);
	            }
	        });
	        return result;
	    };
	    MemoryMutationQueue.prototype.removeMutationBatch = function (transaction, batch) {
	        var _this = this;
	        // Find the position of the first batch for removal. This need not be the
	        // first entry in the queue.
	        var batchIndex = this.indexOfExistingBatchId(batch.batchId, 'removed');
	        assert(batchIndex === 0, 'Can only remove the first entry of the mutation queue');
	        this.mutationQueue.shift();
	        var references = this.batchesByDocumentKey;
	        return PersistencePromise.forEach(batch.mutations, function (mutation) {
	            var ref = new DocReference(mutation.key, batch.batchId);
	            references = references.delete(ref);
	            return _this.referenceDelegate.removeMutationReference(transaction, mutation.key);
	        }).next(function () {
	            _this.batchesByDocumentKey = references;
	        });
	    };
	    MemoryMutationQueue.prototype.removeCachedMutationKeys = function (batchId) {
	        // No-op since the memory mutation queue does not maintain a separate cache.
	    };
	    MemoryMutationQueue.prototype.containsKey = function (txn, key) {
	        var ref = new DocReference(key, 0);
	        var firstRef = this.batchesByDocumentKey.firstAfterOrEqual(ref);
	        return PersistencePromise.resolve(key.isEqual(firstRef && firstRef.key));
	    };
	    MemoryMutationQueue.prototype.performConsistencyCheck = function (txn) {
	        if (this.mutationQueue.length === 0) {
	            assert(this.batchesByDocumentKey.isEmpty(), 'Document leak -- detected dangling mutation references when queue is empty.');
	        }
	        return PersistencePromise.resolve();
	    };
	    /**
	     * Finds the index of the given batchId in the mutation queue and asserts that
	     * the resulting index is within the bounds of the queue.
	     *
	     * @param batchId The batchId to search for
	     * @param action A description of what the caller is doing, phrased in passive
	     * form (e.g. "acknowledged" in a routine that acknowledges batches).
	     */
	    MemoryMutationQueue.prototype.indexOfExistingBatchId = function (batchId, action) {
	        var index = this.indexOfBatchId(batchId);
	        assert(index >= 0 && index < this.mutationQueue.length, 'Batches must exist to be ' + action);
	        return index;
	    };
	    /**
	     * Finds the index of the given batchId in the mutation queue. This operation
	     * is O(1).
	     *
	     * @return The computed index of the batch with the given batchId, based on
	     * the state of the queue. Note this index can be negative if the requested
	     * batchId has already been remvoed from the queue or past the end of the
	     * queue if the batchId is larger than the last added batch.
	     */
	    MemoryMutationQueue.prototype.indexOfBatchId = function (batchId) {
	        if (this.mutationQueue.length === 0) {
	            // As an index this is past the end of the queue
	            return 0;
	        }
	        // Examine the front of the queue to figure out the difference between the
	        // batchId and indexes in the array. Note that since the queue is ordered
	        // by batchId, if the first batch has a larger batchId then the requested
	        // batchId doesn't exist in the queue.
	        var firstBatchId = this.mutationQueue[0].batchId;
	        return batchId - firstBatchId;
	    };
	    /**
	     * A version of lookupMutationBatch that doesn't return a promise, this makes
	     * other functions that uses this code easier to read and more efficent.
	     */
	    MemoryMutationQueue.prototype.findMutationBatch = function (batchId) {
	        var index = this.indexOfBatchId(batchId);
	        if (index < 0 || index >= this.mutationQueue.length) {
	            return null;
	        }
	        var batch = this.mutationQueue[index];
	        assert(batch.batchId === batchId, 'If found batch must match');
	        return batch;
	    };
	    return MemoryMutationQueue;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function documentEntryMap() {
	    return new SortedMap(DocumentKey.comparator);
	}
	var MemoryRemoteDocumentCache = /** @class */ (function () {
	    /**
	     * @param sizer Used to assess the size of a document. For eager GC, this is expected to just
	     * return 0 to avoid unnecessarily doing the work of calculating the size.
	     */
	    function MemoryRemoteDocumentCache(indexManager, sizer) {
	        this.indexManager = indexManager;
	        this.sizer = sizer;
	        /** Underlying cache of documents and their read times. */
	        this.docs = documentEntryMap();
	        /** Size of all cached documents. */
	        this.size = 0;
	    }
	    /**
	     * Adds the supplied entry to the cache and updates the cache size as appropriate.
	     *
	     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
	     * returned by `newChangeBuffer()`.
	     */
	    MemoryRemoteDocumentCache.prototype.addEntry = function (transaction, doc, readTime) {
	        assert(!readTime.isEqual(SnapshotVersion.MIN), 'Cannot add a document with a read time of zero');
	        var key = doc.key;
	        var entry = this.docs.get(key);
	        var previousSize = entry ? entry.size : 0;
	        var currentSize = this.sizer(doc);
	        this.docs = this.docs.insert(key, {
	            maybeDocument: doc,
	            size: currentSize,
	            readTime: readTime
	        });
	        this.size += currentSize - previousSize;
	        return this.indexManager.addToCollectionParentIndex(transaction, key.path.popLast());
	    };
	    /**
	     * Removes the specified entry from the cache and updates the cache size as appropriate.
	     *
	     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
	     * returned by `newChangeBuffer()`.
	     */
	    MemoryRemoteDocumentCache.prototype.removeEntry = function (documentKey) {
	        var entry = this.docs.get(documentKey);
	        if (entry) {
	            this.docs = this.docs.remove(documentKey);
	            this.size -= entry.size;
	        }
	    };
	    MemoryRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
	        var entry = this.docs.get(documentKey);
	        return PersistencePromise.resolve(entry ? entry.maybeDocument : null);
	    };
	    MemoryRemoteDocumentCache.prototype.getEntries = function (transaction, documentKeys) {
	        var _this = this;
	        var results = nullableMaybeDocumentMap();
	        documentKeys.forEach(function (documentKey) {
	            var entry = _this.docs.get(documentKey);
	            results = results.insert(documentKey, entry ? entry.maybeDocument : null);
	        });
	        return PersistencePromise.resolve(results);
	    };
	    MemoryRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query, sinceReadTime) {
	        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
	        var results = documentMap();
	        // Documents are ordered by key, so we can use a prefix scan to narrow down
	        // the documents we need to match the query against.
	        var prefix = new DocumentKey(query.path.child(''));
	        var iterator = this.docs.getIteratorFrom(prefix);
	        while (iterator.hasNext()) {
	            var _a = iterator.getNext(), key = _a.key, _b = _a.value, maybeDocument = _b.maybeDocument, readTime = _b.readTime;
	            if (!query.path.isPrefixOf(key.path)) {
	                break;
	            }
	            if (readTime.compareTo(sinceReadTime) <= 0) {
	                continue;
	            }
	            if (maybeDocument instanceof Document && query.matches(maybeDocument)) {
	                results = results.insert(maybeDocument.key, maybeDocument);
	            }
	        }
	        return PersistencePromise.resolve(results);
	    };
	    MemoryRemoteDocumentCache.prototype.forEachDocumentKey = function (transaction, f) {
	        return PersistencePromise.forEach(this.docs, function (key) { return f(key); });
	    };
	    MemoryRemoteDocumentCache.prototype.getNewDocumentChanges = function (transaction, sinceReadTime) {
	        throw new Error('getNewDocumentChanges() is not supported with MemoryPersistence');
	    };
	    MemoryRemoteDocumentCache.prototype.getLastReadTime = function (transaction) {
	        return PersistencePromise.resolve(SnapshotVersion.MIN);
	    };
	    MemoryRemoteDocumentCache.prototype.newChangeBuffer = function (options) {
	        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
	        // a separate changelog and does not need special handling for removals.
	        return new MemoryRemoteDocumentCache.RemoteDocumentChangeBuffer(this);
	    };
	    MemoryRemoteDocumentCache.prototype.getSize = function (txn) {
	        return PersistencePromise.resolve(this.size);
	    };
	    /**
	     * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
	     */
	    MemoryRemoteDocumentCache.RemoteDocumentChangeBuffer = /** @class */ (function (_super) {
	        tslib.__extends(class_1, _super);
	        function class_1(documentCache) {
	            var _this = _super.call(this) || this;
	            _this.documentCache = documentCache;
	            return _this;
	        }
	        class_1.prototype.applyChanges = function (transaction) {
	            var _this = this;
	            var promises = [];
	            this.changes.forEach(function (key, doc) {
	                if (doc) {
	                    promises.push(_this.documentCache.addEntry(transaction, doc, _this.readTime));
	                }
	                else {
	                    _this.documentCache.removeEntry(key);
	                }
	            });
	            return PersistencePromise.waitFor(promises);
	        };
	        class_1.prototype.getFromCache = function (transaction, documentKey) {
	            return this.documentCache.getEntry(transaction, documentKey);
	        };
	        class_1.prototype.getAllFromCache = function (transaction, documentKeys) {
	            return this.documentCache.getEntries(transaction, documentKeys);
	        };
	        return class_1;
	    }(RemoteDocumentChangeBuffer));
	    return MemoryRemoteDocumentCache;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MemoryTargetCache = /** @class */ (function () {
	    function MemoryTargetCache(persistence) {
	        this.persistence = persistence;
	        /**
	         * Maps a target to the data about that target
	         */
	        this.targets = new ObjectMap(function (t) { return t.canonicalId(); });
	        /** The last received snapshot version. */
	        this.lastRemoteSnapshotVersion = SnapshotVersion.MIN;
	        /** The highest numbered target ID encountered. */
	        this.highestTargetId = 0;
	        /** The highest sequence number encountered. */
	        this.highestSequenceNumber = 0;
	        /**
	         * A ordered bidirectional mapping between documents and the remote target
	         * IDs.
	         */
	        this.references = new ReferenceSet();
	        this.targetCount = 0;
	        this.targetIdGenerator = TargetIdGenerator.forTargetCache();
	    }
	    MemoryTargetCache.prototype.forEachTarget = function (txn, f) {
	        this.targets.forEach(function (_, targetData) { return f(targetData); });
	        return PersistencePromise.resolve();
	    };
	    MemoryTargetCache.prototype.getLastRemoteSnapshotVersion = function (transaction) {
	        return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
	    };
	    MemoryTargetCache.prototype.getHighestSequenceNumber = function (transaction) {
	        return PersistencePromise.resolve(this.highestSequenceNumber);
	    };
	    MemoryTargetCache.prototype.allocateTargetId = function (transaction) {
	        var nextTargetId = this.targetIdGenerator.after(this.highestTargetId);
	        this.highestTargetId = nextTargetId;
	        return PersistencePromise.resolve(nextTargetId);
	    };
	    MemoryTargetCache.prototype.setTargetsMetadata = function (transaction, highestListenSequenceNumber, lastRemoteSnapshotVersion) {
	        if (lastRemoteSnapshotVersion) {
	            this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
	        }
	        if (highestListenSequenceNumber > this.highestSequenceNumber) {
	            this.highestSequenceNumber = highestListenSequenceNumber;
	        }
	        return PersistencePromise.resolve();
	    };
	    MemoryTargetCache.prototype.saveTargetData = function (targetData) {
	        this.targets.set(targetData.target, targetData);
	        var targetId = targetData.targetId;
	        if (targetId > this.highestTargetId) {
	            this.highestTargetId = targetId;
	        }
	        if (targetData.sequenceNumber > this.highestSequenceNumber) {
	            this.highestSequenceNumber = targetData.sequenceNumber;
	        }
	    };
	    MemoryTargetCache.prototype.addTargetData = function (transaction, targetData) {
	        assert(!this.targets.has(targetData.target), 'Adding a target that already exists');
	        this.saveTargetData(targetData);
	        this.targetCount += 1;
	        return PersistencePromise.resolve();
	    };
	    MemoryTargetCache.prototype.updateTargetData = function (transaction, targetData) {
	        assert(this.targets.has(targetData.target), 'Updating a non-existent target');
	        this.saveTargetData(targetData);
	        return PersistencePromise.resolve();
	    };
	    MemoryTargetCache.prototype.removeTargetData = function (transaction, targetData) {
	        assert(this.targetCount > 0, 'Removing a target from an empty cache');
	        assert(this.targets.has(targetData.target), 'Removing a non-existent target from the cache');
	        this.targets.delete(targetData.target);
	        this.references.removeReferencesForId(targetData.targetId);
	        this.targetCount -= 1;
	        return PersistencePromise.resolve();
	    };
	    MemoryTargetCache.prototype.removeTargets = function (transaction, upperBound, activeTargetIds) {
	        var _this = this;
	        var count = 0;
	        var removals = [];
	        this.targets.forEach(function (key, targetData) {
	            if (targetData.sequenceNumber <= upperBound &&
	                activeTargetIds.get(targetData.targetId) === null) {
	                _this.targets.delete(key);
	                removals.push(_this.removeMatchingKeysForTargetId(transaction, targetData.targetId));
	                count++;
	            }
	        });
	        return PersistencePromise.waitFor(removals).next(function () { return count; });
	    };
	    MemoryTargetCache.prototype.getTargetCount = function (transaction) {
	        return PersistencePromise.resolve(this.targetCount);
	    };
	    MemoryTargetCache.prototype.getTargetData = function (transaction, target) {
	        var targetData = this.targets.get(target) || null;
	        return PersistencePromise.resolve(targetData);
	    };
	    MemoryTargetCache.prototype.getTargetDataForTarget = function (transaction, targetId) {
	        // This method is only needed for multi-tab and we can't implement it
	        // efficiently without additional data structures.
	        return fail('Not yet implemented.');
	    };
	    MemoryTargetCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
	        this.references.addReferences(keys, targetId);
	        var referenceDelegate = this.persistence.referenceDelegate;
	        var promises = [];
	        if (referenceDelegate) {
	            keys.forEach(function (key) {
	                promises.push(referenceDelegate.addReference(txn, key));
	            });
	        }
	        return PersistencePromise.waitFor(promises);
	    };
	    MemoryTargetCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
	        this.references.removeReferences(keys, targetId);
	        var referenceDelegate = this.persistence.referenceDelegate;
	        var promises = [];
	        if (referenceDelegate) {
	            keys.forEach(function (key) {
	                promises.push(referenceDelegate.removeReference(txn, key));
	            });
	        }
	        return PersistencePromise.waitFor(promises);
	    };
	    MemoryTargetCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
	        this.references.removeReferencesForId(targetId);
	        return PersistencePromise.resolve();
	    };
	    MemoryTargetCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
	        var matchingKeys = this.references.referencesForId(targetId);
	        return PersistencePromise.resolve(matchingKeys);
	    };
	    MemoryTargetCache.prototype.containsKey = function (txn, key) {
	        return PersistencePromise.resolve(this.references.containsKey(key));
	    };
	    return MemoryTargetCache;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$3 = 'MemoryPersistence';
	/**
	 * A memory-backed instance of Persistence. Data is stored only in RAM and
	 * not persisted across sessions.
	 */
	var MemoryPersistence = /** @class */ (function () {
	    /**
	     * The constructor accepts a factory for creating a reference delegate. This
	     * allows both the delegate and this instance to have strong references to
	     * each other without having nullable fields that would then need to be
	     * checked or asserted on every access.
	     */
	    function MemoryPersistence(clientId, referenceDelegateFactory) {
	        var _this = this;
	        this.clientId = clientId;
	        this.mutationQueues = {};
	        this.listenSequence = new ListenSequence(0);
	        this._started = false;
	        this._started = true;
	        this.referenceDelegate = referenceDelegateFactory(this);
	        this.targetCache = new MemoryTargetCache(this);
	        var sizer = function (doc) {
	            return _this.referenceDelegate.documentSize(doc);
	        };
	        this.indexManager = new MemoryIndexManager();
	        this.remoteDocumentCache = new MemoryRemoteDocumentCache(this.indexManager, sizer);
	    }
	    MemoryPersistence.createLruPersistence = function (clientId, params) {
	        var factory = function (p) {
	            return new MemoryLruDelegate(p, params);
	        };
	        return new MemoryPersistence(clientId, factory);
	    };
	    MemoryPersistence.createEagerPersistence = function (clientId) {
	        var factory = function (p) {
	            return new MemoryEagerDelegate(p);
	        };
	        return new MemoryPersistence(clientId, factory);
	    };
	    MemoryPersistence.prototype.shutdown = function () {
	        // No durable state to ensure is closed on shutdown.
	        this._started = false;
	        return Promise.resolve();
	    };
	    Object.defineProperty(MemoryPersistence.prototype, "started", {
	        get: function () {
	            return this._started;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MemoryPersistence.prototype.getActiveClients = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                return [2 /*return*/, [this.clientId]];
	            });
	        });
	    };
	    MemoryPersistence.prototype.setPrimaryStateListener = function (primaryStateListener) {
	        // All clients using memory persistence act as primary.
	        return primaryStateListener(true);
	    };
	    MemoryPersistence.prototype.setDatabaseDeletedListener = function () {
	        // No op.
	    };
	    MemoryPersistence.prototype.setNetworkEnabled = function (networkEnabled) {
	        // No op.
	    };
	    MemoryPersistence.prototype.getIndexManager = function () {
	        return this.indexManager;
	    };
	    MemoryPersistence.prototype.getMutationQueue = function (user) {
	        var queue = this.mutationQueues[user.toKey()];
	        if (!queue) {
	            queue = new MemoryMutationQueue(this.indexManager, this.referenceDelegate);
	            this.mutationQueues[user.toKey()] = queue;
	        }
	        return queue;
	    };
	    MemoryPersistence.prototype.getTargetCache = function () {
	        return this.targetCache;
	    };
	    MemoryPersistence.prototype.getRemoteDocumentCache = function () {
	        return this.remoteDocumentCache;
	    };
	    MemoryPersistence.prototype.runTransaction = function (action, mode, transactionOperation) {
	        var _this = this;
	        debug(LOG_TAG$3, 'Starting transaction:', action);
	        var txn = new MemoryTransaction(this.listenSequence.next());
	        this.referenceDelegate.onTransactionStarted();
	        return transactionOperation(txn)
	            .next(function (result) {
	            return _this.referenceDelegate
	                .onTransactionCommitted(txn)
	                .next(function () { return result; });
	        })
	            .toPromise()
	            .then(function (result) {
	            txn.raiseOnCommittedEvent();
	            return result;
	        });
	    };
	    MemoryPersistence.prototype.mutationQueuesContainKey = function (transaction, key) {
	        return PersistencePromise.or(values(this.mutationQueues)
	            .map(function (queue) { return function () { return queue.containsKey(transaction, key); }; }));
	    };
	    return MemoryPersistence;
	}());
	/**
	 * Memory persistence is not actually transactional, but future implementations
	 * may have transaction-scoped state.
	 */
	var MemoryTransaction = /** @class */ (function (_super) {
	    tslib.__extends(MemoryTransaction, _super);
	    function MemoryTransaction(currentSequenceNumber) {
	        var _this = _super.call(this) || this;
	        _this.currentSequenceNumber = currentSequenceNumber;
	        return _this;
	    }
	    return MemoryTransaction;
	}(PersistenceTransaction));
	var MemoryEagerDelegate = /** @class */ (function () {
	    function MemoryEagerDelegate(persistence) {
	        this.persistence = persistence;
	        this.inMemoryPins = null;
	        this._orphanedDocuments = null;
	    }
	    Object.defineProperty(MemoryEagerDelegate.prototype, "orphanedDocuments", {
	        get: function () {
	            if (!this._orphanedDocuments) {
	                throw fail('orphanedDocuments is only valid during a transaction.');
	            }
	            else {
	                return this._orphanedDocuments;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MemoryEagerDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
	        this.inMemoryPins = inMemoryPins;
	    };
	    MemoryEagerDelegate.prototype.addReference = function (txn, key) {
	        this.orphanedDocuments.delete(key);
	        return PersistencePromise.resolve();
	    };
	    MemoryEagerDelegate.prototype.removeReference = function (txn, key) {
	        this.orphanedDocuments.add(key);
	        return PersistencePromise.resolve();
	    };
	    MemoryEagerDelegate.prototype.removeMutationReference = function (txn, key) {
	        this.orphanedDocuments.add(key);
	        return PersistencePromise.resolve();
	    };
	    MemoryEagerDelegate.prototype.removeTarget = function (txn, targetData) {
	        var _this = this;
	        var cache = this.persistence.getTargetCache();
	        return cache
	            .getMatchingKeysForTargetId(txn, targetData.targetId)
	            .next(function (keys) {
	            keys.forEach(function (key) { return _this.orphanedDocuments.add(key); });
	        })
	            .next(function () { return cache.removeTargetData(txn, targetData); });
	    };
	    MemoryEagerDelegate.prototype.onTransactionStarted = function () {
	        this._orphanedDocuments = new Set();
	    };
	    MemoryEagerDelegate.prototype.onTransactionCommitted = function (txn) {
	        var _this = this;
	        // Remove newly orphaned documents.
	        var cache = this.persistence.getRemoteDocumentCache();
	        var changeBuffer = cache.newChangeBuffer();
	        return PersistencePromise.forEach(this.orphanedDocuments, function (key) {
	            return _this.isReferenced(txn, key).next(function (isReferenced) {
	                if (!isReferenced) {
	                    changeBuffer.removeEntry(key);
	                }
	            });
	        }).next(function () {
	            _this._orphanedDocuments = null;
	            return changeBuffer.apply(txn);
	        });
	    };
	    MemoryEagerDelegate.prototype.updateLimboDocument = function (txn, key) {
	        var _this = this;
	        return this.isReferenced(txn, key).next(function (isReferenced) {
	            if (isReferenced) {
	                _this.orphanedDocuments.delete(key);
	            }
	            else {
	                _this.orphanedDocuments.add(key);
	            }
	        });
	    };
	    MemoryEagerDelegate.prototype.documentSize = function (doc) {
	        // For eager GC, we don't care about the document size, there are no size thresholds.
	        return 0;
	    };
	    MemoryEagerDelegate.prototype.isReferenced = function (txn, key) {
	        var _this = this;
	        return PersistencePromise.or([
	            function () { return _this.persistence.getTargetCache().containsKey(txn, key); },
	            function () { return _this.persistence.mutationQueuesContainKey(txn, key); },
	            function () { return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key)); }
	        ]);
	    };
	    return MemoryEagerDelegate;
	}());
	var MemoryLruDelegate = /** @class */ (function () {
	    function MemoryLruDelegate(persistence, lruParams) {
	        this.persistence = persistence;
	        this.inMemoryPins = null;
	        this.orphanedSequenceNumbers = new ObjectMap(function (k) { return encode(k.path); });
	        this.garbageCollector = new LruGarbageCollector(this, lruParams);
	    }
	    // No-ops, present so memory persistence doesn't have to care which delegate
	    // it has.
	    MemoryLruDelegate.prototype.onTransactionStarted = function () { };
	    MemoryLruDelegate.prototype.onTransactionCommitted = function (txn) {
	        return PersistencePromise.resolve();
	    };
	    MemoryLruDelegate.prototype.forEachTarget = function (txn, f) {
	        return this.persistence.getTargetCache().forEachTarget(txn, f);
	    };
	    MemoryLruDelegate.prototype.getSequenceNumberCount = function (txn) {
	        var docCountPromise = this.orphanedDocumentCount(txn);
	        var targetCountPromise = this.persistence
	            .getTargetCache()
	            .getTargetCount(txn);
	        return targetCountPromise.next(function (targetCount) {
	            return docCountPromise.next(function (docCount) { return targetCount + docCount; });
	        });
	    };
	    MemoryLruDelegate.prototype.orphanedDocumentCount = function (txn) {
	        var orphanedCount = 0;
	        return this.forEachOrphanedDocumentSequenceNumber(txn, function (_) {
	            orphanedCount++;
	        }).next(function () { return orphanedCount; });
	    };
	    MemoryLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber = function (txn, f) {
	        var _this = this;
	        return PersistencePromise.forEach(this.orphanedSequenceNumbers, function (key, sequenceNumber) {
	            // Pass in the exact sequence number as the upper bound so we know it won't be pinned by
	            // being too recent.
	            return _this.isPinned(txn, key, sequenceNumber).next(function (isPinned) {
	                if (!isPinned) {
	                    return f(sequenceNumber);
	                }
	                else {
	                    return PersistencePromise.resolve();
	                }
	            });
	        });
	    };
	    MemoryLruDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
	        this.inMemoryPins = inMemoryPins;
	    };
	    MemoryLruDelegate.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
	        return this.persistence
	            .getTargetCache()
	            .removeTargets(txn, upperBound, activeTargetIds);
	    };
	    MemoryLruDelegate.prototype.removeOrphanedDocuments = function (txn, upperBound) {
	        var _this = this;
	        var count = 0;
	        var cache = this.persistence.getRemoteDocumentCache();
	        var changeBuffer = cache.newChangeBuffer();
	        var p = cache.forEachDocumentKey(txn, function (key) {
	            return _this.isPinned(txn, key, upperBound).next(function (isPinned) {
	                if (!isPinned) {
	                    count++;
	                    changeBuffer.removeEntry(key);
	                }
	            });
	        });
	        return p.next(function () { return changeBuffer.apply(txn); }).next(function () { return count; });
	    };
	    MemoryLruDelegate.prototype.removeMutationReference = function (txn, key) {
	        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
	        return PersistencePromise.resolve();
	    };
	    MemoryLruDelegate.prototype.removeTarget = function (txn, targetData) {
	        var updated = targetData.withSequenceNumber(txn.currentSequenceNumber);
	        return this.persistence.getTargetCache().updateTargetData(txn, updated);
	    };
	    MemoryLruDelegate.prototype.addReference = function (txn, key) {
	        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
	        return PersistencePromise.resolve();
	    };
	    MemoryLruDelegate.prototype.removeReference = function (txn, key) {
	        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
	        return PersistencePromise.resolve();
	    };
	    MemoryLruDelegate.prototype.updateLimboDocument = function (txn, key) {
	        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
	        return PersistencePromise.resolve();
	    };
	    MemoryLruDelegate.prototype.documentSize = function (maybeDoc) {
	        var documentSize = maybeDoc.key.toString().length;
	        if (maybeDoc instanceof Document) {
	            documentSize += maybeDoc.data().approximateByteSize();
	        }
	        return documentSize;
	    };
	    MemoryLruDelegate.prototype.isPinned = function (txn, key, upperBound) {
	        var _this = this;
	        return PersistencePromise.or([
	            function () { return _this.persistence.mutationQueuesContainKey(txn, key); },
	            function () { return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key)); },
	            function () { return _this.persistence.getTargetCache().containsKey(txn, key); },
	            function () {
	                var orphanedAt = _this.orphanedSequenceNumbers.get(key);
	                return PersistencePromise.resolve(orphanedAt !== undefined && orphanedAt > upperBound);
	            }
	        ]);
	    };
	    MemoryLruDelegate.prototype.getCacheSize = function (txn) {
	        return this.persistence.getRemoteDocumentCache().getSize(txn);
	    };
	    return MemoryLruDelegate;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$4 = 'ExponentialBackoff';
	/**
	 * Initial backoff time in milliseconds after an error.
	 * Set to 1s according to https://cloud.google.com/apis/design/errors.
	 */
	var DEFAULT_BACKOFF_INITIAL_DELAY_MS = 1000;
	var DEFAULT_BACKOFF_FACTOR = 1.5;
	/** Maximum backoff time in milliseconds */
	var DEFAULT_BACKOFF_MAX_DELAY_MS = 60 * 1000;
	/**
	 * A helper for running delayed tasks following an exponential backoff curve
	 * between attempts.
	 *
	 * Each delay is made up of a "base" delay which follows the exponential
	 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
	 * base delay. This prevents clients from accidentally synchronizing their
	 * delays causing spikes of load to the backend.
	 */
	var ExponentialBackoff = /** @class */ (function () {
	    function ExponentialBackoff(
	    /**
	     * The AsyncQueue to run backoff operations on.
	     */
	    queue, 
	    /**
	     * The ID to use when scheduling backoff operations on the AsyncQueue.
	     */
	    timerId, 
	    /**
	     * The initial delay (used as the base delay on the first retry attempt).
	     * Note that jitter will still be applied, so the actual delay could be as
	     * little as 0.5*initialDelayMs.
	     */
	    initialDelayMs, 
	    /**
	     * The multiplier to use to determine the extended base delay after each
	     * attempt.
	     */
	    backoffFactor, 
	    /**
	     * The maximum base delay after which no further backoff is performed.
	     * Note that jitter will still be applied, so the actual delay could be as
	     * much as 1.5*maxDelayMs.
	     */
	    maxDelayMs) {
	        if (initialDelayMs === void 0) { initialDelayMs = DEFAULT_BACKOFF_INITIAL_DELAY_MS; }
	        if (backoffFactor === void 0) { backoffFactor = DEFAULT_BACKOFF_FACTOR; }
	        if (maxDelayMs === void 0) { maxDelayMs = DEFAULT_BACKOFF_MAX_DELAY_MS; }
	        this.queue = queue;
	        this.timerId = timerId;
	        this.initialDelayMs = initialDelayMs;
	        this.backoffFactor = backoffFactor;
	        this.maxDelayMs = maxDelayMs;
	        this.currentBaseMs = 0;
	        this.timerPromise = null;
	        /** The last backoff attempt, as epoch milliseconds. */
	        this.lastAttemptTime = Date.now();
	        this.reset();
	    }
	    /**
	     * Resets the backoff delay.
	     *
	     * The very next backoffAndWait() will have no delay. If it is called again
	     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
	     * subsequent ones will increase according to the backoffFactor.
	     */
	    ExponentialBackoff.prototype.reset = function () {
	        this.currentBaseMs = 0;
	    };
	    /**
	     * Resets the backoff delay to the maximum delay (e.g. for use after a
	     * RESOURCE_EXHAUSTED error).
	     */
	    ExponentialBackoff.prototype.resetToMax = function () {
	        this.currentBaseMs = this.maxDelayMs;
	    };
	    /**
	     * Returns a promise that resolves after currentDelayMs, and increases the
	     * delay for any subsequent attempts. If there was a pending backoff operation
	     * already, it will be canceled.
	     */
	    ExponentialBackoff.prototype.backoffAndRun = function (op) {
	        var _this = this;
	        // Cancel any pending backoff operation.
	        this.cancel();
	        // First schedule using the current base (which may be 0 and should be
	        // honored as such).
	        var desiredDelayWithJitterMs = Math.floor(this.currentBaseMs + this.jitterDelayMs());
	        // Guard against lastAttemptTime being in the future due to a clock change.
	        var delaySoFarMs = Math.max(0, Date.now() - this.lastAttemptTime);
	        // Guard against the backoff delay already being past.
	        var remainingDelayMs = Math.max(0, desiredDelayWithJitterMs - delaySoFarMs);
	        if (this.currentBaseMs > 0) {
	            debug(LOG_TAG$4, "Backing off for " + remainingDelayMs + " ms " +
	                ("(base delay: " + this.currentBaseMs + " ms, ") +
	                ("delay with jitter: " + desiredDelayWithJitterMs + " ms, ") +
	                ("last attempt: " + delaySoFarMs + " ms ago)"));
	        }
	        this.timerPromise = this.queue.enqueueAfterDelay(this.timerId, remainingDelayMs, function () {
	            _this.lastAttemptTime = Date.now();
	            return op();
	        });
	        // Apply backoff factor to determine next delay and ensure it is within
	        // bounds.
	        this.currentBaseMs *= this.backoffFactor;
	        if (this.currentBaseMs < this.initialDelayMs) {
	            this.currentBaseMs = this.initialDelayMs;
	        }
	        if (this.currentBaseMs > this.maxDelayMs) {
	            this.currentBaseMs = this.maxDelayMs;
	        }
	    };
	    ExponentialBackoff.prototype.cancel = function () {
	        if (this.timerPromise !== null) {
	            this.timerPromise.cancel();
	            this.timerPromise = null;
	        }
	    };
	    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
	    ExponentialBackoff.prototype.jitterDelayMs = function () {
	        return (Math.random() - 0.5) * this.currentBaseMs;
	    };
	    return ExponentialBackoff;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$5 = 'PersistentStream';
	/**
	 * PersistentStream can be in one of 5 states (each described in detail below)
	 * based on the following state transition diagram:
	 *
	 *          start() called             auth & connection succeeded
	 * INITIAL ----------------> STARTING -----------------------------> OPEN
	 *                             ^  |                                   |
	 *                             |  |                    error occurred |
	 *                             |  \-----------------------------v-----/
	 *                             |                                |
	 *                    backoff  |                                |
	 *                    elapsed  |              start() called    |
	 *                             \--- BACKOFF <---------------- ERROR
	 *
	 * [any state] --------------------------> INITIAL
	 *               stop() called or
	 *               idle timer expired
	 */
	var PersistentStreamState;
	(function (PersistentStreamState) {
	    /**
	     * The streaming RPC is not yet running and there's no error condition.
	     * Calling start() will start the stream immediately without backoff.
	     * While in this state isStarted() will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Initial"] = 0] = "Initial";
	    /**
	     * The stream is starting, either waiting for an auth token or for the stream
	     * to successfully open. While in this state, isStarted() will return true but
	     * isOpen() will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Starting"] = 1] = "Starting";
	    /**
	     * The streaming RPC is up and running. Requests and responses can flow
	     * freely. Both isStarted() and isOpen() will return true.
	     */
	    PersistentStreamState[PersistentStreamState["Open"] = 2] = "Open";
	    /**
	     * The stream encountered an error. The next start attempt will back off.
	     * While in this state isStarted() will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Error"] = 3] = "Error";
	    /**
	     * An in-between state after an error where the stream is waiting before
	     * re-starting. After waiting is complete, the stream will try to open.
	     * While in this state isStarted() will return true but isOpen() will return
	     * false.
	     */
	    PersistentStreamState[PersistentStreamState["Backoff"] = 4] = "Backoff";
	})(PersistentStreamState || (PersistentStreamState = {}));
	/** The time a stream stays open after it is marked idle. */
	var IDLE_TIMEOUT_MS = 60 * 1000;
	/**
	 * A PersistentStream is an abstract base class that represents a streaming RPC
	 * to the Firestore backend. It's built on top of the connections own support
	 * for streaming RPCs, and adds several critical features for our clients:
	 *
	 *   - Exponential backoff on failure
	 *   - Authentication via CredentialsProvider
	 *   - Dispatching all callbacks into the shared worker queue
	 *   - Closing idle streams after 60 seconds of inactivity
	 *
	 * Subclasses of PersistentStream implement serialization of models to and
	 * from the JSON representation of the protocol buffers for a specific
	 * streaming RPC.
	 *
	 * ## Starting and Stopping
	 *
	 * Streaming RPCs are stateful and need to be start()ed before messages can
	 * be sent and received. The PersistentStream will call the onOpen() function
	 * of the listener once the stream is ready to accept requests.
	 *
	 * Should a start() fail, PersistentStream will call the registered onClose()
	 * listener with a FirestoreError indicating what went wrong.
	 *
	 * A PersistentStream can be started and stopped repeatedly.
	 *
	 * Generic types:
	 *  SendType: The type of the outgoing message of the underlying
	 *    connection stream
	 *  ReceiveType: The type of the incoming message of the underlying
	 *    connection stream
	 *  ListenerType: The type of the listener that will be used for callbacks
	 */
	var PersistentStream = /** @class */ (function () {
	    function PersistentStream(queue, connectionTimerId, idleTimerId, connection, credentialsProvider, listener) {
	        this.queue = queue;
	        this.idleTimerId = idleTimerId;
	        this.connection = connection;
	        this.credentialsProvider = credentialsProvider;
	        this.listener = listener;
	        this.state = PersistentStreamState.Initial;
	        /**
	         * A close count that's incremented every time the stream is closed; used by
	         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
	         * close.
	         */
	        this.closeCount = 0;
	        this.idleTimer = null;
	        this.stream = null;
	        this.backoff = new ExponentialBackoff(queue, connectionTimerId);
	    }
	    /**
	     * Returns true if start() has been called and no error has occurred. True
	     * indicates the stream is open or in the process of opening (which
	     * encompasses respecting backoff, getting auth tokens, and starting the
	     * actual RPC). Use isOpen() to determine if the stream is open and ready for
	     * outbound requests.
	     */
	    PersistentStream.prototype.isStarted = function () {
	        return (this.state === PersistentStreamState.Starting ||
	            this.state === PersistentStreamState.Open ||
	            this.state === PersistentStreamState.Backoff);
	    };
	    /**
	     * Returns true if the underlying RPC is open (the onOpen() listener has been
	     * called) and the stream is ready for outbound requests.
	     */
	    PersistentStream.prototype.isOpen = function () {
	        return this.state === PersistentStreamState.Open;
	    };
	    /**
	     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
	     * not immediately ready for use: onOpen() will be invoked when the RPC is
	     * ready for outbound requests, at which point isOpen() will return true.
	     *
	     * When start returns, isStarted() will return true.
	     */
	    PersistentStream.prototype.start = function () {
	        if (this.state === PersistentStreamState.Error) {
	            this.performBackoff();
	            return;
	        }
	        assert(this.state === PersistentStreamState.Initial, 'Already started');
	        this.auth();
	    };
	    /**
	     * Stops the RPC. This call is idempotent and allowed regardless of the
	     * current isStarted() state.
	     *
	     * When stop returns, isStarted() and isOpen() will both return false.
	     */
	    PersistentStream.prototype.stop = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.isStarted()) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.close(PersistentStreamState.Initial)];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * After an error the stream will usually back off on the next attempt to
	     * start it. If the error warrants an immediate restart of the stream, the
	     * sender can use this to indicate that the receiver should not back off.
	     *
	     * Each error will call the onClose() listener. That function can decide to
	     * inhibit backoff if required.
	     */
	    PersistentStream.prototype.inhibitBackoff = function () {
	        assert(!this.isStarted(), 'Can only inhibit backoff in a stopped state');
	        this.state = PersistentStreamState.Initial;
	        this.backoff.reset();
	    };
	    /**
	     * Marks this stream as idle. If no further actions are performed on the
	     * stream for one minute, the stream will automatically close itself and
	     * notify the stream's onClose() handler with Status.OK. The stream will then
	     * be in a !isStarted() state, requiring the caller to start the stream again
	     * before further use.
	     *
	     * Only streams that are in state 'Open' can be marked idle, as all other
	     * states imply pending network operations.
	     */
	    PersistentStream.prototype.markIdle = function () {
	        var _this = this;
	        // Starts the idle time if we are in state 'Open' and are not yet already
	        // running a timer (in which case the previous idle timeout still applies).
	        if (this.isOpen() && this.idleTimer === null) {
	            this.idleTimer = this.queue.enqueueAfterDelay(this.idleTimerId, IDLE_TIMEOUT_MS, function () { return _this.handleIdleCloseTimer(); });
	        }
	    };
	    /** Sends a message to the underlying stream. */
	    PersistentStream.prototype.sendRequest = function (msg) {
	        this.cancelIdleCheck();
	        this.stream.send(msg);
	    };
	    /** Called by the idle timer when the stream should close due to inactivity. */
	    PersistentStream.prototype.handleIdleCloseTimer = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                if (this.isOpen()) {
	                    // When timing out an idle stream there's no reason to force the stream into backoff when
	                    // it restarts so set the stream state to Initial instead of Error.
	                    return [2 /*return*/, this.close(PersistentStreamState.Initial)];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    /** Marks the stream as active again. */
	    PersistentStream.prototype.cancelIdleCheck = function () {
	        if (this.idleTimer) {
	            this.idleTimer.cancel();
	            this.idleTimer = null;
	        }
	    };
	    /**
	     * Closes the stream and cleans up as necessary:
	     *
	     * * closes the underlying GRPC stream;
	     * * calls the onClose handler with the given 'error';
	     * * sets internal stream state to 'finalState';
	     * * adjusts the backoff timer based on the error
	     *
	     * A new stream can be opened by calling start().
	     *
	     * @param finalState the intended state of the stream after closing.
	     * @param error the error the connection was closed with.
	     */
	    PersistentStream.prototype.close = function (finalState, error$1) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        assert(this.isStarted(), 'Only started streams should be closed.');
	                        assert(finalState === PersistentStreamState.Error || isNullOrUndefined(error$1), "Can't provide an error when not in an error state.");
	                        // Cancel any outstanding timers (they're guaranteed not to execute).
	                        this.cancelIdleCheck();
	                        this.backoff.cancel();
	                        // Invalidates any stream-related callbacks (e.g. from auth or the
	                        // underlying stream), guaranteeing they won't execute.
	                        this.closeCount++;
	                        if (finalState !== PersistentStreamState.Error) {
	                            // If this is an intentional close ensure we don't delay our next connection attempt.
	                            this.backoff.reset();
	                        }
	                        else if (error$1 && error$1.code === Code.RESOURCE_EXHAUSTED) {
	                            // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
	                            error(error$1.toString());
	                            error('Using maximum backoff delay to prevent overloading the backend.');
	                            this.backoff.resetToMax();
	                        }
	                        else if (error$1 && error$1.code === Code.UNAUTHENTICATED) {
	                            // "unauthenticated" error means the token was rejected. Try force refreshing it in case it
	                            // just expired.
	                            this.credentialsProvider.invalidateToken();
	                        }
	                        // Clean up the underlying stream because we are no longer interested in events.
	                        if (this.stream !== null) {
	                            this.tearDown();
	                            this.stream.close();
	                            this.stream = null;
	                        }
	                        // This state must be assigned before calling onClose() to allow the callback to
	                        // inhibit backoff or otherwise manipulate the state in its non-started state.
	                        this.state = finalState;
	                        // Notify the listener that the stream closed.
	                        return [4 /*yield*/, this.listener.onClose(error$1)];
	                    case 1:
	                        // Notify the listener that the stream closed.
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Can be overridden to perform additional cleanup before the stream is closed.
	     * Calling super.tearDown() is not required.
	     */
	    PersistentStream.prototype.tearDown = function () { };
	    PersistentStream.prototype.auth = function () {
	        var _this = this;
	        assert(this.state === PersistentStreamState.Initial, 'Must be in initial state to auth');
	        this.state = PersistentStreamState.Starting;
	        var dispatchIfNotClosed = this.getCloseGuardedDispatcher(this.closeCount);
	        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
	        var closeCount = this.closeCount;
	        this.credentialsProvider.getToken().then(function (token) {
	            // Stream can be stopped while waiting for authentication.
	            // TODO(mikelehen): We really should just use dispatchIfNotClosed
	            // and let this dispatch onto the queue, but that opened a spec test can
	            // of worms that I don't want to deal with in this PR.
	            if (_this.closeCount === closeCount) {
	                // Normally we'd have to schedule the callback on the AsyncQueue.
	                // However, the following calls are safe to be called outside the
	                // AsyncQueue since they don't chain asynchronous calls
	                _this.startStream(token);
	            }
	        }, function (error) {
	            dispatchIfNotClosed(function () {
	                var rpcError = new FirestoreError(Code.UNKNOWN, 'Fetching auth token failed: ' + error.message);
	                return _this.handleStreamClose(rpcError);
	            });
	        });
	    };
	    PersistentStream.prototype.startStream = function (token) {
	        var _this = this;
	        assert(this.state === PersistentStreamState.Starting, 'Trying to start stream in a non-starting state');
	        var dispatchIfNotClosed = this.getCloseGuardedDispatcher(this.closeCount);
	        this.stream = this.startRpc(token);
	        this.stream.onOpen(function () {
	            dispatchIfNotClosed(function () {
	                assert(_this.state === PersistentStreamState.Starting, 'Expected stream to be in state Starting, but was ' + _this.state);
	                _this.state = PersistentStreamState.Open;
	                return _this.listener.onOpen();
	            });
	        });
	        this.stream.onClose(function (error) {
	            dispatchIfNotClosed(function () {
	                return _this.handleStreamClose(error);
	            });
	        });
	        this.stream.onMessage(function (msg) {
	            dispatchIfNotClosed(function () {
	                return _this.onMessage(msg);
	            });
	        });
	    };
	    PersistentStream.prototype.performBackoff = function () {
	        var _this = this;
	        assert(this.state === PersistentStreamState.Error, 'Should only perform backoff when in Error state');
	        this.state = PersistentStreamState.Backoff;
	        this.backoff.backoffAndRun(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                assert(this.state === PersistentStreamState.Backoff, 'Backoff elapsed but state is now: ' + this.state);
	                this.state = PersistentStreamState.Initial;
	                this.start();
	                assert(this.isStarted(), 'PersistentStream should have started');
	                return [2 /*return*/];
	            });
	        }); });
	    };
	    // Visible for tests
	    PersistentStream.prototype.handleStreamClose = function (error) {
	        assert(this.isStarted(), "Can't handle server close on non-started stream");
	        debug(LOG_TAG$5, "close with error: " + error);
	        this.stream = null;
	        // In theory the stream could close cleanly, however, in our current model
	        // we never expect this to happen because if we stop a stream ourselves,
	        // this callback will never be called. To prevent cases where we retry
	        // without a backoff accidentally, we set the stream to error in all cases.
	        return this.close(PersistentStreamState.Error, error);
	    };
	    /**
	     * Returns a "dispatcher" function that dispatches operations onto the
	     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
	     * us to turn auth / stream callbacks into no-ops if the stream is closed /
	     * re-opened, etc.
	     */
	    PersistentStream.prototype.getCloseGuardedDispatcher = function (startCloseCount) {
	        var _this = this;
	        return function (fn) {
	            _this.queue.enqueueAndForget(function () {
	                if (_this.closeCount === startCloseCount) {
	                    return fn();
	                }
	                else {
	                    debug(LOG_TAG$5, 'stream callback skipped by getCloseGuardedDispatcher.');
	                    return Promise.resolve();
	                }
	            });
	        };
	    };
	    return PersistentStream;
	}());
	/**
	 * A PersistentStream that implements the Listen RPC.
	 *
	 * Once the Listen stream has called the onOpen() listener, any number of
	 * listen() and unlisten() calls can be made to control what changes will be
	 * sent from the server for ListenResponses.
	 */
	var PersistentListenStream = /** @class */ (function (_super) {
	    tslib.__extends(PersistentListenStream, _super);
	    function PersistentListenStream(queue, connection, credentials, serializer, listener) {
	        var _this = _super.call(this, queue, TimerId.ListenStreamConnectionBackoff, TimerId.ListenStreamIdle, connection, credentials, listener) || this;
	        _this.serializer = serializer;
	        return _this;
	    }
	    PersistentListenStream.prototype.startRpc = function (token) {
	        return this.connection.openStream('Listen', token);
	    };
	    PersistentListenStream.prototype.onMessage = function (watchChangeProto) {
	        // A successful response means the stream is healthy
	        this.backoff.reset();
	        var watchChange = this.serializer.fromWatchChange(watchChangeProto);
	        var snapshot = this.serializer.versionFromListenResponse(watchChangeProto);
	        return this.listener.onWatchChange(watchChange, snapshot);
	    };
	    /**
	     * Registers interest in the results of the given target. If the target
	     * includes a resumeToken it will be included in the request. Results that
	     * affect the target will be streamed back as WatchChange messages that
	     * reference the targetId.
	     */
	    PersistentListenStream.prototype.watch = function (targetData) {
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        request.addTarget = this.serializer.toTarget(targetData);
	        var labels = this.serializer.toListenRequestLabels(targetData);
	        if (labels) {
	            request.labels = labels;
	        }
	        this.sendRequest(request);
	    };
	    /**
	     * Unregisters interest in the results of the target associated with the
	     * given targetId.
	     */
	    PersistentListenStream.prototype.unwatch = function (targetId) {
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        request.removeTarget = targetId;
	        this.sendRequest(request);
	    };
	    return PersistentListenStream;
	}(PersistentStream));
	/**
	 * A Stream that implements the Write RPC.
	 *
	 * The Write RPC requires the caller to maintain special streamToken
	 * state in between calls, to help the server understand which responses the
	 * client has processed by the time the next request is made. Every response
	 * will contain a streamToken; this value must be passed to the next
	 * request.
	 *
	 * After calling start() on this stream, the next request must be a handshake,
	 * containing whatever streamToken is on hand. Once a response to this
	 * request is received, all pending mutations may be submitted. When
	 * submitting multiple batches of mutations at the same time, it's
	 * okay to use the same streamToken for the calls to writeMutations.
	 *
	 * TODO(b/33271235): Use proto types
	 */
	var PersistentWriteStream = /** @class */ (function (_super) {
	    tslib.__extends(PersistentWriteStream, _super);
	    function PersistentWriteStream(queue, connection, credentials, serializer, listener) {
	        var _this = _super.call(this, queue, TimerId.WriteStreamConnectionBackoff, TimerId.WriteStreamIdle, connection, credentials, listener) || this;
	        _this.serializer = serializer;
	        _this.handshakeComplete_ = false;
	        /**
	         * The last received stream token from the server, used to acknowledge which
	         * responses the client has processed. Stream tokens are opaque checkpoint
	         * markers whose only real value is their inclusion in the next request.
	         *
	         * PersistentWriteStream manages propagating this value from responses to the
	         * next request.
	         */
	        _this.lastStreamToken = emptyByteString();
	        return _this;
	    }
	    Object.defineProperty(PersistentWriteStream.prototype, "handshakeComplete", {
	        /**
	         * Tracks whether or not a handshake has been successfully exchanged and
	         * the stream is ready to accept mutations.
	         */
	        get: function () {
	            return this.handshakeComplete_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Override of PersistentStream.start
	    PersistentWriteStream.prototype.start = function () {
	        this.handshakeComplete_ = false;
	        _super.prototype.start.call(this);
	    };
	    PersistentWriteStream.prototype.tearDown = function () {
	        if (this.handshakeComplete_) {
	            this.writeMutations([]);
	        }
	    };
	    PersistentWriteStream.prototype.startRpc = function (token) {
	        return this.connection.openStream('Write', token);
	    };
	    PersistentWriteStream.prototype.onMessage = function (responseProto) {
	        // Always capture the last stream token.
	        assert(!!responseProto.streamToken, 'Got a write response without a stream token');
	        this.lastStreamToken = responseProto.streamToken;
	        if (!this.handshakeComplete_) {
	            // The first response is always the handshake response
	            assert(!responseProto.writeResults || responseProto.writeResults.length === 0, 'Got mutation results for handshake');
	            this.handshakeComplete_ = true;
	            return this.listener.onHandshakeComplete();
	        }
	        else {
	            // A successful first write response means the stream is healthy,
	            // Note, that we could consider a successful handshake healthy, however,
	            // the write itself might be causing an error we want to back off from.
	            this.backoff.reset();
	            var results = this.serializer.fromWriteResults(responseProto.writeResults, responseProto.commitTime);
	            var commitVersion = this.serializer.fromVersion(responseProto.commitTime);
	            return this.listener.onMutationResult(commitVersion, results);
	        }
	    };
	    /**
	     * Sends an initial streamToken to the server, performing the handshake
	     * required to make the StreamingWrite RPC work. Subsequent
	     * calls should wait until onHandshakeComplete was called.
	     */
	    PersistentWriteStream.prototype.writeHandshake = function () {
	        assert(this.isOpen(), 'Writing handshake requires an opened stream');
	        assert(!this.handshakeComplete_, 'Handshake already completed');
	        // TODO(dimond): Support stream resumption. We intentionally do not set the
	        // stream token on the handshake, ignoring any stream token we might have.
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        this.sendRequest(request);
	    };
	    /** Sends a group of mutations to the Firestore backend to apply. */
	    PersistentWriteStream.prototype.writeMutations = function (mutations) {
	        var _this = this;
	        assert(this.isOpen(), 'Writing mutations requires an opened stream');
	        assert(this.handshakeComplete_, 'Handshake must be complete before writing mutations');
	        assert(this.lastStreamToken.length > 0, 'Trying to write mutation without a token');
	        var request = {
	            // Protos are typed with string, but we support UInt8Array on Node
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            streamToken: this.lastStreamToken,
	            writes: mutations.map(function (mutation) { return _this.serializer.toMutation(mutation); })
	        };
	        this.sendRequest(request);
	    };
	    return PersistentWriteStream;
	}(PersistentStream));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Datastore is a wrapper around the external Google Cloud Datastore grpc API,
	 * which provides an interface that is more convenient for the rest of the
	 * client SDK architecture to consume.
	 */
	var Datastore = /** @class */ (function () {
	    function Datastore(queue, connection, credentials, serializer) {
	        this.queue = queue;
	        this.connection = connection;
	        this.credentials = credentials;
	        this.serializer = serializer;
	    }
	    Datastore.prototype.newPersistentWriteStream = function (listener) {
	        return new PersistentWriteStream(this.queue, this.connection, this.credentials, this.serializer, listener);
	    };
	    Datastore.prototype.newPersistentWatchStream = function (listener) {
	        return new PersistentListenStream(this.queue, this.connection, this.credentials, this.serializer, listener);
	    };
	    Datastore.prototype.commit = function (mutations) {
	        var _this = this;
	        var params = {
	            database: this.serializer.encodedDatabaseId,
	            writes: mutations.map(function (m) { return _this.serializer.toMutation(m); })
	        };
	        return this.invokeRPC('Commit', params).then(function (response) {
	            return _this.serializer.fromWriteResults(response.writeResults, response.commitTime);
	        });
	    };
	    Datastore.prototype.lookup = function (keys) {
	        var _this = this;
	        var params = {
	            database: this.serializer.encodedDatabaseId,
	            documents: keys.map(function (k) { return _this.serializer.toName(k); })
	        };
	        return this.invokeStreamingRPC('BatchGetDocuments', params).then(function (response) {
	            var docs = maybeDocumentMap();
	            response.forEach(function (proto) {
	                var doc = _this.serializer.fromMaybeDocument(proto);
	                docs = docs.insert(doc.key, doc);
	            });
	            var result = [];
	            keys.forEach(function (key) {
	                var doc = docs.get(key);
	                assert(!!doc, 'Missing entity in write response for ' + key);
	                result.push(doc);
	            });
	            return result;
	        });
	    };
	    /** Gets an auth token and invokes the provided RPC. */
	    Datastore.prototype.invokeRPC = function (rpcName, request) {
	        var _this = this;
	        return this.credentials
	            .getToken()
	            .then(function (token) {
	            return _this.connection.invokeRPC(rpcName, request, token);
	        })
	            .catch(function (error) {
	            if (error.code === Code.UNAUTHENTICATED) {
	                _this.credentials.invalidateToken();
	            }
	            throw error;
	        });
	    };
	    /** Gets an auth token and invokes the provided RPC with streamed results. */
	    Datastore.prototype.invokeStreamingRPC = function (rpcName, request) {
	        var _this = this;
	        return this.credentials
	            .getToken()
	            .then(function (token) {
	            return _this.connection.invokeStreamingRPC(rpcName, request, token);
	        })
	            .catch(function (error) {
	            if (error.code === Code.UNAUTHENTICATED) {
	                _this.credentials.invalidateToken();
	            }
	            throw error;
	        });
	    };
	    return Datastore;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Internal transaction object responsible for accumulating the mutations to
	 * perform and the base versions for any documents read.
	 */
	var Transaction = /** @class */ (function () {
	    function Transaction(datastore) {
	        this.datastore = datastore;
	        // The version of each document that was read during this transaction.
	        this.readVersions = documentVersionMap();
	        this.mutations = [];
	        this.committed = false;
	        /**
	         * A deferred usage error that occurred previously in this transaction that
	         * will cause the transaction to fail once it actually commits.
	         */
	        this.lastWriteError = null;
	        /**
	         * Set of documents that have been written in the transaction.
	         *
	         * When there's more than one write to the same key in a transaction, any
	         * writes after the first are handled differently.
	         */
	        this.writtenDocs = new Set();
	    }
	    Transaction.prototype.lookup = function (keys) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var docs;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.ensureCommitNotCalled();
	                        if (this.mutations.length > 0) {
	                            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Firestore transactions require all reads to be executed before all writes.');
	                        }
	                        return [4 /*yield*/, this.datastore.lookup(keys)];
	                    case 1:
	                        docs = _a.sent();
	                        docs.forEach(function (doc) {
	                            if (doc instanceof NoDocument || doc instanceof Document) {
	                                _this.recordVersion(doc);
	                            }
	                            else {
	                                fail('Document in a transaction was a ' + doc.constructor.name);
	                            }
	                        });
	                        return [2 /*return*/, docs];
	                }
	            });
	        });
	    };
	    Transaction.prototype.set = function (key, data) {
	        this.write(data.toMutations(key, this.precondition(key)));
	        this.writtenDocs.add(key);
	    };
	    Transaction.prototype.update = function (key, data) {
	        try {
	            this.write(data.toMutations(key, this.preconditionForUpdate(key)));
	        }
	        catch (e) {
	            this.lastWriteError = e;
	        }
	        this.writtenDocs.add(key);
	    };
	    Transaction.prototype.delete = function (key) {
	        this.write([new DeleteMutation(key, this.precondition(key))]);
	        this.writtenDocs.add(key);
	    };
	    Transaction.prototype.commit = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var unwritten;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.ensureCommitNotCalled();
	                        if (this.lastWriteError) {
	                            throw this.lastWriteError;
	                        }
	                        unwritten = this.readVersions;
	                        // For each mutation, note that the doc was written.
	                        this.mutations.forEach(function (mutation) {
	                            unwritten = unwritten.remove(mutation.key);
	                        });
	                        // For each document that was read but not written to, we want to perform
	                        // a `verify` operation.
	                        unwritten.forEach(function (key, _version) {
	                            _this.mutations.push(new VerifyMutation(key, _this.precondition(key)));
	                        });
	                        return [4 /*yield*/, this.datastore.commit(this.mutations)];
	                    case 1:
	                        _a.sent();
	                        this.committed = true;
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    Transaction.prototype.recordVersion = function (doc) {
	        var docVersion;
	        if (doc instanceof Document) {
	            docVersion = doc.version;
	        }
	        else if (doc instanceof NoDocument) {
	            // For deleted docs, we must use baseVersion 0 when we overwrite them.
	            docVersion = SnapshotVersion.forDeletedDoc();
	        }
	        else {
	            throw fail('Document in a transaction was a ' + doc.constructor.name);
	        }
	        var existingVersion = this.readVersions.get(doc.key);
	        if (existingVersion !== null) {
	            if (!docVersion.isEqual(existingVersion)) {
	                // This transaction will fail no matter what.
	                throw new FirestoreError(Code.ABORTED, 'Document version changed between two reads.');
	            }
	        }
	        else {
	            this.readVersions = this.readVersions.insert(doc.key, docVersion);
	        }
	    };
	    /**
	     * Returns the version of this document when it was read in this transaction,
	     * as a precondition, or no precondition if it was not read.
	     */
	    Transaction.prototype.precondition = function (key) {
	        var version = this.readVersions.get(key);
	        if (!this.writtenDocs.has(key) && version) {
	            return Precondition.updateTime(version);
	        }
	        else {
	            return Precondition.NONE;
	        }
	    };
	    /**
	     * Returns the precondition for a document if the operation is an update.
	     */
	    Transaction.prototype.preconditionForUpdate = function (key) {
	        var version = this.readVersions.get(key);
	        // The first time a document is written, we want to take into account the
	        // read time and existence
	        if (!this.writtenDocs.has(key) && version) {
	            if (version.isEqual(SnapshotVersion.forDeletedDoc())) {
	                // The document doesn't exist, so fail the transaction.
	                // This has to be validated locally because you can't send a
	                // precondition that a document does not exist without changing the
	                // semantics of the backend write to be an insert. This is the reverse
	                // of what we want, since we want to assert that the document doesn't
	                // exist but then send the update and have it fail. Since we can't
	                // express that to the backend, we have to validate locally.
	                // Note: this can change once we can send separate verify writes in the
	                // transaction.
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
	            }
	            // Document exists, base precondition on document update time.
	            return Precondition.updateTime(version);
	        }
	        else {
	            // Document was not read, so we just use the preconditions for a blind
	            // update.
	            return Precondition.exists(true);
	        }
	    };
	    Transaction.prototype.write = function (mutations) {
	        this.ensureCommitNotCalled();
	        this.mutations = this.mutations.concat(mutations);
	    };
	    Transaction.prototype.ensureCommitNotCalled = function () {
	        assert(!this.committed, 'A transaction object cannot be used after its update callback has been invoked.');
	    };
	    return Transaction;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Describes the online state of the Firestore client. Note that this does not
	 * indicate whether or not the remote store is trying to connect or not. This is
	 * primarily used by the View / EventManager code to change their behavior while
	 * offline (e.g. get() calls shouldn't wait for data from the server and
	 * snapshot events should set metadata.isFromCache=true).
	 */
	var OnlineState;
	(function (OnlineState) {
	    /**
	     * The Firestore client is in an unknown online state. This means the client
	     * is either not actively trying to establish a connection or it is currently
	     * trying to establish a connection, but it has not succeeded or failed yet.
	     * Higher-level components should not operate in offline mode.
	     */
	    OnlineState[OnlineState["Unknown"] = 0] = "Unknown";
	    /**
	     * The client is connected and the connections are healthy. This state is
	     * reached after a successful connection and there has been at least one
	     * successful message received from the backends.
	     */
	    OnlineState[OnlineState["Online"] = 1] = "Online";
	    /**
	     * The client is either trying to establish a connection but failing, or it
	     * has been explicitly marked offline via a call to disableNetwork().
	     * Higher-level components should operate in offline mode.
	     */
	    OnlineState[OnlineState["Offline"] = 2] = "Offline";
	})(OnlineState || (OnlineState = {}));
	/** The source of an online state event. */
	var OnlineStateSource;
	(function (OnlineStateSource) {
	    OnlineStateSource[OnlineStateSource["RemoteStore"] = 0] = "RemoteStore";
	    OnlineStateSource[OnlineStateSource["SharedClientState"] = 1] = "SharedClientState";
	})(OnlineStateSource || (OnlineStateSource = {}));
	
	/**
	 * @license
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$6 = 'OnlineStateTracker';
	// To deal with transient failures, we allow multiple stream attempts before
	// giving up and transitioning from OnlineState.Unknown to Offline.
	// TODO(mikelehen): This used to be set to 2 as a mitigation for b/66228394.
	// @jdimond thinks that bug is sufficiently fixed so that we can set this back
	// to 1. If that works okay, we could potentially remove this logic entirely.
	var MAX_WATCH_STREAM_FAILURES = 1;
	// To deal with stream attempts that don't succeed or fail in a timely manner,
	// we have a timeout for OnlineState to reach Online or Offline.
	// If the timeout is reached, we transition to Offline rather than waiting
	// indefinitely.
	var ONLINE_STATE_TIMEOUT_MS = 10 * 1000;
	/**
	 * A component used by the RemoteStore to track the OnlineState (that is,
	 * whether or not the client as a whole should be considered to be online or
	 * offline), implementing the appropriate heuristics.
	 *
	 * In particular, when the client is trying to connect to the backend, we
	 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
	 * a connection to succeed. If we have too many failures or the timeout elapses,
	 * then we set the OnlineState to Offline, and the client will behave as if
	 * it is offline (get()s will return cached data, etc.).
	 */
	var OnlineStateTracker = /** @class */ (function () {
	    function OnlineStateTracker(asyncQueue, onlineStateHandler) {
	        this.asyncQueue = asyncQueue;
	        this.onlineStateHandler = onlineStateHandler;
	        /** The current OnlineState. */
	        this.state = OnlineState.Unknown;
	        /**
	         * A count of consecutive failures to open the stream. If it reaches the
	         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
	         * Offline.
	         */
	        this.watchStreamFailures = 0;
	        /**
	         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
	         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
	         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
	         */
	        this.onlineStateTimer = null;
	        /**
	         * Whether the client should log a warning message if it fails to connect to
	         * the backend (initially true, cleared after a successful stream, or if we've
	         * logged the message already).
	         */
	        this.shouldWarnClientIsOffline = true;
	    }
	    /**
	     * Called by RemoteStore when a watch stream is started (including on each
	     * backoff attempt).
	     *
	     * If this is the first attempt, it sets the OnlineState to Unknown and starts
	     * the onlineStateTimer.
	     */
	    OnlineStateTracker.prototype.handleWatchStreamStart = function () {
	        var _this = this;
	        if (this.watchStreamFailures === 0) {
	            this.setAndBroadcast(OnlineState.Unknown);
	            assert(this.onlineStateTimer === null, "onlineStateTimer shouldn't be started yet");
	            this.onlineStateTimer = this.asyncQueue.enqueueAfterDelay(TimerId.OnlineStateTimeout, ONLINE_STATE_TIMEOUT_MS, function () {
	                _this.onlineStateTimer = null;
	                assert(_this.state === OnlineState.Unknown, 'Timer should be canceled if we transitioned to a different state.');
	                _this.logClientOfflineWarningIfNecessary("Backend didn't respond within " + ONLINE_STATE_TIMEOUT_MS / 1000 + " " +
	                    "seconds.");
	                _this.setAndBroadcast(OnlineState.Offline);
	                // NOTE: handleWatchStreamFailure() will continue to increment
	                // watchStreamFailures even though we are already marked Offline,
	                // but this is non-harmful.
	                return Promise.resolve();
	            });
	        }
	    };
	    /**
	     * Updates our OnlineState as appropriate after the watch stream reports a
	     * failure. The first failure moves us to the 'Unknown' state. We then may
	     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
	     * actually transition to the 'Offline' state.
	     */
	    OnlineStateTracker.prototype.handleWatchStreamFailure = function (error) {
	        if (this.state === OnlineState.Online) {
	            this.setAndBroadcast(OnlineState.Unknown);
	            // To get to OnlineState.Online, set() must have been called which would
	            // have reset our heuristics.
	            assert(this.watchStreamFailures === 0, 'watchStreamFailures must be 0');
	            assert(this.onlineStateTimer === null, 'onlineStateTimer must be null');
	        }
	        else {
	            this.watchStreamFailures++;
	            if (this.watchStreamFailures >= MAX_WATCH_STREAM_FAILURES) {
	                this.clearOnlineStateTimer();
	                this.logClientOfflineWarningIfNecessary("Connection failed " + MAX_WATCH_STREAM_FAILURES + " " +
	                    ("times. Most recent error: " + error.toString()));
	                this.setAndBroadcast(OnlineState.Offline);
	            }
	        }
	    };
	    /**
	     * Explicitly sets the OnlineState to the specified state.
	     *
	     * Note that this resets our timers / failure counters, etc. used by our
	     * Offline heuristics, so must not be used in place of
	     * handleWatchStreamStart() and handleWatchStreamFailure().
	     */
	    OnlineStateTracker.prototype.set = function (newState) {
	        this.clearOnlineStateTimer();
	        this.watchStreamFailures = 0;
	        if (newState === OnlineState.Online) {
	            // We've connected to watch at least once. Don't warn the developer
	            // about being offline going forward.
	            this.shouldWarnClientIsOffline = false;
	        }
	        this.setAndBroadcast(newState);
	    };
	    OnlineStateTracker.prototype.setAndBroadcast = function (newState) {
	        if (newState !== this.state) {
	            this.state = newState;
	            this.onlineStateHandler(newState);
	        }
	    };
	    OnlineStateTracker.prototype.logClientOfflineWarningIfNecessary = function (details) {
	        var message = "Could not reach Cloud Firestore backend. " + details + "\n" +
	            "This typically indicates that your device does not have a healthy " +
	            "Internet connection at the moment. The client will operate in offline " +
	            "mode until it is able to successfully connect to the backend.";
	        if (this.shouldWarnClientIsOffline) {
	            error(message);
	            this.shouldWarnClientIsOffline = false;
	        }
	        else {
	            debug(LOG_TAG$6, message);
	        }
	    };
	    OnlineStateTracker.prototype.clearOnlineStateTimer = function () {
	        if (this.onlineStateTimer !== null) {
	            this.onlineStateTimer.cancel();
	            this.onlineStateTimer = null;
	        }
	    };
	    return OnlineStateTracker;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Error Codes describing the different ways GRPC can fail. These are copied
	 * directly from GRPC's sources here:
	 *
	 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
	 *
	 * Important! The names of these identifiers matter because the string forms
	 * are used for reverse lookups from the webchannel stream. Do NOT change the
	 * names of these identifiers.
	 */
	var RpcCode;
	(function (RpcCode) {
	    RpcCode[RpcCode["OK"] = 0] = "OK";
	    RpcCode[RpcCode["CANCELLED"] = 1] = "CANCELLED";
	    RpcCode[RpcCode["UNKNOWN"] = 2] = "UNKNOWN";
	    RpcCode[RpcCode["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
	    RpcCode[RpcCode["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
	    RpcCode[RpcCode["NOT_FOUND"] = 5] = "NOT_FOUND";
	    RpcCode[RpcCode["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
	    RpcCode[RpcCode["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
	    RpcCode[RpcCode["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
	    RpcCode[RpcCode["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
	    RpcCode[RpcCode["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
	    RpcCode[RpcCode["ABORTED"] = 10] = "ABORTED";
	    RpcCode[RpcCode["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
	    RpcCode[RpcCode["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
	    RpcCode[RpcCode["INTERNAL"] = 13] = "INTERNAL";
	    RpcCode[RpcCode["UNAVAILABLE"] = 14] = "UNAVAILABLE";
	    RpcCode[RpcCode["DATA_LOSS"] = 15] = "DATA_LOSS";
	})(RpcCode || (RpcCode = {}));
	/**
	 * Determines whether an error code represents a permanent error when received
	 * in response to a non-write operation.
	 *
	 * See isPermanentWriteError for classifying write errors.
	 */
	function isPermanentError(code) {
	    switch (code) {
	        case Code.OK:
	            return fail('Treated status OK as error');
	        case Code.CANCELLED:
	        case Code.UNKNOWN:
	        case Code.DEADLINE_EXCEEDED:
	        case Code.RESOURCE_EXHAUSTED:
	        case Code.INTERNAL:
	        case Code.UNAVAILABLE:
	        // Unauthenticated means something went wrong with our token and we need
	        // to retry with new credentials which will happen automatically.
	        case Code.UNAUTHENTICATED:
	            return false;
	        case Code.INVALID_ARGUMENT:
	        case Code.NOT_FOUND:
	        case Code.ALREADY_EXISTS:
	        case Code.PERMISSION_DENIED:
	        case Code.FAILED_PRECONDITION:
	        // Aborted might be retried in some scenarios, but that is dependant on
	        // the context and should handled individually by the calling code.
	        // See https://cloud.google.com/apis/design/errors.
	        case Code.ABORTED:
	        case Code.OUT_OF_RANGE:
	        case Code.UNIMPLEMENTED:
	        case Code.DATA_LOSS:
	            return true;
	        default:
	            return fail('Unknown status code: ' + code);
	    }
	}
	/**
	 * Determines whether an error code represents a permanent error when received
	 * in response to a write operation.
	 *
	 * Write operations must be handled specially because as of b/119437764, ABORTED
	 * errors on the write stream should be retried too (even though ABORTED errors
	 * are not generally retryable).
	 *
	 * Note that during the initial handshake on the write stream an ABORTED error
	 * signals that we should discard our stream token (i.e. it is permanent). This
	 * means a handshake error should be classified with isPermanentError, above.
	 */
	function isPermanentWriteError(code) {
	    return isPermanentError(code) && code !== Code.ABORTED;
	}
	/**
	 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
	 *
	 * @returns The Code equivalent to the given status string or undefined if
	 *     there is no match.
	 */
	function mapCodeFromRpcStatus(status) {
	    // lookup by string
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var code = RpcCode[status];
	    if (code === undefined) {
	        return undefined;
	    }
	    return mapCodeFromRpcCode(code);
	}
	/**
	 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
	 * are not the same as HTTP status codes.
	 *
	 * @returns The Code equivalent to the given GRPC status code. Fails if there
	 *     is no match.
	 */
	function mapCodeFromRpcCode(code) {
	    if (code === undefined) {
	        // This shouldn't normally happen, but in certain error cases (like trying
	        // to send invalid proto messages) we may get an error with no GRPC code.
	        error('GRPC error has no .code');
	        return Code.UNKNOWN;
	    }
	    switch (code) {
	        case RpcCode.OK:
	            return Code.OK;
	        case RpcCode.CANCELLED:
	            return Code.CANCELLED;
	        case RpcCode.UNKNOWN:
	            return Code.UNKNOWN;
	        case RpcCode.DEADLINE_EXCEEDED:
	            return Code.DEADLINE_EXCEEDED;
	        case RpcCode.RESOURCE_EXHAUSTED:
	            return Code.RESOURCE_EXHAUSTED;
	        case RpcCode.INTERNAL:
	            return Code.INTERNAL;
	        case RpcCode.UNAVAILABLE:
	            return Code.UNAVAILABLE;
	        case RpcCode.UNAUTHENTICATED:
	            return Code.UNAUTHENTICATED;
	        case RpcCode.INVALID_ARGUMENT:
	            return Code.INVALID_ARGUMENT;
	        case RpcCode.NOT_FOUND:
	            return Code.NOT_FOUND;
	        case RpcCode.ALREADY_EXISTS:
	            return Code.ALREADY_EXISTS;
	        case RpcCode.PERMISSION_DENIED:
	            return Code.PERMISSION_DENIED;
	        case RpcCode.FAILED_PRECONDITION:
	            return Code.FAILED_PRECONDITION;
	        case RpcCode.ABORTED:
	            return Code.ABORTED;
	        case RpcCode.OUT_OF_RANGE:
	            return Code.OUT_OF_RANGE;
	        case RpcCode.UNIMPLEMENTED:
	            return Code.UNIMPLEMENTED;
	        case RpcCode.DATA_LOSS:
	            return Code.DATA_LOSS;
	        default:
	            return fail('Unknown status code: ' + code);
	    }
	}
	/**
	 * Maps an RPC code from a Code. This is the reverse operation from
	 * mapCodeFromRpcCode and should really only be used in tests.
	 */
	function mapRpcCodeFromCode(code) {
	    if (code === undefined) {
	        return RpcCode.OK;
	    }
	    switch (code) {
	        case Code.OK:
	            return RpcCode.OK;
	        case Code.CANCELLED:
	            return RpcCode.CANCELLED;
	        case Code.UNKNOWN:
	            return RpcCode.UNKNOWN;
	        case Code.DEADLINE_EXCEEDED:
	            return RpcCode.DEADLINE_EXCEEDED;
	        case Code.RESOURCE_EXHAUSTED:
	            return RpcCode.RESOURCE_EXHAUSTED;
	        case Code.INTERNAL:
	            return RpcCode.INTERNAL;
	        case Code.UNAVAILABLE:
	            return RpcCode.UNAVAILABLE;
	        case Code.UNAUTHENTICATED:
	            return RpcCode.UNAUTHENTICATED;
	        case Code.INVALID_ARGUMENT:
	            return RpcCode.INVALID_ARGUMENT;
	        case Code.NOT_FOUND:
	            return RpcCode.NOT_FOUND;
	        case Code.ALREADY_EXISTS:
	            return RpcCode.ALREADY_EXISTS;
	        case Code.PERMISSION_DENIED:
	            return RpcCode.PERMISSION_DENIED;
	        case Code.FAILED_PRECONDITION:
	            return RpcCode.FAILED_PRECONDITION;
	        case Code.ABORTED:
	            return RpcCode.ABORTED;
	        case Code.OUT_OF_RANGE:
	            return RpcCode.OUT_OF_RANGE;
	        case Code.UNIMPLEMENTED:
	            return RpcCode.UNIMPLEMENTED;
	        case Code.DATA_LOSS:
	            return RpcCode.DATA_LOSS;
	        default:
	            return fail('Unknown status code: ' + code);
	    }
	}
	/**
	 * Converts an HTTP response's error status to the equivalent error code.
	 *
	 * @param status An HTTP error response status ("FAILED_PRECONDITION",
	 * "UNKNOWN", etc.)
	 * @returns The equivalent Code. Non-matching responses are mapped to
	 *     Code.UNKNOWN.
	 */
	function mapCodeFromHttpResponseErrorStatus(status) {
	    var serverError = status.toLowerCase().replace('_', '-');
	    return Object.values(Code).indexOf(serverError) >= 0
	        ? serverError
	        : Code.UNKNOWN;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * DocumentSet is an immutable (copy-on-write) collection that holds documents
	 * in order specified by the provided comparator. We always add a document key
	 * comparator on top of what is provided to guarantee document equality based on
	 * the key.
	 */
	var DocumentSet = /** @class */ (function () {
	    /** The default ordering is by key if the comparator is omitted */
	    function DocumentSet(comp) {
	        // We are adding document key comparator to the end as it's the only
	        // guaranteed unique property of a document.
	        if (comp) {
	            this.comparator = function (d1, d2) {
	                return comp(d1, d2) || DocumentKey.comparator(d1.key, d2.key);
	            };
	        }
	        else {
	            this.comparator = function (d1, d2) {
	                return DocumentKey.comparator(d1.key, d2.key);
	            };
	        }
	        this.keyedMap = documentMap();
	        this.sortedSet = new SortedMap(this.comparator);
	    }
	    /**
	     * Returns an empty copy of the existing DocumentSet, using the same
	     * comparator.
	     */
	    DocumentSet.emptySet = function (oldSet) {
	        return new DocumentSet(oldSet.comparator);
	    };
	    DocumentSet.prototype.has = function (key) {
	        return this.keyedMap.get(key) != null;
	    };
	    DocumentSet.prototype.get = function (key) {
	        return this.keyedMap.get(key);
	    };
	    DocumentSet.prototype.first = function () {
	        return this.sortedSet.minKey();
	    };
	    DocumentSet.prototype.last = function () {
	        return this.sortedSet.maxKey();
	    };
	    DocumentSet.prototype.isEmpty = function () {
	        return this.sortedSet.isEmpty();
	    };
	    /**
	     * Returns the index of the provided key in the document set, or -1 if the
	     * document key is not present in the set;
	     */
	    DocumentSet.prototype.indexOf = function (key) {
	        var doc = this.keyedMap.get(key);
	        return doc ? this.sortedSet.indexOf(doc) : -1;
	    };
	    Object.defineProperty(DocumentSet.prototype, "size", {
	        get: function () {
	            return this.sortedSet.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Iterates documents in order defined by "comparator" */
	    DocumentSet.prototype.forEach = function (cb) {
	        this.sortedSet.inorderTraversal(function (k, v) {
	            cb(k);
	            return false;
	        });
	    };
	    /** Inserts or updates a document with the same key */
	    DocumentSet.prototype.add = function (doc) {
	        // First remove the element if we have it.
	        var set = this.delete(doc.key);
	        return set.copy(set.keyedMap.insert(doc.key, doc), set.sortedSet.insert(doc, null));
	    };
	    /** Deletes a document with a given key */
	    DocumentSet.prototype.delete = function (key) {
	        var doc = this.get(key);
	        if (!doc) {
	            return this;
	        }
	        return this.copy(this.keyedMap.remove(key), this.sortedSet.remove(doc));
	    };
	    DocumentSet.prototype.isEqual = function (other) {
	        if (!(other instanceof DocumentSet)) {
	            return false;
	        }
	        if (this.size !== other.size) {
	            return false;
	        }
	        var thisIt = this.sortedSet.getIterator();
	        var otherIt = other.sortedSet.getIterator();
	        while (thisIt.hasNext()) {
	            var thisDoc = thisIt.getNext().key;
	            var otherDoc = otherIt.getNext().key;
	            if (!thisDoc.isEqual(otherDoc)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    DocumentSet.prototype.toString = function () {
	        var docStrings = [];
	        this.forEach(function (doc) {
	            docStrings.push(doc.toString());
	        });
	        if (docStrings.length === 0) {
	            return 'DocumentSet ()';
	        }
	        else {
	            return 'DocumentSet (\n  ' + docStrings.join('  \n') + '\n)';
	        }
	    };
	    DocumentSet.prototype.copy = function (keyedMap, sortedSet) {
	        var newSet = new DocumentSet();
	        newSet.comparator = this.comparator;
	        newSet.keyedMap = keyedMap;
	        newSet.sortedSet = sortedSet;
	        return newSet;
	    };
	    return DocumentSet;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ChangeType;
	(function (ChangeType) {
	    ChangeType[ChangeType["Added"] = 0] = "Added";
	    ChangeType[ChangeType["Removed"] = 1] = "Removed";
	    ChangeType[ChangeType["Modified"] = 2] = "Modified";
	    ChangeType[ChangeType["Metadata"] = 3] = "Metadata";
	})(ChangeType || (ChangeType = {}));
	var SyncState;
	(function (SyncState) {
	    SyncState[SyncState["Local"] = 0] = "Local";
	    SyncState[SyncState["Synced"] = 1] = "Synced";
	})(SyncState || (SyncState = {}));
	/**
	 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
	 * duplicate events for the same doc.
	 */
	var DocumentChangeSet = /** @class */ (function () {
	    function DocumentChangeSet() {
	        this.changeMap = new SortedMap(DocumentKey.comparator);
	    }
	    DocumentChangeSet.prototype.track = function (change) {
	        var key = change.doc.key;
	        var oldChange = this.changeMap.get(key);
	        if (!oldChange) {
	            this.changeMap = this.changeMap.insert(key, change);
	            return;
	        }
	        // Merge the new change with the existing change.
	        if (change.type !== ChangeType.Added &&
	            oldChange.type === ChangeType.Metadata) {
	            this.changeMap = this.changeMap.insert(key, change);
	        }
	        else if (change.type === ChangeType.Metadata &&
	            oldChange.type !== ChangeType.Removed) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: oldChange.type,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Modified &&
	            oldChange.type === ChangeType.Modified) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Modified,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Modified &&
	            oldChange.type === ChangeType.Added) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Added,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Removed &&
	            oldChange.type === ChangeType.Added) {
	            this.changeMap = this.changeMap.remove(key);
	        }
	        else if (change.type === ChangeType.Removed &&
	            oldChange.type === ChangeType.Modified) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Removed,
	                doc: oldChange.doc
	            });
	        }
	        else if (change.type === ChangeType.Added &&
	            oldChange.type === ChangeType.Removed) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Modified,
	                doc: change.doc
	            });
	        }
	        else {
	            // This includes these cases, which don't make sense:
	            // Added->Added
	            // Removed->Removed
	            // Modified->Added
	            // Removed->Modified
	            // Metadata->Added
	            // Removed->Metadata
	            fail('unsupported combination of changes: ' +
	                JSON.stringify(change) +
	                ' after ' +
	                JSON.stringify(oldChange));
	        }
	    };
	    DocumentChangeSet.prototype.getChanges = function () {
	        var changes = [];
	        this.changeMap.inorderTraversal(function (key, change) {
	            changes.push(change);
	        });
	        return changes;
	    };
	    return DocumentChangeSet;
	}());
	var ViewSnapshot = /** @class */ (function () {
	    function ViewSnapshot(query, docs, oldDocs, docChanges, mutatedKeys, fromCache, syncStateChanged, excludesMetadataChanges) {
	        this.query = query;
	        this.docs = docs;
	        this.oldDocs = oldDocs;
	        this.docChanges = docChanges;
	        this.mutatedKeys = mutatedKeys;
	        this.fromCache = fromCache;
	        this.syncStateChanged = syncStateChanged;
	        this.excludesMetadataChanges = excludesMetadataChanges;
	    }
	    /** Returns a view snapshot as if all documents in the snapshot were added. */
	    ViewSnapshot.fromInitialDocuments = function (query, documents, mutatedKeys, fromCache) {
	        var changes = [];
	        documents.forEach(function (doc) {
	            changes.push({ type: ChangeType.Added, doc: doc });
	        });
	        return new ViewSnapshot(query, documents, DocumentSet.emptySet(documents), changes, mutatedKeys, fromCache, 
	        /* syncStateChanged= */ true, 
	        /* excludesMetadataChanges= */ false);
	    };
	    Object.defineProperty(ViewSnapshot.prototype, "hasPendingWrites", {
	        get: function () {
	            return !this.mutatedKeys.isEmpty();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ViewSnapshot.prototype.isEqual = function (other) {
	        if (this.fromCache !== other.fromCache ||
	            this.syncStateChanged !== other.syncStateChanged ||
	            !this.mutatedKeys.isEqual(other.mutatedKeys) ||
	            !this.query.isEqual(other.query) ||
	            !this.docs.isEqual(other.docs) ||
	            !this.oldDocs.isEqual(other.oldDocs)) {
	            return false;
	        }
	        var changes = this.docChanges;
	        var otherChanges = other.docChanges;
	        if (changes.length !== otherChanges.length) {
	            return false;
	        }
	        for (var i = 0; i < changes.length; i++) {
	            if (changes[i].type !== otherChanges[i].type ||
	                !changes[i].doc.isEqual(otherChanges[i].doc)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    return ViewSnapshot;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An event from the RemoteStore. It is split into targetChanges (changes to the
	 * state or the set of documents in our watched targets) and documentUpdates
	 * (changes to the actual documents).
	 */
	var RemoteEvent = /** @class */ (function () {
	    function RemoteEvent(
	    /**
	     * The snapshot version this event brings us up to, or MIN if not set.
	     */
	    snapshotVersion, 
	    /**
	     * A map from target to changes to the target. See TargetChange.
	     */
	    targetChanges, 
	    /**
	     * A set of targets that is known to be inconsistent. Listens for these
	     * targets should be re-established without resume tokens.
	     */
	    targetMismatches, 
	    /**
	     * A set of which documents have changed or been deleted, along with the
	     * doc's new values (if not deleted).
	     */
	    documentUpdates, 
	    /**
	     * A set of which document updates are due only to limbo resolution targets.
	     */
	    resolvedLimboDocuments) {
	        this.snapshotVersion = snapshotVersion;
	        this.targetChanges = targetChanges;
	        this.targetMismatches = targetMismatches;
	        this.documentUpdates = documentUpdates;
	        this.resolvedLimboDocuments = resolvedLimboDocuments;
	    }
	    /**
	     * HACK: Views require RemoteEvents in order to determine whether the view is
	     * CURRENT, but secondary tabs don't receive remote events. So this method is
	     * used to create a synthesized RemoteEvent that can be used to apply a
	     * CURRENT status change to a View, for queries executed in a different tab.
	     */
	    // PORTING NOTE: Multi-tab only
	    RemoteEvent.createSynthesizedRemoteEventForCurrentChange = function (targetId, current) {
	        var _a;
	        var targetChanges = (_a = {},
	            _a[targetId] = TargetChange.createSynthesizedTargetChangeForCurrentChange(targetId, current),
	            _a);
	        return new RemoteEvent(SnapshotVersion.MIN, targetChanges, targetIdSet(), maybeDocumentMap(), documentKeySet());
	    };
	    return RemoteEvent;
	}());
	/**
	 * A TargetChange specifies the set of changes for a specific target as part of
	 * a RemoteEvent. These changes track which documents are added, modified or
	 * removed, as well as the target's resume token and whether the target is
	 * marked CURRENT.
	 * The actual changes *to* documents are not part of the TargetChange since
	 * documents may be part of multiple targets.
	 */
	var TargetChange = /** @class */ (function () {
	    function TargetChange(
	    /**
	     * An opaque, server-assigned token that allows watching a query to be resumed
	     * after disconnecting without retransmitting all the data that matches the
	     * query. The resume token essentially identifies a point in time from which
	     * the server should resume sending results.
	     */
	    resumeToken, 
	    /**
	     * The "current" (synced) status of this target. Note that "current"
	     * has special meaning in the RPC protocol that implies that a target is
	     * both up-to-date and consistent with the rest of the watch stream.
	     */
	    current, 
	    /**
	     * The set of documents that were newly assigned to this target as part of
	     * this remote event.
	     */
	    addedDocuments, 
	    /**
	     * The set of documents that were already assigned to this target but received
	     * an update during this remote event.
	     */
	    modifiedDocuments, 
	    /**
	     * The set of documents that were removed from this target as part of this
	     * remote event.
	     */
	    removedDocuments) {
	        this.resumeToken = resumeToken;
	        this.current = current;
	        this.addedDocuments = addedDocuments;
	        this.modifiedDocuments = modifiedDocuments;
	        this.removedDocuments = removedDocuments;
	    }
	    /**
	     * This method is used to create a synthesized TargetChanges that can be used to
	     * apply a CURRENT status change to a View (for queries executed in a different
	     * tab) or for new queries (to raise snapshots with correct CURRENT status).
	     */
	    TargetChange.createSynthesizedTargetChangeForCurrentChange = function (targetId, current) {
	        return new TargetChange(emptyByteString(), current, documentKeySet(), documentKeySet(), documentKeySet());
	    };
	    return TargetChange;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents a changed document and a list of target ids to which this change
	 * applies.
	 *
	 * If document has been deleted NoDocument will be provided.
	 */
	var DocumentWatchChange = /** @class */ (function () {
	    function DocumentWatchChange(
	    /** The new document applies to all of these targets. */
	    updatedTargetIds, 
	    /** The new document is removed from all of these targets. */
	    removedTargetIds, 
	    /** The key of the document for this change. */
	    key, 
	    /**
	     * The new document or NoDocument if it was deleted. Is null if the
	     * document went out of view without the server sending a new document.
	     */
	    newDoc) {
	        this.updatedTargetIds = updatedTargetIds;
	        this.removedTargetIds = removedTargetIds;
	        this.key = key;
	        this.newDoc = newDoc;
	    }
	    return DocumentWatchChange;
	}());
	var ExistenceFilterChange = /** @class */ (function () {
	    function ExistenceFilterChange(targetId, existenceFilter) {
	        this.targetId = targetId;
	        this.existenceFilter = existenceFilter;
	    }
	    return ExistenceFilterChange;
	}());
	var WatchTargetChangeState;
	(function (WatchTargetChangeState) {
	    WatchTargetChangeState[WatchTargetChangeState["NoChange"] = 0] = "NoChange";
	    WatchTargetChangeState[WatchTargetChangeState["Added"] = 1] = "Added";
	    WatchTargetChangeState[WatchTargetChangeState["Removed"] = 2] = "Removed";
	    WatchTargetChangeState[WatchTargetChangeState["Current"] = 3] = "Current";
	    WatchTargetChangeState[WatchTargetChangeState["Reset"] = 4] = "Reset";
	})(WatchTargetChangeState || (WatchTargetChangeState = {}));
	var WatchTargetChange = /** @class */ (function () {
	    function WatchTargetChange(
	    /** What kind of change occurred to the watch target. */
	    state, 
	    /** The target IDs that were added/removed/set. */
	    targetIds, 
	    /**
	     * An opaque, server-assigned token that allows watching a target to be
	     * resumed after disconnecting without retransmitting all the data that
	     * matches the target. The resume token essentially identifies a point in
	     * time from which the server should resume sending results.
	     */
	    resumeToken, 
	    /** An RPC error indicating why the watch failed. */
	    cause) {
	        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
	        if (cause === void 0) { cause = null; }
	        this.state = state;
	        this.targetIds = targetIds;
	        this.resumeToken = resumeToken;
	        this.cause = cause;
	    }
	    return WatchTargetChange;
	}());
	/** Tracks the internal state of a Watch target. */
	var TargetState = /** @class */ (function () {
	    function TargetState() {
	        /**
	         * The number of pending responses (adds or removes) that we are waiting on.
	         * We only consider targets active that have no pending responses.
	         */
	        this.pendingResponses = 0;
	        /**
	         * Keeps track of the document changes since the last raised snapshot.
	         *
	         * These changes are continuously updated as we receive document updates and
	         * always reflect the current set of changes against the last issued snapshot.
	         */
	        this.documentChanges = snapshotChangesMap();
	        /** See public getters for explanations of these fields. */
	        this._resumeToken = emptyByteString();
	        this._current = false;
	        /**
	         * Whether this target state should be included in the next snapshot. We
	         * initialize to true so that newly-added targets are included in the next
	         * RemoteEvent.
	         */
	        this._hasPendingChanges = true;
	    }
	    Object.defineProperty(TargetState.prototype, "current", {
	        /**
	         * Whether this target has been marked 'current'.
	         *
	         * 'Current' has special meaning in the RPC protocol: It implies that the
	         * Watch backend has sent us all changes up to the point at which the target
	         * was added and that the target is consistent with the rest of the watch
	         * stream.
	         */
	        get: function () {
	            return this._current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TargetState.prototype, "resumeToken", {
	        /** The last resume token sent to us for this target. */
	        get: function () {
	            return this._resumeToken;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TargetState.prototype, "isPending", {
	        /** Whether this target has pending target adds or target removes. */
	        get: function () {
	            return this.pendingResponses !== 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TargetState.prototype, "hasPendingChanges", {
	        /** Whether we have modified any state that should trigger a snapshot. */
	        get: function () {
	            return this._hasPendingChanges;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Applies the resume token to the TargetChange, but only when it has a new
	     * value. Empty resumeTokens are discarded.
	     */
	    TargetState.prototype.updateResumeToken = function (resumeToken) {
	        if (resumeToken.length > 0) {
	            this._hasPendingChanges = true;
	            this._resumeToken = resumeToken;
	        }
	    };
	    /**
	     * Creates a target change from the current set of changes.
	     *
	     * To reset the document changes after raising this snapshot, call
	     * `clearPendingChanges()`.
	     */
	    TargetState.prototype.toTargetChange = function () {
	        var addedDocuments = documentKeySet();
	        var modifiedDocuments = documentKeySet();
	        var removedDocuments = documentKeySet();
	        this.documentChanges.forEach(function (key, changeType) {
	            switch (changeType) {
	                case ChangeType.Added:
	                    addedDocuments = addedDocuments.add(key);
	                    break;
	                case ChangeType.Modified:
	                    modifiedDocuments = modifiedDocuments.add(key);
	                    break;
	                case ChangeType.Removed:
	                    removedDocuments = removedDocuments.add(key);
	                    break;
	                default:
	                    fail('Encountered invalid change type: ' + changeType);
	            }
	        });
	        return new TargetChange(this._resumeToken, this._current, addedDocuments, modifiedDocuments, removedDocuments);
	    };
	    /**
	     * Resets the document changes and sets `hasPendingChanges` to false.
	     */
	    TargetState.prototype.clearPendingChanges = function () {
	        this._hasPendingChanges = false;
	        this.documentChanges = snapshotChangesMap();
	    };
	    TargetState.prototype.addDocumentChange = function (key, changeType) {
	        this._hasPendingChanges = true;
	        this.documentChanges = this.documentChanges.insert(key, changeType);
	    };
	    TargetState.prototype.removeDocumentChange = function (key) {
	        this._hasPendingChanges = true;
	        this.documentChanges = this.documentChanges.remove(key);
	    };
	    TargetState.prototype.recordPendingTargetRequest = function () {
	        this.pendingResponses += 1;
	    };
	    TargetState.prototype.recordTargetResponse = function () {
	        this.pendingResponses -= 1;
	    };
	    TargetState.prototype.markCurrent = function () {
	        this._hasPendingChanges = true;
	        this._current = true;
	    };
	    return TargetState;
	}());
	var LOG_TAG$7 = 'WatchChangeAggregator';
	/**
	 * A helper class to accumulate watch changes into a RemoteEvent.
	 */
	var WatchChangeAggregator = /** @class */ (function () {
	    function WatchChangeAggregator(metadataProvider) {
	        this.metadataProvider = metadataProvider;
	        /** The internal state of all tracked targets. */
	        this.targetStates = {};
	        /** Keeps track of the documents to update since the last raised snapshot. */
	        this.pendingDocumentUpdates = maybeDocumentMap();
	        /** A mapping of document keys to their set of target IDs. */
	        this.pendingDocumentTargetMapping = documentTargetMap();
	        /**
	         * A list of targets with existence filter mismatches. These targets are
	         * known to be inconsistent and their listens needs to be re-established by
	         * RemoteStore.
	         */
	        this.pendingTargetResets = new SortedSet(primitiveComparator);
	    }
	    /**
	     * Processes and adds the DocumentWatchChange to the current set of changes.
	     */
	    WatchChangeAggregator.prototype.handleDocumentChange = function (docChange) {
	        for (var _i = 0, _a = docChange.updatedTargetIds; _i < _a.length; _i++) {
	            var targetId = _a[_i];
	            if (docChange.newDoc instanceof Document) {
	                this.addDocumentToTarget(targetId, docChange.newDoc);
	            }
	            else if (docChange.newDoc instanceof NoDocument) {
	                this.removeDocumentFromTarget(targetId, docChange.key, docChange.newDoc);
	            }
	        }
	        for (var _b = 0, _c = docChange.removedTargetIds; _b < _c.length; _b++) {
	            var targetId = _c[_b];
	            this.removeDocumentFromTarget(targetId, docChange.key, docChange.newDoc);
	        }
	    };
	    /** Processes and adds the WatchTargetChange to the current set of changes. */
	    WatchChangeAggregator.prototype.handleTargetChange = function (targetChange) {
	        var _this = this;
	        this.forEachTarget(targetChange, function (targetId) {
	            var targetState = _this.ensureTargetState(targetId);
	            switch (targetChange.state) {
	                case WatchTargetChangeState.NoChange:
	                    if (_this.isActiveTarget(targetId)) {
	                        targetState.updateResumeToken(targetChange.resumeToken);
	                    }
	                    break;
	                case WatchTargetChangeState.Added:
	                    // We need to decrement the number of pending acks needed from watch
	                    // for this targetId.
	                    targetState.recordTargetResponse();
	                    if (!targetState.isPending) {
	                        // We have a freshly added target, so we need to reset any state
	                        // that we had previously. This can happen e.g. when remove and add
	                        // back a target for existence filter mismatches.
	                        targetState.clearPendingChanges();
	                    }
	                    targetState.updateResumeToken(targetChange.resumeToken);
	                    break;
	                case WatchTargetChangeState.Removed:
	                    // We need to keep track of removed targets to we can post-filter and
	                    // remove any target changes.
	                    // We need to decrement the number of pending acks needed from watch
	                    // for this targetId.
	                    targetState.recordTargetResponse();
	                    if (!targetState.isPending) {
	                        _this.removeTarget(targetId);
	                    }
	                    assert(!targetChange.cause, 'WatchChangeAggregator does not handle errored targets');
	                    break;
	                case WatchTargetChangeState.Current:
	                    if (_this.isActiveTarget(targetId)) {
	                        targetState.markCurrent();
	                        targetState.updateResumeToken(targetChange.resumeToken);
	                    }
	                    break;
	                case WatchTargetChangeState.Reset:
	                    if (_this.isActiveTarget(targetId)) {
	                        // Reset the target and synthesizes removes for all existing
	                        // documents. The backend will re-add any documents that still
	                        // match the target before it sends the next global snapshot.
	                        _this.resetTarget(targetId);
	                        targetState.updateResumeToken(targetChange.resumeToken);
	                    }
	                    break;
	                default:
	                    fail('Unknown target watch change state: ' + targetChange.state);
	            }
	        });
	    };
	    /**
	     * Iterates over all targetIds that the watch change applies to: either the
	     * targetIds explicitly listed in the change or the targetIds of all currently
	     * active targets.
	     */
	    WatchChangeAggregator.prototype.forEachTarget = function (targetChange, fn) {
	        if (targetChange.targetIds.length > 0) {
	            targetChange.targetIds.forEach(fn);
	        }
	        else {
	            forEachNumber(this.targetStates, fn);
	        }
	    };
	    /**
	     * Handles existence filters and synthesizes deletes for filter mismatches.
	     * Targets that are invalidated by filter mismatches are added to
	     * `pendingTargetResets`.
	     */
	    WatchChangeAggregator.prototype.handleExistenceFilter = function (watchChange) {
	        var targetId = watchChange.targetId;
	        var expectedCount = watchChange.existenceFilter.count;
	        var targetData = this.targetDataForActiveTarget(targetId);
	        if (targetData) {
	            var target = targetData.target;
	            if (target.isDocumentQuery()) {
	                if (expectedCount === 0) {
	                    // The existence filter told us the document does not exist. We deduce
	                    // that this document does not exist and apply a deleted document to
	                    // our updates. Without applying this deleted document there might be
	                    // another query that will raise this document as part of a snapshot
	                    // until it is resolved, essentially exposing inconsistency between
	                    // queries.
	                    var key = new DocumentKey(target.path);
	                    this.removeDocumentFromTarget(targetId, key, new NoDocument(key, SnapshotVersion.forDeletedDoc()));
	                }
	                else {
	                    assert(expectedCount === 1, 'Single document existence filter with count: ' + expectedCount);
	                }
	            }
	            else {
	                var currentSize = this.getCurrentDocumentCountForTarget(targetId);
	                if (currentSize !== expectedCount) {
	                    // Existence filter mismatch: We reset the mapping and raise a new
	                    // snapshot with `isFromCache:true`.
	                    this.resetTarget(targetId);
	                    this.pendingTargetResets = this.pendingTargetResets.add(targetId);
	                }
	            }
	        }
	    };
	    /**
	     * Converts the currently accumulated state into a remote event at the
	     * provided snapshot version. Resets the accumulated changes before returning.
	     */
	    WatchChangeAggregator.prototype.createRemoteEvent = function (snapshotVersion) {
	        var _this = this;
	        var targetChanges = {};
	        forEachNumber(this.targetStates, function (targetId, targetState) {
	            var targetData = _this.targetDataForActiveTarget(targetId);
	            if (targetData) {
	                if (targetState.current && targetData.target.isDocumentQuery()) {
	                    // Document queries for document that don't exist can produce an empty
	                    // result set. To update our local cache, we synthesize a document
	                    // delete if we have not previously received the document. This
	                    // resolves the limbo state of the document, removing it from
	                    // limboDocumentRefs.
	                    //
	                    // TODO(dimond): Ideally we would have an explicit lookup target
	                    // instead resulting in an explicit delete message and we could
	                    // remove this special logic.
	                    var key = new DocumentKey(targetData.target.path);
	                    if (_this.pendingDocumentUpdates.get(key) === null &&
	                        !_this.targetContainsDocument(targetId, key)) {
	                        _this.removeDocumentFromTarget(targetId, key, new NoDocument(key, snapshotVersion));
	                    }
	                }
	                if (targetState.hasPendingChanges) {
	                    targetChanges[targetId] = targetState.toTargetChange();
	                    targetState.clearPendingChanges();
	                }
	            }
	        });
	        var resolvedLimboDocuments = documentKeySet();
	        // We extract the set of limbo-only document updates as the GC logic
	        // special-cases documents that do not appear in the target cache.
	        //
	        // TODO(gsoltis): Expand on this comment once GC is available in the JS
	        // client.
	        this.pendingDocumentTargetMapping.forEach(function (key, targets) {
	            var isOnlyLimboTarget = true;
	            targets.forEachWhile(function (targetId) {
	                var targetData = _this.targetDataForActiveTarget(targetId);
	                if (targetData &&
	                    targetData.purpose !== TargetPurpose.LimboResolution) {
	                    isOnlyLimboTarget = false;
	                    return false;
	                }
	                return true;
	            });
	            if (isOnlyLimboTarget) {
	                resolvedLimboDocuments = resolvedLimboDocuments.add(key);
	            }
	        });
	        var remoteEvent = new RemoteEvent(snapshotVersion, targetChanges, this.pendingTargetResets, this.pendingDocumentUpdates, resolvedLimboDocuments);
	        this.pendingDocumentUpdates = maybeDocumentMap();
	        this.pendingDocumentTargetMapping = documentTargetMap();
	        this.pendingTargetResets = new SortedSet(primitiveComparator);
	        return remoteEvent;
	    };
	    /**
	     * Adds the provided document to the internal list of document updates and
	     * its document key to the given target's mapping.
	     */
	    // Visible for testing.
	    WatchChangeAggregator.prototype.addDocumentToTarget = function (targetId, document) {
	        if (!this.isActiveTarget(targetId)) {
	            return;
	        }
	        var changeType = this.targetContainsDocument(targetId, document.key)
	            ? ChangeType.Modified
	            : ChangeType.Added;
	        var targetState = this.ensureTargetState(targetId);
	        targetState.addDocumentChange(document.key, changeType);
	        this.pendingDocumentUpdates = this.pendingDocumentUpdates.insert(document.key, document);
	        this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(document.key, this.ensureDocumentTargetMapping(document.key).add(targetId));
	    };
	    /**
	     * Removes the provided document from the target mapping. If the
	     * document no longer matches the target, but the document's state is still
	     * known (e.g. we know that the document was deleted or we received the change
	     * that caused the filter mismatch), the new document can be provided
	     * to update the remote document cache.
	     */
	    // Visible for testing.
	    WatchChangeAggregator.prototype.removeDocumentFromTarget = function (targetId, key, updatedDocument) {
	        if (!this.isActiveTarget(targetId)) {
	            return;
	        }
	        var targetState = this.ensureTargetState(targetId);
	        if (this.targetContainsDocument(targetId, key)) {
	            targetState.addDocumentChange(key, ChangeType.Removed);
	        }
	        else {
	            // The document may have entered and left the target before we raised a
	            // snapshot, so we can just ignore the change.
	            targetState.removeDocumentChange(key);
	        }
	        this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(key, this.ensureDocumentTargetMapping(key).delete(targetId));
	        if (updatedDocument) {
	            this.pendingDocumentUpdates = this.pendingDocumentUpdates.insert(key, updatedDocument);
	        }
	    };
	    WatchChangeAggregator.prototype.removeTarget = function (targetId) {
	        delete this.targetStates[targetId];
	    };
	    /**
	     * Returns the current count of documents in the target. This includes both
	     * the number of documents that the LocalStore considers to be part of the
	     * target as well as any accumulated changes.
	     */
	    WatchChangeAggregator.prototype.getCurrentDocumentCountForTarget = function (targetId) {
	        var targetState = this.ensureTargetState(targetId);
	        var targetChange = targetState.toTargetChange();
	        return (this.metadataProvider.getRemoteKeysForTarget(targetId).size +
	            targetChange.addedDocuments.size -
	            targetChange.removedDocuments.size);
	    };
	    /**
	     * Increment the number of acks needed from watch before we can consider the
	     * server to be 'in-sync' with the client's active targets.
	     */
	    WatchChangeAggregator.prototype.recordPendingTargetRequest = function (targetId) {
	        // For each request we get we need to record we need a response for it.
	        var targetState = this.ensureTargetState(targetId);
	        targetState.recordPendingTargetRequest();
	    };
	    WatchChangeAggregator.prototype.ensureTargetState = function (targetId) {
	        if (!this.targetStates[targetId]) {
	            this.targetStates[targetId] = new TargetState();
	        }
	        return this.targetStates[targetId];
	    };
	    WatchChangeAggregator.prototype.ensureDocumentTargetMapping = function (key) {
	        var targetMapping = this.pendingDocumentTargetMapping.get(key);
	        if (!targetMapping) {
	            targetMapping = new SortedSet(primitiveComparator);
	            this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(key, targetMapping);
	        }
	        return targetMapping;
	    };
	    /**
	     * Verifies that the user is still interested in this target (by calling
	     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
	     * from watch.
	     */
	    WatchChangeAggregator.prototype.isActiveTarget = function (targetId) {
	        var targetActive = this.targetDataForActiveTarget(targetId) !== null;
	        if (!targetActive) {
	            debug(LOG_TAG$7, 'Detected inactive target', targetId);
	        }
	        return targetActive;
	    };
	    /**
	     * Returns the TargetData for an active target (i.e. a target that the user
	     * is still interested in that has no outstanding target change requests).
	     */
	    WatchChangeAggregator.prototype.targetDataForActiveTarget = function (targetId) {
	        var targetState = this.targetStates[targetId];
	        return targetState && targetState.isPending
	            ? null
	            : this.metadataProvider.getTargetDataForTarget(targetId);
	    };
	    /**
	     * Resets the state of a Watch target to its initial state (e.g. sets
	     * 'current' to false, clears the resume token and removes its target mapping
	     * from all documents).
	     */
	    WatchChangeAggregator.prototype.resetTarget = function (targetId) {
	        var _this = this;
	        assert(!this.targetStates[targetId].isPending, 'Should only reset active targets');
	        this.targetStates[targetId] = new TargetState();
	        // Trigger removal for any documents currently mapped to this target.
	        // These removals will be part of the initial snapshot if Watch does not
	        // resend these documents.
	        var existingKeys = this.metadataProvider.getRemoteKeysForTarget(targetId);
	        existingKeys.forEach(function (key) {
	            _this.removeDocumentFromTarget(targetId, key, /*updatedDocument=*/ null);
	        });
	    };
	    /**
	     * Returns whether the LocalStore considers the document to be part of the
	     * specified target.
	     */
	    WatchChangeAggregator.prototype.targetContainsDocument = function (targetId, key) {
	        var existingKeys = this.metadataProvider.getRemoteKeysForTarget(targetId);
	        return existingKeys.has(key);
	    };
	    return WatchChangeAggregator;
	}());
	function documentTargetMap() {
	    return new SortedMap(DocumentKey.comparator);
	}
	function snapshotChangesMap() {
	    return new SortedMap(DocumentKey.comparator);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$8 = 'RemoteStore';
	// TODO(b/35853402): Negotiate this with the stream.
	var MAX_PENDING_WRITES = 10;
	/**
	 * RemoteStore - An interface to remotely stored data, basically providing a
	 * wrapper around the Datastore that is more reliable for the rest of the
	 * system.
	 *
	 * RemoteStore is responsible for maintaining the connection to the server.
	 * - maintaining a list of active listens.
	 * - reconnecting when the connection is dropped.
	 * - resuming all the active listens on reconnect.
	 *
	 * RemoteStore handles all incoming events from the Datastore.
	 * - listening to the watch stream and repackaging the events as RemoteEvents
	 * - notifying SyncEngine of any changes to the active listens.
	 *
	 * RemoteStore takes writes from other components and handles them reliably.
	 * - pulling pending mutations from LocalStore and sending them to Datastore.
	 * - retrying mutations that failed because of network problems.
	 * - acking mutations to the SyncEngine once they are accepted or rejected.
	 */
	var RemoteStore = /** @class */ (function () {
	    function RemoteStore(
	    /**
	     * The local store, used to fill the write pipeline with outbound mutations.
	     */
	    localStore, 
	    /** The client-side proxy for interacting with the backend. */
	    datastore, asyncQueue, onlineStateHandler, connectivityMonitor) {
	        var _this = this;
	        this.localStore = localStore;
	        this.datastore = datastore;
	        /**
	         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
	         * LocalStore via fillWritePipeline() and have or will send to the write
	         * stream.
	         *
	         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
	         * restart the write stream. When the stream is established the writes in the
	         * pipeline will be sent in order.
	         *
	         * Writes remain in writePipeline until they are acknowledged by the backend
	         * and thus will automatically be re-sent if the stream is interrupted /
	         * restarted before they're acknowledged.
	         *
	         * Write responses from the backend are linked to their originating request
	         * purely based on order, and so we can just shift() writes from the front of
	         * the writePipeline as we receive responses.
	         */
	        this.writePipeline = [];
	        /**
	         * A mapping of watched targets that the client cares about tracking and the
	         * user has explicitly called a 'listen' for this target.
	         *
	         * These targets may or may not have been sent to or acknowledged by the
	         * server. On re-establishing the listen stream, these targets should be sent
	         * to the server. The targets removed with unlistens are removed eagerly
	         * without waiting for confirmation from the listen stream.
	         */
	        this.listenTargets = {};
	        this.watchChangeAggregator = null;
	        /**
	         * Set to true by enableNetwork() and false by disableNetwork() and indicates
	         * the user-preferred network state.
	         */
	        this.networkEnabled = false;
	        this.isPrimary = false;
	        this.connectivityMonitor = connectivityMonitor;
	        this.connectivityMonitor.addCallback(function (status) {
	            asyncQueue.enqueueAndForget(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	                return tslib.__generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            if (!this.canUseNetwork()) return [3 /*break*/, 2];
	                            debug(LOG_TAG$8, 'Restarting streams for network reachability change.');
	                            return [4 /*yield*/, this.restartNetwork()];
	                        case 1:
	                            _a.sent();
	                            _a.label = 2;
	                        case 2: return [2 /*return*/];
	                    }
	                });
	            }); });
	        });
	        this.onlineStateTracker = new OnlineStateTracker(asyncQueue, onlineStateHandler);
	        // Create streams (but note they're not started yet).
	        this.watchStream = this.datastore.newPersistentWatchStream({
	            onOpen: this.onWatchStreamOpen.bind(this),
	            onClose: this.onWatchStreamClose.bind(this),
	            onWatchChange: this.onWatchStreamChange.bind(this)
	        });
	        this.writeStream = this.datastore.newPersistentWriteStream({
	            onOpen: this.onWriteStreamOpen.bind(this),
	            onClose: this.onWriteStreamClose.bind(this),
	            onHandshakeComplete: this.onWriteHandshakeComplete.bind(this),
	            onMutationResult: this.onMutationResult.bind(this)
	        });
	    }
	    /**
	     * Starts up the remote store, creating streams, restoring state from
	     * LocalStore, etc.
	     */
	    RemoteStore.prototype.start = function () {
	        return this.enableNetwork();
	    };
	    /** Re-enables the network. Idempotent. */
	    RemoteStore.prototype.enableNetwork = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        this.networkEnabled = true;
	                        if (!this.canUseNetwork()) return [3 /*break*/, 3];
	                        _a = this.writeStream;
	                        return [4 /*yield*/, this.localStore.getLastStreamToken()];
	                    case 1:
	                        _a.lastStreamToken = _b.sent();
	                        if (this.shouldStartWatchStream()) {
	                            this.startWatchStream();
	                        }
	                        else {
	                            this.onlineStateTracker.set(OnlineState.Unknown);
	                        }
	                        // This will start the write stream if necessary.
	                        return [4 /*yield*/, this.fillWritePipeline()];
	                    case 2:
	                        // This will start the write stream if necessary.
	                        _b.sent();
	                        _b.label = 3;
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Temporarily disables the network. The network can be re-enabled using
	     * enableNetwork().
	     */
	    RemoteStore.prototype.disableNetwork = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.networkEnabled = false;
	                        return [4 /*yield*/, this.disableNetworkInternal()];
	                    case 1:
	                        _a.sent();
	                        // Set the OnlineState to Offline so get()s return from cache, etc.
	                        this.onlineStateTracker.set(OnlineState.Offline);
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    RemoteStore.prototype.disableNetworkInternal = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.writeStream.stop()];
	                    case 1:
	                        _a.sent();
	                        return [4 /*yield*/, this.watchStream.stop()];
	                    case 2:
	                        _a.sent();
	                        if (this.writePipeline.length > 0) {
	                            debug(LOG_TAG$8, "Stopping write stream with " + this.writePipeline.length + " pending writes");
	                            this.writePipeline = [];
	                        }
	                        this.cleanUpWatchStreamState();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    RemoteStore.prototype.shutdown = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        debug(LOG_TAG$8, 'RemoteStore shutting down.');
	                        this.networkEnabled = false;
	                        return [4 /*yield*/, this.disableNetworkInternal()];
	                    case 1:
	                        _a.sent();
	                        this.connectivityMonitor.shutdown();
	                        // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
	                        // triggering spurious listener events with cached data, etc.
	                        this.onlineStateTracker.set(OnlineState.Unknown);
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Starts new listen for the given target. Uses resume token if provided. It
	     * is a no-op if the target of given `TargetData` is already being listened to.
	     */
	    RemoteStore.prototype.listen = function (targetData) {
	        if (contains(this.listenTargets, targetData.targetId)) {
	            return;
	        }
	        // Mark this as something the client is currently listening for.
	        this.listenTargets[targetData.targetId] = targetData;
	        if (this.shouldStartWatchStream()) {
	            // The listen will be sent in onWatchStreamOpen
	            this.startWatchStream();
	        }
	        else if (this.watchStream.isOpen()) {
	            this.sendWatchRequest(targetData);
	        }
	    };
	    /**
	     * Removes the listen from server. It is a no-op if the given target id is
	     * not being listened to.
	     */
	    RemoteStore.prototype.unlisten = function (targetId) {
	        assert(contains(this.listenTargets, targetId), "unlisten called on target no currently watched: " + targetId);
	        delete this.listenTargets[targetId];
	        if (this.watchStream.isOpen()) {
	            this.sendUnwatchRequest(targetId);
	        }
	        if (isEmpty(this.listenTargets)) {
	            if (this.watchStream.isOpen()) {
	                this.watchStream.markIdle();
	            }
	            else if (this.canUseNetwork()) {
	                // Revert to OnlineState.Unknown if the watch stream is not open and we
	                // have no listeners, since without any listens to send we cannot
	                // confirm if the stream is healthy and upgrade to OnlineState.Online.
	                this.onlineStateTracker.set(OnlineState.Unknown);
	            }
	        }
	    };
	    /** {@link TargetMetadataProvider.getTargetDataForTarget} */
	    RemoteStore.prototype.getTargetDataForTarget = function (targetId) {
	        return this.listenTargets[targetId] || null;
	    };
	    /** {@link TargetMetadataProvider.getRemoteKeysForTarget} */
	    RemoteStore.prototype.getRemoteKeysForTarget = function (targetId) {
	        return this.syncEngine.getRemoteKeysForTarget(targetId);
	    };
	    /**
	     * We need to increment the the expected number of pending responses we're due
	     * from watch so we wait for the ack to process any messages from this target.
	     */
	    RemoteStore.prototype.sendWatchRequest = function (targetData) {
	        this.watchChangeAggregator.recordPendingTargetRequest(targetData.targetId);
	        this.watchStream.watch(targetData);
	    };
	    /**
	     * We need to increment the expected number of pending responses we're due
	     * from watch so we wait for the removal on the server before we process any
	     * messages from this target.
	     */
	    RemoteStore.prototype.sendUnwatchRequest = function (targetId) {
	        this.watchChangeAggregator.recordPendingTargetRequest(targetId);
	        this.watchStream.unwatch(targetId);
	    };
	    RemoteStore.prototype.startWatchStream = function () {
	        assert(this.shouldStartWatchStream(), 'startWatchStream() called when shouldStartWatchStream() is false.');
	        this.watchChangeAggregator = new WatchChangeAggregator(this);
	        this.watchStream.start();
	        this.onlineStateTracker.handleWatchStreamStart();
	    };
	    /**
	     * Returns whether the watch stream should be started because it's necessary
	     * and has not yet been started.
	     */
	    RemoteStore.prototype.shouldStartWatchStream = function () {
	        return (this.canUseNetwork() &&
	            !this.watchStream.isStarted() &&
	            !isEmpty(this.listenTargets));
	    };
	    RemoteStore.prototype.canUseNetwork = function () {
	        return this.isPrimary && this.networkEnabled;
	    };
	    RemoteStore.prototype.cleanUpWatchStreamState = function () {
	        this.watchChangeAggregator = null;
	    };
	    RemoteStore.prototype.onWatchStreamOpen = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                forEachNumber(this.listenTargets, function (targetId, targetData) {
	                    _this.sendWatchRequest(targetData);
	                });
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.onWatchStreamClose = function (error) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                if (error === undefined) {
	                    // Graceful stop (due to stop() or idle timeout). Make sure that's
	                    // desirable.
	                    assert(!this.shouldStartWatchStream(), 'Watch stream was stopped gracefully while still needed.');
	                }
	                this.cleanUpWatchStreamState();
	                // If we still need the watch stream, retry the connection.
	                if (this.shouldStartWatchStream()) {
	                    this.onlineStateTracker.handleWatchStreamFailure(error);
	                    this.startWatchStream();
	                }
	                else {
	                    // No need to restart watch stream because there are no active targets.
	                    // The online state is set to unknown because there is no active attempt
	                    // at establishing a connection
	                    this.onlineStateTracker.set(OnlineState.Unknown);
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.onWatchStreamChange = function (watchChange, snapshotVersion) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var lastRemoteSnapshotVersion;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        // Mark the client as online since we got a message from the server
	                        this.onlineStateTracker.set(OnlineState.Online);
	                        if (watchChange instanceof WatchTargetChange &&
	                            watchChange.state === WatchTargetChangeState.Removed &&
	                            watchChange.cause) {
	                            // There was an error on a target, don't wait for a consistent snapshot
	                            // to raise events
	                            return [2 /*return*/, this.handleTargetError(watchChange)];
	                        }
	                        if (watchChange instanceof DocumentWatchChange) {
	                            this.watchChangeAggregator.handleDocumentChange(watchChange);
	                        }
	                        else if (watchChange instanceof ExistenceFilterChange) {
	                            this.watchChangeAggregator.handleExistenceFilter(watchChange);
	                        }
	                        else {
	                            assert(watchChange instanceof WatchTargetChange, 'Expected watchChange to be an instance of WatchTargetChange');
	                            this.watchChangeAggregator.handleTargetChange(watchChange);
	                        }
	                        if (!!snapshotVersion.isEqual(SnapshotVersion.MIN)) return [3 /*break*/, 3];
	                        return [4 /*yield*/, this.localStore.getLastRemoteSnapshotVersion()];
	                    case 1:
	                        lastRemoteSnapshotVersion = _a.sent();
	                        if (!(snapshotVersion.compareTo(lastRemoteSnapshotVersion) >= 0)) return [3 /*break*/, 3];
	                        // We have received a target change with a global snapshot if the snapshot
	                        // version is not equal to SnapshotVersion.MIN.
	                        return [4 /*yield*/, this.raiseWatchSnapshot(snapshotVersion)];
	                    case 2:
	                        // We have received a target change with a global snapshot if the snapshot
	                        // version is not equal to SnapshotVersion.MIN.
	                        _a.sent();
	                        _a.label = 3;
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Takes a batch of changes from the Datastore, repackages them as a
	     * RemoteEvent, and passes that on to the listener, which is typically the
	     * SyncEngine.
	     */
	    RemoteStore.prototype.raiseWatchSnapshot = function (snapshotVersion) {
	        var _this = this;
	        assert(!snapshotVersion.isEqual(SnapshotVersion.MIN), "Can't raise event for unknown SnapshotVersion");
	        var remoteEvent = this.watchChangeAggregator.createRemoteEvent(snapshotVersion);
	        // Update in-memory resume tokens. LocalStore will update the
	        // persistent view of these when applying the completed RemoteEvent.
	        forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
	            if (change.resumeToken.length > 0) {
	                var targetData = _this.listenTargets[targetId];
	                // A watched target might have been removed already.
	                if (targetData) {
	                    _this.listenTargets[targetId] = targetData.withResumeToken(change.resumeToken, snapshotVersion);
	                }
	            }
	        });
	        // Re-establish listens for the targets that have been invalidated by
	        // existence filter mismatches.
	        remoteEvent.targetMismatches.forEach(function (targetId) {
	            var targetData = _this.listenTargets[targetId];
	            if (!targetData) {
	                // A watched target might have been removed already.
	                return;
	            }
	            // Clear the resume token for the target, since we're in a known mismatch
	            // state.
	            _this.listenTargets[targetId] = targetData.withResumeToken(emptyByteString(), targetData.snapshotVersion);
	            // Cause a hard reset by unwatching and rewatching immediately, but
	            // deliberately don't send a resume token so that we get a full update.
	            _this.sendUnwatchRequest(targetId);
	            // Mark the target we send as being on behalf of an existence filter
	            // mismatch, but don't actually retain that in listenTargets. This ensures
	            // that we flag the first re-listen this way without impacting future
	            // listens of this target (that might happen e.g. on reconnect).
	            var requestTargetData = new TargetData(targetData.target, targetId, TargetPurpose.ExistenceFilterMismatch, targetData.sequenceNumber);
	            _this.sendWatchRequest(requestTargetData);
	        });
	        // Finally raise remote event
	        return this.syncEngine.applyRemoteEvent(remoteEvent);
	    };
	    /** Handles an error on a target */
	    RemoteStore.prototype.handleTargetError = function (watchChange) {
	        var _this = this;
	        assert(!!watchChange.cause, 'Handling target error without a cause');
	        var error = watchChange.cause;
	        var promiseChain = Promise.resolve();
	        watchChange.targetIds.forEach(function (targetId) {
	            promiseChain = promiseChain.then(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	                return tslib.__generator(this, function (_a) {
	                    // A watched target might have been removed already.
	                    if (contains(this.listenTargets, targetId)) {
	                        delete this.listenTargets[targetId];
	                        this.watchChangeAggregator.removeTarget(targetId);
	                        return [2 /*return*/, this.syncEngine.rejectListen(targetId, error)];
	                    }
	                    return [2 /*return*/];
	                });
	            }); });
	        });
	        return promiseChain;
	    };
	    /**
	     * Attempts to fill our write pipeline with writes from the LocalStore.
	     *
	     * Called internally to bootstrap or refill the write pipeline and by
	     * SyncEngine whenever there are new mutations to process.
	     *
	     * Starts the write stream if necessary.
	     */
	    RemoteStore.prototype.fillWritePipeline = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var lastBatchIdRetrieved, batch;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.canAddToWritePipeline()) return [3 /*break*/, 4];
	                        lastBatchIdRetrieved = this.writePipeline.length > 0
	                            ? this.writePipeline[this.writePipeline.length - 1].batchId
	                            : BATCHID_UNKNOWN;
	                        return [4 /*yield*/, this.localStore.nextMutationBatch(lastBatchIdRetrieved)];
	                    case 1:
	                        batch = _a.sent();
	                        if (!(batch === null)) return [3 /*break*/, 2];
	                        if (this.writePipeline.length === 0) {
	                            this.writeStream.markIdle();
	                        }
	                        return [3 /*break*/, 4];
	                    case 2:
	                        this.addToWritePipeline(batch);
	                        return [4 /*yield*/, this.fillWritePipeline()];
	                    case 3:
	                        _a.sent();
	                        _a.label = 4;
	                    case 4:
	                        if (this.shouldStartWriteStream()) {
	                            this.startWriteStream();
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Returns true if we can add to the write pipeline (i.e. the network is
	     * enabled and the write pipeline is not full).
	     */
	    RemoteStore.prototype.canAddToWritePipeline = function () {
	        return (this.canUseNetwork() && this.writePipeline.length < MAX_PENDING_WRITES);
	    };
	    // For testing
	    RemoteStore.prototype.outstandingWrites = function () {
	        return this.writePipeline.length;
	    };
	    /**
	     * Queues additional writes to be sent to the write stream, sending them
	     * immediately if the write stream is established.
	     */
	    RemoteStore.prototype.addToWritePipeline = function (batch) {
	        assert(this.canAddToWritePipeline(), 'addToWritePipeline called when pipeline is full');
	        this.writePipeline.push(batch);
	        if (this.writeStream.isOpen() && this.writeStream.handshakeComplete) {
	            this.writeStream.writeMutations(batch.mutations);
	        }
	    };
	    RemoteStore.prototype.shouldStartWriteStream = function () {
	        return (this.canUseNetwork() &&
	            !this.writeStream.isStarted() &&
	            this.writePipeline.length > 0);
	    };
	    RemoteStore.prototype.startWriteStream = function () {
	        assert(this.shouldStartWriteStream(), 'startWriteStream() called when shouldStartWriteStream() is false.');
	        this.writeStream.start();
	    };
	    RemoteStore.prototype.onWriteStreamOpen = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                this.writeStream.writeHandshake();
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.onWriteHandshakeComplete = function () {
	        var _this = this;
	        // Record the stream token.
	        return this.localStore
	            .setLastStreamToken(this.writeStream.lastStreamToken)
	            .then(function () {
	            // Send the write pipeline now that the stream is established.
	            for (var _i = 0, _a = _this.writePipeline; _i < _a.length; _i++) {
	                var batch = _a[_i];
	                _this.writeStream.writeMutations(batch.mutations);
	            }
	        })
	            .catch(ignoreIfPrimaryLeaseLoss);
	    };
	    RemoteStore.prototype.onMutationResult = function (commitVersion, results) {
	        var _this = this;
	        // This is a response to a write containing mutations and should be
	        // correlated to the first write in our write pipeline.
	        assert(this.writePipeline.length > 0, 'Got result for empty write pipeline');
	        var batch = this.writePipeline.shift();
	        var success = MutationBatchResult.from(batch, commitVersion, results, this.writeStream.lastStreamToken);
	        return this.syncEngine.applySuccessfulWrite(success).then(function () {
	            // It's possible that with the completion of this mutation another
	            // slot has freed up.
	            return _this.fillWritePipeline();
	        });
	    };
	    RemoteStore.prototype.onWriteStreamClose = function (error) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var errorHandling;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                if (error === undefined) {
	                    // Graceful stop (due to stop() or idle timeout). Make sure that's
	                    // desirable.
	                    assert(!this.shouldStartWriteStream(), 'Write stream was stopped gracefully while still needed.');
	                }
	                // If the write stream closed due to an error, invoke the error callbacks if
	                // there are pending writes.
	                if (error && this.writePipeline.length > 0) {
	                    errorHandling = void 0;
	                    if (this.writeStream.handshakeComplete) {
	                        // This error affects the actual write.
	                        errorHandling = this.handleWriteError(error);
	                    }
	                    else {
	                        // If there was an error before the handshake has finished, it's
	                        // possible that the server is unable to process the stream token
	                        // we're sending. (Perhaps it's too old?)
	                        errorHandling = this.handleHandshakeError(error);
	                    }
	                    return [2 /*return*/, errorHandling.then(function () {
	                            // The write stream might have been started by refilling the write
	                            // pipeline for failed writes
	                            if (_this.shouldStartWriteStream()) {
	                                _this.startWriteStream();
	                            }
	                        })];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.handleHandshakeError = function (error) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                // Reset the token if it's a permanent error, signaling the write stream is
	                // no longer valid. Note that the handshake does not count as a write: see
	                // comments on isPermanentWriteError for details.
	                if (isPermanentError(error.code)) {
	                    debug(LOG_TAG$8, 'RemoteStore error before completed handshake; resetting stream token: ', this.writeStream.lastStreamToken);
	                    this.writeStream.lastStreamToken = emptyByteString();
	                    return [2 /*return*/, this.localStore
	                            .setLastStreamToken(emptyByteString())
	                            .catch(ignoreIfPrimaryLeaseLoss)];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.handleWriteError = function (error) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var batch;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                // Only handle permanent errors here. If it's transient, just let the retry
	                // logic kick in.
	                if (isPermanentWriteError(error.code)) {
	                    batch = this.writePipeline.shift();
	                    // In this case it's also unlikely that the server itself is melting
	                    // down -- this was just a bad request so inhibit backoff on the next
	                    // restart.
	                    this.writeStream.inhibitBackoff();
	                    return [2 /*return*/, this.syncEngine
	                            .rejectFailedWrite(batch.batchId, error)
	                            .then(function () {
	                            // It's possible that with the completion of this mutation
	                            // another slot has freed up.
	                            return _this.fillWritePipeline();
	                        })];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    RemoteStore.prototype.createTransaction = function () {
	        return new Transaction(this.datastore);
	    };
	    RemoteStore.prototype.restartNetwork = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.networkEnabled = false;
	                        return [4 /*yield*/, this.disableNetworkInternal()];
	                    case 1:
	                        _a.sent();
	                        this.onlineStateTracker.set(OnlineState.Unknown);
	                        return [4 /*yield*/, this.enableNetwork()];
	                    case 2:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    RemoteStore.prototype.handleCredentialChange = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.canUseNetwork()) return [3 /*break*/, 2];
	                        // Tear down and re-create our network streams. This will ensure we get a fresh auth token
	                        // for the new user and re-fill the write pipeline with new mutations from the LocalStore
	                        // (since mutations are per-user).
	                        debug(LOG_TAG$8, 'RemoteStore restarting streams for new credential');
	                        return [4 /*yield*/, this.restartNetwork()];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Toggles the network state when the client gains or loses its primary lease.
	     */
	    RemoteStore.prototype.applyPrimaryState = function (isPrimary) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.isPrimary = isPrimary;
	                        if (!(isPrimary && this.networkEnabled)) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.enableNetwork()];
	                    case 1:
	                        _a.sent();
	                        return [3 /*break*/, 4];
	                    case 2:
	                        if (!!isPrimary) return [3 /*break*/, 4];
	                        return [4 /*yield*/, this.disableNetworkInternal()];
	                    case 3:
	                        _a.sent();
	                        this.onlineStateTracker.set(OnlineState.Unknown);
	                        _a.label = 4;
	                    case 4: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return RemoteStore;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Immutable class representing a geo point as latitude-longitude pair.
	 * This class is directly exposed in the public API, including its constructor.
	 */
	var GeoPoint = /** @class */ (function () {
	    function GeoPoint(latitude, longitude) {
	        validateExactNumberOfArgs('GeoPoint', arguments, 2);
	        validateArgType('GeoPoint', 'number', 1, latitude);
	        validateArgType('GeoPoint', 'number', 2, longitude);
	        if (!isFinite(latitude) || latitude < -90 || latitude > 90) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Latitude must be a number between -90 and 90, but was: ' + latitude);
	        }
	        if (!isFinite(longitude) || longitude < -180 || longitude > 180) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Longitude must be a number between -180 and 180, but was: ' + longitude);
	        }
	        this._lat = latitude;
	        this._long = longitude;
	    }
	    Object.defineProperty(GeoPoint.prototype, "latitude", {
	        /**
	         * Returns the latitude of this geo point, a number between -90 and 90.
	         */
	        get: function () {
	            return this._lat;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GeoPoint.prototype, "longitude", {
	        /**
	         * Returns the longitude of this geo point, a number between -180 and 180.
	         */
	        get: function () {
	            return this._long;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GeoPoint.prototype.isEqual = function (other) {
	        return this._lat === other._lat && this._long === other._long;
	    };
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    GeoPoint.prototype._compareTo = function (other) {
	        return (primitiveComparator(this._lat, other._lat) ||
	            primitiveComparator(this._long, other._long));
	    };
	    return GeoPoint;
	}());
	
	/**
	 * @license
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Transforms a value into a server-generated timestamp. */
	var ServerTimestampTransform = /** @class */ (function () {
	    function ServerTimestampTransform() {
	    }
	    ServerTimestampTransform.prototype.applyToLocalView = function (previousValue, localWriteTime) {
	        return new ServerTimestampValue(localWriteTime, previousValue);
	    };
	    ServerTimestampTransform.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
	        return transformResult;
	    };
	    ServerTimestampTransform.prototype.computeBaseValue = function (previousValue) {
	        return null; // Server timestamps are idempotent and don't require a base value.
	    };
	    ServerTimestampTransform.prototype.isEqual = function (other) {
	        return other instanceof ServerTimestampTransform;
	    };
	    ServerTimestampTransform.instance = new ServerTimestampTransform();
	    return ServerTimestampTransform;
	}());
	/** Transforms an array value via a union operation. */
	var ArrayUnionTransformOperation = /** @class */ (function () {
	    function ArrayUnionTransformOperation(elements) {
	        this.elements = elements;
	    }
	    ArrayUnionTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
	        return this.apply(previousValue);
	    };
	    ArrayUnionTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
	        // The server just sends null as the transform result for array operations,
	        // so we have to calculate a result the same as we do for local
	        // applications.
	        return this.apply(previousValue);
	    };
	    ArrayUnionTransformOperation.prototype.apply = function (previousValue) {
	        var result = coercedFieldValuesArray(previousValue);
	        var _loop_1 = function (toUnion) {
	            if (!result.find(function (element) { return element.isEqual(toUnion); })) {
	                result.push(toUnion);
	            }
	        };
	        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
	            var toUnion = _a[_i];
	            _loop_1(toUnion);
	        }
	        return new ArrayValue(result);
	    };
	    ArrayUnionTransformOperation.prototype.computeBaseValue = function (previousValue) {
	        return null; // Array transforms are idempotent and don't require a base value.
	    };
	    ArrayUnionTransformOperation.prototype.isEqual = function (other) {
	        return (other instanceof ArrayUnionTransformOperation &&
	            arrayEquals(other.elements, this.elements));
	    };
	    return ArrayUnionTransformOperation;
	}());
	/** Transforms an array value via a remove operation. */
	var ArrayRemoveTransformOperation = /** @class */ (function () {
	    function ArrayRemoveTransformOperation(elements) {
	        this.elements = elements;
	    }
	    ArrayRemoveTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
	        return this.apply(previousValue);
	    };
	    ArrayRemoveTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
	        // The server just sends null as the transform result for array operations,
	        // so we have to calculate a result the same as we do for local
	        // applications.
	        return this.apply(previousValue);
	    };
	    ArrayRemoveTransformOperation.prototype.apply = function (previousValue) {
	        var result = coercedFieldValuesArray(previousValue);
	        var _loop_2 = function (toRemove) {
	            result = result.filter(function (element) { return !element.isEqual(toRemove); });
	        };
	        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
	            var toRemove = _a[_i];
	            _loop_2(toRemove);
	        }
	        return new ArrayValue(result);
	    };
	    ArrayRemoveTransformOperation.prototype.computeBaseValue = function (previousValue) {
	        return null; // Array transforms are idempotent and don't require a base value.
	    };
	    ArrayRemoveTransformOperation.prototype.isEqual = function (other) {
	        return (other instanceof ArrayRemoveTransformOperation &&
	            arrayEquals(other.elements, this.elements));
	    };
	    return ArrayRemoveTransformOperation;
	}());
	/**
	 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
	 * transforms. Converts all field values to integers or doubles, but unlike the
	 * backend does not cap integer values at 2^63. Instead, JavaScript number
	 * arithmetic is used and precision loss can occur for values greater than 2^53.
	 */
	var NumericIncrementTransformOperation = /** @class */ (function () {
	    function NumericIncrementTransformOperation(operand) {
	        this.operand = operand;
	    }
	    NumericIncrementTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
	        var baseValue = this.computeBaseValue(previousValue);
	        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
	        // precision and resolves overflows by reducing precision, we do not
	        // manually cap overflows at 2^63.
	        // Return an integer value iff the previous value and the operand is an
	        // integer.
	        if (baseValue instanceof IntegerValue &&
	            this.operand instanceof IntegerValue) {
	            var sum = baseValue.internalValue + this.operand.internalValue;
	            return new IntegerValue(sum);
	        }
	        else {
	            var sum = baseValue.internalValue + this.operand.internalValue;
	            return new DoubleValue(sum);
	        }
	    };
	    NumericIncrementTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
	        assert(transformResult !== null, "Didn't receive transformResult for NUMERIC_ADD transform");
	        return transformResult;
	    };
	    /**
	     * Inspects the provided value, returning the provided value if it is already
	     * a NumberValue, otherwise returning a coerced IntegerValue of 0.
	     */
	    NumericIncrementTransformOperation.prototype.computeBaseValue = function (previousValue) {
	        return previousValue instanceof NumberValue
	            ? previousValue
	            : new IntegerValue(0);
	    };
	    NumericIncrementTransformOperation.prototype.isEqual = function (other) {
	        return (other instanceof NumericIncrementTransformOperation &&
	            this.operand.isEqual(other.operand));
	    };
	    return NumericIncrementTransformOperation;
	}());
	function coercedFieldValuesArray(value) {
	    if (value instanceof ArrayValue) {
	        return value.internalValue.slice();
	    }
	    else {
	        // coerce to empty array.
	        return [];
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ExistenceFilter = /** @class */ (function () {
	    // TODO(b/33078163): just use simplest form of existence filter for now
	    function ExistenceFilter(count) {
	        this.count = count;
	    }
	    ExistenceFilter.prototype.isEqual = function (other) {
	        return other && other.count === this.count;
	    };
	    return ExistenceFilter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DIRECTIONS = (function () {
	    var dirs = {};
	    dirs[Direction.ASCENDING.name] = 'ASCENDING';
	    dirs[Direction.DESCENDING.name] = 'DESCENDING';
	    return dirs;
	})();
	var OPERATORS = (function () {
	    var ops = {};
	    ops[Operator.LESS_THAN.name] = 'LESS_THAN';
	    ops[Operator.LESS_THAN_OR_EQUAL.name] = 'LESS_THAN_OR_EQUAL';
	    ops[Operator.GREATER_THAN.name] = 'GREATER_THAN';
	    ops[Operator.GREATER_THAN_OR_EQUAL.name] = 'GREATER_THAN_OR_EQUAL';
	    ops[Operator.EQUAL.name] = 'EQUAL';
	    ops[Operator.ARRAY_CONTAINS.name] = 'ARRAY_CONTAINS';
	    ops[Operator.IN.name] = 'IN';
	    ops[Operator.ARRAY_CONTAINS_ANY.name] = 'ARRAY_CONTAINS_ANY';
	    return ops;
	})();
	// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
	var ISO_REG_EXP = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
	function assertPresent(value, description) {
	    assert(!isNullOrUndefined(value), description + ' is missing');
	}
	function parseInt64(value) {
	    // TODO(bjornick): Handle int64 greater than 53 bits.
	    if (typeof value === 'number') {
	        return value;
	    }
	    else if (typeof value === 'string') {
	        return Number(value);
	    }
	    else {
	        return fail("can't parse " + value);
	    }
	}
	/**
	 * Generates JsonObject values for the Datastore API suitable for sending to
	 * either GRPC stub methods or via the JSON/HTTP REST API.
	 * TODO(klimt): We can remove the databaseId argument if we keep the full
	 * resource name in documents.
	 */
	var JsonProtoSerializer = /** @class */ (function () {
	    function JsonProtoSerializer(databaseId, options) {
	        this.databaseId = databaseId;
	        this.options = options;
	    }
	    JsonProtoSerializer.prototype.emptyByteString = function () {
	        if (this.options.useProto3Json) {
	            return '';
	        }
	        else {
	            return new Uint8Array(0);
	        }
	    };
	    JsonProtoSerializer.prototype.unsafeCastProtoByteString = function (byteString) {
	        // byteStrings can be either string or UInt8Array, but the typings say
	        // it's always a string. Cast as string to avoid type check failing
	        return byteString;
	    };
	    JsonProtoSerializer.prototype.fromRpcStatus = function (status) {
	        var code = status.code === undefined
	            ? Code.UNKNOWN
	            : mapCodeFromRpcCode(status.code);
	        return new FirestoreError(code, status.message || '');
	    };
	    /**
	     * Returns a value for a number (or null) that's appropriate to put into
	     * a google.protobuf.Int32Value proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "number" because that's what
	     * our generated proto interfaces say Int32Value must be. But GRPC actually
	     * expects a { value: <number> } struct.
	     */
	    JsonProtoSerializer.prototype.toInt32Value = function (val) {
	        if (this.options.useProto3Json || isNullOrUndefined(val)) {
	            return val;
	        }
	        else {
	            // ProtobufJS requires that we wrap Int32Values.
	            // Use any because we need to match generated Proto types.
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            return { value: val };
	        }
	    };
	    /**
	     * Returns a number (or null) from a google.protobuf.Int32Value proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as accepting "number" because that's what
	     * our generated proto interfaces say Int32Value must be, but it actually
	     * accepts { value: number } to match our serialization in toInt32Value().
	     */
	    JsonProtoSerializer.prototype.fromInt32Value = function (val) {
	        var result;
	        if (typeof val === 'object') {
	            // Use any because we need to match generated Proto types.
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            result = val.value;
	        }
	        else {
	            // We accept raw numbers (without the {value: ... } wrapper) for
	            // compatibility with legacy persisted data.
	            result = val;
	        }
	        return isNullOrUndefined(result) ? null : result;
	    };
	    /**
	     * Returns a value for a Date that's appropriate to put into a proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "string" because that's what
	     * our generated proto interfaces say dates must be. But it's easier and safer
	     * to actually return a Timestamp proto.
	     */
	    JsonProtoSerializer.prototype.toTimestamp = function (timestamp) {
	        if (this.options.useProto3Json) {
	            // Serialize to ISO-8601 date format, but with full nano resolution.
	            // Since JS Date has only millis, let's only use it for the seconds and
	            // then manually add the fractions to the end.
	            var jsDateStr = new Date(timestamp.seconds * 1000).toISOString();
	            // Remove .xxx frac part and Z in the end.
	            var strUntilSeconds = jsDateStr.replace(/\.\d*/, '').replace('Z', '');
	            // Pad the fraction out to 9 digits (nanos).
	            var nanoStr = ('000000000' + timestamp.nanoseconds).slice(-9);
	            return strUntilSeconds + "." + nanoStr + "Z";
	        }
	        else {
	            return {
	                seconds: '' + timestamp.seconds,
	                nanos: timestamp.nanoseconds
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            };
	        }
	    };
	    JsonProtoSerializer.prototype.fromTimestamp = function (date) {
	        // The json interface (for the browser) will return an iso timestamp string,
	        // while the proto js library (for node) will return a
	        // google.protobuf.Timestamp instance.
	        if (typeof date === 'string') {
	            // TODO(b/37282237): Use strings for Proto3 timestamps
	            // assert(this.options.useProto3Json,
	            //   'The timestamp string format requires Proto3.');
	            return this.fromIso8601String(date);
	        }
	        else {
	            assert(!!date, 'Cannot deserialize null or undefined timestamp.');
	            // TODO(b/37282237): Use strings for Proto3 timestamps
	            // assert(!this.options.useProto3Json,
	            //   'The timestamp instance format requires Proto JS.');
	            var seconds = parseInt64(date.seconds || '0');
	            var nanos = date.nanos || 0;
	            return new Timestamp(seconds, nanos);
	        }
	    };
	    JsonProtoSerializer.prototype.fromIso8601String = function (utc) {
	        // The date string can have higher precision (nanos) than the Date class
	        // (millis), so we do some custom parsing here.
	        // Parse the nanos right out of the string.
	        var nanos = 0;
	        var fraction = ISO_REG_EXP.exec(utc);
	        assert(!!fraction, 'invalid timestamp: ' + utc);
	        if (fraction[1]) {
	            // Pad the fraction out to 9 digits (nanos).
	            var nanoStr = fraction[1];
	            nanoStr = (nanoStr + '000000000').substr(0, 9);
	            nanos = Number(nanoStr);
	        }
	        // Parse the date to get the seconds.
	        var date = new Date(utc);
	        var seconds = Math.floor(date.getTime() / 1000);
	        return new Timestamp(seconds, nanos);
	    };
	    /**
	     * Returns a value for bytes that's appropriate to put in a proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "string" because that's what
	     * our generated proto interfaces say bytes must be. But it should return
	     * an Uint8Array in Node.
	     */
	    JsonProtoSerializer.prototype.toBytes = function (bytes) {
	        if (this.options.useProto3Json) {
	            return bytes.toBase64();
	        }
	        else {
	            // The typings say it's a string, but it needs to be a Uint8Array in Node.
	            return this.unsafeCastProtoByteString(bytes.toUint8Array());
	        }
	    };
	    /**
	     * Parse the blob from the protos into the internal Blob class. Note that the
	     * typings assume all blobs are strings, but they are actually Uint8Arrays
	     * on Node.
	     */
	    JsonProtoSerializer.prototype.fromBlob = function (blob) {
	        if (typeof blob === 'string') {
	            assert(this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
	            return Blob.fromBase64String(blob);
	        }
	        else {
	            assert(!this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
	            return Blob.fromUint8Array(blob);
	        }
	    };
	    JsonProtoSerializer.prototype.toVersion = function (version) {
	        return this.toTimestamp(version.toTimestamp());
	    };
	    JsonProtoSerializer.prototype.fromVersion = function (version) {
	        assert(!!version, "Trying to deserialize version that isn't set");
	        return SnapshotVersion.fromTimestamp(this.fromTimestamp(version));
	    };
	    JsonProtoSerializer.prototype.toResourceName = function (databaseId, path) {
	        return this.fullyQualifiedPrefixPath(databaseId)
	            .child('documents')
	            .child(path)
	            .canonicalString();
	    };
	    JsonProtoSerializer.prototype.fromResourceName = function (name) {
	        var resource = ResourcePath.fromString(name);
	        assert(this.isValidResourceName(resource), 'Tried to deserialize invalid key ' + resource.toString());
	        return resource;
	    };
	    JsonProtoSerializer.prototype.toName = function (key) {
	        return this.toResourceName(this.databaseId, key.path);
	    };
	    JsonProtoSerializer.prototype.fromName = function (name) {
	        var resource = this.fromResourceName(name);
	        assert(resource.get(1) === this.databaseId.projectId, 'Tried to deserialize key from different project: ' +
	            resource.get(1) +
	            ' vs ' +
	            this.databaseId.projectId);
	        assert((!resource.get(3) && !this.databaseId.database) ||
	            resource.get(3) === this.databaseId.database, 'Tried to deserialize key from different database: ' +
	            resource.get(3) +
	            ' vs ' +
	            this.databaseId.database);
	        return new DocumentKey(this.extractLocalPathFromResourceName(resource));
	    };
	    JsonProtoSerializer.prototype.toQueryPath = function (path) {
	        return this.toResourceName(this.databaseId, path);
	    };
	    JsonProtoSerializer.prototype.fromQueryPath = function (name) {
	        var resourceName = this.fromResourceName(name);
	        // In v1beta1 queries for collections at the root did not have a trailing
	        // "/documents". In v1 all resource paths contain "/documents". Preserve the
	        // ability to read the v1beta1 form for compatibility with queries persisted
	        // in the local target cache.
	        if (resourceName.length === 4) {
	            return ResourcePath.EMPTY_PATH;
	        }
	        return this.extractLocalPathFromResourceName(resourceName);
	    };
	    Object.defineProperty(JsonProtoSerializer.prototype, "encodedDatabaseId", {
	        get: function () {
	            var path = new ResourcePath([
	                'projects',
	                this.databaseId.projectId,
	                'databases',
	                this.databaseId.database
	            ]);
	            return path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    JsonProtoSerializer.prototype.fullyQualifiedPrefixPath = function (databaseId) {
	        return new ResourcePath([
	            'projects',
	            databaseId.projectId,
	            'databases',
	            databaseId.database
	        ]);
	    };
	    JsonProtoSerializer.prototype.extractLocalPathFromResourceName = function (resourceName) {
	        assert(resourceName.length > 4 && resourceName.get(4) === 'documents', 'tried to deserialize invalid key ' + resourceName.toString());
	        return resourceName.popFirst(5);
	    };
	    JsonProtoSerializer.prototype.isValidResourceName = function (path) {
	        // Resource names have at least 4 components (project ID, database ID)
	        return (path.length >= 4 &&
	            path.get(0) === 'projects' &&
	            path.get(2) === 'databases');
	    };
	    JsonProtoSerializer.prototype.toValue = function (val) {
	        if (val instanceof NullValue) {
	            return { nullValue: 'NULL_VALUE' };
	        }
	        else if (val instanceof BooleanValue) {
	            return { booleanValue: val.value() };
	        }
	        else if (val instanceof IntegerValue) {
	            return { integerValue: '' + val.value() };
	        }
	        else if (val instanceof DoubleValue) {
	            var doubleValue = val.value();
	            if (this.options.useProto3Json) {
	                // Proto 3 let's us encode NaN and Infinity as string values as
	                // expected by the backend. This is currently not checked by our unit
	                // tests because they rely on protobuf.js.
	                if (isNaN(doubleValue)) {
	                    return { doubleValue: 'NaN' };
	                }
	                else if (doubleValue === Infinity) {
	                    return { doubleValue: 'Infinity' };
	                }
	                else if (doubleValue === -Infinity) {
	                    return { doubleValue: '-Infinity' };
	                }
	            }
	            return { doubleValue: val.value() };
	        }
	        else if (val instanceof StringValue) {
	            return { stringValue: val.value() };
	        }
	        else if (val instanceof ObjectValue) {
	            return { mapValue: this.toMapValue(val) };
	        }
	        else if (val instanceof ArrayValue) {
	            return { arrayValue: this.toArrayValue(val) };
	        }
	        else if (val instanceof TimestampValue) {
	            return {
	                timestampValue: this.toTimestamp(val.internalValue)
	            };
	        }
	        else if (val instanceof GeoPointValue) {
	            return {
	                geoPointValue: {
	                    latitude: val.value().latitude,
	                    longitude: val.value().longitude
	                }
	            };
	        }
	        else if (val instanceof BlobValue) {
	            return {
	                bytesValue: this.toBytes(val.value())
	            };
	        }
	        else if (val instanceof RefValue) {
	            return {
	                referenceValue: this.toResourceName(val.databaseId, val.key.path)
	            };
	        }
	        else {
	            return fail('Unknown FieldValue ' + JSON.stringify(val));
	        }
	    };
	    JsonProtoSerializer.prototype.fromValue = function (obj) {
	        var _this = this;
	        if ('nullValue' in obj) {
	            return NullValue.INSTANCE;
	        }
	        else if ('booleanValue' in obj) {
	            return BooleanValue.of(obj.booleanValue);
	        }
	        else if ('integerValue' in obj) {
	            return new IntegerValue(parseInt64(obj.integerValue));
	        }
	        else if ('doubleValue' in obj) {
	            if (this.options.useProto3Json) {
	                // Proto 3 uses the string values 'NaN' and 'Infinity'.
	                if (obj.doubleValue === 'NaN') {
	                    return DoubleValue.NAN;
	                }
	                else if (obj.doubleValue === 'Infinity') {
	                    return DoubleValue.POSITIVE_INFINITY;
	                }
	                else if (obj.doubleValue === '-Infinity') {
	                    return DoubleValue.NEGATIVE_INFINITY;
	                }
	            }
	            return new DoubleValue(obj.doubleValue);
	        }
	        else if ('stringValue' in obj) {
	            return new StringValue(obj.stringValue);
	        }
	        else if ('mapValue' in obj) {
	            return this.fromFields(obj.mapValue.fields || {});
	        }
	        else if ('arrayValue' in obj) {
	            // "values" is not present if the array is empty
	            assertPresent(obj.arrayValue, 'arrayValue');
	            var values = obj.arrayValue.values || [];
	            return new ArrayValue(values.map(function (v) { return _this.fromValue(v); }));
	        }
	        else if ('timestampValue' in obj) {
	            assertPresent(obj.timestampValue, 'timestampValue');
	            return new TimestampValue(this.fromTimestamp(obj.timestampValue));
	        }
	        else if ('geoPointValue' in obj) {
	            assertPresent(obj.geoPointValue, 'geoPointValue');
	            var latitude = obj.geoPointValue.latitude || 0;
	            var longitude = obj.geoPointValue.longitude || 0;
	            return new GeoPointValue(new GeoPoint(latitude, longitude));
	        }
	        else if ('bytesValue' in obj) {
	            assertPresent(obj.bytesValue, 'bytesValue');
	            var blob = this.fromBlob(obj.bytesValue);
	            return new BlobValue(blob);
	        }
	        else if ('referenceValue' in obj) {
	            assertPresent(obj.referenceValue, 'referenceValue');
	            var resourceName = this.fromResourceName(obj.referenceValue);
	            var dbId = new DatabaseId(resourceName.get(1), resourceName.get(3));
	            var key = new DocumentKey(this.extractLocalPathFromResourceName(resourceName));
	            return new RefValue(dbId, key);
	        }
	        else {
	            return fail('Unknown Value proto ' + JSON.stringify(obj));
	        }
	    };
	    /** Creates an api.Document from key and fields (but no create/update time) */
	    JsonProtoSerializer.prototype.toMutationDocument = function (key, fields) {
	        return {
	            name: this.toName(key),
	            fields: this.toFields(fields)
	        };
	    };
	    JsonProtoSerializer.prototype.toDocument = function (document) {
	        assert(!document.hasLocalMutations, "Can't serialize documents with mutations.");
	        return {
	            name: this.toName(document.key),
	            fields: this.toFields(document.data()),
	            updateTime: this.toTimestamp(document.version.toTimestamp())
	        };
	    };
	    JsonProtoSerializer.prototype.fromDocument = function (document, hasCommittedMutations) {
	        var _this = this;
	        var key = this.fromName(document.name);
	        var version = this.fromVersion(document.updateTime);
	        return new Document(key, version, { hasCommittedMutations: !!hasCommittedMutations }, undefined, document, function (v) { return _this.fromValue(v); });
	    };
	    JsonProtoSerializer.prototype.toFields = function (fields) {
	        var _this = this;
	        var result = {};
	        fields.forEach(function (key, value) {
	            result[key] = _this.toValue(value);
	        });
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromFields = function (object) {
	        var _this = this;
	        // Proto map<string, Value> gets mapped to Object, so cast it.
	        var map = object;
	        var result = ObjectValue.EMPTY;
	        forEach(map, function (key, value) {
	            result = result.set(new FieldPath([key]), _this.fromValue(value));
	        });
	        return result;
	    };
	    JsonProtoSerializer.prototype.toMapValue = function (map) {
	        return {
	            fields: this.toFields(map)
	        };
	    };
	    JsonProtoSerializer.prototype.toArrayValue = function (array) {
	        var _this = this;
	        var result = [];
	        array.forEach(function (value) {
	            result.push(_this.toValue(value));
	        });
	        return { values: result };
	    };
	    JsonProtoSerializer.prototype.fromFound = function (doc) {
	        var _this = this;
	        assert(!!doc.found, 'Tried to deserialize a found document from a missing document.');
	        assertPresent(doc.found.name, 'doc.found.name');
	        assertPresent(doc.found.updateTime, 'doc.found.updateTime');
	        var key = this.fromName(doc.found.name);
	        var version = this.fromVersion(doc.found.updateTime);
	        return new Document(key, version, {}, undefined, doc.found, function (v) {
	            return _this.fromValue(v);
	        });
	    };
	    JsonProtoSerializer.prototype.fromMissing = function (result) {
	        assert(!!result.missing, 'Tried to deserialize a missing document from a found document.');
	        assert(!!result.readTime, 'Tried to deserialize a missing document without a read time.');
	        var key = this.fromName(result.missing);
	        var version = this.fromVersion(result.readTime);
	        return new NoDocument(key, version);
	    };
	    JsonProtoSerializer.prototype.fromMaybeDocument = function (result) {
	        if ('found' in result) {
	            return this.fromFound(result);
	        }
	        else if ('missing' in result) {
	            return this.fromMissing(result);
	        }
	        return fail('invalid batch get response: ' + JSON.stringify(result));
	    };
	    JsonProtoSerializer.prototype.toWatchTargetChangeState = function (state) {
	        switch (state) {
	            case WatchTargetChangeState.Added:
	                return 'ADD';
	            case WatchTargetChangeState.Current:
	                return 'CURRENT';
	            case WatchTargetChangeState.NoChange:
	                return 'NO_CHANGE';
	            case WatchTargetChangeState.Removed:
	                return 'REMOVE';
	            case WatchTargetChangeState.Reset:
	                return 'RESET';
	            default:
	                return fail('Unknown WatchTargetChangeState: ' + state);
	        }
	    };
	    JsonProtoSerializer.prototype.toTestWatchChange = function (watchChange) {
	        if (watchChange instanceof ExistenceFilterChange) {
	            return {
	                filter: {
	                    count: watchChange.existenceFilter.count,
	                    targetId: watchChange.targetId
	                }
	            };
	        }
	        if (watchChange instanceof DocumentWatchChange) {
	            if (watchChange.newDoc instanceof Document) {
	                var doc = watchChange.newDoc;
	                return {
	                    documentChange: {
	                        document: {
	                            name: this.toName(doc.key),
	                            fields: this.toFields(doc.data()),
	                            updateTime: this.toVersion(doc.version)
	                        },
	                        targetIds: watchChange.updatedTargetIds,
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	            else if (watchChange.newDoc instanceof NoDocument) {
	                var doc = watchChange.newDoc;
	                return {
	                    documentDelete: {
	                        document: this.toName(doc.key),
	                        readTime: this.toVersion(doc.version),
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	            else if (watchChange.newDoc === null) {
	                return {
	                    documentRemove: {
	                        document: this.toName(watchChange.key),
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	        }
	        if (watchChange instanceof WatchTargetChange) {
	            var cause = undefined;
	            if (watchChange.cause) {
	                cause = {
	                    code: mapRpcCodeFromCode(watchChange.cause.code),
	                    message: watchChange.cause.message
	                };
	            }
	            return {
	                targetChange: {
	                    targetChangeType: this.toWatchTargetChangeState(watchChange.state),
	                    targetIds: watchChange.targetIds,
	                    resumeToken: this.unsafeCastProtoByteString(watchChange.resumeToken),
	                    cause: cause
	                }
	            };
	        }
	        return fail('Unrecognized watch change: ' + JSON.stringify(watchChange));
	    };
	    JsonProtoSerializer.prototype.fromWatchChange = function (change) {
	        var _this = this;
	        var watchChange;
	        if ('targetChange' in change) {
	            assertPresent(change.targetChange, 'targetChange');
	            // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
	            // if unset
	            var state = this.fromWatchTargetChangeState(change.targetChange.targetChangeType || 'NO_CHANGE');
	            var targetIds = change.targetChange.targetIds || [];
	            var resumeToken = change.targetChange.resumeToken || this.emptyByteString();
	            var causeProto = change.targetChange.cause;
	            var cause = causeProto && this.fromRpcStatus(causeProto);
	            watchChange = new WatchTargetChange(state, targetIds, resumeToken, cause || null);
	        }
	        else if ('documentChange' in change) {
	            assertPresent(change.documentChange, 'documentChange');
	            var entityChange = change.documentChange;
	            assertPresent(entityChange.document, 'documentChange.name');
	            assertPresent(entityChange.document.name, 'documentChange.document.name');
	            assertPresent(entityChange.document.updateTime, 'documentChange.document.updateTime');
	            var key = this.fromName(entityChange.document.name);
	            var version = this.fromVersion(entityChange.document.updateTime);
	            var doc = new Document(key, version, {}, undefined, entityChange.document, function (v) { return _this.fromValue(v); });
	            var updatedTargetIds = entityChange.targetIds || [];
	            var removedTargetIds = entityChange.removedTargetIds || [];
	            watchChange = new DocumentWatchChange(updatedTargetIds, removedTargetIds, doc.key, doc);
	        }
	        else if ('documentDelete' in change) {
	            assertPresent(change.documentDelete, 'documentDelete');
	            var docDelete = change.documentDelete;
	            assertPresent(docDelete.document, 'documentDelete.document');
	            var key = this.fromName(docDelete.document);
	            var version = docDelete.readTime
	                ? this.fromVersion(docDelete.readTime)
	                : SnapshotVersion.forDeletedDoc();
	            var doc = new NoDocument(key, version);
	            var removedTargetIds = docDelete.removedTargetIds || [];
	            watchChange = new DocumentWatchChange([], removedTargetIds, doc.key, doc);
	        }
	        else if ('documentRemove' in change) {
	            assertPresent(change.documentRemove, 'documentRemove');
	            var docRemove = change.documentRemove;
	            assertPresent(docRemove.document, 'documentRemove');
	            var key = this.fromName(docRemove.document);
	            var removedTargetIds = docRemove.removedTargetIds || [];
	            watchChange = new DocumentWatchChange([], removedTargetIds, key, null);
	        }
	        else if ('filter' in change) {
	            // TODO(dimond): implement existence filter parsing with strategy.
	            assertPresent(change.filter, 'filter');
	            var filter = change.filter;
	            assertPresent(filter.targetId, 'filter.targetId');
	            var count = filter.count || 0;
	            var existenceFilter = new ExistenceFilter(count);
	            var targetId = filter.targetId;
	            watchChange = new ExistenceFilterChange(targetId, existenceFilter);
	        }
	        else {
	            return fail('Unknown change type ' + JSON.stringify(change));
	        }
	        return watchChange;
	    };
	    JsonProtoSerializer.prototype.fromWatchTargetChangeState = function (state) {
	        if (state === 'NO_CHANGE') {
	            return WatchTargetChangeState.NoChange;
	        }
	        else if (state === 'ADD') {
	            return WatchTargetChangeState.Added;
	        }
	        else if (state === 'REMOVE') {
	            return WatchTargetChangeState.Removed;
	        }
	        else if (state === 'CURRENT') {
	            return WatchTargetChangeState.Current;
	        }
	        else if (state === 'RESET') {
	            return WatchTargetChangeState.Reset;
	        }
	        else {
	            return fail('Got unexpected TargetChange.state: ' + state);
	        }
	    };
	    JsonProtoSerializer.prototype.versionFromListenResponse = function (change) {
	        // We have only reached a consistent snapshot for the entire stream if there
	        // is a read_time set and it applies to all targets (i.e. the list of
	        // targets is empty). The backend is guaranteed to send such responses.
	        if (!('targetChange' in change)) {
	            return SnapshotVersion.MIN;
	        }
	        var targetChange = change.targetChange;
	        if (targetChange.targetIds && targetChange.targetIds.length) {
	            return SnapshotVersion.MIN;
	        }
	        if (!targetChange.readTime) {
	            return SnapshotVersion.MIN;
	        }
	        return this.fromVersion(targetChange.readTime);
	    };
	    JsonProtoSerializer.prototype.toMutation = function (mutation) {
	        var _this = this;
	        var result;
	        if (mutation instanceof SetMutation) {
	            result = {
	                update: this.toMutationDocument(mutation.key, mutation.value)
	            };
	        }
	        else if (mutation instanceof DeleteMutation) {
	            result = { delete: this.toName(mutation.key) };
	        }
	        else if (mutation instanceof PatchMutation) {
	            result = {
	                update: this.toMutationDocument(mutation.key, mutation.data),
	                updateMask: this.toDocumentMask(mutation.fieldMask)
	            };
	        }
	        else if (mutation instanceof TransformMutation) {
	            result = {
	                transform: {
	                    document: this.toName(mutation.key),
	                    fieldTransforms: mutation.fieldTransforms.map(function (transform) {
	                        return _this.toFieldTransform(transform);
	                    })
	                }
	            };
	        }
	        else if (mutation instanceof VerifyMutation) {
	            result = {
	                verify: this.toName(mutation.key)
	            };
	        }
	        else {
	            return fail('Unknown mutation type ' + mutation.type);
	        }
	        if (!mutation.precondition.isNone) {
	            result.currentDocument = this.toPrecondition(mutation.precondition);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromMutation = function (proto) {
	        var _this = this;
	        var precondition = proto.currentDocument
	            ? this.fromPrecondition(proto.currentDocument)
	            : Precondition.NONE;
	        if (proto.update) {
	            assertPresent(proto.update.name, 'name');
	            var key = this.fromName(proto.update.name);
	            var value = this.fromFields(proto.update.fields || {});
	            if (proto.updateMask) {
	                var fieldMask = this.fromDocumentMask(proto.updateMask);
	                return new PatchMutation(key, value, fieldMask, precondition);
	            }
	            else {
	                return new SetMutation(key, value, precondition);
	            }
	        }
	        else if (proto.delete) {
	            var key = this.fromName(proto.delete);
	            return new DeleteMutation(key, precondition);
	        }
	        else if (proto.transform) {
	            var key = this.fromName(proto.transform.document);
	            var fieldTransforms = proto.transform.fieldTransforms.map(function (transform) {
	                return _this.fromFieldTransform(transform);
	            });
	            assert(precondition.exists === true, 'Transforms only support precondition "exists == true"');
	            return new TransformMutation(key, fieldTransforms);
	        }
	        else if (proto.verify) {
	            var key = this.fromName(proto.verify);
	            return new VerifyMutation(key, precondition);
	        }
	        else {
	            return fail('unknown mutation proto: ' + JSON.stringify(proto));
	        }
	    };
	    JsonProtoSerializer.prototype.toPrecondition = function (precondition) {
	        assert(!precondition.isNone, "Can't serialize an empty precondition");
	        if (precondition.updateTime !== undefined) {
	            return {
	                updateTime: this.toVersion(precondition.updateTime)
	            };
	        }
	        else if (precondition.exists !== undefined) {
	            return { exists: precondition.exists };
	        }
	        else {
	            return fail('Unknown precondition');
	        }
	    };
	    JsonProtoSerializer.prototype.fromPrecondition = function (precondition) {
	        if (precondition.updateTime !== undefined) {
	            return Precondition.updateTime(this.fromVersion(precondition.updateTime));
	        }
	        else if (precondition.exists !== undefined) {
	            return Precondition.exists(precondition.exists);
	        }
	        else {
	            return Precondition.NONE;
	        }
	    };
	    JsonProtoSerializer.prototype.fromWriteResult = function (proto, commitTime) {
	        var _this = this;
	        // NOTE: Deletes don't have an updateTime.
	        var version = proto.updateTime
	            ? this.fromVersion(proto.updateTime)
	            : this.fromVersion(commitTime);
	        if (version.isEqual(SnapshotVersion.MIN)) {
	            // The Firestore Emulator currently returns an update time of 0 for
	            // deletes of non-existing documents (rather than null). This breaks the
	            // test "get deleted doc while offline with source=cache" as NoDocuments
	            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
	            // TODO(#2149): Remove this when Emulator is fixed
	            version = this.fromVersion(commitTime);
	        }
	        var transformResults = null;
	        if (proto.transformResults && proto.transformResults.length > 0) {
	            transformResults = proto.transformResults.map(function (result) {
	                return _this.fromValue(result);
	            });
	        }
	        return new MutationResult(version, transformResults);
	    };
	    JsonProtoSerializer.prototype.fromWriteResults = function (protos, commitTime) {
	        var _this = this;
	        if (protos && protos.length > 0) {
	            assert(commitTime !== undefined, 'Received a write result without a commit time');
	            return protos.map(function (proto) { return _this.fromWriteResult(proto, commitTime); });
	        }
	        else {
	            return [];
	        }
	    };
	    JsonProtoSerializer.prototype.toFieldTransform = function (fieldTransform) {
	        var _this = this;
	        var transform = fieldTransform.transform;
	        if (transform instanceof ServerTimestampTransform) {
	            return {
	                fieldPath: fieldTransform.field.canonicalString(),
	                setToServerValue: 'REQUEST_TIME'
	            };
	        }
	        else if (transform instanceof ArrayUnionTransformOperation) {
	            return {
	                fieldPath: fieldTransform.field.canonicalString(),
	                appendMissingElements: {
	                    values: transform.elements.map(function (v) { return _this.toValue(v); })
	                }
	            };
	        }
	        else if (transform instanceof ArrayRemoveTransformOperation) {
	            return {
	                fieldPath: fieldTransform.field.canonicalString(),
	                removeAllFromArray: {
	                    values: transform.elements.map(function (v) { return _this.toValue(v); })
	                }
	            };
	        }
	        else if (transform instanceof NumericIncrementTransformOperation) {
	            return {
	                fieldPath: fieldTransform.field.canonicalString(),
	                increment: this.toValue(transform.operand)
	            };
	        }
	        else {
	            throw fail('Unknown transform: ' + fieldTransform.transform);
	        }
	    };
	    JsonProtoSerializer.prototype.fromFieldTransform = function (proto) {
	        var _this = this;
	        var transform = null;
	        if ('setToServerValue' in proto) {
	            assert(proto.setToServerValue === 'REQUEST_TIME', 'Unknown server value transform proto: ' + JSON.stringify(proto));
	            transform = ServerTimestampTransform.instance;
	        }
	        else if ('appendMissingElements' in proto) {
	            var values = proto.appendMissingElements.values || [];
	            transform = new ArrayUnionTransformOperation(values.map(function (v) { return _this.fromValue(v); }));
	        }
	        else if ('removeAllFromArray' in proto) {
	            var values = proto.removeAllFromArray.values || [];
	            transform = new ArrayRemoveTransformOperation(values.map(function (v) { return _this.fromValue(v); }));
	        }
	        else if ('increment' in proto) {
	            var operand = this.fromValue(proto.increment);
	            assert(operand instanceof NumberValue, 'NUMERIC_ADD transform requires a NumberValue');
	            transform = new NumericIncrementTransformOperation(operand);
	        }
	        else {
	            fail('Unknown transform proto: ' + JSON.stringify(proto));
	        }
	        var fieldPath = FieldPath.fromServerFormat(proto.fieldPath);
	        return new FieldTransform(fieldPath, transform);
	    };
	    JsonProtoSerializer.prototype.toDocumentsTarget = function (target) {
	        return { documents: [this.toQueryPath(target.path)] };
	    };
	    JsonProtoSerializer.prototype.fromDocumentsTarget = function (documentsTarget) {
	        var count = documentsTarget.documents.length;
	        assert(count === 1, 'DocumentsTarget contained other than 1 document: ' + count);
	        var name = documentsTarget.documents[0];
	        return Query.atPath(this.fromQueryPath(name)).toTarget();
	    };
	    JsonProtoSerializer.prototype.toQueryTarget = function (target) {
	        // Dissect the path into parent, collectionId, and optional key filter.
	        var result = { structuredQuery: {} };
	        var path = target.path;
	        if (target.collectionGroup !== null) {
	            assert(path.length % 2 === 0, 'Collection Group queries should be within a document path or root.');
	            result.parent = this.toQueryPath(path);
	            result.structuredQuery.from = [
	                {
	                    collectionId: target.collectionGroup,
	                    allDescendants: true
	                }
	            ];
	        }
	        else {
	            assert(path.length % 2 !== 0, 'Document queries with filters are not supported.');
	            result.parent = this.toQueryPath(path.popLast());
	            result.structuredQuery.from = [{ collectionId: path.lastSegment() }];
	        }
	        var where = this.toFilter(target.filters);
	        if (where) {
	            result.structuredQuery.where = where;
	        }
	        var orderBy = this.toOrder(target.orderBy);
	        if (orderBy) {
	            result.structuredQuery.orderBy = orderBy;
	        }
	        var limit = this.toInt32Value(target.limit);
	        if (limit !== null) {
	            result.structuredQuery.limit = limit;
	        }
	        if (target.startAt) {
	            result.structuredQuery.startAt = this.toCursor(target.startAt);
	        }
	        if (target.endAt) {
	            result.structuredQuery.endAt = this.toCursor(target.endAt);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromQueryTarget = function (target) {
	        var path = this.fromQueryPath(target.parent);
	        var query = target.structuredQuery;
	        var fromCount = query.from ? query.from.length : 0;
	        var collectionGroup = null;
	        if (fromCount > 0) {
	            assert(fromCount === 1, 'StructuredQuery.from with more than one collection is not supported.');
	            var from = query.from[0];
	            if (from.allDescendants) {
	                collectionGroup = from.collectionId;
	            }
	            else {
	                path = path.child(from.collectionId);
	            }
	        }
	        var filterBy = [];
	        if (query.where) {
	            filterBy = this.fromFilter(query.where);
	        }
	        var orderBy = [];
	        if (query.orderBy) {
	            orderBy = this.fromOrder(query.orderBy);
	        }
	        var limit = null;
	        if (query.limit) {
	            limit = this.fromInt32Value(query.limit);
	        }
	        var startAt = null;
	        if (query.startAt) {
	            startAt = this.fromCursor(query.startAt);
	        }
	        var endAt = null;
	        if (query.endAt) {
	            endAt = this.fromCursor(query.endAt);
	        }
	        return new Query(path, collectionGroup, orderBy, filterBy, limit, LimitType.First, startAt, endAt).toTarget();
	    };
	    JsonProtoSerializer.prototype.toListenRequestLabels = function (targetData) {
	        var value = this.toLabel(targetData.purpose);
	        if (value == null) {
	            return null;
	        }
	        else {
	            return {
	                'goog-listen-tags': value
	            };
	        }
	    };
	    JsonProtoSerializer.prototype.toLabel = function (purpose) {
	        switch (purpose) {
	            case TargetPurpose.Listen:
	                return null;
	            case TargetPurpose.ExistenceFilterMismatch:
	                return 'existence-filter-mismatch';
	            case TargetPurpose.LimboResolution:
	                return 'limbo-document';
	            default:
	                return fail('Unrecognized query purpose: ' + purpose);
	        }
	    };
	    JsonProtoSerializer.prototype.toTarget = function (targetData) {
	        var result;
	        var target = targetData.target;
	        if (target.isDocumentQuery()) {
	            result = { documents: this.toDocumentsTarget(target) };
	        }
	        else {
	            result = { query: this.toQueryTarget(target) };
	        }
	        result.targetId = targetData.targetId;
	        if (targetData.resumeToken.length > 0) {
	            result.resumeToken = this.unsafeCastProtoByteString(targetData.resumeToken);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.toFilter = function (filters) {
	        var _this = this;
	        if (filters.length === 0) {
	            return;
	        }
	        var protos = filters.map(function (filter) {
	            if (filter instanceof FieldFilter) {
	                return _this.toUnaryOrFieldFilter(filter);
	            }
	            else {
	                return fail('Unrecognized filter: ' + JSON.stringify(filter));
	            }
	        });
	        if (protos.length === 1) {
	            return protos[0];
	        }
	        return { compositeFilter: { op: 'AND', filters: protos } };
	    };
	    JsonProtoSerializer.prototype.fromFilter = function (filter) {
	        var _this = this;
	        if (!filter) {
	            return [];
	        }
	        else if (filter.unaryFilter !== undefined) {
	            return [this.fromUnaryFilter(filter)];
	        }
	        else if (filter.fieldFilter !== undefined) {
	            return [this.fromFieldFilter(filter)];
	        }
	        else if (filter.compositeFilter !== undefined) {
	            return filter.compositeFilter
	                .filters.map(function (f) { return _this.fromFilter(f); })
	                .reduce(function (accum, current) { return accum.concat(current); });
	        }
	        else {
	            return fail('Unknown filter: ' + JSON.stringify(filter));
	        }
	    };
	    JsonProtoSerializer.prototype.toOrder = function (orderBys) {
	        var _this = this;
	        if (orderBys.length === 0) {
	            return;
	        }
	        return orderBys.map(function (order) { return _this.toPropertyOrder(order); });
	    };
	    JsonProtoSerializer.prototype.fromOrder = function (orderBys) {
	        var _this = this;
	        return orderBys.map(function (order) { return _this.fromPropertyOrder(order); });
	    };
	    JsonProtoSerializer.prototype.toCursor = function (cursor) {
	        var _this = this;
	        return {
	            before: cursor.before,
	            values: cursor.position.map(function (component) { return _this.toValue(component); })
	        };
	    };
	    JsonProtoSerializer.prototype.fromCursor = function (cursor) {
	        var _this = this;
	        var before = !!cursor.before;
	        var position = cursor.values.map(function (component) { return _this.fromValue(component); });
	        return new Bound(position, before);
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toDirection = function (dir) {
	        return DIRECTIONS[dir.name];
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.fromDirection = function (dir) {
	        switch (dir) {
	            case 'ASCENDING':
	                return Direction.ASCENDING;
	            case 'DESCENDING':
	                return Direction.DESCENDING;
	            default:
	                return undefined;
	        }
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toOperatorName = function (op) {
	        return OPERATORS[op.name];
	    };
	    JsonProtoSerializer.prototype.fromOperatorName = function (op) {
	        switch (op) {
	            case 'EQUAL':
	                return Operator.EQUAL;
	            case 'GREATER_THAN':
	                return Operator.GREATER_THAN;
	            case 'GREATER_THAN_OR_EQUAL':
	                return Operator.GREATER_THAN_OR_EQUAL;
	            case 'LESS_THAN':
	                return Operator.LESS_THAN;
	            case 'LESS_THAN_OR_EQUAL':
	                return Operator.LESS_THAN_OR_EQUAL;
	            case 'ARRAY_CONTAINS':
	                return Operator.ARRAY_CONTAINS;
	            case 'IN':
	                return Operator.IN;
	            case 'ARRAY_CONTAINS_ANY':
	                return Operator.ARRAY_CONTAINS_ANY;
	            case 'OPERATOR_UNSPECIFIED':
	                return fail('Unspecified operator');
	            default:
	                return fail('Unknown operator');
	        }
	    };
	    JsonProtoSerializer.prototype.toFieldPathReference = function (path) {
	        return { fieldPath: path.canonicalString() };
	    };
	    JsonProtoSerializer.prototype.fromFieldPathReference = function (fieldReference) {
	        return FieldPath.fromServerFormat(fieldReference.fieldPath);
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toPropertyOrder = function (orderBy) {
	        return {
	            field: this.toFieldPathReference(orderBy.field),
	            direction: this.toDirection(orderBy.dir)
	        };
	    };
	    JsonProtoSerializer.prototype.fromPropertyOrder = function (orderBy) {
	        return new OrderBy(this.fromFieldPathReference(orderBy.field), this.fromDirection(orderBy.direction));
	    };
	    JsonProtoSerializer.prototype.fromFieldFilter = function (filter) {
	        return FieldFilter.create(this.fromFieldPathReference(filter.fieldFilter.field), this.fromOperatorName(filter.fieldFilter.op), this.fromValue(filter.fieldFilter.value));
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toUnaryOrFieldFilter = function (filter) {
	        if (filter.op === Operator.EQUAL) {
	            if (filter.value.isEqual(DoubleValue.NAN)) {
	                return {
	                    unaryFilter: {
	                        field: this.toFieldPathReference(filter.field),
	                        op: 'IS_NAN'
	                    }
	                };
	            }
	            else if (filter.value.isEqual(NullValue.INSTANCE)) {
	                return {
	                    unaryFilter: {
	                        field: this.toFieldPathReference(filter.field),
	                        op: 'IS_NULL'
	                    }
	                };
	            }
	        }
	        return {
	            fieldFilter: {
	                field: this.toFieldPathReference(filter.field),
	                op: this.toOperatorName(filter.op),
	                value: this.toValue(filter.value)
	            }
	        };
	    };
	    JsonProtoSerializer.prototype.fromUnaryFilter = function (filter) {
	        switch (filter.unaryFilter.op) {
	            case 'IS_NAN':
	                var nanField = this.fromFieldPathReference(filter.unaryFilter.field);
	                return FieldFilter.create(nanField, Operator.EQUAL, DoubleValue.NAN);
	            case 'IS_NULL':
	                var nullField = this.fromFieldPathReference(filter.unaryFilter.field);
	                return FieldFilter.create(nullField, Operator.EQUAL, NullValue.INSTANCE);
	            case 'OPERATOR_UNSPECIFIED':
	                return fail('Unspecified filter');
	            default:
	                return fail('Unknown filter');
	        }
	    };
	    JsonProtoSerializer.prototype.toDocumentMask = function (fieldMask) {
	        var canonicalFields = [];
	        fieldMask.fields.forEach(function (field) {
	            return canonicalFields.push(field.canonicalString());
	        });
	        return {
	            fieldPaths: canonicalFields
	        };
	    };
	    JsonProtoSerializer.prototype.fromDocumentMask = function (proto) {
	        var paths = proto.fieldPaths || [];
	        var fields = paths.map(function (path) { return FieldPath.fromServerFormat(path); });
	        return FieldMask.fromArray(fields);
	    };
	    return JsonProtoSerializer;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Holds the listeners and the last received ViewSnapshot for a query being
	 * tracked by EventManager.
	 */
	var QueryListenersInfo = /** @class */ (function () {
	    function QueryListenersInfo() {
	        this.viewSnap = null;
	        this.targetId = 0;
	        this.listeners = [];
	    }
	    return QueryListenersInfo;
	}());
	/**
	 * EventManager is responsible for mapping queries to query event emitters.
	 * It handles "fan-out". -- Identical queries will re-use the same watch on the
	 * backend.
	 */
	var EventManager = /** @class */ (function () {
	    function EventManager(syncEngine) {
	        this.syncEngine = syncEngine;
	        this.queries = new ObjectMap(function (q) {
	            return q.canonicalId();
	        });
	        this.onlineState = OnlineState.Unknown;
	        this.snapshotsInSyncListeners = new Set();
	        this.syncEngine.subscribe(this);
	    }
	    EventManager.prototype.listen = function (listener) {
	        var query = listener.query;
	        var firstListen = false;
	        var queryInfo = this.queries.get(query);
	        if (!queryInfo) {
	            firstListen = true;
	            queryInfo = new QueryListenersInfo();
	            this.queries.set(query, queryInfo);
	        }
	        queryInfo.listeners.push(listener);
	        // Run global snapshot listeners if a consistent snapshot has been emitted.
	        var raisedEvent = listener.applyOnlineStateChange(this.onlineState);
	        assert(!raisedEvent, "applyOnlineStateChange() shouldn't raise an event for brand-new listeners.");
	        if (queryInfo.viewSnap) {
	            var raisedEvent_1 = listener.onViewSnapshot(queryInfo.viewSnap);
	            if (raisedEvent_1) {
	                this.raiseSnapshotsInSyncEvent();
	            }
	        }
	        if (firstListen) {
	            return this.syncEngine.listen(query).then(function (targetId) {
	                queryInfo.targetId = targetId;
	                return targetId;
	            });
	        }
	        else {
	            return Promise.resolve(queryInfo.targetId);
	        }
	    };
	    EventManager.prototype.unlisten = function (listener) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var query, lastListen, queryInfo, i;
	            return tslib.__generator(this, function (_a) {
	                query = listener.query;
	                lastListen = false;
	                queryInfo = this.queries.get(query);
	                if (queryInfo) {
	                    i = queryInfo.listeners.indexOf(listener);
	                    if (i >= 0) {
	                        queryInfo.listeners.splice(i, 1);
	                        lastListen = queryInfo.listeners.length === 0;
	                    }
	                }
	                if (lastListen) {
	                    this.queries.delete(query);
	                    return [2 /*return*/, this.syncEngine.unlisten(query)];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    EventManager.prototype.onWatchChange = function (viewSnaps) {
	        var raisedEvent = false;
	        for (var _i = 0, viewSnaps_1 = viewSnaps; _i < viewSnaps_1.length; _i++) {
	            var viewSnap = viewSnaps_1[_i];
	            var query = viewSnap.query;
	            var queryInfo = this.queries.get(query);
	            if (queryInfo) {
	                for (var _a = 0, _b = queryInfo.listeners; _a < _b.length; _a++) {
	                    var listener = _b[_a];
	                    if (listener.onViewSnapshot(viewSnap)) {
	                        raisedEvent = true;
	                    }
	                }
	                queryInfo.viewSnap = viewSnap;
	            }
	        }
	        if (raisedEvent) {
	            this.raiseSnapshotsInSyncEvent();
	        }
	    };
	    EventManager.prototype.onWatchError = function (query, error) {
	        var queryInfo = this.queries.get(query);
	        if (queryInfo) {
	            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
	                var listener = _a[_i];
	                listener.onError(error);
	            }
	        }
	        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
	        // after an error.
	        this.queries.delete(query);
	    };
	    EventManager.prototype.onOnlineStateChange = function (onlineState) {
	        this.onlineState = onlineState;
	        var raisedEvent = false;
	        this.queries.forEach(function (_, queryInfo) {
	            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
	                var listener = _a[_i];
	                // Run global snapshot listeners if a consistent snapshot has been emitted.
	                if (listener.applyOnlineStateChange(onlineState)) {
	                    raisedEvent = true;
	                }
	            }
	        });
	        if (raisedEvent) {
	            this.raiseSnapshotsInSyncEvent();
	        }
	    };
	    EventManager.prototype.addSnapshotsInSyncListener = function (observer) {
	        this.snapshotsInSyncListeners.add(observer);
	        // Immediately fire an initial event, indicating all existing listeners
	        // are in-sync.
	        observer.next();
	    };
	    EventManager.prototype.removeSnapshotsInSyncListener = function (observer) {
	        this.snapshotsInSyncListeners.delete(observer);
	    };
	    // Call all global snapshot listeners that have been set.
	    EventManager.prototype.raiseSnapshotsInSyncEvent = function () {
	        this.snapshotsInSyncListeners.forEach(function (observer) {
	            observer.next();
	        });
	    };
	    return EventManager;
	}());
	/**
	 * QueryListener takes a series of internal view snapshots and determines
	 * when to raise the event.
	 *
	 * It uses an Observer to dispatch events.
	 */
	var QueryListener = /** @class */ (function () {
	    function QueryListener(query, queryObserver, options) {
	        this.query = query;
	        this.queryObserver = queryObserver;
	        /**
	         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
	         * observer. This flag is set to true once we've actually raised an event.
	         */
	        this.raisedInitialEvent = false;
	        this.snap = null;
	        this.onlineState = OnlineState.Unknown;
	        this.options = options || {};
	    }
	    /**
	     * Applies the new ViewSnapshot to this listener, raising a user-facing event
	     * if applicable (depending on what changed, whether the user has opted into
	     * metadata-only changes, etc.). Returns true if a user-facing event was
	     * indeed raised.
	     */
	    QueryListener.prototype.onViewSnapshot = function (snap) {
	        assert(snap.docChanges.length > 0 || snap.syncStateChanged, 'We got a new snapshot with no changes?');
	        if (!this.options.includeMetadataChanges) {
	            // Remove the metadata only changes.
	            var docChanges = [];
	            for (var _i = 0, _a = snap.docChanges; _i < _a.length; _i++) {
	                var docChange = _a[_i];
	                if (docChange.type !== ChangeType.Metadata) {
	                    docChanges.push(docChange);
	                }
	            }
	            snap = new ViewSnapshot(snap.query, snap.docs, snap.oldDocs, docChanges, snap.mutatedKeys, snap.fromCache, snap.syncStateChanged, 
	            /* excludesMetadataChanges= */ true);
	        }
	        var raisedEvent = false;
	        if (!this.raisedInitialEvent) {
	            if (this.shouldRaiseInitialEvent(snap, this.onlineState)) {
	                this.raiseInitialEvent(snap);
	                raisedEvent = true;
	            }
	        }
	        else if (this.shouldRaiseEvent(snap)) {
	            this.queryObserver.next(snap);
	            raisedEvent = true;
	        }
	        this.snap = snap;
	        return raisedEvent;
	    };
	    QueryListener.prototype.onError = function (error) {
	        this.queryObserver.error(error);
	    };
	    /** Returns whether a snapshot was raised. */
	    QueryListener.prototype.applyOnlineStateChange = function (onlineState) {
	        this.onlineState = onlineState;
	        var raisedEvent = false;
	        if (this.snap &&
	            !this.raisedInitialEvent &&
	            this.shouldRaiseInitialEvent(this.snap, onlineState)) {
	            this.raiseInitialEvent(this.snap);
	            raisedEvent = true;
	        }
	        return raisedEvent;
	    };
	    QueryListener.prototype.shouldRaiseInitialEvent = function (snap, onlineState) {
	        assert(!this.raisedInitialEvent, 'Determining whether to raise first event but already had first event');
	        // Always raise the first event when we're synced
	        if (!snap.fromCache) {
	            return true;
	        }
	        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
	        // or Online if we wait long enough).
	        var maybeOnline = onlineState !== OnlineState.Offline;
	        // Don't raise the event if we're online, aren't synced yet (checked
	        // above) and are waiting for a sync.
	        if (this.options.waitForSyncWhenOnline && maybeOnline) {
	            assert(snap.fromCache, 'Waiting for sync, but snapshot is not from cache');
	            return false;
	        }
	        // Raise data from cache if we have any documents or we are offline
	        return !snap.docs.isEmpty() || onlineState === OnlineState.Offline;
	    };
	    QueryListener.prototype.shouldRaiseEvent = function (snap) {
	        // We don't need to handle includeDocumentMetadataChanges here because
	        // the Metadata only changes have already been stripped out if needed.
	        // At this point the only changes we will see are the ones we should
	        // propagate.
	        if (snap.docChanges.length > 0) {
	            return true;
	        }
	        var hasPendingWritesChanged = this.snap && this.snap.hasPendingWrites !== snap.hasPendingWrites;
	        if (snap.syncStateChanged || hasPendingWritesChanged) {
	            return this.options.includeMetadataChanges === true;
	        }
	        // Generally we should have hit one of the cases above, but it's possible
	        // to get here if there were only metadata docChanges and they got
	        // stripped out.
	        return false;
	    };
	    QueryListener.prototype.raiseInitialEvent = function (snap) {
	        assert(!this.raisedInitialEvent, 'Trying to raise initial events for second time');
	        snap = ViewSnapshot.fromInitialDocuments(snap.query, snap.docs, snap.mutatedKeys, snap.fromCache);
	        this.raisedInitialEvent = true;
	        this.queryObserver.next(snap);
	    };
	    return QueryListener;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A set of changes to what documents are currently in view and out of view for
	 * a given query. These changes are sent to the LocalStore by the View (via
	 * the SyncEngine) and are used to pin / unpin documents as appropriate.
	 */
	var LocalViewChanges = /** @class */ (function () {
	    function LocalViewChanges(targetId, fromCache, addedKeys, removedKeys) {
	        this.targetId = targetId;
	        this.fromCache = fromCache;
	        this.addedKeys = addedKeys;
	        this.removedKeys = removedKeys;
	    }
	    LocalViewChanges.fromSnapshot = function (targetId, viewSnapshot) {
	        var addedKeys = documentKeySet();
	        var removedKeys = documentKeySet();
	        for (var _i = 0, _a = viewSnapshot.docChanges; _i < _a.length; _i++) {
	            var docChange = _a[_i];
	            switch (docChange.type) {
	                case ChangeType.Added:
	                    addedKeys = addedKeys.add(docChange.doc.key);
	                    break;
	                case ChangeType.Removed:
	                    removedKeys = removedKeys.add(docChange.doc.key);
	                    break;
	                // do nothing
	            }
	        }
	        return new LocalViewChanges(targetId, viewSnapshot.fromCache, addedKeys, removedKeys);
	    };
	    return LocalViewChanges;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var AddedLimboDocument = /** @class */ (function () {
	    function AddedLimboDocument(key) {
	        this.key = key;
	    }
	    return AddedLimboDocument;
	}());
	var RemovedLimboDocument = /** @class */ (function () {
	    function RemovedLimboDocument(key) {
	        this.key = key;
	    }
	    return RemovedLimboDocument;
	}());
	/**
	 * View is responsible for computing the final merged truth of what docs are in
	 * a query. It gets notified of local and remote changes to docs, and applies
	 * the query filters and limits to determine the most correct possible results.
	 */
	var View = /** @class */ (function () {
	    function View(query, 
	    /** Documents included in the remote target */
	    _syncedDocuments) {
	        this.query = query;
	        this._syncedDocuments = _syncedDocuments;
	        this.syncState = null;
	        /**
	         * A flag whether the view is current with the backend. A view is considered
	         * current after it has seen the current flag from the backend and did not
	         * lose consistency within the watch stream (e.g. because of an existence
	         * filter mismatch).
	         */
	        this.current = false;
	        /** Documents in the view but not in the remote target */
	        this.limboDocuments = documentKeySet();
	        /** Document Keys that have local changes */
	        this.mutatedKeys = documentKeySet();
	        this.documentSet = new DocumentSet(query.docComparator.bind(query));
	    }
	    Object.defineProperty(View.prototype, "syncedDocuments", {
	        /**
	         * The set of remote documents that the server has told us belongs to the target associated with
	         * this view.
	         */
	        get: function () {
	            return this._syncedDocuments;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Iterates over a set of doc changes, applies the query limit, and computes
	     * what the new results should be, what the changes were, and whether we may
	     * need to go back to the local cache for more results. Does not make any
	     * changes to the view.
	     * @param docChanges The doc changes to apply to this view.
	     * @param previousChanges If this is being called with a refill, then start
	     *        with this set of docs and changes instead of the current view.
	     * @return a new set of docs, changes, and refill flag.
	     */
	    View.prototype.computeDocChanges = function (docChanges, previousChanges) {
	        var _this = this;
	        var changeSet = previousChanges
	            ? previousChanges.changeSet
	            : new DocumentChangeSet();
	        var oldDocumentSet = previousChanges
	            ? previousChanges.documentSet
	            : this.documentSet;
	        var newMutatedKeys = previousChanges
	            ? previousChanges.mutatedKeys
	            : this.mutatedKeys;
	        var newDocumentSet = oldDocumentSet;
	        var needsRefill = false;
	        // Track the last doc in a (full) limit. This is necessary, because some
	        // update (a delete, or an update moving a doc past the old limit) might
	        // mean there is some other document in the local cache that either should
	        // come (1) between the old last limit doc and the new last document, in the
	        // case of updates, or (2) after the new last document, in the case of
	        // deletes. So we keep this doc at the old limit to compare the updates to.
	        //
	        // Note that this should never get used in a refill (when previousChanges is
	        // set), because there will only be adds -- no deletes or updates.
	        var lastDocInLimit = this.query.hasLimitToFirst() && oldDocumentSet.size === this.query.limit
	            ? oldDocumentSet.last()
	            : null;
	        var firstDocInLimit = this.query.hasLimitToLast() && oldDocumentSet.size === this.query.limit
	            ? oldDocumentSet.first()
	            : null;
	        docChanges.inorderTraversal(function (key, newMaybeDoc) {
	            var oldDoc = oldDocumentSet.get(key);
	            var newDoc = newMaybeDoc instanceof Document ? newMaybeDoc : null;
	            if (newDoc) {
	                assert(key.isEqual(newDoc.key), 'Mismatching keys found in document changes: ' +
	                    key +
	                    ' != ' +
	                    newDoc.key);
	                newDoc = _this.query.matches(newDoc) ? newDoc : null;
	            }
	            var oldDocHadPendingMutations = oldDoc
	                ? _this.mutatedKeys.has(oldDoc.key)
	                : false;
	            var newDocHasPendingMutations = newDoc
	                ? newDoc.hasLocalMutations ||
	                    // We only consider committed mutations for documents that were
	                    // mutated during the lifetime of the view.
	                    (_this.mutatedKeys.has(newDoc.key) && newDoc.hasCommittedMutations)
	                : false;
	            var changeApplied = false;
	            // Calculate change
	            if (oldDoc && newDoc) {
	                var docsEqual = oldDoc.data().isEqual(newDoc.data());
	                if (!docsEqual) {
	                    if (!_this.shouldWaitForSyncedDocument(oldDoc, newDoc)) {
	                        changeSet.track({
	                            type: ChangeType.Modified,
	                            doc: newDoc
	                        });
	                        changeApplied = true;
	                        if ((lastDocInLimit &&
	                            _this.query.docComparator(newDoc, lastDocInLimit) > 0) ||
	                            (firstDocInLimit &&
	                                _this.query.docComparator(newDoc, firstDocInLimit) < 0)) {
	                            // This doc moved from inside the limit to outside the limit.
	                            // That means there may be some other doc in the local cache
	                            // that should be included instead.
	                            needsRefill = true;
	                        }
	                    }
	                }
	                else if (oldDocHadPendingMutations !== newDocHasPendingMutations) {
	                    changeSet.track({ type: ChangeType.Metadata, doc: newDoc });
	                    changeApplied = true;
	                }
	            }
	            else if (!oldDoc && newDoc) {
	                changeSet.track({ type: ChangeType.Added, doc: newDoc });
	                changeApplied = true;
	            }
	            else if (oldDoc && !newDoc) {
	                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
	                changeApplied = true;
	                if (lastDocInLimit || firstDocInLimit) {
	                    // A doc was removed from a full limit query. We'll need to
	                    // requery from the local cache to see if we know about some other
	                    // doc that should be in the results.
	                    needsRefill = true;
	                }
	            }
	            if (changeApplied) {
	                if (newDoc) {
	                    newDocumentSet = newDocumentSet.add(newDoc);
	                    if (newDocHasPendingMutations) {
	                        newMutatedKeys = newMutatedKeys.add(key);
	                    }
	                    else {
	                        newMutatedKeys = newMutatedKeys.delete(key);
	                    }
	                }
	                else {
	                    newDocumentSet = newDocumentSet.delete(key);
	                    newMutatedKeys = newMutatedKeys.delete(key);
	                }
	            }
	        });
	        // Drop documents out to meet limit/limitToLast requirement.
	        if (this.query.hasLimitToFirst() || this.query.hasLimitToLast()) {
	            while (newDocumentSet.size > this.query.limit) {
	                var oldDoc = this.query.hasLimitToFirst()
	                    ? newDocumentSet.last()
	                    : newDocumentSet.first();
	                newDocumentSet = newDocumentSet.delete(oldDoc.key);
	                newMutatedKeys = newMutatedKeys.delete(oldDoc.key);
	                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
	            }
	        }
	        assert(!needsRefill || !previousChanges, 'View was refilled using docs that themselves needed refilling.');
	        return {
	            documentSet: newDocumentSet,
	            changeSet: changeSet,
	            needsRefill: needsRefill,
	            mutatedKeys: newMutatedKeys
	        };
	    };
	    View.prototype.shouldWaitForSyncedDocument = function (oldDoc, newDoc) {
	        // We suppress the initial change event for documents that were modified as
	        // part of a write acknowledgment (e.g. when the value of a server transform
	        // is applied) as Watch will send us the same document again.
	        // By suppressing the event, we only raise two user visible events (one with
	        // `hasPendingWrites` and the final state of the document) instead of three
	        // (one with `hasPendingWrites`, the modified document with
	        // `hasPendingWrites` and the final state of the document).
	        return (oldDoc.hasLocalMutations &&
	            newDoc.hasCommittedMutations &&
	            !newDoc.hasLocalMutations);
	    };
	    /**
	     * Updates the view with the given ViewDocumentChanges and optionally updates
	     * limbo docs and sync state from the provided target change.
	     * @param docChanges The set of changes to make to the view's docs.
	     * @param updateLimboDocuments Whether to update limbo documents based on this
	     *        change.
	     * @param targetChange A target change to apply for computing limbo docs and
	     *        sync state.
	     * @return A new ViewChange with the given docs, changes, and sync state.
	     */
	    // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
	    View.prototype.applyChanges = function (docChanges, updateLimboDocuments, targetChange) {
	        var _this = this;
	        assert(!docChanges.needsRefill, 'Cannot apply changes that need a refill');
	        var oldDocs = this.documentSet;
	        this.documentSet = docChanges.documentSet;
	        this.mutatedKeys = docChanges.mutatedKeys;
	        // Sort changes based on type and query comparator
	        var changes = docChanges.changeSet.getChanges();
	        changes.sort(function (c1, c2) {
	            return (compareChangeType(c1.type, c2.type) ||
	                _this.query.docComparator(c1.doc, c2.doc));
	        });
	        this.applyTargetChange(targetChange);
	        var limboChanges = updateLimboDocuments
	            ? this.updateLimboDocuments()
	            : [];
	        var synced = this.limboDocuments.size === 0 && this.current;
	        var newSyncState = synced ? SyncState.Synced : SyncState.Local;
	        var syncStateChanged = newSyncState !== this.syncState;
	        this.syncState = newSyncState;
	        if (changes.length === 0 && !syncStateChanged) {
	            // no changes
	            return { limboChanges: limboChanges };
	        }
	        else {
	            var snap = new ViewSnapshot(this.query, docChanges.documentSet, oldDocs, changes, docChanges.mutatedKeys, newSyncState === SyncState.Local, syncStateChanged, 
	            /* excludesMetadataChanges= */ false);
	            return {
	                snapshot: snap,
	                limboChanges: limboChanges
	            };
	        }
	    };
	    /**
	     * Applies an OnlineState change to the view, potentially generating a
	     * ViewChange if the view's syncState changes as a result.
	     */
	    View.prototype.applyOnlineStateChange = function (onlineState) {
	        if (this.current && onlineState === OnlineState.Offline) {
	            // If we're offline, set `current` to false and then call applyChanges()
	            // to refresh our syncState and generate a ViewChange as appropriate. We
	            // are guaranteed to get a new TargetChange that sets `current` back to
	            // true once the client is back online.
	            this.current = false;
	            return this.applyChanges({
	                documentSet: this.documentSet,
	                changeSet: new DocumentChangeSet(),
	                mutatedKeys: this.mutatedKeys,
	                needsRefill: false
	            }, 
	            /* updateLimboDocuments= */ false);
	        }
	        else {
	            // No effect, just return a no-op ViewChange.
	            return { limboChanges: [] };
	        }
	    };
	    /**
	     * Returns whether the doc for the given key should be in limbo.
	     */
	    View.prototype.shouldBeInLimbo = function (key) {
	        // If the remote end says it's part of this query, it's not in limbo.
	        if (this._syncedDocuments.has(key)) {
	            return false;
	        }
	        // The local store doesn't think it's a result, so it shouldn't be in limbo.
	        if (!this.documentSet.has(key)) {
	            return false;
	        }
	        // If there are local changes to the doc, they might explain why the server
	        // doesn't know that it's part of the query. So don't put it in limbo.
	        // TODO(klimt): Ideally, we would only consider changes that might actually
	        // affect this specific query.
	        if (this.documentSet.get(key).hasLocalMutations) {
	            return false;
	        }
	        // Everything else is in limbo.
	        return true;
	    };
	    /**
	     * Updates syncedDocuments, current, and limbo docs based on the given change.
	     * Returns the list of changes to which docs are in limbo.
	     */
	    View.prototype.applyTargetChange = function (targetChange) {
	        var _this = this;
	        if (targetChange) {
	            targetChange.addedDocuments.forEach(function (key) { return (_this._syncedDocuments = _this._syncedDocuments.add(key)); });
	            targetChange.modifiedDocuments.forEach(function (key) {
	                return assert(_this._syncedDocuments.has(key), "Modified document " + key + " not found in view.");
	            });
	            targetChange.removedDocuments.forEach(function (key) { return (_this._syncedDocuments = _this._syncedDocuments.delete(key)); });
	            this.current = targetChange.current;
	        }
	    };
	    View.prototype.updateLimboDocuments = function () {
	        var _this = this;
	        // We can only determine limbo documents when we're in-sync with the server.
	        if (!this.current) {
	            return [];
	        }
	        // TODO(klimt): Do this incrementally so that it's not quadratic when
	        // updating many documents.
	        var oldLimboDocuments = this.limboDocuments;
	        this.limboDocuments = documentKeySet();
	        this.documentSet.forEach(function (doc) {
	            if (_this.shouldBeInLimbo(doc.key)) {
	                _this.limboDocuments = _this.limboDocuments.add(doc.key);
	            }
	        });
	        // Diff the new limbo docs with the old limbo docs.
	        var changes = [];
	        oldLimboDocuments.forEach(function (key) {
	            if (!_this.limboDocuments.has(key)) {
	                changes.push(new RemovedLimboDocument(key));
	            }
	        });
	        this.limboDocuments.forEach(function (key) {
	            if (!oldLimboDocuments.has(key)) {
	                changes.push(new AddedLimboDocument(key));
	            }
	        });
	        return changes;
	    };
	    /**
	     * Update the in-memory state of the current view with the state read from
	     * persistence.
	     *
	     * We update the query view whenever a client's primary status changes:
	     * - When a client transitions from primary to secondary, it can miss
	     *   LocalStorage updates and its query views may temporarily not be
	     *   synchronized with the state on disk.
	     * - For secondary to primary transitions, the client needs to update the list
	     *   of `syncedDocuments` since secondary clients update their query views
	     *   based purely on synthesized RemoteEvents.
	     *
	     * @param queryResult.documents - The documents that match the query according
	     * to the LocalStore.
	     * @param queryResult.remoteKeys - The keys of the documents that match the
	     * query according to the backend.
	     *
	     * @return The ViewChange that resulted from this synchronization.
	     */
	    // PORTING NOTE: Multi-tab only.
	    View.prototype.synchronizeWithPersistedState = function (queryResult) {
	        this._syncedDocuments = queryResult.remoteKeys;
	        this.limboDocuments = documentKeySet();
	        var docChanges = this.computeDocChanges(queryResult.documents);
	        return this.applyChanges(docChanges, /*updateLimboDocuments=*/ true);
	    };
	    /**
	     * Returns a view snapshot as if this query was just listened to. Contains
	     * a document add for every existing document and the `fromCache` and
	     * `hasPendingWrites` status of the already established view.
	     */
	    // PORTING NOTE: Multi-tab only.
	    View.prototype.computeInitialSnapshot = function () {
	        return ViewSnapshot.fromInitialDocuments(this.query, this.documentSet, this.mutatedKeys, this.syncState === SyncState.Local);
	    };
	    return View;
	}());
	function compareChangeType(c1, c2) {
	    var order = function (change) {
	        switch (change) {
	            case ChangeType.Added:
	                return 1;
	            case ChangeType.Modified:
	                return 2;
	            case ChangeType.Metadata:
	                // A metadata change is converted to a modified change at the public
	                // api layer.  Since we sort by document key and then change type,
	                // metadata and modified changes must be sorted equivalently.
	                return 2;
	            case ChangeType.Removed:
	                return 0;
	            default:
	                return fail('Unknown ChangeType: ' + change);
	        }
	    };
	    return order(c1) - order(c2);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var RETRY_COUNT = 5;
	/**
	 * TransactionRunner encapsulates the logic needed to run and retry transactions
	 * with backoff.
	 */
	var TransactionRunner = /** @class */ (function () {
	    function TransactionRunner(asyncQueue, remoteStore, updateFunction, deferred) {
	        this.asyncQueue = asyncQueue;
	        this.remoteStore = remoteStore;
	        this.updateFunction = updateFunction;
	        this.deferred = deferred;
	        this.retries = RETRY_COUNT;
	        this.backoff = new ExponentialBackoff(this.asyncQueue, TimerId.RetryTransaction);
	    }
	    /** Runs the transaction and sets the result on deferred. */
	    TransactionRunner.prototype.run = function () {
	        this.runWithBackOff();
	    };
	    TransactionRunner.prototype.runWithBackOff = function () {
	        var _this = this;
	        this.backoff.backoffAndRun(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	            var transaction, userPromise;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                transaction = this.remoteStore.createTransaction();
	                userPromise = this.tryRunUpdateFunction(transaction);
	                if (userPromise) {
	                    userPromise
	                        .then(function (result) {
	                        _this.asyncQueue.enqueueAndForget(function () {
	                            return transaction
	                                .commit()
	                                .then(function () {
	                                _this.deferred.resolve(result);
	                            })
	                                .catch(function (commitError) {
	                                _this.handleTransactionError(commitError);
	                            });
	                        });
	                    })
	                        .catch(function (userPromiseError) {
	                        _this.handleTransactionError(userPromiseError);
	                    });
	                }
	                return [2 /*return*/];
	            });
	        }); });
	    };
	    TransactionRunner.prototype.tryRunUpdateFunction = function (transaction) {
	        try {
	            var userPromise = this.updateFunction(transaction);
	            if (isNullOrUndefined(userPromise) ||
	                !userPromise.catch ||
	                !userPromise.then) {
	                this.deferred.reject(Error('Transaction callback must return a Promise'));
	                return null;
	            }
	            return userPromise;
	        }
	        catch (error) {
	            // Do not retry errors thrown by user provided updateFunction.
	            this.deferred.reject(error);
	            return null;
	        }
	    };
	    TransactionRunner.prototype.handleTransactionError = function (error) {
	        var _this = this;
	        if (this.retries > 0 && this.isRetryableTransactionError(error)) {
	            this.retries -= 1;
	            this.asyncQueue.enqueueAndForget(function () {
	                _this.runWithBackOff();
	                return Promise.resolve();
	            });
	        }
	        else {
	            this.deferred.reject(error);
	        }
	    };
	    TransactionRunner.prototype.isRetryableTransactionError = function (error) {
	        if (error.name === 'FirebaseError') {
	            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
	            // non-matching document versions with ABORTED. These errors should be retried.
	            var code = error.code;
	            return (code === 'aborted' ||
	                code === 'failed-precondition' ||
	                !isPermanentError(code));
	        }
	        return false;
	    };
	    return TransactionRunner;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$9 = 'SyncEngine';
	/**
	 * QueryView contains all of the data that SyncEngine needs to keep track of for
	 * a particular query.
	 */
	var QueryView = /** @class */ (function () {
	    function QueryView(
	    /**
	     * The query itself.
	     */
	    query, 
	    /**
	     * The target number created by the client that is used in the watch
	     * stream to identify this query.
	     */
	    targetId, 
	    /**
	     * The view is responsible for computing the final merged truth of what
	     * docs are in the query. It gets notified of local and remote changes,
	     * and applies the query filters and limits to determine the most correct
	     * possible results.
	     */
	    view) {
	        this.query = query;
	        this.targetId = targetId;
	        this.view = view;
	    }
	    return QueryView;
	}());
	/** Tracks a limbo resolution. */
	var LimboResolution = /** @class */ (function () {
	    function LimboResolution(key) {
	        this.key = key;
	        /**
	         * Set to true once we've received a document. This is used in
	         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
	         * decide whether it needs to manufacture a delete event for the target once
	         * the target is CURRENT.
	         */
	        this.receivedDocument = false;
	    }
	    return LimboResolution;
	}());
	/**
	 * SyncEngine is the central controller in the client SDK architecture. It is
	 * the glue code between the EventManager, LocalStore, and RemoteStore. Some of
	 * SyncEngine's responsibilities include:
	 * 1. Coordinating client requests and remote events between the EventManager
	 *    and the local and remote data stores.
	 * 2. Managing a View object for each query, providing the unified view between
	 *    the local and remote data stores.
	 * 3. Notifying the RemoteStore when the LocalStore has new mutations in its
	 *    queue that need sending to the backend.
	 *
	 * The SyncEngine’s methods should only ever be called by methods running in the
	 * global async queue.
	 */
	var SyncEngine = /** @class */ (function () {
	    function SyncEngine(localStore, remoteStore, 
	    // PORTING NOTE: Manages state synchronization in multi-tab environments.
	    sharedClientState, currentUser) {
	        this.localStore = localStore;
	        this.remoteStore = remoteStore;
	        this.sharedClientState = sharedClientState;
	        this.currentUser = currentUser;
	        this.syncEngineListener = null;
	        this.queryViewsByQuery = new ObjectMap(function (q) {
	            return q.canonicalId();
	        });
	        this.queriesByTarget = {};
	        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
	        this.limboResolutionsByTarget = {};
	        this.limboDocumentRefs = new ReferenceSet();
	        /** Stores user completion handlers, indexed by User and BatchId. */
	        this.mutationUserCallbacks = {};
	        /** Stores user callbacks waiting for all pending writes to be acknowledged. */
	        this.pendingWritesCallbacks = new Map();
	        this.limboTargetIdGenerator = TargetIdGenerator.forSyncEngine();
	        // The primary state is set to `true` or `false` immediately after Firestore
	        // startup. In the interim, a client should only be considered primary if
	        // `isPrimary` is true.
	        this.isPrimary = undefined;
	        this.onlineState = OnlineState.Unknown;
	    }
	    Object.defineProperty(SyncEngine.prototype, "isPrimaryClient", {
	        // Only used for testing.
	        get: function () {
	            return this.isPrimary === true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Subscribes to SyncEngine notifications. Has to be called exactly once. */
	    SyncEngine.prototype.subscribe = function (syncEngineListener) {
	        assert(syncEngineListener !== null, 'SyncEngine listener cannot be null');
	        assert(this.syncEngineListener === null, 'SyncEngine already has a subscriber.');
	        this.syncEngineListener = syncEngineListener;
	    };
	    /**
	     * Initiates the new listen, resolves promise when listen enqueued to the
	     * server. All the subsequent view snapshots or errors are sent to the
	     * subscribed handlers. Returns the targetId of the query.
	     */
	    SyncEngine.prototype.listen = function (query) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var targetId, viewSnapshot, queryView, targetData, status_1;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.assertSubscribed('listen()');
	                        queryView = this.queryViewsByQuery.get(query);
	                        if (!queryView) return [3 /*break*/, 1];
	                        // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
	                        // already exists when EventManager calls us for the first time. This
	                        // happens when the primary tab is already listening to this query on
	                        // behalf of another tab and the user of the primary also starts listening
	                        // to the query. EventManager will not have an assigned target ID in this
	                        // case and calls `listen` to obtain this ID.
	                        targetId = queryView.targetId;
	                        this.sharedClientState.addLocalQueryTarget(targetId);
	                        viewSnapshot = queryView.view.computeInitialSnapshot();
	                        return [3 /*break*/, 4];
	                    case 1: return [4 /*yield*/, this.localStore.allocateTarget(query.toTarget())];
	                    case 2:
	                        targetData = _a.sent();
	                        status_1 = this.sharedClientState.addLocalQueryTarget(targetData.targetId);
	                        targetId = targetData.targetId;
	                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(query, targetId, status_1 === 'current')];
	                    case 3:
	                        viewSnapshot = _a.sent();
	                        if (this.isPrimary) {
	                            this.remoteStore.listen(targetData);
	                        }
	                        _a.label = 4;
	                    case 4:
	                        this.syncEngineListener.onWatchChange([viewSnapshot]);
	                        return [2 /*return*/, targetId];
	                }
	            });
	        });
	    };
	    /**
	     * Registers a view for a previously unknown query and computes its initial
	     * snapshot.
	     */
	    SyncEngine.prototype.initializeViewAndComputeSnapshot = function (query, targetId, current) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var queryResult, view, viewDocChanges, synthesizedTargetChange, viewChange, data;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.localStore.executeQuery(query, 
	                        /* usePreviousResults= */ true)];
	                    case 1:
	                        queryResult = _a.sent();
	                        view = new View(query, queryResult.remoteKeys);
	                        viewDocChanges = view.computeDocChanges(queryResult.documents);
	                        synthesizedTargetChange = TargetChange.createSynthesizedTargetChangeForCurrentChange(targetId, current && this.onlineState !== OnlineState.Offline);
	                        viewChange = view.applyChanges(viewDocChanges, 
	                        /* updateLimboDocuments= */ this.isPrimary === true, synthesizedTargetChange);
	                        assert(viewChange.limboChanges.length === 0, 'View returned limbo docs before target ack from the server.');
	                        assert(!!viewChange.snapshot, 'applyChanges for new view should always return a snapshot');
	                        data = new QueryView(query, targetId, view);
	                        this.queryViewsByQuery.set(query, data);
	                        if (!this.queriesByTarget[targetId]) {
	                            this.queriesByTarget[targetId] = [];
	                        }
	                        this.queriesByTarget[targetId].push(query);
	                        return [2 /*return*/, viewChange.snapshot];
	                }
	            });
	        });
	    };
	    /**
	     * Reconcile the list of synced documents in an existing view with those
	     * from persistence.
	     */
	    // PORTING NOTE: Multi-tab only.
	    SyncEngine.prototype.synchronizeViewAndComputeSnapshot = function (queryView) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var queryResult, viewSnapshot;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.localStore.executeQuery(queryView.query, 
	                        /* usePreviousResults= */ true)];
	                    case 1:
	                        queryResult = _a.sent();
	                        viewSnapshot = queryView.view.synchronizeWithPersistedState(queryResult);
	                        if (this.isPrimary) {
	                            this.updateTrackedLimbos(queryView.targetId, viewSnapshot.limboChanges);
	                        }
	                        return [2 /*return*/, viewSnapshot];
	                }
	            });
	        });
	    };
	    /** Stops listening to the query. */
	    SyncEngine.prototype.unlisten = function (query) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var queryView, queries, targetRemainsActive;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.assertSubscribed('unlisten()');
	                        queryView = this.queryViewsByQuery.get(query);
	                        assert(!!queryView, 'Trying to unlisten on query not found:' + query);
	                        queries = this.queriesByTarget[queryView.targetId];
	                        if (queries.length > 1) {
	                            this.queriesByTarget[queryView.targetId] = queries.filter(function (q) { return !q.isEqual(query); });
	                            this.queryViewsByQuery.delete(query);
	                            return [2 /*return*/];
	                        }
	                        if (!this.isPrimary) return [3 /*break*/, 3];
	                        // We need to remove the local query target first to allow us to verify
	                        // whether any other client is still interested in this target.
	                        this.sharedClientState.removeLocalQueryTarget(queryView.targetId);
	                        targetRemainsActive = this.sharedClientState.isActiveQueryTarget(queryView.targetId);
	                        if (!!targetRemainsActive) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.localStore
	                                .releaseTarget(queryView.targetId, /*keepPersistedTargetData=*/ false)
	                                .then(function () {
	                                _this.sharedClientState.clearQueryState(queryView.targetId);
	                                _this.remoteStore.unlisten(queryView.targetId);
	                                _this.removeAndCleanupTarget(queryView.targetId);
	                            })
	                                .catch(ignoreIfPrimaryLeaseLoss)];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2: return [3 /*break*/, 5];
	                    case 3:
	                        this.removeAndCleanupTarget(queryView.targetId);
	                        return [4 /*yield*/, this.localStore.releaseTarget(queryView.targetId, 
	                            /*keepPersistedTargetData=*/ true)];
	                    case 4:
	                        _a.sent();
	                        _a.label = 5;
	                    case 5: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Initiates the write of local mutation batch which involves adding the
	     * writes to the mutation queue, notifying the remote store about new
	     * mutations and raising events for any changes this write caused.
	     *
	     * The promise returned by this call is resolved when the above steps
	     * have completed, *not* when the write was acked by the backend. The
	     * userCallback is resolved once the write was acked/rejected by the
	     * backend (or failed locally for any other reason).
	     */
	    SyncEngine.prototype.write = function (batch, userCallback) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var result;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.assertSubscribed('write()');
	                        return [4 /*yield*/, this.localStore.localWrite(batch)];
	                    case 1:
	                        result = _a.sent();
	                        this.sharedClientState.addPendingMutation(result.batchId);
	                        this.addMutationCallback(result.batchId, userCallback);
	                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(result.changes)];
	                    case 2:
	                        _a.sent();
	                        return [4 /*yield*/, this.remoteStore.fillWritePipeline()];
	                    case 3:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Takes an updateFunction in which a set of reads and writes can be performed
	     * atomically. In the updateFunction, the client can read and write values
	     * using the supplied transaction object. After the updateFunction, all
	     * changes will be committed. If a retryable error occurs (ex: some other
	     * client has changed any of the data referenced), then the updateFunction
	     * will be called again after a backoff. If the updateFunction still fails
	     * after all retries, then the transaction will be rejected.
	     *
	     * The transaction object passed to the updateFunction contains methods for
	     * accessing documents and collections. Unlike other datastore access, data
	     * accessed with the transaction will not reflect local changes that have not
	     * been committed. For this reason, it is required that all reads are
	     * performed before any writes. Transactions must be performed while online.
	     *
	     * The Deferred input is resolved when the transaction is fully committed.
	     */
	    SyncEngine.prototype.runTransaction = function (asyncQueue, updateFunction, deferred) {
	        new TransactionRunner(asyncQueue, this.remoteStore, updateFunction, deferred).run();
	    };
	    SyncEngine.prototype.applyRemoteEvent = function (remoteEvent) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var changes, error_1;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.assertSubscribed('applyRemoteEvent()');
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 6]);
	                        return [4 /*yield*/, this.localStore.applyRemoteEvent(remoteEvent)];
	                    case 2:
	                        changes = _a.sent();
	                        // Update `receivedDocument` as appropriate for any limbo targets.
	                        forEach(remoteEvent.targetChanges, function (targetId, targetChange) {
	                            var limboResolution = _this.limboResolutionsByTarget[Number(targetId)];
	                            if (limboResolution) {
	                                // Since this is a limbo resolution lookup, it's for a single document
	                                // and it could be added, modified, or removed, but not a combination.
	                                assert(targetChange.addedDocuments.size +
	                                    targetChange.modifiedDocuments.size +
	                                    targetChange.removedDocuments.size <=
	                                    1, 'Limbo resolution for single document contains multiple changes.');
	                                if (targetChange.addedDocuments.size > 0) {
	                                    limboResolution.receivedDocument = true;
	                                }
	                                else if (targetChange.modifiedDocuments.size > 0) {
	                                    assert(limboResolution.receivedDocument, 'Received change for limbo target document without add.');
	                                }
	                                else if (targetChange.removedDocuments.size > 0) {
	                                    assert(limboResolution.receivedDocument, 'Received remove for limbo target document without add.');
	                                    limboResolution.receivedDocument = false;
	                                }
	                            }
	                        });
	                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes, remoteEvent)];
	                    case 3:
	                        _a.sent();
	                        return [3 /*break*/, 6];
	                    case 4:
	                        error_1 = _a.sent();
	                        return [4 /*yield*/, ignoreIfPrimaryLeaseLoss(error_1)];
	                    case 5:
	                        _a.sent();
	                        return [3 /*break*/, 6];
	                    case 6: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Applies an OnlineState change to the sync engine and notifies any views of
	     * the change.
	     */
	    SyncEngine.prototype.applyOnlineStateChange = function (onlineState, source) {
	        // If we are the secondary client, we explicitly ignore the remote store's
	        // online state (the local client may go offline, even though the primary
	        // tab remains online) and only apply the primary tab's online state from
	        // SharedClientState.
	        if ((this.isPrimary && source === OnlineStateSource.RemoteStore) ||
	            (!this.isPrimary && source === OnlineStateSource.SharedClientState)) {
	            this.assertSubscribed('applyOnlineStateChange()');
	            var newViewSnapshots_1 = [];
	            this.queryViewsByQuery.forEach(function (query, queryView) {
	                var viewChange = queryView.view.applyOnlineStateChange(onlineState);
	                assert(viewChange.limboChanges.length === 0, 'OnlineState should not affect limbo documents.');
	                if (viewChange.snapshot) {
	                    newViewSnapshots_1.push(viewChange.snapshot);
	                }
	            });
	            this.syncEngineListener.onOnlineStateChange(onlineState);
	            this.syncEngineListener.onWatchChange(newViewSnapshots_1);
	            this.onlineState = onlineState;
	            if (this.isPrimary) {
	                this.sharedClientState.setOnlineState(onlineState);
	            }
	        }
	    };
	    SyncEngine.prototype.rejectListen = function (targetId, err) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var limboResolution, limboKey, documentUpdates, resolvedLimboDocuments, event_1;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.assertSubscribed('rejectListens()');
	                        // PORTING NOTE: Multi-tab only.
	                        this.sharedClientState.updateQueryState(targetId, 'rejected', err);
	                        limboResolution = this.limboResolutionsByTarget[targetId];
	                        limboKey = limboResolution && limboResolution.key;
	                        if (!limboKey) return [3 /*break*/, 1];
	                        // Since this query failed, we won't want to manually unlisten to it.
	                        // So go ahead and remove it from bookkeeping.
	                        this.limboTargetsByKey = this.limboTargetsByKey.remove(limboKey);
	                        delete this.limboResolutionsByTarget[targetId];
	                        documentUpdates = new SortedMap(DocumentKey.comparator);
	                        documentUpdates = documentUpdates.insert(limboKey, new NoDocument(limboKey, SnapshotVersion.forDeletedDoc()));
	                        resolvedLimboDocuments = documentKeySet().add(limboKey);
	                        event_1 = new RemoteEvent(SnapshotVersion.MIN, 
	                        /* targetChanges= */ {}, 
	                        /* targetMismatches= */ new SortedSet(primitiveComparator), documentUpdates, resolvedLimboDocuments);
	                        return [2 /*return*/, this.applyRemoteEvent(event_1)];
	                    case 1: return [4 /*yield*/, this.localStore
	                            .releaseTarget(targetId, /* keepPersistedTargetData */ false)
	                            .then(function () { return _this.removeAndCleanupTarget(targetId, err); })
	                            .catch(ignoreIfPrimaryLeaseLoss)];
	                    case 2:
	                        _a.sent();
	                        _a.label = 3;
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    // PORTING NOTE: Multi-tab only
	    SyncEngine.prototype.applyBatchState = function (batchId, batchState, error) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var documents;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.assertSubscribed('applyBatchState()');
	                        return [4 /*yield*/, this.localStore.lookupMutationDocuments(batchId)];
	                    case 1:
	                        documents = _a.sent();
	                        if (documents === null) {
	                            // A throttled tab may not have seen the mutation before it was completed
	                            // and removed from the mutation queue, in which case we won't have cached
	                            // the affected documents. In this case we can safely ignore the update
	                            // since that means we didn't apply the mutation locally at all (if we
	                            // had, we would have cached the affected documents), and so we will just
	                            // see any resulting document changes via normal remote document updates
	                            // as applicable.
	                            debug(LOG_TAG$9, 'Cannot apply mutation batch with id: ' + batchId);
	                            return [2 /*return*/];
	                        }
	                        if (!(batchState === 'pending')) return [3 /*break*/, 3];
	                        // If we are the primary client, we need to send this write to the
	                        // backend. Secondary clients will ignore these writes since their remote
	                        // connection is disabled.
	                        return [4 /*yield*/, this.remoteStore.fillWritePipeline()];
	                    case 2:
	                        // If we are the primary client, we need to send this write to the
	                        // backend. Secondary clients will ignore these writes since their remote
	                        // connection is disabled.
	                        _a.sent();
	                        return [3 /*break*/, 4];
	                    case 3:
	                        if (batchState === 'acknowledged' || batchState === 'rejected') {
	                            // NOTE: Both these methods are no-ops for batches that originated from
	                            // other clients.
	                            this.processUserCallback(batchId, error ? error : null);
	                            this.localStore.removeCachedMutationBatchMetadata(batchId);
	                        }
	                        else {
	                            fail("Unknown batchState: " + batchState);
	                        }
	                        _a.label = 4;
	                    case 4: return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(documents)];
	                    case 5:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SyncEngine.prototype.applySuccessfulWrite = function (mutationBatchResult) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var batchId, changes, error_2;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.assertSubscribed('applySuccessfulWrite()');
	                        batchId = mutationBatchResult.batch.batchId;
	                        // The local store may or may not be able to apply the write result and
	                        // raise events immediately (depending on whether the watcher is caught
	                        // up), so we raise user callbacks first so that they consistently happen
	                        // before listen events.
	                        this.processUserCallback(batchId, /*error=*/ null);
	                        this.triggerPendingWritesCallbacks(batchId);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 6]);
	                        return [4 /*yield*/, this.localStore.acknowledgeBatch(mutationBatchResult)];
	                    case 2:
	                        changes = _a.sent();
	                        this.sharedClientState.updateMutationState(batchId, 'acknowledged');
	                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes)];
	                    case 3:
	                        _a.sent();
	                        return [3 /*break*/, 6];
	                    case 4:
	                        error_2 = _a.sent();
	                        return [4 /*yield*/, ignoreIfPrimaryLeaseLoss(error_2)];
	                    case 5:
	                        _a.sent();
	                        return [3 /*break*/, 6];
	                    case 6: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SyncEngine.prototype.rejectFailedWrite = function (batchId, error) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var changes, error_3;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.assertSubscribed('rejectFailedWrite()');
	                        // The local store may or may not be able to apply the write result and
	                        // raise events immediately (depending on whether the watcher is caught up),
	                        // so we raise user callbacks first so that they consistently happen before
	                        // listen events.
	                        this.processUserCallback(batchId, error);
	                        this.triggerPendingWritesCallbacks(batchId);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 6]);
	                        return [4 /*yield*/, this.localStore.rejectBatch(batchId)];
	                    case 2:
	                        changes = _a.sent();
	                        this.sharedClientState.updateMutationState(batchId, 'rejected', error);
	                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes)];
	                    case 3:
	                        _a.sent();
	                        return [3 /*break*/, 6];
	                    case 4:
	                        error_3 = _a.sent();
	                        return [4 /*yield*/, ignoreIfPrimaryLeaseLoss(error_3)];
	                    case 5:
	                        _a.sent();
	                        return [3 /*break*/, 6];
	                    case 6: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Registers a user callback that resolves when all pending mutations at the moment of calling
	     * are acknowledged .
	     */
	    SyncEngine.prototype.registerPendingWritesCallback = function (callback) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var highestBatchId, callbacks;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.remoteStore.canUseNetwork()) {
	                            debug(LOG_TAG$9, 'The network is disabled. The task returned by ' +
	                                "'awaitPendingWrites()' will not complete until the network is enabled.");
	                        }
	                        return [4 /*yield*/, this.localStore.getHighestUnacknowledgedBatchId()];
	                    case 1:
	                        highestBatchId = _a.sent();
	                        if (highestBatchId === BATCHID_UNKNOWN) {
	                            // Trigger the callback right away if there is no pending writes at the moment.
	                            callback.resolve();
	                            return [2 /*return*/];
	                        }
	                        callbacks = this.pendingWritesCallbacks.get(highestBatchId) || [];
	                        callbacks.push(callback);
	                        this.pendingWritesCallbacks.set(highestBatchId, callbacks);
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
	     * if there are any.
	     */
	    SyncEngine.prototype.triggerPendingWritesCallbacks = function (batchId) {
	        (this.pendingWritesCallbacks.get(batchId) || []).forEach(function (callback) {
	            callback.resolve();
	        });
	        this.pendingWritesCallbacks.delete(batchId);
	    };
	    /** Reject all outstanding callbacks waiting for pending writes to complete. */
	    SyncEngine.prototype.rejectOutstandingPendingWritesCallbacks = function (errorMessage) {
	        this.pendingWritesCallbacks.forEach(function (callbacks) {
	            callbacks.forEach(function (callback) {
	                callback.reject(new FirestoreError(Code.CANCELLED, errorMessage));
	            });
	        });
	        this.pendingWritesCallbacks.clear();
	    };
	    SyncEngine.prototype.addMutationCallback = function (batchId, callback) {
	        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
	        if (!newCallbacks) {
	            newCallbacks = new SortedMap(primitiveComparator);
	        }
	        newCallbacks = newCallbacks.insert(batchId, callback);
	        this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
	    };
	    /**
	     * Resolves or rejects the user callback for the given batch and then discards
	     * it.
	     */
	    SyncEngine.prototype.processUserCallback = function (batchId, error) {
	        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
	        // NOTE: Mutations restored from persistence won't have callbacks, so it's
	        // okay for there to be no callback for this ID.
	        if (newCallbacks) {
	            var callback = newCallbacks.get(batchId);
	            if (callback) {
	                assert(batchId === newCallbacks.minKey(), 'Mutation callbacks processed out-of-order?');
	                if (error) {
	                    callback.reject(error);
	                }
	                else {
	                    callback.resolve();
	                }
	                newCallbacks = newCallbacks.remove(batchId);
	            }
	            this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
	        }
	    };
	    SyncEngine.prototype.removeAndCleanupTarget = function (targetId, error) {
	        var _this = this;
	        if (error === void 0) { error = null; }
	        this.sharedClientState.removeLocalQueryTarget(targetId);
	        assert(this.queriesByTarget[targetId] &&
	            this.queriesByTarget[targetId].length !== 0, "There are no queries mapped to target id " + targetId);
	        for (var _i = 0, _a = this.queriesByTarget[targetId]; _i < _a.length; _i++) {
	            var query = _a[_i];
	            this.queryViewsByQuery.delete(query);
	            if (error) {
	                this.syncEngineListener.onWatchError(query, error);
	            }
	        }
	        delete this.queriesByTarget[targetId];
	        if (this.isPrimary) {
	            var limboKeys = this.limboDocumentRefs.referencesForId(targetId);
	            this.limboDocumentRefs.removeReferencesForId(targetId);
	            limboKeys.forEach(function (limboKey) {
	                var isReferenced = _this.limboDocumentRefs.containsKey(limboKey);
	                if (!isReferenced) {
	                    // We removed the last reference for this key
	                    _this.removeLimboTarget(limboKey);
	                }
	            });
	        }
	    };
	    SyncEngine.prototype.removeLimboTarget = function (key) {
	        // It's possible that the target already got removed because the query failed. In that case,
	        // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
	        var limboTargetId = this.limboTargetsByKey.get(key);
	        if (limboTargetId === null) {
	            // This target already got removed, because the query failed.
	            return;
	        }
	        this.remoteStore.unlisten(limboTargetId);
	        this.limboTargetsByKey = this.limboTargetsByKey.remove(key);
	        delete this.limboResolutionsByTarget[limboTargetId];
	    };
	    SyncEngine.prototype.updateTrackedLimbos = function (targetId, limboChanges) {
	        for (var _i = 0, limboChanges_1 = limboChanges; _i < limboChanges_1.length; _i++) {
	            var limboChange = limboChanges_1[_i];
	            if (limboChange instanceof AddedLimboDocument) {
	                this.limboDocumentRefs.addReference(limboChange.key, targetId);
	                this.trackLimboChange(limboChange);
	            }
	            else if (limboChange instanceof RemovedLimboDocument) {
	                debug(LOG_TAG$9, 'Document no longer in limbo: ' + limboChange.key);
	                this.limboDocumentRefs.removeReference(limboChange.key, targetId);
	                var isReferenced = this.limboDocumentRefs.containsKey(limboChange.key);
	                if (!isReferenced) {
	                    // We removed the last reference for this key
	                    this.removeLimboTarget(limboChange.key);
	                }
	            }
	            else {
	                fail('Unknown limbo change: ' + JSON.stringify(limboChange));
	            }
	        }
	    };
	    SyncEngine.prototype.trackLimboChange = function (limboChange) {
	        var key = limboChange.key;
	        if (!this.limboTargetsByKey.get(key)) {
	            debug(LOG_TAG$9, 'New document in limbo: ' + key);
	            var limboTargetId = this.limboTargetIdGenerator.next();
	            var query = Query.atPath(key.path);
	            this.limboResolutionsByTarget[limboTargetId] = new LimboResolution(key);
	            this.remoteStore.listen(new TargetData(query.toTarget(), limboTargetId, TargetPurpose.LimboResolution, ListenSequence.INVALID));
	            this.limboTargetsByKey = this.limboTargetsByKey.insert(key, limboTargetId);
	        }
	    };
	    // Visible for testing
	    SyncEngine.prototype.currentLimboDocs = function () {
	        return this.limboTargetsByKey;
	    };
	    SyncEngine.prototype.emitNewSnapsAndNotifyLocalStore = function (changes, remoteEvent) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var newSnaps, docChangesInAllViews, queriesProcessed;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        newSnaps = [];
	                        docChangesInAllViews = [];
	                        queriesProcessed = [];
	                        this.queryViewsByQuery.forEach(function (_, queryView) {
	                            queriesProcessed.push(Promise.resolve()
	                                .then(function () {
	                                var viewDocChanges = queryView.view.computeDocChanges(changes);
	                                if (!viewDocChanges.needsRefill) {
	                                    return viewDocChanges;
	                                }
	                                // The query has a limit and some docs were removed, so we need
	                                // to re-run the query against the local store to make sure we
	                                // didn't lose any good docs that had been past the limit.
	                                return _this.localStore
	                                    .executeQuery(queryView.query, /* usePreviousResults= */ false)
	                                    .then(function (_a) {
	                                    var documents = _a.documents;
	                                    return queryView.view.computeDocChanges(documents, viewDocChanges);
	                                });
	                            })
	                                .then(function (viewDocChanges) {
	                                var targetChange = remoteEvent && remoteEvent.targetChanges[queryView.targetId];
	                                var viewChange = queryView.view.applyChanges(viewDocChanges, 
	                                /* updateLimboDocuments= */ _this.isPrimary === true, targetChange);
	                                _this.updateTrackedLimbos(queryView.targetId, viewChange.limboChanges);
	                                if (viewChange.snapshot) {
	                                    if (_this.isPrimary) {
	                                        _this.sharedClientState.updateQueryState(queryView.targetId, viewChange.snapshot.fromCache ? 'not-current' : 'current');
	                                    }
	                                    newSnaps.push(viewChange.snapshot);
	                                    var docChanges = LocalViewChanges.fromSnapshot(queryView.targetId, viewChange.snapshot);
	                                    docChangesInAllViews.push(docChanges);
	                                }
	                            }));
	                        });
	                        return [4 /*yield*/, Promise.all(queriesProcessed)];
	                    case 1:
	                        _a.sent();
	                        this.syncEngineListener.onWatchChange(newSnaps);
	                        return [4 /*yield*/, this.localStore.notifyLocalViewChanges(docChangesInAllViews)];
	                    case 2:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SyncEngine.prototype.assertSubscribed = function (fnName) {
	        assert(this.syncEngineListener !== null, 'Trying to call ' + fnName + ' before calling subscribe().');
	    };
	    SyncEngine.prototype.handleCredentialChange = function (user) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var userChanged, result;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        userChanged = !this.currentUser.isEqual(user);
	                        this.currentUser = user;
	                        if (!userChanged) return [3 /*break*/, 3];
	                        // Fails tasks waiting for pending writes requested by previous user.
	                        this.rejectOutstandingPendingWritesCallbacks("'waitForPendingWrites' promise is rejected due to a user change.");
	                        return [4 /*yield*/, this.localStore.handleUserChange(user)];
	                    case 1:
	                        result = _a.sent();
	                        // TODO(b/114226417): Consider calling this only in the primary tab.
	                        this.sharedClientState.handleUserChange(user, result.removedBatchIds, result.addedBatchIds);
	                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(result.affectedDocuments)];
	                    case 2:
	                        _a.sent();
	                        _a.label = 3;
	                    case 3: return [4 /*yield*/, this.remoteStore.handleCredentialChange()];
	                    case 4:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    // PORTING NOTE: Multi-tab only
	    SyncEngine.prototype.applyPrimaryState = function (isPrimary) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var activeTargets, activeQueries, _i, activeQueries_1, targetData, activeTargets_1, p_1;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!(isPrimary === true && this.isPrimary !== true)) return [3 /*break*/, 3];
	                        this.isPrimary = true;
	                        return [4 /*yield*/, this.remoteStore.applyPrimaryState(true)];
	                    case 1:
	                        _a.sent();
	                        activeTargets = this.sharedClientState.getAllActiveQueryTargets();
	                        return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets.toArray())];
	                    case 2:
	                        activeQueries = _a.sent();
	                        for (_i = 0, activeQueries_1 = activeQueries; _i < activeQueries_1.length; _i++) {
	                            targetData = activeQueries_1[_i];
	                            this.remoteStore.listen(targetData);
	                        }
	                        return [3 /*break*/, 7];
	                    case 3:
	                        if (!(isPrimary === false && this.isPrimary !== false)) return [3 /*break*/, 7];
	                        this.isPrimary = false;
	                        activeTargets_1 = [];
	                        p_1 = Promise.resolve();
	                        forEachNumber(this.queriesByTarget, function (targetId, _) {
	                            if (_this.sharedClientState.isLocalQueryTarget(targetId)) {
	                                activeTargets_1.push(targetId);
	                            }
	                            else {
	                                p_1 = p_1.then(function () {
	                                    _this.removeAndCleanupTarget(targetId);
	                                    return _this.localStore.releaseTarget(targetId, 
	                                    /*keepPersistedTargetData=*/ true);
	                                });
	                            }
	                            _this.remoteStore.unlisten(targetId);
	                        });
	                        return [4 /*yield*/, p_1];
	                    case 4:
	                        _a.sent();
	                        return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets_1)];
	                    case 5:
	                        _a.sent();
	                        this.resetLimboDocuments();
	                        return [4 /*yield*/, this.remoteStore.applyPrimaryState(false)];
	                    case 6:
	                        _a.sent();
	                        _a.label = 7;
	                    case 7: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    // PORTING NOTE: Multi-tab only.
	    SyncEngine.prototype.resetLimboDocuments = function () {
	        var _this = this;
	        forEachNumber(this.limboResolutionsByTarget, function (targetId) {
	            _this.remoteStore.unlisten(targetId);
	        });
	        this.limboDocumentRefs.removeAllReferences();
	        this.limboResolutionsByTarget = [];
	        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
	    };
	    /**
	     * Reconcile the query views of the provided query targets with the state from
	     * persistence. Raises snapshots for any changes that affect the local
	     * client and returns the updated state of all target's query data.
	     */
	    // PORTING NOTE: Multi-tab only.
	    SyncEngine.prototype.synchronizeQueryViewsAndRaiseSnapshots = function (targets) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var activeQueries, newViewSnapshots, _i, targets_1, targetId, targetData, queries, _a, queries_1, query, queryView, viewChange, target;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        activeQueries = [];
	                        newViewSnapshots = [];
	                        _i = 0, targets_1 = targets;
	                        _b.label = 1;
	                    case 1:
	                        if (!(_i < targets_1.length)) return [3 /*break*/, 14];
	                        targetId = targets_1[_i];
	                        targetData = void 0;
	                        queries = this.queriesByTarget[targetId];
	                        if (!(queries && queries.length !== 0)) return [3 /*break*/, 8];
	                        // For queries that have a local View, we need to update their state
	                        // in LocalStore (as the resume token and the snapshot version
	                        // might have changed) and reconcile their views with the persisted
	                        // state (the list of syncedDocuments may have gotten out of sync).
	                        return [4 /*yield*/, this.localStore.releaseTarget(targetId, 
	                            /*keepPersistedTargetData=*/ true)];
	                    case 2:
	                        // For queries that have a local View, we need to update their state
	                        // in LocalStore (as the resume token and the snapshot version
	                        // might have changed) and reconcile their views with the persisted
	                        // state (the list of syncedDocuments may have gotten out of sync).
	                        _b.sent();
	                        return [4 /*yield*/, this.localStore.allocateTarget(queries[0].toTarget())];
	                    case 3:
	                        targetData = _b.sent();
	                        _a = 0, queries_1 = queries;
	                        _b.label = 4;
	                    case 4:
	                        if (!(_a < queries_1.length)) return [3 /*break*/, 7];
	                        query = queries_1[_a];
	                        queryView = this.queryViewsByQuery.get(query);
	                        assert(!!queryView, "No query view found for " + query);
	                        return [4 /*yield*/, this.synchronizeViewAndComputeSnapshot(queryView)];
	                    case 5:
	                        viewChange = _b.sent();
	                        if (viewChange.snapshot) {
	                            newViewSnapshots.push(viewChange.snapshot);
	                        }
	                        _b.label = 6;
	                    case 6:
	                        _a++;
	                        return [3 /*break*/, 4];
	                    case 7: return [3 /*break*/, 12];
	                    case 8:
	                        assert(this.isPrimary === true, 'A secondary tab should never have an active target without an active query.');
	                        return [4 /*yield*/, this.localStore.getTarget(targetId)];
	                    case 9:
	                        target = _b.sent();
	                        assert(!!target, "Target for id " + targetId + " not found");
	                        return [4 /*yield*/, this.localStore.allocateTarget(target)];
	                    case 10:
	                        targetData = _b.sent();
	                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(this.synthesizeTargetToQuery(target), targetId, 
	                            /*current=*/ false)];
	                    case 11:
	                        _b.sent();
	                        _b.label = 12;
	                    case 12:
	                        activeQueries.push(targetData);
	                        _b.label = 13;
	                    case 13:
	                        _i++;
	                        return [3 /*break*/, 1];
	                    case 14:
	                        this.syncEngineListener.onWatchChange(newViewSnapshots);
	                        return [2 /*return*/, activeQueries];
	                }
	            });
	        });
	    };
	    /**
	     * Creates a `Query` object from the specified `Target`. There is no way to
	     * obtain the original `Query`, so we synthesize a `Query` from the `Target`
	     * object.
	     *
	     * The synthesized result might be different from the original `Query`, but
	     * since the synthesized `Query` should return the same results as the
	     * original one (only the presentation of results might differ), the potential
	     * difference will not cause issues.
	     */
	    // PORTING NOTE: Multi-tab only
	    SyncEngine.prototype.synthesizeTargetToQuery = function (target) {
	        return new Query(target.path, target.collectionGroup, target.orderBy, target.filters, target.limit, LimitType.First, target.startAt, target.endAt);
	    };
	    // PORTING NOTE: Multi-tab only
	    SyncEngine.prototype.getActiveClients = function () {
	        return this.localStore.getActiveClients();
	    };
	    // PORTING NOTE: Multi-tab only
	    SyncEngine.prototype.applyTargetState = function (targetId, state, error) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a, changes, synthesizedRemoteEvent;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        if (this.isPrimary) {
	                            // If we receive a target state notification via WebStorage, we are
	                            // either already secondary or another tab has taken the primary lease.
	                            debug(LOG_TAG$9, 'Ignoring unexpected query state notification.');
	                            return [2 /*return*/];
	                        }
	                        if (!this.queriesByTarget[targetId]) return [3 /*break*/, 7];
	                        _a = state;
	                        switch (_a) {
	                            case 'current': return [3 /*break*/, 1];
	                            case 'not-current': return [3 /*break*/, 1];
	                            case 'rejected': return [3 /*break*/, 4];
	                        }
	                        return [3 /*break*/, 6];
	                    case 1: return [4 /*yield*/, this.localStore.getNewDocumentChanges()];
	                    case 2:
	                        changes = _b.sent();
	                        synthesizedRemoteEvent = RemoteEvent.createSynthesizedRemoteEventForCurrentChange(targetId, state === 'current');
	                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes, synthesizedRemoteEvent)];
	                    case 3:
	                        _b.sent();
	                        return [3 /*break*/, 7];
	                    case 4: return [4 /*yield*/, this.localStore.releaseTarget(targetId, 
	                        /* keepPersistedTargetData */ true)];
	                    case 5:
	                        _b.sent();
	                        this.removeAndCleanupTarget(targetId, error);
	                        return [3 /*break*/, 7];
	                    case 6:
	                        fail('Unexpected target state: ' + state);
	                        _b.label = 7;
	                    case 7: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    // PORTING NOTE: Multi-tab only
	    SyncEngine.prototype.applyActiveTargetsChange = function (added, removed) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _i, added_1, targetId, target, targetData, _loop_1, this_1, _a, removed_1, targetId;
	            var _this = this;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        if (!this.isPrimary) {
	                            return [2 /*return*/];
	                        }
	                        _i = 0, added_1 = added;
	                        _b.label = 1;
	                    case 1:
	                        if (!(_i < added_1.length)) return [3 /*break*/, 6];
	                        targetId = added_1[_i];
	                        assert(!this.queriesByTarget[targetId], 'Trying to add an already active target');
	                        return [4 /*yield*/, this.localStore.getTarget(targetId)];
	                    case 2:
	                        target = _b.sent();
	                        assert(!!target, "Query data for active target " + targetId + " not found");
	                        return [4 /*yield*/, this.localStore.allocateTarget(target)];
	                    case 3:
	                        targetData = _b.sent();
	                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(this.synthesizeTargetToQuery(target), targetData.targetId, 
	                            /*current=*/ false)];
	                    case 4:
	                        _b.sent();
	                        this.remoteStore.listen(targetData);
	                        _b.label = 5;
	                    case 5:
	                        _i++;
	                        return [3 /*break*/, 1];
	                    case 6:
	                        _loop_1 = function (targetId) {
	                            return tslib.__generator(this, function (_a) {
	                                switch (_a.label) {
	                                    case 0:
	                                        // Check that the target is still active since the target might have been
	                                        // removed if it has been rejected by the backend.
	                                        if (!this_1.queriesByTarget[targetId]) {
	                                            return [2 /*return*/, "continue"];
	                                        }
	                                        // Release queries that are still active.
	                                        return [4 /*yield*/, this_1.localStore
	                                                .releaseTarget(targetId, /* keepPersistedTargetData */ false)
	                                                .then(function () {
	                                                _this.remoteStore.unlisten(targetId);
	                                                _this.removeAndCleanupTarget(targetId);
	                                            })
	                                                .catch(ignoreIfPrimaryLeaseLoss)];
	                                    case 1:
	                                        // Release queries that are still active.
	                                        _a.sent();
	                                        return [2 /*return*/];
	                                }
	                            });
	                        };
	                        this_1 = this;
	                        _a = 0, removed_1 = removed;
	                        _b.label = 7;
	                    case 7:
	                        if (!(_a < removed_1.length)) return [3 /*break*/, 10];
	                        targetId = removed_1[_a];
	                        return [5 /*yield**/, _loop_1(targetId)];
	                    case 8:
	                        _b.sent();
	                        _b.label = 9;
	                    case 9:
	                        _a++;
	                        return [3 /*break*/, 7];
	                    case 10: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    // PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
	    // the online state.
	    SyncEngine.prototype.enableNetwork = function () {
	        this.localStore.setNetworkEnabled(true);
	        return this.remoteStore.enableNetwork();
	    };
	    // PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
	    // the online state.
	    SyncEngine.prototype.disableNetwork = function () {
	        this.localStore.setNetworkEnabled(false);
	        return this.remoteStore.disableNetwork();
	    };
	    SyncEngine.prototype.getRemoteKeysForTarget = function (targetId) {
	        var limboResolution = this.limboResolutionsByTarget[targetId];
	        if (limboResolution && limboResolution.receivedDocument) {
	            return documentKeySet().add(limboResolution.key);
	        }
	        else {
	            var keySet = documentKeySet();
	            var queries = this.queriesByTarget[targetId];
	            if (!queries) {
	                return keySet;
	            }
	            for (var _i = 0, queries_2 = queries; _i < queries_2.length; _i++) {
	                var query = queries_2[_i];
	                var queryView = this.queryViewsByQuery.get(query);
	                assert(!!queryView, "No query view found for " + query);
	                keySet = keySet.unionWith(queryView.view.syncedDocuments);
	            }
	            return keySet;
	        }
	    };
	    return SyncEngine;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Simple wrapper around a nullable UID. Mostly exists to make code more
	 * readable.
	 */
	var User = /** @class */ (function () {
	    function User(uid) {
	        this.uid = uid;
	    }
	    User.prototype.isAuthenticated = function () {
	        return this.uid != null;
	    };
	    /**
	     * Returns a key representing this user, suitable for inclusion in a
	     * dictionary.
	     */
	    User.prototype.toKey = function () {
	        if (this.isAuthenticated()) {
	            return 'uid:' + this.uid;
	        }
	        else {
	            return 'anonymous-user';
	        }
	    };
	    User.prototype.isEqual = function (otherUser) {
	        return otherUser.uid === this.uid;
	    };
	    /** A user with a null UID. */
	    User.UNAUTHENTICATED = new User(null);
	    // TODO(mikelehen): Look into getting a proper uid-equivalent for
	    // non-FirebaseAuth providers.
	    User.GOOGLE_CREDENTIALS = new User('google-credentials-uid');
	    User.FIRST_PARTY = new User('first-party-uid');
	    return User;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// The format of the LocalStorage key that stores the client state is:
	//     firestore_clients_<persistence_prefix>_<instance_key>
	var CLIENT_STATE_KEY_PREFIX = 'firestore_clients';
	/** Assembles the key for a client state in WebStorage */
	function createWebStorageClientStateKey(persistenceKey, clientId) {
	    assert(clientId.indexOf('_') === -1, "Client key cannot contain '_', but was '" + clientId + "'");
	    return CLIENT_STATE_KEY_PREFIX + "_" + persistenceKey + "_" + clientId;
	}
	// The format of the WebStorage key that stores the mutation state is:
	//     firestore_mutations_<persistence_prefix>_<batch_id>
	//     (for unauthenticated users)
	// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
	//
	// 'user_uid' is last to avoid needing to escape '_' characters that it might
	// contain.
	var MUTATION_BATCH_KEY_PREFIX = 'firestore_mutations';
	/** Assembles the key for a mutation batch in WebStorage */
	function createWebStorageMutationBatchKey(persistenceKey, user, batchId) {
	    var mutationKey = MUTATION_BATCH_KEY_PREFIX + "_" + persistenceKey + "_" + batchId;
	    if (user.isAuthenticated()) {
	        mutationKey += "_" + user.uid;
	    }
	    return mutationKey;
	}
	// The format of the WebStorage key that stores a query target's metadata is:
	//     firestore_targets_<persistence_prefix>_<target_id>
	var QUERY_TARGET_KEY_PREFIX = 'firestore_targets';
	/** Assembles the key for a query state in WebStorage */
	function createWebStorageQueryTargetMetadataKey(persistenceKey, targetId) {
	    return QUERY_TARGET_KEY_PREFIX + "_" + persistenceKey + "_" + targetId;
	}
	// The WebStorage prefix that stores the primary tab's online state. The
	// format of the key is:
	//     firestore_online_state_<persistence_prefix>
	var ONLINE_STATE_KEY_PREFIX = 'firestore_online_state';
	/** Assembles the key for the online state of the primary tab. */
	function createWebStorageOnlineStateKey(persistenceKey) {
	    return ONLINE_STATE_KEY_PREFIX + "_" + persistenceKey;
	}
	// The WebStorage key prefix for the key that stores the last sequence number allocated. The key
	// looks like 'firestore_sequence_number_<persistence_prefix>'.
	var SEQUENCE_NUMBER_KEY_PREFIX = 'firestore_sequence_number';
	/** Assembles the key for the current sequence number. */
	function createWebStorageSequenceNumberKey(persistenceKey) {
	    return SEQUENCE_NUMBER_KEY_PREFIX + "_" + persistenceKey;
	}
	
	/**
	 * @license
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$a = 'SharedClientState';
	/**
	 * Holds the state of a mutation batch, including its user ID, batch ID and
	 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
	 */
	// Visible for testing
	var MutationMetadata = /** @class */ (function () {
	    function MutationMetadata(user, batchId, state, error) {
	        this.user = user;
	        this.batchId = batchId;
	        this.state = state;
	        this.error = error;
	        assert((error !== undefined) === (state === 'rejected'), "MutationMetadata must contain an error iff state is 'rejected'");
	    }
	    /**
	     * Parses a MutationMetadata from its JSON representation in WebStorage.
	     * Logs a warning and returns null if the format of the data is not valid.
	     */
	    MutationMetadata.fromWebStorageEntry = function (user, batchId, value) {
	        var mutationBatch = JSON.parse(value);
	        var validData = typeof mutationBatch === 'object' &&
	            ['pending', 'acknowledged', 'rejected'].indexOf(mutationBatch.state) !==
	                -1 &&
	            (mutationBatch.error === undefined ||
	                typeof mutationBatch.error === 'object');
	        var firestoreError = undefined;
	        if (validData && mutationBatch.error) {
	            validData =
	                typeof mutationBatch.error.message === 'string' &&
	                    typeof mutationBatch.error.code === 'string';
	            if (validData) {
	                firestoreError = new FirestoreError(mutationBatch.error.code, mutationBatch.error.message);
	            }
	        }
	        if (validData) {
	            return new MutationMetadata(user, batchId, mutationBatch.state, firestoreError);
	        }
	        else {
	            error(LOG_TAG$a, "Failed to parse mutation state for ID '" + batchId + "': " + value);
	            return null;
	        }
	    };
	    MutationMetadata.prototype.toWebStorageJSON = function () {
	        var batchMetadata = {
	            state: this.state,
	            updateTimeMs: Date.now() // Modify the existing value to trigger update.
	        };
	        if (this.error) {
	            batchMetadata.error = {
	                code: this.error.code,
	                message: this.error.message
	            };
	        }
	        return JSON.stringify(batchMetadata);
	    };
	    return MutationMetadata;
	}());
	/**
	 * Holds the state of a query target, including its target ID and whether the
	 * target is 'not-current', 'current' or 'rejected'.
	 */
	// Visible for testing
	var QueryTargetMetadata = /** @class */ (function () {
	    function QueryTargetMetadata(targetId, state, error) {
	        this.targetId = targetId;
	        this.state = state;
	        this.error = error;
	        assert((error !== undefined) === (state === 'rejected'), "QueryTargetMetadata must contain an error iff state is 'rejected'");
	    }
	    /**
	     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
	     * Logs a warning and returns null if the format of the data is not valid.
	     */
	    QueryTargetMetadata.fromWebStorageEntry = function (targetId, value) {
	        var targetState = JSON.parse(value);
	        var validData = typeof targetState === 'object' &&
	            ['not-current', 'current', 'rejected'].indexOf(targetState.state) !==
	                -1 &&
	            (targetState.error === undefined ||
	                typeof targetState.error === 'object');
	        var firestoreError = undefined;
	        if (validData && targetState.error) {
	            validData =
	                typeof targetState.error.message === 'string' &&
	                    typeof targetState.error.code === 'string';
	            if (validData) {
	                firestoreError = new FirestoreError(targetState.error.code, targetState.error.message);
	            }
	        }
	        if (validData) {
	            return new QueryTargetMetadata(targetId, targetState.state, firestoreError);
	        }
	        else {
	            error(LOG_TAG$a, "Failed to parse target state for ID '" + targetId + "': " + value);
	            return null;
	        }
	    };
	    QueryTargetMetadata.prototype.toWebStorageJSON = function () {
	        var targetState = {
	            state: this.state,
	            updateTimeMs: Date.now() // Modify the existing value to trigger update.
	        };
	        if (this.error) {
	            targetState.error = {
	                code: this.error.code,
	                message: this.error.message
	            };
	        }
	        return JSON.stringify(targetState);
	    };
	    return QueryTargetMetadata;
	}());
	/**
	 * This class represents the immutable ClientState for a client read from
	 * WebStorage, containing the list of active query targets.
	 */
	var RemoteClientState = /** @class */ (function () {
	    function RemoteClientState(clientId, activeTargetIds) {
	        this.clientId = clientId;
	        this.activeTargetIds = activeTargetIds;
	    }
	    /**
	     * Parses a RemoteClientState from the JSON representation in WebStorage.
	     * Logs a warning and returns null if the format of the data is not valid.
	     */
	    RemoteClientState.fromWebStorageEntry = function (clientId, value) {
	        var clientState = JSON.parse(value);
	        var validData = typeof clientState === 'object' &&
	            clientState.activeTargetIds instanceof Array;
	        var activeTargetIdsSet = targetIdSet();
	        for (var i = 0; validData && i < clientState.activeTargetIds.length; ++i) {
	            validData = isSafeInteger(clientState.activeTargetIds[i]);
	            activeTargetIdsSet = activeTargetIdsSet.add(clientState.activeTargetIds[i]);
	        }
	        if (validData) {
	            return new RemoteClientState(clientId, activeTargetIdsSet);
	        }
	        else {
	            error(LOG_TAG$a, "Failed to parse client data for instance '" + clientId + "': " + value);
	            return null;
	        }
	    };
	    return RemoteClientState;
	}());
	/**
	 * This class represents the online state for all clients participating in
	 * multi-tab. The online state is only written to by the primary client, and
	 * used in secondary clients to update their query views.
	 */
	var SharedOnlineState = /** @class */ (function () {
	    function SharedOnlineState(clientId, onlineState) {
	        this.clientId = clientId;
	        this.onlineState = onlineState;
	    }
	    /**
	     * Parses a SharedOnlineState from its JSON representation in WebStorage.
	     * Logs a warning and returns null if the format of the data is not valid.
	     */
	    SharedOnlineState.fromWebStorageEntry = function (value) {
	        var onlineState = JSON.parse(value);
	        var validData = typeof onlineState === 'object' &&
	            onlineState.onlineState in OnlineState &&
	            typeof onlineState.clientId === 'string';
	        if (validData) {
	            return new SharedOnlineState(onlineState.clientId, OnlineState[onlineState.onlineState]);
	        }
	        else {
	            error(LOG_TAG$a, "Failed to parse online state: " + value);
	            return null;
	        }
	    };
	    return SharedOnlineState;
	}());
	/**
	 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
	 * mutable and keeps track of all pending mutations, which allows us to
	 * update the range of pending mutation batch IDs as new mutations are added or
	 * removed.
	 *
	 * The data in `LocalClientState` is not read from WebStorage and instead
	 * updated via its instance methods. The updated state can be serialized via
	 * `toWebStorageJSON()`.
	 */
	// Visible for testing.
	var LocalClientState = /** @class */ (function () {
	    function LocalClientState() {
	        this.activeTargetIds = targetIdSet();
	    }
	    LocalClientState.prototype.addQueryTarget = function (targetId) {
	        this.activeTargetIds = this.activeTargetIds.add(targetId);
	    };
	    LocalClientState.prototype.removeQueryTarget = function (targetId) {
	        this.activeTargetIds = this.activeTargetIds.delete(targetId);
	    };
	    /**
	     * Converts this entry into a JSON-encoded format we can use for WebStorage.
	     * Does not encode `clientId` as it is part of the key in WebStorage.
	     */
	    LocalClientState.prototype.toWebStorageJSON = function () {
	        var data = {
	            activeTargetIds: this.activeTargetIds.toArray(),
	            updateTimeMs: Date.now() // Modify the existing value to trigger update.
	        };
	        return JSON.stringify(data);
	    };
	    return LocalClientState;
	}());
	/**
	 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
	 * backing store for the SharedClientState. It keeps track of all active
	 * clients and supports modifications of the local client's data.
	 */
	var WebStorageSharedClientState = /** @class */ (function () {
	    function WebStorageSharedClientState(queue, platform, persistenceKey, localClientId, initialUser) {
	        this.queue = queue;
	        this.platform = platform;
	        this.persistenceKey = persistenceKey;
	        this.localClientId = localClientId;
	        this.syncEngine = null;
	        this.onlineStateHandler = null;
	        this.sequenceNumberHandler = null;
	        this.activeClients = {};
	        this.storageListener = this.handleWebStorageEvent.bind(this);
	        this.started = false;
	        /**
	         * Captures WebStorage events that occur before `start()` is called. These
	         * events are replayed once `WebStorageSharedClientState` is started.
	         */
	        this.earlyEvents = [];
	        if (!WebStorageSharedClientState.isAvailable(this.platform)) {
	            throw new FirestoreError(Code.UNIMPLEMENTED, 'LocalStorage is not available on this platform.');
	        }
	        // Escape the special characters mentioned here:
	        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	        var escapedPersistenceKey = persistenceKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	        this.storage = this.platform.window.localStorage;
	        this.currentUser = initialUser;
	        this.localClientStorageKey = createWebStorageClientStateKey(this.persistenceKey, this.localClientId);
	        this.sequenceNumberKey = createWebStorageSequenceNumberKey(this.persistenceKey);
	        this.activeClients[this.localClientId] = new LocalClientState();
	        this.clientStateKeyRe = new RegExp("^" + CLIENT_STATE_KEY_PREFIX + "_" + escapedPersistenceKey + "_([^_]*)$");
	        this.mutationBatchKeyRe = new RegExp("^" + MUTATION_BATCH_KEY_PREFIX + "_" + escapedPersistenceKey + "_(\\d+)(?:_(.*))?$");
	        this.queryTargetKeyRe = new RegExp("^" + QUERY_TARGET_KEY_PREFIX + "_" + escapedPersistenceKey + "_(\\d+)$");
	        this.onlineStateKey = createWebStorageOnlineStateKey(this.persistenceKey);
	        // Rather than adding the storage observer during start(), we add the
	        // storage observer during initialization. This ensures that we collect
	        // events before other components populate their initial state (during their
	        // respective start() calls). Otherwise, we might for example miss a
	        // mutation that is added after LocalStore's start() processed the existing
	        // mutations but before we observe WebStorage events.
	        this.platform.window.addEventListener('storage', this.storageListener);
	    }
	    /** Returns 'true' if WebStorage is available in the current environment. */
	    WebStorageSharedClientState.isAvailable = function (platform) {
	        return !!(platform.window && platform.window.localStorage != null);
	    };
	    WebStorageSharedClientState.prototype.start = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var existingClients, _i, existingClients_1, clientId, storageItem, clientState, onlineStateJSON, onlineState, _a, _b, event_1;
	            var _this = this;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        assert(!this.started, 'WebStorageSharedClientState already started');
	                        assert(this.syncEngine !== null, 'syncEngine property must be set before calling start()');
	                        assert(this.onlineStateHandler !== null, 'onlineStateHandler property must be set before calling start()');
	                        return [4 /*yield*/, this.syncEngine.getActiveClients()];
	                    case 1:
	                        existingClients = _c.sent();
	                        for (_i = 0, existingClients_1 = existingClients; _i < existingClients_1.length; _i++) {
	                            clientId = existingClients_1[_i];
	                            if (clientId === this.localClientId) {
	                                continue;
	                            }
	                            storageItem = this.getItem(createWebStorageClientStateKey(this.persistenceKey, clientId));
	                            if (storageItem) {
	                                clientState = RemoteClientState.fromWebStorageEntry(clientId, storageItem);
	                                if (clientState) {
	                                    this.activeClients[clientState.clientId] = clientState;
	                                }
	                            }
	                        }
	                        this.persistClientState();
	                        onlineStateJSON = this.storage.getItem(this.onlineStateKey);
	                        if (onlineStateJSON) {
	                            onlineState = this.fromWebStorageOnlineState(onlineStateJSON);
	                            if (onlineState) {
	                                this.handleOnlineStateEvent(onlineState);
	                            }
	                        }
	                        for (_a = 0, _b = this.earlyEvents; _a < _b.length; _a++) {
	                            event_1 = _b[_a];
	                            this.handleWebStorageEvent(event_1);
	                        }
	                        this.earlyEvents = [];
	                        // Register a window unload hook to remove the client metadata entry from
	                        // WebStorage even if `shutdown()` was not called.
	                        this.platform.window.addEventListener('unload', function () { return _this.shutdown(); });
	                        this.started = true;
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    WebStorageSharedClientState.prototype.writeSequenceNumber = function (sequenceNumber) {
	        this.setItem(this.sequenceNumberKey, JSON.stringify(sequenceNumber));
	    };
	    WebStorageSharedClientState.prototype.getAllActiveQueryTargets = function () {
	        var activeTargets = targetIdSet();
	        forEach(this.activeClients, function (key, value) {
	            activeTargets = activeTargets.unionWith(value.activeTargetIds);
	        });
	        return activeTargets;
	    };
	    WebStorageSharedClientState.prototype.isActiveQueryTarget = function (targetId) {
	        // This is not using `obj.forEach` since `forEach` doesn't support early
	        // return.
	        for (var clientId in this.activeClients) {
	            if (this.activeClients.hasOwnProperty(clientId)) {
	                if (this.activeClients[clientId].activeTargetIds.has(targetId)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    WebStorageSharedClientState.prototype.addPendingMutation = function (batchId) {
	        this.persistMutationState(batchId, 'pending');
	    };
	    WebStorageSharedClientState.prototype.updateMutationState = function (batchId, state, error) {
	        this.persistMutationState(batchId, state, error);
	        // Once a final mutation result is observed by other clients, they no longer
	        // access the mutation's metadata entry. Since WebStorage replays events
	        // in order, it is safe to delete the entry right after updating it.
	        this.removeMutationState(batchId);
	    };
	    WebStorageSharedClientState.prototype.addLocalQueryTarget = function (targetId) {
	        var queryState = 'not-current';
	        // Lookup an existing query state if the target ID was already registered
	        // by another tab
	        if (this.isActiveQueryTarget(targetId)) {
	            var storageItem = this.storage.getItem(createWebStorageQueryTargetMetadataKey(this.persistenceKey, targetId));
	            if (storageItem) {
	                var metadata = QueryTargetMetadata.fromWebStorageEntry(targetId, storageItem);
	                if (metadata) {
	                    queryState = metadata.state;
	                }
	            }
	        }
	        this.localClientState.addQueryTarget(targetId);
	        this.persistClientState();
	        return queryState;
	    };
	    WebStorageSharedClientState.prototype.removeLocalQueryTarget = function (targetId) {
	        this.localClientState.removeQueryTarget(targetId);
	        this.persistClientState();
	    };
	    WebStorageSharedClientState.prototype.isLocalQueryTarget = function (targetId) {
	        return this.localClientState.activeTargetIds.has(targetId);
	    };
	    WebStorageSharedClientState.prototype.clearQueryState = function (targetId) {
	        this.removeItem(createWebStorageQueryTargetMetadataKey(this.persistenceKey, targetId));
	    };
	    WebStorageSharedClientState.prototype.updateQueryState = function (targetId, state, error) {
	        this.persistQueryTargetState(targetId, state, error);
	    };
	    WebStorageSharedClientState.prototype.handleUserChange = function (user, removedBatchIds, addedBatchIds) {
	        var _this = this;
	        removedBatchIds.forEach(function (batchId) {
	            _this.removeMutationState(batchId);
	        });
	        this.currentUser = user;
	        addedBatchIds.forEach(function (batchId) {
	            _this.addPendingMutation(batchId);
	        });
	    };
	    WebStorageSharedClientState.prototype.setOnlineState = function (onlineState) {
	        this.persistOnlineState(onlineState);
	    };
	    WebStorageSharedClientState.prototype.shutdown = function () {
	        if (this.started) {
	            this.platform.window.removeEventListener('storage', this.storageListener);
	            this.removeItem(this.localClientStorageKey);
	            this.started = false;
	        }
	    };
	    WebStorageSharedClientState.prototype.getItem = function (key) {
	        var value = this.storage.getItem(key);
	        debug(LOG_TAG$a, 'READ', key, value);
	        return value;
	    };
	    WebStorageSharedClientState.prototype.setItem = function (key, value) {
	        debug(LOG_TAG$a, 'SET', key, value);
	        this.storage.setItem(key, value);
	    };
	    WebStorageSharedClientState.prototype.removeItem = function (key) {
	        debug(LOG_TAG$a, 'REMOVE', key);
	        this.storage.removeItem(key);
	    };
	    WebStorageSharedClientState.prototype.handleWebStorageEvent = function (event) {
	        var _this = this;
	        if (event.storageArea === this.storage) {
	            debug(LOG_TAG$a, 'EVENT', event.key, event.newValue);
	            if (event.key === this.localClientStorageKey) {
	                error('Received WebStorage notification for local change. Another client might have ' +
	                    'garbage-collected our state');
	                return;
	            }
	            this.queue.enqueueAndForget(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	                var clientState, clientId, mutationMetadata, queryTargetMetadata, onlineState, sequenceNumber;
	                return tslib.__generator(this, function (_a) {
	                    if (!this.started) {
	                        this.earlyEvents.push(event);
	                        return [2 /*return*/];
	                    }
	                    if (event.key === null) {
	                        return [2 /*return*/];
	                    }
	                    if (this.clientStateKeyRe.test(event.key)) {
	                        if (event.newValue != null) {
	                            clientState = this.fromWebStorageClientState(event.key, event.newValue);
	                            if (clientState) {
	                                return [2 /*return*/, this.handleClientStateEvent(clientState.clientId, clientState)];
	                            }
	                        }
	                        else {
	                            clientId = this.fromWebStorageClientStateKey(event.key);
	                            return [2 /*return*/, this.handleClientStateEvent(clientId, null)];
	                        }
	                    }
	                    else if (this.mutationBatchKeyRe.test(event.key)) {
	                        if (event.newValue !== null) {
	                            mutationMetadata = this.fromWebStorageMutationMetadata(event.key, event.newValue);
	                            if (mutationMetadata) {
	                                return [2 /*return*/, this.handleMutationBatchEvent(mutationMetadata)];
	                            }
	                        }
	                    }
	                    else if (this.queryTargetKeyRe.test(event.key)) {
	                        if (event.newValue !== null) {
	                            queryTargetMetadata = this.fromWebStorageQueryTargetMetadata(event.key, event.newValue);
	                            if (queryTargetMetadata) {
	                                return [2 /*return*/, this.handleQueryTargetEvent(queryTargetMetadata)];
	                            }
	                        }
	                    }
	                    else if (event.key === this.onlineStateKey) {
	                        if (event.newValue !== null) {
	                            onlineState = this.fromWebStorageOnlineState(event.newValue);
	                            if (onlineState) {
	                                return [2 /*return*/, this.handleOnlineStateEvent(onlineState)];
	                            }
	                        }
	                    }
	                    else if (event.key === this.sequenceNumberKey) {
	                        assert(!!this.sequenceNumberHandler, 'Missing sequenceNumberHandler');
	                        sequenceNumber = fromWebStorageSequenceNumber(event.newValue);
	                        if (sequenceNumber !== ListenSequence.INVALID) {
	                            this.sequenceNumberHandler(sequenceNumber);
	                        }
	                    }
	                    return [2 /*return*/];
	                });
	            }); });
	        }
	    };
	    Object.defineProperty(WebStorageSharedClientState.prototype, "localClientState", {
	        get: function () {
	            return this.activeClients[this.localClientId];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    WebStorageSharedClientState.prototype.persistClientState = function () {
	        this.setItem(this.localClientStorageKey, this.localClientState.toWebStorageJSON());
	    };
	    WebStorageSharedClientState.prototype.persistMutationState = function (batchId, state, error) {
	        var mutationState = new MutationMetadata(this.currentUser, batchId, state, error);
	        var mutationKey = createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, batchId);
	        this.setItem(mutationKey, mutationState.toWebStorageJSON());
	    };
	    WebStorageSharedClientState.prototype.removeMutationState = function (batchId) {
	        var mutationKey = createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, batchId);
	        this.removeItem(mutationKey);
	    };
	    WebStorageSharedClientState.prototype.persistOnlineState = function (onlineState) {
	        var entry = {
	            clientId: this.localClientId,
	            onlineState: OnlineState[onlineState]
	        };
	        this.storage.setItem(this.onlineStateKey, JSON.stringify(entry));
	    };
	    WebStorageSharedClientState.prototype.persistQueryTargetState = function (targetId, state, error) {
	        var targetKey = createWebStorageQueryTargetMetadataKey(this.persistenceKey, targetId);
	        var targetMetadata = new QueryTargetMetadata(targetId, state, error);
	        this.setItem(targetKey, targetMetadata.toWebStorageJSON());
	    };
	    /**
	     * Parses a client state key in WebStorage. Returns null if the key does not
	     * match the expected key format.
	     */
	    WebStorageSharedClientState.prototype.fromWebStorageClientStateKey = function (key) {
	        var match = this.clientStateKeyRe.exec(key);
	        return match ? match[1] : null;
	    };
	    /**
	     * Parses a client state in WebStorage. Returns 'null' if the value could not
	     * be parsed.
	     */
	    WebStorageSharedClientState.prototype.fromWebStorageClientState = function (key, value) {
	        var clientId = this.fromWebStorageClientStateKey(key);
	        assert(clientId !== null, "Cannot parse client state key '" + key + "'");
	        return RemoteClientState.fromWebStorageEntry(clientId, value);
	    };
	    /**
	     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
	     * could not be parsed.
	     */
	    WebStorageSharedClientState.prototype.fromWebStorageMutationMetadata = function (key, value) {
	        var match = this.mutationBatchKeyRe.exec(key);
	        assert(match !== null, "Cannot parse mutation batch key '" + key + "'");
	        var batchId = Number(match[1]);
	        var userId = match[2] !== undefined ? match[2] : null;
	        return MutationMetadata.fromWebStorageEntry(new User(userId), batchId, value);
	    };
	    /**
	     * Parses a query target state from WebStorage. Returns 'null' if the value
	     * could not be parsed.
	     */
	    WebStorageSharedClientState.prototype.fromWebStorageQueryTargetMetadata = function (key, value) {
	        var match = this.queryTargetKeyRe.exec(key);
	        assert(match !== null, "Cannot parse query target key '" + key + "'");
	        var targetId = Number(match[1]);
	        return QueryTargetMetadata.fromWebStorageEntry(targetId, value);
	    };
	    /**
	     * Parses an online state from WebStorage. Returns 'null' if the value
	     * could not be parsed.
	     */
	    WebStorageSharedClientState.prototype.fromWebStorageOnlineState = function (value) {
	        return SharedOnlineState.fromWebStorageEntry(value);
	    };
	    WebStorageSharedClientState.prototype.handleMutationBatchEvent = function (mutationBatch) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                if (mutationBatch.user.uid !== this.currentUser.uid) {
	                    debug(LOG_TAG$a, "Ignoring mutation for non-active user " + mutationBatch.user.uid);
	                    return [2 /*return*/];
	                }
	                return [2 /*return*/, this.syncEngine.applyBatchState(mutationBatch.batchId, mutationBatch.state, mutationBatch.error)];
	            });
	        });
	    };
	    WebStorageSharedClientState.prototype.handleQueryTargetEvent = function (targetMetadata) {
	        return this.syncEngine.applyTargetState(targetMetadata.targetId, targetMetadata.state, targetMetadata.error);
	    };
	    WebStorageSharedClientState.prototype.handleClientStateEvent = function (clientId, clientState) {
	        var _this = this;
	        var existingTargets = this.getAllActiveQueryTargets();
	        if (clientState) {
	            this.activeClients[clientId] = clientState;
	        }
	        else {
	            delete this.activeClients[clientId];
	        }
	        var newTargets = this.getAllActiveQueryTargets();
	        var addedTargets = [];
	        var removedTargets = [];
	        newTargets.forEach(function (targetId) { return tslib.__awaiter(_this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                if (!existingTargets.has(targetId)) {
	                    addedTargets.push(targetId);
	                }
	                return [2 /*return*/];
	            });
	        }); });
	        existingTargets.forEach(function (targetId) { return tslib.__awaiter(_this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                if (!newTargets.has(targetId)) {
	                    removedTargets.push(targetId);
	                }
	                return [2 /*return*/];
	            });
	        }); });
	        return this.syncEngine.applyActiveTargetsChange(addedTargets, removedTargets);
	    };
	    WebStorageSharedClientState.prototype.handleOnlineStateEvent = function (onlineState) {
	        // We check whether the client that wrote this online state is still active
	        // by comparing its client ID to the list of clients kept active in
	        // IndexedDb. If a client does not update their IndexedDb client state
	        // within 5 seconds, it is considered inactive and we don't emit an online
	        // state event.
	        if (this.activeClients[onlineState.clientId]) {
	            this.onlineStateHandler(onlineState.onlineState);
	        }
	    };
	    return WebStorageSharedClientState;
	}());
	function fromWebStorageSequenceNumber(seqString) {
	    var sequenceNumber = ListenSequence.INVALID;
	    if (seqString != null) {
	        try {
	            var parsed = JSON.parse(seqString);
	            assert(typeof parsed === 'number', 'Found non-numeric sequence number');
	            sequenceNumber = parsed;
	        }
	        catch (e) {
	            error(LOG_TAG$a, 'Failed to read sequence number from WebStorage', e);
	        }
	    }
	    return sequenceNumber;
	}
	/**
	 * `MemorySharedClientState` is a simple implementation of SharedClientState for
	 * clients using memory persistence. The state in this class remains fully
	 * isolated and no synchronization is performed.
	 */
	var MemorySharedClientState = /** @class */ (function () {
	    function MemorySharedClientState() {
	        this.localState = new LocalClientState();
	        this.queryState = {};
	        this.syncEngine = null;
	        this.onlineStateHandler = null;
	        this.sequenceNumberHandler = null;
	    }
	    MemorySharedClientState.prototype.addPendingMutation = function (batchId) {
	        // No op.
	    };
	    MemorySharedClientState.prototype.updateMutationState = function (batchId, state, error) {
	        // No op.
	    };
	    MemorySharedClientState.prototype.addLocalQueryTarget = function (targetId) {
	        this.localState.addQueryTarget(targetId);
	        return this.queryState[targetId] || 'not-current';
	    };
	    MemorySharedClientState.prototype.updateQueryState = function (targetId, state, error) {
	        this.queryState[targetId] = state;
	    };
	    MemorySharedClientState.prototype.removeLocalQueryTarget = function (targetId) {
	        this.localState.removeQueryTarget(targetId);
	    };
	    MemorySharedClientState.prototype.isLocalQueryTarget = function (targetId) {
	        return this.localState.activeTargetIds.has(targetId);
	    };
	    MemorySharedClientState.prototype.clearQueryState = function (targetId) {
	        delete this.queryState[targetId];
	    };
	    MemorySharedClientState.prototype.getAllActiveQueryTargets = function () {
	        return this.localState.activeTargetIds;
	    };
	    MemorySharedClientState.prototype.isActiveQueryTarget = function (targetId) {
	        return this.localState.activeTargetIds.has(targetId);
	    };
	    MemorySharedClientState.prototype.start = function () {
	        this.localState = new LocalClientState();
	        return Promise.resolve();
	    };
	    MemorySharedClientState.prototype.handleUserChange = function (user, removedBatchIds, addedBatchIds) {
	        // No op.
	    };
	    MemorySharedClientState.prototype.setOnlineState = function (onlineState) {
	        // No op.
	    };
	    MemorySharedClientState.prototype.shutdown = function () { };
	    MemorySharedClientState.prototype.writeSequenceNumber = function (sequenceNumber) { };
	    return MemorySharedClientState;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$b = 'FirestoreClient';
	/** DOMException error code constants. */
	var DOM_EXCEPTION_INVALID_STATE = 11;
	var DOM_EXCEPTION_ABORTED = 20;
	var DOM_EXCEPTION_QUOTA_EXCEEDED = 22;
	var IndexedDbPersistenceSettings = /** @class */ (function () {
	    function IndexedDbPersistenceSettings(cacheSizeBytes, synchronizeTabs) {
	        this.cacheSizeBytes = cacheSizeBytes;
	        this.synchronizeTabs = synchronizeTabs;
	    }
	    IndexedDbPersistenceSettings.prototype.lruParams = function () {
	        return LruParams.withCacheSize(this.cacheSizeBytes);
	    };
	    return IndexedDbPersistenceSettings;
	}());
	var MemoryPersistenceSettings = /** @class */ (function () {
	    function MemoryPersistenceSettings() {
	    }
	    return MemoryPersistenceSettings;
	}());
	/**
	 * FirestoreClient is a top-level class that constructs and owns all of the
	 * pieces of the client SDK architecture. It is responsible for creating the
	 * async queue that is shared by all of the other components in the system.
	 */
	var FirestoreClient = /** @class */ (function () {
	    function FirestoreClient(platform, databaseInfo, credentials, 
	    /**
	     * Asynchronous queue responsible for all of our internal processing. When
	     * we get incoming work from the user (via public API) or the network
	     * (incoming GRPC messages), we should always schedule onto this queue.
	     * This ensures all of our work is properly serialized (e.g. we don't
	     * start processing a new operation while the previous one is waiting for
	     * an async I/O to complete).
	     */
	    asyncQueue) {
	        this.platform = platform;
	        this.databaseInfo = databaseInfo;
	        this.credentials = credentials;
	        this.asyncQueue = asyncQueue;
	        this.clientId = AutoId.newId();
	    }
	    /**
	     * Starts up the FirestoreClient, returning only whether or not enabling
	     * persistence succeeded.
	     *
	     * The intent here is to "do the right thing" as far as users are concerned.
	     * Namely, in cases where offline persistence is requested and possible,
	     * enable it, but otherwise fall back to persistence disabled. For the most
	     * part we expect this to succeed one way or the other so we don't expect our
	     * users to actually wait on the firestore.enablePersistence Promise since
	     * they generally won't care.
	     *
	     * Of course some users actually do care about whether or not persistence
	     * was successfully enabled, so the Promise returned from this method
	     * indicates this outcome.
	     *
	     * This presents a problem though: even before enablePersistence resolves or
	     * rejects, users may have made calls to e.g. firestore.collection() which
	     * means that the FirestoreClient in there will be available and will be
	     * enqueuing actions on the async queue.
	     *
	     * Meanwhile any failure of an operation on the async queue causes it to
	     * panic and reject any further work, on the premise that unhandled errors
	     * are fatal.
	     *
	     * Consequently the fallback is handled internally here in start, and if the
	     * fallback succeeds we signal success to the async queue even though the
	     * start() itself signals failure.
	     *
	     * @param persistenceSettings Settings object to configure offline
	     *     persistence.
	     * @returns A deferred result indicating the user-visible result of enabling
	     *     offline persistence. This method will reject this if IndexedDB fails to
	     *     start for any reason. If usePersistence is false this is
	     *     unconditionally resolved.
	     */
	    FirestoreClient.prototype.start = function (persistenceSettings) {
	        var _this = this;
	        this.verifyNotTerminated();
	        // We defer our initialization until we get the current user from
	        // setChangeListener(). We block the async queue until we got the initial
	        // user and the initialization is completed. This will prevent any scheduled
	        // work from happening before initialization is completed.
	        //
	        // If initializationDone resolved then the FirestoreClient is in a usable
	        // state.
	        var initializationDone = new Deferred();
	        // If usePersistence is true, certain classes of errors while starting are
	        // recoverable but only by falling back to persistence disabled.
	        //
	        // If there's an error in the first case but not in recovery we cannot
	        // reject the promise blocking the async queue because this will cause the
	        // async queue to panic.
	        var persistenceResult = new Deferred();
	        var initialized = false;
	        this.credentials.setChangeListener(function (user) {
	            if (!initialized) {
	                initialized = true;
	                _this.initializePersistence(persistenceSettings, persistenceResult, user)
	                    .then(function (maybeLruGc) { return _this.initializeRest(user, maybeLruGc); })
	                    .then(initializationDone.resolve, initializationDone.reject);
	            }
	            else {
	                _this.asyncQueue.enqueueAndForget(function () {
	                    return _this.handleCredentialChange(user);
	                });
	            }
	        });
	        // Block the async queue until initialization is done
	        this.asyncQueue.enqueueAndForget(function () {
	            return initializationDone.promise;
	        });
	        // Return only the result of enabling persistence. Note that this does not
	        // need to await the completion of initializationDone because the result of
	        // this method should not reflect any other kind of failure to start.
	        return persistenceResult.promise;
	    };
	    /** Enables the network connection and requeues all pending operations. */
	    FirestoreClient.prototype.enableNetwork = function () {
	        var _this = this;
	        this.verifyNotTerminated();
	        return this.asyncQueue.enqueue(function () {
	            return _this.syncEngine.enableNetwork();
	        });
	    };
	    /**
	     * Initializes persistent storage, attempting to use IndexedDB if
	     * usePersistence is true or memory-only if false.
	     *
	     * If IndexedDB fails because it's already open in another tab or because the
	     * platform can't possibly support our implementation then this method rejects
	     * the persistenceResult and falls back on memory-only persistence.
	     *
	     * @param persistenceSettings Settings object to configure offline persistence
	     * @param persistenceResult A deferred result indicating the user-visible
	     *     result of enabling offline persistence. This method will reject this if
	     *     IndexedDB fails to start for any reason. If usePersistence is false
	     *     this is unconditionally resolved.
	     * @returns a Promise indicating whether or not initialization should
	     *     continue, i.e. that one of the persistence implementations actually
	     *     succeeded.
	     */
	    FirestoreClient.prototype.initializePersistence = function (persistenceSettings, persistenceResult, user) {
	        var _this = this;
	        if (persistenceSettings instanceof IndexedDbPersistenceSettings) {
	            return this.startIndexedDbPersistence(user, persistenceSettings)
	                .then(function (maybeLruGc) {
	                persistenceResult.resolve();
	                return maybeLruGc;
	            })
	                .catch(function (error) {
	                // Regardless of whether or not the retry succeeds, from an user
	                // perspective, offline persistence has failed.
	                persistenceResult.reject(error);
	                // An unknown failure on the first stage shuts everything down.
	                if (!_this.canFallback(error)) {
	                    throw error;
	                }
	                console.warn('Error enabling offline persistence. Falling back to' +
	                    ' persistence disabled: ' +
	                    error);
	                return _this.startMemoryPersistence();
	            });
	        }
	        else {
	            // When usePersistence == false, enabling offline persistence is defined
	            // to unconditionally succeed. This allows start() to have the same
	            // signature for both cases, despite the fact that the returned promise
	            // is only used in the enablePersistence call.
	            persistenceResult.resolve();
	            return this.startMemoryPersistence();
	        }
	    };
	    /**
	     * Decides whether the provided error allows us to gracefully disable
	     * persistence (as opposed to crashing the client).
	     */
	    FirestoreClient.prototype.canFallback = function (error) {
	        if (error instanceof FirestoreError) {
	            return (error.code === Code.FAILED_PRECONDITION ||
	                error.code === Code.UNIMPLEMENTED);
	        }
	        else if (typeof DOMException !== 'undefined' &&
	            error instanceof DOMException) {
	            // There are a few known circumstances where we can open IndexedDb but
	            // trying to read/write will fail (e.g. quota exceeded). For
	            // well-understood cases, we attempt to detect these and then gracefully
	            // fall back to memory persistence.
	            // NOTE: Rather than continue to add to this list, we could decide to
	            // always fall back, with the risk that we might accidentally hide errors
	            // representing actual SDK bugs.
	            return (
	            // When the browser is out of quota we could get either quota exceeded
	            // or an aborted error depending on whether the error happened during
	            // schema migration.
	            error.code === DOM_EXCEPTION_QUOTA_EXCEEDED ||
	                error.code === DOM_EXCEPTION_ABORTED ||
	                // Firefox Private Browsing mode disables IndexedDb and returns
	                // INVALID_STATE for any usage.
	                error.code === DOM_EXCEPTION_INVALID_STATE);
	        }
	        return true;
	    };
	    /**
	     * Checks that the client has not been terminated. Ensures that other methods on
	     * this class cannot be called after the client is terminated.
	     */
	    FirestoreClient.prototype.verifyNotTerminated = function () {
	        if (this.asyncQueue.isShuttingDown) {
	            throw new FirestoreError(Code.FAILED_PRECONDITION, 'The client has already been terminated.');
	        }
	    };
	    /**
	     * Starts IndexedDB-based persistence.
	     *
	     * @returns A promise indicating success or failure.
	     */
	    FirestoreClient.prototype.startIndexedDbPersistence = function (user, settings) {
	        var _this = this;
	        // TODO(http://b/33384523): For now we just disable garbage collection
	        // when persistence is enabled.
	        var persistenceKey = IndexedDbPersistence.buildStoragePrefix(this.databaseInfo);
	        // Opt to use proto3 JSON in case the platform doesn't support Uint8Array.
	        var serializer = new JsonProtoSerializer(this.databaseInfo.databaseId, {
	            useProto3Json: true
	        });
	        return Promise.resolve().then(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	            var lruParams, persistence;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (settings.synchronizeTabs &&
	                            !WebStorageSharedClientState.isAvailable(this.platform)) {
	                            throw new FirestoreError(Code.UNIMPLEMENTED, 'IndexedDB persistence is only available on platforms that support LocalStorage.');
	                        }
	                        lruParams = settings.lruParams();
	                        this.sharedClientState = settings.synchronizeTabs
	                            ? new WebStorageSharedClientState(this.asyncQueue, this.platform, persistenceKey, this.clientId, user)
	                            : new MemorySharedClientState();
	                        return [4 /*yield*/, IndexedDbPersistence.createIndexedDbPersistence({
	                                allowTabSynchronization: settings.synchronizeTabs,
	                                persistenceKey: persistenceKey,
	                                clientId: this.clientId,
	                                platform: this.platform,
	                                queue: this.asyncQueue,
	                                serializer: serializer,
	                                lruParams: lruParams,
	                                sequenceNumberSyncer: this.sharedClientState
	                            })];
	                    case 1:
	                        persistence = _a.sent();
	                        this.persistence = persistence;
	                        return [2 /*return*/, persistence.referenceDelegate.garbageCollector];
	                }
	            });
	        }); });
	    };
	    /**
	     * Starts Memory-backed persistence. In practice this cannot fail.
	     *
	     * @returns A promise that will successfully resolve.
	     */
	    FirestoreClient.prototype.startMemoryPersistence = function () {
	        this.persistence = MemoryPersistence.createEagerPersistence(this.clientId);
	        this.sharedClientState = new MemorySharedClientState();
	        return Promise.resolve(null);
	    };
	    /**
	     * Initializes the rest of the FirestoreClient, assuming the initial user
	     * has been obtained from the credential provider and some persistence
	     * implementation is available in this.persistence.
	     */
	    FirestoreClient.prototype.initializeRest = function (user, maybeLruGc) {
	        var _this = this;
	        debug(LOG_TAG$b, 'Initializing. user=', user.uid);
	        return this.platform
	            .loadConnection(this.databaseInfo)
	            .then(function (connection) { return tslib.__awaiter(_this, void 0, void 0, function () {
	            var queryEngine, connectivityMonitor, serializer, datastore, remoteStoreOnlineStateChangedHandler, sharedClientStateOnlineStateChangedHandler;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        queryEngine = new IndexFreeQueryEngine();
	                        this.localStore = new LocalStore(this.persistence, queryEngine, user);
	                        return [4 /*yield*/, this.localStore.start()];
	                    case 1:
	                        _a.sent();
	                        if (maybeLruGc) {
	                            // We're running LRU Garbage collection. Set up the scheduler.
	                            this.lruScheduler = new LruScheduler(maybeLruGc, this.asyncQueue, this.localStore);
	                        }
	                        connectivityMonitor = this.platform.newConnectivityMonitor();
	                        serializer = this.platform.newSerializer(this.databaseInfo.databaseId);
	                        datastore = new Datastore(this.asyncQueue, connection, this.credentials, serializer);
	                        remoteStoreOnlineStateChangedHandler = function (onlineState) {
	                            return _this.syncEngine.applyOnlineStateChange(onlineState, OnlineStateSource.RemoteStore);
	                        };
	                        sharedClientStateOnlineStateChangedHandler = function (onlineState) {
	                            return _this.syncEngine.applyOnlineStateChange(onlineState, OnlineStateSource.SharedClientState);
	                        };
	                        this.remoteStore = new RemoteStore(this.localStore, datastore, this.asyncQueue, remoteStoreOnlineStateChangedHandler, connectivityMonitor);
	                        this.syncEngine = new SyncEngine(this.localStore, this.remoteStore, this.sharedClientState, user);
	                        this.sharedClientState.onlineStateHandler = sharedClientStateOnlineStateChangedHandler;
	                        // Set up wiring between sync engine and other components
	                        this.remoteStore.syncEngine = this.syncEngine;
	                        this.sharedClientState.syncEngine = this.syncEngine;
	                        this.eventMgr = new EventManager(this.syncEngine);
	                        // PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
	                        return [4 /*yield*/, this.sharedClientState.start()];
	                    case 2:
	                        // PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
	                        _a.sent();
	                        return [4 /*yield*/, this.remoteStore.start()];
	                    case 3:
	                        _a.sent();
	                        // NOTE: This will immediately call the listener, so we make sure to
	                        // set it after localStore / remoteStore are started.
	                        return [4 /*yield*/, this.persistence.setPrimaryStateListener(function (isPrimary) { return tslib.__awaiter(_this, void 0, void 0, function () {
	                                return tslib.__generator(this, function (_a) {
	                                    switch (_a.label) {
	                                        case 0: return [4 /*yield*/, this.syncEngine.applyPrimaryState(isPrimary)];
	                                        case 1:
	                                            _a.sent();
	                                            if (this.lruScheduler) {
	                                                if (isPrimary && !this.lruScheduler.started) {
	                                                    this.lruScheduler.start();
	                                                }
	                                                else if (!isPrimary) {
	                                                    this.lruScheduler.stop();
	                                                }
	                                            }
	                                            return [2 /*return*/];
	                                    }
	                                });
	                            }); })];
	                    case 4:
	                        // NOTE: This will immediately call the listener, so we make sure to
	                        // set it after localStore / remoteStore are started.
	                        _a.sent();
	                        // When a user calls clearPersistence() in one client, all other clients
	                        // need to be terminated to allow the delete to succeed.
	                        return [4 /*yield*/, this.persistence.setDatabaseDeletedListener(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	                                return tslib.__generator(this, function (_a) {
	                                    switch (_a.label) {
	                                        case 0: return [4 /*yield*/, this.terminate()];
	                                        case 1:
	                                            _a.sent();
	                                            return [2 /*return*/];
	                                    }
	                                });
	                            }); })];
	                    case 5:
	                        // When a user calls clearPersistence() in one client, all other clients
	                        // need to be terminated to allow the delete to succeed.
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        }); });
	    };
	    FirestoreClient.prototype.handleCredentialChange = function (user) {
	        this.asyncQueue.verifyOperationInProgress();
	        debug(LOG_TAG$b, 'Credential Changed. Current user: ' + user.uid);
	        return this.syncEngine.handleCredentialChange(user);
	    };
	    /** Disables the network connection. Pending operations will not complete. */
	    FirestoreClient.prototype.disableNetwork = function () {
	        var _this = this;
	        this.verifyNotTerminated();
	        return this.asyncQueue.enqueue(function () {
	            return _this.syncEngine.disableNetwork();
	        });
	    };
	    FirestoreClient.prototype.terminate = function () {
	        var _this = this;
	        return this.asyncQueue.enqueueAndInitiateShutdown(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
	                        if (this.lruScheduler) {
	                            this.lruScheduler.stop();
	                        }
	                        return [4 /*yield*/, this.remoteStore.shutdown()];
	                    case 1:
	                        _a.sent();
	                        return [4 /*yield*/, this.sharedClientState.shutdown()];
	                    case 2:
	                        _a.sent();
	                        return [4 /*yield*/, this.persistence.shutdown()];
	                    case 3:
	                        _a.sent();
	                        // `removeChangeListener` must be called after shutting down the
	                        // RemoteStore as it will prevent the RemoteStore from retrieving
	                        // auth tokens.
	                        this.credentials.removeChangeListener();
	                        return [2 /*return*/];
	                }
	            });
	        }); });
	    };
	    /**
	     * Returns a Promise that resolves when all writes that were pending at the time this
	     * method was called received server acknowledgement. An acknowledgement can be either acceptance
	     * or rejection.
	     */
	    FirestoreClient.prototype.waitForPendingWrites = function () {
	        var _this = this;
	        this.verifyNotTerminated();
	        var deferred = new Deferred();
	        this.asyncQueue.enqueueAndForget(function () {
	            return _this.syncEngine.registerPendingWritesCallback(deferred);
	        });
	        return deferred.promise;
	    };
	    FirestoreClient.prototype.listen = function (query, observer, options) {
	        var _this = this;
	        this.verifyNotTerminated();
	        var listener = new QueryListener(query, observer, options);
	        this.asyncQueue.enqueueAndForget(function () {
	            return _this.eventMgr.listen(listener);
	        });
	        return listener;
	    };
	    FirestoreClient.prototype.unlisten = function (listener) {
	        var _this = this;
	        // Checks for termination but does not raise error, allowing unlisten after
	        // termination to be a no-op.
	        if (this.clientTerminated) {
	            return;
	        }
	        this.asyncQueue.enqueueAndForget(function () {
	            return _this.eventMgr.unlisten(listener);
	        });
	    };
	    FirestoreClient.prototype.getDocumentFromLocalCache = function (docKey) {
	        var _this = this;
	        this.verifyNotTerminated();
	        return this.asyncQueue
	            .enqueue(function () {
	            return _this.localStore.readDocument(docKey);
	        })
	            .then(function (maybeDoc) {
	            if (maybeDoc instanceof Document) {
	                return maybeDoc;
	            }
	            else if (maybeDoc instanceof NoDocument) {
	                return null;
	            }
	            else {
	                throw new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from cache. (However, this document may ' +
	                    "exist on the server. Run again without setting 'source' in " +
	                    'the GetOptions to attempt to retrieve the document from the ' +
	                    'server.)');
	            }
	        });
	    };
	    FirestoreClient.prototype.getDocumentsFromLocalCache = function (query) {
	        var _this = this;
	        this.verifyNotTerminated();
	        return this.asyncQueue.enqueue(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	            var queryResult, view, viewDocChanges;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.localStore.executeQuery(query, 
	                        /* usePreviousResults= */ true)];
	                    case 1:
	                        queryResult = _a.sent();
	                        view = new View(query, queryResult.remoteKeys);
	                        viewDocChanges = view.computeDocChanges(queryResult.documents);
	                        return [2 /*return*/, view.applyChanges(viewDocChanges, 
	                            /* updateLimboDocuments= */ false).snapshot];
	                }
	            });
	        }); });
	    };
	    FirestoreClient.prototype.write = function (mutations) {
	        var _this = this;
	        this.verifyNotTerminated();
	        var deferred = new Deferred();
	        this.asyncQueue.enqueueAndForget(function () {
	            return _this.syncEngine.write(mutations, deferred);
	        });
	        return deferred.promise;
	    };
	    FirestoreClient.prototype.databaseId = function () {
	        return this.databaseInfo.databaseId;
	    };
	    FirestoreClient.prototype.addSnapshotsInSyncListener = function (observer) {
	        var _this = this;
	        this.verifyNotTerminated();
	        this.asyncQueue.enqueueAndForget(function () {
	            _this.eventMgr.addSnapshotsInSyncListener(observer);
	            return Promise.resolve();
	        });
	    };
	    FirestoreClient.prototype.removeSnapshotsInSyncListener = function (observer) {
	        // Checks for shutdown but does not raise error, allowing remove after
	        // shutdown to be a no-op.
	        if (this.clientTerminated) {
	            return;
	        }
	        this.eventMgr.removeSnapshotsInSyncListener(observer);
	    };
	    Object.defineProperty(FirestoreClient.prototype, "clientTerminated", {
	        get: function () {
	            // Technically, the asyncQueue is still running, but only accepting operations
	            // related to termination or supposed to be run after termination. It is effectively
	            // terminated to the eyes of users.
	            return this.asyncQueue.isShuttingDown;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FirestoreClient.prototype.transaction = function (updateFunction) {
	        var _this = this;
	        this.verifyNotTerminated();
	        var deferred = new Deferred();
	        this.asyncQueue.enqueueAndForget(function () {
	            _this.syncEngine.runTransaction(_this.asyncQueue, updateFunction, deferred);
	            return Promise.resolve();
	        });
	        return deferred.promise;
	    };
	    return FirestoreClient;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/*
	 * A wrapper implementation of Observer<T> that will dispatch events
	 * asynchronously. To allow immediate silencing, a mute call is added which
	 * causes events scheduled to no longer be raised.
	 */
	var AsyncObserver = /** @class */ (function () {
	    function AsyncObserver(observer) {
	        this.observer = observer;
	        /**
	         * When set to true, will not raise future events. Necessary to deal with
	         * async detachment of listener.
	         */
	        this.muted = false;
	    }
	    AsyncObserver.prototype.next = function (value) {
	        this.scheduleEvent(this.observer.next, value);
	    };
	    AsyncObserver.prototype.error = function (error) {
	        this.scheduleEvent(this.observer.error, error);
	    };
	    AsyncObserver.prototype.mute = function () {
	        this.muted = true;
	    };
	    AsyncObserver.prototype.scheduleEvent = function (eventHandler, event) {
	        var _this = this;
	        if (!this.muted) {
	            setTimeout(function () {
	                if (!_this.muted) {
	                    eventHandler(event);
	                }
	            }, 0);
	        }
	    };
	    return AsyncObserver;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// The objects that are a part of this API are exposed to third-parties as
	// compiled javascript so we want to flag our private members with a leading
	// underscore to discourage their use.
	/**
	 * A FieldPath refers to a field in a document. The path may consist of a single
	 * field name (referring to a top-level field in the document), or a list of
	 * field names (referring to a nested field in the document).
	 */
	var FieldPath$1 = /** @class */ (function () {
	    /**
	     * Creates a FieldPath from the provided field names. If more than one field
	     * name is provided, the path will point to a nested field in a document.
	     *
	     * @param fieldNames A list of field names.
	     */
	    function FieldPath$1() {
	        var fieldNames = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            fieldNames[_i] = arguments[_i];
	        }
	        validateNamedArrayAtLeastNumberOfElements('FieldPath', fieldNames, 'fieldNames', 1);
	        for (var i = 0; i < fieldNames.length; ++i) {
	            validateArgType('FieldPath', 'string', i, fieldNames[i]);
	            if (fieldNames[i].length === 0) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). " +
	                    'Field names must not be empty.');
	            }
	        }
	        this._internalPath = new FieldPath(fieldNames);
	    }
	    FieldPath$1.documentId = function () {
	        return FieldPath$1._DOCUMENT_ID;
	    };
	    FieldPath$1.prototype.isEqual = function (other) {
	        if (!(other instanceof FieldPath$1)) {
	            throw invalidClassError('isEqual', 'FieldPath', 1, other);
	        }
	        return this._internalPath.isEqual(other._internalPath);
	    };
	    /**
	     * Internal Note: The backend doesn't technically support querying by
	     * document ID. Instead it queries by the entire document name (full path
	     * included), but in the cases we currently support documentId(), the net
	     * effect is the same.
	     */
	    FieldPath$1._DOCUMENT_ID = new FieldPath$1(FieldPath.keyField().canonicalString());
	    return FieldPath$1;
	}());
	/**
	 * Matches any characters in a field path string that are reserved.
	 */
	var RESERVED = new RegExp('[~\\*/\\[\\]]');
	/**
	 * Parses a field path string into a FieldPath, treating dots as separators.
	 */
	function fromDotSeparatedString(path) {
	    var found = path.search(RESERVED);
	    if (found >= 0) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not contain " +
	            "'~', '*', '/', '[', or ']'");
	    }
	    try {
	        return new (FieldPath$1.bind.apply(FieldPath$1, tslib.__spreadArrays([void 0], path.split('.'))))();
	    }
	    catch (e) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, " +
	            "begin with '.', end with '.', or contain '..'");
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var OAuthToken = /** @class */ (function () {
	    function OAuthToken(value, user) {
	        this.user = user;
	        this.type = 'OAuth';
	        this.authHeaders = {};
	        // Set the headers using Object Literal notation to avoid minification
	        this.authHeaders['Authorization'] = "Bearer " + value;
	    }
	    return OAuthToken;
	}());
	/** A CredentialsProvider that always yields an empty token. */
	var EmptyCredentialsProvider = /** @class */ (function () {
	    function EmptyCredentialsProvider() {
	        /**
	         * Stores the listener registered with setChangeListener()
	         * This isn't actually necessary since the UID never changes, but we use this
	         * to verify the listen contract is adhered to in tests.
	         */
	        this.changeListener = null;
	    }
	    EmptyCredentialsProvider.prototype.getToken = function () {
	        return Promise.resolve(null);
	    };
	    EmptyCredentialsProvider.prototype.invalidateToken = function () { };
	    EmptyCredentialsProvider.prototype.setChangeListener = function (changeListener) {
	        assert(!this.changeListener, 'Can only call setChangeListener() once.');
	        this.changeListener = changeListener;
	        // Fire with initial user.
	        changeListener(User.UNAUTHENTICATED);
	    };
	    EmptyCredentialsProvider.prototype.removeChangeListener = function () {
	        assert(this.changeListener !== null, 'removeChangeListener() when no listener registered');
	        this.changeListener = null;
	    };
	    return EmptyCredentialsProvider;
	}());
	var FirebaseCredentialsProvider = /** @class */ (function () {
	    function FirebaseCredentialsProvider(authProvider) {
	        var _this = this;
	        /**
	         * The auth token listener registered with FirebaseApp, retained here so we
	         * can unregister it.
	         */
	        this.tokenListener = null;
	        /** Tracks the current User. */
	        this.currentUser = User.UNAUTHENTICATED;
	        this.receivedInitialUser = false;
	        /**
	         * Counter used to detect if the token changed while a getToken request was
	         * outstanding.
	         */
	        this.tokenCounter = 0;
	        /** The listener registered with setChangeListener(). */
	        this.changeListener = null;
	        this.forceRefresh = false;
	        this.tokenListener = function () {
	            _this.tokenCounter++;
	            _this.currentUser = _this.getUser();
	            _this.receivedInitialUser = true;
	            if (_this.changeListener) {
	                _this.changeListener(_this.currentUser);
	            }
	        };
	        this.tokenCounter = 0;
	        this.auth = authProvider.getImmediate({ optional: true });
	        if (this.auth) {
	            this.auth.addAuthTokenListener(this.tokenListener);
	        }
	        else {
	            // if auth is not available, invoke tokenListener once with null token
	            this.tokenListener(null);
	            authProvider.get().then(function (auth) {
	                _this.auth = auth;
	                if (_this.tokenListener) {
	                    // tokenListener can be removed by removeChangeListener()
	                    _this.auth.addAuthTokenListener(_this.tokenListener);
	                }
	            }, function () {
	                /* this.authProvider.get() never rejects */
	            });
	        }
	    }
	    FirebaseCredentialsProvider.prototype.getToken = function () {
	        var _this = this;
	        assert(this.tokenListener != null, 'getToken cannot be called after listener removed.');
	        // Take note of the current value of the tokenCounter so that this method
	        // can fail (with an ABORTED error) if there is a token change while the
	        // request is outstanding.
	        var initialTokenCounter = this.tokenCounter;
	        var forceRefresh = this.forceRefresh;
	        this.forceRefresh = false;
	        if (!this.auth) {
	            return Promise.resolve(null);
	        }
	        return this.auth.getToken(forceRefresh).then(function (tokenData) {
	            // Cancel the request since the token changed while the request was
	            // outstanding so the response is potentially for a previous user (which
	            // user, we can't be sure).
	            if (_this.tokenCounter !== initialTokenCounter) {
	                throw new FirestoreError(Code.ABORTED, 'getToken aborted due to token change.');
	            }
	            else {
	                if (tokenData) {
	                    assert(typeof tokenData.accessToken === 'string', 'Invalid tokenData returned from getToken():' + tokenData);
	                    return new OAuthToken(tokenData.accessToken, _this.currentUser);
	                }
	                else {
	                    return null;
	                }
	            }
	        });
	    };
	    FirebaseCredentialsProvider.prototype.invalidateToken = function () {
	        this.forceRefresh = true;
	    };
	    FirebaseCredentialsProvider.prototype.setChangeListener = function (changeListener) {
	        assert(!this.changeListener, 'Can only call setChangeListener() once.');
	        this.changeListener = changeListener;
	        // Fire the initial event
	        if (this.receivedInitialUser) {
	            changeListener(this.currentUser);
	        }
	    };
	    FirebaseCredentialsProvider.prototype.removeChangeListener = function () {
	        assert(this.tokenListener != null, 'removeChangeListener() called twice');
	        assert(this.changeListener !== null, 'removeChangeListener() called when no listener registered');
	        if (this.auth) {
	            this.auth.removeAuthTokenListener(this.tokenListener);
	        }
	        this.tokenListener = null;
	        this.changeListener = null;
	    };
	    // Auth.getUid() can return null even with a user logged in. It is because
	    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
	    // This method should only be called in the AuthTokenListener callback
	    // to guarantee to get the actual user.
	    FirebaseCredentialsProvider.prototype.getUser = function () {
	        var currentUid = this.auth && this.auth.getUid();
	        assert(currentUid === null || typeof currentUid === 'string', 'Received invalid UID: ' + currentUid);
	        return new User(currentUid);
	    };
	    return FirebaseCredentialsProvider;
	}());
	/*
	 * FirstPartyToken provides a fresh token each time its value
	 * is requested, because if the token is too old, requests will be rejected.
	 * Technically this may no longer be necessary since the SDK should gracefully
	 * recover from unauthenticated errors (see b/33147818 for context), but it's
	 * safer to keep the implementation as-is.
	 */
	var FirstPartyToken = /** @class */ (function () {
	    function FirstPartyToken(gapi, sessionIndex) {
	        this.gapi = gapi;
	        this.sessionIndex = sessionIndex;
	        this.type = 'FirstParty';
	        this.user = User.FIRST_PARTY;
	    }
	    Object.defineProperty(FirstPartyToken.prototype, "authHeaders", {
	        get: function () {
	            var headers = {
	                'X-Goog-AuthUser': this.sessionIndex
	            };
	            var authHeader = this.gapi.auth.getAuthHeaderValueForFirstParty([]);
	            if (authHeader) {
	                headers['Authorization'] = authHeader;
	            }
	            return headers;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return FirstPartyToken;
	}());
	/*
	 * Provides user credentials required for the Firestore JavaScript SDK
	 * to authenticate the user, using technique that is only available
	 * to applications hosted by Google.
	 */
	var FirstPartyCredentialsProvider = /** @class */ (function () {
	    function FirstPartyCredentialsProvider(gapi, sessionIndex) {
	        this.gapi = gapi;
	        this.sessionIndex = sessionIndex;
	    }
	    FirstPartyCredentialsProvider.prototype.getToken = function () {
	        return Promise.resolve(new FirstPartyToken(this.gapi, this.sessionIndex));
	    };
	    FirstPartyCredentialsProvider.prototype.setChangeListener = function (changeListener) {
	        // Fire with initial uid.
	        changeListener(User.FIRST_PARTY);
	    };
	    FirstPartyCredentialsProvider.prototype.removeChangeListener = function () { };
	    FirstPartyCredentialsProvider.prototype.invalidateToken = function () { };
	    return FirstPartyCredentialsProvider;
	}());
	/**
	 * Builds a CredentialsProvider depending on the type of
	 * the credentials passed in.
	 */
	function makeCredentialsProvider(credentials) {
	    if (!credentials) {
	        return new EmptyCredentialsProvider();
	    }
	    switch (credentials.type) {
	        case 'gapi':
	            var client = credentials.client;
	            // Make sure this really is a Gapi client.
	            assert(!!(typeof client === 'object' &&
	                client !== null &&
	                client['auth'] &&
	                client['auth']['getAuthHeaderValueForFirstParty']), 'unexpected gapi interface');
	            return new FirstPartyCredentialsProvider(client, credentials.sessionIndex || '0');
	        case 'provider':
	            return credentials.client;
	        default:
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'makeCredentialsProvider failed due to invalid credential type');
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function isPartialObserver(obj) {
	    return implementsAnyMethods(obj, ['next', 'error', 'complete']);
	}
	/**
	 * Returns true if obj is an object and contains at least one of the specified
	 * methods.
	 */
	function implementsAnyMethods(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    var object = obj;
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in object && typeof object[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An opaque base class for FieldValue sentinel objects in our public API,
	 * with public static methods for creating said sentinel objects.
	 */
	var FieldValueImpl = /** @class */ (function () {
	    function FieldValueImpl(_methodName) {
	        this._methodName = _methodName;
	    }
	    FieldValueImpl.delete = function () {
	        validateNoArgs('FieldValue.delete', arguments);
	        return DeleteFieldValueImpl.instance;
	    };
	    FieldValueImpl.serverTimestamp = function () {
	        validateNoArgs('FieldValue.serverTimestamp', arguments);
	        return ServerTimestampFieldValueImpl.instance;
	    };
	    FieldValueImpl.arrayUnion = function () {
	        var elements = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            elements[_i] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('FieldValue.arrayUnion', arguments, 1);
	        // NOTE: We don't actually parse the data until it's used in set() or
	        // update() since we need access to the Firestore instance.
	        return new ArrayUnionFieldValueImpl(elements);
	    };
	    FieldValueImpl.arrayRemove = function () {
	        var elements = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            elements[_i] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('FieldValue.arrayRemove', arguments, 1);
	        // NOTE: We don't actually parse the data until it's used in set() or
	        // update() since we need access to the Firestore instance.
	        return new ArrayRemoveFieldValueImpl(elements);
	    };
	    FieldValueImpl.increment = function (n) {
	        validateArgType('FieldValue.increment', 'number', 1, n);
	        validateExactNumberOfArgs('FieldValue.increment', arguments, 1);
	        return new NumericIncrementFieldValueImpl(n);
	    };
	    FieldValueImpl.prototype.isEqual = function (other) {
	        return this === other;
	    };
	    return FieldValueImpl;
	}());
	var DeleteFieldValueImpl = /** @class */ (function (_super) {
	    tslib.__extends(DeleteFieldValueImpl, _super);
	    function DeleteFieldValueImpl() {
	        return _super.call(this, 'FieldValue.delete') || this;
	    }
	    /** Singleton instance. */
	    DeleteFieldValueImpl.instance = new DeleteFieldValueImpl();
	    return DeleteFieldValueImpl;
	}(FieldValueImpl));
	var ServerTimestampFieldValueImpl = /** @class */ (function (_super) {
	    tslib.__extends(ServerTimestampFieldValueImpl, _super);
	    function ServerTimestampFieldValueImpl() {
	        return _super.call(this, 'FieldValue.serverTimestamp') || this;
	    }
	    /** Singleton instance. */
	    ServerTimestampFieldValueImpl.instance = new ServerTimestampFieldValueImpl();
	    return ServerTimestampFieldValueImpl;
	}(FieldValueImpl));
	var ArrayUnionFieldValueImpl = /** @class */ (function (_super) {
	    tslib.__extends(ArrayUnionFieldValueImpl, _super);
	    function ArrayUnionFieldValueImpl(_elements) {
	        var _this = _super.call(this, 'FieldValue.arrayUnion') || this;
	        _this._elements = _elements;
	        return _this;
	    }
	    return ArrayUnionFieldValueImpl;
	}(FieldValueImpl));
	var ArrayRemoveFieldValueImpl = /** @class */ (function (_super) {
	    tslib.__extends(ArrayRemoveFieldValueImpl, _super);
	    function ArrayRemoveFieldValueImpl(_elements) {
	        var _this = _super.call(this, 'FieldValue.arrayRemove') || this;
	        _this._elements = _elements;
	        return _this;
	    }
	    return ArrayRemoveFieldValueImpl;
	}(FieldValueImpl));
	var NumericIncrementFieldValueImpl = /** @class */ (function (_super) {
	    tslib.__extends(NumericIncrementFieldValueImpl, _super);
	    function NumericIncrementFieldValueImpl(_operand) {
	        var _this = _super.call(this, 'FieldValue.increment') || this;
	        _this._operand = _operand;
	        return _this;
	    }
	    return NumericIncrementFieldValueImpl;
	}(FieldValueImpl));
	// Public instance that disallows construction at runtime. This constructor is
	// used when exporting FieldValueImpl on firebase.firestore.FieldValue and will
	// be called FieldValue publicly. Internally we still use FieldValueImpl which
	// has a type-checked private constructor. Note that FieldValueImpl and
	// PublicFieldValue can be used interchangeably in instanceof checks.
	// For our internal TypeScript code PublicFieldValue doesn't exist as a type,
	// and so we need to use FieldValueImpl as type and export it too.
	var PublicFieldValue = makeConstructorPrivate(FieldValueImpl, 'Use FieldValue.<field>() instead.');
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var RESERVED_FIELD_REGEX = /^__.*__$/;
	/** The result of parsing document data (e.g. for a setData call). */
	var ParsedSetData = /** @class */ (function () {
	    function ParsedSetData(data, fieldMask, fieldTransforms) {
	        this.data = data;
	        this.fieldMask = fieldMask;
	        this.fieldTransforms = fieldTransforms;
	    }
	    ParsedSetData.prototype.toMutations = function (key, precondition) {
	        var mutations = [];
	        if (this.fieldMask !== null) {
	            mutations.push(new PatchMutation(key, this.data, this.fieldMask, precondition));
	        }
	        else {
	            mutations.push(new SetMutation(key, this.data, precondition));
	        }
	        if (this.fieldTransforms.length > 0) {
	            mutations.push(new TransformMutation(key, this.fieldTransforms));
	        }
	        return mutations;
	    };
	    return ParsedSetData;
	}());
	/** The result of parsing "update" data (i.e. for an updateData call). */
	var ParsedUpdateData = /** @class */ (function () {
	    function ParsedUpdateData(data, fieldMask, fieldTransforms) {
	        this.data = data;
	        this.fieldMask = fieldMask;
	        this.fieldTransforms = fieldTransforms;
	    }
	    ParsedUpdateData.prototype.toMutations = function (key, precondition) {
	        var mutations = [
	            new PatchMutation(key, this.data, this.fieldMask, precondition)
	        ];
	        if (this.fieldTransforms.length > 0) {
	            mutations.push(new TransformMutation(key, this.fieldTransforms));
	        }
	        return mutations;
	    };
	    return ParsedUpdateData;
	}());
	/*
	 * Represents what type of API method provided the data being parsed; useful
	 * for determining which error conditions apply during parsing and providing
	 * better error messages.
	 */
	var UserDataSource;
	(function (UserDataSource) {
	    UserDataSource[UserDataSource["Set"] = 0] = "Set";
	    UserDataSource[UserDataSource["Update"] = 1] = "Update";
	    UserDataSource[UserDataSource["MergeSet"] = 2] = "MergeSet";
	    /**
	     * Indicates the source is a where clause, cursor bound, arrayUnion()
	     * element, etc. Of note, isWrite(source) will return false.
	     */
	    UserDataSource[UserDataSource["Argument"] = 3] = "Argument";
	    /**
	     * Indicates that the source is an Argument that may directly contain nested
	     * arrays (e.g. the operand of an `in` query).
	     */
	    UserDataSource[UserDataSource["ArrayArgument"] = 4] = "ArrayArgument";
	})(UserDataSource || (UserDataSource = {}));
	function isWrite(dataSource) {
	    switch (dataSource) {
	        case UserDataSource.Set: // fall through
	        case UserDataSource.MergeSet: // fall through
	        case UserDataSource.Update:
	            return true;
	        case UserDataSource.Argument:
	        case UserDataSource.ArrayArgument:
	            return false;
	        default:
	            throw fail("Unexpected case for UserDataSource: " + dataSource);
	    }
	}
	/** A "context" object passed around while parsing user data. */
	var ParseContext = /** @class */ (function () {
	    /**
	     * Initializes a ParseContext with the given source and path.
	     *
	     * @param dataSource Indicates what kind of API method this data came from.
	     * @param methodName The name of the method the user called to create this
	     *     ParseContext.
	     * @param path A path within the object being parsed. This could be an empty
	     *     path (in which case the context represents the root of the data being
	     *     parsed), or a nonempty path (indicating the context represents a nested
	     *     location within the data).
	     * @param arrayElement Whether or not this context corresponds to an element
	     *     of an array.
	     * @param fieldTransforms A mutable list of field transforms encountered while
	     *     parsing the data.
	     * @param fieldMask A mutable list of field paths encountered while parsing
	     *     the data.
	     *
	     * TODO(b/34871131): We don't support array paths right now, so path can be
	     * null to indicate the context represents any location within an array (in
	     * which case certain features will not work and errors will be somewhat
	     * compromised).
	     */
	    function ParseContext(dataSource, methodName, path, arrayElement, fieldTransforms, fieldMask) {
	        this.dataSource = dataSource;
	        this.methodName = methodName;
	        this.path = path;
	        this.arrayElement = arrayElement;
	        // Minor hack: If fieldTransforms is undefined, we assume this is an
	        // external call and we need to validate the entire path.
	        if (fieldTransforms === undefined) {
	            this.validatePath();
	        }
	        this.arrayElement = arrayElement !== undefined ? arrayElement : false;
	        this.fieldTransforms = fieldTransforms || [];
	        this.fieldMask = fieldMask || [];
	    }
	    ParseContext.prototype.childContextForField = function (field) {
	        var childPath = this.path == null ? null : this.path.child(field);
	        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
	        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
	        context.validatePathSegment(field);
	        return context;
	    };
	    ParseContext.prototype.childContextForFieldPath = function (field) {
	        var childPath = this.path == null ? null : this.path.child(field);
	        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
	        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
	        context.validatePath();
	        return context;
	    };
	    ParseContext.prototype.childContextForArray = function (index) {
	        // TODO(b/34871131): We don't support array paths right now; so make path
	        // null.
	        return new ParseContext(this.dataSource, this.methodName, 
	        /*path=*/ null, 
	        /*arrayElement=*/ true, this.fieldTransforms, this.fieldMask);
	    };
	    ParseContext.prototype.createError = function (reason) {
	        var fieldDescription = this.path === null || this.path.isEmpty()
	            ? ''
	            : " (found in field " + this.path.toString() + ")";
	        return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + this.methodName + "() called with invalid data. " +
	            reason +
	            fieldDescription);
	    };
	    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */
	    ParseContext.prototype.contains = function (fieldPath) {
	        return (this.fieldMask.find(function (field) { return fieldPath.isPrefixOf(field); }) !== undefined ||
	            this.fieldTransforms.find(function (transform) {
	                return fieldPath.isPrefixOf(transform.field);
	            }) !== undefined);
	    };
	    ParseContext.prototype.validatePath = function () {
	        // TODO(b/34871131): Remove null check once we have proper paths for fields
	        // within arrays.
	        if (this.path === null) {
	            return;
	        }
	        for (var i = 0; i < this.path.length; i++) {
	            this.validatePathSegment(this.path.get(i));
	        }
	    };
	    ParseContext.prototype.validatePathSegment = function (segment) {
	        if (segment.length === 0) {
	            throw this.createError('Document fields must not be empty');
	        }
	        if (isWrite(this.dataSource) && RESERVED_FIELD_REGEX.test(segment)) {
	            throw this.createError('Document fields cannot begin and end with "__"');
	        }
	    };
	    return ParseContext;
	}());
	/**
	 * A placeholder object for DocumentReferences in this file, in order to
	 * avoid a circular dependency. See the comments for `DataPreConverter` for
	 * the full context.
	 */
	var DocumentKeyReference = /** @class */ (function () {
	    function DocumentKeyReference(databaseId, key) {
	        this.databaseId = databaseId;
	        this.key = key;
	    }
	    return DocumentKeyReference;
	}());
	/**
	 * Helper for parsing raw user input (provided via the API) into internal model
	 * classes.
	 */
	var UserDataConverter = /** @class */ (function () {
	    function UserDataConverter(preConverter) {
	        this.preConverter = preConverter;
	    }
	    /** Parse document data from a non-merge set() call. */
	    UserDataConverter.prototype.parseSetData = function (methodName, input) {
	        var context = new ParseContext(UserDataSource.Set, methodName, FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var updateData = this.parseData(input, context);
	        return new ParsedSetData(updateData, 
	        /* fieldMask= */ null, context.fieldTransforms);
	    };
	    /** Parse document data from a set() call with '{merge:true}'. */
	    UserDataConverter.prototype.parseMergeData = function (methodName, input, fieldPaths) {
	        var context = new ParseContext(UserDataSource.MergeSet, methodName, FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var updateData = this.parseData(input, context);
	        var fieldMask;
	        var fieldTransforms;
	        if (!fieldPaths) {
	            fieldMask = FieldMask.fromArray(context.fieldMask);
	            fieldTransforms = context.fieldTransforms;
	        }
	        else {
	            var validatedFieldPaths = new SortedSet(FieldPath.comparator);
	            for (var _i = 0, fieldPaths_1 = fieldPaths; _i < fieldPaths_1.length; _i++) {
	                var stringOrFieldPath = fieldPaths_1[_i];
	                var fieldPath = void 0;
	                if (stringOrFieldPath instanceof FieldPath$1) {
	                    fieldPath = stringOrFieldPath._internalPath;
	                }
	                else if (typeof stringOrFieldPath === 'string') {
	                    fieldPath = fieldPathFromDotSeparatedString(methodName, stringOrFieldPath);
	                }
	                else {
	                    throw fail('Expected stringOrFieldPath to be a string or a FieldPath');
	                }
	                if (!context.contains(fieldPath)) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Field '" + fieldPath + "' is specified in your field mask but missing from your input data.");
	                }
	                validatedFieldPaths = validatedFieldPaths.add(fieldPath);
	            }
	            fieldMask = FieldMask.fromSet(validatedFieldPaths);
	            fieldTransforms = context.fieldTransforms.filter(function (transform) {
	                return fieldMask.covers(transform.field);
	            });
	        }
	        return new ParsedSetData(updateData, fieldMask, fieldTransforms);
	    };
	    /** Parse update data from an update() call. */
	    UserDataConverter.prototype.parseUpdateData = function (methodName, input) {
	        var _this = this;
	        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var fieldMaskPaths = new SortedSet(FieldPath.comparator);
	        var updateData = ObjectValue.EMPTY;
	        forEach(input, function (key, value) {
	            var path = fieldPathFromDotSeparatedString(methodName, key);
	            var childContext = context.childContextForFieldPath(path);
	            value = _this.runPreConverter(value, childContext);
	            if (value instanceof DeleteFieldValueImpl) {
	                // Add it to the field mask, but don't add anything to updateData.
	                fieldMaskPaths = fieldMaskPaths.add(path);
	            }
	            else {
	                var parsedValue = _this.parseData(value, childContext);
	                if (parsedValue != null) {
	                    fieldMaskPaths = fieldMaskPaths.add(path);
	                    updateData = updateData.set(path, parsedValue);
	                }
	            }
	        });
	        var mask = FieldMask.fromSet(fieldMaskPaths);
	        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
	    };
	    /** Parse update data from a list of field/value arguments. */
	    UserDataConverter.prototype.parseUpdateVarargs = function (methodName, field, value, moreFieldsAndValues) {
	        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
	        var keys = [fieldPathFromArgument(methodName, field)];
	        var values = [value];
	        if (moreFieldsAndValues.length % 2 !== 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() needs to be called with an even number " +
	                'of arguments that alternate between field names and values.');
	        }
	        for (var i = 0; i < moreFieldsAndValues.length; i += 2) {
	            keys.push(fieldPathFromArgument(methodName, moreFieldsAndValues[i]));
	            values.push(moreFieldsAndValues[i + 1]);
	        }
	        var fieldMaskPaths = new SortedSet(FieldPath.comparator);
	        var updateData = ObjectValue.EMPTY;
	        for (var i = 0; i < keys.length; ++i) {
	            var path = keys[i];
	            var childContext = context.childContextForFieldPath(path);
	            var value_1 = this.runPreConverter(values[i], childContext);
	            if (value_1 instanceof DeleteFieldValueImpl) {
	                // Add it to the field mask, but don't add anything to updateData.
	                fieldMaskPaths = fieldMaskPaths.add(path);
	            }
	            else {
	                var parsedValue = this.parseData(value_1, childContext);
	                if (parsedValue != null) {
	                    fieldMaskPaths = fieldMaskPaths.add(path);
	                    updateData = updateData.set(path, parsedValue);
	                }
	            }
	        }
	        var mask = FieldMask.fromSet(fieldMaskPaths);
	        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
	    };
	    /**
	     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
	     * bound).
	     *
	     * @param allowArrays Whether the query value is an array that may directly
	     * contain additional arrays (e.g. the operand of an `in` query).
	     */
	    UserDataConverter.prototype.parseQueryValue = function (methodName, input, allowArrays) {
	        if (allowArrays === void 0) { allowArrays = false; }
	        var context = new ParseContext(allowArrays ? UserDataSource.ArrayArgument : UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
	        var parsed = this.parseData(input, context);
	        assert(parsed != null, 'Parsed data should not be null.');
	        assert(context.fieldTransforms.length === 0, 'Field transforms should have been disallowed.');
	        return parsed;
	    };
	    /** Sends data through this.preConverter, handling any thrown errors. */
	    UserDataConverter.prototype.runPreConverter = function (input, context) {
	        try {
	            return this.preConverter(input);
	        }
	        catch (e) {
	            var message = errorMessage(e);
	            throw context.createError(message);
	        }
	    };
	    /**
	     * Internal helper for parsing user data.
	     *
	     * @param input Data to be parsed.
	     * @param context A context object representing the current path being parsed,
	     * the source of the data being parsed, etc.
	     * @return The parsed value, or null if the value was a FieldValue sentinel
	     * that should not be included in the resulting parsed data.
	     */
	    UserDataConverter.prototype.parseData = function (input, context) {
	        input = this.runPreConverter(input, context);
	        if (looksLikeJsonObject(input)) {
	            validatePlainObject('Unsupported field value:', context, input);
	            return this.parseObject(input, context);
	        }
	        else if (input instanceof FieldValueImpl) {
	            // FieldValues usually parse into transforms (except FieldValue.delete())
	            // in which case we do not want to include this field in our parsed data
	            // (as doing so will overwrite the field directly prior to the transform
	            // trying to transform it). So we don't add this location to
	            // context.fieldMask and we return null as our parsing result.
	            this.parseSentinelFieldValue(input, context);
	            return null;
	        }
	        else {
	            // If context.path is null we are inside an array and we don't support
	            // field mask paths more granular than the top-level array.
	            if (context.path) {
	                context.fieldMask.push(context.path);
	            }
	            if (input instanceof Array) {
	                // TODO(b/34871131): Include the path containing the array in the error
	                // message.
	                // In the case of IN queries, the parsed data is an array (representing
	                // the set of values to be included for the IN query) that may directly
	                // contain additional arrays (each representing an individual field
	                // value), so we disable this validation.
	                if (context.arrayElement &&
	                    context.dataSource !== UserDataSource.ArrayArgument) {
	                    throw context.createError('Nested arrays are not supported');
	                }
	                return this.parseArray(input, context);
	            }
	            else {
	                return this.parseScalarValue(input, context);
	            }
	        }
	    };
	    UserDataConverter.prototype.parseObject = function (obj, context) {
	        var _this = this;
	        var result = new SortedMap(primitiveComparator);
	        if (isEmpty(obj)) {
	            // If we encounter an empty object, we explicitly add it to the update
	            // mask to ensure that the server creates a map entry.
	            if (context.path && context.path.length > 0) {
	                context.fieldMask.push(context.path);
	            }
	        }
	        else {
	            forEach(obj, function (key, val) {
	                var parsedValue = _this.parseData(val, context.childContextForField(key));
	                if (parsedValue != null) {
	                    result = result.insert(key, parsedValue);
	                }
	            });
	        }
	        return new ObjectValue(result);
	    };
	    UserDataConverter.prototype.parseArray = function (array, context) {
	        var result = [];
	        var entryIndex = 0;
	        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
	            var entry = array_1[_i];
	            var parsedEntry = this.parseData(entry, context.childContextForArray(entryIndex));
	            if (parsedEntry == null) {
	                // Just include nulls in the array for fields being replaced with a
	                // sentinel.
	                parsedEntry = NullValue.INSTANCE;
	            }
	            result.push(parsedEntry);
	            entryIndex++;
	        }
	        return new ArrayValue(result);
	    };
	    /**
	     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
	     * context.fieldTransforms.
	     */
	    UserDataConverter.prototype.parseSentinelFieldValue = function (value, context) {
	        // Sentinels are only supported with writes, and not within arrays.
	        if (!isWrite(context.dataSource)) {
	            throw context.createError(value._methodName + "() can only be used with update() and set()");
	        }
	        if (context.path === null) {
	            throw context.createError(value._methodName + "() is not currently supported inside arrays");
	        }
	        if (value instanceof DeleteFieldValueImpl) {
	            if (context.dataSource === UserDataSource.MergeSet) {
	                // No transform to add for a delete, but we need to add it to our
	                // fieldMask so it gets deleted.
	                context.fieldMask.push(context.path);
	            }
	            else if (context.dataSource === UserDataSource.Update) {
	                assert(context.path.length > 0, 'FieldValue.delete() at the top level should have already' +
	                    ' been handled.');
	                throw context.createError('FieldValue.delete() can only appear at the top level ' +
	                    'of your update data');
	            }
	            else {
	                // We shouldn't encounter delete sentinels for queries or non-merge set() calls.
	                throw context.createError('FieldValue.delete() cannot be used with set() unless you pass ' +
	                    '{merge:true}');
	            }
	        }
	        else if (value instanceof ServerTimestampFieldValueImpl) {
	            context.fieldTransforms.push(new FieldTransform(context.path, ServerTimestampTransform.instance));
	        }
	        else if (value instanceof ArrayUnionFieldValueImpl) {
	            var parsedElements = this.parseArrayTransformElements(value._methodName, value._elements);
	            var arrayUnion = new ArrayUnionTransformOperation(parsedElements);
	            context.fieldTransforms.push(new FieldTransform(context.path, arrayUnion));
	        }
	        else if (value instanceof ArrayRemoveFieldValueImpl) {
	            var parsedElements = this.parseArrayTransformElements(value._methodName, value._elements);
	            var arrayRemove = new ArrayRemoveTransformOperation(parsedElements);
	            context.fieldTransforms.push(new FieldTransform(context.path, arrayRemove));
	        }
	        else if (value instanceof NumericIncrementFieldValueImpl) {
	            var operand = this.parseQueryValue('FieldValue.increment', value._operand);
	            var numericIncrement = new NumericIncrementTransformOperation(operand);
	            context.fieldTransforms.push(new FieldTransform(context.path, numericIncrement));
	        }
	        else {
	            fail('Unknown FieldValue type: ' + value);
	        }
	    };
	    /**
	     * Helper to parse a scalar value (i.e. not an Object, Array, or FieldValue)
	     *
	     * @return The parsed value
	     */
	    UserDataConverter.prototype.parseScalarValue = function (value, context) {
	        if (value === null) {
	            return NullValue.INSTANCE;
	        }
	        else if (typeof value === 'number') {
	            if (isSafeInteger(value)) {
	                return new IntegerValue(value);
	            }
	            else {
	                return new DoubleValue(value);
	            }
	        }
	        else if (typeof value === 'boolean') {
	            return BooleanValue.of(value);
	        }
	        else if (typeof value === 'string') {
	            return new StringValue(value);
	        }
	        else if (value instanceof Date) {
	            return new TimestampValue(Timestamp.fromDate(value));
	        }
	        else if (value instanceof Timestamp) {
	            // Firestore backend truncates precision down to microseconds. To ensure
	            // offline mode works the same with regards to truncation, perform the
	            // truncation immediately without waiting for the backend to do that.
	            return new TimestampValue(new Timestamp(value.seconds, Math.floor(value.nanoseconds / 1000) * 1000));
	        }
	        else if (value instanceof GeoPoint) {
	            return new GeoPointValue(value);
	        }
	        else if (value instanceof Blob) {
	            return new BlobValue(value);
	        }
	        else if (value instanceof DocumentKeyReference) {
	            return new RefValue(value.databaseId, value.key);
	        }
	        else {
	            throw context.createError("Unsupported field value: " + valueDescription(value));
	        }
	    };
	    UserDataConverter.prototype.parseArrayTransformElements = function (methodName, elements) {
	        var _this = this;
	        return elements.map(function (element, i) {
	            // Although array transforms are used with writes, the actual elements
	            // being unioned or removed are not considered writes since they cannot
	            // contain any FieldValue sentinels, etc.
	            var context = new ParseContext(UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
	            return _this.parseData(element, context.childContextForArray(i));
	        });
	    };
	    return UserDataConverter;
	}());
	/**
	 * Checks whether an object looks like a JSON object that should be converted
	 * into a struct. Normal class/prototype instances are considered to look like
	 * JSON objects since they should be converted to a struct value. Arrays, Dates,
	 * GeoPoints, etc. are not considered to look like JSON objects since they map
	 * to specific FieldValue types other than ObjectValue.
	 */
	function looksLikeJsonObject(input) {
	    return (typeof input === 'object' &&
	        input !== null &&
	        !(input instanceof Array) &&
	        !(input instanceof Date) &&
	        !(input instanceof Timestamp) &&
	        !(input instanceof GeoPoint) &&
	        !(input instanceof Blob) &&
	        !(input instanceof DocumentKeyReference) &&
	        !(input instanceof FieldValueImpl));
	}
	function validatePlainObject(message, context, input) {
	    if (!looksLikeJsonObject(input) || !isPlainObject(input)) {
	        var description = valueDescription(input);
	        if (description === 'an object') {
	            // Massage the error if it was an object.
	            throw context.createError(message + ' a custom object');
	        }
	        else {
	            throw context.createError(message + ' ' + description);
	        }
	    }
	}
	/**
	 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
	 */
	function fieldPathFromArgument(methodName, path) {
	    if (path instanceof FieldPath$1) {
	        return path._internalPath;
	    }
	    else if (typeof path === 'string') {
	        return fieldPathFromDotSeparatedString(methodName, path);
	    }
	    else {
	        var message = 'Field path arguments must be of type string or FieldPath.';
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
	    }
	}
	/**
	 * Wraps fromDotSeparatedString with an error message about the method that
	 * was thrown.
	 * @param methodName The publicly visible method name
	 * @param path The dot-separated string form of a field path which will be split
	 * on dots.
	 */
	function fieldPathFromDotSeparatedString(methodName, path) {
	    try {
	        return fromDotSeparatedString(path)._internalPath;
	    }
	    catch (e) {
	        var message = errorMessage(e);
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
	    }
	}
	/**
	 * Extracts the message from a caught exception, which should be an Error object
	 * though JS doesn't guarantee that.
	 */
	function errorMessage(error) {
	    return error instanceof Error ? error.message : error.toString();
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// settings() defaults:
	var DEFAULT_HOST = 'firestore.googleapis.com';
	var DEFAULT_SSL = true;
	var DEFAULT_TIMESTAMPS_IN_SNAPSHOTS = true;
	var DEFAULT_FORCE_LONG_POLLING = false;
	/**
	 * Constant used to indicate the LRU garbage collection should be disabled.
	 * Set this value as the `cacheSizeBytes` on the settings passed to the
	 * `Firestore` instance.
	 */
	var CACHE_SIZE_UNLIMITED = LruParams.COLLECTION_DISABLED;
	// enablePersistence() defaults:
	var DEFAULT_SYNCHRONIZE_TABS = false;
	/**
	 * A concrete type describing all the values that can be applied via a
	 * user-supplied firestore.Settings object. This is a separate type so that
	 * defaults can be supplied and the value can be checked for equality.
	 */
	var FirestoreSettings = /** @class */ (function () {
	    function FirestoreSettings(settings) {
	        if (settings.host === undefined) {
	            if (settings.ssl !== undefined) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
	            }
	            this.host = DEFAULT_HOST;
	            this.ssl = DEFAULT_SSL;
	        }
	        else {
	            validateNamedType('settings', 'non-empty string', 'host', settings.host);
	            this.host = settings.host;
	            validateNamedOptionalType('settings', 'boolean', 'ssl', settings.ssl);
	            this.ssl = defaulted(settings.ssl, DEFAULT_SSL);
	        }
	        validateOptionNames('settings', settings, [
	            'host',
	            'ssl',
	            'credentials',
	            'timestampsInSnapshots',
	            'cacheSizeBytes',
	            'experimentalForceLongPolling'
	        ]);
	        validateNamedOptionalType('settings', 'object', 'credentials', settings.credentials);
	        this.credentials = settings.credentials;
	        validateNamedOptionalType('settings', 'boolean', 'timestampsInSnapshots', settings.timestampsInSnapshots);
	        // Nobody should set timestampsInSnapshots anymore, but the error depends on
	        // whether they set it to true or false...
	        if (settings.timestampsInSnapshots === true) {
	            error("\n  The timestampsInSnapshots setting now defaults to true and you no\n  longer need to explicitly set it. In a future release, the setting\n  will be removed entirely and so it is recommended that you remove it\n  from your firestore.settings() call now.");
	        }
	        else if (settings.timestampsInSnapshots === false) {
	            error("\n  The timestampsInSnapshots setting will soon be removed. YOU MUST UPDATE\n  YOUR CODE.\n\n  To hide this warning, stop using the timestampsInSnapshots setting in your\n  firestore.settings({ ... }) call.\n\n  Once you remove the setting, Timestamps stored in Cloud Firestore will be\n  read back as Firebase Timestamp objects instead of as system Date objects.\n  So you will also need to update code expecting a Date to instead expect a\n  Timestamp. For example:\n\n  // Old:\n  const date = snapshot.get('created_at');\n  // New:\n  const timestamp = snapshot.get('created_at'); const date =\n  timestamp.toDate();\n\n  Please audit all existing usages of Date when you enable the new\n  behavior.");
	        }
	        this.timestampsInSnapshots = defaulted(settings.timestampsInSnapshots, DEFAULT_TIMESTAMPS_IN_SNAPSHOTS);
	        validateNamedOptionalType('settings', 'number', 'cacheSizeBytes', settings.cacheSizeBytes);
	        if (settings.cacheSizeBytes === undefined) {
	            this.cacheSizeBytes = LruParams.DEFAULT_CACHE_SIZE_BYTES;
	        }
	        else {
	            if (settings.cacheSizeBytes !== CACHE_SIZE_UNLIMITED &&
	                settings.cacheSizeBytes < LruParams.MINIMUM_CACHE_SIZE_BYTES) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "cacheSizeBytes must be at least " + LruParams.MINIMUM_CACHE_SIZE_BYTES);
	            }
	            else {
	                this.cacheSizeBytes = settings.cacheSizeBytes;
	            }
	        }
	        validateNamedOptionalType('settings', 'boolean', 'experimentalForceLongPolling', settings.experimentalForceLongPolling);
	        this.forceLongPolling =
	            settings.experimentalForceLongPolling === undefined
	                ? DEFAULT_FORCE_LONG_POLLING
	                : settings.experimentalForceLongPolling;
	    }
	    FirestoreSettings.prototype.isEqual = function (other) {
	        return (this.host === other.host &&
	            this.ssl === other.ssl &&
	            this.timestampsInSnapshots === other.timestampsInSnapshots &&
	            this.credentials === other.credentials &&
	            this.cacheSizeBytes === other.cacheSizeBytes &&
	            this.forceLongPolling === other.forceLongPolling);
	    };
	    return FirestoreSettings;
	}());
	/**
	 * The root reference to the database.
	 */
	var Firestore = /** @class */ (function () {
	    function Firestore(databaseIdOrApp, authProvider) {
	        var _this = this;
	        this._firebaseApp = null;
	        // Public for use in tests.
	        // TODO(mikelehen): Use modularized initialization instead.
	        this._queue = new AsyncQueue();
	        this.INTERNAL = {
	            delete: function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	                return tslib.__generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            // The client must be initalized to ensure that all subsequent API usage
	                            // throws an exception.
	                            this.ensureClientConfigured();
	                            return [4 /*yield*/, this._firestoreClient.terminate()];
	                        case 1:
	                            _a.sent();
	                            return [2 /*return*/];
	                    }
	                });
	            }); }
	        };
	        if (typeof databaseIdOrApp.options === 'object') {
	            // This is very likely a Firebase app object
	            // TODO(b/34177605): Can we somehow use instanceof?
	            var app = databaseIdOrApp;
	            this._firebaseApp = app;
	            this._databaseId = Firestore.databaseIdFromApp(app);
	            this._persistenceKey = app.name;
	            this._credentials = new FirebaseCredentialsProvider(authProvider);
	        }
	        else {
	            var external_1 = databaseIdOrApp;
	            if (!external_1.projectId) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide projectId');
	            }
	            this._databaseId = new DatabaseId(external_1.projectId, external_1.database);
	            // Use a default persistenceKey that lines up with FirebaseApp.
	            this._persistenceKey = '[DEFAULT]';
	            this._credentials = new EmptyCredentialsProvider();
	        }
	        this._settings = new FirestoreSettings({});
	        this._dataConverter = this.createDataConverter(this._databaseId);
	    }
	    Firestore.prototype.settings = function (settingsLiteral) {
	        validateExactNumberOfArgs('Firestore.settings', arguments, 1);
	        validateArgType('Firestore.settings', 'object', 1, settingsLiteral);
	        if (contains(settingsLiteral, 'persistence')) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, '"persistence" is now specified with a separate call to ' +
	                'firestore.enablePersistence().');
	        }
	        var newSettings = new FirestoreSettings(settingsLiteral);
	        if (this._firestoreClient && !this._settings.isEqual(newSettings)) {
	            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and its settings can no longer ' +
	                'be changed. You can only call settings() before calling any other ' +
	                'methods on a Firestore object.');
	        }
	        this._settings = newSettings;
	        if (newSettings.credentials !== undefined) {
	            this._credentials = makeCredentialsProvider(newSettings.credentials);
	        }
	    };
	    Firestore.prototype.enableNetwork = function () {
	        this.ensureClientConfigured();
	        return this._firestoreClient.enableNetwork();
	    };
	    Firestore.prototype.disableNetwork = function () {
	        this.ensureClientConfigured();
	        return this._firestoreClient.disableNetwork();
	    };
	    Firestore.prototype.enablePersistence = function (settings) {
	        if (this._firestoreClient) {
	            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and persistence can no longer ' +
	                'be enabled. You can only call enablePersistence() before calling ' +
	                'any other methods on a Firestore object.');
	        }
	        var synchronizeTabs = false;
	        if (settings) {
	            if (settings.experimentalTabSynchronization !== undefined) {
	                error("The 'experimentalTabSynchronization' setting has been renamed to " +
	                    "'synchronizeTabs'. In a future release, the setting will be removed " +
	                    'and it is recommended that you update your ' +
	                    "firestore.enablePersistence() call to use 'synchronizeTabs'.");
	            }
	            synchronizeTabs = defaulted(settings.synchronizeTabs !== undefined
	                ? settings.synchronizeTabs
	                : settings.experimentalTabSynchronization, DEFAULT_SYNCHRONIZE_TABS);
	        }
	        return this.configureClient(new IndexedDbPersistenceSettings(this._settings.cacheSizeBytes, synchronizeTabs));
	    };
	    Firestore.prototype.clearPersistence = function () {
	        var _this = this;
	        var persistenceKey = IndexedDbPersistence.buildStoragePrefix(this.makeDatabaseInfo());
	        var deferred = new Deferred();
	        this._queue.enqueueAndForgetEvenAfterShutdown(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	            var e_1;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        _a.trys.push([0, 2, , 3]);
	                        if (this._firestoreClient !== undefined &&
	                            !this._firestoreClient.clientTerminated) {
	                            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Persistence cannot be cleared after this Firestore instance is initialized.');
	                        }
	                        return [4 /*yield*/, IndexedDbPersistence.clearPersistence(persistenceKey)];
	                    case 1:
	                        _a.sent();
	                        deferred.resolve();
	                        return [3 /*break*/, 3];
	                    case 2:
	                        e_1 = _a.sent();
	                        deferred.reject(e_1);
	                        return [3 /*break*/, 3];
	                    case 3: return [2 /*return*/];
	                }
	            });
	        }); });
	        return deferred.promise;
	    };
	    Firestore.prototype.terminate = function () {
	        this.app._removeServiceInstance('firestore');
	        return this.INTERNAL.delete();
	    };
	    Object.defineProperty(Firestore.prototype, "_isTerminated", {
	        get: function () {
	            this.ensureClientConfigured();
	            return this._firestoreClient.clientTerminated;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Firestore.prototype.waitForPendingWrites = function () {
	        this.ensureClientConfigured();
	        return this._firestoreClient.waitForPendingWrites();
	    };
	    Firestore.prototype.onSnapshotsInSync = function (arg) {
	        this.ensureClientConfigured();
	        if (isPartialObserver(arg)) {
	            return this.onSnapshotsInSyncInternal(arg);
	        }
	        else {
	            validateArgType('Firestore.onSnapshotsInSync', 'function', 1, arg);
	            var observer = {
	                next: arg
	            };
	            return this.onSnapshotsInSyncInternal(observer);
	        }
	    };
	    Firestore.prototype.onSnapshotsInSyncInternal = function (observer) {
	        var _this = this;
	        var errHandler = function (err) {
	            throw fail('Uncaught Error in onSnapshotsInSync');
	        };
	        var asyncObserver = new AsyncObserver({
	            next: function () {
	                if (observer.next) {
	                    observer.next();
	                }
	            },
	            error: errHandler
	        });
	        this._firestoreClient.addSnapshotsInSyncListener(asyncObserver);
	        return function () {
	            asyncObserver.mute();
	            _this._firestoreClient.removeSnapshotsInSyncListener(asyncObserver);
	        };
	    };
	    Firestore.prototype.ensureClientConfigured = function () {
	        if (!this._firestoreClient) {
	            // Kick off starting the client but don't actually wait for it.
	            // eslint-disable-next-line @typescript-eslint/no-floating-promises
	            this.configureClient(new MemoryPersistenceSettings());
	        }
	        return this._firestoreClient;
	    };
	    Firestore.prototype.makeDatabaseInfo = function () {
	        return new DatabaseInfo(this._databaseId, this._persistenceKey, this._settings.host, this._settings.ssl, this._settings.forceLongPolling);
	    };
	    Firestore.prototype.configureClient = function (persistenceSettings) {
	        assert(!!this._settings.host, 'FirestoreSettings.host is not set');
	        assert(!this._firestoreClient, 'configureClient() called multiple times');
	        var databaseInfo = this.makeDatabaseInfo();
	        this._firestoreClient = new FirestoreClient(PlatformSupport.getPlatform(), databaseInfo, this._credentials, this._queue);
	        return this._firestoreClient.start(persistenceSettings);
	    };
	    Firestore.prototype.createDataConverter = function (databaseId) {
	        var preConverter = function (value) {
	            if (value instanceof DocumentReference) {
	                var thisDb = databaseId;
	                var otherDb = value.firestore._databaseId;
	                if (!otherDb.isEqual(thisDb)) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document reference is for database ' +
	                        (otherDb.projectId + "/" + otherDb.database + " but should be ") +
	                        ("for database " + thisDb.projectId + "/" + thisDb.database));
	                }
	                return new DocumentKeyReference(databaseId, value._key);
	            }
	            else {
	                return value;
	            }
	        };
	        return new UserDataConverter(preConverter);
	    };
	    Firestore.databaseIdFromApp = function (app) {
	        var options = app.options;
	        if (!contains(options, 'projectId')) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
	        }
	        var projectId = options['projectId'];
	        if (!projectId || typeof projectId !== 'string') {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'projectId must be a string in FirebaseApp.options');
	        }
	        return new DatabaseId(projectId);
	    };
	    Object.defineProperty(Firestore.prototype, "app", {
	        get: function () {
	            if (!this._firebaseApp) {
	                throw new FirestoreError(Code.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is " +
	                    'not available');
	            }
	            return this._firebaseApp;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Firestore.prototype.collection = function (pathString) {
	        validateExactNumberOfArgs('Firestore.collection', arguments, 1);
	        validateArgType('Firestore.collection', 'non-empty string', 1, pathString);
	        this.ensureClientConfigured();
	        return new CollectionReference(ResourcePath.fromString(pathString), this);
	    };
	    Firestore.prototype.doc = function (pathString) {
	        validateExactNumberOfArgs('Firestore.doc', arguments, 1);
	        validateArgType('Firestore.doc', 'non-empty string', 1, pathString);
	        this.ensureClientConfigured();
	        return DocumentReference.forPath(ResourcePath.fromString(pathString), this);
	    };
	    Firestore.prototype.collectionGroup = function (collectionId) {
	        validateExactNumberOfArgs('Firestore.collectionGroup', arguments, 1);
	        validateArgType('Firestore.collectionGroup', 'non-empty string', 1, collectionId);
	        if (collectionId.indexOf('/') >= 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid collection ID '" + collectionId + "' passed to function " +
	                "Firestore.collectionGroup(). Collection IDs must not contain '/'.");
	        }
	        this.ensureClientConfigured();
	        return new Query$1(new Query(ResourcePath.EMPTY_PATH, collectionId), this);
	    };
	    Firestore.prototype.runTransaction = function (updateFunction) {
	        var _this = this;
	        validateExactNumberOfArgs('Firestore.runTransaction', arguments, 1);
	        validateArgType('Firestore.runTransaction', 'function', 1, updateFunction);
	        return this.ensureClientConfigured().transaction(function (transaction) {
	            return updateFunction(new Transaction$1(_this, transaction));
	        });
	    };
	    Firestore.prototype.batch = function () {
	        this.ensureClientConfigured();
	        return new WriteBatch(this);
	    };
	    Object.defineProperty(Firestore, "logLevel", {
	        get: function () {
	            switch (getLogLevel()) {
	                case LogLevel.DEBUG:
	                    return 'debug';
	                case LogLevel.ERROR:
	                    return 'error';
	                case LogLevel.SILENT:
	                    return 'silent';
	                default:
	                    return fail('Unknown log level: ' + getLogLevel());
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Firestore.setLogLevel = function (level) {
	        validateExactNumberOfArgs('Firestore.setLogLevel', arguments, 1);
	        validateArgType('Firestore.setLogLevel', 'non-empty string', 1, level);
	        switch (level) {
	            case 'debug':
	                setLogLevel(LogLevel.DEBUG);
	                break;
	            case 'error':
	                setLogLevel(LogLevel.ERROR);
	                break;
	            case 'silent':
	                setLogLevel(LogLevel.SILENT);
	                break;
	            default:
	                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid log level: ' + level);
	        }
	    };
	    // Note: this is not a property because the minifier can't work correctly with
	    // the way TypeScript compiler outputs properties.
	    Firestore.prototype._areTimestampsInSnapshotsEnabled = function () {
	        return this._settings.timestampsInSnapshots;
	    };
	    return Firestore;
	}());
	/**
	 * A reference to a transaction.
	 */
	var Transaction$1 = /** @class */ (function () {
	    function Transaction(_firestore, _transaction) {
	        this._firestore = _firestore;
	        this._transaction = _transaction;
	    }
	    Transaction.prototype.get = function (documentRef) {
	        var _this = this;
	        validateExactNumberOfArgs('Transaction.get', arguments, 1);
	        var ref = validateReference('Transaction.get', documentRef, this._firestore);
	        return this._transaction
	            .lookup([ref._key])
	            .then(function (docs) {
	            if (!docs || docs.length !== 1) {
	                return fail('Mismatch in docs returned from document lookup.');
	            }
	            var doc = docs[0];
	            if (doc instanceof NoDocument) {
	                return new DocumentSnapshot(_this._firestore, ref._key, null, 
	                /* fromCache= */ false, 
	                /* hasPendingWrites= */ false, ref._converter);
	            }
	            else if (doc instanceof Document) {
	                return new DocumentSnapshot(_this._firestore, ref._key, doc, 
	                /* fromCache= */ false, 
	                /* hasPendingWrites= */ false, ref._converter);
	            }
	            else {
	                throw fail("BatchGetDocumentsRequest returned unexpected document type: " + doc.constructor.name);
	            }
	        });
	    };
	    Transaction.prototype.set = function (documentRef, value, options) {
	        validateBetweenNumberOfArgs('Transaction.set', arguments, 2, 3);
	        var ref = validateReference('Transaction.set', documentRef, this._firestore);
	        options = validateSetOptions('Transaction.set', options);
	        var _a = applyFirestoreDataConverter(ref._converter, value, 'Transaction.set'), convertedValue = _a[0], functionName = _a[1];
	        var parsed = options.merge || options.mergeFields
	            ? this._firestore._dataConverter.parseMergeData(functionName, convertedValue, options.mergeFields)
	            : this._firestore._dataConverter.parseSetData(functionName, convertedValue);
	        this._transaction.set(ref._key, parsed);
	        return this;
	    };
	    Transaction.prototype.update = function (documentRef, fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 3] = arguments[_i];
	        }
	        var ref;
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof FieldPath$1) {
	            validateAtLeastNumberOfArgs('Transaction.update', arguments, 3);
	            ref = validateReference('Transaction.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateVarargs('Transaction.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            validateExactNumberOfArgs('Transaction.update', arguments, 2);
	            ref = validateReference('Transaction.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateData('Transaction.update', fieldOrUpdateData);
	        }
	        this._transaction.update(ref._key, parsed);
	        return this;
	    };
	    Transaction.prototype.delete = function (documentRef) {
	        validateExactNumberOfArgs('Transaction.delete', arguments, 1);
	        var ref = validateReference('Transaction.delete', documentRef, this._firestore);
	        this._transaction.delete(ref._key);
	        return this;
	    };
	    return Transaction;
	}());
	var WriteBatch = /** @class */ (function () {
	    function WriteBatch(_firestore) {
	        this._firestore = _firestore;
	        this._mutations = [];
	        this._committed = false;
	    }
	    WriteBatch.prototype.set = function (documentRef, value, options) {
	        validateBetweenNumberOfArgs('WriteBatch.set', arguments, 2, 3);
	        this.verifyNotCommitted();
	        var ref = validateReference('WriteBatch.set', documentRef, this._firestore);
	        options = validateSetOptions('WriteBatch.set', options);
	        var _a = applyFirestoreDataConverter(ref._converter, value, 'WriteBatch.set'), convertedValue = _a[0], functionName = _a[1];
	        var parsed = options.merge || options.mergeFields
	            ? this._firestore._dataConverter.parseMergeData(functionName, convertedValue, options.mergeFields)
	            : this._firestore._dataConverter.parseSetData(functionName, convertedValue);
	        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.NONE));
	        return this;
	    };
	    WriteBatch.prototype.update = function (documentRef, fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 3] = arguments[_i];
	        }
	        this.verifyNotCommitted();
	        var ref;
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof FieldPath$1) {
	            validateAtLeastNumberOfArgs('WriteBatch.update', arguments, 3);
	            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateVarargs('WriteBatch.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            validateExactNumberOfArgs('WriteBatch.update', arguments, 2);
	            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateData('WriteBatch.update', fieldOrUpdateData);
	        }
	        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.exists(true)));
	        return this;
	    };
	    WriteBatch.prototype.delete = function (documentRef) {
	        validateExactNumberOfArgs('WriteBatch.delete', arguments, 1);
	        this.verifyNotCommitted();
	        var ref = validateReference('WriteBatch.delete', documentRef, this._firestore);
	        this._mutations = this._mutations.concat(new DeleteMutation(ref._key, Precondition.NONE));
	        return this;
	    };
	    WriteBatch.prototype.commit = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                this.verifyNotCommitted();
	                this._committed = true;
	                if (this._mutations.length > 0) {
	                    return [2 /*return*/, this._firestore.ensureClientConfigured().write(this._mutations)];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    WriteBatch.prototype.verifyNotCommitted = function () {
	        if (this._committed) {
	            throw new FirestoreError(Code.FAILED_PRECONDITION, 'A write batch can no longer be used after commit() ' +
	                'has been called.');
	        }
	    };
	    return WriteBatch;
	}());
	/**
	 * A reference to a particular document in a collection in the database.
	 */
	var DocumentReference = /** @class */ (function () {
	    function DocumentReference(_key, firestore, _converter) {
	        this._key = _key;
	        this.firestore = firestore;
	        this._converter = _converter;
	        this._firestoreClient = this.firestore.ensureClientConfigured();
	    }
	    DocumentReference.forPath = function (path, firestore, converter) {
	        if (path.length % 2 !== 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid document reference. Document ' +
	                'references must have an even number of segments, but ' +
	                (path.canonicalString() + " has " + path.length));
	        }
	        return new DocumentReference(new DocumentKey(path), firestore, converter);
	    };
	    Object.defineProperty(DocumentReference.prototype, "id", {
	        get: function () {
	            return this._key.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentReference.prototype, "parent", {
	        get: function () {
	            return new CollectionReference(this._key.path.popLast(), this.firestore, this._converter);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentReference.prototype, "path", {
	        get: function () {
	            return this._key.path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DocumentReference.prototype.collection = function (pathString) {
	        validateExactNumberOfArgs('DocumentReference.collection', arguments, 1);
	        validateArgType('DocumentReference.collection', 'non-empty string', 1, pathString);
	        if (!pathString) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection name to collection()');
	        }
	        var path = ResourcePath.fromString(pathString);
	        return new CollectionReference(this._key.path.child(path), this.firestore);
	    };
	    DocumentReference.prototype.isEqual = function (other) {
	        if (!(other instanceof DocumentReference)) {
	            throw invalidClassError('isEqual', 'DocumentReference', 1, other);
	        }
	        return (this.firestore === other.firestore &&
	            this._key.isEqual(other._key) &&
	            this._converter === other._converter);
	    };
	    DocumentReference.prototype.set = function (value, options) {
	        validateBetweenNumberOfArgs('DocumentReference.set', arguments, 1, 2);
	        options = validateSetOptions('DocumentReference.set', options);
	        var _a = applyFirestoreDataConverter(this._converter, value, 'DocumentReference.set'), convertedValue = _a[0], functionName = _a[1];
	        var parsed = options.merge || options.mergeFields
	            ? this.firestore._dataConverter.parseMergeData(functionName, convertedValue, options.mergeFields)
	            : this.firestore._dataConverter.parseSetData(functionName, convertedValue);
	        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.NONE));
	    };
	    DocumentReference.prototype.update = function (fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 2] = arguments[_i];
	        }
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof FieldPath$1) {
	            validateAtLeastNumberOfArgs('DocumentReference.update', arguments, 2);
	            parsed = this.firestore._dataConverter.parseUpdateVarargs('DocumentReference.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            validateExactNumberOfArgs('DocumentReference.update', arguments, 1);
	            parsed = this.firestore._dataConverter.parseUpdateData('DocumentReference.update', fieldOrUpdateData);
	        }
	        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.exists(true)));
	    };
	    DocumentReference.prototype.delete = function () {
	        validateExactNumberOfArgs('DocumentReference.delete', arguments, 0);
	        return this._firestoreClient.write([
	            new DeleteMutation(this._key, Precondition.NONE)
	        ]);
	    };
	    DocumentReference.prototype.onSnapshot = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        validateBetweenNumberOfArgs('DocumentReference.onSnapshot', arguments, 1, 4);
	        var options = {
	            includeMetadataChanges: false
	        };
	        var observer;
	        var currArg = 0;
	        if (typeof args[currArg] === 'object' &&
	            !isPartialObserver(args[currArg])) {
	            options = args[currArg];
	            validateOptionNames('DocumentReference.onSnapshot', options, [
	                'includeMetadataChanges'
	            ]);
	            validateNamedOptionalType('DocumentReference.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
	            currArg++;
	        }
	        var internalOptions = {
	            includeMetadataChanges: options.includeMetadataChanges
	        };
	        if (isPartialObserver(args[currArg])) {
	            observer = args[currArg];
	        }
	        else {
	            validateArgType('DocumentReference.onSnapshot', 'function', currArg, args[currArg]);
	            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
	            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
	            observer = {
	                next: args[currArg],
	                error: args[currArg + 1],
	                complete: args[currArg + 2]
	            };
	        }
	        return this.onSnapshotInternal(internalOptions, observer);
	    };
	    DocumentReference.prototype.onSnapshotInternal = function (options, observer) {
	        var _this = this;
	        var errHandler = function (err) {
	            console.error('Uncaught Error in onSnapshot:', err);
	        };
	        if (observer.error) {
	            errHandler = observer.error.bind(observer);
	        }
	        var asyncObserver = new AsyncObserver({
	            next: function (snapshot) {
	                if (observer.next) {
	                    assert(snapshot.docs.size <= 1, 'Too many documents returned on a document query');
	                    var doc = snapshot.docs.get(_this._key);
	                    observer.next(new DocumentSnapshot(_this.firestore, _this._key, doc, snapshot.fromCache, snapshot.hasPendingWrites, _this._converter));
	                }
	            },
	            error: errHandler
	        });
	        var internalListener = this._firestoreClient.listen(Query.atPath(this._key.path), asyncObserver, options);
	        return function () {
	            asyncObserver.mute();
	            _this._firestoreClient.unlisten(internalListener);
	        };
	    };
	    DocumentReference.prototype.get = function (options) {
	        var _this = this;
	        validateBetweenNumberOfArgs('DocumentReference.get', arguments, 0, 1);
	        validateGetOptions('DocumentReference.get', options);
	        return new Promise(function (resolve, reject) {
	            if (options && options.source === 'cache') {
	                _this.firestore
	                    .ensureClientConfigured()
	                    .getDocumentFromLocalCache(_this._key)
	                    .then(function (doc) {
	                    resolve(new DocumentSnapshot(_this.firestore, _this._key, doc, 
	                    /*fromCache=*/ true, doc instanceof Document ? doc.hasLocalMutations : false, _this._converter));
	                }, reject);
	            }
	            else {
	                _this.getViaSnapshotListener(resolve, reject, options);
	            }
	        });
	    };
	    DocumentReference.prototype.getViaSnapshotListener = function (resolve, reject, options) {
	        var unlisten = this.onSnapshotInternal({
	            includeMetadataChanges: true,
	            waitForSyncWhenOnline: true
	        }, {
	            next: function (snap) {
	                // Remove query first before passing event to user to avoid
	                // user actions affecting the now stale query.
	                unlisten();
	                if (!snap.exists && snap.metadata.fromCache) {
	                    // TODO(dimond): If we're online and the document doesn't
	                    // exist then we resolve with a doc.exists set to false. If
	                    // we're offline however, we reject the Promise in this
	                    // case. Two options: 1) Cache the negative response from
	                    // the server so we can deliver that even when you're
	                    // offline 2) Actually reject the Promise in the online case
	                    // if the document doesn't exist.
	                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document because the client is ' + 'offline.'));
	                }
	                else if (snap.exists &&
	                    snap.metadata.fromCache &&
	                    options &&
	                    options.source === 'server') {
	                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from server. (However, this ' +
	                        'document does exist in the local cache. Run again ' +
	                        'without setting source to "server" to ' +
	                        'retrieve the cached document.)'));
	                }
	                else {
	                    resolve(snap);
	                }
	            },
	            error: reject
	        });
	    };
	    DocumentReference.prototype.withConverter = function (converter) {
	        return new DocumentReference(this._key, this.firestore, converter);
	    };
	    return DocumentReference;
	}());
	var SnapshotMetadata = /** @class */ (function () {
	    function SnapshotMetadata(hasPendingWrites, fromCache) {
	        this.hasPendingWrites = hasPendingWrites;
	        this.fromCache = fromCache;
	    }
	    SnapshotMetadata.prototype.isEqual = function (other) {
	        return (this.hasPendingWrites === other.hasPendingWrites &&
	            this.fromCache === other.fromCache);
	    };
	    return SnapshotMetadata;
	}());
	var DocumentSnapshot = /** @class */ (function () {
	    function DocumentSnapshot(_firestore, _key, _document, _fromCache, _hasPendingWrites, _converter) {
	        this._firestore = _firestore;
	        this._key = _key;
	        this._document = _document;
	        this._fromCache = _fromCache;
	        this._hasPendingWrites = _hasPendingWrites;
	        this._converter = _converter;
	    }
	    DocumentSnapshot.prototype.data = function (options) {
	        validateBetweenNumberOfArgs('DocumentSnapshot.data', arguments, 0, 1);
	        options = validateSnapshotOptions('DocumentSnapshot.data', options);
	        if (!this._document) {
	            return undefined;
	        }
	        else {
	            // We only want to use the converter and create a new DocumentSnapshot
	            // if a converter has been provided.
	            if (this._converter) {
	                var snapshot = new QueryDocumentSnapshot(this._firestore, this._key, this._document, this._fromCache, this._hasPendingWrites);
	                return this._converter.fromFirestore(snapshot, options);
	            }
	            else {
	                return this.toJSObject(this._document.data(), FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
	            }
	        }
	    };
	    DocumentSnapshot.prototype.get = function (fieldPath, options) {
	        validateBetweenNumberOfArgs('DocumentSnapshot.get', arguments, 1, 2);
	        options = validateSnapshotOptions('DocumentSnapshot.get', options);
	        if (this._document) {
	            var value = this._document
	                .data()
	                .field(fieldPathFromArgument('DocumentSnapshot.get', fieldPath));
	            if (value !== null) {
	                return this.toJSValue(value, FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
	            }
	        }
	        return undefined;
	    };
	    Object.defineProperty(DocumentSnapshot.prototype, "id", {
	        get: function () {
	            return this._key.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "ref", {
	        get: function () {
	            return new DocumentReference(this._key, this._firestore, this._converter);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "exists", {
	        get: function () {
	            return this._document !== null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "metadata", {
	        get: function () {
	            return new SnapshotMetadata(this._hasPendingWrites, this._fromCache);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DocumentSnapshot.prototype.isEqual = function (other) {
	        if (!(other instanceof DocumentSnapshot)) {
	            throw invalidClassError('isEqual', 'DocumentSnapshot', 1, other);
	        }
	        return (this._firestore === other._firestore &&
	            this._fromCache === other._fromCache &&
	            this._key.isEqual(other._key) &&
	            (this._document === null
	                ? other._document === null
	                : this._document.isEqual(other._document)) &&
	            this._converter === other._converter);
	    };
	    DocumentSnapshot.prototype.toJSObject = function (data, options) {
	        var _this = this;
	        var result = {};
	        data.forEach(function (key, value) {
	            result[key] = _this.toJSValue(value, options);
	        });
	        return result;
	    };
	    DocumentSnapshot.prototype.toJSValue = function (value, options) {
	        if (value instanceof ObjectValue) {
	            return this.toJSObject(value, options);
	        }
	        else if (value instanceof ArrayValue) {
	            return this.toJSArray(value, options);
	        }
	        else if (value instanceof RefValue) {
	            var key = value.value(options);
	            var database = this._firestore.ensureClientConfigured().databaseId();
	            if (!value.databaseId.isEqual(database)) {
	                // TODO(b/64130202): Somehow support foreign references.
	                error("Document " + this._key.path + " contains a document " +
	                    "reference within a different database (" +
	                    (value.databaseId.projectId + "/" + value.databaseId.database + ") which is not ") +
	                    "supported. It will be treated as a reference in the current " +
	                    ("database (" + database.projectId + "/" + database.database + ") ") +
	                    "instead.");
	            }
	            return new DocumentReference(key, this._firestore, this._converter);
	        }
	        else {
	            return value.value(options);
	        }
	    };
	    DocumentSnapshot.prototype.toJSArray = function (data, options) {
	        var _this = this;
	        return data.internalValue.map(function (value) {
	            return _this.toJSValue(value, options);
	        });
	    };
	    return DocumentSnapshot;
	}());
	var QueryDocumentSnapshot = /** @class */ (function (_super) {
	    tslib.__extends(QueryDocumentSnapshot, _super);
	    function QueryDocumentSnapshot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    QueryDocumentSnapshot.prototype.data = function (options) {
	        var data = _super.prototype.data.call(this, options);
	        assert(data !== undefined, 'Document in a QueryDocumentSnapshot should exist');
	        return data;
	    };
	    return QueryDocumentSnapshot;
	}(DocumentSnapshot));
	var Query$1 = /** @class */ (function () {
	    function Query(_query, firestore, _converter) {
	        this._query = _query;
	        this.firestore = firestore;
	        this._converter = _converter;
	    }
	    Query.prototype.where = function (field, opStr, value) {
	        validateExactNumberOfArgs('Query.where', arguments, 3);
	        validateDefined('Query.where', 3, value);
	        // Enumerated from the WhereFilterOp type in index.d.ts.
	        var whereFilterOpEnums = [
	            '<',
	            '<=',
	            '==',
	            '>=',
	            '>',
	            'array-contains',
	            'in',
	            'array-contains-any'
	        ];
	        validateStringEnum('Query.where', whereFilterOpEnums, 2, opStr);
	        var fieldValue;
	        var fieldPath = fieldPathFromArgument('Query.where', field);
	        var operator = Operator.fromString(opStr);
	        if (fieldPath.isKeyField()) {
	            if (operator === Operator.ARRAY_CONTAINS ||
	                operator === Operator.ARRAY_CONTAINS_ANY) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. You can't perform '" + operator.toString() + "' " +
	                    'queries on FieldPath.documentId().');
	            }
	            else if (operator === Operator.IN) {
	                this.validateDisjunctiveFilterElements(value, operator);
	                var referenceList = [];
	                for (var _i = 0, _a = value; _i < _a.length; _i++) {
	                    var arrayValue = _a[_i];
	                    referenceList.push(this.parseDocumentIdValue(arrayValue));
	                }
	                fieldValue = new ArrayValue(referenceList);
	            }
	            else {
	                fieldValue = this.parseDocumentIdValue(value);
	            }
	        }
	        else {
	            if (operator === Operator.IN ||
	                operator === Operator.ARRAY_CONTAINS_ANY) {
	                this.validateDisjunctiveFilterElements(value, operator);
	            }
	            fieldValue = this.firestore._dataConverter.parseQueryValue('Query.where', value, 
	            // We only allow nested arrays for IN queries.
	            /** allowArrays = */ operator === Operator.IN ? true : false);
	        }
	        var filter = FieldFilter.create(fieldPath, operator, fieldValue);
	        this.validateNewFilter(filter);
	        return new Query(this._query.addFilter(filter), this.firestore, this._converter);
	    };
	    Query.prototype.orderBy = function (field, directionStr) {
	        validateBetweenNumberOfArgs('Query.orderBy', arguments, 1, 2);
	        validateOptionalArgType('Query.orderBy', 'non-empty string', 2, directionStr);
	        var direction;
	        if (directionStr === undefined || directionStr === 'asc') {
	            direction = Direction.ASCENDING;
	        }
	        else if (directionStr === 'desc') {
	            direction = Direction.DESCENDING;
	        }
	        else {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + directionStr + "', " +
	                "expected 'asc' or 'desc'.");
	        }
	        if (this._query.startAt !== null) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.startAt() or ' +
	                'Query.startAfter() before calling Query.orderBy().');
	        }
	        if (this._query.endAt !== null) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.endAt() or ' +
	                'Query.endBefore() before calling Query.orderBy().');
	        }
	        var fieldPath = fieldPathFromArgument('Query.orderBy', field);
	        var orderBy = new OrderBy(fieldPath, direction);
	        this.validateNewOrderBy(orderBy);
	        return new Query(this._query.addOrderBy(orderBy), this.firestore, this._converter);
	    };
	    Query.prototype.limit = function (n) {
	        validateExactNumberOfArgs('Query.limit', arguments, 1);
	        validateArgType('Query.limit', 'number', 1, n);
	        validatePositiveNumber('Query.limit', 1, n);
	        return new Query(this._query.withLimitToFirst(n), this.firestore, this._converter);
	    };
	    Query.prototype.limitToLast = function (n) {
	        validateExactNumberOfArgs('Query.limitToLast', arguments, 1);
	        validateArgType('Query.limitToLast', 'number', 1, n);
	        validatePositiveNumber('Query.limitToLast', 1, n);
	        return new Query(this._query.withLimitToLast(n), this.firestore, this._converter);
	    };
	    Query.prototype.startAt = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('Query.startAt', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.startAt', docOrField, fields, 
	        /*before=*/ true);
	        return new Query(this._query.withStartAt(bound), this.firestore, this._converter);
	    };
	    Query.prototype.startAfter = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('Query.startAfter', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.startAfter', docOrField, fields, 
	        /*before=*/ false);
	        return new Query(this._query.withStartAt(bound), this.firestore, this._converter);
	    };
	    Query.prototype.endBefore = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('Query.endBefore', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.endBefore', docOrField, fields, 
	        /*before=*/ true);
	        return new Query(this._query.withEndAt(bound), this.firestore, this._converter);
	    };
	    Query.prototype.endAt = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        validateAtLeastNumberOfArgs('Query.endAt', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.endAt', docOrField, fields, 
	        /*before=*/ false);
	        return new Query(this._query.withEndAt(bound), this.firestore, this._converter);
	    };
	    Query.prototype.isEqual = function (other) {
	        if (!(other instanceof Query)) {
	            throw invalidClassError('isEqual', 'Query', 1, other);
	        }
	        return (this.firestore === other.firestore && this._query.isEqual(other._query));
	    };
	    Query.prototype.withConverter = function (converter) {
	        return new Query(this._query, this.firestore, converter);
	    };
	    /** Helper function to create a bound from a document or fields */
	    Query.prototype.boundFromDocOrFields = function (methodName, docOrField, fields, before) {
	        validateDefined(methodName, 1, docOrField);
	        if (docOrField instanceof DocumentSnapshot) {
	            if (fields.length > 0) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "().");
	            }
	            var snap = docOrField;
	            if (!snap.exists) {
	                throw new FirestoreError(Code.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " +
	                    (methodName + "()."));
	            }
	            return this.boundFromDocument(methodName, snap._document, before);
	        }
	        else {
	            var allFields = [docOrField].concat(fields);
	            return this.boundFromFields(methodName, allFields, before);
	        }
	    };
	    /**
	     * Create a Bound from a query and a document.
	     *
	     * Note that the Bound will always include the key of the document
	     * and so only the provided document will compare equal to the returned
	     * position.
	     *
	     * Will throw if the document does not contain all fields of the order by
	     * of the query or if any of the fields in the order by are an uncommitted
	     * server timestamp.
	     */
	    Query.prototype.boundFromDocument = function (methodName, doc, before) {
	        var components = [];
	        // Because people expect to continue/end a query at the exact document
	        // provided, we need to use the implicit sort order rather than the explicit
	        // sort order, because it's guaranteed to contain the document key. That way
	        // the position becomes unambiguous and the query continues/ends exactly at
	        // the provided document. Without the key (by using the explicit sort
	        // orders), multiple documents could match the position, yielding duplicate
	        // results.
	        for (var _i = 0, _a = this._query.orderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            if (orderBy.field.isKeyField()) {
	                components.push(new RefValue(this.firestore._databaseId, doc.key));
	            }
	            else {
	                var value = doc.field(orderBy.field);
	                if (value instanceof ServerTimestampValue) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a ' +
	                        'document for which the field "' +
	                        orderBy.field +
	                        '" is an uncommitted server timestamp. (Since the value of ' +
	                        'this field is unknown, you cannot start/end a query with it.)');
	                }
	                else if (value !== null) {
	                    components.push(value);
	                }
	                else {
	                    var field = orderBy.field.canonicalString();
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a " +
	                        ("document for which the field '" + field + "' (used as the ") +
	                        "orderBy) does not exist.");
	                }
	            }
	        }
	        return new Bound(components, before);
	    };
	    /**
	     * Converts a list of field values to a Bound for the given query.
	     */
	    Query.prototype.boundFromFields = function (methodName, values, before) {
	        // Use explicit order by's because it has to match the query the user made
	        var orderBy = this._query.explicitOrderBy;
	        if (values.length > orderBy.length) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "(). " +
	                "The number of arguments must be less than or equal to the " +
	                "number of Query.orderBy() clauses");
	        }
	        var components = [];
	        for (var i = 0; i < values.length; i++) {
	            var rawValue = values[i];
	            var orderByComponent = orderBy[i];
	            if (orderByComponent.field.isKeyField()) {
	                if (typeof rawValue !== 'string') {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " +
	                        (methodName + "(), but got a " + typeof rawValue));
	                }
	                if (!this._query.isCollectionGroupQuery() &&
	                    rawValue.indexOf('/') !== -1) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by FieldPath.documentId(), " +
	                        ("the value passed to " + methodName + "() must be a plain document ID, but ") +
	                        ("'" + rawValue + "' contains a slash."));
	                }
	                var path = this._query.path.child(ResourcePath.fromString(rawValue));
	                if (!DocumentKey.isDocumentKey(path)) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by " +
	                        ("FieldPath.documentId(), the value passed to " + methodName + "() must result in a ") +
	                        ("valid document path, but '" + path + "' is not because it contains an odd number ") +
	                        "of segments.");
	                }
	                var key = new DocumentKey(path);
	                components.push(new RefValue(this.firestore._databaseId, key));
	            }
	            else {
	                var wrapped = this.firestore._dataConverter.parseQueryValue(methodName, rawValue);
	                components.push(wrapped);
	            }
	        }
	        return new Bound(components, before);
	    };
	    Query.prototype.onSnapshot = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        validateBetweenNumberOfArgs('Query.onSnapshot', arguments, 1, 4);
	        var options = {};
	        var observer;
	        var currArg = 0;
	        if (typeof args[currArg] === 'object' &&
	            !isPartialObserver(args[currArg])) {
	            options = args[currArg];
	            validateOptionNames('Query.onSnapshot', options, [
	                'includeMetadataChanges'
	            ]);
	            validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
	            currArg++;
	        }
	        if (isPartialObserver(args[currArg])) {
	            observer = args[currArg];
	        }
	        else {
	            validateArgType('Query.onSnapshot', 'function', currArg, args[currArg]);
	            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
	            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
	            observer = {
	                next: args[currArg],
	                error: args[currArg + 1],
	                complete: args[currArg + 2]
	            };
	        }
	        this.validateHasExplicitOrderByForLimitToLast(this._query);
	        return this.onSnapshotInternal(options, observer);
	    };
	    Query.prototype.onSnapshotInternal = function (options, observer) {
	        var _this = this;
	        var errHandler = function (err) {
	            console.error('Uncaught Error in onSnapshot:', err);
	        };
	        if (observer.error) {
	            errHandler = observer.error.bind(observer);
	        }
	        var asyncObserver = new AsyncObserver({
	            next: function (result) {
	                if (observer.next) {
	                    observer.next(new QuerySnapshot(_this.firestore, _this._query, result, _this._converter));
	                }
	            },
	            error: errHandler
	        });
	        var firestoreClient = this.firestore.ensureClientConfigured();
	        var internalListener = firestoreClient.listen(this._query, asyncObserver, options);
	        return function () {
	            asyncObserver.mute();
	            firestoreClient.unlisten(internalListener);
	        };
	    };
	    Query.prototype.validateHasExplicitOrderByForLimitToLast = function (query) {
	        if (query.hasLimitToLast() && query.explicitOrderBy.length === 0) {
	            throw new FirestoreError(Code.UNIMPLEMENTED, 'limitToLast() queries require specifying at least one orderBy() clause');
	        }
	    };
	    Query.prototype.get = function (options) {
	        var _this = this;
	        validateBetweenNumberOfArgs('Query.get', arguments, 0, 1);
	        validateGetOptions('Query.get', options);
	        this.validateHasExplicitOrderByForLimitToLast(this._query);
	        return new Promise(function (resolve, reject) {
	            if (options && options.source === 'cache') {
	                _this.firestore
	                    .ensureClientConfigured()
	                    .getDocumentsFromLocalCache(_this._query)
	                    .then(function (viewSnap) {
	                    resolve(new QuerySnapshot(_this.firestore, _this._query, viewSnap, _this._converter));
	                }, reject);
	            }
	            else {
	                _this.getViaSnapshotListener(resolve, reject, options);
	            }
	        });
	    };
	    Query.prototype.getViaSnapshotListener = function (resolve, reject, options) {
	        var unlisten = this.onSnapshotInternal({
	            includeMetadataChanges: true,
	            waitForSyncWhenOnline: true
	        }, {
	            next: function (result) {
	                // Remove query first before passing event to user to avoid
	                // user actions affecting the now stale query.
	                unlisten();
	                if (result.metadata.fromCache &&
	                    options &&
	                    options.source === 'server') {
	                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get documents from server. (However, these ' +
	                        'documents may exist in the local cache. Run again ' +
	                        'without setting source to "server" to ' +
	                        'retrieve the cached documents.)'));
	                }
	                else {
	                    resolve(result);
	                }
	            },
	            error: reject
	        });
	    };
	    /**
	     * Parses the given documentIdValue into a ReferenceValue, throwing
	     * appropriate errors if the value is anything other than a DocumentReference
	     * or String, or if the string is malformed.
	     */
	    Query.prototype.parseDocumentIdValue = function (documentIdValue) {
	        if (typeof documentIdValue === 'string') {
	            if (documentIdValue === '') {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. When querying with FieldPath.documentId(), you ' +
	                    'must provide a valid document ID, but it was an empty string.');
	            }
	            if (!this._query.isCollectionGroupQuery() &&
	                documentIdValue.indexOf('/') !== -1) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying a collection by " +
	                    "FieldPath.documentId(), you must provide a plain document ID, but " +
	                    ("'" + documentIdValue + "' contains a '/' character."));
	            }
	            var path = this._query.path.child(ResourcePath.fromString(documentIdValue));
	            if (!DocumentKey.isDocumentKey(path)) {
	                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying a collection group by " +
	                    "FieldPath.documentId(), the value provided must result in a valid document path, " +
	                    ("but '" + path + "' is not because it has an odd number of segments (" + path.length + ")."));
	            }
	            return new RefValue(this.firestore._databaseId, new DocumentKey(path));
	        }
	        else if (documentIdValue instanceof DocumentReference) {
	            var ref = documentIdValue;
	            return new RefValue(this.firestore._databaseId, ref._key);
	        }
	        else {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid " +
	                "string or a DocumentReference, but it was: " +
	                (valueDescription(documentIdValue) + "."));
	        }
	    };
	    /**
	     * Validates that the value passed into a disjunctrive filter satisfies all
	     * array requirements.
	     */
	    Query.prototype.validateDisjunctiveFilterElements = function (value, operator) {
	        if (!Array.isArray(value) || value.length === 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid Query. A non-empty array is required for ' +
	                ("'" + operator.toString() + "' filters."));
	        }
	        if (value.length > 10) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. '" + operator.toString() + "' filters support a " +
	                'maximum of 10 elements in the value array.');
	        }
	        if (value.indexOf(null) >= 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. '" + operator.toString() + "' filters cannot contain 'null' " +
	                'in the value array.');
	        }
	        if (value.filter(function (element) { return Number.isNaN(element); }).length > 0) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. '" + operator.toString() + "' filters cannot contain 'NaN' " +
	                'in the value array.');
	        }
	    };
	    Query.prototype.validateNewFilter = function (filter) {
	        if (filter instanceof FieldFilter) {
	            var arrayOps = [Operator.ARRAY_CONTAINS, Operator.ARRAY_CONTAINS_ANY];
	            var disjunctiveOps = [Operator.IN, Operator.ARRAY_CONTAINS_ANY];
	            var isArrayOp = arrayOps.indexOf(filter.op) >= 0;
	            var isDisjunctiveOp = disjunctiveOps.indexOf(filter.op) >= 0;
	            if (filter.isInequality()) {
	                var existingField = this._query.getInequalityFilterField();
	                if (existingField !== null && !existingField.isEqual(filter.field)) {
	                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. All where filters with an inequality' +
	                        ' (<, <=, >, or >=) must be on the same field. But you have' +
	                        (" inequality filters on '" + existingField.toString() + "'") +
	                        (" and '" + filter.field.toString() + "'"));
	                }
	                var firstOrderByField = this._query.getFirstOrderByField();
	                if (firstOrderByField !== null) {
	                    this.validateOrderByAndInequalityMatch(filter.field, firstOrderByField);
	                }
	            }
	            else if (isDisjunctiveOp || isArrayOp) {
	                // You can have at most 1 disjunctive filter and 1 array filter. Check if
	                // the new filter conflicts with an existing one.
	                var conflictingOp = null;
	                if (isDisjunctiveOp) {
	                    conflictingOp = this._query.findFilterOperator(disjunctiveOps);
	                }
	                if (conflictingOp === null && isArrayOp) {
	                    conflictingOp = this._query.findFilterOperator(arrayOps);
	                }
	                if (conflictingOp != null) {
	                    // We special case when it's a duplicate op to give a slightly clearer error message.
	                    if (conflictingOp === filter.op) {
	                        throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You cannot use more than one ' +
	                            ("'" + filter.op.toString() + "' filter."));
	                    }
	                    else {
	                        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You cannot use '" + filter.op.toString() + "' filters " +
	                            ("with '" + conflictingOp.toString() + "' filters."));
	                    }
	                }
	            }
	        }
	    };
	    Query.prototype.validateNewOrderBy = function (orderBy) {
	        if (this._query.getFirstOrderByField() === null) {
	            // This is the first order by. It must match any inequality.
	            var inequalityField = this._query.getInequalityFilterField();
	            if (inequalityField !== null) {
	                this.validateOrderByAndInequalityMatch(inequalityField, orderBy.field);
	            }
	        }
	    };
	    Query.prototype.validateOrderByAndInequalityMatch = function (inequality, orderBy) {
	        if (!orderBy.isEqual(inequality)) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality " +
	                ("(<, <=, >, or >=) on field '" + inequality.toString() + "' ") +
	                ("and so you must also use '" + inequality.toString() + "' ") +
	                "as your first Query.orderBy(), but your first Query.orderBy() " +
	                ("is on field '" + orderBy.toString() + "' instead."));
	        }
	    };
	    return Query;
	}());
	var QuerySnapshot = /** @class */ (function () {
	    function QuerySnapshot(_firestore, _originalQuery, _snapshot, _converter) {
	        this._firestore = _firestore;
	        this._originalQuery = _originalQuery;
	        this._snapshot = _snapshot;
	        this._converter = _converter;
	        this._cachedChanges = null;
	        this._cachedChangesIncludeMetadataChanges = null;
	        this.metadata = new SnapshotMetadata(_snapshot.hasPendingWrites, _snapshot.fromCache);
	    }
	    Object.defineProperty(QuerySnapshot.prototype, "docs", {
	        get: function () {
	            var result = [];
	            this.forEach(function (doc) { return result.push(doc); });
	            return result;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QuerySnapshot.prototype, "empty", {
	        get: function () {
	            return this._snapshot.docs.isEmpty();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QuerySnapshot.prototype, "size", {
	        get: function () {
	            return this._snapshot.docs.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    QuerySnapshot.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        validateBetweenNumberOfArgs('QuerySnapshot.forEach', arguments, 1, 2);
	        validateArgType('QuerySnapshot.forEach', 'function', 1, callback);
	        this._snapshot.docs.forEach(function (doc) {
	            callback.call(thisArg, _this.convertToDocumentImpl(doc));
	        });
	    };
	    Object.defineProperty(QuerySnapshot.prototype, "query", {
	        get: function () {
	            return new Query$1(this._originalQuery, this._firestore, this._converter);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    QuerySnapshot.prototype.docChanges = function (options) {
	        if (options) {
	            validateOptionNames('QuerySnapshot.docChanges', options, [
	                'includeMetadataChanges'
	            ]);
	            validateNamedOptionalType('QuerySnapshot.docChanges', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
	        }
	        var includeMetadataChanges = !!(options && options.includeMetadataChanges);
	        if (includeMetadataChanges && this._snapshot.excludesMetadataChanges) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'To include metadata changes with your document changes, you must ' +
	                'also pass { includeMetadataChanges:true } to onSnapshot().');
	        }
	        if (!this._cachedChanges ||
	            this._cachedChangesIncludeMetadataChanges !== includeMetadataChanges) {
	            this._cachedChanges = changesFromSnapshot(this._firestore, includeMetadataChanges, this._snapshot, this._converter);
	            this._cachedChangesIncludeMetadataChanges = includeMetadataChanges;
	        }
	        return this._cachedChanges;
	    };
	    /** Check the equality. The call can be very expensive. */
	    QuerySnapshot.prototype.isEqual = function (other) {
	        if (!(other instanceof QuerySnapshot)) {
	            throw invalidClassError('isEqual', 'QuerySnapshot', 1, other);
	        }
	        return (this._firestore === other._firestore &&
	            this._originalQuery.isEqual(other._originalQuery) &&
	            this._snapshot.isEqual(other._snapshot) &&
	            this._converter === other._converter);
	    };
	    QuerySnapshot.prototype.convertToDocumentImpl = function (doc) {
	        return new QueryDocumentSnapshot(this._firestore, doc.key, doc, this.metadata.fromCache, this._snapshot.mutatedKeys.has(doc.key), this._converter);
	    };
	    return QuerySnapshot;
	}());
	// TODO(2018/11/01): As of 2018/04/17 we're changing docChanges from an array
	// into a method. Because this is a runtime breaking change and somewhat subtle
	// (both Array and Function have a .length, etc.), we'll replace commonly-used
	// properties (including Symbol.iterator) to throw a custom error message. In
	// ~6 months we can delete the custom error as most folks will have hopefully
	// migrated.
	function throwDocChangesMethodError() {
	    throw new FirestoreError(Code.INVALID_ARGUMENT, 'QuerySnapshot.docChanges has been changed from a property into a ' +
	        'method, so usages like "querySnapshot.docChanges" should become ' +
	        '"querySnapshot.docChanges()"');
	}
	var docChangesPropertiesToOverride = tslib.__spreadArrays([
	    'length',
	    'forEach',
	    'map'
	], (typeof Symbol !== 'undefined' ? [Symbol.iterator] : []));
	docChangesPropertiesToOverride.forEach(function (property) {
	    /**
	     * We are (re-)defining properties on QuerySnapshot.prototype.docChanges which
	     * is a Function. This could fail, in particular in the case of 'length' which
	     * already exists on Function.prototype and on IE11 is improperly defined with
	     * `{ configurable: false }`. So we wrap this in a try/catch to ensure that we
	     * still have a functional SDK.
	     */
	    try {
	        Object.defineProperty(QuerySnapshot.prototype.docChanges, property, {
	            get: function () { return throwDocChangesMethodError(); }
	        });
	    }
	    catch (err) { } // Ignore this failure intentionally
	});
	var CollectionReference = /** @class */ (function (_super) {
	    tslib.__extends(CollectionReference, _super);
	    function CollectionReference(_path, firestore, _converter) {
	        var _this = _super.call(this, Query.atPath(_path), firestore, _converter) || this;
	        _this._path = _path;
	        if (_path.length % 2 !== 1) {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid collection reference. Collection ' +
	                'references must have an odd number of segments, but ' +
	                (_path.canonicalString() + " has " + _path.length));
	        }
	        return _this;
	    }
	    Object.defineProperty(CollectionReference.prototype, "id", {
	        get: function () {
	            return this._query.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CollectionReference.prototype, "parent", {
	        get: function () {
	            var parentPath = this._query.path.popLast();
	            if (parentPath.isEmpty()) {
	                return null;
	            }
	            else {
	                return new DocumentReference(new DocumentKey(parentPath), this.firestore);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CollectionReference.prototype, "path", {
	        get: function () {
	            return this._query.path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CollectionReference.prototype.doc = function (pathString) {
	        validateBetweenNumberOfArgs('CollectionReference.doc', arguments, 0, 1);
	        // We allow omission of 'pathString' but explicitly prohibit passing in both
	        // 'undefined' and 'null'.
	        if (arguments.length === 0) {
	            pathString = AutoId.newId();
	        }
	        validateArgType('CollectionReference.doc', 'non-empty string', 1, pathString);
	        if (pathString === '') {
	            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document path must be a non-empty string');
	        }
	        var path = ResourcePath.fromString(pathString);
	        return DocumentReference.forPath(this._query.path.child(path), this.firestore, this._converter);
	    };
	    CollectionReference.prototype.add = function (value) {
	        validateExactNumberOfArgs('CollectionReference.add', arguments, 1);
	        var convertedValue = this._converter
	            ? this._converter.toFirestore(value)
	            : value;
	        validateArgType('CollectionReference.add', 'object', 1, convertedValue);
	        var docRef = this.doc();
	        return docRef.set(value).then(function () { return docRef; });
	    };
	    CollectionReference.prototype.withConverter = function (converter) {
	        return new CollectionReference(this._path, this.firestore, converter);
	    };
	    return CollectionReference;
	}(Query$1));
	function validateSetOptions(methodName, options) {
	    if (options === undefined) {
	        return {
	            merge: false
	        };
	    }
	    validateOptionNames(methodName, options, ['merge', 'mergeFields']);
	    validateNamedOptionalType(methodName, 'boolean', 'merge', options.merge);
	    validateOptionalArrayElements(methodName, 'mergeFields', 'a string or a FieldPath', options.mergeFields, function (element) {
	        return typeof element === 'string' || element instanceof FieldPath$1;
	    });
	    if (options.mergeFields !== undefined && options.merge !== undefined) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid options passed to function " + methodName + "(): You cannot specify both \"merge\" " +
	            "and \"mergeFields\".");
	    }
	    return options;
	}
	function validateSnapshotOptions(methodName, options) {
	    if (options === undefined) {
	        return {};
	    }
	    validateOptionNames(methodName, options, ['serverTimestamps']);
	    validateNamedOptionalPropertyEquals(methodName, 'options', 'serverTimestamps', options.serverTimestamps, ['estimate', 'previous', 'none']);
	    return options;
	}
	function validateGetOptions(methodName, options) {
	    validateOptionalArgType(methodName, 'object', 1, options);
	    if (options) {
	        validateOptionNames(methodName, options, ['source']);
	        validateNamedOptionalPropertyEquals(methodName, 'options', 'source', options.source, ['default', 'server', 'cache']);
	    }
	}
	function validateReference(methodName, documentRef, firestore) {
	    if (!(documentRef instanceof DocumentReference)) {
	        throw invalidClassError(methodName, 'DocumentReference', 1, documentRef);
	    }
	    else if (documentRef.firestore !== firestore) {
	        throw new FirestoreError(Code.INVALID_ARGUMENT, 'Provided document reference is from a different Firestore instance.');
	    }
	    else {
	        return documentRef;
	    }
	}
	/**
	 * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
	 *
	 * Exported for testing.
	 */
	function changesFromSnapshot(firestore, includeMetadataChanges, snapshot, converter) {
	    if (snapshot.oldDocs.isEmpty()) {
	        // Special case the first snapshot because index calculation is easy and
	        // fast
	        var lastDoc_1;
	        var index_1 = 0;
	        return snapshot.docChanges.map(function (change) {
	            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache, snapshot.mutatedKeys.has(change.doc.key), converter);
	            assert(change.type === ChangeType.Added, 'Invalid event type for first snapshot');
	            assert(!lastDoc_1 || snapshot.query.docComparator(lastDoc_1, change.doc) < 0, 'Got added events in wrong order');
	            lastDoc_1 = change.doc;
	            return {
	                type: 'added',
	                doc: doc,
	                oldIndex: -1,
	                newIndex: index_1++
	            };
	        });
	    }
	    else {
	        // A DocumentSet that is updated incrementally as changes are applied to use
	        // to lookup the index of a document.
	        var indexTracker_1 = snapshot.oldDocs;
	        return snapshot.docChanges
	            .filter(function (change) { return includeMetadataChanges || change.type !== ChangeType.Metadata; })
	            .map(function (change) {
	            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache, snapshot.mutatedKeys.has(change.doc.key), converter);
	            var oldIndex = -1;
	            var newIndex = -1;
	            if (change.type !== ChangeType.Added) {
	                oldIndex = indexTracker_1.indexOf(change.doc.key);
	                assert(oldIndex >= 0, 'Index for document not found');
	                indexTracker_1 = indexTracker_1.delete(change.doc.key);
	            }
	            if (change.type !== ChangeType.Removed) {
	                indexTracker_1 = indexTracker_1.add(change.doc);
	                newIndex = indexTracker_1.indexOf(change.doc.key);
	            }
	            return { type: resultChangeType(change.type), doc: doc, oldIndex: oldIndex, newIndex: newIndex };
	        });
	    }
	}
	function resultChangeType(type) {
	    switch (type) {
	        case ChangeType.Added:
	            return 'added';
	        case ChangeType.Modified:
	        case ChangeType.Metadata:
	            return 'modified';
	        case ChangeType.Removed:
	            return 'removed';
	        default:
	            return fail('Unknown change type: ' + type);
	    }
	}
	/**
	 * Converts custom model object of type T into DocumentData by applying the
	 * converter if it exists.
	 *
	 * This function is used when converting user objects to DocumentData
	 * because we want to provide the user with a more specific error message if
	 * their set() or fails due to invalid data originating from a toFirestore()
	 * call.
	 */
	function applyFirestoreDataConverter(converter, value, functionName) {
	    var convertedValue;
	    if (converter) {
	        convertedValue = converter.toFirestore(value);
	        functionName = 'toFirestore() in ' + functionName;
	    }
	    else {
	        convertedValue = value;
	    }
	    return [convertedValue, functionName];
	}
	// Export the classes with a private constructor (it will fail if invoked
	// at runtime). Note that this still allows instanceof checks.
	// We're treating the variables as class names, so disable checking for lower
	// case variable names.
	var PublicFirestore = makeConstructorPrivate(Firestore, 'Use firebase.firestore() instead.');
	var PublicTransaction = makeConstructorPrivate(Transaction$1, 'Use firebase.firestore().runTransaction() instead.');
	var PublicWriteBatch = makeConstructorPrivate(WriteBatch, 'Use firebase.firestore().batch() instead.');
	var PublicDocumentReference = makeConstructorPrivate(DocumentReference, 'Use firebase.firestore().doc() instead.');
	var PublicDocumentSnapshot = makeConstructorPrivate(DocumentSnapshot);
	var PublicQueryDocumentSnapshot = makeConstructorPrivate(QueryDocumentSnapshot);
	var PublicQuery = makeConstructorPrivate(Query$1);
	var PublicQuerySnapshot = makeConstructorPrivate(QuerySnapshot);
	var PublicCollectionReference = makeConstructorPrivate(CollectionReference, 'Use firebase.firestore().collection() instead.');
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var firestoreNamespace = {
	    Firestore: PublicFirestore,
	    GeoPoint: GeoPoint,
	    Timestamp: Timestamp,
	    Blob: PublicBlob,
	    Transaction: PublicTransaction,
	    WriteBatch: PublicWriteBatch,
	    DocumentReference: PublicDocumentReference,
	    DocumentSnapshot: PublicDocumentSnapshot,
	    Query: PublicQuery,
	    QueryDocumentSnapshot: PublicQueryDocumentSnapshot,
	    QuerySnapshot: PublicQuerySnapshot,
	    CollectionReference: PublicCollectionReference,
	    FieldPath: FieldPath$1,
	    FieldValue: PublicFieldValue,
	    setLogLevel: Firestore.setLogLevel,
	    CACHE_SIZE_UNLIMITED: CACHE_SIZE_UNLIMITED
	};
	/**
	 * Configures Firestore as part of the Firebase SDK by calling registerService.
	 */
	function configureForFirebase(firebase) {
	    firebase.INTERNAL.registerComponent(new component.Component('firestore', function (container) {
	        var app = container.getProvider('app').getImmediate();
	        return new Firestore(app, container.getProvider('auth-internal'));
	    }, "PUBLIC" /* PUBLIC */).setServiceProps(shallowCopy(firestoreNamespace)));
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var NoopConnectivityMonitor = /** @class */ (function () {
	    function NoopConnectivityMonitor() {
	    }
	    NoopConnectivityMonitor.prototype.addCallback = function (callback) {
	        // No-op.
	    };
	    NoopConnectivityMonitor.prototype.shutdown = function () {
	        // No-op.
	    };
	    return NoopConnectivityMonitor;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$c = 'ConnectivityMonitor';
	/**
	 * Browser implementation of ConnectivityMonitor.
	 */
	var BrowserConnectivityMonitor = /** @class */ (function () {
	    function BrowserConnectivityMonitor() {
	        var _this = this;
	        this.networkAvailableListener = function () {
	            return _this.onNetworkAvailable();
	        };
	        this.networkUnavailableListener = function () {
	            return _this.onNetworkUnavailable();
	        };
	        this.callbacks = [];
	        this.configureNetworkMonitoring();
	    }
	    BrowserConnectivityMonitor.prototype.addCallback = function (callback) {
	        this.callbacks.push(callback);
	    };
	    BrowserConnectivityMonitor.prototype.shutdown = function () {
	        window.removeEventListener('online', this.networkAvailableListener);
	        window.removeEventListener('offline', this.networkUnavailableListener);
	    };
	    BrowserConnectivityMonitor.prototype.configureNetworkMonitoring = function () {
	        window.addEventListener('online', this.networkAvailableListener);
	        window.addEventListener('offline', this.networkUnavailableListener);
	    };
	    BrowserConnectivityMonitor.prototype.onNetworkAvailable = function () {
	        debug(LOG_TAG$c, 'Network connectivity changed: AVAILABLE');
	        for (var _i = 0, _a = this.callbacks; _i < _a.length; _i++) {
	            var callback = _a[_i];
	            callback(0 /* AVAILABLE */);
	        }
	    };
	    BrowserConnectivityMonitor.prototype.onNetworkUnavailable = function () {
	        debug(LOG_TAG$c, 'Network connectivity changed: UNAVAILABLE');
	        for (var _i = 0, _a = this.callbacks; _i < _a.length; _i++) {
	            var callback = _a[_i];
	            callback(1 /* UNAVAILABLE */);
	        }
	    };
	    // TODO(chenbrian): Consider passing in window either into this component or
	    // here for testing via FakeWindow.
	    /** Checks that all used attributes of window are available. */
	    BrowserConnectivityMonitor.isAvailable = function () {
	        return (typeof window !== 'undefined' &&
	            window.addEventListener !== undefined &&
	            window.removeEventListener !== undefined);
	    };
	    return BrowserConnectivityMonitor;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides a simple helper class that implements the Stream interface to
	 * bridge to other implementations that are streams but do not implement the
	 * interface. The stream callbacks are invoked with the callOn... methods.
	 */
	var StreamBridge = /** @class */ (function () {
	    function StreamBridge(args) {
	        this.sendFn = args.sendFn;
	        this.closeFn = args.closeFn;
	    }
	    StreamBridge.prototype.onOpen = function (callback) {
	        assert(!this.wrappedOnOpen, 'Called onOpen on stream twice!');
	        this.wrappedOnOpen = callback;
	    };
	    StreamBridge.prototype.onClose = function (callback) {
	        assert(!this.wrappedOnClose, 'Called onClose on stream twice!');
	        this.wrappedOnClose = callback;
	    };
	    StreamBridge.prototype.onMessage = function (callback) {
	        assert(!this.wrappedOnMessage, 'Called onMessage on stream twice!');
	        this.wrappedOnMessage = callback;
	    };
	    StreamBridge.prototype.close = function () {
	        this.closeFn();
	    };
	    StreamBridge.prototype.send = function (msg) {
	        this.sendFn(msg);
	    };
	    StreamBridge.prototype.callOnOpen = function () {
	        assert(this.wrappedOnOpen !== undefined, 'Cannot call onOpen because no callback was set');
	        this.wrappedOnOpen();
	    };
	    StreamBridge.prototype.callOnClose = function (err) {
	        assert(this.wrappedOnClose !== undefined, 'Cannot call onClose because no callback was set');
	        this.wrappedOnClose(err);
	    };
	    StreamBridge.prototype.callOnMessage = function (msg) {
	        assert(this.wrappedOnMessage !== undefined, 'Cannot call onMessage because no callback was set');
	        this.wrappedOnMessage(msg);
	    };
	    return StreamBridge;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_TAG$d = 'Connection';
	var RPC_STREAM_SERVICE = 'google.firestore.v1.Firestore';
	var RPC_URL_VERSION = 'v1';
	/**
	 * Maps RPC names to the corresponding REST endpoint name.
	 * Uses Object Literal notation to avoid renaming.
	 */
	var RPC_NAME_REST_MAPPING = {};
	RPC_NAME_REST_MAPPING['BatchGetDocuments'] = 'batchGet';
	RPC_NAME_REST_MAPPING['Commit'] = 'commit';
	// TODO(b/38203344): The SDK_VERSION is set independently from Firebase because
	// we are doing out-of-band releases. Once we release as part of Firebase, we
	// should use the Firebase version instead.
	var X_GOOG_API_CLIENT_VALUE = 'gl-js/ fire/' + SDK_VERSION;
	var XHR_TIMEOUT_SECS = 15;
	var WebChannelConnection = /** @class */ (function () {
	    function WebChannelConnection(info) {
	        this.databaseId = info.databaseId;
	        var proto = info.ssl ? 'https' : 'http';
	        this.baseUrl = proto + '://' + info.host;
	        this.forceLongPolling = info.forceLongPolling;
	    }
	    /**
	     * Modifies the headers for a request, adding any authorization token if
	     * present and any additional headers for the request.
	     */
	    WebChannelConnection.prototype.modifyHeadersForRequest = function (headers, token) {
	        if (token) {
	            for (var header in token.authHeaders) {
	                if (token.authHeaders.hasOwnProperty(header)) {
	                    headers[header] = token.authHeaders[header];
	                }
	            }
	        }
	        headers['X-Goog-Api-Client'] = X_GOOG_API_CLIENT_VALUE;
	    };
	    WebChannelConnection.prototype.invokeRPC = function (rpcName, request, token) {
	        var _this = this;
	        var url = this.makeUrl(rpcName);
	        return new Promise(function (resolve, reject) {
	            var xhr = new webchannelWrapper.XhrIo();
	            xhr.listenOnce(webchannelWrapper.EventType.COMPLETE, function () {
	                try {
	                    switch (xhr.getLastErrorCode()) {
	                        case webchannelWrapper.ErrorCode.NO_ERROR:
	                            var json = xhr.getResponseJson();
	                            debug(LOG_TAG$d, 'XHR received:', JSON.stringify(json));
	                            resolve(json);
	                            break;
	                        case webchannelWrapper.ErrorCode.TIMEOUT:
	                            debug(LOG_TAG$d, 'RPC "' + rpcName + '" timed out');
	                            reject(new FirestoreError(Code.DEADLINE_EXCEEDED, 'Request time out'));
	                            break;
	                        case webchannelWrapper.ErrorCode.HTTP_ERROR:
	                            var status_1 = xhr.getStatus();
	                            debug(LOG_TAG$d, 'RPC "' + rpcName + '" failed with status:', status_1, 'response text:', xhr.getResponseText());
	                            if (status_1 > 0) {
	                                var responseError = xhr.getResponseJson()
	                                    .error;
	                                if (!!responseError &&
	                                    !!responseError.status &&
	                                    !!responseError.message) {
	                                    var firestoreErrorCode = mapCodeFromHttpResponseErrorStatus(responseError.status);
	                                    reject(new FirestoreError(firestoreErrorCode, responseError.message));
	                                }
	                                else {
	                                    reject(new FirestoreError(Code.UNKNOWN, 'Server responded with status ' + xhr.getStatus()));
	                                }
	                            }
	                            else {
	                                // If we received an HTTP_ERROR but there's no status code,
	                                // it's most probably a connection issue
	                                debug(LOG_TAG$d, 'RPC "' + rpcName + '" failed');
	                                reject(new FirestoreError(Code.UNAVAILABLE, 'Connection failed.'));
	                            }
	                            break;
	                        default:
	                            fail('RPC "' +
	                                rpcName +
	                                '" failed with unanticipated ' +
	                                'webchannel error ' +
	                                xhr.getLastErrorCode() +
	                                ': ' +
	                                xhr.getLastError() +
	                                ', giving up.');
	                    }
	                }
	                finally {
	                    debug(LOG_TAG$d, 'RPC "' + rpcName + '" completed.');
	                }
	            });
	            // The database field is already encoded in URL. Specifying it again in
	            // the body is not necessary in production, and will cause duplicate field
	            // errors in the Firestore Emulator. Let's remove it.
	            var jsonObj = tslib.__assign({}, request);
	            delete jsonObj.database;
	            var requestString = JSON.stringify(jsonObj);
	            debug(LOG_TAG$d, 'XHR sending: ', url + ' ' + requestString);
	            // Content-Type: text/plain will avoid preflight requests which might
	            // mess with CORS and redirects by proxies. If we add custom headers
	            // we will need to change this code to potentially use the
	            // $httpOverwrite parameter supported by ESF to avoid
	            // triggering preflight requests.
	            var headers = { 'Content-Type': 'text/plain' };
	            _this.modifyHeadersForRequest(headers, token);
	            xhr.send(url, 'POST', requestString, headers, XHR_TIMEOUT_SECS);
	        });
	    };
	    WebChannelConnection.prototype.invokeStreamingRPC = function (rpcName, request, token) {
	        // The REST API automatically aggregates all of the streamed results, so we
	        // can just use the normal invoke() method.
	        return this.invokeRPC(rpcName, request, token);
	    };
	    WebChannelConnection.prototype.openStream = function (rpcName, token) {
	        var urlParts = [
	            this.baseUrl,
	            '/',
	            RPC_STREAM_SERVICE,
	            '/',
	            rpcName,
	            '/channel'
	        ];
	        var webchannelTransport = webchannelWrapper.createWebChannelTransport();
	        var request = {
	            // Background channel test avoids the initial two test calls and decreases
	            // initial cold start time.
	            // TODO(dimond): wenboz@ mentioned this might affect use with proxies and
	            // we should monitor closely for any reports.
	            backgroundChannelTest: true,
	            // Required for backend stickiness, routing behavior is based on this
	            // parameter.
	            httpSessionIdParam: 'gsessionid',
	            initMessageHeaders: {},
	            messageUrlParams: {
	                // This param is used to improve routing and project isolation by the
	                // backend and must be included in every request.
	                database: "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database
	            },
	            sendRawJson: true,
	            supportsCrossDomainXhr: true,
	            internalChannelParams: {
	                // Override the default timeout (randomized between 10-20 seconds) since
	                // a large write batch on a slow internet connection may take a long
	                // time to send to the backend. Rather than have WebChannel impose a
	                // tight timeout which could lead to infinite timeouts and retries, we
	                // set it very large (5-10 minutes) and rely on the browser's builtin
	                // timeouts to kick in if the request isn't working.
	                forwardChannelRequestTimeoutMs: 10 * 60 * 1000
	            },
	            forceLongPolling: this.forceLongPolling
	        };
	        this.modifyHeadersForRequest(request.initMessageHeaders, token);
	        // Sending the custom headers we just added to request.initMessageHeaders
	        // (Authorization, etc.) will trigger the browser to make a CORS preflight
	        // request because the XHR will no longer meet the criteria for a "simple"
	        // CORS request:
	        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
	        //
	        // Therefore to avoid the CORS preflight request (an extra network
	        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
	        // the headers should instead be encoded into a special "$httpHeaders" query
	        // parameter, which is recognized by the webchannel backend. This is
	        // formally defined here:
	        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
	        //
	        // TODO(b/145624756): There is a backend bug where $httpHeaders isn't respected if the request
	        // doesn't have an Origin header. So we have to exclude a few browser environments that are
	        // known to (sometimes) not include an Origin. See
	        // https://github.com/firebase/firebase-js-sdk/issues/1491.
	        if (!util.isReactNative() &&
	            !util.isElectron() &&
	            !util.isIE() &&
	            !util.isUWP() &&
	            !util.isBrowserExtension()) {
	            request.httpHeadersOverwriteParam = '$httpHeaders';
	        }
	        var url = urlParts.join('');
	        debug(LOG_TAG$d, 'Creating WebChannel: ' + url + ' ' + request);
	        var channel = webchannelTransport.createWebChannel(url, request);
	        // WebChannel supports sending the first message with the handshake - saving
	        // a network round trip. However, it will have to call send in the same
	        // JS event loop as open. In order to enforce this, we delay actually
	        // opening the WebChannel until send is called. Whether we have called
	        // open is tracked with this variable.
	        var opened = false;
	        // A flag to determine whether the stream was closed (by us or through an
	        // error/close event) to avoid delivering multiple close events or sending
	        // on a closed stream
	        var closed = false;
	        var streamBridge = new StreamBridge({
	            sendFn: function (msg) {
	                if (!closed) {
	                    if (!opened) {
	                        debug(LOG_TAG$d, 'Opening WebChannel transport.');
	                        channel.open();
	                        opened = true;
	                    }
	                    debug(LOG_TAG$d, 'WebChannel sending:', msg);
	                    channel.send(msg);
	                }
	                else {
	                    debug(LOG_TAG$d, 'Not sending because WebChannel is closed:', msg);
	                }
	            },
	            closeFn: function () { return channel.close(); }
	        });
	        // Closure events are guarded and exceptions are swallowed, so catch any
	        // exception and rethrow using a setTimeout so they become visible again.
	        // Note that eventually this function could go away if we are confident
	        // enough the code is exception free.
	        var unguardedEventListen = function (type, fn) {
	            // TODO(dimond): closure typing seems broken because WebChannel does
	            // not implement goog.events.Listenable
	            channel.listen(type, function (param) {
	                try {
	                    fn(param);
	                }
	                catch (e) {
	                    setTimeout(function () {
	                        throw e;
	                    }, 0);
	                }
	            });
	        };
	        unguardedEventListen(webchannelWrapper.WebChannel.EventType.OPEN, function () {
	            if (!closed) {
	                debug(LOG_TAG$d, 'WebChannel transport opened.');
	            }
	        });
	        unguardedEventListen(webchannelWrapper.WebChannel.EventType.CLOSE, function () {
	            if (!closed) {
	                closed = true;
	                debug(LOG_TAG$d, 'WebChannel transport closed');
	                streamBridge.callOnClose();
	            }
	        });
	        unguardedEventListen(webchannelWrapper.WebChannel.EventType.ERROR, function (err) {
	            if (!closed) {
	                closed = true;
	                debug(LOG_TAG$d, 'WebChannel transport errored:', err);
	                streamBridge.callOnClose(new FirestoreError(Code.UNAVAILABLE, 'The operation could not be completed'));
	            }
	        });
	        unguardedEventListen(webchannelWrapper.WebChannel.EventType.MESSAGE, function (msg) {
	            var _a;
	            if (!closed) {
	                var msgData = msg.data[0];
	                assert(!!msgData, 'Got a webchannel message without data.');
	                // TODO(b/35143891): There is a bug in One Platform that caused errors
	                // (and only errors) to be wrapped in an extra array. To be forward
	                // compatible with the bug we need to check either condition. The latter
	                // can be removed once the fix has been rolled out.
	                // Use any because msgData.error is not typed.
	                var msgDataOrError = msgData;
	                var error = msgDataOrError.error || ((_a = msgDataOrError[0]) === null || _a === void 0 ? void 0 : _a.error);
	                if (error) {
	                    debug(LOG_TAG$d, 'WebChannel received error:', error);
	                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
	                    var status_2 = error.status;
	                    var code = mapCodeFromRpcStatus(status_2);
	                    var message = error.message;
	                    if (code === undefined) {
	                        code = Code.INTERNAL;
	                        message =
	                            'Unknown error status: ' +
	                                status_2 +
	                                ' with message ' +
	                                error.message;
	                    }
	                    // Mark closed so no further events are propagated
	                    closed = true;
	                    streamBridge.callOnClose(new FirestoreError(code, message));
	                    channel.close();
	                }
	                else {
	                    debug(LOG_TAG$d, 'WebChannel received:', msgData);
	                    streamBridge.callOnMessage(msgData);
	                }
	            }
	        });
	        setTimeout(function () {
	            // Technically we could/should wait for the WebChannel opened event,
	            // but because we want to send the first message with the WebChannel
	            // handshake we pretend the channel opened here (asynchronously), and
	            // then delay the actual open until the first message is sent.
	            streamBridge.callOnOpen();
	        }, 0);
	        return streamBridge;
	    };
	    // visible for testing
	    WebChannelConnection.prototype.makeUrl = function (rpcName) {
	        var urlRpcName = RPC_NAME_REST_MAPPING[rpcName];
	        assert(urlRpcName !== undefined, 'Unknown REST mapping for: ' + rpcName);
	        return (this.baseUrl +
	            '/' +
	            RPC_URL_VERSION +
	            '/projects/' +
	            this.databaseId.projectId +
	            '/databases/' +
	            this.databaseId.database +
	            '/documents:' +
	            urlRpcName);
	    };
	    return WebChannelConnection;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var BrowserPlatform = /** @class */ (function () {
	    function BrowserPlatform() {
	        this.emptyByteString = '';
	        this.base64Available = typeof atob !== 'undefined';
	    }
	    Object.defineProperty(BrowserPlatform.prototype, "document", {
	        get: function () {
	            return typeof document !== 'undefined' ? document : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BrowserPlatform.prototype, "window", {
	        get: function () {
	            return typeof window !== 'undefined' ? window : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BrowserPlatform.prototype.loadConnection = function (databaseInfo) {
	        return Promise.resolve(new WebChannelConnection(databaseInfo));
	    };
	    BrowserPlatform.prototype.newConnectivityMonitor = function () {
	        if (BrowserConnectivityMonitor.isAvailable()) {
	            return new BrowserConnectivityMonitor();
	        }
	        else {
	            return new NoopConnectivityMonitor();
	        }
	    };
	    BrowserPlatform.prototype.newSerializer = function (databaseId) {
	        return new JsonProtoSerializer(databaseId, { useProto3Json: true });
	    };
	    BrowserPlatform.prototype.formatJSON = function (value) {
	        return JSON.stringify(value);
	    };
	    BrowserPlatform.prototype.atob = function (encoded) {
	        return atob(encoded);
	    };
	    BrowserPlatform.prototype.btoa = function (raw) {
	        return btoa(raw);
	    };
	    return BrowserPlatform;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This code needs to run before Firestore is used. This can be achieved in
	 * several ways:
	 *   1) Through the JSCompiler compiling this code and then (automatically)
	 *      executing it before exporting the Firestore symbols.
	 *   2) Through importing this module first in a Firestore main module
	 */
	PlatformSupport.setPlatform(new BrowserPlatform());
	
	var name = "@firebase/firestore";
	var version = "1.10.2";
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerFirestore(instance) {
	    configureForFirebase(instance);
	    instance.registerVersion(name, version);
	}
	registerFirestore(firebase);
	
	exports.registerFirestore = registerFirestore;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	var tslib = __webpack_require__(11);
	var component = __webpack_require__(12);
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Standard error codes for different ways a request can fail, as defined by:
	 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
	 *
	 * This map is used primarily to convert from a backend error code string to
	 * a client SDK error code string, and make sure it's in the supported set.
	 */
	var errorCodeMap = {
	    OK: 'ok',
	    CANCELLED: 'cancelled',
	    UNKNOWN: 'unknown',
	    INVALID_ARGUMENT: 'invalid-argument',
	    DEADLINE_EXCEEDED: 'deadline-exceeded',
	    NOT_FOUND: 'not-found',
	    ALREADY_EXISTS: 'already-exists',
	    PERMISSION_DENIED: 'permission-denied',
	    UNAUTHENTICATED: 'unauthenticated',
	    RESOURCE_EXHAUSTED: 'resource-exhausted',
	    FAILED_PRECONDITION: 'failed-precondition',
	    ABORTED: 'aborted',
	    OUT_OF_RANGE: 'out-of-range',
	    UNIMPLEMENTED: 'unimplemented',
	    INTERNAL: 'internal',
	    UNAVAILABLE: 'unavailable',
	    DATA_LOSS: 'data-loss'
	};
	/**
	 * An explicit error that can be thrown from a handler to send an error to the
	 * client that called the function.
	 */
	var HttpsErrorImpl = /** @class */ (function (_super) {
	    tslib.__extends(HttpsErrorImpl, _super);
	    function HttpsErrorImpl(code, message, details) {
	        var _this = _super.call(this, message) || this;
	        // This is a workaround for a bug in TypeScript when extending Error:
	        // tslint:disable-next-line
	        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
	        Object.setPrototypeOf(_this, HttpsErrorImpl.prototype);
	        _this.code = code;
	        _this.details = details;
	        return _this;
	    }
	    return HttpsErrorImpl;
	}(Error));
	/**
	 * Takes an HTTP status code and returns the corresponding ErrorCode.
	 * This is the standard HTTP status code -> error mapping defined in:
	 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
	 *
	 * @param status An HTTP status code.
	 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
	 */
	function codeForHTTPStatus(status) {
	    // Make sure any successful status is OK.
	    if (status >= 200 && status < 300) {
	        return 'ok';
	    }
	    switch (status) {
	        case 0:
	            // This can happen if the server returns 500.
	            return 'internal';
	        case 400:
	            return 'invalid-argument';
	        case 401:
	            return 'unauthenticated';
	        case 403:
	            return 'permission-denied';
	        case 404:
	            return 'not-found';
	        case 409:
	            return 'aborted';
	        case 429:
	            return 'resource-exhausted';
	        case 499:
	            return 'cancelled';
	        case 500:
	            return 'internal';
	        case 501:
	            return 'unimplemented';
	        case 503:
	            return 'unavailable';
	        case 504:
	            return 'deadline-exceeded';
	    }
	    return 'unknown';
	}
	/**
	 * Takes an HTTP response and returns the corresponding Error, if any.
	 */
	function _errorForResponse(status, bodyJSON, serializer) {
	    var code = codeForHTTPStatus(status);
	    // Start with reasonable defaults from the status code.
	    var description = code;
	    var details = undefined;
	    // Then look through the body for explicit details.
	    try {
	        var errorJSON = bodyJSON && bodyJSON.error;
	        if (errorJSON) {
	            var status_1 = errorJSON.status;
	            if (typeof status_1 === 'string') {
	                if (!errorCodeMap[status_1]) {
	                    // They must've included an unknown error code in the body.
	                    return new HttpsErrorImpl('internal', 'internal');
	                }
	                code = errorCodeMap[status_1];
	                // TODO(klimt): Add better default descriptions for error enums.
	                // The default description needs to be updated for the new code.
	                description = status_1;
	            }
	            var message = errorJSON.message;
	            if (typeof message === 'string') {
	                description = message;
	            }
	            details = errorJSON.details;
	            if (details !== undefined) {
	                details = serializer.decode(details);
	            }
	        }
	    }
	    catch (e) {
	        // If we couldn't parse explicit error data, that's fine.
	    }
	    if (code === 'ok') {
	        // Technically, there's an edge case where a developer could explicitly
	        // return an error code of OK, and we will treat it as success, but that
	        // seems reasonable.
	        return null;
	    }
	    return new HttpsErrorImpl(code, description, details);
	}
	
	/**
	 * Helper class to get metadata that should be included with a function call.
	 */
	var ContextProvider = /** @class */ (function () {
	    function ContextProvider(authProvider, messagingProvider) {
	        var _this = this;
	        this.auth = null;
	        this.messaging = null;
	        this.auth = authProvider.getImmediate({ optional: true });
	        this.messaging = messagingProvider.getImmediate({
	            optional: true
	        });
	        if (!this.auth) {
	            authProvider.get().then(function (auth) { return (_this.auth = auth); }, function () {
	                /* get() never rejects */
	            });
	        }
	        if (!this.messaging) {
	            messagingProvider.get().then(function (messaging) { return (_this.messaging = messaging); }, function () {
	                /* get() never rejects */
	            });
	        }
	    }
	    ContextProvider.prototype.getAuthToken = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var token, e_1;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.auth) {
	                            return [2 /*return*/, undefined];
	                        }
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, this.auth.getToken()];
	                    case 2:
	                        token = _a.sent();
	                        if (!token) {
	                            return [2 /*return*/, undefined];
	                        }
	                        return [2 /*return*/, token.accessToken];
	                    case 3:
	                        e_1 = _a.sent();
	                        // If there's any error when trying to get the auth token, leave it off.
	                        return [2 /*return*/, undefined];
	                    case 4: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    ContextProvider.prototype.getInstanceIdToken = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                if (!this.messaging ||
	                    !('Notification' in self) ||
	                    Notification.permission !== 'granted') {
	                    return [2 /*return*/, undefined];
	                }
	                try {
	                    return [2 /*return*/, this.messaging.getToken()];
	                }
	                catch (e) {
	                    // We don't warn on this, because it usually means messaging isn't set up.
	                    // console.warn('Failed to retrieve instance id token.', e);
	                    // If there's any error when trying to get the token, leave it off.
	                    return [2 /*return*/, undefined];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    ContextProvider.prototype.getContext = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var authToken, instanceIdToken;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.getAuthToken()];
	                    case 1:
	                        authToken = _a.sent();
	                        return [4 /*yield*/, this.getInstanceIdToken()];
	                    case 2:
	                        instanceIdToken = _a.sent();
	                        return [2 /*return*/, { authToken: authToken, instanceIdToken: instanceIdToken }];
	                }
	            });
	        });
	    };
	    return ContextProvider;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
	var UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';
	function mapValues(
	// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	o, f) {
	    var result = {};
	    for (var key in o) {
	        if (o.hasOwnProperty(key)) {
	            result[key] = f(o[key]);
	        }
	    }
	    return result;
	}
	var Serializer = /** @class */ (function () {
	    function Serializer() {
	    }
	    // Takes data and encodes it in a JSON-friendly way, such that types such as
	    // Date are preserved.
	    Serializer.prototype.encode = function (data) {
	        var _this = this;
	        if (data == null) {
	            return null;
	        }
	        if (data instanceof Number) {
	            data = data.valueOf();
	        }
	        if (typeof data === 'number' && isFinite(data)) {
	            // Any number in JS is safe to put directly in JSON and parse as a double
	            // without any loss of precision.
	            return data;
	        }
	        if (data === true || data === false) {
	            return data;
	        }
	        if (Object.prototype.toString.call(data) === '[object String]') {
	            return data;
	        }
	        if (Array.isArray(data)) {
	            return data.map(function (x) { return _this.encode(x); });
	        }
	        if (typeof data === 'function' || typeof data === 'object') {
	            return mapValues(data, function (x) { return _this.encode(x); });
	        }
	        // If we got this far, the data is not encodable.
	        throw new Error('Data cannot be encoded in JSON: ' + data);
	    };
	    // Takes data that's been encoded in a JSON-friendly form and returns a form
	    // with richer datatypes, such as Dates, etc.
	    Serializer.prototype.decode = function (json) {
	        var _this = this;
	        if (json == null) {
	            return json;
	        }
	        if (json['@type']) {
	            switch (json['@type']) {
	                case LONG_TYPE:
	                // Fall through and handle this the same as unsigned.
	                case UNSIGNED_LONG_TYPE: {
	                    // Technically, this could work return a valid number for malformed
	                    // data if there was a number followed by garbage. But it's just not
	                    // worth all the extra code to detect that case.
	                    var value = Number(json['value']);
	                    if (isNaN(value)) {
	                        throw new Error('Data cannot be decoded from JSON: ' + json);
	                    }
	                    return value;
	                }
	                default: {
	                    throw new Error('Data cannot be decoded from JSON: ' + json);
	                }
	            }
	        }
	        if (Array.isArray(json)) {
	            return json.map(function (x) { return _this.decode(x); });
	        }
	        if (typeof json === 'function' || typeof json === 'object') {
	            return mapValues(json, function (x) { return _this.decode(x); });
	        }
	        // Anything else is safe to return.
	        return json;
	    };
	    return Serializer;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a Promise that will be rejected after the given duration.
	 * The error will be of type HttpsErrorImpl.
	 *
	 * @param millis Number of milliseconds to wait before rejecting.
	 */
	function failAfter(millis) {
	    return new Promise(function (_, reject) {
	        setTimeout(function () {
	            reject(new HttpsErrorImpl('deadline-exceeded', 'deadline-exceeded'));
	        }, millis);
	    });
	}
	/**
	 * The main class for the Firebase Functions SDK.
	 */
	var Service = /** @class */ (function () {
	    /**
	     * Creates a new Functions service for the given app and (optional) region.
	     * @param app_ The FirebaseApp to use.
	     * @param region_ The region to call functions in.
	     */
	    function Service(app_, authProvider, messagingProvider, region_) {
	        var _this = this;
	        if (region_ === void 0) { region_ = 'us-central1'; }
	        this.app_ = app_;
	        this.region_ = region_;
	        this.serializer = new Serializer();
	        this.emulatorOrigin = null;
	        this.INTERNAL = {
	            delete: function () {
	                return _this.deleteService();
	            }
	        };
	        this.contextProvider = new ContextProvider(authProvider, messagingProvider);
	        // Cancels all ongoing requests when resolved.
	        this.cancelAllRequests = new Promise(function (resolve) {
	            _this.deleteService = function () {
	                return resolve();
	            };
	        });
	    }
	    Object.defineProperty(Service.prototype, "app", {
	        get: function () {
	            return this.app_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the URL for a callable with the given name.
	     * @param name The name of the callable.
	     */
	    Service.prototype._url = function (name) {
	        var projectId = this.app_.options.projectId;
	        var region = this.region_;
	        if (this.emulatorOrigin !== null) {
	            var origin_1 = this.emulatorOrigin;
	            return origin_1 + "/" + projectId + "/" + region + "/" + name;
	        }
	        return "https://" + region + "-" + projectId + ".cloudfunctions.net/" + name;
	    };
	    /**
	     * Changes this instance to point to a Cloud Functions emulator running
	     * locally. See https://firebase.google.com/docs/functions/local-emulator
	     *
	     * @param origin The origin of the local emulator, such as
	     * "http://localhost:5005".
	     */
	    Service.prototype.useFunctionsEmulator = function (origin) {
	        this.emulatorOrigin = origin;
	    };
	    /**
	     * Returns a reference to the callable https trigger with the given name.
	     * @param name The name of the trigger.
	     */
	    Service.prototype.httpsCallable = function (name, options) {
	        var _this = this;
	        return function (data) {
	            return _this.call(name, data, options || {});
	        };
	    };
	    /**
	     * Does an HTTP POST and returns the completed response.
	     * @param url The url to post to.
	     * @param body The JSON body of the post.
	     * @param headers The HTTP headers to include in the request.
	     * @return A Promise that will succeed when the request finishes.
	     */
	    Service.prototype.postJSON = function (url, body, headers) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var response, e_1, json, e_2;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        headers.append('Content-Type', 'application/json');
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, fetch(url, {
	                                method: 'POST',
	                                body: JSON.stringify(body),
	                                headers: headers
	                            })];
	                    case 2:
	                        response = _a.sent();
	                        return [3 /*break*/, 4];
	                    case 3:
	                        e_1 = _a.sent();
	                        // This could be an unhandled error on the backend, or it could be a
	                        // network error. There's no way to know, since an unhandled error on the
	                        // backend will fail to set the proper CORS header, and thus will be
	                        // treated as a network error by fetch.
	                        return [2 /*return*/, {
	                                status: 0,
	                                json: null
	                            }];
	                    case 4:
	                        json = null;
	                        _a.label = 5;
	                    case 5:
	                        _a.trys.push([5, 7, , 8]);
	                        return [4 /*yield*/, response.json()];
	                    case 6:
	                        json = _a.sent();
	                        return [3 /*break*/, 8];
	                    case 7:
	                        e_2 = _a.sent();
	                        return [3 /*break*/, 8];
	                    case 8: return [2 /*return*/, {
	                            status: response.status,
	                            json: json
	                        }];
	                }
	            });
	        });
	    };
	    /**
	     * Calls a callable function asynchronously and returns the result.
	     * @param name The name of the callable trigger.
	     * @param data The data to pass as params to the function.s
	     */
	    Service.prototype.call = function (name, data, options) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var url, body, headers, context, timeout, response, error, responseData, decodedData;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        url = this._url(name);
	                        // Encode any special types, such as dates, in the input data.
	                        data = this.serializer.encode(data);
	                        body = { data: data };
	                        headers = new Headers();
	                        return [4 /*yield*/, this.contextProvider.getContext()];
	                    case 1:
	                        context = _a.sent();
	                        if (context.authToken) {
	                            headers.append('Authorization', 'Bearer ' + context.authToken);
	                        }
	                        if (context.instanceIdToken) {
	                            headers.append('Firebase-Instance-ID-Token', context.instanceIdToken);
	                        }
	                        timeout = options.timeout || 70000;
	                        return [4 /*yield*/, Promise.race([
	                                this.postJSON(url, body, headers),
	                                failAfter(timeout),
	                                this.cancelAllRequests
	                            ])];
	                    case 2:
	                        response = _a.sent();
	                        // If service was deleted, interrupted response throws an error.
	                        if (!response) {
	                            throw new HttpsErrorImpl('cancelled', 'Firebase Functions instance was deleted.');
	                        }
	                        error = _errorForResponse(response.status, response.json, this.serializer);
	                        if (error) {
	                            throw error;
	                        }
	                        if (!response.json) {
	                            throw new HttpsErrorImpl('internal', 'Response is not valid JSON object.');
	                        }
	                        responseData = response.json.data;
	                        // TODO(klimt): For right now, allow "result" instead of "data", for
	                        // backwards compatibility.
	                        if (typeof responseData === 'undefined') {
	                            responseData = response.json.result;
	                        }
	                        if (typeof responseData === 'undefined') {
	                            // Consider the response malformed.
	                            throw new HttpsErrorImpl('internal', 'Response is missing data field.');
	                        }
	                        decodedData = this.serializer.decode(responseData);
	                        return [2 /*return*/, { data: decodedData }];
	                }
	            });
	        });
	    };
	    return Service;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Type constant for Firebase Functions.
	 */
	var FUNCTIONS_TYPE = 'functions';
	function factory(container, region) {
	    // Dependencies
	    var app = container.getProvider('app').getImmediate();
	    var authProvider = container.getProvider('auth-internal');
	    var messagingProvider = container.getProvider('messaging');
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return new Service(app, authProvider, messagingProvider, region);
	}
	function registerFunctions(instance) {
	    var namespaceExports = {
	        // no-inline
	        Functions: Service
	    };
	    instance.INTERNAL.registerComponent(new component.Component(FUNCTIONS_TYPE, factory, "PUBLIC" /* PUBLIC */)
	        .setServiceProps(namespaceExports)
	        .setMultipleInstances(true));
	}
	
	var name = "@firebase/functions";
	var version = "0.4.32";
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	registerFunctions(firebase);
	firebase.registerVersion(name, version);
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	__webpack_require__(28);
	var component = __webpack_require__(12);
	var tslib = __webpack_require__(11);
	var util = __webpack_require__(14);
	var idb = __webpack_require__(76);
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERROR_MAP = (_a = {},
	    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration value: "{$valueName}"',
	    _a["only-available-in-window" /* AVAILABLE_IN_WINDOW */] = 'This method is available in a Window context.',
	    _a["only-available-in-sw" /* AVAILABLE_IN_SW */] = 'This method is available in a service worker context.',
	    _a["permission-default" /* PERMISSION_DEFAULT */] = 'The notification permission was not granted and dismissed instead.',
	    _a["permission-blocked" /* PERMISSION_BLOCKED */] = 'The notification permission was not granted and blocked instead.',
	    _a["unsupported-browser" /* UNSUPPORTED_BROWSER */] = "This browser doesn't support the API's required to use the firebase SDK.",
	    _a["failed-service-worker-registration" /* FAILED_DEFAULT_REGISTRATION */] = 'We are unable to register the default service worker. {$browserErrorMessage}',
	    _a["token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */] = 'A problem occured while subscribing the user to FCM: {$errorInfo}',
	    _a["token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */] = 'FCM returned no token when subscribing the user to push.',
	    _a["token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */] = 'A problem occured while unsubscribing the ' +
	        'user from FCM: {$errorInfo}',
	    _a["token-update-failed" /* TOKEN_UPDATE_FAILED */] = 'A problem occured while updating the user from FCM: {$errorInfo}',
	    _a["token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */] = 'FCM returned no token when updating the user to push.',
	    _a["use-sw-after-get-token" /* USE_SW_AFTER_GET_TOKEN */] = 'The useServiceWorker() method may only be called once and must be ' +
	        'called before calling getToken() to ensure your service worker is used.',
	    _a["invalid-sw-registration" /* INVALID_SW_REGISTRATION */] = 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
	    _a["invalid-bg-handler" /* INVALID_BG_HANDLER */] = 'The input to setBackgroundMessageHandler() must be a function.',
	    _a["invalid-vapid-key" /* INVALID_VAPID_KEY */] = 'The public VAPID key must be a string.',
	    _a["use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */] = 'The usePublicVapidKey() method may only be called once and must be ' +
	        'called before calling getToken() to ensure your VAPID key is used.',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory('messaging', 'Messaging', ERROR_MAP);
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function extractAppConfig(app) {
	    var e_1, _a;
	    if (!app || !app.options) {
	        throw getMissingValueError('App Configuration Object');
	    }
	    if (!app.name) {
	        throw getMissingValueError('App Name');
	    }
	    // Required app config keys
	    var configKeys = [
	        'projectId',
	        'apiKey',
	        'appId',
	        'messagingSenderId'
	    ];
	    var options = app.options;
	    try {
	        for (var configKeys_1 = tslib.__values(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
	            var keyName = configKeys_1_1.value;
	            if (!options[keyName]) {
	                throw getMissingValueError(keyName);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	    return {
	        appName: app.name,
	        projectId: options.projectId,
	        apiKey: options.apiKey,
	        appId: options.appId,
	        senderId: options.messagingSenderId
	    };
	}
	function getMissingValueError(valueName) {
	    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
	        valueName: valueName
	    });
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function arrayToBase64(array) {
	    var uint8Array = new Uint8Array(array);
	    var base64String = btoa(String.fromCharCode.apply(String, tslib.__spread(uint8Array)));
	    return base64String
	        .replace(/=/g, '')
	        .replace(/\+/g, '-')
	        .replace(/\//g, '_');
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var OLD_DB_NAME = 'fcm_token_details_db';
	/**
	 * The last DB version of 'fcm_token_details_db' was 4. This is one higher,
	 * so that the upgrade callback is called for all versions of the old DB.
	 */
	var OLD_DB_VERSION = 5;
	var OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
	function migrateOldDatabase(senderId) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var databases, dbNames, tokenDetails, db;
	        var _this = this;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    if (!('databases' in indexedDB)) return [3 /*break*/, 2];
	                    return [4 /*yield*/, indexedDB.databases()];
	                case 1:
	                    databases = _a.sent();
	                    dbNames = databases.map(function (db) { return db.name; });
	                    if (!dbNames.includes(OLD_DB_NAME)) {
	                        // old DB didn't exist, no need to open.
	                        return [2 /*return*/, null];
	                    }
	                    _a.label = 2;
	                case 2:
	                    tokenDetails = null;
	                    return [4 /*yield*/, idb.openDb(OLD_DB_NAME, OLD_DB_VERSION, function (db) { return tslib.__awaiter(_this, void 0, void 0, function () {
	                            var objectStore, value, oldDetails, oldDetails, oldDetails;
	                            var _a;
	                            return tslib.__generator(this, function (_b) {
	                                switch (_b.label) {
	                                    case 0:
	                                        if (db.oldVersion < 2) {
	                                            // Database too old, skip migration.
	                                            return [2 /*return*/];
	                                        }
	                                        if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
	                                            // Database did not exist. Nothing to do.
	                                            return [2 /*return*/];
	                                        }
	                                        objectStore = db.transaction.objectStore(OLD_OBJECT_STORE_NAME);
	                                        return [4 /*yield*/, objectStore.index('fcmSenderId').get(senderId)];
	                                    case 1:
	                                        value = _b.sent();
	                                        return [4 /*yield*/, objectStore.clear()];
	                                    case 2:
	                                        _b.sent();
	                                        if (!value) {
	                                            // No entry in the database, nothing to migrate.
	                                            return [2 /*return*/];
	                                        }
	                                        if (db.oldVersion === 2) {
	                                            oldDetails = value;
	                                            if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) {
	                                                return [2 /*return*/];
	                                            }
	                                            tokenDetails = {
	                                                token: oldDetails.fcmToken,
	                                                createTime: (_a = oldDetails.createTime, (_a !== null && _a !== void 0 ? _a : Date.now())),
	                                                subscriptionOptions: {
	                                                    auth: oldDetails.auth,
	                                                    p256dh: oldDetails.p256dh,
	                                                    endpoint: oldDetails.endpoint,
	                                                    swScope: oldDetails.swScope,
	                                                    vapidKey: typeof oldDetails.vapidKey === 'string'
	                                                        ? oldDetails.vapidKey
	                                                        : arrayToBase64(oldDetails.vapidKey)
	                                                }
	                                            };
	                                        }
	                                        else if (db.oldVersion === 3) {
	                                            oldDetails = value;
	                                            tokenDetails = {
	                                                token: oldDetails.fcmToken,
	                                                createTime: oldDetails.createTime,
	                                                subscriptionOptions: {
	                                                    auth: arrayToBase64(oldDetails.auth),
	                                                    p256dh: arrayToBase64(oldDetails.p256dh),
	                                                    endpoint: oldDetails.endpoint,
	                                                    swScope: oldDetails.swScope,
	                                                    vapidKey: arrayToBase64(oldDetails.vapidKey)
	                                                }
	                                            };
	                                        }
	                                        else if (db.oldVersion === 4) {
	                                            oldDetails = value;
	                                            tokenDetails = {
	                                                token: oldDetails.fcmToken,
	                                                createTime: oldDetails.createTime,
	                                                subscriptionOptions: {
	                                                    auth: arrayToBase64(oldDetails.auth),
	                                                    p256dh: arrayToBase64(oldDetails.p256dh),
	                                                    endpoint: oldDetails.endpoint,
	                                                    swScope: oldDetails.swScope,
	                                                    vapidKey: arrayToBase64(oldDetails.vapidKey)
	                                                }
	                                            };
	                                        }
	                                        return [2 /*return*/];
	                                }
	                            });
	                        }); })];
	                case 3:
	                    db = _a.sent();
	                    db.close();
	                    // Delete all old databases.
	                    return [4 /*yield*/, idb.deleteDb(OLD_DB_NAME)];
	                case 4:
	                    // Delete all old databases.
	                    _a.sent();
	                    return [4 /*yield*/, idb.deleteDb('fcm_vapid_details_db')];
	                case 5:
	                    _a.sent();
	                    return [4 /*yield*/, idb.deleteDb('undefined')];
	                case 6:
	                    _a.sent();
	                    return [2 /*return*/, checkTokenDetails(tokenDetails) ? tokenDetails : null];
	            }
	        });
	    });
	}
	function checkTokenDetails(tokenDetails) {
	    if (!tokenDetails || !tokenDetails.subscriptionOptions) {
	        return false;
	    }
	    var subscriptionOptions = tokenDetails.subscriptionOptions;
	    return (typeof tokenDetails.createTime === 'number' &&
	        tokenDetails.createTime > 0 &&
	        typeof tokenDetails.token === 'string' &&
	        tokenDetails.token.length > 0 &&
	        typeof subscriptionOptions.auth === 'string' &&
	        subscriptionOptions.auth.length > 0 &&
	        typeof subscriptionOptions.p256dh === 'string' &&
	        subscriptionOptions.p256dh.length > 0 &&
	        typeof subscriptionOptions.endpoint === 'string' &&
	        subscriptionOptions.endpoint.length > 0 &&
	        typeof subscriptionOptions.swScope === 'string' &&
	        subscriptionOptions.swScope.length > 0 &&
	        typeof subscriptionOptions.vapidKey === 'string' &&
	        subscriptionOptions.vapidKey.length > 0);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Exported for tests.
	var DATABASE_NAME = 'firebase-messaging-database';
	var DATABASE_VERSION = 1;
	var OBJECT_STORE_NAME = 'firebase-messaging-store';
	var dbPromise = null;
	function getDbPromise() {
	    if (!dbPromise) {
	        dbPromise = idb.openDb(DATABASE_NAME, DATABASE_VERSION, function (upgradeDb) {
	            // We don't use 'break' in this switch statement, the fall-through
	            // behavior is what we want, because if there are multiple versions between
	            // the old version and the current version, we want ALL the migrations
	            // that correspond to those versions to run, not only the last one.
	            // eslint-disable-next-line default-case
	            switch (upgradeDb.oldVersion) {
	                case 0:
	                    upgradeDb.createObjectStore(OBJECT_STORE_NAME);
	            }
	        });
	    }
	    return dbPromise;
	}
	/** Gets record(s) from the objectStore that match the given key. */
	function dbGet(firebaseDependencies) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tokenDetails, oldTokenDetails;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(firebaseDependencies);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    return [4 /*yield*/, db
	                            .transaction(OBJECT_STORE_NAME)
	                            .objectStore(OBJECT_STORE_NAME)
	                            .get(key)];
	                case 2:
	                    tokenDetails = _a.sent();
	                    if (!tokenDetails) return [3 /*break*/, 3];
	                    return [2 /*return*/, tokenDetails];
	                case 3: return [4 /*yield*/, migrateOldDatabase(firebaseDependencies.appConfig.senderId)];
	                case 4:
	                    oldTokenDetails = _a.sent();
	                    if (!oldTokenDetails) return [3 /*break*/, 6];
	                    return [4 /*yield*/, dbSet(firebaseDependencies, oldTokenDetails)];
	                case 5:
	                    _a.sent();
	                    return [2 /*return*/, oldTokenDetails];
	                case 6: return [2 /*return*/];
	            }
	        });
	    });
	}
	/** Assigns or overwrites the record for the given key with the given value. */
	function dbSet(firebaseDependencies, tokenDetails) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(firebaseDependencies);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).put(tokenDetails, key)];
	                case 2:
	                    _a.sent();
	                    return [4 /*yield*/, tx.complete];
	                case 3:
	                    _a.sent();
	                    return [2 /*return*/, tokenDetails];
	            }
	        });
	    });
	}
	/** Removes record(s) from the objectStore that match the given key. */
	function dbRemove(firebaseDependencies) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(firebaseDependencies);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
	                case 2:
	                    _a.sent();
	                    return [4 /*yield*/, tx.complete];
	                case 3:
	                    _a.sent();
	                    return [2 /*return*/];
	            }
	        });
	    });
	}
	function getKey(_a) {
	    var appConfig = _a.appConfig;
	    return appConfig.appId;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
	var DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
	var DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
	var ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
	/** Key of FCM Payload in Notification's data field. */
	var FCM_MSG = 'FCM_MSG';
	var CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
	var CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
	var CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
	/** Set to '1' if Analytics is enabled for the campaign */
	var CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function requestGetToken(firebaseDependencies, subscriptionOptions) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var headers, body, subscribeOptions, responseData, response, err_1, message;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
	                case 1:
	                    headers = _a.sent();
	                    body = getBody(subscriptionOptions);
	                    subscribeOptions = {
	                        method: 'POST',
	                        headers: headers,
	                        body: JSON.stringify(body)
	                    };
	                    _a.label = 2;
	                case 2:
	                    _a.trys.push([2, 5, , 6]);
	                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions)];
	                case 3:
	                    response = _a.sent();
	                    return [4 /*yield*/, response.json()];
	                case 4:
	                    responseData = _a.sent();
	                    return [3 /*break*/, 6];
	                case 5:
	                    err_1 = _a.sent();
	                    throw ERROR_FACTORY.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
	                        errorInfo: err_1
	                    });
	                case 6:
	                    if (responseData.error) {
	                        message = responseData.error.message;
	                        throw ERROR_FACTORY.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
	                            errorInfo: message
	                        });
	                    }
	                    if (!responseData.token) {
	                        throw ERROR_FACTORY.create("token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */);
	                    }
	                    return [2 /*return*/, responseData.token];
	            }
	        });
	    });
	}
	function requestUpdateToken(firebaseDependencies, tokenDetails) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var headers, body, updateOptions, responseData, response, err_2, message;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
	                case 1:
	                    headers = _a.sent();
	                    body = getBody(tokenDetails.subscriptionOptions);
	                    updateOptions = {
	                        method: 'PATCH',
	                        headers: headers,
	                        body: JSON.stringify(body)
	                    };
	                    _a.label = 2;
	                case 2:
	                    _a.trys.push([2, 5, , 6]);
	                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig) + "/" + tokenDetails.token, updateOptions)];
	                case 3:
	                    response = _a.sent();
	                    return [4 /*yield*/, response.json()];
	                case 4:
	                    responseData = _a.sent();
	                    return [3 /*break*/, 6];
	                case 5:
	                    err_2 = _a.sent();
	                    throw ERROR_FACTORY.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
	                        errorInfo: err_2
	                    });
	                case 6:
	                    if (responseData.error) {
	                        message = responseData.error.message;
	                        throw ERROR_FACTORY.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
	                            errorInfo: message
	                        });
	                    }
	                    if (!responseData.token) {
	                        throw ERROR_FACTORY.create("token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */);
	                    }
	                    return [2 /*return*/, responseData.token];
	            }
	        });
	    });
	}
	function requestDeleteToken(firebaseDependencies, token) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var headers, unsubscribeOptions, response, responseData, message, err_3;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
	                case 1:
	                    headers = _a.sent();
	                    unsubscribeOptions = {
	                        method: 'DELETE',
	                        headers: headers
	                    };
	                    _a.label = 2;
	                case 2:
	                    _a.trys.push([2, 5, , 6]);
	                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig) + "/" + token, unsubscribeOptions)];
	                case 3:
	                    response = _a.sent();
	                    return [4 /*yield*/, response.json()];
	                case 4:
	                    responseData = _a.sent();
	                    if (responseData.error) {
	                        message = responseData.error.message;
	                        throw ERROR_FACTORY.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
	                            errorInfo: message
	                        });
	                    }
	                    return [3 /*break*/, 6];
	                case 5:
	                    err_3 = _a.sent();
	                    throw ERROR_FACTORY.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
	                        errorInfo: err_3
	                    });
	                case 6: return [2 /*return*/];
	            }
	        });
	    });
	}
	function getEndpoint(_a) {
	    var projectId = _a.projectId;
	    return ENDPOINT + "/projects/" + projectId + "/registrations";
	}
	function getHeaders(_a) {
	    var appConfig = _a.appConfig, installations = _a.installations;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var authToken;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, installations.getToken()];
	                case 1:
	                    authToken = _b.sent();
	                    return [2 /*return*/, new Headers({
	                            'Content-Type': 'application/json',
	                            Accept: 'application/json',
	                            'x-goog-api-key': appConfig.apiKey,
	                            'x-goog-firebase-installations-auth': "FIS " + authToken
	                        })];
	            }
	        });
	    });
	}
	function getBody(_a) {
	    var p256dh = _a.p256dh, auth = _a.auth, endpoint = _a.endpoint, vapidKey = _a.vapidKey;
	    var body = {
	        web: {
	            endpoint: endpoint,
	            auth: auth,
	            p256dh: p256dh
	        }
	    };
	    if (vapidKey !== DEFAULT_VAPID_KEY) {
	        body.web.applicationPubKey = vapidKey;
	    }
	    return body;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** UpdateRegistration will be called once every week. */
	var TOKEN_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
	function getToken(firebaseDependencies, swRegistration, vapidKey) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var pushSubscription, tokenDetails, subscriptionOptions, e_1;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    if (Notification.permission !== 'granted') {
	                        throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
	                    }
	                    return [4 /*yield*/, getPushSubscription(swRegistration, vapidKey)];
	                case 1:
	                    pushSubscription = _a.sent();
	                    return [4 /*yield*/, dbGet(firebaseDependencies)];
	                case 2:
	                    tokenDetails = _a.sent();
	                    subscriptionOptions = {
	                        vapidKey: vapidKey,
	                        swScope: swRegistration.scope,
	                        endpoint: pushSubscription.endpoint,
	                        auth: arrayToBase64(pushSubscription.getKey('auth')),
	                        p256dh: arrayToBase64(pushSubscription.getKey('p256dh'))
	                    };
	                    if (!!tokenDetails) return [3 /*break*/, 3];
	                    // No token, get a new one.
	                    return [2 /*return*/, getNewToken(firebaseDependencies, subscriptionOptions)];
	                case 3:
	                    if (!!isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) return [3 /*break*/, 8];
	                    _a.label = 4;
	                case 4:
	                    _a.trys.push([4, 6, , 7]);
	                    return [4 /*yield*/, requestDeleteToken(firebaseDependencies, tokenDetails.token)];
	                case 5:
	                    _a.sent();
	                    return [3 /*break*/, 7];
	                case 6:
	                    e_1 = _a.sent();
	                    // Suppress errors because of #2364
	                    console.warn(e_1);
	                    return [3 /*break*/, 7];
	                case 7: return [2 /*return*/, getNewToken(firebaseDependencies, subscriptionOptions)];
	                case 8:
	                    if (Date.now() >= tokenDetails.createTime + TOKEN_EXPIRATION_MS) {
	                        // Weekly token refresh
	                        return [2 /*return*/, updateToken({
	                                token: tokenDetails.token,
	                                createTime: Date.now(),
	                                subscriptionOptions: subscriptionOptions
	                            }, firebaseDependencies, swRegistration)];
	                    }
	                    else {
	                        // Valid token, nothing to do.
	                        return [2 /*return*/, tokenDetails.token];
	                    }
	                case 9: return [2 /*return*/];
	            }
	        });
	    });
	}
	/**
	 * This method deletes the token from the database, unsubscribes the token from
	 * FCM, and unregisters the push subscription if it exists.
	 */
	function deleteToken(firebaseDependencies, swRegistration) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var tokenDetails, pushSubscription;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, dbGet(firebaseDependencies)];
	                case 1:
	                    tokenDetails = _a.sent();
	                    if (!tokenDetails) return [3 /*break*/, 4];
	                    return [4 /*yield*/, requestDeleteToken(firebaseDependencies, tokenDetails.token)];
	                case 2:
	                    _a.sent();
	                    return [4 /*yield*/, dbRemove(firebaseDependencies)];
	                case 3:
	                    _a.sent();
	                    _a.label = 4;
	                case 4: return [4 /*yield*/, swRegistration.pushManager.getSubscription()];
	                case 5:
	                    pushSubscription = _a.sent();
	                    if (pushSubscription) {
	                        return [2 /*return*/, pushSubscription.unsubscribe()];
	                    }
	                    // If there's no SW, consider it a success.
	                    return [2 /*return*/, true];
	            }
	        });
	    });
	}
	function updateToken(tokenDetails, firebaseDependencies, swRegistration) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var updatedToken, updatedTokenDetails, e_2;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    _a.trys.push([0, 3, , 5]);
	                    return [4 /*yield*/, requestUpdateToken(firebaseDependencies, tokenDetails)];
	                case 1:
	                    updatedToken = _a.sent();
	                    updatedTokenDetails = tslib.__assign({ token: updatedToken, createTime: Date.now() }, tokenDetails);
	                    return [4 /*yield*/, dbSet(firebaseDependencies, updatedTokenDetails)];
	                case 2:
	                    _a.sent();
	                    return [2 /*return*/, updatedToken];
	                case 3:
	                    e_2 = _a.sent();
	                    return [4 /*yield*/, deleteToken(firebaseDependencies, swRegistration)];
	                case 4:
	                    _a.sent();
	                    throw e_2;
	                case 5: return [2 /*return*/];
	            }
	        });
	    });
	}
	function getNewToken(firebaseDependencies, subscriptionOptions) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var token, tokenDetails;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, requestGetToken(firebaseDependencies, subscriptionOptions)];
	                case 1:
	                    token = _a.sent();
	                    tokenDetails = {
	                        token: token,
	                        createTime: Date.now(),
	                        subscriptionOptions: subscriptionOptions
	                    };
	                    return [4 /*yield*/, dbSet(firebaseDependencies, tokenDetails)];
	                case 2:
	                    _a.sent();
	                    return [2 /*return*/, tokenDetails.token];
	            }
	        });
	    });
	}
	/**
	 * Gets a PushSubscription for the current user.
	 */
	function getPushSubscription(swRegistration, vapidKey) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var subscription;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, swRegistration.pushManager.getSubscription()];
	                case 1:
	                    subscription = _a.sent();
	                    if (subscription) {
	                        return [2 /*return*/, subscription];
	                    }
	                    return [2 /*return*/, swRegistration.pushManager.subscribe({
	                            userVisibleOnly: true,
	                            applicationServerKey: vapidKey
	                        })];
	            }
	        });
	    });
	}
	/**
	 * Checks if the saved tokenDetails object matches the configuration provided.
	 */
	function isTokenValid(dbOptions, currentOptions) {
	    var isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
	    var isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
	    var isAuthEqual = currentOptions.auth === dbOptions.auth;
	    var isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
	    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MessageType;
	(function (MessageType) {
	    MessageType["PUSH_RECEIVED"] = "push-received";
	    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
	})(MessageType || (MessageType = {}));
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function isConsoleMessage(data) {
	    // This message has a campaign ID, meaning it was sent using the
	    // Firebase Console.
	    return typeof data === 'object' && !!data && CONSOLE_CAMPAIGN_ID in data;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var WindowController = /** @class */ (function () {
	    function WindowController(firebaseDependencies) {
	        var _this = this;
	        this.firebaseDependencies = firebaseDependencies;
	        this.vapidKey = null;
	        this.onMessageCallback = null;
	        navigator.serviceWorker.addEventListener('message', function (e) {
	            return _this.messageEventListener(e);
	        });
	    }
	    Object.defineProperty(WindowController.prototype, "app", {
	        get: function () {
	            return this.firebaseDependencies.app;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    WindowController.prototype.getToken = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var swRegistration;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.vapidKey) {
	                            this.vapidKey = DEFAULT_VAPID_KEY;
	                        }
	                        return [4 /*yield*/, this.getServiceWorkerRegistration()];
	                    case 1:
	                        swRegistration = _a.sent();
	                        if (!(Notification.permission === 'default')) return [3 /*break*/, 3];
	                        // The user hasn't allowed or denied notifications yet. Ask them.
	                        return [4 /*yield*/, Notification.requestPermission()];
	                    case 2:
	                        // The user hasn't allowed or denied notifications yet. Ask them.
	                        _a.sent();
	                        _a.label = 3;
	                    case 3:
	                        if (Notification.permission !== 'granted') {
	                            throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
	                        }
	                        return [2 /*return*/, getToken(this.firebaseDependencies, swRegistration, this.vapidKey)];
	                }
	            });
	        });
	    };
	    WindowController.prototype.deleteToken = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var swRegistration;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.getServiceWorkerRegistration()];
	                    case 1:
	                        swRegistration = _a.sent();
	                        return [2 /*return*/, deleteToken(this.firebaseDependencies, swRegistration)];
	                }
	            });
	        });
	    };
	    /**
	     * Request permission if it is not currently granted.
	     *
	     * @return Resolves if the permission was granted, rejects otherwise.
	     *
	     * @deprecated Use Notification.requestPermission() instead.
	     * https://developer.mozilla.org/en-US/docs/Web/API/Notification/requestPermission
	     */
	    WindowController.prototype.requestPermission = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var permissionResult;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (Notification.permission === 'granted') {
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, Notification.requestPermission()];
	                    case 1:
	                        permissionResult = _a.sent();
	                        if (permissionResult === 'granted') {
	                            return [2 /*return*/];
	                        }
	                        else if (permissionResult === 'denied') {
	                            throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
	                        }
	                        else {
	                            throw ERROR_FACTORY.create("permission-default" /* PERMISSION_DEFAULT */);
	                        }
	                }
	            });
	        });
	    };
	    // TODO: Deprecate this and make VAPID key a parameter in getToken.
	    WindowController.prototype.usePublicVapidKey = function (vapidKey) {
	        if (this.vapidKey !== null) {
	            throw ERROR_FACTORY.create("use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */);
	        }
	        if (typeof vapidKey !== 'string' || vapidKey.length === 0) {
	            throw ERROR_FACTORY.create("invalid-vapid-key" /* INVALID_VAPID_KEY */);
	        }
	        this.vapidKey = vapidKey;
	    };
	    WindowController.prototype.useServiceWorker = function (swRegistration) {
	        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
	            throw ERROR_FACTORY.create("invalid-sw-registration" /* INVALID_SW_REGISTRATION */);
	        }
	        if (this.swRegistration) {
	            throw ERROR_FACTORY.create("use-sw-after-get-token" /* USE_SW_AFTER_GET_TOKEN */);
	        }
	        this.swRegistration = swRegistration;
	    };
	    /**
	     * @param nextOrObserver An observer object or a function triggered on
	     * message.
	     * @return The unsubscribe function for the observer.
	     */
	    // TODO: Simplify this to only accept a function and not an Observer.
	    WindowController.prototype.onMessage = function (nextOrObserver) {
	        var _this = this;
	        this.onMessageCallback =
	            typeof nextOrObserver === 'function'
	                ? nextOrObserver
	                : nextOrObserver.next;
	        return function () {
	            _this.onMessageCallback = null;
	        };
	    };
	    WindowController.prototype.setBackgroundMessageHandler = function () {
	        throw ERROR_FACTORY.create("only-available-in-sw" /* AVAILABLE_IN_SW */);
	    };
	    // Unimplemented
	    WindowController.prototype.onTokenRefresh = function () {
	        return function () { };
	    };
	    /**
	     * Creates or updates the default service worker registration.
	     * @return The service worker registration to be used for the push service.
	     */
	    WindowController.prototype.getServiceWorkerRegistration = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a, e_1;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        if (!!this.swRegistration) return [3 /*break*/, 4];
	                        _b.label = 1;
	                    case 1:
	                        _b.trys.push([1, 3, , 4]);
	                        _a = this;
	                        return [4 /*yield*/, navigator.serviceWorker.register(DEFAULT_SW_PATH, {
	                                scope: DEFAULT_SW_SCOPE
	                            })];
	                    case 2:
	                        _a.swRegistration = _b.sent();
	                        return [3 /*break*/, 4];
	                    case 3:
	                        e_1 = _b.sent();
	                        throw ERROR_FACTORY.create("failed-service-worker-registration" /* FAILED_DEFAULT_REGISTRATION */, {
	                            browserErrorMessage: e_1.message
	                        });
	                    case 4: return [2 /*return*/, this.swRegistration];
	                }
	            });
	        });
	    };
	    WindowController.prototype.messageEventListener = function (event) {
	        var _a;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _b, type, payload, data;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        if (!((_a = event.data) === null || _a === void 0 ? void 0 : _a.firebaseMessaging)) {
	                            // Not a message from FCM
	                            return [2 /*return*/];
	                        }
	                        _b = event.data.firebaseMessaging, type = _b.type, payload = _b.payload;
	                        if (this.onMessageCallback && type === MessageType.PUSH_RECEIVED) {
	                            this.onMessageCallback(payload);
	                        }
	                        data = payload.data;
	                        if (!(isConsoleMessage(data) &&
	                            data[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1')) return [3 /*break*/, 2];
	                        // Analytics is enabled on this message, so we should log it.
	                        return [4 /*yield*/, this.logEvent(type, data)];
	                    case 1:
	                        // Analytics is enabled on this message, so we should log it.
	                        _c.sent();
	                        _c.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    WindowController.prototype.logEvent = function (messageType, data) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var eventType, analytics;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        eventType = getEventType(messageType);
	                        return [4 /*yield*/, this.firebaseDependencies.analyticsProvider.get()];
	                    case 1:
	                        analytics = _a.sent();
	                        analytics.logEvent(eventType, {
	                            /* eslint-disable camelcase */
	                            message_id: data[CONSOLE_CAMPAIGN_ID],
	                            message_name: data[CONSOLE_CAMPAIGN_NAME],
	                            message_time: data[CONSOLE_CAMPAIGN_TIME],
	                            message_device_time: Math.floor(Date.now() / 1000)
	                            /* eslint-enable camelcase */
	                        });
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return WindowController;
	}());
	function getEventType(messageType) {
	    switch (messageType) {
	        case MessageType.NOTIFICATION_CLICKED:
	            return 'notification_open';
	        case MessageType.PUSH_RECEIVED:
	            return 'notification_foreground';
	        default:
	            throw new Error();
	    }
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Returns a promise that resolves after given time passes. */
	function sleep(ms) {
	    return new Promise(function (resolve) {
	        setTimeout(resolve, ms);
	    });
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var SwController = /** @class */ (function () {
	    function SwController(firebaseDependencies) {
	        var _this = this;
	        this.firebaseDependencies = firebaseDependencies;
	        this.vapidKey = null;
	        this.bgMessageHandler = null;
	        self.addEventListener('push', function (e) {
	            e.waitUntil(_this.onPush(e));
	        });
	        self.addEventListener('pushsubscriptionchange', function (e) {
	            e.waitUntil(_this.onSubChange(e));
	        });
	        self.addEventListener('notificationclick', function (e) {
	            e.waitUntil(_this.onNotificationClick(e));
	        });
	    }
	    Object.defineProperty(SwController.prototype, "app", {
	        get: function () {
	            return this.firebaseDependencies.app;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Calling setBackgroundMessageHandler will opt in to some specific
	     * behaviours.
	     * 1.) If a notification doesn't need to be shown due to a window already
	     * being visible, then push messages will be sent to the page.
	     * 2.) If a notification needs to be shown, and the message contains no
	     * notification data this method will be called
	     * and the promise it returns will be passed to event.waitUntil.
	     * If you do not set this callback then all push messages will let and the
	     * developer can handle them in a their own 'push' event callback
	     *
	     * @param callback The callback to be called when a push message is received
	     * and a notification must be shown. The callback will be given the data from
	     * the push message.
	     */
	    SwController.prototype.setBackgroundMessageHandler = function (callback) {
	        if (!callback || typeof callback !== 'function') {
	            throw ERROR_FACTORY.create("invalid-bg-handler" /* INVALID_BG_HANDLER */);
	        }
	        this.bgMessageHandler = callback;
	    };
	    // TODO: Remove getToken from SW Controller.
	    // Calling this from an old SW can cause all kinds of trouble.
	    SwController.prototype.getToken = function () {
	        var _a, _b, _c;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var tokenDetails;
	            return tslib.__generator(this, function (_d) {
	                switch (_d.label) {
	                    case 0:
	                        if (!!this.vapidKey) return [3 /*break*/, 2];
	                        return [4 /*yield*/, dbGet(this.firebaseDependencies)];
	                    case 1:
	                        tokenDetails = _d.sent();
	                        this.vapidKey = (_c = (_b = (_a = tokenDetails) === null || _a === void 0 ? void 0 : _a.subscriptionOptions) === null || _b === void 0 ? void 0 : _b.vapidKey, (_c !== null && _c !== void 0 ? _c : DEFAULT_VAPID_KEY));
	                        _d.label = 2;
	                    case 2: return [2 /*return*/, getToken(this.firebaseDependencies, self.registration, this.vapidKey)];
	                }
	            });
	        });
	    };
	    // TODO: Remove deleteToken from SW Controller.
	    // Calling this from an old SW can cause all kinds of trouble.
	    SwController.prototype.deleteToken = function () {
	        return deleteToken(this.firebaseDependencies, self.registration);
	    };
	    SwController.prototype.requestPermission = function () {
	        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
	    };
	    // TODO: Deprecate this and make VAPID key a parameter in getToken.
	    // TODO: Remove this together with getToken from SW Controller.
	    SwController.prototype.usePublicVapidKey = function (vapidKey) {
	        if (this.vapidKey !== null) {
	            throw ERROR_FACTORY.create("use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */);
	        }
	        if (typeof vapidKey !== 'string' || vapidKey.length === 0) {
	            throw ERROR_FACTORY.create("invalid-vapid-key" /* INVALID_VAPID_KEY */);
	        }
	        this.vapidKey = vapidKey;
	    };
	    SwController.prototype.useServiceWorker = function () {
	        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
	    };
	    SwController.prototype.onMessage = function () {
	        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
	    };
	    SwController.prototype.onTokenRefresh = function () {
	        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
	    };
	    /**
	     * A handler for push events that shows notifications based on the content of
	     * the payload.
	     *
	     * The payload must be a JSON-encoded Object with a `notification` key. The
	     * value of the `notification` property will be used as the NotificationOptions
	     * object passed to showNotification. Additionally, the `title` property of the
	     * notification object will be used as the title.
	     *
	     * If there is no notification data in the payload then no notification will be
	     * shown.
	     */
	    SwController.prototype.onPush = function (event) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var payload, clientList, notificationDetails;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        payload = getMessagePayload(event);
	                        if (!payload) {
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, getClientList()];
	                    case 1:
	                        clientList = _a.sent();
	                        if (hasVisibleClients(clientList)) {
	                            // App in foreground. Send to page.
	                            return [2 /*return*/, sendMessageToWindowClients(clientList, payload)];
	                        }
	                        notificationDetails = getNotificationData(payload);
	                        if (!notificationDetails) return [3 /*break*/, 3];
	                        return [4 /*yield*/, showNotification(notificationDetails)];
	                    case 2:
	                        _a.sent();
	                        return [3 /*break*/, 5];
	                    case 3:
	                        if (!this.bgMessageHandler) return [3 /*break*/, 5];
	                        return [4 /*yield*/, this.bgMessageHandler(payload)];
	                    case 4:
	                        _a.sent();
	                        _a.label = 5;
	                    case 5: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SwController.prototype.onSubChange = function (event) {
	        var _a, _b, _c;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var newSubscription, tokenDetails;
	            return tslib.__generator(this, function (_d) {
	                switch (_d.label) {
	                    case 0:
	                        newSubscription = event.newSubscription;
	                        if (!!newSubscription) return [3 /*break*/, 2];
	                        // Subscription revoked, delete token
	                        return [4 /*yield*/, deleteToken(this.firebaseDependencies, self.registration)];
	                    case 1:
	                        // Subscription revoked, delete token
	                        _d.sent();
	                        return [2 /*return*/];
	                    case 2: return [4 /*yield*/, dbGet(this.firebaseDependencies)];
	                    case 3:
	                        tokenDetails = _d.sent();
	                        return [4 /*yield*/, deleteToken(this.firebaseDependencies, self.registration)];
	                    case 4:
	                        _d.sent();
	                        return [4 /*yield*/, getToken(this.firebaseDependencies, self.registration, (_c = (_b = (_a = tokenDetails) === null || _a === void 0 ? void 0 : _a.subscriptionOptions) === null || _b === void 0 ? void 0 : _b.vapidKey, (_c !== null && _c !== void 0 ? _c : DEFAULT_VAPID_KEY)))];
	                    case 5:
	                        _d.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SwController.prototype.onNotificationClick = function (event) {
	        var _a, _b;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var payload, link, client, message;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        payload = (_b = (_a = event.notification) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[FCM_MSG];
	                        if (!payload) {
	                            // Not an FCM notification, do nothing.
	                            return [2 /*return*/];
	                        }
	                        else if (event.action) {
	                            // User clicked on an action button.
	                            // This will allow devs to act on action button clicks by using a custom
	                            // onNotificationClick listener that they define.
	                            return [2 /*return*/];
	                        }
	                        // Prevent other listeners from receiving the event
	                        event.stopImmediatePropagation();
	                        event.notification.close();
	                        link = getLink(payload);
	                        if (!link) {
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, getWindowClient(link)];
	                    case 1:
	                        client = _c.sent();
	                        if (!!client) return [3 /*break*/, 4];
	                        return [4 /*yield*/, self.clients.openWindow(link)];
	                    case 2:
	                        // Unable to find window client so need to open one.
	                        // This also focuses the opened client.
	                        client = _c.sent();
	                        // Wait three seconds for the client to initialize and set up the message
	                        // handler so that it can receive the message.
	                        return [4 /*yield*/, sleep(3000)];
	                    case 3:
	                        // Wait three seconds for the client to initialize and set up the message
	                        // handler so that it can receive the message.
	                        _c.sent();
	                        return [3 /*break*/, 6];
	                    case 4: return [4 /*yield*/, client.focus()];
	                    case 5:
	                        client = _c.sent();
	                        _c.label = 6;
	                    case 6:
	                        if (!client) {
	                            // Window Client will not be returned if it's for a third party origin.
	                            return [2 /*return*/];
	                        }
	                        message = createNewMessage(MessageType.NOTIFICATION_CLICKED, payload);
	                        return [2 /*return*/, client.postMessage(message)];
	                }
	            });
	        });
	    };
	    return SwController;
	}());
	function getMessagePayload(_a) {
	    var data = _a.data;
	    if (!data) {
	        return null;
	    }
	    try {
	        return data.json();
	    }
	    catch (err) {
	        // Not JSON so not an FCM message.
	        return null;
	    }
	}
	function getNotificationData(payload) {
	    var _a;
	    if (!payload || typeof payload.notification !== 'object') {
	        return;
	    }
	    var notificationInformation = tslib.__assign({}, payload.notification);
	    // Put the message payload under FCM_MSG name so we can identify the
	    // notification as being an FCM notification vs a notification from
	    // somewhere else (i.e. normal web push or developer generated
	    // notification).
	    notificationInformation.data = tslib.__assign(tslib.__assign({}, payload.notification.data), (_a = {}, _a[FCM_MSG] = payload, _a));
	    return notificationInformation;
	}
	/**
	 * @param url The URL to look for when focusing a client.
	 * @return Returns an existing window client or a newly opened WindowClient.
	 */
	function getWindowClient(url) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var parsedURL, clientList, clientList_1, clientList_1_1, client, parsedClientUrl;
	        var e_1, _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    parsedURL = new URL(url, self.location.href).href;
	                    return [4 /*yield*/, getClientList()];
	                case 1:
	                    clientList = _b.sent();
	                    try {
	                        for (clientList_1 = tslib.__values(clientList), clientList_1_1 = clientList_1.next(); !clientList_1_1.done; clientList_1_1 = clientList_1.next()) {
	                            client = clientList_1_1.value;
	                            parsedClientUrl = new URL(client.url, self.location.href).href;
	                            if (parsedClientUrl === parsedURL) {
	                                return [2 /*return*/, client];
	                            }
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (clientList_1_1 && !clientList_1_1.done && (_a = clientList_1.return)) _a.call(clientList_1);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                    return [2 /*return*/, null];
	            }
	        });
	    });
	}
	/**
	 * @returns If there is currently a visible WindowClient, this method will
	 * resolve to true, otherwise false.
	 */
	function hasVisibleClients(clientList) {
	    return clientList.some(function (client) {
	        return client.visibilityState === 'visible' &&
	            // Ignore chrome-extension clients as that matches the background pages
	            // of extensions, which are always considered visible for some reason.
	            !client.url.startsWith('chrome-extension://');
	    });
	}
	/**
	 * @param payload The data from the push event that should be sent to all
	 * available pages.
	 * @returns Returns a promise that resolves once the message has been sent to
	 * all WindowClients.
	 */
	function sendMessageToWindowClients(clientList, payload) {
	    var e_2, _a;
	    var message = createNewMessage(MessageType.PUSH_RECEIVED, payload);
	    try {
	        for (var clientList_2 = tslib.__values(clientList), clientList_2_1 = clientList_2.next(); !clientList_2_1.done; clientList_2_1 = clientList_2.next()) {
	            var client = clientList_2_1.value;
	            client.postMessage(message);
	        }
	    }
	    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	    finally {
	        try {
	            if (clientList_2_1 && !clientList_2_1.done && (_a = clientList_2.return)) _a.call(clientList_2);
	        }
	        finally { if (e_2) throw e_2.error; }
	    }
	}
	function getClientList() {
	    return self.clients.matchAll({
	        type: 'window',
	        includeUncontrolled: true
	        // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
	    });
	}
	function createNewMessage(type, payload) {
	    return {
	        firebaseMessaging: { type: type, payload: payload }
	    };
	}
	function showNotification(details) {
	    var _a;
	    var title = (_a = details.title, (_a !== null && _a !== void 0 ? _a : ''));
	    var actions = details.actions;
	    var maxActions = Notification.maxActions;
	    if (actions && maxActions && actions.length > maxActions) {
	        console.warn("This browser only supports " + maxActions + " actions. The remaining actions will not be displayed.");
	    }
	    return self.registration.showNotification(title, details);
	}
	function getLink(payload) {
	    var _a, _b, _c;
	    // eslint-disable-next-line camelcase
	    var link = (_b = (_a = payload.fcmOptions) === null || _a === void 0 ? void 0 : _a.link, (_b !== null && _b !== void 0 ? _b : (_c = payload.notification) === null || _c === void 0 ? void 0 : _c.click_action));
	    if (link) {
	        return link;
	    }
	    if (isConsoleMessage(payload.data)) {
	        // Notification created in the Firebase Console. Redirect to origin.
	        return self.location.origin;
	    }
	    else {
	        return null;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MESSAGING_NAME = 'messaging';
	function factoryMethod(container) {
	    // Dependencies.
	    var app = container.getProvider('app').getImmediate();
	    var appConfig = extractAppConfig(app);
	    var installations = container.getProvider('installations').getImmediate();
	    var analyticsProvider = container.getProvider('analytics-internal');
	    var firebaseDependencies = {
	        app: app,
	        appConfig: appConfig,
	        installations: installations,
	        analyticsProvider: analyticsProvider
	    };
	    if (!isSupported()) {
	        throw ERROR_FACTORY.create("unsupported-browser" /* UNSUPPORTED_BROWSER */);
	    }
	    if (self && 'ServiceWorkerGlobalScope' in self) {
	        // Running in ServiceWorker context
	        return new SwController(firebaseDependencies);
	    }
	    else {
	        // Assume we are in the window context.
	        return new WindowController(firebaseDependencies);
	    }
	}
	var NAMESPACE_EXPORTS = {
	    isSupported: isSupported
	};
	firebase.INTERNAL.registerComponent(new component.Component(MESSAGING_NAME, factoryMethod, "PUBLIC" /* PUBLIC */).setServiceProps(NAMESPACE_EXPORTS));
	function isSupported() {
	    if (self && 'ServiceWorkerGlobalScope' in self) {
	        // Running in ServiceWorker context
	        return isSWControllerSupported();
	    }
	    else {
	        // Assume we are in the window context.
	        return isWindowControllerSupported();
	    }
	}
	/**
	 * Checks to see if the required APIs exist.
	 */
	function isWindowControllerSupported() {
	    return ('indexedDB' in window &&
	        indexedDB !== null &&
	        navigator.cookieEnabled &&
	        'serviceWorker' in navigator &&
	        'PushManager' in window &&
	        'Notification' in window &&
	        'fetch' in window &&
	        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
	        PushSubscription.prototype.hasOwnProperty('getKey'));
	}
	/**
	 * Checks to see if the required APIs exist within SW Context.
	 */
	function isSWControllerSupported() {
	    return ('indexedDB' in self &&
	        indexedDB !== null &&
	        'PushManager' in self &&
	        'Notification' in self &&
	        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
	        PushSubscription.prototype.hasOwnProperty('getKey'));
	}
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	__webpack_require__(28);
	var tslib = __webpack_require__(11);
	var util = __webpack_require__(14);
	var logger$1 = __webpack_require__(20);
	var component = __webpack_require__(12);
	
	var name = "@firebase/performance";
	var version = "0.2.32";
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var SDK_VERSION = version;
	/** The prefix for start User Timing marks used for creating Traces. */
	var TRACE_START_MARK_PREFIX = 'FB-PERF-TRACE-START';
	/** The prefix for stop User Timing marks used for creating Traces. */
	var TRACE_STOP_MARK_PREFIX = 'FB-PERF-TRACE-STOP';
	/** The prefix for User Timing measure used for creating Traces. */
	var TRACE_MEASURE_PREFIX = 'FB-PERF-TRACE-MEASURE';
	/** The prefix for out of the box page load Trace name. */
	var OOB_TRACE_PAGE_LOAD_PREFIX = '_wt_';
	var FIRST_PAINT_COUNTER_NAME = '_fp';
	var FIRST_CONTENTFUL_PAINT_COUNTER_NAME = '_fcp';
	var FIRST_INPUT_DELAY_COUNTER_NAME = '_fid';
	var CONFIG_LOCAL_STORAGE_KEY = '@firebase/performance/config';
	var CONFIG_EXPIRY_LOCAL_STORAGE_KEY = '@firebase/performance/configexpire';
	var SERVICE = 'performance';
	var SERVICE_NAME = 'Performance';
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERROR_DESCRIPTION_MAP = (_a = {},
	    _a["trace started" /* TRACE_STARTED_BEFORE */] = 'Trace {$traceName} was started before.',
	    _a["trace stopped" /* TRACE_STOPPED_BEFORE */] = 'Trace {$traceName} is not running.',
	    _a["no window" /* NO_WINDOW */] = 'Window is not available.',
	    _a["no app id" /* NO_APP_ID */] = 'App id is not available.',
	    _a["no project id" /* NO_PROJECT_ID */] = 'Project id is not available.',
	    _a["no api key" /* NO_API_KEY */] = 'Api key is not available.',
	    _a["invalid cc log" /* INVALID_CC_LOG */] = 'Attempted to queue invalid cc event',
	    _a["FB not default" /* FB_NOT_DEFAULT */] = 'Performance can only start when Firebase app instance is the default one.',
	    _a["RC response not ok" /* RC_NOT_OK */] = 'RC response is not ok',
	    _a["invalid attribute name" /* INVALID_ATTRIBUTE_NAME */] = 'Attribute name {$attributeName} is invalid.',
	    _a["invalid attribute value" /* INVALID_ATTRIBUTE_VALUE */] = 'Attribute value {$attributeValue} is invalid.',
	    _a["invalide custom metric name" /* INVALID_CUSTOM_METRIC_NAME */] = 'Custom metric name {$customMetricName} is invalid',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var apiInstance;
	var windowInstance;
	/**
	 * This class holds a reference to various browser related objects injected by
	 * set methods.
	 */
	var Api = /** @class */ (function () {
	    function Api(window) {
	        this.window = window;
	        if (!window) {
	            throw ERROR_FACTORY.create("no window" /* NO_WINDOW */);
	        }
	        this.performance = window.performance;
	        this.PerformanceObserver = window.PerformanceObserver;
	        this.windowLocation = window.location;
	        this.navigator = window.navigator;
	        this.document = window.document;
	        if (this.navigator && this.navigator.cookieEnabled) {
	            // If user blocks cookies on the browser, accessing localStorage will
	            // throw an exception.
	            this.localStorage = window.localStorage;
	        }
	        if (window.perfMetrics && window.perfMetrics.onFirstInputDelay) {
	            this.onFirstInputDelay = window.perfMetrics.onFirstInputDelay;
	        }
	    }
	    Api.prototype.getUrl = function () {
	        // Do not capture the string query part of url.
	        return this.windowLocation.href.split('?')[0];
	    };
	    Api.prototype.mark = function (name) {
	        if (!this.performance || !this.performance.mark) {
	            return;
	        }
	        this.performance.mark(name);
	    };
	    Api.prototype.measure = function (measureName, mark1, mark2) {
	        if (!this.performance || !this.performance.measure) {
	            return;
	        }
	        this.performance.measure(measureName, mark1, mark2);
	    };
	    Api.prototype.getEntriesByType = function (type) {
	        if (!this.performance || !this.performance.getEntriesByType) {
	            return [];
	        }
	        return this.performance.getEntriesByType(type);
	    };
	    Api.prototype.getEntriesByName = function (name) {
	        if (!this.performance || !this.performance.getEntriesByName) {
	            return [];
	        }
	        return this.performance.getEntriesByName(name);
	    };
	    Api.prototype.getTimeOrigin = function () {
	        // Polyfill the time origin with performance.timing.navigationStart.
	        return (this.performance &&
	            (this.performance.timeOrigin || this.performance.timing.navigationStart));
	    };
	    Api.prototype.requiredApisAvailable = function () {
	        if (fetch && Promise && this.navigator && this.navigator.cookieEnabled) {
	            return true;
	        }
	        return false;
	    };
	    Api.prototype.setupObserver = function (entryType, callback) {
	        if (!this.PerformanceObserver) {
	            return;
	        }
	        var observer = new this.PerformanceObserver(function (list) {
	            for (var _i = 0, _a = list.getEntries(); _i < _a.length; _i++) {
	                var entry = _a[_i];
	                // `entry` is a PerformanceEntry instance.
	                callback(entry);
	            }
	        });
	        // Start observing the entry types you care about.
	        observer.observe({ entryTypes: [entryType] });
	    };
	    Api.getInstance = function () {
	        if (apiInstance === undefined) {
	            apiInstance = new Api(windowInstance);
	        }
	        return apiInstance;
	    };
	    return Api;
	}());
	function setupApi(window) {
	    windowInstance = window;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var settingsServiceInstance;
	var SettingsService = /** @class */ (function () {
	    function SettingsService() {
	        // The variable which controls logging of automatic traces and HTTP/S network monitoring.
	        this.instrumentationEnabled = true;
	        // The variable which controls logging of custom traces.
	        this.dataCollectionEnabled = true;
	        // Configuration flags set through remote config.
	        this.loggingEnabled = false;
	        // Sampling rate between 0 and 1.
	        this.tracesSamplingRate = 1;
	        this.networkRequestsSamplingRate = 1;
	        // Address of logging service.
	        this.logEndPointUrl = 'https://firebaselogging.googleapis.com/v0cc/log?format=json_proto';
	        this.logSource = 462;
	        // Flags which control per session logging of traces and network requests.
	        this.logTraceAfterSampling = false;
	        this.logNetworkAfterSampling = false;
	        // TTL of config retrieved from remote config in hours.
	        this.configTimeToLive = 12;
	    }
	    SettingsService.prototype.getAppId = function () {
	        var appId = this.firebaseAppInstance &&
	            this.firebaseAppInstance.options &&
	            this.firebaseAppInstance.options.appId;
	        if (!appId) {
	            throw ERROR_FACTORY.create("no app id" /* NO_APP_ID */);
	        }
	        return appId;
	    };
	    SettingsService.prototype.getProjectId = function () {
	        var projectId = this.firebaseAppInstance &&
	            this.firebaseAppInstance.options &&
	            this.firebaseAppInstance.options.projectId;
	        if (!projectId) {
	            throw ERROR_FACTORY.create("no project id" /* NO_PROJECT_ID */);
	        }
	        return projectId;
	    };
	    SettingsService.prototype.getApiKey = function () {
	        var apiKey = this.firebaseAppInstance &&
	            this.firebaseAppInstance.options &&
	            this.firebaseAppInstance.options.apiKey;
	        if (!apiKey) {
	            throw ERROR_FACTORY.create("no api key" /* NO_API_KEY */);
	        }
	        return apiKey;
	    };
	    SettingsService.getInstance = function () {
	        if (settingsServiceInstance === undefined) {
	            settingsServiceInstance = new SettingsService();
	        }
	        return settingsServiceInstance;
	    };
	    return SettingsService;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var iid;
	function getIidPromise() {
	    var iidPromise = SettingsService.getInstance().installationsService.getId();
	    // eslint-disable-next-line @typescript-eslint/no-floating-promises
	    iidPromise.then(function (iidVal) {
	        iid = iidVal;
	    });
	    return iidPromise;
	}
	// This method should be used after the iid is retrieved by getIidPromise method.
	function getIid() {
	    return iid;
	}
	function getAuthTokenPromise() {
	    var authTokenPromise = SettingsService.getInstance().installationsService.getToken();
	    // eslint-disable-next-line @typescript-eslint/no-floating-promises
	    authTokenPromise.then(function (authTokenVal) {
	    });
	    return authTokenPromise;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var VisibilityState;
	(function (VisibilityState) {
	    VisibilityState[VisibilityState["UNKNOWN"] = 0] = "UNKNOWN";
	    VisibilityState[VisibilityState["VISIBLE"] = 1] = "VISIBLE";
	    VisibilityState[VisibilityState["HIDDEN"] = 2] = "HIDDEN";
	})(VisibilityState || (VisibilityState = {}));
	var RESERVED_ATTRIBUTE_PREFIXES = ['firebase_', 'google_', 'ga_'];
	var ATTRIBUTE_FORMAT_REGEX = new RegExp('^[a-zA-Z]\\w*$');
	var MAX_ATTRIBUTE_NAME_LENGTH = 40;
	var MAX_ATTRIBUTE_VALUE_LENGTH = 100;
	function getServiceWorkerStatus() {
	    var navigator = Api.getInstance().navigator;
	    if ('serviceWorker' in navigator) {
	        if (navigator.serviceWorker.controller) {
	            return 2 /* CONTROLLED */;
	        }
	        else {
	            return 3 /* UNCONTROLLED */;
	        }
	    }
	    else {
	        return 1 /* UNSUPPORTED */;
	    }
	}
	function getVisibilityState() {
	    var document = Api.getInstance().document;
	    var visibilityState = document.visibilityState;
	    switch (visibilityState) {
	        case 'visible':
	            return VisibilityState.VISIBLE;
	        case 'hidden':
	            return VisibilityState.HIDDEN;
	        default:
	            return VisibilityState.UNKNOWN;
	    }
	}
	function getEffectiveConnectionType() {
	    var navigator = Api.getInstance().navigator;
	    var navigatorConnection = navigator.connection;
	    var effectiveType = navigatorConnection && navigatorConnection.effectiveType;
	    switch (effectiveType) {
	        case 'slow-2g':
	            return 1 /* CONNECTION_SLOW_2G */;
	        case '2g':
	            return 2 /* CONNECTION_2G */;
	        case '3g':
	            return 3 /* CONNECTION_3G */;
	        case '4g':
	            return 4 /* CONNECTION_4G */;
	        default:
	            return 0 /* UNKNOWN */;
	    }
	}
	function isValidCustomAttributeName(name) {
	    if (name.length === 0 || name.length > MAX_ATTRIBUTE_NAME_LENGTH) {
	        return false;
	    }
	    var matchesReservedPrefix = RESERVED_ATTRIBUTE_PREFIXES.some(function (prefix) {
	        return name.startsWith(prefix);
	    });
	    return !matchesReservedPrefix && !!name.match(ATTRIBUTE_FORMAT_REGEX);
	}
	function isValidCustomAttributeValue(value) {
	    return value.length !== 0 && value.length <= MAX_ATTRIBUTE_VALUE_LENGTH;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var consoleLogger = new logger$1.Logger(SERVICE_NAME);
	consoleLogger.logLevel = logger$1.LogLevel.INFO;
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var REMOTE_CONFIG_SDK_VERSION = '0.0.1';
	// These values will be used if the remote config object is successfully
	// retrieved, but the template does not have these fields.
	var SECONDARY_CONFIGS = {
	    loggingEnabled: true
	};
	var FIS_AUTH_PREFIX = 'FIREBASE_INSTALLATIONS_AUTH';
	function getConfig(iid) {
	    var config = getStoredConfig();
	    if (config) {
	        processConfig(config);
	        return Promise.resolve();
	    }
	    return getRemoteConfig(iid)
	        .then(function (config) { return processConfig(config); })
	        .then(function (config) { return storeConfig(config); }, 
	    /** Do nothing for error, use defaults set in settings service. */
	    function () { });
	}
	function getStoredConfig() {
	    var localStorage = Api.getInstance().localStorage;
	    if (!localStorage) {
	        return;
	    }
	    var expiryString = localStorage.getItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY);
	    if (!expiryString || !configValid(expiryString)) {
	        return;
	    }
	    var configStringified = localStorage.getItem(CONFIG_LOCAL_STORAGE_KEY);
	    if (!configStringified) {
	        return;
	    }
	    try {
	        var configResponse = JSON.parse(configStringified);
	        return configResponse;
	    }
	    catch (_a) {
	        return;
	    }
	}
	function storeConfig(config) {
	    var localStorage = Api.getInstance().localStorage;
	    if (!config || !localStorage) {
	        return;
	    }
	    localStorage.setItem(CONFIG_LOCAL_STORAGE_KEY, JSON.stringify(config));
	    localStorage.setItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY, String(Date.now() +
	        SettingsService.getInstance().configTimeToLive * 60 * 60 * 1000));
	}
	var COULD_NOT_GET_CONFIG_MSG = 'Could not fetch config, will use default configs';
	function getRemoteConfig(iid) {
	    // Perf needs auth token only to retrieve remote config.
	    return getAuthTokenPromise()
	        .then(function (authToken) {
	        var projectId = SettingsService.getInstance().getProjectId();
	        var configEndPoint = "https://firebaseremoteconfig.googleapis.com/v1/projects/" + projectId + "/namespaces/fireperf:fetch?key=" + SettingsService.getInstance().getApiKey();
	        var request = new Request(configEndPoint, {
	            method: 'POST',
	            headers: { Authorization: FIS_AUTH_PREFIX + " " + authToken },
	            /* eslint-disable camelcase */
	            body: JSON.stringify({
	                app_instance_id: iid,
	                app_instance_id_token: authToken,
	                app_id: SettingsService.getInstance().getAppId(),
	                app_version: SDK_VERSION,
	                sdk_version: REMOTE_CONFIG_SDK_VERSION
	            })
	            /* eslint-enable camelcase */
	        });
	        return fetch(request).then(function (response) {
	            if (response.ok) {
	                return response.json();
	            }
	            // In case response is not ok. This will be caught by catch.
	            throw ERROR_FACTORY.create("RC response not ok" /* RC_NOT_OK */);
	        });
	    })
	        .catch(function () {
	        consoleLogger.info(COULD_NOT_GET_CONFIG_MSG);
	        return undefined;
	    });
	}
	/**
	 * Processes config coming either from calling RC or from local storage.
	 * This method only runs if call is successful or config in storage
	 * is valie.
	 */
	function processConfig(config) {
	    if (!config) {
	        return config;
	    }
	    var settingsServiceInstance = SettingsService.getInstance();
	    var entries = config.entries || {};
	    if (entries.fpr_enabled !== undefined) {
	        // TODO: Change the assignment of loggingEnabled once the received type is
	        // known.
	        settingsServiceInstance.loggingEnabled =
	            String(entries.fpr_enabled) === 'true';
	    }
	    else {
	        // Config retrieved successfully, but there is no fpr_enabled in template.
	        // Use secondary configs value.
	        settingsServiceInstance.loggingEnabled = SECONDARY_CONFIGS.loggingEnabled;
	    }
	    if (entries.fpr_log_source) {
	        settingsServiceInstance.logSource = Number(entries.fpr_log_source);
	    }
	    if (entries.fpr_log_endpoint_url) {
	        settingsServiceInstance.logEndPointUrl = entries.fpr_log_endpoint_url;
	    }
	    if (entries.fpr_vc_network_request_sampling_rate !== undefined) {
	        settingsServiceInstance.networkRequestsSamplingRate = Number(entries.fpr_vc_network_request_sampling_rate);
	    }
	    if (entries.fpr_vc_trace_sampling_rate !== undefined) {
	        settingsServiceInstance.tracesSamplingRate = Number(entries.fpr_vc_trace_sampling_rate);
	    }
	    // Set the per session trace and network logging flags.
	    settingsServiceInstance.logTraceAfterSampling = shouldLogAfterSampling(settingsServiceInstance.tracesSamplingRate);
	    settingsServiceInstance.logNetworkAfterSampling = shouldLogAfterSampling(settingsServiceInstance.networkRequestsSamplingRate);
	    return config;
	}
	function configValid(expiry) {
	    return Number(expiry) > Date.now();
	}
	function shouldLogAfterSampling(samplingRate) {
	    return Math.random() <= samplingRate;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var initializationStatus = 1 /* notInitialized */;
	var initializationPromise;
	function getInitializationPromise() {
	    initializationStatus = 2 /* initializationPending */;
	    initializationPromise = initializationPromise || initializePerf();
	    return initializationPromise;
	}
	function isPerfInitialized() {
	    return initializationStatus === 3 /* initialized */;
	}
	function initializePerf() {
	    return getDocumentReadyComplete()
	        .then(function () { return getIidPromise(); })
	        .then(function (iid) { return getConfig(iid); })
	        .then(function () { return changeInitializationStatus(); }, function () { return changeInitializationStatus(); });
	}
	/**
	 * Returns a promise which resolves whenever the document readystate is complete or
	 * immediately if it is called after page load complete.
	 */
	function getDocumentReadyComplete() {
	    var document = Api.getInstance().document;
	    return new Promise(function (resolve) {
	        if (document && document.readyState !== 'complete') {
	            var handler_1 = function () {
	                if (document.readyState === 'complete') {
	                    document.removeEventListener('readystatechange', handler_1);
	                    resolve();
	                }
	            };
	            document.addEventListener('readystatechange', handler_1);
	        }
	        else {
	            resolve();
	        }
	    });
	}
	function changeInitializationStatus() {
	    initializationStatus = 3 /* initialized */;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_SEND_INTERVAL_MS = 10 * 1000;
	var INITIAL_SEND_TIME_DELAY_MS = 5.5 * 1000;
	// If end point does not work, the call will be tried for these many times.
	var DEFAULT_REMAINING_TRIES = 3;
	var remainingTries = DEFAULT_REMAINING_TRIES;
	/* eslint-enable camelcase */
	var queue = [];
	var isTransportSetup = false;
	function setupTransportService() {
	    if (!isTransportSetup) {
	        processQueue(INITIAL_SEND_TIME_DELAY_MS);
	        isTransportSetup = true;
	    }
	}
	function processQueue(timeOffset) {
	    setTimeout(function () {
	        // If there is no remainingTries left, stop retrying.
	        if (remainingTries === 0) {
	            return;
	        }
	        // If there are no events to process, wait for DEFAULT_SEND_INTERVAL_MS and try again.
	        if (!queue.length) {
	            return processQueue(DEFAULT_SEND_INTERVAL_MS);
	        }
	        // Capture a snapshot of the queue and empty the "official queue".
	        var staged = tslib.__spreadArrays(queue);
	        queue = [];
	        /* eslint-disable camelcase */
	        // We will pass the JSON serialized event to the backend.
	        var log_event = staged.map(function (evt) { return ({
	            source_extension_json_proto3: evt.message,
	            event_time_ms: String(evt.eventTime)
	        }); });
	        var data = {
	            request_time_ms: String(Date.now()),
	            client_info: {
	                client_type: 1,
	                js_client_info: {}
	            },
	            log_source: SettingsService.getInstance().logSource,
	            log_event: log_event
	        };
	        /* eslint-enable camelcase */
	        fetch(SettingsService.getInstance().logEndPointUrl, {
	            method: 'POST',
	            body: JSON.stringify(data)
	        })
	            .then(function (res) {
	            if (!res.ok) {
	                consoleLogger.info('Call to Firebase backend failed.');
	            }
	            return res.json();
	        })
	            .then(function (res) {
	            var wait = Number(res.next_request_wait_millis);
	            // Find the next call wait time from the response.
	            var requestOffset = isNaN(wait)
	                ? DEFAULT_SEND_INTERVAL_MS
	                : Math.max(DEFAULT_SEND_INTERVAL_MS, wait);
	            remainingTries = DEFAULT_REMAINING_TRIES;
	            // Schedule the next process.
	            processQueue(requestOffset);
	        })
	            .catch(function () {
	            /**
	             * If the request fails for some reason, add the events that were attempted
	             * back to the primary queue to retry later.
	             */
	            queue = tslib.__spreadArrays(staged, queue);
	            remainingTries--;
	            consoleLogger.info("Tries left: " + remainingTries + ".");
	            processQueue(DEFAULT_SEND_INTERVAL_MS);
	        });
	    }, timeOffset);
	}
	function addToQueue(evt) {
	    if (!evt.eventTime || !evt.message) {
	        throw ERROR_FACTORY.create("invalid cc log" /* INVALID_CC_LOG */);
	    }
	    // Add the new event to the queue.
	    queue = tslib.__spreadArrays(queue, [evt]);
	}
	/** Log handler for cc service to send the performance logs to the server. */
	function transportHandler(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	serializer) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var message = serializer.apply(void 0, args);
	        addToQueue({
	            message: message,
	            eventTime: Date.now()
	        });
	    };
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-enble camelcase */
	var logger;
	// This method is not called before initialization.
	function sendLog(resource, resourceType) {
	    if (!logger) {
	        logger = transportHandler(serializer);
	    }
	    logger(resource, resourceType);
	}
	function logTrace(trace) {
	    var settingsService = SettingsService.getInstance();
	    // Do not log if trace is auto generated and instrumentation is disabled.
	    if (!settingsService.instrumentationEnabled && trace.isAuto) {
	        return;
	    }
	    // Do not log if trace is custom and data collection is disabled.
	    if (!settingsService.dataCollectionEnabled && !trace.isAuto) {
	        return;
	    }
	    // Do not log if required apis are not available.
	    if (!Api.getInstance().requiredApisAvailable()) {
	        return;
	    }
	    // Only log the page load auto traces if page is visible.
	    if (trace.isAuto && getVisibilityState() !== VisibilityState.VISIBLE) {
	        return;
	    }
	    if (!settingsService.loggingEnabled ||
	        !settingsService.logTraceAfterSampling) {
	        return;
	    }
	    if (isPerfInitialized()) {
	        sendTraceLog(trace);
	    }
	    else {
	        // Custom traces can be used before the initialization but logging
	        // should wait until after.
	        getInitializationPromise().then(function () { return sendTraceLog(trace); }, function () { return sendTraceLog(trace); });
	    }
	}
	function sendTraceLog(trace) {
	    if (getIid()) {
	        setTimeout(function () { return sendLog(trace, 1 /* Trace */); }, 0);
	    }
	}
	function logNetworkRequest(networkRequest) {
	    var settingsService = SettingsService.getInstance();
	    // Do not log network requests if instrumentation is disabled.
	    if (!settingsService.instrumentationEnabled) {
	        return;
	    }
	    // Do not log the js sdk's call to cc service to avoid unnecessary cycle.
	    if (networkRequest.url === settingsService.logEndPointUrl.split('?')[0]) {
	        return;
	    }
	    if (!settingsService.loggingEnabled ||
	        !settingsService.logNetworkAfterSampling) {
	        return;
	    }
	    setTimeout(function () { return sendLog(networkRequest, 0 /* NetworkRequest */); }, 0);
	}
	function serializer(resource, resourceType) {
	    if (resourceType === 0 /* NetworkRequest */) {
	        return serializeNetworkRequest(resource);
	    }
	    return serializeTrace(resource);
	}
	function serializeNetworkRequest(networkRequest) {
	    var networkRequestMetric = {
	        url: networkRequest.url,
	        http_method: networkRequest.httpMethod || 0,
	        http_response_code: 200,
	        response_payload_bytes: networkRequest.responsePayloadBytes,
	        client_start_time_us: networkRequest.startTimeUs,
	        time_to_response_initiated_us: networkRequest.timeToResponseInitiatedUs,
	        time_to_response_completed_us: networkRequest.timeToResponseCompletedUs
	    };
	    var perfMetric = {
	        application_info: getApplicationInfo(),
	        network_request_metric: networkRequestMetric
	    };
	    return JSON.stringify(perfMetric);
	}
	function serializeTrace(trace) {
	    var traceMetric = {
	        name: trace.name,
	        is_auto: trace.isAuto,
	        client_start_time_us: trace.startTimeUs,
	        duration_us: trace.durationUs
	    };
	    if (Object.keys(trace.counters).length !== 0) {
	        traceMetric.counters = trace.counters;
	    }
	    var customAttributes = trace.getAttributes();
	    if (Object.keys(customAttributes).length !== 0) {
	        traceMetric.custom_attributes = customAttributes;
	    }
	    var perfMetric = {
	        application_info: getApplicationInfo(),
	        trace_metric: traceMetric
	    };
	    return JSON.stringify(perfMetric);
	}
	function getApplicationInfo() {
	    return {
	        google_app_id: SettingsService.getInstance().getAppId(),
	        app_instance_id: getIid(),
	        web_app_info: {
	            sdk_version: SDK_VERSION,
	            page_url: Api.getInstance().getUrl(),
	            service_worker_status: getServiceWorkerStatus(),
	            visibility_state: getVisibilityState(),
	            effective_connection_type: getEffectiveConnectionType()
	        },
	        application_process_state: 0
	    };
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MAX_METRIC_NAME_LENGTH = 100;
	var RESERVED_AUTO_PREFIX = '_';
	var oobMetrics = [
	    FIRST_PAINT_COUNTER_NAME,
	    FIRST_CONTENTFUL_PAINT_COUNTER_NAME,
	    FIRST_INPUT_DELAY_COUNTER_NAME
	];
	/**
	 * Returns true if the metric is custom and does not start with reserved prefix, or if
	 * the metric is one of out of the box page load trace metrics.
	 */
	function isValidMetricName(name, traceName) {
	    if (name.length === 0 || name.length > MAX_METRIC_NAME_LENGTH) {
	        return false;
	    }
	    return ((traceName &&
	        traceName.startsWith(OOB_TRACE_PAGE_LOAD_PREFIX) &&
	        oobMetrics.indexOf(name) > -1) ||
	        !name.startsWith(RESERVED_AUTO_PREFIX));
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Trace = /** @class */ (function () {
	    /**
	     * @param name The name of the trace.
	     * @param isAuto If the trace is auto-instrumented.
	     * @param traceMeasureName The name of the measure marker in user timing specification. This field
	     * is only set when the trace is built for logging when the user directly uses the user timing
	     * api (performance.mark and performance.measure).
	     */
	    function Trace(name, isAuto, traceMeasureName) {
	        if (isAuto === void 0) { isAuto = false; }
	        this.name = name;
	        this.isAuto = isAuto;
	        this.state = 1 /* UNINITIALIZED */;
	        this.customAttributes = {};
	        this.counters = {};
	        this.api = Api.getInstance();
	        this.randomId = Math.floor(Math.random() * 1000000);
	        if (!this.isAuto) {
	            this.traceStartMark = TRACE_START_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
	            this.traceStopMark = TRACE_STOP_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
	            this.traceMeasure =
	                traceMeasureName ||
	                    TRACE_MEASURE_PREFIX + "-" + this.randomId + "-" + this.name;
	            if (traceMeasureName) {
	                // For the case of direct user timing traces, no start stop will happen. The measure object
	                // is already available.
	                this.calculateTraceMetrics();
	            }
	        }
	    }
	    /**
	     * Starts a trace. The measurement of the duration starts at this point.
	     */
	    Trace.prototype.start = function () {
	        if (this.state !== 1 /* UNINITIALIZED */) {
	            throw ERROR_FACTORY.create("trace started" /* TRACE_STARTED_BEFORE */, {
	                traceName: this.name
	            });
	        }
	        this.api.mark(this.traceStartMark);
	        this.state = 2 /* RUNNING */;
	    };
	    /**
	     * Stops the trace. The measurement of the duration of the trace stops at this point and trace
	     * is logged.
	     */
	    Trace.prototype.stop = function () {
	        if (this.state !== 2 /* RUNNING */) {
	            throw ERROR_FACTORY.create("trace stopped" /* TRACE_STOPPED_BEFORE */, {
	                traceName: this.name
	            });
	        }
	        this.state = 3 /* TERMINATED */;
	        this.api.mark(this.traceStopMark);
	        this.api.measure(this.traceMeasure, this.traceStartMark, this.traceStopMark);
	        this.calculateTraceMetrics();
	        logTrace(this);
	    };
	    /**
	     * Records a trace with predetermined values. If this method is used a trace is created and logged
	     * directly. No need to use start and stop methods.
	     * @param startTime Trace start time since epoch in millisec
	     * @param duration The duraction of the trace in millisec
	     * @param options An object which can optionally hold maps of custom metrics and custom attributes
	     */
	    Trace.prototype.record = function (startTime, duration, options) {
	        this.durationUs = Math.floor(duration * 1000);
	        this.startTimeUs = Math.floor(startTime * 1000);
	        if (options && options.attributes) {
	            this.customAttributes = tslib.__assign({}, options.attributes);
	        }
	        if (options && options.metrics) {
	            for (var _i = 0, _a = Object.keys(options.metrics); _i < _a.length; _i++) {
	                var metric = _a[_i];
	                if (!isNaN(Number(options.metrics[metric]))) {
	                    this.counters[metric] = Number(Math.floor(options.metrics[metric]));
	                }
	            }
	        }
	        logTrace(this);
	    };
	    /**
	     * Increments a custom metric by a certain number or 1 if number not specified. Will create a new
	     * custom metric if one with the given name does not exist.
	     * @param counter Name of the custom metric
	     * @param num Increment by value
	     */
	    Trace.prototype.incrementMetric = function (counter, num) {
	        if (num === void 0) { num = 1; }
	        if (this.counters[counter] === undefined) {
	            this.putMetric(counter, 0);
	        }
	        this.counters[counter] += num;
	    };
	    /**
	     * Sets a custom metric to a specified value. Will create a new custom metric if one with the
	     * given name does not exist.
	     * @param counter Name of the custom metric
	     * @param num Set custom metric to this value
	     */
	    Trace.prototype.putMetric = function (counter, num) {
	        if (isValidMetricName(counter, this.name)) {
	            this.counters[counter] = num;
	        }
	        else {
	            throw ERROR_FACTORY.create("invalide custom metric name" /* INVALID_CUSTOM_METRIC_NAME */, {
	                customMetricName: counter
	            });
	        }
	    };
	    /**
	     * Returns the value of the custom metric by that name. If a custom metric with that name does
	     * not exist will return zero.
	     * @param counter
	     */
	    Trace.prototype.getMetric = function (counter) {
	        return this.counters[counter] || 0;
	    };
	    /**
	     * Sets a custom attribute of a trace to a certain value.
	     * @param attr
	     * @param value
	     */
	    Trace.prototype.putAttribute = function (attr, value) {
	        var isValidName = isValidCustomAttributeName(attr);
	        var isValidValue = isValidCustomAttributeValue(value);
	        if (isValidName && isValidValue) {
	            this.customAttributes[attr] = value;
	            return;
	        }
	        // Throw appropriate error when the attribute name or value is invalid.
	        if (!isValidName) {
	            throw ERROR_FACTORY.create("invalid attribute name" /* INVALID_ATTRIBUTE_NAME */, {
	                attributeName: attr
	            });
	        }
	        if (!isValidValue) {
	            throw ERROR_FACTORY.create("invalid attribute value" /* INVALID_ATTRIBUTE_VALUE */, {
	                attributeValue: value
	            });
	        }
	    };
	    /**
	     * Retrieves the value a custom attribute of a trace is set to.
	     * @param attr
	     */
	    Trace.prototype.getAttribute = function (attr) {
	        return this.customAttributes[attr];
	    };
	    Trace.prototype.removeAttribute = function (attr) {
	        if (this.customAttributes[attr] === undefined) {
	            return;
	        }
	        delete this.customAttributes[attr];
	    };
	    Trace.prototype.getAttributes = function () {
	        return tslib.__assign({}, this.customAttributes);
	    };
	    Trace.prototype.setStartTime = function (startTime) {
	        this.startTimeUs = startTime;
	    };
	    Trace.prototype.setDuration = function (duration) {
	        this.durationUs = duration;
	    };
	    /**
	     * Calculates and assigns the duration and start time of the trace using the measure performance
	     * entry.
	     */
	    Trace.prototype.calculateTraceMetrics = function () {
	        var perfMeasureEntries = this.api.getEntriesByName(this.traceMeasure);
	        var perfMeasureEntry = perfMeasureEntries && perfMeasureEntries[0];
	        if (perfMeasureEntry) {
	            this.durationUs = Math.floor(perfMeasureEntry.duration * 1000);
	            this.startTimeUs = Math.floor((perfMeasureEntry.startTime + this.api.getTimeOrigin()) * 1000);
	        }
	    };
	    /**
	     * @param navigationTimings A single element array which contains the navigationTIming object of
	     * the page load
	     * @param paintTimings A array which contains paintTiming object of the page load
	     * @param firstInputDelay First input delay in millisec
	     */
	    Trace.createOobTrace = function (navigationTimings, paintTimings, firstInputDelay) {
	        var route = Api.getInstance().getUrl();
	        if (!route) {
	            return;
	        }
	        var trace = new Trace(OOB_TRACE_PAGE_LOAD_PREFIX + route, true);
	        var timeOriginUs = Math.floor(Api.getInstance().getTimeOrigin() * 1000);
	        trace.setStartTime(timeOriginUs);
	        // navigationTimings includes only one element.
	        if (navigationTimings && navigationTimings[0]) {
	            trace.setDuration(Math.floor(navigationTimings[0].duration * 1000));
	            trace.putMetric('domInteractive', Math.floor(navigationTimings[0].domInteractive * 1000));
	            trace.putMetric('domContentLoadedEventEnd', Math.floor(navigationTimings[0].domContentLoadedEventEnd * 1000));
	            trace.putMetric('loadEventEnd', Math.floor(navigationTimings[0].loadEventEnd * 1000));
	        }
	        var FIRST_PAINT = 'first-paint';
	        var FIRST_CONTENTFUL_PAINT = 'first-contentful-paint';
	        if (paintTimings) {
	            var firstPaint = paintTimings.find(function (paintObject) { return paintObject.name === FIRST_PAINT; });
	            if (firstPaint && firstPaint.startTime) {
	                trace.putMetric(FIRST_PAINT_COUNTER_NAME, Math.floor(firstPaint.startTime * 1000));
	            }
	            var firstContentfulPaint = paintTimings.find(function (paintObject) { return paintObject.name === FIRST_CONTENTFUL_PAINT; });
	            if (firstContentfulPaint && firstContentfulPaint.startTime) {
	                trace.putMetric(FIRST_CONTENTFUL_PAINT_COUNTER_NAME, Math.floor(firstContentfulPaint.startTime * 1000));
	            }
	            if (firstInputDelay) {
	                trace.putMetric(FIRST_INPUT_DELAY_COUNTER_NAME, Math.floor(firstInputDelay * 1000));
	            }
	        }
	        logTrace(trace);
	    };
	    Trace.createUserTimingTrace = function (measureName) {
	        var trace = new Trace(measureName, false, measureName);
	        logTrace(trace);
	    };
	    return Trace;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function createNetworkRequestEntry(entry) {
	    var performanceEntry = entry;
	    if (!performanceEntry || performanceEntry.responseStart === undefined) {
	        return;
	    }
	    var timeOrigin = Api.getInstance().getTimeOrigin();
	    var startTimeUs = Math.floor((performanceEntry.startTime + timeOrigin) * 1000);
	    var timeToResponseInitiatedUs = performanceEntry.responseStart
	        ? Math.floor((performanceEntry.responseStart - performanceEntry.startTime) * 1000)
	        : undefined;
	    var timeToResponseCompletedUs = Math.floor((performanceEntry.responseEnd - performanceEntry.startTime) * 1000);
	    // Remove the query params from logged network request url.
	    var url = performanceEntry.name && performanceEntry.name.split('?')[0];
	    var networkRequest = {
	        url: url,
	        responsePayloadBytes: performanceEntry.transferSize,
	        startTimeUs: startTimeUs,
	        timeToResponseInitiatedUs: timeToResponseInitiatedUs,
	        timeToResponseCompletedUs: timeToResponseCompletedUs
	    };
	    logNetworkRequest(networkRequest);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var FID_WAIT_TIME_MS = 5000;
	function setupOobResources() {
	    // Do not initialize unless iid is available.
	    if (!getIid()) {
	        return;
	    }
	    // The load event might not have fired yet, and that means performance navigation timing
	    // object has a duration of 0. The setup should run after all current tasks in js queue.
	    setTimeout(function () { return setupOobTraces(); }, 0);
	    setTimeout(function () { return setupNetworkRequests(); }, 0);
	    setTimeout(function () { return setupUserTimingTraces(); }, 0);
	}
	function setupNetworkRequests() {
	    var api = Api.getInstance();
	    var resources = api.getEntriesByType('resource');
	    for (var _i = 0, resources_1 = resources; _i < resources_1.length; _i++) {
	        var resource = resources_1[_i];
	        createNetworkRequestEntry(resource);
	    }
	    api.setupObserver('resource', createNetworkRequestEntry);
	}
	function setupOobTraces() {
	    var api = Api.getInstance();
	    var navigationTimings = api.getEntriesByType('navigation');
	    var paintTimings = api.getEntriesByType('paint');
	    // If First Input Desly polyfill is added to the page, report the fid value.
	    // https://github.com/GoogleChromeLabs/first-input-delay
	    if (api.onFirstInputDelay) {
	        // If the fid call back is not called for certain time, continue without it.
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var timeoutId_1 = setTimeout(function () {
	            Trace.createOobTrace(navigationTimings, paintTimings);
	            timeoutId_1 = undefined;
	        }, FID_WAIT_TIME_MS);
	        api.onFirstInputDelay(function (fid) {
	            if (timeoutId_1) {
	                clearTimeout(timeoutId_1);
	                Trace.createOobTrace(navigationTimings, paintTimings, fid);
	            }
	        });
	    }
	    else {
	        Trace.createOobTrace(navigationTimings, paintTimings);
	    }
	}
	function setupUserTimingTraces() {
	    var api = Api.getInstance();
	    // Run through the measure performance entries collected up to this point.
	    var measures = api.getEntriesByType('measure');
	    for (var _i = 0, measures_1 = measures; _i < measures_1.length; _i++) {
	        var measure = measures_1[_i];
	        createUserTimingTrace(measure);
	    }
	    // Setup an observer to capture the measures from this point on.
	    api.setupObserver('measure', createUserTimingTrace);
	}
	function createUserTimingTrace(measure) {
	    var measureName = measure.name;
	    // Do not create a trace, if the user timing marks and measures are created by the sdk itself.
	    if (measureName.substring(0, TRACE_MEASURE_PREFIX.length) ===
	        TRACE_MEASURE_PREFIX) {
	        return;
	    }
	    Trace.createUserTimingTrace(measureName);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PerformanceController = /** @class */ (function () {
	    function PerformanceController(app) {
	        this.app = app;
	        if (Api.getInstance().requiredApisAvailable()) {
	            setupTransportService();
	            getInitializationPromise().then(setupOobResources, setupOobResources);
	        }
	        else {
	            consoleLogger.info('Firebase Performance cannot start if browser does not support fetch and Promise or cookie is disabled.');
	        }
	    }
	    PerformanceController.prototype.trace = function (name) {
	        return new Trace(name);
	    };
	    Object.defineProperty(PerformanceController.prototype, "instrumentationEnabled", {
	        get: function () {
	            return SettingsService.getInstance().instrumentationEnabled;
	        },
	        set: function (val) {
	            SettingsService.getInstance().instrumentationEnabled = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PerformanceController.prototype, "dataCollectionEnabled", {
	        get: function () {
	            return SettingsService.getInstance().dataCollectionEnabled;
	        },
	        set: function (val) {
	            SettingsService.getInstance().dataCollectionEnabled = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return PerformanceController;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	function registerPerformance(instance) {
	    var factoryMethod = function (app, installations) {
	        if (app.name !== DEFAULT_ENTRY_NAME) {
	            throw ERROR_FACTORY.create("FB not default" /* FB_NOT_DEFAULT */);
	        }
	        if (typeof window === 'undefined') {
	            throw ERROR_FACTORY.create("no window" /* NO_WINDOW */);
	        }
	        setupApi(window);
	        SettingsService.getInstance().firebaseAppInstance = app;
	        SettingsService.getInstance().installationsService = installations;
	        return new PerformanceController(app);
	    };
	    // Register performance with firebase-app.
	    instance.INTERNAL.registerComponent(new component.Component('performance', function (container) {
	        /* Dependencies */
	        // getImmediate for FirebaseApp will always succeed
	        var app = container.getProvider('app').getImmediate();
	        // The following call will always succeed because perf has `import '@firebase/installations'`
	        var installations = container
	            .getProvider('installations')
	            .getImmediate();
	        return factoryMethod(app, installations);
	    }, "PUBLIC" /* PUBLIC */));
	    instance.registerVersion(name, version);
	}
	registerPerformance(firebase);
	
	exports.registerPerformance = registerPerformance;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	__webpack_require__(28);
	var tslib = __webpack_require__(11);
	var util = __webpack_require__(14);
	var logger = __webpack_require__(20);
	var component = __webpack_require__(12);
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Implements the {@link RemoteConfigClient} abstraction with success response caching.
	 *
	 * <p>Comparable to the browser's Cache API for responses, but the Cache API requires a Service
	 * Worker, which requires HTTPS, which would significantly complicate SDK installation. Also, the
	 * Cache API doesn't support matching entries by time.
	 */
	var CachingClient = /** @class */ (function () {
	    function CachingClient(client, storage, storageCache, logger) {
	        this.client = client;
	        this.storage = storage;
	        this.storageCache = storageCache;
	        this.logger = logger;
	    }
	    /**
	     * Returns true if the age of the cached fetched configs is less than or equal to
	     * {@link Settings#minimumFetchIntervalInSeconds}.
	     *
	     * <p>This is comparable to passing `headers = { 'Cache-Control': max-age <maxAge> }` to the
	     * native Fetch API.
	     *
	     * <p>Visible for testing.
	     */
	    CachingClient.prototype.isCachedDataFresh = function (cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis) {
	        // Cache can only be fresh if it's populated.
	        if (!lastSuccessfulFetchTimestampMillis) {
	            this.logger.debug('Config fetch cache check. Cache unpopulated.');
	            return false;
	        }
	        // Calculates age of cache entry.
	        var cacheAgeMillis = Date.now() - lastSuccessfulFetchTimestampMillis;
	        var isCachedDataFresh = cacheAgeMillis <= cacheMaxAgeMillis;
	        this.logger.debug('Config fetch cache check.' +
	            (" Cache age millis: " + cacheAgeMillis + ".") +
	            (" Cache max age millis (minimumFetchIntervalMillis setting): " + cacheMaxAgeMillis + ".") +
	            (" Is cache hit: " + isCachedDataFresh + "."));
	        return isCachedDataFresh;
	    };
	    CachingClient.prototype.fetch = function (request) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a, lastSuccessfulFetchTimestampMillis, lastSuccessfulFetchResponse, response, storageOperations;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, Promise.all([
	                            this.storage.getLastSuccessfulFetchTimestampMillis(),
	                            this.storage.getLastSuccessfulFetchResponse()
	                        ])];
	                    case 1:
	                        _a = _b.sent(), lastSuccessfulFetchTimestampMillis = _a[0], lastSuccessfulFetchResponse = _a[1];
	                        // Exits early on cache hit.
	                        if (lastSuccessfulFetchResponse &&
	                            this.isCachedDataFresh(request.cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis)) {
	                            return [2 /*return*/, lastSuccessfulFetchResponse];
	                        }
	                        // Deviates from pure decorator by not honoring a passed ETag since we don't have a public API
	                        // that allows the caller to pass an ETag.
	                        request.eTag =
	                            lastSuccessfulFetchResponse && lastSuccessfulFetchResponse.eTag;
	                        return [4 /*yield*/, this.client.fetch(request)];
	                    case 2:
	                        response = _b.sent();
	                        storageOperations = [
	                            // Uses write-through cache for consistency with synchronous public API.
	                            this.storageCache.setLastSuccessfulFetchTimestampMillis(Date.now())
	                        ];
	                        if (response.status === 200) {
	                            // Caches response only if it has changed, ie non-304 responses.
	                            storageOperations.push(this.storage.setLastSuccessfulFetchResponse(response));
	                        }
	                        return [4 /*yield*/, Promise.all(storageOperations)];
	                    case 3:
	                        _b.sent();
	                        return [2 /*return*/, response];
	                }
	            });
	        });
	    };
	    return CachingClient;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERROR_DESCRIPTION_MAP = (_a = {},
	    _a["registration-window" /* REGISTRATION_WINDOW */] = 'Undefined window object. This SDK only supports usage in a browser environment.',
	    _a["registration-project-id" /* REGISTRATION_PROJECT_ID */] = 'Undefined project identifier. Check Firebase app initialization.',
	    _a["registration-api-key" /* REGISTRATION_API_KEY */] = 'Undefined API key. Check Firebase app initialization.',
	    _a["registration-app-id" /* REGISTRATION_APP_ID */] = 'Undefined app identifier. Check Firebase app initialization.',
	    _a["storage-open" /* STORAGE_OPEN */] = 'Error thrown when opening storage. Original error: {$originalErrorMessage}.',
	    _a["storage-get" /* STORAGE_GET */] = 'Error thrown when reading from storage. Original error: {$originalErrorMessage}.',
	    _a["storage-set" /* STORAGE_SET */] = 'Error thrown when writing to storage. Original error: {$originalErrorMessage}.',
	    _a["storage-delete" /* STORAGE_DELETE */] = 'Error thrown when deleting from storage. Original error: {$originalErrorMessage}.',
	    _a["fetch-client-network" /* FETCH_NETWORK */] = 'Fetch client failed to connect to a network. Check Internet connection.' +
	        ' Original error: {$originalErrorMessage}.',
	    _a["fetch-timeout" /* FETCH_TIMEOUT */] = 'The config fetch request timed out. ' +
	        ' Configure timeout using "fetchTimeoutMillis" SDK setting.',
	    _a["fetch-throttle" /* FETCH_THROTTLE */] = 'The config fetch request timed out while in an exponential backoff state.' +
	        ' Configure timeout using "fetchTimeoutMillis" SDK setting.' +
	        ' Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.',
	    _a["fetch-client-parse" /* FETCH_PARSE */] = 'Fetch client could not parse response.' +
	        ' Original error: {$originalErrorMessage}.',
	    _a["fetch-status" /* FETCH_STATUS */] = 'Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory('remoteconfig' /* service */, 'Remote Config' /* service name */, ERROR_DESCRIPTION_MAP);
	// Note how this is like typeof/instanceof, but for ErrorCode.
	function hasErrorCode(e, errorCode) {
	    return e instanceof util.FirebaseError && e.code.indexOf(errorCode) !== -1;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Attempts to get the most accurate browser language setting.
	 *
	 * <p>Adapted from getUserLanguage in packages/auth/src/utils.js for TypeScript.
	 *
	 * <p>Defers default language specification to server logic for consistency.
	 *
	 * @param navigatorLanguage Enables tests to override read-only {@link NavigatorLanguage}.
	 */
	function getUserLanguage(navigatorLanguage) {
	    if (navigatorLanguage === void 0) { navigatorLanguage = navigator; }
	    return (
	    // Most reliable, but only supported in Chrome/Firefox.
	    (navigatorLanguage.languages && navigatorLanguage.languages[0]) ||
	        // Supported in most browsers, but returns the language of the browser
	        // UI, not the language set in browser settings.
	        navigatorLanguage.language
	    // Polyfill otherwise.
	    );
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Implements the Client abstraction for the Remote Config REST API.
	 */
	var RestClient = /** @class */ (function () {
	    function RestClient(firebaseInstallations, sdkVersion, namespace, projectId, apiKey, appId) {
	        this.firebaseInstallations = firebaseInstallations;
	        this.sdkVersion = sdkVersion;
	        this.namespace = namespace;
	        this.projectId = projectId;
	        this.apiKey = apiKey;
	        this.appId = appId;
	    }
	    /**
	     * Fetches from the Remote Config REST API.
	     *
	     * @throws a {@link ErrorCode.FETCH_NETWORK} error if {@link GlobalFetch#fetch} can't
	     * connect to the network.
	     * @throws a {@link ErrorCode.FETCH_PARSE} error if {@link Response#json} can't parse the
	     * fetch response.
	     * @throws a {@link ErrorCode.FETCH_STATUS} error if the service returns an HTTP error status.
	     */
	    RestClient.prototype.fetch = function (request) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a, installationId, installationToken, urlBase, url, headers, requestBody, options, fetchPromise, timeoutPromise, response, originalError_1, errorCode, status, responseEtag, config, state, responseBody, originalError_2;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, Promise.all([
	                            this.firebaseInstallations.getId(),
	                            this.firebaseInstallations.getToken()
	                        ])];
	                    case 1:
	                        _a = _b.sent(), installationId = _a[0], installationToken = _a[1];
	                        urlBase = window.FIREBASE_REMOTE_CONFIG_URL_BASE ||
	                            'https://firebaseremoteconfig.googleapis.com';
	                        url = urlBase + "/v1/projects/" + this.projectId + "/namespaces/" + this.namespace + ":fetch?key=" + this.apiKey;
	                        headers = {
	                            'Content-Type': 'application/json',
	                            'Content-Encoding': 'gzip',
	                            // Deviates from pure decorator by not passing max-age header since we don't currently have
	                            // service behavior using that header.
	                            'If-None-Match': request.eTag || '*'
	                        };
	                        requestBody = {
	                            /* eslint-disable camelcase */
	                            sdk_version: this.sdkVersion,
	                            app_instance_id: installationId,
	                            app_instance_id_token: installationToken,
	                            app_id: this.appId,
	                            language_code: getUserLanguage()
	                            /* eslint-enable camelcase */
	                        };
	                        options = {
	                            method: 'POST',
	                            headers: headers,
	                            body: JSON.stringify(requestBody)
	                        };
	                        fetchPromise = fetch(url, options);
	                        timeoutPromise = new Promise(function (_resolve, reject) {
	                            // Maps async event listener to Promise API.
	                            request.signal.addEventListener(function () {
	                                // Emulates https://heycam.github.io/webidl/#aborterror
	                                var error = new Error('The operation was aborted.');
	                                error.name = 'AbortError';
	                                reject(error);
	                            });
	                        });
	                        _b.label = 2;
	                    case 2:
	                        _b.trys.push([2, 5, , 6]);
	                        return [4 /*yield*/, Promise.race([fetchPromise, timeoutPromise])];
	                    case 3:
	                        _b.sent();
	                        return [4 /*yield*/, fetchPromise];
	                    case 4:
	                        response = _b.sent();
	                        return [3 /*break*/, 6];
	                    case 5:
	                        originalError_1 = _b.sent();
	                        errorCode = "fetch-client-network" /* FETCH_NETWORK */;
	                        if (originalError_1.name === 'AbortError') {
	                            errorCode = "fetch-timeout" /* FETCH_TIMEOUT */;
	                        }
	                        throw ERROR_FACTORY.create(errorCode, {
	                            originalErrorMessage: originalError_1.message
	                        });
	                    case 6:
	                        status = response.status;
	                        responseEtag = response.headers.get('ETag') || undefined;
	                        if (!(response.status === 200)) return [3 /*break*/, 11];
	                        responseBody = void 0;
	                        _b.label = 7;
	                    case 7:
	                        _b.trys.push([7, 9, , 10]);
	                        return [4 /*yield*/, response.json()];
	                    case 8:
	                        responseBody = _b.sent();
	                        return [3 /*break*/, 10];
	                    case 9:
	                        originalError_2 = _b.sent();
	                        throw ERROR_FACTORY.create("fetch-client-parse" /* FETCH_PARSE */, {
	                            originalErrorMessage: originalError_2.message
	                        });
	                    case 10:
	                        config = responseBody['entries'];
	                        state = responseBody['state'];
	                        _b.label = 11;
	                    case 11:
	                        // Normalizes based on legacy state.
	                        if (state === 'INSTANCE_STATE_UNSPECIFIED') {
	                            status = 500;
	                        }
	                        else if (state === 'NO_CHANGE') {
	                            status = 304;
	                        }
	                        else if (state === 'NO_TEMPLATE' || state === 'EMPTY_CONFIG') {
	                            // These cases can be fixed remotely, so normalize to safe value.
	                            config = {};
	                        }
	                        // Normalize to exception-based control flow for non-success cases.
	                        // Encapsulates HTTP specifics in this class as much as possible. Status is still the best for
	                        // differentiating success states (200 from 304; the state body param is undefined in a
	                        // standard 304).
	                        if (status !== 304 && status !== 200) {
	                            throw ERROR_FACTORY.create("fetch-status" /* FETCH_STATUS */, {
	                                httpStatus: status
	                            });
	                        }
	                        return [2 /*return*/, { status: status, eTag: responseEtag, config: config }];
	                }
	            });
	        });
	    };
	    return RestClient;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Shims a minimal AbortSignal.
	 *
	 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
	 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
	 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
	 * swapped out if/when we do.
	 */
	var RemoteConfigAbortSignal = /** @class */ (function () {
	    function RemoteConfigAbortSignal() {
	        this.listeners = [];
	    }
	    RemoteConfigAbortSignal.prototype.addEventListener = function (listener) {
	        this.listeners.push(listener);
	    };
	    RemoteConfigAbortSignal.prototype.abort = function () {
	        this.listeners.forEach(function (listener) { return listener(); });
	    };
	    return RemoteConfigAbortSignal;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_VALUE_FOR_BOOLEAN = false;
	var DEFAULT_VALUE_FOR_STRING = '';
	var DEFAULT_VALUE_FOR_NUMBER = 0;
	var BOOLEAN_TRUTHY_VALUES = ['1', 'true', 't', 'yes', 'y', 'on'];
	var Value = /** @class */ (function () {
	    function Value(_source, _value) {
	        if (_value === void 0) { _value = DEFAULT_VALUE_FOR_STRING; }
	        this._source = _source;
	        this._value = _value;
	    }
	    Value.prototype.asString = function () {
	        return this._value;
	    };
	    Value.prototype.asBoolean = function () {
	        if (this._source === 'static') {
	            return DEFAULT_VALUE_FOR_BOOLEAN;
	        }
	        return BOOLEAN_TRUTHY_VALUES.indexOf(this._value.toLowerCase()) >= 0;
	    };
	    Value.prototype.asNumber = function () {
	        if (this._source === 'static') {
	            return DEFAULT_VALUE_FOR_NUMBER;
	        }
	        var num = Number(this._value);
	        if (isNaN(num)) {
	            num = DEFAULT_VALUE_FOR_NUMBER;
	        }
	        return num;
	    };
	    Value.prototype.getSource = function () {
	        return this._source;
	    };
	    return Value;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_FETCH_TIMEOUT_MILLIS = 60 * 1000; // One minute
	var DEFAULT_CACHE_MAX_AGE_MILLIS = 12 * 60 * 60 * 1000; // Twelve hours.
	/**
	 * Encapsulates business logic mapping network and storage dependencies to the public SDK API.
	 *
	 * See {@link https://github.com/FirebasePrivate/firebase-js-sdk/blob/master/packages/firebase/index.d.ts|interface documentation} for method descriptions.
	 */
	var RemoteConfig = /** @class */ (function () {
	    function RemoteConfig(
	    // Required by FirebaseServiceFactory interface.
	    app, 
	    // JS doesn't support private yet
	    // (https://github.com/tc39/proposal-class-fields#private-fields), so we hint using an
	    // underscore prefix.
	    _client, _storageCache, _storage, _logger) {
	        this.app = app;
	        this._client = _client;
	        this._storageCache = _storageCache;
	        this._storage = _storage;
	        this._logger = _logger;
	        // Tracks completion of initialization promise.
	        this._isInitializationComplete = false;
	        this.settings = {
	            fetchTimeoutMillis: DEFAULT_FETCH_TIMEOUT_MILLIS,
	            minimumFetchIntervalMillis: DEFAULT_CACHE_MAX_AGE_MILLIS
	        };
	        this.defaultConfig = {};
	    }
	    // Based on packages/firestore/src/util/log.ts but not static because we need per-instance levels
	    // to differentiate 2p and 3p use-cases.
	    RemoteConfig.prototype.setLogLevel = function (logLevel) {
	        switch (logLevel) {
	            case 'debug':
	                this._logger.logLevel = logger.LogLevel.DEBUG;
	                break;
	            case 'silent':
	                this._logger.logLevel = logger.LogLevel.SILENT;
	                break;
	            default:
	                this._logger.logLevel = logger.LogLevel.ERROR;
	        }
	    };
	    Object.defineProperty(RemoteConfig.prototype, "fetchTimeMillis", {
	        get: function () {
	            return this._storageCache.getLastSuccessfulFetchTimestampMillis() || -1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RemoteConfig.prototype, "lastFetchStatus", {
	        get: function () {
	            return this._storageCache.getLastFetchStatus() || 'no-fetch-yet';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RemoteConfig.prototype.activate = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a, lastSuccessfulFetchResponse, activeConfigEtag;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, Promise.all([
	                            this._storage.getLastSuccessfulFetchResponse(),
	                            this._storage.getActiveConfigEtag()
	                        ])];
	                    case 1:
	                        _a = _b.sent(), lastSuccessfulFetchResponse = _a[0], activeConfigEtag = _a[1];
	                        if (!lastSuccessfulFetchResponse ||
	                            !lastSuccessfulFetchResponse.config ||
	                            !lastSuccessfulFetchResponse.eTag ||
	                            lastSuccessfulFetchResponse.eTag === activeConfigEtag) {
	                            // Either there is no successful fetched config, or is the same as current active
	                            // config.
	                            return [2 /*return*/, false];
	                        }
	                        return [4 /*yield*/, Promise.all([
	                                this._storageCache.setActiveConfig(lastSuccessfulFetchResponse.config),
	                                this._storage.setActiveConfigEtag(lastSuccessfulFetchResponse.eTag)
	                            ])];
	                    case 2:
	                        _b.sent();
	                        return [2 /*return*/, true];
	                }
	            });
	        });
	    };
	    RemoteConfig.prototype.ensureInitialized = function () {
	        var _this = this;
	        if (!this._initializePromise) {
	            this._initializePromise = this._storageCache
	                .loadFromStorage()
	                .then(function () {
	                _this._isInitializationComplete = true;
	            });
	        }
	        return this._initializePromise;
	    };
	    /**
	     * @throws a {@link ErrorCode.FETCH_CLIENT_TIMEOUT} if the request takes longer than
	     * {@link Settings.fetchTimeoutInSeconds} or
	     * {@link DEFAULT_FETCH_TIMEOUT_SECONDS}.
	     */
	    RemoteConfig.prototype.fetch = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var abortSignal, e_1, lastFetchStatus;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        abortSignal = new RemoteConfigAbortSignal();
	                        setTimeout(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	                            return tslib.__generator(this, function (_a) {
	                                // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
	                                abortSignal.abort();
	                                return [2 /*return*/];
	                            });
	                        }); }, this.settings.fetchTimeoutMillis);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 6]);
	                        return [4 /*yield*/, this._client.fetch({
	                                cacheMaxAgeMillis: this.settings.minimumFetchIntervalMillis,
	                                signal: abortSignal
	                            })];
	                    case 2:
	                        _a.sent();
	                        return [4 /*yield*/, this._storageCache.setLastFetchStatus('success')];
	                    case 3:
	                        _a.sent();
	                        return [3 /*break*/, 6];
	                    case 4:
	                        e_1 = _a.sent();
	                        lastFetchStatus = hasErrorCode(e_1, "fetch-throttle" /* FETCH_THROTTLE */)
	                            ? 'throttle'
	                            : 'failure';
	                        return [4 /*yield*/, this._storageCache.setLastFetchStatus(lastFetchStatus)];
	                    case 5:
	                        _a.sent();
	                        throw e_1;
	                    case 6: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    RemoteConfig.prototype.fetchAndActivate = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.fetch()];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/, this.activate()];
	                }
	            });
	        });
	    };
	    RemoteConfig.prototype.getAll = function () {
	        var _this = this;
	        return getAllKeys(this._storageCache.getActiveConfig(), this.defaultConfig).reduce(function (allConfigs, key) {
	            allConfigs[key] = _this.getValue(key);
	            return allConfigs;
	        }, {});
	    };
	    RemoteConfig.prototype.getBoolean = function (key) {
	        return this.getValue(key).asBoolean();
	    };
	    RemoteConfig.prototype.getNumber = function (key) {
	        return this.getValue(key).asNumber();
	    };
	    RemoteConfig.prototype.getString = function (key) {
	        return this.getValue(key).asString();
	    };
	    RemoteConfig.prototype.getValue = function (key) {
	        if (!this._isInitializationComplete) {
	            this._logger.debug("A value was requested for key \"" + key + "\" before SDK initialization completed." +
	                ' Await on ensureInitialized if the intent was to get a previously activated value.');
	        }
	        var activeConfig = this._storageCache.getActiveConfig();
	        if (activeConfig && activeConfig[key] !== undefined) {
	            return new Value('remote', activeConfig[key]);
	        }
	        else if (this.defaultConfig && this.defaultConfig[key] !== undefined) {
	            return new Value('default', String(this.defaultConfig[key]));
	        }
	        this._logger.debug("Returning static value for key \"" + key + "\"." +
	            ' Define a default or remote value if this is unintentional.');
	        return new Value('static');
	    };
	    return RemoteConfig;
	}());
	/**
	 * Dedupes and returns an array of all the keys of the received objects.
	 */
	function getAllKeys(obj1, obj2) {
	    if (obj1 === void 0) { obj1 = {}; }
	    if (obj2 === void 0) { obj2 = {}; }
	    return Object.keys(tslib.__assign(tslib.__assign({}, obj1), obj2));
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Converts an error event associated with a {@link IDBRequest} to a {@link FirebaseError}.
	 */
	function toFirebaseError(event, errorCode) {
	    var originalError = event.target.error || undefined;
	    return ERROR_FACTORY.create(errorCode, {
	        originalErrorMessage: originalError && originalError.message
	    });
	}
	/**
	 * A general-purpose store keyed by app + namespace + {@link
	 * ProjectNamespaceKeyFieldValue}.
	 *
	 * <p>The Remote Config SDK can be used with multiple app installations, and each app can interact
	 * with multiple namespaces, so this store uses app (ID + name) and namespace as common parent keys
	 * for a set of key-value pairs. See {@link Storage#createCompositeKey}.
	 *
	 * <p>Visible for testing.
	 */
	var APP_NAMESPACE_STORE = 'app_namespace_store';
	var DB_NAME = 'firebase_remote_config';
	var DB_VERSION = 1;
	// Visible for testing.
	function openDatabase() {
	    return new Promise(function (resolve, reject) {
	        var request = indexedDB.open(DB_NAME, DB_VERSION);
	        request.onerror = function (event) {
	            reject(toFirebaseError(event, "storage-open" /* STORAGE_OPEN */));
	        };
	        request.onsuccess = function (event) {
	            resolve(event.target.result);
	        };
	        request.onupgradeneeded = function (event) {
	            var db = event.target.result;
	            // We don't use 'break' in this switch statement, the fall-through
	            // behavior is what we want, because if there are multiple versions between
	            // the old version and the current version, we want ALL the migrations
	            // that correspond to those versions to run, not only the last one.
	            // eslint-disable-next-line default-case
	            switch (event.oldVersion) {
	                case 0:
	                    db.createObjectStore(APP_NAMESPACE_STORE, {
	                        keyPath: 'compositeKey'
	                    });
	            }
	        };
	    });
	}
	/**
	 * Abstracts data persistence.
	 */
	var Storage = /** @class */ (function () {
	    /**
	     * @param appId enables storage segmentation by app (ID + name).
	     * @param appName enables storage segmentation by app (ID + name).
	     * @param namespace enables storage segmentation by namespace.
	     */
	    function Storage(appId, appName, namespace, openDbPromise) {
	        if (openDbPromise === void 0) { openDbPromise = openDatabase(); }
	        this.appId = appId;
	        this.appName = appName;
	        this.namespace = namespace;
	        this.openDbPromise = openDbPromise;
	    }
	    Storage.prototype.getLastFetchStatus = function () {
	        return this.get('last_fetch_status');
	    };
	    Storage.prototype.setLastFetchStatus = function (status) {
	        return this.set('last_fetch_status', status);
	    };
	    // This is comparable to a cache entry timestamp. If we need to expire other data, we could
	    // consider adding timestamp to all storage records and an optional max age arg to getters.
	    Storage.prototype.getLastSuccessfulFetchTimestampMillis = function () {
	        return this.get('last_successful_fetch_timestamp_millis');
	    };
	    Storage.prototype.setLastSuccessfulFetchTimestampMillis = function (timestamp) {
	        return this.set('last_successful_fetch_timestamp_millis', timestamp);
	    };
	    Storage.prototype.getLastSuccessfulFetchResponse = function () {
	        return this.get('last_successful_fetch_response');
	    };
	    Storage.prototype.setLastSuccessfulFetchResponse = function (response) {
	        return this.set('last_successful_fetch_response', response);
	    };
	    Storage.prototype.getActiveConfig = function () {
	        return this.get('active_config');
	    };
	    Storage.prototype.setActiveConfig = function (config) {
	        return this.set('active_config', config);
	    };
	    Storage.prototype.getActiveConfigEtag = function () {
	        return this.get('active_config_etag');
	    };
	    Storage.prototype.setActiveConfigEtag = function (etag) {
	        return this.set('active_config_etag', etag);
	    };
	    Storage.prototype.getThrottleMetadata = function () {
	        return this.get('throttle_metadata');
	    };
	    Storage.prototype.setThrottleMetadata = function (metadata) {
	        return this.set('throttle_metadata', metadata);
	    };
	    Storage.prototype.deleteThrottleMetadata = function () {
	        return this.delete('throttle_metadata');
	    };
	    Storage.prototype.get = function (key) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var db;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.openDbPromise];
	                    case 1:
	                        db = _a.sent();
	                        return [2 /*return*/, new Promise(function (resolve, reject) {
	                                var transaction = db.transaction([APP_NAMESPACE_STORE], 'readonly');
	                                var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
	                                var compositeKey = _this.createCompositeKey(key);
	                                try {
	                                    var request = objectStore.get(compositeKey);
	                                    request.onerror = function (event) {
	                                        reject(toFirebaseError(event, "storage-get" /* STORAGE_GET */));
	                                    };
	                                    request.onsuccess = function (event) {
	                                        var result = event.target.result;
	                                        if (result) {
	                                            resolve(result.value);
	                                        }
	                                        else {
	                                            resolve(undefined);
	                                        }
	                                    };
	                                }
	                                catch (e) {
	                                    reject(ERROR_FACTORY.create("storage-get" /* STORAGE_GET */, {
	                                        originalErrorMessage: e && e.message
	                                    }));
	                                }
	                            })];
	                }
	            });
	        });
	    };
	    Storage.prototype.set = function (key, value) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var db;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.openDbPromise];
	                    case 1:
	                        db = _a.sent();
	                        return [2 /*return*/, new Promise(function (resolve, reject) {
	                                var transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
	                                var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
	                                var compositeKey = _this.createCompositeKey(key);
	                                try {
	                                    var request = objectStore.put({
	                                        compositeKey: compositeKey,
	                                        value: value
	                                    });
	                                    request.onerror = function (event) {
	                                        reject(toFirebaseError(event, "storage-set" /* STORAGE_SET */));
	                                    };
	                                    request.onsuccess = function () {
	                                        resolve();
	                                    };
	                                }
	                                catch (e) {
	                                    reject(ERROR_FACTORY.create("storage-set" /* STORAGE_SET */, {
	                                        originalErrorMessage: e && e.message
	                                    }));
	                                }
	                            })];
	                }
	            });
	        });
	    };
	    Storage.prototype.delete = function (key) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var db;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.openDbPromise];
	                    case 1:
	                        db = _a.sent();
	                        return [2 /*return*/, new Promise(function (resolve, reject) {
	                                var transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
	                                var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
	                                var compositeKey = _this.createCompositeKey(key);
	                                try {
	                                    var request = objectStore.delete(compositeKey);
	                                    request.onerror = function (event) {
	                                        reject(toFirebaseError(event, "storage-delete" /* STORAGE_DELETE */));
	                                    };
	                                    request.onsuccess = function () {
	                                        resolve();
	                                    };
	                                }
	                                catch (e) {
	                                    reject(ERROR_FACTORY.create("storage-delete" /* STORAGE_DELETE */, {
	                                        originalErrorMessage: e && e.message
	                                    }));
	                                }
	                            })];
	                }
	            });
	        });
	    };
	    // Facilitates composite key functionality (which is unsupported in IE).
	    Storage.prototype.createCompositeKey = function (key) {
	        return [this.appId, this.appName, this.namespace, key].join();
	    };
	    return Storage;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A memory cache layer over storage to support the SDK's synchronous read requirements.
	 */
	var StorageCache = /** @class */ (function () {
	    function StorageCache(storage) {
	        this.storage = storage;
	    }
	    /**
	     * Memory-only getters
	     */
	    StorageCache.prototype.getLastFetchStatus = function () {
	        return this.lastFetchStatus;
	    };
	    StorageCache.prototype.getLastSuccessfulFetchTimestampMillis = function () {
	        return this.lastSuccessfulFetchTimestampMillis;
	    };
	    StorageCache.prototype.getActiveConfig = function () {
	        return this.activeConfig;
	    };
	    /**
	     * Read-ahead getter
	     */
	    StorageCache.prototype.loadFromStorage = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var lastFetchStatusPromise, lastSuccessfulFetchTimestampMillisPromise, activeConfigPromise, lastFetchStatus, lastSuccessfulFetchTimestampMillis, activeConfig;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        lastFetchStatusPromise = this.storage.getLastFetchStatus();
	                        lastSuccessfulFetchTimestampMillisPromise = this.storage.getLastSuccessfulFetchTimestampMillis();
	                        activeConfigPromise = this.storage.getActiveConfig();
	                        return [4 /*yield*/, lastFetchStatusPromise];
	                    case 1:
	                        lastFetchStatus = _a.sent();
	                        if (lastFetchStatus) {
	                            this.lastFetchStatus = lastFetchStatus;
	                        }
	                        return [4 /*yield*/, lastSuccessfulFetchTimestampMillisPromise];
	                    case 2:
	                        lastSuccessfulFetchTimestampMillis = _a.sent();
	                        if (lastSuccessfulFetchTimestampMillis) {
	                            this.lastSuccessfulFetchTimestampMillis = lastSuccessfulFetchTimestampMillis;
	                        }
	                        return [4 /*yield*/, activeConfigPromise];
	                    case 3:
	                        activeConfig = _a.sent();
	                        if (activeConfig) {
	                            this.activeConfig = activeConfig;
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Write-through setters
	     */
	    StorageCache.prototype.setLastFetchStatus = function (status) {
	        this.lastFetchStatus = status;
	        return this.storage.setLastFetchStatus(status);
	    };
	    StorageCache.prototype.setLastSuccessfulFetchTimestampMillis = function (timestampMillis) {
	        this.lastSuccessfulFetchTimestampMillis = timestampMillis;
	        return this.storage.setLastSuccessfulFetchTimestampMillis(timestampMillis);
	    };
	    StorageCache.prototype.setActiveConfig = function (activeConfig) {
	        this.activeConfig = activeConfig;
	        return this.storage.setActiveConfig(activeConfig);
	    };
	    return StorageCache;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * The amount of milliseconds to exponentially increase.
	 */
	var INTERVAL_MILLIS = 1000;
	/**
	 * The factor to backoff by.
	 * Should be a number greater than 1.
	 */
	var BACKOFF_FACTOR = 2;
	/**
	 * The maximum milliseconds to increase to.
	 *
	 * <p>Visible for testing
	 */
	var MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
	/**
	 * The percentage of backoff time to randomize by.
	 * See
	 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
	 * for context.
	 *
	 * <p>Visible for testing
	 */
	var RANDOM_FACTOR = 0.5;
	/**
	 * Based on the backoff method from
	 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
	 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
	 */
	function calculateBackoffMillis(backoffCount) {
	    // Calculates an exponentially increasing value.
	    // Deviation: calculates value from count and a constant interval, so we only need to save value
	    // and count to restore state.
	    var currBaseValue = INTERVAL_MILLIS * Math.pow(BACKOFF_FACTOR, backoffCount);
	    // A random "fuzz" to avoid waves of retries.
	    // Deviation: randomFactor is required.
	    var randomWait = Math.round(
	    // A fraction of the backoff value to add/subtract.
	    // Deviation: changes multiplication order to improve readability.
	    RANDOM_FACTOR *
	        currBaseValue *
	        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
	        // if we add or subtract.
	        (Math.random() - 0.5) *
	        2);
	    // Limits backoff to max to avoid effectively permanent backoff.
	    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Supports waiting on a backoff by:
	 *
	 * <ul>
	 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
	 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
	 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
	 *       request appear the same.</li>
	 * </ul>
	 *
	 * <p>Visible for testing.
	 */
	function setAbortableTimeout(signal, throttleEndTimeMillis) {
	    return new Promise(function (resolve, reject) {
	        // Derives backoff from given end time, normalizing negative numbers to zero.
	        var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
	        var timeout = setTimeout(resolve, backoffMillis);
	        // Adds listener, rather than sets onabort, because signal is a shared object.
	        signal.addEventListener(function () {
	            clearTimeout(timeout);
	            // If the request completes before this timeout, the rejection has no effect.
	            reject(ERROR_FACTORY.create("fetch-throttle" /* FETCH_THROTTLE */, {
	                throttleEndTimeMillis: throttleEndTimeMillis
	            }));
	        });
	    });
	}
	/**
	 * Returns true if the {@link Error} indicates a fetch request may succeed later.
	 */
	function isRetriableError(e) {
	    if (!(e instanceof util.FirebaseError)) {
	        return false;
	    }
	    // Uses string index defined by ErrorData, which FirebaseError implements.
	    var httpStatus = Number(e['httpStatus']);
	    return (httpStatus === 429 ||
	        httpStatus === 500 ||
	        httpStatus === 503 ||
	        httpStatus === 504);
	}
	/**
	 * Decorates a Client with retry logic.
	 *
	 * <p>Comparable to CachingClient, but uses backoff logic instead of cache max age and doesn't cache
	 * responses (because the SDK has no use for error responses).
	 */
	var RetryingClient = /** @class */ (function () {
	    function RetryingClient(client, storage) {
	        this.client = client;
	        this.storage = storage;
	    }
	    RetryingClient.prototype.fetch = function (request) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var throttleMetadata;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.storage.getThrottleMetadata()];
	                    case 1:
	                        throttleMetadata = (_a.sent()) || {
	                            backoffCount: 0,
	                            throttleEndTimeMillis: Date.now()
	                        };
	                        return [2 /*return*/, this.attemptFetch(request, throttleMetadata)];
	                }
	            });
	        });
	    };
	    /**
	     * A recursive helper for attempting a fetch request repeatedly.
	     *
	     * @throws any non-retriable errors.
	     */
	    RetryingClient.prototype.attemptFetch = function (request, _a) {
	        var throttleEndTimeMillis = _a.throttleEndTimeMillis, backoffCount = _a.backoffCount;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var response, e_1, throttleMetadata;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: 
	                    // Starts with a (potentially zero) timeout to support resumption from stored state.
	                    // Ensures the throttle end time is honored if the last attempt timed out.
	                    // Note the SDK will never make a request if the fetch timeout expires at this point.
	                    return [4 /*yield*/, setAbortableTimeout(request.signal, throttleEndTimeMillis)];
	                    case 1:
	                        // Starts with a (potentially zero) timeout to support resumption from stored state.
	                        // Ensures the throttle end time is honored if the last attempt timed out.
	                        // Note the SDK will never make a request if the fetch timeout expires at this point.
	                        _b.sent();
	                        _b.label = 2;
	                    case 2:
	                        _b.trys.push([2, 5, , 7]);
	                        return [4 /*yield*/, this.client.fetch(request)];
	                    case 3:
	                        response = _b.sent();
	                        // Note the SDK only clears throttle state if response is success or non-retriable.
	                        return [4 /*yield*/, this.storage.deleteThrottleMetadata()];
	                    case 4:
	                        // Note the SDK only clears throttle state if response is success or non-retriable.
	                        _b.sent();
	                        return [2 /*return*/, response];
	                    case 5:
	                        e_1 = _b.sent();
	                        if (!isRetriableError(e_1)) {
	                            throw e_1;
	                        }
	                        throttleMetadata = {
	                            throttleEndTimeMillis: Date.now() + calculateBackoffMillis(backoffCount),
	                            backoffCount: backoffCount + 1
	                        };
	                        // Persists state.
	                        return [4 /*yield*/, this.storage.setThrottleMetadata(throttleMetadata)];
	                    case 6:
	                        // Persists state.
	                        _b.sent();
	                        return [2 /*return*/, this.attemptFetch(request, throttleMetadata)];
	                    case 7: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return RetryingClient;
	}());
	
	var name = "@firebase/remote-config";
	var version = "0.1.13";
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerRemoteConfig(firebaseInstance) {
	    firebaseInstance.INTERNAL.registerComponent(new component.Component('remoteConfig', remoteConfigFactory, "PUBLIC" /* PUBLIC */).setMultipleInstances(true));
	    firebaseInstance.registerVersion(name, version);
	    function remoteConfigFactory(container, namespace) {
	        /* Dependencies */
	        // getImmediate for FirebaseApp will always succeed
	        var app = container.getProvider('app').getImmediate();
	        // The following call will always succeed because rc has `import '@firebase/installations'`
	        var installations = container.getProvider('installations').getImmediate();
	        // Guards against the SDK being used in non-browser environments.
	        if (typeof window === 'undefined') {
	            throw ERROR_FACTORY.create("registration-window" /* REGISTRATION_WINDOW */);
	        }
	        // Normalizes optional inputs.
	        var _a = app.options, projectId = _a.projectId, apiKey = _a.apiKey, appId = _a.appId;
	        if (!projectId) {
	            throw ERROR_FACTORY.create("registration-project-id" /* REGISTRATION_PROJECT_ID */);
	        }
	        if (!apiKey) {
	            throw ERROR_FACTORY.create("registration-api-key" /* REGISTRATION_API_KEY */);
	        }
	        if (!appId) {
	            throw ERROR_FACTORY.create("registration-app-id" /* REGISTRATION_APP_ID */);
	        }
	        namespace = namespace || 'firebase';
	        var storage = new Storage(appId, app.name, namespace);
	        var storageCache = new StorageCache(storage);
	        var logger$1 = new logger.Logger(name);
	        // Sets ERROR as the default log level.
	        // See RemoteConfig#setLogLevel for corresponding normalization to ERROR log level.
	        logger$1.logLevel = logger.LogLevel.ERROR;
	        var restClient = new RestClient(installations, 
	        // Uses the JS SDK version, by which the RC package version can be deduced, if necessary.
	        firebaseInstance.SDK_VERSION, namespace, projectId, apiKey, appId);
	        var retryingClient = new RetryingClient(restClient, storage);
	        var cachingClient = new CachingClient(retryingClient, storage, storageCache, logger$1);
	        var remoteConfigInstance = new RemoteConfig(app, cachingClient, storageCache, storage, logger$1);
	        // Starts warming cache.
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        remoteConfigInstance.ensureInitialized();
	        return remoteConfigInstance;
	    }
	}
	registerRemoteConfig(firebase);
	
	exports.registerRemoteConfig = registerRemoteConfig;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	var tslib = __webpack_require__(11);
	var component = __webpack_require__(12);
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Constants used in the Firebase Storage library.
	 */
	/**
	 * Domain name for firebase storage.
	 */
	var DEFAULT_HOST = 'firebasestorage.googleapis.com';
	/**
	 * The key in Firebase config json for the storage bucket.
	 */
	var CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
	/**
	 * 2 minutes
	 *
	 * The timeout for all operations except upload.
	 */
	var DEFAULT_MAX_OPERATION_RETRY_TIME = 2 * 60 * 1000;
	/**
	 * 10 minutes
	 *
	 * The timeout for upload.
	 */
	var DEFAULT_MAX_UPLOAD_RETRY_TIME = 10 * 60 * 1000;
	/**
	 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
	 * enough for us to use it directly.
	 */
	var MIN_SAFE_INTEGER = -9007199254740991;
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var FirebaseStorageError = /** @class */ (function () {
	    function FirebaseStorageError(code, message) {
	        this.code_ = prependCode(code);
	        this.message_ = 'Firebase Storage: ' + message;
	        this.serverResponse_ = null;
	        this.name_ = 'FirebaseError';
	    }
	    FirebaseStorageError.prototype.codeProp = function () {
	        return this.code;
	    };
	    FirebaseStorageError.prototype.codeEquals = function (code) {
	        return prependCode(code) === this.codeProp();
	    };
	    FirebaseStorageError.prototype.serverResponseProp = function () {
	        return this.serverResponse_;
	    };
	    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
	        this.serverResponse_ = serverResponse;
	    };
	    Object.defineProperty(FirebaseStorageError.prototype, "name", {
	        get: function () {
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "code", {
	        get: function () {
	            return this.code_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "message", {
	        get: function () {
	            return this.message_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
	        get: function () {
	            return this.serverResponse_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return FirebaseStorageError;
	}());
	var Code = {
	    // Shared between all platforms
	    UNKNOWN: 'unknown',
	    OBJECT_NOT_FOUND: 'object-not-found',
	    BUCKET_NOT_FOUND: 'bucket-not-found',
	    PROJECT_NOT_FOUND: 'project-not-found',
	    QUOTA_EXCEEDED: 'quota-exceeded',
	    UNAUTHENTICATED: 'unauthenticated',
	    UNAUTHORIZED: 'unauthorized',
	    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
	    INVALID_CHECKSUM: 'invalid-checksum',
	    CANCELED: 'canceled',
	    // JS specific
	    INVALID_EVENT_NAME: 'invalid-event-name',
	    INVALID_URL: 'invalid-url',
	    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
	    NO_DEFAULT_BUCKET: 'no-default-bucket',
	    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
	    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
	    NO_DOWNLOAD_URL: 'no-download-url',
	    INVALID_ARGUMENT: 'invalid-argument',
	    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
	    APP_DELETED: 'app-deleted',
	    INVALID_ROOT_OPERATION: 'invalid-root-operation',
	    INVALID_FORMAT: 'invalid-format',
	    INTERNAL_ERROR: 'internal-error'
	};
	function prependCode(code) {
	    return 'storage/' + code;
	}
	function unknown() {
	    var message = 'An unknown error occurred, please check the error payload for ' +
	        'server response.';
	    return new FirebaseStorageError(Code.UNKNOWN, message);
	}
	function objectNotFound(path) {
	    return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
	}
	function quotaExceeded(bucket) {
	    return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" +
	        bucket +
	        "' exceeded, please view quota on " +
	        'https://firebase.google.com/pricing/.');
	}
	function unauthenticated() {
	    var message = 'User is not authenticated, please authenticate using Firebase ' +
	        'Authentication and try again.';
	    return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
	}
	function unauthorized(path) {
	    return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
	}
	function retryLimitExceeded() {
	    return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
	}
	function canceled() {
	    return new FirebaseStorageError(Code.CANCELED, 'User canceled the upload/download.');
	}
	function invalidUrl(url) {
	    return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
	}
	function invalidDefaultBucket(bucket) {
	    return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
	}
	function noDefaultBucket() {
	    return new FirebaseStorageError(Code.NO_DEFAULT_BUCKET, 'No default bucket ' +
	        "found. Did you set the '" +
	        CONFIG_STORAGE_BUCKET_KEY +
	        "' property when initializing the app?");
	}
	function cannotSliceBlob() {
	    return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
	}
	function serverFileWrongSize() {
	    return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
	}
	function noDownloadURL() {
	    return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
	}
	function invalidArgument(index, fnName, message) {
	    return new FirebaseStorageError(Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
	}
	function invalidArgumentCount(argMin, argMax, fnName, real) {
	    var countPart;
	    var plural;
	    if (argMin === argMax) {
	        countPart = argMin;
	        plural = argMin === 1 ? 'argument' : 'arguments';
	    }
	    else {
	        countPart = 'between ' + argMin + ' and ' + argMax;
	        plural = 'arguments';
	    }
	    return new FirebaseStorageError(Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
	        fnName +
	        '`: Expected ' +
	        countPart +
	        ' ' +
	        plural +
	        ', received ' +
	        real +
	        '.');
	}
	function appDeleted() {
	    return new FirebaseStorageError(Code.APP_DELETED, 'The Firebase app was deleted.');
	}
	/**
	 * @param name The name of the operation that was invalid.
	 */
	function invalidRootOperation(name) {
	    return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" +
	        name +
	        "' cannot be performed on a root reference, create a non-root " +
	        "reference using child, such as .child('file.png').");
	}
	/**
	 * @param format The format that was not valid.
	 * @param message A message describing the format violation.
	 */
	function invalidFormat(format, message) {
	    return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
	}
	/**
	 * @param message A message describing the internal error.
	 */
	function internalError(message) {
	    throw new FirebaseStorageError(Code.INTERNAL_ERROR, 'Internal error: ' + message);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var StringFormat = {
	    RAW: 'raw',
	    BASE64: 'base64',
	    BASE64URL: 'base64url',
	    DATA_URL: 'data_url'
	};
	function formatValidator(stringFormat) {
	    switch (stringFormat) {
	        case StringFormat.RAW:
	        case StringFormat.BASE64:
	        case StringFormat.BASE64URL:
	        case StringFormat.DATA_URL:
	            return;
	        default:
	            throw 'Expected one of the event types: [' +
	                StringFormat.RAW +
	                ', ' +
	                StringFormat.BASE64 +
	                ', ' +
	                StringFormat.BASE64URL +
	                ', ' +
	                StringFormat.DATA_URL +
	                '].';
	    }
	}
	/**
	 * @struct
	 */
	var StringData = /** @class */ (function () {
	    function StringData(data, contentType) {
	        this.data = data;
	        this.contentType = contentType || null;
	    }
	    return StringData;
	}());
	function dataFromString(format, stringData) {
	    switch (format) {
	        case StringFormat.RAW:
	            return new StringData(utf8Bytes_(stringData));
	        case StringFormat.BASE64:
	        case StringFormat.BASE64URL:
	            return new StringData(base64Bytes_(format, stringData));
	        case StringFormat.DATA_URL:
	            return new StringData(dataURLBytes_(stringData), dataURLContentType_(stringData));
	        // do nothing
	    }
	    // assert(false);
	    throw unknown();
	}
	function utf8Bytes_(value) {
	    var b = [];
	    for (var i = 0; i < value.length; i++) {
	        var c = value.charCodeAt(i);
	        if (c <= 127) {
	            b.push(c);
	        }
	        else {
	            if (c <= 2047) {
	                b.push(192 | (c >> 6), 128 | (c & 63));
	            }
	            else {
	                if ((c & 64512) === 55296) {
	                    // The start of a surrogate pair.
	                    var valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
	                    if (!valid) {
	                        // The second surrogate wasn't there.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        var hi = c;
	                        var lo = value.charCodeAt(++i);
	                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
	                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	                else {
	                    if ((c & 64512) === 56320) {
	                        // Invalid low surrogate.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	            }
	        }
	    }
	    return new Uint8Array(b);
	}
	function percentEncodedBytes_(value) {
	    var decoded;
	    try {
	        decoded = decodeURIComponent(value);
	    }
	    catch (e) {
	        throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
	    }
	    return utf8Bytes_(decoded);
	}
	function base64Bytes_(format, value) {
	    switch (format) {
	        case StringFormat.BASE64: {
	            var hasMinus = value.indexOf('-') !== -1;
	            var hasUnder = value.indexOf('_') !== -1;
	            if (hasMinus || hasUnder) {
	                var invalidChar = hasMinus ? '-' : '_';
	                throw invalidFormat(format, "Invalid character '" +
	                    invalidChar +
	                    "' found: is it base64url encoded?");
	            }
	            break;
	        }
	        case StringFormat.BASE64URL: {
	            var hasPlus = value.indexOf('+') !== -1;
	            var hasSlash = value.indexOf('/') !== -1;
	            if (hasPlus || hasSlash) {
	                var invalidChar = hasPlus ? '+' : '/';
	                throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
	            }
	            value = value.replace(/-/g, '+').replace(/_/g, '/');
	            break;
	        }
	        // do nothing
	    }
	    var bytes;
	    try {
	        bytes = atob(value);
	    }
	    catch (e) {
	        throw invalidFormat(format, 'Invalid character found');
	    }
	    var array = new Uint8Array(bytes.length);
	    for (var i = 0; i < bytes.length; i++) {
	        array[i] = bytes.charCodeAt(i);
	    }
	    return array;
	}
	/**
	 * @struct
	 */
	var DataURLParts = /** @class */ (function () {
	    function DataURLParts(dataURL) {
	        this.base64 = false;
	        this.contentType = null;
	        var matches = dataURL.match(/^data:([^,]+)?,/);
	        if (matches === null) {
	            throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
	        }
	        var middle = matches[1] || null;
	        if (middle != null) {
	            this.base64 = endsWith(middle, ';base64');
	            this.contentType = this.base64
	                ? middle.substring(0, middle.length - ';base64'.length)
	                : middle;
	        }
	        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
	    }
	    return DataURLParts;
	}());
	function dataURLBytes_(dataUrl) {
	    var parts = new DataURLParts(dataUrl);
	    if (parts.base64) {
	        return base64Bytes_(StringFormat.BASE64, parts.rest);
	    }
	    else {
	        return percentEncodedBytes_(parts.rest);
	    }
	}
	function dataURLContentType_(dataUrl) {
	    var parts = new DataURLParts(dataUrl);
	    return parts.contentType;
	}
	function endsWith(s, end) {
	    var longEnough = s.length >= end.length;
	    if (!longEnough) {
	        return false;
	    }
	    return s.substring(s.length - end.length) === end;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TaskEvent = {
	    /** Triggered whenever the task changes or progress is updated. */
	    STATE_CHANGED: 'state_changed'
	};
	var InternalTaskState = {
	    RUNNING: 'running',
	    PAUSING: 'pausing',
	    PAUSED: 'paused',
	    SUCCESS: 'success',
	    CANCELING: 'canceling',
	    CANCELED: 'canceled',
	    ERROR: 'error'
	};
	var TaskState = {
	    /** The task is currently transferring data. */
	    RUNNING: 'running',
	    /** The task was paused by the user. */
	    PAUSED: 'paused',
	    /** The task completed successfully. */
	    SUCCESS: 'success',
	    /** The task was canceled. */
	    CANCELED: 'canceled',
	    /** The task failed with an error. */
	    ERROR: 'error'
	};
	function taskStateFromInternalTaskState(state) {
	    switch (state) {
	        case InternalTaskState.RUNNING:
	        case InternalTaskState.PAUSING:
	        case InternalTaskState.CANCELING:
	            return TaskState.RUNNING;
	        case InternalTaskState.PAUSED:
	            return TaskState.PAUSED;
	        case InternalTaskState.SUCCESS:
	            return TaskState.SUCCESS;
	        case InternalTaskState.CANCELED:
	            return TaskState.CANCELED;
	        case InternalTaskState.ERROR:
	            return TaskState.ERROR;
	        default:
	            // TODO(andysoto): assert(false);
	            return TaskState.ERROR;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @return False if the object is undefined or null, true otherwise.
	 */
	function isDef(p) {
	    return p != null;
	}
	function isJustDef(p) {
	    return p !== void 0;
	}
	function isFunction(p) {
	    return typeof p === 'function';
	}
	function isObject(p) {
	    return typeof p === 'object';
	}
	function isNonNullObject(p) {
	    return isObject(p) && p !== null;
	}
	function isNonArrayObject(p) {
	    return isObject(p) && !Array.isArray(p);
	}
	function isString(p) {
	    return typeof p === 'string' || p instanceof String;
	}
	function isInteger(p) {
	    return isNumber(p) && Number.isInteger(p);
	}
	function isNumber(p) {
	    return typeof p === 'number' || p instanceof Number;
	}
	function isNativeBlob(p) {
	    return isNativeBlobDefined() && p instanceof Blob;
	}
	function isNativeBlobDefined() {
	    return typeof Blob !== 'undefined';
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @enum{number}
	 */
	var ErrorCode;
	(function (ErrorCode) {
	    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
	    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
	    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
	})(ErrorCode || (ErrorCode = {}));
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
	 * doesn't work in React Native on Android.
	 */
	var NetworkXhrIo = /** @class */ (function () {
	    function NetworkXhrIo() {
	        var _this = this;
	        this.sent_ = false;
	        this.xhr_ = new XMLHttpRequest();
	        this.errorCode_ = ErrorCode.NO_ERROR;
	        this.sendPromise_ = new Promise(function (resolve) {
	            _this.xhr_.addEventListener('abort', function () {
	                _this.errorCode_ = ErrorCode.ABORT;
	                resolve(_this);
	            });
	            _this.xhr_.addEventListener('error', function () {
	                _this.errorCode_ = ErrorCode.NETWORK_ERROR;
	                resolve(_this);
	            });
	            _this.xhr_.addEventListener('load', function () {
	                resolve(_this);
	            });
	        });
	    }
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.send = function (url, method, body, headers) {
	        if (this.sent_) {
	            throw internalError('cannot .send() more than once');
	        }
	        this.sent_ = true;
	        this.xhr_.open(method, url, true);
	        if (isDef(headers)) {
	            for (var key in headers) {
	                if (headers.hasOwnProperty(key)) {
	                    this.xhr_.setRequestHeader(key, headers[key].toString());
	                }
	            }
	        }
	        if (isDef(body)) {
	            this.xhr_.send(body);
	        }
	        else {
	            this.xhr_.send();
	        }
	        return this.sendPromise_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getErrorCode = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getErrorCode() before sending');
	        }
	        return this.errorCode_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getStatus = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getStatus() before sending');
	        }
	        try {
	            return this.xhr_.status;
	        }
	        catch (e) {
	            return -1;
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseText = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getResponseText() before sending');
	        }
	        return this.xhr_.responseText;
	    };
	    /**
	     * Aborts the request.
	     * @override
	     */
	    NetworkXhrIo.prototype.abort = function () {
	        this.xhr_.abort();
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseHeader = function (header) {
	        return this.xhr_.getResponseHeader(header);
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
	        if (isDef(this.xhr_.upload)) {
	            this.xhr_.upload.addEventListener('progress', listener);
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
	        if (isDef(this.xhr_.upload)) {
	            this.xhr_.upload.removeEventListener('progress', listener);
	        }
	    };
	    return NetworkXhrIo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Factory-like class for creating XhrIo instances.
	 */
	var XhrIoPool = /** @class */ (function () {
	    function XhrIoPool() {
	    }
	    XhrIoPool.prototype.createXhrIo = function () {
	        return new NetworkXhrIo();
	    };
	    return XhrIoPool;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getBlobBuilder() {
	    if (typeof BlobBuilder !== 'undefined') {
	        return BlobBuilder;
	    }
	    else if (typeof WebKitBlobBuilder !== 'undefined') {
	        return WebKitBlobBuilder;
	    }
	    else {
	        return undefined;
	    }
	}
	/**
	 * Concatenates one or more values together and converts them to a Blob.
	 *
	 * @param args The values that will make up the resulting blob.
	 * @return The blob.
	 */
	function getBlob() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var BlobBuilder = getBlobBuilder();
	    if (BlobBuilder !== undefined) {
	        var bb = new BlobBuilder();
	        for (var i = 0; i < args.length; i++) {
	            bb.append(args[i]);
	        }
	        return bb.getBlob();
	    }
	    else {
	        if (isNativeBlobDefined()) {
	            return new Blob(args);
	        }
	        else {
	            throw Error("This browser doesn't seem to support creating Blobs");
	        }
	    }
	}
	/**
	 * Slices the blob. The returned blob contains data from the start byte
	 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
	 *
	 * @param blob The blob to be sliced.
	 * @param start Index of the starting byte.
	 * @param end Index of the ending byte.
	 * @return The blob slice or null if not supported.
	 */
	function sliceBlob(blob, start, end) {
	    if (blob.webkitSlice) {
	        return blob.webkitSlice(start, end);
	    }
	    else if (blob.mozSlice) {
	        return blob.mozSlice(start, end);
	    }
	    else if (blob.slice) {
	        return blob.slice(start, end);
	    }
	    return null;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param opt_elideCopy If true, doesn't copy mutable input data
	 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
	 *     modified after this blob's construction.
	 */
	var FbsBlob = /** @class */ (function () {
	    function FbsBlob(data, elideCopy) {
	        var size = 0;
	        var blobType = '';
	        if (isNativeBlob(data)) {
	            this.data_ = data;
	            size = data.size;
	            blobType = data.type;
	        }
	        else if (data instanceof ArrayBuffer) {
	            if (elideCopy) {
	                this.data_ = new Uint8Array(data);
	            }
	            else {
	                this.data_ = new Uint8Array(data.byteLength);
	                this.data_.set(new Uint8Array(data));
	            }
	            size = this.data_.length;
	        }
	        else if (data instanceof Uint8Array) {
	            if (elideCopy) {
	                this.data_ = data;
	            }
	            else {
	                this.data_ = new Uint8Array(data.length);
	                this.data_.set(data);
	            }
	            size = data.length;
	        }
	        this.size_ = size;
	        this.type_ = blobType;
	    }
	    FbsBlob.prototype.size = function () {
	        return this.size_;
	    };
	    FbsBlob.prototype.type = function () {
	        return this.type_;
	    };
	    FbsBlob.prototype.slice = function (startByte, endByte) {
	        if (isNativeBlob(this.data_)) {
	            var realBlob = this.data_;
	            var sliced = sliceBlob(realBlob, startByte, endByte);
	            if (sliced === null) {
	                return null;
	            }
	            return new FbsBlob(sliced);
	        }
	        else {
	            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
	            return new FbsBlob(slice, true);
	        }
	    };
	    FbsBlob.getBlob = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (isNativeBlobDefined()) {
	            var blobby = args.map(function (val) {
	                if (val instanceof FbsBlob) {
	                    return val.data_;
	                }
	                else {
	                    return val;
	                }
	            });
	            return new FbsBlob(getBlob.apply(null, blobby));
	        }
	        else {
	            var uint8Arrays = args.map(function (val) {
	                if (isString(val)) {
	                    return dataFromString(StringFormat.RAW, val).data;
	                }
	                else {
	                    // Blobs don't exist, so this has to be a Uint8Array.
	                    return val.data_;
	                }
	            });
	            var finalLength_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                finalLength_1 += array.byteLength;
	            });
	            var merged_1 = new Uint8Array(finalLength_1);
	            var index_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                for (var i = 0; i < array.length; i++) {
	                    merged_1[index_1++] = array[i];
	                }
	            });
	            return new FbsBlob(merged_1, true);
	        }
	    };
	    FbsBlob.prototype.uploadData = function () {
	        return this.data_;
	    };
	    return FbsBlob;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 */
	var Location = /** @class */ (function () {
	    function Location(bucket, path) {
	        this.bucket = bucket;
	        this.path_ = path;
	    }
	    Object.defineProperty(Location.prototype, "path", {
	        get: function () {
	            return this.path_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Location.prototype, "isRoot", {
	        get: function () {
	            return this.path.length === 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Location.prototype.fullServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
	    };
	    Location.prototype.bucketOnlyServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o';
	    };
	    Location.makeFromBucketSpec = function (bucketString) {
	        var bucketLocation;
	        try {
	            bucketLocation = Location.makeFromUrl(bucketString);
	        }
	        catch (e) {
	            // Not valid URL, use as-is. This lets you put bare bucket names in
	            // config.
	            return new Location(bucketString, '');
	        }
	        if (bucketLocation.path === '') {
	            return bucketLocation;
	        }
	        else {
	            throw invalidDefaultBucket(bucketString);
	        }
	    };
	    Location.makeFromUrl = function (url) {
	        var location = null;
	        var bucketDomain = '([A-Za-z0-9.\\-_]+)';
	        function gsModify(loc) {
	            if (loc.path.charAt(loc.path.length - 1) === '/') {
	                loc.path_ = loc.path_.slice(0, -1);
	            }
	        }
	        var gsPath = '(/(.*))?$';
	        var path = '(/([^?#]*).*)?$';
	        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
	        var gsIndices = { bucket: 1, path: 3 };
	        function httpModify(loc) {
	            loc.path_ = decodeURIComponent(loc.path);
	        }
	        var version = 'v[A-Za-z0-9_]+';
	        var hostRegex = DEFAULT_HOST.replace(/[.]/g, '\\.');
	        var httpRegex = new RegExp("^https?://" + hostRegex + "/" + version + "/b/" + bucketDomain + "/o" + path, 'i');
	        var httpIndices = { bucket: 1, path: 3 };
	        var groups = [
	            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
	            { regex: httpRegex, indices: httpIndices, postModify: httpModify }
	        ];
	        for (var i = 0; i < groups.length; i++) {
	            var group = groups[i];
	            var captures = group.regex.exec(url);
	            if (captures) {
	                var bucketValue = captures[group.indices.bucket];
	                var pathValue = captures[group.indices.path];
	                if (!pathValue) {
	                    pathValue = '';
	                }
	                location = new Location(bucketValue, pathValue);
	                group.postModify(location);
	                break;
	            }
	        }
	        if (location == null) {
	            throw invalidUrl(url);
	        }
	        return location;
	    };
	    return Location;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns the Object resulting from parsing the given JSON, or null if the
	 * given string does not represent a JSON object.
	 */
	function jsonObjectOrNull(s) {
	    var obj;
	    try {
	        obj = JSON.parse(s);
	    }
	    catch (e) {
	        return null;
	    }
	    if (isNonArrayObject(obj)) {
	        return obj;
	    }
	    else {
	        return null;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Contains helper methods for manipulating paths.
	 */
	/**
	 * @return Null if the path is already at the root.
	 */
	function parent(path) {
	    if (path.length === 0) {
	        return null;
	    }
	    var index = path.lastIndexOf('/');
	    if (index === -1) {
	        return '';
	    }
	    var newPath = path.slice(0, index);
	    return newPath;
	}
	function child(path, childPath) {
	    var canonicalChildPath = childPath
	        .split('/')
	        .filter(function (component) { return component.length > 0; })
	        .join('/');
	    if (path.length === 0) {
	        return canonicalChildPath;
	    }
	    else {
	        return path + '/' + canonicalChildPath;
	    }
	}
	/**
	 * Returns the last component of a path.
	 * '/foo/bar' -> 'bar'
	 * '/foo/bar/baz/' -> 'baz/'
	 * '/a' -> 'a'
	 */
	function lastComponent(path) {
	    var index = path.lastIndexOf('/', path.length - 2);
	    if (index === -1) {
	        return path;
	    }
	    else {
	        return path.slice(index + 1);
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function makeUrl(urlPart) {
	    return "https://" + DEFAULT_HOST + "/v0" + urlPart;
	}
	function makeQueryString(params) {
	    var encode = encodeURIComponent;
	    var queryPart = '?';
	    for (var key in params) {
	        if (params.hasOwnProperty(key)) {
	            // @ts-ignore TODO: remove once typescript is upgraded to 3.5.x
	            var nextPart = encode(key) + '=' + encode(params[key]);
	            queryPart = queryPart + nextPart + '&';
	        }
	    }
	    // Chop off the extra '&' or '?' on the end
	    queryPart = queryPart.slice(0, -1);
	    return queryPart;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function noXform_(metadata, value) {
	    return value;
	}
	/**
	 * @struct
	 */
	var Mapping = /** @class */ (function () {
	    function Mapping(server, local, writable, xform) {
	        this.server = server;
	        this.local = local || server;
	        this.writable = !!writable;
	        this.xform = xform || noXform_;
	    }
	    return Mapping;
	}());
	var mappings_ = null;
	function xformPath(fullPath) {
	    if (!isString(fullPath) || fullPath.length < 2) {
	        return fullPath;
	    }
	    else {
	        return lastComponent(fullPath);
	    }
	}
	function getMappings() {
	    if (mappings_) {
	        return mappings_;
	    }
	    var mappings = [];
	    mappings.push(new Mapping('bucket'));
	    mappings.push(new Mapping('generation'));
	    mappings.push(new Mapping('metageneration'));
	    mappings.push(new Mapping('name', 'fullPath', true));
	    function mappingsXformPath(_metadata, fullPath) {
	        return xformPath(fullPath);
	    }
	    var nameMapping = new Mapping('name');
	    nameMapping.xform = mappingsXformPath;
	    mappings.push(nameMapping);
	    /**
	     * Coerces the second param to a number, if it is defined.
	     */
	    function xformSize(_metadata, size) {
	        if (isDef(size)) {
	            return Number(size);
	        }
	        else {
	            return size;
	        }
	    }
	    var sizeMapping = new Mapping('size');
	    sizeMapping.xform = xformSize;
	    mappings.push(sizeMapping);
	    mappings.push(new Mapping('timeCreated'));
	    mappings.push(new Mapping('updated'));
	    mappings.push(new Mapping('md5Hash', null, true));
	    mappings.push(new Mapping('cacheControl', null, true));
	    mappings.push(new Mapping('contentDisposition', null, true));
	    mappings.push(new Mapping('contentEncoding', null, true));
	    mappings.push(new Mapping('contentLanguage', null, true));
	    mappings.push(new Mapping('contentType', null, true));
	    mappings.push(new Mapping('metadata', 'customMetadata', true));
	    mappings_ = mappings;
	    return mappings_;
	}
	function addRef(metadata, authWrapper) {
	    function generateRef() {
	        var bucket = metadata['bucket'];
	        var path = metadata['fullPath'];
	        var loc = new Location(bucket, path);
	        return authWrapper.makeStorageReference(loc);
	    }
	    Object.defineProperty(metadata, 'ref', { get: generateRef });
	}
	function fromResource(authWrapper, resource, mappings) {
	    var metadata = {};
	    metadata['type'] = 'file';
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
	    }
	    addRef(metadata, authWrapper);
	    return metadata;
	}
	function fromResourceString(authWrapper, resourceString, mappings) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    var resource = obj;
	    return fromResource(authWrapper, resource, mappings);
	}
	function downloadUrlFromResourceString(metadata, resourceString) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    if (!isString(obj['downloadTokens'])) {
	        // This can happen if objects are uploaded through GCS and retrieved
	        // through list, so we don't want to throw an Error.
	        return null;
	    }
	    var tokens = obj['downloadTokens'];
	    if (tokens.length === 0) {
	        return null;
	    }
	    var encode = encodeURIComponent;
	    var tokensList = tokens.split(',');
	    var urls = tokensList.map(function (token) {
	        var bucket = metadata['bucket'];
	        var path = metadata['fullPath'];
	        var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
	        var base = makeUrl(urlPart);
	        var queryString = makeQueryString({
	            alt: 'media',
	            token: token
	        });
	        return base + queryString;
	    });
	    return urls[0];
	}
	function toResourceString(metadata, mappings) {
	    var resource = {};
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        if (mapping.writable) {
	            resource[mapping.server] = metadata[mapping.local];
	        }
	    }
	    return JSON.stringify(resource);
	}
	function metadataValidator(p) {
	    if (!isObject(p) || !p) {
	        throw 'Expected Metadata object.';
	    }
	    for (var key in p) {
	        if (p.hasOwnProperty(key)) {
	            var val = p[key];
	            if (key === 'customMetadata') {
	                if (!isObject(val)) {
	                    throw 'Expected object for \'customMetadata\' mapping.';
	                }
	            }
	            else {
	                if (isNonNullObject(val)) {
	                    throw "Mapping for '" + key + "' cannot be an object.";
	                }
	            }
	        }
	    }
	}
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MAX_RESULTS_KEY = 'maxResults';
	var MAX_MAX_RESULTS = 1000;
	var PAGE_TOKEN_KEY = 'pageToken';
	var PREFIXES_KEY = 'prefixes';
	var ITEMS_KEY = 'items';
	function fromBackendResponse(authWrapper, resource) {
	    var listResult = {
	        prefixes: [],
	        items: [],
	        nextPageToken: resource['nextPageToken']
	    };
	    var bucket = authWrapper.bucket();
	    if (bucket === null) {
	        throw noDefaultBucket();
	    }
	    if (resource[PREFIXES_KEY]) {
	        for (var _i = 0, _a = resource[PREFIXES_KEY]; _i < _a.length; _i++) {
	            var path = _a[_i];
	            var pathWithoutTrailingSlash = path.replace(/\/$/, '');
	            var reference = authWrapper.makeStorageReference(new Location(bucket, pathWithoutTrailingSlash));
	            listResult.prefixes.push(reference);
	        }
	    }
	    if (resource[ITEMS_KEY]) {
	        for (var _b = 0, _c = resource[ITEMS_KEY]; _b < _c.length; _b++) {
	            var item = _c[_b];
	            var reference = authWrapper.makeStorageReference(new Location(bucket, item['name']));
	            listResult.items.push(reference);
	        }
	    }
	    return listResult;
	}
	function fromResponseString(authWrapper, resourceString) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    var resource = obj;
	    return fromBackendResponse(authWrapper, resource);
	}
	function listOptionsValidator(p) {
	    if (!isObject(p) || !p) {
	        throw 'Expected ListOptions object.';
	    }
	    for (var key in p) {
	        if (key === MAX_RESULTS_KEY) {
	            if (!isInteger(p[MAX_RESULTS_KEY]) ||
	                p[MAX_RESULTS_KEY] <= 0) {
	                throw 'Expected maxResults to be a positive number.';
	            }
	            if (p[MAX_RESULTS_KEY] > 1000) {
	                throw "Expected maxResults to be less than or equal to " + MAX_MAX_RESULTS + ".";
	            }
	        }
	        else if (key === PAGE_TOKEN_KEY) {
	            if (p[PAGE_TOKEN_KEY] && !isString(p[PAGE_TOKEN_KEY])) {
	                throw 'Expected pageToken to be string.';
	            }
	        }
	        else {
	            throw 'Unknown option: ' + key;
	        }
	    }
	}
	
	var RequestInfo = /** @class */ (function () {
	    function RequestInfo(url, method, 
	    /**
	     * Returns the value with which to resolve the request's promise. Only called
	     * if the request is successful. Throw from this function to reject the
	     * returned Request's promise with the thrown error.
	     * Note: The XhrIo passed to this function may be reused after this callback
	     * returns. Do not keep a reference to it in any way.
	     */
	    handler, timeout) {
	        this.url = url;
	        this.method = method;
	        this.handler = handler;
	        this.timeout = timeout;
	        this.urlParams = {};
	        this.headers = {};
	        this.body = null;
	        this.errorHandler = null;
	        /**
	         * Called with the current number of bytes uploaded and total size (-1 if not
	         * computable) of the request body (i.e. used to report upload progress).
	         */
	        this.progressCallback = null;
	        this.successCodes = [200];
	        this.additionalRetryCodes = [];
	    }
	    return RequestInfo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
	 */
	function handlerCheck(cndn) {
	    if (!cndn) {
	        throw unknown();
	    }
	}
	function metadataHandler(authWrapper, mappings) {
	    function handler(xhr, text) {
	        var metadata = fromResourceString(authWrapper, text, mappings);
	        handlerCheck(metadata !== null);
	        return metadata;
	    }
	    return handler;
	}
	function listHandler(authWrapper) {
	    function handler(xhr, text) {
	        var listResult = fromResponseString(authWrapper, text);
	        handlerCheck(listResult !== null);
	        return listResult;
	    }
	    return handler;
	}
	function downloadUrlHandler(authWrapper, mappings) {
	    function handler(xhr, text) {
	        var metadata = fromResourceString(authWrapper, text, mappings);
	        handlerCheck(metadata !== null);
	        return downloadUrlFromResourceString(metadata, text);
	    }
	    return handler;
	}
	function sharedErrorHandler(location) {
	    function errorHandler(xhr, err) {
	        var newErr;
	        if (xhr.getStatus() === 401) {
	            newErr = unauthenticated();
	        }
	        else {
	            if (xhr.getStatus() === 402) {
	                newErr = quotaExceeded(location.bucket);
	            }
	            else {
	                if (xhr.getStatus() === 403) {
	                    newErr = unauthorized(location.path);
	                }
	                else {
	                    newErr = err;
	                }
	            }
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	function objectErrorHandler(location) {
	    var shared = sharedErrorHandler(location);
	    function errorHandler(xhr, err) {
	        var newErr = shared(xhr, err);
	        if (xhr.getStatus() === 404) {
	            newErr = objectNotFound(location.path);
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	function getMetadata(authWrapper, location, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'GET';
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function list(authWrapper, location, delimiter, pageToken, maxResults) {
	    var urlParams = {};
	    if (location.isRoot) {
	        urlParams['prefix'] = '';
	    }
	    else {
	        urlParams['prefix'] = location.path + '/';
	    }
	    if (delimiter && delimiter.length > 0) {
	        urlParams['delimiter'] = delimiter;
	    }
	    if (pageToken) {
	        urlParams['pageToken'] = pageToken;
	    }
	    if (maxResults) {
	        urlParams['maxResults'] = maxResults;
	    }
	    var urlPart = location.bucketOnlyServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'GET';
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, listHandler(authWrapper), timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	function getDownloadUrl(authWrapper, location, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'GET';
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, downloadUrlHandler(authWrapper, mappings), timeout);
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function updateMetadata(authWrapper, location, metadata, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'PATCH';
	    var body = toResourceString(metadata, mappings);
	    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function deleteObject(authWrapper, location) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'DELETE';
	    var timeout = authWrapper.maxOperationRetryTime();
	    function handler(_xhr, _text) { }
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.successCodes = [200, 204];
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function determineContentType_(metadata, blob) {
	    return ((metadata && metadata['contentType']) ||
	        (blob && blob.type()) ||
	        'application/octet-stream');
	}
	function metadataForUpload_(location, blob, metadata) {
	    var metadataClone = Object.assign({}, metadata);
	    metadataClone['fullPath'] = location.path;
	    metadataClone['size'] = blob.size();
	    if (!metadataClone['contentType']) {
	        metadataClone['contentType'] = determineContentType_(null, blob);
	    }
	    return metadataClone;
	}
	function multipartUpload(authWrapper, location, mappings, blob, metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var headers = {
	        'X-Goog-Upload-Protocol': 'multipart'
	    };
	    function genBoundary() {
	        var str = '';
	        for (var i = 0; i < 2; i++) {
	            str =
	                str +
	                    Math.random()
	                        .toString()
	                        .slice(2);
	        }
	        return str;
	    }
	    var boundary = genBoundary();
	    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
	    var metadata_ = metadataForUpload_(location, blob, metadata);
	    var metadataString = toResourceString(metadata_, mappings);
	    var preBlobPart = '--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
	        metadataString +
	        '\r\n--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: ' +
	        metadata_['contentType'] +
	        '\r\n\r\n';
	    var postBlobPart = '\r\n--' + boundary + '--';
	    var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
	    if (body === null) {
	        throw cannotSliceBlob();
	    }
	    var urlParams = { name: metadata_['fullPath'] };
	    var url = makeUrl(urlPart);
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * @param current The number of bytes that have been uploaded so far.
	 * @param total The total number of bytes in the upload.
	 * @param opt_finalized True if the server has finished the upload.
	 * @param opt_metadata The upload metadata, should
	 *     only be passed if opt_finalized is true.
	 * @struct
	 */
	var ResumableUploadStatus = /** @class */ (function () {
	    function ResumableUploadStatus(current, total, finalized, metadata) {
	        this.current = current;
	        this.total = total;
	        this.finalized = !!finalized;
	        this.metadata = metadata || null;
	    }
	    return ResumableUploadStatus;
	}());
	function checkResumeHeader_(xhr, allowed) {
	    var status = null;
	    try {
	        status = xhr.getResponseHeader('X-Goog-Upload-Status');
	    }
	    catch (e) {
	        handlerCheck(false);
	    }
	    var allowedStatus = allowed || ['active'];
	    handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
	    return status;
	}
	function createResumableUpload(authWrapper, location, mappings, blob, metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var metadataForUpload = metadataForUpload_(location, blob, metadata);
	    var urlParams = { name: metadataForUpload['fullPath'] };
	    var url = makeUrl(urlPart);
	    var method = 'POST';
	    var headers = {
	        'X-Goog-Upload-Protocol': 'resumable',
	        'X-Goog-Upload-Command': 'start',
	        'X-Goog-Upload-Header-Content-Length': blob.size(),
	        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
	        'Content-Type': 'application/json; charset=utf-8'
	    };
	    var body = toResourceString(metadataForUpload, mappings);
	    var timeout = authWrapper.maxUploadRetryTime();
	    function handler(xhr) {
	        checkResumeHeader_(xhr);
	        var url;
	        try {
	            url = xhr.getResponseHeader('X-Goog-Upload-URL');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        handlerCheck(isString(url));
	        return url;
	    }
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 */
	function getResumableUploadStatus(authWrapper, location, url, blob) {
	    var headers = { 'X-Goog-Upload-Command': 'query' };
	    function handler(xhr) {
	        var status = checkResumeHeader_(xhr, ['active', 'final']);
	        var sizeString = null;
	        try {
	            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        if (!sizeString) {
	            // null or empty string
	            handlerCheck(false);
	        }
	        var size = Number(sizeString);
	        handlerCheck(!isNaN(size));
	        return new ResumableUploadStatus(size, blob.size(), status === 'final');
	    }
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * Any uploads via the resumable upload API must transfer a number of bytes
	 * that is a multiple of this number.
	 */
	var resumableUploadChunkSize = 256 * 1024;
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 * @param chunkSize Number of bytes to upload.
	 * @param status The previous status.
	 *     If not passed or null, we start from the beginning.
	 * @throws fbs.Error If the upload is already complete, the passed in status
	 *     has a final size inconsistent with the blob, or the blob cannot be sliced
	 *     for upload.
	 */
	function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, status, progressCallback) {
	    // TODO(andysoto): standardize on internal asserts
	    // assert(!(opt_status && opt_status.finalized));
	    var status_ = new ResumableUploadStatus(0, 0);
	    if (status) {
	        status_.current = status.current;
	        status_.total = status.total;
	    }
	    else {
	        status_.current = 0;
	        status_.total = blob.size();
	    }
	    if (blob.size() !== status_.total) {
	        throw serverFileWrongSize();
	    }
	    var bytesLeft = status_.total - status_.current;
	    var bytesToUpload = bytesLeft;
	    if (chunkSize > 0) {
	        bytesToUpload = Math.min(bytesToUpload, chunkSize);
	    }
	    var startByte = status_.current;
	    var endByte = startByte + bytesToUpload;
	    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
	    var headers = {
	        'X-Goog-Upload-Command': uploadCommand,
	        'X-Goog-Upload-Offset': status_.current
	    };
	    var body = blob.slice(startByte, endByte);
	    if (body === null) {
	        throw cannotSliceBlob();
	    }
	    function handler(xhr, text) {
	        // TODO(andysoto): Verify the MD5 of each uploaded range:
	        // the 'x-range-md5' header comes back with status code 308 responses.
	        // We'll only be able to bail out though, because you can't re-upload a
	        // range that you previously uploaded.
	        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
	        var newCurrent = status_.current + bytesToUpload;
	        var size = blob.size();
	        var metadata;
	        if (uploadStatus === 'final') {
	            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
	        }
	        else {
	            metadata = null;
	        }
	        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
	    }
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.progressCallback = progressCallback || null;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 */
	var Observer = /** @class */ (function () {
	    function Observer(nextOrObserver, error, complete) {
	        var asFunctions = isFunction(nextOrObserver) ||
	            isDef(error) ||
	            isDef(complete);
	        if (asFunctions) {
	            this.next = nextOrObserver;
	            this.error = error || null;
	            this.complete = complete || null;
	        }
	        else {
	            var observer = nextOrObserver;
	            this.next = observer.next || null;
	            this.error = observer.error || null;
	            this.complete = observer.complete || null;
	        }
	    }
	    return Observer;
	}());
	
	var UploadTaskSnapshot = /** @class */ (function () {
	    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
	        this.bytesTransferred = bytesTransferred;
	        this.totalBytes = totalBytes;
	        this.state = state;
	        this.metadata = metadata;
	        this.task = task;
	        this.ref = ref;
	    }
	    return UploadTaskSnapshot;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param name Name of the function.
	 * @param specs Argument specs.
	 * @param passed The actual arguments passed to the function.
	 * @throws {fbs.Error} If the arguments are invalid.
	 */
	function validate(name, specs, passed) {
	    var minArgs = specs.length;
	    var maxArgs = specs.length;
	    for (var i = 0; i < specs.length; i++) {
	        if (specs[i].optional) {
	            minArgs = i;
	            break;
	        }
	    }
	    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
	    if (!validLength) {
	        throw invalidArgumentCount(minArgs, maxArgs, name, passed.length);
	    }
	    for (var i = 0; i < passed.length; i++) {
	        try {
	            specs[i].validator(passed[i]);
	        }
	        catch (e) {
	            if (e instanceof Error) {
	                throw invalidArgument(i, name, e.message);
	            }
	            else {
	                throw invalidArgument(i, name, e);
	            }
	        }
	    }
	}
	/**
	 * @struct
	 */
	var ArgSpec = /** @class */ (function () {
	    function ArgSpec(validator, optional) {
	        var self = this;
	        this.validator = function (p) {
	            if (self.optional && !isJustDef(p)) {
	                return;
	            }
	            validator(p);
	        };
	        this.optional = !!optional;
	    }
	    return ArgSpec;
	}());
	function and_(v1, v2) {
	    return function (p) {
	        v1(p);
	        v2(p);
	    };
	}
	function stringSpec(validator, optional) {
	    function stringValidator(p) {
	        if (!isString(p)) {
	            throw 'Expected string.';
	        }
	    }
	    var chainedValidator;
	    if (validator) {
	        chainedValidator = and_(stringValidator, validator);
	    }
	    else {
	        chainedValidator = stringValidator;
	    }
	    return new ArgSpec(chainedValidator, optional);
	}
	function uploadDataSpec() {
	    function validator(p) {
	        var valid = p instanceof Uint8Array ||
	            p instanceof ArrayBuffer ||
	            (isNativeBlobDefined() && p instanceof Blob);
	        if (!valid) {
	            throw 'Expected Blob or File.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	function metadataSpec(optional) {
	    return new ArgSpec(metadataValidator, optional);
	}
	function listOptionSpec(optional) {
	    return new ArgSpec(listOptionsValidator, optional);
	}
	function nonNegativeNumberSpec() {
	    function validator(p) {
	        var valid = isNumber(p) && p >= 0;
	        if (!valid) {
	            throw 'Expected a number 0 or greater.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	function looseObjectSpec(validator, optional) {
	    function isLooseObjectValidator(p) {
	        var isLooseObject = p === null || (isDef(p) && p instanceof Object);
	        if (!isLooseObject) {
	            throw 'Expected an Object.';
	        }
	        if (validator !== undefined && validator !== null) {
	            validator(p);
	        }
	    }
	    return new ArgSpec(isLooseObjectValidator, optional);
	}
	function nullFunctionSpec(optional) {
	    function validator(p) {
	        var valid = p === null || isFunction(p);
	        if (!valid) {
	            throw 'Expected a Function.';
	        }
	    }
	    return new ArgSpec(validator, optional);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a function that invokes f with its arguments asynchronously as a
	 * microtask, i.e. as soon as possible after the current script returns back
	 * into browser code.
	 */
	function async(f) {
	    return function () {
	        var argsToForward = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            argsToForward[_i] = arguments[_i];
	        }
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        Promise.resolve().then(function () { return f.apply(void 0, argsToForward); });
	    };
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
	 * upload and manage callbacks for various events.
	 */
	var UploadTask = /** @class */ (function () {
	    /**
	     * @param ref The firebaseStorage.Reference object this task came
	     *     from, untyped to avoid cyclic dependencies.
	     * @param blob The blob to upload.
	     */
	    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
	        var _this = this;
	        if (metadata === void 0) { metadata = null; }
	        this.transferred_ = 0;
	        this.needToFetchStatus_ = false;
	        this.needToFetchMetadata_ = false;
	        this.observers_ = [];
	        this.error_ = null;
	        this.uploadUrl_ = null;
	        this.request_ = null;
	        this.chunkMultiplier_ = 1;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.ref_ = ref;
	        this.authWrapper_ = authWrapper;
	        this.location_ = location;
	        this.blob_ = blob;
	        this.metadata_ = metadata;
	        this.mappings_ = mappings;
	        this.resumable_ = this.shouldDoResumable_(this.blob_);
	        this.state_ = InternalTaskState.RUNNING;
	        this.errorHandler_ = function (error) {
	            _this.request_ = null;
	            _this.chunkMultiplier_ = 1;
	            if (error.codeEquals(Code.CANCELED)) {
	                _this.needToFetchStatus_ = true;
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(InternalTaskState.ERROR);
	            }
	        };
	        this.metadataErrorHandler_ = function (error) {
	            _this.request_ = null;
	            if (error.codeEquals(Code.CANCELED)) {
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(InternalTaskState.ERROR);
	            }
	        };
	        this.promise_ = new Promise(function (resolve, reject) {
	            _this.resolve_ = resolve;
	            _this.reject_ = reject;
	            _this.start_();
	        });
	        // Prevent uncaught rejections on the internal promise from bubbling out
	        // to the top level with a dummy handler.
	        this.promise_.then(null, function () { });
	    }
	    UploadTask.prototype.makeProgressCallback_ = function () {
	        var _this = this;
	        var sizeBefore = this.transferred_;
	        return function (loaded) { return _this.updateProgress_(sizeBefore + loaded); };
	    };
	    UploadTask.prototype.shouldDoResumable_ = function (blob) {
	        return blob.size() > 256 * 1024;
	    };
	    UploadTask.prototype.start_ = function () {
	        if (this.state_ !== InternalTaskState.RUNNING) {
	            // This can happen if someone pauses us in a resume callback, for example.
	            return;
	        }
	        if (this.request_ !== null) {
	            return;
	        }
	        if (this.resumable_) {
	            if (this.uploadUrl_ === null) {
	                this.createResumable_();
	            }
	            else {
	                if (this.needToFetchStatus_) {
	                    this.fetchStatus_();
	                }
	                else {
	                    if (this.needToFetchMetadata_) {
	                        // Happens if we miss the metadata on upload completion.
	                        this.fetchMetadata_();
	                    }
	                    else {
	                        this.continueUpload_();
	                    }
	                }
	            }
	        }
	        else {
	            this.oneShotUpload_();
	        }
	    };
	    UploadTask.prototype.resolveToken_ = function (callback) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.authWrapper_.getAuthToken().then(function (authToken) {
	            switch (_this.state_) {
	                case InternalTaskState.RUNNING:
	                    callback(authToken);
	                    break;
	                case InternalTaskState.CANCELING:
	                    _this.transition_(InternalTaskState.CANCELED);
	                    break;
	                case InternalTaskState.PAUSING:
	                    _this.transition_(InternalTaskState.PAUSED);
	                    break;
	            }
	        });
	    };
	    // TODO(andysoto): assert false
	    UploadTask.prototype.createResumable_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = createRequest;
	            createRequest.getPromise().then(function (url) {
	                _this.request_ = null;
	                _this.uploadUrl_ = url;
	                _this.needToFetchStatus_ = false;
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.fetchStatus_ = function () {
	        var _this = this;
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
	            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = statusRequest;
	            statusRequest.getPromise().then(function (status) {
	                status = status;
	                _this.request_ = null;
	                _this.updateProgress_(status.current);
	                _this.needToFetchStatus_ = false;
	                if (status.finalized) {
	                    _this.needToFetchMetadata_ = true;
	                }
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.continueUpload_ = function () {
	        var _this = this;
	        var chunkSize = resumableUploadChunkSize * this.chunkMultiplier_;
	        var status = new ResumableUploadStatus(this.transferred_, this.blob_.size());
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo;
	            try {
	                requestInfo = continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
	            }
	            catch (e) {
	                _this.error_ = e;
	                _this.transition_(InternalTaskState.ERROR);
	                return;
	            }
	            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = uploadRequest;
	            uploadRequest
	                .getPromise()
	                .then(function (newStatus) {
	                _this.increaseMultiplier_();
	                _this.request_ = null;
	                _this.updateProgress_(newStatus.current);
	                if (newStatus.finalized) {
	                    _this.metadata_ = newStatus.metadata;
	                    _this.transition_(InternalTaskState.SUCCESS);
	                }
	                else {
	                    _this.completeTransitions_();
	                }
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.increaseMultiplier_ = function () {
	        var currentSize = resumableUploadChunkSize * this.chunkMultiplier_;
	        // Max chunk size is 32M.
	        if (currentSize < 32 * 1024 * 1024) {
	            this.chunkMultiplier_ *= 2;
	        }
	    };
	    UploadTask.prototype.fetchMetadata_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
	            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = metadataRequest;
	            metadataRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.transition_(InternalTaskState.SUCCESS);
	            }, _this.metadataErrorHandler_);
	        });
	    };
	    UploadTask.prototype.oneShotUpload_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = multipartRequest;
	            multipartRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.updateProgress_(_this.blob_.size());
	                _this.transition_(InternalTaskState.SUCCESS);
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.updateProgress_ = function (transferred) {
	        var old = this.transferred_;
	        this.transferred_ = transferred;
	        // A progress update can make the "transferred" value smaller (e.g. a
	        // partial upload not completed by server, after which the "transferred"
	        // value may reset to the value at the beginning of the request).
	        if (this.transferred_ !== old) {
	            this.notifyObservers_();
	        }
	    };
	    UploadTask.prototype.transition_ = function (state) {
	        if (this.state_ === state) {
	            return;
	        }
	        switch (state) {
	            case InternalTaskState.CANCELING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case InternalTaskState.PAUSING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case InternalTaskState.RUNNING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                var wasPaused = this.state_ === InternalTaskState.PAUSED;
	                this.state_ = state;
	                if (wasPaused) {
	                    this.notifyObservers_();
	                    this.start_();
	                }
	                break;
	            case InternalTaskState.PAUSED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.CANCELED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.error_ = canceled();
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.ERROR:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.SUCCESS:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	        }
	    };
	    UploadTask.prototype.completeTransitions_ = function () {
	        switch (this.state_) {
	            case InternalTaskState.PAUSING:
	                this.transition_(InternalTaskState.PAUSED);
	                break;
	            case InternalTaskState.CANCELING:
	                this.transition_(InternalTaskState.CANCELED);
	                break;
	            case InternalTaskState.RUNNING:
	                this.start_();
	                break;
	        }
	    };
	    Object.defineProperty(UploadTask.prototype, "snapshot", {
	        get: function () {
	            var externalState = taskStateFromInternalTaskState(this.state_);
	            return new UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Adds a callback for an event.
	     * @param type The type of event to listen for.
	     */
	    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
	        function typeValidator() {
	            if (type !== TaskEvent.STATE_CHANGED) {
	                throw "Expected one of the event types: [" + TaskEvent.STATE_CHANGED + "].";
	            }
	        }
	        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
	            '`next`, `error`, `complete` properties.';
	        var nextValidator = nullFunctionSpec(true).validator;
	        var observerValidator = looseObjectSpec(null, true).validator;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        function nextOrObserverValidator(p) {
	            try {
	                nextValidator(p);
	                return;
	            }
	            catch (e) { }
	            try {
	                observerValidator(p);
	                var anyDefined = isJustDef(p['next']) ||
	                    isJustDef(p['error']) ||
	                    isJustDef(p['complete']);
	                if (!anyDefined) {
	                    throw '';
	                }
	                return;
	            }
	            catch (e) {
	                throw nextOrObserverMessage;
	            }
	        }
	        var specs = [
	            stringSpec(typeValidator),
	            looseObjectSpec(nextOrObserverValidator, true),
	            nullFunctionSpec(true),
	            nullFunctionSpec(true)
	        ];
	        validate('on', specs, arguments);
	        var self = this;
	        function makeBinder(specs) {
	            function binder(nextOrObserver, error, complete) {
	                if (specs !== null) {
	                    validate('on', specs, arguments);
	                }
	                var observer = new Observer(nextOrObserver, error, completed);
	                self.addObserver_(observer);
	                return function () {
	                    self.removeObserver_(observer);
	                };
	            }
	            return binder;
	        }
	        function binderNextOrObserverValidator(p) {
	            if (p === null) {
	                throw nextOrObserverMessage;
	            }
	            nextOrObserverValidator(p);
	        }
	        var binderSpecs = [
	            looseObjectSpec(binderNextOrObserverValidator),
	            nullFunctionSpec(true),
	            nullFunctionSpec(true)
	        ];
	        var typeOnly = !(isJustDef(nextOrObserver) ||
	            isJustDef(error) ||
	            isJustDef(completed));
	        if (typeOnly) {
	            return makeBinder(binderSpecs);
	        }
	        else {
	            return makeBinder(null)(nextOrObserver, error, completed);
	        }
	    };
	    /**
	     * This object behaves like a Promise, and resolves with its snapshot data
	     * when the upload completes.
	     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
	     * @param onRejected The rejection callback.
	     */
	    UploadTask.prototype.then = function (onFulfilled, onRejected) {
	        // These casts are needed so that TypeScript can infer the types of the
	        // resulting Promise.
	        return this.promise_.then(onFulfilled, onRejected);
	    };
	    /**
	     * Equivalent to calling `then(null, onRejected)`.
	     */
	    UploadTask.prototype.catch = function (onRejected) {
	        return this.then(null, onRejected);
	    };
	    /**
	     * Adds the given observer.
	     */
	    UploadTask.prototype.addObserver_ = function (observer) {
	        this.observers_.push(observer);
	        this.notifyObserver_(observer);
	    };
	    /**
	     * Removes the given observer.
	     */
	    UploadTask.prototype.removeObserver_ = function (observer) {
	        var i = this.observers_.indexOf(observer);
	        if (i !== -1) {
	            this.observers_.splice(i, 1);
	        }
	    };
	    UploadTask.prototype.notifyObservers_ = function () {
	        var _this = this;
	        this.finishPromise_();
	        var observers = this.observers_.slice();
	        observers.forEach(function (observer) {
	            _this.notifyObserver_(observer);
	        });
	    };
	    UploadTask.prototype.finishPromise_ = function () {
	        if (this.resolve_ !== null) {
	            var triggered = true;
	            switch (taskStateFromInternalTaskState(this.state_)) {
	                case TaskState.SUCCESS:
	                    async(this.resolve_.bind(null, this.snapshot))();
	                    break;
	                case TaskState.CANCELED:
	                case TaskState.ERROR:
	                    var toCall = this.reject_;
	                    async(toCall.bind(null, this.error_))();
	                    break;
	                default:
	                    triggered = false;
	                    break;
	            }
	            if (triggered) {
	                this.resolve_ = null;
	                this.reject_ = null;
	            }
	        }
	    };
	    UploadTask.prototype.notifyObserver_ = function (observer) {
	        var externalState = taskStateFromInternalTaskState(this.state_);
	        switch (externalState) {
	            case TaskState.RUNNING:
	            case TaskState.PAUSED:
	                if (observer.next) {
	                    async(observer.next.bind(observer, this.snapshot))();
	                }
	                break;
	            case TaskState.SUCCESS:
	                if (observer.complete) {
	                    async(observer.complete.bind(observer))();
	                }
	                break;
	            case TaskState.CANCELED:
	            case TaskState.ERROR:
	                if (observer.error) {
	                    async(observer.error.bind(observer, this.error_))();
	                }
	                break;
	            default:
	                // TODO(andysoto): assert(false);
	                if (observer.error) {
	                    async(observer.error.bind(observer, this.error_))();
	                }
	        }
	    };
	    /**
	     * Resumes a paused task. Has no effect on a currently running or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.resume = function () {
	        validate('resume', [], arguments);
	        var valid = this.state_ === InternalTaskState.PAUSED ||
	            this.state_ === InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(InternalTaskState.RUNNING);
	        }
	        return valid;
	    };
	    /**
	     * Pauses a currently running task. Has no effect on a paused or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.pause = function () {
	        validate('pause', [], arguments);
	        var valid = this.state_ === InternalTaskState.RUNNING;
	        if (valid) {
	            this.transition_(InternalTaskState.PAUSING);
	        }
	        return valid;
	    };
	    /**
	     * Cancels a currently running or paused task. Has no effect on a complete or
	     * failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.cancel = function () {
	        validate('cancel', [], arguments);
	        var valid = this.state_ === InternalTaskState.RUNNING ||
	            this.state_ === InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(InternalTaskState.CANCELING);
	        }
	        return valid;
	    };
	    return UploadTask;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides methods to interact with a bucket in the Firebase Storage service.
	 * @param location An fbs.location, or the URL at
	 *     which to base this object, in one of the following forms:
	 *         gs://<bucket>/<object-path>
	 *         http[s]://firebasestorage.googleapis.com/
	 *                     <api-version>/b/<bucket>/o/<object-path>
	 *     Any query or fragment strings will be ignored in the http[s]
	 *     format. If no value is passed, the storage object will use a URL based on
	 *     the project ID of the base firebase.App instance.
	 */
	var Reference = /** @class */ (function () {
	    function Reference(authWrapper, location) {
	        this.authWrapper = authWrapper;
	        if (location instanceof Location) {
	            this.location = location;
	        }
	        else {
	            this.location = Location.makeFromUrl(location);
	        }
	    }
	    /**
	     * @return The URL for the bucket and path this object references,
	     *     in the form gs://<bucket>/<object-path>
	     * @override
	     */
	    Reference.prototype.toString = function () {
	        validate('toString', [], arguments);
	        return 'gs://' + this.location.bucket + '/' + this.location.path;
	    };
	    Reference.prototype.newRef = function (authWrapper, location) {
	        return new Reference(authWrapper, location);
	    };
	    Reference.prototype.mappings = function () {
	        return getMappings();
	    };
	    /**
	     * @return A reference to the object obtained by
	     *     appending childPath, removing any duplicate, beginning, or trailing
	     *     slashes.
	     */
	    Reference.prototype.child = function (childPath) {
	        validate('child', [stringSpec()], arguments);
	        var newPath = child(this.location.path, childPath);
	        var location = new Location(this.location.bucket, newPath);
	        return this.newRef(this.authWrapper, location);
	    };
	    Object.defineProperty(Reference.prototype, "parent", {
	        /**
	         * @return A reference to the parent of the
	         *     current object, or null if the current object is the root.
	         */
	        get: function () {
	            var newPath = parent(this.location.path);
	            if (newPath === null) {
	                return null;
	            }
	            var location = new Location(this.location.bucket, newPath);
	            return this.newRef(this.authWrapper, location);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        /**
	         * @return An reference to the root of this
	         *     object's bucket.
	         */
	        get: function () {
	            var location = new Location(this.location.bucket, '');
	            return this.newRef(this.authWrapper, location);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "bucket", {
	        get: function () {
	            return this.location.bucket;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "fullPath", {
	        get: function () {
	            return this.location.path;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "name", {
	        get: function () {
	            return lastComponent(this.location.path);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "storage", {
	        get: function () {
	            return this.authWrapper.service();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Uploads a blob to this object's location.
	     * @param data The blob to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.put = function (data, metadata) {
	        if (metadata === void 0) { metadata = null; }
	        validate('put', [uploadDataSpec(), metadataSpec(true)], arguments);
	        this.throwIfRoot_('put');
	        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data), metadata);
	    };
	    /**
	     * Uploads a string to this object's location.
	     * @param value The string to upload.
	     * @param format The format of the string to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.putString = function (value, format, metadata) {
	        if (format === void 0) { format = StringFormat.RAW; }
	        validate('putString', [stringSpec(), stringSpec(formatValidator, true), metadataSpec(true)], arguments);
	        this.throwIfRoot_('putString');
	        var data = dataFromString(format, value);
	        var metadataClone = Object.assign({}, metadata);
	        if (!isDef(metadataClone['contentType']) &&
	            isDef(data.contentType)) {
	            metadataClone['contentType'] = data.contentType;
	        }
	        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data.data, true), metadataClone);
	    };
	    /**
	     * Deletes the object at this location.
	     * @return A promise that resolves if the deletion succeeds.
	     */
	    Reference.prototype.delete = function () {
	        var _this = this;
	        validate('delete', [], arguments);
	        this.throwIfRoot_('delete');
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = deleteObject(_this.authWrapper, _this.location);
	            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * List all items (files) and prefixes (folders) under this storage reference.
	     *
	     * This is a helper method for calling list() repeatedly until there are
	     * no more results. The default pagination size is 1000.
	     *
	     * Note: The results may not be consistent if objects are changed while this
	     * operation is running.
	     *
	     * Warning: listAll may potentially consume too many resources if there are
	     * too many results.
	     *
	     * @return A Promise that resolves with all the items and prefixes under
	     *      the current storage reference. `prefixes` contains references to
	     *      sub-directories and `items` contains references to objects in this
	     *      folder. `nextPageToken` is never returned.
	     */
	    Reference.prototype.listAll = function () {
	        validate('listAll', [], arguments);
	        var accumulator = {
	            prefixes: [],
	            items: []
	        };
	        return this.listAllHelper(accumulator).then(function () { return accumulator; });
	    };
	    Reference.prototype.listAllHelper = function (accumulator, pageToken) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var opt, nextPage;
	            var _a, _b;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        opt = {
	                            // maxResults is 1000 by default.
	                            pageToken: pageToken
	                        };
	                        return [4 /*yield*/, this.list(opt)];
	                    case 1:
	                        nextPage = _c.sent();
	                        (_a = accumulator.prefixes).push.apply(_a, nextPage.prefixes);
	                        (_b = accumulator.items).push.apply(_b, nextPage.items);
	                        if (!(nextPage.nextPageToken != null)) return [3 /*break*/, 3];
	                        return [4 /*yield*/, this.listAllHelper(accumulator, nextPage.nextPageToken)];
	                    case 2:
	                        _c.sent();
	                        _c.label = 3;
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * List items (files) and prefixes (folders) under this storage reference.
	     *
	     * List API is only available for Firebase Rules Version 2.
	     *
	     * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
	     * delimited folder structure.
	     * Refer to GCS's List API if you want to learn more.
	     *
	     * To adhere to Firebase Rules's Semantics, Firebase Storage does not
	     * support objects whose paths end with "/" or contain two consecutive
	     * "/"s. Firebase Storage List API will filter these unsupported objects.
	     * list() may fail if there are too many unsupported objects in the bucket.
	     *
	     * @param options See ListOptions for details.
	     * @return A Promise that resolves with the items and prefixes.
	     *      `prefixes` contains references to sub-folders and `items`
	     *      contains references to objects in this folder. `nextPageToken`
	     *      can be used to get the rest of the results.
	     */
	    Reference.prototype.list = function (options) {
	        validate('list', [listOptionSpec(true)], arguments);
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var op = options || {};
	            var requestInfo = list(self.authWrapper, self.location, 
	            /*delimiter= */ '/', op.pageToken, op.maxResults);
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     *     A promise that resolves with the metadata for this object. If this
	     *     object doesn't exist or metadata cannot be retreived, the promise is
	     *     rejected.
	     */
	    Reference.prototype.getMetadata = function () {
	        var _this = this;
	        validate('getMetadata', [], arguments);
	        this.throwIfRoot_('getMetadata');
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = getMetadata(_this.authWrapper, _this.location, _this.mappings());
	            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * Updates the metadata for this object.
	     * @param metadata The new metadata for the object.
	     *     Only values that have been explicitly set will be changed. Explicitly
	     *     setting a value to null will remove the metadata.
	     * @return A promise that resolves
	     *     with the new metadata for this object.
	     *     @see firebaseStorage.Reference.prototype.getMetadata
	     */
	    Reference.prototype.updateMetadata = function (metadata) {
	        var _this = this;
	        validate('updateMetadata', [metadataSpec()], arguments);
	        this.throwIfRoot_('updateMetadata');
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = updateMetadata(_this.authWrapper, _this.location, metadata, _this.mappings());
	            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * @return A promise that resolves with the download
	     *     URL for this object.
	     */
	    Reference.prototype.getDownloadURL = function () {
	        var _this = this;
	        validate('getDownloadURL', [], arguments);
	        this.throwIfRoot_('getDownloadURL');
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = getDownloadUrl(_this.authWrapper, _this.location, _this.mappings());
	            return _this.authWrapper
	                .makeRequest(requestInfo, authToken)
	                .getPromise()
	                .then(function (url) {
	                if (url === null) {
	                    throw noDownloadURL();
	                }
	                return url;
	            });
	        });
	    };
	    Reference.prototype.throwIfRoot_ = function (name) {
	        if (this.location.path === '') {
	            throw invalidRootOperation(name);
	        }
	    };
	    return Reference;
	}());
	
	/**
	 * A request whose promise always fails.
	 * @struct
	 * @template T
	 */
	var FailRequest = /** @class */ (function () {
	    function FailRequest(error) {
	        this.promise_ = Promise.reject(error);
	    }
	    /** @inheritDoc */
	    FailRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    FailRequest.prototype.cancel = function (_appDelete) {
	    };
	    return FailRequest;
	}());
	
	var RequestMap = /** @class */ (function () {
	    function RequestMap() {
	        this.map = new Map();
	        this.id = MIN_SAFE_INTEGER;
	    }
	    /**
	     * Registers the given request with this map.
	     * The request is unregistered when it completes.
	     *
	     * @param request The request to register.
	     */
	    RequestMap.prototype.addRequest = function (request) {
	        var _this = this;
	        var id = this.id;
	        this.id++;
	        this.map.set(id, request);
	        request.getPromise().then(function () { return _this.map.delete(id); }, function () { return _this.map.delete(id); });
	    };
	    /**
	     * Cancels all registered requests.
	     */
	    RequestMap.prototype.clear = function () {
	        this.map.forEach(function (v) {
	            v && v.cancel(true);
	        });
	        this.map.clear();
	    };
	    return RequestMap;
	}());
	
	/**
	 * @param app If null, getAuthToken always resolves with null.
	 * @param service The storage service associated with this auth wrapper.
	 *     Untyped to avoid circular type dependencies.
	 * @struct
	 */
	var AuthWrapper = /** @class */ (function () {
	    function AuthWrapper(app, authProvider, maker, requestMaker, service, pool) {
	        this.bucket_ = null;
	        this.deleted_ = false;
	        this.app_ = app;
	        if (this.app_ !== null) {
	            var options = this.app_.options;
	            if (isDef(options)) {
	                this.bucket_ = AuthWrapper.extractBucket_(options);
	            }
	        }
	        this.authProvider_ = authProvider;
	        this.storageRefMaker_ = maker;
	        this.requestMaker_ = requestMaker;
	        this.pool_ = pool;
	        this.service_ = service;
	        this.maxOperationRetryTime_ = DEFAULT_MAX_OPERATION_RETRY_TIME;
	        this.maxUploadRetryTime_ = DEFAULT_MAX_UPLOAD_RETRY_TIME;
	        this.requestMap_ = new RequestMap();
	    }
	    AuthWrapper.extractBucket_ = function (config) {
	        var bucketString = config[CONFIG_STORAGE_BUCKET_KEY] || null;
	        if (bucketString == null) {
	            return null;
	        }
	        var loc = Location.makeFromBucketSpec(bucketString);
	        return loc.bucket;
	    };
	    AuthWrapper.prototype.getAuthToken = function () {
	        var auth = this.authProvider_.getImmediate({ optional: true });
	        if (auth) {
	            return auth.getToken().then(function (response) {
	                if (response !== null) {
	                    return response.accessToken;
	                }
	                else {
	                    return null;
	                }
	            }, function () { return null; });
	        }
	        else {
	            return Promise.resolve(null);
	        }
	    };
	    AuthWrapper.prototype.bucket = function () {
	        if (this.deleted_) {
	            throw appDeleted();
	        }
	        else {
	            return this.bucket_;
	        }
	    };
	    /**
	     * The service associated with this auth wrapper. Untyped to avoid circular
	     * type dependencies.
	     */
	    AuthWrapper.prototype.service = function () {
	        return this.service_;
	    };
	    /**
	     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
	     * at the given Location.
	     * @param loc The Location.
	     * @return Actually a firebaseStorage.Reference, typing not allowed
	     *     because of circular dependency problems.
	     */
	    AuthWrapper.prototype.makeStorageReference = function (loc) {
	        return this.storageRefMaker_(this, loc);
	    };
	    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
	        if (!this.deleted_) {
	            var request = this.requestMaker_(requestInfo, authToken, this.pool_);
	            this.requestMap_.addRequest(request);
	            return request;
	        }
	        else {
	            return new FailRequest(appDeleted());
	        }
	    };
	    /**
	     * Stop running requests and prevent more from being created.
	     */
	    AuthWrapper.prototype.deleteApp = function () {
	        this.deleted_ = true;
	        this.app_ = null;
	        this.requestMap_.clear();
	    };
	    AuthWrapper.prototype.maxUploadRetryTime = function () {
	        return this.maxUploadRetryTime_;
	    };
	    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
	        this.maxUploadRetryTime_ = time;
	    };
	    AuthWrapper.prototype.maxOperationRetryTime = function () {
	        return this.maxOperationRetryTime_;
	    };
	    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
	        this.maxOperationRetryTime_ = time;
	    };
	    return AuthWrapper;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param f May be invoked
	 *     before the function returns.
	 * @param callback Get all the arguments passed to the function
	 *     passed to f, including the initial boolean.
	 */
	function start(f, callback, timeout) {
	    // TODO(andysoto): make this code cleaner (probably refactor into an actual
	    // type instead of a bunch of functions with state shared in the closure)
	    var waitSeconds = 1;
	    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
	    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var timeoutId = null;
	    var hitTimeout = false;
	    var cancelState = 0;
	    function canceled() {
	        return cancelState === 2;
	    }
	    var triggeredCallback = false;
	    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
	    // the no-explicit-any rule when ESlint releases it.
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function triggerCallback() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!triggeredCallback) {
	            triggeredCallback = true;
	            callback.apply(null, args);
	        }
	    }
	    function callWithDelay(millis) {
	        timeoutId = setTimeout(function () {
	            timeoutId = null;
	            f(handler, canceled());
	        }, millis);
	    }
	    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
	    // the no-explicit-any rule when ESlint releases it.
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function handler(success) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (triggeredCallback) {
	            return;
	        }
	        if (success) {
	            triggerCallback.call.apply(triggerCallback, tslib.__spreadArrays([null, success], args));
	            return;
	        }
	        var mustStop = canceled() || hitTimeout;
	        if (mustStop) {
	            triggerCallback.call.apply(triggerCallback, tslib.__spreadArrays([null, success], args));
	            return;
	        }
	        if (waitSeconds < 64) {
	            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
	            waitSeconds *= 2;
	        }
	        var waitMillis;
	        if (cancelState === 1) {
	            cancelState = 2;
	            waitMillis = 0;
	        }
	        else {
	            waitMillis = (waitSeconds + Math.random()) * 1000;
	        }
	        callWithDelay(waitMillis);
	    }
	    var stopped = false;
	    function stop(wasTimeout) {
	        if (stopped) {
	            return;
	        }
	        stopped = true;
	        if (triggeredCallback) {
	            return;
	        }
	        if (timeoutId !== null) {
	            if (!wasTimeout) {
	                cancelState = 2;
	            }
	            clearTimeout(timeoutId);
	            callWithDelay(0);
	        }
	        else {
	            if (!wasTimeout) {
	                cancelState = 1;
	            }
	        }
	    }
	    callWithDelay(0);
	    setTimeout(function () {
	        hitTimeout = true;
	        stop(true);
	    }, timeout);
	    return stop;
	}
	/**
	 * Stops the retry loop from repeating.
	 * If the function is currently "in between" retries, it is invoked immediately
	 * with the second parameter as "true". Otherwise, it will be invoked once more
	 * after the current invocation finishes iff the current invocation would have
	 * triggered another retry.
	 */
	function stop(id) {
	    id(false);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 * @template T
	 */
	var NetworkRequest = /** @class */ (function () {
	    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
	        var _this = this;
	        this.pendingXhr_ = null;
	        this.backoffId_ = null;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.canceled_ = false;
	        this.appDelete_ = false;
	        this.url_ = url;
	        this.method_ = method;
	        this.headers_ = headers;
	        this.body_ = body;
	        this.successCodes_ = successCodes.slice();
	        this.additionalRetryCodes_ = additionalRetryCodes.slice();
	        this.callback_ = callback;
	        this.errorCallback_ = errorCallback;
	        this.progressCallback_ = progressCallback;
	        this.timeout_ = timeout;
	        this.pool_ = pool;
	        this.promise_ = new Promise(function (resolve, reject) {
	            _this.resolve_ = resolve;
	            _this.reject_ = reject;
	            _this.start_();
	        });
	    }
	    /**
	     * Actually starts the retry loop.
	     */
	    NetworkRequest.prototype.start_ = function () {
	        var self = this;
	        function doTheRequest(backoffCallback, canceled) {
	            if (canceled) {
	                backoffCallback(false, new RequestEndStatus(false, null, true));
	                return;
	            }
	            var xhr = self.pool_.createXhrIo();
	            self.pendingXhr_ = xhr;
	            function progressListener(progressEvent) {
	                var loaded = progressEvent.loaded;
	                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
	                if (self.progressCallback_ !== null) {
	                    self.progressCallback_(loaded, total);
	                }
	            }
	            if (self.progressCallback_ !== null) {
	                xhr.addUploadProgressListener(progressListener);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-floating-promises
	            xhr
	                .send(self.url_, self.method_, self.body_, self.headers_)
	                .then(function (xhr) {
	                if (self.progressCallback_ !== null) {
	                    xhr.removeUploadProgressListener(progressListener);
	                }
	                self.pendingXhr_ = null;
	                xhr = xhr;
	                var hitServer = xhr.getErrorCode() === ErrorCode.NO_ERROR;
	                var status = xhr.getStatus();
	                if (!hitServer || self.isRetryStatusCode_(status)) {
	                    var wasCanceled = xhr.getErrorCode() === ErrorCode.ABORT;
	                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
	                    return;
	                }
	                var successCode = self.successCodes_.indexOf(status) !== -1;
	                backoffCallback(true, new RequestEndStatus(successCode, xhr));
	            });
	        }
	        /**
	         * @param requestWentThrough True if the request eventually went
	         *     through, false if it hit the retry limit or was canceled.
	         */
	        function backoffDone(requestWentThrough, status) {
	            var resolve = self.resolve_;
	            var reject = self.reject_;
	            var xhr = status.xhr;
	            if (status.wasSuccessCode) {
	                try {
	                    var result = self.callback_(xhr, xhr.getResponseText());
	                    if (isJustDef(result)) {
	                        resolve(result);
	                    }
	                    else {
	                        resolve();
	                    }
	                }
	                catch (e) {
	                    reject(e);
	                }
	            }
	            else {
	                if (xhr !== null) {
	                    var err = unknown();
	                    err.setServerResponseProp(xhr.getResponseText());
	                    if (self.errorCallback_) {
	                        reject(self.errorCallback_(xhr, err));
	                    }
	                    else {
	                        reject(err);
	                    }
	                }
	                else {
	                    if (status.canceled) {
	                        var err = self.appDelete_ ? appDeleted() : canceled();
	                        reject(err);
	                    }
	                    else {
	                        var err = retryLimitExceeded();
	                        reject(err);
	                    }
	                }
	            }
	        }
	        if (this.canceled_) {
	            backoffDone(false, new RequestEndStatus(false, null, true));
	        }
	        else {
	            this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
	        }
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.cancel = function (appDelete) {
	        this.canceled_ = true;
	        this.appDelete_ = appDelete || false;
	        if (this.backoffId_ !== null) {
	            stop(this.backoffId_);
	        }
	        if (this.pendingXhr_ !== null) {
	            this.pendingXhr_.abort();
	        }
	    };
	    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
	        // The codes for which to retry came from this page:
	        // https://cloud.google.com/storage/docs/exponential-backoff
	        var isFiveHundredCode = status >= 500 && status < 600;
	        var extraRetryCodes = [
	            // Request Timeout: web server didn't receive full request in time.
	            408,
	            // Too Many Requests: you're getting rate-limited, basically.
	            429
	        ];
	        var isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
	        var isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
	        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
	    };
	    return NetworkRequest;
	}());
	/**
	 * A collection of information about the result of a network request.
	 * @param opt_canceled Defaults to false.
	 * @struct
	 */
	var RequestEndStatus = /** @class */ (function () {
	    function RequestEndStatus(wasSuccessCode, xhr, canceled) {
	        this.wasSuccessCode = wasSuccessCode;
	        this.xhr = xhr;
	        this.canceled = !!canceled;
	    }
	    return RequestEndStatus;
	}());
	function addAuthHeader_(headers, authToken) {
	    if (authToken !== null && authToken.length > 0) {
	        headers['Authorization'] = 'Firebase ' + authToken;
	    }
	}
	function addVersionHeader_(headers) {
	    var version = typeof firebase !== 'undefined' ? firebase.SDK_VERSION : 'AppManager';
	    headers['X-Firebase-Storage-Version'] = 'webjs/' + version;
	}
	/**
	 * @template T
	 */
	function makeRequest(requestInfo, authToken, pool) {
	    var queryPart = makeQueryString(requestInfo.urlParams);
	    var url = requestInfo.url + queryPart;
	    var headers = Object.assign({}, requestInfo.headers);
	    addAuthHeader_(headers, authToken);
	    addVersionHeader_(headers);
	    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A service that provides firebaseStorage.Reference instances.
	 * @param opt_url gs:// url to a custom Storage Bucket
	 *
	 * @struct
	 */
	var Service = /** @class */ (function () {
	    function Service(app, authProvider, pool, url) {
	        this.bucket_ = null;
	        function maker(authWrapper, loc) {
	            return new Reference(authWrapper, loc);
	        }
	        this.authWrapper_ = new AuthWrapper(app, authProvider, maker, makeRequest, this, pool);
	        this.app_ = app;
	        if (url != null) {
	            this.bucket_ = Location.makeFromBucketSpec(url);
	        }
	        else {
	            var authWrapperBucket = this.authWrapper_.bucket();
	            if (authWrapperBucket != null) {
	                this.bucket_ = new Location(authWrapperBucket, '');
	            }
	        }
	        this.internals_ = new ServiceInternals(this);
	    }
	    /**
	     * Returns a firebaseStorage.Reference for the given path in the default
	     * bucket.
	     */
	    Service.prototype.ref = function (path) {
	        function validator(path) {
	            if (typeof path !== 'string') {
	                throw 'Path is not a string.';
	            }
	            if (/^[A-Za-z]+:\/\//.test(path)) {
	                throw 'Expected child path but got a URL, use refFromURL instead.';
	            }
	        }
	        validate('ref', [stringSpec(validator, true)], arguments);
	        if (this.bucket_ == null) {
	            throw new Error('No Storage Bucket defined in Firebase Options.');
	        }
	        var ref = new Reference(this.authWrapper_, this.bucket_);
	        if (path != null) {
	            return ref.child(path);
	        }
	        else {
	            return ref;
	        }
	    };
	    /**
	     * Returns a firebaseStorage.Reference object for the given absolute URL,
	     * which must be a gs:// or http[s]:// URL.
	     */
	    Service.prototype.refFromURL = function (url) {
	        function validator(p) {
	            if (typeof p !== 'string') {
	                throw 'Path is not a string.';
	            }
	            if (!/^[A-Za-z]+:\/\//.test(p)) {
	                throw 'Expected full URL but got a child path, use ref instead.';
	            }
	            try {
	                Location.makeFromUrl(p);
	            }
	            catch (e) {
	                throw 'Expected valid full URL but got an invalid one.';
	            }
	        }
	        validate('refFromURL', [stringSpec(validator, false)], arguments);
	        return new Reference(this.authWrapper_, url);
	    };
	    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
	        get: function () {
	            return this.authWrapper_.maxUploadRetryTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Service.prototype.setMaxUploadRetryTime = function (time) {
	        validate('setMaxUploadRetryTime', [nonNegativeNumberSpec()], arguments);
	        this.authWrapper_.setMaxUploadRetryTime(time);
	    };
	    Service.prototype.setMaxOperationRetryTime = function (time) {
	        validate('setMaxOperationRetryTime', [nonNegativeNumberSpec()], arguments);
	        this.authWrapper_.setMaxOperationRetryTime(time);
	    };
	    Object.defineProperty(Service.prototype, "app", {
	        get: function () {
	            return this.app_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Service.prototype, "INTERNAL", {
	        get: function () {
	            return this.internals_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Service;
	}());
	/**
	 * @struct
	 */
	var ServiceInternals = /** @class */ (function () {
	    function ServiceInternals(service) {
	        this.service_ = service;
	    }
	    /**
	     * Called when the associated app is deleted.
	     * @see {!fbs.AuthWrapper.prototype.deleteApp}
	     */
	    ServiceInternals.prototype.delete = function () {
	        this.service_.authWrapper_.deleteApp();
	        return Promise.resolve();
	    };
	    return ServiceInternals;
	}());
	
	var name = "@firebase/storage";
	var version = "0.3.26";
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Type constant for Firebase Storage.
	 */
	var STORAGE_TYPE = 'storage';
	function factory(container, url) {
	    // Dependencies
	    var app = container.getProvider('app').getImmediate();
	    var authProvider = container.getProvider('auth-internal');
	    return new Service(app, authProvider, new XhrIoPool(), url);
	}
	function registerStorage(instance) {
	    var namespaceExports = {
	        // no-inline
	        TaskState: TaskState,
	        TaskEvent: TaskEvent,
	        StringFormat: StringFormat,
	        Storage: Service,
	        Reference: Reference
	    };
	    instance.INTERNAL.registerComponent(new component.Component(STORAGE_TYPE, factory, "PUBLIC" /* PUBLIC */)
	        .setServiceProps(namespaceExports)
	        .setMultipleInstances(true));
	    instance.registerVersion(name, version);
	}
	registerStorage(firebase);
	
	exports.registerStorage = registerStorage;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 104 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {'use strict';var h,goog=goog||{},l=this||self;function n(b){return"string"==typeof b}function aa(b){return"number"==typeof b}function p(b,c){b=b.split(".");c=c||l;for(var d=0;d<b.length;d++)if(c=c[b[d]],null==c)return null;return c}function ba(){}
	function q(b){var c=typeof b;if("object"==c)if(b){if(b instanceof Array)return"array";if(b instanceof Object)return c;var d=Object.prototype.toString.call(b);if("[object Window]"==d)return"object";if("[object Array]"==d||"number"==typeof b.length&&"undefined"!=typeof b.splice&&"undefined"!=typeof b.propertyIsEnumerable&&!b.propertyIsEnumerable("splice"))return"array";if("[object Function]"==d||"undefined"!=typeof b.call&&"undefined"!=typeof b.propertyIsEnumerable&&!b.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==c&&"undefined"==typeof b.call)return"object";return c}function r(b){return"array"==q(b)}function ca(b){var c=q(b);return"array"==c||"object"==c&&"number"==typeof b.length}function t(b){var c=typeof b;return"object"==c&&null!=b||"function"==c}var u="closure_uid_"+(1E9*Math.random()>>>0),da=0;function ea(b,c,d){return b.call.apply(b.bind,arguments)}
	function fa(b,c,d){if(!b)throw Error();if(2<arguments.length){var e=Array.prototype.slice.call(arguments,2);return function(){var f=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(f,e);return b.apply(c,f)}}return function(){return b.apply(c,arguments)}}function v(b,c,d){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?v=ea:v=fa;return v.apply(null,arguments)}
	function w(b,c){var d=Array.prototype.slice.call(arguments,1);return function(){var e=d.slice();e.push.apply(e,arguments);return b.apply(this,e)}}var x=Date.now||function(){return+new Date};function y(b,c){function d(){}d.prototype=c.prototype;b.N=c.prototype;b.prototype=new d;b.prototype.constructor=b;b.wb=function(e,f,g){for(var k=Array(arguments.length-2),m=2;m<arguments.length;m++)k[m-2]=arguments[m];return c.prototype[f].apply(e,k)}};function z(){0!=ha&&(ia[this[u]||(this[u]=++da)]=this);this.j=this.j;this.i=this.i}var ha=0,ia={};z.prototype.j=!1;z.prototype.ka=function(){if(!this.j&&(this.j=!0,this.G(),0!=ha)){var b=this[u]||(this[u]=++da);if(0!=ha&&this.i&&0<this.i.length)throw Error(this+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete ia[b]}};z.prototype.G=function(){if(this.i)for(;this.i.length;)this.i.shift()()};var ja=Array.prototype.indexOf?function(b,c){return Array.prototype.indexOf.call(b,c,void 0)}:function(b,c){if(n(b))return n(c)&&1==c.length?b.indexOf(c,0):-1;for(var d=0;d<b.length;d++)if(d in b&&b[d]===c)return d;return-1},ka=Array.prototype.forEach?function(b,c,d){Array.prototype.forEach.call(b,c,d)}:function(b,c,d){for(var e=b.length,f=n(b)?b.split(""):b,g=0;g<e;g++)g in f&&c.call(d,f[g],g,b)};
	function la(b){a:{var c=ma;for(var d=b.length,e=n(b)?b.split(""):b,f=0;f<d;f++)if(f in e&&c.call(void 0,e[f],f,b)){c=f;break a}c=-1}return 0>c?null:n(b)?b.charAt(c):b[c]}function na(b){return Array.prototype.concat.apply([],arguments)}function oa(b){var c=b.length;if(0<c){for(var d=Array(c),e=0;e<c;e++)d[e]=b[e];return d}return[]};function pa(b){return/^[\s\xa0]*$/.test(b)}var qa=String.prototype.trim?function(b){return b.trim()}:function(b){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(b)[1]};function A(b,c){return-1!=b.indexOf(c)}function ra(b,c){return b<c?-1:b>c?1:0};var B;a:{var sa=l.navigator;if(sa){var ta=sa.userAgent;if(ta){B=ta;break a}}B=""};function ua(b,c,d){for(var e in b)c.call(d,b[e],e,b)}function va(b){var c={},d;for(d in b)c[d]=b[d];return c}var wa="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function xa(b,c){for(var d,e,f=1;f<arguments.length;f++){e=arguments[f];for(d in e)b[d]=e[d];for(var g=0;g<wa.length;g++)d=wa[g],Object.prototype.hasOwnProperty.call(e,d)&&(b[d]=e[d])}};function ya(b){ya[" "](b);return b}ya[" "]=ba;function za(b,c){var d=Aa;return Object.prototype.hasOwnProperty.call(d,b)?d[b]:d[b]=c(b)};var Ba=A(B,"Opera"),C=A(B,"Trident")||A(B,"MSIE"),Ca=A(B,"Edge"),Da=Ca||C,Ea=A(B,"Gecko")&&!(A(B.toLowerCase(),"webkit")&&!A(B,"Edge"))&&!(A(B,"Trident")||A(B,"MSIE"))&&!A(B,"Edge"),Fa=A(B.toLowerCase(),"webkit")&&!A(B,"Edge");function Ga(){var b=l.document;return b?b.documentMode:void 0}var Ha;
	a:{var Ia="",Ja=function(){var b=B;if(Ea)return/rv:([^\);]+)(\)|;)/.exec(b);if(Ca)return/Edge\/([\d\.]+)/.exec(b);if(C)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(b);if(Fa)return/WebKit\/(\S+)/.exec(b);if(Ba)return/(?:Version)[ \/]?(\S+)/.exec(b)}();Ja&&(Ia=Ja?Ja[1]:"");if(C){var Ka=Ga();if(null!=Ka&&Ka>parseFloat(Ia)){Ha=String(Ka);break a}}Ha=Ia}var Aa={};
	function La(b){return za(b,function(){for(var c=0,d=qa(String(Ha)).split("."),e=qa(String(b)).split("."),f=Math.max(d.length,e.length),g=0;0==c&&g<f;g++){var k=d[g]||"",m=e[g]||"";do{k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];m=/(\d*)(\D*)(.*)/.exec(m)||["","","",""];if(0==k[0].length&&0==m[0].length)break;c=ra(0==k[1].length?0:parseInt(k[1],10),0==m[1].length?0:parseInt(m[1],10))||ra(0==k[2].length,0==m[2].length)||ra(k[2],m[2]);k=k[3];m=m[3]}while(0==c)}return 0<=c})}var Ma;
	Ma=l.document&&C?Ga():void 0;var Na=!C||9<=Number(Ma),Oa=C&&!La("9"),Pa=function(){if(!l.addEventListener||!Object.defineProperty)return!1;var b=!1,c=Object.defineProperty({},"passive",{get:function(){b=!0}});try{l.addEventListener("test",ba,c),l.removeEventListener("test",ba,c)}catch(d){}return b}();function D(b,c){this.type=b;this.a=this.target=c;this.Ha=!0}D.prototype.b=function(){this.Ha=!1};function F(b,c){D.call(this,b?b.type:"");this.relatedTarget=this.a=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.c=null;if(b){var d=this.type=b.type,e=b.changedTouches&&b.changedTouches.length?b.changedTouches[0]:null;this.target=b.target||b.srcElement;this.a=c;if(c=b.relatedTarget){if(Ea){a:{try{ya(c.nodeName);var f=!0;break a}catch(g){}f=!1}f||(c=null)}}else"mouseover"==
	d?c=b.fromElement:"mouseout"==d&&(c=b.toElement);this.relatedTarget=c;e?(this.clientX=void 0!==e.clientX?e.clientX:e.pageX,this.clientY=void 0!==e.clientY?e.clientY:e.pageY,this.screenX=e.screenX||0,this.screenY=e.screenY||0):(this.clientX=void 0!==b.clientX?b.clientX:b.pageX,this.clientY=void 0!==b.clientY?b.clientY:b.pageY,this.screenX=b.screenX||0,this.screenY=b.screenY||0);this.button=b.button;this.key=b.key||"";this.ctrlKey=b.ctrlKey;this.altKey=b.altKey;this.shiftKey=b.shiftKey;this.metaKey=
	b.metaKey;this.pointerId=b.pointerId||0;this.pointerType=n(b.pointerType)?b.pointerType:Qa[b.pointerType]||"";this.c=b;b.defaultPrevented&&this.b()}}y(F,D);var Qa={2:"touch",3:"pen",4:"mouse"};F.prototype.b=function(){F.N.b.call(this);var b=this.c;if(b.preventDefault)b.preventDefault();else if(b.returnValue=!1,Oa)try{if(b.ctrlKey||112<=b.keyCode&&123>=b.keyCode)b.keyCode=-1}catch(c){}};var G="closure_listenable_"+(1E6*Math.random()|0),Ra=0;function Sa(b,c,d,e,f){this.listener=b;this.proxy=null;this.src=c;this.type=d;this.capture=!!e;this.da=f;this.key=++Ra;this.X=this.Z=!1}function Ta(b){b.X=!0;b.listener=null;b.proxy=null;b.src=null;b.da=null};function Ua(b){this.src=b;this.a={};this.b=0}Ua.prototype.add=function(b,c,d,e,f){var g=b.toString();b=this.a[g];b||(b=this.a[g]=[],this.b++);var k=Va(b,c,e,f);-1<k?(c=b[k],d||(c.Z=!1)):(c=new Sa(c,this.src,g,!!e,f),c.Z=d,b.push(c));return c};function Wa(b,c){var d=c.type;if(d in b.a){var e=b.a[d],f=ja(e,c),g;(g=0<=f)&&Array.prototype.splice.call(e,f,1);g&&(Ta(c),0==b.a[d].length&&(delete b.a[d],b.b--))}}
	function Va(b,c,d,e){for(var f=0;f<b.length;++f){var g=b[f];if(!g.X&&g.listener==c&&g.capture==!!d&&g.da==e)return f}return-1};var Xa="closure_lm_"+(1E6*Math.random()|0),Ya={},Za=0;function $a(b,c,d,e,f){if(e&&e.once)return ab(b,c,d,e,f);if(r(c)){for(var g=0;g<c.length;g++)$a(b,c[g],d,e,f);return null}d=bb(d);return b&&b[G]?b.ya(c,d,t(e)?!!e.capture:!!e,f):cb(b,c,d,!1,e,f)}
	function cb(b,c,d,e,f,g){if(!c)throw Error("Invalid event type");var k=t(f)?!!f.capture:!!f;if(k&&!Na)return null;var m=db(b);m||(b[Xa]=m=new Ua(b));d=m.add(c,d,e,k,g);if(d.proxy)return d;e=eb();d.proxy=e;e.src=b;e.listener=d;if(b.addEventListener)Pa||(f=k),void 0===f&&(f=!1),b.addEventListener(c.toString(),e,f);else if(b.attachEvent)b.attachEvent(fb(c.toString()),e);else if(b.addListener&&b.removeListener)b.addListener(e);else throw Error("addEventListener and attachEvent are unavailable.");Za++;
	return d}function eb(){var b=gb,c=Na?function(d){return b.call(c.src,c.listener,d)}:function(d){d=b.call(c.src,c.listener,d);if(!d)return d};return c}function ab(b,c,d,e,f){if(r(c)){for(var g=0;g<c.length;g++)ab(b,c[g],d,e,f);return null}d=bb(d);return b&&b[G]?b.za(c,d,t(e)?!!e.capture:!!e,f):cb(b,c,d,!0,e,f)}
	function hb(b,c,d,e,f){if(r(c))for(var g=0;g<c.length;g++)hb(b,c[g],d,e,f);else(e=t(e)?!!e.capture:!!e,d=bb(d),b&&b[G])?(b=b.c,c=String(c).toString(),c in b.a&&(g=b.a[c],d=Va(g,d,e,f),-1<d&&(Ta(g[d]),Array.prototype.splice.call(g,d,1),0==g.length&&(delete b.a[c],b.b--)))):b&&(b=db(b))&&(c=b.a[c.toString()],b=-1,c&&(b=Va(c,d,e,f)),(d=-1<b?c[b]:null)&&ib(d))}
	function ib(b){if(!aa(b)&&b&&!b.X){var c=b.src;if(c&&c[G])Wa(c.c,b);else{var d=b.type,e=b.proxy;c.removeEventListener?c.removeEventListener(d,e,b.capture):c.detachEvent?c.detachEvent(fb(d),e):c.addListener&&c.removeListener&&c.removeListener(e);Za--;(d=db(c))?(Wa(d,b),0==d.b&&(d.src=null,c[Xa]=null)):Ta(b)}}}function fb(b){return b in Ya?Ya[b]:Ya[b]="on"+b}function jb(b,c){var d=b.listener,e=b.da||b.src;b.Z&&ib(b);return d.call(e,c)}
	function gb(b,c){return b.X?!0:Na?jb(b,new F(c,this)):(c=new F(c||p("window.event"),this),jb(b,c))}function db(b){b=b[Xa];return b instanceof Ua?b:null}var kb="__closure_events_fn_"+(1E9*Math.random()>>>0);function bb(b){if("function"==q(b))return b;b[kb]||(b[kb]=function(c){return b.handleEvent(c)});return b[kb]};function H(){z.call(this);this.c=new Ua(this);this.J=this;this.B=null}y(H,z);H.prototype[G]=!0;h=H.prototype;h.addEventListener=function(b,c,d,e){$a(this,b,c,d,e)};h.removeEventListener=function(b,c,d,e){hb(this,b,c,d,e)};
	h.dispatchEvent=function(b){var c,d=this.B;if(d)for(c=[];d;d=d.B)c.push(d);d=this.J;var e=b.type||b;if(n(b))b=new D(b,d);else if(b instanceof D)b.target=b.target||d;else{var f=b;b=new D(e,d);xa(b,f)}f=!0;if(c)for(var g=c.length-1;0<=g;g--){var k=b.a=c[g];f=lb(k,e,!0,b)&&f}k=b.a=d;f=lb(k,e,!0,b)&&f;f=lb(k,e,!1,b)&&f;if(c)for(g=0;g<c.length;g++)k=b.a=c[g],f=lb(k,e,!1,b)&&f;return f};
	h.G=function(){H.N.G.call(this);if(this.c){var b=this.c,c=0,d;for(d in b.a){for(var e=b.a[d],f=0;f<e.length;f++)++c,Ta(e[f]);delete b.a[d];b.b--}}this.B=null};h.ya=function(b,c,d,e){return this.c.add(String(b),c,!1,d,e)};h.za=function(b,c,d,e){return this.c.add(String(b),c,!0,d,e)};
	function lb(b,c,d,e){c=b.c.a[String(c)];if(!c)return!0;c=c.concat();for(var f=!0,g=0;g<c.length;++g){var k=c[g];if(k&&!k.X&&k.capture==d){var m=k.listener,E=k.da||k.src;k.Z&&Wa(b.c,k);f=!1!==m.call(E,e)&&f}}return f&&0!=e.Ha};var mb=l.JSON.stringify;function nb(b,c){this.c=b;this.f=c;this.b=0;this.a=null}nb.prototype.get=function(){if(0<this.b){this.b--;var b=this.a;this.a=b.next;b.next=null}else b=this.c();return b};function ob(){this.b=this.a=null}var qb=new nb(function(){return new pb},function(b){b.reset()});ob.prototype.add=function(b,c){var d=qb.get();d.set(b,c);this.b?this.b.next=d:this.a=d;this.b=d};function rb(){var b=sb,c=null;b.a&&(c=b.a,b.a=b.a.next,b.a||(b.b=null),c.next=null);return c}function pb(){this.next=this.b=this.a=null}pb.prototype.set=function(b,c){this.a=b;this.b=c;this.next=null};pb.prototype.reset=function(){this.next=this.b=this.a=null};function tb(b){l.setTimeout(function(){throw b;},0)};function ub(b,c){vb||wb();xb||(vb(),xb=!0);sb.add(b,c)}var vb;function wb(){var b=l.Promise.resolve(void 0);vb=function(){b.then(zb)}}var xb=!1,sb=new ob;function zb(){for(var b;b=rb();){try{b.a.call(b.b)}catch(d){tb(d)}var c=qb;c.f(b);100>c.b&&(c.b++,b.next=c.a,c.a=b)}xb=!1};function Ab(b,c){H.call(this);this.b=b||1;this.a=c||l;this.f=v(this.eb,this);this.g=x()}y(Ab,H);h=Ab.prototype;h.ba=!1;h.L=null;h.eb=function(){if(this.ba){var b=x()-this.g;0<b&&b<.8*this.b?this.L=this.a.setTimeout(this.f,this.b-b):(this.L&&(this.a.clearTimeout(this.L),this.L=null),this.dispatchEvent("tick"),this.ba&&(Bb(this),this.start()))}};h.start=function(){this.ba=!0;this.L||(this.L=this.a.setTimeout(this.f,this.b),this.g=x())};function Bb(b){b.ba=!1;b.L&&(b.a.clearTimeout(b.L),b.L=null)}
	h.G=function(){Ab.N.G.call(this);Bb(this);delete this.a};function Cb(b,c,d){if("function"==q(b))d&&(b=v(b,d));else if(b&&"function"==typeof b.handleEvent)b=v(b.handleEvent,b);else throw Error("Invalid listener argument");return 2147483647<Number(c)?-1:l.setTimeout(b,c||0)};function Db(b,c,d){z.call(this);this.f=null!=d?v(b,d):b;this.c=c;this.b=v(this.Za,this);this.a=[]}y(Db,z);h=Db.prototype;h.ea=!1;h.U=null;h.Sa=function(b){this.a=arguments;this.U?this.ea=!0:Eb(this)};h.G=function(){Db.N.G.call(this);this.U&&(l.clearTimeout(this.U),this.U=null,this.ea=!1,this.a=[])};h.Za=function(){this.U=null;this.ea&&(this.ea=!1,Eb(this))};function Eb(b){b.U=Cb(b.b,b.c);b.f.apply(null,b.a)};function I(b){z.call(this);this.b=b;this.a={}}y(I,z);var Fb=[];function Gb(b,c,d,e){r(d)||(d&&(Fb[0]=d.toString()),d=Fb);for(var f=0;f<d.length;f++){var g=$a(c,d[f],e||b.handleEvent,!1,b.b||b);if(!g)break;b.a[g.key]=g}}function Hb(b){ua(b.a,function(c,d){this.a.hasOwnProperty(d)&&ib(c)},b);b.a={}}I.prototype.G=function(){I.N.G.call(this);Hb(this)};I.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function Ib(){};var Jb=null;function Kb(){return Jb=Jb||new H}function Lb(b){D.call(this,"serverreachability",b)}y(Lb,D);function J(b){var c=Kb();c.dispatchEvent(new Lb(c,b))}function Mb(b){D.call(this,"statevent",b)}y(Mb,D);function K(b){var c=Kb();c.dispatchEvent(new Mb(c,b))}function Nb(b){D.call(this,"timingevent",b)}y(Nb,D);function Ob(b,c){if("function"!=q(b))throw Error("Fn must not be null and must be a function");return l.setTimeout(function(){b()},c)};var Pb={NO_ERROR:0,fb:1,mb:2,lb:3,ib:4,kb:5,nb:6,Ka:7,TIMEOUT:8,qb:9};var Qb={hb:"complete",ub:"success",La:"error",Ka:"abort",sb:"ready",tb:"readystatechange",TIMEOUT:"timeout",ob:"incrementaldata",rb:"progress",jb:"downloadprogress",vb:"uploadprogress"};function Rb(){}Rb.prototype.a=null;function Sb(b){var c;(c=b.a)||(c=b.a={});return c};function Tb(){}var L={OPEN:"a",gb:"b",La:"c",pb:"d"};function Ub(){D.call(this,"d")}y(Ub,D);function Vb(){D.call(this,"c")}y(Vb,D);var Wb;function Xb(){}y(Xb,Rb);Wb=new Xb;function M(b,c,d){this.g=b;this.W=c;this.V=d||1;this.I=new I(this);this.O=Yb;b=Da?125:void 0;this.P=new Ab(b);this.h=null;this.b=!1;this.l=this.D=this.f=this.F=this.v=this.R=this.i=null;this.j=[];this.a=null;this.A=0;this.c=this.w=null;this.o=-1;this.m=!1;this.J=0;this.B=null;this.s=this.S=this.H=!1}var Yb=45E3,Zb={},$b={};h=M.prototype;h.setTimeout=function(b){this.O=b};function ac(b,c,d){b.F=1;b.f=bc(N(c));b.l=d;b.H=!0;cc(b,null)}function dc(b,c,d,e){b.F=1;b.f=bc(N(c));b.l=null;b.H=d;cc(b,e)}
	function cc(b,c){b.v=x();ec(b);b.D=N(b.f);fc(b.D,"t",b.V);b.A=0;b.a=b.g.$(b.g.Y()?c:null);0<b.J&&(b.B=new Db(v(b.Ia,b,b.a),b.J));Gb(b.I,b.a,"readystatechange",b.bb);c=b.h?va(b.h):{};b.l?(b.w||(b.w="POST"),c["Content-Type"]="application/x-www-form-urlencoded",b.a.ca(b.D,b.w,b.l,c)):(b.w="GET",b.a.ca(b.D,b.w,null,c));J(1)}h.bb=function(b){b=b.target;var c=this.B;c&&3==O(b)?c.Sa():this.Ia(b)};
	h.Ia=function(b){try{if(b==this.a)a:{var c=O(this.a),d=this.a.xa(),e=this.a.T();if(!(3>c||3==c&&!Da&&!this.a.aa())){this.m||4!=c||7==d||(8==d||0>=e?J(3):J(2));gc(this);var f=this.a.T();this.o=f;var g=this.a.aa();if(this.b=200==f){if(this.S&&!this.s){b:{if(this.a){var k=hc(this.a,"X-HTTP-Initial-Response");if(k&&!pa(k)){var m=k;break b}}m=null}if(m)this.s=!0,ic(this,m);else{this.b=!1;this.c=3;K(12);P(this);jc(this);break a}}this.H?(kc(this,c,g),Da&&this.b&&3==c&&(Gb(this.I,this.P,"tick",this.ab),this.P.start())):
	ic(this,g);4==c&&P(this);this.b&&!this.m&&(4==c?this.g.ma(this):(this.b=!1,ec(this)))}else 400==f&&0<g.indexOf("Unknown SID")?(this.c=3,K(12)):(this.c=0,K(13)),P(this),jc(this)}}}catch(E){}finally{}};function kc(b,c,d){for(var e=!0;!b.m&&b.A<d.length;){var f=lc(b,d);if(f==$b){4==c&&(b.c=4,K(14),e=!1);break}else if(f==Zb){b.c=4;K(15);e=!1;break}else ic(b,f)}4==c&&0==d.length&&(b.c=1,K(16),e=!1);b.b=b.b&&e;e||(P(b),jc(b))}
	h.ab=function(){if(this.a){var b=O(this.a),c=this.a.aa();this.A<c.length&&(gc(this),kc(this,b,c),this.b&&4!=b&&ec(this))}};function lc(b,c){var d=b.A,e=c.indexOf("\n",d);if(-1==e)return $b;d=Number(c.substring(d,e));if(isNaN(d))return Zb;e+=1;if(e+d>c.length)return $b;c=c.substr(e,d);b.A=e+d;return c}h.cancel=function(){this.m=!0;P(this)};function ec(b){b.R=x()+b.O;mc(b,b.O)}function mc(b,c){if(null!=b.i)throw Error("WatchDog timer not null");b.i=Ob(v(b.$a,b),c)}
	function gc(b){b.i&&(l.clearTimeout(b.i),b.i=null)}h.$a=function(){this.i=null;var b=x();0<=b-this.R?(2!=this.F&&(J(3),K(17)),P(this),this.c=2,jc(this)):mc(this,this.R-b)};function jc(b){b.g.Ba()||b.m||b.g.ma(b)}function P(b){gc(b);var c=b.B;c&&"function"==typeof c.ka&&c.ka();b.B=null;Bb(b.P);Hb(b.I);b.a&&(c=b.a,b.a=null,c.abort(),c.ka())}function ic(b,c){try{b.g.Ea(b,c),J(4)}catch(d){}};function nc(b){if(b.C&&"function"==typeof b.C)return b.C();if(n(b))return b.split("");if(ca(b)){for(var c=[],d=b.length,e=0;e<d;e++)c.push(b[e]);return c}c=[];d=0;for(e in b)c[d++]=b[e];return c}
	function oc(b,c){if(b.forEach&&"function"==typeof b.forEach)b.forEach(c,void 0);else if(ca(b)||n(b))ka(b,c,void 0);else{if(b.K&&"function"==typeof b.K)var d=b.K();else if(b.C&&"function"==typeof b.C)d=void 0;else if(ca(b)||n(b)){d=[];for(var e=b.length,f=0;f<e;f++)d.push(f)}else for(f in d=[],e=0,b)d[e++]=f;e=nc(b);f=e.length;for(var g=0;g<f;g++)c.call(void 0,e[g],d&&d[g],b)}};function Q(b,c){this.b={};this.a=[];this.c=0;var d=arguments.length;if(1<d){if(d%2)throw Error("Uneven number of arguments");for(var e=0;e<d;e+=2)this.set(arguments[e],arguments[e+1])}else if(b)if(b instanceof Q)for(d=b.K(),e=0;e<d.length;e++)this.set(d[e],b.get(d[e]));else for(e in b)this.set(e,b[e])}h=Q.prototype;h.C=function(){pc(this);for(var b=[],c=0;c<this.a.length;c++)b.push(this.b[this.a[c]]);return b};h.K=function(){pc(this);return this.a.concat()};
	function qc(b){b.b={};b.a.length=0;b.c=0}function rc(b,c){R(b.b,c)&&(delete b.b[c],b.c--,b.a.length>2*b.c&&pc(b))}function pc(b){if(b.c!=b.a.length){for(var c=0,d=0;c<b.a.length;){var e=b.a[c];R(b.b,e)&&(b.a[d++]=e);c++}b.a.length=d}if(b.c!=b.a.length){var f={};for(d=c=0;c<b.a.length;)e=b.a[c],R(f,e)||(b.a[d++]=e,f[e]=1),c++;b.a.length=d}}h.get=function(b,c){return R(this.b,b)?this.b[b]:c};h.set=function(b,c){R(this.b,b)||(this.c++,this.a.push(b));this.b[b]=c};
	h.forEach=function(b,c){for(var d=this.K(),e=0;e<d.length;e++){var f=d[e],g=this.get(f);b.call(c,g,f,this)}};function R(b,c){return Object.prototype.hasOwnProperty.call(b,c)};var sc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function tc(b,c){if(b){b=b.split("&");for(var d=0;d<b.length;d++){var e=b[d].indexOf("="),f=null;if(0<=e){var g=b[d].substring(0,e);f=b[d].substring(e+1)}else g=b[d];c(g,f?decodeURIComponent(f.replace(/\+/g," ")):"")}}};function S(b,c){this.c=this.j=this.f="";this.h=null;this.i=this.g="";this.a=!1;if(b instanceof S){this.a=void 0!==c?c:b.a;uc(this,b.f);this.j=b.j;vc(this,b.c);wc(this,b.h);this.g=b.g;c=b.b;var d=new xc;d.c=c.c;c.a&&(d.a=new Q(c.a),d.b=c.b);yc(this,d);this.i=b.i}else b&&(d=String(b).match(sc))?(this.a=!!c,uc(this,d[1]||"",!0),this.j=zc(d[2]||""),vc(this,d[3]||"",!0),wc(this,d[4]),this.g=zc(d[5]||"",!0),yc(this,d[6]||"",!0),this.i=zc(d[7]||"")):(this.a=!!c,this.b=new xc(null,this.a))}
	S.prototype.toString=function(){var b=[],c=this.f;c&&b.push(Ac(c,Bc,!0),":");var d=this.c;if(d||"file"==c)b.push("//"),(c=this.j)&&b.push(Ac(c,Bc,!0),"@"),b.push(encodeURIComponent(String(d)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),d=this.h,null!=d&&b.push(":",String(d));if(d=this.g)this.c&&"/"!=d.charAt(0)&&b.push("/"),b.push(Ac(d,"/"==d.charAt(0)?Cc:Dc,!0));(d=this.b.toString())&&b.push("?",d);(d=this.i)&&b.push("#",Ac(d,Ec));return b.join("")};function N(b){return new S(b)}
	function uc(b,c,d){b.f=d?zc(c,!0):c;b.f&&(b.f=b.f.replace(/:$/,""))}function vc(b,c,d){b.c=d?zc(c,!0):c}function wc(b,c){if(c){c=Number(c);if(isNaN(c)||0>c)throw Error("Bad port number "+c);b.h=c}else b.h=null}function yc(b,c,d){c instanceof xc?(b.b=c,Fc(b.b,b.a)):(d||(c=Ac(c,Gc)),b.b=new xc(c,b.a))}function T(b,c,d){b.b.set(c,d)}function fc(b,c,d){r(d)||(d=[String(d)]);Hc(b.b,c,d)}
	function bc(b){T(b,"zx",Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^x()).toString(36));return b}function Ic(b){return b instanceof S?N(b):new S(b,void 0)}function Jc(b,c,d,e){var f=new S(null,void 0);b&&uc(f,b);c&&vc(f,c);d&&wc(f,d);e&&(f.g=e);return f}function zc(b,c){return b?c?decodeURI(b.replace(/%25/g,"%2525")):decodeURIComponent(b):""}
	function Ac(b,c,d){return n(b)?(b=encodeURI(b).replace(c,Kc),d&&(b=b.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),b):null}function Kc(b){b=b.charCodeAt(0);return"%"+(b>>4&15).toString(16)+(b&15).toString(16)}var Bc=/[#\/\?@]/g,Dc=/[#\?:]/g,Cc=/[#\?]/g,Gc=/[#\?@]/g,Ec=/#/g;function xc(b,c){this.b=this.a=null;this.c=b||null;this.f=!!c}function U(b){b.a||(b.a=new Q,b.b=0,b.c&&tc(b.c,function(c,d){b.add(decodeURIComponent(c.replace(/\+/g," ")),d)}))}h=xc.prototype;
	h.add=function(b,c){U(this);this.c=null;b=V(this,b);var d=this.a.get(b);d||this.a.set(b,d=[]);d.push(c);this.b+=1;return this};function Lc(b,c){U(b);c=V(b,c);R(b.a.b,c)&&(b.c=null,b.b-=b.a.get(c).length,rc(b.a,c))}function Mc(b,c){U(b);c=V(b,c);return R(b.a.b,c)}h.forEach=function(b,c){U(this);this.a.forEach(function(d,e){ka(d,function(f){b.call(c,f,e,this)},this)},this)};
	h.K=function(){U(this);for(var b=this.a.C(),c=this.a.K(),d=[],e=0;e<c.length;e++)for(var f=b[e],g=0;g<f.length;g++)d.push(c[e]);return d};h.C=function(b){U(this);var c=[];if(n(b))Mc(this,b)&&(c=na(c,this.a.get(V(this,b))));else{b=this.a.C();for(var d=0;d<b.length;d++)c=na(c,b[d])}return c};h.set=function(b,c){U(this);this.c=null;b=V(this,b);Mc(this,b)&&(this.b-=this.a.get(b).length);this.a.set(b,[c]);this.b+=1;return this};
	h.get=function(b,c){if(!b)return c;b=this.C(b);return 0<b.length?String(b[0]):c};function Hc(b,c,d){Lc(b,c);0<d.length&&(b.c=null,b.a.set(V(b,c),oa(d)),b.b+=d.length)}h.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var b=[],c=this.a.K(),d=0;d<c.length;d++){var e=c[d],f=encodeURIComponent(String(e));e=this.C(e);for(var g=0;g<e.length;g++){var k=f;""!==e[g]&&(k+="="+encodeURIComponent(String(e[g])));b.push(k)}}return this.c=b.join("&")};
	function V(b,c){c=String(c);b.f&&(c=c.toLowerCase());return c}function Fc(b,c){c&&!b.f&&(U(b),b.c=null,b.a.forEach(function(d,e){var f=e.toLowerCase();e!=f&&(Lc(this,e),Hc(this,f,d))},b));b.f=c};function Nc(b){this.a=b;this.b=this.h=null;this.g=!1;this.i=null;this.c=-1;this.l=this.f=null}h=Nc.prototype;h.M=null;function Oc(b){var c=b.a.F.a;if(null!=c)K(4),c?(K(10),Qc(b.a,b,!1)):(K(11),Qc(b.a,b,!0));else{b.b=new M(b,void 0,void 0);b.b.h=b.h;c=b.a;c=Rc(c,c.Y()?b.f:null,b.i);K(4);fc(c,"TYPE","xmlhttp");var d=b.a.j,e=b.a.I;d&&e&&T(c,d,e);dc(b.b,c,!1,b.f)}}h.$=function(b){return this.a.$(b)};h.abort=function(){this.b&&(this.b.cancel(),this.b=null);this.c=-1};h.Ba=function(){return!1};
	h.Ea=function(b,c){this.c=b.o;if(0==this.M){if(!this.a.o&&(b=b.a)){var d=hc(b,"X-Client-Wire-Protocol");this.l=d?d:null;this.a.j&&(b=hc(b,"X-HTTP-Session-Id"))&&(this.a.I=b)}if(c){try{var e=this.a.ja.a.parse(c)}catch(f){c=this.a;c.m=this.c;W(c,2);return}this.f=e[0]}else c=this.a,c.m=this.c,W(c,2)}else if(1==this.M)if(this.g)K(6);else if("11111"==c){if(K(5),this.g=!0,!C||10<=Number(Ma))this.c=200,this.b.cancel(),K(11),Qc(this.a,this,!0)}else K(7),this.g=!1};
	h.ma=function(){this.c=this.b.o;if(this.b.b)0==this.M?(this.M=1,Oc(this)):1==this.M&&(this.g?(K(11),Qc(this.a,this,!0)):(K(10),Qc(this.a,this,!1)));else{0==this.M?K(8):1==this.M&&K(9);var b=this.a;b.m=this.c;W(b,2)}};h.Y=function(){return this.a.Y()};h.la=function(){return this.a.la()};function Sc(){this.a=this.b=null};function Tc(){this.a=new Q}function Uc(b){var c=typeof b;return"object"==c&&b||"function"==c?"o"+(b[u]||(b[u]=++da)):c.charAt(0)+b}Tc.prototype.add=function(b){this.a.set(Uc(b),b)};Tc.prototype.C=function(){return this.a.C()};function Vc(b,c){this.b=b;this.a=c};function Wc(b){this.g=b||Xc;l.PerformanceNavigationTiming?(b=l.performance.getEntriesByType("navigation"),b=0<b.length&&("hq"==b[0].nextHopProtocol||"h2"==b[0].nextHopProtocol)):b=!!(l.a&&l.a.Ca&&l.a.Ca()&&l.a.Ca().xb);this.f=b?this.g:1;this.a=null;1<this.f&&(this.a=new Tc);this.b=null;this.c=[]}var Xc=10;function Yc(b,c){!b.a&&(A(c,"spdy")||A(c,"quic")||A(c,"h2"))&&(b.f=b.g,b.a=new Tc,b.b&&(Zc(b,b.b),b.b=null))}function $c(b){return b.b?!0:b.a?b.a.a.c>=b.f:!1}
	function ad(b){return b.b?1:b.a?b.a.a.c:0}function bd(b,c){b.b?b=b.b==c:b.a?(c=Uc(c),b=R(b.a.a.b,c)):b=!1;return b}function Zc(b,c){b.a?b.a.add(c):b.b=c}function cd(b,c){if(b.b&&b.b==c)b.b=null;else{var d;if(d=b.a)d=Uc(c),d=R(b.a.a.b,d);d&&rc(b.a.a,Uc(c))}}Wc.prototype.cancel=function(){this.c=dd(this);this.b?(this.b.cancel(),this.b=null):this.a&&0!=this.a.a.c&&(ka(this.a.C(),function(b){b.cancel()}),qc(this.a.a))};
	function dd(b){if(null!=b.b)return b.c.concat(b.b.j);if(null!=b.a&&0!=b.a.a.c){var c=b.c;ka(b.a.C(),function(d){c=c.concat(d.j)});return c}return oa(b.c)};function ed(){}ed.prototype.stringify=function(b){return l.JSON.stringify(b,void 0)};ed.prototype.parse=function(b){return l.JSON.parse(b,void 0)};function fd(){this.a=new ed}function gd(b,c,d){var e=d||"";try{oc(b,function(f,g){var k=f;t(f)&&(k=mb(f));c.push(e+g+"="+encodeURIComponent(k))})}catch(f){throw c.push(e+"type="+encodeURIComponent("_badmap")),f;}};function hd(b,c){var d=new Ib;if(l.Image){var e=new Image;e.onload=w(id,d,e,"TestLoadImage: loaded",!0,c);e.onerror=w(id,d,e,"TestLoadImage: error",!1,c);e.onabort=w(id,d,e,"TestLoadImage: abort",!1,c);e.ontimeout=w(id,d,e,"TestLoadImage: timeout",!1,c);l.setTimeout(function(){if(e.ontimeout)e.ontimeout()},1E4);e.src=b}else c(!1)}function id(b,c,d,e,f){try{c.onload=null,c.onerror=null,c.onabort=null,c.ontimeout=null,f(e)}catch(g){}};var jd=l.JSON.parse;function X(b){H.call(this);this.headers=new Q;this.H=b||null;this.b=!1;this.s=this.a=null;this.A="";this.h=0;this.f="";this.g=this.w=this.l=this.v=!1;this.o=0;this.m=null;this.I=kd;this.D=this.F=!1}y(X,H);var kd="",ld=/^https?$/i,md=["POST","PUT"];h=X.prototype;
	h.ca=function(b,c,d,e){if(this.a)throw Error("[goog.net.XhrIo] Object is active with another request="+this.A+"; newUri="+b);c=c?c.toUpperCase():"GET";this.A=b;this.f="";this.h=0;this.v=!1;this.b=!0;this.a=new XMLHttpRequest;this.s=this.H?Sb(this.H):Sb(Wb);this.a.onreadystatechange=v(this.Da,this);try{this.w=!0,this.a.open(c,String(b),!0),this.w=!1}catch(g){nd(this,g);return}b=d||"";var f=new Q(this.headers);e&&oc(e,function(g,k){f.set(k,g)});e=la(f.K());d=l.FormData&&b instanceof l.FormData;!(0<=
	ja(md,c))||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(g,k){this.a.setRequestHeader(k,g)},this);this.I&&(this.a.responseType=this.I);"withCredentials"in this.a&&this.a.withCredentials!==this.F&&(this.a.withCredentials=this.F);try{od(this),0<this.o&&((this.D=pd(this.a))?(this.a.timeout=this.o,this.a.ontimeout=v(this.Aa,this)):this.m=Cb(this.Aa,this.o,this)),this.l=!0,this.a.send(b),this.l=!1}catch(g){nd(this,g)}};
	function pd(b){return C&&La(9)&&aa(b.timeout)&&void 0!==b.ontimeout}function ma(b){return"content-type"==b.toLowerCase()}h.Aa=function(){"undefined"!=typeof goog&&this.a&&(this.f="Timed out after "+this.o+"ms, aborting",this.h=8,this.dispatchEvent("timeout"),this.abort(8))};function nd(b,c){b.b=!1;b.a&&(b.g=!0,b.a.abort(),b.g=!1);b.f=c;b.h=5;qd(b);rd(b)}function qd(b){b.v||(b.v=!0,b.dispatchEvent("complete"),b.dispatchEvent("error"))}
	h.abort=function(b){this.a&&this.b&&(this.b=!1,this.g=!0,this.a.abort(),this.g=!1,this.h=b||7,this.dispatchEvent("complete"),this.dispatchEvent("abort"),rd(this))};h.G=function(){this.a&&(this.b&&(this.b=!1,this.g=!0,this.a.abort(),this.g=!1),rd(this,!0));X.N.G.call(this)};h.Da=function(){this.j||(this.w||this.l||this.g?sd(this):this.Ya())};h.Ya=function(){sd(this)};
	function sd(b){if(b.b&&"undefined"!=typeof goog&&(!b.s[1]||4!=O(b)||2!=b.T()))if(b.l&&4==O(b))Cb(b.Da,0,b);else if(b.dispatchEvent("readystatechange"),4==O(b)){b.b=!1;try{var c=b.T();a:switch(c){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var d=!0;break a;default:d=!1}var e;if(!(e=d)){var f;if(f=0===c){var g=String(b.A).match(sc)[1]||null;if(!g&&l.self&&l.self.location){var k=l.self.location.protocol;g=k.substr(0,k.length-1)}f=!ld.test(g?g.toLowerCase():"")}e=f}if(e)b.dispatchEvent("complete"),
	b.dispatchEvent("success");else{b.h=6;try{var m=2<O(b)?b.a.statusText:""}catch(E){m=""}b.f=m+" ["+b.T()+"]";qd(b)}}finally{rd(b)}}}function rd(b,c){if(b.a){od(b);var d=b.a,e=b.s[0]?ba:null;b.a=null;b.s=null;c||b.dispatchEvent("ready");try{d.onreadystatechange=e}catch(f){}}}function od(b){b.a&&b.D&&(b.a.ontimeout=null);b.m&&(l.clearTimeout(b.m),b.m=null)}function O(b){return b.a?b.a.readyState:0}h.T=function(){try{return 2<O(this)?this.a.status:-1}catch(b){return-1}};
	h.aa=function(){try{return this.a?this.a.responseText:""}catch(b){return""}};h.Ta=function(b){if(this.a){var c=this.a.responseText;b&&0==c.indexOf(b)&&(c=c.substring(b.length));return jd(c)}};function hc(b,c){return b.a?b.a.getResponseHeader(c):null}h.xa=function(){return this.h};h.Wa=function(){return n(this.f)?this.f:String(this.f)};function td(b){var c="";ua(b,function(d,e){c+=e;c+=":";c+=d;c+="\r\n"});return c}function ud(b,c,d){a:{for(e in d){var e=!1;break a}e=!0}if(e)return b;d=td(d);if(n(b)){c=encodeURIComponent(String(c));d=null!=d?"="+encodeURIComponent(String(d)):"";if(c+=d){d=b.indexOf("#");0>d&&(d=b.length);e=b.indexOf("?");if(0>e||e>d){e=d;var f=""}else f=b.substring(e+1,d);b=[b.substr(0,e),f,b.substr(d)];d=b[1];b[1]=c?d?d+"&"+c:c:d;b=b[0]+(b[1]?"?"+b[1]:"")+b[2]}return b}T(b,c,d);return b};function vd(b){this.f=[];this.F=new Sc;this.ga=this.oa=this.B=this.ha=this.a=this.I=this.j=this.V=this.g=this.J=this.i=null;this.Pa=this.P=0;this.Na=!!p("internalChannelParams.failFast",b);this.ia=this.w=this.s=this.l=this.h=this.c=null;this.na=!0;this.m=this.qa=this.O=-1;this.S=this.v=this.A=0;this.Ma=p("internalChannelParams.baseRetryDelayMs",b)||5E3;this.Qa=p("internalChannelParams.retryDelaySeedMs",b)||1E4;this.Oa=p("internalChannelParams.forwardChannelMaxRetries",b)||2;this.pa=p("internalChannelParams.forwardChannelRequestTimeoutMs",
	b)||2E4;this.Ja=b&&b.yb||void 0;this.D=void 0;this.R=b&&b.supportsCrossDomainXhr||!1;this.H="";this.b=new Wc(b&&b.concurrentRequestLimit);this.ja=new fd;this.o=b&&void 0!==b.backgroundChannelTest?b.backgroundChannelTest:!0;(this.W=b&&b.fastHandshake||!1)&&!this.o&&(this.o=!0);b&&b.forceLongPolling&&(this.na=!1);this.fa=void 0}h=vd.prototype;h.va=8;h.u=1;
	function wd(b){xd(b);if(3==b.u){var c=b.P++,d=N(b.B);T(d,"SID",b.H);T(d,"RID",c);T(d,"TYPE","terminate");yd(b,d);c=new M(b,c,void 0);c.F=2;c.f=bc(N(d));d=!1;l.navigator&&l.navigator.sendBeacon&&(d=l.navigator.sendBeacon(c.f.toString(),""));!d&&l.Image&&((new Image).src=c.f,d=!0);d||(c.a=c.g.$(null),c.a.ca(c.f));c.v=x();ec(c)}zd(b)}
	function xd(b){b.w&&(b.w.abort(),b.w=null);b.a&&(b.a.cancel(),b.a=null);b.l&&(l.clearTimeout(b.l),b.l=null);Ad(b);b.b.cancel();b.h&&(aa(b.h)&&l.clearTimeout(b.h),b.h=null)}function Bd(b,c){b.f.push(new Vc(b.Pa++,c));3==b.u&&Cd(b)}h.Ba=function(){return 0==this.u};function Cd(b){$c(b.b)||b.h||(b.h=!0,ub(b.Ga,b),b.A=0)}
	function Dd(b,c){if(ad(b.b)>=b.b.f-(b.h?1:0))return!1;if(b.h)return b.f=c.j.concat(b.f),!0;if(1==b.u||2==b.u||b.A>=(b.Na?0:b.Oa))return!1;b.h=Ob(v(b.Ga,b,c),Ed(b,b.A));b.A++;return!0}
	h.Ga=function(b){if(this.h)if(this.h=null,1==this.u){if(!b){this.P=Math.floor(1E5*Math.random());b=this.P++;var c=new M(this,b,void 0),d=this.i;this.J&&(d?(d=va(d),xa(d,this.J)):d=this.J);null===this.g&&(c.h=d);var e;if(this.W)a:{for(var f=e=0;f<this.f.length;f++){b:{var g=this.f[f];if("__data__"in g.a&&(g=g.a.__data__,n(g))){g=g.length;break b}g=void 0}if(void 0===g)break;e+=g;if(4096<e){e=f;break a}if(4096===e||f===this.f.length-1){e=f+1;break a}}e=1E3}else e=1E3;e=Fd(this,c,e);f=N(this.B);T(f,
	"RID",b);T(f,"CVER",22);this.o&&this.j&&T(f,"X-HTTP-Session-Id",this.j);yd(this,f);this.g&&d&&ud(f,this.g,d);Zc(this.b,c);this.W?(T(f,"$req",e),T(f,"SID","null"),c.S=!0,ac(c,f,null)):ac(c,f,e);this.u=2}}else 3==this.u&&(b?Gd(this,b):0==this.f.length||$c(this.b)||Gd(this))};
	function Gd(b,c){var d;c?d=c.W:d=b.P++;var e=N(b.B);T(e,"SID",b.H);T(e,"RID",d);T(e,"AID",b.O);yd(b,e);b.g&&b.i&&ud(e,b.g,b.i);d=new M(b,d,b.A+1);null===b.g&&(d.h=b.i);c&&(b.f=c.j.concat(b.f));c=Fd(b,d,1E3);d.setTimeout(Math.round(.5*b.pa)+Math.round(.5*b.pa*Math.random()));Zc(b.b,d);ac(d,e,c)}function yd(b,c){b.c&&oc({},function(d,e){T(c,e,d)})}
	function Fd(b,c,d){d=Math.min(b.f.length,d);var e=b.c?v(b.c.Ra,b.c,b):null;a:for(var f=b.f,g=-1;;){var k=["count="+d];-1==g?0<d?(g=f[0].b,k.push("ofs="+g)):g=0:k.push("ofs="+g);for(var m=!0,E=0;E<d;E++){var yb=f[E].b,Pc=f[E].a;yb-=g;if(0>yb)g=Math.max(0,f[E].b-100),m=!1;else try{gd(Pc,k,"req"+yb+"_")}catch(Pd){e&&e(Pc)}}if(m){e=k.join("&");break a}}b=b.f.splice(0,d);c.j=b;return e}function Hd(b){b.a||b.l||(b.S=1,ub(b.Fa,b),b.v=0)}
	function Id(b){if(b.a||b.l||3<=b.v)return!1;b.S++;b.l=Ob(v(b.Fa,b),Ed(b,b.v));b.v++;return!0}h.Fa=function(){this.l=null;this.a=new M(this,"rpc",this.S);null===this.g&&(this.a.h=this.i);this.a.J=0;var b=N(this.oa);T(b,"RID","rpc");T(b,"SID",this.H);T(b,"CI",this.ia?"0":"1");T(b,"AID",this.O);yd(this,b);T(b,"TYPE","xmlhttp");this.g&&this.i&&ud(b,this.g,this.i);this.D&&this.a.setTimeout(this.D);dc(this.a,b,!0,this.ga)};
	function Qc(b,c,d){var e=c.l;e&&Yc(b.b,e);b.ia=b.na&&d;b.m=c.c;b.B=Rc(b,null,b.ha);Cd(b)}
	h.Ea=function(b,c){if(0!=this.u&&(this.a==b||bd(this.b,b)))if(this.m=b.o,!b.s&&bd(this.b,b)&&3==this.u){try{var d=this.ja.a.parse(c)}catch(g){d=null}if(r(d)&&3==d.length){c=d;if(0==c[0])a:{if(!this.l){if(this.a)if(this.a.v+3E3<b.v)Ad(this),this.a.cancel(),this.a=null;else break a;Id(this);K(18)}}else this.qa=c[1],0<this.qa-this.O&&37500>c[2]&&this.ia&&0==this.v&&!this.s&&(this.s=Ob(v(this.Xa,this),6E3));if(1>=ad(this.b)&&this.fa){try{this.fa()}catch(g){}this.fa=void 0}}else W(this,11)}else if((b.s||
	this.a==b)&&Ad(this),!pa(c))for(c=d=this.ja.a.parse(c),d=0;d<c.length;d++){var e=c[d];this.O=e[0];e=e[1];if(2==this.u)if("c"==e[0]){this.H=e[1];this.ga=e[2];var f=e[3];null!=f&&(this.va=f);e=e[5];null!=e&&aa(e)&&0<e&&(this.D=1.5*e);this.o&&(e=b.a)&&((f=hc(e,"X-Client-Wire-Protocol"))&&Yc(this.b,f),this.j&&(e=hc(e,"X-HTTP-Session-Id")))&&(this.I=e,T(this.B,this.j,e));this.u=3;this.c&&this.c.ua();e=b;this.oa=Rc(this,this.Y()?this.ga:null,this.ha);e.s?(cd(this.b,e),(f=this.D)&&e.setTimeout(f),e.i&&(gc(e),
	ec(e)),this.a=e):Hd(this);0<this.f.length&&Cd(this)}else"stop"!=e[0]&&"close"!=e[0]||W(this,7);else 3==this.u&&("stop"==e[0]||"close"==e[0]?"stop"==e[0]?W(this,7):wd(this):"noop"!=e[0]&&this.c&&this.c.ta(e),this.v=0)}};h.Xa=function(){null!=this.s&&(this.s=null,this.a.cancel(),this.a=null,Id(this),K(19))};function Ad(b){null!=b.s&&(l.clearTimeout(b.s),b.s=null)}
	h.ma=function(b){var c=null;if(this.a==b){Ad(this);this.a=null;var d=2}else if(bd(this.b,b))c=b.j,cd(this.b,b),d=1;else return;this.m=b.o;if(0!=this.u)if(b.b)if(1==d){c=b.l?b.l.length:0;b=x()-b.v;var e=this.A;d=Kb();d.dispatchEvent(new Nb(d,c,b,e));Cd(this)}else Hd(this);else if(e=b.c,3==e||0==e&&0<this.m||!(1==d&&Dd(this,b)||2==d&&Id(this)))switch(c&&0<c.length&&(b=this.b,b.c=b.c.concat(c)),e){case 1:W(this,5);break;case 4:W(this,10);break;case 3:W(this,6);break;default:W(this,2)}};
	function Ed(b,c){var d=b.Ma+Math.floor(Math.random()*b.Qa);b.la()||(d*=2);return d*c}function W(b,c){if(2==c){var d=null;b.c&&(d=null);var e=v(b.cb,b);d||(d=new S("//www.google.com/images/cleardot.gif"),l.location&&"http"==l.location.protocol||uc(d,"https"),bc(d));hd(d.toString(),e)}else K(2);b.u=0;b.c&&b.c.sa(c);zd(b);xd(b)}h.cb=function(b){b?K(2):K(1)};function zd(b){b.u=0;b.m=-1;if(b.c){if(0!=dd(b.b).length||0!=b.f.length)b.b.c.length=0,oa(b.f),b.f.length=0;b.c.ra()}}
	function Rc(b,c,d){var e=Ic(d);if(""!=e.c)c&&vc(e,c+"."+e.c),wc(e,e.h);else{var f=l.location;e=Jc(f.protocol,c?c+"."+f.hostname:f.hostname,+f.port,d)}b.V&&ua(b.V,function(g,k){T(e,k,g)});c=b.j;d=b.I;c&&d&&T(e,c,d);T(e,"VER",b.va);yd(b,e);return e}h.$=function(b){if(b&&!this.R)throw Error("Can't create secondary domain capable XhrIo object.");b=new X(this.Ja);b.F=this.R;return b};h.la=function(){return!!this.c&&!0};h.Y=function(){return this.R};function Jd(){}h=Jd.prototype;h.ua=function(){};
	h.ta=function(){};h.sa=function(){};h.ra=function(){};h.Ra=function(){};function Kd(b){for(var c=arguments[0],d=1;d<arguments.length;d++){var e=arguments[d];if(0==e.lastIndexOf("/",0))c=e;else{var f;(f=""==c)||(f=c.length-1,f=0<=f&&c.indexOf("/",f)==f);f?c+=e:c+="/"+e}}return c};function Ld(){if(C&&!(10<=Number(Ma)))throw Error("Environmental error: no available transport.");}Ld.prototype.a=function(b,c){return new Y(b,c)};
	function Y(b,c){H.call(this);this.a=new vd(c);this.g=b;this.m=c&&c.testUrl?c.testUrl:Kd(this.g,"test");this.b=c&&c.messageUrlParams||null;b=c&&c.messageHeaders||null;c&&c.clientProtocolHeaderRequired&&(b?b["X-Client-Protocol"]="webchannel":b={"X-Client-Protocol":"webchannel"});this.a.i=b;b=c&&c.initMessageHeaders||null;c&&c.messageContentType&&(b?b["X-WebChannel-Content-Type"]=c.messageContentType:b={"X-WebChannel-Content-Type":c.messageContentType});c&&c.wa&&(b?b["X-WebChannel-Client-Profile"]=c.wa:
	b={"X-WebChannel-Client-Profile":c.wa});this.a.J=b;(b=c&&c.httpHeadersOverwriteParam)&&!pa(b)&&(this.a.g=b);this.l=c&&c.supportsCrossDomainXhr||!1;this.h=c&&c.sendRawJson||!1;(c=c&&c.httpSessionIdParam)&&!pa(c)&&(this.a.j=c,b=this.b,null!==b&&c in b&&(b=this.b,c in b&&delete b[c]));this.f=new Z(this)}y(Y,H);h=Y.prototype;h.addEventListener=function(b,c,d,e){Y.N.addEventListener.call(this,b,c,d,e)};h.removeEventListener=function(b,c,d,e){Y.N.removeEventListener.call(this,b,c,d,e)};
	h.Ua=function(){this.a.c=this.f;this.l&&(this.a.R=!0);var b=this.a,c=this.m,d=this.g,e=this.b||void 0;K(0);b.ha=d;b.V=e||{};b.o&&(b.F.b=[],b.F.a=!1);b.w=new Nc(b);null===b.g&&(b.w.h=b.i);d=c;b.g&&b.i&&(d=ud(c,b.g,b.i));b=b.w;b.i=d;c=Rc(b.a,null,b.i);K(3);d=b.a.F.b;null!=d?(b.f=d[0],b.M=1,Oc(b)):(fc(c,"MODE","init"),!b.a.o&&b.a.j&&fc(c,"X-HTTP-Session-Id",b.a.j),b.b=new M(b,void 0,void 0),b.b.h=b.h,dc(b.b,c,!1,null),b.M=0)};h.close=function(){wd(this.a)};
	h.Va=function(b){if(n(b)){var c={};c.__data__=b;Bd(this.a,c)}else this.h?(c={},c.__data__=mb(b),Bd(this.a,c)):Bd(this.a,b)};h.G=function(){this.a.c=null;delete this.f;wd(this.a);delete this.a;Y.N.G.call(this)};function Md(b){Ub.call(this);var c=b.__sm__;if(c){a:{for(var d in c){b=d;break a}b=void 0}(this.c=b)?(b=this.c,this.data=null!==c&&b in c?c[b]:void 0):this.data=c}else this.data=b}y(Md,Ub);function Nd(){Vb.call(this);this.status=1}y(Nd,Vb);function Z(b){this.a=b}y(Z,Jd);Z.prototype.ua=function(){this.a.dispatchEvent("a")};
	Z.prototype.ta=function(b){this.a.dispatchEvent(new Md(b))};Z.prototype.sa=function(b){this.a.dispatchEvent(new Nd(b))};Z.prototype.ra=function(){this.a.dispatchEvent("b")};var Od=w(function(b,c){function d(){}d.prototype=b.prototype;var e=new d;b.apply(e,Array.prototype.slice.call(arguments,1));return e},Ld);/*
	
	 Copyright 2017 Google Inc.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	Ld.prototype.createWebChannel=Ld.prototype.a;Y.prototype.send=Y.prototype.Va;Y.prototype.open=Y.prototype.Ua;Y.prototype.close=Y.prototype.close;Pb.NO_ERROR=0;Pb.TIMEOUT=8;Pb.HTTP_ERROR=6;Qb.COMPLETE="complete";Tb.EventType=L;L.OPEN="a";L.CLOSE="b";L.ERROR="c";L.MESSAGE="d";H.prototype.listen=H.prototype.ya;X.prototype.listenOnce=X.prototype.za;X.prototype.getLastError=X.prototype.Wa;X.prototype.getLastErrorCode=X.prototype.xa;X.prototype.getStatus=X.prototype.T;X.prototype.getResponseJson=X.prototype.Ta;
	X.prototype.getResponseText=X.prototype.aa;X.prototype.send=X.prototype.ca;module.exports={createWebChannelTransport:Od,ErrorCode:Pb,EventType:Qb,WebChannel:Tb,XhrIo:X};}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {})
	//# sourceMappingURL=index.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Fade = _interopRequireDefault(__webpack_require__(115));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    // Improve scrollable dialog support.
	    zIndex: -1,
	    position: 'fixed',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	exports.styles = styles;
	
	var Backdrop = _react.default.forwardRef(function Backdrop(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      transitionDuration = props.transitionDuration,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "invisible", "open", "transitionDuration"]);
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
	    in: open,
	    timeout: transitionDuration
	  }, other), _react.default.createElement("div", {
	    className: (0, _clsx.default)(classes.root, className, invisible && classes.invisible),
	    "aria-hidden": true,
	    ref: ref
	  }, children));
	});
	
	 false ? Backdrop.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBackdrop'
	})(Backdrop);
	
	exports.default = _default;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(105));

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(13));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _utils = __webpack_require__(6);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(16));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(40));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(131));
	
	var _focusVisible = __webpack_require__(166);
	
	var _TouchRipple = _interopRequireDefault(__webpack_require__(109));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$disabled': {
	      pointerEvents: 'none',
	      // Disable link interactions
	      cursor: 'default'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if `disabled={true}`. */
	  disabled: {},
	
	  /* Pseudo-class applied to the root element if keyboard focused. */
	  focusVisible: {}
	};
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	exports.styles = styles;
	
	var ButtonBase = _react.default.forwardRef(function ButtonBase(props, ref) {
	  var action = props.action,
	      buttonRefProp = props.buttonRef,
	      _props$centerRipple = props.centerRipple,
	      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$disableTouchRi = props.disableTouchRipple,
	      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
	      _props$focusRipple = props.focusRipple,
	      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
	      focusVisibleClassName = props.focusVisibleClassName,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onFocusVisible = props.onFocusVisible,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      onMouseDown = props.onMouseDown,
	      onMouseLeave = props.onMouseLeave,
	      onMouseUp = props.onMouseUp,
	      onTouchEnd = props.onTouchEnd,
	      onTouchMove = props.onTouchMove,
	      onTouchStart = props.onTouchStart,
	      onDragLeave = props.onDragLeave,
	      _props$tabIndex = props.tabIndex,
	      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
	      TouchRippleProps = props.TouchRippleProps,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);
	
	  var buttonRef = _react.default.useRef(null);
	
	  function getButtonNode() {
	    // #StrictMode ready
	    return _reactDom.default.findDOMNode(buttonRef.current);
	  }
	
	  var rippleRef = _react.default.useRef(null);
	
	  var _React$useState = _react.default.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  if (disabled && focusVisible) {
	    setFocusVisible(false);
	  }
	
	  var _useIsFocusVisible = (0, _focusVisible.useIsFocusVisible)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  _react.default.useImperativeHandle(action, function () {
	    return {
	      focusVisible: function focusVisible() {
	        setFocusVisible(true);
	        buttonRef.current.focus();
	      }
	    };
	  }, []);
	
	  _react.default.useEffect(function () {
	    if (focusVisible && focusRipple && !disableRipple) {
	      rippleRef.current.pulsate();
	    }
	  }, [disableRipple, focusRipple, focusVisible]);
	
	  function useRippleHandler(rippleAction, eventCallback) {
	    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
	    return (0, _useEventCallback.default)(function (event) {
	      if (eventCallback) {
	        eventCallback(event);
	      }
	
	      var ignore = skipRippleAction;
	
	      if (!ignore && rippleRef.current) {
	        rippleRef.current[rippleAction](event);
	      }
	
	      return true;
	    });
	  }
	
	  var handleMouseDown = useRippleHandler('start', onMouseDown);
	  var handleDragLeave = useRippleHandler('stop', onDragLeave);
	  var handleMouseUp = useRippleHandler('stop', onMouseUp);
	  var handleMouseLeave = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      event.preventDefault();
	    }
	
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	  });
	  var handleTouchStart = useRippleHandler('start', onTouchStart);
	  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
	  var handleTouchMove = useRippleHandler('stop', onTouchMove);
	  var handleBlur = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      onBlurVisible(event);
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  }, false);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    if (disabled) {
	      return;
	    } // Fix for https://github.com/facebook/react/issues/7769
	
	
	    if (!buttonRef.current) {
	      buttonRef.current = event.currentTarget;
	    }
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	
	      if (onFocusVisible) {
	        onFocusVisible(event);
	      }
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  });
	
	  var isNonNativeButton = function isNonNativeButton() {
	    var button = getButtonNode();
	    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
	  };
	  /**
	   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
	   */
	
	
	  var keydownRef = _react.default.useRef(false);
	
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    // Check if key is already down to avoid repeats being counted as multiple activations
	    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
	      keydownRef.current = true;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.start(event);
	      });
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter') {
	      event.preventDefault();
	
	      if (onClick) {
	        onClick(event);
	      }
	    }
	  });
	  var handleKeyUp = (0, _useEventCallback.default)(function (event) {
	    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
	    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
	    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
	      keydownRef.current = false;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.pulsate(event);
	      });
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
	      event.preventDefault();
	
	      if (onClick) {
	        onClick(event);
	      }
	    }
	  });
	  var ComponentProp = component;
	
	  if (ComponentProp === 'button' && other.href) {
	    ComponentProp = 'a';
	  }
	
	  var buttonProps = {};
	
	  if (ComponentProp === 'button') {
	    buttonProps.type = type;
	    buttonProps.disabled = disabled;
	  } else {
	    if (ComponentProp !== 'a' || !other.href) {
	      buttonProps.role = 'button';
	    }
	
	    buttonProps['aria-disabled'] = disabled;
	  }
	
	  var handleUserRef = (0, _useForkRef.default)(buttonRefProp, ref);
	  var handleOwnRef = (0, _useForkRef.default)(focusVisibleRef, buttonRef);
	  var handleRef = (0, _useForkRef.default)(handleUserRef, handleOwnRef);
	  return _react.default.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
	    onBlur: handleBlur,
	    onClick: onClick,
	    onFocus: handleFocus,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    onMouseDown: handleMouseDown,
	    onMouseLeave: handleMouseLeave,
	    onMouseUp: handleMouseUp,
	    onDragLeave: handleDragLeave,
	    onTouchEnd: handleTouchEnd,
	    onTouchMove: handleTouchMove,
	    onTouchStart: handleTouchStart,
	    ref: handleRef,
	    tabIndex: disabled ? -1 : tabIndex
	  }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_NoSsr.default, null, _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
	    ref: rippleRef,
	    center: centerRipple
	  }, TouchRippleProps))) : null);
	});
	
	 false ? ButtonBase.propTypes = {
	  /**
	   * A ref for imperative actions.
	   * It currently only supports `focusVisible()` action.
	   */
	  action: _utils.refType,
	
	  /**
	   * @ignore
	   *
	   * Use that prop to pass a ref to the native button component.
	   * @deprecated Use `ref` instead.
	   */
	  buttonRef: _utils.refType,
	
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the touch ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   * `disableRipple` must also be `false`.
	   */
	  focusRipple: _propTypes.default.bool,
	
	  /**
	   * This prop can help a person know which element has the keyboard focus.
	   * The class name will be applied when the element gain the focus through a keyboard interaction.
	   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
	   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
	   * if needed.
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onDragLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Props applied to the `TouchRipple` element.
	   */
	  TouchRippleProps: _propTypes.default.object,
	
	  /**
	   * Used to control the button's purpose.
	   * This prop passes the value to the `type` attribute of the native button component.
	   */
	  type: _propTypes.default.oneOf(['submit', 'reset', 'button'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonBase'
	})(ButtonBase);
	
	exports.default = _default;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(40));
	
	var useEnhancedEffect = typeof window === 'undefined' ? _react.default.useEffect : _react.default.useLayoutEffect;
	/**
	 * @ignore - internal component.
	 */
	
	function Ripple(props) {
	  var classes = props.classes,
	      _props$pulsate = props.pulsate,
	      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
	      rippleX = props.rippleX,
	      rippleY = props.rippleY,
	      rippleSize = props.rippleSize,
	      inProp = props.in,
	      _props$onExited = props.onExited,
	      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
	      timeout = props.timeout;
	
	  var _React$useState = _react.default.useState(false),
	      leaving = _React$useState[0],
	      setLeaving = _React$useState[1];
	
	  var rippleClassName = (0, _clsx.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
	  var rippleStyles = {
	    width: rippleSize,
	    height: rippleSize,
	    top: -(rippleSize / 2) + rippleY,
	    left: -(rippleSize / 2) + rippleX
	  };
	  var childClassName = (0, _clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
	  var handleExited = (0, _useEventCallback.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
	
	  useEnhancedEffect(function () {
	    if (!inProp) {
	      // react-transition-group#onExit
	      setLeaving(true); // react-transition-group#onExited
	
	      var timeoutId = setTimeout(handleExited, timeout);
	      return function () {
	        clearTimeout(timeoutId);
	      };
	    }
	
	    return undefined;
	  }, [handleExited, inProp, timeout]);
	  return _react.default.createElement("span", {
	    className: rippleClassName,
	    style: rippleStyles
	  }, _react.default.createElement("span", {
	    className: childClassName
	  }));
	}
	
	 false ? Ripple.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes.default.bool,
	
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes.default.number,
	
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes.default.number,
	
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes.default.number,
	
	  /**
	   * exit delay
	   */
	  timeout: _propTypes.default.number.isRequired
	} : void 0;
	var _default = Ripple;
	exports.default = _default;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(39));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(49);
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Ripple = _interopRequireDefault(__webpack_require__(108));
	
	var DURATION = 550;
	var DELAY_RIPPLE = 80;
	exports.DELAY_RIPPLE = DELAY_RIPPLE;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      zIndex: 0,
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit'
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripple` class. */
	    ripple: {
	      opacity: 0,
	      position: 'absolute'
	    },
	
	    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
	    ripplePulsate: {
	      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
	    },
	
	    /* Styles applied to the internal `Ripple` components `child` class. */
	    child: {
	      opacity: 1,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      borderRadius: '50%',
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
	    childLeaving: {
	      opacity: 0,
	      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
	    childPulsate: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
	    },
	    '@keyframes enter': {
	      '0%': {
	        transform: 'scale(0)',
	        opacity: 0.1
	      },
	      '100%': {
	        transform: 'scale(1)',
	        opacity: 0.3
	      }
	    },
	    '@keyframes exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 *
	 * TODO v5: Make private
	 */
	
	
	exports.styles = styles;
	
	var TouchRipple = _react.default.forwardRef(function TouchRipple(props, ref) {
	  var _props$center = props.center,
	      centerProp = _props$center === void 0 ? false : _props$center,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["center", "classes", "className"]);
	
	  var _React$useState = _react.default.useState([]),
	      ripples = _React$useState[0],
	      setRipples = _React$useState[1];
	
	  var nextKey = _react.default.useRef(0);
	
	  var rippleCallback = _react.default.useRef(null);
	
	  _react.default.useEffect(function () {
	    if (rippleCallback.current) {
	      rippleCallback.current();
	      rippleCallback.current = null;
	    }
	  }, [ripples]); // Used to filter out mouse emulated events on mobile.
	
	
	  var ignoringMouseDown = _react.default.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
	  // We don't want to display the ripple for touch scroll events.
	
	
	  var startTimer = _react.default.useRef(null); // This is the hook called once the previous timeout is ready.
	
	
	  var startTimerCommit = _react.default.useRef(null);
	
	  var container = _react.default.useRef(null);
	
	  _react.default.useEffect(function () {
	    return function () {
	      clearTimeout(startTimer.current);
	    };
	  }, []);
	
	  var startCommit = _react.default.useCallback(function (params) {
	    var pulsate = params.pulsate,
	        rippleX = params.rippleX,
	        rippleY = params.rippleY,
	        rippleSize = params.rippleSize,
	        cb = params.cb;
	    setRipples(function (oldRipples) {
	      return [].concat((0, _toConsumableArray2.default)(oldRipples), [_react.default.createElement(_Ripple.default, {
	        key: nextKey.current,
	        classes: classes,
	        timeout: DURATION,
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize
	      })]);
	    });
	    nextKey.current += 1;
	    rippleCallback.current = cb;
	  }, [classes]);
	
	  var start = _react.default.useCallback(function () {
	    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var cb = arguments.length > 2 ? arguments[2] : undefined;
	    var _options$pulsate = options.pulsate,
	        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
	        _options$center = options.center,
	        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
	        _options$fakeElement = options.fakeElement,
	        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
	
	    if (event.type === 'mousedown' && ignoringMouseDown.current) {
	      ignoringMouseDown.current = false;
	      return;
	    }
	
	    if (event.type === 'touchstart') {
	      ignoringMouseDown.current = true;
	    }
	
	    var element = fakeElement ? null : container.current;
	    var rect = element ? element.getBoundingClientRect() : {
	      width: 0,
	      height: 0,
	      left: 0,
	      top: 0
	    }; // Get the size of the ripple
	
	    var rippleX;
	    var rippleY;
	    var rippleSize;
	
	    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	      rippleX = Math.round(rect.width / 2);
	      rippleY = Math.round(rect.height / 2);
	    } else {
	      var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	      var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	      rippleX = Math.round(clientX - rect.left);
	      rippleY = Math.round(clientY - rect.top);
	    }
	
	    if (center) {
	      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
	
	      if (rippleSize % 2 === 0) {
	        rippleSize += 1;
	      }
	    } else {
	      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	    } // Touche devices
	
	
	    if (event.touches) {
	      // check that this isn't another touchstart due to multitouch
	      // otherwise we will only clear a single timer when unmounting while two
	      // are running
	      if (startTimerCommit.current === null) {
	        // Prepare the ripple effect.
	        startTimerCommit.current = function () {
	          startCommit({
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize,
	            cb: cb
	          });
	        }; // Delay the execution of the ripple effect.
	
	
	        startTimer.current = setTimeout(function () {
	          if (startTimerCommit.current) {
	            startTimerCommit.current();
	            startTimerCommit.current = null;
	          }
	        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	      }
	    } else {
	      startCommit({
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize,
	        cb: cb
	      });
	    }
	  }, [centerProp, startCommit]);
	
	  var pulsate = _react.default.useCallback(function () {
	    start({}, {
	      pulsate: true
	    });
	  }, [start]);
	
	  var stop = _react.default.useCallback(function (event, cb) {
	    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
	    // We still want to show ripple effect.
	
	    if (event.type === 'touchend' && startTimerCommit.current) {
	      event.persist();
	      startTimerCommit.current();
	      startTimerCommit.current = null;
	      startTimer.current = setTimeout(function () {
	        stop(event, cb);
	      });
	      return;
	    }
	
	    startTimerCommit.current = null;
	    setRipples(function (oldRipples) {
	      if (oldRipples.length > 0) {
	        return oldRipples.slice(1);
	      }
	
	      return oldRipples;
	    });
	    rippleCallback.current = cb;
	  }, []);
	
	  _react.default.useImperativeHandle(ref, function () {
	    return {
	      pulsate: pulsate,
	      start: start,
	      stop: stop
	    };
	  }, [pulsate, start, stop]);
	
	  return _react.default.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: container
	  }, other), _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: null,
	    exit: true
	  }, ripples));
	});
	
	 false ? TouchRipple.propTypes = {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiTouchRipple'
	})(_react.default.memo(TouchRipple));
	
	exports.default = _default;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _colorManipulator = __webpack_require__(30);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 1,
	      margin: 0,
	      // Reset browser default style.
	      border: 'none',
	      flexShrink: 0,
	      backgroundColor: theme.palette.divider
	    },
	
	    /* Styles applied to the root element if `absolute={true}`. */
	    absolute: {
	      position: 'absolute',
	      bottom: 0,
	      left: 0,
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `variant="inset"`. */
	    inset: {
	      marginLeft: 72
	    },
	
	    /* Styles applied to the root element if `light={true}`. */
	    light: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
	    },
	
	    /* Styles applied to the root element if `variant="middle"`. */
	    middle: {
	      marginLeft: theme.spacing(2),
	      marginRight: theme.spacing(2)
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      height: '100%',
	      width: 1
	    },
	
	    /* Styles applied to the root element if `flexItem={true}`. */
	    flexItem: {
	      alignSelf: 'stretch',
	      height: 'auto'
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Divider = _react.default.forwardRef(function Divider(props, ref) {
	  var _props$absolute = props.absolute,
	      absolute = _props$absolute === void 0 ? false : _props$absolute,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'hr' : _props$component,
	      _props$flexItem = props.flexItem,
	      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
	      _props$light = props.light,
	      light = _props$light === void 0 ? false : _props$light,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$role = props.role,
	      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
	    role: role,
	    ref: ref
	  }, other));
	});
	
	 false ? Divider.propTypes = {
	  /**
	   * Absolutely position the element.
	   */
	  absolute: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, a vertical divider will have the correct height when used in flex container.
	   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
	   */
	  flexItem: _propTypes.default.bool,
	
	  /**
	   * If `true`, the divider will have a lighter color.
	   */
	  light: _propTypes.default.bool,
	
	  /**
	   * The divider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['fullWidth', 'inset', 'middle'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDivider'
	})(Divider);
	
	exports.default = _default;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	
	var _Divider = _interopRequireDefault(__webpack_require__(110));

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isHorizontal = isHorizontal;
	exports.getAnchor = getAnchor;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _Modal = _interopRequireDefault(__webpack_require__(129));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(106));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Slide = _interopRequireDefault(__webpack_require__(137));
	
	var _Paper = _interopRequireDefault(__webpack_require__(133));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(32));
	
	var _transitions = __webpack_require__(22);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {},
	
	    /* Styles applied to the root element if `variant="permanent or persistent"`. */
	    docked: {
	      flex: '0 0 auto'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100%',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"`. */
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"`. */
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"`. */
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
	    paperAnchorDockedLeft: {
	      borderRight: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
	    paperAnchorDockedTop: {
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
	    paperAnchorDockedRight: {
	      borderLeft: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
	    paperAnchorDockedBottom: {
	      borderTop: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Modal` component. */
	    modal: {}
	  };
	};
	
	exports.styles = styles;
	var oppositeDirection = {
	  left: 'right',
	  right: 'left',
	  top: 'down',
	  bottom: 'up'
	};
	
	function isHorizontal(anchor) {
	  return ['left', 'right'].indexOf(anchor) !== -1;
	}
	
	function getAnchor(theme, anchor) {
	  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
	}
	
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The props of the [Modal](/api/modal/) component are available
	 * when `variant="temporary"` is set.
	 */
	
	var Drawer = _react.default.forwardRef(function Drawer(props, ref) {
	  var _props$anchor = props.anchor,
	      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropPropsProp = _props$ModalProps.BackdropProps,
	      ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      _props$open = props.open,
	      open = _props$open === void 0 ? false : _props$open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      SlideProps = props.SlideProps,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)(); // Let's assume that the Drawer will always be rendered on user space.
	  // We use this state is order to skip the appear transition during the
	  // initial mount of the component.
	
	  var mounted = _react.default.useRef(false);
	
	  _react.default.useEffect(function () {
	    mounted.current = true;
	  }, []);
	
	  var anchor = getAnchor(theme, anchorProp);
	
	  var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: variant === 'temporary' ? elevation : 0,
	    square: true
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, classes["paperAnchor".concat((0, _capitalize.default)(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat((0, _capitalize.default)(anchor))])
	  }), children);
	
	  if (variant === 'permanent') {
	    return _react.default.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), drawer);
	  }
	
	  var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
	    in: open,
	    direction: oppositeDirection[anchor],
	    timeout: transitionDuration,
	    appear: mounted.current
	  }, SlideProps), drawer);
	
	  if (variant === 'persistent') {
	    return _react.default.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), slidingDrawer);
	  } // variant === temporary
	
	
	  return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	    BackdropProps: (0, _extends2.default)({}, BackdropProps, {}, BackdropPropsProp, {
	      transitionDuration: transitionDuration
	    }),
	    BackdropComponent: _Backdrop.default,
	    className: (0, _clsx.default)(classes.root, classes.modal, className),
	    open: open,
	    onClose: onClose,
	    ref: ref
	  }, other, ModalProps), slidingDrawer);
	});
	
	 false ? Drawer.propTypes = {
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Modal`](/api/modal/) element.
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`Slide`](/api/slide/) element.
	   */
	  SlideProps: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDrawer',
	  flip: false
	})(Drawer);
	
	exports.default = _default;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	
	var _Drawer = _interopRequireDefault(__webpack_require__(112));

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(49);
	
	var _transitions = __webpack_require__(22);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(31));
	
	var _utils = __webpack_require__(64);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(16));
	
	var styles = {
	  entering: {
	    opacity: 1
	  },
	  entered: {
	    opacity: 1
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Fade transition is used by the [Modal](/components/modal/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Fade = _react.default.forwardRef(function Fade(props, ref) {
	  var children = props.children,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onExit = props.onExit,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);
	  var theme = (0, _useTheme.default)();
	  var handleRef = (0, _useForkRef.default)(children.ref, ref);
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    onEnter: handleEnter,
	    onExit: handleExit,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return _react.default.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], {}, style, {}, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	
	 false ? Fade.propTypes = {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Fade;
	exports.default = _default;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	
	var _Fade = _interopRequireDefault(__webpack_require__(114));

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _utils = __webpack_require__(6);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _colorManipulator = __webpack_require__(30);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(60));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(32));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      padding: 12,
	      borderRadius: '50%',
	      overflow: 'visible',
	      // Explicitly set the default value to solve a bug on IE 11.
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: 'transparent',
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -12,
	      '$sizeSmall&': {
	        marginLeft: -3
	      }
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -12,
	      '$sizeSmall&': {
	        marginRight: -3
	      }
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: 3,
	      fontSize: theme.typography.pxToRem(18)
	    },
	
	    /* Styles applied to the children container element. */
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/components/icons/) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	
	var IconButton = _react.default.forwardRef(function IconButton(props, ref) {
	  var _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, _capitalize.default)(size))], {
	      'start': classes.edgeStart,
	      'end': classes.edgeEnd
	    }[edge]),
	    centerRipple: true,
	    focusRipple: !disableFocusRipple,
	    disabled: disabled,
	    ref: ref
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	});
	
	 false ? IconButton.propTypes = {
	  /**
	   * The icon element.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var found = _react.default.Children.toArray(props.children).some(function (child) {
	      return _react.default.isValidElement(child) && child.props.onClick;
	    });
	
	    if (found) {
	      return new Error(['Material-UI: you are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['start', 'end', false]),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(116));

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(29));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	
	  /* Styles applied to the root element if `disablePadding={false}`. */
	  padding: {
	    paddingTop: 8,
	    paddingBottom: 8
	  },
	
	  /* Styles applied to the root element if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if a `subheader` is provided. */
	  subheader: {
	    paddingTop: 0
	  }
	};
	exports.styles = styles;
	
	var List = _react.default.forwardRef(function List(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disablePadding = props.disablePadding,
	      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
	      subheader = props.subheader,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
	
	  var context = _react.default.useMemo(function () {
	    return {
	      dense: dense
	    };
	  }, [dense]);
	
	  return _react.default.createElement(_ListContext.default.Provider, {
	    value: context
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
	    ref: ref
	  }, other), subheader, children));
	});
	
	 false ? List.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
	   * the list and list items.
	   * The prop is available to descendant components as the `dense` context.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, vertical padding will be removed from the list.
	   */
	  disablePadding: _propTypes.default.bool,
	
	  /**
	   * The content of the subheader, normally `ListSubheader`.
	   */
	  subheader: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiList'
	})(List);
	
	exports.default = _default;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(118));

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _utils = __webpack_require__(6);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(60));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(168));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(16));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(29));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(13));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left',
	      paddingTop: 8,
	      paddingBottom: 8,
	      '&$focusVisible': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$selected, &$selected:hover': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$disabled': {
	        opacity: 0.5
	      }
	    },
	
	    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
	    container: {
	      position: 'relative'
	    },
	
	    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
	    focusVisible: {},
	
	    /* Styles applied to the `component` element if dense. */
	    dense: {
	      paddingTop: 4,
	      paddingBottom: 4
	    },
	
	    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      alignItems: 'flex-start'
	    },
	
	    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the inner `component` element if `divider={true}`. */
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the inner `component` element if `button={true}`. */
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positioned.
	      paddingRight: 48
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? _react.default.useEffect : _react.default.useLayoutEffect;
	/**
	 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
	 */
	
	var ListItem = _react.default.forwardRef(function ListItem(props, ref) {
	  var _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$button = props.button,
	      button = _props$button === void 0 ? false : _props$button,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      componentProp = props.component,
	      _props$ContainerCompo = props.ContainerComponent,
	      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
	      _props$ContainerProps = props.ContainerProps;
	  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
	  var ContainerClassName = _props$ContainerProps.className,
	      ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$divider = props.divider,
	      divider = _props$divider === void 0 ? false : _props$divider,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);
	
	  var context = _react.default.useContext(_ListContext.default);
	
	  var childContext = {
	    dense: dense || context.dense || false,
	    alignItems: alignItems
	  };
	
	  var listItemRef = _react.default.useRef(null);
	
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      if (listItemRef.current) {
	        listItemRef.current.focus();
	      } else if (false) {
	        console.error('Material-UI: unable to set focus to a ListItem whose component has not been rendered.');
	      }
	    }
	  }, [autoFocus]);
	
	  var children = _react.default.Children.toArray(childrenProp);
	
	  var hasSecondaryAction = children.length && (0, _isMuiElement.default)(children[children.length - 1], ['ListItemSecondaryAction']);
	
	  var handleOwnRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    listItemRef.current = _reactDom.default.findDOMNode(instance);
	  }, []);
	
	  var handleRef = (0, _useForkRef.default)(handleOwnRef, ref);
	  var componentProps = (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
	    disabled: disabled
	  }, other);
	  var Component = componentProp || 'li';
	
	  if (button) {
	    componentProps.component = componentProp || 'div';
	    componentProps.focusVisibleClassName = (0, _clsx.default)(classes.focusVisible, focusVisibleClassName);
	    Component = _ButtonBase.default;
	  }
	
	  if (hasSecondaryAction) {
	    // Use div by default.
	    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	    if (ContainerComponent === 'li') {
	      if (Component === 'li') {
	        Component = 'div';
	      } else if (componentProps.component === 'li') {
	        componentProps.component = 'div';
	      }
	    }
	
	    return _react.default.createElement(_ListContext.default.Provider, {
	      value: childContext
	    }, _react.default.createElement(ContainerComponent, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, ContainerClassName),
	      ref: handleRef
	    }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop()));
	  }
	
	  return _react.default.createElement(_ListContext.default.Provider, {
	    value: childContext
	  }, _react.default.createElement(Component, (0, _extends2.default)({
	    ref: handleRef
	  }, componentProps), children));
	});
	
	 false ? ListItem.propTypes = {
	  /**
	   * Defines the `align-items` style property.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center']),
	
	  /**
	   * If `true`, the list item will be focused during the first mount.
	   * Focus will also be triggered if the value changes from false to true.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
	   * for `ButtonBase` can then be applied to `ListItem`.
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component. If a `ListItemSecondaryAction` is used it must
	   * be the last child.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var children = _react.default.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
	
	
	    var secondaryActionIndex = -1;
	
	    for (var i = children.length - 1; i >= 0; i -= 1) {
	      var child = children[i];
	
	      if ((0, _isMuiElement.default)(child, ['ListItemSecondaryAction'])) {
	        secondaryActionIndex = i;
	        break;
	      }
	    } //  is ListItemSecondaryAction the last child of ListItem
	
	
	    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
	      return new Error('Material-UI: you used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is the last child.
	   */
	  ContainerComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the container component if used.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * Use to apply selected styling.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(120));

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(29));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      minWidth: 56,
	      color: theme.palette.action.active,
	      flexShrink: 0,
	      display: 'inline-flex'
	    },
	
	    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      marginTop: 8
	    }
	  };
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
	 */
	
	
	exports.styles = styles;
	
	var ListItemIcon = _react.default.forwardRef(function ListItemIcon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	
	  var context = _react.default.useContext(_ListContext.default);
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	
	 false ? ListItemIcon.propTypes = {
	  /**
	   * The content of the component, normally `Icon`, `SvgIcon`,
	   * or a `@material-ui/icons` SVG icon element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemIcon'
	})(ListItemIcon);
	
	exports.default = _default;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	
	var _ListItemIcon = _interopRequireDefault(__webpack_require__(122));

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Typography = _interopRequireDefault(__webpack_require__(141));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(29));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    flex: '1 1 auto',
	    minWidth: 0,
	    marginTop: 4,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the `Typography` components if primary and secondary are set. */
	  multiline: {
	    marginTop: 6,
	    marginBottom: 6
	  },
	
	  /* Styles applied to the `Typography` components if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if `inset={true}`. */
	  inset: {
	    paddingLeft: 56
	  },
	
	  /* Styles applied to the primary `Typography` component. */
	  primary: {},
	
	  /* Styles applied to the secondary `Typography` component. */
	  secondary: {}
	};
	exports.styles = styles;
	
	var ListItemText = _react.default.forwardRef(function ListItemText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      primaryProp = props.primary,
	      primaryTypographyProps = props.primaryTypographyProps,
	      secondaryProp = props.secondary,
	      secondaryTypographyProps = props.secondaryTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);
	
	  var _React$useContext = _react.default.useContext(_ListContext.default),
	      dense = _React$useContext.dense;
	
	  var primary = primaryProp != null ? primaryProp : children;
	
	  if (primary != null && primary.type !== _Typography.default && !disableTypography) {
	    primary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
	      variant: dense ? 'body2' : 'body1',
	      className: classes.primary,
	      component: "span"
	    }, primaryTypographyProps), primary);
	  }
	
	  var secondary = secondaryProp;
	
	  if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
	    secondary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
	      variant: "body2",
	      className: classes.secondary,
	      color: "textSecondary"
	    }, secondaryTypographyProps), secondary);
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
	    ref: ref
	  }, other), primary, secondary);
	});
	
	 false ? ListItemText.propTypes = {
	  /**
	   * Alias for the `primary` property.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `children` (or `primary`) text, and optional `secondary` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes.default.bool,
	
	  /**
	   * The main content element.
	   */
	  primary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the primary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  primaryTypographyProps: _propTypes.default.object,
	
	  /**
	   * The secondary content element.
	   */
	  secondary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the secondary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  secondaryTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemText'
	})(ListItemText);
	
	exports.default = _default;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(124));

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(19);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(15);
	
	var _utils = __webpack_require__(6);
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	var _Portal = _interopRequireDefault(__webpack_require__(135));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(164));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(16));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(40));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(63));
	
	var _ModalManager = _interopRequireWildcard(__webpack_require__(61));
	
	var _TrapFocus = _interopRequireDefault(__webpack_require__(128));
	
	var _SimpleBackdrop = _interopRequireDefault(__webpack_require__(127));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom.default.findDOMNode(container);
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	} // A modal manager used to track and manage the state of open Modals.
	// Modals don't open on the server so this won't conflict with concurrent requests.
	
	
	var defaultManager = new _ModalManager.default();
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      right: 0,
	      bottom: 0,
	      top: 0,
	      left: 0
	    },
	
	    /* Styles applied to the root element if the `Modal` has exited. */
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	/**
	 * Modal is a lower-level construct that is leveraged by the following components:
	 *
	 * - [Dialog](/api/dialog/)
	 * - [Drawer](/api/drawer/)
	 * - [Menu](/api/menu/)
	 * - [Popover](/api/popover/)
	 *
	 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
	 * rather than directly using Modal.
	 *
	 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
	 */
	
	
	exports.styles = styles;
	
	var Modal = _react.default.forwardRef(function Modal(inProps, ref) {
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiModal',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$BackdropCompon = props.BackdropComponent,
	      BackdropComponent = _props$BackdropCompon === void 0 ? _SimpleBackdrop.default : _props$BackdropCompon,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      _props$closeAfterTran = props.closeAfterTransition,
	      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
	      container = props.container,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      _props$disableScrollL = props.disableScrollLock,
	      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
	      _props$hideBackdrop = props.hideBackdrop,
	      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      _props$manager = props.manager,
	      manager = _props$manager === void 0 ? defaultManager : _props$manager,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onRendered = props.onRendered,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
	
	  var _React$useState = _react.default.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var modal = _react.default.useRef({});
	
	  var mountNodeRef = _react.default.useRef(null);
	
	  var modalRef = _react.default.useRef(null);
	
	  var handleRef = (0, _useForkRef.default)(modalRef, ref);
	  var hasTransition = getHasTransition(props);
	
	  var getDoc = function getDoc() {
	    return (0, _ownerDocument.default)(mountNodeRef.current);
	  };
	
	  var getModal = function getModal() {
	    modal.current.modalRef = modalRef.current;
	    modal.current.mountNode = mountNodeRef.current;
	    return modal.current;
	  };
	
	  var handleMounted = function handleMounted() {
	    manager.mount(getModal(), {
	      disableScrollLock: disableScrollLock
	    }); // Fix a bug on Chrome where the scroll isn't initially 0.
	
	    modalRef.current.scrollTop = 0;
	  };
	
	  var handleOpen = (0, _useEventCallback.default)(function () {
	    var resolvedContainer = getContainer(container) || getDoc().body;
	    manager.add(getModal(), resolvedContainer); // The element was already mounted.
	
	    if (modalRef.current) {
	      handleMounted();
	    }
	  });
	
	  var isTopModal = _react.default.useCallback(function () {
	    return manager.isTopModal(getModal());
	  }, [manager]);
	
	  var handlePortalRef = (0, _useEventCallback.default)(function (node) {
	    mountNodeRef.current = node;
	
	    if (!node) {
	      return;
	    }
	
	    if (onRendered) {
	      onRendered();
	    }
	
	    if (open && isTopModal()) {
	      handleMounted();
	    } else {
	      (0, _ModalManager.ariaHidden)(modalRef.current, true);
	    }
	  });
	
	  var handleClose = _react.default.useCallback(function () {
	    manager.remove(getModal());
	  }, [manager]);
	
	  _react.default.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, [handleClose]);
	
	  _react.default.useEffect(function () {
	    if (open) {
	      handleOpen();
	    } else if (!hasTransition || !closeAfterTransition) {
	      handleClose();
	    }
	  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
	
	  if (!keepMounted && !open && (!hasTransition || exited)) {
	    return null;
	  }
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	
	    if (closeAfterTransition) {
	      handleClose();
	    }
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    if (event.target !== event.currentTarget) {
	      return;
	    }
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // The handler doesn't take event.defaultPrevented into account:
	    //
	    // event.preventDefault() is meant to stop default behaviours like
	    // clicking a checkbox to check it, hitting a button to submit a form,
	    // and hitting left arrow to move the cursor in a text input etc.
	    // Only special HTML elements have these default behaviors.
	    if (event.key !== 'Escape' || !isTopModal()) {
	      return;
	    } // Swallow the event, in case someone is listening for the escape key on the body.
	
	
	    event.stopPropagation();
	
	    if (onEscapeKeyDown) {
	      onEscapeKeyDown(event);
	    }
	
	    if (!disableEscapeKeyDown && onClose) {
	      onClose(event, 'escapeKeyDown');
	    }
	  };
	
	  var inlineStyle = styles(theme || {
	    zIndex: _zIndex.default
	  });
	  var childProps = {};
	
	  if (children.props.tabIndex === undefined) {
	    childProps.tabIndex = children.props.tabIndex || '-1';
	  } // It's a Transition like component
	
	
	  if (hasTransition) {
	    childProps.onEnter = (0, _createChainedFunction.default)(handleEnter, children.props.onEnter);
	    childProps.onExited = (0, _createChainedFunction.default)(handleExited, children.props.onExited);
	  }
	
	  return _react.default.createElement(_Portal.default, {
	    ref: handlePortalRef,
	    container: container,
	    disablePortal: disablePortal
	  }, _react.default.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    onKeyDown: handleKeyDown,
	    role: "presentation"
	  }, other, {
	    style: (0, _extends2.default)({}, inlineStyle.root, {}, !open && exited ? inlineStyle.hidden : {}, {}, other.style)
	  }), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
	    open: open,
	    onClick: handleBackdropClick
	  }, BackdropProps)), _react.default.createElement(_TrapFocus.default, {
	    disableEnforceFocus: disableEnforceFocus,
	    disableAutoFocus: disableAutoFocus,
	    disableRestoreFocus: disableRestoreFocus,
	    getDoc: getDoc,
	    isEnabled: isTopModal,
	    open: open
	  }, _react.default.cloneElement(children, childProps))));
	});
	
	 false ? Modal.propTypes = {
	  /**
	   * A backdrop component. This prop enables custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Backdrop`](/api/backdrop/) element.
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * When set to true the Modal waits until a nested Transition is completed before closing.
	   */
	  closeAfterTransition: _propTypes.default.bool,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, clicking the backdrop will not fire any callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire any callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Disable the scroll lock behavior.
	   */
	  disableScrollLock: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  manager: _propTypes.default.object,
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` prop took effect.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    zIndex: -1,
	    position: 'fixed',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	
	var SimpleBackdrop = _react.default.forwardRef(function SimpleBackdrop(props, ref) {
	  var _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["invisible", "open"]);
	  return open ? _react.default.createElement("div", (0, _extends2.default)({
	    "aria-hidden": true,
	    ref: ref
	  }, other, {
	    style: (0, _extends2.default)({}, styles.root, {}, invisible ? styles.invisible : {}, {}, other.style)
	  })) : null;
	});
	
	 false ? SimpleBackdrop.propTypes = {
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = SimpleBackdrop;
	exports.default = _default;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(16));
	
	/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */
	
	/**
	 * @ignore - internal component.
	 */
	function TrapFocus(props) {
	  var children = props.children,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      getDoc = props.getDoc,
	      isEnabled = props.isEnabled,
	      open = props.open;
	
	  var ignoreNextEnforceFocus = _react.default.useRef();
	
	  var sentinelStart = _react.default.useRef(null);
	
	  var sentinelEnd = _react.default.useRef(null);
	
	  var nodeToRestore = _react.default.useRef();
	
	  var rootRef = _react.default.useRef(null); // can be removed once we drop support for non ref forwarding class components
	
	
	  var handleOwnRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    rootRef.current = _reactDom.default.findDOMNode(instance);
	  }, []);
	
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // ⚠️ You may rely on React.useMemo as a performance optimization, not as a semantic guarantee.
	  // https://reactjs.org/docs/hooks-reference.html#usememo
	
	  _react.default.useMemo(function () {
	    if (!open || typeof window === 'undefined') {
	      return;
	    }
	
	    nodeToRestore.current = getDoc().activeElement;
	  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
	
	
	  _react.default.useEffect(function () {
	    if (!open) {
	      return;
	    }
	
	    var doc = (0, _ownerDocument.default)(rootRef.current); // We might render an empty child.
	
	    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	      if (!rootRef.current.hasAttribute('tabIndex')) {
	        if (false) {
	          console.error(['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
	        }
	
	        rootRef.current.setAttribute('tabIndex', -1);
	      }
	
	      rootRef.current.focus();
	    }
	
	    var contain = function contain() {
	      if (disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
	        ignoreNextEnforceFocus.current = false;
	        return;
	      }
	
	      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	        rootRef.current.focus();
	      }
	    };
	
	    var loopFocus = function loopFocus(event) {
	      // 9 = Tab
	      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
	        return;
	      } // Make sure the next tab starts from the right place.
	
	
	      if (doc.activeElement === rootRef.current) {
	        // We need to ignore the next contain as
	        // it will try to move the focus back to the rootRef element.
	        ignoreNextEnforceFocus.current = true;
	
	        if (event.shiftKey) {
	          sentinelEnd.current.focus();
	        } else {
	          sentinelStart.current.focus();
	        }
	      }
	    };
	
	    doc.addEventListener('focus', contain, true);
	    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
	    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
	    //
	    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
	    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
	
	    var interval = setInterval(function () {
	      contain();
	    }, 50);
	    return function () {
	      clearInterval(interval);
	      doc.removeEventListener('focus', contain, true);
	      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
	
	      if (!disableRestoreFocus) {
	        // In IE 11 it is possible for document.activeElement to be null resulting
	        // in nodeToRestore.current being null.
	        // Not all elements in IE 11 have a focus method.
	        // Once IE 11 support is dropped the focus() call can be unconditional.
	        if (nodeToRestore.current && nodeToRestore.current.focus) {
	          nodeToRestore.current.focus();
	        }
	
	        nodeToRestore.current = null;
	      }
	    };
	  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
	
	  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelStart,
	    "data-test": "sentinelStart"
	  }), _react.default.cloneElement(children, {
	    ref: handleRef
	  }), _react.default.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelEnd,
	    "data-test": "sentinelEnd"
	  }));
	}
	
	 false ? TrapFocus.propTypes = {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Return the document to consider.
	   * We use it to implement the restore focus between different browser documents.
	   */
	  getDoc: _propTypes.default.func.isRequired,
	
	  /**
	   * Do we still want to enforce the focus?
	   * This prop helps nesting TrapFocus elements.
	   */
	  isEnabled: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	/*
	
	In the future, we should be able to replace TrapFocus with:
	https://github.com/facebook/react/blob/master/packages/react-events/docs/FocusScope.md
	
	```jsx
	import FocusScope from 'react-dom/FocusScope';
	
	function TrapFocus(props) {
	  const {
	    children
	    disableAutoFocus = false,
	    disableEnforceFocus = false,
	    disableRestoreFocus = false,
	    open,
	  } = props;
	
	  if (!open) {
	    return children;
	  }
	
	  return (
	    <FocusScope
	      autoFocus={!disableAutoFocus}
	      contain={!disableEnforceFocus}
	      restoreFocus={!disableRestoreFocus}
	    >
	      {children}
	    </FocusScope>
	  );
	}
	```
	
	*/
	
	var _default = TrapFocus;
	exports.default = _default;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _ModalManager.default;
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(126));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(61));

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(6);
	
	var useEnhancedEffect = typeof window !== 'undefined' && ("production") !== 'test' ? _react.default.useLayoutEffect : _react.default.useEffect;
	/**
	 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
	 *
	 * This component can be useful in a variety of situations:
	 * - Escape hatch for broken dependencies not supporting SSR.
	 * - Improve the time-to-first paint on the client by only rendering above the fold.
	 * - Reduce the rendering time on the server.
	 * - Under too heavy server load, you can turn on service degradation.
	 */
	
	function NoSsr(props) {
	  var children = props.children,
	      _props$defer = props.defer,
	      defer = _props$defer === void 0 ? false : _props$defer,
	      _props$fallback = props.fallback,
	      fallback = _props$fallback === void 0 ? null : _props$fallback;
	
	  var _React$useState = _react.default.useState(false),
	      mountedState = _React$useState[0],
	      setMountedState = _React$useState[1];
	
	  useEnhancedEffect(function () {
	    if (!defer) {
	      setMountedState(true);
	    }
	  }, [defer]);
	
	  _react.default.useEffect(function () {
	    if (defer) {
	      setMountedState(true);
	    }
	  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
	
	
	  return _react.default.createElement(_react.default.Fragment, null, mountedState ? children : fallback);
	}
	
	 false ? NoSsr.propTypes = {
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * If `true`, the component will not only prevent server-side rendering.
	   * It will also defer the rendering of the children into a different screen frame.
	   */
	  defer: _propTypes.default.bool,
	
	  /**
	   * The fallback content to display.
	   */
	  fallback: _propTypes.default.node
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  NoSsr['propTypes' + ''] = (0, _utils.exactProp)(NoSsr.propTypes);
	}
	
	var _default = NoSsr;
	exports.default = _default;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(130));

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create('box-shadow')
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` */
	    outlined: {
	      border: "1px solid ".concat(theme.palette.divider)
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	
	var Paper = _react.default.forwardRef(function Paper(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation", "variant"]);
	
	  if (false) {
	    if (classes["elevation".concat(elevation)] === undefined) {
	      console.error("Material-UI: this elevation `".concat(elevation, "` is not implemented."));
	    }
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
	    ref: ref
	  }, other));
	});
	
	 false ? Paper.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It accepts values between 0 and 24 inclusive.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['elevation', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(132));

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(6);
	
	var _setRef = _interopRequireDefault(__webpack_require__(65));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(16));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container; // #StrictMode ready
	
	  return _reactDom.default.findDOMNode(container);
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? _react.default.useLayoutEffect : _react.default.useEffect;
	/**
	 * Portals provide a first-class way to render children into a DOM node
	 * that exists outside the DOM hierarchy of the parent component.
	 */
	
	var Portal = _react.default.forwardRef(function Portal(props, ref) {
	  var children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      onRendered = props.onRendered;
	
	  var _React$useState = _react.default.useState(null),
	      mountNode = _React$useState[0],
	      setMountNode = _React$useState[1];
	
	  var handleRef = (0, _useForkRef.default)(_react.default.isValidElement(children) ? children.ref : null, ref);
	  useEnhancedEffect(function () {
	    if (!disablePortal) {
	      setMountNode(getContainer(container) || document.body);
	    }
	  }, [container, disablePortal]);
	  useEnhancedEffect(function () {
	    if (mountNode && !disablePortal) {
	      (0, _setRef.default)(ref, mountNode);
	      return function () {
	        (0, _setRef.default)(ref, null);
	      };
	    }
	
	    return undefined;
	  }, [ref, mountNode, disablePortal]);
	  useEnhancedEffect(function () {
	    if (onRendered && (mountNode || disablePortal)) {
	      onRendered();
	    }
	  }, [onRendered, mountNode, disablePortal]);
	
	  if (disablePortal) {
	    if (_react.default.isValidElement(children)) {
	      return _react.default.cloneElement(children, {
	        ref: handleRef
	      });
	    }
	
	    return children;
	  }
	
	  return mountNode ? _reactDom.default.createPortal(children, mountNode) : mountNode;
	});
	
	 false ? Portal.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.default.Component), _propTypes.default.instanceOf(typeof Element === 'undefined' ? Object : Element)]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  Portal['propTypes' + ''] = (0, _utils.exactProp)(Portal.propTypes);
	}
	
	var _default = Portal;
	exports.default = _default;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(134));

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(13));
	
	var _debounce = _interopRequireDefault(__webpack_require__(165));
	
	var _reactTransitionGroup = __webpack_require__(49);
	
	var _utils = __webpack_require__(6);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(16));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(31));
	
	var _transitions = __webpack_require__(22);
	
	var _utils2 = __webpack_require__(64);
	
	// Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `none`.`
	function getTranslateValue(direction, node) {
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = window.getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(".concat(window.innerWidth, "px) translateX(-").concat(rect.left - offsetX, "px)");
	  }
	
	  if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
	  }
	
	  if (direction === 'up') {
	    return "translateY(".concat(window.innerHeight, "px) translateY(-").concat(rect.top - offsetY, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
	}
	
	function setTranslateValue(direction, node) {
	  var transform = getTranslateValue(direction, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Slide transition is used by the [Drawer](/components/drawers/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Slide = _react.default.forwardRef(function Slide(props, ref) {
	  var children = props.children,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'down' : _props$direction,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "direction", "in", "onEnter", "onEntering", "onExit", "onExited", "style", "timeout"]);
	  var theme = (0, _useTheme.default)();
	
	  var childrenRef = _react.default.useRef(null);
	  /**
	   * used in cloneElement(children, { ref: handleRef })
	   */
	
	
	  var handleOwnRef = _react.default.useCallback(function (instance) {
	    // #StrictMode ready
	    childrenRef.current = _reactDom.default.findDOMNode(instance);
	  }, []);
	
	  var handleRefIntermediary = (0, _useForkRef.default)(children.ref, handleOwnRef);
	  var handleRef = (0, _useForkRef.default)(handleRefIntermediary, ref);
	
	  var handleEnter = function handleEnter(_, isAppearing) {
	    var node = childrenRef.current;
	    setTranslateValue(direction, node);
	    (0, _utils2.reflow)(node);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleEntering = function handleEntering(_, isAppearing) {
	    var node = childrenRef.current;
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.webkitTransform = 'none';
	    node.style.transform = 'none';
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit() {
	    var node = childrenRef.current;
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    setTranslateValue(direction, node);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  var handleExited = function handleExited() {
	    var node = childrenRef.current; // No need for transitions when the component is hidden
	
	    node.style.webkitTransition = '';
	    node.style.transition = '';
	
	    if (onExited) {
	      onExited(node);
	    }
	  };
	
	  var updatePosition = _react.default.useCallback(function () {
	    if (childrenRef.current) {
	      setTranslateValue(direction, childrenRef.current);
	    }
	  }, [direction]);
	
	  _react.default.useEffect(function () {
	    // Skip configuration where the position is screen size invariant.
	    if (inProp || direction === 'down' || direction === 'right') {
	      return undefined;
	    }
	
	    var handleResize = (0, _debounce.default)(function () {
	      if (childrenRef.current) {
	        setTranslateValue(direction, childrenRef.current);
	      }
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [direction, inProp]);
	
	  _react.default.useEffect(function () {
	    if (!inProp) {
	      // We need to update the position of the drawer when the direction change and
	      // when it's hidden.
	      updatePosition();
	    }
	  }, [inProp, updatePosition]);
	
	  return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    onEnter: handleEnter,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    appear: true,
	    in: inProp,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return _react.default.cloneElement(children, (0, _extends2.default)({
	      ref: handleRef,
	      style: (0, _extends2.default)({
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, style, {}, children.props.style)
	    }, childProps));
	  });
	});
	
	 false ? Slide.propTypes = {
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef,
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Slide;
	exports.default = _default;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(136));

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(32));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      width: '1em',
	      height: '1em',
	      display: 'inline-block',
	      fill: 'currentColor',
	      flexShrink: 0,
	      fontSize: theme.typography.pxToRem(24),
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(35)
	    }
	  };
	};
	
	exports.styles = styles;
	
	var SvgIcon = _react.default.forwardRef(function SvgIcon(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'svg' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      htmlColor = props.htmlColor,
	      titleAccess = props.titleAccess,
	      _props$viewBox = props.viewBox,
	      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _capitalize.default)(fontSize))]),
	    focusable: "false",
	    viewBox: viewBox,
	    color: htmlColor,
	    "aria-hidden": titleAccess ? undefined : 'true',
	    role: titleAccess ? 'img' : 'presentation',
	    ref: ref
	  }, other), children, titleAccess ? _react.default.createElement("title", null, titleAccess) : null);
	});
	
	 false ? SvgIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
	   */
	  color: _propTypes.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['default', 'inherit', 'large', 'small']),
	
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  htmlColor: _propTypes.default.string,
	
	  /**
	   * The shape-rendering attribute. The behavior of the different options is described on the
	   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
	   * If you are having issues with blurry icons you should investigate this property.
	   */
	  shapeRendering: _propTypes.default.string,
	
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes.default.string,
	
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes.default.string
	} : void 0;
	SvgIcon.muiName = 'SvgIcon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSvgIcon'
	})(SvgIcon);
	
	exports.default = _default;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(138));

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(32));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      margin: 0
	    },
	
	    /* Styles applied to the root element if `variant="body2"`. */
	    body2: theme.typography.body2,
	
	    /* Styles applied to the root element if `variant="body1"`. */
	    body1: theme.typography.body1,
	
	    /* Styles applied to the root element if `variant="caption"`. */
	    caption: theme.typography.caption,
	
	    /* Styles applied to the root element if `variant="button"`. */
	    button: theme.typography.button,
	
	    /* Styles applied to the root element if `variant="h1"`. */
	    h1: theme.typography.h1,
	
	    /* Styles applied to the root element if `variant="h2"`. */
	    h2: theme.typography.h2,
	
	    /* Styles applied to the root element if `variant="h3"`. */
	    h3: theme.typography.h3,
	
	    /* Styles applied to the root element if `variant="h4"`. */
	    h4: theme.typography.h4,
	
	    /* Styles applied to the root element if `variant="h5"`. */
	    h5: theme.typography.h5,
	
	    /* Styles applied to the root element if `variant="h6"`. */
	    h6: theme.typography.h6,
	
	    /* Styles applied to the root element if `variant="subtitle1"`. */
	    subtitle1: theme.typography.subtitle1,
	
	    /* Styles applied to the root element if `variant="subtitle2"`. */
	    subtitle2: theme.typography.subtitle2,
	
	    /* Styles applied to the root element if `variant="overline"`. */
	    overline: theme.typography.overline,
	
	    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
	    srOnly: {
	      position: 'absolute',
	      height: 1,
	      width: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `nowrap={true}`. */
	    noWrap: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `gutterBottom={true}`. */
	    gutterBottom: {
	      marginBottom: '0.35em'
	    },
	
	    /* Styles applied to the root element if `paragraph={true}`. */
	    paragraph: {
	      marginBottom: 16
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="textPrimary"`. */
	    colorTextPrimary: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `color="textSecondary"`. */
	    colorTextSecondary: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `display="inline"`. */
	    displayInline: {
	      display: 'inline'
	    },
	
	    /* Styles applied to the root element if `display="block"`. */
	    displayBlock: {
	      display: 'block'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultVariantMapping = {
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  subtitle1: 'h6',
	  subtitle2: 'h6',
	  body1: 'p',
	  body2: 'p'
	};
	
	var Typography = _react.default.forwardRef(function Typography(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'initial' : _props$color,
	      component = props.component,
	      _props$display = props.display,
	      display = _props$display === void 0 ? 'initial' : _props$display,
	      _props$gutterBottom = props.gutterBottom,
	      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
	      _props$noWrap = props.noWrap,
	      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
	      _props$paragraph = props.paragraph,
	      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'body1' : _props$variant,
	      _props$variantMapping = props.variantMapping,
	      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);
	  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, _capitalize.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, _capitalize.default)(align))], display !== 'initial' && classes["display".concat((0, _capitalize.default)(display))]),
	    ref: ref
	  }, other));
	});
	
	 false ? Typography.propTypes = {
	  /**
	   * Set the text-align on the component.
	   */
	  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * Overrides the behavior of the `variantMapping` prop.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Controls the display type
	   */
	  display: _propTypes.default.oneOf(['initial', 'block', 'inline']),
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  gutterBottom: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
	   *
	   * Note that text overflow can only happen with block or inline-block level elements
	   * (the element needs to have a width in order to overflow).
	   */
	  noWrap: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  paragraph: _propTypes.default.bool,
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),
	
	  /**
	   * The component maps the variant prop to a range of different DOM element types.
	   * For instance, subtitle1 to `<h6>`.
	   * If you wish to change that mapping, you can provide your own.
	   * Alternatively, you can use the `component` prop.
	   */
	  variantMapping: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTypography'
	})(Typography);
	
	exports.default = _default;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	
	var _Typography = _interopRequireDefault(__webpack_require__(140));

/***/ },
/* 142 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blue = {
	  50: '#e3f2fd',
	  100: '#bbdefb',
	  200: '#90caf9',
	  300: '#64b5f6',
	  400: '#42a5f5',
	  500: '#2196f3',
	  600: '#1e88e5',
	  700: '#1976d2',
	  800: '#1565c0',
	  900: '#0d47a1',
	  A100: '#82b1ff',
	  A200: '#448aff',
	  A400: '#2979ff',
	  A700: '#2962ff'
	};
	var _default = blue;
	exports.default = _default;

/***/ },
/* 143 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var common = {
	  black: '#000',
	  white: '#fff'
	};
	var _default = common;
	exports.default = _default;

/***/ },
/* 144 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var green = {
	  50: '#e8f5e9',
	  100: '#c8e6c9',
	  200: '#a5d6a7',
	  300: '#81c784',
	  400: '#66bb6a',
	  500: '#4caf50',
	  600: '#43a047',
	  700: '#388e3c',
	  800: '#2e7d32',
	  900: '#1b5e20',
	  A100: '#b9f6ca',
	  A200: '#69f0ae',
	  A400: '#00e676',
	  A700: '#00c853'
	};
	var _default = green;
	exports.default = _default;

/***/ },
/* 145 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var grey = {
	  50: '#fafafa',
	  100: '#f5f5f5',
	  200: '#eeeeee',
	  300: '#e0e0e0',
	  400: '#bdbdbd',
	  500: '#9e9e9e',
	  600: '#757575',
	  700: '#616161',
	  800: '#424242',
	  900: '#212121',
	  A100: '#d5d5d5',
	  A200: '#aaaaaa',
	  A400: '#303030',
	  A700: '#616161'
	};
	var _default = grey;
	exports.default = _default;

/***/ },
/* 146 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var indigo = {
	  50: '#e8eaf6',
	  100: '#c5cae9',
	  200: '#9fa8da',
	  300: '#7986cb',
	  400: '#5c6bc0',
	  500: '#3f51b5',
	  600: '#3949ab',
	  700: '#303f9f',
	  800: '#283593',
	  900: '#1a237e',
	  A100: '#8c9eff',
	  A200: '#536dfe',
	  A400: '#3d5afe',
	  A700: '#304ffe'
	};
	var _default = indigo;
	exports.default = _default;

/***/ },
/* 147 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var orange = {
	  50: '#fff3e0',
	  100: '#ffe0b2',
	  200: '#ffcc80',
	  300: '#ffb74d',
	  400: '#ffa726',
	  500: '#ff9800',
	  600: '#fb8c00',
	  700: '#f57c00',
	  800: '#ef6c00',
	  900: '#e65100',
	  A100: '#ffd180',
	  A200: '#ffab40',
	  A400: '#ff9100',
	  A700: '#ff6d00'
	};
	var _default = orange;
	exports.default = _default;

/***/ },
/* 148 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var pink = {
	  50: '#fce4ec',
	  100: '#f8bbd0',
	  200: '#f48fb1',
	  300: '#f06292',
	  400: '#ec407a',
	  500: '#e91e63',
	  600: '#d81b60',
	  700: '#c2185b',
	  800: '#ad1457',
	  900: '#880e4f',
	  A100: '#ff80ab',
	  A200: '#ff4081',
	  A400: '#f50057',
	  A700: '#c51162'
	};
	var _default = pink;
	exports.default = _default;

/***/ },
/* 149 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var red = {
	  50: '#ffebee',
	  100: '#ffcdd2',
	  200: '#ef9a9a',
	  300: '#e57373',
	  400: '#ef5350',
	  500: '#f44336',
	  600: '#e53935',
	  700: '#d32f2f',
	  800: '#c62828',
	  900: '#b71c1c',
	  A100: '#ff8a80',
	  A200: '#ff5252',
	  A400: '#ff1744',
	  A700: '#d50000'
	};
	var _default = red;
	exports.default = _default;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createBreakpoints;
	exports.keys = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	// Sorted ASC by size. That's important.
	// It can't be configured as it's used statically for propTypes.
	var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.
	
	exports.keys = keys;
	
	function createBreakpoints(breakpoints) {
	  var _breakpoints$values = breakpoints.values,
	      values = _breakpoints$values === void 0 ? {
	    xs: 0,
	    sm: 600,
	    md: 960,
	    lg: 1280,
	    xl: 1920
	  } : _breakpoints$values,
	      _breakpoints$unit = breakpoints.unit,
	      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
	      _breakpoints$step = breakpoints.step,
	      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
	      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);
	
	  function up(key) {
	    var value = typeof values[key] === 'number' ? values[key] : key;
	    return "@media (min-width:".concat(value).concat(unit, ")");
	  }
	
	  function down(key) {
	    var endIndex = keys.indexOf(key) + 1;
	    var upperbound = values[keys[endIndex]];
	
	    if (endIndex === keys.length) {
	      // xl down applies to all sizes
	      return up('xs');
	    }
	
	    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
	    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
	  }
	
	  function between(start, end) {
	    var endIndex = keys.indexOf(end);
	
	    if (endIndex === keys.length - 1) {
	      return up(start);
	    }
	
	    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
	  }
	
	  function only(key) {
	    return between(key, key);
	  }
	
	  function width(key) {
	    return values[key];
	  }
	
	  return (0, _extends2.default)({
	    keys: keys,
	    values: values,
	    up: up,
	    down: down,
	    between: between,
	    only: only,
	    width: width
	  }, other);
	}

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMixins;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(26));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(3));
	
	function createMixins(breakpoints, spacing, mixins) {
	  var _toolbar;
	
	  return (0, _extends3.default)({
	    gutters: function gutters() {
	      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      // To deprecate in v4.1
	      //       warning(
	      //         false,
	      //         [
	      //           'Material-UI: theme.mixins.gutters() is deprecated.',
	      //           'You can use the source of the mixin directly:',
	      //           `
	      // paddingLeft: theme.spacing(2),
	      // paddingRight: theme.spacing(2),
	      // [theme.breakpoints.up('sm')]: {
	      //   paddingLeft: theme.spacing(3),
	      //   paddingRight: theme.spacing(3),
	      // },
	      // `,
	      //         ].join('\n'),
	      //       );
	      return (0, _extends3.default)({
	        paddingLeft: spacing(2),
	        paddingRight: spacing(2)
	      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
	        paddingLeft: spacing(3),
	        paddingRight: spacing(3)
	      }, styles[breakpoints.up('sm')])));
	    },
	    toolbar: (_toolbar = {
	      minHeight: 56
	    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
	      minHeight: 48
	    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
	      minHeight: 64
	    }), _toolbar)
	  }, mixins);
	}

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPalette;
	exports.dark = exports.light = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(6);
	
	var _common = _interopRequireDefault(__webpack_require__(143));
	
	var _grey = _interopRequireDefault(__webpack_require__(145));
	
	var _indigo = _interopRequireDefault(__webpack_require__(146));
	
	var _pink = _interopRequireDefault(__webpack_require__(148));
	
	var _red = _interopRequireDefault(__webpack_require__(149));
	
	var _orange = _interopRequireDefault(__webpack_require__(147));
	
	var _blue = _interopRequireDefault(__webpack_require__(142));
	
	var _green = _interopRequireDefault(__webpack_require__(144));
	
	var _colorManipulator = __webpack_require__(30);
	
	var light = {
	  // The colors used to style the text.
	  text: {
	    // The most important text.
	    primary: 'rgba(0, 0, 0, 0.87)',
	    // Secondary text.
	    secondary: 'rgba(0, 0, 0, 0.54)',
	    // Disabled text have even lower visual prominence.
	    disabled: 'rgba(0, 0, 0, 0.38)',
	    // Text hints.
	    hint: 'rgba(0, 0, 0, 0.38)'
	  },
	  // The color used to divide different elements.
	  divider: 'rgba(0, 0, 0, 0.12)',
	  // The background colors used to style the surfaces.
	  // Consistency between these values is important.
	  background: {
	    paper: _common.default.white,
	    default: _grey.default[50]
	  },
	  // The colors used to style the action elements.
	  action: {
	    // The color of an active action like an icon button.
	    active: 'rgba(0, 0, 0, 0.54)',
	    // The color of an hovered action.
	    hover: 'rgba(0, 0, 0, 0.04)',
	    hoverOpacity: 0.04,
	    // The color of a selected action.
	    selected: 'rgba(0, 0, 0, 0.08)',
	    selectedOpacity: 0.08,
	    // The color of a disabled action.
	    disabled: 'rgba(0, 0, 0, 0.26)',
	    // The background color of a disabled action.
	    disabledBackground: 'rgba(0, 0, 0, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(0, 0, 0, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpaciy: 0.12
	  }
	};
	exports.light = light;
	var dark = {
	  text: {
	    primary: _common.default.white,
	    secondary: 'rgba(255, 255, 255, 0.7)',
	    disabled: 'rgba(255, 255, 255, 0.5)',
	    hint: 'rgba(255, 255, 255, 0.5)',
	    icon: 'rgba(255, 255, 255, 0.5)'
	  },
	  divider: 'rgba(255, 255, 255, 0.12)',
	  background: {
	    paper: _grey.default[800],
	    default: '#303030'
	  },
	  action: {
	    active: _common.default.white,
	    hover: 'rgba(255, 255, 255, 0.08)',
	    hoverOpacity: 0.08,
	    selected: 'rgba(255, 255, 255, 0.16)',
	    selectedOpacity: 0.16,
	    disabled: 'rgba(255, 255, 255, 0.3)',
	    disabledBackground: 'rgba(255, 255, 255, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(255, 255, 255, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpaciy: 0.24
	  }
	};
	exports.dark = dark;
	
	function addLightOrDark(intent, direction, shade, tonalOffset) {
	  if (!intent[direction]) {
	    if (intent.hasOwnProperty(shade)) {
	      intent[direction] = intent[shade];
	    } else if (direction === 'light') {
	      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
	    } else if (direction === 'dark') {
	      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
	    }
	  }
	}
	
	function createPalette(palette) {
	  var _palette$primary = palette.primary,
	      primary = _palette$primary === void 0 ? {
	    light: _indigo.default[300],
	    main: _indigo.default[500],
	    dark: _indigo.default[700]
	  } : _palette$primary,
	      _palette$secondary = palette.secondary,
	      secondary = _palette$secondary === void 0 ? {
	    light: _pink.default.A200,
	    main: _pink.default.A400,
	    dark: _pink.default.A700
	  } : _palette$secondary,
	      _palette$error = palette.error,
	      error = _palette$error === void 0 ? {
	    light: _red.default[300],
	    main: _red.default[500],
	    dark: _red.default[700]
	  } : _palette$error,
	      _palette$warning = palette.warning,
	      warning = _palette$warning === void 0 ? {
	    light: _orange.default[300],
	    main: _orange.default[500],
	    dark: _orange.default[700]
	  } : _palette$warning,
	      _palette$info = palette.info,
	      info = _palette$info === void 0 ? {
	    light: _blue.default[300],
	    main: _blue.default[500],
	    dark: _blue.default[700]
	  } : _palette$info,
	      _palette$success = palette.success,
	      success = _palette$success === void 0 ? {
	    light: _green.default[300],
	    main: _green.default[500],
	    dark: _green.default[700]
	  } : _palette$success,
	      _palette$type = palette.type,
	      type = _palette$type === void 0 ? 'light' : _palette$type,
	      _palette$contrastThre = palette.contrastThreshold,
	      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
	      _palette$tonalOffset = palette.tonalOffset,
	      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
	      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
	  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
	  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
	
	  function getContrastText(background) {
	    if (!background) {
	      throw new TypeError("Material-UI: missing background argument in getContrastText(".concat(background, ")."));
	    }
	
	    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
	
	    if (false) {
	      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
	
	      if (contrast < 3) {
	        console.error(["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
	      }
	    }
	
	    return contrastText;
	  }
	
	  function augmentColor(color) {
	    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
	    color = (0, _extends2.default)({}, color);
	
	    if (!color.main && color[mainShade]) {
	      color.main = color[mainShade];
	    }
	
	    if (false) {
	      if (!color.main) {
	        throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
	      }
	    }
	
	    addLightOrDark(color, 'light', lightShade, tonalOffset);
	    addLightOrDark(color, 'dark', darkShade, tonalOffset);
	
	    if (!color.contrastText) {
	      color.contrastText = getContrastText(color.main);
	    }
	
	    return color;
	  }
	
	  var types = {
	    dark: dark,
	    light: light
	  };
	
	  if (false) {
	    if (!types[type]) {
	      console.error("Material-UI: the palette type `".concat(type, "` is not supported."));
	    }
	  }
	
	  var paletteOutput = (0, _utils.deepmerge)((0, _extends2.default)({
	    // A collection of common colors.
	    common: _common.default,
	    // The palette type, can be light or dark.
	    type: type,
	    // The colors used to represent primary interface elements for a user.
	    primary: augmentColor(primary),
	    // The colors used to represent secondary interface elements for a user.
	    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
	    // The colors used to represent interface elements that the user should be made aware of.
	    error: augmentColor(error),
	    // The colors used to represent potentially dangerous actions or important messages.
	    warning: augmentColor(warning),
	    // The colors used to present information to the user that is neutral and not necessarily important.
	    info: augmentColor(info),
	    // The colors used to indicate the successful completion of an action that user triggered.
	    success: augmentColor(success),
	    // The grey colors.
	    grey: _grey.default,
	    // Used by `getContrastText()` to maximize the contrast between
	    // the background and the text.
	    contrastThreshold: contrastThreshold,
	    // Takes a background color and returns the text color that maximizes the contrast.
	    getContrastText: getContrastText,
	    // Generate a rich color object.
	    augmentColor: augmentColor,
	    // Used by the functions below to shift a color's luminance by approximately
	    // two indexes within its tonal palette.
	    // E.g., shift from Red 500 to Red 300 or Red 700.
	    tonalOffset: tonalOffset
	  }, types[type]), other);
	  return paletteOutput;
	}

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSpacing;
	var warnOnce;
	
	function createSpacing() {
	  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
	
	  // Already transformed.
	  if (spacingInput.mui) {
	    return spacingInput;
	  } // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
	  // https://material.io/design/layout/understanding-layout.html#pixel-density
	
	
	  var transform;
	
	  if (typeof spacingInput === 'function') {
	    transform = spacingInput;
	  } else {
	    if (false) {
	      if (typeof spacingInput !== 'number') {
	        console.error(["Material-UI: the `theme.spacing` value (".concat(spacingInput, ") is invalid."), 'It should be a number or a function.'].join('\n'));
	      }
	    }
	
	    transform = function transform(factor) {
	      if (false) {
	        if (typeof factor !== 'number') {
	          console.error("Expected spacing argument to be a number, got ".concat(factor));
	        }
	      }
	
	      return spacingInput * factor;
	    };
	  }
	
	  var spacing = function spacing() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (false) {
	      if (!(args.length <= 4)) {
	        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
	      }
	    }
	
	    if (args.length === 0) {
	      return transform(1);
	    }
	
	    if (args.length === 1) {
	      return transform(args[0]);
	    }
	
	    return args.map(function (factor) {
	      var output = transform(factor);
	      return typeof output === 'number' ? "".concat(output, "px") : output;
	    }).join(' ');
	  }; // Backward compatibility, to remove in v5.
	
	
	  Object.defineProperty(spacing, 'unit', {
	    get: function get() {
	      if (false) {
	        if (!warnOnce || process.env.NODE_ENV === 'test') {
	          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
	        }
	
	        warnOnce = true;
	      }
	
	      return spacingInput;
	    }
	  });
	  spacing.mui = true;
	  return spacing;
	}

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	var _styles = __webpack_require__(15);
	
	// let warnOnce = false;
	// To remove in v5
	function createStyles(styles) {
	  // warning(
	  //   warnOnce,
	  //   [
	  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
	  //     'Please use @material-ui/styles/createStyles',
	  //   ].join('\n'),
	  // );
	  // warnOnce = true;
	  return (0, _styles.createStyles)(styles);
	}

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTypography;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(6);
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	var caseAllCaps = {
	  textTransform: 'uppercase'
	};
	var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
	/**
	 * @see @link{https://material.io/design/typography/the-type-system.html}
	 * @see @link{https://material.io/design/typography/understanding-typography.html}
	 */
	
	function createTypography(palette, typography) {
	  var _ref = typeof typography === 'function' ? typography(palette) : typography,
	      _ref$fontFamily = _ref.fontFamily,
	      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
	      _ref$fontSize = _ref.fontSize,
	      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
	      _ref$fontWeightLight = _ref.fontWeightLight,
	      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
	      _ref$fontWeightRegula = _ref.fontWeightRegular,
	      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
	      _ref$fontWeightMedium = _ref.fontWeightMedium,
	      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
	      _ref$fontWeightBold = _ref.fontWeightBold,
	      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
	      _ref$htmlFontSize = _ref.htmlFontSize,
	      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
	      allVariants = _ref.allVariants,
	      pxToRem2 = _ref.pxToRem,
	      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
	
	  if (false) {
	    if (typeof fontSize !== 'number') {
	      console.error('Material-UI: `fontSize` is required to be a number.');
	    }
	
	    if (typeof htmlFontSize !== 'number') {
	      console.error('Material-UI: `htmlFontSize` is required to be a number.');
	    }
	  }
	
	  var coef = fontSize / 14;
	
	  var pxToRem = pxToRem2 || function (size) {
	    return "".concat(size / htmlFontSize * coef, "rem");
	  };
	
	  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
	    return (0, _extends2.default)({
	      fontFamily: fontFamily,
	      fontWeight: fontWeight,
	      fontSize: pxToRem(size),
	      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
	      lineHeight: lineHeight
	    }, fontFamily === defaultFontFamily ? {
	      letterSpacing: "".concat(round(letterSpacing / size), "em")
	    } : {}, {}, casing, {}, allVariants);
	  };
	
	  var variants = {
	    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
	    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
	    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
	    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
	    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
	    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
	    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
	    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
	    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
	    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
	    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
	    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
	    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
	  };
	  return (0, _utils.deepmerge)((0, _extends2.default)({
	    htmlFontSize: htmlFontSize,
	    pxToRem: pxToRem,
	    round: round,
	    // TODO v5: remove
	    fontFamily: fontFamily,
	    fontSize: fontSize,
	    fontWeightLight: fontWeightLight,
	    fontWeightRegular: fontWeightRegular,
	    fontWeightMedium: fontWeightMedium,
	    fontWeightBold: fontWeightBold
	  }, variants), other, {
	    clone: false // No need to clone deep
	
	  });
	}

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.alignProperty = alignProperty;
	exports.fontGrid = fontGrid;
	exports.responsiveProperty = responsiveProperty;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(26));
	
	function alignProperty(_ref) {
	  var size = _ref.size,
	      grid = _ref.grid;
	  var sizeBelow = size - size % grid;
	  var sizeAbove = sizeBelow + grid;
	  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
	} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
	// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
	// without changing the relative line height
	
	
	function fontGrid(_ref2) {
	  var lineHeight = _ref2.lineHeight,
	      pixels = _ref2.pixels,
	      htmlFontSize = _ref2.htmlFontSize;
	  return pixels / (lineHeight * htmlFontSize);
	}
	/**
	 * generate a responsive version of a given CSS property
	 * @example
	 * responsiveProperty({
	 *   cssProperty: 'fontSize',
	 *   min: 15,
	 *   max: 20,
	 *   unit: 'px',
	 *   breakpoints: [300, 600],
	 * })
	 *
	 * // this returns
	 *
	 * {
	 *   fontSize: '15px',
	 *   '@media (min-width:300px)': {
	 *     fontSize: '17.5px',
	 *   },
	 *   '@media (min-width:600px)': {
	 *     fontSize: '20px',
	 *   },
	 * }
	 *
	 * @param {Object} params
	 * @param {string} params.cssProperty - The CSS property to be made responsive
	 * @param {number} params.min - The smallest value of the CSS property
	 * @param {number} params.max - The largest value of the CSS property
	 * @param {string} [params.unit] - The unit to be used for the CSS property
	 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
	 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
	 * @returns {Object} responsive styles for {params.cssProperty}
	 */
	
	
	function responsiveProperty(_ref3) {
	  var cssProperty = _ref3.cssProperty,
	      min = _ref3.min,
	      max = _ref3.max,
	      _ref3$unit = _ref3.unit,
	      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
	      _ref3$breakpoints = _ref3.breakpoints,
	      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
	      _ref3$transform = _ref3.transform,
	      transform = _ref3$transform === void 0 ? null : _ref3$transform;
	  var output = (0, _defineProperty2.default)({}, cssProperty, "".concat(min).concat(unit));
	  var factor = (max - min) / breakpoints[breakpoints.length - 1];
	  breakpoints.forEach(function (breakpoint) {
	    var value = min + factor * breakpoint;
	
	    if (transform !== null) {
	      value = transform(value);
	    }
	
	    output["@media (min-width:".concat(breakpoint, "px)")] = (0, _defineProperty2.default)({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
	  });
	  return output;
	}

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createMuiTheme: true,
	  createStyles: true,
	  makeStyles: true,
	  responsiveFontSizes: true,
	  styled: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true,
	  createGenerateClassName: true,
	  jssPreset: true,
	  ServerStyleSheets: true,
	  StylesProvider: true,
	  MuiThemeProvider: true,
	  ThemeProvider: true
	};
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiTheme.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "responsiveFontSizes", {
	  enumerable: true,
	  get: function get() {
	    return _responsiveFontSizes.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _styles.createGenerateClassName;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _styles.jssPreset;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ServerStyleSheets;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.StylesProvider;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	
	var _colorManipulator = __webpack_require__(30);
	
	Object.keys(_colorManipulator).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _colorManipulator[key];
	    }
	  });
	});
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(62));
	
	var _createStyles = _interopRequireDefault(__webpack_require__(154));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(158));
	
	var _responsiveFontSizes = _interopRequireDefault(__webpack_require__(159));
	
	var _styled = _interopRequireDefault(__webpack_require__(162));
	
	var _transitions = __webpack_require__(22);
	
	Object.keys(_transitions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _transitions[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(31));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(163));
	
	var _styles = __webpack_require__(15);

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _styles = __webpack_require__(15);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(21));
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return (0, _styles.makeStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = makeStyles;
	exports.default = _default;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = responsiveFontSizes;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _convertCssLength = _interopRequireDefault(__webpack_require__(220));
	
	var _cssUtils = __webpack_require__(156);
	
	function isUnitless(value) {
	  return String(parseFloat(value)).length === String(value).length;
	}
	
	function responsiveFontSizes(themeInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
	      _options$disableAlign = options.disableAlign,
	      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
	      _options$factor = options.factor,
	      factor = _options$factor === void 0 ? 2 : _options$factor,
	      _options$variants = options.variants,
	      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;
	  var theme = (0, _extends2.default)({}, themeInput);
	  theme.typography = (0, _extends2.default)({}, theme.typography);
	  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
	  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
	
	  var convert = (0, _convertCssLength.default)(typography.htmlFontSize);
	  var breakpointValues = breakpoints.map(function (x) {
	    return theme.breakpoints.values[x];
	  });
	  variants.forEach(function (variant) {
	    var style = typography[variant];
	    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));
	
	    if (remFontSize <= 1) {
	      return;
	    }
	
	    var maxFontSize = remFontSize;
	    var minFontSize = 1 + (maxFontSize - 1) / factor;
	    var lineHeight = style.lineHeight;
	
	    if (!isUnitless(lineHeight) && !disableAlign) {
	      throw new Error(["Material-UI: unsupported non-unitless line height with grid alignment.", 'Use unitless line heights instead.'].join('\n'));
	    }
	
	    if (!isUnitless(lineHeight)) {
	      // make it unitless
	      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
	    }
	
	    var transform = null;
	
	    if (!disableAlign) {
	      transform = function transform(value) {
	        return (0, _cssUtils.alignProperty)({
	          size: value,
	          grid: (0, _cssUtils.fontGrid)({
	            pixels: 4,
	            lineHeight: lineHeight,
	            htmlFontSize: typography.htmlFontSize
	          })
	        });
	      };
	    }
	
	    typography[variant] = (0, _extends2.default)({}, style, {}, (0, _cssUtils.responsiveProperty)({
	      cssProperty: 'fontSize',
	      min: minFontSize,
	      max: maxFontSize,
	      unit: 'rem',
	      breakpoints: breakpointValues,
	      transform: transform
	    }));
	  });
	  return theme;
	}

/***/ },
/* 160 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shadowKeyUmbraOpacity = 0.2;
	var shadowKeyPenumbraOpacity = 0.14;
	var shadowAmbientShadowOpacity = 0.12;
	
	function createShadow() {
	  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
	} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
	
	
	var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
	var _default = shadows;
	exports.default = _default;

/***/ },
/* 161 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shape = {
	  borderRadius: 4
	};
	var _default = shape;
	exports.default = _default;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _styles = __webpack_require__(15);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(21));
	
	var styled = function styled(Component) {
	  var componentCreator = (0, _styles.styled)(Component);
	  return function (style, options) {
	    return componentCreator(style, (0, _extends2.default)({
	      defaultTheme: _defaultTheme.default
	    }, options));
	  };
	};
	
	var _default = styled;
	exports.default = _default;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _styles = __webpack_require__(15);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(21));
	
	var withTheme = (0, _styles.withThemeCreator)({
	  defaultTheme: _defaultTheme.default
	});
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainedFunction;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (acc, func) {
	    if (func == null) {
	      return acc;
	    }
	
	    if (false) {
	      if (typeof func !== 'function') {
	        console.error('Material-UI: invalid Argument Type, must only provide functions, undefined, or null.');
	      }
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, function () {});
	}

/***/ },
/* 165 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	
	// Corresponds to 10 frames at 60 Hz.
	// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
	function debounce(func) {
	  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
	  var timeout;
	
	  function debounced() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // eslint-disable-next-line consistent-this
	    var that = this;
	
	    var later = function later() {
	      func.apply(that, args);
	    };
	
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	  }
	
	  debounced.clear = function () {
	    clearTimeout(timeout);
	  };
	
	  return debounced;
	}

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.teardown = teardown;
	exports.useIsFocusVisible = useIsFocusVisible;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(13));
	
	// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
	var hadKeyboardEvent = true;
	var hadFocusVisibleRecently = false;
	var hadFocusVisibleRecentlyTimeout = null;
	var inputTypesWhitelist = {
	  text: true,
	  search: true,
	  url: true,
	  tel: true,
	  email: true,
	  password: true,
	  number: true,
	  date: true,
	  month: true,
	  week: true,
	  time: true,
	  datetime: true,
	  'datetime-local': true
	};
	/**
	 * Computes whether the given element should automatically trigger the
	 * `focus-visible` class being added, i.e. whether it should always match
	 * `:focus-visible` when focused.
	 * @param {Element} node
	 * @return {boolean}
	 */
	
	function focusTriggersKeyboardModality(node) {
	  var type = node.type,
	      tagName = node.tagName;
	
	  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
	    return true;
	  }
	
	  if (tagName === 'TEXTAREA' && !node.readOnly) {
	    return true;
	  }
	
	  if (node.isContentEditable) {
	    return true;
	  }
	
	  return false;
	}
	/**
	 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
	 * If the most recent user interaction was via the keyboard;
	 * and the key press did not include a meta, alt/option, or control key;
	 * then the modality is keyboard. Otherwise, the modality is not keyboard.
	 * @param {KeyboardEvent} event
	 */
	
	
	function handleKeyDown(event) {
	  if (event.metaKey || event.altKey || event.ctrlKey) {
	    return;
	  }
	
	  hadKeyboardEvent = true;
	}
	/**
	 * If at any point a user clicks with a pointing device, ensure that we change
	 * the modality away from keyboard.
	 * This avoids the situation where a user presses a key on an already focused
	 * element, and then clicks on a different element, focusing it with a
	 * pointing device, while we still think we're in keyboard modality.
	 */
	
	
	function handlePointerDown() {
	  hadKeyboardEvent = false;
	}
	
	function handleVisibilityChange() {
	  if (this.visibilityState === 'hidden') {
	    // If the tab becomes active again, the browser will handle calling focus
	    // on the element (Safari actually calls it twice).
	    // If this tab change caused a blur on an element with focus-visible,
	    // re-apply the class when the user switches back to the tab.
	    if (hadFocusVisibleRecently) {
	      hadKeyboardEvent = true;
	    }
	  }
	}
	
	function prepare(doc) {
	  doc.addEventListener('keydown', handleKeyDown, true);
	  doc.addEventListener('mousedown', handlePointerDown, true);
	  doc.addEventListener('pointerdown', handlePointerDown, true);
	  doc.addEventListener('touchstart', handlePointerDown, true);
	  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function teardown(doc) {
	  doc.removeEventListener('keydown', handleKeyDown, true);
	  doc.removeEventListener('mousedown', handlePointerDown, true);
	  doc.removeEventListener('pointerdown', handlePointerDown, true);
	  doc.removeEventListener('touchstart', handlePointerDown, true);
	  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function isFocusVisible(event) {
	  var target = event.target;
	
	  try {
	    return target.matches(':focus-visible');
	  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
	  // we use our own heuristic for those browsers
	  // rethrow might be better if it's not the expected error but do we really
	  // want to crash if focus-visible malfunctioned?
	  // no need for validFocusTarget check. the user does that by attaching it to
	  // focusable events only
	
	
	  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
	}
	/**
	 * Should be called if a blur event is fired on a focus-visible element
	 */
	
	
	function handleBlurVisible() {
	  // To detect a tab/window switch, we look for a blur event followed
	  // rapidly by a visibility change.
	  // If we don't see a visibility change within 100ms, it's probably a
	  // regular focus change.
	  hadFocusVisibleRecently = true;
	  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
	  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
	    hadFocusVisibleRecently = false;
	  }, 100);
	}
	
	function useIsFocusVisible() {
	  var ref = _react.default.useCallback(function (instance) {
	    var node = _reactDom.default.findDOMNode(instance);
	
	    if (node != null) {
	      prepare(node.ownerDocument);
	    }
	  }, []);
	
	  return {
	    isFocusVisible: isFocusVisible,
	    onBlurVisible: handleBlurVisible,
	    ref: ref
	  };
	}

/***/ },
/* 167 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScrollbarSize;
	
	// A change of the browser zoom change the scrollbar size.
	// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
	function getScrollbarSize() {
	  var scrollDiv = document.createElement('div');
	  scrollDiv.style.width = '99px';
	  scrollDiv.style.height = '99px';
	  scrollDiv.style.position = 'absolute';
	  scrollDiv.style.top = '-9999px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarSize;
	}

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMuiElement;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function isMuiElement(element, muiNames) {
	  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
	}

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerWindow;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc.defaultView || window;
	}

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(171));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
	}), 'Reorder');
	
	exports.default = _default;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(139));
	
	function createSvgIcon(path, displayName) {
	  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
	    return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  }));
	
	  if (false) {
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return Component;
	}

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(52));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(37));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _jss = __webpack_require__(17);
	
	var _StylesProvider = _interopRequireDefault(__webpack_require__(41));
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(42));
	
	var ServerStyleSheets =
	/*#__PURE__*/
	function () {
	  function ServerStyleSheets() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, ServerStyleSheets);
	    this.options = options;
	  }
	
	  (0, _createClass2.default)(ServerStyleSheets, [{
	    key: "collect",
	    value: function collect(children) {
	      // This is needed in order to deduplicate the injection of CSS in the page.
	      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.
	
	      this.sheetsRegistry = new _jss.SheetsRegistry(); // A new class name generator
	
	      var generateClassName = (0, _createGenerateClassName.default)();
	      return _react.default.createElement(_StylesProvider.default, (0, _extends2.default)({
	        sheetsManager: sheetsManager,
	        serverGenerateClassName: generateClassName,
	        sheetsRegistry: this.sheetsRegistry
	      }, this.options), children);
	    }
	  }, {
	    key: "toString",
	    value: function toString() {
	      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
	    }
	  }, {
	    key: "getStyleElement",
	    value: function getStyleElement(props) {
	      return _react.default.createElement('style', (0, _extends2.default)({
	        id: 'jss-server-side',
	        key: 'jss-server-side',
	        dangerouslySetInnerHTML: {
	          __html: this.toString()
	        }
	      }, props));
	    }
	  }]);
	  return ServerStyleSheets;
	}();
	
	var _default = ServerStyleSheets;
	exports.default = _default;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	
	var _ServerStyleSheets = _interopRequireDefault(__webpack_require__(172));

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.StylesContext = exports.sheetsManager = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(6);
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(42));
	
	var _jss = __webpack_require__(17);
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(69));
	
	// Default JSS instance.
	var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
	//
	// The counter-based approach doesn't tolerate any mistake.
	// It's much safer to use the same counter everywhere.
	
	var generateClassName = (0, _createGenerateClassName.default)(); // Exported for test purposes
	
	var sheetsManager = new Map();
	exports.sheetsManager = sheetsManager;
	var defaultOptions = {
	  disableGeneration: false,
	  generateClassName: generateClassName,
	  jss: jss,
	  sheetsCache: null,
	  sheetsManager: sheetsManager,
	  sheetsRegistry: null
	};
	
	var StylesContext = _react.default.createContext(defaultOptions);
	
	exports.StylesContext = StylesContext;
	
	if (false) {
	  StylesContext.displayName = 'StylesContext';
	}
	
	var injectFirstNode;
	
	function StylesProvider(props) {
	  var children = props.children,
	      _props$injectFirst = props.injectFirst,
	      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
	      _props$disableGenerat = props.disableGeneration,
	      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
	      localOptions = (0, _objectWithoutProperties2.default)(props, ["children", "injectFirst", "disableGeneration"]);
	
	  var outerOptions = _react.default.useContext(StylesContext);
	
	  var context = (0, _extends2.default)({}, outerOptions, {
	    disableGeneration: disableGeneration
	  }, localOptions);
	
	  if (false) {
	    if (typeof window === 'undefined' && !context.sheetsManager) {
	      console.error('Material-UI: you need to use the ServerStyleSheets API when rendering on the server.');
	    }
	  }
	
	  if (false) {
	    if (context.jss.options.insertionPoint && injectFirst) {
	      console.error('Material-UI: you cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
	    }
	  }
	
	  if (false) {
	    if (injectFirst && localOptions.jss) {
	      console.error('Material-UI: you cannot use the jss and injectFirst props at the same time.');
	    }
	  }
	
	  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
	    if (!injectFirstNode) {
	      var head = document.head;
	      injectFirstNode = document.createComment('mui-inject-first');
	      head.insertBefore(injectFirstNode, head.firstChild);
	    }
	
	    context.jss = (0, _jss.create)({
	      plugins: (0, _jssPreset.default)().plugins,
	      insertionPoint: injectFirstNode
	    });
	  }
	
	  return _react.default.createElement(StylesContext.Provider, {
	    value: context
	  }, children);
	}
	
	 false ? StylesProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * You can disable the generation of the styles with this option.
	   * It can be useful when traversing the React tree outside of the HTML
	   * rendering step on the server.
	   * Let's say you are using react-apollo to extract all
	   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
	   */
	  disableGeneration: _propTypes.default.bool,
	
	  /**
	   * JSS's class name generator.
	   */
	  generateClassName: _propTypes.default.func,
	
	  /**
	   * By default, the styles are injected last in the <head> element of the page.
	   * As a result, they gain more specificity than any other style sheet.
	   * If you want to override Material-UI's styles, set this prop.
	   */
	  injectFirst: _propTypes.default.bool,
	
	  /**
	   * JSS's instance.
	   */
	  jss: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  serverGenerateClassName: _propTypes.default.func,
	
	  /**
	   * @ignore
	   *
	   * Beta feature.
	   *
	   * Cache for the sheets.
	   */
	  sheetsCache: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * The sheetsManager is used to deduplicate style sheet injection in the page.
	   * It's deduplicating using the (theme, styles) couple.
	   * On the server, you should provide a new instance for each request.
	   */
	  sheetsManager: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * Collect the sheets.
	   */
	  sheetsRegistry: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = (0, _utils.exactProp)(StylesProvider.propTypes) : void 0;
	}
	
	var _default = StylesProvider;
	exports.default = _default;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(6);
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(71));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(23));
	
	var _nested = _interopRequireDefault(__webpack_require__(66));
	
	// To support composition of theme.
	function mergeOuterLocalTheme(outerTheme, localTheme) {
	  if (typeof localTheme === 'function') {
	    var mergedTheme = localTheme(outerTheme);
	
	    if (false) {
	      if (!mergedTheme) {
	        console.error(['Material-UI: you should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
	      }
	    }
	
	    return mergedTheme;
	  }
	
	  return (0, _extends2.default)({}, outerTheme, {}, localTheme);
	}
	/**
	 * This component takes a `theme` prop.
	 * It makes the `theme` available down the React tree thanks to React context.
	 * This component should preferably be used at **the root of your component tree**.
	 */
	
	
	function ThemeProvider(props) {
	  var children = props.children,
	      localTheme = props.theme;
	  var outerTheme = (0, _useTheme.default)();
	
	  if (false) {
	    if (outerTheme === null && typeof localTheme === 'function') {
	      console.error(['Material-UI: you are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
	    }
	  }
	
	  var theme = _react.default.useMemo(function () {
	    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
	
	    if (output != null) {
	      output[_nested.default] = outerTheme !== null;
	    }
	
	    return output;
	  }, [localTheme, outerTheme]);
	
	  return _react.default.createElement(_ThemeContext.default.Provider, {
	    value: theme
	  }, children);
	}
	
	 false ? ThemeProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * A theme object. You can provide a function to extend the outer theme.
	   */
	  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = (0, _utils.exactProp)(ThemeProvider.propTypes) : void 0;
	}
	
	var _default = ThemeProvider;
	exports.default = _default;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	
	var _ThemeProvider = _interopRequireDefault(__webpack_require__(175));

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createGenerateClassName;
	
	var _nested = _interopRequireDefault(__webpack_require__(66));
	
	/**
	 * This is the list of the style rule name we use as drop in replacement for the built-in
	 * pseudo classes (:checked, :disabled, :focused, etc.).
	 *
	 * Why do they exist in the first place?
	 * These classes are used at a specificity of 2.
	 * It allows them to override previously definied styles as well as
	 * being untouched by simple user overrides.
	 */
	var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
	// When new generator function is created, rule counter is reset.
	// We need to reset the rule counter for SSR for each request.
	//
	// It's inspired by
	// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
	
	function createGenerateClassName() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$disableGloba = options.disableGlobal,
	      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
	      _options$productionPr = options.productionPrefix,
	      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
	      _options$seed = options.seed,
	      seed = _options$seed === void 0 ? '' : _options$seed;
	  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
	  var ruleCounter = 0;
	  return function (rule, styleSheet) {
	    ruleCounter += 1;
	
	    if (false) {
	      if (ruleCounter >= 1e10) {
	        console.warn(['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
	      }
	    }
	
	    var name = styleSheet.options.name; // Is a global static MUI style?
	
	    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
	      // We can use a shorthand class name, we never use the keys to style the components.
	      if (pseudoClasses.indexOf(rule.key) !== -1) {
	        return "Mui-".concat(rule.key);
	      }
	
	      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
	
	      if (!styleSheet.options.theme[_nested.default] || seed !== '') {
	        return prefix;
	      }
	
	      return "".concat(prefix, "-").concat(ruleCounter);
	    }
	
	    if (true) {
	      return "".concat(seedPrefix).concat(productionPrefix).concat(ruleCounter);
	    }
	
	    var suffix = "".concat(rule.key, "-").concat(ruleCounter); // Help with debuggability.
	
	    if (styleSheet.options.classNamePrefix) {
	      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
	    }
	
	    return "".concat(seedPrefix).concat(suffix);
	  };
	}

/***/ },
/* 178 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	function createStyles(styles) {
	  return styles;
	}

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	
	var _createStyles = _interopRequireDefault(__webpack_require__(178));

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(27));
	
	var _utils = __webpack_require__(6);
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(67));
	
	function getStylesCreator(stylesOrCreator) {
	  var themingEnabled = typeof stylesOrCreator === 'function';
	
	  if (false) {
	    if ((0, _typeof2.default)(stylesOrCreator) !== 'object' && !themingEnabled) {
	      console.error(['Material-UI: the `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
	    }
	  }
	
	  return {
	    create: function create(theme, name) {
	      var styles;
	
	      try {
	        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
	      } catch (err) {
	        if (false) {
	          if (themingEnabled === true && theme === _noopTheme.default) {
	            // TODO: prepend error message/name instead
	            console.error(['Material-UI: the `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	          }
	        }
	
	        throw err;
	      }
	
	      if (!name || !theme.overrides || !theme.overrides[name]) {
	        return styles;
	      }
	
	      var overrides = theme.overrides[name];
	      var stylesWithOverrides = (0, _extends2.default)({}, styles);
	      Object.keys(overrides).forEach(function (key) {
	        if (false) {
	          if (!stylesWithOverrides[key]) {
	            console.warn(['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
	          }
	        }
	
	        stylesWithOverrides[key] = (0, _utils.deepmerge)(stylesWithOverrides[key], overrides[key]);
	      });
	      return stylesWithOverrides;
	    },
	    options: {}
	  };
	}
	
	var _default = getStylesCreator;
	exports.default = _default;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getStylesCreator.default;
	  }
	});
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(180));

/***/ },
/* 182 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* eslint-disable no-restricted-syntax */
	function getThemeProps(params) {
	  var theme = params.theme,
	      name = params.name,
	      props = params.props;
	
	  if (!theme || !theme.props || !theme.props[name]) {
	    return props;
	  } // Resolve default props, code borrow from React source.
	  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
	
	
	  var defaultProps = theme.props[name];
	  var propName;
	
	  for (propName in defaultProps) {
	    if (props[propName] === undefined) {
	      props[propName] = defaultProps[propName];
	    }
	  }
	
	  return props;
	}
	
	var _default = getThemeProps;
	exports.default = _default;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _jssPluginRuleValueFunction = _interopRequireDefault(__webpack_require__(240));
	
	var _jssPluginGlobal = _interopRequireDefault(__webpack_require__(237));
	
	var _jssPluginNested = _interopRequireDefault(__webpack_require__(238));
	
	var _jssPluginCamelCase = _interopRequireDefault(__webpack_require__(235));
	
	var _jssPluginDefaultUnit = _interopRequireDefault(__webpack_require__(236));
	
	var _jssPluginVendorPrefixer = _interopRequireDefault(__webpack_require__(241));
	
	var _jssPluginPropsSort = _interopRequireDefault(__webpack_require__(239));
	
	// Subset of jss-preset-default with only the plugins the Material-UI components are using.
	function jssPreset() {
	  return {
	    plugins: [(0, _jssPluginRuleValueFunction.default)(), (0, _jssPluginGlobal.default)(), (0, _jssPluginNested.default)(), (0, _jssPluginCamelCase.default)(), (0, _jssPluginDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
	    // This way, we can get a performance boost.
	    // In the documentation, we are using `autoprefixer` to solve this problem.
	    typeof window === 'undefined' ? null : (0, _jssPluginVendorPrefixer.default)(), (0, _jssPluginPropsSort.default)()]
	  };
	}
	
	var _default = jssPreset;
	exports.default = _default;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.increment = increment;
	
	/* eslint-disable import/prefer-default-export */
	// Global index counter to preserve source order.
	// We create the style sheet during at the creation of the component,
	// children are handled after the parents, so the order of style elements would be parent->child.
	// It is a problem though when a parent passes a className
	// which needs to override any child's styles.
	// StyleSheet of the child has a higher specificity, because of the source order.
	// So our solution is to render sheets them in the reverse order child->sheet, so
	// that parent has a higher specificity.
	var indexCounter = -1e9;
	
	function increment() {
	  indexCounter += 1;
	
	  if (false) {
	    if (indexCounter >= 0) {
	      console.warn(['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
	    }
	  }
	
	  return indexCounter;
	}

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _jss = __webpack_require__(17);
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(70));
	
	var _multiKeyStore = _interopRequireDefault(__webpack_require__(186));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(23));
	
	var _StylesProvider = __webpack_require__(41);
	
	var _indexCounter = __webpack_require__(184);
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(181));
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(67));
	
	function getClasses(_ref, classes, Component) {
	  var state = _ref.state,
	      stylesOptions = _ref.stylesOptions;
	
	  if (stylesOptions.disableGeneration) {
	    return classes || {};
	  }
	
	  if (!state.cacheClasses) {
	    state.cacheClasses = {
	      // Cache for the finalized classes value.
	      value: null,
	      // Cache for the last used classes prop pointer.
	      lastProp: null,
	      // Cache for the last used rendered classes pointer.
	      lastJSS: {}
	    };
	  } // Tracks if either the rendered classes or classes prop has changed,
	  // requiring the generation of a new finalized classes object.
	
	
	  var generate = false;
	
	  if (state.classes !== state.cacheClasses.lastJSS) {
	    state.cacheClasses.lastJSS = state.classes;
	    generate = true;
	  }
	
	  if (classes !== state.cacheClasses.lastProp) {
	    state.cacheClasses.lastProp = classes;
	    generate = true;
	  }
	
	  if (generate) {
	    state.cacheClasses.value = (0, _mergeClasses.default)({
	      baseClasses: state.cacheClasses.lastJSS,
	      newClasses: classes,
	      Component: Component
	    });
	  }
	
	  return state.cacheClasses.value;
	}
	
	function attach(_ref2, props) {
	  var state = _ref2.state,
	      theme = _ref2.theme,
	      stylesOptions = _ref2.stylesOptions,
	      stylesCreator = _ref2.stylesCreator,
	      name = _ref2.name;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  if (!sheetManager) {
	    sheetManager = {
	      refs: 0,
	      staticSheet: null,
	      dynamicStyles: null
	    };
	
	    _multiKeyStore.default.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
	  }
	
	  var options = (0, _extends2.default)({}, stylesCreator.options, {}, stylesOptions, {
	    theme: theme,
	    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
	  });
	  options.generateId = options.serverGenerateClassName || options.generateClassName;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    var staticSheet;
	
	    if (stylesOptions.sheetsCache) {
	      staticSheet = _multiKeyStore.default.get(stylesOptions.sheetsCache, stylesCreator, theme);
	    }
	
	    var styles = stylesCreator.create(theme, name);
	
	    if (!staticSheet) {
	      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, _extends2.default)({
	        link: false
	      }, options));
	      staticSheet.attach();
	
	      if (stylesOptions.sheetsCache) {
	        _multiKeyStore.default.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
	      }
	    }
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(staticSheet);
	    }
	
	    sheetManager.staticSheet = staticSheet;
	    sheetManager.dynamicStyles = (0, _jss.getDynamicStyles)(styles);
	  }
	
	  if (sheetManager.dynamicStyles) {
	    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, _extends2.default)({
	      link: true
	    }, options));
	    dynamicSheet.update(props);
	    dynamicSheet.attach();
	    state.dynamicSheet = dynamicSheet;
	    state.classes = (0, _mergeClasses.default)({
	      baseClasses: sheetManager.staticSheet.classes,
	      newClasses: dynamicSheet.classes
	    });
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(dynamicSheet);
	    }
	  } else {
	    state.classes = sheetManager.staticSheet.classes;
	  }
	
	  sheetManager.refs += 1;
	}
	
	function update(_ref3, props) {
	  var state = _ref3.state;
	
	  if (state.dynamicSheet) {
	    state.dynamicSheet.update(props);
	  }
	}
	
	function detach(_ref4) {
	  var state = _ref4.state,
	      theme = _ref4.theme,
	      stylesOptions = _ref4.stylesOptions,
	      stylesCreator = _ref4.stylesCreator;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  sheetManager.refs -= 1;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    _multiKeyStore.default.delete(stylesOptions.sheetsManager, stylesCreator, theme);
	
	    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(sheetManager.staticSheet);
	    }
	  }
	
	  if (state.dynamicSheet) {
	    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(state.dynamicSheet);
	    }
	  }
	}
	
	function useSynchronousEffect(func, values) {
	  var key = _react.default.useRef([]);
	
	  var output; // Store "generation" key. Just returns a new object every time
	
	  var currentKey = _react.default.useMemo(function () {
	    return {};
	  }, values); // eslint-disable-line react-hooks/exhaustive-deps
	  // "the first render", or "memo dropped the value"
	
	
	  if (key.current !== currentKey) {
	    key.current = currentKey;
	    output = func();
	  }
	
	  _react.default.useEffect(function () {
	    return function () {
	      if (output) {
	        output();
	      }
	    };
	  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
	  );
	}
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var name = options.name,
	      classNamePrefixOption = options.classNamePrefix,
	      Component = options.Component,
	      _options$defaultTheme = options.defaultTheme,
	      defaultTheme = _options$defaultTheme === void 0 ? _noopTheme.default : _options$defaultTheme,
	      stylesOptions2 = (0, _objectWithoutProperties2.default)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
	  var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
	  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
	  stylesCreator.options = {
	    index: (0, _indexCounter.increment)(),
	    name: name,
	    meta: classNamePrefix,
	    classNamePrefix: classNamePrefix
	  };
	  return function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var theme = (0, _useTheme.default)() || defaultTheme;
	    var stylesOptions = (0, _extends2.default)({}, _react.default.useContext(_StylesProvider.StylesContext), {}, stylesOptions2);
	
	    var instance = _react.default.useRef();
	
	    var shouldUpdate = _react.default.useRef();
	
	    useSynchronousEffect(function () {
	      var current = {
	        name: name,
	        state: {},
	        stylesCreator: stylesCreator,
	        stylesOptions: stylesOptions,
	        theme: theme
	      };
	      attach(current, props);
	      shouldUpdate.current = false;
	      instance.current = current;
	      return function () {
	        detach(current);
	      };
	    }, [theme, stylesCreator]);
	
	    _react.default.useEffect(function () {
	      if (shouldUpdate.current) {
	        update(instance.current, props);
	      }
	
	      shouldUpdate.current = true;
	    });
	
	    return getClasses(instance.current, props.classes, Component);
	  };
	}
	
	var _default = makeStyles;
	exports.default = _default;

/***/ },
/* 186 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// Used https://github.com/thinkloop/multi-key-cache as inspiration
	var multiKeyStore = {
	  set: function set(cache, key1, key2, value) {
	    var subCache = cache.get(key1);
	
	    if (!subCache) {
	      subCache = new Map();
	      cache.set(key1, subCache);
	    }
	
	    subCache.set(key2, value);
	  },
	  get: function get(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    return subCache ? subCache.get(key2) : undefined;
	  },
	  delete: function _delete(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    subCache.delete(key2);
	  }
	};
	var _default = multiKeyStore;
	exports.default = _default;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _utils = __webpack_require__(6);
	
	function mergeClasses() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var baseClasses = options.baseClasses,
	      newClasses = options.newClasses,
	      Component = options.Component;
	
	  if (!newClasses) {
	    return baseClasses;
	  }
	
	  var nextClasses = (0, _extends2.default)({}, baseClasses);
	
	  if (false) {
	    if (typeof newClasses === 'string') {
	      console.error(["Material-UI: the value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
	      return baseClasses;
	    }
	  }
	
	  Object.keys(newClasses).forEach(function (key) {
	    if (false) {
	      if (!baseClasses[key] && newClasses[key]) {
	        console.error(["Material-UI: the key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
	      }
	
	      if (newClasses[key] && typeof newClasses[key] !== 'string') {
	        console.error(["Material-UI: the key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
	      }
	    }
	
	    if (newClasses[key]) {
	      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
	    }
	  });
	  return nextClasses;
	}
	
	var _default = mergeClasses;
	exports.default = _default;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	
	var _styled = _interopRequireDefault(__webpack_require__(189));

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(7));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(6);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(24));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(43));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	} // styled-components's API removes the mapping between components and styles.
	// Using components as a low-level styling construct can be simpler.
	
	
	function styled(Component) {
	  var componentCreator = function componentCreator(style) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["name"]);
	
	    if (false) {
	      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var stylesOrCreator = typeof style === 'function' ? function (theme) {
	      return {
	        root: function root(props) {
	          return style((0, _extends2.default)({
	            theme: theme
	          }, props));
	        }
	      };
	    } : {
	      root: style
	    };
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	    var filterProps;
	    var propTypes = {};
	
	    if (style.filterProps) {
	      filterProps = style.filterProps;
	      delete style.filterProps;
	    }
	    /* eslint-disable react/forbid-foreign-prop-types */
	
	
	    if (style.propTypes) {
	      propTypes = style.propTypes;
	      delete style.propTypes;
	    }
	    /* eslint-enable react/forbid-foreign-prop-types */
	
	
	    var StyledComponent = _react.default.forwardRef(function StyledComponent(props, ref) {
	      var children = props.children,
	          classNameProp = props.className,
	          clone = props.clone,
	          ComponentProp = props.component,
	          other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "clone", "component"]);
	      var classes = useStyles(props);
	      var className = (0, _clsx.default)(classes.root, classNameProp);
	      var spread = other;
	
	      if (filterProps) {
	        spread = omit(spread, filterProps);
	      }
	
	      if (clone) {
	        return _react.default.cloneElement(children, (0, _extends2.default)({
	          className: (0, _clsx.default)(children.props.className, className)
	        }, spread));
	      }
	
	      if (typeof children === 'function') {
	        return children((0, _extends2.default)({
	          className: className
	        }, spread));
	      }
	
	      var FinalComponent = ComponentProp || Component;
	      return _react.default.createElement(FinalComponent, (0, _extends2.default)({
	        ref: ref,
	        className: className
	      }, spread), children);
	    });
	
	     false ? StyledComponent.propTypes = (0, _extends2.default)({
	      /**
	       * A render function or node.
	       */
	      children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	
	      /**
	       * @ignore
	       */
	      className: _propTypes.default.string,
	
	      /**
	       * If `true`, the component will recycle it's children DOM element.
	       * It's using `React.cloneElement` internally.
	       *
	       * This prop will be deprecated and removed in v5
	       */
	      clone: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	        if (props.clone && props.component) {
	          return new Error('You can not use the clone and component prop at the same time.');
	        }
	
	        return null;
	      }),
	
	      /**
	       * The component used for the root node.
	       * Either a string to use a DOM element or a component.
	       */
	      component: _propTypes.default.elementType
	    }, propTypes) : void 0;
	
	    if (false) {
	      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(StyledComponent, Component);
	    return StyledComponent;
	  };
	
	  return componentCreator;
	}
	
	var _default = styled;
	exports.default = _default;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(71));
	
	function useTheme() {
	  return _react.default.useContext(_ThemeContext.default);
	}

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	
	var _withStyles = _interopRequireDefault(__webpack_require__(192));

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(24));
	
	var _utils = __webpack_require__(6);
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(43));
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(68));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(23));
	
	// Link a style sheet with a component.
	// It does not modify the component passed to it;
	// instead, it returns a new component, with a `classes` property.
	var withStyles = function withStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (Component) {
	    var defaultTheme = options.defaultTheme,
	        _options$withTheme = options.withTheme,
	        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
	        name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["defaultTheme", "withTheme", "name"]);
	
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      defaultTheme: defaultTheme,
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	
	    var WithStyles = _react.default.forwardRef(function WithStyles(props, ref) {
	      var classesProp = props.classes,
	          innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["classes", "innerRef"]);
	      var classes = useStyles(props);
	      var theme;
	      var more = other;
	
	      if (typeof name === 'string' || withTheme) {
	        // name and withTheme are invariant in the outer scope
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        theme = (0, _useTheme.default)() || defaultTheme;
	
	        if (name) {
	          more = (0, _getThemeProps.default)({
	            theme: theme,
	            name: name,
	            props: other
	          });
	        } // Provide the theme to the wrapped component.
	        // So we don't have to use the `withTheme()` Higher-order Component.
	
	
	        if (withTheme && !more.theme) {
	          more.theme = theme;
	        }
	      }
	
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        ref: innerRef || ref,
	        classes: classes
	      }, more));
	    });
	
	     false ? WithStyles.propTypes = {
	      /**
	       * Override or extend the styles applied to the component.
	       */
	      classes: _propTypes.default.object,
	
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return null; // return new Error(
	        //   'Material-UI: the `innerRef` prop is deprecated and will be removed in v5. ' +
	        //     'Refs are now automatically forwarded to the inner component.',
	        // );
	      })
	    } : void 0; // The wrapper receives only user supplied props, which could be a subset of
	    // the actual props Component might receive due to merging with defaultProps.
	    // So copying it here would give us the same result in the wrapper as well.
	
	    WithStyles.defaultProps = Component.defaultProps;
	
	    if (false) {
	      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithStyles, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithStyles.Naked = Component;
	      WithStyles.options = options;
	      WithStyles.useStyles = useStyles;
	    }
	
	    return WithStyles;
	  };
	};
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(19);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(194));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withThemeCreator = withThemeCreator;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(24));
	
	var _utils = __webpack_require__(6);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(23));
	
	function withThemeCreator() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultTheme = options.defaultTheme;
	
	  var withTheme = function withTheme(Component) {
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var WithTheme = _react.default.forwardRef(function WithTheme(props, ref) {
	      var innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["innerRef"]);
	      var theme = (0, _useTheme.default)() || defaultTheme;
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        theme: theme,
	        ref: innerRef || ref
	      }, other));
	    });
	
	     false ? WithTheme.propTypes = {
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return new Error('Material-UI: the `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
	      })
	    } : void 0;
	
	    if (false) {
	      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	
	  return withTheme;
	} // Provide the theme object as a prop to the input component.
	// It's an alternative API to useTheme().
	// We encourage the usage of useTheme() where possible.
	
	
	var withTheme = withThemeCreator();
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isObject = isObject;
	exports.default = deepmerge;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(3));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(27));
	
	function isObject(item) {
	  return item && (0, _typeof2.default)(item) === 'object' && !Array.isArray(item);
	}
	
	function deepmerge(target, source) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    clone: true
	  };
	  var output = options.clone ? (0, _extends2.default)({}, target) : target;
	
	  if (isObject(target) && isObject(source)) {
	    Object.keys(source).forEach(function (key) {
	      // Avoid prototype pollution
	      if (key === '__proto__') {
	        return;
	      }
	
	      if (isObject(source[key]) && key in target) {
	        output[key] = deepmerge(target[key], source[key], options);
	      } else {
	        output[key] = source[key];
	      }
	    });
	  }
	
	  return output;
	}

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(44));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function acceptingRef(props, propName, componentName, location, propFullName) {
	  var element = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (element == null) {
	    return null;
	  }
	
	  var warningHint;
	  var elementType = element.type;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
	    warningHint = 'Did you accidentally use a plain function component for an element instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var elementAcceptingRef = (0, _chainPropTypes.default)(_propTypes.default.element, acceptingRef);
	elementAcceptingRef.isRequired = (0, _chainPropTypes.default)(_propTypes.default.element.isRequired, acceptingRef);
	var _default = elementAcceptingRef;
	exports.default = _default;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(19);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(4));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(44));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  var warningHint;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
	    warningHint = 'Did you accidentally provide a plain function component instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var _default = (0, _chainPropTypes.default)(PropTypes.elementType, elementTypeAcceptingRef);
	
	exports.default = _default;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exactProp;
	exports.specialProperty = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(26));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(3));
	
	// This module is based on https://github.com/airbnb/prop-types-exact repository.
	// However, in order to reduce the number of dependencies and to remove some extra safe checks
	// the module was forked.
	// Only exported for test purposes.
	var specialProperty = "exact-prop: \u200B";
	exports.specialProperty = specialProperty;
	
	function exactProp(propTypes) {
	  if (true) {
	    return propTypes;
	  }
	
	  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
	    var unsupportedProps = Object.keys(props).filter(function (prop) {
	      return !propTypes.hasOwnProperty(prop);
	    });
	
	    if (unsupportedProps.length > 0) {
	      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
	        return "`".concat(prop, "`");
	      }).join(', '), ". Please remove them."));
	    }
	
	    return null;
	  }));
	}

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFunctionName = getFunctionName;
	exports.default = getDisplayName;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(27));
	
	var _reactIs = __webpack_require__(36);
	
	// Simplified polyfill for IE 11 support
	// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
	var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
	
	function getFunctionName(fn) {
	  var match = "".concat(fn).match(fnNameMatchRegex);
	  var name = match && match[1];
	  return name || '';
	}
	/**
	 * @param {function} Component
	 * @param {string} fallback
	 * @returns {string | undefined}
	 */
	
	
	function getFunctionComponentName(Component) {
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
	}
	
	function getWrappedName(outerType, innerType, wrapperName) {
	  var functionName = getFunctionComponentName(innerType);
	  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
	}
	/**
	 * cherry-pick from
	 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
	 * originally forked from recompose/getDisplayName with added IE 11 support
	 *
	 * @param {React.ReactType} Component
	 * @returns {string | undefined}
	 */
	
	
	function getDisplayName(Component) {
	  if (Component == null) {
	    return undefined;
	  }
	
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (typeof Component === 'function') {
	    return getFunctionComponentName(Component, 'Component');
	  }
	
	  if ((0, _typeof2.default)(Component) === 'object') {
	    switch (Component.$$typeof) {
	      case _reactIs.ForwardRef:
	        return getWrappedName(Component, Component.render, 'ForwardRef');
	
	      default:
	        return undefined;
	    }
	  }
	
	  return undefined;
	}

/***/ },
/* 200 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	exports.default = _default;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var refType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]);
	
	var _default = refType;
	exports.default = _default;

/***/ },
/* 202 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	__webpack_require__(227);
	
	var _firebase = __webpack_require__(229);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _styles = __webpack_require__(157);
	
	var _styles2 = __webpack_require__(15);
	
	var _fireBaseContext = __webpack_require__(34);
	
	var _userContext = __webpack_require__(45);
	
	var _userContext2 = _interopRequireDefault(_userContext);
	
	var _auth = __webpack_require__(72);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _index = __webpack_require__(209);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _banner = __webpack_require__(204);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _reactRouterDom = __webpack_require__(252);
	
	var _jquery = __webpack_require__(234);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window;
	var doc = document;
	
	var postMessageProxy = function postMessageProxy(message) {
	  if ($.ReactNativeWebView !== undefined) {
	    setTimeout(function () {
	      $.ReactNativeWebView.postMessage(message);
	    }, 0);
	  }
	};
	
	_firebase2.default.default.initializeApp({
	  apiKey: "AIzaSyB7TL6WDx_jA3wNZbVFLC2icbbCeTVoeXE",
	  authDomain: "popit-234c4.firebaseapp.com",
	  databaseURL: "https://popit-234c4.firebaseio.com",
	  projectId: "popit-234c4",
	  storageBucket: "popit-234c4.appspot.com",
	  messagingSenderId: "832674601845",
	  appId: "1:832674601845:web:a4c8b4d265e76d27fd913c",
	  measurementId: "G-GE1DLYHFKW"
	});
	
	var theme = (0, _styles.createMuiTheme)({
	  typography: {
	    fontFamily: ['"Open Sans"', '"Roboto"', '"ヒラギノ角ゴ Pro W3"', '"Hiragino Kaku Gothic Pro"', 'Osaka', '"メイリオ"', 'Meiryo', '"ＭＳ Ｐゴシック"', '"MS PGothic"', 'sans-serif'].join(',')
	  }
	});
	
	var App = function (_BaseComponent) {
	  _inherits(App, _BaseComponent);
	
	  function App(props, context) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));
	
	    _this.state = _this.defaultUserState();
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'defaultUserState',
	    value: function defaultUserState() {
	      return {
	        user: {
	          info: {}
	        }
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _jquery2.default)(doc).ready(function () {
	        setTimeout(function () {
	          (0, _jquery2.default)(".firebaseui-container, .firebaseui-idp-button").bind('click', function (e) {
	            (0, _jquery2.default)("#mainFish").css({ "width": "100px" });
	          });
	        }, 1000);
	      });
	
	      this.unregisterAuthObserver = _firebase2.default.auth().onAuthStateChanged(function (user) {
	        if (user !== undefined && user !== null) {
	          $.user = {};
	          $.user = user;
	          _this2.setState({ user: { isSignedIn: !!user, info: user } });
	        }
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unregisterAuthObserver();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var page = null;
	      if (this.state.user.isSignedIn && !this.state.user.info.isAnonymous) {
	        page = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'logged in user ',
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                _firebase2.default.default.auth().signOut();
	                _this3.setState(_this3.defaultUserState());
	              } },
	            'sign out'
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                postMessageProxy("qr");
	              } },
	            'TEST QR'
	          )
	        );
	      } else {
	        page = _react2.default.createElement(_auth2.default, null);
	      }
	
	      return _react2.default.createElement(
	        _reactRouterDom.BrowserRouter,
	        null,
	        _react2.default.createElement(
	          _userContext2.default.Provider,
	          { value: { user: this.state.user } },
	          _react2.default.createElement(
	            _fireBaseContext.FireBaseProvider,
	            { value: { firebase: _firebase2.default } },
	            _react2.default.createElement(
	              _styles2.ThemeProvider,
	              { theme: theme },
	              _react2.default.createElement(
	                _banner2.default,
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Switch,
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Route,
	                    { path: '/winPrize' },
	                    _react2.default.createElement(_index2.default, null)
	                  ),
	                  _react2.default.createElement(
	                    _reactRouterDom.Route,
	                    { path: '/' },
	                    page
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_base2.default);
	
	exports.default = App;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sidebar = __webpack_require__(206);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _userContext = __webpack_require__(45);
	
	var _userContext2 = _interopRequireDefault(_userContext);
	
	var _Reorder = __webpack_require__(170);
	
	var _Reorder2 = _interopRequireDefault(_Reorder);
	
	var _IconButton = __webpack_require__(117);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _pubsubJs = __webpack_require__(25);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banner = function (_BaseComponent) {
	  _inherits(Banner, _BaseComponent);
	
	  function Banner() {
	    _classCallCheck(this, Banner);
	
	    return _possibleConstructorReturn(this, (Banner.__proto__ || Object.getPrototypeOf(Banner)).apply(this, arguments));
	  }
	
	  _createClass(Banner, [{
	    key: 'render',
	
	
	    // state = {
	    //   isSignedIn: undefined,
	    // };
	
	    value: function render() {
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_sidebar2.default, null),
	        _react2.default.createElement(
	          'div',
	          { style: { backgroundColor: "#1A1A1A" } },
	          this.context.user.isSignedIn && _react2.default.createElement(
	            _IconButton2.default,
	            { style: { position: "absolute", color: "white" }, onClick: function onClick() {
	                _pubsubJs2.default.publish('nav-toggle', true);
	              } },
	            _react2.default.createElement(_Reorder2.default, { style: { fontSize: 30 } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'center' },
	            _react2.default.createElement('img', { src: '/images/content/banner/popitLogoTop.png', alt: 'Main Popit Logo' })
	          )
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Banner;
	}(_base2.default);
	
	Banner.contextType = _userContext2.default;
	exports.default = Banner;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Popup = function (_BaseComponent) {
	  _inherits(Popup, _BaseComponent);
	
	  function Popup(props, context) {
	    _classCallCheck(this, Popup);
	
	    var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props, context));
	
	    _this.state = {
	      open: _this.props.open
	    };
	    return _this;
	  }
	
	  _createClass(Popup, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open !== nextProps.open) {
	        this.setState({ open: nextProps.open });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: "md-modal " + this.props.classModal + " " + (this.state.open ? "md-show" : "") },
	          _react2.default.createElement(
	            'div',
	            { className: 'md-content' },
	            this.props.children
	          )
	        ),
	        this.state.open && _react2.default.createElement('div', { className: 'md-overlay', onClick: function onClick() {
	            if (_this2.props.closeOnOverlayClick) {
	              _this2.setState({ open: false });
	            }
	            if (_this2.props.hasOwnProperty("onClickOverlay")) {
	              _this2.props.onClickOverlay();
	            }
	          } })
	      );
	    }
	  }]);
	
	  return Popup;
	}(_base2.default);
	
	Popup.propTypes = {
	  onClickOverlay: _propTypes2.default.func,
	  classModal: _propTypes2.default.string,
	  open: _propTypes2.default.bool
	};
	
	Popup.defaultProps = {
	  classModal: "md-effect-13",
	  closeOnOverlayClick: true
	};
	
	exports.default = Popup;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _userContext = __webpack_require__(45);
	
	var _userContext2 = _interopRequireDefault(_userContext);
	
	var _Drawer = __webpack_require__(113);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _List = __webpack_require__(119);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Divider = __webpack_require__(111);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _ListItem = __webpack_require__(121);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemIcon = __webpack_require__(123);
	
	var _ListItemIcon2 = _interopRequireDefault(_ListItemIcon);
	
	var _ListItemText = __webpack_require__(125);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _pubsubJs = __webpack_require__(25);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SideBar = function (_BaseComponent) {
	  _inherits(SideBar, _BaseComponent);
	
	  function SideBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SideBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SideBar.__proto__ || Object.getPrototypeOf(SideBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SideBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _pubsubJs2.default.subscribe('nav-toggle', function (msg, data) {
	        _this2.setState({ open: data });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _Drawer2.default,
	        { open: this.state.open, onClose: function onClose() {
	            _this3.setState({ open: false });
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: { backgroundColor: "#1A1A1A", color: "white" } },
	          _react2.default.createElement(
	            _List2.default,
	            null,
	            _react2.default.createElement(
	              _ListItem2.default,
	              { button: true },
	              _react2.default.createElement(
	                _ListItemIcon2.default,
	                null,
	                _react2.default.createElement('img', { src: '/images/content/banner/popitLogoTop.png', alt: 'adsf' })
	              ),
	              _react2.default.createElement(_ListItemText2.default, { primary: "asdfadsfafds" })
	            ),
	            _react2.default.createElement(
	              _ListItem2.default,
	              { button: true, onClick: function onClick() {
	                  //todo
	                  // this.context.firebase.default.auth().signOut();
	                  // this.setState(this.defaultUserState());
	                } },
	              _react2.default.createElement(
	                _ListItemIcon2.default,
	                null,
	                _react2.default.createElement('img', { src: '/images/content/banner/popitLogoTop.png', alt: 'adsf' })
	              ),
	              _react2.default.createElement(_ListItemText2.default, { primary: "logout" })
	            )
	          ),
	          _react2.default.createElement(_Divider2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return SideBar;
	}(_base2.default);
	
	SideBar.contextType = _userContext2.default;
	exports.default = SideBar;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var objectAssign = __webpack_require__(35);
	
	var globals = {};
	var $ = window;
	
	globals.times = function (x) {
	  return function (f) {
	    if (x > 0) {
	      f();
	      globals.times(x - 1)(f);
	    }
	  };
	};
	
	globals.isObject = function (item) {
	  return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item) && item !== null;
	};
	
	globals.mergeDeep = function (target, source) {
	  var output = objectAssign({}, target);
	  if (target === null) {
	    target = {};
	  }
	  if (globals.isObject(target) && globals.isObject(source)) {
	    Object.keys(source).forEach(function (key) {
	      if (globals.isObject(source[key])) {
	        if (!(key in target)) {
	          objectAssign(output, _defineProperty({}, key, source[key]));
	        } else {
	          if (Object.keys(source[key]).length === 0) {
	            objectAssign(output, _defineProperty({}, key, source[key]));
	          } else {
	            output[key] = globals.mergeDeep(target[key], source[key]);
	          }
	        }
	      } else {
	        objectAssign(output, _defineProperty({}, key, source[key]));
	      }
	    });
	  }
	  return output;
	};
	
	globals.sortByKey = function (array, key, type) {
	  if (array instanceof Array) {
	    return array.sort(function (a, b) {
	      var aVal = a[key];
	      var bVal = b[key];
	      if (typeof aVal === "string") {
	        aVal = a[key] !== undefined ? a[key].toUpperCase() : a[key];
	      }
	      if (typeof bVal === "string") {
	        bVal = b[key] !== undefined ? b[key].toUpperCase() : b[key];
	      }
	      var x = aVal;var y = bVal;
	
	      if (type === undefined || type === null && type === "" || type === "asc") {
	        return x < y ? -1 : x > y ? 1 : 0;
	      } else {
	        return x > y ? -1 : x < y ? 1 : 0;
	      }
	    });
	  }
	};
	
	globals.clearSpace = function (str) {
	  return str.replace(/ /g, '');
	};
	
	globals.getCookie = function (cname) {
	  var name = cname + "=";
	  var decodedCookie = decodeURIComponent(document.cookie);
	  var ca = decodedCookie.split(';');
	  for (var i = 0; i < ca.length; i++) {
	    var c = ca[i];
	    while (c.charAt(0) === ' ') {
	      c = c.substring(1);
	    }
	    if (c.indexOf(name) === 0) {
	      return c.substring(name.length, c.length);
	    }
	  }
	  return "";
	};
	
	globals.debounce = function (func, wait) {
	  return globals.debounceWithImmediate(func, wait).wait;
	};
	
	globals.debounceWithImmediate = function (func, _wait) {
	  var timeout;
	  return {
	    wait: function wait() {
	      var context = this;
	      var args = arguments;
	      clearTimeout(timeout);
	      timeout = setTimeout(function () {
	        timeout = null;
	        func.apply(context, args);
	      }, _wait);
	    },
	    now: function now() {
	      clearTimeout(timeout);
	      timeout = null;
	      func.apply(this, arguments);
	    }
	  };
	};
	
	globals.unixTimeToDurationStr = function (unixTime) {
	  var t = Number(unixTime);
	  var days = Number(t / 86400);
	  t -= days * 86400;
	
	  var hours = Number(t / 3600);
	  t -= hours * 3600;
	
	  var minutes = Number(t / 60);
	  t -= minutes * 60;
	  var content = "";
	  if (days) content += days + " days";
	
	  if (hours || days) {
	    if (content) content += ", ";content += hours + " hours";
	  }
	
	  if (content) content += ", ";content += minutes + " minutes";
	
	  return content;
	};
	
	globals.unixTimeToStr = function (unixTime) {
	  var months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	  var date = new Date(unixTime * 1000);
	  var year = date.getFullYear();
	  var month = months_arr[date.getMonth()];
	  var day = date.getDate();
	  var hours = date.getHours();
	  var minutes = "0" + date.getMinutes();
	  var seconds = "0" + date.getSeconds();
	  var convdataTime = month + '-' + day + '-' + year + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
	
	  return convdataTime;
	};
	
	globals.hexToRGB = function (hex, alpha) {
	  var r = parseInt(hex.slice(1, 3), 16),
	      g = parseInt(hex.slice(3, 5), 16),
	      b = parseInt(hex.slice(5, 7), 16);
	
	  if (alpha) {
	    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
	  } else {
	    return "rgb(" + r + ", " + g + ", " + b + ")";
	  }
	};
	
	globals.guid = function () {
	  function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	  }
	  return s4() + s4() + s4() + s4() + s4() + s4();
	};
	
	globals.uuid = function () {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0,
	        v = c === 'x' ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	};
	
	globals.roughSizeOfObject = function (object) {
	  var objectList = [];
	  var stack = [object];
	  var bytes = 0;
	  var loops = 0;
	
	  while (stack.length && loops < 100000) {
	    var value = stack.pop();
	    if (typeof value === 'boolean') {
	      bytes += 4;
	    } else if (typeof value === 'string') {
	      bytes += value.length * 2;
	    } else if (typeof value === 'number') {
	      bytes += 8;
	    } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && objectList.indexOf(value) === -1) {
	      objectList.push(value);
	      for (var i in value) {
	        stack.push(value[i]);
	      }
	    }
	    loops++;
	  }
	  return bytes;
	};
	
	globals.humanFileSize = function (bytes, si) {
	  var thresh = si ? 1000 : 1024;
	  if (Math.abs(bytes) < thresh) {
	    return bytes + ' B';
	  }
	  var units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
	  var u = -1;
	  do {
	    bytes /= thresh;
	    ++u;
	  } while (Math.abs(bytes) >= thresh && u < units.length - 1);
	  return bytes.toFixed(1) + ' ' + units[u];
	};
	
	globals.productTitle = function () {
	  return "Atlona Velocity | ";
	};
	
	globals.toTitleCase = function (str) {
	  return str.replace(/(?:^|\s)\w/g, function (match) {
	    return match.toUpperCase();
	  });
	};
	
	globals.camelize = function (str) {
	  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
	    return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
	  }).replace(/\s+/g, '').replace(/[^\w\s]/gi, '');
	};
	
	globals.isEmpty = function (o) {
	  var ret = false;
	  if (globals.typeof(o) === "Null" || globals.typeof(o) === "Undefined") {
	    ret = true;
	  }
	  return ret;
	};
	
	globals.typeof = function (o) {
	  var typeInfo = "";
	  if (o !== null && o !== undefined) {
	    typeInfo = o.constructor.name; // returns Array, Boolean, Object, String, etc...
	  } else if (o === null) {
	    typeInfo = "Null";
	  } else if (o === undefined) {
	    typeInfo = "Undefined";
	  }
	  return typeInfo;
	};
	
	globals.touchAndClick = function (cb) {
	  var useOnTouchTap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var props = {};
	  if ('ontouchstart' in $) {
	    props = {};
	    // for ListItem in materialUI, onTouchStart does not fire, but onTouchTap does,
	    // if we had output this on everything, two events would fire so we need to conditionally add this in
	    props.onTouchStart = function (e) {
	      cb(e);
	    };
	  } else {
	    props = {
	      onClick: function onClick(e) {
	        cb(e);
	      }
	    };
	  }
	  return props;
	};
	
	globals.HexToAscii = function (str1) {
	  var hex = str1.toString();
	  var str = '';
	  for (var n = 0; n < hex.length; n += 2) {
	    str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
	  }
	  return str;
	};
	
	globals.SubstituteASCIIHex = function (value) {
	  var returnValue = "";
	  var j = 0;
	  if (value === undefined) {
	    return value;
	  }
	  for (j = 0; j < value.length; j++) {
	    var ch = value.charCodeAt(j);
	    if (ch === 92) {
	      //Checking for \x
	      if (value.length > j + 1) {
	        var chX = value.charCodeAt(j + 1);
	        // session_functions.VelocityDump(ch, chX);
	        if (chX === 120) {
	          if (value.length >= j + 4) {
	            var hexString = value.substring(j + 2, j + 4);
	            returnValue += String.fromCharCode(parseInt(hexString, 16));
	            j += 3;
	          }
	        }
	      }
	    } else {
	      returnValue += value[j];
	    }
	  }
	  return returnValue;
	};
	
	globals.validateIPaddress = function (ipaddress) {
	  if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
	    return true;
	  }
	  return false;
	};
	
	globals.createMark = function (name) {
	  if (performance.mark === undefined) {
	    console.log("performance.mark Not supported");
	    return;
	  }
	  // Create the performance mark
	  performance.mark(name);
	};
	
	globals.endMark = function (originalMark) {
	  if (performance.mark === undefined) {
	    console.log("performance.mark Not supported");
	    return;
	  }
	
	  globals.createMark("done-" + originalMark);
	  $.performance.measure('diff-' + originalMark, originalMark, "done-" + originalMark);
	  console.info("mark for " + originalMark + " executed in " + $.performance.getEntriesByName('diff-' + originalMark)[0].duration + 'ms');
	  performance.clearMeasures(originalMark);
	  performance.clearMeasures("done-" + originalMark);
	  performance.clearMeasures('diff-' + originalMark);
	};
	
	globals.ObjectId = function () {
	  var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
	  return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
	    return (Math.random() * 16 | 0).toString(16);
	  }).toLowerCase();
	};
	
	globals.GetVar = function (name, url) {
	  if (!url) {
	    url = $.location.href;
	  }
	  name = name.replace(/[[]]/g, "\\$&");
	  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	      results = regex.exec(url);
	  if (!results) return null;
	  if (!results[2]) return '';
	  return decodeURIComponent(results[2].replace(/\+/g, " "));
	};
	
	globals.isArray = function (pointer) {
	  return pointer !== undefined && pointer !== null && Array.isArray(pointer);
	};
	
	globals.filter = function (pointer, mapFunc) {
	  if (globals.isArray(pointer)) {
	    return pointer.filter(mapFunc);
	  }
	};
	
	globals.reduce = function (pointer, mapFunc) {
	  if (globals.isArray(pointer)) {
	    return pointer.reduce(mapFunc);
	  }
	};
	
	globals.forEach = function (pointer, mapFunc) {
	  if (globals.isArray(pointer)) {
	    pointer.forEach(mapFunc);
	  } else if (globals.typeof(pointer) === "Object") {
	    Object.keys(pointer).forEach(function (key) {
	      mapFunc(pointer[key], key);
	    });
	  }
	};
	
	globals.indexOf = function (pointer, searchValue, start) {
	  if (globals.typeof(pointer) === "String") {
	    return pointer.indexOf(searchValue, start);
	  } else {
	    return -1;
	  }
	};
	
	globals.length = function (pointer) {
	  if ((globals.isArray(pointer) || globals.typeof(pointer) === "String") && pointer !== undefined) {
	    return pointer.length;
	  } else if (globals.typeof(pointer) === "Object") {
	    return Object.keys(pointer).length;
	  } else {
	    return 0;
	  }
	};
	
	globals.map = function (pointer, mapFunc) {
	  if (globals.isArray(pointer)) {
	    return pointer.map(mapFunc);
	  } else if (globals.typeof(pointer) === "Object") {
	    return Object.keys(pointer).map(function (key) {
	      return mapFunc(pointer[key], key);
	    });
	  }
	};
	
	globals.filter = function (pointer, mapFunc) {
	  if (globals.isArray(pointer)) {
	    return pointer.filter(mapFunc);
	  }
	};
	
	globals.findIndex = function (pointer, mapFunc) {
	  if (globals.isArray(pointer)) {
	    return pointer.findIndex(mapFunc);
	  }
	};
	
	globals.reduceRight = function (pointer, mapFunc) {
	  if (globals.isArray(pointer)) {
	    return pointer.reduceRight(mapFunc);
	  }
	};
	
	globals.some = function (pointer, mapFunc) {
	  if (globals.isArray(pointer)) {
	    return pointer.some(mapFunc);
	  }
	};
	
	globals.__ = function (tpl, replacements) {
	  return globals._(tpl, replacements);
	};
	
	globals._ = function (tpl, replacements) {
	  if (typeof tpl === "undefined") {
	    return tpl;
	  }
	  globals.forEach(replacements, function (k, v) {
	    tpl = tpl.replace("{" + v + "}", k);
	  });
	  return tpl;
	};
	
	exports.default = globals;

/***/ },
/* 208 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  "en": {
	    "popItSetupCustomerManagement": "Customer Management",
	    "popItSetupTitle": "Product Title",
	    "popItSetupTitleJP": "Product Title (Japanese)",
	    "popItSetupOdds": "Odds",
	    "popItSetupOddsHelp": "Example: 1 in 100 chance of winning",
	    "popItSetupExpireDays": "Number of days to expire",
	    "popItSetupPriority": "Priority",
	    "popItSetupCategory": "Category",
	    "popItSetupQuantity": "Quantity",
	    "popItSetupPopitProducts": "Popit Products",
	    "popItSetupTotalRedeemed": "Total Redeemed",
	    "popItSetupTerms": "Terms and Conditions",
	    "popItSetupYes": "Yes",
	    "popItSetupNo": "No",
	    "popItSetupIsClosed": "Is Closed",
	    "popItSetupIsNightStart": "Night Hour Start (optional)",
	    "popItSetupNightEnd": "Night Hour End (optional)",
	    "popItSetupBusinessImage": "Main Photo",
	    "popItSetupContactInformation": "Contact Information",
	    "popItSetupContactPhone": "Phone Number",
	    "popItSetupContactEmail": "Email Address",
	    "popItSetupCustomerSignEmail": "Email Address",
	    "popItSetupCustomerSignPassword": "Password",
	    "popItSetupContactWebsite": "Website",
	    "popItSetupPhotos": "Header Photos",
	    "popItSetupMisc": "Misc Photos",
	    "popItSetupLongitude": "Longitude",
	    "popItSetupLatitude": "Latitude",
	    "popItSetupDescription": "Description",
	    "popItSetupHolidays": "Holidays",
	    "popItSetupBusinessName": "Business Name",
	    "popItSetupAddress": "Address",
	    "popItSetupCity": "City",
	    "popItSetupState": "Prefecture",
	    "popItSetupZip": "Zip",
	    "popItSetupCategories": "Business Categories",
	    "popItSetupCountry": "Business Categories",
	    "popItSetupHours": "Hours",
	    "popItSetupCoordinates": "Coordinates",
	    "popItSetupMonday": "Monday",
	    "popItSetupTuesday": "Tuesday",
	    "popItSetupWednesday": "Wednesday",
	    "popItSetupThursday": "Thursday",
	    "popItSetupFriday": "Friday",
	    "popItSetupSaturday": "Saturday",
	    "popItSetupSunday": "Sunday",
	    "popItSetupMaxTicketCount": "Max Ticket Count",
	    "popItSetupShowOnWinning": "(Shown on the winning/losing screen)",
	    "popItSetupStart": "Start",
	    "popItSetupEnd": "End",
	    "popItSetupCustomerSignin": "Login Information",
	    "popItSetupContactTitle": "Contact",
	    "popItSetupSocial": "Social",
	    "popItSetupMenuPhotos": "Menu Photos",
	    "popItSetupQuantityToRedeem": "Visits Needed To Redeem",
	    "popItSetupPunchCardProducts": "Punchcard Products",
	    "popItSetupEnabled": "Enabled",
	    "popItSetupDaysToRedeem": "Days To Redeem",
	    "Stop": "Stop",
	    "popToWin": "Pop It To Win",
	    "youWon": "You Won!",
	    "from": "From",
	    "redeemNow": "Redeem Now",
	    "saveForLater": "Save For Later",
	    "mustBeRedeemedWithinDays": "Must be redeemed within {dayCount} days",
	    "oneVisitCloser": "You also are {dayCount} visit closer to",
	    "readyToRedeem": "Are you sure you are ready to redeem now?",
	    "ifSoShowThis": "If so, show this to a staff member",
	    "confirmStaffMember": "Confirm a staff member has seen your device",
	    "cancel": "Cancel"
	  },
	  "jp": {
	    "popItSetupCustomerManagement": "顧客管理",
	    "popItSetupTitle": "商品タイトル -- Chihiro",
	    "popItSetupTitleJP": "商品タイトル (Japanese) -- Chihiro",
	    "popItSetupOdds": "オッズ -- Chihiro",
	    "popItSetupMenuPhotos": "メニュー写真 -- Chihiro",
	    "popItSetupOddsHelp": "たとえば、100分の1の確率で勝つ -- Chihiro",
	    "popItSetupExpireDays": "有効期限の日数 -- Chihiro",
	    "popItSetupPriority": "優先度",
	    "popItSetupCategory": "カテゴリー",
	    "popItSetupPopitProducts": "Popitの製品 -- Chihiro",
	    "popItSetupQuantity": "量 -- Chihiro",
	    "popItSetupTotalRedeemed": "合計償還 -- Chihiro",
	    "popItSetupTerms": "条項",
	    "popItSetupYes": "はい",
	    "popItSetupNo": "番号",
	    "popItSetupDescription": "説明文",
	    "popItSetupIsClosed": "閉じています",
	    "popItSetupMaxTicketCount": "最大チケット数",
	    "popItSetupNightStart": "夜間営業時間（オプション） -- Chihiro",
	    "popItSetupNightEnd": "夜の時間終了（オプション） -- Chihiro",
	    "popItSetupBusinessImage": "ロゴまたはビジネス画像",
	    "popItSetupContact": "連絡先",
	    "popItSetupContactPhone": "電話番号",
	    "popItSetupCoordinates": "コーディネート",
	    "popItSetupContactEmail": "電子メールアドレス",
	    "popItSetupContactWebsite": "ウェブサイト",
	    "popItSetupPhotos": "ピクチャー",
	    "popItSetupDaysToRedeem": "交換する日",
	    "popItSetupMisc": "Miscellaneous -- chihiro",
	    "popItSetupLongitude": "経度 -- chihiro",
	    "popItSetupLatitude": "緯度",
	    "popItSetupHolidays": "祝日 -- chihiro",
	    "popItSetupBusinessName": "商号",
	    "popItSetupAddress": "住所",
	    "popItSetupCity": "市",
	    "popItSetupState": "都道府県",
	    "popItSetupZip": "郵便記号",
	    "popItSetupCategories": "事業区分 -- chihiro",
	    "popItSetupCountry": "国",
	    "popItSetupHours": "時間",
	    "popItSetupMonday": "月曜",
	    "popItSetupTuesday": "火曜日 -- chihiro",
	    "popItSetupShowOnWinning": "受賞ページに表示 -- chihiro",
	    "popItSetupStart": "開始 -- chihiro",
	    "popItSetupEnd": "終わり",
	    "popItSetupWednesday": "水曜日 -- chihiro",
	    "popItSetupThursday": "木曜日 -- chihiro",
	    "popItSetupFriday": "金曜日 -- chihiro",
	    "popItSetupSaturday": "土曜日",
	    "popItSetupSunday": "日曜日",
	    "popItSetupCustomerSignEmail": "電子メールアドレス",
	    "popItSetupCustomerSignPassword": "パスワード -- chihiro",
	    "popItSetupCustomerSignin": "ログイン情報",
	    "popItSetupContactTitle": "連絡先",
	    "popItSetupSocial": "ソーシャルネットワーク",
	    "popItSetupContactInformation": "連絡先",
	    "popItSetupQuantityToRedeem": "引き換える数量 -- chihiro",
	    "popItSetupPunchCardProducts": "カード製品 -- chihiro",
	    "popItSetupEnabled": "有効化 -- chihiro",
	    "Stop": "やめる",
	    "popToWin": "ポップ・トゥ・トゥ・ウィン -- Chihiro",
	    "youWon": "勝った！-- chihiro",
	    "from": "から",
	    "redeemNow": "今すぐ交換",
	    "saveForLater": "後で見るように保存",
	    "mustBeRedeemedWithinDays": "{dayCount}日以内に引き換える必要があります",
	    "oneVisitCloser": "あなたも{dayCount}回の訪問に近い -- chihiro",
	    "readyToRedeem": "今すぐ交換する準備ができていますか? -- chihiro",
	    "ifSoShowThis": "もしそうなら、これをスタッフに見せてください -- chihiro",
	    "confirmStaffMember": "スタッフがデバイスを見たことを確認する -- chihiro",
	    "cancel": "キャンセル -- chihiro"
	  }
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _popup = __webpack_require__(205);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _fireBaseContext = __webpack_require__(34);
	
	var _fireBaseContext2 = _interopRequireDefault(_fireBaseContext);
	
	var _winPopup = __webpack_require__(217);
	
	var _winPopup2 = _interopRequireDefault(_winPopup);
	
	var _losePopup = __webpack_require__(210);
	
	var _losePopup2 = _interopRequireDefault(_losePopup);
	
	var _slotShell = __webpack_require__(216);
	
	var _slotShell2 = _interopRequireDefault(_slotShell);
	
	var _auth = __webpack_require__(72);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _probabilityNode = __webpack_require__(243);
	
	var _probabilityNode2 = _interopRequireDefault(_probabilityNode);
	
	var _PacmanLoader = __webpack_require__(258);
	
	var _PacmanLoader2 = _interopRequireDefault(_PacmanLoader);
	
	var _pubsubJs = __webpack_require__(25);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window;
	
	var WinPrize = function (_BaseComponent) {
	  _inherits(WinPrize, _BaseComponent);
	
	  function WinPrize(props, context) {
	    _classCallCheck(this, WinPrize);
	
	    var _this = _possibleConstructorReturn(this, (WinPrize.__proto__ || Object.getPrototypeOf(WinPrize)).call(this, props, context));
	
	    _this.c = function (data) {
	      var winnings = {};
	      var youWon = false;
	      var productIdWon = "";
	      var productCategory = "";
	      var productNameWon = "";
	      var terms = "";
	      var expireDays = 0;
	      if (_this.globs.length(data.Products) > 0) {
	        _this.globs.forEach(data.Products, function (product) {
	          winnings[product.Slug] = 0;
	          if (product.Odds > 0) {
	            var probabilitilized = new _probabilityNode2.default({
	              p: 1 / product.Odds,
	              f: function f() {
	                winnings[product.Slug]++;
	              }
	            });
	            probabilitilized();
	          }
	        });
	        if (_this.globs.length(winnings) > 0) {
	          var currentProductWonPriority = 0;
	          _this.globs.forEach(data.Products, function (product) {
	            _this.globs.forEach(winnings, function (wins, key) {
	              if (key === product.Slug && wins > 0 && product.Priority >= currentProductWonPriority) {
	                youWon = true;
	                currentProductWonPriority = product.Priority;
	                productIdWon = product.Slug;
	                productCategory = product.Category;
	                expireDays = product.ExpireDays;
	                if (_this.lang == "jp") {
	                  productNameWon = product.TitleJP;
	                  terms = product.TermsJP;
	                } else {
	                  productNameWon = product.Title;
	                  terms = product.Terms;
	                }
	              }
	            });
	          });
	          var userDoc = _this.context.firebase.firestore().collection("users").doc($.user.uid);
	          userDoc.get().then(function (doc) {
	            var currentRow = doc.data();
	            var customerId = _this.globs.GetVar("c");
	            var update = { UserId: $.user.uid };
	            if (currentRow.QuarterlyRaffle === undefined) {
	              update.QuarterlyRaffle = 1;
	            } else {
	              update.QuarterlyRaffle = currentRow.QuarterlyRaffle + 1;
	            }
	
	            if (currentRow.PunchCards === undefined) {
	              update.PunchCards = {};
	            } else {
	              update.PunchCards = currentRow.PunchCards;
	            }
	            if (!youWon) {
	              if (!update.PunchCards.hasOwnProperty(customerId)) {
	                update.PunchCards[customerId] = 1;
	              } else {
	                update.PunchCards[customerId] = currentRow.PunchCards[customerId] + 1;
	              }
	            }
	
	            if (currentRow.ProductWinnings === undefined) {
	              update.ProductWinnings = {};
	            } else {
	              update.ProductWinnings = currentRow.ProductWinnings;
	            }
	            if (!update.ProductWinnings.hasOwnProperty(customerId)) {
	              update.ProductWinnings[customerId] = [];
	            }
	            update.ProductWinnings[customerId].push({ DaysLeft: expireDays, ProductId: productIdWon, Category: productCategory, ProductName: productNameWon, Terms: terms });
	            $.firebaseUser = update;
	            userDoc.set(update);
	          }).catch(function (e) {
	            alert("An error occurred to fetch information " + e.message);
	          });
	
	          _this.setState(function (s) {
	            s.showSlot = true;
	            s.youWon = youWon;
	            s.punchCard = {};
	            s.productIdWon = productIdWon;
	            s.punchCard = data.PunchCardProducts;
	            s.businessName = data.Name;
	            s.businessImage = data.BusinessImage;
	            s.terms = terms;
	            s.expireDays = expireDays;
	            s.productNameWon = productNameWon;
	            s.productCategory = productCategory;
	            return s;
	          });
	        } else {
	          alert("Probability Error");
	        }
	      } else {
	        alert("No customer products");
	      }
	    };
	
	    _this.state = _this.defaultUserState();
	    return _this;
	  }
	
	  _createClass(WinPrize, [{
	    key: 'defaultUserState',
	    value: function defaultUserState() {
	      return {
	        user: {
	          info: {}
	        },
	        showSlot: false,
	        showModal: false,
	        popUpDone: false,
	        youWon: false,
	        productNameWon: ""
	      };
	    }
	
	    // calculate winnings. Trying to obfuscate things so people dont hack the JS to win
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.slotDoneToken = _pubsubJs2.default.subscribe('slot-done', function (msg, data) {
	        _this2.setState({ showModal: true, showSlot: false });
	      });
	
	      this.redeemDone = _pubsubJs2.default.subscribe('redeem-done', function (msg, data) {
	        _this2.setState({ popUpDone: true, showModal: false, showSlot: false });
	      });
	
	      this.db = this.context.firebase.firestore();
	      this.unregisterAuthObserver = this.context.firebase.auth().onAuthStateChanged(function (user) {
	        if (user !== undefined && user !== null) {
	          _this2.setState(function (s) {
	            s.user.isSignedIn = !!user;
	            s.user.info = user;
	            return s;
	          }, function () {
	            window.setTimeout(function () {
	              _this2.setState({ init: false });
	              var customerId = _this2.globs.GetVar("c");
	              if (customerId) {
	                _this2.db.collection("customers").doc(customerId).get().then(function (doc) {
	                  _this2.c(doc.data());
	                }).catch(function (e) {
	                  alert("An error occurred to submit information " + e.message);
	                });
	              } else {
	                alert("An error occurred, c error");
	              }
	            }, 1500);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _pubsubJs2.default.unsubscribe(this.slotDoneToken);
	      _pubsubJs2.default.unsubscribe(this.redeemDone);
	      this.unregisterAuthObserver();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var page = null;
	      if (this.state.user.isSignedIn && !this.state.user.info.isAnonymous) {
	        page = _react2.default.createElement(
	          'span',
	          null,
	          !this.state.showSlot && this.state.showModal && _react2.default.createElement(
	            _popup2.default,
	            { open: this.state.showModal, closeOnOverlayClick: true, onClickOverlay: function onClickOverlay() {
	                _this3.setState({ popUpDone: true });
	              } },
	            this.state.youWon ? _react2.default.createElement(_winPopup2.default, { productNameWon: this.state.productNameWon, businessImage: this.state.businessImage, expireDays: this.state.expireDays, category: this.state.productCategory, productIdWon: this.state.productIdWon, redeeNow: false, businessName: this.state.businessName, terms: this.state.terms }) : _react2.default.createElement(_losePopup2.default, { punchCard: this.state.punchCard })
	          ),
	          this.state.showSlot && !this.state.showModal && _react2.default.createElement(_slotShell2.default, null),
	          !this.state.showSlot && !this.state.showModal && !this.state.popUpDone ? _react2.default.createElement(
	            'div',
	            { className: 'sweet-loading', style: { marginLeft: "35%", marginTop: "50%" } },
	            _react2.default.createElement(_PacmanLoader2.default, {
	              size: 58,
	              color: "#1691CF",
	              loading: !this.state.showSlot
	            })
	          ) : _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            this.state.popUpDone && _react2.default.createElement(
	              'div',
	              null,
	              'This is shown after popup win'
	            )
	          )
	        );
	      } else {
	        page = _react2.default.createElement(_auth2.default, null);
	      }
	
	      return page;
	    }
	  }]);
	
	  return WinPrize;
	}(_base2.default);
	
	WinPrize.contextType = _fireBaseContext2.default;
	exports.default = WinPrize;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LosePopup = function (_BaseComponent) {
	  _inherits(LosePopup, _BaseComponent);
	
	  function LosePopup() {
	    _classCallCheck(this, LosePopup);
	
	    return _possibleConstructorReturn(this, (LosePopup.__proto__ || Object.getPrototypeOf(LosePopup)).apply(this, arguments));
	  }
	
	  _createClass(LosePopup, [{
	    key: 'render',
	    value: function render() {
	      var calculateQuantityLeftOnPunchCard = 5;
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { paddingTop: 20 } },
	            _react2.default.createElement(
	              'div',
	              { style: { width: 300, height: 181, paddingBottom: 40, backgroundRepeat: "no-repeat", backgroundImage: "url('/images/content/losePopup/fishLose.png')" } },
	              this.lang == "en" && _react2.default.createElement(
	                'div',
	                { style: { fontSize: 18, color: "#1691CF", paddingTop: 11, paddingLeft: 24 } },
	                'Sorry, you did not',
	                _react2.default.createElement('br', null),
	                'win a prize.'
	              ),
	              this.lang == "jp" && _react2.default.createElement(
	                'div',
	                { style: { fontSize: 18, color: "#1691CF", paddingTop: 11, paddingLeft: 24 } },
	                'Chihiro todo...'
	              ),
	              this.lang == "en" && _react2.default.createElement(
	                'div',
	                { style: { fontSize: 12, color: "white", paddingTop: 3, paddingLeft: 120 } },
	                'I held my breath and obtained',
	                _react2.default.createElement('br', null),
	                'a special raffle ticket power,',
	                _react2.default.createElement('br', null),
	                'for you to win a trip to ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Disneyland!'
	                )
	              ),
	              this.lang == "jp" && _react2.default.createElement(
	                'div',
	                { style: { fontSize: 12, color: "white", paddingTop: 3, paddingLeft: 120 } },
	                'Chihiro todo....'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { paddingBottom: 30 } },
	            _react2.default.createElement(
	              'div',
	              { style: { width: 305, height: 142, backgroundRepeat: "no-repeat", backgroundImage: "url('/images/content/losePopup/myWinningsLose.png')" } },
	              _react2.default.createElement(
	                'div',
	                { style: { fontSize: 15, color: "white", paddingTop: 9, paddingLeft: 84 } },
	                this.globs.__(this.translate["oneVisitCloser"], { dayCount: this.props.punchCard.Quantity - calculateQuantityLeftOnPunchCard }),
	                ':'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { fontSize: 21, paddingLeft: 141, paddingTop: 12 }, className: 'pink' },
	                this.lang == "en" ? this.props.punchCard.Title : this.props.punchCard.TitleJP
	              ),
	              _react2.default.createElement('img', { style: { width: 141, marginLeft: 141, marginTop: 6 }, src: "/images/content/winningPopup/" + this.props.punchCard.Category + ".png", alt: "Category " + this.props.punchCard.Category })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LosePopup;
	}(_base2.default);
	
	LosePopup.propTypes = {
	  // productNameWon : PropTypes.string,
	};
	
	exports.default = LosePopup;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wheel = __webpack_require__(215);
	
	var _Wheel2 = _interopRequireDefault(_Wheel);
	
	var _StartButton = __webpack_require__(212);
	
	var _StartButton2 = _interopRequireDefault(_StartButton);
	
	var _StopButton = __webpack_require__(213);
	
	var _StopButton2 = _interopRequireDefault(_StopButton);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _pubsubJs = __webpack_require__(25);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SlotMachine = function (_BaseComponent) {
	  _inherits(SlotMachine, _BaseComponent);
	
	  function SlotMachine(props) {
	    _classCallCheck(this, SlotMachine);
	
	    var _this = _possibleConstructorReturn(this, (SlotMachine.__proto__ || Object.getPrototypeOf(SlotMachine)).call(this, props));
	
	    _this.state = {
	      isGameOn: true,
	      timeout: null
	    };
	    _this.handleStart = _this.handleStart.bind(_this);
	    _this.handleStop = _this.handleStop.bind(_this);
	    _this.getActive = _this.getActive.bind(_this);
	    _this.checkPrize = _this.checkPrize.bind(_this);
	    _this.results = [];
	    return _this;
	  }
	
	  _createClass(SlotMachine, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleTimeout(this.handleStart, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'SlotMachine' },
	        _react2.default.createElement(
	          'div',
	          { className: 'WheelWrapper' },
	          _react2.default.createElement(_Wheel2.default, { name: 'Wheel1', isSpinning: this.state.isGameOn, active: this.getActive }),
	          _react2.default.createElement(_Wheel2.default, { name: 'Wheel2', isSpinning: this.state.isGameOn, active: this.getActive }),
	          _react2.default.createElement(_Wheel2.default, { name: 'Wheel3', isSpinning: this.state.isGameOn, active: this.getActive })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'StartButtonHandler' },
	          _react2.default.createElement(_StartButton2.default, { clicked: this.handleStart })
	        ),
	        _react2.default.createElement(_StopButton2.default, { clicked: this.handleStop })
	      );
	    }
	  }, {
	    key: 'handleStart',
	    value: function handleStart() {
	      clearTimeout(this.state.timeout);
	      this.setState({
	        isGameOn: true,
	        timeout: null
	      });
	      this.props.prize(this.translate["popToWin"]);
	      this.handleTimeout(this.handleStop, 4000);
	    }
	  }, {
	    key: 'handleStop',
	    value: function handleStop() {
	      clearTimeout(this.state.timeout);
	      this.setState({
	        isGameOn: false,
	        timeout: null
	      });
	    }
	  }, {
	    key: 'handleTimeout',
	    value: function handleTimeout(fn, time) {
	      var timeout = setTimeout(function () {
	        fn();
	      }, time);
	      this.setState({
	        timeout: timeout
	      });
	    }
	  }, {
	    key: 'getActive',
	    value: function getActive(num, symbol) {
	      var prize = void 0;
	      this.results.push(symbol);
	      if (this.results.length === 3) {
	
	        prize = this.checkPrize();
	        this.results = [];
	      }
	      _pubsubJs2.default.publish('slot-done', '');
	      this.props.prize("");
	    }
	  }, {
	    key: 'checkPrize',
	    value: function checkPrize() {
	
	      if (this.results[0] === this.results[1] && this.results[1] === this.results[2]) {
	        return 100;
	      } else if (this.results[0] === this.results[1] || this.results[1] === this.results[2]) {
	        return 20;
	      } else if (this.results[0] === this.results[2]) {
	        return 10;
	      } else {
	        return 0;
	      }
	    }
	  }]);
	
	  return SlotMachine;
	}(_base2.default);
	
	exports.default = SlotMachine;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StartButton = function (_BaseComponent) {
	  _inherits(StartButton, _BaseComponent);
	
	  function StartButton() {
	    _classCallCheck(this, StartButton);
	
	    return _possibleConstructorReturn(this, (StartButton.__proto__ || Object.getPrototypeOf(StartButton)).apply(this, arguments));
	  }
	
	  _createClass(StartButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('button', Object.assign({ className: 'StartButton' }, this.globs.touchAndClick(this.props.clicked)));
	    }
	  }]);
	
	  return StartButton;
	}(_base2.default);
	
	exports.default = StartButton;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StopButton = function (_BaseComponent) {
	  _inherits(StopButton, _BaseComponent);
	
	  function StopButton() {
	    _classCallCheck(this, StopButton);
	
	    return _possibleConstructorReturn(this, (StopButton.__proto__ || Object.getPrototypeOf(StopButton)).apply(this, arguments));
	  }
	
	  _createClass(StopButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'button',
	        Object.assign({ className: 'StopButton' }, this.globs.touchAndClick(this.props.clicked)),
	        this.translate["Stop"]
	      );
	    }
	  }]);
	
	  return StopButton;
	}(_base2.default);
	
	exports.default = StopButton;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Symbol = function (_BaseComponent) {
	  _inherits(_Symbol, _BaseComponent);
	
	  function _Symbol() {
	    _classCallCheck(this, _Symbol);
	
	    return _possibleConstructorReturn(this, (_Symbol.__proto__ || Object.getPrototypeOf(_Symbol)).apply(this, arguments));
	  }
	
	  _createClass(_Symbol, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('img', { className: "Symbol " + this.props.name, src: this.props.src, alt: this.props.name, style: { 'top': this.props.positionY } });
	    }
	  }]);
	
	  return _Symbol;
	}(_base2.default);
	
	exports.default = _Symbol;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Symbol2 = __webpack_require__(214);
	
	var _Symbol3 = _interopRequireDefault(_Symbol2);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Wheel = function (_BaseComponent) {
	  _inherits(Wheel, _BaseComponent);
	
	  function Wheel(props) {
	    _classCallCheck(this, Wheel);
	
	    var _this = _possibleConstructorReturn(this, (Wheel.__proto__ || Object.getPrototypeOf(Wheel)).call(this, props));
	
	    _this.state = {
	      spinning: false,
	      symbols: ["Strawberry", "Banana", "Orange", "Monkey"]
	    };
	    return _this;
	  }
	
	  _createClass(Wheel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.shuffle();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Wheel' },
	        _react2.default.createElement(_Symbol3.default, { name: 'Strawberry', src: "/images/content/slot/fish-slot.png", positionY: this.state.order[0] * 128 }),
	        _react2.default.createElement(_Symbol3.default, { name: 'Banana', src: "/images/content/slot/banana.png", positionY: this.state.order[1] * 128 }),
	        _react2.default.createElement(_Symbol3.default, { name: 'Orange', src: "/images/content/slot/orange.png", positionY: this.state.order[2] * 128 }),
	        _react2.default.createElement(_Symbol3.default, { name: 'Monkey', src: "/images/content/slot/monkey.png", positionY: this.state.order[3] * 128 })
	      );
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.isSpinning) {
	        if (!this.state.spinning) {
	          this.startSpinning();
	          this.setState({
	            spinning: true
	          });
	        }
	      } else if (!this.props.isSpinning) {
	        if (this.state.spinning) {
	          this.stopSpinning();
	          this.setState({
	            spinning: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'shuffle',
	    value: function shuffle() {
	
	      var options = [0, 1, 2, 3];
	      var temp = [];
	      for (var i = 0; i < 4; i++) {
	        var rand = Math.floor(Math.random() * (4 - i));
	        temp.push(options[rand]);
	        options.splice(rand, 1);
	      }
	      this.setState({
	        order: temp
	      });
	    }
	  }, {
	    key: 'startSpinning',
	    value: function startSpinning() {
	      var _this2 = this;
	
	      var temp = [];
	      var arr = this.state.order;
	      var intervalId = setInterval(function () {
	        temp = [];
	        temp[0] = arr[3];
	        temp[1] = arr[0];
	        temp[2] = arr[1];
	        temp[3] = arr[2];
	        arr = temp;
	        _this2.setState({
	          order: temp,
	          interval: intervalId
	        });
	      }, 100);
	    }
	  }, {
	    key: 'stopSpinning',
	    value: function stopSpinning() {
	      clearTimeout(this.state.interval);
	      var selected = this.state.symbols[this.state.order.indexOf(0)];
	      this.props.active(this.props.name, selected);
	    }
	  }]);
	
	  return Wheel;
	}(_base2.default);
	
	exports.default = Wheel;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SlotMachine = __webpack_require__(211);
	
	var _SlotMachine2 = _interopRequireDefault(_SlotMachine);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _reshake = __webpack_require__(269);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SlotShell = function (_BaseComponent) {
	  _inherits(SlotShell, _BaseComponent);
	
	  function SlotShell(props) {
	    _classCallCheck(this, SlotShell);
	
	    var _this = _possibleConstructorReturn(this, (SlotShell.__proto__ || Object.getPrototypeOf(SlotShell)).call(this, props));
	
	    _this.state = {
	      text: _this.translate["popToWin"]
	    };
	    _this.printPrize = _this.printPrize.bind(_this);
	    return _this;
	  }
	
	  _createClass(SlotShell, [{
	    key: 'render',
	    value: function render() {
	      var _React$createElement;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'center', style: { marginTop: 20 } },
	          _react2.default.createElement(
	            _reshake.Shake,
	            {
	              h: 9,
	              v: 5,
	              r: 52,
	              dur: 1000,
	              int: 91.1,
	              max: 100,
	              fixed: true,
	              fixedStop: false,
	              freez: false },
	            _react2.default.createElement('img', (_React$createElement = { style: { marginTop: 5, width: "100%" }, src: '/images/content/slot/Fish.png' }, _defineProperty(_React$createElement, 'style', { width: 150 }), _defineProperty(_React$createElement, 'alt', 'Main Fish'), _React$createElement))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: 15 } },
	          _react2.default.createElement(
	            'h1',
	            { className: 'slot' },
	            this.state.text
	          ),
	          _react2.default.createElement(_SlotMachine2.default, { prize: this.printPrize })
	        )
	      );
	    }
	  }, {
	    key: 'printPrize',
	    value: function printPrize(text) {
	      this.setState({
	        text: text
	      });
	    }
	  }]);
	
	  return SlotShell;
	}(_base2.default);
	
	exports.default = SlotShell;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WinPopup$propTypes;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _base = __webpack_require__(9);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _fireBaseContext = __webpack_require__(34);
	
	var _fireBaseContext2 = _interopRequireDefault(_fireBaseContext);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pubsubJs = __webpack_require__(25);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = window;
	
	var WinPopup = function (_BaseComponent) {
	  _inherits(WinPopup, _BaseComponent);
	
	  function WinPopup(props, context) {
	    _classCallCheck(this, WinPopup);
	
	    var _this = _possibleConstructorReturn(this, (WinPopup.__proto__ || Object.getPrototypeOf(WinPopup)).call(this, props, context));
	
	    _this.redeemNow = function () {
	      var newWinnings = [];
	      var hasRedeemed = false;
	      var customerId = _this.globs.GetVar("c");
	      var lowestDaysLeft = 9999999;
	      _this.globs.forEach($.firebaseUser.ProductWinnings[customerId], function (product) {
	        if (product.ProductId === _this.props.productIdWon && product.DaysLeft < lowestDaysLeft) {
	          lowestDaysLeft = product.DaysLeft;
	        }
	      });
	
	      _this.globs.forEach($.firebaseUser.ProductWinnings[customerId], function (product) {
	        if (!hasRedeemed && product.ProductId === _this.props.productIdWon && lowestDaysLeft === product.DaysLeft) {
	          hasRedeemed = true;
	        } else {
	          newWinnings.push(product);
	        }
	      });
	      var update = $.firebaseUser;
	      // $.firebaseUser comes from window and loading previous screen
	      update.ProductWinnings[customerId] = newWinnings;
	      var userDoc = _this.context.firebase.firestore().collection("users").doc($.user.uid);
	      userDoc.set(update);
	    };
	
	    _this.state = {
	      redeeNow: _this.props.redeemNow
	    };
	    return _this;
	  }
	
	  _createClass(WinPopup, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var fromBusiness = _react2.default.createElement(
	        'div',
	        { className: 'center', style: { paddingTop: 10 } },
	        _react2.default.createElement(
	          'span',
	          { className: 'pink', style: { fontSize: 16 } },
	          this.translate["from"]
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: { fontSize: 26, marginLeft: 20 } },
	          this.props.businessName
	        )
	      );
	      var terms = this.props.terms.length > 0 && _react2.default.createElement(
	        'div',
	        { className: 'center', style: { fontSize: 12, paddingTop: 14 } },
	        '* ',
	        this.props.terms
	      );
	      var RedeemNow = function RedeemNow(props) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'center' },
	          _react2.default.createElement(
	            'div',
	            Object.assign({ style: { width: 200, height: 52, marginTop: 20, backgroundRepeat: "no-repeat", backgroundImage: "url('/images/content/winningPopup/redeem.png')" } }, _this2.globs.touchAndClick(props.onClick)),
	            _react2.default.createElement(
	              'div',
	              { className: 'center', style: { fontSize: 26, color: "black", marginTop: 7 } },
	              _this2.translate["redeemNow"]
	            )
	          )
	        );
	      };
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        !this.state.redeeNow ? _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('img', { style: { marginTop: 5, width: "100%" }, src: '/images/content/winningPopup/congratulations.png', alt: 'Congratulations' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'pink center', style: { fontSize: 21 } },
	            this.translate["youWon"]
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pink center', style: { fontSize: 17, marginTop: 10 } },
	            this.props.productNameWon,
	            ' ',
	            _react2.default.createElement('img', { style: { width: 141, marginLeft: 15 }, src: "/images/content/winningPopup/" + this.props.category + ".png", alt: "Category " + this.props.category })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { width: "90%", height: 333, borderRadius: 25, backgroundColor: "#342a2a", marginTop: 15, marginLeft: 15, marginRight: 15 } },
	            terms,
	            fromBusiness,
	            _react2.default.createElement(
	              'div',
	              { style: { marginTop: 20 }, className: 'center' },
	              _react2.default.createElement('img', { style: { width: "75%" }, src: this.props.businessImage, alt: 'Business Image' })
	            ),
	            _react2.default.createElement(RedeemNow, { onClick: function onClick() {
	                _this2.setState({ redeeNow: true });
	              } })
	          ),
	          this.props.expireDays > 0 && _react2.default.createElement(
	            'div',
	            { className: 'center', style: { fontSize: 12, paddingTop: 14 } },
	            '* ',
	            this.globs.__(this.translate["mustBeRedeemedWithinDays"], { dayCount: this.props.expireDays })
	          ),
	          _react2.default.createElement(
	            'div',
	            this.globs.touchAndClick(function () {
	              _pubsubJs2.default.publish('redeem-done', {
	                productIdWon: _this2.props.productIdWon
	              });
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement('img', { style: { width: 100 }, src: '/images/content/winningPopup/save.png', alt: 'Save For Later' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pink center', style: { fontSize: 16 } },
	              this.translate["saveForLater"]
	            )
	          )
	        ) : _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { width: "90%", height: 116, borderRadius: 25, backgroundColor: "white", marginLeft: 15, marginRight: 15, fontSize: 22 }, className: 'center pink' },
	            _react2.default.createElement(
	              'span',
	              { style: { margin: 30 } },
	              this.translate["readyToRedeem"]
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'center' },
	            this.translate["ifSoShowThis"]
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'center' },
	            _react2.default.createElement('img', { style: { marginTop: 5, width: "100%" }, src: '/images/content/redeemNow/fireworks.png', alt: 'Fireworks' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { width: "90%", height: 200, borderRadius: 25, backgroundColor: "#342a2a", marginLeft: 15, marginRight: 15, paddingTop: 20, paddingBottom: 30, fontSize: 28 }, className: 'pink' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pink center', style: { fontSize: 25, marginTop: 10 } },
	              this.props.productNameWon,
	              ' ',
	              _react2.default.createElement('img', { style: { width: 120, marginLeft: 15 }, src: "/images/content/winningPopup/" + this.props.category + ".png", alt: "Category " + this.props.category })
	            ),
	            terms,
	            fromBusiness,
	            _react2.default.createElement(RedeemNow, { onClick: function onClick() {
	                var response = window.confirm(_this2.translate["confirmStaffMember"]);
	                if (response) {
	                  _pubsubJs2.default.publish('redeem-done', {
	                    productIdWon: _this2.props.productIdWon
	                  });
	                  _this2.redeemNow();
	                }
	              } }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              Object.assign({ className: 'center', style: { color: "white", fontSize: 15 } }, this.globs.touchAndClick(function () {
	                _pubsubJs2.default.publish('redeem-done', {
	                  productIdWon: _this2.props.productIdWon
	                });
	              })),
	              this.translate["cancel"]
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return WinPopup;
	}(_base2.default);
	
	WinPopup.contextType = _fireBaseContext2.default;
	
	
	WinPopup.propTypes = (_WinPopup$propTypes = {
	  productNameWon: _propTypes2.default.string,
	  businessImage: _propTypes2.default.string,
	  expireDays: _propTypes2.default.number,
	  category: _propTypes2.default.string
	}, _defineProperty(_WinPopup$propTypes, 'category', _propTypes2.default.string), _defineProperty(_WinPopup$propTypes, 'productIdWon', _propTypes2.default.string), _defineProperty(_WinPopup$propTypes, 'businessName', _propTypes2.default.string), _defineProperty(_WinPopup$propTypes, 'terms', _propTypes2.default.string), _defineProperty(_WinPopup$propTypes, 'redeeNow', _propTypes2.default.bool), _WinPopup$propTypes);
	
	exports.default = WinPopup;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(13);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(203);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _registerServiceWorker = __webpack_require__(219);
	
	var _registerServiceWorker2 = _interopRequireDefault(_registerServiceWorker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(226);
	
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));
	(0, _registerServiceWorker2.default)();

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = register;
	exports.unregister = unregister;
	// In production, we register a service worker to serve assets from local cache.
	
	// This lets the app load faster on subsequent visits in production, and gives
	// it offline capabilities. However, it also means that developers (and users)
	// will only see deployed updates on the "N+1" visit to a page, since previously
	// cached resources are updated in the background.
	
	// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
	// This link also includes instructions on opting out of this behavior.
	
	var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
	// [::1] is the IPv6 localhost address.
	window.location.hostname === '[::1]' ||
	// 127.0.0.1/8 is considered localhost for IPv4.
	window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
	
	function register() {
	  if (("production") === 'production' && 'serviceWorker' in navigator) {
	    // The URL constructor is available in all browsers that support SW.
	    var publicUrl = new URL((""), window.location);
	    if (publicUrl.origin !== window.location.origin) {
	      // Our service worker won't work if PUBLIC_URL is on a different origin
	      // from what our page is served on. This might happen if a CDN is used to
	      // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
	      return;
	    }
	
	    window.addEventListener('load', function () {
	      var swUrl = ("") + '/service-worker.js';
	
	      if (isLocalhost) {
	        // This is running on localhost. Lets check if a service worker still exists or not.
	        checkValidServiceWorker(swUrl);
	
	        // Add some additional logging to localhost, pointing developers to the
	        // service worker/PWA documentation.
	        navigator.serviceWorker.ready.then(function () {
	          console.log('This web app is being served cache-first by a service ' + 'worker. To learn more, visit https://goo.gl/SC7cgQ');
	        });
	      } else {
	        // Is not local host. Just register service worker
	        registerValidSW(swUrl);
	      }
	    });
	  }
	}
	
	function registerValidSW(swUrl) {
	  navigator.serviceWorker.register(swUrl).then(function (registration) {
	    registration.onupdatefound = function () {
	      var installingWorker = registration.installing;
	      installingWorker.onstatechange = function () {
	        if (installingWorker.state === 'installed') {
	          if (navigator.serviceWorker.controller) {
	            // At this point, the old content will have been purged and
	            // the fresh content will have been added to the cache.
	            // It's the perfect time to display a "New content is
	            // available; please refresh." message in your web app.
	            console.log('New content is available; please refresh.');
	          } else {
	            // At this point, everything has been precached.
	            // It's the perfect time to display a
	            // "Content is cached for offline use." message.
	            console.log('Content is cached for offline use.');
	          }
	        }
	      };
	    };
	  }).catch(function (error) {
	    console.error('Error during service worker registration:', error);
	  });
	}
	
	function checkValidServiceWorker(swUrl) {
	  // Check if the service worker can be found. If it can't reload the page.
	  fetch(swUrl).then(function (response) {
	    // Ensure service worker exists, and that we really are getting a JS file.
	    if (response.status === 404 || response.headers.get('content-type').indexOf('javascript') === -1) {
	      // No service worker found. Probably a different app. Reload the page.
	      navigator.serviceWorker.ready.then(function (registration) {
	        registration.unregister().then(function () {
	          window.location.reload();
	        });
	      });
	    } else {
	      // Service worker found. Proceed as normal.
	      registerValidSW(swUrl);
	    }
	  }).catch(function () {
	    console.log('No internet connection found. App is running in offline mode.');
	  });
	}
	
	function unregister() {
	  if ('serviceWorker' in navigator) {
	    navigator.serviceWorker.ready.then(function (registration) {
	      registration.unregister();
	    });
	  }
	}

/***/ },
/* 220 */
/***/ function(module, exports) {

	var e=function(e){return parseFloat(e)};module.exports=function(r){return null==r&&(r=r),function(n,t,i,l){null==i&&(i=r),null==l&&(l=i);var u=String(n).match(/[\d.\-\+]*\s*(.*)/)[1]||"";if(u===t)return n;var f=e(n);if("px"!==u)if("em"===u)f=e(n)*e(i);else if("rem"===u)f=e(n)*e(r);else{if("ex"!==u)return n;f=e(n)*e(i)*2}var a=f;if("px"!==t)if("em"===t)a=f/e(l);else if("rem"===t)a=f/e(r);else{if("ex"!==t)return n;a=f/e(l)/2}return parseFloat(a.toFixed(5))+t}};
	//# sourceMappingURL=index.js.map


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var isInBrowser = _interopDefault(__webpack_require__(77));
	var _toConsumableArray = _interopDefault(__webpack_require__(39));
	
	// Export javascript style and css style vendor prefixes.
	var js = '';
	var css = '';
	var vendor = '';
	var browser = '';
	var isTouch = isInBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
	
	if (isInBrowser) {
	  // Order matters. We need to check Webkit the last one because
	  // other vendors use to add Webkit prefixes to some properties
	  var jsCssMap = {
	    Moz: '-moz-',
	    ms: '-ms-',
	    O: '-o-',
	    Webkit: '-webkit-'
	  };
	
	  var _document$createEleme = document.createElement('p'),
	      style = _document$createEleme.style;
	
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      js = key;
	      css = jsCssMap[key];
	      break;
	    }
	  } // Correctly detect the Edge browser.
	
	
	  if (js === 'Webkit' && 'msHyphens' in style) {
	    js = 'ms';
	    css = jsCssMap.ms;
	    browser = 'edge';
	  } // Correctly detect the Safari browser.
	
	
	  if (js === 'Webkit' && '-apple-trailing-word' in style) {
	    vendor = 'apple';
	  }
	}
	/**
	 * Vendor prefix string for the current browser.
	 *
	 * @type {{js: String, css: String, vendor: String, browser: String}}
	 * @api public
	 */
	
	
	var prefix = {
	  js: js,
	  css: css,
	  vendor: vendor,
	  browser: browser,
	  isTouch: isTouch
	};
	
	/**
	 * Test if a keyframe at-rule should be prefixed or not
	 *
	 * @param {String} vendor prefix string for the current browser.
	 * @return {String}
	 * @api public
	 */
	
	function supportedKeyframes(key) {
	  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
	  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
	  // https://caniuse.com/#search=keyframes
	
	  if (prefix.js === 'ms') return key;
	  return "@" + prefix.css + "keyframes" + key.substr(10);
	}
	
	// https://caniuse.com/#search=appearance
	
	var appearence = {
	  noPrefill: ['appearance'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'appearance') return false;
	    if (prefix.js === 'ms') return "-webkit-" + prop;
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=color-adjust
	
	var colorAdjust = {
	  noPrefill: ['color-adjust'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'color-adjust') return false;
	    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
	    return prop;
	  }
	};
	
	var regExp = /[-\s]+(.)?/g;
	/**
	 * Replaces the letter with the capital letter
	 *
	 * @param {String} match
	 * @param {String} c
	 * @return {String}
	 * @api private
	 */
	
	function toUpper(match, c) {
	  return c ? c.toUpperCase() : '';
	}
	/**
	 * Convert dash separated strings to camel-cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	
	function camelize(str) {
	  return str.replace(regExp, toUpper);
	}
	
	/**
	 * Convert dash separated strings to pascal cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function pascalize(str) {
	  return camelize("-" + str);
	}
	
	// but we can use a longhand property instead.
	// https://caniuse.com/#search=mask
	
	var mask = {
	  noPrefill: ['mask'],
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^mask/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var longhand = 'mask-image';
	
	      if (camelize(longhand) in style) {
	        return prop;
	      }
	
	      if (prefix.js + pascalize(longhand) in style) {
	        return prefix.css + prop;
	      }
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=text-orientation
	
	var textOrientation = {
	  noPrefill: ['text-orientation'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'text-orientation') return false;
	
	    if (prefix.vendor === 'apple' && !prefix.isTouch) {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=transform
	
	var transform = {
	  noPrefill: ['transform'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transform') return false;
	
	    if (options.transform) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=transition
	
	var transition = {
	  noPrefill: ['transition'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transition') return false;
	
	    if (options.transition) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=writing-mode
	
	var writingMode = {
	  noPrefill: ['writing-mode'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'writing-mode') return false;
	
	    if (prefix.js === 'Webkit' || prefix.js === 'ms') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=user-select
	
	var userSelect = {
	  noPrefill: ['user-select'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'user-select') return false;
	
	    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=multicolumn
	// https://github.com/postcss/autoprefixer/issues/491
	// https://github.com/postcss/autoprefixer/issues/177
	
	var breakPropsOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^break-/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var jsProp = "WebkitColumn" + pascalize(prop);
	      return jsProp in style ? prefix.css + "column-" + prop : false;
	    }
	
	    if (prefix.js === 'Moz') {
	      var _jsProp = "page" + pascalize(prop);
	
	      return _jsProp in style ? "page-" + prop : false;
	    }
	
	    return false;
	  }
	};
	
	// See https://github.com/postcss/autoprefixer/issues/324.
	
	var inlineLogicalOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
	    if (prefix.js === 'Moz') return prop;
	    var newProp = prop.replace('-inline', '');
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	// Camelization is required because we can't test using.
	// CSS syntax for e.g. in FF.
	
	var unprefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    return camelize(prop) in style ? prop : false;
	  }
	};
	
	var prefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.
	
	    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
	
	    if (prop[0] === '-' && prop[1] === '-') return prop;
	    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.
	
	    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
	    return false;
	  }
	};
	
	// https://caniuse.com/#search=scroll-snap
	
	var scrollSnap = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop.substring(0, 11) !== 'scroll-snap') return false;
	
	    if (prefix.js === 'ms') {
	      return "" + prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=overscroll-behavior
	
	var overscrollBehavior = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'overscroll-behavior') return false;
	
	    if (prefix.js === 'ms') {
	      return prefix.css + "scroll-chaining";
	    }
	
	    return prop;
	  }
	};
	
	var propMap = {
	  'flex-grow': 'flex-positive',
	  'flex-shrink': 'flex-negative',
	  'flex-basis': 'flex-preferred-size',
	  'justify-content': 'flex-pack',
	  order: 'flex-order',
	  'align-items': 'flex-align',
	  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
	
	}; // Support old flex spec from 2012.
	
	var flex2012 = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var newProp = propMap[prop];
	    if (!newProp) return false;
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	var propMap$1 = {
	  flex: 'box-flex',
	  'flex-grow': 'box-flex',
	  'flex-direction': ['box-orient', 'box-direction'],
	  order: 'box-ordinal-group',
	  'align-items': 'box-align',
	  'flex-flow': ['box-orient', 'box-direction'],
	  'justify-content': 'box-pack'
	};
	var propKeys = Object.keys(propMap$1);
	
	var prefixCss = function prefixCss(p) {
	  return prefix.css + p;
	}; // Support old flex spec from 2009.
	
	
	var flex2009 = {
	  supportedProperty: function supportedProperty(prop, style, _ref) {
	    var multiple = _ref.multiple;
	
	    if (propKeys.indexOf(prop) > -1) {
	      var newProp = propMap$1[prop];
	
	      if (!Array.isArray(newProp)) {
	        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	      }
	
	      if (!multiple) return false;
	
	      for (var i = 0; i < newProp.length; i++) {
	        if (!(prefix.js + pascalize(newProp[0]) in style)) {
	          return false;
	        }
	      }
	
	      return newProp.map(prefixCss);
	    }
	
	    return false;
	  }
	};
	
	// plugins = [
	//   ...plugins,
	//    breakPropsOld,
	//    inlineLogicalOld,
	//    unprefixed,
	//    prefixed,
	//    scrollSnap,
	//    flex2012,
	//    flex2009
	// ]
	// Plugins without 'noPrefill' value, going last.
	// 'flex-*' plugins should be at the bottom.
	// 'flex2009' going after 'flex2012'.
	// 'prefixed' going after 'unprefixed'
	
	var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
	var propertyDetectors = plugins.filter(function (p) {
	  return p.supportedProperty;
	}).map(function (p) {
	  return p.supportedProperty;
	});
	var noPrefill = plugins.filter(function (p) {
	  return p.noPrefill;
	}).reduce(function (a, p) {
	  a.push.apply(a, _toConsumableArray(p.noPrefill));
	  return a;
	}, []);
	
	var el;
	var cache = {};
	
	if (isInBrowser) {
	  el = document.createElement('p'); // We test every property on vendor prefix requirement.
	  // Once tested, result is cached. It gives us up to 70% perf boost.
	  // http://jsperf.com/element-style-object-access-vs-plain-object
	  //
	  // Prefill cache with known css properties to reduce amount of
	  // properties we need to feature test at runtime.
	  // http://davidwalsh.name/vendor-prefix
	
	  var computed = window.getComputedStyle(document.documentElement, '');
	
	  for (var key$1 in computed) {
	    // eslint-disable-next-line no-restricted-globals
	    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
	  } // Properties that cannot be correctly detected using the
	  // cache prefill method.
	
	
	  noPrefill.forEach(function (x) {
	    return delete cache[x];
	  });
	}
	/**
	 * Test if a property is supported, returns supported property with vendor
	 * prefix if required. Returns `false` if not supported.
	 *
	 * @param {String} prop dash separated
	 * @param {Object} [options]
	 * @return {String|Boolean}
	 * @api public
	 */
	
	
	function supportedProperty(prop, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  // For server-side rendering.
	  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.
	
	  if (("production") !== 'benchmark' && cache[prop] != null) {
	    return cache[prop];
	  } // Check if 'transition' or 'transform' natively supported in browser.
	
	
	  if (prop === 'transition' || prop === 'transform') {
	    options[prop] = prop in el.style;
	  } // Find a plugin for current prefix property.
	
	
	  for (var i = 0; i < propertyDetectors.length; i++) {
	    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.
	
	    if (cache[prop]) break;
	  } // Reset styles for current property.
	  // Firefox can even throw an error for invalid properties, e.g., "0".
	
	
	  try {
	    el.style[prop] = '';
	  } catch (err) {
	    return false;
	  }
	
	  return cache[prop];
	}
	
	var cache$1 = {};
	var transitionProperties = {
	  transition: 1,
	  'transition-property': 1,
	  '-webkit-transition': 1,
	  '-webkit-transition-property': 1
	};
	var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
	var el$1;
	/**
	 * Returns prefixed value transition/transform if needed.
	 *
	 * @param {String} match
	 * @param {String} p1
	 * @param {String} p2
	 * @return {String}
	 * @api private
	 */
	
	function prefixTransitionCallback(match, p1, p2) {
	  if (p1 === 'var') return 'var';
	  if (p1 === 'all') return 'all';
	  if (p2 === 'all') return ', all';
	  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
	  if (!prefixedValue) return p1 || p2;
	  return prefixedValue;
	}
	
	if (isInBrowser) el$1 = document.createElement('p');
	/**
	 * Returns prefixed value if needed. Returns `false` if value is not supported.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @return {String|Boolean}
	 * @api public
	 */
	
	function supportedValue(property, value) {
	  // For server-side rendering.
	  var prefixedValue = value;
	  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
	  // We want only prefixable values here.
	  // eslint-disable-next-line no-restricted-globals
	
	  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
	    return prefixedValue;
	  } // Create cache key for current value.
	
	
	  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
	
	  if (("production") !== 'benchmark' && cache$1[cacheKey] != null) {
	    return cache$1[cacheKey];
	  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
	
	
	  try {
	    // Test value as it is.
	    el$1.style[property] = prefixedValue;
	  } catch (err) {
	    // Return false if value not supported.
	    cache$1[cacheKey] = false;
	    return false;
	  } // If 'transition' or 'transition-property' property.
	
	
	  if (transitionProperties[property]) {
	    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
	  } else if (el$1.style[property] === '') {
	    // Value with a vendor prefix.
	    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
	
	    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
	
	    el$1.style[property] = prefixedValue; // Return false if value not supported.
	
	    if (el$1.style[property] === '') {
	      cache$1[cacheKey] = false;
	      return false;
	    }
	  } // Reset styles for current property.
	
	
	  el$1.style[property] = ''; // Write current value to cache.
	
	  cache$1[cacheKey] = prefixedValue;
	  return cache$1[cacheKey];
	}
	
	exports.prefix = prefix;
	exports.supportedKeyframes = supportedKeyframes;
	exports.supportedProperty = supportedProperty;
	exports.supportedValue = supportedValue;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {(function() {
	
	  // nb. This is for IE10 and lower _only_.
	  var supportCustomEvent = window.CustomEvent;
	  if (!supportCustomEvent || typeof supportCustomEvent === 'object') {
	    supportCustomEvent = function CustomEvent(event, x) {
	      x = x || {};
	      var ev = document.createEvent('CustomEvent');
	      ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);
	      return ev;
	    };
	    supportCustomEvent.prototype = window.Event.prototype;
	  }
	
	  /**
	   * @param {Element} el to check for stacking context
	   * @return {boolean} whether this el or its parents creates a stacking context
	   */
	  function createsStackingContext(el) {
	    while (el && el !== document.body) {
	      var s = window.getComputedStyle(el);
	      var invalid = function(k, ok) {
	        return !(s[k] === undefined || s[k] === ok);
	      }
	      if (s.opacity < 1 ||
	          invalid('zIndex', 'auto') ||
	          invalid('transform', 'none') ||
	          invalid('mixBlendMode', 'normal') ||
	          invalid('filter', 'none') ||
	          invalid('perspective', 'none') ||
	          s['isolation'] === 'isolate' ||
	          s.position === 'fixed' ||
	          s.webkitOverflowScrolling === 'touch') {
	        return true;
	      }
	      el = el.parentElement;
	    }
	    return false;
	  }
	
	  /**
	   * Finds the nearest <dialog> from the passed element.
	   *
	   * @param {Element} el to search from
	   * @return {HTMLDialogElement} dialog found
	   */
	  function findNearestDialog(el) {
	    while (el) {
	      if (el.localName === 'dialog') {
	        return /** @type {HTMLDialogElement} */ (el);
	      }
	      el = el.parentElement;
	    }
	    return null;
	  }
	
	  /**
	   * Blur the specified element, as long as it's not the HTML body element.
	   * This works around an IE9/10 bug - blurring the body causes Windows to
	   * blur the whole application.
	   *
	   * @param {Element} el to blur
	   */
	  function safeBlur(el) {
	    if (el && el.blur && el !== document.body) {
	      el.blur();
	    }
	  }
	
	  /**
	   * @param {!NodeList} nodeList to search
	   * @param {Node} node to find
	   * @return {boolean} whether node is inside nodeList
	   */
	  function inNodeList(nodeList, node) {
	    for (var i = 0; i < nodeList.length; ++i) {
	      if (nodeList[i] === node) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * @param {HTMLFormElement} el to check
	   * @return {boolean} whether this form has method="dialog"
	   */
	  function isFormMethodDialog(el) {
	    if (!el || !el.hasAttribute('method')) {
	      return false;
	    }
	    return el.getAttribute('method').toLowerCase() === 'dialog';
	  }
	
	  /**
	   * @param {!HTMLDialogElement} dialog to upgrade
	   * @constructor
	   */
	  function dialogPolyfillInfo(dialog) {
	    this.dialog_ = dialog;
	    this.replacedStyleTop_ = false;
	    this.openAsModal_ = false;
	
	    // Set a11y role. Browsers that support dialog implicitly know this already.
	    if (!dialog.hasAttribute('role')) {
	      dialog.setAttribute('role', 'dialog');
	    }
	
	    dialog.show = this.show.bind(this);
	    dialog.showModal = this.showModal.bind(this);
	    dialog.close = this.close.bind(this);
	
	    if (!('returnValue' in dialog)) {
	      dialog.returnValue = '';
	    }
	
	    if ('MutationObserver' in window) {
	      var mo = new MutationObserver(this.maybeHideModal.bind(this));
	      mo.observe(dialog, {attributes: true, attributeFilter: ['open']});
	    } else {
	      // IE10 and below support. Note that DOMNodeRemoved etc fire _before_ removal. They also
	      // seem to fire even if the element was removed as part of a parent removal. Use the removed
	      // events to force downgrade (useful if removed/immediately added).
	      var removed = false;
	      var cb = function() {
	        removed ? this.downgradeModal() : this.maybeHideModal();
	        removed = false;
	      }.bind(this);
	      var timeout;
	      var delayModel = function(ev) {
	        if (ev.target !== dialog) { return; }  // not for a child element
	        var cand = 'DOMNodeRemoved';
	        removed |= (ev.type.substr(0, cand.length) === cand);
	        window.clearTimeout(timeout);
	        timeout = window.setTimeout(cb, 0);
	      };
	      ['DOMAttrModified', 'DOMNodeRemoved', 'DOMNodeRemovedFromDocument'].forEach(function(name) {
	        dialog.addEventListener(name, delayModel);
	      });
	    }
	    // Note that the DOM is observed inside DialogManager while any dialog
	    // is being displayed as a modal, to catch modal removal from the DOM.
	
	    Object.defineProperty(dialog, 'open', {
	      set: this.setOpen.bind(this),
	      get: dialog.hasAttribute.bind(dialog, 'open')
	    });
	
	    this.backdrop_ = document.createElement('div');
	    this.backdrop_.className = 'backdrop';
	    this.backdrop_.addEventListener('click', this.backdropClick_.bind(this));
	  }
	
	  dialogPolyfillInfo.prototype = {
	
	    get dialog() {
	      return this.dialog_;
	    },
	
	    /**
	     * Maybe remove this dialog from the modal top layer. This is called when
	     * a modal dialog may no longer be tenable, e.g., when the dialog is no
	     * longer open or is no longer part of the DOM.
	     */
	    maybeHideModal: function() {
	      if (this.dialog_.hasAttribute('open') && document.body.contains(this.dialog_)) { return; }
	      this.downgradeModal();
	    },
	
	    /**
	     * Remove this dialog from the modal top layer, leaving it as a non-modal.
	     */
	    downgradeModal: function() {
	      if (!this.openAsModal_) { return; }
	      this.openAsModal_ = false;
	      this.dialog_.style.zIndex = '';
	
	      // This won't match the native <dialog> exactly because if the user set top on a centered
	      // polyfill dialog, that top gets thrown away when the dialog is closed. Not sure it's
	      // possible to polyfill this perfectly.
	      if (this.replacedStyleTop_) {
	        this.dialog_.style.top = '';
	        this.replacedStyleTop_ = false;
	      }
	
	      // Clear the backdrop and remove from the manager.
	      this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);
	      dialogPolyfill.dm.removeDialog(this);
	    },
	
	    /**
	     * @param {boolean} value whether to open or close this dialog
	     */
	    setOpen: function(value) {
	      if (value) {
	        this.dialog_.hasAttribute('open') || this.dialog_.setAttribute('open', '');
	      } else {
	        this.dialog_.removeAttribute('open');
	        this.maybeHideModal();  // nb. redundant with MutationObserver
	      }
	    },
	
	    /**
	     * Handles clicks on the fake .backdrop element, redirecting them as if
	     * they were on the dialog itself.
	     *
	     * @param {!Event} e to redirect
	     */
	    backdropClick_: function(e) {
	      if (!this.dialog_.hasAttribute('tabindex')) {
	        // Clicking on the backdrop should move the implicit cursor, even if dialog cannot be
	        // focused. Create a fake thing to focus on. If the backdrop was _before_ the dialog, this
	        // would not be needed - clicks would move the implicit cursor there.
	        var fake = document.createElement('div');
	        this.dialog_.insertBefore(fake, this.dialog_.firstChild);
	        fake.tabIndex = -1;
	        fake.focus();
	        this.dialog_.removeChild(fake);
	      } else {
	        this.dialog_.focus();
	      }
	
	      var redirectedEvent = document.createEvent('MouseEvents');
	      redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window,
	          e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey,
	          e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
	      this.dialog_.dispatchEvent(redirectedEvent);
	      e.stopPropagation();
	    },
	
	    /**
	     * Focuses on the first focusable element within the dialog. This will always blur the current
	     * focus, even if nothing within the dialog is found.
	     */
	    focus_: function() {
	      // Find element with `autofocus` attribute, or fall back to the first form/tabindex control.
	      var target = this.dialog_.querySelector('[autofocus]:not([disabled])');
	      if (!target && this.dialog_.tabIndex >= 0) {
	        target = this.dialog_;
	      }
	      if (!target) {
	        // Note that this is 'any focusable area'. This list is probably not exhaustive, but the
	        // alternative involves stepping through and trying to focus everything.
	        var opts = ['button', 'input', 'keygen', 'select', 'textarea'];
	        var query = opts.map(function(el) {
	          return el + ':not([disabled])';
	        });
	        // TODO(samthor): tabindex values that are not numeric are not focusable.
	        query.push('[tabindex]:not([disabled]):not([tabindex=""])');  // tabindex != "", not disabled
	        target = this.dialog_.querySelector(query.join(', '));
	      }
	      safeBlur(document.activeElement);
	      target && target.focus();
	    },
	
	    /**
	     * Sets the zIndex for the backdrop and dialog.
	     *
	     * @param {number} dialogZ
	     * @param {number} backdropZ
	     */
	    updateZIndex: function(dialogZ, backdropZ) {
	      if (dialogZ < backdropZ) {
	        throw new Error('dialogZ should never be < backdropZ');
	      }
	      this.dialog_.style.zIndex = dialogZ;
	      this.backdrop_.style.zIndex = backdropZ;
	    },
	
	    /**
	     * Shows the dialog. If the dialog is already open, this does nothing.
	     */
	    show: function() {
	      if (!this.dialog_.open) {
	        this.setOpen(true);
	        this.focus_();
	      }
	    },
	
	    /**
	     * Show this dialog modally.
	     */
	    showModal: function() {
	      if (this.dialog_.hasAttribute('open')) {
	        throw new Error('Failed to execute \'showModal\' on dialog: The element is already open, and therefore cannot be opened modally.');
	      }
	      if (!document.body.contains(this.dialog_)) {
	        throw new Error('Failed to execute \'showModal\' on dialog: The element is not in a Document.');
	      }
	      if (!dialogPolyfill.dm.pushDialog(this)) {
	        throw new Error('Failed to execute \'showModal\' on dialog: There are too many open modal dialogs.');
	      }
	
	      if (createsStackingContext(this.dialog_.parentElement)) {
	        console.warn('A dialog is being shown inside a stacking context. ' +
	            'This may cause it to be unusable. For more information, see this link: ' +
	            'https://github.com/GoogleChrome/dialog-polyfill/#stacking-context');
	      }
	
	      this.setOpen(true);
	      this.openAsModal_ = true;
	
	      // Optionally center vertically, relative to the current viewport.
	      if (dialogPolyfill.needsCentering(this.dialog_)) {
	        dialogPolyfill.reposition(this.dialog_);
	        this.replacedStyleTop_ = true;
	      } else {
	        this.replacedStyleTop_ = false;
	      }
	
	      // Insert backdrop.
	      this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling);
	
	      // Focus on whatever inside the dialog.
	      this.focus_();
	    },
	
	    /**
	     * Closes this HTMLDialogElement. This is optional vs clearing the open
	     * attribute, however this fires a 'close' event.
	     *
	     * @param {string=} opt_returnValue to use as the returnValue
	     */
	    close: function(opt_returnValue) {
	      if (!this.dialog_.hasAttribute('open')) {
	        throw new Error('Failed to execute \'close\' on dialog: The element does not have an \'open\' attribute, and therefore cannot be closed.');
	      }
	      this.setOpen(false);
	
	      // Leave returnValue untouched in case it was set directly on the element
	      if (opt_returnValue !== undefined) {
	        this.dialog_.returnValue = opt_returnValue;
	      }
	
	      // Triggering "close" event for any attached listeners on the <dialog>.
	      var closeEvent = new supportCustomEvent('close', {
	        bubbles: false,
	        cancelable: false
	      });
	      this.dialog_.dispatchEvent(closeEvent);
	    }
	
	  };
	
	  var dialogPolyfill = {};
	
	  dialogPolyfill.reposition = function(element) {
	    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
	    var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;
	    element.style.top = Math.max(scrollTop, topValue) + 'px';
	  };
	
	  dialogPolyfill.isInlinePositionSetByStylesheet = function(element) {
	    for (var i = 0; i < document.styleSheets.length; ++i) {
	      var styleSheet = document.styleSheets[i];
	      var cssRules = null;
	      // Some browsers throw on cssRules.
	      try {
	        cssRules = styleSheet.cssRules;
	      } catch (e) {}
	      if (!cssRules) { continue; }
	      for (var j = 0; j < cssRules.length; ++j) {
	        var rule = cssRules[j];
	        var selectedNodes = null;
	        // Ignore errors on invalid selector texts.
	        try {
	          selectedNodes = document.querySelectorAll(rule.selectorText);
	        } catch(e) {}
	        if (!selectedNodes || !inNodeList(selectedNodes, element)) {
	          continue;
	        }
	        var cssTop = rule.style.getPropertyValue('top');
	        var cssBottom = rule.style.getPropertyValue('bottom');
	        if ((cssTop && cssTop !== 'auto') || (cssBottom && cssBottom !== 'auto')) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  dialogPolyfill.needsCentering = function(dialog) {
	    var computedStyle = window.getComputedStyle(dialog);
	    if (computedStyle.position !== 'absolute') {
	      return false;
	    }
	
	    // We must determine whether the top/bottom specified value is non-auto.  In
	    // WebKit/Blink, checking computedStyle.top == 'auto' is sufficient, but
	    // Firefox returns the used value. So we do this crazy thing instead: check
	    // the inline style and then go through CSS rules.
	    if ((dialog.style.top !== 'auto' && dialog.style.top !== '') ||
	        (dialog.style.bottom !== 'auto' && dialog.style.bottom !== '')) {
	      return false;
	    }
	    return !dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
	  };
	
	  /**
	   * @param {!Element} element to force upgrade
	   */
	  dialogPolyfill.forceRegisterDialog = function(element) {
	    if (window.HTMLDialogElement || element.showModal) {
	      console.warn('This browser already supports <dialog>, the polyfill ' +
	          'may not work correctly', element);
	    }
	    if (element.localName !== 'dialog') {
	      throw new Error('Failed to register dialog: The element is not a dialog.');
	    }
	    new dialogPolyfillInfo(/** @type {!HTMLDialogElement} */ (element));
	  };
	
	  /**
	   * @param {!Element} element to upgrade, if necessary
	   */
	  dialogPolyfill.registerDialog = function(element) {
	    if (!element.showModal) {
	      dialogPolyfill.forceRegisterDialog(element);
	    }
	  };
	
	  /**
	   * @constructor
	   */
	  dialogPolyfill.DialogManager = function() {
	    /** @type {!Array<!dialogPolyfillInfo>} */
	    this.pendingDialogStack = [];
	
	    var checkDOM = this.checkDOM_.bind(this);
	
	    // The overlay is used to simulate how a modal dialog blocks the document.
	    // The blocking dialog is positioned on top of the overlay, and the rest of
	    // the dialogs on the pending dialog stack are positioned below it. In the
	    // actual implementation, the modal dialog stacking is controlled by the
	    // top layer, where z-index has no effect.
	    this.overlay = document.createElement('div');
	    this.overlay.className = '_dialog_overlay';
	    this.overlay.addEventListener('click', function(e) {
	      this.forwardTab_ = undefined;
	      e.stopPropagation();
	      checkDOM([]);  // sanity-check DOM
	    }.bind(this));
	
	    this.handleKey_ = this.handleKey_.bind(this);
	    this.handleFocus_ = this.handleFocus_.bind(this);
	
	    this.zIndexLow_ = 100000;
	    this.zIndexHigh_ = 100000 + 150;
	
	    this.forwardTab_ = undefined;
	
	    if ('MutationObserver' in window) {
	      this.mo_ = new MutationObserver(function(records) {
	        var removed = [];
	        records.forEach(function(rec) {
	          for (var i = 0, c; c = rec.removedNodes[i]; ++i) {
	            if (!(c instanceof Element)) {
	              continue;
	            } else if (c.localName === 'dialog') {
	              removed.push(c);
	            }
	            removed = removed.concat(c.querySelectorAll('dialog'));
	          }
	        });
	        removed.length && checkDOM(removed);
	      });
	    }
	  };
	
	  /**
	   * Called on the first modal dialog being shown. Adds the overlay and related
	   * handlers.
	   */
	  dialogPolyfill.DialogManager.prototype.blockDocument = function() {
	    document.documentElement.addEventListener('focus', this.handleFocus_, true);
	    document.addEventListener('keydown', this.handleKey_);
	    this.mo_ && this.mo_.observe(document, {childList: true, subtree: true});
	  };
	
	  /**
	   * Called on the first modal dialog being removed, i.e., when no more modal
	   * dialogs are visible.
	   */
	  dialogPolyfill.DialogManager.prototype.unblockDocument = function() {
	    document.documentElement.removeEventListener('focus', this.handleFocus_, true);
	    document.removeEventListener('keydown', this.handleKey_);
	    this.mo_ && this.mo_.disconnect();
	  };
	
	  /**
	   * Updates the stacking of all known dialogs.
	   */
	  dialogPolyfill.DialogManager.prototype.updateStacking = function() {
	    var zIndex = this.zIndexHigh_;
	
	    for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
	      dpi.updateZIndex(--zIndex, --zIndex);
	      if (i === 0) {
	        this.overlay.style.zIndex = --zIndex;
	      }
	    }
	
	    // Make the overlay a sibling of the dialog itself.
	    var last = this.pendingDialogStack[0];
	    if (last) {
	      var p = last.dialog.parentNode || document.body;
	      p.appendChild(this.overlay);
	    } else if (this.overlay.parentNode) {
	      this.overlay.parentNode.removeChild(this.overlay);
	    }
	  };
	
	  /**
	   * @param {Element} candidate to check if contained or is the top-most modal dialog
	   * @return {boolean} whether candidate is contained in top dialog
	   */
	  dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function(candidate) {
	    while (candidate = findNearestDialog(candidate)) {
	      for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
	        if (dpi.dialog === candidate) {
	          return i === 0;  // only valid if top-most
	        }
	      }
	      candidate = candidate.parentElement;
	    }
	    return false;
	  };
	
	  dialogPolyfill.DialogManager.prototype.handleFocus_ = function(event) {
	    if (this.containedByTopDialog_(event.target)) { return; }
	
	    event.preventDefault();
	    event.stopPropagation();
	    safeBlur(/** @type {Element} */ (event.target));
	
	    if (this.forwardTab_ === undefined) { return; }  // move focus only from a tab key
	
	    var dpi = this.pendingDialogStack[0];
	    var dialog = dpi.dialog;
	    var position = dialog.compareDocumentPosition(event.target);
	    if (position & Node.DOCUMENT_POSITION_PRECEDING) {
	      if (this.forwardTab_) {  // forward
	        dpi.focus_();
	      } else {  // backwards
	        document.documentElement.focus();
	      }
	    } else {
	      // TODO: Focus after the dialog, is ignored.
	    }
	
	    return false;
	  };
	
	  dialogPolyfill.DialogManager.prototype.handleKey_ = function(event) {
	    this.forwardTab_ = undefined;
	    if (event.keyCode === 27) {
	      event.preventDefault();
	      event.stopPropagation();
	      var cancelEvent = new supportCustomEvent('cancel', {
	        bubbles: false,
	        cancelable: true
	      });
	      var dpi = this.pendingDialogStack[0];
	      if (dpi && dpi.dialog.dispatchEvent(cancelEvent)) {
	        dpi.dialog.close();
	      }
	    } else if (event.keyCode === 9) {
	      this.forwardTab_ = !event.shiftKey;
	    }
	  };
	
	  /**
	   * Finds and downgrades any known modal dialogs that are no longer displayed. Dialogs that are
	   * removed and immediately readded don't stay modal, they become normal.
	   *
	   * @param {!Array<!HTMLDialogElement>} removed that have definitely been removed
	   */
	  dialogPolyfill.DialogManager.prototype.checkDOM_ = function(removed) {
	    // This operates on a clone because it may cause it to change. Each change also calls
	    // updateStacking, which only actually needs to happen once. But who removes many modal dialogs
	    // at a time?!
	    var clone = this.pendingDialogStack.slice();
	    clone.forEach(function(dpi) {
	      if (removed.indexOf(dpi.dialog) !== -1) {
	        dpi.downgradeModal();
	      } else {
	        dpi.maybeHideModal();
	      }
	    });
	  };
	
	  /**
	   * @param {!dialogPolyfillInfo} dpi
	   * @return {boolean} whether the dialog was allowed
	   */
	  dialogPolyfill.DialogManager.prototype.pushDialog = function(dpi) {
	    var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
	    if (this.pendingDialogStack.length >= allowed) {
	      return false;
	    }
	    if (this.pendingDialogStack.unshift(dpi) === 1) {
	      this.blockDocument();
	    }
	    this.updateStacking();
	    return true;
	  };
	
	  /**
	   * @param {!dialogPolyfillInfo} dpi
	   */
	  dialogPolyfill.DialogManager.prototype.removeDialog = function(dpi) {
	    var index = this.pendingDialogStack.indexOf(dpi);
	    if (index === -1) { return; }
	
	    this.pendingDialogStack.splice(index, 1);
	    if (this.pendingDialogStack.length === 0) {
	      this.unblockDocument();
	    }
	    this.updateStacking();
	  };
	
	  dialogPolyfill.dm = new dialogPolyfill.DialogManager();
	  dialogPolyfill.formSubmitter = null;
	  dialogPolyfill.useValue = null;
	
	  /**
	   * Installs global handlers, such as click listers and native method overrides. These are needed
	   * even if a no dialog is registered, as they deal with <form method="dialog">.
	   */
	  if (window.HTMLDialogElement === undefined) {
	
	    /**
	     * If HTMLFormElement translates method="DIALOG" into 'get', then replace the descriptor with
	     * one that returns the correct value.
	     */
	    var testForm = document.createElement('form');
	    testForm.setAttribute('method', 'dialog');
	    if (testForm.method !== 'dialog') {
	      var methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, 'method');
	      if (methodDescriptor) {
	        // nb. Some older iOS and older PhantomJS fail to return the descriptor. Don't do anything
	        // and don't bother to update the element.
	        var realGet = methodDescriptor.get;
	        methodDescriptor.get = function() {
	          if (isFormMethodDialog(this)) {
	            return 'dialog';
	          }
	          return realGet.call(this);
	        };
	        var realSet = methodDescriptor.set;
	        methodDescriptor.set = function(v) {
	          if (typeof v === 'string' && v.toLowerCase() === 'dialog') {
	            return this.setAttribute('method', v);
	          }
	          return realSet.call(this, v);
	        };
	        Object.defineProperty(HTMLFormElement.prototype, 'method', methodDescriptor);
	      }
	    }
	
	    /**
	     * Global 'click' handler, to capture the <input type="submit"> or <button> element which has
	     * submitted a <form method="dialog">. Needed as Safari and others don't report this inside
	     * document.activeElement.
	     */
	    document.addEventListener('click', function(ev) {
	      dialogPolyfill.formSubmitter = null;
	      dialogPolyfill.useValue = null;
	      if (ev.defaultPrevented) { return; }  // e.g. a submit which prevents default submission
	
	      var target = /** @type {Element} */ (ev.target);
	      if (!target || !isFormMethodDialog(target.form)) { return; }
	
	      var valid = (target.type === 'submit' && ['button', 'input'].indexOf(target.localName) > -1);
	      if (!valid) {
	        if (!(target.localName === 'input' && target.type === 'image')) { return; }
	        // this is a <input type="image">, which can submit forms
	        dialogPolyfill.useValue = ev.offsetX + ',' + ev.offsetY;
	      }
	
	      var dialog = findNearestDialog(target);
	      if (!dialog) { return; }
	
	      dialogPolyfill.formSubmitter = target;
	    }, false);
	
	    /**
	     * Replace the native HTMLFormElement.submit() method, as it won't fire the
	     * submit event and give us a chance to respond.
	     */
	    var nativeFormSubmit = HTMLFormElement.prototype.submit;
	    var replacementFormSubmit = function () {
	      if (!isFormMethodDialog(this)) {
	        return nativeFormSubmit.call(this);
	      }
	      var dialog = findNearestDialog(this);
	      dialog && dialog.close();
	    };
	    HTMLFormElement.prototype.submit = replacementFormSubmit;
	
	    /**
	     * Global form 'dialog' method handler. Closes a dialog correctly on submit
	     * and possibly sets its return value.
	     */
	    document.addEventListener('submit', function(ev) {
	      var form = /** @type {HTMLFormElement} */ (ev.target);
	      if (!isFormMethodDialog(form)) { return; }
	      ev.preventDefault();
	
	      var dialog = findNearestDialog(form);
	      if (!dialog) { return; }
	
	      // Forms can only be submitted via .submit() or a click (?), but anyway: sanity-check that
	      // the submitter is correct before using its value as .returnValue.
	      var s = dialogPolyfill.formSubmitter;
	      if (s && s.form === form) {
	        dialog.close(dialogPolyfill.useValue || s.value);
	      } else {
	        dialog.close();
	      }
	      dialogPolyfill.formSubmitter = null;
	    }, true);
	  }
	
	  dialogPolyfill['forceRegisterDialog'] = dialogPolyfill.forceRegisterDialog;
	  dialogPolyfill['registerDialog'] = dialogPolyfill.registerDialog;
	
	  if ("function" === 'function' && 'amd' in __webpack_require__(84)) {
	    // AMD support
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return dialogPolyfill; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && typeof module['exports'] === 'object') {
	    // CommonJS support
	    module['exports'] = dialogPolyfill;
	  } else {
	    // all others
	    window['dialogPolyfill'] = dialogPolyfill;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)(module)))

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(224));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 224 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 225 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    ;
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 226 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 227 */
226,
/* 228 */
226,
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(10));
	__webpack_require__(59);
	__webpack_require__(97);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(103);
	__webpack_require__(101);
	__webpack_require__(96);
	__webpack_require__(102);
	
	var name = "firebase";
	var version = "7.8.2";
	
	/**
	 * @license
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	firebase.registerVersion(name, version, 'app');
	
	var name$1 = "firebase";
	var version$1 = "7.8.2";
	
	/**
	 * @license
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	console.warn("\nIt looks like you're using the development build of the Firebase JS SDK.\nWhen deploying Firebase apps to production, it is advisable to only import\nthe individual SDK components you intend to use.\n\nFor the module builds, these are available in the following manner\n(replace <PACKAGE> with the name of a component - i.e. auth, database, etc):\n\nCommonJS Modules:\nconst firebase = require('firebase/app');\nrequire('firebase/<PACKAGE>');\n\nES Modules:\nimport firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n\nTypescript:\nimport * as firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n");
	firebase.registerVersion(name$1, version$1);
	
	module.exports = firebase;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {(function() { var firebase=__webpack_require__(73);__webpack_require__(74);if(typeof firebase.default!=='undefined'){firebase=firebase.default;}(function(){var supportCustomEvent=window.CustomEvent;if(!supportCustomEvent||typeof supportCustomEvent==="object"){supportCustomEvent=function CustomEvent(event,x){x=x||{};var ev=document.createEvent("CustomEvent");ev.initCustomEvent(event,!!x.bubbles,!!x.cancelable,x.detail||null);return ev};supportCustomEvent.prototype=window.Event.prototype}function createsStackingContext(el){while(el&&el!==document.body){var s=window.getComputedStyle(el);var invalid=function(k,ok){return!(s[k]===undefined||s[k]===
	ok)};if(s.opacity<1||invalid("zIndex","auto")||invalid("transform","none")||invalid("mixBlendMode","normal")||invalid("filter","none")||invalid("perspective","none")||s["isolation"]==="isolate"||s.position==="fixed"||s.webkitOverflowScrolling==="touch")return true;el=el.parentElement}return false}function findNearestDialog(el){while(el){if(el.localName==="dialog")return el;el=el.parentElement}return null}function safeBlur(el){if(el&&el.blur&&el!==document.body)el.blur()}function inNodeList(nodeList,
	node){for(var i=0;i<nodeList.length;++i)if(nodeList[i]===node)return true;return false}function isFormMethodDialog(el){if(!el||!el.hasAttribute("method"))return false;return el.getAttribute("method").toLowerCase()==="dialog"}function dialogPolyfillInfo(dialog){this.dialog_=dialog;this.replacedStyleTop_=false;this.openAsModal_=false;if(!dialog.hasAttribute("role"))dialog.setAttribute("role","dialog");dialog.show=this.show.bind(this);dialog.showModal=this.showModal.bind(this);dialog.close=this.close.bind(this);
	if(!("returnValue"in dialog))dialog.returnValue="";if("MutationObserver"in window){var mo=new MutationObserver(this.maybeHideModal.bind(this));mo.observe(dialog,{attributes:true,attributeFilter:["open"]})}else{var removed=false;var cb=function(){removed?this.downgradeModal():this.maybeHideModal();removed=false}.bind(this);var timeout;var delayModel=function(ev){if(ev.target!==dialog)return;var cand="DOMNodeRemoved";removed|=ev.type.substr(0,cand.length)===cand;window.clearTimeout(timeout);timeout=
	window.setTimeout(cb,0)};["DOMAttrModified","DOMNodeRemoved","DOMNodeRemovedFromDocument"].forEach(function(name){dialog.addEventListener(name,delayModel)})}Object.defineProperty(dialog,"open",{set:this.setOpen.bind(this),get:dialog.hasAttribute.bind(dialog,"open")});this.backdrop_=document.createElement("div");this.backdrop_.className="backdrop";this.backdrop_.addEventListener("click",this.backdropClick_.bind(this))}dialogPolyfillInfo.prototype={get dialog(){return this.dialog_},maybeHideModal:function(){if(this.dialog_.hasAttribute("open")&&
	document.body.contains(this.dialog_))return;this.downgradeModal()},downgradeModal:function(){if(!this.openAsModal_)return;this.openAsModal_=false;this.dialog_.style.zIndex="";if(this.replacedStyleTop_){this.dialog_.style.top="";this.replacedStyleTop_=false}this.backdrop_.parentNode&&this.backdrop_.parentNode.removeChild(this.backdrop_);dialogPolyfill.dm.removeDialog(this)},setOpen:function(value){if(value)this.dialog_.hasAttribute("open")||this.dialog_.setAttribute("open","");else{this.dialog_.removeAttribute("open");
	this.maybeHideModal()}},backdropClick_:function(e){if(!this.dialog_.hasAttribute("tabindex")){var fake=document.createElement("div");this.dialog_.insertBefore(fake,this.dialog_.firstChild);fake.tabIndex=-1;fake.focus();this.dialog_.removeChild(fake)}else this.dialog_.focus();var redirectedEvent=document.createEvent("MouseEvents");redirectedEvent.initMouseEvent(e.type,e.bubbles,e.cancelable,window,e.detail,e.screenX,e.screenY,e.clientX,e.clientY,e.ctrlKey,e.altKey,e.shiftKey,e.metaKey,e.button,e.relatedTarget);
	this.dialog_.dispatchEvent(redirectedEvent);e.stopPropagation()},focus_:function(){var target=this.dialog_.querySelector("[autofocus]:not([disabled])");if(!target&&this.dialog_.tabIndex>=0)target=this.dialog_;if(!target){var opts=["button","input","keygen","select","textarea"];var query=opts.map(function(el){return el+":not([disabled])"});query.push('[tabindex]:not([disabled]):not([tabindex=""])');target=this.dialog_.querySelector(query.join(", "))}safeBlur(document.activeElement);target&&target.focus()},
	updateZIndex:function(dialogZ,backdropZ){if(dialogZ<backdropZ)throw new Error("dialogZ should never be < backdropZ");this.dialog_.style.zIndex=dialogZ;this.backdrop_.style.zIndex=backdropZ},show:function(){if(!this.dialog_.open){this.setOpen(true);this.focus_()}},showModal:function(){if(this.dialog_.hasAttribute("open"))throw new Error("Failed to execute 'showModal' on dialog: The element is already open, and therefore cannot be opened modally.");if(!document.body.contains(this.dialog_))throw new Error("Failed to execute 'showModal' on dialog: The element is not in a Document.");
	if(!dialogPolyfill.dm.pushDialog(this))throw new Error("Failed to execute 'showModal' on dialog: There are too many open modal dialogs.");if(createsStackingContext(this.dialog_.parentElement))console.warn("A dialog is being shown inside a stacking context. "+"This may cause it to be unusable. For more information, see this link: "+"https://github.com/GoogleChrome/dialog-polyfill/#stacking-context");this.setOpen(true);this.openAsModal_=true;if(dialogPolyfill.needsCentering(this.dialog_)){dialogPolyfill.reposition(this.dialog_);
	this.replacedStyleTop_=true}else this.replacedStyleTop_=false;this.dialog_.parentNode.insertBefore(this.backdrop_,this.dialog_.nextSibling);this.focus_()},close:function(opt_returnValue){if(!this.dialog_.hasAttribute("open"))throw new Error("Failed to execute 'close' on dialog: The element does not have an 'open' attribute, and therefore cannot be closed.");this.setOpen(false);if(opt_returnValue!==undefined)this.dialog_.returnValue=opt_returnValue;var closeEvent=new supportCustomEvent("close",{bubbles:false,
	cancelable:false});this.dialog_.dispatchEvent(closeEvent)}};var dialogPolyfill={};dialogPolyfill.reposition=function(element){var scrollTop=document.body.scrollTop||document.documentElement.scrollTop;var topValue=scrollTop+(window.innerHeight-element.offsetHeight)/2;element.style.top=Math.max(scrollTop,topValue)+"px"};dialogPolyfill.isInlinePositionSetByStylesheet=function(element){for(var i=0;i<document.styleSheets.length;++i){var styleSheet=document.styleSheets[i];var cssRules=null;try{cssRules=
	styleSheet.cssRules}catch(e){}if(!cssRules)continue;for(var j=0;j<cssRules.length;++j){var rule=cssRules[j];var selectedNodes=null;try{selectedNodes=document.querySelectorAll(rule.selectorText)}catch(e$0){}if(!selectedNodes||!inNodeList(selectedNodes,element))continue;var cssTop=rule.style.getPropertyValue("top");var cssBottom=rule.style.getPropertyValue("bottom");if(cssTop&&cssTop!=="auto"||cssBottom&&cssBottom!=="auto")return true}}return false};dialogPolyfill.needsCentering=function(dialog){var computedStyle=
	window.getComputedStyle(dialog);if(computedStyle.position!=="absolute")return false;if(dialog.style.top!=="auto"&&dialog.style.top!==""||dialog.style.bottom!=="auto"&&dialog.style.bottom!=="")return false;return!dialogPolyfill.isInlinePositionSetByStylesheet(dialog)};dialogPolyfill.forceRegisterDialog=function(element){if(window.HTMLDialogElement||element.showModal)console.warn("This browser already supports <dialog>, the polyfill "+"may not work correctly",element);if(element.localName!=="dialog")throw new Error("Failed to register dialog: The element is not a dialog.");
	new dialogPolyfillInfo(element)};dialogPolyfill.registerDialog=function(element){if(!element.showModal)dialogPolyfill.forceRegisterDialog(element)};dialogPolyfill.DialogManager=function(){this.pendingDialogStack=[];var checkDOM=this.checkDOM_.bind(this);this.overlay=document.createElement("div");this.overlay.className="_dialog_overlay";this.overlay.addEventListener("click",function(e){this.forwardTab_=undefined;e.stopPropagation();checkDOM([])}.bind(this));this.handleKey_=this.handleKey_.bind(this);
	this.handleFocus_=this.handleFocus_.bind(this);this.zIndexLow_=1E5;this.zIndexHigh_=1E5+150;this.forwardTab_=undefined;if("MutationObserver"in window)this.mo_=new MutationObserver(function(records){var removed=[];records.forEach(function(rec){for(var i=0,c;c=rec.removedNodes[i];++i){if(!(c instanceof Element))continue;else if(c.localName==="dialog")removed.push(c);removed=removed.concat(c.querySelectorAll("dialog"))}});removed.length&&checkDOM(removed)})};dialogPolyfill.DialogManager.prototype.blockDocument=
	function(){document.documentElement.addEventListener("focus",this.handleFocus_,true);document.addEventListener("keydown",this.handleKey_);this.mo_&&this.mo_.observe(document,{childList:true,subtree:true})};dialogPolyfill.DialogManager.prototype.unblockDocument=function(){document.documentElement.removeEventListener("focus",this.handleFocus_,true);document.removeEventListener("keydown",this.handleKey_);this.mo_&&this.mo_.disconnect()};dialogPolyfill.DialogManager.prototype.updateStacking=function(){var zIndex=
	this.zIndexHigh_;for(var i=0,dpi;dpi=this.pendingDialogStack[i];++i){dpi.updateZIndex(--zIndex,--zIndex);if(i===0)this.overlay.style.zIndex=--zIndex}var last=this.pendingDialogStack[0];if(last){var p=last.dialog.parentNode||document.body;p.appendChild(this.overlay)}else if(this.overlay.parentNode)this.overlay.parentNode.removeChild(this.overlay)};dialogPolyfill.DialogManager.prototype.containedByTopDialog_=function(candidate){while(candidate=findNearestDialog(candidate)){for(var i=0,dpi;dpi=this.pendingDialogStack[i];++i)if(dpi.dialog===
	candidate)return i===0;candidate=candidate.parentElement}return false};dialogPolyfill.DialogManager.prototype.handleFocus_=function(event){if(this.containedByTopDialog_(event.target))return;event.preventDefault();event.stopPropagation();safeBlur(event.target);if(this.forwardTab_===undefined)return;var dpi=this.pendingDialogStack[0];var dialog=dpi.dialog;var position=dialog.compareDocumentPosition(event.target);if(position&Node.DOCUMENT_POSITION_PRECEDING)if(this.forwardTab_)dpi.focus_();else document.documentElement.focus();
	else;return false};dialogPolyfill.DialogManager.prototype.handleKey_=function(event){this.forwardTab_=undefined;if(event.keyCode===27){event.preventDefault();event.stopPropagation();var cancelEvent=new supportCustomEvent("cancel",{bubbles:false,cancelable:true});var dpi=this.pendingDialogStack[0];if(dpi&&dpi.dialog.dispatchEvent(cancelEvent))dpi.dialog.close()}else if(event.keyCode===9)this.forwardTab_=!event.shiftKey};dialogPolyfill.DialogManager.prototype.checkDOM_=function(removed){var clone=this.pendingDialogStack.slice();
	clone.forEach(function(dpi){if(removed.indexOf(dpi.dialog)!==-1)dpi.downgradeModal();else dpi.maybeHideModal()})};dialogPolyfill.DialogManager.prototype.pushDialog=function(dpi){var allowed=(this.zIndexHigh_-this.zIndexLow_)/2-1;if(this.pendingDialogStack.length>=allowed)return false;if(this.pendingDialogStack.unshift(dpi)===1)this.blockDocument();this.updateStacking();return true};dialogPolyfill.DialogManager.prototype.removeDialog=function(dpi){var index=this.pendingDialogStack.indexOf(dpi);if(index===
	-1)return;this.pendingDialogStack.splice(index,1);if(this.pendingDialogStack.length===0)this.unblockDocument();this.updateStacking()};dialogPolyfill.dm=new dialogPolyfill.DialogManager;dialogPolyfill.formSubmitter=null;dialogPolyfill.useValue=null;if(window.HTMLDialogElement===undefined){var testForm=document.createElement("form");testForm.setAttribute("method","dialog");if(testForm.method!=="dialog"){var methodDescriptor=Object.getOwnPropertyDescriptor(HTMLFormElement.prototype,"method");if(methodDescriptor){var realGet=
	methodDescriptor.get;methodDescriptor.get=function(){if(isFormMethodDialog(this))return"dialog";return realGet.call(this)};var realSet=methodDescriptor.set;methodDescriptor.set=function(v){if(typeof v==="string"&&v.toLowerCase()==="dialog")return this.setAttribute("method",v);return realSet.call(this,v)};Object.defineProperty(HTMLFormElement.prototype,"method",methodDescriptor)}}document.addEventListener("click",function(ev){dialogPolyfill.formSubmitter=null;dialogPolyfill.useValue=null;if(ev.defaultPrevented)return;
	var target=ev.target;if(!target||!isFormMethodDialog(target.form))return;var valid=target.type==="submit"&&["button","input"].indexOf(target.localName)>-1;if(!valid){if(!(target.localName==="input"&&target.type==="image"))return;dialogPolyfill.useValue=ev.offsetX+","+ev.offsetY}var dialog=findNearestDialog(target);if(!dialog)return;dialogPolyfill.formSubmitter=target},false);var nativeFormSubmit=HTMLFormElement.prototype.submit;var replacementFormSubmit=function(){if(!isFormMethodDialog(this))return nativeFormSubmit.call(this);
	var dialog=findNearestDialog(this);dialog&&dialog.close()};HTMLFormElement.prototype.submit=replacementFormSubmit;document.addEventListener("submit",function(ev){var form=ev.target;if(!isFormMethodDialog(form))return;ev.preventDefault();var dialog=findNearestDialog(form);if(!dialog)return;var s=dialogPolyfill.formSubmitter;if(s&&s.form===form)dialog.close(dialogPolyfill.useValue||s.value);else dialog.close();dialogPolyfill.formSubmitter=null},true)}dialogPolyfill["forceRegisterDialog"]=dialogPolyfill.forceRegisterDialog;
	dialogPolyfill["registerDialog"]=dialogPolyfill.registerDialog;if("function"==="function"&&"amd"in __webpack_require__(84))!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return dialogPolyfill}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if(typeof module==="object"&&typeof module["exports"]==="object")module["exports"]=dialogPolyfill;else window["dialogPolyfill"]=dialogPolyfill})();/*
	
	 Copyright 2015 Google Inc. All Rights Reserved.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	      http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	var componentHandler={upgradeDom:function(optJsClass,optCssClass){},upgradeElement:function(element,optJsClass){},upgradeElements:function(elements){},upgradeAllRegistered:function(){},registerUpgradedCallback:function(jsClass,callback){},register:function(config){},downgradeElements:function(nodes){}};
	componentHandler=function(){var registeredComponents_=[];var createdComponents_=[];var componentConfigProperty_="mdlComponentConfigInternal_";function findRegisteredClass_(name,optReplace){for(var i=0;i<registeredComponents_.length;i++)if(registeredComponents_[i].className===name){if(typeof optReplace!=="undefined")registeredComponents_[i]=optReplace;return registeredComponents_[i]}return false}function getUpgradedListOfElement_(element){var dataUpgraded=element.getAttribute("data-upgraded");return dataUpgraded===
	null?[""]:dataUpgraded.split(",")}function isElementUpgraded_(element,jsClass){var upgradedList=getUpgradedListOfElement_(element);return upgradedList.indexOf(jsClass)!==-1}function upgradeDomInternal(optJsClass,optCssClass){if(typeof optJsClass==="undefined"&&typeof optCssClass==="undefined")for(var i=0;i<registeredComponents_.length;i++)upgradeDomInternal(registeredComponents_[i].className,registeredComponents_[i].cssClass);else{var jsClass=optJsClass;if(typeof optCssClass==="undefined"){var registeredClass=
	findRegisteredClass_(jsClass);if(registeredClass)optCssClass=registeredClass.cssClass}var elements=document.querySelectorAll("."+optCssClass);for(var n=0;n<elements.length;n++)upgradeElementInternal(elements[n],jsClass)}}function upgradeElementInternal(element,optJsClass){if(!(typeof element==="object"&&element instanceof Element))throw new Error("Invalid argument provided to upgrade MDL element.");var upgradedList=getUpgradedListOfElement_(element);var classesToUpgrade=[];if(!optJsClass){var classList=
	element.classList;registeredComponents_.forEach(function(component){if(classList.contains(component.cssClass)&&classesToUpgrade.indexOf(component)===-1&&!isElementUpgraded_(element,component.className))classesToUpgrade.push(component)})}else if(!isElementUpgraded_(element,optJsClass))classesToUpgrade.push(findRegisteredClass_(optJsClass));for(var i=0,n=classesToUpgrade.length,registeredClass;i<n;i++){registeredClass=classesToUpgrade[i];if(registeredClass){upgradedList.push(registeredClass.className);
	element.setAttribute("data-upgraded",upgradedList.join(","));var instance=new registeredClass.classConstructor(element);instance[componentConfigProperty_]=registeredClass;createdComponents_.push(instance);for(var j=0,m=registeredClass.callbacks.length;j<m;j++)registeredClass.callbacks[j](element);if(registeredClass.widget)element[registeredClass.className]=instance}else throw new Error("Unable to find a registered component for the given class.");var ev;if("CustomEvent"in window&&typeof window.CustomEvent===
	"function")ev=new CustomEvent("mdl-componentupgraded",{bubbles:true,cancelable:false});else{ev=document.createEvent("Events");ev.initEvent("mdl-componentupgraded",true,true)}element.dispatchEvent(ev)}}function upgradeElementsInternal(elements){if(!Array.isArray(elements))if(elements instanceof Element)elements=[elements];else elements=Array.prototype.slice.call(elements);for(var i=0,n=elements.length,element;i<n;i++){element=elements[i];if(element instanceof HTMLElement){upgradeElementInternal(element);
	if(element.children.length>0)upgradeElementsInternal(element.children)}}}function registerInternal(config){var widgetMissing=typeof config.widget==="undefined"&&typeof config["widget"]==="undefined";var widget=true;if(!widgetMissing)widget=config.widget||config["widget"];var newConfig={classConstructor:config.constructor||config["constructor"],className:config.classAsString||config["classAsString"],cssClass:config.cssClass||config["cssClass"],widget:widget,callbacks:[]};registeredComponents_.forEach(function(item){if(item.cssClass===
	newConfig.cssClass)throw new Error("The provided cssClass has already been registered: "+item.cssClass);if(item.className===newConfig.className)throw new Error("The provided className has already been registered");});if(config.constructor.prototype.hasOwnProperty(componentConfigProperty_))throw new Error("MDL component classes must not have "+componentConfigProperty_+" defined as a property.");var found=findRegisteredClass_(config.classAsString,newConfig);if(!found)registeredComponents_.push(newConfig)}
	function registerUpgradedCallbackInternal(jsClass,callback){var regClass=findRegisteredClass_(jsClass);if(regClass)regClass.callbacks.push(callback)}function upgradeAllRegisteredInternal(){for(var n=0;n<registeredComponents_.length;n++)upgradeDomInternal(registeredComponents_[n].className)}function deconstructComponentInternal(component){if(component){var componentIndex=createdComponents_.indexOf(component);createdComponents_.splice(componentIndex,1);var upgrades=component.element_.getAttribute("data-upgraded").split(",");
	var componentPlace=upgrades.indexOf(component[componentConfigProperty_].classAsString);upgrades.splice(componentPlace,1);component.element_.setAttribute("data-upgraded",upgrades.join(","));var ev;if("CustomEvent"in window&&typeof window.CustomEvent==="function")ev=new CustomEvent("mdl-componentdowngraded",{bubbles:true,cancelable:false});else{ev=document.createEvent("Events");ev.initEvent("mdl-componentdowngraded",true,true)}component.element_.dispatchEvent(ev)}}function downgradeNodesInternal(nodes){var downgradeNode=
	function(node){createdComponents_.filter(function(item){return item.element_===node}).forEach(deconstructComponentInternal)};if(nodes instanceof Array||nodes instanceof NodeList)for(var n=0;n<nodes.length;n++)downgradeNode(nodes[n]);else if(nodes instanceof Node)downgradeNode(nodes);else throw new Error("Invalid argument provided to downgrade MDL nodes.");}return{upgradeDom:upgradeDomInternal,upgradeElement:upgradeElementInternal,upgradeElements:upgradeElementsInternal,upgradeAllRegistered:upgradeAllRegisteredInternal,
	registerUpgradedCallback:registerUpgradedCallbackInternal,register:registerInternal,downgradeElements:downgradeNodesInternal}}();componentHandler.ComponentConfigPublic;componentHandler.ComponentConfig;componentHandler.Component;componentHandler["upgradeDom"]=componentHandler.upgradeDom;componentHandler["upgradeElement"]=componentHandler.upgradeElement;componentHandler["upgradeElements"]=componentHandler.upgradeElements;componentHandler["upgradeAllRegistered"]=componentHandler.upgradeAllRegistered;
	componentHandler["registerUpgradedCallback"]=componentHandler.registerUpgradedCallback;componentHandler["register"]=componentHandler.register;componentHandler["downgradeElements"]=componentHandler.downgradeElements;window.componentHandler=componentHandler;window["componentHandler"]=componentHandler;
	window.addEventListener("load",function(){if("classList"in document.createElement("div")&&"querySelector"in document&&"addEventListener"in window&&Array.prototype.forEach){document.documentElement.classList.add("mdl-js");componentHandler.upgradeAllRegistered()}else{componentHandler.upgradeElement=function(){};componentHandler.register=function(){}}});(function(){var MaterialButton=function MaterialButton(element){this.element_=element;this.init()};window["MaterialButton"]=MaterialButton;MaterialButton.prototype.Constant_={};MaterialButton.prototype.CssClasses_={RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_CONTAINER:"mdl-button__ripple-container",RIPPLE:"mdl-ripple"};MaterialButton.prototype.blurHandler_=function(event){if(event)this.element_.blur()};MaterialButton.prototype.disable=function(){this.element_.disabled=true};MaterialButton.prototype["disable"]=
	MaterialButton.prototype.disable;MaterialButton.prototype.enable=function(){this.element_.disabled=false};MaterialButton.prototype["enable"]=MaterialButton.prototype.enable;MaterialButton.prototype.init=function(){if(this.element_){if(this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)){var rippleContainer=document.createElement("span");rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);this.rippleElement_=document.createElement("span");this.rippleElement_.classList.add(this.CssClasses_.RIPPLE);
	rippleContainer.appendChild(this.rippleElement_);this.boundRippleBlurHandler=this.blurHandler_.bind(this);this.rippleElement_.addEventListener("mouseup",this.boundRippleBlurHandler);this.element_.appendChild(rippleContainer)}this.boundButtonBlurHandler=this.blurHandler_.bind(this);this.element_.addEventListener("mouseup",this.boundButtonBlurHandler);this.element_.addEventListener("mouseleave",this.boundButtonBlurHandler)}};componentHandler.register({constructor:MaterialButton,classAsString:"MaterialButton",
	cssClass:"mdl-js-button",widget:true})})();(function(){var MaterialProgress=function MaterialProgress(element){this.element_=element;this.init()};window["MaterialProgress"]=MaterialProgress;MaterialProgress.prototype.Constant_={};MaterialProgress.prototype.CssClasses_={INDETERMINATE_CLASS:"mdl-progress__indeterminate"};MaterialProgress.prototype.setProgress=function(p){if(this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS))return;this.progressbar_.style.width=p+"%"};MaterialProgress.prototype["setProgress"]=MaterialProgress.prototype.setProgress;
	MaterialProgress.prototype.setBuffer=function(p){this.bufferbar_.style.width=p+"%";this.auxbar_.style.width=100-p+"%"};MaterialProgress.prototype["setBuffer"]=MaterialProgress.prototype.setBuffer;MaterialProgress.prototype.init=function(){if(this.element_){var el=document.createElement("div");el.className="progressbar bar bar1";this.element_.appendChild(el);this.progressbar_=el;el=document.createElement("div");el.className="bufferbar bar bar2";this.element_.appendChild(el);this.bufferbar_=el;el=document.createElement("div");
	el.className="auxbar bar bar3";this.element_.appendChild(el);this.auxbar_=el;this.progressbar_.style.width="0%";this.bufferbar_.style.width="100%";this.auxbar_.style.width="0%";this.element_.classList.add("is-upgraded")}};componentHandler.register({constructor:MaterialProgress,classAsString:"MaterialProgress",cssClass:"mdl-js-progress",widget:true})})();(function(){var MaterialSpinner=function MaterialSpinner(element){this.element_=element;this.init()};window["MaterialSpinner"]=MaterialSpinner;MaterialSpinner.prototype.Constant_={MDL_SPINNER_LAYER_COUNT:4};MaterialSpinner.prototype.CssClasses_={MDL_SPINNER_LAYER:"mdl-spinner__layer",MDL_SPINNER_CIRCLE_CLIPPER:"mdl-spinner__circle-clipper",MDL_SPINNER_CIRCLE:"mdl-spinner__circle",MDL_SPINNER_GAP_PATCH:"mdl-spinner__gap-patch",MDL_SPINNER_LEFT:"mdl-spinner__left",MDL_SPINNER_RIGHT:"mdl-spinner__right"};
	MaterialSpinner.prototype.createLayer=function(index){var layer=document.createElement("div");layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER);layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER+"-"+index);var leftClipper=document.createElement("div");leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_LEFT);var gapPatch=document.createElement("div");gapPatch.classList.add(this.CssClasses_.MDL_SPINNER_GAP_PATCH);var rightClipper=
	document.createElement("div");rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_RIGHT);var circleOwners=[leftClipper,gapPatch,rightClipper];for(var i=0;i<circleOwners.length;i++){var circle=document.createElement("div");circle.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE);circleOwners[i].appendChild(circle)}layer.appendChild(leftClipper);layer.appendChild(gapPatch);layer.appendChild(rightClipper);this.element_.appendChild(layer)};
	MaterialSpinner.prototype["createLayer"]=MaterialSpinner.prototype.createLayer;MaterialSpinner.prototype.stop=function(){this.element_.classList.remove("is-active")};MaterialSpinner.prototype["stop"]=MaterialSpinner.prototype.stop;MaterialSpinner.prototype.start=function(){this.element_.classList.add("is-active")};MaterialSpinner.prototype["start"]=MaterialSpinner.prototype.start;MaterialSpinner.prototype.init=function(){if(this.element_){for(var i=1;i<=this.Constant_.MDL_SPINNER_LAYER_COUNT;i++)this.createLayer(i);
	this.element_.classList.add("is-upgraded")}};componentHandler.register({constructor:MaterialSpinner,classAsString:"MaterialSpinner",cssClass:"mdl-js-spinner",widget:true})})();(function(){var MaterialTextfield=function MaterialTextfield(element){this.element_=element;this.maxRows=this.Constant_.NO_MAX_ROWS;this.init()};window["MaterialTextfield"]=MaterialTextfield;MaterialTextfield.prototype.Constant_={NO_MAX_ROWS:-1,MAX_ROWS_ATTRIBUTE:"maxrows"};MaterialTextfield.prototype.CssClasses_={LABEL:"mdl-textfield__label",INPUT:"mdl-textfield__input",IS_DIRTY:"is-dirty",IS_FOCUSED:"is-focused",IS_DISABLED:"is-disabled",IS_INVALID:"is-invalid",IS_UPGRADED:"is-upgraded",HAS_PLACEHOLDER:"has-placeholder"};
	MaterialTextfield.prototype.onKeyDown_=function(event){var currentRowCount=event.target.value.split("\n").length;if(event.keyCode===13)if(currentRowCount>=this.maxRows)event.preventDefault()};MaterialTextfield.prototype.onFocus_=function(event){this.element_.classList.add(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype.onBlur_=function(event){this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype.onReset_=function(event){this.updateClasses_()};MaterialTextfield.prototype.updateClasses_=
	function(){this.checkDisabled();this.checkValidity();this.checkDirty();this.checkFocus()};MaterialTextfield.prototype.checkDisabled=function(){if(this.input_.disabled)this.element_.classList.add(this.CssClasses_.IS_DISABLED);else this.element_.classList.remove(this.CssClasses_.IS_DISABLED)};MaterialTextfield.prototype["checkDisabled"]=MaterialTextfield.prototype.checkDisabled;MaterialTextfield.prototype.checkFocus=function(){if(Boolean(this.element_.querySelector(":focus")))this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	else this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype["checkFocus"]=MaterialTextfield.prototype.checkFocus;MaterialTextfield.prototype.checkValidity=function(){if(this.input_.validity)if(this.input_.validity.valid)this.element_.classList.remove(this.CssClasses_.IS_INVALID);else this.element_.classList.add(this.CssClasses_.IS_INVALID)};MaterialTextfield.prototype["checkValidity"]=MaterialTextfield.prototype.checkValidity;MaterialTextfield.prototype.checkDirty=
	function(){if(this.input_.value&&this.input_.value.length>0)this.element_.classList.add(this.CssClasses_.IS_DIRTY);else this.element_.classList.remove(this.CssClasses_.IS_DIRTY)};MaterialTextfield.prototype["checkDirty"]=MaterialTextfield.prototype.checkDirty;MaterialTextfield.prototype.disable=function(){this.input_.disabled=true;this.updateClasses_()};MaterialTextfield.prototype["disable"]=MaterialTextfield.prototype.disable;MaterialTextfield.prototype.enable=function(){this.input_.disabled=false;
	this.updateClasses_()};MaterialTextfield.prototype["enable"]=MaterialTextfield.prototype.enable;MaterialTextfield.prototype.change=function(value){this.input_.value=value||"";this.updateClasses_()};MaterialTextfield.prototype["change"]=MaterialTextfield.prototype.change;MaterialTextfield.prototype.init=function(){if(this.element_){this.label_=this.element_.querySelector("."+this.CssClasses_.LABEL);this.input_=this.element_.querySelector("."+this.CssClasses_.INPUT);if(this.input_){if(this.input_.hasAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE)){this.maxRows=
	parseInt(this.input_.getAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE),10);if(isNaN(this.maxRows))this.maxRows=this.Constant_.NO_MAX_ROWS}if(this.input_.hasAttribute("placeholder"))this.element_.classList.add(this.CssClasses_.HAS_PLACEHOLDER);this.boundUpdateClassesHandler=this.updateClasses_.bind(this);this.boundFocusHandler=this.onFocus_.bind(this);this.boundBlurHandler=this.onBlur_.bind(this);this.boundResetHandler=this.onReset_.bind(this);this.input_.addEventListener("input",this.boundUpdateClassesHandler);
	this.input_.addEventListener("focus",this.boundFocusHandler);this.input_.addEventListener("blur",this.boundBlurHandler);this.input_.addEventListener("reset",this.boundResetHandler);if(this.maxRows!==this.Constant_.NO_MAX_ROWS){this.boundKeyDownHandler=this.onKeyDown_.bind(this);this.input_.addEventListener("keydown",this.boundKeyDownHandler)}var invalid=this.element_.classList.contains(this.CssClasses_.IS_INVALID);this.updateClasses_();this.element_.classList.add(this.CssClasses_.IS_UPGRADED);if(invalid)this.element_.classList.add(this.CssClasses_.IS_INVALID);
	if(this.input_.hasAttribute("autofocus")){this.element_.focus();this.checkFocus()}}}};componentHandler.register({constructor:MaterialTextfield,classAsString:"MaterialTextfield",cssClass:"mdl-js-textfield",widget:true})})();(function(){var l,aa="function"==typeof Object.create?Object.create:function(a){function b(){}b.prototype=a;return new b},ba;if("function"==typeof Object.setPrototypeOf)ba=Object.setPrototypeOf;else{var ca;a:{var da={zb:!0},ea={};try{ea.__proto__=da;ca=ea.zb;break a}catch(a){}ca=!1}ba=ca?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null}var fa=ba;function n(a,b){a.prototype=aa(b.prototype);a.prototype.constructor=a;if(fa)fa(a,b);else for(var c in b)if("prototype"!=
	c)if(Object.defineProperties){var d=Object.getOwnPropertyDescriptor(b,c);d&&Object.defineProperty(a,c,d)}else a[c]=b[c];a.K=b.prototype}var ha="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},ia="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this;function ka(a,b){if(b){var c=ia;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];e in c||(c[e]={});c=c[e]}a=a[a.length-
	1];d=c[a];b=b(d);b!=d&&null!=b&&ha(c,a,{configurable:!0,writable:!0,value:b})}}function la(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}ka("Object.is",function(a){return a?a:function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c}});ka("Array.prototype.includes",function(a){return a?a:function(b,c){var d=this;d instanceof String&&(d=String(d));var e=d.length;c=c||0;for(0>c&&(c=Math.max(c+e,0));c<e;c++){var f=d[c];if(f===b||Object.is(f,b))return!0}return!1}});function ma(a){var b=
	"undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:la(a)}}ka("Promise",function(a){function b(g){this.f=0;this.h=void 0;this.a=[];var h=this.j();try{g(h.resolve,h.reject)}catch(k){h.reject(k)}}function c(){this.a=null}function d(g){return g instanceof b?g:new b(function(h){h(g)})}if(a)return a;c.prototype.f=function(g){if(null==this.a){this.a=[];var h=this;this.h(function(){h.m()})}this.a.push(g)};var e=ia.setTimeout;c.prototype.h=function(g){e(g,0)};c.prototype.m=
	function(){for(;this.a&&this.a.length;){var g=this.a;this.a=[];for(var h=0;h<g.length;++h){var k=g[h];g[h]=null;try{k()}catch(m){this.j(m)}}}this.a=null};c.prototype.j=function(g){this.h(function(){throw g;})};b.prototype.j=function(){function g(m){return function(q){k||(k=!0,m.call(h,q))}}var h=this,k=!1;return{resolve:g(this.J),reject:g(this.m)}};b.prototype.J=function(g){if(g===this)this.m(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.M(g);else{a:switch(typeof g){case "object":var h=
	null!=g;break a;case "function":h=!0;break a;default:h=!1}h?this.H(g):this.i(g)}};b.prototype.H=function(g){var h=void 0;try{h=g.then}catch(k){this.m(k);return}"function"==typeof h?this.N(h,g):this.i(g)};b.prototype.m=function(g){this.w(2,g)};b.prototype.i=function(g){this.w(1,g)};b.prototype.w=function(g,h){if(0!=this.f)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.f);this.f=g;this.h=h;this.C()};b.prototype.C=function(){if(null!=this.a){for(var g=0;g<this.a.length;++g)f.f(this.a[g]);
	this.a=null}};var f=new c;b.prototype.M=function(g){var h=this.j();g.Ia(h.resolve,h.reject)};b.prototype.N=function(g,h){var k=this.j();try{g.call(h,k.resolve,k.reject)}catch(m){k.reject(m)}};b.prototype.then=function(g,h){function k(S,Ga){return"function"==typeof S?function(Oa){try{m(S(Oa))}catch(ja){q(ja)}}:Ga}var m,q,B=new b(function(S,Ga){m=S;q=Ga});this.Ia(k(g,m),k(h,q));return B};b.prototype.catch=function(g){return this.then(void 0,g)};b.prototype.Ia=function(g,h){function k(){switch(m.f){case 1:g(m.h);
	break;case 2:h(m.h);break;default:throw Error("Unexpected state: "+m.f);}}var m=this;null==this.a?f.f(k):this.a.push(k)};b.resolve=d;b.reject=function(g){return new b(function(h,k){k(g)})};b.race=function(g){return new b(function(h,k){for(var m=ma(g),q=m.next();!q.done;q=m.next())d(q.value).Ia(h,k)})};b.all=function(g){var h=ma(g),k=h.next();return k.done?d([]):new b(function(m,q){function B(Oa){return function(ja){S[Oa]=ja;Ga--;0==Ga&&m(S)}}var S=[],Ga=0;do S.push(void 0),Ga++,d(k.value).Ia(B(S.length-
	1),q),k=h.next();while(!k.done)})};return b});var p=this;function na(a){return void 0!==a}function r(a){return"string"==typeof a}var oa=/^[\w+/_-]+[=]{0,2}$/,pa=null;function qa(){}function ra(a){a.V=void 0;a.Ya=function(){return a.V?a.V:a.V=new a}}function sa(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=
	typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ta(a){return"array"==sa(a)}function ua(a){var b=sa(a);return"array"==b||"object"==b&&"number"==typeof a.length}function va(a){return"function"==
	sa(a)}function wa(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var xa="closure_uid_"+(1E9*Math.random()>>>0),ya=0;function za(a,b,c){return a.call.apply(a.bind,arguments)}function Aa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function t(a,b,c){Function.prototype.bind&&
	-1!=Function.prototype.bind.toString().indexOf("native code")?t=za:t=Aa;return t.apply(null,arguments)}function Ba(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}function u(a,b){for(var c in b)a[c]=b[c]}var Ca=Date.now||function(){return+new Date};function v(a,b){a=a.split(".");var c=p;a[0]in c||"undefined"==typeof c.execScript||c.execScript("var "+a[0]);for(var d;a.length&&(d=a.shift());)!a.length&&na(b)?c[d]=
	b:c[d]&&c[d]!==Object.prototype[d]?c=c[d]:c=c[d]={}}function w(a,b){function c(){}c.prototype=b.prototype;a.K=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.uc=function(d,e,f){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[e].apply(d,g)}}function Da(a){if(Error.captureStackTrace)Error.captureStackTrace(this,Da);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}w(Da,Error);Da.prototype.name="CustomError";var Ea;
	function Fa(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");Da.call(this,c+a[d])}w(Fa,Da);Fa.prototype.name="AssertionError";function Ha(a,b){throw new Fa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));}var Ia=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(r(a))return r(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},Ja=Array.prototype.forEach?
	function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=r(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};function Ka(a,b){for(var c=r(a)?a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)}var La=Array.prototype.filter?function(a,b){return Array.prototype.filter.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=[],e=0,f=r(a)?a.split(""):a,g=0;g<c;g++)if(g in f){var h=f[g];b.call(void 0,h,g,a)&&(d[e++]=h)}return d},Ma=Array.prototype.map?
	function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=r(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Na=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=r(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};function Pa(a,b,c){for(var d=a.length,e=r(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}
	function Qa(a,b){return 0<=Ia(a,b)}function Ra(a,b){b=Ia(a,b);var c;(c=0<=b)&&Sa(a,b);return c}function Sa(a,b){return 1==Array.prototype.splice.call(a,b,1).length}function Ta(a,b){b=Pa(a,b,void 0);0<=b&&Sa(a,b)}function Ua(a,b){var c=0;Ka(a,function(d,e){b.call(void 0,d,e,a)&&Sa(a,e)&&c++})}function Va(a){return Array.prototype.concat.apply([],arguments)}function Wa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}function Xa(a,b,c,d){return Array.prototype.splice.apply(a,
	Ya(arguments,1))}function Ya(a,b,c){return 2>=arguments.length?Array.prototype.slice.call(a,b):Array.prototype.slice.call(a,b,c)}var Za=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]},$a=/&/g,ab=/</g,bb=/>/g,cb=/"/g,db=/'/g,eb=/\x00/g,fb=/[\x00&<>"']/;function gb(a,b){return a<b?-1:a>b?1:0}function hb(a){fb.test(a)&&(-1!=a.indexOf("&")&&(a=a.replace($a,"&amp;")),-1!=a.indexOf("<")&&(a=a.replace(ab,"&lt;")),-1!=a.indexOf(">")&&(a=a.replace(bb,
	"&gt;")),-1!=a.indexOf('"')&&(a=a.replace(cb,"&quot;")),-1!=a.indexOf("'")&&(a=a.replace(db,"&#39;")),-1!=a.indexOf("\x00")&&(a=a.replace(eb,"&#0;")));return a}function ib(a,b,c){for(var d in a)b.call(c,a[d],d,a)}function jb(a){var b={},c;for(c in a)b[c]=a[c];return b}var kb="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function lb(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<kb.length;f++)c=
	kb[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}}var mb="StopIteration"in p?p.StopIteration:{message:"StopIteration",stack:""};function nb(){}nb.prototype.next=function(){throw mb;};nb.prototype.ha=function(){return this};function ob(a){if(a instanceof nb)return a;if("function"==typeof a.ha)return a.ha(!1);if(ua(a)){var b=0,c=new nb;c.next=function(){for(;;){if(b>=a.length)throw mb;if(b in a)return a[b++];b++}};return c}throw Error("Not implemented");}function pb(a,b){if(ua(a))try{Ja(a,
	b,void 0)}catch(c){if(c!==mb)throw c;}else{a=ob(a);try{for(;;)b.call(void 0,a.next(),void 0,a)}catch(c$1){if(c$1!==mb)throw c$1;}}}function qb(a){if(ua(a))return Wa(a);a=ob(a);var b=[];pb(a,function(c){b.push(c)});return b}function rb(a,b){this.f={};this.a=[];this.j=this.h=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof rb)for(c=a.ja(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));
	else for(d in a)this.set(d,a[d])}l=rb.prototype;l.la=function(){sb(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.f[this.a[b]]);return a};l.ja=function(){sb(this);return this.a.concat()};l.clear=function(){this.f={};this.j=this.h=this.a.length=0};function sb(a){if(a.h!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];tb(a.f,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.h!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],tb(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}l.get=function(a,
	b){return tb(this.f,a)?this.f[a]:b};l.set=function(a,b){tb(this.f,a)||(this.h++,this.a.push(a),this.j++);this.f[a]=b};l.forEach=function(a,b){for(var c=this.ja(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};l.ha=function(a){sb(this);var b=0,c=this.j,d=this,e=new nb;e.next=function(){if(c!=d.j)throw Error("The map has changed since the iterator was created");if(b>=d.a.length)throw mb;var f=d.a[b++];return a?f:d.f[f]};return e};function tb(a,b){return Object.prototype.hasOwnProperty.call(a,
	b)}var ub=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function vb(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}}function wb(a,b,c,d){for(var e=c.length;0<=(b=a.indexOf(c,b))&&b<d;){var f=a.charCodeAt(b-1);if(38==f||63==f)if(f=a.charCodeAt(b+e),!f||61==f||38==f||35==
	f)return b;b+=e+1}return-1}var xb=/#|$/;function yb(a,b){var c=a.search(xb),d=wb(a,0,b,c);if(0>d)return null;var e=a.indexOf("&",d);if(0>e||e>c)e=c;d+=b.length+1;return decodeURIComponent(a.substr(d,e-d).replace(/\+/g," "))}var zb=/[?&]($|#)/;function Ab(a,b){this.h=this.w=this.j="";this.C=null;this.m=this.f="";this.i=!1;var c;a instanceof Ab?(this.i=na(b)?b:a.i,Bb(this,a.j),this.w=a.w,this.h=a.h,Cb(this,a.C),this.f=a.f,Db(this,Eb(a.a)),this.m=a.m):a&&(c=String(a).match(ub))?(this.i=!!b,Bb(this,c[1]||
	"",!0),this.w=Fb(c[2]||""),this.h=Fb(c[3]||"",!0),Cb(this,c[4]),this.f=Fb(c[5]||"",!0),Db(this,c[6]||"",!0),this.m=Fb(c[7]||"")):(this.i=!!b,this.a=new Gb(null,this.i))}Ab.prototype.toString=function(){var a=[],b=this.j;b&&a.push(Hb(b,Ib,!0),":");var c=this.h;if(c||"file"==b)a.push("//"),(b=this.w)&&a.push(Hb(b,Ib,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.C,null!=c&&a.push(":",String(c));if(c=this.f)this.h&&"/"!=c.charAt(0)&&a.push("/"),a.push(Hb(c,
	"/"==c.charAt(0)?Jb:Kb,!0));(c=this.a.toString())&&a.push("?",c);(c=this.m)&&a.push("#",Hb(c,Lb));return a.join("")};Ab.prototype.resolve=function(a){var b=new Ab(this),c=!!a.j;c?Bb(b,a.j):c=!!a.w;c?b.w=a.w:c=!!a.h;c?b.h=a.h:c=null!=a.C;var d=a.f;if(c)Cb(b,a.C);else if(c=!!a.f){if("/"!=d.charAt(0))if(this.h&&!this.f)d="/"+d;else{var e=b.f.lastIndexOf("/");-1!=e&&(d=b.f.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(-1!=e.indexOf("./")||-1!=e.indexOf("/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");
	for(var f=[],g=0;g<e.length;){var h=e[g++];"."==h?d&&g==e.length&&f.push(""):".."==h?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),d&&g==e.length&&f.push("")):(f.push(h),d=!0)}d=f.join("/")}else d=e}c?b.f=d:c=""!==a.a.toString();c?Db(b,Eb(a.a)):c=!!a.m;c&&(b.m=a.m);return b};function Bb(a,b,c){a.j=c?Fb(b,!0):b;a.j&&(a.j=a.j.replace(/:$/,""))}function Cb(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.C=b}else a.C=null}function Db(a,b,c){b instanceof Gb?(a.a=b,Mb(a.a,a.i)):
	(c||(b=Hb(b,Nb)),a.a=new Gb(b,a.i))}function Ob(a){return a instanceof Ab?new Ab(a):new Ab(a,void 0)}function Pb(a,b){a instanceof Ab||(a=Ob(a));b instanceof Ab||(b=Ob(b));return a.resolve(b)}function Fb(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Hb(a,b,c){return r(a)?(a=encodeURI(a).replace(b,Qb),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Qb(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Ib=/[#\/\?@]/g,
	Kb=/[#\?:]/g,Jb=/[#\?]/g,Nb=/[#\?@]/g,Lb=/#/g;function Gb(a,b){this.f=this.a=null;this.h=a||null;this.j=!!b}function Rb(a){a.a||(a.a=new rb,a.f=0,a.h&&vb(a.h,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}l=Gb.prototype;l.add=function(a,b){Rb(this);this.h=null;a=Sb(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.f+=1;return this};function Tb(a,b){Rb(a);b=Sb(a,b);tb(a.a.f,b)&&(a.h=null,a.f-=a.a.get(b).length,a=a.a,tb(a.f,b)&&(delete a.f[b],a.h--,a.j++,a.a.length>
	2*a.h&&sb(a)))}l.clear=function(){this.a=this.h=null;this.f=0};function Ub(a,b){Rb(a);b=Sb(a,b);return tb(a.a.f,b)}l.forEach=function(a,b){Rb(this);this.a.forEach(function(c,d){Ja(c,function(e){a.call(b,e,d,this)},this)},this)};l.ja=function(){Rb(this);for(var a=this.a.la(),b=this.a.ja(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};l.la=function(a){Rb(this);var b=[];if(r(a))Ub(this,a)&&(b=Va(b,this.a.get(Sb(this,a))));else{a=this.a.la();for(var c=0;c<a.length;c++)b=
	Va(b,a[c])}return b};l.set=function(a,b){Rb(this);this.h=null;a=Sb(this,a);Ub(this,a)&&(this.f-=this.a.get(a).length);this.a.set(a,[b]);this.f+=1;return this};l.get=function(a,b){if(!a)return b;a=this.la(a);return 0<a.length?String(a[0]):b};l.toString=function(){if(this.h)return this.h;if(!this.a)return"";for(var a=[],b=this.a.ja(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.la(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.h=
	a.join("&")};function Eb(a){var b=new Gb;b.h=a.h;a.a&&(b.a=new rb(a.a),b.f=a.f);return b}function Sb(a,b){b=String(b);a.j&&(b=b.toLowerCase());return b}function Mb(a,b){b&&!a.j&&(Rb(a),a.h=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(Tb(this,d),Tb(this,e),0<c.length&&(this.h=null,this.a.set(Sb(this,e),Wa(c)),this.f+=c.length))},a));a.j=b}function Vb(a){this.a=Ob(a)}function Wb(a,b){b?a.a.a.set(x.Ta,b):Tb(a.a.a,x.Ta)}function Xb(a,b){null!==b?a.a.a.set(x.Ra,b?"1":"0"):Tb(a.a.a,x.Ra)}
	function Yb(a){return a.a.a.get(x.Qa)||null}function Zb(a,b){b?a.a.a.set(x.PROVIDER_ID,b):Tb(a.a.a,x.PROVIDER_ID)}Vb.prototype.toString=function(){return this.a.toString()};var x={Qa:"ui_auid",kc:"apiKey",Ra:"ui_sd",wb:"mode",ab:"oobCode",PROVIDER_ID:"ui_pid",Ta:"ui_sid",xb:"tenantId"};var $b;a:{var ac=p.navigator;if(ac){var bc=ac.userAgent;if(bc){$b=bc;break a}}$b=""}function y(a){return-1!=$b.indexOf(a)}function cc(){return(y("Chrome")||y("CriOS"))&&!y("Edge")}function dc(a){dc[" "](a);return a}
	dc[" "]=qa;function ec(a,b){var c=fc;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)}var gc=y("Opera"),z=y("Trident")||y("MSIE"),hc=y("Edge"),ic=hc||z,jc=y("Gecko")&&!(-1!=$b.toLowerCase().indexOf("webkit")&&!y("Edge"))&&!(y("Trident")||y("MSIE"))&&!y("Edge"),kc=-1!=$b.toLowerCase().indexOf("webkit")&&!y("Edge"),lc=kc&&y("Mobile"),mc=y("Macintosh");function nc(){var a=p.document;return a?a.documentMode:void 0}var oc;a:{var pc="",qc=function(){var a=$b;if(jc)return/rv:([^\);]+)(\)|;)/.exec(a);
	if(hc)return/Edge\/([\d\.]+)/.exec(a);if(z)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(kc)return/WebKit\/(\S+)/.exec(a);if(gc)return/(?:Version)[ \/]?(\S+)/.exec(a)}();qc&&(pc=qc?qc[1]:"");if(z){var rc=nc();if(null!=rc&&rc>parseFloat(pc)){oc=String(rc);break a}}oc=pc}var fc={};function sc(a){return ec(a,function(){for(var b=0,c=Za(String(oc)).split("."),d=Za(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",h=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["",
	"","",""];h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];if(0==g[0].length&&0==h[0].length)break;b=gb(0==g[1].length?0:parseInt(g[1],10),0==h[1].length?0:parseInt(h[1],10))||gb(0==g[2].length,0==h[2].length)||gb(g[2],h[2]);g=g[3];h=h[3]}while(0==b)}return 0<=b})}var tc;var uc=p.document;tc=uc&&z?nc()||("CSS1Compat"==uc.compatMode?parseInt(oc,10):5):void 0;function vc(a,b){this.a=a===wc&&b||"";this.f=xc}vc.prototype.ma=!0;vc.prototype.ka=function(){return this.a};vc.prototype.toString=function(){return"Const{"+
	this.a+"}"};function yc(a){if(a instanceof vc&&a.constructor===vc&&a.f===xc)return a.a;Ha("expected object of type Const, got '"+a+"'");return"type_error:Const"}var xc={},wc={};function zc(){this.a="";this.h=Ac}zc.prototype.ma=!0;zc.prototype.ka=function(){return this.a.toString()};zc.prototype.f=function(){return 1};zc.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function Bc(a){if(a instanceof zc&&a.constructor===zc&&a.h===Ac)return a.a;Ha("expected object of type TrustedResourceUrl, got '"+
	a+"' of type "+sa(a));return"type_error:TrustedResourceUrl"}var Ac={};function Cc(a){var b=new zc;b.a=a;return b}function Dc(){this.a="";this.h=Ec}Dc.prototype.ma=!0;Dc.prototype.ka=function(){return this.a.toString()};Dc.prototype.f=function(){return 1};Dc.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Fc(a){return Gc(a).toString()}function Gc(a){if(a instanceof Dc&&a.constructor===Dc&&a.h===Ec)return a.a;Ha("expected object of type SafeUrl, got '"+a+"' of type "+sa(a));return"type_error:SafeUrl"}
	var Hc=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;function Ic(a){if(a instanceof Dc)return a;a="object"==typeof a&&a.ma?a.ka():String(a);Hc.test(a)||(a="about:invalid#zClosurez");return Jc(a)}var Ec={};function Jc(a){var b=new Dc;b.a=a;return b}Jc("about:blank");function Kc(){this.a="";this.f=Lc}Kc.prototype.ma=!0;var Lc={};Kc.prototype.ka=function(){return this.a};Kc.prototype.toString=function(){return"SafeStyle{"+this.a+"}"};function Mc(){this.a="";this.j=Nc;this.h=null}Mc.prototype.f=
	function(){return this.h};Mc.prototype.ma=!0;Mc.prototype.ka=function(){return this.a.toString()};Mc.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Oc(a){if(a instanceof Mc&&a.constructor===Mc&&a.j===Nc)return a.a;Ha("expected object of type SafeHtml, got '"+a+"' of type "+sa(a));return"type_error:SafeHtml"}var Nc={};function Pc(a,b){var c=new Mc;c.a=a;c.h=b;return c}Pc("<!DOCTYPE html>",0);var Qc=Pc("",0);Pc("<br>",0);var Rc=function(a){var b=!1,c;return function(){b||(c=a(),
	b=!0);return c}}(function(){if("undefined"===typeof document)return!1;var a=document.createElement("div"),b=document.createElement("div");b.appendChild(document.createElement("div"));a.appendChild(b);if(!a.firstChild)return!1;b=a.firstChild.firstChild;a.innerHTML=Oc(Qc);return!b.parentElement});function Sc(a,b){a.src=Bc(b);if(null===pa)b:{b=p.document;if((b=b.querySelector&&b.querySelector("script[nonce]"))&&(b=b.nonce||b.getAttribute("nonce"))&&oa.test(b)){pa=b;break b}pa=""}b=pa;b&&a.setAttribute("nonce",
	b)}function Tc(a,b){this.a=na(a)?a:0;this.f=na(b)?b:0}Tc.prototype.toString=function(){return"("+this.a+", "+this.f+")"};Tc.prototype.ceil=function(){this.a=Math.ceil(this.a);this.f=Math.ceil(this.f);return this};Tc.prototype.floor=function(){this.a=Math.floor(this.a);this.f=Math.floor(this.f);return this};Tc.prototype.round=function(){this.a=Math.round(this.a);this.f=Math.round(this.f);return this};function Uc(a,b){this.width=a;this.height=b}l=Uc.prototype;l.toString=function(){return"("+this.width+
	" x "+this.height+")"};l.aspectRatio=function(){return this.width/this.height};l.ceil=function(){this.width=Math.ceil(this.width);this.height=Math.ceil(this.height);return this};l.floor=function(){this.width=Math.floor(this.width);this.height=Math.floor(this.height);return this};l.round=function(){this.width=Math.round(this.width);this.height=Math.round(this.height);return this};function Vc(a){return a?new Wc(Xc(a)):Ea||(Ea=new Wc)}function Yc(a,b){var c=b||document;return c.querySelectorAll&&c.querySelector?
	c.querySelectorAll("."+a):Zc(document,a,b)}function $c(a,b){var c=b||document;if(c.getElementsByClassName)a=c.getElementsByClassName(a)[0];else{c=document;var d=b||c;a=d.querySelectorAll&&d.querySelector&&a?d.querySelector(a?"."+a:""):Zc(c,a,b)[0]||null}return a||null}function Zc(a,b,c){var d;a=c||a;if(a.querySelectorAll&&a.querySelector&&b)return a.querySelectorAll(b?"."+b:"");if(b&&a.getElementsByClassName){var e=a.getElementsByClassName(b);return e}e=a.getElementsByTagName("*");if(b){var f={};
	for(c=d=0;a=e[c];c++){var g=a.className;"function"==typeof g.split&&Qa(g.split(/\s+/),b)&&(f[d++]=a)}f.length=d;return f}return e}function ad(a,b){ib(b,function(c,d){c&&"object"==typeof c&&c.ma&&(c=c.ka());"style"==d?a.style.cssText=c:"class"==d?a.className=c:"for"==d?a.htmlFor=c:bd.hasOwnProperty(d)?a.setAttribute(bd[d],c):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,c):a[d]=c})}var bd={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",
	height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};function cd(a){return a.scrollingElement?a.scrollingElement:kc||"CSS1Compat"!=a.compatMode?a.body||a.documentElement:a.documentElement}function dd(a){a&&a.parentNode&&a.parentNode.removeChild(a)}function Xc(a){return 9==a.nodeType?a:a.ownerDocument||a.document}function ed(a,b){if("textContent"in a)a.textContent=b;else if(3==a.nodeType)a.data=String(b);else if(a.firstChild&&
	3==a.firstChild.nodeType){for(;a.lastChild!=a.firstChild;)a.removeChild(a.lastChild);a.firstChild.data=String(b)}else{for(var c;c=a.firstChild;)a.removeChild(c);a.appendChild(Xc(a).createTextNode(String(b)))}}function fd(a,b){return b?gd(a,function(c){return!b||r(c.className)&&Qa(c.className.split(/\s+/),b)}):null}function gd(a,b){for(var c=0;a;){if(b(a))return a;a=a.parentNode;c++}return null}function Wc(a){this.a=a||p.document||document}Wc.prototype.P=function(){return r(void 0)?this.a.getElementById(void 0):
	void 0};var hd={Ec:!0},id={Gc:!0},jd={Dc:!0},kd={Fc:!0};function ld(){throw Error("Do not instantiate directly");}ld.prototype.va=null;ld.prototype.toString=function(){return this.content};function md(a,b,c,d){a=a(b||nd,void 0,c);d=(d||Vc()).a.createElement("DIV");a=od(a);a.match(pd);a=Pc(a,null);if(Rc())for(;d.lastChild;)d.removeChild(d.lastChild);d.innerHTML=Oc(a);1==d.childNodes.length&&(a=d.firstChild,1==a.nodeType&&(d=a));return d}function od(a){if(!wa(a))return hb(String(a));if(a instanceof
	ld){if(a.fa===hd)return a.content;if(a.fa===kd)return hb(a.content)}Ha("Soy template output is unsafe for use as HTML: "+a);return"zSoyz"}var pd=/^<(body|caption|col|colgroup|head|html|tr|td|th|tbody|thead|tfoot)>/i,nd={};function rd(a){if(null!=a)switch(a.va){case 1:return 1;case -1:return-1;case 0:return 0}return null}function sd(){ld.call(this)}w(sd,ld);sd.prototype.fa=hd;function A(a){return null!=a&&a.fa===hd?a:a instanceof Mc?C(Oc(a).toString(),a.f()):C(hb(String(String(a))),rd(a))}function td(){ld.call(this)}
	w(td,ld);td.prototype.fa=id;td.prototype.va=1;function ud(a,b){this.content=String(a);this.va=null!=b?b:null}w(ud,ld);ud.prototype.fa=kd;function D(a){return new ud(a,void 0)}var C=function(a){function b(c){this.content=c}b.prototype=a.prototype;return function(c,d){c=new b(String(c));void 0!==d&&(c.va=d);return c}}(sd),vd=function(a){function b(c){this.content=c}b.prototype=a.prototype;return function(c){return new b(String(c))}}(td);function wd(a){function b(){}var c={label:E("New password")};b.prototype=
	a;a=new b;for(var d in c)a[d]=c[d];return a}function E(a){return(a=String(a))?new ud(a,void 0):""}var xd=function(a){function b(c){this.content=c}b.prototype=a.prototype;return function(c,d){c=String(c);if(!c)return"";c=new b(c);void 0!==d&&(c.va=d);return c}}(sd);function yd(a){return null!=a&&a.fa===hd?String(String(a.content).replace(zd,"").replace(Ad,"&lt;")).replace(Bd,Cd):hb(String(a))}function Dd(a){null!=a&&a.fa===id?a=String(a).replace(Ed,Fd):a instanceof Dc?a=String(Fc(a)).replace(Ed,Fd):
	(a=String(a),Gd.test(a)?a=a.replace(Ed,Fd):(Ha("Bad value `%s` for |filterNormalizeUri",[a]),a="#zSoyz"));return a}function Hd(a){null!=a&&a.fa===jd?a=a.content:null==a?a="":a instanceof Kc?a instanceof Kc&&a.constructor===Kc&&a.f===Lc?a=a.a:(Ha("expected object of type SafeStyle, got '"+a+"' of type "+sa(a)),a="type_error:SafeStyle"):(a=String(a),Id.test(a)||(Ha("Bad value `%s` for |filterCssValue",[a]),a="zSoyz"));return a}var Jd={"\x00":"&#0;","\t":"&#9;","\n":"&#10;","\x0B":"&#11;","\f":"&#12;",
	"\r":"&#13;"," ":"&#32;",'"':"&quot;","&":"&amp;","'":"&#39;","-":"&#45;","/":"&#47;","<":"&lt;","=":"&#61;",">":"&gt;","`":"&#96;","\u0085":"&#133;","\u00a0":"&#160;","\u2028":"&#8232;","\u2029":"&#8233;"};function Cd(a){return Jd[a]}var Kd={"\x00":"%00","\u0001":"%01","\u0002":"%02","\u0003":"%03","\u0004":"%04","\u0005":"%05","\u0006":"%06","\u0007":"%07","\b":"%08","\t":"%09","\n":"%0A","\x0B":"%0B","\f":"%0C","\r":"%0D","\u000e":"%0E","\u000f":"%0F","\u0010":"%10","\u0011":"%11","\u0012":"%12",
	"\u0013":"%13","\u0014":"%14","\u0015":"%15","\u0016":"%16","\u0017":"%17","\u0018":"%18","\u0019":"%19","\u001a":"%1A","\u001b":"%1B","\u001c":"%1C","\u001d":"%1D","\u001e":"%1E","\u001f":"%1F"," ":"%20",'"':"%22","'":"%27","(":"%28",")":"%29","<":"%3C",">":"%3E","\\":"%5C","{":"%7B","}":"%7D","\u007f":"%7F","\u0085":"%C2%85","\u00a0":"%C2%A0","\u2028":"%E2%80%A8","\u2029":"%E2%80%A9","\uff01":"%EF%BC%81","\uff03":"%EF%BC%83","\uff04":"%EF%BC%84","\uff06":"%EF%BC%86","\uff07":"%EF%BC%87","\uff08":"%EF%BC%88",
	"\uff09":"%EF%BC%89","\uff0a":"%EF%BC%8A","\uff0b":"%EF%BC%8B","\uff0c":"%EF%BC%8C","\uff0f":"%EF%BC%8F","\uff1a":"%EF%BC%9A","\uff1b":"%EF%BC%9B","\uff1d":"%EF%BC%9D","\uff1f":"%EF%BC%9F","\uff20":"%EF%BC%A0","\uff3b":"%EF%BC%BB","\uff3d":"%EF%BC%BD"};function Fd(a){return Kd[a]}var Bd=/[\x00\x22\x27\x3c\x3e]/g,Ed=/[\x00- \x22\x27-\x29\x3c\x3e\\\x7b\x7d\x7f\x85\xa0\u2028\u2029\uff01\uff03\uff04\uff06-\uff0c\uff0f\uff1a\uff1b\uff1d\uff1f\uff20\uff3b\uff3d]/g,Id=/^(?!-*(?:expression|(?:moz-)?binding))(?:[.#]?-?(?:[_a-z0-9-]+)(?:-[_a-z0-9-]+)*-?|-?(?:[0-9]+(?:\.[0-9]*)?|\.[0-9]+)(?:[a-z]{1,2}|%)?|!important|)$/i,
	Gd=/^(?![^#?]*\/(?:\.|%2E){2}(?:[\/?#]|$))(?:(?:https?|mailto):|[^&:\/?#]*(?:[\/?#]|$))/i,zd=/<(?:!|\/?([a-zA-Z][a-zA-Z0-9:\-]*))(?:[^>'"]|"[^"]*"|'[^']*')*>/g,Ad=/</g;function Ld(){return D("Enter a valid phone number")}function Md(){return D("Something went wrong. Please try again.")}function Nd(){return D("This email already exists without any means of sign-in. Please reset the password to recover.")}function Od(a){a=a||{};var b="";switch(a.code){case "invalid-argument":b+="Client specified an invalid argument.";
	break;case "invalid-configuration":b+="Client specified an invalid project configuration.";break;case "failed-precondition":b+="Request can not be executed in the current system state.";break;case "out-of-range":b+="Client specified an invalid range.";break;case "unauthenticated":b+="Request not authenticated due to missing, invalid, or expired OAuth token.";break;case "permission-denied":b+="Client does not have sufficient permission.";break;case "not-found":b+="Specified resource is not found.";
	break;case "aborted":b+="Concurrency conflict, such as read-modify-write conflict.";break;case "already-exists":b+="The resource that a client tried to create already exists.";break;case "resource-exhausted":b+="Either out of resource quota or reaching rate limiting.";break;case "cancelled":b+="Request cancelled by the client.";break;case "data-loss":b+="Unrecoverable data loss or data corruption.";break;case "unknown":b+="Unknown server error.";break;case "internal":b+="Internal server error.";break;
	case "not-implemented":b+="API method not implemented by the server.";break;case "unavailable":b+="Service unavailable.";break;case "deadline-exceeded":b+="Request deadline exceeded.";break;case "auth/user-disabled":b+="The user account has been disabled by an administrator.";break;case "auth/timeout":b+="The operation has timed out.";break;case "auth/too-many-requests":b+="We have blocked all requests from this device due to unusual activity. Try again later.";break;case "auth/quota-exceeded":b+=
	"The quota for this operation has been exceeded. Try again later.";break;case "auth/network-request-failed":b+="A network error has occurred. Try again later.";break;case "restart-process":b+="An issue was encountered when authenticating your request. Please visit the URL that redirected you to this page again to restart the authentication process.";break;case "no-matching-tenant-for-email":b+="No sign-in provider is available for the given email, please try with a different email."}return D(b)}function Pd(){return D("Please login again to perform this operation")}
	function Qd(a,b,c){var d=Error.call(this);this.message=d.message;"stack"in d&&(this.stack=d.stack);this.code=Rd+a;if(!(a=b)){a="";switch(this.code){case "firebaseui/merge-conflict":a+="The current anonymous user failed to upgrade. The non-anonymous credential is already associated with a different user account.";break;default:a+=Md()}a=D(a).toString()}this.message=a||"";this.credential=c||null}n(Qd,Error);Qd.prototype.aa=function(){return{code:this.code,message:this.message}};Qd.prototype.toJSON=
	function(){return this.aa()};var Rd="firebaseui/";function Sd(){0!=Td&&(Ud[this[xa]||(this[xa]=++ya)]=this);this.N=this.N;this.C=this.C}var Td=0,Ud={};Sd.prototype.N=!1;Sd.prototype.o=function(){if(!this.N&&(this.N=!0,this.s(),0!=Td)){var a=this[xa]||(this[xa]=++ya);if(0!=Td&&this.C&&0<this.C.length)throw Error(this+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Ud[a]}};function Vd(a,b){a.N?
	na(void 0)?b.call(void 0):b():(a.C||(a.C=[]),a.C.push(na(void 0)?t(b,void 0):b))}Sd.prototype.s=function(){if(this.C)for(;this.C.length;)this.C.shift()()};function Wd(a){a&&"function"==typeof a.o&&a.o()}var Xd=Object.freeze||function(a){return a};var Yd=!z||9<=Number(tc),Zd=z&&!sc("9"),$d=function(){if(!p.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});try{p.addEventListener("test",qa,b),p.removeEventListener("test",qa,b)}catch(c){}return a}();
	function ae(a,b){this.type=a;this.f=this.target=b;this.h=!1;this.sb=!0}ae.prototype.stopPropagation=function(){this.h=!0};ae.prototype.preventDefault=function(){this.sb=!1};function be(a,b){ae.call(this,a?a.type:"");this.relatedTarget=this.f=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.j=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches&&
	a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.f=b;if(b=a.relatedTarget){if(jc){a:{try{dc(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==
	a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.j=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=r(a.pointerType)?a.pointerType:ce[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}w(be,ae);var ce=Xd({2:"touch",3:"pen",4:"mouse"});be.prototype.stopPropagation=
	function(){be.K.stopPropagation.call(this);this.a.stopPropagation?this.a.stopPropagation():this.a.cancelBubble=!0};be.prototype.preventDefault=function(){be.K.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Zd)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};var de="closure_listenable_"+(1E6*Math.random()|0),ee=0;function fe(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.La=e;this.key=
	++ee;this.sa=this.Ha=!1}function ge(a){a.sa=!0;a.listener=null;a.proxy=null;a.src=null;a.La=null}function he(a){this.src=a;this.a={};this.f=0}he.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.f++);var g=ie(a,b,d,e);-1<g?(b=a[g],c||(b.Ha=!1)):(b=new fe(b,this.src,f,!!d,e),b.Ha=c,a.push(b));return b};function je(a,b){var c=b.type;c in a.a&&Ra(a.a[c],b)&&(ge(b),0==a.a[c].length&&(delete a.a[c],a.f--))}function ie(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];
	if(!f.sa&&f.listener==b&&f.capture==!!c&&f.La==d)return e}return-1}var ke="closure_lm_"+(1E6*Math.random()|0),le={},me=0;function ne(a,b,c,d,e){if(d&&d.once)return oe(a,b,c,d,e);if(ta(b)){for(var f=0;f<b.length;f++)ne(a,b[f],c,d,e);return null}c=pe(c);return a&&a[de]?a.H.add(String(b),c,!1,wa(d)?!!d.capture:!!d,e):qe(a,b,c,!1,d,e)}function qe(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=wa(e)?!!e.capture:!!e,h=re(a);h||(a[ke]=h=new he(a));c=h.add(b,c,d,g,f);if(c.proxy)return c;d=se();
	c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)$d||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(te(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");me++;return c}function se(){var a=ue,b=Yd?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function oe(a,b,c,d,e){if(ta(b)){for(var f=0;f<
	b.length;f++)oe(a,b[f],c,d,e);return null}c=pe(c);return a&&a[de]?a.H.add(String(b),c,!0,wa(d)?!!d.capture:!!d,e):qe(a,b,c,!0,d,e)}function ve(a,b,c,d,e){if(ta(b))for(var f=0;f<b.length;f++)ve(a,b[f],c,d,e);else(d=wa(d)?!!d.capture:!!d,c=pe(c),a&&a[de])?(a=a.H,b=String(b).toString(),b in a.a&&(f=a.a[b],c=ie(f,c,d,e),-1<c&&(ge(f[c]),Sa(f,c),0==f.length&&(delete a.a[b],a.f--)))):a&&(a=re(a))&&(b=a.a[b.toString()],a=-1,b&&(a=ie(b,c,d,e)),(c=-1<a?b[a]:null)&&we(c))}function we(a){if("number"!=typeof a&&
	a&&!a.sa){var b=a.src;if(b&&b[de])je(b.H,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(te(c),d):b.addListener&&b.removeListener&&b.removeListener(d);me--;(c=re(b))?(je(c,a),0==c.f&&(c.src=null,b[ke]=null)):ge(a)}}}function te(a){return a in le?le[a]:le[a]="on"+a}function xe(a,b,c,d){var e=!0;if(a=re(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.sa&&(f=ye(f,d),e=e&&!1!==f)}return e}
	function ye(a,b){var c=a.listener,d=a.La||a.src;a.Ha&&we(a);return c.call(d,b)}function ue(a,b){if(a.sa)return!0;if(!Yd){if(!b)a:{b=["window","event"];for(var c=p,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new be(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.f;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;!b.h&&0<=e;e--){b.f=d[e];var f=
	xe(d[e],a,!0,b);c=c&&f}for(e=0;!b.h&&e<d.length;e++)b.f=d[e],f=xe(d[e],a,!1,b),c=c&&f}return c}return ye(a,new be(b,this))}function re(a){a=a[ke];return a instanceof he?a:null}var ze="__closure_events_fn_"+(1E9*Math.random()>>>0);function pe(a){if(va(a))return a;a[ze]||(a[ze]=function(b){return a.handleEvent(b)});return a[ze]}function F(){Sd.call(this);this.H=new he(this);this.yb=this;this.Fa=null}w(F,Sd);F.prototype[de]=!0;F.prototype.$a=function(a){this.Fa=a};F.prototype.removeEventListener=function(a,
	b,c,d){ve(this,a,b,c,d)};function Ae(a,b){var c,d=a.Fa;if(d)for(c=[];d;d=d.Fa)c.push(d);a=a.yb;d=b.type||b;if(r(b))b=new ae(b,a);else if(b instanceof ae)b.target=b.target||a;else{var e=b;b=new ae(d,a);lb(b,e)}e=!0;if(c)for(var f=c.length-1;!b.h&&0<=f;f--){var g=b.f=c[f];e=Be(g,d,!0,b)&&e}b.h||(g=b.f=a,e=Be(g,d,!0,b)&&e,b.h||(e=Be(g,d,!1,b)&&e));if(c)for(f=0;!b.h&&f<c.length;f++)g=b.f=c[f],e=Be(g,d,!1,b)&&e;return e}F.prototype.s=function(){F.K.s.call(this);if(this.H){var a=this.H,b=0,c;for(c in a.a){for(var d=
	a.a[c],e=0;e<d.length;e++)++b,ge(d[e]);delete a.a[c];a.f--}}this.Fa=null};function Be(a,b,c,d){b=a.H.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.sa&&g.capture==c){var h=g.listener,k=g.La||g.src;g.Ha&&je(a.H,g);e=!1!==h.call(k,d)&&e}}return e&&0!=d.sb}var Ce={},De=0;function Ee(a,b){if(!a)throw Error("Event target element must be provided!");a=Fe(a);if(Ce[a]&&Ce[a].length)for(var c=0;c<Ce[a].length;c++)Ae(Ce[a][c],b)}function Ge(a){var b=Fe(a.P());
	Ce[b]&&Ce[b].length&&(Ta(Ce[b],function(c){return c==a}),Ce[b].length||delete Ce[b])}function Fe(a){"undefined"===typeof a.a&&(a.a=De,De++);return a.a}function He(a){if(!a)throw Error("Event target element must be provided!");F.call(this);this.a=a}n(He,F);He.prototype.P=function(){return this.a};He.prototype.register=function(){var a=Fe(this.P());Ce[a]?Qa(Ce[a],this)||Ce[a].push(this):Ce[a]=[this]};function Ie(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}}function Je(a,b){this.h=
	a;this.j=b;this.f=0;this.a=null}Je.prototype.get=function(){if(0<this.f){this.f--;var a=this.a;this.a=a.next;a.next=null}else a=this.h();return a};function Ke(a,b){a.j(b);100>a.f&&(a.f++,b.next=a.a,a.a=b)}function Le(){this.f=this.a=null}var Ne=new Je(function(){return new Me},function(a){a.reset()});Le.prototype.add=function(a,b){var c=Ne.get();c.set(a,b);this.f?this.f.next=c:this.a=c;this.f=c};function Oe(){var a=Pe,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.f=null),b.next=null);return b}function Me(){this.next=
	this.f=this.a=null}Me.prototype.set=function(a,b){this.a=a;this.f=b;this.next=null};Me.prototype.reset=function(){this.next=this.f=this.a=null};function Qe(a){p.setTimeout(function(){throw a;},0)}var Re;function Se(){var a=p.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!y("Presto")&&(a=function(){var e=document.createElement("IFRAME");e.style.display="none";e.src="";document.documentElement.appendChild(e);var f=e.contentWindow;e=
	f.document;e.open();e.write("");e.close();var g="callImmediate"+Math.random(),h="file:"==f.location.protocol?"*":f.location.protocol+"//"+f.location.host;e=t(function(k){if(("*"==h||k.origin==h)&&k.data==g)this.port1.onmessage()},this);f.addEventListener("message",e,!1);this.port1={};this.port2={postMessage:function(){f.postMessage(g,h)}}});if("undefined"!==typeof a&&!y("Trident")&&!y("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(na(c.next)){c=c.next;var e=c.hb;c.hb=null;e()}};return function(e){d.next=
	{hb:e};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(e){var f=document.createElement("SCRIPT");f.onreadystatechange=function(){f.onreadystatechange=null;f.parentNode.removeChild(f);f=null;e();e=null};document.documentElement.appendChild(f)}:function(e){p.setTimeout(e,0)}}function Te(a,b){Ue||Ve();We||(Ue(),We=!0);Pe.add(a,b)}var Ue;function Ve(){if(p.Promise&&p.Promise.resolve){var a=p.Promise.resolve(void 0);
	Ue=function(){a.then(Xe)}}else Ue=function(){var b=Xe;!va(p.setImmediate)||p.Window&&p.Window.prototype&&!y("Edge")&&p.Window.prototype.setImmediate==p.setImmediate?(Re||(Re=Se()),Re(b)):p.setImmediate(b)}}var We=!1,Pe=new Le;function Xe(){for(var a;a=Oe();){try{a.a.call(a.f)}catch(b){Qe(b)}Ke(Ne,a)}We=!1}function G(a){this.a=Ye;this.w=void 0;this.j=this.f=this.h=null;this.m=this.i=!1;if(a!=qa)try{var b=this;a.call(void 0,function(c){Ze(b,$e,c)},function(c){if(!(c instanceof af))try{if(c instanceof
	Error)throw c;throw Error("Promise rejected.");}catch(d){}Ze(b,bf,c)})}catch(c){Ze(this,bf,c)}}var Ye=0,$e=2,bf=3;function cf(){this.next=this.context=this.f=this.j=this.a=null;this.h=!1}cf.prototype.reset=function(){this.context=this.f=this.j=this.a=null;this.h=!1};var df=new Je(function(){return new cf},function(a){a.reset()});function ef(a,b,c){var d=df.get();d.j=a;d.f=b;d.context=c;return d}function H(a){if(a instanceof G)return a;var b=new G(qa);Ze(b,$e,a);return b}function ff(a){return new G(function(b,
	c){c(a)})}G.prototype.then=function(a,b,c){return gf(this,va(a)?a:null,va(b)?b:null,c)};G.prototype.$goog_Thenable=!0;l=G.prototype;l.ec=function(a,b){a=ef(a,a,b);a.h=!0;hf(this,a);return this};l.ta=function(a,b){return gf(this,null,a,b)};l.cancel=function(a){this.a==Ye&&Te(function(){var b=new af(a);jf(this,b)},this)};function jf(a,b){if(a.a==Ye)if(a.h){var c=a.h;if(c.f){for(var d=0,e=null,f=null,g=c.f;g&&(g.h||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==Ye&&1==d?jf(c,b):(f?(d=f,d.next==
	c.j&&(c.j=d),d.next=d.next.next):kf(c),lf(c,e,bf,b)))}a.h=null}else Ze(a,bf,b)}function hf(a,b){a.f||a.a!=$e&&a.a!=bf||mf(a);a.j?a.j.next=b:a.f=b;a.j=b}function gf(a,b,c,d){var e=ef(null,null,null);e.a=new G(function(f,g){e.j=b?function(h){try{var k=b.call(d,h);f(k)}catch(m){g(m)}}:f;e.f=c?function(h){try{var k=c.call(d,h);!na(k)&&h instanceof af?g(h):f(k)}catch(m){g(m)}}:g});e.a.h=a;hf(a,e);return e.a}l.gc=function(a){this.a=Ye;Ze(this,$e,a)};l.hc=function(a){this.a=Ye;Ze(this,bf,a)};function Ze(a,
	b,c){if(a.a==Ye){a===c&&(b=bf,c=new TypeError("Promise cannot resolve to itself"));a.a=1;a:{var d=c,e=a.gc,f=a.hc;if(d instanceof G){hf(d,ef(e||qa,f||null,a));var g=!0}else if(Ie(d))d.then(e,f,a),g=!0;else{if(wa(d))try{var h=d.then;if(va(h)){nf(d,h,e,f,a);g=!0;break a}}catch(k){f.call(a,k);g=!0;break a}g=!1}}g||(a.w=c,a.a=b,a.h=null,mf(a),b!=bf||c instanceof af||of(a,c))}}function nf(a,b,c,d,e){function f(k){h||(h=!0,d.call(e,k))}function g(k){h||(h=!0,c.call(e,k))}var h=!1;try{b.call(a,g,f)}catch(k){f(k)}}
	function mf(a){a.i||(a.i=!0,Te(a.Gb,a))}function kf(a){var b=null;a.f&&(b=a.f,a.f=b.next,b.next=null);a.f||(a.j=null);return b}l.Gb=function(){for(var a;a=kf(this);)lf(this,a,this.a,this.w);this.i=!1};function lf(a,b,c,d){if(c==bf&&b.f&&!b.h)for(;a&&a.m;a=a.h)a.m=!1;if(b.a)b.a.h=null,pf(b,c,d);else try{b.h?b.j.call(b.context):pf(b,c,d)}catch(e){qf.call(null,e)}Ke(df,b)}function pf(a,b,c){b==$e?a.j.call(a.context,c):a.f&&a.f.call(a.context,c)}function of(a,b){a.m=!0;Te(function(){a.m&&qf.call(null,
	b)})}var qf=Qe;function af(a){Da.call(this,a)}w(af,Da);af.prototype.name="cancel";function rf(a,b,c){b||(b={});c=c||window;var d=a instanceof Dc?a:Ic("undefined"!=typeof a.href?a.href:String(a));a=b.target||a.target;var e=[];for(f in b)switch(f){case "width":case "height":case "top":case "left":e.push(f+"="+b[f]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(f+"="+(b[f]?1:0))}var f=e.join(",");(y("iPhone")&&!y("iPod")&&!y("iPad")||y("iPad")||y("iPod"))&&c.navigator&&c.navigator.standalone&&
	a&&"_self"!=a?(f=c.document.createElement("A"),d instanceof Dc||d instanceof Dc||(d="object"==typeof d&&d.ma?d.ka():String(d),Hc.test(d)||(d="about:invalid#zClosurez"),d=Jc(d)),f.href=Gc(d),f.setAttribute("target",a),b.noreferrer&&f.setAttribute("rel","noreferrer"),b=document.createEvent("MouseEvent"),b.initMouseEvent("click",!0,!0,c,1),f.dispatchEvent(b),c={}):b.noreferrer?(c=c.open("",a,f),b=Fc(d),c&&(ic&&-1!=b.indexOf(";")&&(b="'"+b.replace(/'/g,"%27")+"'"),c.opener=null,b=Pc('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+
	hb(b)+'">',null),c.document.write(Oc(b)),c.document.close())):(c=c.open(Fc(d),a,f))&&b.noopener&&(c.opener=null);return c}function sf(a){window.location.assign(Fc(Ic(a)))}function tf(){try{return!!(window.opener&&window.opener.location&&window.opener.location.assign&&window.opener.location.hostname===window.location.hostname&&window.opener.location.protocol===window.location.protocol)}catch(a$2){}return!1}function uf(a){rf(a,{target:window.cordova&&window.cordova.InAppBrowser?"_system":"_blank"},
	void 0)}function vf(a,b){a=wa(a)&&1==a.nodeType?a:document.querySelector(String(a));if(null==a)throw Error(b||"Cannot find element.");return a}function wf(){return window.location.href}function xf(){var a=null;return(new G(function(b){"complete"==p.document.readyState?b():(a=function(){b()},oe(window,"load",a))})).ta(function(b){ve(window,"load",a);throw b;})}function yf(){for(var a=32,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),
	a--;return b.join("")}function zf(a,b,c){c=void 0===c?{}:c;return Object.keys(a).filter(function(d){return b.includes(d)}).reduce(function(d,e){d[e]=a[e];return d},c)}function Af(a){var b=Bf;this.m=[];this.N=b;this.M=a||null;this.j=this.a=!1;this.h=void 0;this.H=this.l=this.w=!1;this.i=0;this.f=null;this.C=0}Af.prototype.cancel=function(a){if(this.a)this.h instanceof Af&&this.h.cancel();else{if(this.f){var b=this.f;delete this.f;a?b.cancel(a):(b.C--,0>=b.C&&b.cancel())}this.N?this.N.call(this.M,this):
	this.H=!0;this.a||(a=new Cf(this),Df(this),Ef(this,!1,a))}};Af.prototype.J=function(a,b){this.w=!1;Ef(this,a,b)};function Ef(a,b,c){a.a=!0;a.h=c;a.j=!b;Ff(a)}function Df(a){if(a.a){if(!a.H)throw new Gf(a);a.H=!1}}function Hf(a,b,c){a.m.push([b,c,void 0]);a.a&&Ff(a)}Af.prototype.then=function(a,b,c){var d,e,f=new G(function(g,h){d=g;e=h});Hf(this,d,function(g){g instanceof Cf?f.cancel():e(g)});return f.then(a,b,c)};Af.prototype.$goog_Thenable=!0;function If(a){return Na(a.m,function(b){return va(b[1])})}
	function Ff(a){if(a.i&&a.a&&If(a)){var b=a.i,c=Jf[b];c&&(p.clearTimeout(c.a),delete Jf[b]);a.i=0}a.f&&(a.f.C--,delete a.f);b=a.h;for(var d=c=!1;a.m.length&&!a.w;){var e=a.m.shift(),f=e[0],g=e[1];e=e[2];if(f=a.j?g:f)try{var h=f.call(e||a.M,b);na(h)&&(a.j=a.j&&(h==b||h instanceof Error),a.h=b=h);if(Ie(b)||"function"===typeof p.Promise&&b instanceof p.Promise)d=!0,a.w=!0}catch(k){b=k,a.j=!0,If(a)||(c=!0)}}a.h=b;d&&(h=t(a.J,a,!0),d=t(a.J,a,!1),b instanceof Af?(Hf(b,h,d),b.l=!0):b.then(h,d));c&&(b=new Kf(b),
	Jf[b.a]=b,a.i=b.a)}function Gf(){Da.call(this)}w(Gf,Da);Gf.prototype.message="Deferred has already fired";Gf.prototype.name="AlreadyCalledError";function Cf(){Da.call(this)}w(Cf,Da);Cf.prototype.message="Deferred was canceled";Cf.prototype.name="CanceledError";function Kf(a){this.a=p.setTimeout(t(this.h,this),0);this.f=a}Kf.prototype.h=function(){delete Jf[this.a];throw this.f;};var Jf={};function Lf(a){var b={},c=b.document||document,d=Bc(a).toString(),e=document.createElement("SCRIPT"),f={tb:e,
	ub:void 0},g=new Af(f),h=null,k=null!=b.timeout?b.timeout:5E3;0<k&&(h=window.setTimeout(function(){Mf(e,!0);var m=new Nf(Of,"Timeout reached for loading script "+d);Df(g);Ef(g,!1,m)},k),f.ub=h);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Mf(e,b.wc||!1,h),Df(g),Ef(g,!0,null))};e.onerror=function(){Mf(e,!0,h);var m=new Nf(Pf,"Error while loading script "+d);Df(g);Ef(g,!1,m)};f=b.attributes||{};lb(f,{type:"text/javascript",charset:"UTF-8"});
	ad(e,f);Sc(e,a);Qf(c).appendChild(e);return g}function Qf(a){var b=(a||document).getElementsByTagName("HEAD");return b&&0!=b.length?b[0]:a.documentElement}function Bf(){if(this&&this.tb){var a=this.tb;a&&"SCRIPT"==a.tagName&&Mf(a,!0,this.ub)}}function Mf(a,b,c){null!=c&&p.clearTimeout(c);a.onload=qa;a.onerror=qa;a.onreadystatechange=qa;b&&window.setTimeout(function(){dd(a)},0)}var Pf=0,Of=1;function Nf(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);Da.call(this,c);this.code=a}w(Nf,Da);function Rf(a){this.a=
	a||p.googleyolo;this.f=null;this.h=!1}Rf.prototype.cancel=function(){this.a&&this.h&&(this.f=this.a.cancelLastOperation().catch(function(){}))};function Sf(a,b,c){if(a.a&&b){var d=function(){a.h=!0;var e=Promise.resolve(null);c||(e=a.a.retrieve(b).catch(function(f){if(f.type===Tf||f.type===Uf)throw f;return null}));return e.then(function(f){return f?f:a.a.hint(b)}).catch(function(f){if(f.type===Tf)a.f=Promise.resolve();else if(f.type===Uf)return a.cancel(),Sf(a,b,c);return null})};return a.f?a.f.then(d):
	d()}if(b)return d=Vf.Ya().load().then(function(){a.a=p.googleyolo;return Sf(a,b,c)}).ta(function(){return null}),Promise.resolve(d);if("undefined"!==typeof Promise)return Promise.resolve(null);throw Error("One-Tap sign in not supported in the current browser!");}ra(Rf);var Wf=new vc(wc,"https://smartlock.google.com/client"),Uf="illegalConcurrentRequest",Tf="userCanceled";function Vf(){this.a=null}Vf.prototype.load=function(){var a=this;if(this.a)return this.a;var b=Cc(yc(Wf));return p.googleyolo?
	H():this.a=xf().then(function(){if(!p.googleyolo)return new G(function(c,d){var e=setTimeout(function(){a.a=null;d(Error("Network error!"))},1E4);p.onGoogleYoloLoad=function(){clearTimeout(e);c()};H(Lf(b)).ta(function(f){clearTimeout(e);a.a=null;d(f)})})})};ra(Vf);function Xf(a,b){this.a=a;this.f=b||function(c){throw c;}}Xf.prototype.confirm=function(a){return H(this.a.confirm(a)).ta(this.f)};function Yf(a,b,c){this.reset(a,b,c,void 0,void 0)}Yf.prototype.a=null;var Zf=0;Yf.prototype.reset=function(a,
	b,c,d,e){"number"==typeof e||Zf++;this.h=d||Ca();this.j=a;this.m=b;this.f=c;delete this.a};function $f(a){this.m=a;this.a=this.h=this.j=this.f=null}function ag(a,b){this.name=a;this.value=b}ag.prototype.toString=function(){return this.name};var bg=new ag("SEVERE",1E3),cg=new ag("WARNING",900),dg=new ag("CONFIG",700);function eg(a){if(a.j)return a.j;if(a.f)return eg(a.f);Ha("Root logger has no level set.");return null}$f.prototype.log=function(a,b,c){if(a.value>=eg(this).value)for(va(b)&&(b=b()),a=
	new Yf(a,String(b),this.m),c&&(a.a=c),c=this;c;){var d=c,e=a;if(d.a)for(var f=0;b=d.a[f];f++)b(e);c=c.f}};var fg={},gg=null;function hg(){gg||(gg=new $f(""),fg[""]=gg,gg.j=dg)}function ig(a){hg();var b;if(!(b=fg[a])){b=new $f(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=ig(a.substr(0,c));c.h||(c.h={});c.h[d]=b;b.f=c;fg[a]=b}return b}function jg(){this.a=Ca()}var kg=null;jg.prototype.set=function(a){this.a=a};jg.prototype.reset=function(){this.set(Ca())};jg.prototype.get=function(){return this.a};
	function lg(a){this.j=a||"";kg||(kg=new jg);this.m=kg}lg.prototype.a=!0;lg.prototype.f=!0;lg.prototype.h=!1;function mg(a){return 10>a?"0"+a:String(a)}function ng(a,b){a=(a.h-b)/1E3;b=a.toFixed(3);var c=0;if(1>a)c=2;else for(;100>a;)c++,a*=10;for(;0<c--;)b=" "+b;return b}function og(a){lg.call(this,a)}w(og,lg);function pg(a,b){var c=[];c.push(a.j," ");if(a.f){var d=new Date(b.h);c.push("[",mg(d.getFullYear()-2E3)+mg(d.getMonth()+1)+mg(d.getDate())+" "+mg(d.getHours())+":"+mg(d.getMinutes())+":"+mg(d.getSeconds())+
	"."+mg(Math.floor(d.getMilliseconds()/10)),"] ")}c.push("[",ng(b,a.m.get()),"s] ");c.push("[",b.f,"] ");c.push(b.m);a.h&&(b=b.a)&&c.push("\n",b instanceof Error?b.message:b.toString());a.a&&c.push("\n");return c.join("")}function qg(){this.m=t(this.h,this);this.a=new og;this.a.f=!1;this.a.h=!1;this.f=this.a.a=!1;this.j={}}qg.prototype.h=function(a){function b(f){if(f){if(f.value>=bg.value)return"error";if(f.value>=cg.value)return"warn";if(f.value>=dg.value)return"log"}return"debug"}if(!this.j[a.f]){var c=
	pg(this.a,a),d=rg;if(d){var e=b(a.j);sg(d,e,c,a.a)}}};var rg=p.console;function sg(a,b,c,d){if(a[b])a[b](c,d||"");else a.log(c,d||"")}function tg(a,b){var c=ug;c&&c.log(bg,a,b)}var ug;ug=ig("firebaseui");var vg=new qg;if(1!=vg.f){var wg;hg();wg=gg;var xg=vg.m;wg.a||(wg.a=[]);wg.a.push(xg);vg.f=!0}function yg(a){var b=ug;b&&b.log(cg,a,void 0)}function zg(a,b,c,d){this.a=a;this.h=b||null;this.j=c||null;this.f=d||null}zg.prototype.aa=function(){return{email:this.a,displayName:this.h,photoUrl:this.j,
	providerId:this.f}};function Ag(a){return a.email?new zg(a.email,a.displayName,a.photoUrl,a.providerId):null}function Bg(){this.a=("undefined"==typeof document?null:document)||{cookie:""}}l=Bg.prototype;l.set=function(a,b,c,d,e,f){if(/[;=\s]/.test(a))throw Error('Invalid cookie name "'+a+'"');if(/[;\r\n]/.test(b))throw Error('Invalid cookie value "'+b+'"');na(c)||(c=-1);e=e?";domain="+e:"";d=d?";path="+d:"";f=f?";secure":"";c=0>c?"":0==c?";expires="+(new Date(1970,1,1)).toUTCString():";expires="+
	(new Date(Ca()+1E3*c)).toUTCString();this.a.cookie=a+"="+b+e+d+c+f};l.get=function(a,b){for(var c=a+"=",d=(this.a.cookie||"").split(";"),e=0,f;e<d.length;e++){f=Za(d[e]);if(0==f.lastIndexOf(c,0))return f.substr(c.length);if(f==a)return""}return b};l.ja=function(){return Cg(this).keys};l.la=function(){return Cg(this).values};l.clear=function(){for(var a=Cg(this).keys,b=a.length-1;0<=b;b--){var c=a[b];this.get(c);this.set(c,"",0,void 0,void 0)}};function Cg(a){a=(a.a.cookie||"").split(";");for(var b=
	[],c=[],d,e,f=0;f<a.length;f++)e=Za(a[f]),d=e.indexOf("="),-1==d?(b.push(""),c.push(e)):(b.push(e.substring(0,d)),c.push(e.substring(d+1)));return{keys:b,values:c}}var Dg=new Bg;function Eg(){}function Fg(a,b,c,d){this.h="undefined"!==typeof a&&null!==a?a:-1;this.f=b||null;this.a=c||null;this.j=!!d}n(Fg,Eg);Fg.prototype.set=function(a,b){Dg.set(a,b,this.h,this.f,this.a,this.j)};Fg.prototype.get=function(a){return Dg.get(a)||null};Fg.prototype.ra=function(a){var b=this.f,c=this.a;Dg.get(a);Dg.set(a,
	"",0,b,c)};function Gg(a,b){this.f=a;this.a=b||null}Gg.prototype.aa=function(){return{email:this.f,credential:this.a&&this.a.toJSON()}};function Hg(a){if(a&&a.email){var b=a.credential&&firebase.auth.AuthCredential.fromJSON(a.credential);return new Gg(a.email,b)}return null}function Ig(a){this.a=a||null}Ig.prototype.aa=function(){return{tenantId:this.a}};function Jg(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);255<e&&(b[c++]=e&255,e>>=8);b[c++]=e}return b}function Lg(a){return Ma(a,
	function(b){b=b.toString(16);return 1<b.length?b:"0"+b}).join("")}function Mg(a){this.i=a;this.f=this.i.length/4;this.j=this.f+6;this.h=[[],[],[],[]];this.m=[[],[],[],[]];this.a=Array(Ng*(this.j+1));for(a=0;a<this.f;a++)this.a[a]=[this.i[4*a],this.i[4*a+1],this.i[4*a+2],this.i[4*a+3]];var b=Array(4);for(a=this.f;a<Ng*(this.j+1);a++){b[0]=this.a[a-1][0];b[1]=this.a[a-1][1];b[2]=this.a[a-1][2];b[3]=this.a[a-1][3];if(0==a%this.f){var c=b,d=c[0];c[0]=c[1];c[1]=c[2];c[2]=c[3];c[3]=d;Og(b);b[0]^=Pg[a/this.f][0];
	b[1]^=Pg[a/this.f][1];b[2]^=Pg[a/this.f][2];b[3]^=Pg[a/this.f][3]}else 6<this.f&&4==a%this.f&&Og(b);this.a[a]=Array(4);this.a[a][0]=this.a[a-this.f][0]^b[0];this.a[a][1]=this.a[a-this.f][1]^b[1];this.a[a][2]=this.a[a-this.f][2]^b[2];this.a[a][3]=this.a[a-this.f][3]^b[3]}}Mg.prototype.w=16;var Ng=Mg.prototype.w/4;function Qg(a,b){for(var c,d=0;d<Ng;d++)for(var e=0;4>e;e++)c=4*e+d,c=b[c],a.h[d][e]=c}function Rg(a){for(var b=[],c=0;c<Ng;c++)for(var d=0;4>d;d++)b[4*d+c]=a.h[c][d];return b}function Sg(a,
	b){for(var c=0;4>c;c++)for(var d=0;4>d;d++)a.h[c][d]^=a.a[4*b+d][c]}function Tg(a,b){for(var c=0;4>c;c++)for(var d=0;4>d;d++)a.h[c][d]=b[a.h[c][d]]}function Ug(a){for(var b=1;4>b;b++)for(var c=0;4>c;c++)a.m[b][c]=a.h[b][c];for(b=1;4>b;b++)for(c=0;4>c;c++)a.h[b][c]=a.m[b][(c+b)%Ng]}function Vg(a){for(var b=1;4>b;b++)for(var c=0;4>c;c++)a.m[b][(c+b)%Ng]=a.h[b][c];for(b=1;4>b;b++)for(c=0;4>c;c++)a.h[b][c]=a.m[b][c]}function Og(a){a[0]=Wg[a[0]];a[1]=Wg[a[1]];a[2]=Wg[a[2]];a[3]=Wg[a[3]]}var Wg=[99,124,
	119,123,242,107,111,197,48,1,103,43,254,215,171,118,202,130,201,125,250,89,71,240,173,212,162,175,156,164,114,192,183,253,147,38,54,63,247,204,52,165,229,241,113,216,49,21,4,199,35,195,24,150,5,154,7,18,128,226,235,39,178,117,9,131,44,26,27,110,90,160,82,59,214,179,41,227,47,132,83,209,0,237,32,252,177,91,106,203,190,57,74,76,88,207,208,239,170,251,67,77,51,133,69,249,2,127,80,60,159,168,81,163,64,143,146,157,56,245,188,182,218,33,16,255,243,210,205,12,19,236,95,151,68,23,196,167,126,61,100,93,25,
	115,96,129,79,220,34,42,144,136,70,238,184,20,222,94,11,219,224,50,58,10,73,6,36,92,194,211,172,98,145,149,228,121,231,200,55,109,141,213,78,169,108,86,244,234,101,122,174,8,186,120,37,46,28,166,180,198,232,221,116,31,75,189,139,138,112,62,181,102,72,3,246,14,97,53,87,185,134,193,29,158,225,248,152,17,105,217,142,148,155,30,135,233,206,85,40,223,140,161,137,13,191,230,66,104,65,153,45,15,176,84,187,22],Xg=[82,9,106,213,48,54,165,56,191,64,163,158,129,243,215,251,124,227,57,130,155,47,255,135,52,142,
	67,68,196,222,233,203,84,123,148,50,166,194,35,61,238,76,149,11,66,250,195,78,8,46,161,102,40,217,36,178,118,91,162,73,109,139,209,37,114,248,246,100,134,104,152,22,212,164,92,204,93,101,182,146,108,112,72,80,253,237,185,218,94,21,70,87,167,141,157,132,144,216,171,0,140,188,211,10,247,228,88,5,184,179,69,6,208,44,30,143,202,63,15,2,193,175,189,3,1,19,138,107,58,145,17,65,79,103,220,234,151,242,207,206,240,180,230,115,150,172,116,34,231,173,53,133,226,249,55,232,28,117,223,110,71,241,26,113,29,41,
	197,137,111,183,98,14,170,24,190,27,252,86,62,75,198,210,121,32,154,219,192,254,120,205,90,244,31,221,168,51,136,7,199,49,177,18,16,89,39,128,236,95,96,81,127,169,25,181,74,13,45,229,122,159,147,201,156,239,160,224,59,77,174,42,245,176,200,235,187,60,131,83,153,97,23,43,4,126,186,119,214,38,225,105,20,99,85,33,12,125],Pg=[[0,0,0,0],[1,0,0,0],[2,0,0,0],[4,0,0,0],[8,0,0,0],[16,0,0,0],[32,0,0,0],[64,0,0,0],[128,0,0,0],[27,0,0,0],[54,0,0,0]],Yg=[0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,32,34,36,38,
	40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,152,154,156,158,160,162,164,166,168,170,172,174,176,178,180,182,184,186,188,190,192,194,196,198,200,202,204,206,208,210,212,214,216,218,220,222,224,226,228,230,232,234,236,238,240,242,244,246,248,250,252,254,27,25,31,29,19,17,23,21,11,9,15,13,3,1,7,5,59,57,63,61,51,49,55,53,43,41,47,45,35,33,39,37,91,89,95,
	93,83,81,87,85,75,73,79,77,67,65,71,69,123,121,127,125,115,113,119,117,107,105,111,109,99,97,103,101,155,153,159,157,147,145,151,149,139,137,143,141,131,129,135,133,187,185,191,189,179,177,183,181,171,169,175,173,163,161,167,165,219,217,223,221,211,209,215,213,203,201,207,205,195,193,199,197,251,249,255,253,243,241,247,245,235,233,239,237,227,225,231,229],Zg=[0,3,6,5,12,15,10,9,24,27,30,29,20,23,18,17,48,51,54,53,60,63,58,57,40,43,46,45,36,39,34,33,96,99,102,101,108,111,106,105,120,123,126,125,116,
	119,114,113,80,83,86,85,92,95,90,89,72,75,78,77,68,71,66,65,192,195,198,197,204,207,202,201,216,219,222,221,212,215,210,209,240,243,246,245,252,255,250,249,232,235,238,237,228,231,226,225,160,163,166,165,172,175,170,169,184,187,190,189,180,183,178,177,144,147,150,149,156,159,154,153,136,139,142,141,132,135,130,129,155,152,157,158,151,148,145,146,131,128,133,134,143,140,137,138,171,168,173,174,167,164,161,162,179,176,181,182,191,188,185,186,251,248,253,254,247,244,241,242,227,224,229,230,239,236,233,
	234,203,200,205,206,199,196,193,194,211,208,213,214,223,220,217,218,91,88,93,94,87,84,81,82,67,64,69,70,79,76,73,74,107,104,109,110,103,100,97,98,115,112,117,118,127,124,121,122,59,56,61,62,55,52,49,50,35,32,37,38,47,44,41,42,11,8,13,14,7,4,1,2,19,16,21,22,31,28,25,26],$g=[0,9,18,27,36,45,54,63,72,65,90,83,108,101,126,119,144,153,130,139,180,189,166,175,216,209,202,195,252,245,238,231,59,50,41,32,31,22,13,4,115,122,97,104,87,94,69,76,171,162,185,176,143,134,157,148,227,234,241,248,199,206,213,220,
	118,127,100,109,82,91,64,73,62,55,44,37,26,19,8,1,230,239,244,253,194,203,208,217,174,167,188,181,138,131,152,145,77,68,95,86,105,96,123,114,5,12,23,30,33,40,51,58,221,212,207,198,249,240,235,226,149,156,135,142,177,184,163,170,236,229,254,247,200,193,218,211,164,173,182,191,128,137,146,155,124,117,110,103,88,81,74,67,52,61,38,47,16,25,2,11,215,222,197,204,243,250,225,232,159,150,141,132,187,178,169,160,71,78,85,92,99,106,113,120,15,6,29,20,43,34,57,48,154,147,136,129,190,183,172,165,210,219,192,
	201,246,255,228,237,10,3,24,17,46,39,60,53,66,75,80,89,102,111,116,125,161,168,179,186,133,140,151,158,233,224,251,242,205,196,223,214,49,56,35,42,21,28,7,14,121,112,107,98,93,84,79,70],ah=[0,11,22,29,44,39,58,49,88,83,78,69,116,127,98,105,176,187,166,173,156,151,138,129,232,227,254,245,196,207,210,217,123,112,109,102,87,92,65,74,35,40,53,62,15,4,25,18,203,192,221,214,231,236,241,250,147,152,133,142,191,180,169,162,246,253,224,235,218,209,204,199,174,165,184,179,130,137,148,159,70,77,80,91,106,97,
	124,119,30,21,8,3,50,57,36,47,141,134,155,144,161,170,183,188,213,222,195,200,249,242,239,228,61,54,43,32,17,26,7,12,101,110,115,120,73,66,95,84,247,252,225,234,219,208,205,198,175,164,185,178,131,136,149,158,71,76,81,90,107,96,125,118,31,20,9,2,51,56,37,46,140,135,154,145,160,171,182,189,212,223,194,201,248,243,238,229,60,55,42,33,16,27,6,13,100,111,114,121,72,67,94,85,1,10,23,28,45,38,59,48,89,82,79,68,117,126,99,104,177,186,167,172,157,150,139,128,233,226,255,244,197,206,211,216,122,113,108,103,
	86,93,64,75,34,41,52,63,14,5,24,19,202,193,220,215,230,237,240,251,146,153,132,143,190,181,168,163],bh=[0,13,26,23,52,57,46,35,104,101,114,127,92,81,70,75,208,221,202,199,228,233,254,243,184,181,162,175,140,129,150,155,187,182,161,172,143,130,149,152,211,222,201,196,231,234,253,240,107,102,113,124,95,82,69,72,3,14,25,20,55,58,45,32,109,96,119,122,89,84,67,78,5,8,31,18,49,60,43,38,189,176,167,170,137,132,147,158,213,216,207,194,225,236,251,246,214,219,204,193,226,239,248,245,190,179,164,169,138,135,
	144,157,6,11,28,17,50,63,40,37,110,99,116,121,90,87,64,77,218,215,192,205,238,227,244,249,178,191,168,165,134,139,156,145,10,7,16,29,62,51,36,41,98,111,120,117,86,91,76,65,97,108,123,118,85,88,79,66,9,4,19,30,61,48,39,42,177,188,171,166,133,136,159,146,217,212,195,206,237,224,247,250,183,186,173,160,131,142,153,148,223,210,197,200,235,230,241,252,103,106,125,112,83,94,73,68,15,2,21,24,59,54,33,44,12,1,22,27,56,53,34,47,100,105,126,115,80,93,74,71,220,209,198,203,232,229,242,255,180,185,174,163,128,
	141,154,151],ch=[0,14,28,18,56,54,36,42,112,126,108,98,72,70,84,90,224,238,252,242,216,214,196,202,144,158,140,130,168,166,180,186,219,213,199,201,227,237,255,241,171,165,183,185,147,157,143,129,59,53,39,41,3,13,31,17,75,69,87,89,115,125,111,97,173,163,177,191,149,155,137,135,221,211,193,207,229,235,249,247,77,67,81,95,117,123,105,103,61,51,33,47,5,11,25,23,118,120,106,100,78,64,82,92,6,8,26,20,62,48,34,44,150,152,138,132,174,160,178,188,230,232,250,244,222,208,194,204,65,79,93,83,121,119,101,107,
	49,63,45,35,9,7,21,27,161,175,189,179,153,151,133,139,209,223,205,195,233,231,245,251,154,148,134,136,162,172,190,176,234,228,246,248,210,220,206,192,122,116,102,104,66,76,94,80,10,4,22,24,50,60,46,32,236,226,240,254,212,218,200,198,156,146,128,142,164,170,184,182,12,2,16,30,52,58,40,38,124,114,96,110,68,74,88,86,55,57,43,37,15,1,19,29,71,73,91,85,127,113,99,109,215,217,203,197,239,225,243,253,167,169,187,181,159,145,131,141];function dh(a,b){a=new Mg(eh(a));b=Jg(b);for(var c=Xa(b,0,16),d="",e;c.length;){e=
	16-c.length;for(var f=0;f<e;f++)c.push(0);e=a;Qg(e,c);Sg(e,0);for(c=1;c<e.j;++c){Tg(e,Wg);Ug(e);f=e.h;for(var g=e.m[0],h=0;4>h;h++)g[0]=f[0][h],g[1]=f[1][h],g[2]=f[2][h],g[3]=f[3][h],f[0][h]=Yg[g[0]]^Zg[g[1]]^g[2]^g[3],f[1][h]=g[0]^Yg[g[1]]^Zg[g[2]]^g[3],f[2][h]=g[0]^g[1]^Yg[g[2]]^Zg[g[3]],f[3][h]=Zg[g[0]]^g[1]^g[2]^Yg[g[3]];Sg(e,c)}Tg(e,Wg);Ug(e);Sg(e,e.j);d+=Lg(Rg(e));c=Xa(b,0,16)}return d}function fh(a,b){a=new Mg(eh(a));for(var c=[],d=0;d<b.length;d+=2)c.push(parseInt(b.substring(d,d+2),16));
	var e=Xa(c,0,16);for(b="";e.length;){d=a;Qg(d,e);Sg(d,d.j);for(e=1;e<d.j;++e){Vg(d);Tg(d,Xg);Sg(d,d.j-e);for(var f=d.h,g=d.m[0],h=0;4>h;h++)g[0]=f[0][h],g[1]=f[1][h],g[2]=f[2][h],g[3]=f[3][h],f[0][h]=ch[g[0]]^ah[g[1]]^bh[g[2]]^$g[g[3]],f[1][h]=$g[g[0]]^ch[g[1]]^ah[g[2]]^bh[g[3]],f[2][h]=bh[g[0]]^$g[g[1]]^ch[g[2]]^ah[g[3]],f[3][h]=ah[g[0]]^bh[g[1]]^$g[g[2]]^ch[g[3]]}Vg(d);Tg(d,Xg);Sg(d,0);d=Rg(d);if(8192>=d.length)d=String.fromCharCode.apply(null,d);else{e="";for(f=0;f<d.length;f+=8192)e+=String.fromCharCode.apply(null,
	Ya(d,f,f+8192));d=e}b+=d;e=Xa(c,0,16)}return b.replace(/(\x00)+$/,"")}function eh(a){a=Jg(a.substring(0,32));for(var b=32-a.length,c=0;c<b;c++)a.push(0);return a}function gh(a){var b=[];hh(new ih,a,b);return b.join("")}function ih(){}function hh(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(ta(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),hh(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();
	else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),jh(d,c),c.push(":"),hh(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":jh(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var kh={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t",
	"\x0B":"\\u000b"},lh=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;function jh(a,b){b.push('"',a.replace(lh,function(c){var d=kh[c];d||(d="\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),kh[c]=d);return d}),'"')}function mh(a){this.a=a}mh.prototype.set=function(a,b){na(b)?this.a.set(a,gh(b)):this.a.ra(a)};mh.prototype.get=function(a){try{var b=this.a.get(a)}catch(c){return}if(null!==b)try{return JSON.parse(b)}catch(c$3){throw"Storage: Invalid value was encountered";
	}};function nh(){}w(nh,Eg);nh.prototype.clear=function(){var a=qb(this.ha(!0)),b=this;Ja(a,function(c){b.ra(c)})};function oh(a){this.a=a}w(oh,nh);function ph(a){if(!a.a)return!1;try{return a.a.setItem("__sak","1"),a.a.removeItem("__sak"),!0}catch(b){return!1}}l=oh.prototype;l.set=function(a,b){try{this.a.setItem(a,b)}catch(c){if(0==this.a.length)throw"Storage mechanism: Storage disabled";throw"Storage mechanism: Quota exceeded";}};l.get=function(a){a=this.a.getItem(a);if(!r(a)&&null!==a)throw"Storage mechanism: Invalid value was encountered";
	return a};l.ra=function(a){this.a.removeItem(a)};l.ha=function(a){var b=0,c=this.a,d=new nb;d.next=function(){if(b>=c.length)throw mb;var e=c.key(b++);if(a)return e;e=c.getItem(e);if(!r(e))throw"Storage mechanism: Invalid value was encountered";return e};return d};l.clear=function(){this.a.clear()};l.key=function(a){return this.a.key(a)};function qh(){var a=null;try{a=window.localStorage||null}catch(b){}this.a=a}w(qh,oh);function rh(){var a=null;try{a=window.sessionStorage||null}catch(b){}this.a=
	a}w(rh,oh);function sh(a,b){this.f=a;this.a=b+"::"}w(sh,nh);sh.prototype.set=function(a,b){this.f.set(this.a+a,b)};sh.prototype.get=function(a){return this.f.get(this.a+a)};sh.prototype.ra=function(a){this.f.ra(this.a+a)};sh.prototype.ha=function(a){var b=this.f.ha(!0),c=this,d=new nb;d.next=function(){for(var e=b.next();e.substr(0,c.a.length)!=c.a;)e=b.next();return a?e.substr(c.a.length):c.f.get(e)};return d};var th,uh=new qh;th=ph(uh)?new sh(uh,"firebaseui"):null;var vh=new mh(th),wh,xh=new rh;
	wh=ph(xh)?new sh(xh,"firebaseui"):null;var yh=new mh(wh),zh={name:"pendingEmailCredential",storage:yh},Ah={name:"redirectStatus",storage:yh},Bh={name:"redirectUrl",storage:yh},Ch={name:"rememberAccount",storage:yh},Dh={name:"rememberedAccounts",storage:vh},Eh={name:"emailForSignIn",storage:new mh(new Fg(3600,"/"))},Fh={name:"pendingEncryptedCredential",storage:new mh(new Fg(3600,"/"))};function Gh(a,b){return a.storage.get(b?a.name+":"+b:a.name)}function Hh(a,b){a.storage.a.ra(b?a.name+":"+b:a.name)}
	function Ih(a,b,c){a.storage.set(c?a.name+":"+c:a.name,b)}function Jh(a){return Gh(Bh,a)||null}function Kh(a,b){Ih(Bh,a,b)}function Lh(a,b){Ih(Ch,a,b)}function Mh(a){a=Gh(Dh,a)||[];a=Ma(a,function(b){return Ag(b)});return La(a,function(b){return null!=b})}function Nh(a,b){var c=Mh(b),d=Pa(c,function(e){return e.a==a.a&&(e.f||null)==(a.f||null)});-1<d&&Sa(c,d);c.unshift(a);Ih(Dh,Ma(c,function(e){return e.aa()}),b)}function Oh(a){a=Gh(zh,a)||null;return Hg(a)}function Ph(a){Hh(zh,a)}function Qh(a,b){Ih(zh,
	a.aa(),b)}function Rh(a){return(a=Gh(Ah,a)||null)&&"undefined"!==typeof a.tenantId?new Ig(a.tenantId):null}function Sh(a,b){Ih(Ah,a.aa(),b)}function Th(a,b){b=Gh(Eh,b);var c=null;if(b)try{var d=fh(a,b),e=JSON.parse(d);c=e&&e.email||null}catch(f){}return c}function Uh(a,b){b=Gh(Fh,b);var c=null;if(b)try{var d=fh(a,b);c=JSON.parse(d)}catch(e){}return Hg(c||null)}function Vh(a,b,c){Ih(Fh,dh(a,JSON.stringify(b.aa())),c)}function Wh(){this.V={}}function I(a,b,c){if(b.toLowerCase()in a.V)throw Error("Configuration "+
	b+" has already been defined.");a.V[b.toLowerCase()]=c}function Xh(a,b,c){if(!(b.toLowerCase()in a.V))throw Error("Configuration "+b+" is not defined.");a.V[b.toLowerCase()]=c}Wh.prototype.get=function(a){if(!(a.toLowerCase()in this.V))throw Error("Configuration "+a+" is not defined.");return this.V[a.toLowerCase()]};function Yh(a,b){a=a.get(b);if(!a)throw Error("Configuration "+b+" is required.");return a}function Zh(){this.f=void 0;this.a={}}l=Zh.prototype;l.set=function(a,b){$h(this,a,b,!1)};l.add=
	function(a,b){$h(this,a,b,!0)};function $h(a,b,c,d){for(var e=0;e<b.length;e++){var f=b.charAt(e);a.a[f]||(a.a[f]=new Zh);a=a.a[f]}if(d&&void 0!==a.f)throw Error('The collection already contains the key "'+b+'"');a.f=c}l.get=function(a){a:{for(var b=this,c=0;c<a.length;c++)if(b=b.a[a.charAt(c)],!b){a=void 0;break a}a=b}return a?a.f:void 0};l.la=function(){var a=[];ai(this,a);return a};function ai(a,b){void 0!==a.f&&b.push(a.f);for(var c in a.a)ai(a.a[c],b)}l.ja=function(){var a=[];bi(this,"",a);return a};
	function bi(a,b,c){void 0!==a.f&&c.push(b);for(var d in a.a)bi(a.a[d],b+d,c)}l.clear=function(){this.a={};this.f=void 0};function ci(a){this.a=a;this.f=new Zh;for(a=0;a<this.a.length;a++){var b=this.f.get("+"+this.a[a].b);b?b.push(this.a[a]):this.f.add("+"+this.a[a].b,[this.a[a]])}}function di(a,b){a=a.f;var c={},d=0;void 0!==a.f&&(c[d]=a.f);for(;d<b.length;d++){var e=b.charAt(d);if(!(e in a.a))break;a=a.a[e];void 0!==a.f&&(c[d]=a.f)}for(var f in c)if(c.hasOwnProperty(f))return c[f];return[]}function ei(a){for(var b=
	0;b<fi.length;b++)if(fi[b].c===a)return fi[b];return null}function gi(a){a=a.toUpperCase();for(var b=[],c=0;c<fi.length;c++)fi[c].g===a&&b.push(fi[c]);return b}function hi(a){if(0<a.length&&"+"==a.charAt(0)){a=a.substring(1);for(var b=[],c=0;c<fi.length;c++)fi[c].b==a&&b.push(fi[c]);a=b}else a=gi(a);return a}function ii(a){a.sort(function(b,c){return b.name.localeCompare(c.name,"en")})}var fi=[{name:"Afghanistan",c:"93-AF-0",b:"93",g:"AF"},{name:"\u00c5land Islands",c:"358-AX-0",b:"358",g:"AX"},{name:"Albania",
	c:"355-AL-0",b:"355",g:"AL"},{name:"Algeria",c:"213-DZ-0",b:"213",g:"DZ"},{name:"American Samoa",c:"1-AS-0",b:"1",g:"AS"},{name:"Andorra",c:"376-AD-0",b:"376",g:"AD"},{name:"Angola",c:"244-AO-0",b:"244",g:"AO"},{name:"Anguilla",c:"1-AI-0",b:"1",g:"AI"},{name:"Antigua and Barbuda",c:"1-AG-0",b:"1",g:"AG"},{name:"Argentina",c:"54-AR-0",b:"54",g:"AR"},{name:"Armenia",c:"374-AM-0",b:"374",g:"AM"},{name:"Aruba",c:"297-AW-0",b:"297",g:"AW"},{name:"Ascension Island",c:"247-AC-0",b:"247",g:"AC"},{name:"Australia",
	c:"61-AU-0",b:"61",g:"AU"},{name:"Austria",c:"43-AT-0",b:"43",g:"AT"},{name:"Azerbaijan",c:"994-AZ-0",b:"994",g:"AZ"},{name:"Bahamas",c:"1-BS-0",b:"1",g:"BS"},{name:"Bahrain",c:"973-BH-0",b:"973",g:"BH"},{name:"Bangladesh",c:"880-BD-0",b:"880",g:"BD"},{name:"Barbados",c:"1-BB-0",b:"1",g:"BB"},{name:"Belarus",c:"375-BY-0",b:"375",g:"BY"},{name:"Belgium",c:"32-BE-0",b:"32",g:"BE"},{name:"Belize",c:"501-BZ-0",b:"501",g:"BZ"},{name:"Benin",c:"229-BJ-0",b:"229",g:"BJ"},{name:"Bermuda",c:"1-BM-0",b:"1",
	g:"BM"},{name:"Bhutan",c:"975-BT-0",b:"975",g:"BT"},{name:"Bolivia",c:"591-BO-0",b:"591",g:"BO"},{name:"Bosnia and Herzegovina",c:"387-BA-0",b:"387",g:"BA"},{name:"Botswana",c:"267-BW-0",b:"267",g:"BW"},{name:"Brazil",c:"55-BR-0",b:"55",g:"BR"},{name:"British Indian Ocean Territory",c:"246-IO-0",b:"246",g:"IO"},{name:"British Virgin Islands",c:"1-VG-0",b:"1",g:"VG"},{name:"Brunei",c:"673-BN-0",b:"673",g:"BN"},{name:"Bulgaria",c:"359-BG-0",b:"359",g:"BG"},{name:"Burkina Faso",c:"226-BF-0",b:"226",
	g:"BF"},{name:"Burundi",c:"257-BI-0",b:"257",g:"BI"},{name:"Cambodia",c:"855-KH-0",b:"855",g:"KH"},{name:"Cameroon",c:"237-CM-0",b:"237",g:"CM"},{name:"Canada",c:"1-CA-0",b:"1",g:"CA"},{name:"Cape Verde",c:"238-CV-0",b:"238",g:"CV"},{name:"Caribbean Netherlands",c:"599-BQ-0",b:"599",g:"BQ"},{name:"Cayman Islands",c:"1-KY-0",b:"1",g:"KY"},{name:"Central African Republic",c:"236-CF-0",b:"236",g:"CF"},{name:"Chad",c:"235-TD-0",b:"235",g:"TD"},{name:"Chile",c:"56-CL-0",b:"56",g:"CL"},{name:"China",c:"86-CN-0",
	b:"86",g:"CN"},{name:"Christmas Island",c:"61-CX-0",b:"61",g:"CX"},{name:"Cocos [Keeling] Islands",c:"61-CC-0",b:"61",g:"CC"},{name:"Colombia",c:"57-CO-0",b:"57",g:"CO"},{name:"Comoros",c:"269-KM-0",b:"269",g:"KM"},{name:"Democratic Republic Congo",c:"243-CD-0",b:"243",g:"CD"},{name:"Republic of Congo",c:"242-CG-0",b:"242",g:"CG"},{name:"Cook Islands",c:"682-CK-0",b:"682",g:"CK"},{name:"Costa Rica",c:"506-CR-0",b:"506",g:"CR"},{name:"C\u00f4te d'Ivoire",c:"225-CI-0",b:"225",g:"CI"},{name:"Croatia",
	c:"385-HR-0",b:"385",g:"HR"},{name:"Cuba",c:"53-CU-0",b:"53",g:"CU"},{name:"Cura\u00e7ao",c:"599-CW-0",b:"599",g:"CW"},{name:"Cyprus",c:"357-CY-0",b:"357",g:"CY"},{name:"Czech Republic",c:"420-CZ-0",b:"420",g:"CZ"},{name:"Denmark",c:"45-DK-0",b:"45",g:"DK"},{name:"Djibouti",c:"253-DJ-0",b:"253",g:"DJ"},{name:"Dominica",c:"1-DM-0",b:"1",g:"DM"},{name:"Dominican Republic",c:"1-DO-0",b:"1",g:"DO"},{name:"East Timor",c:"670-TL-0",b:"670",g:"TL"},{name:"Ecuador",c:"593-EC-0",b:"593",g:"EC"},{name:"Egypt",
	c:"20-EG-0",b:"20",g:"EG"},{name:"El Salvador",c:"503-SV-0",b:"503",g:"SV"},{name:"Equatorial Guinea",c:"240-GQ-0",b:"240",g:"GQ"},{name:"Eritrea",c:"291-ER-0",b:"291",g:"ER"},{name:"Estonia",c:"372-EE-0",b:"372",g:"EE"},{name:"Ethiopia",c:"251-ET-0",b:"251",g:"ET"},{name:"Falkland Islands [Islas Malvinas]",c:"500-FK-0",b:"500",g:"FK"},{name:"Faroe Islands",c:"298-FO-0",b:"298",g:"FO"},{name:"Fiji",c:"679-FJ-0",b:"679",g:"FJ"},{name:"Finland",c:"358-FI-0",b:"358",g:"FI"},{name:"France",c:"33-FR-0",
	b:"33",g:"FR"},{name:"French Guiana",c:"594-GF-0",b:"594",g:"GF"},{name:"French Polynesia",c:"689-PF-0",b:"689",g:"PF"},{name:"Gabon",c:"241-GA-0",b:"241",g:"GA"},{name:"Gambia",c:"220-GM-0",b:"220",g:"GM"},{name:"Georgia",c:"995-GE-0",b:"995",g:"GE"},{name:"Germany",c:"49-DE-0",b:"49",g:"DE"},{name:"Ghana",c:"233-GH-0",b:"233",g:"GH"},{name:"Gibraltar",c:"350-GI-0",b:"350",g:"GI"},{name:"Greece",c:"30-GR-0",b:"30",g:"GR"},{name:"Greenland",c:"299-GL-0",b:"299",g:"GL"},{name:"Grenada",c:"1-GD-0",
	b:"1",g:"GD"},{name:"Guadeloupe",c:"590-GP-0",b:"590",g:"GP"},{name:"Guam",c:"1-GU-0",b:"1",g:"GU"},{name:"Guatemala",c:"502-GT-0",b:"502",g:"GT"},{name:"Guernsey",c:"44-GG-0",b:"44",g:"GG"},{name:"Guinea Conakry",c:"224-GN-0",b:"224",g:"GN"},{name:"Guinea-Bissau",c:"245-GW-0",b:"245",g:"GW"},{name:"Guyana",c:"592-GY-0",b:"592",g:"GY"},{name:"Haiti",c:"509-HT-0",b:"509",g:"HT"},{name:"Heard Island and McDonald Islands",c:"672-HM-0",b:"672",g:"HM"},{name:"Honduras",c:"504-HN-0",b:"504",g:"HN"},{name:"Hong Kong",
	c:"852-HK-0",b:"852",g:"HK"},{name:"Hungary",c:"36-HU-0",b:"36",g:"HU"},{name:"Iceland",c:"354-IS-0",b:"354",g:"IS"},{name:"India",c:"91-IN-0",b:"91",g:"IN"},{name:"Indonesia",c:"62-ID-0",b:"62",g:"ID"},{name:"Iran",c:"98-IR-0",b:"98",g:"IR"},{name:"Iraq",c:"964-IQ-0",b:"964",g:"IQ"},{name:"Ireland",c:"353-IE-0",b:"353",g:"IE"},{name:"Isle of Man",c:"44-IM-0",b:"44",g:"IM"},{name:"Israel",c:"972-IL-0",b:"972",g:"IL"},{name:"Italy",c:"39-IT-0",b:"39",g:"IT"},{name:"Jamaica",c:"1-JM-0",b:"1",g:"JM"},
	{name:"Japan",c:"81-JP-0",b:"81",g:"JP"},{name:"Jersey",c:"44-JE-0",b:"44",g:"JE"},{name:"Jordan",c:"962-JO-0",b:"962",g:"JO"},{name:"Kazakhstan",c:"7-KZ-0",b:"7",g:"KZ"},{name:"Kenya",c:"254-KE-0",b:"254",g:"KE"},{name:"Kiribati",c:"686-KI-0",b:"686",g:"KI"},{name:"Kosovo",c:"377-XK-0",b:"377",g:"XK"},{name:"Kosovo",c:"381-XK-0",b:"381",g:"XK"},{name:"Kosovo",c:"386-XK-0",b:"386",g:"XK"},{name:"Kuwait",c:"965-KW-0",b:"965",g:"KW"},{name:"Kyrgyzstan",c:"996-KG-0",b:"996",g:"KG"},{name:"Laos",c:"856-LA-0",
	b:"856",g:"LA"},{name:"Latvia",c:"371-LV-0",b:"371",g:"LV"},{name:"Lebanon",c:"961-LB-0",b:"961",g:"LB"},{name:"Lesotho",c:"266-LS-0",b:"266",g:"LS"},{name:"Liberia",c:"231-LR-0",b:"231",g:"LR"},{name:"Libya",c:"218-LY-0",b:"218",g:"LY"},{name:"Liechtenstein",c:"423-LI-0",b:"423",g:"LI"},{name:"Lithuania",c:"370-LT-0",b:"370",g:"LT"},{name:"Luxembourg",c:"352-LU-0",b:"352",g:"LU"},{name:"Macau",c:"853-MO-0",b:"853",g:"MO"},{name:"Macedonia",c:"389-MK-0",b:"389",g:"MK"},{name:"Madagascar",c:"261-MG-0",
	b:"261",g:"MG"},{name:"Malawi",c:"265-MW-0",b:"265",g:"MW"},{name:"Malaysia",c:"60-MY-0",b:"60",g:"MY"},{name:"Maldives",c:"960-MV-0",b:"960",g:"MV"},{name:"Mali",c:"223-ML-0",b:"223",g:"ML"},{name:"Malta",c:"356-MT-0",b:"356",g:"MT"},{name:"Marshall Islands",c:"692-MH-0",b:"692",g:"MH"},{name:"Martinique",c:"596-MQ-0",b:"596",g:"MQ"},{name:"Mauritania",c:"222-MR-0",b:"222",g:"MR"},{name:"Mauritius",c:"230-MU-0",b:"230",g:"MU"},{name:"Mayotte",c:"262-YT-0",b:"262",g:"YT"},{name:"Mexico",c:"52-MX-0",
	b:"52",g:"MX"},{name:"Micronesia",c:"691-FM-0",b:"691",g:"FM"},{name:"Moldova",c:"373-MD-0",b:"373",g:"MD"},{name:"Monaco",c:"377-MC-0",b:"377",g:"MC"},{name:"Mongolia",c:"976-MN-0",b:"976",g:"MN"},{name:"Montenegro",c:"382-ME-0",b:"382",g:"ME"},{name:"Montserrat",c:"1-MS-0",b:"1",g:"MS"},{name:"Morocco",c:"212-MA-0",b:"212",g:"MA"},{name:"Mozambique",c:"258-MZ-0",b:"258",g:"MZ"},{name:"Myanmar [Burma]",c:"95-MM-0",b:"95",g:"MM"},{name:"Namibia",c:"264-NA-0",b:"264",g:"NA"},{name:"Nauru",c:"674-NR-0",
	b:"674",g:"NR"},{name:"Nepal",c:"977-NP-0",b:"977",g:"NP"},{name:"Netherlands",c:"31-NL-0",b:"31",g:"NL"},{name:"New Caledonia",c:"687-NC-0",b:"687",g:"NC"},{name:"New Zealand",c:"64-NZ-0",b:"64",g:"NZ"},{name:"Nicaragua",c:"505-NI-0",b:"505",g:"NI"},{name:"Niger",c:"227-NE-0",b:"227",g:"NE"},{name:"Nigeria",c:"234-NG-0",b:"234",g:"NG"},{name:"Niue",c:"683-NU-0",b:"683",g:"NU"},{name:"Norfolk Island",c:"672-NF-0",b:"672",g:"NF"},{name:"North Korea",c:"850-KP-0",b:"850",g:"KP"},{name:"Northern Mariana Islands",
	c:"1-MP-0",b:"1",g:"MP"},{name:"Norway",c:"47-NO-0",b:"47",g:"NO"},{name:"Oman",c:"968-OM-0",b:"968",g:"OM"},{name:"Pakistan",c:"92-PK-0",b:"92",g:"PK"},{name:"Palau",c:"680-PW-0",b:"680",g:"PW"},{name:"Palestinian Territories",c:"970-PS-0",b:"970",g:"PS"},{name:"Panama",c:"507-PA-0",b:"507",g:"PA"},{name:"Papua New Guinea",c:"675-PG-0",b:"675",g:"PG"},{name:"Paraguay",c:"595-PY-0",b:"595",g:"PY"},{name:"Peru",c:"51-PE-0",b:"51",g:"PE"},{name:"Philippines",c:"63-PH-0",b:"63",g:"PH"},{name:"Poland",
	c:"48-PL-0",b:"48",g:"PL"},{name:"Portugal",c:"351-PT-0",b:"351",g:"PT"},{name:"Puerto Rico",c:"1-PR-0",b:"1",g:"PR"},{name:"Qatar",c:"974-QA-0",b:"974",g:"QA"},{name:"R\u00e9union",c:"262-RE-0",b:"262",g:"RE"},{name:"Romania",c:"40-RO-0",b:"40",g:"RO"},{name:"Russia",c:"7-RU-0",b:"7",g:"RU"},{name:"Rwanda",c:"250-RW-0",b:"250",g:"RW"},{name:"Saint Barth\u00e9lemy",c:"590-BL-0",b:"590",g:"BL"},{name:"Saint Helena",c:"290-SH-0",b:"290",g:"SH"},{name:"St. Kitts",c:"1-KN-0",b:"1",g:"KN"},{name:"St. Lucia",
	c:"1-LC-0",b:"1",g:"LC"},{name:"Saint Martin",c:"590-MF-0",b:"590",g:"MF"},{name:"Saint Pierre and Miquelon",c:"508-PM-0",b:"508",g:"PM"},{name:"St. Vincent",c:"1-VC-0",b:"1",g:"VC"},{name:"Samoa",c:"685-WS-0",b:"685",g:"WS"},{name:"San Marino",c:"378-SM-0",b:"378",g:"SM"},{name:"S\u00e3o Tom\u00e9 and Pr\u00edncipe",c:"239-ST-0",b:"239",g:"ST"},{name:"Saudi Arabia",c:"966-SA-0",b:"966",g:"SA"},{name:"Senegal",c:"221-SN-0",b:"221",g:"SN"},{name:"Serbia",c:"381-RS-0",b:"381",g:"RS"},{name:"Seychelles",
	c:"248-SC-0",b:"248",g:"SC"},{name:"Sierra Leone",c:"232-SL-0",b:"232",g:"SL"},{name:"Singapore",c:"65-SG-0",b:"65",g:"SG"},{name:"Sint Maarten",c:"1-SX-0",b:"1",g:"SX"},{name:"Slovakia",c:"421-SK-0",b:"421",g:"SK"},{name:"Slovenia",c:"386-SI-0",b:"386",g:"SI"},{name:"Solomon Islands",c:"677-SB-0",b:"677",g:"SB"},{name:"Somalia",c:"252-SO-0",b:"252",g:"SO"},{name:"South Africa",c:"27-ZA-0",b:"27",g:"ZA"},{name:"South Georgia and the South Sandwich Islands",c:"500-GS-0",b:"500",g:"GS"},{name:"South Korea",
	c:"82-KR-0",b:"82",g:"KR"},{name:"South Sudan",c:"211-SS-0",b:"211",g:"SS"},{name:"Spain",c:"34-ES-0",b:"34",g:"ES"},{name:"Sri Lanka",c:"94-LK-0",b:"94",g:"LK"},{name:"Sudan",c:"249-SD-0",b:"249",g:"SD"},{name:"Suriname",c:"597-SR-0",b:"597",g:"SR"},{name:"Svalbard and Jan Mayen",c:"47-SJ-0",b:"47",g:"SJ"},{name:"Swaziland",c:"268-SZ-0",b:"268",g:"SZ"},{name:"Sweden",c:"46-SE-0",b:"46",g:"SE"},{name:"Switzerland",c:"41-CH-0",b:"41",g:"CH"},{name:"Syria",c:"963-SY-0",b:"963",g:"SY"},{name:"Taiwan",
	c:"886-TW-0",b:"886",g:"TW"},{name:"Tajikistan",c:"992-TJ-0",b:"992",g:"TJ"},{name:"Tanzania",c:"255-TZ-0",b:"255",g:"TZ"},{name:"Thailand",c:"66-TH-0",b:"66",g:"TH"},{name:"Togo",c:"228-TG-0",b:"228",g:"TG"},{name:"Tokelau",c:"690-TK-0",b:"690",g:"TK"},{name:"Tonga",c:"676-TO-0",b:"676",g:"TO"},{name:"Trinidad/Tobago",c:"1-TT-0",b:"1",g:"TT"},{name:"Tunisia",c:"216-TN-0",b:"216",g:"TN"},{name:"Turkey",c:"90-TR-0",b:"90",g:"TR"},{name:"Turkmenistan",c:"993-TM-0",b:"993",g:"TM"},{name:"Turks and Caicos Islands",
	c:"1-TC-0",b:"1",g:"TC"},{name:"Tuvalu",c:"688-TV-0",b:"688",g:"TV"},{name:"U.S. Virgin Islands",c:"1-VI-0",b:"1",g:"VI"},{name:"Uganda",c:"256-UG-0",b:"256",g:"UG"},{name:"Ukraine",c:"380-UA-0",b:"380",g:"UA"},{name:"United Arab Emirates",c:"971-AE-0",b:"971",g:"AE"},{name:"United Kingdom",c:"44-GB-0",b:"44",g:"GB"},{name:"United States",c:"1-US-0",b:"1",g:"US"},{name:"Uruguay",c:"598-UY-0",b:"598",g:"UY"},{name:"Uzbekistan",c:"998-UZ-0",b:"998",g:"UZ"},{name:"Vanuatu",c:"678-VU-0",b:"678",g:"VU"},
	{name:"Vatican City",c:"379-VA-0",b:"379",g:"VA"},{name:"Venezuela",c:"58-VE-0",b:"58",g:"VE"},{name:"Vietnam",c:"84-VN-0",b:"84",g:"VN"},{name:"Wallis and Futuna",c:"681-WF-0",b:"681",g:"WF"},{name:"Western Sahara",c:"212-EH-0",b:"212",g:"EH"},{name:"Yemen",c:"967-YE-0",b:"967",g:"YE"},{name:"Zambia",c:"260-ZM-0",b:"260",g:"ZM"},{name:"Zimbabwe",c:"263-ZW-0",b:"263",g:"ZW"}];ii(fi);var ji=new ci(fi);function ki(a,b){this.a=a;this.za=b}function li(a){a=Za(a);var b=di(ji,a);return 0<b.length?new ki("1"==
	b[0].b?"1-US-0":b[0].c,Za(a.substr(b[0].b.length+1))):null}function mi(a){var b=ei(a.a);if(!b)throw Error("Country ID "+a.a+" not found.");return"+"+b.b+a.za}function ni(a,b){for(var c=0;c<a.length;c++)if(!Qa(oi,a[c])&&(null!==pi&&a[c]in pi||Qa(b,a[c])))return a[c];return null}var oi=["emailLink","password","phone"],pi={"facebook.com":"FacebookAuthProvider","github.com":"GithubAuthProvider","google.com":"GoogleAuthProvider",password:"EmailAuthProvider","twitter.com":"TwitterAuthProvider",phone:"PhoneAuthProvider"};
	function qi(){this.a=new Wh;I(this.a,"acUiConfig");I(this.a,"autoUpgradeAnonymousUsers");I(this.a,"callbacks");I(this.a,"credentialHelper",ri);I(this.a,"immediateFederatedRedirect",!1);I(this.a,"popupMode",!1);I(this.a,"privacyPolicyUrl");I(this.a,"queryParameterForSignInSuccessUrl","signInSuccessUrl");I(this.a,"queryParameterForWidgetMode","mode");I(this.a,"signInFlow");I(this.a,"signInOptions");I(this.a,"signInSuccessUrl");I(this.a,"siteName");I(this.a,"tosUrl");I(this.a,"widgetUrl")}function si(a){return a.a.get("acUiConfig")||
	null}function ti(a){var b=a.a.get("widgetUrl")||wf();return ui(a,b)}function ui(a,b){a=vi(a);for(var c=b.search(xb),d=0,e,f=[];0<=(e=wb(b,d,a,c));)f.push(b.substring(d,e)),d=Math.min(b.indexOf("&",e)+1||c,c);f.push(b.substr(d));b=f.join("").replace(zb,"$1");c="="+encodeURIComponent("select");(a+=c)?(c=b.indexOf("#"),0>c&&(c=b.length),d=b.indexOf("?"),0>d||d>c?(d=c,e=""):e=b.substring(d+1,c),b=[b.substr(0,d),e,b.substr(c)],c=b[1],b[1]=a?c?c+"&"+a:a:c,a=b[0]+(b[1]?"?"+b[1]:"")+b[2]):a=b;return a}function wi(a){var b=
	!!a.a.get("autoUpgradeAnonymousUsers");b&&!xi(a)&&tg('Missing "signInFailure" callback: "signInFailure" callback needs to be provided when "autoUpgradeAnonymousUsers" is set to true.',void 0);return b}function yi(a){a=a.a.get("signInOptions")||[];for(var b=[],c=0;c<a.length;c++){var d=a[c];d=wa(d)?d:{provider:d};d.provider&&b.push(d)}return b}function zi(a,b){a=yi(a);for(var c=0;c<a.length;c++)if(a[c].provider===b)return a[c];return null}function Ai(a){return Ma(yi(a),function(b){return b.provider})}
	function Bi(a,b){a=Ci(a);for(var c=0;c<a.length;c++)if(a[c].providerId===b)return a[c];return null}function Ci(a){return Ma(yi(a),function(b){return pi[b.provider]||Qa(Di,b.provider)?{providerId:b.provider}:{providerId:b.provider,rb:b.providerName||null,Ga:b.buttonColor||null,Na:b.iconUrl?Fc(Ic(b.iconUrl)):null,Nb:b.loginHintKey||null}})}function Ei(a){var b=[],c=[];Ja(yi(a),function(e){e.authMethod&&(b.push(e.authMethod),e.clientId&&c.push({uri:e.authMethod,clientId:e.clientId}))});var d=null;Fi(a)===
	Gi&&b.length&&(d={supportedIdTokenProviders:c,supportedAuthMethods:b});return d}function Hi(a,b){var c=null;Ja(yi(a),function(d){d.authMethod===b&&(c=d.provider)});return c}function Ii(a){var b=null;Ja(yi(a),function(d){d.provider==firebase.auth.PhoneAuthProvider.PROVIDER_ID&&wa(d.recaptchaParameters)&&!ta(d.recaptchaParameters)&&(b=jb(d.recaptchaParameters))});if(b){var c=[];Ja(Ji,function(d){"undefined"!==typeof b[d]&&(c.push(d),delete b[d])});c.length&&yg('The following provided "recaptchaParameters" keys are not allowed: '+
	c.join(", "))}return b}function Ki(a,b){a=(a=zi(a,b))&&a.scopes;return ta(a)?a:[]}function Li(a,b){a=(a=zi(a,b))&&a.customParameters;return wa(a)?(a=jb(a),b===firebase.auth.GoogleAuthProvider.PROVIDER_ID&&delete a.login_hint,b===firebase.auth.GithubAuthProvider.PROVIDER_ID&&delete a.login,a):null}function Mi(a){a=zi(a,firebase.auth.PhoneAuthProvider.PROVIDER_ID);var b=null;a&&"string"===typeof a.loginHint&&(b=li(a.loginHint));return a&&a.defaultNationalNumber||b&&b.za||null}function Ni(a){var b=(a=
	zi(a,firebase.auth.PhoneAuthProvider.PROVIDER_ID))&&a.defaultCountry||null;b=b&&gi(b);var c=null;a&&"string"===typeof a.loginHint&&(c=li(a.loginHint));return b&&b[0]||c&&ei(c.a)||null}function Oi(a){a=zi(a,firebase.auth.PhoneAuthProvider.PROVIDER_ID);if(!a)return null;var b=a.whitelistedCountries,c=a.blacklistedCountries;if("undefined"!==typeof b&&(!ta(b)||0==b.length))throw Error("WhitelistedCountries must be a non-empty array.");if("undefined"!==typeof c&&!ta(c))throw Error("BlacklistedCountries must be an array.");
	if(b&&c)throw Error("Both whitelistedCountries and blacklistedCountries are provided.");if(!b&&!c)return fi;a=[];if(b){c={};for(var d=0;d<b.length;d++){var e=hi(b[d]);for(var f=0;f<e.length;f++)c[e[f].c]=e[f]}for(var g in c)c.hasOwnProperty(g)&&a.push(c[g])}else{g={};for(b=0;b<c.length;b++)for(e=hi(c[b]),d=0;d<e.length;d++)g[e[d].c]=e[d];for(e=0;e<fi.length;e++)null!==g&&fi[e].c in g||a.push(fi[e])}return a}function vi(a){return Yh(a.a,"queryParameterForWidgetMode")}function Pi(a){var b=a.a.get("tosUrl")||
	null;a=a.a.get("privacyPolicyUrl")||null;b&&!a&&yg("Privacy Policy URL is missing, the link will not be displayed.");if(b&&a){if(va(b))return b;if("string"===typeof b)return function(){uf(b)}}return null}function Qi(a){var b=a.a.get("tosUrl")||null,c=a.a.get("privacyPolicyUrl")||null;c&&!b&&yg("Term of Service URL is missing, the link will not be displayed.");if(b&&c){if(va(c))return c;if("string"===typeof c)return function(){uf(c)}}return null}function Ri(a){return(a=zi(a,firebase.auth.EmailAuthProvider.PROVIDER_ID))&&
	"undefined"!==typeof a.requireDisplayName?!!a.requireDisplayName:!0}function Si(a){a=zi(a,firebase.auth.EmailAuthProvider.PROVIDER_ID);return!(!a||a.signInMethod!==firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD)}function Ti(a){a=zi(a,firebase.auth.EmailAuthProvider.PROVIDER_ID);return!(!a||!a.forceSameDevice)}function Ui(a){if(Si(a)){var b={url:wf(),handleCodeInApp:!0};(a=zi(a,firebase.auth.EmailAuthProvider.PROVIDER_ID))&&"function"===typeof a.emailLinkSignIn&&lb(b,a.emailLinkSignIn());
	b.url=Pb(wf(),b.url).toString();return b}return null}function Vi(a){var b=!!a.a.get("immediateFederatedRedirect"),c=Ai(a);a=Wi(a);return b&&1==c.length&&!Qa(oi,c[0])&&a==Xi}function Wi(a){a=a.a.get("signInFlow");for(var b in Yi)if(Yi[b]==a)return Yi[b];return Xi}function Zi(a){return $i(a).uiShown||null}function aj(a){return $i(a).signInSuccess||null}function bj(a){return $i(a).signInSuccessWithAuthResult||null}function xi(a){return $i(a).signInFailure||null}function $i(a){return a.a.get("callbacks")||
	{}}function Fi(a){if("http:"!==(window.location&&window.location.protocol)&&"https:"!==(window.location&&window.location.protocol))return cj;a=a.a.get("credentialHelper");for(var b in dj)if(dj[b]==a)return dj[b];return ri}var ri="accountchooser.com",Gi="googleyolo",cj="none",dj={jc:ri,mc:Gi,NONE:cj},Xi="redirect",Yi={pc:"popup",qc:Xi},ej={lc:"callback",RECOVER_EMAIL:"recoverEmail",rc:"resetPassword",sc:"select",tc:"signIn",VERIFY_EMAIL:"verifyEmail"},Di=["anonymous"],Ji=["sitekey","tabindex","callback",
	"expired-callback"];var fj,gj,hj,ij,J={};function K(a,b,c,d){J[a].apply(null,Array.prototype.slice.call(arguments,1))}var jj=null;function kj(a){return!(!a||-32E3!=a.code||"Service unavailable"!=a.message)}function lj(a,b,c,d){jj||(a={callbacks:{empty:a,select:function(e,f){e&&e.account&&b?b(Ag(e.account)):c&&c(!kj(f))},store:a,update:a},language:"en",providers:void 0,ui:d},"undefined"!=typeof accountchooser&&accountchooser.Api&&accountchooser.Api.init?jj=accountchooser.Api.init(a):(jj=new mj(a),
	nj()))}function oj(a,b,c){function d(){var e=Pb(window.location.href,c).toString();jj.select(Ma(b||[],function(f){return f.aa()}),{clientCallbackUrl:e})}b&&b.length?d():jj.checkEmpty(function(e,f){e||f?a(!kj(f)):d()})}function mj(a){this.a=a;this.a.callbacks=this.a.callbacks||{}}function nj(){var a=jj;va(a.a.callbacks.empty)&&a.a.callbacks.empty()}l=mj.prototype;l.store=function(){va(this.a.callbacks.store)&&this.a.callbacks.store(void 0,pj)};l.select=function(){va(this.a.callbacks.select)&&this.a.callbacks.select(void 0,
	pj)};l.update=function(){va(this.a.callbacks.update)&&this.a.callbacks.update(void 0,pj)};l.checkDisabled=function(a){a(!0)};l.checkEmpty=function(a){a(void 0,pj)};l.checkAccountExist=function(a,b){b(void 0,pj)};l.checkShouldUpdate=function(a,b){b(void 0,pj)};var pj={code:-32E3,message:"Service unavailable",data:"Service is unavailable."};var qj=/MSIE ([\d.]+).*Windows NT ([\d.]+)/,rj=/Firefox\/([\d.]+)/,sj=/Opera[ \/]([\d.]+)(.*Version\/([\d.]+))?/,tj=/Chrome\/([\d.]+)/,uj=/((Windows NT ([\d.]+))|(Mac OS X ([\d_]+))).*Version\/([\d.]+).*Safari/,
	vj=/Mac OS X;.*(?!(Version)).*Safari/,wj=/Android ([\d.]+).*Safari/,xj=/OS ([\d_]+) like Mac OS X.*Mobile.*Safari/,yj=/Konqueror\/([\d.]+)/,zj=/MSIE ([\d.]+).*Windows Phone OS ([\d.]+)/;function Aj(a,b){a=a.split(b||".");this.a=[];for(b=0;b<a.length;b++)this.a.push(parseInt(a[b],10))}function Bj(a,b){b instanceof Aj||(b=new Aj(String(b)));for(var c=Math.max(a.a.length,b.a.length),d=0;d<c;d++){var e=a.a[d],f=b.a[d];if(void 0!==e&&void 0!==f&&e!==f)return e-f;if(void 0===e)return-1;if(void 0===f)return 1}return 0}
	function Cj(a,b){return 0<=Bj(a,b)}function Dj(){var a=window.navigator&&window.navigator.userAgent;if(a){var b;if(b=a.match(sj)){var c=new Aj(b[3]||b[1]);return 0<=a.indexOf("Opera Mini")?!1:0<=a.indexOf("Opera Mobi")?0<=a.indexOf("Android")&&Cj(c,"10.1"):Cj(c,"8.0")}if(b=a.match(rj))return Cj(new Aj(b[1]),"2.0");if(b=a.match(tj))return Cj(new Aj(b[1]),"6.0");if(b=a.match(uj))return c=new Aj(b[6]),a=b[3]&&new Aj(b[3]),b=b[5]&&new Aj(b[5],"_"),(!(!a||!Cj(a,"6.0"))||!(!b||!Cj(b,"10.5.6")))&&Cj(c,"3.0");
	if(b=a.match(wj))return Cj(new Aj(b[1]),"3.0");if(b=a.match(xj))return Cj(new Aj(b[1],"_"),"4.0");if(b=a.match(yj))return Cj(new Aj(b[1]),"4.7");if(b=a.match(zj))return c=new Aj(b[1]),a=new Aj(b[2]),Cj(c,"7.0")&&Cj(a,"7.0");if(b=a.match(qj))return c=new Aj(b[1]),a=new Aj(b[2]),Cj(c,"7.0")&&Cj(a,"6.0");if(a.match(vj))return!1}return!0}function Ej(a){if(a.classList)return a.classList;a=a.className;return r(a)&&a.match(/\S+/g)||[]}function Fj(a,b){return a.classList?a.classList.contains(b):Qa(Ej(a),
	b)}function Gj(a,b){a.classList?a.classList.add(b):Fj(a,b)||(a.className+=0<a.className.length?" "+b:b)}function Hj(a,b){a.classList?a.classList.remove(b):Fj(a,b)&&(a.className=La(Ej(a),function(c){return c!=b}).join(" "))}function Ij(a){var b=a.type;switch(r(b)&&b.toLowerCase()){case "checkbox":case "radio":return a.checked?a.value:null;case "select-one":return b=a.selectedIndex,0<=b?a.options[b].value:null;case "select-multiple":b=[];for(var c,d=0;c=a.options[d];d++)c.selected&&b.push(c.value);
	return b.length?b:null;default:return null!=a.value?a.value:null}}function Jj(a,b){var c=a.type;switch(r(c)&&c.toLowerCase()){case "checkbox":case "radio":a.checked=b;break;case "select-one":a.selectedIndex=-1;if(r(b))for(var d=0;c=a.options[d];d++)if(c.value==b){c.selected=!0;break}break;case "select-multiple":r(b)&&(b=[b]);for(d=0;c=a.options[d];d++)if(c.selected=!1,b)for(var e,f=0;e=b[f];f++)c.value==e&&(c.selected=!0);break;default:a.value=null!=b?b:""}}function Kj(a){if(a.altKey&&!a.ctrlKey||
	a.metaKey||112<=a.keyCode&&123>=a.keyCode)return!1;if(Lj(a.keyCode))return!0;switch(a.keyCode){case 18:case 20:case 93:case 17:case 40:case 35:case 27:case 36:case 45:case 37:case 224:case 91:case 144:case 12:case 34:case 33:case 19:case 255:case 44:case 39:case 145:case 16:case 38:case 252:case 224:case 92:return!1;case 0:return!jc;default:return 166>a.keyCode||183<a.keyCode}}function Mj(a,b,c,d,e,f){if(kc&&!sc("525"))return!0;if(mc&&e)return Lj(a);if(e&&!d)return!1;if(!jc){"number"==typeof b&&(b=
	Nj(b));var g=17==b||18==b||mc&&91==b;if((!c||mc)&&g||mc&&16==b&&(d||f))return!1}if((kc||hc)&&d&&c)switch(a){case 220:case 219:case 221:case 192:case 186:case 189:case 187:case 188:case 190:case 191:case 192:case 222:return!1}if(z&&d&&b==a)return!1;switch(a){case 13:return jc?f||e?!1:!(c&&d):!0;case 27:return!(kc||hc||jc)}return jc&&(d||e||f)?!1:Lj(a)}function Lj(a){if(48<=a&&57>=a||96<=a&&106>=a||65<=a&&90>=a||(kc||hc)&&0==a)return!0;switch(a){case 32:case 43:case 63:case 64:case 107:case 109:case 110:case 111:case 186:case 59:case 189:case 187:case 61:case 188:case 190:case 191:case 192:case 222:case 219:case 220:case 221:case 163:return!0;
	case 173:return jc;default:return!1}}function Nj(a){if(jc)a=Oj(a);else if(mc&&kc)switch(a){case 93:a=91}return a}function Oj(a){switch(a){case 61:return 187;case 59:return 186;case 173:return 189;case 224:return 91;case 0:return 224;default:return a}}function Pj(a){F.call(this);this.a=a;ne(a,"keydown",this.f,!1,this);ne(a,"click",this.h,!1,this)}w(Pj,F);Pj.prototype.f=function(a){(13==a.keyCode||kc&&3==a.keyCode)&&Qj(this,a)};Pj.prototype.h=function(a){Qj(this,a)};function Qj(a,b){var c=new Rj(b);
	if(Ae(a,c)){c=new Sj(b);try{Ae(a,c)}finally{b.stopPropagation()}}}Pj.prototype.s=function(){Pj.K.s.call(this);ve(this.a,"keydown",this.f,!1,this);ve(this.a,"click",this.h,!1,this);delete this.a};function Sj(a){be.call(this,a.a);this.type="action"}w(Sj,be);function Rj(a){be.call(this,a.a);this.type="beforeaction"}w(Rj,be);function Tj(a){F.call(this);this.a=a;a=z?"focusout":"blur";this.f=ne(this.a,z?"focusin":"focus",this,!z);this.h=ne(this.a,a,this,!z)}w(Tj,F);Tj.prototype.handleEvent=function(a){var b=
	new be(a.a);b.type="focusin"==a.type||"focus"==a.type?"focusin":"focusout";Ae(this,b)};Tj.prototype.s=function(){Tj.K.s.call(this);we(this.f);we(this.h);delete this.a};function Uj(a,b){F.call(this);this.f=a||1;this.a=b||p;this.h=t(this.fc,this);this.j=Ca()}w(Uj,F);l=Uj.prototype;l.Ka=!1;l.$=null;l.fc=function(){if(this.Ka){var a=Ca()-this.j;0<a&&a<.8*this.f?this.$=this.a.setTimeout(this.h,this.f-a):(this.$&&(this.a.clearTimeout(this.$),this.$=null),Ae(this,"tick"),this.Ka&&(Vj(this),this.start()))}};
	l.start=function(){this.Ka=!0;this.$||(this.$=this.a.setTimeout(this.h,this.f),this.j=Ca())};function Vj(a){a.Ka=!1;a.$&&(a.a.clearTimeout(a.$),a.$=null)}l.s=function(){Uj.K.s.call(this);Vj(this);delete this.a};function Wj(a,b){if(va(a))b&&(a=t(a,b));else if(a&&"function"==typeof a.handleEvent)a=t(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(0)?-1:p.setTimeout(a,0)}function Xj(a){Sd.call(this);this.f=a;this.a={}}w(Xj,Sd);var Yj=[];function Zj(a,b,c,d){ta(c)||
	(c&&(Yj[0]=c.toString()),c=Yj);for(var e=0;e<c.length;e++){var f=ne(b,c[e],d||a.handleEvent,!1,a.f||a);if(!f)break;a.a[f.key]=f}}function ak(a){ib(a.a,function(b,c){this.a.hasOwnProperty(c)&&we(b)},a);a.a={}}Xj.prototype.s=function(){Xj.K.s.call(this);ak(this)};Xj.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function bk(a){F.call(this);this.a=null;this.f=a;a=z||hc||kc&&!sc("531")&&"TEXTAREA"==a.tagName;this.h=new Xj(this);Zj(this.h,this.f,a?["keydown",
	"paste","cut","drop","input"]:"input",this)}w(bk,F);bk.prototype.handleEvent=function(a){if("input"==a.type)z&&sc(10)&&0==a.keyCode&&0==a.j||(ck(this),Ae(this,dk(a)));else if("keydown"!=a.type||Kj(a)){var b="keydown"==a.type?this.f.value:null;z&&229==a.keyCode&&(b=null);var c=dk(a);ck(this);this.a=Wj(function(){this.a=null;this.f.value!=b&&Ae(this,c)},this)}};function ck(a){null!=a.a&&(p.clearTimeout(a.a),a.a=null)}function dk(a){a=new be(a.a);a.type="input";return a}bk.prototype.s=function(){bk.K.s.call(this);
	this.h.o();ck(this);delete this.f};function ek(a,b){F.call(this);a&&(this.Pa&&fk(this),this.qa=a,this.Oa=ne(this.qa,"keypress",this,b),this.Za=ne(this.qa,"keydown",this.Ib,b,this),this.Pa=ne(this.qa,"keyup",this.Jb,b,this))}w(ek,F);l=ek.prototype;l.qa=null;l.Oa=null;l.Za=null;l.Pa=null;l.S=-1;l.W=-1;l.Va=!1;var gk={3:13,12:144,63232:38,63233:40,63234:37,63235:39,63236:112,63237:113,63238:114,63239:115,63240:116,63241:117,63242:118,63243:119,63244:120,63245:121,63246:122,63247:123,63248:44,63272:46,
	63273:36,63275:35,63276:33,63277:34,63289:144,63302:45},hk={Up:38,Down:40,Left:37,Right:39,Enter:13,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,"U+007F":46,Home:36,End:35,PageUp:33,PageDown:34,Insert:45},ik=!kc||sc("525"),jk=mc&&jc;l=ek.prototype;l.Ib=function(a){if(kc||hc)if(17==this.S&&!a.ctrlKey||18==this.S&&!a.altKey||mc&&91==this.S&&!a.metaKey)this.W=this.S=-1;-1==this.S&&(a.ctrlKey&&17!=a.keyCode?this.S=17:a.altKey&&18!=a.keyCode?this.S=18:a.metaKey&&
	91!=a.keyCode&&(this.S=91));ik&&!Mj(a.keyCode,this.S,a.shiftKey,a.ctrlKey,a.altKey,a.metaKey)?this.handleEvent(a):(this.W=Nj(a.keyCode),jk&&(this.Va=a.altKey))};l.Jb=function(a){this.W=this.S=-1;this.Va=a.altKey};l.handleEvent=function(a){var b=a.a,c=b.altKey;if(z&&"keypress"==a.type){var d=this.W;var e=13!=d&&27!=d?b.keyCode:0}else(kc||hc)&&"keypress"==a.type?(d=this.W,e=0<=b.charCode&&63232>b.charCode&&Lj(d)?b.charCode:0):gc&&!kc?(d=this.W,e=Lj(d)?b.keyCode:0):("keypress"==a.type?(jk&&(c=this.Va),
	b.keyCode==b.charCode?32>b.keyCode?(d=b.keyCode,e=0):(d=this.W,e=b.charCode):(d=b.keyCode||this.W,e=b.charCode||0)):(d=b.keyCode||this.W,e=b.charCode||0),mc&&63==e&&224==d&&(d=191));var f=d=Nj(d);d?63232<=d&&d in gk?f=gk[d]:25==d&&a.shiftKey&&(f=9):b.keyIdentifier&&b.keyIdentifier in hk&&(f=hk[b.keyIdentifier]);jc&&ik&&"keypress"==a.type&&!Mj(f,this.S,a.shiftKey,a.ctrlKey,c,a.metaKey)||(a=f==this.S,this.S=f,b=new kk(f,e,a,b),b.altKey=c,Ae(this,b))};l.P=function(){return this.qa};function fk(a){a.Oa&&
	(we(a.Oa),we(a.Za),we(a.Pa),a.Oa=null,a.Za=null,a.Pa=null);a.qa=null;a.S=-1;a.W=-1}l.s=function(){ek.K.s.call(this);fk(this)};function kk(a,b,c,d){be.call(this,d);this.type="key";this.keyCode=a;this.j=b;this.repeat=c}w(kk,be);function lk(a,b,c,d){this.top=a;this.right=b;this.bottom=c;this.left=d}lk.prototype.toString=function(){return"("+this.top+"t, "+this.right+"r, "+this.bottom+"b, "+this.left+"l)"};lk.prototype.ceil=function(){this.top=Math.ceil(this.top);this.right=Math.ceil(this.right);this.bottom=
	Math.ceil(this.bottom);this.left=Math.ceil(this.left);return this};lk.prototype.floor=function(){this.top=Math.floor(this.top);this.right=Math.floor(this.right);this.bottom=Math.floor(this.bottom);this.left=Math.floor(this.left);return this};lk.prototype.round=function(){this.top=Math.round(this.top);this.right=Math.round(this.right);this.bottom=Math.round(this.bottom);this.left=Math.round(this.left);return this};function mk(a,b){var c=Xc(a);return c.defaultView&&c.defaultView.getComputedStyle&&(a=
	c.defaultView.getComputedStyle(a,null))?a[b]||a.getPropertyValue(b)||"":""}function nk(a){try{var b=a.getBoundingClientRect()}catch(c){return{left:0,top:0,right:0,bottom:0}}z&&a.ownerDocument.body&&(a=a.ownerDocument,b.left-=a.documentElement.clientLeft+a.body.clientLeft,b.top-=a.documentElement.clientTop+a.body.clientTop);return b}function ok(a,b){b=b||cd(document);var c=b||cd(document);var d=pk(a),e=pk(c);if(!z||9<=Number(tc)){g=mk(c,"borderLeftWidth");var f=mk(c,"borderRightWidth");h=mk(c,"borderTopWidth");
	k=mk(c,"borderBottomWidth");f=new lk(parseFloat(h),parseFloat(f),parseFloat(k),parseFloat(g))}else{var g=qk(c,"borderLeft");f=qk(c,"borderRight");var h=qk(c,"borderTop"),k=qk(c,"borderBottom");f=new lk(h,f,k,g)}c==cd(document)?(g=d.a-c.scrollLeft,d=d.f-c.scrollTop,!z||10<=Number(tc)||(g+=f.left,d+=f.top)):(g=d.a-e.a-f.left,d=d.f-e.f-f.top);e=a.offsetWidth;f=a.offsetHeight;h=kc&&!e&&!f;na(e)&&!h||!a.getBoundingClientRect?a=new Uc(e,f):(a=nk(a),a=new Uc(a.right-a.left,a.bottom-a.top));e=c.clientHeight-
	a.height;f=c.scrollLeft;h=c.scrollTop;f+=Math.min(g,Math.max(g-(c.clientWidth-a.width),0));h+=Math.min(d,Math.max(d-e,0));c=new Tc(f,h);b.scrollLeft=c.a;b.scrollTop=c.f}function pk(a){var b=Xc(a),c=new Tc(0,0);var d=b?Xc(b):document;d=!z||9<=Number(tc)||"CSS1Compat"==Vc(d).a.compatMode?d.documentElement:d.body;if(a==d)return c;a=nk(a);d=Vc(b).a;b=cd(d);d=d.parentWindow||d.defaultView;b=z&&sc("10")&&d.pageYOffset!=b.scrollTop?new Tc(b.scrollLeft,b.scrollTop):new Tc(d.pageXOffset||b.scrollLeft,d.pageYOffset||
	b.scrollTop);c.a=a.left+b.a;c.f=a.top+b.f;return c}var rk={thin:2,medium:4,thick:6};function qk(a,b){if("none"==(a.currentStyle?a.currentStyle[b+"Style"]:null))return 0;var c=a.currentStyle?a.currentStyle[b+"Width"]:null;if(c in rk)a=rk[c];else if(/^\d+px?$/.test(c))a=parseInt(c,10);else{b=a.style.left;var d=a.runtimeStyle.left;a.runtimeStyle.left=a.currentStyle.left;a.style.left=c;c=a.style.pixelLeft;a.style.left=b;a.runtimeStyle.left=d;a=+c}return a}function sk(){}ra(sk);sk.prototype.a=0;function tk(a){F.call(this);
	this.m=a||Vc();this.eb=null;this.na=!1;this.f=null;this.J=void 0;this.oa=this.Ca=this.X=null}w(tk,F);l=tk.prototype;l.Kb=sk.Ya();l.P=function(){return this.f};function L(a,b){return a.f?$c(b,a.f||a.m.a):null}function uk(a){a.J||(a.J=new Xj(a));return a.J}l.$a=function(a){if(this.X&&this.X!=a)throw Error("Method not supported");tk.K.$a.call(this,a)};l.lb=function(){this.f=this.m.a.createElement("DIV")};l.render=function(a){if(this.na)throw Error("Component already rendered");this.f||this.lb();a?a.insertBefore(this.f,
	null):this.m.a.body.appendChild(this.f);this.X&&!this.X.na||this.v()};l.v=function(){this.na=!0;vk(this,function(a){!a.na&&a.P()&&a.v()})};l.ya=function(){vk(this,function(a){a.na&&a.ya()});this.J&&ak(this.J);this.na=!1};l.s=function(){this.na&&this.ya();this.J&&(this.J.o(),delete this.J);vk(this,function(a){a.o()});this.f&&dd(this.f);this.X=this.f=this.oa=this.Ca=null;tk.K.s.call(this)};function vk(a,b){a.Ca&&Ja(a.Ca,b,void 0)}l.removeChild=function(a,b){if(a){var c=r(a)?a:a.eb||(a.eb=":"+(a.Kb.a++).toString(36));
	this.oa&&c?(a=this.oa,a=(null!==a&&c in a?a[c]:void 0)||null):a=null;if(c&&a){var d=this.oa;c in d&&delete d[c];Ra(this.Ca,a);b&&(a.ya(),a.f&&dd(a.f));b=a;if(null==b)throw Error("Unable to set parent component");b.X=null;tk.K.$a.call(b,null)}}if(!a)throw Error("Child is not in parent component");return a};function M(a,b){var c=fd(a,"firebaseui-textfield");b?(Hj(a,"firebaseui-input-invalid"),Gj(a,"firebaseui-input"),c&&Hj(c,"firebaseui-textfield-invalid")):(Hj(a,"firebaseui-input"),Gj(a,"firebaseui-input-invalid"),
	c&&Gj(c,"firebaseui-textfield-invalid"))}function wk(a,b,c){b=new bk(b);Vd(a,Ba(Wd,b));Zj(uk(a),b,"input",c)}function xk(a,b,c){b=new ek(b);Vd(a,Ba(Wd,b));Zj(uk(a),b,"key",function(d){13==d.keyCode&&(d.stopPropagation(),d.preventDefault(),c(d))})}function yk(a,b,c){b=new Tj(b);Vd(a,Ba(Wd,b));Zj(uk(a),b,"focusin",c)}function zk(a,b,c){b=new Tj(b);Vd(a,Ba(Wd,b));Zj(uk(a),b,"focusout",c)}function N(a,b,c){b=new Pj(b);Vd(a,Ba(Wd,b));Zj(uk(a),b,"action",function(d){d.stopPropagation();d.preventDefault();
	c(d)})}function Ak(a){Gj(a,"firebaseui-hidden")}function Bk(a,b){b&&ed(a,b);Hj(a,"firebaseui-hidden")}function Ck(a){return!Fj(a,"firebaseui-hidden")&&"none"!=a.style.display}function Dk(a){a=a||{};var b=a.email,c=a.disabled,d='<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-email-input">';d=a.vc?d+"Enter new email address":d+"Email";d+='</label><input type="email" name="email" id="ui-sign-in-email-input" autocomplete="username" class="mdl-textfield__input firebaseui-input firebaseui-id-email" value="'+
	yd(null!=b?b:"")+'"'+(c?"disabled":"")+'></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-email-error"></p></div>';return C(d)}function Ek(a){a=a||{};a=a.label;var b='<button type="submit" class="firebaseui-id-submit firebaseui-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored">';b=a?b+A(a):b+"Next";return C(b+"</button>")}function Fk(){var a=""+Ek({label:E("Sign In")});return C(a)}function Gk(){var a=
	""+Ek({label:E("Save")});return C(a)}function Hk(){var a=""+Ek({label:E("Continue")});return C(a)}function Ik(a){a=a||{};a=a.label;var b='<div class="firebaseui-new-password-component"><div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-new-password-input">';b=a?b+A(a):b+"Choose password";return C(b+'</label><input type="password" name="newPassword" id="ui-sign-in-new-password-input" autocomplete="new-password" class="mdl-textfield__input firebaseui-input firebaseui-id-new-password"></div><a href="javascript:void(0)" class="firebaseui-input-floating-button firebaseui-id-password-toggle firebaseui-input-toggle-on firebaseui-input-toggle-blur"></a><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-new-password-error"></p></div></div>')}
	function Jk(){var a={};var b='<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-password-input">';b=a.current?b+"Current password":b+"Password";return C(b+'</label><input type="password" name="password" id="ui-sign-in-password-input" autocomplete="current-password" class="mdl-textfield__input firebaseui-input firebaseui-id-password"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-password-error"></p></div>')}
	function Kk(){return C('<a class="firebaseui-link firebaseui-id-secondary-link" href="javascript:void(0)">Trouble signing in?</a>')}function Lk(a){a=a||{};a=a.label;var b='<button class="firebaseui-id-secondary-link firebaseui-button mdl-button mdl-js-button mdl-button--primary">';b=a?b+A(a):b+"Cancel";return C(b+"</button>")}function Mk(a){var b="";a.G&&a.F&&(b+='<ul class="firebaseui-tos-list firebaseui-tos"><li class="firebaseui-inline-list-item"><a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a></li><li class="firebaseui-inline-list-item"><a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a></li></ul>');
	return C(b)}function Nk(a){var b="";a.G&&a.F&&(b+='<p class="firebaseui-tos firebaseui-tospp-full-message">By continuing, you are indicating that you accept our <a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a> and <a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a>.</p>');return C(b)}function Ok(a){a='<div class="firebaseui-info-bar firebaseui-id-info-bar"><p class="firebaseui-info-bar-message">'+
	A(a.message)+'&nbsp;&nbsp;<a href="javascript:void(0)" class="firebaseui-link firebaseui-id-dismiss-info-bar">Dismiss</a></p></div>';return C(a)}Ok.A="firebaseui.auth.soy2.element.infoBar";function Pk(a){var b=a.content;a=a.Bb;return C('<dialog class="mdl-dialog firebaseui-dialog firebaseui-id-dialog'+(a?" "+yd(a):"")+'">'+A(b)+"</dialog>")}function Qk(a){var b=a.message;return C(Pk({content:xd('<div class="firebaseui-dialog-icon-wrapper"><div class="'+yd(a.Ma)+' firebaseui-dialog-icon"></div></div><div class="firebaseui-progress-dialog-message">'+
	A(b)+"</div>")}))}Qk.A="firebaseui.auth.soy2.element.progressDialog";function Rk(a){var b='<div class="firebaseui-list-box-actions">';a=a.items;for(var c=a.length,d=0;d<c;d++){var e=a[d];b+='<button type="button" data-listboxid="'+yd(e.id)+'" class="mdl-button firebaseui-id-list-box-dialog-button firebaseui-list-box-dialog-button">'+(e.Ma?'<div class="firebaseui-list-box-icon-wrapper"><div class="firebaseui-list-box-icon '+yd(e.Ma)+'"></div></div>':"")+'<div class="firebaseui-list-box-label-wrapper">'+
	A(e.label)+"</div></button>"}b=""+Pk({Bb:E("firebaseui-list-box-dialog"),content:xd(b+"</div>")});return C(b)}Rk.A="firebaseui.auth.soy2.element.listBoxDialog";function Sk(a){a=a||{};return C(a.vb?'<div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>':'<div class="mdl-progress mdl-js-progress mdl-progress__indeterminate firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>')}Sk.A="firebaseui.auth.soy2.element.busyIndicator";
	function Tk(a,b){a=a||{};a=a.ga;return D(a.rb?a.rb:b.ib[a.providerId]?""+b.ib[a.providerId]:0==(""+a.providerId).indexOf("saml.")?(""+a.providerId).substring(5):0==(""+a.providerId).indexOf("oidc.")?(""+a.providerId).substring(5):""+a.providerId)}function Uk(a){Vk(a,"upgradeElement")}function Wk(a){Vk(a,"downgradeElements")}var Xk=["mdl-js-textfield","mdl-js-progress","mdl-js-spinner","mdl-js-button"];function Vk(a,b){a&&window.componentHandler&&window.componentHandler[b]&&Ja(Xk,function(c){if(Fj(a,
	c))window.componentHandler[b](a);Ja(Yc(c,a),function(d){window.componentHandler[b](d)})})}function Yk(a,b,c){Zk.call(this);document.body.appendChild(a);a.showModal||window.dialogPolyfill.registerDialog(a);a.showModal();Uk(a);b&&N(this,a,function(f){var g=a.getBoundingClientRect();(f.clientX<g.left||g.left+g.width<f.clientX||f.clientY<g.top||g.top+g.height<f.clientY)&&Zk.call(this)});if(!c){var d=this.P().parentElement||this.P().parentNode;if(d){var e=this;this.da=function(){if(a.open){var f=a.getBoundingClientRect().height,
	g=d.getBoundingClientRect().height,h=d.getBoundingClientRect().top-document.body.getBoundingClientRect().top,k=d.getBoundingClientRect().left-document.body.getBoundingClientRect().left,m=a.getBoundingClientRect().width,q=d.getBoundingClientRect().width;a.style.top=(h+(g-f)/2).toString()+"px";f=k+(q-m)/2;a.style.left=f.toString()+"px";a.style.right=(document.body.getBoundingClientRect().width-f-m).toString()+"px"}else window.removeEventListener("resize",e.da)};this.da();window.addEventListener("resize",
	this.da,!1)}}}function Zk(){var a=$k.call(this);a&&(Wk(a),a.open&&a.close(),dd(a),this.da&&window.removeEventListener("resize",this.da))}function $k(){return $c("firebaseui-id-dialog")}function al(){dd(bl.call(this))}function bl(){return L(this,"firebaseui-id-info-bar")}function cl(){return L(this,"firebaseui-id-dismiss-info-bar")}var dl={xa:{"google.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg","github.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/github.svg",
	"facebook.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg","twitter.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/twitter.svg",password:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg",phone:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/phone.svg",anonymous:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/anonymous.png","microsoft.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/microsoft.svg","yahoo.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/yahoo.svg",
	"apple.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/apple.png",saml:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/saml.svg",oidc:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/oidc.svg"},wa:{"google.com":"#ffffff","github.com":"#333333","facebook.com":"#3b5998","twitter.com":"#55acee",password:"#db4437",phone:"#02bd7e",anonymous:"#f4b400","microsoft.com":"#2F2F2F","yahoo.com":"#720E9E","apple.com":"#000000",saml:"#007bff",oidc:"#007bff"},ib:{"google.com":"Google",
	"github.com":"GitHub","facebook.com":"Facebook","twitter.com":"Twitter",password:"Password",phone:"Phone",anonymous:"Guest","microsoft.com":"Microsoft","yahoo.com":"Yahoo","apple.com":"Apple"}};function el(a,b,c){ae.call(this,a,b);for(var d in c)this[d]=c[d]}w(el,ae);function O(a,b,c,d,e){tk.call(this,c);this.gb=a;this.fb=b;this.Da=!1;this.Ea=d||null;this.w=this.ca=null;this.Y=jb(dl);lb(this.Y,e||{})}w(O,tk);l=O.prototype;l.lb=function(){var a=md(this.gb,this.fb,this.Y,this.m);Uk(a);this.f=a};l.v=
	function(){O.K.v.call(this);Ee(P(this),new el("pageEnter",P(this),{pageId:this.Ea}));if(this.cb()&&this.Y.G){var a=this.Y.G;N(this,this.cb(),function(){a()})}if(this.bb()&&this.Y.F){var b=this.Y.F;N(this,this.bb(),function(){b()})}};l.ya=function(){Ee(P(this),new el("pageExit",P(this),{pageId:this.Ea}));O.K.ya.call(this)};l.s=function(){window.clearTimeout(this.ca);this.fb=this.gb=this.ca=null;this.Da=!1;this.w=null;Wk(this.P());O.K.s.call(this)};function fl(a){a.Da=!0;var b=Fj(a.P(),"firebaseui-use-spinner");
	a.ca=window.setTimeout(function(){a.P()&&null===a.w&&(a.w=md(Sk,{vb:b},null,a.m),a.P().appendChild(a.w),Uk(a.w))},500)}l.L=function(a,b,c,d){function e(){if(f.N)return null;f.Da=!1;window.clearTimeout(f.ca);f.ca=null;f.w&&(Wk(f.w),dd(f.w),f.w=null)}var f=this;if(f.Da)return null;fl(f);return a.apply(null,b).then(c,d).then(e,e)};function P(a){return a.P().parentElement||a.P().parentNode}function gl(a,b,c){xk(a,b,function(){c.focus()})}function hl(a,b,c){xk(a,b,function(){c()})}u(O.prototype,{a:function(a){al.call(this);
	var b=md(Ok,{message:a},null,this.m);this.P().appendChild(b);N(this,cl.call(this),function(){dd(b)})},xc:al,zc:bl,yc:cl,Z:function(a,b){a=md(Qk,{Ma:a,message:b},null,this.m);Yk.call(this,a)},h:Zk,Db:$k,Bc:function(){return L(this,"firebaseui-tos")},cb:function(){return L(this,"firebaseui-tos-link")},bb:function(){return L(this,"firebaseui-pp-link")},Cc:function(){return L(this,"firebaseui-tos-list")}});function il(a,b,c){a=a||{};b=a.Wa;var d=a.ia;a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in with email</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">'+
	Dk(a)+'</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+(b?Lk(null):"")+Ek(null)+'</div></div><div class="firebaseui-card-footer">'+(d?Nk(c):Mk(c))+"</div></form></div>";return C(a)}il.A="firebaseui.auth.soy2.page.signIn";function jl(a,b,c){a=a||{};b=a.ia;a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content">'+
	Dk(a)+Jk()+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">'+Kk()+'</div><div class="firebaseui-form-actions">'+Fk()+'</div></div><div class="firebaseui-card-footer">'+(b?Nk(c):Mk(c))+"</div></form></div>";return C(a)}jl.A="firebaseui.auth.soy2.page.passwordSignIn";function kl(a,b,c){a=a||{};var d=a.Sb;b=a.Ua;var e=a.ia,f='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-up"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Create account</h1></div><div class="firebaseui-card-content">'+
	Dk(a);d?(a=a||{},a=a.name,a='<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-name-input">First &amp; last name</label><input type="text" name="name" id="ui-sign-in-name-input" autocomplete="name" class="mdl-textfield__input firebaseui-input firebaseui-id-name" value="'+yd(null!=a?a:"")+'"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-name-error"></p></div>',
	a=C(a)):a="";c=f+a+Ik(null)+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+(b?Lk(null):"")+Gk()+'</div></div><div class="firebaseui-card-footer">'+(e?Nk(c):Mk(c))+"</div></form></div>";return C(c)}kl.A="firebaseui.auth.soy2.page.passwordSignUp";function ll(a,b,c){a=a||{};b=a.Ua;a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Recover password</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Get instructions sent to this email that explain how to reset your password</p>'+
	Dk(a)+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+(b?Lk(null):"")+Ek({label:E("Send")})+'</div></div><div class="firebaseui-card-footer">'+Mk(c)+"</div></form></div>";return C(a)}ll.A="firebaseui.auth.soy2.page.passwordRecovery";function ml(a,b,c){b=a.T;var d="";a="Follow the instructions sent to <strong>"+(A(a.email)+"</strong> to recover your password");d+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery-email-sent"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Check your email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+
	a+'</p></div><div class="firebaseui-card-actions">';b&&(d+='<div class="firebaseui-form-actions">'+Ek({label:E("Done")})+"</div>");d+='</div><div class="firebaseui-card-footer">'+Mk(c)+"</div></div>";return C(d)}ml.A="firebaseui.auth.soy2.page.passwordRecoveryEmailSent";function nl(a,b,c){return C('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-callback"><div class="firebaseui-callback-indicator-container">'+Sk(null,null,c)+"</div></div>")}nl.A="firebaseui.auth.soy2.page.callback";
	function ol(a,b,c){return C('<div class="firebaseui-container firebaseui-id-page-spinner">'+Sk({vb:!0},null,c)+"</div>")}ol.A="firebaseui.auth.soy2.page.spinner";function pl(){return C('<div class="firebaseui-container firebaseui-id-page-blank firebaseui-use-spinner"></div>')}pl.A="firebaseui.auth.soy2.page.blank";function ql(a,b,c){b="";a="A sign-in email with additional instructions was sent to <strong>"+(A(a.email)+"</strong>. Check your email to complete sign-in.");var d=C('<a class="firebaseui-link firebaseui-id-trouble-getting-email-link" href="javascript:void(0)">Trouble getting email?</a>');
	b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-sent"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign-in email sent</h1></div><div class="firebaseui-card-content"><div class="firebaseui-email-sent"></div><p class="firebaseui-text">'+a+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">'+d+'</div><div class="firebaseui-form-actions">'+Lk({label:E("Back")})+'</div></div><div class="firebaseui-card-footer">'+
	Mk(c)+"</div></form></div>";return C(b)}ql.A="firebaseui.auth.soy2.page.emailLinkSignInSent";function rl(a,b,c){a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-not-received"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Trouble getting email?</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Try these common fixes:<ul><li>Check if the email was marked as spam or filtered.</li><li>Check your internet connection.</li><li>Check that you did not misspell your email.</li><li>Check that your inbox space is not running out or other inbox settings related issues.</li></ul></p><p class="firebaseui-text">If the steps above didn\'t work, you can resend the email. Note that this will deactivate the link in the older email.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">'+
	C('<a class="firebaseui-link firebaseui-id-resend-email-link" href="javascript:void(0)">Resend</a>')+'</div><div class="firebaseui-form-actions">'+Lk({label:E("Back")})+'</div></div><div class="firebaseui-card-footer">'+Mk(c)+"</div></form></div>";return C(a)}rl.A="firebaseui.auth.soy2.page.emailNotReceived";function sl(a,b,c){a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-confirmation"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Confirm email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Confirm your email to complete sign in</p><div class="firebaseui-relative-wrapper">'+
	Dk(a)+'</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Lk(null)+Ek(null)+'</div></div><div class="firebaseui-card-footer">'+Mk(c)+"</div></form></div>";return C(a)}sl.A="firebaseui.auth.soy2.page.emailLinkSignInConfirmation";function tl(){var a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-different-device-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">New device or browser detected</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Try opening the link using the same device or browser where you started the sign-in process.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+
	Lk({label:E("Dismiss")})+"</div></div></div>";return C(a)}tl.A="firebaseui.auth.soy2.page.differentDeviceError";function ul(){var a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-anonymous-user-mismatch"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Session ended</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">The session associated with this sign-in request has either expired or was cleared.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+
	Lk({label:E("Dismiss")})+"</div></div></div>";return C(a)}ul.A="firebaseui.auth.soy2.page.anonymousUserMismatch";function vl(a,b,c){b="";a="You\u2019ve already used <strong>"+(A(a.email)+"</strong> to sign in. Enter your password for that account.");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">'+
	a+"</p>"+Jk()+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">'+Kk()+'</div><div class="firebaseui-form-actions">'+Fk()+'</div></div><div class="firebaseui-card-footer">'+Mk(c)+"</div></form></div>";return C(b)}vl.A="firebaseui.auth.soy2.page.passwordLinking";function wl(a,b,c){var d=a.email;b="";a=""+Tk(a,c);a=E(a);d="You\u2019ve already used <strong>"+(A(d)+("</strong>. You can connect your <strong>"+(A(a)+("</strong> account with <strong>"+(A(d)+"</strong> by signing in with email link below.")))));
	a="For this flow to successfully connect your "+(A(a)+" account with this email, you have to open the link on the same device or browser.");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text firebaseui-text-justify">'+
	d+'<p class="firebaseui-text firebaseui-text-justify">'+a+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Fk()+'</div></div><div class="firebaseui-card-footer">'+Mk(c)+"</div></form></div>";return C(b)}wl.A="firebaseui.auth.soy2.page.emailLinkSignInLinking";function xl(a,b,c){b="";var d=""+Tk(a,c);d=E(d);a="You originally intended to connect <strong>"+(A(d)+"</strong> to your email account but have opened the link on a different device where you are not signed in.");
	d="If you still want to connect your <strong>"+(A(d)+"</strong> account, open the link on the same device where you started sign-in. Otherwise, tap Continue to sign-in on this device.");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-linking-different-device"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text firebaseui-text-justify">'+
	a+'</p><p class="firebaseui-text firebaseui-text-justify">'+d+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Hk()+'</div></div><div class="firebaseui-card-footer">'+Mk(c)+"</div></form></div>";return C(b)}xl.A="firebaseui.auth.soy2.page.emailLinkSignInLinkingDifferentDevice";function yl(a,b,c){var d=a.email;b="";a=""+Tk(a,c);a=E(a);d="You\u2019ve already used <strong>"+(A(d)+("</strong>. Sign in with "+(A(a)+" to continue.")));b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-federated-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">'+
	d+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Ek({label:E("Sign in with "+a)})+'</div></div><div class="firebaseui-card-footer">'+Mk(c)+"</div></form></div>";return C(b)}yl.A="firebaseui.auth.soy2.page.federatedLinking";function zl(a,b,c){b="";a="To continue sign in with <strong>"+(A(a.email)+"</strong> on this device, you have to recover the password.");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unsupported-provider"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+
	a+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Lk(null)+Ek({label:E("Recover password")})+'</div></div><div class="firebaseui-card-footer">'+Mk(c)+"</div></form></div>";return C(b)}zl.A="firebaseui.auth.soy2.page.unsupportedProvider";function Al(a){var b="",c='<p class="firebaseui-text">for <strong>'+(A(a.email)+"</strong></p>");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Reset your password</h1></div><div class="firebaseui-card-content">'+
	c+Ik(wd(a))+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Gk()+"</div></div></form></div>";return C(b)}Al.A="firebaseui.auth.soy2.page.passwordReset";function Bl(a){a=a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Password changed</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new password</p></div><div class="firebaseui-card-actions">'+
	(a.T?'<div class="firebaseui-form-actions">'+Hk()+"</div>":"")+"</div></div>";return C(a)}Bl.A="firebaseui.auth.soy2.page.passwordResetSuccess";function Cl(a){a=a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try resetting your password again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to reset your password has expired or the link has already been used</p></div><div class="firebaseui-card-actions">'+
	(a.T?'<div class="firebaseui-form-actions">'+Hk()+"</div>":"")+"</div></div>";return C(a)}Cl.A="firebaseui.auth.soy2.page.passwordResetFailure";function Dl(a){var b=a.T,c="";a="Your sign-in email address has been changed back to <strong>"+(A(a.email)+"</strong>.");c+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-success"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Updated email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+
	a+'</p><p class="firebaseui-text">If you didn\u2019t ask to change your sign-in email, it\u2019s possible someone is trying to access your account and you should <a class="firebaseui-link firebaseui-id-reset-password-link" href="javascript:void(0)">change your password right away</a>.</p></div><div class="firebaseui-card-actions">'+(b?'<div class="firebaseui-form-actions">'+Hk()+"</div>":"")+"</div></form></div>";return C(c)}Dl.A="firebaseui.auth.soy2.page.emailChangeRevokeSuccess";function El(a){a=
	a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Unable to update your email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">There was a problem changing your sign-in email back.</p><p class="firebaseui-text">If you try again and still can\u2019t reset your email, try asking your administrator for help.</p></div><div class="firebaseui-card-actions">'+
	(a.T?'<div class="firebaseui-form-actions">'+Hk()+"</div>":"")+"</div></div>";return C(a)}El.A="firebaseui.auth.soy2.page.emailChangeRevokeFailure";function Fl(a){a=a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Your email has been verified</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new account</p></div><div class="firebaseui-card-actions">'+
	(a.T?'<div class="firebaseui-form-actions">'+Hk()+"</div>":"")+"</div></div>";return C(a)}Fl.A="firebaseui.auth.soy2.page.emailVerificationSuccess";function Gl(a){a=a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try verifying your email again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to verify your email has expired or the link has already been used</p></div><div class="firebaseui-card-actions">'+
	(a.T?'<div class="firebaseui-form-actions">'+Hk()+"</div>":"")+"</div></div>";return C(a)}Gl.A="firebaseui.auth.soy2.page.emailVerificationFailure";function Hl(a){var b=a.Ab;a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-recoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+A(a.errorMessage)+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">';
	b&&(a+=Ek({label:E("Retry")}));return C(a+"</div></div></div>")}Hl.A="firebaseui.auth.soy2.page.recoverableError";function Il(a){a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unrecoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+A(a.errorMessage)+"</p></div></div>";return C(a)}Il.A="firebaseui.auth.soy2.page.unrecoverableError";function Jl(a,
	b,c){var d=a.Pb;b="";a="Continue with "+(A(a.ic)+"?");d="You originally wanted to sign in with "+A(d);b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-mismatch"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">'+a+'</h2><p class="firebaseui-text">'+d+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+
	Lk(null)+Ek({label:E("Continue")})+'</div></div><div class="firebaseui-card-footer">'+Mk(c)+"</div></form></div>";return C(b)}Jl.A="firebaseui.auth.soy2.page.emailMismatch";function Kl(a,b,c){var d='<div class="firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in firebaseui-use-spinner"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-idp-list">';a=a.Rb;b=a.length;for(var e=0;e<b;e++){var f={ga:a[e]};var g=c;f=f||{};var h=
	f.ga,k=f;k=k||{};var m="";switch(k.ga.providerId){case "google.com":m+="firebaseui-idp-google";break;case "github.com":m+="firebaseui-idp-github";break;case "facebook.com":m+="firebaseui-idp-facebook";break;case "twitter.com":m+="firebaseui-idp-twitter";break;case "phone":m+="firebaseui-idp-phone";break;case "anonymous":m+="firebaseui-idp-anonymous";break;case "password":m+="firebaseui-idp-password";break;default:m+="firebaseui-idp-generic"}k='<button class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised '+
	yd(D(m))+' firebaseui-id-idp-button" data-provider-id="'+yd(h.providerId)+'" style="background-color:';m=(m=f)||{};m=m.ga;k=k+yd(Hd(D(m.Ga?m.Ga:g.wa[m.providerId]?""+g.wa[m.providerId]:0==m.providerId.indexOf("saml.")?""+g.wa.saml:0==m.providerId.indexOf("oidc.")?""+g.wa.oidc:""+g.wa.password)))+'"><span class="firebaseui-idp-icon-wrapper"><img class="firebaseui-idp-icon" alt="" src="';var q=f;m=g;q=q||{};q=q.ga;m=vd(q.Na?Dd(q.Na):m.xa[q.providerId]?Dd(m.xa[q.providerId]):0==q.providerId.indexOf("saml.")?
	Dd(m.xa.saml):0==q.providerId.indexOf("oidc.")?Dd(m.xa.oidc):Dd(m.xa.password));k=k+yd(Dd(m))+'"></span>';"password"==h.providerId?k+='<span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with email</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Email</span>':"phone"==h.providerId?k+='<span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with phone</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Phone</span>':"anonymous"==h.providerId?
	k+='<span class="firebaseui-idp-text firebaseui-idp-text-long">Continue as guest</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Guest</span>':(h="Sign in with "+A(Tk(f,g)),k+='<span class="firebaseui-idp-text firebaseui-idp-text-long">'+h+'</span><span class="firebaseui-idp-text firebaseui-idp-text-short">'+A(Tk(f,g))+"</span>");f=C(k+"</button>");d+='<li class="firebaseui-list-item">'+f+"</li>"}d+='</ul></form></div><div class="firebaseui-card-footer firebaseui-provider-sign-in-footer">'+
	Nk(c)+"</div></div>";return C(d)}Kl.A="firebaseui.auth.soy2.page.providerSignIn";function Ll(a,b,c){a=a||{};var d=a.Fb,e=a.Wa;b=a.ia;a=a||{};a=a.za;a='<div class="firebaseui-phone-number"><button class="firebaseui-id-country-selector firebaseui-country-selector mdl-button mdl-js-button"><span class="firebaseui-flag firebaseui-country-selector-flag firebaseui-id-country-selector-flag"></span><span class="firebaseui-id-country-selector-code"></span></button><div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label firebaseui-textfield firebaseui-phone-input-wrapper"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-phone-number-input">Phone number</label><input type="tel" name="phoneNumber" id="ui-sign-in-phone-number-input" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-number" value="'+
	yd(null!=a?a:"")+'"></div></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-phone-number-error firebaseui-id-phone-number-error"></p></div>';a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-start"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Enter your phone number</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">'+
	C(a);var f;d?f=C('<div class="firebaseui-recaptcha-wrapper"><div class="firebaseui-recaptcha-container"></div><div class="firebaseui-error-wrapper firebaseui-recaptcha-error-wrapper"><p class="firebaseui-error firebaseui-hidden firebaseui-id-recaptcha-error"></p></div></div>'):f="";f=a+f+'</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+(e?Lk(null):"")+Ek({label:E("Verify")})+'</div></div><div class="firebaseui-card-footer">';b?(b='<p class="firebaseui-tos firebaseui-phone-tos">',
	b=c.G&&c.F?b+'By tapping Verify, you are indicating that you accept our <a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a> and <a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a>. An SMS may be sent. Message &amp; data rates may apply.':b+"By tapping Verify, an SMS may be sent. Message &amp; data rates may apply.",c=C(b+"</p>")):c=C('<p class="firebaseui-tos firebaseui-phone-sms-notice">By tapping Verify, an SMS may be sent. Message &amp; data rates may apply.</p>')+
	Mk(c);return C(f+c+"</div></form></div>")}Ll.A="firebaseui.auth.soy2.page.phoneSignInStart";function Ml(a,b,c){a=a||{};b=a.phoneNumber;var d="";a='Enter the 6-digit code we sent to <a class="firebaseui-link firebaseui-change-phone-number-link firebaseui-id-change-phone-number-link" href="javascript:void(0)">&lrm;'+(A(b)+"</a>");A(b);b=d;d=C('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-phone-confirmation-code-input">6-digit code</label><input type="number" name="phoneConfirmationCode" id="ui-sign-in-phone-confirmation-code-input" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-confirmation-code"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-phone-confirmation-code-error"></p></div>');
	c='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-finish"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Verify your phone number</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+a+"</p>"+d+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Lk(null)+Ek({label:E("Continue")})+'</div></div><div class="firebaseui-card-footer">'+Mk(c)+"</div></form>";
	a=C('<div class="firebaseui-resend-container"><span class="firebaseui-id-resend-countdown"></span><a href="javascript:void(0)" class="firebaseui-id-resend-link firebaseui-hidden firebaseui-link">Resend</a></div>');return C(b+(c+a+"</div>"))}Ml.A="firebaseui.auth.soy2.page.phoneSignInFinish";function Nl(){return C('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-out"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign Out</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You are now successfully signed out.</p></div></div>')}
	Nl.A="firebaseui.auth.soy2.page.signOut";function Ol(a,b,c){var d='<div class="firebaseui-container firebaseui-page-select-tenant firebaseui-id-page-select-tenant"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-tenant-list">';a=a.dc;b=a.length;for(var e=0;e<b;e++){var f=a[e];var g="",h="Sign in to "+A(f.displayName),k=A(f.displayName),m=f.tenantId?f.tenantId:"top-level-project";m=E(m);g+='<button class="firebaseui-tenant-button mdl-button mdl-js-button mdl-button--raised firebaseui-tenant-selection-'+
	yd(m)+' firebaseui-id-tenant-selection-button"'+(f.tenantId?'data-tenant-id="'+yd(f.tenantId)+'"':"")+'style="background-color:'+yd(Hd(f.Ga))+'"><span class="firebaseui-idp-icon-wrapper"><img class="firebaseui-idp-icon" alt="" src="'+yd(Dd(f.Na))+'"></span><span class="firebaseui-idp-text firebaseui-idp-text-long">'+h+'</span><span class="firebaseui-idp-text firebaseui-idp-text-short">'+k+"</span></button>";f=C(g);d+='<li class="firebaseui-list-item">'+f+"</li>"}d+='</ul></form></div><div class="firebaseui-card-footer firebaseui-provider-sign-in-footer">'+
	Nk(c)+"</div></div>";return C(d)}Ol.A="firebaseui.auth.soy2.page.selectTenant";function Pl(a,b,c){a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-provider-match-by-email"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">'+Dk(null)+'</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Ek(null)+
	'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form></div>";return C(a)}Pl.A="firebaseui.auth.soy2.page.providerMatchByEmail";function Ql(){return L(this,"firebaseui-id-submit")}function Rl(){return L(this,"firebaseui-id-secondary-link")}function Sl(a,b){N(this,Ql.call(this),function(d){a(d)});var c=Rl.call(this);c&&b&&N(this,c,function(d){b(d)})}function Tl(){return L(this,"firebaseui-id-password")}function Ul(){return L(this,"firebaseui-id-password-error")}function Vl(){var a=
	Tl.call(this),b=Ul.call(this);wk(this,a,function(){Ck(b)&&(M(a,!0),Ak(b))})}function Wl(){var a=Tl.call(this);var b=Ul.call(this);Ij(a)?(M(a,!0),Ak(b),b=!0):(M(a,!1),Bk(b,D("Enter your password").toString()),b=!1);return b?Ij(a):null}function Xl(a,b,c,d,e,f){O.call(this,vl,{email:a},f,"passwordLinking",{G:d,F:e});this.B=b;this.I=c}n(Xl,O);Xl.prototype.v=function(){this.R();this.O(this.B,this.I);hl(this,this.i(),this.B);this.i().focus();O.prototype.v.call(this)};Xl.prototype.s=function(){this.B=null;
	O.prototype.s.call(this)};Xl.prototype.j=function(){return Ij(L(this,"firebaseui-id-email"))};u(Xl.prototype,{i:Tl,D:Ul,R:Vl,u:Wl,ea:Ql,ba:Rl,O:Sl});var Yl=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;function Zl(){return L(this,"firebaseui-id-email")}function $l(){return L(this,"firebaseui-id-email-error")}function am(a){var b=Zl.call(this),c=$l.call(this);wk(this,b,function(){Ck(c)&&(M(b,!0),Ak(c))});a&&xk(this,b,function(){a()})}function bm(){return Za(Ij(Zl.call(this))||
	"")}function cm(){var a=Zl.call(this);var b=$l.call(this);var c=Ij(a)||"";c?Yl.test(c)?(M(a,!0),Ak(b),b=!0):(M(a,!1),Bk(b,D("That email address isn't correct").toString()),b=!1):(M(a,!1),Bk(b,D("Enter your email address to continue").toString()),b=!1);return b?Za(Ij(a)):null}function dm(a,b,c,d,e,f,g){O.call(this,jl,{email:c,ia:!!f},g,"passwordSignIn",{G:d,F:e});this.B=a;this.I=b}n(dm,O);dm.prototype.v=function(){this.R();this.ea();this.ba(this.B,this.I);gl(this,this.l(),this.i());hl(this,this.i(),
	this.B);Ij(this.l())?this.i().focus():this.l().focus();O.prototype.v.call(this)};dm.prototype.s=function(){this.I=this.B=null;O.prototype.s.call(this)};u(dm.prototype,{l:Zl,U:$l,R:am,O:bm,j:cm,i:Tl,D:Ul,ea:Vl,u:Wl,ua:Ql,pa:Rl,ba:Sl});function Q(a,b,c,d,e,f){O.call(this,a,b,d,e||"notice",f);this.i=c||null}w(Q,O);Q.prototype.v=function(){this.i&&(this.u(this.i),this.l().focus());Q.K.v.call(this)};Q.prototype.s=function(){this.i=null;Q.K.s.call(this)};u(Q.prototype,{l:Ql,B:Rl,u:Sl});function em(a,b,
	c,d,e){Q.call(this,ml,{email:a,T:!!b},b,e,"passwordRecoveryEmailSent",{G:c,F:d})}w(em,Q);function fm(a,b){Q.call(this,Fl,{T:!!a},a,b,"emailVerificationSuccess")}w(fm,Q);function gm(a,b){Q.call(this,Gl,{T:!!a},a,b,"emailVerificationFailure")}w(gm,Q);function hm(a){Q.call(this,Nl,void 0,void 0,a,"signOut")}w(hm,Q);function im(a,b){Q.call(this,Bl,{T:!!a},a,b,"passwordResetSuccess")}w(im,Q);function jm(a,b){Q.call(this,Cl,{T:!!a},a,b,"passwordResetFailure")}w(jm,Q);function km(a,b){Q.call(this,El,{T:!!a},
	a,b,"emailChangeRevokeFailure")}w(km,Q);function lm(a,b,c){Q.call(this,Hl,{errorMessage:a,Ab:!!b},b,c,"recoverableError")}w(lm,Q);function mm(a,b){Q.call(this,Il,{errorMessage:a},void 0,b,"unrecoverableError")}w(mm,Q);var nm=!1,om=null;function pm(a,b){nm=!!b;om||("undefined"==typeof accountchooser&&Dj()?(b=Cc(yc(new vc(wc,"//www.gstatic.com/accountchooser/client.js"))),om=H(Lf(b)).ta(function(){})):om=H());om.then(a,a)}function qm(a,b){a=R(a);(a=$i(a).accountChooserInvoked||null)?a(b):b()}function rm(a,
	b,c){a=R(a);(a=$i(a).accountChooserResult||null)?a(b,c):c()}function sm(a,b,c,d,e){d?(K("callback",a,b),nm&&c()):qm(a,function(){Sh(new Ig(a.a.tenantId||null),T(a));oj(function(f){Hh(Ah,T(a));rm(a,f?"empty":"unavailable",function(){K("signIn",a,b);(f||nm)&&c()})},Mh(T(a)),e)})}function tm(a,b,c,d){function e(f){f=U(f);V(b,c,void 0,f);d()}rm(b,"accountSelected",function(){Lh(!1,T(b));var f=um(b);W(b,X(b).fetchSignInMethodsForEmail(a.a).then(function(g){vm(b,c,g,a.a,a.h||void 0,void 0,f);d()},e))})}
	function wm(a,b,c,d){rm(b,a?"addAccount":"unavailable",function(){K("signIn",b,c);(a||nm)&&d()})}function xm(a,b,c,d){function e(){var f=a();f&&(f=Zi(R(f)))&&f()}lj(function(){var f=a();f&&sm(f,b,e,c,d)},function(f){var g=a();g&&tm(f,g,b,e)},function(f){var g=a();g&&wm(f,g,b,e)},a()&&si(R(a())))}function ym(a,b,c,d){function e(g){if(!g.name||"cancel"!=g.name){a:{var h=g.message;try{var k=((JSON.parse(h).error||{}).message||"").toLowerCase().match(/invalid.+(access|id)_token/);if(k&&k.length){var m=
	!0;break a}}catch(q){}m=!1}if(m)g=P(b),b.o(),V(a,g,void 0,D("Your sign-in session has expired. Please try again.").toString());else{m=g&&g.message||"";if(g.code){if("auth/email-already-in-use"==g.code||"auth/credential-already-in-use"==g.code)return;m=U(g)}b.a(m)}}}zm(a);if(d)return Am(a,c),H();if(!c.credential)throw Error("No credential found!");d=X(a).currentUser||c.user;if(!d)throw Error("User not logged in.");d=new zg(d.email,d.displayName,d.photoURL,"password"==c.credential.providerId?null:c.credential.providerId);
	null!=Gh(Ch,T(a))&&!Gh(Ch,T(a))||Nh(d,T(a));Hh(Ch,T(a));try{var f=Bm(a,c)}catch(g){return tg(g.code||g.message,g),b.a(g.code||g.message),H()}c=f.then(function(g){Am(a,g)},e).then(void 0,e);W(a,f);return H(c)}function Am(a,b){if(!b.user)throw Error("No user found");var c=bj(R(a));aj(R(a))&&c&&yg("Both signInSuccess and signInSuccessWithAuthResult callbacks are provided. Only signInSuccessWithAuthResult callback will be invoked.");if(c){c=bj(R(a));var d=Jh(T(a))||void 0;Hh(Bh,T(a));var e=!1;if(tf()){if(!c||
	c(b,d))e=!0,window.opener.location.assign(Fc(Ic(Cm(a,d))));c||window.close()}else if(!c||c(b,d))e=!0,sf(Cm(a,d));e||a.reset()}else{c=b.user;b=b.credential;d=aj(R(a));e=Jh(T(a))||void 0;Hh(Bh,T(a));var f=!1;if(tf()){if(!d||d(c,b,e))f=!0,window.opener.location.assign(Fc(Ic(Cm(a,e))));d||window.close()}else if(!d||d(c,b,e))f=!0,sf(Cm(a,e));f||a.reset()}}function Cm(a,b){a=b||R(a).a.get("signInSuccessUrl");if(!a)throw Error("No redirect URL has been found. You must either specify a signInSuccessUrl in the configuration, pass in a redirect URL to the widget URL, or return false from the callback.");
	return a}function U(a){var b="";switch(a.code){case "auth/email-already-in-use":b+="The email address is already used by another account";break;case "auth/requires-recent-login":b+=Pd();break;case "auth/too-many-requests":b+="You have entered an incorrect password too many times. Please try again in a few minutes.";break;case "auth/user-cancelled":b+="Please authorize the required permissions to sign in to the application";break;case "auth/user-not-found":b+="That email address doesn't match an existing account";
	break;case "auth/user-token-expired":b+=Pd();break;case "auth/weak-password":b+="Strong passwords have at least 6 characters and a mix of letters and numbers";break;case "auth/wrong-password":b+="The email and password you entered don't match";break;case "auth/network-request-failed":b+="A network error has occurred";break;case "auth/invalid-phone-number":b+=Ld();break;case "auth/invalid-verification-code":b+=D("Wrong code. Try again.");break;case "auth/code-expired":b+="This code is no longer valid";
	break;case "auth/expired-action-code":b+="This code has expired.";break;case "auth/invalid-action-code":b+="The action code is invalid. This can happen if the code is malformed, expired, or has already been used."}if(b=D(b).toString())return b;try{return JSON.parse(a.message),tg("Internal error: "+a.message,void 0),Md().toString()}catch(c){return a.message}}function Dm(a,b,c){var d=pi[b]&&firebase.auth[pi[b]]?new firebase.auth[pi[b]]:0==b.indexOf("saml.")?new firebase.auth.SAMLAuthProvider(b):new firebase.auth.OAuthProvider(b);
	if(!d)throw Error("Invalid Firebase Auth provider!");var e=Ki(R(a),b);if(d.addScope)for(var f=0;f<e.length;f++)d.addScope(e[f]);e=Li(R(a),b)||{};c&&(b==firebase.auth.GoogleAuthProvider.PROVIDER_ID?a="login_hint":b==firebase.auth.GithubAuthProvider.PROVIDER_ID?a="login":a=(a=Bi(R(a),b))&&a.Nb,a&&(e[a]=c));d.setCustomParameters&&d.setCustomParameters(e);return d}function Em(a,b,c,d){function e(){Sh(new Ig(a.a.tenantId||null),T(a));W(a,b.L(t(a.cc,a),[k],function(){if("file:"===(window.location&&window.location.protocol))return W(a,
	Fm(a).then(function(m){b.o();Hh(Ah,T(a));K("callback",a,h,H(m))},f))},g))}function f(m){Hh(Ah,T(a));if(!m.name||"cancel"!=m.name)switch(m.code){case "auth/popup-blocked":e();break;case "auth/popup-closed-by-user":case "auth/cancelled-popup-request":break;case "auth/credential-already-in-use":break;case "auth/network-request-failed":case "auth/too-many-requests":case "auth/user-cancelled":b.a(U(m));break;default:b.o(),K("callback",a,h,ff(m))}}function g(m){Hh(Ah,T(a));m.name&&"cancel"==m.name||(tg("signInWithRedirect: "+
	m.code,void 0),m=U(m),"blank"==b.Ea&&Vi(R(a))?(b.o(),K("providerSignIn",a,h,m)):b.a(m))}var h=P(b),k=Dm(a,c,d);Wi(R(a))==Xi?e():W(a,Gm(a,k).then(function(m){b.o();K("callback",a,h,H(m))},f))}function Hm(a,b){W(a,b.L(t(a.Zb,a),[],function(c){b.o();return ym(a,b,c,!0)},function(c){c.name&&"cancel"==c.name||(tg("ContinueAsGuest: "+c.code,void 0),c=U(c),b.a(c))}))}function Im(a,b,c){function d(f){var g=!1;f=b.L(t(a.$b,a),[f],function(h){var k=P(b);b.o();K("callback",a,k,H(h));g=!0},function(h){if(!h.name||
	"cancel"!=h.name)if(!h||"auth/credential-already-in-use"!=h.code)if(h&&"auth/email-already-in-use"==h.code&&h.email&&h.credential){var k=P(b);b.o();K("callback",a,k,ff(h))}else h=U(h),b.a(h)});W(a,f);return f.then(function(){return g},function(){return!1})}var e=Hi(R(a),c&&c.authMethod||null);if(c&&c.idToken&&e===firebase.auth.GoogleAuthProvider.PROVIDER_ID)return Ki(R(a),firebase.auth.GoogleAuthProvider.PROVIDER_ID).length?(Em(a,b,e,c.id),c=H(!0)):c=d(firebase.auth.GoogleAuthProvider.credential(c.idToken)),
	c;c&&b.a(D("The selected credential for the authentication provider is not supported!").toString());return H(!1)}function Jm(a,b){var c=b.j(),d=b.u();if(c)if(d){var e=firebase.auth.EmailAuthProvider.credential(c,d);W(a,b.L(t(a.ac,a),[c,d],function(f){return ym(a,b,{user:f.user,credential:e,operationType:f.operationType,additionalUserInfo:f.additionalUserInfo})},function(f){if(!f.name||"cancel"!=f.name)switch(f.code){case "auth/email-already-in-use":break;case "auth/email-exists":M(b.l(),!1);Bk(b.U(),
	U(f));break;case "auth/too-many-requests":case "auth/wrong-password":M(b.i(),!1);Bk(b.D(),U(f));break;default:tg("verifyPassword: "+f.message,void 0),b.a(U(f))}}))}else b.i().focus();else b.l().focus()}function um(a){a=Ai(R(a));return 1==a.length&&a[0]==firebase.auth.EmailAuthProvider.PROVIDER_ID}function Km(a){a=Ai(R(a));return 1==a.length&&a[0]==firebase.auth.PhoneAuthProvider.PROVIDER_ID}function V(a,b,c,d){um(a)?d?K("signIn",a,b,c,d):Lm(a,b,c):a&&Km(a)&&!d?K("phoneSignInStart",a,b):a&&Vi(R(a))&&
	!d?K("federatedRedirect",a,b,c):K("providerSignIn",a,b,d,c)}function Mm(a,b,c,d){var e=P(b);W(a,b.L(t(X(a).fetchSignInMethodsForEmail,X(a)),[c],function(f){Lh(Fi(R(a))==ri,T(a));b.o();vm(a,e,f,c,void 0,d)},function(f){f=U(f);b.a(f)}))}function vm(a,b,c,d,e,f,g){c.length||Si(R(a))?!c.length&&Si(R(a))?K("sendEmailLinkForSignIn",a,b,d,function(){K("signIn",a,b)}):Qa(c,firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD)?K("passwordSignIn",a,b,d,g):1==c.length&&c[0]===firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD?
	K("sendEmailLinkForSignIn",a,b,d,function(){K("signIn",a,b)}):(c=ni(c,Ai(R(a))))?(Qh(new Gg(d),T(a)),K("federatedSignIn",a,b,d,c,f)):K("unsupportedProvider",a,b,d):K("passwordSignUp",a,b,d,e,void 0,g)}function Nm(a,b,c,d,e,f){var g=P(b);W(a,b.L(t(a.Hb,a),[c,f],function(){b.o();K("emailLinkSignInSent",a,g,c,d,f)},e))}function Lm(a,b,c){Fi(R(a))==ri?pm(function(){jj?qm(a,function(){Sh(new Ig(a.a.tenantId||null),T(a));oj(function(d){Hh(Ah,T(a));rm(a,d?"empty":"unavailable",function(){c?K("prefilledEmailSignIn",
	a,b,c):K("signIn",a,b)})},Mh(T(a)),ti(R(a)))}):(Y(a),xm(Om,b,!1,ti(R(a))))},!1):(nm=!1,qm(a,function(){rm(a,"unavailable",function(){c?K("prefilledEmailSignIn",a,b,c):K("signIn",a,b)})}))}function Pm(a){var b=wf();a=vi(R(a));b=yb(b,a)||"";for(var c in ej)if(ej[c].toLowerCase()==b.toLowerCase())return ej[c];return"callback"}function Qm(a){var b=wf();a=Yh(R(a).a,"queryParameterForSignInSuccessUrl");return(b=yb(b,a))?Fc(Ic(b)):null}function Rm(){return yb(wf(),"oobCode")}function Sm(){var a=yb(wf(),
	"continueUrl");return a?function(){sf(a)}:null}function Tm(a,b){var c=vf(b,"Could not find the FirebaseUI widget element on the page.");b=Qm(a);switch(Pm(a)){case "callback":b&&Kh(b,T(a));a.ob()?K("callback",a,c):V(a,c,Um(a));break;case "resetPassword":K("passwordReset",a,c,Rm(),Sm());break;case "recoverEmail":K("emailChangeRevocation",a,c,Rm());break;case "verifyEmail":K("emailVerification",a,c,Rm(),Sm());break;case "signIn":K("emailLinkSignInCallback",a,c,wf());Vm();break;case "select":if(b&&Kh(b,
	T(a)),jj){V(a,c);break}else{pm(function(){Y(a);xm(Om,c,!0)},!0);return}default:throw Error("Unhandled widget operation.");}(b=Zi(R(a)))&&b()}function Wm(a,b){O.call(this,ul,void 0,b,"anonymousUserMismatch");this.i=a}n(Wm,O);Wm.prototype.v=function(){var a=this;N(this,this.l(),function(){a.i()});this.l().focus();O.prototype.v.call(this)};Wm.prototype.s=function(){this.i=null;O.prototype.s.call(this)};u(Wm.prototype,{l:Rl});J.anonymousUserMismatch=function(a,b){var c=new Wm(function(){c.o();V(a,b)});
	c.render(b);Z(a,c)};function Xm(a){O.call(this,nl,void 0,a,"callback")}n(Xm,O);Xm.prototype.L=function(a,b,c,d){return a.apply(null,b).then(c,d)};function Ym(a,b,c){if(c.user){var d={user:c.user,credential:c.credential,operationType:c.operationType,additionalUserInfo:c.additionalUserInfo},e=Oh(T(a)),f=e&&e.f;if(f&&!Zm(c.user,f))$m(a,b,d);else{var g=e&&e.a;g?W(a,c.user.linkWithCredential(g).then(function(h){d={user:h.user,credential:g,operationType:h.operationType,additionalUserInfo:h.additionalUserInfo};
	an(a,b,d)},function(h){bn(a,b,h)})):an(a,b,d)}}else c=P(b),b.o(),Ph(T(a)),V(a,c)}function an(a,b,c){Ph(T(a));ym(a,b,c)}function bn(a,b,c){var d=P(b);Ph(T(a));c=U(c);b.o();V(a,d,void 0,c)}function cn(a,b,c,d){var e=P(b);W(a,X(a).fetchSignInMethodsForEmail(c).then(function(f){b.o();f.length?Qa(f,firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD)?K("passwordLinking",a,e,c):1==f.length&&f[0]===firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD?K("emailLinkSignInLinking",a,e,c):(f=ni(f,
	Ai(R(a))))?K("federatedLinking",a,e,c,f,d):(Ph(T(a)),K("unsupportedProvider",a,e,c)):(Ph(T(a)),K("passwordRecovery",a,e,c,!1,Nd().toString()))},function(f){bn(a,b,f)}))}function $m(a,b,c){var d=P(b);W(a,dn(a).then(function(){b.o();K("emailMismatch",a,d,c)},function(e){e.name&&"cancel"==e.name||(e=U(e.code),b.a(e))}))}function Zm(a,b){if(b==a.email)return!0;if(a.providerData)for(var c=0;c<a.providerData.length;c++)if(b==a.providerData[c].email)return!0;return!1}J.callback=function(a,b,c){var d=new Xm;
	d.render(b);Z(a,d);b=c||Fm(a);W(a,b.then(function(e){Ym(a,d,e)},function(e){if(e&&("auth/account-exists-with-different-credential"==e.code||"auth/email-already-in-use"==e.code)&&e.email&&e.credential)Qh(new Gg(e.email,e.credential),T(a)),cn(a,d,e.email);else if(e&&"auth/user-cancelled"==e.code){var f=Oh(T(a)),g=U(e);f&&f.a?cn(a,d,f.f,g):f?Mm(a,d,f.f,g):bn(a,d,e)}else e&&"auth/credential-already-in-use"==e.code||(e&&"auth/operation-not-supported-in-this-environment"==e.code&&um(a)?Ym(a,d,{user:null,
	credential:null}):bn(a,d,e))}))};function en(a,b){O.call(this,tl,void 0,b,"differentDeviceError");this.i=a}n(en,O);en.prototype.v=function(){var a=this;N(this,this.l(),function(){a.i()});this.l().focus();O.prototype.v.call(this)};en.prototype.s=function(){this.i=null;O.prototype.s.call(this)};u(en.prototype,{l:Rl});J.differentDeviceError=function(a,b){var c=new en(function(){c.o();V(a,b)});c.render(b);Z(a,c)};function fn(a,b,c,d){O.call(this,Dl,{email:a,T:!!c},d,"emailChangeRevoke");this.l=b;this.i=
	c||null}n(fn,O);fn.prototype.v=function(){var a=this;N(this,L(this,"firebaseui-id-reset-password-link"),function(){a.l()});this.i&&(this.B(this.i),this.u().focus());O.prototype.v.call(this)};fn.prototype.s=function(){this.l=this.i=null;O.prototype.s.call(this)};u(fn.prototype,{u:Ql,D:Rl,B:Sl});function gn(){return L(this,"firebaseui-id-new-password")}function hn(){return L(this,"firebaseui-id-password-toggle")}function jn(){this.Sa=!this.Sa;var a=hn.call(this),b=gn.call(this);this.Sa?(b.type="text",
	Gj(a,"firebaseui-input-toggle-off"),Hj(a,"firebaseui-input-toggle-on")):(b.type="password",Gj(a,"firebaseui-input-toggle-on"),Hj(a,"firebaseui-input-toggle-off"));b.focus()}function kn(){return L(this,"firebaseui-id-new-password-error")}function ln(){this.Sa=!1;var a=gn.call(this);a.type="password";var b=kn.call(this);wk(this,a,function(){Ck(b)&&(M(a,!0),Ak(b))});var c=hn.call(this);Gj(c,"firebaseui-input-toggle-on");Hj(c,"firebaseui-input-toggle-off");yk(this,a,function(){Gj(c,"firebaseui-input-toggle-focus");
	Hj(c,"firebaseui-input-toggle-blur")});zk(this,a,function(){Gj(c,"firebaseui-input-toggle-blur");Hj(c,"firebaseui-input-toggle-focus")});N(this,c,t(jn,this))}function mn(){var a=gn.call(this);var b=kn.call(this);Ij(a)?(M(a,!0),Ak(b),b=!0):(M(a,!1),Bk(b,D("Enter your password").toString()),b=!1);return b?Ij(a):null}function nn(a,b,c){O.call(this,Al,{email:a},c,"passwordReset");this.l=b}n(nn,O);nn.prototype.v=function(){this.I();this.D(this.l);hl(this,this.i(),this.l);this.i().focus();O.prototype.v.call(this)};
	nn.prototype.s=function(){this.l=null;O.prototype.s.call(this)};u(nn.prototype,{i:gn,B:kn,O:hn,I:ln,u:mn,U:Ql,R:Rl,D:Sl});function on(a,b,c,d,e){var f=c.u();f&&W(a,c.L(t(X(a).confirmPasswordReset,X(a)),[d,f],function(){c.o();var g=new im(e);g.render(b);Z(a,g)},function(g){pn(a,b,c,g)}))}function pn(a,b,c,d){"auth/weak-password"==(d&&d.code)?(a=U(d),M(c.i(),!1),Bk(c.B(),a),c.i().focus()):(c&&c.o(),c=new jm,c.render(b),Z(a,c))}function qn(a,b,c){var d=new fn(c,function(){W(a,d.L(t(X(a).sendPasswordResetEmail,
	X(a)),[c],function(){d.o();d=new em(c,void 0,Pi(R(a)),Qi(R(a)));d.render(b);Z(a,d)},function(){d.a(D("Unable to send password reset code to specified email").toString())}))});d.render(b);Z(a,d)}J.passwordReset=function(a,b,c,d){W(a,X(a).verifyPasswordResetCode(c).then(function(e){var f=new nn(e,function(){on(a,b,f,c,d)});f.render(b);Z(a,f)},function(){pn(a,b)}))};J.emailChangeRevocation=function(a,b,c){var d=null;W(a,X(a).checkActionCode(c).then(function(e){d=e.data.email;return X(a).applyActionCode(c)}).then(function(){qn(a,
	b,d)},function(){var e=new km;e.render(b);Z(a,e)}))};J.emailVerification=function(a,b,c,d){W(a,X(a).applyActionCode(c).then(function(){var e=new fm(d);e.render(b);Z(a,e)},function(){var e=new gm;e.render(b);Z(a,e)}))};function rn(a,b){try{var c="number"==typeof a.selectionStart}catch(d){c=!1}c?(a.selectionStart=b,a.selectionEnd=b):z&&!sc("9")&&("textarea"==a.type&&(b=a.value.substring(0,b).replace(/(\r\n|\r|\n)/g,"\n").length),a=a.createTextRange(),a.collapse(!0),a.move("character",b),a.select())}
	function sn(a,b,c,d,e,f){O.call(this,sl,{email:c},f,"emailLinkSignInConfirmation",{G:d,F:e});this.l=a;this.u=b}n(sn,O);sn.prototype.v=function(){this.B(this.l);this.D(this.l,this.u);this.i().focus();rn(this.i(),(this.i().value||"").length);O.prototype.v.call(this)};sn.prototype.s=function(){this.u=this.l=null;O.prototype.s.call(this)};u(sn.prototype,{i:Zl,O:$l,B:am,I:bm,j:cm,U:Ql,R:Rl,D:Sl});J.emailLinkConfirmation=function(a,b,c,d,e,f){var g=new sn(function(){var h=g.j();h?(g.o(),d(a,b,h,c)):g.i().focus()},
	function(){g.o();V(a,b,e||void 0)},e||void 0,Pi(R(a)),Qi(R(a)));g.render(b);Z(a,g);f&&g.a(f)};function tn(a,b,c,d,e){O.call(this,xl,{ga:a},e,"emailLinkSignInLinkingDifferentDevice",{G:c,F:d});this.i=b}n(tn,O);tn.prototype.v=function(){this.u(this.i);this.l().focus();O.prototype.v.call(this)};tn.prototype.s=function(){this.i=null;O.prototype.s.call(this)};u(tn.prototype,{l:Ql,u:Sl});J.emailLinkNewDeviceLinking=function(a,b,c,d){var e=new Vb(c);c=e.a.a.get(x.PROVIDER_ID)||null;Zb(e,null);if(c){var f=
	new tn(Bi(R(a),c),function(){f.o();d(a,b,e.toString())},Pi(R(a)),Qi(R(a)));f.render(b);Z(a,f)}else V(a,b)};function un(a){O.call(this,pl,void 0,a,"blank")}n(un,O);function vn(a,b,c,d,e){var f=new un,g=new Vb(c),h=g.a.a.get(x.ab)||"",k=g.a.a.get(x.Ta)||"",m="1"===g.a.a.get(x.Ra),q=Yb(g),B=g.a.a.get(x.PROVIDER_ID)||null;g=g.a.a.get(x.xb)||null;wn(a,g);var S=!Gh(Eh,T(a)),Ga=d||Th(k,T(a)),Oa=(d=Uh(k,T(a)))&&d.a;B&&Oa&&Oa.providerId!==B&&(Oa=null);f.render(b);Z(a,f);W(a,f.L(function(){var ja=H(null);ja=
	q&&S||S&&m?ff(Error("anonymous-user-not-found")):xn(a,c).then(function(Kg){if(B&&!Oa)throw Error("pending-credential-not-found");return Kg});var qd=null;return ja.then(function(Kg){qd=Kg;return e?null:X(a).checkActionCode(h)}).then(function(){return qd})},[],function(ja){Ga?yn(a,f,Ga,c,Oa,ja):m?(f.o(),K("differentDeviceError",a,b)):(f.o(),K("emailLinkConfirmation",a,b,c,zn))},function(ja){var qd=void 0;if(!ja||!ja.name||"cancel"!=ja.name)switch(f.o(),ja&&ja.message){case "anonymous-user-not-found":K("differentDeviceError",
	a,b);break;case "anonymous-user-mismatch":K("anonymousUserMismatch",a,b);break;case "pending-credential-not-found":K("emailLinkNewDeviceLinking",a,b,c,An);break;default:ja&&(qd=U(ja)),V(a,b,void 0,qd)}}))}function zn(a,b,c,d){vn(a,b,d,c,!0)}function An(a,b,c){vn(a,b,c)}function yn(a,b,c,d,e,f){var g=P(b);b.Z("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon",D("Signing in...").toString());var h=null;e=(f?Bn(a,f,c,d,e):Cn(a,c,d,e)).then(function(k){Hh(Fh,
	T(a));Hh(Eh,T(a));b.h();b.Z("firebaseui-icon-done",D("Signed in!").toString());h=setTimeout(function(){b.h();ym(a,b,k,!0)},1E3);W(a,function(){b&&(b.h(),b.o());clearTimeout(h)})},function(k){b.h();b.o();if(!k.name||"cancel"!=k.name){var m=U(k);"auth/email-already-in-use"==k.code||"auth/credential-already-in-use"==k.code?(Hh(Fh,T(a)),Hh(Eh,T(a))):"auth/invalid-email"==k.code?(m=D("The email provided does not match the current sign-in session.").toString(),K("emailLinkConfirmation",a,g,d,zn,null,m)):
	V(a,g,c,m)}});W(a,e)}J.emailLinkSignInCallback=vn;function Dn(a,b,c,d,e,f){O.call(this,wl,{email:a,ga:b},f,"emailLinkSignInLinking",{G:d,F:e});this.i=c}n(Dn,O);Dn.prototype.v=function(){this.u(this.i);this.l().focus();O.prototype.v.call(this)};Dn.prototype.s=function(){this.i=null;O.prototype.s.call(this)};u(Dn.prototype,{l:Ql,u:Sl});function En(a,b,c,d){var e=P(b);Nm(a,b,c,function(){V(a,e,c)},function(f){if(!f.name||"cancel"!=f.name){var g=U(f);f&&"auth/network-request-failed"==f.code?b.a(g):(b.o(),
	V(a,e,c,g))}},d)}J.emailLinkSignInLinking=function(a,b,c){var d=Oh(T(a));Ph(T(a));if(d){var e=d.a.providerId,f=new Dn(c,Bi(R(a),e),function(){En(a,f,c,d)},Pi(R(a)),Qi(R(a)));f.render(b);Z(a,f)}else V(a,b)};function Fn(a,b,c,d,e,f){O.call(this,ql,{email:a},f,"emailLinkSignInSent",{G:d,F:e});this.u=b;this.i=c}n(Fn,O);Fn.prototype.v=function(){var a=this;N(this,this.l(),function(){a.i()});N(this,L(this,"firebaseui-id-trouble-getting-email-link"),function(){a.u()});this.l().focus();O.prototype.v.call(this)};
	Fn.prototype.s=function(){this.i=this.u=null;O.prototype.s.call(this)};u(Fn.prototype,{l:Rl});J.emailLinkSignInSent=function(a,b,c,d,e){var f=new Fn(c,function(){f.o();K("emailNotReceived",a,b,c,d,e)},function(){f.o();d()},Pi(R(a)),Qi(R(a)));f.render(b);Z(a,f)};function Gn(a,b,c,d,e,f,g){O.call(this,Jl,{ic:a,Pb:b},g,"emailMismatch",{G:e,F:f});this.l=c;this.i=d}n(Gn,O);Gn.prototype.v=function(){this.B(this.l,this.i);this.u().focus();O.prototype.v.call(this)};Gn.prototype.s=function(){this.i=null;O.prototype.s.call(this)};
	u(Gn.prototype,{u:Ql,D:Rl,B:Sl});J.emailMismatch=function(a,b,c){var d=Oh(T(a));if(d){var e=new Gn(c.user.email,d.f,function(){var f=e;Ph(T(a));ym(a,f,c)},function(){var f=c.credential.providerId,g=P(e);e.o();d.a?K("federatedLinking",a,g,d.f,f):K("federatedSignIn",a,g,d.f,f)},Pi(R(a)),Qi(R(a)));e.render(b);Z(a,e)}else V(a,b)};function Hn(a,b,c,d,e){O.call(this,rl,void 0,e,"emailNotReceived",{G:c,F:d});this.l=a;this.i=b}n(Hn,O);Hn.prototype.v=function(){var a=this;N(this,this.u(),function(){a.i()});
	N(this,this.Ba(),function(){a.l()});this.u().focus();O.prototype.v.call(this)};Hn.prototype.Ba=function(){return L(this,"firebaseui-id-resend-email-link")};Hn.prototype.s=function(){this.i=this.l=null;O.prototype.s.call(this)};u(Hn.prototype,{u:Rl});J.emailNotReceived=function(a,b,c,d,e){var f=new Hn(function(){Nm(a,f,c,d,function(g){g=U(g);f.a(g)},e)},function(){f.o();V(a,b,c)},Pi(R(a)),Qi(R(a)));f.render(b);Z(a,f)};function In(a,b,c,d,e,f){O.call(this,yl,{email:a,ga:b},f,"federatedLinking",{G:d,
	F:e});this.i=c}n(In,O);In.prototype.v=function(){this.u(this.i);this.l().focus();O.prototype.v.call(this)};In.prototype.s=function(){this.i=null;O.prototype.s.call(this)};u(In.prototype,{l:Ql,u:Sl});J.federatedLinking=function(a,b,c,d,e){var f=Oh(T(a));if(f&&f.a){var g=new In(c,Bi(R(a),d),function(){Em(a,g,d,c)},Pi(R(a)),Qi(R(a)));g.render(b);Z(a,g);e&&g.a(e)}else V(a,b)};J.federatedRedirect=function(a,b,c){var d=new un;d.render(b);Z(a,d);b=Ai(R(a))[0];Em(a,d,b,c)};J.federatedSignIn=function(a,b,
	c,d,e){var f=new In(c,Bi(R(a),d),function(){Em(a,f,d,c)},Pi(R(a)),Qi(R(a)));f.render(b);Z(a,f);e&&f.a(e)};function Jn(a,b,c,d){var e=b.u();e?W(a,b.L(t(a.Wb,a),[c,e],function(f){f=f.user.linkWithCredential(d).then(function(g){return ym(a,b,{user:g.user,credential:d,operationType:g.operationType,additionalUserInfo:g.additionalUserInfo})});W(a,f);return f},function(f){if(!f.name||"cancel"!=f.name)switch(f.code){case "auth/wrong-password":M(b.i(),!1);Bk(b.D(),U(f));break;case "auth/too-many-requests":b.a(U(f));
	break;default:tg("signInWithEmailAndPassword: "+f.message,void 0),b.a(U(f))}})):b.i().focus()}J.passwordLinking=function(a,b,c){var d=Oh(T(a));Ph(T(a));var e=d&&d.a;if(e){var f=new Xl(c,function(){Jn(a,f,c,e)},function(){f.o();K("passwordRecovery",a,b,c)},Pi(R(a)),Qi(R(a)));f.render(b);Z(a,f)}else V(a,b)};function Kn(a,b,c,d,e,f){O.call(this,ll,{email:c,Ua:!!b},f,"passwordRecovery",{G:d,F:e});this.l=a;this.u=b}n(Kn,O);Kn.prototype.v=function(){this.D();this.I(this.l,this.u);Ij(this.i())||this.i().focus();
	hl(this,this.i(),this.l);O.prototype.v.call(this)};Kn.prototype.s=function(){this.u=this.l=null;O.prototype.s.call(this)};u(Kn.prototype,{i:Zl,B:$l,D:am,O:bm,j:cm,U:Ql,R:Rl,I:Sl});function Ln(a,b){var c=b.j();if(c){var d=P(b);W(a,b.L(t(X(a).sendPasswordResetEmail,X(a)),[c],function(){b.o();var e=new em(c,function(){e.o();V(a,d)},Pi(R(a)),Qi(R(a)));e.render(d);Z(a,e)},function(e){M(b.i(),!1);Bk(b.B(),U(e))}))}else b.i().focus()}J.passwordRecovery=function(a,b,c,d,e){var f=new Kn(function(){Ln(a,f)},
	d?void 0:function(){f.o();V(a,b)},c,Pi(R(a)),Qi(R(a)));f.render(b);Z(a,f);e&&f.a(e)};J.passwordSignIn=function(a,b,c,d){var e=new dm(function(){Jm(a,e)},function(){var f=e.O();e.o();K("passwordRecovery",a,b,f)},c,Pi(R(a)),Qi(R(a)),d);e.render(b);Z(a,e)};function Mn(){return L(this,"firebaseui-id-name")}function Nn(){return L(this,"firebaseui-id-name-error")}function On(a,b,c,d,e,f,g,h,k){O.call(this,kl,{email:d,Sb:a,name:e,Ua:!!c,ia:!!h},k,"passwordSignUp",{G:f,F:g});this.B=b;this.I=c;this.D=a}n(On,
	O);On.prototype.v=function(){this.ea();this.D&&this.Ja();this.ua();this.pa(this.B,this.I);this.D?(gl(this,this.i(),this.u()),gl(this,this.u(),this.l())):gl(this,this.i(),this.l());this.B&&hl(this,this.l(),this.B);Ij(this.i())?this.D&&!Ij(this.u())?this.u().focus():this.l().focus():this.i().focus();O.prototype.v.call(this)};On.prototype.s=function(){this.I=this.B=null;O.prototype.s.call(this)};u(On.prototype,{i:Zl,U:$l,ea:am,kb:bm,j:cm,u:Mn,Ac:Nn,Ja:function(){var a=Mn.call(this),b=Nn.call(this);wk(this,
	a,function(){Ck(b)&&(M(a,!0),Ak(b))})},O:function(){var a=Mn.call(this);var b=Nn.call(this);var c=Ij(a);c=!/^[\s\xa0]*$/.test(null==c?"":String(c));M(a,c);c?(Ak(b),b=!0):(Bk(b,D("Enter your account name").toString()),b=!1);return b?Za(Ij(a)):null},l:gn,ba:kn,mb:hn,ua:ln,R:mn,Mb:Ql,Lb:Rl,pa:Sl});function Pn(a,b){var c=Ri(R(a)),d=b.j(),e=null;c&&(e=b.O());var f=b.R();if(d){if(c)if(e)e=hb(e);else{b.u().focus();return}if(f){var g=firebase.auth.EmailAuthProvider.credential(d,f);W(a,b.L(t(a.Xb,a),[d,f],
	function(h){var k={user:h.user,credential:g,operationType:h.operationType,additionalUserInfo:h.additionalUserInfo};return c?(h=h.user.updateProfile({displayName:e}).then(function(){return ym(a,b,k)}),W(a,h),h):ym(a,b,k)},function(h){if(!h.name||"cancel"!=h.name){var k=U(h);switch(h.code){case "auth/email-already-in-use":return Qn(a,b,d,h);case "auth/too-many-requests":k=D("Too many account requests are coming from your IP address. Try again in a few minutes.").toString();case "auth/operation-not-allowed":case "auth/weak-password":M(b.l(),
	!1);Bk(b.ba(),k);break;default:h="setAccountInfo: "+gh(h),tg(h,void 0),b.a(k)}}}))}else b.l().focus()}else b.i().focus()}function Qn(a,b,c,d){function e(){var g=U(d);M(b.i(),!1);Bk(b.U(),g);b.i().focus()}var f=X(a).fetchSignInMethodsForEmail(c).then(function(g){g.length?e():(g=P(b),b.o(),K("passwordRecovery",a,g,c,!1,Nd().toString()))},function(){e()});W(a,f);return f}J.passwordSignUp=function(a,b,c,d,e,f){function g(){h.o();V(a,b)}var h=new On(Ri(R(a)),function(){Pn(a,h)},e?void 0:g,c,d,Pi(R(a)),
	Qi(R(a)),f);h.render(b);Z(a,h)};function Rn(){return L(this,"firebaseui-id-phone-confirmation-code")}function Sn(){return L(this,"firebaseui-id-phone-confirmation-code-error")}function Tn(){return L(this,"firebaseui-id-resend-countdown")}function Un(a,b,c,d,e,f,g,h,k){O.call(this,Ml,{phoneNumber:e},k,"phoneSignInFinish",{G:g,F:h});this.kb=f;this.i=new Uj(1E3);this.D=f;this.R=a;this.l=b;this.I=c;this.O=d}n(Un,O);Un.prototype.v=function(){var a=this;this.U(this.kb);ne(this.i,"tick",this.B,!1,this);
	this.i.start();N(this,L(this,"firebaseui-id-change-phone-number-link"),function(){a.R()});N(this,this.Ba(),function(){a.O()});this.Ja(this.l);this.ea(this.l,this.I);this.u().focus();O.prototype.v.call(this)};Un.prototype.s=function(){this.O=this.I=this.l=this.R=null;Vj(this.i);ve(this.i,"tick",this.B);this.i=null;O.prototype.s.call(this)};Un.prototype.B=function(){--this.D;0<this.D?this.U(this.D):(Vj(this.i),ve(this.i,"tick",this.B),this.ua(),this.mb())};u(Un.prototype,{u:Rn,pa:Sn,Ja:function(a){var b=
	Rn.call(this),c=Sn.call(this);wk(this,b,function(){Ck(c)&&(M(b,!0),Ak(c))});a&&xk(this,b,function(){a()})},ba:function(){var a=Za(Ij(Rn.call(this))||"");return/^\d{6}$/.test(a)?a:null},Eb:Tn,U:function(a){ed(Tn.call(this),D("Resend code in "+((9<a?"0:":"0:0")+a)).toString())},ua:function(){Ak(this.Eb())},Ba:function(){return L(this,"firebaseui-id-resend-link")},mb:function(){Bk(this.Ba())},Mb:Ql,Lb:Rl,ea:Sl});function Vn(a,b,c,d){function e(g){b.u().focus();M(b.u(),!1);Bk(b.pa(),g)}var f=b.ba();f?
	(b.Z("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon",D("Verifying...").toString()),W(a,b.L(t(d.confirm,d),[f],function(g){b.h();b.Z("firebaseui-icon-done",D("Verified!").toString());var h=setTimeout(function(){b.h();b.o();var k={user:Wn(a).currentUser,credential:null,operationType:g.operationType,additionalUserInfo:g.additionalUserInfo};ym(a,b,k,!0)},1E3);W(a,function(){b&&b.h();clearTimeout(h)})},function(g){if(g.name&&"cancel"==g.name)b.h();
	else{var h=U(g);switch(g.code){case "auth/credential-already-in-use":b.h();break;case "auth/code-expired":g=P(b);b.h();b.o();K("phoneSignInStart",a,g,c,h);break;case "auth/missing-verification-code":case "auth/invalid-verification-code":b.h();e(h);break;default:b.h(),b.a(h)}}}))):e(D("Wrong code. Try again.").toString())}J.phoneSignInFinish=function(a,b,c,d,e,f){var g=new Un(function(){g.o();K("phoneSignInStart",a,b,c)},function(){Vn(a,g,c,e)},function(){g.o();V(a,b)},function(){g.o();K("phoneSignInStart",
	a,b,c)},mi(c),d,Pi(R(a)),Qi(R(a)));g.render(b);Z(a,g);f&&g.a(f)};var Xn=!z&&!(y("Safari")&&!(cc()||y("Coast")||y("Opera")||y("Edge")||y("Firefox")||y("FxiOS")||y("Silk")||y("Android")));function Yn(a,b){if(/-[a-z]/.test(b))return null;if(Xn&&a.dataset){if(!(!y("Android")||cc()||y("Firefox")||y("FxiOS")||y("Opera")||y("Silk")||b in a.dataset))return null;a=a.dataset[b];return void 0===a?null:a}return a.getAttribute("data-"+String(b).replace(/([A-Z])/g,"-$1").toLowerCase())}function Zn(a,b,c){var d=
	this;a=md(Rk,{items:a},null,this.m);Yk.call(this,a,!0,!0);c&&(c=$n(a,c))&&(c.focus(),ok(c,a));N(this,a,function(e){if(e=(e=fd(e.target,"firebaseui-id-list-box-dialog-button"))&&Yn(e,"listboxid"))Zk.call(d),b(e)})}function $n(a,b){a=(a||document).getElementsByTagName("BUTTON");for(var c=0;c<a.length;c++)if(Yn(a[c],"listboxid")===b)return a[c];return null}function ao(){return L(this,"firebaseui-id-phone-number")}function bo(){return L(this,"firebaseui-id-country-selector")}function co(){return L(this,
	"firebaseui-id-phone-number-error")}function eo(a,b){var c=a.a,d=fo("1-US-0",c),e=null;b&&fo(b,c)?e=b:d?e="1-US-0":e=0<c.length?c[0].c:null;if(!e)throw Error("No available default country");go.call(this,e,a)}function fo(a,b){a=ei(a);return!(!a||!Qa(b,a))}function ho(a){return Ma(a,function(b){return{id:b.c,Ma:"firebaseui-flag "+io(b),label:b.name+" "+("\u200e+"+b.b)}})}function io(a){return"firebaseui-flag-"+a.g}function jo(a){var b=this;Zn.call(this,ho(a.a),function(c){go.call(b,c,a,!0);b.M().focus()},
	this.Aa)}function go(a,b,c){var d=ei(a);d&&(c&&(c=Za(Ij(ao.call(this))||""),b=di(b,c),b.length&&b[0].b!=d.b&&(c="+"+d.b+c.substr(b[0].b.length+1),Jj(ao.call(this),c))),b=ei(this.Aa),this.Aa=a,a=L(this,"firebaseui-id-country-selector-flag"),b&&Hj(a,io(b)),Gj(a,io(d)),ed(L(this,"firebaseui-id-country-selector-code"),"\u200e+"+d.b))}function ko(a,b,c,d,e,f,g,h,k,m){O.call(this,Ll,{Fb:b,za:k||null,Wa:!!c,ia:!!f},m,"phoneSignInStart",{G:d,F:e});this.I=h||null;this.O=b;this.l=a;this.B=c||null;this.pa=g||
	null}n(ko,O);ko.prototype.v=function(){this.ea(this.pa,this.I);this.R(this.l,this.B||void 0);this.O||gl(this,this.M(),this.i());hl(this,this.i(),this.l);this.M().focus();rn(this.M(),(this.M().value||"").length);O.prototype.v.call(this)};ko.prototype.s=function(){this.B=this.l=null;O.prototype.s.call(this)};u(ko.prototype,{Db:$k,M:ao,D:co,ea:function(a,b,c){var d=this,e=ao.call(this),f=bo.call(this),g=co.call(this),h=a||ji,k=h.a;if(0==k.length)throw Error("No available countries provided.");eo.call(d,
	h,b);N(this,f,function(){jo.call(d,h)});wk(this,e,function(){Ck(g)&&(M(e,!0),Ak(g));var m=Za(Ij(e)||""),q=ei(this.Aa),B=di(h,m);m=fo("1-US-0",k);B.length&&B[0].b!=q.b&&(q=B[0],go.call(d,"1"==q.b&&m?"1-US-0":q.c,h))});c&&xk(this,e,function(){c()})},U:function(a){var b=Za(Ij(ao.call(this))||"");a=a||ji;var c=a.a,d=di(ji,b);if(d.length&&!Qa(c,d[0]))throw Jj(ao.call(this)),ao.call(this).focus(),Bk(co.call(this),D("The country code provided is not supported.").toString()),Error("The country code provided is not supported.");
	c=ei(this.Aa);d.length&&d[0].b!=c.b&&go.call(this,d[0].c,a);d.length&&(b=b.substr(d[0].b.length+1));return b?new ki(this.Aa,b):null},Ja:bo,ba:function(){return L(this,"firebaseui-recaptcha-container")},u:function(){return L(this,"firebaseui-id-recaptcha-error")},i:Ql,ua:Rl,R:Sl});function lo(a,b,c,d){try{var e=b.U(hj)}catch(f){return}e?fj?(b.Z("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon",D("Verifying...").toString()),W(a,b.L(t(a.bc,a),[mi(e),
	c],function(f){var g=P(b);b.Z("firebaseui-icon-done",D("Code sent!").toString());var h=setTimeout(function(){b.h();b.o();K("phoneSignInFinish",a,g,e,15,f)},1E3);W(a,function(){b&&b.h();clearTimeout(h)})},function(f){b.h();if(!f.name||"cancel"!=f.name){grecaptcha.reset(ij);fj=null;var g=f&&f.message||"";if(f.code)switch(f.code){case "auth/too-many-requests":g=D("This phone number has been used too many times").toString();break;case "auth/invalid-phone-number":case "auth/missing-phone-number":b.M().focus();
	Bk(b.D(),Ld().toString());return;default:g=U(f)}b.a(g)}}))):gj?Bk(b.u(),D("Solve the reCAPTCHA").toString()):!gj&&d&&b.i().click():(b.M().focus(),Bk(b.D(),Ld().toString()))}J.phoneSignInStart=function(a,b,c,d){var e=Ii(R(a))||{};fj=null;gj=!(e&&"invisible"===e.size);var f=Km(a),g=Ni(R(a)),h=f?Mi(R(a)):null;g=c&&c.a||g&&g.c||null;c=c&&c.za||h;(h=Oi(R(a)))&&ii(h);hj=h?new ci(Oi(R(a))):ji;var k=new ko(function(q){lo(a,k,m,!(!q||!q.keyCode))},gj,f?null:function(){m.clear();k.o();V(a,b)},Pi(R(a)),Qi(R(a)),
	f,hj,g,c);k.render(b);Z(a,k);d&&k.a(d);e.callback=function(q){k.u()&&Ak(k.u());fj=q;gj||lo(a,k,m)};e["expired-callback"]=function(){fj=null};var m=new firebase.auth.RecaptchaVerifier(gj?k.ba():k.i(),e,Wn(a).app);W(a,k.L(t(m.render,m),[],function(q){ij=q},function(q){q.name&&"cancel"==q.name||(q=U(q),k.o(),V(a,b,void 0,q))}))};J.prefilledEmailSignIn=function(a,b,c){var d=new un;d.render(b);Z(a,d);W(a,d.L(t(X(a).fetchSignInMethodsForEmail,X(a)),[c],function(e){d.o();var f=!(!um(a)||!Um(a));vm(a,b,e,
	c,void 0,void 0,f)},function(e){e=U(e);d.o();K("signIn",a,b,c,e)}))};function mo(a,b,c,d,e){O.call(this,Kl,{Rb:b},e,"providerSignIn",{G:c,F:d});this.i=a}n(mo,O);mo.prototype.v=function(){this.l(this.i);O.prototype.v.call(this)};mo.prototype.s=function(){this.i=null;O.prototype.s.call(this)};u(mo.prototype,{l:function(a){function b(g){a(g)}for(var c=this.f?Yc("firebaseui-id-idp-button",this.f||this.m.a):[],d=0;d<c.length;d++){var e=c[d],f=Yn(e,"providerId");N(this,e,Ba(b,f))}}});J.providerSignIn=function(a,
	b,c,d){var e=new mo(function(f){f==firebase.auth.EmailAuthProvider.PROVIDER_ID?(e.o(),Lm(a,b,d)):f==firebase.auth.PhoneAuthProvider.PROVIDER_ID?(e.o(),K("phoneSignInStart",a,b)):"anonymous"==f?Hm(a,e):Em(a,e,f,d);Y(a);a.l.cancel()},Ci(R(a)),Pi(R(a)),Qi(R(a)));e.render(b);Z(a,e);c&&e.a(c);no(a)};J.sendEmailLinkForSignIn=function(a,b,c,d){var e=new Xm;e.render(b);Z(a,e);Nm(a,e,c,d,function(f){e.o();f=U(f);K("signIn",a,b,c,f)})};function oo(a,b,c,d,e,f,g){O.call(this,il,{email:c,Wa:!!b,ia:!!f},g,"signIn",
	{G:d,F:e});this.i=a;this.u=b}n(oo,O);oo.prototype.v=function(){this.B(this.i);this.D(this.i,this.u||void 0);this.l().focus();rn(this.l(),(this.l().value||"").length);O.prototype.v.call(this)};oo.prototype.s=function(){this.u=this.i=null;O.prototype.s.call(this)};u(oo.prototype,{l:Zl,O:$l,B:am,I:bm,j:cm,U:Ql,R:Rl,D:Sl});J.signIn=function(a,b,c,d){var e=um(a),f=e&&Fi(R(a))!=ri,g=new oo(function(){var h=g,k=h.j()||"";k&&Mm(a,h,k)},f?null:function(){g.o();V(a,b,c)},c,Pi(R(a)),Qi(R(a)),e);g.render(b);
	Z(a,g);d&&g.a(d)};function po(a,b,c,d,e,f){O.call(this,zl,{email:a},f,"unsupportedProvider",{G:d,F:e});this.l=b;this.i=c}n(po,O);po.prototype.v=function(){this.B(this.l,this.i);this.u().focus();O.prototype.v.call(this)};po.prototype.s=function(){this.i=this.l=null;O.prototype.s.call(this)};u(po.prototype,{u:Ql,D:Rl,B:Sl});J.unsupportedProvider=function(a,b,c){var d=new po(c,function(){d.o();K("passwordRecovery",a,b,c)},function(){d.o();V(a,b,c)},Pi(R(a)),Qi(R(a)));d.render(b);Z(a,d)};function qo(a,
	b){this.Z=!1;var c=ro(b);if(so[c])throw Error('An AuthUI instance already exists for the key "'+c+'"');so[c]=this;this.f=a;this.u=null;this.X=!1;to(this.f);this.a=firebase.initializeApp({apiKey:a.app.options.apiKey,authDomain:a.app.options.authDomain},a.app.name+"-firebaseui-temp").auth();to(this.a);this.a.setPersistence&&this.a.setPersistence(firebase.auth.Auth.Persistence.SESSION);this.oa=b;this.ca=new qi;this.h=this.N=this.i=this.H=this.M=null;this.m=[];this.Y=!1;this.l=Rf.Ya();this.j=this.C=null;
	this.da=this.w=!1}function to(a){a&&a.INTERNAL&&a.INTERNAL.logFramework&&a.INTERNAL.logFramework("FirebaseUI-web")}var so={};function ro(a){return a||"[DEFAULT]"}function Fm(a){Y(a);a.i||(a.i=uo(a,function(b){return b&&!Oh(T(a))?H(Wn(a).getRedirectResult().then(function(c){return c},function(c){if(c&&"auth/email-already-in-use"==c.code&&c.email&&c.credential)throw c;return vo(a,c)})):H(X(a).getRedirectResult().then(function(c){return wi(R(a))&&!c.user&&a.j&&!a.j.isAnonymous?Wn(a).getRedirectResult():
	c}))}));return a.i}function Z(a,b){Y(a);a.h=b}var wo=null;function Om(){return wo}function X(a){Y(a);return a.a}function Wn(a){Y(a);return a.f}function T(a){Y(a);return a.oa}function Um(a){Y(a);return a.M?a.M.emailHint:void 0}l=qo.prototype;l.ob=function(){Y(this);return!!Rh(T(this))||xo(wf())};function xo(a){a=new Vb(a);return"signIn"===(a.a.a.get(x.wb)||null)&&!!a.a.a.get(x.ab)}l.start=function(a,b){yo(this,a,b)};function yo(a,b,c,d){Y(a);"undefined"!==typeof a.f.languageCode&&(a.u=a.f.languageCode);
	var e="en".replace(/_/g,"-");a.f.languageCode=e;a.a.languageCode=e;a.X=!0;"undefined"!==typeof a.f.tenantId&&(a.a.tenantId=a.f.tenantId);a.jb(c);a.M=d||null;var f=p.document;a.C?a.C.then(function(){"complete"==f.readyState?zo(a,b):oe(window,"load",function(){zo(a,b)})}):"complete"==f.readyState?zo(a,b):oe(window,"load",function(){zo(a,b)})}function zo(a,b){var c=vf(b,"Could not find the FirebaseUI widget element on the page.");c.setAttribute("lang","en".replace(/_/g,"-"));if(wo){var d=wo;Y(d);Oh(T(d))&&
	yg("UI Widget is already rendered on the page and is pending some user interaction. Only one widget instance can be rendered per page. The previous instance has been automatically reset.");wo.reset()}wo=a;a.N=c;Ao(a,c);ph(new qh)&&ph(new rh)?Tm(a,b):(b=vf(b,"Could not find the FirebaseUI widget element on the page."),c=new mm(D("The browser you are using does not support Web Storage. Please try again in a different browser.").toString()),c.render(b),Z(a,c));b=a.h&&"blank"==a.h.Ea&&Vi(R(a));Rh(T(a))&&
	!b&&(b=Rh(T(a)),wn(a,b.a),Hh(Ah,T(a)))}function uo(a,b){if(a.w)return b(Bo(a));W(a,function(){a.w=!1});if(wi(R(a))){var c=new G(function(d){W(a,a.f.onAuthStateChanged(function(e){a.j=e;a.w||(a.w=!0,d(b(Bo(a))))}))});W(a,c);return c}a.w=!0;return b(null)}function Bo(a){Y(a);return wi(R(a))&&a.j&&a.j.isAnonymous?a.j:null}function W(a,b){Y(a);if(b){a.m.push(b);var c=function(){Ua(a.m,function(d){return d==b})};"function"!=typeof b&&b.then(c,c)}}l.disableAutoSignIn=function(){Y(this);this.Y=!0};function Co(a){Y(a);
	var b;(b=a.Y)||(a=R(a),a=Li(a,firebase.auth.GoogleAuthProvider.PROVIDER_ID),b=!(!a||"select_account"!==a.prompt));return b}function zm(a){"undefined"!==typeof a.f.languageCode&&a.X&&(a.X=!1,a.f.languageCode=a.u)}function wn(a,b){a.f.tenantId=b;a.a.tenantId=b}l.reset=function(){Y(this);var a=this;this.N&&this.N.removeAttribute("lang");this.H&&Ge(this.H);zm(this);this.M=null;Vm();Hh(Ah,T(this));Y(this);this.l.cancel();this.i=H({user:null,credential:null});wo==this&&(wo=null);this.N=null;for(var b=0;b<
	this.m.length;b++)if("function"==typeof this.m[b])this.m[b]();else this.m[b].cancel&&this.m[b].cancel();this.m=[];Ph(T(this));this.h&&(this.h.o(),this.h=null);this.J=null;this.a&&(this.C=dn(this).then(function(){a.C=null},function(){a.C=null}))};function Ao(a,b){a.J=null;a.H=new He(b);a.H.register();ne(a.H,"pageEnter",function(c){c=c&&c.pageId;if(a.J!=c){var d=R(a);(d=$i(d).uiChanged||null)&&d(a.J,c);a.J=c}})}l.jb=function(a){Y(this);var b=this.ca,c;for(c in a)try{Xh(b.a,c,a[c])}catch(d){tg('Invalid config: "'+
	c+'"',void 0)}lc&&Xh(b.a,"popupMode",!1);Oi(b);!this.da&&aj(R(this))&&(yg("signInSuccess callback is deprecated. Please use signInSuccessWithAuthResult callback instead."),this.da=!0)};function R(a){Y(a);return a.ca}l.Vb=function(){Y(this);var a=R(this),b=Yh(a.a,"widgetUrl");var c=ui(a,b);R(this).a.get("popupMode")?(a=(window.screen.availHeight-600)/2,b=(window.screen.availWidth-500)/2,c=c||"about:blank",a={width:500,height:600,top:0<a?a:0,left:0<b?b:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1},
	a.target=a.target||c.target||"google_popup",a.width=a.width||690,a.height=a.height||500,(a=rf(c,a))&&a.focus()):sf(c)};function Y(a){if(a.Z)throw Error("AuthUI instance is deleted!");}l.Xa=function(){var a=this;Y(this);return this.a.app.delete().then(function(){var b=ro(T(a));delete so[b];a.reset();a.Z=!0})};function no(a){Y(a);try{Sf(a.l,Ei(R(a)),Co(a)).then(function(b){return a.h?Im(a,a.h,b):!1})}catch(b){}}l.Hb=function(a,b){Y(this);var c=this,d=yf();if(!Si(R(this)))throw Error("Email link sign-in should be enabled to trigger email sending.");
	var e=Ui(R(this)),f=new Vb(e.url);Wb(f,d);b&&b.a&&(Vh(d,b,T(this)),Zb(f,b.a.providerId));Xb(f,Ti(R(this)));return uo(this,function(g){g&&((g=g.uid)?f.a.a.set(x.Qa,g):Tb(f.a.a,x.Qa));e.url=f.toString();return X(c).sendSignInLinkToEmail(a,e)}).then(function(){var g=T(c),h={};h.email=a;Ih(Eh,dh(d,JSON.stringify(h)),g)},function(g){Hh(Fh,T(c));Hh(Eh,T(c));throw g;})};function xn(a,b){var c=Yb(new Vb(b));if(!c)return H(null);b=new G(function(d,e){var f=Wn(a).onAuthStateChanged(function(g){f();g&&g.isAnonymous&&
	g.uid===c?d(g):g&&g.isAnonymous&&g.uid!==c?e(Error("anonymous-user-mismatch")):e(Error("anonymous-user-not-found"))});W(a,f)});W(a,b);return b}function Bn(a,b,c,d,e){Y(a);var f=e||null,g=firebase.auth.EmailAuthProvider.credentialWithLink(c,d);c=f?X(a).signInWithEmailLink(c,d).then(function(h){return h.user.linkWithCredential(f)}).then(function(){return dn(a)}).then(function(){return vo(a,{code:"auth/email-already-in-use"},f)}):X(a).fetchSignInMethodsForEmail(c).then(function(h){return h.length?vo(a,
	{code:"auth/email-already-in-use"},g):b.linkWithCredential(g)});W(a,c);return c}function Cn(a,b,c,d){Y(a);var e=d||null,f;b=X(a).signInWithEmailLink(b,c).then(function(g){f={user:g.user,credential:null,operationType:g.operationType,additionalUserInfo:g.additionalUserInfo};if(e)return g.user.linkWithCredential(e).then(function(h){f={user:h.user,credential:e,operationType:f.operationType,additionalUserInfo:h.additionalUserInfo}})}).then(function(){dn(a)}).then(function(){return Wn(a).updateCurrentUser(f.user)}).then(function(){f.user=
	Wn(a).currentUser;return f});W(a,b);return b}function Vm(){var a=wf();if(xo(a)){a=new Vb(a);for(var b in x)x.hasOwnProperty(b)&&Tb(a.a.a,x[b]);b={state:"signIn",mode:"emailLink",operation:"clear"};var c=p.document.title;p.history&&p.history.replaceState&&p.history.replaceState(b,c,a.toString())}}l.ac=function(a,b){Y(this);var c=this;return X(this).signInWithEmailAndPassword(a,b).then(function(d){return uo(c,function(e){return e?dn(c).then(function(){return vo(c,{code:"auth/email-already-in-use"},
	firebase.auth.EmailAuthProvider.credential(a,b))}):d})})};l.Xb=function(a,b){Y(this);var c=this;return uo(this,function(d){if(d){var e=firebase.auth.EmailAuthProvider.credential(a,b);return d.linkWithCredential(e)}return X(c).createUserWithEmailAndPassword(a,b)})};l.$b=function(a){Y(this);var b=this;return uo(this,function(c){return c?c.linkWithCredential(a).then(function(d){return d},function(d){if(d&&"auth/email-already-in-use"==d.code&&d.email&&d.credential)throw d;return vo(b,d,a)}):X(b).signInWithCredential(a)})};
	function Gm(a,b){Y(a);return uo(a,function(c){return c&&!Oh(T(a))?c.linkWithPopup(b).then(function(d){return d},function(d){if(d&&"auth/email-already-in-use"==d.code&&d.email&&d.credential)throw d;return vo(a,d)}):X(a).signInWithPopup(b)})}l.cc=function(a){Y(this);var b=this,c=this.i;this.i=null;return uo(this,function(d){return d&&!Oh(T(b))?d.linkWithRedirect(a):X(b).signInWithRedirect(a)}).then(function(){},function(d){b.i=c;throw d;})};l.bc=function(a,b){Y(this);var c=this;return uo(this,function(d){return d?
	d.linkWithPhoneNumber(a,b).then(function(e){return new Xf(e,function(f){if("auth/credential-already-in-use"==f.code)return vo(c,f);throw f;})}):Wn(c).signInWithPhoneNumber(a,b).then(function(e){return new Xf(e)})})};l.Zb=function(){Y(this);return Wn(this).signInAnonymously()};function Bm(a,b){Y(a);return uo(a,function(c){if(a.j&&!a.j.isAnonymous&&wi(R(a))&&!X(a).currentUser)return dn(a).then(function(){"password"==b.credential.providerId&&(b.credential=null);return b});if(c)return dn(a).then(function(){return c.linkWithCredential(b.credential)}).then(function(d){b.user=
	d.user;b.credential=d.credential;b.operationType=d.operationType;b.additionalUserInfo=d.additionalUserInfo;return b},function(d){if(d&&"auth/email-already-in-use"==d.code&&d.email&&d.credential)throw d;return vo(a,d,b.credential)});if(!b.user)throw Error('Internal error: An incompatible or outdated version of "firebase.js" may be used.');return dn(a).then(function(){return Wn(a).updateCurrentUser(b.user)}).then(function(){b.user=Wn(a).currentUser;b.operationType="signIn";b.credential&&b.credential.providerId&&
	"password"==b.credential.providerId&&(b.credential=null);return b})})}l.Wb=function(a,b){Y(this);return X(this).signInWithEmailAndPassword(a,b)};function dn(a){Y(a);return X(a).signOut()}function vo(a,b,c){Y(a);if(b&&b.code&&("auth/email-already-in-use"==b.code||"auth/credential-already-in-use"==b.code)){var d=xi(R(a));return H().then(function(){return d(new Qd("anonymous-upgrade-merge-conflict",null,c||b.credential))}).then(function(){a.h&&(a.h.o(),a.h=null);throw b;})}return ff(b)}function Do(a,
	b,c,d){O.call(this,Pl,void 0,d,"providerMatchByEmail",{G:b,F:c});this.i=a}n(Do,O);Do.prototype.v=function(){this.u(this.i);this.B(this.i);this.l().focus();rn(this.l(),(this.l().value||"").length);O.prototype.v.call(this)};Do.prototype.s=function(){this.i=null;O.prototype.s.call(this)};u(Do.prototype,{l:Zl,I:$l,u:am,D:bm,j:cm,O:Ql,B:Sl});function Eo(a,b,c,d,e){O.call(this,Ol,{dc:b},e,"selectTenant",{G:c,F:d});this.i=a}n(Eo,O);Eo.prototype.v=function(){Fo(this,this.i);O.prototype.v.call(this)};Eo.prototype.s=
	function(){this.i=null;O.prototype.s.call(this)};function Fo(a,b){function c(h){b(h)}for(var d=a.f?Yc("firebaseui-id-tenant-selection-button",a.f||a.m.a):[],e=0;e<d.length;e++){var f=d[e],g=Yn(f,"tenantId");N(a,f,Ba(c,g))}}function Go(a){O.call(this,ol,void 0,a,"spinner")}n(Go,O);function Ho(a){this.a=new Wh;I(this.a,"authDomain");I(this.a,"displayMode",Io);I(this.a,"tenants");I(this.a,"callbacks");I(this.a,"tosUrl");I(this.a,"privacyPolicyUrl");for(var b in a)if(a.hasOwnProperty(b))try{Xh(this.a,
	b,a[b])}catch(c){tg('Invalid config: "'+b+'"',void 0)}}function Jo(a){a=a.a.get("displayMode");for(var b in Ko)if(Ko[b]===a)return Ko[b];return Io}function Lo(a){return a.a.get("callbacks")||{}}function Mo(a){var b=a.a.get("tosUrl")||null;a=a.a.get("privacyPolicyUrl")||null;b&&!a&&yg("Privacy Policy URL is missing, the link will not be displayed.");if(b&&a){if("function"===typeof b)return b;if("string"===typeof b)return function(){uf(b)}}return null}function No(a){var b=a.a.get("tosUrl")||null,c=
	a.a.get("privacyPolicyUrl")||null;c&&!b&&yg("Terms of Service URL is missing, the link will not be displayed.");if(b&&c){if("function"===typeof c)return c;if("string"===typeof c)return function(){uf(c)}}return null}function Oo(a,b){a=a.a.get("tenants");if(!a||!a.hasOwnProperty(b)&&!a.hasOwnProperty(Po))throw Error("Invalid tenant configuration!");}function Qo(a,b,c){a=a.a.get("tenants");if(!a)throw Error("Invalid tenant configuration!");var d=[];a=a[b]||a[Po];if(!a)return tg("Invalid tenant configuration: "+
	(b+" is not configured!"),void 0),d;b=a.signInOptions;if(!b)throw Error("Invalid tenant configuration: signInOptions are invalid!");b.forEach(function(e){if("string"===typeof e)d.push(e);else if("string"===typeof e.provider){var f=e.hd;f&&c?(f instanceof RegExp?f:new RegExp("@"+f.replace(".","\\.")+"$")).test(c)&&d.push(e.provider):d.push(e.provider)}else e="Invalid tenant configuration: signInOption "+(JSON.stringify(e)+" is invalid!"),tg(e,void 0)});return d}function Ro(a,b,c){a=So(a,b);(b=a.signInOptions)&&
	c&&(b=b.filter(function(d){return"string"===typeof d?c.includes(d):c.includes(d.provider)}),a.signInOptions=b);return a}function So(a,b){var c=To;var d=void 0===d?{}:d;Oo(a,b);a=a.a.get("tenants");return zf(a[b]||a[Po],c,d)}var To=["immediateFederatedRedirect","privacyPolicyUrl","signInFlow","signInOptions","tosUrl"],Io="optionFirst",Ko={oc:Io,nc:"identifierFirst"},Po="*";function Uo(a,b){var c=this;this.m=vf(a);this.a={};Object.keys(b).forEach(function(d){c.a[d]=new Ho(b[d])});this.pb=this.f=this.w=
	this.h=this.i=this.j=null;Object.defineProperty(this,"languageCode",{get:function(){return this.pb},set:function(d){this.pb=d||null},enumerable:!1})}l=Uo.prototype;l.Tb=function(a,b){var c=this;Vo(this);var d=a.apiKey;return new G(function(e,f){if(c.a.hasOwnProperty(d)){var g=Lo(c.a[d]).selectTenantUiHidden||null;if(Jo(c.a[d])===Io){var h=[];b.forEach(function(q){q=q||"_";var B=c.a[d].a.get("tenants");if(!B)throw Error("Invalid tenant configuration!");(B=B[q]||B[Po])?q={tenantId:"_"!==q?q:null,displayName:B.displayName,
	Na:B.iconUrl,Ga:B.buttonColor}:(tg("Invalid tenant configuration: "+(q+" is not configured!"),void 0),q=null);q&&h.push(q)});var k=function(q){q={tenantId:q,providerIds:Qo(c.a[d],q||"_")};e(q)};if(1===h.length){k(h[0].tenantId);return}c.f=new Eo(function(q){Vo(c);g&&g();k(q)},h,Mo(c.a[d]),No(c.a[d]))}else c.f=new Do(function(){var q=c.f.j();if(q){for(var B=0;B<b.length;B++){var S=Qo(c.a[d],b[B]||"_",q);if(0!==S.length){q={tenantId:b[B],providerIds:S,email:q};Vo(c);g&&g();e(q);return}}c.f.a(Od({code:"no-matching-tenant-for-email"}).toString())}},
	Mo(c.a[d]),No(c.a[d]));c.f.render(c.m);(f=Lo(c.a[d]).selectTenantUiShown||null)&&f()}else{var m=Error("Invalid project configuration: API key is invalid!");m.code="invalid-configuration";c.qb(m);f(m)}})};l.Ob=function(a,b){if(!this.a.hasOwnProperty(a))throw Error("Invalid project configuration: API key is invalid!");var c=b||void 0;Oo(this.a[a],b||"_");try{this.i=firebase.app(c).auth()}catch(e){var d=this.a[a].a.get("authDomain");if(!d)throw Error("Invalid project configuration: authDomain is required!");
	a=firebase.initializeApp({apiKey:a,authDomain:d},c);a.auth().tenantId=b;this.i=a.auth()}return this.i};l.Yb=function(a,b){var c=this;return new G(function(d,e){function f(B,S){c.j=new qo(a);yo(c.j,c.m,B,S)}var g=a.app.options.apiKey;c.a.hasOwnProperty(g)||e(Error("Invalid project configuration: API key is invalid!"));var h=Ro(c.a[g],a.tenantId||"_",b&&b.providerIds);Vo(c);e={signInSuccessWithAuthResult:function(B){d(B);return!1}};var k=Lo(c.a[g]).signInUiShown||null,m=!1;e.uiChanged=function(B,S){null===
	B&&"callback"===S?((B=$c("firebaseui-id-page-callback",c.m))&&Ak(B),c.h=new Go,c.h.render(c.m)):m||null===B&&"spinner"===S||"blank"===S||(c.h&&(c.h.o(),c.h=null),m=!0,k&&k(a.tenantId))};h.callbacks=e;h.credentialHelper="none";var q;b&&b.email&&(q={emailHint:b.email});c.j?c.j.Xa().then(function(){f(h,q)}):f(h,q)})};l.reset=function(){var a=this;return H().then(function(){a.j&&a.j.Xa()}).then(function(){a.j=null;Vo(a)})};l.Ub=function(){var a=this;this.h||this.w||(this.w=window.setTimeout(function(){Vo(a);
	a.h=new Go;a.f=a.h;a.h.render(a.m);a.w=null},500))};l.nb=function(){window.clearTimeout(this.w);this.w=null;this.h&&(this.h.o(),this.h=null)};l.Cb=function(){Vo(this);this.f=new hm;this.f.render(this.m);return H()};function Vo(a){a.j&&a.j.reset();a.nb();a.f&&a.f.o()}l.qb=function(a){var b=this,c=Od({code:a.code}).toString()||a.message;Vo(this);var d;a.retry&&va(a.retry)&&(d=function(){b.reset();a.retry()});this.f=new lm(c,d);this.f.render(this.m)};l.Qb=function(a){var b=this;return H().then(function(){var c=
	b.i&&b.i.app.options.apiKey;if(!b.a.hasOwnProperty(c))throw Error("Invalid project configuration: API key is invalid!");Oo(b.a[c],a.tenantId||"_");if(!b.i.currentUser||b.i.currentUser.uid!==a.uid)throw Error("The user being processed does not match the signed in user!");return(c=Lo(b.a[c]).beforeSignInSuccess||null)?c(a):a}).then(function(c){if(c.uid!==a.uid)throw Error("User with mismatching UID returned.");return c})};v("firebaseui.auth.FirebaseUiHandler",Uo);v("firebaseui.auth.FirebaseUiHandler.prototype.selectTenant",
	Uo.prototype.Tb);v("firebaseui.auth.FirebaseUiHandler.prototype.getAuth",Uo.prototype.Ob);v("firebaseui.auth.FirebaseUiHandler.prototype.startSignIn",Uo.prototype.Yb);v("firebaseui.auth.FirebaseUiHandler.prototype.reset",Uo.prototype.reset);v("firebaseui.auth.FirebaseUiHandler.prototype.showProgressBar",Uo.prototype.Ub);v("firebaseui.auth.FirebaseUiHandler.prototype.hideProgressBar",Uo.prototype.nb);v("firebaseui.auth.FirebaseUiHandler.prototype.completeSignOut",Uo.prototype.Cb);v("firebaseui.auth.FirebaseUiHandler.prototype.handleError",
	Uo.prototype.qb);v("firebaseui.auth.FirebaseUiHandler.prototype.processUser",Uo.prototype.Qb);v("firebaseui.auth.AuthUI",qo);v("firebaseui.auth.AuthUI.getInstance",function(a){a=ro(a);return so[a]?so[a]:null});v("firebaseui.auth.AuthUI.prototype.disableAutoSignIn",qo.prototype.disableAutoSignIn);v("firebaseui.auth.AuthUI.prototype.start",qo.prototype.start);v("firebaseui.auth.AuthUI.prototype.setConfig",qo.prototype.jb);v("firebaseui.auth.AuthUI.prototype.signIn",qo.prototype.Vb);v("firebaseui.auth.AuthUI.prototype.reset",
	qo.prototype.reset);v("firebaseui.auth.AuthUI.prototype.delete",qo.prototype.Xa);v("firebaseui.auth.AuthUI.prototype.isPendingRedirect",qo.prototype.ob);v("firebaseui.auth.AuthUIError",Qd);v("firebaseui.auth.AuthUIError.prototype.toJSON",Qd.prototype.toJSON);v("firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM",ri);v("firebaseui.auth.CredentialHelper.GOOGLE_YOLO",Gi);v("firebaseui.auth.CredentialHelper.NONE",cj);v("firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID","anonymous");G.prototype["catch"]=
	G.prototype.ta;G.prototype["finally"]=G.prototype.ec}).apply(typeof global!=="undefined"?global:typeof self!=="undefined"?self:window); if(typeof window!=='undefined'){window.dialogPolyfill=__webpack_require__(222);}})();module.exports=firebaseui;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)(module), (function() { return this; }())))

/***/ },
/* 231 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(271)),valueEqual=_interopDefault(__webpack_require__(277));__webpack_require__(18);var invariant=_interopDefault(__webpack_require__(50));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 233 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.4.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2019-05-01T21:04Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.4.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code, options ) {
			DOMEval( code, { nonce: options && options.nonce } );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.4
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2019-04-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) &&
	
					// Support: IE 8 only
					// Exclude object elements
					(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 && rdescend.test( selector ) ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = (elem.ownerDocument || elem).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( typeof elem.contentDocument !== "undefined" ) {
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									} );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		// Support: IE 9-11 only
		// Also use offsetWidth/offsetHeight for when box sizing is unreliable
		// We use getClientRects() to check for hidden/disconnected.
		// In those cases, the computed value can be trusted to be border-box
		if ( ( !support.boxSizingReliable() && isBorderBox ||
			val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url, options ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hyphenate = _interopDefault(__webpack_require__(233));
	
	/**
	 * Convert camel cased property names to dash separated.
	 *
	 * @param {Object} style
	 * @return {Object}
	 */
	
	function convertCase(style) {
	  var converted = {};
	
	  for (var prop in style) {
	    var key = prop.indexOf('--') === 0 ? prop : hyphenate(prop);
	    converted[key] = style[prop];
	  }
	
	  if (style.fallbacks) {
	    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
	  }
	
	  return converted;
	}
	/**
	 * Allow camel cased property names by converting them back to dasherized.
	 *
	 * @param {Rule} rule
	 */
	
	
	function camelCase() {
	  function onProcessStyle(style) {
	    if (Array.isArray(style)) {
	      // Handle rules like @font-face, which can have multiple styles in an array
	      for (var index = 0; index < style.length; index++) {
	        style[index] = convertCase(style[index]);
	      }
	
	      return style;
	    }
	
	    return convertCase(style);
	  }
	
	  function onChangeValue(value, prop, rule) {
	    if (prop.indexOf('--') === 0) {
	      return value;
	    }
	
	    var hyphenatedProp = hyphenate(prop); // There was no camel case in place
	
	    if (prop === hyphenatedProp) return value;
	    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
	
	    return null;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = camelCase;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var jss = __webpack_require__(17);
	
	var px = jss.hasCSSTOMSupport && CSS ? CSS.px : 'px';
	var ms = jss.hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
	var percent = jss.hasCSSTOMSupport && CSS ? CSS.percent : '%';
	/**
	 * Generated jss-plugin-default-unit CSS property units
	 *
	 * @type object
	 */
	
	var defaultUnits = {
	  // Animation properties
	  'animation-delay': ms,
	  'animation-duration': ms,
	  // Background properties
	  'background-position': px,
	  'background-position-x': px,
	  'background-position-y': px,
	  'background-size': px,
	  // Border Properties
	  border: px,
	  'border-bottom': px,
	  'border-bottom-left-radius': px,
	  'border-bottom-right-radius': px,
	  'border-bottom-width': px,
	  'border-left': px,
	  'border-left-width': px,
	  'border-radius': px,
	  'border-right': px,
	  'border-right-width': px,
	  'border-top': px,
	  'border-top-left-radius': px,
	  'border-top-right-radius': px,
	  'border-top-width': px,
	  'border-width': px,
	  // Margin properties
	  margin: px,
	  'margin-bottom': px,
	  'margin-left': px,
	  'margin-right': px,
	  'margin-top': px,
	  // Padding properties
	  padding: px,
	  'padding-bottom': px,
	  'padding-left': px,
	  'padding-right': px,
	  'padding-top': px,
	  // Mask properties
	  'mask-position-x': px,
	  'mask-position-y': px,
	  'mask-size': px,
	  // Width and height properties
	  height: px,
	  width: px,
	  'min-height': px,
	  'max-height': px,
	  'min-width': px,
	  'max-width': px,
	  // Position properties
	  bottom: px,
	  left: px,
	  top: px,
	  right: px,
	  // Shadow properties
	  'box-shadow': px,
	  'text-shadow': px,
	  // Column properties
	  'column-gap': px,
	  'column-rule': px,
	  'column-rule-width': px,
	  'column-width': px,
	  // Font and text properties
	  'font-size': px,
	  'font-size-delta': px,
	  'letter-spacing': px,
	  'text-indent': px,
	  'text-stroke': px,
	  'text-stroke-width': px,
	  'word-spacing': px,
	  // Motion properties
	  motion: px,
	  'motion-offset': px,
	  // Outline properties
	  outline: px,
	  'outline-offset': px,
	  'outline-width': px,
	  // Perspective properties
	  perspective: px,
	  'perspective-origin-x': percent,
	  'perspective-origin-y': percent,
	  // Transform properties
	  'transform-origin': percent,
	  'transform-origin-x': percent,
	  'transform-origin-y': percent,
	  'transform-origin-z': percent,
	  // Transition properties
	  'transition-delay': ms,
	  'transition-duration': ms,
	  // Alignment properties
	  'vertical-align': px,
	  'flex-basis': px,
	  // Some random properties
	  'shape-margin': px,
	  size: px,
	  // Grid properties
	  grid: px,
	  'grid-gap': px,
	  'grid-row-gap': px,
	  'grid-column-gap': px,
	  'grid-template-rows': px,
	  'grid-template-columns': px,
	  'grid-auto-rows': px,
	  'grid-auto-columns': px,
	  // Not existing properties.
	  // Used to avoid issues with jss-plugin-expand integration.
	  'box-shadow-x': px,
	  'box-shadow-y': px,
	  'box-shadow-blur': px,
	  'box-shadow-spread': px,
	  'font-line-height': px,
	  'text-shadow-x': px,
	  'text-shadow-y': px,
	  'text-shadow-blur': px
	};
	
	/**
	 * Clones the object and adds a camel cased property version.
	 */
	function addCamelCasedVersion(obj) {
	  var regExp = /(-[a-z])/g;
	
	  var replace = function replace(str) {
	    return str[1].toUpperCase();
	  };
	
	  var newObj = {};
	
	  for (var _key in obj) {
	    newObj[_key] = obj[_key];
	    newObj[_key.replace(regExp, replace)] = obj[_key];
	  }
	
	  return newObj;
	}
	
	var units = addCamelCasedVersion(defaultUnits);
	/**
	 * Recursive deep style passing function
	 */
	
	function iterate(prop, value, options) {
	  if (!value) return value;
	
	  if (Array.isArray(value)) {
	    for (var i = 0; i < value.length; i++) {
	      value[i] = iterate(prop, value[i], options);
	    }
	  } else if (typeof value === 'object') {
	    if (prop === 'fallbacks') {
	      for (var innerProp in value) {
	        value[innerProp] = iterate(innerProp, value[innerProp], options);
	      }
	    } else {
	      for (var _innerProp in value) {
	        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
	      }
	    }
	  } else if (typeof value === 'number') {
	    if (options[prop]) {
	      return "" + value + options[prop];
	    }
	
	    if (units[prop]) {
	      return typeof units[prop] === 'function' ? units[prop](value).toString() : "" + value + units[prop];
	    }
	
	    return value.toString();
	  }
	
	  return value;
	}
	/**
	 * Add unit to numeric values.
	 */
	
	
	function defaultUnit(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var camelCasedOptions = addCamelCasedVersion(options);
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      style[prop] = iterate(prop, style[prop], camelCasedOptions);
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return iterate(prop, value, camelCasedOptions);
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = defaultUnit;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(3));
	var jss = __webpack_require__(17);
	
	var at = '@global';
	var atPrefix = '@global ';
	
	var GlobalContainerRule =
	/*#__PURE__*/
	function () {
	  function GlobalContainerRule(key, styles, options) {
	    this.type = 'global';
	    this.at = at;
	    this.rules = void 0;
	    this.options = void 0;
	    this.key = void 0;
	    this.isProcessed = false;
	    this.key = key;
	    this.options = options;
	    this.rules = new jss.RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var selector in styles) {
	      this.rules.add(selector, styles[selector]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = GlobalContainerRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString() {
	    return this.rules.toString();
	  };
	
	  return GlobalContainerRule;
	}();
	
	var GlobalPrefixedRule =
	/*#__PURE__*/
	function () {
	  function GlobalPrefixedRule(key, style, options) {
	    this.type = 'global';
	    this.at = at;
	    this.options = void 0;
	    this.rule = void 0;
	    this.isProcessed = false;
	    this.key = void 0;
	    this.key = key;
	    this.options = options;
	    var selector = key.substr(atPrefix.length);
	    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
	      parent: this
	    }));
	  }
	
	  var _proto2 = GlobalPrefixedRule.prototype;
	
	  _proto2.toString = function toString(options) {
	    return this.rule ? this.rule.toString(options) : '';
	  };
	
	  return GlobalPrefixedRule;
	}();
	
	var separatorRegExp = /\s*,\s*/g;
	
	function addScope(selector, scope) {
	  var parts = selector.split(separatorRegExp);
	  var scoped = '';
	
	  for (var i = 0; i < parts.length; i++) {
	    scoped += scope + " " + parts[i].trim();
	    if (parts[i + 1]) scoped += ', ';
	  }
	
	  return scoped;
	}
	
	function handleNestedGlobalContainerRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	  var rules = style ? style[at] : null;
	  if (!rules) return;
	
	  for (var name in rules) {
	    options.sheet.addRule(name, rules[name], _extends({}, options, {
	      selector: addScope(name, rule.selector)
	    }));
	  }
	
	  delete style[at];
	}
	
	function handlePrefixedGlobalRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	
	  for (var prop in style) {
	    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
	    var selector = addScope(prop.substr(at.length), rule.selector);
	    options.sheet.addRule(selector, style[prop], _extends({}, options, {
	      selector: selector
	    }));
	    delete style[prop];
	  }
	}
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	
	
	function jssGlobal() {
	  function onCreateRule(name, styles, options) {
	    if (!name) return null;
	
	    if (name === at) {
	      return new GlobalContainerRule(name, styles, options);
	    }
	
	    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
	      return new GlobalPrefixedRule(name, styles, options);
	    }
	
	    var parent = options.parent;
	
	    if (parent) {
	      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
	        options.scoped = false;
	      }
	    }
	
	    if (options.scoped === false) {
	      options.selector = name;
	    }
	
	    return null;
	  }
	
	  function onProcessRule(rule) {
	    if (rule.type !== 'style') return;
	    handleNestedGlobalContainerRule(rule);
	    handlePrefixedGlobalRule(rule);
	  }
	
	  return {
	    onCreateRule: onCreateRule,
	    onProcessRule: onProcessRule
	  };
	}
	
	exports.default = jssGlobal;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(3));
	var warning = _interopDefault(__webpack_require__(18));
	
	var separatorRegExp = /\s*,\s*/g;
	var parentRegExp = /&/g;
	var refRegExp = /\$([\w-]+)/g;
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	
	function jssNested() {
	  // Get a function to be used for $ref replacement.
	  function getReplaceRef(container, sheet) {
	    return function (match, key) {
	      var rule = container.getRule(key) || sheet && sheet.getRule(key);
	
	      if (rule) {
	        rule = rule;
	        return rule.selector;
	      }
	
	       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
	      return key;
	    };
	  }
	
	  function replaceParentRefs(nestedProp, parentProp) {
	    var parentSelectors = parentProp.split(separatorRegExp);
	    var nestedSelectors = nestedProp.split(separatorRegExp);
	    var result = '';
	
	    for (var i = 0; i < parentSelectors.length; i++) {
	      var parent = parentSelectors[i];
	
	      for (var j = 0; j < nestedSelectors.length; j++) {
	        var nested = nestedSelectors[j];
	        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
	
	        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
	      }
	    }
	
	    return result;
	  }
	
	  function getOptions(rule, container, prevOptions) {
	    // Options has been already created, now we only increase index.
	    if (prevOptions) return _extends({}, prevOptions, {
	      index: prevOptions.index + 1
	    });
	    var nestingLevel = rule.options.nestingLevel;
	    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
	
	    var options = _extends({}, rule.options, {
	      nestingLevel: nestingLevel,
	      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
	
	    });
	
	    delete options.name;
	    return options;
	  }
	
	  function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style') return style;
	    var styleRule = rule;
	    var container = styleRule.options.parent;
	    var options;
	    var replaceRef;
	
	    for (var prop in style) {
	      var isNested = prop.indexOf('&') !== -1;
	      var isNestedConditional = prop[0] === '@';
	      if (!isNested && !isNestedConditional) continue;
	      options = getOptions(styleRule, container, options);
	
	      if (isNested) {
	        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
	        // all nested rules within the sheet.
	
	        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
	
	        selector = selector.replace(refRegExp, replaceRef);
	        container.addRule(selector, style[prop], _extends({}, options, {
	          selector: selector
	        }));
	      } else if (isNestedConditional) {
	        // Place conditional right after the parent rule to ensure right ordering.
	        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
	        // And flow doesn't know this will always be a StyleRule which has the addRule method
	        // $FlowFixMe
	        .addRule(styleRule.key, style[prop], {
	          selector: styleRule.selector
	        });
	      }
	
	      delete style[prop];
	    }
	
	    return style;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle
	  };
	}
	
	exports.default = jssNested;


/***/ },
/* 239 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Sort props by length.
	 */
	function jssPropsSort() {
	  var sort = function sort(prop0, prop1) {
	    if (prop0.length === prop1.length) {
	      return prop0 > prop1 ? 1 : -1;
	    }
	
	    return prop0.length - prop1.length;
	  };
	
	  return {
	    onProcessStyle: function onProcessStyle(style, rule) {
	      if (rule.type !== 'style') return style;
	      var newStyle = {};
	      var props = Object.keys(style).sort(sort);
	
	      for (var i = 0; i < props.length; i++) {
	        newStyle[props[i]] = style[props[i]];
	      }
	
	      return newStyle;
	    }
	  };
	}
	
	exports.default = jssPropsSort;


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var jss = __webpack_require__(17);
	
	var now = Date.now();
	var fnValuesNs = "fnValues" + now;
	var fnRuleNs = "fnStyle" + ++now;
	function functionPlugin() {
	  return {
	    onCreateRule: function onCreateRule(name, decl, options) {
	      if (typeof decl !== 'function') return null;
	      var rule = jss.createRule(name, {}, options);
	      rule[fnRuleNs] = decl;
	      return rule;
	    },
	    onProcessStyle: function onProcessStyle(style, rule) {
	      // We need to extract function values from the declaration, so that we can keep core unaware of them.
	      // We need to do that only once.
	      // We don't need to extract functions on each style update, since this can happen only once.
	      // We don't support function values inside of function rules.
	      if (fnValuesNs in rule || fnRuleNs in rule) return style;
	      var fnValues = {};
	
	      for (var prop in style) {
	        var value = style[prop];
	        if (typeof value !== 'function') continue;
	        delete style[prop];
	        fnValues[prop] = value;
	      } // $FlowFixMe
	
	
	      rule[fnValuesNs] = fnValues;
	      return style;
	    },
	    onUpdate: function onUpdate(data, rule, sheet, options) {
	      var styleRule = rule;
	      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
	      // will be returned from that function.
	
	      if (fnRule) {
	        // Empty object will remove all currently defined props
	        // in case function rule returns a falsy value.
	        styleRule.style = fnRule(data) || {};
	      }
	
	      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.
	
	      if (fnValues) {
	        for (var prop in fnValues) {
	          styleRule.prop(prop, fnValues[prop](data), options);
	        }
	      }
	    }
	  };
	}
	
	exports.default = functionPlugin;


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendor = __webpack_require__(221);
	var jss = __webpack_require__(17);
	
	/**
	 * Add vendor prefix to a property name when needed.
	 *
	 * @api public
	 */
	
	function jssVendorPrefixer() {
	  function onProcessRule(rule) {
	    if (rule.type === 'keyframes') {
	      var atRule = rule;
	      atRule.at = vendor.supportedKeyframes(atRule.at);
	    }
	  }
	
	  function prefixStyle(style) {
	    for (var prop in style) {
	      var value = style[prop];
	
	      if (prop === 'fallbacks' && Array.isArray(value)) {
	        style[prop] = value.map(prefixStyle);
	        continue;
	      }
	
	      var changeProp = false;
	      var supportedProp = vendor.supportedProperty(prop);
	      if (supportedProp && supportedProp !== prop) changeProp = true;
	      var changeValue = false;
	      var supportedValue = vendor.supportedValue(supportedProp, jss.toCssValue(value));
	      if (supportedValue && supportedValue !== value) changeValue = true;
	
	      if (changeProp || changeValue) {
	        if (changeProp) delete style[prop];
	        style[supportedProp || prop] = supportedValue || value;
	      }
	    }
	
	    return style;
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	    return prefixStyle(style);
	  }
	
	  function onChangeValue(value, prop) {
	    return vendor.supportedValue(prop, jss.toCssValue(value)) || value;
	  }
	
	  return {
	    onProcessRule: onProcessRule,
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = jssVendorPrefixer;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';function _interopDefault(e){return(e&&(typeof e==='object')&&'default'in e)?e['default']:e}var React=__webpack_require__(2),React__default=_interopDefault(React),_inheritsLoose=_interopDefault(__webpack_require__(38)),PropTypes=_interopDefault(__webpack_require__(4)),gud=_interopDefault(__webpack_require__(231)),warning=_interopDefault(__webpack_require__(18));var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + gud() + '__';
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes.object.isRequired, _Provider$childContex);
	
	  var Consumer =
	  /*#__PURE__*/
	  function (_Component2) {
	    _inheritsLoose(Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes.object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default.createContext || createReactContext;module.exports=index;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Probability.js: Call JavaScript functions by probability.
	 *
	 * Copyright (c) 2012 Florian Schäfer (florian.schaefer@gmail.com)
	 *                    Misha Marinenko (a0x77@icloud.com)
	 * Released under MIT license.
	 *
	 * Version: 0.0.1
	 *
	 */
	
	(function(root, factory) {
	  if (true) {
	    module.exports = factory();
	  } else if (typeof define === "function" && define.amd) {
	    define(factory);
	  } else {
	    root.Probability = factory();
	  }
	})(this, function() {
	  var toString = Object.prototype.toString,
	    slice = Array.prototype.slice;
	
	  function Probability() {
	    var i = 0,
	      l = 0,
	      probas = [],
	      functions = [],
	      sum = 0,
	      args =
	        toString.call(arguments[0]) === "[object Array]"
	          ? arguments[0]
	          : slice.call(arguments);
	
	    args.push({
	      p: 0,
	      f: function() {}
	    });
	
	    for (i = 0, l = args.length; i < l; i++) {
	      var p = Math.abs(parseFloat(args[i].p)),
	        f = args[i].f;
	
	      if (isNaN(p) || typeof f !== "function") {
	        throw new TypeError(
	          "Probability.js: Invalid probability object in argument " + i + "."
	        );
	      }
	
	      if (/%/.test(args[i].p)) {
	        p = p / 100.0;
	      }
	
	      sum += p;
	
	      if (sum > 1.0) {
	        throw new TypeError(
	          'Probability.js: Probability exceeds "1.0" (=100%) in argument ' +
	            i +
	            ': p="' +
	            p +
	            '" (=' +
	            p * 100 +
	            '%), sum="' +
	            sum +
	            '" (=' +
	            sum * 100 +
	            "%)."
	        );
	      }
	
	      probas[i] = sum;
	      functions[i] = f;
	    }
	
	    return function probabilitilized() {
	      var random = Math.random();
	      for (i = 0, l = probas.length - 1; i < l && random >= probas[i]; i++) {
	        /* intentionally left empty */
	      }
	      return functions[i].apply(this, arguments);
	    };
	  }
	
	  return Probability;
	});


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(78);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(78);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(247);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 247 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.12.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),n=__webpack_require__(35),q=__webpack_require__(273);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
	function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
	function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
	var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
	function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
	return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
	var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
	60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
	function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
	var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
	function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
	tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
	D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
	function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
	function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
	function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
	function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
	Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
	function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
	function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
	function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
	function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
	function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
	function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
	function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
	function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
	function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
	n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
	function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
	var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
	b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
	elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
	0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
	0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
	2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
	"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
	var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
	Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
	function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
	var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
	function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
	function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
	function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
	function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
	var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
	function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
	function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
	function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
	function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
	function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
	function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
	var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
	function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
	function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
	var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
	b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
	var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
	function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
	var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
	dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
	e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
	a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
	h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
	var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
	function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
	var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
	case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
	function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
	function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
	var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
	function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
	function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
	function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
	function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
	function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
	function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
	function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
	function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
	k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
	function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
	var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
	c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
	function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
	function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
	function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
	Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
	r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
	if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
	p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
	k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
	typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
	function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
	function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
	var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
	function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
	function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
	function Ph(a,b){return"function"===typeof b?b(a):b}
	function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
	d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
	function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
	function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
	(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
	var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
	[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
	c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
	null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
	N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
	function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
	function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
	"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
	("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
	d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
	function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
	var xi={dehydrated:null,retryTime:0};
	function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
	null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
	function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
	Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
	Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
	function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
	var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
	function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
	function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
	function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
	e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
	d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
	if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
	a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
	function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
	function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
	function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
	function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
	function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
	function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
	function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
	pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
	function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
	function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
	function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
	function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
	H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
	"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
	(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
	function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
	function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
	lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
	(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
	k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
	c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
	Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
	typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
	null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
	e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
	d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
	64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
	e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
	V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
	function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
	null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
	Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
	l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
	"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
	fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
	Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
	(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
	function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
	function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
	gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
	1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
	typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
	e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
	null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
	b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
	e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
	c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
	case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
	function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
	function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
	function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
	10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
	function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
	function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
	function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
	function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
	Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
	fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
	var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
	if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
	xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
	(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
	rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	module.exports=function(i){var e={};function o(t){if(e[t])return e[t].exports;var a=e[t]={i:t,l:!1,exports:{}};return i[t].call(a.exports,a,a.exports,o),a.l=!0,a.exports}return o.m=i,o.c=e,o.d=function(i,e,t){o.o(i,e)||Object.defineProperty(i,e,{enumerable:!0,get:t})},o.r=function(i){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(i,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(i,"__esModule",{value:!0})},o.t=function(i,e){if(1&e&&(i=o(i)),8&e)return i;if(4&e&&"object"==typeof i&&i&&i.__esModule)return i;var t=Object.create(null);if(o.r(t),Object.defineProperty(t,"default",{enumerable:!0,value:i}),2&e&&"string"!=typeof i)for(var a in i)o.d(t,a,function(e){return i[e]}.bind(null,a));return t},o.n=function(i){var e=i&&i.__esModule?function(){return i.default}:function(){return i};return o.d(e,"a",e),e},o.o=function(i,e){return Object.prototype.hasOwnProperty.call(i,e)},o.p="",o(o.s=0)}([function(i,e,o){"use strict";e.__esModule=!0;var t=function(i){return i&&i.__esModule?i:{default:i}}(o(1));var a=Promise.resolve(),r=function(i){function e(o){!function(i,e){if(!(i instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var t=function(i,e){if(!i)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?i:e}(this,i.call(this,o));return t.uiConfig=o.uiConfig,t.firebaseAuth=o.firebaseAuth,t.className=o.className,t.uiCallback=o.uiCallback,t.unregisterAuthObserver=function(){},t}return function(i,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);i.prototype=Object.create(e&&e.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(i,e):i.__proto__=e)}(e,i),e.prototype.componentDidMount=function(){var i=this;o(2);var e=o(7);return a.then(function(){i.firebaseUiWidget=e.auth.AuthUI.getInstance()||new e.auth.AuthUI(i.firebaseAuth),"popup"===i.uiConfig.signInFlow&&i.firebaseUiWidget.reset(),i.userSignedIn=!1,i.unregisterAuthObserver=i.firebaseAuth.onAuthStateChanged(function(e){!e&&i.userSignedIn&&i.firebaseUiWidget.reset(),i.userSignedIn=!!e}),i.uiCallback&&i.uiCallback(i.firebaseUiWidget),i.firebaseUiWidget.start("#firebaseui_container",i.uiConfig)})},e.prototype.componentWillUnmount=function(){var i=this;return a=a.then(function(){return i.unregisterAuthObserver(),i.firebaseUiWidget.delete()})},e.prototype.render=function(){return t.default.createElement("div",{className:this.className,id:"firebaseui_container"})},e}(t.default.Component);e.default=r},function(i,e){i.exports=__webpack_require__(2)},function(i,e,o){var t=o(3);"string"==typeof t&&(t=[[i.i,t,""]]);var a={hmr:!0,transform:void 0,insertInto:void 0};o(5)(t,a);t.locals&&(i.exports=t.locals)},function(i,e,o){(e=i.exports=o(4)(!1)).push([i.i,"@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);",""]),e.push([i.i,'.mdl-button{background:0 0;border:none;border-radius:2px;color:#000;position:relative;height:36px;margin:0;min-width:64px;padding:0 16px;display:inline-block;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;text-transform:uppercase;line-height:1;letter-spacing:0;overflow:hidden;will-change:box-shadow;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1),color .2s cubic-bezier(.4,0,.2,1);outline:0;cursor:pointer;text-decoration:none;text-align:center;line-height:36px;vertical-align:middle}.mdl-button::-moz-focus-inner{border:0}.mdl-button:hover{background-color:hsla(0,0%,62%,.2)}.mdl-button:focus:not(:active){background-color:rgba(0,0,0,.12)}.mdl-button:active{background-color:hsla(0,0%,62%,.4)}.mdl-button.mdl-button--colored{color:#3f51b5}.mdl-button.mdl-button--colored:focus:not(:active){background-color:rgba(0,0,0,.12)}input.mdl-button[type=submit]{-webkit-appearance:none}.mdl-button--raised{background:hsla(0,0%,62%,.2);box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-button--raised:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised.mdl-button--colored{background:#3f51b5;color:#fff}.mdl-button--raised.mdl-button--colored:active,.mdl-button--raised.mdl-button--colored:focus:not(:active),.mdl-button--raised.mdl-button--colored:hover{background-color:#3f51b5}.mdl-button--raised.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--fab{border-radius:50%;font-size:24px;height:56px;margin:auto;min-width:56px;width:56px;padding:0;overflow:hidden;background:hsla(0,0%,62%,.2);box-shadow:0 1px 1.5px 0 rgba(0,0,0,.12),0 1px 1px 0 rgba(0,0,0,.24);position:relative;line-height:normal}.mdl-button--fab .material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--fab.mdl-button--mini-fab{height:40px;min-width:40px;width:40px}.mdl-button--fab .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button--fab:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab.mdl-button--colored{background:#ff4081;color:#fff}.mdl-button--fab.mdl-button--colored:active,.mdl-button--fab.mdl-button--colored:focus:not(:active),.mdl-button--fab.mdl-button--colored:hover{background-color:#ff4081}.mdl-button--fab.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--icon{border-radius:50%;font-size:24px;height:32px;margin-left:0;margin-right:0;min-width:32px;width:32px;padding:0;overflow:hidden;color:inherit;line-height:normal}.mdl-button--icon .material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon{height:24px;min-width:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon .material-icons{top:0;left:0}.mdl-button--icon .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button__ripple-container{display:block;height:100%;left:0;position:absolute;top:0;width:100%;z-index:0;overflow:hidden}.mdl-button.mdl-button--disabled .mdl-button__ripple-container .mdl-ripple,.mdl-button[disabled] .mdl-button__ripple-container .mdl-ripple{background-color:transparent}.mdl-button--primary.mdl-button--primary{color:#3f51b5}.mdl-button--primary.mdl-button--primary .mdl-ripple{background:#fff}.mdl-button--primary.mdl-button--primary.mdl-button--fab,.mdl-button--primary.mdl-button--primary.mdl-button--raised{color:#fff;background-color:#3f51b5}.mdl-button--accent.mdl-button--accent{color:#ff4081}.mdl-button--accent.mdl-button--accent .mdl-ripple{background:#fff}.mdl-button--accent.mdl-button--accent.mdl-button--fab,.mdl-button--accent.mdl-button--accent.mdl-button--raised{color:#fff;background-color:#ff4081}.mdl-button.mdl-button--disabled.mdl-button--disabled,.mdl-button[disabled][disabled]{color:rgba(0,0,0,.26);cursor:default;background-color:transparent}.mdl-button--fab.mdl-button--disabled.mdl-button--disabled,.mdl-button--fab[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-button--raised.mdl-button--disabled.mdl-button--disabled,.mdl-button--raised[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26);box-shadow:none}.mdl-button--colored.mdl-button--disabled.mdl-button--disabled,.mdl-button--colored[disabled][disabled]{color:rgba(0,0,0,.26)}.mdl-button .material-icons{vertical-align:middle}.mdl-card{display:flex;flex-direction:column;font-size:16px;font-weight:400;min-height:200px;overflow:hidden;width:330px;z-index:1;position:relative;background:#fff;border-radius:2px;box-sizing:border-box}.mdl-card__media{background-color:#ff4081;background-repeat:repeat;background-position:50% 50%;background-size:cover;background-origin:padding-box;background-attachment:scroll;box-sizing:border-box}.mdl-card__title{align-items:center;color:#000;display:block;display:flex;justify-content:stretch;line-height:normal;padding:16px;perspective-origin:165px 56px;transform-origin:165px 56px;box-sizing:border-box}.mdl-card__title.mdl-card--border{border-bottom:1px solid rgba(0,0,0,.1)}.mdl-card__title-text{align-self:flex-end;color:inherit;display:block;display:flex;font-size:24px;font-weight:300;line-height:normal;overflow:hidden;transform-origin:149px 48px;margin:0}.mdl-card__subtitle-text{font-size:14px;color:rgba(0,0,0,.54);margin:0}.mdl-card__supporting-text{color:rgba(0,0,0,.54);font-size:1rem;line-height:18px;overflow:hidden;padding:16px;width:90%}.mdl-card__supporting-text.mdl-card--border{border-bottom:1px solid rgba(0,0,0,.1)}.mdl-card__actions{font-size:16px;line-height:normal;width:100%;background-color:transparent;padding:8px;box-sizing:border-box}.mdl-card__actions.mdl-card--border{border-top:1px solid rgba(0,0,0,.1)}.mdl-card--expand{flex-grow:1}.mdl-card__menu{position:absolute;right:16px;top:16px}.mdl-dialog{border:none;box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2);width:280px}.mdl-dialog__title{padding:24px 24px 0;margin:0;font-size:2.5rem}.mdl-dialog__actions{padding:8px 8px 8px 24px;display:flex;flex-direction:row-reverse;flex-wrap:wrap}.mdl-dialog__actions>*{margin-right:8px;height:36px}.mdl-dialog__actions>:first-child{margin-right:0}.mdl-dialog__actions--full-width{padding:0 0 8px}.mdl-dialog__actions--full-width>*{height:48px;flex:0 0 100%;padding-right:16px;margin-right:0;text-align:right}.mdl-dialog__content{padding:20px 24px 24px;color:rgba(0,0,0,.54)}.mdl-progress{display:block;position:relative;height:4px;width:500px;max-width:100%}.mdl-progress>.bar{display:block;position:absolute;top:0;bottom:0;width:0;transition:width .2s cubic-bezier(.4,0,.2,1)}.mdl-progress>.progressbar{background-color:#3f51b5;z-index:1;left:0}.mdl-progress>.bufferbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#3f51b5,#3f51b5);z-index:0;left:0}.mdl-progress>.auxbar{right:0}@supports (-webkit-appearance:none){.mdl-progress:not(.mdl-progress--indeterminate):not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate):not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#3f51b5,#3f51b5);mask:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=)}}.mdl-progress:not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.9),hsla(0,0%,100%,.9)),linear-gradient(90deg,#3f51b5,#3f51b5)}.mdl-progress.mdl-progress--indeterminate>.bar1,.mdl-progress.mdl-progress__indeterminate>.bar1{background-color:#3f51b5;animation-name:indeterminate1;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}.mdl-progress.mdl-progress--indeterminate>.bar3,.mdl-progress.mdl-progress__indeterminate>.bar3{background-image:none;background-color:#3f51b5;animation-name:indeterminate2;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes indeterminate1{0%{left:0;width:0}50%{left:25%;width:75%}75%{left:100%;width:0}}@keyframes indeterminate2{0%{left:0;width:0}50%{left:0;width:0}75%{left:0;width:25%}to{left:100%;width:0}}.mdl-shadow--2dp{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-shadow--3dp{box-shadow:0 3px 4px 0 rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.2),0 1px 8px 0 rgba(0,0,0,.12)}.mdl-shadow--4dp{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2)}.mdl-shadow--6dp{box-shadow:0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12),0 3px 5px -1px rgba(0,0,0,.2)}.mdl-shadow--8dp{box-shadow:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2)}.mdl-shadow--16dp{box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.mdl-shadow--24dp{box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2)}.mdl-spinner{display:inline-block;position:relative;width:28px;height:28px}.mdl-spinner:not(.is-upgraded).is-active:after{content:"Loading..."}.mdl-spinner.is-upgraded.is-active{animation:mdl-spinner__container-rotate 1.568s linear infinite}@keyframes mdl-spinner__container-rotate{to{transform:rotate(1turn)}}.mdl-spinner__layer{position:absolute;width:100%;height:100%;opacity:0}.mdl-spinner__layer-1{border-color:#42a5f5}.mdl-spinner--single-color .mdl-spinner__layer-1{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-1{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-2{border-color:#f44336}.mdl-spinner--single-color .mdl-spinner__layer-2{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-2{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-3{border-color:#fdd835}.mdl-spinner--single-color .mdl-spinner__layer-3{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-3{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-4{border-color:#4caf50}.mdl-spinner--single-color .mdl-spinner__layer-4{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-4{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}@keyframes mdl-spinner__fill-unfill-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}to{transform:rotate(3turn)}}@keyframes mdl-spinner__layer-1-fade-in-out{0%{opacity:.99}25%{opacity:.99}26%{opacity:0}89%{opacity:0}90%{opacity:.99}to{opacity:.99}}@keyframes mdl-spinner__layer-2-fade-in-out{0%{opacity:0}15%{opacity:0}25%{opacity:.99}50%{opacity:.99}51%{opacity:0}}@keyframes mdl-spinner__layer-3-fade-in-out{0%{opacity:0}40%{opacity:0}50%{opacity:.99}75%{opacity:.99}76%{opacity:0}}@keyframes mdl-spinner__layer-4-fade-in-out{0%{opacity:0}65%{opacity:0}75%{opacity:.99}90%{opacity:.99}to{opacity:0}}.mdl-spinner__gap-patch{position:absolute;box-sizing:border-box;top:0;left:45%;width:10%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__gap-patch .mdl-spinner__circle{width:1000%;left:-450%}.mdl-spinner__circle-clipper{display:inline-block;position:relative;width:50%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__circle-clipper.mdl-spinner__left{float:left}.mdl-spinner__circle-clipper.mdl-spinner__right{float:right}.mdl-spinner__circle-clipper .mdl-spinner__circle{width:200%}.mdl-spinner__circle{box-sizing:border-box;height:100%;border-width:3px;border-style:solid;border-color:inherit;border-bottom-color:transparent!important;border-radius:50%;animation:none;position:absolute;top:0;right:0;bottom:0;left:0}.mdl-spinner__left .mdl-spinner__circle{border-right-color:transparent!important;transform:rotate(129deg)}.mdl-spinner.is-active .mdl-spinner__left .mdl-spinner__circle{animation:mdl-spinner__left-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__right .mdl-spinner__circle{left:-100%;border-left-color:transparent!important;transform:rotate(-129deg)}.mdl-spinner.is-active .mdl-spinner__right .mdl-spinner__circle{animation:mdl-spinner__right-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}@keyframes mdl-spinner__left-spin{0%{transform:rotate(130deg)}50%{transform:rotate(-5deg)}to{transform:rotate(130deg)}}@keyframes mdl-spinner__right-spin{0%{transform:rotate(-130deg)}50%{transform:rotate(5deg)}to{transform:rotate(-130deg)}}.mdl-textfield{position:relative;font-size:16px;display:inline-block;box-sizing:border-box;width:300px;max-width:100%;margin:0;padding:20px 0}.mdl-textfield .mdl-button{position:absolute;bottom:20px}.mdl-textfield--align-right{text-align:right}.mdl-textfield--full-width{width:100%}.mdl-textfield--expandable{min-width:32px;width:auto;min-height:32px}.mdl-textfield--expandable .mdl-button--icon{top:16px}.mdl-textfield__input{border:none;border-bottom:1px solid rgba(0,0,0,.12);display:block;font-size:16px;font-family:Helvetica,Arial,sans-serif;margin:0;padding:4px 0;width:100%;background:0 0;text-align:left;color:inherit}.mdl-textfield__input[type=number]{-moz-appearance:textfield}.mdl-textfield__input[type=number]::-webkit-inner-spin-button,.mdl-textfield__input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.mdl-textfield.is-focused .mdl-textfield__input{outline:0}.mdl-textfield.is-invalid .mdl-textfield__input{border-color:#d50000;box-shadow:none}.mdl-textfield.is-disabled .mdl-textfield__input,fieldset[disabled] .mdl-textfield .mdl-textfield__input{background-color:transparent;border-bottom:1px dotted rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-textfield textarea.mdl-textfield__input{display:block}.mdl-textfield__label{bottom:0;color:rgba(0,0,0,.26);font-size:16px;left:0;right:0;pointer-events:none;position:absolute;display:block;top:24px;width:100%;overflow:hidden;white-space:nowrap;text-align:left}.mdl-textfield.has-placeholder .mdl-textfield__label,.mdl-textfield.is-dirty .mdl-textfield__label{visibility:hidden}.mdl-textfield--floating-label .mdl-textfield__label{transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label{transition:none}.mdl-textfield.is-disabled.is-disabled .mdl-textfield__label,fieldset[disabled] .mdl-textfield .mdl-textfield__label{color:rgba(0,0,0,.26)}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#3f51b5;font-size:12px;top:4px;visibility:visible}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__expandable-holder .mdl-textfield__label{top:-16px}.mdl-textfield--floating-label.is-invalid .mdl-textfield__label{color:#d50000;font-size:12px}.mdl-textfield__label:after{background-color:#3f51b5;bottom:20px;content:"";height:2px;left:45%;position:absolute;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);visibility:hidden;width:10px}.mdl-textfield.is-focused .mdl-textfield__label:after{left:0;visibility:visible;width:100%}.mdl-textfield.is-invalid .mdl-textfield__label:after{background-color:#d50000}.mdl-textfield__error{color:#d50000;position:absolute;font-size:12px;margin-top:3px;visibility:hidden;display:block}.mdl-textfield.is-invalid .mdl-textfield__error{visibility:visible}.mdl-textfield__expandable-holder{position:relative;margin-left:32px;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);display:inline-block;max-width:.1px}.mdl-textfield.is-dirty .mdl-textfield__expandable-holder,.mdl-textfield.is-focused .mdl-textfield__expandable-holder{max-width:600px}.mdl-textfield__expandable-holder .mdl-textfield__label:after{bottom:0}dialog{position:absolute;left:0;right:0;width:-moz-fit-content;width:-webkit-fit-content;width:fit-content;height:-moz-fit-content;height:-webkit-fit-content;height:fit-content;margin:auto;border:solid;padding:1em;background:#fff;color:#000;display:block}dialog:not([open]){display:none}dialog+.backdrop{background:rgba(0,0,0,.1)}._dialog_overlay,dialog+.backdrop{position:fixed;top:0;right:0;bottom:0;left:0}dialog.fixed{position:fixed;top:50%;transform:translateY(-50%)}.firebaseui-container{background-color:#fff;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;color:rgba(0,0,0,.87);direction:ltr;font:16px Roboto,arial,sans-serif;margin:0 auto;max-width:360px;overflow:visible;position:relative;text-align:left;width:100%}.firebaseui-container.mdl-card{overflow:visible}.firebaseui-card-header{padding:24px 24px 0}.firebaseui-card-content,.firebaseui-card-footer{padding:0 24px}.firebaseui-card-actions{box-sizing:border-box;display:table;font-size:14px;padding:8px 24px 24px;text-align:left;width:100%}.firebaseui-form-links{display:table-cell;vertical-align:middle;width:100%}.firebaseui-form-actions{display:table-cell;text-align:right;white-space:nowrap;width:100%}.firebaseui-subtitle,.firebaseui-title{color:rgba(0,0,0,.87);direction:ltr;font-size:20px;font-weight:500;line-height:24px;margin:0;padding:0;text-align:left}.firebaseui-title{padding-bottom:16px}.firebaseui-subtitle{margin:16px 0}.firebaseui-text{color:rgba(0,0,0,.87);direction:ltr;font-size:16px;line-height:24px;text-align:left}.firebaseui-id-page-password-recovery-email-sent p.firebaseui-text{margin:16px 0}.firebaseui-text-emphasis{font-weight:700}.firebaseui-error{color:#dd2c00;direction:ltr;font-size:12px;line-height:16px;margin:0;text-align:left}.firebaseui-text-input-error{margin:-16px 0 16px}.firebaseui-error-wrapper{min-height:16px}.firebaseui-list-item{direction:ltr;margin:0;padding:0;text-align:left}.firebaseui-hidden{display:none}.firebaseui-relative-wrapper{position:relative}.firebaseui-label{color:rgba(0,0,0,.54);direction:ltr;font-size:16px;text-align:left}.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#757575}.firebaseui-input,.firebaseui-input-invalid{border-radius:0;color:rgba(0,0,0,.87);direction:ltr;font-size:16px;width:100%}input.firebaseui-input,input.firebaseui-input-invalid{direction:ltr;text-align:left}.firebaseui-input-invalid{border-color:#dd2c00}.firebaseui-textfield{width:100%}.firebaseui-textfield.mdl-textfield .firebaseui-input{border-color:rgba(0,0,0,.12)}.firebaseui-textfield.mdl-textfield .firebaseui-label:after{background-color:#3f51b5}.firebaseui-textfield-invalid.mdl-textfield .firebaseui-input{border-color:#dd2c00}.firebaseui-textfield-invalid.mdl-textfield .firebaseui-label:after{background-color:#dd2c00}.firebaseui-button{display:inline-block;height:36px;margin-left:8px;min-width:88px}.firebaseui-link{color:#4285f4;font-variant:normal;font-weight:400;text-decoration:none}.firebaseui-link:hover{text-decoration:underline}.firebaseui-indent{margin-left:1em}.firebaseui-tos{color:#757575;direction:ltr;font-size:12px;line-height:16px;margin-bottom:24px;margin-top:0;text-align:left}.firebaseui-provider-sign-in-footer>.firebaseui-tos{text-align:center}.firebaseui-tos-list{list-style:none;text-align:right}.firebaseui-inline-list-item{display:inline-block;margin-left:5px;margin-right:5px}.firebaseui-page-provider-sign-in{background:inherit}.firebaseui-idp-list{list-style:none;margin:1em 0;padding:0}.firebaseui-idp-button{direction:ltr;font-weight:500;height:auto;line-height:normal;max-width:220px;min-height:40px;padding:8px 16px;text-align:left;width:100%}.firebaseui-idp-list>.firebaseui-list-item{margin-bottom:15px;text-align:center}.firebaseui-idp-icon-wrapper{display:table-cell;vertical-align:middle}.firebaseui-idp-icon{height:18px;width:18px}.firebaseui-idp-favicon,.firebaseui-idp-icon{border:none;display:inline-block;vertical-align:middle}.firebaseui-idp-favicon{height:14px;margin-right:5px;width:14px}.firebaseui-idp-text{color:#fff;display:table-cell;font-size:14px;padding-left:16px;text-transform:none;vertical-align:middle}.firebaseui-idp-text.firebaseui-idp-text-long{display:table-cell}.firebaseui-idp-text.firebaseui-idp-text-short{display:none}@media (max-width:268px){.firebaseui-idp-text.firebaseui-idp-text-long{display:none}.firebaseui-idp-text.firebaseui-idp-text-short{display:table-cell}}@media (max-width:320px){.firebaseui-recaptcha-container>div>div{transform:scale(.9);-webkit-transform:scale(.9);transform-origin:0 0;-webkit-transform-origin:0 0}}.firebaseui-idp-password,.firebaseui-idp-password:hover,.mdl-button.firebaseui-idp-password:active,.mdl-button.firebaseui-idp-password:focus{background-color:#db4437}.firebaseui-idp-phone,.firebaseui-idp-phone:hover,.mdl-button.firebaseui-idp-phone:active,.mdl-button.firebaseui-idp-phone:focus{background-color:#02bd7e}.firebaseui-idp-google,.firebaseui-idp-google:hover,.mdl-button.firebaseui-idp-google:active,.mdl-button.firebaseui-idp-google:focus{background-color:#fff}.firebaseui-idp-google>.firebaseui-idp-text{color:#757575}.firebaseui-idp-github,.firebaseui-idp-github:hover,.mdl-button.firebaseui-idp-github:active,.mdl-button.firebaseui-idp-github:focus{background-color:#333}.firebaseui-idp-facebook,.firebaseui-idp-facebook:hover,.mdl-button.firebaseui-idp-facebook:active,.mdl-button.firebaseui-idp-facebook:focus{background-color:#3b5998}.firebaseui-idp-twitter,.firebaseui-idp-twitter:hover,.mdl-button.firebaseui-idp-twitter:active,.mdl-button.firebaseui-idp-twitter:focus{background-color:#55acee}.firebaseui-idp-anonymous,.firebaseui-idp-anonymous:hover,.mdl-button.firebaseui-idp-anonymous:active,.mdl-button.firebaseui-idp-anonymous:focus{background-color:#f4b400}.firebaseui-info-bar{background-color:#f9edbe;border:1px solid #f0c36d;box-shadow:0 2px 4px rgba(0,0,0,.2);-webkit-box-shadow:0 2px 4px rgba(0,0,0,.2);-moz-box-shadow:0 2px 4px rgba(0,0,0,.2);left:10%;padding:8px 16px;position:absolute;right:10%;text-align:center;top:0}.firebaseui-info-bar-message{font-size:12px;margin:0}.firebaseui-dialog{box-sizing:border-box;color:rgba(0,0,0,.87);font:16px Roboto,arial,sans-serif;height:auto;padding:24px;text-align:left}.firebaseui-dialog-icon-wrapper{display:table-cell;vertical-align:middle}.firebaseui-dialog-icon{float:left;height:40px;margin-right:24px;width:40px}.firebaseui-progress-dialog-message{display:table-cell;font-size:16px;font-weight:400;min-height:40px;vertical-align:middle}.firebaseui-progress-dialog-loading-icon{height:28px;margin:6px 30px 6px 6px;width:28px}.firebaseui-icon-done{background-image:url(https://www.gstatic.com/images/icons/material/system/2x/done_googgreen_36dp.png);background-position:50%;background-repeat:no-repeat;background-size:36px 36px}.firebaseui-phone-number{display:flex}.firebaseui-country-selector{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/arrow_drop_down_grey600_18dp.png);background-position:100%;background-repeat:no-repeat;background-size:18px auto;border-radius:0;border-bottom:1px solid rgba(0,0,0,.12);color:rgba(0,0,0,.87);flex-shrink:0;font-size:16px;font-weight:400;height:auto;line-height:normal;margin:20px 24px 20px 0;padding:4px 20px 4px 0;width:90px}.firebaseui-country-selector-flag{display:inline-block;margin-right:1ex}.firebaseui-flag{background-image:url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/flags_sprite_2x.png);background-size:100% auto;filter:drop-shadow(1px 1px 1px rgba(0,0,0,.54));height:14px;width:24px}.firebaseui-list-box-dialog{max-height:90%;overflow:auto;padding:8px 0 0}.firebaseui-list-box-actions{padding-bottom:8px}.firebaseui-list-box-icon-wrapper{padding-right:24px}.firebaseui-list-box-icon-wrapper,.firebaseui-list-box-label-wrapper{display:table-cell;vertical-align:top}.firebaseui-list-box-dialog-button{color:rgba(0,0,0,.87);direction:ltr;font-size:16px;font-weight:400;height:auto;line-height:normal;min-height:48px;padding:14px 24px;text-align:left;text-transform:none;width:100%}.firebaseui-phone-number-error{margin-left:114px}.mdl-progress.firebaseui-busy-indicator{height:2px;left:0;position:absolute;top:55px;width:100%}.mdl-spinner.firebaseui-busy-indicator{height:56px;left:0;margin:auto;position:absolute;right:0;top:30%;width:56px}.firebaseui-callback-indicator-container .firebaseui-busy-indicator{top:0}.firebaseui-callback-indicator-container{height:120px}.firebaseui-new-password-component{display:inline-block;position:relative;width:100%}.firebaseui-input-floating-button{background-position:50%;background-repeat:no-repeat;display:block;height:24px;position:absolute;right:0;top:20px;width:24px}.firebaseui-input-toggle-on{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/visibility_black_24dp.png)}.firebaseui-input-toggle-off{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/visibility_off_black_24dp.png)}.firebaseui-input-toggle-focus{opacity:.87}.firebaseui-input-toggle-blur{opacity:.38}.firebaseui-recaptcha-wrapper{display:table;margin:0 auto;padding-bottom:8px}.firebaseui-recaptcha-container{display:table-cell}.firebaseui-recaptcha-error-wrapper{caption-side:bottom;display:table-caption}.firebaseui-change-phone-number-link{display:block}.firebaseui-resend-container{direction:ltr;margin:20px 0;text-align:center}.firebaseui-id-resend-countdown{color:rgba(0,0,0,.38)}.firebaseui-id-page-phone-sign-in-start .firebaseui-form-actions div{float:left}@media (max-width:480px){.firebaseui-container{box-shadow:none;max-width:none;width:100%}.firebaseui-card-header{border-bottom:1px solid #e0e0e0;margin-bottom:16px;padding:16px 24px 0}.firebaseui-title{padding-bottom:16px}.firebaseui-card-actions{padding-right:24px}.firebaseui-busy-indicator{top:0}}.mdl-textfield__label{font-weight:400;margin-bottom:0}.firebaseui-id-page-blank{background:inherit;height:64px}.firebaseui-email-sent{background-image:url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/success_status.png);background-position:50%;background-repeat:no-repeat;background-size:64px 64px;height:64px;margin-top:16px;text-align:center}.firebaseui-text-justify{text-align:justify}.firebaseui-flag-KY{background-position:0 0}.firebaseui-flag-AC{background-position:0 -14px}.firebaseui-flag-AE{background-position:0 -28px}.firebaseui-flag-AF{background-position:0 -42px}.firebaseui-flag-AG{background-position:0 -56px}.firebaseui-flag-AI{background-position:0 -70px}.firebaseui-flag-AL{background-position:0 -84px}.firebaseui-flag-AM{background-position:0 -98px}.firebaseui-flag-AO{background-position:0 -112px}.firebaseui-flag-AQ{background-position:0 -126px}.firebaseui-flag-AR{background-position:0 -140px}.firebaseui-flag-AS{background-position:0 -154px}.firebaseui-flag-AT{background-position:0 -168px}.firebaseui-flag-AU{background-position:0 -182px}.firebaseui-flag-AW{background-position:0 -196px}.firebaseui-flag-AX{background-position:0 -210px}.firebaseui-flag-AZ{background-position:0 -224px}.firebaseui-flag-BA{background-position:0 -238px}.firebaseui-flag-BB{background-position:0 -252px}.firebaseui-flag-BD{background-position:0 -266px}.firebaseui-flag-BE{background-position:0 -280px}.firebaseui-flag-BF{background-position:0 -294px}.firebaseui-flag-BG{background-position:0 -308px}.firebaseui-flag-BH{background-position:0 -322px}.firebaseui-flag-BI{background-position:0 -336px}.firebaseui-flag-BJ{background-position:0 -350px}.firebaseui-flag-BL{background-position:0 -364px}.firebaseui-flag-BM{background-position:0 -378px}.firebaseui-flag-BN{background-position:0 -392px}.firebaseui-flag-BO{background-position:0 -406px}.firebaseui-flag-BQ{background-position:0 -420px}.firebaseui-flag-BR{background-position:0 -434px}.firebaseui-flag-BS{background-position:0 -448px}.firebaseui-flag-BT{background-position:0 -462px}.firebaseui-flag-BV{background-position:0 -476px}.firebaseui-flag-BW{background-position:0 -490px}.firebaseui-flag-BY{background-position:0 -504px}.firebaseui-flag-BZ{background-position:0 -518px}.firebaseui-flag-CA{background-position:0 -532px}.firebaseui-flag-CC{background-position:0 -546px}.firebaseui-flag-CD{background-position:0 -560px}.firebaseui-flag-CF{background-position:0 -574px}.firebaseui-flag-CG{background-position:0 -588px}.firebaseui-flag-CH{background-position:0 -602px}.firebaseui-flag-CI{background-position:0 -616px}.firebaseui-flag-CK{background-position:0 -630px}.firebaseui-flag-CL{background-position:0 -644px}.firebaseui-flag-CM{background-position:0 -658px}.firebaseui-flag-CN{background-position:0 -672px}.firebaseui-flag-CO{background-position:0 -686px}.firebaseui-flag-CP{background-position:0 -700px}.firebaseui-flag-CR{background-position:0 -714px}.firebaseui-flag-CU{background-position:0 -728px}.firebaseui-flag-CV{background-position:0 -742px}.firebaseui-flag-CW{background-position:0 -756px}.firebaseui-flag-CX{background-position:0 -770px}.firebaseui-flag-CY{background-position:0 -784px}.firebaseui-flag-CZ{background-position:0 -798px}.firebaseui-flag-DE{background-position:0 -812px}.firebaseui-flag-DG{background-position:0 -826px}.firebaseui-flag-DJ{background-position:0 -840px}.firebaseui-flag-DK{background-position:0 -854px}.firebaseui-flag-DM{background-position:0 -868px}.firebaseui-flag-DO{background-position:0 -882px}.firebaseui-flag-DZ{background-position:0 -896px}.firebaseui-flag-EA{background-position:0 -910px}.firebaseui-flag-EC{background-position:0 -924px}.firebaseui-flag-EE{background-position:0 -938px}.firebaseui-flag-EG{background-position:0 -952px}.firebaseui-flag-EH{background-position:0 -966px}.firebaseui-flag-ER{background-position:0 -980px}.firebaseui-flag-ES{background-position:0 -994px}.firebaseui-flag-ET{background-position:0 -1008px}.firebaseui-flag-EU{background-position:0 -1022px}.firebaseui-flag-FI{background-position:0 -1036px}.firebaseui-flag-FJ{background-position:0 -1050px}.firebaseui-flag-FK{background-position:0 -1064px}.firebaseui-flag-FM{background-position:0 -1078px}.firebaseui-flag-FO{background-position:0 -1092px}.firebaseui-flag-FR{background-position:0 -1106px}.firebaseui-flag-GA{background-position:0 -1120px}.firebaseui-flag-GB{background-position:0 -1134px}.firebaseui-flag-GD{background-position:0 -1148px}.firebaseui-flag-GE{background-position:0 -1162px}.firebaseui-flag-GF{background-position:0 -1176px}.firebaseui-flag-GG{background-position:0 -1190px}.firebaseui-flag-GH{background-position:0 -1204px}.firebaseui-flag-GI{background-position:0 -1218px}.firebaseui-flag-GL{background-position:0 -1232px}.firebaseui-flag-GM{background-position:0 -1246px}.firebaseui-flag-GN{background-position:0 -1260px}.firebaseui-flag-GP{background-position:0 -1274px}.firebaseui-flag-GQ{background-position:0 -1288px}.firebaseui-flag-GR{background-position:0 -1302px}.firebaseui-flag-GS{background-position:0 -1316px}.firebaseui-flag-GT{background-position:0 -1330px}.firebaseui-flag-GU{background-position:0 -1344px}.firebaseui-flag-GW{background-position:0 -1358px}.firebaseui-flag-GY{background-position:0 -1372px}.firebaseui-flag-HK{background-position:0 -1386px}.firebaseui-flag-HM{background-position:0 -1400px}.firebaseui-flag-HN{background-position:0 -1414px}.firebaseui-flag-HR{background-position:0 -1428px}.firebaseui-flag-HT{background-position:0 -1442px}.firebaseui-flag-HU{background-position:0 -1456px}.firebaseui-flag-IC{background-position:0 -1470px}.firebaseui-flag-ID{background-position:0 -1484px}.firebaseui-flag-IE{background-position:0 -1498px}.firebaseui-flag-IL{background-position:0 -1512px}.firebaseui-flag-IM{background-position:0 -1526px}.firebaseui-flag-IN{background-position:0 -1540px}.firebaseui-flag-IO{background-position:0 -1554px}.firebaseui-flag-IQ{background-position:0 -1568px}.firebaseui-flag-IR{background-position:0 -1582px}.firebaseui-flag-IS{background-position:0 -1596px}.firebaseui-flag-IT{background-position:0 -1610px}.firebaseui-flag-JE{background-position:0 -1624px}.firebaseui-flag-JM{background-position:0 -1638px}.firebaseui-flag-JO{background-position:0 -1652px}.firebaseui-flag-JP{background-position:0 -1666px}.firebaseui-flag-KE{background-position:0 -1680px}.firebaseui-flag-KG{background-position:0 -1694px}.firebaseui-flag-KH{background-position:0 -1708px}.firebaseui-flag-KI{background-position:0 -1722px}.firebaseui-flag-KM{background-position:0 -1736px}.firebaseui-flag-KN{background-position:0 -1750px}.firebaseui-flag-KP{background-position:0 -1764px}.firebaseui-flag-KR{background-position:0 -1778px}.firebaseui-flag-KW{background-position:0 -1792px}.firebaseui-flag-AD{background-position:0 -1806px}.firebaseui-flag-KZ{background-position:0 -1820px}.firebaseui-flag-LA{background-position:0 -1834px}.firebaseui-flag-LB{background-position:0 -1848px}.firebaseui-flag-LC{background-position:0 -1862px}.firebaseui-flag-LI{background-position:0 -1876px}.firebaseui-flag-LK{background-position:0 -1890px}.firebaseui-flag-LR{background-position:0 -1904px}.firebaseui-flag-LS{background-position:0 -1918px}.firebaseui-flag-LT{background-position:0 -1932px}.firebaseui-flag-LU{background-position:0 -1946px}.firebaseui-flag-LV{background-position:0 -1960px}.firebaseui-flag-LY{background-position:0 -1974px}.firebaseui-flag-MA{background-position:0 -1988px}.firebaseui-flag-MC{background-position:0 -2002px}.firebaseui-flag-MD{background-position:0 -2016px}.firebaseui-flag-ME{background-position:0 -2030px}.firebaseui-flag-MF{background-position:0 -2044px}.firebaseui-flag-MG{background-position:0 -2058px}.firebaseui-flag-MH{background-position:0 -2072px}.firebaseui-flag-MK{background-position:0 -2086px}.firebaseui-flag-ML{background-position:0 -2100px}.firebaseui-flag-MM{background-position:0 -2114px}.firebaseui-flag-MN{background-position:0 -2128px}.firebaseui-flag-MO{background-position:0 -2142px}.firebaseui-flag-MP{background-position:0 -2156px}.firebaseui-flag-MQ{background-position:0 -2170px}.firebaseui-flag-MR{background-position:0 -2184px}.firebaseui-flag-MS{background-position:0 -2198px}.firebaseui-flag-MT{background-position:0 -2212px}.firebaseui-flag-MU{background-position:0 -2226px}.firebaseui-flag-MV{background-position:0 -2240px}.firebaseui-flag-MW{background-position:0 -2254px}.firebaseui-flag-MX{background-position:0 -2268px}.firebaseui-flag-MY{background-position:0 -2282px}.firebaseui-flag-MZ{background-position:0 -2296px}.firebaseui-flag-NA{background-position:0 -2310px}.firebaseui-flag-NC{background-position:0 -2324px}.firebaseui-flag-NE{background-position:0 -2338px}.firebaseui-flag-NF{background-position:0 -2352px}.firebaseui-flag-NG{background-position:0 -2366px}.firebaseui-flag-NI{background-position:0 -2380px}.firebaseui-flag-NL{background-position:0 -2394px}.firebaseui-flag-NO{background-position:0 -2408px}.firebaseui-flag-NP{background-position:0 -2422px}.firebaseui-flag-NR{background-position:0 -2436px}.firebaseui-flag-NU{background-position:0 -2450px}.firebaseui-flag-NZ{background-position:0 -2464px}.firebaseui-flag-OM{background-position:0 -2478px}.firebaseui-flag-PA{background-position:0 -2492px}.firebaseui-flag-PE{background-position:0 -2506px}.firebaseui-flag-PF{background-position:0 -2520px}.firebaseui-flag-PG{background-position:0 -2534px}.firebaseui-flag-PH{background-position:0 -2548px}.firebaseui-flag-PK{background-position:0 -2562px}.firebaseui-flag-PL{background-position:0 -2576px}.firebaseui-flag-PM{background-position:0 -2590px}.firebaseui-flag-PN{background-position:0 -2604px}.firebaseui-flag-PR{background-position:0 -2618px}.firebaseui-flag-PS{background-position:0 -2632px}.firebaseui-flag-PT{background-position:0 -2646px}.firebaseui-flag-PW{background-position:0 -2660px}.firebaseui-flag-PY{background-position:0 -2674px}.firebaseui-flag-QA{background-position:0 -2688px}.firebaseui-flag-RE{background-position:0 -2702px}.firebaseui-flag-RO{background-position:0 -2716px}.firebaseui-flag-RS{background-position:0 -2730px}.firebaseui-flag-RU{background-position:0 -2744px}.firebaseui-flag-RW{background-position:0 -2758px}.firebaseui-flag-SA{background-position:0 -2772px}.firebaseui-flag-SB{background-position:0 -2786px}.firebaseui-flag-SC{background-position:0 -2800px}.firebaseui-flag-SD{background-position:0 -2814px}.firebaseui-flag-SE{background-position:0 -2828px}.firebaseui-flag-SG{background-position:0 -2842px}.firebaseui-flag-SH{background-position:0 -2856px}.firebaseui-flag-SI{background-position:0 -2870px}.firebaseui-flag-SJ{background-position:0 -2884px}.firebaseui-flag-SK{background-position:0 -2898px}.firebaseui-flag-SL{background-position:0 -2912px}.firebaseui-flag-SM{background-position:0 -2926px}.firebaseui-flag-SN{background-position:0 -2940px}.firebaseui-flag-SO{background-position:0 -2954px}.firebaseui-flag-SR{background-position:0 -2968px}.firebaseui-flag-SS{background-position:0 -2982px}.firebaseui-flag-ST{background-position:0 -2996px}.firebaseui-flag-SV{background-position:0 -3010px}.firebaseui-flag-SX{background-position:0 -3024px}.firebaseui-flag-SY{background-position:0 -3038px}.firebaseui-flag-SZ{background-position:0 -3052px}.firebaseui-flag-TA{background-position:0 -3066px}.firebaseui-flag-TC{background-position:0 -3080px}.firebaseui-flag-TD{background-position:0 -3094px}.firebaseui-flag-TF{background-position:0 -3108px}.firebaseui-flag-TG{background-position:0 -3122px}.firebaseui-flag-TH{background-position:0 -3136px}.firebaseui-flag-TJ{background-position:0 -3150px}.firebaseui-flag-TK{background-position:0 -3164px}.firebaseui-flag-TL{background-position:0 -3178px}.firebaseui-flag-TM{background-position:0 -3192px}.firebaseui-flag-TN{background-position:0 -3206px}.firebaseui-flag-TO{background-position:0 -3220px}.firebaseui-flag-TR{background-position:0 -3234px}.firebaseui-flag-TT{background-position:0 -3248px}.firebaseui-flag-TV{background-position:0 -3262px}.firebaseui-flag-TW{background-position:0 -3276px}.firebaseui-flag-TZ{background-position:0 -3290px}.firebaseui-flag-UA{background-position:0 -3304px}.firebaseui-flag-UG{background-position:0 -3318px}.firebaseui-flag-UM{background-position:0 -3332px}.firebaseui-flag-UN{background-position:0 -3346px}.firebaseui-flag-US{background-position:0 -3360px}.firebaseui-flag-UY{background-position:0 -3374px}.firebaseui-flag-UZ{background-position:0 -3388px}.firebaseui-flag-VA{background-position:0 -3402px}.firebaseui-flag-VC{background-position:0 -3416px}.firebaseui-flag-VE{background-position:0 -3430px}.firebaseui-flag-VG{background-position:0 -3444px}.firebaseui-flag-VI{background-position:0 -3458px}.firebaseui-flag-VN{background-position:0 -3472px}.firebaseui-flag-VU{background-position:0 -3486px}.firebaseui-flag-WF{background-position:0 -3500px}.firebaseui-flag-WS{background-position:0 -3514px}.firebaseui-flag-XK{background-position:0 -3528px}.firebaseui-flag-YE{background-position:0 -3542px}.firebaseui-flag-YT{background-position:0 -3556px}.firebaseui-flag-ZA{background-position:0 -3570px}.firebaseui-flag-ZM{background-position:0 -3584px}.firebaseui-flag-ZW{background-position:0 -3598px}',""])},function(i,e){i.exports=function(i){var e=[];return e.toString=function(){return this.map(function(e){var o=function(i,e){var o=i[1]||"",t=i[3];if(!t)return o;if(e&&"function"==typeof btoa){var a=function(i){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"}(t),r=t.sources.map(function(i){return"/*# sourceURL="+t.sourceRoot+i+" */"});return[o].concat(r).concat([a]).join("\n")}return[o].join("\n")}(e,i);return e[2]?"@media "+e[2]+"{"+o+"}":o}).join("")},e.i=function(i,o){"string"==typeof i&&(i=[[null,i,""]]);for(var t={},a=0;a<this.length;a++){var r=this[a][0];"number"==typeof r&&(t[r]=!0)}for(a=0;a<i.length;a++){var n=i[a];"number"==typeof n[0]&&t[n[0]]||(o&&!n[2]?n[2]=o:o&&(n[2]="("+n[2]+") and ("+o+")"),e.push(n))}},e}},function(i,e,o){var t={},a=function(i){var e;return function(){return void 0===e&&(e=i.apply(this,arguments)),e}}(function(){return window&&document&&document.all&&!window.atob}),r=function(i){var e={};return function(i){if("function"==typeof i)return i();if(void 0===e[i]){var o=function(i){return document.querySelector(i)}.call(this,i);if(window.HTMLIFrameElement&&o instanceof window.HTMLIFrameElement)try{o=o.contentDocument.head}catch(i){o=null}e[i]=o}return e[i]}}(),n=null,l=0,s=[],d=o(6);function p(i,e){for(var o=0;o<i.length;o++){var a=i[o],r=t[a.id];if(r){r.refs++;for(var n=0;n<r.parts.length;n++)r.parts[n](a.parts[n]);for(;n<a.parts.length;n++)r.parts.push(x(a.parts[n],e))}else{var l=[];for(n=0;n<a.parts.length;n++)l.push(x(a.parts[n],e));t[a.id]={id:a.id,refs:1,parts:l}}}}function b(i,e){for(var o=[],t={},a=0;a<i.length;a++){var r=i[a],n=e.base?r[0]+e.base:r[0],l={css:r[1],media:r[2],sourceMap:r[3]};t[n]?t[n].parts.push(l):o.push(t[n]={id:n,parts:[l]})}return o}function f(i,e){var o=r(i.insertInto);if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var t=s[s.length-1];if("top"===i.insertAt)t?t.nextSibling?o.insertBefore(e,t.nextSibling):o.appendChild(e):o.insertBefore(e,o.firstChild),s.push(e);else if("bottom"===i.insertAt)o.appendChild(e);else{if("object"!=typeof i.insertAt||!i.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var a=r(i.insertInto+" "+i.insertAt.before);o.insertBefore(e,a)}}function u(i){if(null===i.parentNode)return!1;i.parentNode.removeChild(i);var e=s.indexOf(i);e>=0&&s.splice(e,1)}function g(i){var e=document.createElement("style");return void 0===i.attrs.type&&(i.attrs.type="text/css"),c(e,i.attrs),f(i,e),e}function c(i,e){Object.keys(e).forEach(function(o){i.setAttribute(o,e[o])})}function x(i,e){var o,t,a,r;if(e.transform&&i.css){if(!(r=e.transform(i.css)))return function(){};i.css=r}if(e.singleton){var s=l++;o=n||(n=g(e)),t=h.bind(null,o,s,!1),a=h.bind(null,o,s,!0)}else i.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(o=function(i){var e=document.createElement("link");return void 0===i.attrs.type&&(i.attrs.type="text/css"),i.attrs.rel="stylesheet",c(e,i.attrs),f(i,e),e}(e),t=function(i,e,o){var t=o.css,a=o.sourceMap,r=void 0===e.convertToAbsoluteUrls&&a;(e.convertToAbsoluteUrls||r)&&(t=d(t));a&&(t+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */");var n=new Blob([t],{type:"text/css"}),l=i.href;i.href=URL.createObjectURL(n),l&&URL.revokeObjectURL(l)}.bind(null,o,e),a=function(){u(o),o.href&&URL.revokeObjectURL(o.href)}):(o=g(e),t=function(i,e){var o=e.css,t=e.media;t&&i.setAttribute("media",t);if(i.styleSheet)i.styleSheet.cssText=o;else{for(;i.firstChild;)i.removeChild(i.firstChild);i.appendChild(document.createTextNode(o))}}.bind(null,o),a=function(){u(o)});return t(i),function(e){if(e){if(e.css===i.css&&e.media===i.media&&e.sourceMap===i.sourceMap)return;t(i=e)}else a()}}i.exports=function(i,e){if(false)throw new Error("The style-loader cannot be used in a non-browser environment");(e=e||{}).attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||"boolean"==typeof e.singleton||(e.singleton=a()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var o=b(i,e);return p(o,e),function(i){for(var a=[],r=0;r<o.length;r++){var n=o[r];(l=t[n.id]).refs--,a.push(l)}i&&p(b(i,e),e);for(r=0;r<a.length;r++){var l;if(0===(l=a[r]).refs){for(var s=0;s<l.parts.length;s++)l.parts[s]();delete t[l.id]}}}};var m=function(){var i=[];return function(e,o){return i[e]=o,i.filter(Boolean).join("\n")}}();function h(i,e,o,t){var a=o?"":t.css;if(i.styleSheet)i.styleSheet.cssText=m(e,a);else{var r=document.createTextNode(a),n=i.childNodes;n[e]&&i.removeChild(n[e]),n.length?i.insertBefore(r,n[e]):i.appendChild(r)}}},function(i,e){i.exports=function(i){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!i||"string"!=typeof i)return i;var o=e.protocol+"//"+e.host,t=o+e.pathname.replace(/\/[^\/]*$/,"/");return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(i,e){var a,r=e.trim().replace(/^"(.*)"$/,function(i,e){return e}).replace(/^'(.*)'$/,function(i,e){return e});return/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r)?i:(a=0===r.indexOf("//")?r:0===r.indexOf("/")?o+r:t+r.replace(/^\.\//,""),"url("+JSON.stringify(a)+")")})}},function(i,e){i.exports=__webpack_require__(230)}]);
	//# sourceMappingURL=StyledFirebaseAuth.js.map

/***/ },
/* 250 */
/***/ function(module, exports) {

	/** @license React v16.12.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
	exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(254),React=_interopDefault(__webpack_require__(2)),history=__webpack_require__(75);__webpack_require__(4),__webpack_require__(18);var invariant=_interopDefault(__webpack_require__(50));function _extends(){return(_extends=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var o in t)Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,r){e.prototype=Object.create(r.prototype),(e.prototype.constructor=e).__proto__=r}function _objectWithoutPropertiesLoose(e,r){if(null==e)return{};var t,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)t=a[o],0<=r.indexOf(t)||(n[t]=e[t]);return n}var BrowserRouter=function(n){function e(){for(var e,r=arguments.length,t=new Array(r),o=0;o<r;o++)t[o]=arguments[o];return(e=n.call.apply(n,[this].concat(t))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,r=arguments.length,t=new Array(r),o=0;o<r;o++)t[o]=arguments[o];return(e=n.call.apply(n,[this].concat(t))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,r){return"function"==typeof e?e(r):e},normalizeToLocation=function(e,r){return"string"==typeof e?history.createLocation(e,null,null,r):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,r){var t=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(r){try{n&&n(r)}catch(e){throw r.preventDefault(),e}r.defaultPrevented||0!==r.button||i&&"_self"!==i||isModifiedEvent(r)||(r.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&r||t,React.createElement("a",c)}),Link=forwardRef(function(e,a){var r=e.component,i=void 0===r?LinkAnchor:r,c=e.replace,f=e.to,u=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var t=r.history,e=normalizeToLocation(resolveToLocation(f,r.location),r.location),o=e?t.createHref(e):"",n=_extends({},s,{href:o,navigate:function(){var e=resolveToLocation(f,r.location);(c?t.replace:t.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||u:n.innerRef=u,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,r=new Array(e),t=0;t<e;t++)r[t]=arguments[t];return r.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var r=e["aria-current"],l=void 0===r?"page":r,t=e.activeClassName,p=void 0===t?"active":t,h=e.activeStyle,R=e.className,d=e.exact,v=e.isActive,y=e.location,m=e.strict,w=e.style,_=e.to,L=e.innerRef,x=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var r=y||e.location,t=normalizeToLocation(resolveToLocation(_,r),r),o=t.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(r.pathname,{path:n,exact:d,strict:m}):null,i=!!(v?v(a,r):a),c=i?joinClassnames(R,p):R,f=i?_extends({},w,{},h):w,u=_extends({"aria-current":i&&l||null,className:c,style:f,to:t},x);return forwardRefShim$1!==forwardRef$1?u.ref=s||L:u.innerRef=L,React.createElement(Link,u)})});Object.keys(reactRouter).forEach(function(e){"default"!==e&&Object.defineProperty(exports,e,{enumerable:!0,get:function(){return reactRouter[e]}})}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(251);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(2));__webpack_require__(4);var history=__webpack_require__(75);__webpack_require__(18);var createContext=_interopDefault(__webpack_require__(242)),invariant=_interopDefault(__webpack_require__(50)),pathToRegexp=_interopDefault(__webpack_require__(256));__webpack_require__(36);var hoistStatics=_interopDefault(__webpack_require__(24));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&this.unlisten()},e.render=function(){return React.createElement(context.Provider,{children:this.props.children||null,value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}})},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&0===r.length&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(context).history}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){return t?matchPath(useLocation().pathname,t):useContext(context).match}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(253);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 255 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(255)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(245).enable();
	  window.Promise = __webpack_require__(244);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(278);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(35);


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	    result["default"] = mod;
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @jsx jsx */
	var React = __importStar(__webpack_require__(2));
	var core_1 = __webpack_require__(90);
	var helpers_1 = __webpack_require__(260);
	var pacman = [
	    core_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(-44deg)}\n  "], ["\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(-44deg)}\n  "]))),
	    core_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(44deg)}\n  "], ["\n    0% {transform: rotate(0deg)}\n    50% {transform: rotate(44deg)}\n  "])))
	];
	var Loader = /** @class */ (function (_super) {
	    __extends(Loader, _super);
	    function Loader() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.ball = function () {
	            var size = _this.props.size;
	            var _a = helpers_1.parseLengthAndUnit(size), value = _a.value, unit = _a.unit;
	            return core_1.keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      75% {opacity: 0.7}\n      100% {transform: translate(", ", ", ")}\n    "], ["\n      75% {opacity: 0.7}\n      100% {transform: translate(", ", ", ")}\n    "])), "" + -4 * value + unit, "" + -value / 4 + unit);
	        };
	        _this.ballStyle = function (i) {
	            var _a = _this.props, color = _a.color, margin = _a.margin, size = _a.size;
	            var _b = helpers_1.parseLengthAndUnit(size), value = _b.value, unit = _b.unit;
	            return core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      width: ", ";\n      height: ", ";\n      background-color: ", ";\n      margin: ", ";\n      border-radius: 100%;\n      transform: translate(0, ", ");\n      position: absolute;\n      top: ", ";\n      left: ", ";\n      animation: ", " 1s ", "s infinite linear;\n      animation-fill-mode: both;\n    "], ["\n      width: ", ";\n      height: ", ";\n      background-color: ", ";\n      margin: ", ";\n      border-radius: 100%;\n      transform: translate(0, ", ");\n      position: absolute;\n      top: ", ";\n      left: ", ";\n      animation: ", " 1s ", "s infinite linear;\n      animation-fill-mode: both;\n    "])), "" + value / 3 + unit, "" + value / 3 + unit, color, helpers_1.cssValue(margin), "" + -value / 4 + unit, "" + value + unit, "" + value * 4 + unit, _this.ball(), i * 0.25);
	        };
	        _this.s1 = function () {
	            var size = _this.props.size;
	            return helpers_1.cssValue(size) + " solid transparent";
	        };
	        _this.s2 = function () {
	            var _a = _this.props, size = _a.size, color = _a.color;
	            return helpers_1.cssValue(size) + " solid " + color;
	        };
	        _this.pacmanStyle = function (i) {
	            var size = _this.props.size;
	            var s1 = _this.s1();
	            var s2 = _this.s2();
	            return core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: 0;\n      height: 0;\n      border-right: ", ";\n      border-top: ", ";\n      border-left: ", ";\n      border-bottom: ", ";\n      border-radius: ", ";\n      position: absolute;\n      animation: ", " 0.8s infinite ease-in-out;\n      animation-fill-mode: both;\n    "], ["\n      width: 0;\n      height: 0;\n      border-right: ", ";\n      border-top: ", ";\n      border-left: ", ";\n      border-bottom: ", ";\n      border-radius: ", ";\n      position: absolute;\n      animation: ", " 0.8s infinite ease-in-out;\n      animation-fill-mode: both;\n    "])), s1, i === 0 ? s1 : s2, s2, i === 0 ? s2 : s1, helpers_1.cssValue(size), pacman[i]);
	        };
	        _this.wrapper = function () {
	            var size = _this.props.size;
	            return core_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      position: relative;\n      font-size: 0;\n      height: ", ";\n      width: ", ";\n    "], ["\n      position: relative;\n      font-size: 0;\n      height: ", ";\n      width: ", ";\n    "])), helpers_1.cssValue(size), helpers_1.cssValue(size));
	        };
	        _this.pac = function () { return _this.pacmanStyle(0); };
	        _this.man = function () { return _this.pacmanStyle(1); };
	        return _this;
	    }
	    Loader.prototype.render = function () {
	        var _a = this.props, loading = _a.loading, css = _a.css;
	        return loading ? (core_1.jsx("div", { css: [this.wrapper(), css] },
	            core_1.jsx("div", { css: this.pac() }),
	            core_1.jsx("div", { css: this.man() }),
	            core_1.jsx("div", { css: this.ballStyle(2) }),
	            core_1.jsx("div", { css: this.ballStyle(3) }),
	            core_1.jsx("div", { css: this.ballStyle(4) }),
	            core_1.jsx("div", { css: this.ballStyle(5) }))) : null;
	    };
	    Loader.defaultProps = helpers_1.sizeMarginDefaults(25);
	    return Loader;
	}(React.PureComponent));
	exports.default = Loader;
	var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;


/***/ },
/* 259 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BasicColors;
	(function (BasicColors) {
	    BasicColors["maroon"] = "#800000";
	    BasicColors["red"] = "#FF0000";
	    BasicColors["orange"] = "#FFA500";
	    BasicColors["yellow"] = "#FFFF00";
	    BasicColors["olive"] = "#808000";
	    BasicColors["green"] = "#008000";
	    BasicColors["purple"] = "#800080";
	    BasicColors["fuchsia"] = "#FF00FF";
	    BasicColors["lime"] = "#00FF00";
	    BasicColors["teal"] = "#008080";
	    BasicColors["aqua"] = "#00FFFF";
	    BasicColors["blue"] = "#0000FF";
	    BasicColors["navy"] = "#000080";
	    BasicColors["black"] = "#000000";
	    BasicColors["gray"] = "#808080";
	    BasicColors["silver"] = "#C0C0C0";
	    BasicColors["white"] = "#FFFFFF";
	})(BasicColors || (BasicColors = {}));
	exports.calculateRgba = function (color, opacity) {
	    if (Object.keys(BasicColors).includes(color)) {
	        color = BasicColors[color];
	    }
	    if (color[0] === "#") {
	        color = color.slice(1);
	    }
	    if (color.length === 3) {
	        var res_1 = "";
	        color.split("").forEach(function (c) {
	            res_1 += c;
	            res_1 += c;
	        });
	        color = res_1;
	    }
	    var rgbValues = color
	        .match(/.{2}/g)
	        .map(function (hex) { return parseInt(hex, 16); })
	        .join(", ");
	    return "rgba(" + rgbValues + ", " + opacity + ")";
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(261));
	__export(__webpack_require__(259));
	__export(__webpack_require__(262));


/***/ },
/* 261 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var commonValues = {
	    loading: true,
	    color: "#000000",
	    css: ""
	};
	function sizeDefaults(sizeValue) {
	    return Object.assign({}, commonValues, { size: sizeValue });
	}
	exports.sizeDefaults = sizeDefaults;
	function sizeMarginDefaults(sizeValue) {
	    return Object.assign({}, sizeDefaults(sizeValue), {
	        margin: 2
	    });
	}
	exports.sizeMarginDefaults = sizeMarginDefaults;
	function heightWidthDefaults(height, width) {
	    return Object.assign({}, commonValues, {
	        height: height,
	        width: width
	    });
	}
	exports.heightWidthDefaults = heightWidthDefaults;
	function heightWidthRadiusDefaults(height, width, radius) {
	    if (radius === void 0) { radius = 2; }
	    return Object.assign({}, heightWidthDefaults(height, width), {
	        radius: radius,
	        margin: 2
	    });
	}
	exports.heightWidthRadiusDefaults = heightWidthRadiusDefaults;


/***/ },
/* 262 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var cssUnit = {
	    cm: true,
	    mm: true,
	    in: true,
	    px: true,
	    pt: true,
	    pc: true,
	    em: true,
	    ex: true,
	    ch: true,
	    rem: true,
	    vw: true,
	    vh: true,
	    vmin: true,
	    vmax: true,
	    "%": true
	};
	/**
	 * If size is a number, append px to the value as default unit.
	 * If size is a string, validate against list of valid units.
	 * If unit is valid, return size as is.
	 * If unit is invalid, console warn issue, replace with px as the unit.
	 *
	 * @param {(number | string)} size
	 * @return {LengthObject} LengthObject
	 */
	function parseLengthAndUnit(size) {
	    if (typeof size === "number") {
	        return {
	            value: size,
	            unit: "px"
	        };
	    }
	    var value;
	    var valueString = size.match(/^[0-9.]*/).toString();
	    if (valueString.includes(".")) {
	        value = parseFloat(valueString);
	    }
	    else {
	        value = parseInt(valueString, 10);
	    }
	    var unit = size.match(/[^0-9]*$/).toString();
	    if (cssUnit[unit]) {
	        return {
	            value: value,
	            unit: unit
	        };
	    }
	    console.warn("React Spinners: " + size + " is not a valid css value. Defaulting to " + value + "px.");
	    return {
	        value: value,
	        unit: "px"
	    };
	}
	exports.parseLengthAndUnit = parseLengthAndUnit;
	/**
	 * Take value as an input and return valid css value
	 *
	 * @param {(number | string)} value
	 * @return {string} valid css value
	 */
	function cssValue(value) {
	    var lengthWithunit = parseLengthAndUnit(value);
	    return "" + lengthWithunit.value + lengthWithunit.unit;
	}
	exports.cssValue = cssValue;


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(223));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(225));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Transition = _interopRequireDefault(__webpack_require__(47));
	
	var _PropTypes = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (node, appearing) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    if (type === 'appear' && phase === 'done') {
	      className += " " + this.getClassNames('enter').doneClassName;
	    } // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	    }
	
	    this.appliedClasses[type][phase] = className;
	
	    _addClass(node, className);
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided and it
	   * will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-appear`, `fade-appear-active`,
	   * `fade-appear-done`, `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, and `fade-exit-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(13));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(79));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler](_reactDom.default.findDOMNode(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.modes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Transition = __webpack_require__(47);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(48));
	
	var _leaveRenders, _enterRenders;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function areChildrenDifferent(oldChildren, newChildren) {
	  if (oldChildren === newChildren) return false;
	
	  if (_react.default.isValidElement(oldChildren) && _react.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Enum of modes for SwitchTransition component
	 * @enum { string }
	 */
	
	
	var modes = {
	  out: 'out-in',
	  in: 'in-out'
	};
	exports.modes = modes;
	
	var callHook = function callHook(element, name, cb) {
	  return function () {
	    var _element$props;
	
	    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
	    cb();
	  };
	};
	
	var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
	  var current = _ref.current,
	      changeState = _ref.changeState;
	  return _react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERING, null);
	    })
	  });
	}, _leaveRenders[modes.in] = function (_ref2) {
	  var current = _ref2.current,
	      changeState = _ref2.changeState,
	      children = _ref2.children;
	  return [current, _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERING);
	    })
	  })];
	}, _leaveRenders);
	var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
	  var children = _ref3.children,
	      changeState = _ref3.changeState;
	  return _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  });
	}, _enterRenders[modes.in] = function (_ref4) {
	  var current = _ref4.current,
	      children = _ref4.children,
	      changeState = _ref4.changeState;
	  return [_react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  }), _react.default.cloneElement(children, {
	    in: true
	  })];
	}, _enterRenders);
	/**
	 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
	 * You can use it when you want to control the render between state transitions.
	 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
	 *
	 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
	 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child
	 *
	 * ```jsx
	 *
	 * function App() {
	 *  const [state, setState] = useState(false);
	 *  return (
	 *    <SwitchTransition>
	 *      <FadeTransition key={state ? "Goodbye, world!" : "Hello, world!"}
	 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
	 *        classNames='fade' >
	 *        <button onClick={() => setState(state => !state)}>
	 *          {state ? "Goodbye, world!" : "Hello, world!"}
	 *        </button>
	 *      </FadeTransition>
	 *    </SwitchTransition>
	 *  )
	 * }
	 * ```
	 */
	
	var SwitchTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(SwitchTransition, _React$Component);
	
	  function SwitchTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      status: _Transition.ENTERED,
	      current: null
	    };
	    _this.appeared = false;
	
	    _this.changeState = function (status, current) {
	      if (current === void 0) {
	        current = _this.state.current;
	      }
	
	      _this.setState({
	        status: status,
	        current: current
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = SwitchTransition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.children == null) {
	      return {
	        current: null
	      };
	    }
	
	    if (state.status === _Transition.ENTERING && props.mode === modes.in) {
	      return {
	        status: _Transition.ENTERING
	      };
	    }
	
	    if (state.current && areChildrenDifferent(state.current, props.children)) {
	      return {
	        status: _Transition.EXITING
	      };
	    }
	
	    return {
	      current: _react.default.cloneElement(props.children, {
	        in: true
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        mode = _this$props.mode,
	        _this$state = this.state,
	        status = _this$state.status,
	        current = _this$state.current;
	    var data = {
	      children: children,
	      current: current,
	      changeState: this.changeState,
	      status: status
	    };
	    var component;
	
	    switch (status) {
	      case _Transition.ENTERING:
	        component = enterRenders[mode](data);
	        break;
	
	      case _Transition.EXITING:
	        component = leaveRenders[mode](data);
	        break;
	
	      case _Transition.ENTERED:
	        component = current;
	    }
	
	    return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: {
	        isMounting: !this.appeared
	      }
	    }, component);
	  };
	
	  return SwitchTransition;
	}(_react.default.Component);
	
	SwitchTransition.propTypes =  false ? {
	  /**
	   * Transition modes.
	   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
	   * `in-out: New element transitions in first, then when complete, the current element transitions out.`
	   *
	   * @type {'out-in'|'in-out'}
	   */
	  mode: _propTypes.default.oneOf([modes.in, modes.out]),
	
	  /**
	   * Any `Transition` or `CSSTransition` component
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element.isRequired])
	} : {};
	SwitchTransition.defaultProps = {
	  mode: modes.out
	};
	var _default = SwitchTransition;
	exports.default = _default;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.12.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var h=__webpack_require__(35),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
	var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
	function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
	H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
	function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
	0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
	function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
	var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
	if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Shake = _interopRequireDefault(__webpack_require__(82));
	
	var _shakes = _interopRequireDefault(__webpack_require__(83));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var Shaking = function Shaking(_ref) {
	  var _ref$type = _ref.type,
	      type = _ref$type === void 0 ? null : _ref$type,
	      props = _objectWithoutProperties(_ref, ["type"]);
	
	  var attrs = type && _shakes["default"][type];
	  return _react["default"].createElement(_Shake["default"], _extends({}, attrs, props), props.children);
	};
	
	var _default = Shaking;
	exports["default"] = _default;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Shake", {
	  enumerable: true,
	  get: function get() {
	    return _Shake["default"];
	  }
	});
	Object.defineProperty(exports, "Shaking", {
	  enumerable: true,
	  get: function get() {
	    return _Shaking["default"];
	  }
	});
	Object.defineProperty(exports, "shakes", {
	  enumerable: true,
	  get: function get() {
	    return _shakes["default"];
	  }
	});
	exports["default"] = exports.ShakeCrazy = exports.ShakeRotate = exports.ShakeVertical = exports.ShakeHorizontal = exports.ShakeHard = exports.ShakeSlow = exports.ShakeLittle = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Shake = _interopRequireDefault(__webpack_require__(82));
	
	var _Shaking = _interopRequireDefault(__webpack_require__(268));
	
	var _shakes = _interopRequireDefault(__webpack_require__(83));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ShakeLittle = function ShakeLittle(props) {
	  return _react["default"].createElement(_Shaking["default"], _extends({}, props, {
	    type: "little"
	  }));
	};
	
	exports.ShakeLittle = ShakeLittle;
	
	var ShakeSlow = function ShakeSlow(props) {
	  return _react["default"].createElement(_Shaking["default"], _extends({}, props, {
	    type: "slow"
	  }));
	};
	
	exports.ShakeSlow = ShakeSlow;
	
	var ShakeHard = function ShakeHard(props) {
	  return _react["default"].createElement(_Shaking["default"], _extends({}, props, {
	    type: "hard"
	  }));
	};
	
	exports.ShakeHard = ShakeHard;
	
	var ShakeHorizontal = function ShakeHorizontal(props) {
	  return _react["default"].createElement(_Shaking["default"], _extends({}, props, {
	    type: "horizontal"
	  }));
	};
	
	exports.ShakeHorizontal = ShakeHorizontal;
	
	var ShakeVertical = function ShakeVertical(props) {
	  return _react["default"].createElement(_Shaking["default"], _extends({}, props, {
	    type: "vertical"
	  }));
	};
	
	exports.ShakeVertical = ShakeVertical;
	
	var ShakeRotate = function ShakeRotate(props) {
	  return _react["default"].createElement(_Shaking["default"], _extends({}, props, {
	    type: "rotate"
	  }));
	};
	
	exports.ShakeRotate = ShakeRotate;
	
	var ShakeCrazy = function ShakeCrazy(props) {
	  return _react["default"].createElement(_Shaking["default"], _extends({}, props, {
	    type: "crazy"
	  }));
	};
	
	exports.ShakeCrazy = ShakeCrazy;
	var _default = {
	  Shake: _Shake["default"],
	  Shaking: _Shaking["default"],
	  shakes: _shakes["default"],
	  ShakeLittle: ShakeLittle,
	  ShakeSlow: ShakeSlow,
	  ShakeHard: ShakeHard,
	  ShakeHorizontal: ShakeHorizontal,
	  ShakeVertical: ShakeVertical,
	  ShakeRotate: ShakeRotate,
	  ShakeCrazy: ShakeCrazy
	};
	exports["default"] = _default;

/***/ },
/* 270 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(270);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 272 */
/***/ function(module, exports) {

	/** @license React v0.18.0
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
	exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(272);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 274 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var reactIs = __webpack_require__(36);
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var shallowequal = _interopDefault(__webpack_require__(274));
	var Stylis = _interopDefault(__webpack_require__(57));
	var unitless = _interopDefault(__webpack_require__(58));
	var validAttr = _interopDefault(__webpack_require__(92));
	var hoist = _interopDefault(__webpack_require__(24));
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	// 
	var interleave = (function (strings, interpolations) {
	  var result = [strings[0]];
	
	  for (var i = 0, len = interpolations.length; i < len; i += 1) {
	    result.push(interpolations[i], strings[i + 1]);
	  }
	
	  return result;
	});
	
	// 
	var isPlainObject = (function (x) {
	  return typeof x === 'object' && x.constructor === Object;
	});
	
	// 
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	
	// 
	function isFunction(test) {
	  return typeof test === 'function';
	}
	
	// 
	function getComponentName(target) {
	  return ( false ? typeof target === 'string' && target : false) || // $FlowFixMe
	  target.displayName || // $FlowFixMe
	  target.name || 'Component';
	}
	
	// 
	function isStatelessFunction(test) {
	  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
	}
	
	// 
	function isStyledComponent(target) {
	  return target && typeof target.styledComponentId === 'string';
	}
	
	// 
	var SC_ATTR = typeof process !== 'undefined' && (({"NODE_ENV":"production","PUBLIC_URL":""}).REACT_APP_SC_ATTR || ({"NODE_ENV":"production","PUBLIC_URL":""}).SC_ATTR) || 'data-styled';
	var SC_ATTR_ACTIVE = 'active';
	var SC_ATTR_VERSION = 'data-styled-version';
	var SC_VERSION = "5.0.1";
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (({"NODE_ENV":"production","PUBLIC_URL":""}).REACT_APP_SC_DISABLE_SPEEDY || ({"NODE_ENV":"production","PUBLIC_URL":""}).SC_DISABLE_SPEEDY) || ("production") !== 'production'; // Shared empty execution context when generating static styles
	
	var STATIC_EXECUTION_CONTEXT = {};
	
	// 
	
	/* eslint-disable camelcase, no-undef */
	var getNonce = function getNonce() {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	};
	
	var errorMap = {
	  "1": "Cannot create styled-component for component: %s.\n\n",
	  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
	  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
	  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
	  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
	  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
	  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
	  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
	  "9": "Missing document `<head>`\n\n",
	  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
	  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
	  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
	  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
	  "14": "ThemeProvider: \"theme\" prop is required.\n\n",
	  "15": "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
	  "16": "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
	  "17": "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
	};
	
	// 
	var ERRORS =  false ? errorMap : {};
	/**
	 * super basic version of sprintf
	 */
	
	function format() {
	  var a = arguments.length <= 0 ? undefined : arguments[0];
	  var b = [];
	
	  for (var c = 1, len = arguments.length; c < len; c += 1) {
	    b.push(c < 0 || arguments.length <= c ? undefined : arguments[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	  return a;
	}
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 */
	
	
	function throwStyledComponentsError(code) {
	  for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (true) {
	    throw new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + code + " for more information." + (interpolations.length > 0 ? " Additional arguments: " + interpolations.join(', ') : ''));
	  } else {
	    throw new Error(format.apply(void 0, [ERRORS[code]].concat(interpolations)).trim());
	  }
	}
	
	// 
	var ELEMENT_TYPE = 1;
	/* Node.ELEMENT_TYPE */
	
	/** Find last style element if any inside target */
	
	var findLastStyleTag = function findLastStyleTag(target) {
	  var childNodes = target.childNodes;
	
	  for (var i = childNodes.length; i >= 0; i--) {
	    var child = childNodes[i];
	
	    if (child && child.nodeType === ELEMENT_TYPE && child.hasAttribute(SC_ATTR)) {
	      return child;
	    }
	  }
	
	  return undefined;
	};
	/** Create a style element inside `target` or <head> after the last */
	
	
	var makeStyleTag = function makeStyleTag(target) {
	  var head = document.head;
	  var parent = target || head;
	  var style = document.createElement('style');
	  var prevStyle = findLastStyleTag(parent);
	  var nextSibling = prevStyle !== undefined ? prevStyle.nextSibling : null;
	  style.setAttribute(SC_ATTR, SC_ATTR_ACTIVE);
	  style.setAttribute(SC_ATTR_VERSION, SC_VERSION);
	  var nonce = getNonce();
	  if (nonce) style.setAttribute('nonce', nonce);
	  parent.insertBefore(style, nextSibling);
	  return style;
	};
	/** Get the CSSStyleSheet instance for a given style element */
	
	var getSheet = function getSheet(tag) {
	  if (tag.sheet) {
	    return tag.sheet;
	  } // Avoid Firefox quirk where the style element might not have a sheet property
	
	
	  var _document = document,
	      styleSheets = _document.styleSheets;
	
	  for (var i = 0, l = styleSheets.length; i < l; i++) {
	    var sheet = styleSheets[i];
	
	    if (sheet.ownerNode === tag) {
	      return sheet;
	    }
	  }
	
	  throwStyledComponentsError(17);
	  return undefined;
	};
	
	// 
	/** Create a CSSStyleSheet-like tag depending on the environment */
	
	var makeTag = function makeTag(_ref) {
	  var isServer = _ref.isServer,
	      useCSSOMInjection = _ref.useCSSOMInjection,
	      target = _ref.target;
	
	  if (isServer) {
	    return new VirtualTag(target);
	  } else if (useCSSOMInjection) {
	    return new CSSOMTag(target);
	  } else {
	    return new TextTag(target);
	  }
	};
	var CSSOMTag =
	/*#__PURE__*/
	function () {
	  function CSSOMTag(target) {
	    var element = this.element = makeStyleTag(target); // Avoid Edge bug where empty style elements don't create sheets
	
	    element.appendChild(document.createTextNode(''));
	    this.sheet = getSheet(element);
	    this.length = 0;
	  }
	
	  var _proto = CSSOMTag.prototype;
	
	  _proto.insertRule = function insertRule(index, rule) {
	    try {
	      this.sheet.insertRule(rule, index);
	      this.length++;
	      return true;
	    } catch (_error) {
	      return false;
	    }
	  };
	
	  _proto.deleteRule = function deleteRule(index) {
	    this.sheet.deleteRule(index);
	    this.length--;
	  };
	
	  _proto.getRule = function getRule(index) {
	    var rule = this.sheet.cssRules[index]; // Avoid IE11 quirk where cssText is inaccessible on some invalid rules
	
	    if (rule !== undefined && typeof rule.cssText === 'string') {
	      return rule.cssText;
	    } else {
	      return '';
	    }
	  };
	
	  return CSSOMTag;
	}();
	/** A Tag that emulates the CSSStyleSheet API but uses text nodes */
	
	var TextTag =
	/*#__PURE__*/
	function () {
	  function TextTag(target) {
	    var element = this.element = makeStyleTag(target);
	    this.nodes = element.childNodes;
	    this.length = 0;
	  }
	
	  var _proto2 = TextTag.prototype;
	
	  _proto2.insertRule = function insertRule(index, rule) {
	    if (index <= this.length && index >= 0) {
	      var node = document.createTextNode(rule);
	      var refNode = this.nodes[index];
	      this.element.insertBefore(node, refNode || null);
	      this.length++;
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  _proto2.deleteRule = function deleteRule(index) {
	    this.element.removeChild(this.nodes[index]);
	    this.length--;
	  };
	
	  _proto2.getRule = function getRule(index) {
	    if (index < this.length) {
	      return this.nodes[index].textContent;
	    } else {
	      return '';
	    }
	  };
	
	  return TextTag;
	}();
	/** A completely virtual (server-side) Tag that doesn't manipulate the DOM */
	
	var VirtualTag =
	/*#__PURE__*/
	function () {
	  function VirtualTag(_target) {
	    this.rules = [];
	    this.length = 0;
	  }
	
	  var _proto3 = VirtualTag.prototype;
	
	  _proto3.insertRule = function insertRule(index, rule) {
	    if (index <= this.length) {
	      this.rules.splice(index, 0, rule);
	      this.length++;
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  _proto3.deleteRule = function deleteRule(index) {
	    this.rules.splice(index, 1);
	    this.length--;
	  };
	
	  _proto3.getRule = function getRule(index) {
	    if (index < this.length) {
	      return this.rules[index];
	    } else {
	      return '';
	    }
	  };
	
	  return VirtualTag;
	}();
	
	// 
	/** Create a GroupedTag with an underlying Tag implementation */
	
	var makeGroupedTag = function makeGroupedTag(tag) {
	  return new DefaultGroupedTag(tag);
	};
	var BASE_SIZE = 1 << 9;
	
	var DefaultGroupedTag =
	/*#__PURE__*/
	function () {
	  function DefaultGroupedTag(tag) {
	    this.groupSizes = new Uint32Array(BASE_SIZE);
	    this.length = BASE_SIZE;
	    this.tag = tag;
	  }
	
	  var _proto = DefaultGroupedTag.prototype;
	
	  _proto.indexOfGroup = function indexOfGroup(group) {
	    var index = 0;
	
	    for (var i = 0; i < group; i++) {
	      index += this.groupSizes[i];
	    }
	
	    return index;
	  };
	
	  _proto.insertRules = function insertRules(group, rules) {
	    if (group >= this.groupSizes.length) {
	      var oldBuffer = this.groupSizes;
	      var oldSize = oldBuffer.length;
	      var newSize = oldSize;
	
	      while (group >= newSize) {
	        newSize <<= 1;
	
	        if (newSize < 0) {
	          throwStyledComponentsError(16, "" + group);
	        }
	      }
	
	      this.groupSizes = new Uint32Array(newSize);
	      this.groupSizes.set(oldBuffer);
	      this.length = newSize;
	
	      for (var i = oldSize; i < newSize; i++) {
	        this.groupSizes[i] = 0;
	      }
	    }
	
	    var ruleIndex = this.indexOfGroup(group + 1);
	
	    for (var _i = 0, l = rules.length; _i < l; _i++) {
	      if (this.tag.insertRule(ruleIndex, rules[_i])) {
	        this.groupSizes[group]++;
	        ruleIndex++;
	      }
	    }
	  };
	
	  _proto.clearGroup = function clearGroup(group) {
	    if (group < this.length) {
	      var length = this.groupSizes[group];
	      var startIndex = this.indexOfGroup(group);
	      var endIndex = startIndex + length;
	      this.groupSizes[group] = 0;
	
	      for (var i = startIndex; i < endIndex; i++) {
	        this.tag.deleteRule(startIndex);
	      }
	    }
	  };
	
	  _proto.getGroup = function getGroup(group) {
	    var css = '';
	
	    if (group >= this.length || this.groupSizes[group] === 0) {
	      return css;
	    }
	
	    var length = this.groupSizes[group];
	    var startIndex = this.indexOfGroup(group);
	    var endIndex = startIndex + length;
	
	    for (var i = startIndex; i < endIndex; i++) {
	      css += this.tag.getRule(i) + "\n";
	    }
	
	    return css;
	  };
	
	  return DefaultGroupedTag;
	}();
	
	// 
	var MAX_SMI = 1 << 31 - 1;
	var groupIDRegister = new Map();
	var reverseRegister = new Map();
	var nextFreeGroup = 1;
	var getGroupForId = function getGroupForId(id) {
	  if (groupIDRegister.has(id)) {
	    return groupIDRegister.get(id);
	  }
	
	  var group = nextFreeGroup++;
	
	  if (false) {
	    throwStyledComponentsError(16, "" + group);
	  }
	
	  groupIDRegister.set(id, group);
	  reverseRegister.set(group, id);
	  return group;
	};
	var getIdForGroup = function getIdForGroup(group) {
	  return reverseRegister.get(group);
	};
	var setGroupForId = function setGroupForId(id, group) {
	  if (group >= nextFreeGroup) {
	    nextFreeGroup = group + 1;
	  }
	
	  groupIDRegister.set(id, group);
	  reverseRegister.set(group, id);
	};
	
	// 
	var SELECTOR = "style[" + SC_ATTR + "][" + SC_ATTR_VERSION + "=\"" + SC_VERSION + "\"]";
	var RULE_RE = /(?:\s*)?(.*?){((?:{[^}]*}|(?!{).*?)*)}/g;
	var MARKER_RE = new RegExp("^" + SC_ATTR + "\\.g(\\d+)\\[id=\"([\\w\\d-]+)\"\\]");
	var outputSheet = function outputSheet(sheet) {
	  var tag = sheet.getTag();
	  var length = tag.length;
	  var css = '';
	
	  for (var group = 0; group < length; group++) {
	    var id = getIdForGroup(group);
	    if (id === undefined) continue;
	    var names = sheet.names.get(id);
	    var rules = tag.getGroup(group);
	    if (names === undefined || rules.length === 0) continue;
	    var selector = SC_ATTR + ".g" + group + "[id=\"" + id + "\"]";
	    var content = '';
	
	    if (names !== undefined) {
	      names.forEach(function (name) {
	        if (name.length > 0) {
	          content += name + ",";
	        }
	      });
	    } // NOTE: It's easier to collect rules and have the marker
	    // after the actual rules to simplify the rehydration
	
	
	    css += "" + rules + selector + "{content:\"" + content + "\"}\n";
	  }
	
	  return css;
	};
	
	var rehydrateNamesFromContent = function rehydrateNamesFromContent(sheet, id, content) {
	  var names = content.split(',');
	  var name;
	
	  for (var i = 0, l = names.length; i < l; i++) {
	    // eslint-disable-next-line
	    if (name = names[i]) {
	      sheet.registerName(id, name);
	    }
	  }
	};
	
	var rehydrateSheetFromTag = function rehydrateSheetFromTag(sheet, style) {
	  var rawHTML = style.innerHTML;
	  var rules = [];
	  var parts; // parts = [match, selector, content]
	  // eslint-disable-next-line no-cond-assign
	
	  while (parts = RULE_RE.exec(rawHTML)) {
	    var marker = parts[1].match(MARKER_RE);
	
	    if (marker) {
	      var group = parseInt(marker[1], 10) | 0;
	      var id = marker[2];
	
	      if (group !== 0) {
	        // Rehydrate componentId to group index mapping
	        setGroupForId(id, group); // Rehydrate names and rules
	        // looks like: data-styled.g11[id="idA"]{content:"nameA,"}
	
	        rehydrateNamesFromContent(sheet, id, parts[2].split('"')[1]);
	        sheet.getTag().insertRules(group, rules);
	      }
	
	      rules.length = 0;
	    } else {
	      rules.push(parts[0].trim());
	    }
	  }
	};
	
	var rehydrateSheet = function rehydrateSheet(sheet) {
	  var nodes = document.querySelectorAll(SELECTOR);
	
	  for (var i = 0, l = nodes.length; i < l; i++) {
	    var node = nodes[i];
	
	    if (node && node.getAttribute(SC_ATTR) !== SC_ATTR_ACTIVE) {
	      rehydrateSheetFromTag(sheet, node);
	
	      if (node.parentNode) {
	        node.parentNode.removeChild(node);
	      }
	    }
	  }
	};
	
	var SHOULD_REHYDRATE = IS_BROWSER;
	var defaultOptions = {
	  isServer: !IS_BROWSER,
	  useCSSOMInjection: !DISABLE_SPEEDY
	};
	/** Contains the main stylesheet logic for stringification and caching */
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  /** Register a group ID to give it an index */
	  StyleSheet.registerId = function registerId(id) {
	    return getGroupForId(id);
	  };
	
	  function StyleSheet(options, globalStyles, names) {
	    if (options === void 0) {
	      options = defaultOptions;
	    }
	
	    if (globalStyles === void 0) {
	      globalStyles = {};
	    }
	
	    this.options = _extends({}, defaultOptions, {}, options);
	    this.gs = globalStyles;
	    this.names = new Map(names); // We rehydrate only once and use the sheet that is created first
	
	    if (!this.options.isServer && IS_BROWSER && SHOULD_REHYDRATE) {
	      SHOULD_REHYDRATE = false;
	      rehydrateSheet(this);
	    }
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.reconstructWithOptions = function reconstructWithOptions(options) {
	    return new StyleSheet(_extends({}, this.options, {}, options), this.gs, this.names);
	  };
	
	  _proto.allocateGSInstance = function allocateGSInstance(id) {
	    return this.gs[id] = (this.gs[id] || 0) + 1;
	  }
	  /** Lazily initialises a GroupedTag for when it's actually needed */
	  ;
	
	  _proto.getTag = function getTag() {
	    return this.tag || (this.tag = makeGroupedTag(makeTag(this.options)));
	  }
	  /** Check whether a name is known for caching */
	  ;
	
	  _proto.hasNameForId = function hasNameForId(id, name) {
	    return this.names.has(id) && this.names.get(id).has(name);
	  }
	  /** Mark a group's name as known for caching */
	  ;
	
	  _proto.registerName = function registerName(id, name) {
	    getGroupForId(id);
	
	    if (!this.names.has(id)) {
	      var groupNames = new Set();
	      groupNames.add(name);
	      this.names.set(id, groupNames);
	    } else {
	      this.names.get(id).add(name);
	    }
	  }
	  /** Insert new rules which also marks the name as known */
	  ;
	
	  _proto.insertRules = function insertRules(id, name, rules) {
	    this.registerName(id, name);
	    this.getTag().insertRules(getGroupForId(id), rules);
	  }
	  /** Clears all cached names for a given group ID */
	  ;
	
	  _proto.clearNames = function clearNames(id) {
	    if (this.names.has(id)) {
	      this.names.get(id).clear();
	    }
	  }
	  /** Clears all rules for a given group ID */
	  ;
	
	  _proto.clearRules = function clearRules(id) {
	    this.getTag().clearGroup(getGroupForId(id));
	    this.clearNames(id);
	  }
	  /** Clears the entire tag which deletes all rules but not its names */
	  ;
	
	  _proto.clearTag = function clearTag() {
	    // NOTE: This does not clear the names, since it's only used during SSR
	    // so that we can continuously output only new rules
	    this.tag = undefined;
	  }
	  /** Outputs the current sheet as a CSS string with markers for SSR */
	  ;
	
	  _proto.toString = function toString() {
	    return outputSheet(this);
	  };
	
	  return StyleSheet;
	}();
	
	// 
	
	/* eslint-disable */
	var SEED = 5381; // When we have separate strings it's useful to run a progressive
	// version of djb2 where we pretend that we're still looping over
	// the same string
	
	var phash = function phash(h, x) {
	  var i = x.length;
	
	  while (i) {
	    h = h * 33 ^ x.charCodeAt(--i);
	  }
	
	  return h;
	}; // This is a djb2 hashing function
	
	var hash = function hash(x) {
	  return phash(SEED, x);
	};
	
	/**
	 * MIT License
	 *
	 * Copyright (c) 2016 Sultan Tarimo
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of
	 * this software and associated documentation files (the "Software"),
	 * to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	 * sell copies of the Software and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	 * OR IMPLIED INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
	 * IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	/* eslint-disable */
	function insertRulePlugin (insertRule) {
	  var delimiter = '/*|*/';
	  var needle = delimiter + "}";
	
	  function toSheet(block) {
	    if (block) {
	      try {
	        insertRule(block + "}");
	      } catch (e) {}
	    }
	  }
	
	  return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	    switch (context) {
	      // property
	      case 1:
	        // @import
	        if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ";"), '';
	        break;
	      // selector
	
	      case 2:
	        if (ns === 0) return content + delimiter;
	        break;
	      // at-rule
	
	      case 3:
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            return insertRule(selectors[0] + content), '';
	
	          default:
	            return content + (at === 0 ? delimiter : '');
	        }
	
	      case -2:
	        content.split(needle).forEach(toSheet);
	    }
	  };
	}
	
	var COMMENT_REGEX = /^\s*\/\/.*$/gm;
	function createStylisInstance(_temp) {
	  var _ref = _temp === void 0 ? EMPTY_OBJECT : _temp,
	      _ref$options = _ref.options,
	      options = _ref$options === void 0 ? EMPTY_OBJECT : _ref$options,
	      _ref$plugins = _ref.plugins,
	      plugins = _ref$plugins === void 0 ? EMPTY_ARRAY : _ref$plugins;
	
	  var stylis = new Stylis(options); // Wrap `insertRulePlugin to build a list of rules,
	  // and then make our own plugin to return the rules. This
	  // makes it easier to hook into the existing SSR architecture
	
	  var parsingRules = []; // eslint-disable-next-line consistent-return
	
	  var returnRulesPlugin = function returnRulesPlugin(context) {
	    if (context === -2) {
	      var parsedRules = parsingRules;
	      parsingRules = [];
	      return parsedRules;
	    }
	  };
	
	  var parseRulesPlugin = insertRulePlugin(function (rule) {
	    parsingRules.push(rule);
	  });
	
	  var _componentId;
	
	  var _selector;
	
	  var _selectorRegexp;
	
	  var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
	    if ( // the first self-ref is always untouched
	    offset > 0 && // there should be at least two self-refs to do a replacement (.b > .b)
	    string.slice(0, offset).indexOf(_selector) !== -1 && // no consecutive self refs (.b.b); that is a precedence boost and treated differently
	    string.slice(offset - _selector.length, offset) !== _selector) {
	      return "." + _componentId;
	    }
	
	    return match;
	  };
	  /**
	   * When writing a style like
	   *
	   * & + & {
	   *   color: red;
	   * }
	   *
	   * The second ampersand should be a reference to the static component class. stylis
	   * has no knowledge of static class so we have to intelligently replace the base selector.
	   *
	   * https://github.com/thysultan/stylis.js#plugins <- more info about the context phase values
	   * "2" means this plugin is taking effect at the very end after all other processing is complete
	   */
	
	
	  var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
	    if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
	      // eslint-disable-next-line no-param-reassign
	      selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
	    }
	  };
	
	  stylis.use([].concat(plugins, [selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]));
	
	  function stringifyRules(css, selector, prefix, componentId) {
	    if (componentId === void 0) {
	      componentId = '&';
	    }
	
	    var flatCSS = css.replace(COMMENT_REGEX, '');
	    var cssStr = selector && prefix ? prefix + " " + selector + " { " + flatCSS + " }" : flatCSS; // stylis has no concept of state to be passed to plugins
	    // but since JS is single=threaded, we can rely on that to ensure
	    // these properties stay in sync with the current stylis run
	
	    _componentId = componentId;
	    _selector = selector;
	    _selectorRegexp = new RegExp("\\" + _selector + "\\b", 'g');
	    return stylis(prefix || !selector ? '' : selector, cssStr);
	  }
	
	  stringifyRules.hash = plugins.length ? plugins.reduce(function (acc, plugin) {
	    if (!plugin.name) {
	      throwStyledComponentsError(15);
	    }
	
	    return phash(acc, plugin.name);
	  }, SEED).toString() : '';
	  return stringifyRules;
	}
	
	// 
	var StyleSheetContext = React__default.createContext();
	var StyleSheetConsumer = StyleSheetContext.Consumer;
	var StylisContext = React__default.createContext();
	var StylisConsumer = StylisContext.Consumer;
	var masterSheet = new StyleSheet();
	var masterStylis = createStylisInstance();
	function useStyleSheet() {
	  return React.useContext(StyleSheetContext) || masterSheet;
	}
	function useStylis() {
	  return React.useContext(StylisContext) || masterStylis;
	}
	function StyleSheetManager(props) {
	  var _useState = React.useState(props.stylisPlugins),
	      plugins = _useState[0],
	      setPlugins = _useState[1];
	
	  var contextStyleSheet = useStyleSheet();
	  var styleSheet = React.useMemo(function () {
	    var sheet = contextStyleSheet;
	
	    if (props.sheet) {
	      // eslint-disable-next-line prefer-destructuring
	      sheet = props.sheet;
	    } else if (props.target) {
	      sheet = sheet.reconstructWithOptions({
	        target: props.target
	      });
	    }
	
	    if (props.disableCSSOMInjection) {
	      sheet = sheet.reconstructWithOptions({
	        useCSSOMInjection: false
	      });
	    }
	
	    return sheet;
	  }, [props.disableCSSOMInjection, props.sheet, props.target]);
	  var stylis = React.useMemo(function () {
	    return createStylisInstance({
	      options: {
	        prefix: !props.disableVendorPrefixes
	      },
	      plugins: plugins
	    });
	  }, [props.disableVendorPrefixes, plugins]);
	  React.useEffect(function () {
	    if (!shallowequal(plugins, props.stylisPlugins)) setPlugins(props.stylisPlugins);
	  }, [props.stylisPlugins]);
	  return React__default.createElement(StyleSheetContext.Provider, {
	    value: styleSheet
	  }, React__default.createElement(StylisContext.Provider, {
	    value: stylis
	  },  false ? React__default.Children.only(props.children) : props.children));
	}
	
	// 
	
	var Keyframes =
	/*#__PURE__*/
	function () {
	  function Keyframes(name, stringifyArgs) {
	    var _this = this;
	
	    this.inject = function (styleSheet) {
	      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
	        styleSheet.insertRules(_this.id, _this.name, masterStylis.apply(void 0, _this.stringifyArgs));
	      }
	    };
	
	    this.toString = function () {
	      return throwStyledComponentsError(12, String(_this.name));
	    };
	
	    this.name = name;
	    this.id = "sc-keyframes-" + name;
	    this.stringifyArgs = stringifyArgs;
	  }
	
	  var _proto = Keyframes.prototype;
	
	  _proto.getName = function getName() {
	    return this.name;
	  };
	
	  return Keyframes;
	}();
	
	// 
	
	/**
	 * inlined version of
	 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
	 */
	var uppercasePattern = /([A-Z])/g;
	var msPattern = /^ms-/;
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	
	function hyphenateStyleName(string) {
	  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
	}
	
	// 
	
	function addUnitIfNeeded(name, value) {
	  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
	  // $FlowFixMe
	  if (value == null || typeof value === 'boolean' || value === '') {
	    return '';
	  }
	
	  if (typeof value === 'number' && value !== 0 && !(name in unitless)) {
	    return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
	  }
	
	  return String(value).trim();
	}
	
	// 
	/**
	 * It's falsish not falsy because 0 is allowed.
	 */
	
	var isFalsish = function isFalsish(chunk) {
	  return chunk === undefined || chunk === null || chunk === false || chunk === '';
	};
	
	var objToCssArray = function objToCssArray(obj, prevKey) {
	  var rules = [];
	  var keys = Object.keys(obj);
	  keys.forEach(function (key) {
	    if (!isFalsish(obj[key])) {
	      if (isPlainObject(obj[key])) {
	        rules.push.apply(rules, objToCssArray(obj[key], key));
	        return rules;
	      } else if (isFunction(obj[key])) {
	        rules.push(hyphenateStyleName(key) + ":", obj[key], ';');
	        return rules;
	      }
	
	      rules.push(hyphenateStyleName(key) + ": " + addUnitIfNeeded(key, obj[key]) + ";");
	    }
	
	    return rules;
	  });
	  return prevKey ? [prevKey + " {"].concat(rules, ['}']) : rules;
	};
	function flatten(chunk, executionContext, styleSheet) {
	  if (Array.isArray(chunk)) {
	    var ruleSet = [];
	
	    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
	      result = flatten(chunk[i], executionContext, styleSheet);
	      if (result === '') continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
	    }
	
	    return ruleSet;
	  }
	
	  if (isFalsish(chunk)) {
	    return '';
	  }
	  /* Handle other components */
	
	
	  if (isStyledComponent(chunk)) {
	    return "." + chunk.styledComponentId;
	  }
	  /* Either execute or defer the function */
	
	
	  if (isFunction(chunk)) {
	    if (isStatelessFunction(chunk) && executionContext) {
	      var _result = chunk(executionContext);
	
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn(getComponentName(chunk) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.");
	      }
	
	      return flatten(_result, executionContext, styleSheet);
	    } else return chunk;
	  }
	
	  if (chunk instanceof Keyframes) {
	    if (styleSheet) {
	      chunk.inject(styleSheet);
	      return chunk.getName();
	    } else return chunk;
	  }
	  /* Handle objects */
	
	
	  return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
	}
	
	// 
	function css(styles) {
	  for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (isFunction(styles) || isPlainObject(styles)) {
	    // $FlowFixMe
	    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
	  }
	
	  if (interpolations.length === 0 && styles.length === 1 && typeof styles[0] === "string") {
	    // $FlowFixMe
	    return styles;
	  } // $FlowFixMe
	
	
	  return flatten(interleave(styles, interpolations));
	}
	
	function constructWithOptions(componentConstructor, tag, options) {
	  if (options === void 0) {
	    options = EMPTY_OBJECT;
	  }
	
	  if (!reactIs.isValidElementType(tag)) {
	    return throwStyledComponentsError(1, String(tag));
	  }
	  /* This is callable directly as a template function */
	  // $FlowFixMe: Not typed to avoid destructuring arguments
	
	
	  var templateFunction = function templateFunction() {
	    return componentConstructor(tag, options, css.apply(void 0, arguments));
	  };
	  /* If config methods are called, wrap up a new template function and merge options */
	
	
	  templateFunction.withConfig = function (config) {
	    return constructWithOptions(componentConstructor, tag, _extends({}, options, {}, config));
	  };
	  /* Modify/inject new props at runtime */
	
	
	  templateFunction.attrs = function (attrs) {
	    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
	    }));
	  };
	
	  return templateFunction;
	}
	
	/* eslint-disable */
	
	/**
	  mixin-deep; https://github.com/jonschlinkert/mixin-deep
	  Inlined such that it will be consistently transpiled to an IE-compatible syntax.
	
	  The MIT License (MIT)
	
	  Copyright (c) 2014-present, Jon Schlinkert.
	
	  Permission is hereby granted, free of charge, to any person obtaining a copy
	  of this software and associated documentation files (the "Software"), to deal
	  in the Software without restriction, including without limitation the rights
	  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	  copies of the Software, and to permit persons to whom the Software is
	  furnished to do so, subject to the following conditions:
	
	  The above copyright notice and this permission notice shall be included in
	  all copies or substantial portions of the Software.
	
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	  THE SOFTWARE.
	*/
	var isObject = function isObject(val) {
	  return typeof val === 'function' || typeof val === 'object' && val !== null && !Array.isArray(val);
	};
	
	var isValidKey = function isValidKey(key) {
	  return key !== '__proto__' && key !== 'constructor' && key !== 'prototype';
	};
	
	function mixin(target, val, key) {
	  var obj = target[key];
	
	  if (isObject(val) && isObject(obj)) {
	    mixinDeep(obj, val);
	  } else {
	    target[key] = val;
	  }
	}
	
	function mixinDeep(target) {
	  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    rest[_key - 1] = arguments[_key];
	  }
	
	  for (var _i = 0, _rest = rest; _i < _rest.length; _i++) {
	    var obj = _rest[_i];
	
	    if (isObject(obj)) {
	      for (var key in obj) {
	        if (isValidKey(key)) {
	          mixin(target, obj[key], key);
	        }
	      }
	    }
	  }
	
	  return target;
	}
	
	// 
	
	/* eslint-disable no-bitwise */
	var AD_REPLACER_R = /(a)(d)/gi;
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	
	var charsLength = 52;
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	/* input a number, usually a hash and convert it to base-52 */
	
	
	function generateAlphabeticName(code) {
	  var name = '';
	  var x;
	  /* get a char and divide by alphabet-length */
	
	  for (x = Math.abs(code); x > charsLength; x = x / charsLength | 0) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return (getAlphabeticChar(x % charsLength) + name).replace(AD_REPLACER_R, '$1-$2');
	}
	
	// 
	function isStaticRules(rules) {
	  for (var i = 0; i < rules.length; i += 1) {
	    var rule = rules[i];
	
	    if (isFunction(rule) && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// 
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	
	var ComponentStyle =
	/*#__PURE__*/
	function () {
	  function ComponentStyle(rules, componentId) {
	    this.rules = rules;
	    this.staticRulesId = '';
	    this.isStatic = ("production") === 'production' && isStaticRules(rules);
	    this.componentId = componentId;
	    this.baseHash = hash(componentId); // NOTE: This registers the componentId, which ensures a consistent order
	    // for this component's styles compared to others
	
	    StyleSheet.registerId(componentId);
	  }
	  /*
	   * Flattens a rule set into valid CSS
	   * Hashes it, wraps the whole chunk in a .hash1234 {}
	   * Returns the hash to be injected on render()
	   * */
	
	
	  var _proto = ComponentStyle.prototype;
	
	  _proto.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet, stylis) {
	    var componentId = this.componentId; // force dynamic classnames if user-supplied stylis plugins are in use
	
	    if (this.isStatic && !stylis.hash) {
	      if (this.staticRulesId && styleSheet.hasNameForId(componentId, this.staticRulesId)) {
	        return this.staticRulesId;
	      }
	
	      var cssStatic = flatten(this.rules, executionContext, styleSheet).join('');
	      var name = generateAlphabeticName(phash(this.baseHash, cssStatic.length) >>> 0);
	
	      if (!styleSheet.hasNameForId(componentId, name)) {
	        var cssStaticFormatted = stylis(cssStatic, "." + name, undefined, componentId);
	        styleSheet.insertRules(componentId, name, cssStaticFormatted);
	      }
	
	      this.staticRulesId = name;
	      return name;
	    } else {
	      var length = this.rules.length;
	      var dynamicHash = phash(this.baseHash, stylis.hash);
	      var css = '';
	
	      for (var i = 0; i < length; i++) {
	        var partRule = this.rules[i];
	
	        if (typeof partRule === 'string') {
	          css += partRule;
	          if (false) dynamicHash = phash(dynamicHash, partRule + i);
	        } else {
	          var partChunk = flatten(partRule, executionContext, styleSheet);
	          var partString = Array.isArray(partChunk) ? partChunk.join('') : partChunk;
	          dynamicHash = phash(dynamicHash, partString + i);
	          css += partString;
	        }
	      }
	
	      var _name = generateAlphabeticName(dynamicHash >>> 0);
	
	      if (!styleSheet.hasNameForId(componentId, _name)) {
	        var cssFormatted = stylis(css, "." + _name, undefined, componentId);
	        styleSheet.insertRules(componentId, _name, cssFormatted);
	      }
	
	      return _name;
	    }
	  };
	
	  return ComponentStyle;
	}();
	
	// 
	var LIMIT = 200;
	var createWarnTooManyClasses = (function (displayName, componentId) {
	  var generatedClasses = {};
	  var warningSeen = false;
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	
	        /* eslint-disable no-console, prefer-template */
	        var parsedIdString = componentId ? " with the id of \"" + componentId + "\"" : '';
	        console.warn("Over " + LIMIT + " classes were generated for component " + displayName + parsedIdString + ".\n" + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	});
	
	// 
	var invalidHookCallRe = /invalid hook call/i;
	var seen = new Set();
	var checkDynamicCreation = function checkDynamicCreation(displayName, componentId) {
	  if (false) {
	    var parsedIdString = componentId ? " with the id of \"" + componentId + "\"" : '';
	    var message = "The component " + displayName + parsedIdString + " has been created dynamically.\n" + 'You may see this warning because you\'ve called styled inside another component.\n' + 'To resolve this only create new StyledComponents outside of any render method and function component.';
	
	    try {
	      // We purposefully call `useRef` outside of a component and expect it to throw
	      // If it doesn't, then we're inside another component.
	      // eslint-disable-next-line react-hooks/rules-of-hooks
	      React.useRef();
	
	      if (!seen.has(message)) {
	        // eslint-disable-next-line no-console
	        console.warn(message);
	        seen.add(message);
	      }
	    } catch (error) {
	      // The error here is expected, since we're expecting anything that uses `checkDynamicCreation` to
	      // be called outside of a React component.
	      if (invalidHookCallRe.test(error.message)) {
	        // This shouldn't happen, but resets `warningSeen` if we had this error happen intermittently
	        seen["delete"](message);
	      }
	    }
	  }
	};
	
	// 
	var determineTheme = (function (props, providedTheme, defaultProps) {
	  if (defaultProps === void 0) {
	    defaultProps = EMPTY_OBJECT;
	  }
	
	  return props.theme !== defaultProps.theme && props.theme || providedTheme || defaultProps.theme;
	});
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	
	function escape(str) {
	  return str // Replace all possible CSS selectors
	  .replace(escapeRegex, '-') // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	function isTag(target) {
	  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
	}
	
	// 
	function generateDisplayName(target) {
	  // $FlowFixMe
	  return isTag(target) ? "styled." + target : "Styled(" + getComponentName(target) + ")";
	}
	
	// 
	var generateComponentId = (function (str) {
	  return generateAlphabeticName(hash(str) >>> 0);
	});
	
	/**
	 * Convenience function for joining strings to form className chains
	 */
	function joinStrings(a, b) {
	  return a && b ? a + " " + b : a || b;
	}
	
	var ThemeContext = React__default.createContext();
	var ThemeConsumer = ThemeContext.Consumer;
	
	function mergeTheme(theme, outerTheme) {
	  if (!theme) {
	    return throwStyledComponentsError(14);
	  }
	
	  if (isFunction(theme)) {
	    var mergedTheme = theme(outerTheme);
	
	    if (false) {
	      return throwStyledComponentsError(7);
	    }
	
	    return mergedTheme;
	  }
	
	  if (Array.isArray(theme) || typeof theme !== 'object') {
	    return throwStyledComponentsError(8);
	  }
	
	  return outerTheme ? _extends({}, outerTheme, {}, theme) : theme;
	}
	/**
	 * Provide a theme to an entire react component tree via context
	 */
	
	
	function ThemeProvider(props) {
	  var outerTheme = React.useContext(ThemeContext);
	  var themeContext = React.useMemo(function () {
	    return mergeTheme(props.theme, outerTheme);
	  }, [props.theme, outerTheme]);
	
	  if (!props.children) {
	    return null;
	  }
	
	  return React__default.createElement(ThemeContext.Provider, {
	    value: themeContext
	  }, props.children);
	}
	
	/* global $Call */
	
	var identifiers = {};
	/* We depend on components having unique IDs */
	
	function generateId(displayName, parentComponentId) {
	  var name = typeof displayName !== 'string' ? 'sc' : escape(displayName); // Ensure that no displayName can lead to duplicate componentIds
	
	  identifiers[name] = (identifiers[name] || 0) + 1;
	  var componentId = name + "-" + generateComponentId(name + identifiers[name]);
	  return parentComponentId ? parentComponentId + "-" + componentId : componentId;
	}
	
	function useResolvedAttrs(theme, props, attrs) {
	  if (theme === void 0) {
	    theme = EMPTY_OBJECT;
	  }
	
	  // NOTE: can't memoize this
	  // returns [context, resolvedAttrs]
	  // where resolvedAttrs is only the things injected by the attrs themselves
	  var context = _extends({}, props, {
	    theme: theme
	  });
	
	  var resolvedAttrs = {};
	  attrs.forEach(function (attrDef) {
	    var resolvedAttrDef = attrDef;
	    var key;
	
	    if (isFunction(resolvedAttrDef)) {
	      resolvedAttrDef = resolvedAttrDef(context);
	    }
	    /* eslint-disable guard-for-in */
	
	
	    for (key in resolvedAttrDef) {
	      context[key] = resolvedAttrs[key] = key === 'className' ? joinStrings(resolvedAttrs[key], resolvedAttrDef[key]) : resolvedAttrDef[key];
	    }
	    /* eslint-enable guard-for-in */
	
	  });
	  return [context, resolvedAttrs];
	}
	
	function useInjectedStyle(componentStyle, hasAttrs, resolvedAttrs, warnTooManyClasses) {
	  var styleSheet = useStyleSheet();
	  var stylis = useStylis(); // statically styled-components don't need to build an execution context object,
	  // and shouldn't be increasing the number of class names
	
	  var isStatic = componentStyle.isStatic && !hasAttrs;
	  var className = isStatic ? componentStyle.generateAndInjectStyles(EMPTY_OBJECT, styleSheet, stylis) : componentStyle.generateAndInjectStyles(resolvedAttrs, styleSheet, stylis);
	  React.useDebugValue(className);
	
	  if (false) {
	    warnTooManyClasses(className);
	  }
	
	  return className;
	}
	
	function useStyledComponentImpl(forwardedComponent, props, forwardedRef) {
	  var componentAttrs = forwardedComponent.attrs,
	      componentStyle = forwardedComponent.componentStyle,
	      defaultProps = forwardedComponent.defaultProps,
	      foldedComponentIds = forwardedComponent.foldedComponentIds,
	      styledComponentId = forwardedComponent.styledComponentId,
	      target = forwardedComponent.target;
	  React.useDebugValue(styledComponentId); // NOTE: the non-hooks version only subscribes to this when !componentStyle.isStatic,
	  // but that'd be against the rules-of-hooks. We could be naughty and do it anyway as it
	  // should be an immutable value, but behave for now.
	
	  var theme = determineTheme(props, React.useContext(ThemeContext), defaultProps);
	
	  var _useResolvedAttrs = useResolvedAttrs(theme || EMPTY_OBJECT, props, componentAttrs),
	      context = _useResolvedAttrs[0],
	      attrs = _useResolvedAttrs[1];
	
	  var generatedClassName = useInjectedStyle(componentStyle, componentAttrs.length > 0, context,  false ? forwardedComponent.warnTooManyClasses : undefined);
	  var refToForward = forwardedRef;
	  var elementToBeCreated = attrs.as || props.as || target;
	  var isTargetTag = isTag(elementToBeCreated);
	  var computedProps = attrs !== props ? _extends({}, props, {}, attrs) : props;
	  var shouldFilterProps = isTargetTag || 'as' in computedProps || 'forwardedAs' in computedProps;
	  var propsForElement = shouldFilterProps ? {} : _extends({}, computedProps);
	
	  if (shouldFilterProps) {
	    // eslint-disable-next-line guard-for-in
	    for (var key in computedProps) {
	      if (key === 'forwardedAs') {
	        propsForElement.as = computedProps[key];
	      } else if (key !== 'as' && key !== 'forwardedAs' && (!isTargetTag || validAttr(key))) {
	        // Don't pass through non HTML tags through to HTML elements
	        propsForElement[key] = computedProps[key];
	      }
	    }
	  }
	
	  if (props.style && attrs.style !== props.style) {
	    propsForElement.style = _extends({}, props.style, {}, attrs.style);
	  }
	
	  propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, props.className, attrs.className).filter(Boolean).join(' ');
	  propsForElement.ref = refToForward;
	  return React.createElement(elementToBeCreated, propsForElement);
	}
	
	function createStyledComponent(target, options, rules) {
	  var isTargetStyledComp = isStyledComponent(target);
	  var isCompositeComponent = !isTag(target);
	  var _options$displayName = options.displayName,
	      displayName = _options$displayName === void 0 ? generateDisplayName(target) : _options$displayName,
	      _options$componentId = options.componentId,
	      componentId = _options$componentId === void 0 ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
	      _options$attrs = options.attrs,
	      attrs = _options$attrs === void 0 ? EMPTY_ARRAY : _options$attrs;
	  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + "-" + options.componentId : options.componentId || componentId; // fold the underlying StyledComponent attrs up (implicit extend)
	
	  var finalAttrs = // $FlowFixMe
	  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;
	  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
	  // $FlowFixMe
	  target.componentStyle.rules.concat(rules) : rules, styledComponentId);
	  /**
	   * forwardRef creates a new interim component, which we'll take advantage of
	   * instead of extending ParentComponent to create _another_ interim class
	   */
	
	  var WrappedStyledComponent; // eslint-disable-next-line react-hooks/rules-of-hooks
	
	  var forwardRef = function forwardRef(props, ref) {
	    return useStyledComponentImpl(WrappedStyledComponent, props, ref);
	  };
	
	  forwardRef.displayName = displayName; // $FlowFixMe this is a forced cast to merge it StyledComponentWrapperProperties
	
	  WrappedStyledComponent = React__default.forwardRef(forwardRef);
	  WrappedStyledComponent.attrs = finalAttrs;
	  WrappedStyledComponent.componentStyle = componentStyle;
	  WrappedStyledComponent.displayName = displayName; // this static is used to preserve the cascade of static classes for component selector
	  // purposes; this is especially important with usage of the css prop
	
	  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
	  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;
	  WrappedStyledComponent.styledComponentId = styledComponentId; // fold the underlying StyledComponent target up since we folded the styles
	
	  WrappedStyledComponent.target = isTargetStyledComp ? // $FlowFixMe
	  target.target : target; // $FlowFixMe
	
	  WrappedStyledComponent.withComponent = function withComponent(tag) {
	    var previousComponentId = options.componentId,
	        optionsToCopy = _objectWithoutPropertiesLoose(options, ["componentId"]);
	
	    var newComponentId = previousComponentId && previousComponentId + "-" + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	    var newOptions = _extends({}, optionsToCopy, {
	      attrs: finalAttrs,
	      componentId: newComponentId
	    });
	
	    return createStyledComponent(tag, newOptions, rules);
	  }; // $FlowFixMe
	
	
	  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
	    get: function get() {
	      return this._foldedDefaultProps;
	    },
	    set: function set(obj) {
	      // $FlowFixMe
	      this._foldedDefaultProps = isTargetStyledComp ? mixinDeep({}, target.defaultProps, obj) : obj;
	    }
	  });
	
	  if (false) {
	    checkDynamicCreation(displayName, styledComponentId);
	    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName, styledComponentId);
	  } // $FlowFixMe
	
	
	  WrappedStyledComponent.toString = function () {
	    return "." + WrappedStyledComponent.styledComponentId;
	  };
	
	  if (isCompositeComponent) {
	    hoist(WrappedStyledComponent, target, {
	      // all SC-specific things should not be hoisted
	      attrs: true,
	      componentStyle: true,
	      displayName: true,
	      foldedComponentIds: true,
	      self: true,
	      styledComponentId: true,
	      target: true,
	      withComponent: true
	    });
	  }
	
	  return WrappedStyledComponent;
	}
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	
	var styled = function styled(tag) {
	  return constructWithOptions(createStyledComponent, tag);
	}; // Shorthands for all valid HTML Elements
	
	
	domElements.forEach(function (domElement) {
	  styled[domElement] = styled(domElement);
	});
	
	// 
	
	var GlobalStyle =
	/*#__PURE__*/
	function () {
	  function GlobalStyle(rules, componentId) {
	    this.rules = rules;
	    this.componentId = componentId;
	    this.isStatic = isStaticRules(rules);
	  }
	
	  var _proto = GlobalStyle.prototype;
	
	  _proto.createStyles = function createStyles(instance, executionContext, styleSheet, stylis) {
	    var flatCSS = flatten(this.rules, executionContext, styleSheet);
	    var css = stylis(flatCSS.join(''), '');
	    var id = this.componentId + instance; // NOTE: We use the id as a name as well, since these rules never change
	
	    styleSheet.insertRules(id, id, css);
	  };
	
	  _proto.removeStyles = function removeStyles(instance, styleSheet) {
	    styleSheet.clearRules(this.componentId + instance);
	  };
	
	  _proto.renderStyles = function renderStyles(instance, executionContext, styleSheet, stylis) {
	    StyleSheet.registerId(this.componentId + instance); // NOTE: Remove old styles, then inject the new ones
	
	    this.removeStyles(instance, styleSheet);
	    this.createStyles(instance, executionContext, styleSheet, stylis);
	  };
	
	  return GlobalStyle;
	}();
	
	function createGlobalStyle(strings) {
	  for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var rules = css.apply(void 0, [strings].concat(interpolations));
	  var styledComponentId = "sc-global-" + generateComponentId(JSON.stringify(rules));
	  var globalStyle = new GlobalStyle(rules, styledComponentId);
	
	  if (false) {
	    checkDynamicCreation(styledComponentId);
	  }
	
	  function GlobalStyleComponent(props) {
	    var styleSheet = useStyleSheet();
	    var stylis = useStylis();
	    var theme = React.useContext(ThemeContext);
	    var instanceRef = React.useRef(null);
	
	    if (instanceRef.current === null) {
	      instanceRef.current = styleSheet.allocateGSInstance(styledComponentId);
	    }
	
	    var instance = instanceRef.current;
	
	    if (false) {
	      // eslint-disable-next-line no-console
	      console.warn("The global style component " + styledComponentId + " was given child JSX. createGlobalStyle does not render children.");
	    }
	
	    if (false) {
	      console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app.");
	    }
	
	    if (globalStyle.isStatic) {
	      globalStyle.renderStyles(instance, STATIC_EXECUTION_CONTEXT, styleSheet, stylis);
	    } else {
	      var context = _extends({}, props, {
	        theme: determineTheme(props, theme, GlobalStyleComponent.defaultProps)
	      });
	
	      globalStyle.renderStyles(instance, context, styleSheet, stylis);
	    }
	
	    React.useEffect(function () {
	      return function () {
	        return globalStyle.removeStyles(instance, styleSheet);
	      };
	    }, EMPTY_ARRAY);
	    return null;
	  } // $FlowFixMe
	
	
	  return React__default.memo(GlobalStyleComponent);
	}
	
	// 
	function keyframes(strings) {
	  /* Warning if you've used keyframes on React Native */
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
	  }
	
	  for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var rules = css.apply(void 0, [strings].concat(interpolations)).join('');
	  var name = generateComponentId(rules);
	  return new Keyframes(name, [rules, name, '@keyframes']);
	}
	
	var ServerStyleSheet =
	/*#__PURE__*/
	function () {
	  function ServerStyleSheet() {
	    var _this = this;
	
	    this._emitSheetCSS = function () {
	      var css = _this.instance.toString();
	
	      var nonce = getNonce();
	      var attrs = [nonce && "nonce=\"" + nonce + "\"", SC_ATTR + "=\"true\"", SC_ATTR_VERSION + "=\"" + SC_VERSION + "\""];
	      var htmlAttr = attrs.filter(Boolean).join(' ');
	      return "<style " + htmlAttr + ">" + css + "</style>";
	    };
	
	    this.getStyleTags = function () {
	      if (_this.sealed) {
	        return throwStyledComponentsError(2);
	      }
	
	      return _this._emitSheetCSS();
	    };
	
	    this.getStyleElement = function () {
	      var _props;
	
	      if (_this.sealed) {
	        return throwStyledComponentsError(2);
	      }
	
	      var props = (_props = {}, _props[SC_ATTR] = '', _props[SC_ATTR_VERSION] = SC_VERSION, _props.dangerouslySetInnerHTML = {
	        __html: _this.instance.toString()
	      }, _props);
	      var nonce = getNonce();
	
	      if (nonce) {
	        props.nonce = nonce;
	      } // v4 returned an array for this fn, so we'll do the same for v5 for backward compat
	
	
	      return [React__default.createElement("style", _extends({}, props, {
	        key: "sc-0-0"
	      }))];
	    };
	
	    this.seal = function () {
	      _this.sealed = true;
	    };
	
	    this.instance = new StyleSheet({
	      isServer: true
	    });
	    this.sealed = false;
	  }
	
	  var _proto = ServerStyleSheet.prototype;
	
	  _proto.collectStyles = function collectStyles(children) {
	    if (this.sealed) {
	      return throwStyledComponentsError(2);
	    }
	
	    return React__default.createElement(StyleSheetManager, {
	      sheet: this.instance
	    }, children);
	  };
	
	  // eslint-disable-next-line consistent-return
	  _proto.interleaveWithNodeStream = function interleaveWithNodeStream(input) {
	    {
	      return throwStyledComponentsError(3);
	    }
	  };
	
	  return ServerStyleSheet;
	}();
	
	// export default <Config: { theme?: any }, Instance>(
	//  Component: AbstractComponent<Config, Instance>
	// ): AbstractComponent<$Diff<Config, { theme?: any }> & { theme?: any }, Instance>
	//
	// but the old build system tooling doesn't support the syntax
	
	var withTheme = (function (Component) {
	  // $FlowFixMe This should be React.forwardRef<Config, Instance>
	  var WithTheme = React__default.forwardRef(function (props, ref) {
	    var theme = React.useContext(ThemeContext); // $FlowFixMe defaultProps isn't declared so it can be inferrable
	
	    var defaultProps = Component.defaultProps;
	    var themeProp = determineTheme(props, theme, defaultProps);
	
	    if (false) {
	      // eslint-disable-next-line no-console
	      console.warn("[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class \"" + getComponentName(Component) + "\"");
	    }
	
	    return React__default.createElement(Component, _extends({}, props, {
	      theme: themeProp,
	      ref: ref
	    }));
	  });
	  hoist(WithTheme, Component);
	  WithTheme.displayName = "WithTheme(" + getComponentName(Component) + ")";
	  return WithTheme;
	});
	
	// 
	
	var useTheme = function useTheme() {
	  return React.useContext(ThemeContext);
	};
	
	// 
	var __PRIVATE__ = {
	  StyleSheet: StyleSheet,
	  masterSheet: masterSheet
	};
	
	// 
	/* Define bundle version for export */
	
	var version = "5.0.1";
	/* Warning if you've imported this file on React Native */
	
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	/* Warning if there are several instances of styled-components */
	
	
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process, ' + 'missing theme prop, and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetConsumer = StyleSheetConsumer;
	exports.StyleSheetContext = StyleSheetContext;
	exports.StyleSheetManager = StyleSheetManager;
	exports.ThemeConsumer = ThemeConsumer;
	exports.ThemeContext = ThemeContext;
	exports.ThemeProvider = ThemeProvider;
	exports.__PRIVATE__ = __PRIVATE__;
	exports.createGlobalStyle = createGlobalStyle;
	exports.css = css;
	exports.default = styled;
	exports.isStyledComponent = isStyledComponent;
	exports.keyframes = keyframes;
	exports.useTheme = useTheme;
	exports.version = version;
	exports.withTheme = withTheme;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ },
/* 276 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(276);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 278 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.81bbcfbc.js